function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
            return;
        }
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("j5uWP", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$f5c48d759809faf1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("bnL6w");
    var $7nKe3;
    var $7TJr2;
    var $67rvX;
    var $l2N2a;
    var $9dbF6;
    var $9NiTW;
    var $l8ruj;
    const $f5c48d759809faf1$var$JiraBusinessSummaryApp = ()=>{
        const { data: project } = (0, (0, parcelRequire("l2N2a")).useProject)();
        const hasAdministerProjectPermission = Boolean(project?.permissions.administerProject);
        const hasCreateItem = Boolean(project?.permissions.createIssues);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "jira-business-summary-app"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9NiTW")).AuthenticationCheck), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7nKe3")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7TJr2")).default), {
            hasCreateItem: hasCreateItem,
            hasInviteTeammateButton: hasAdministerProjectPermission,
            hasManageTypesButton: hasAdministerProjectPermission,
            issuesLinkUrl: project != null ? `/jira/core/projects/${project.key}/list` : ''
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("67rvX")).default), null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9dbF6")).SubProductUpdater), {
            subProduct: "core"
        })));
    };
    var $f5c48d759809faf1$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($f5c48d759809faf1$var$JiraBusinessSummaryApp);
});
parcelRegister("7nKe3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b120e66bf4d03608$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $12jwF;
    var $54qG5;
    var $5YBrl;
    var $1Zr0i;
    var $daQYX;
    var $cm8b5;
    var $gxGcZ;
    var $iXVV6;
    var $aVFIE;
    var $l2N2a;
    var $koeKL;
    var $lVJAU;
    var $k7McJ;
    var $8OqLl;
    const $b120e66bf4d03608$var$ProjectContextProvider = ({ children: children })=>{
        const { data: project, loading: loading, error: error } = (0, (0, parcelRequire("l2N2a")).useProject)();
        const { replace: replace } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const projectId = project?.id;
        const projectKey = project?.key;
        const projectType = project?.type;
        const isTeamManaged = Boolean(project?.isSimplified);
        const jqlContext = projectKey ? `project = '${projectKey}'` : '';
        const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
                projectId: projectId,
                isTeamManaged: isTeamManaged,
                projectType: projectType
            }), [
            projectId,
            isTeamManaged,
            projectType
        ]);
        const entityData = (0, $5uXOq.useMemo)(()=>project?.permissions?.viewIssues ? {
                name: project.name,
                id: String(project.id)
            } : null, [
            project
        ]);
        const projects = (0, $5uXOq.useMemo)(()=>project ? [
                project
            ] : undefined, [
            project
        ]);
        const projectIdList = (0, $5uXOq.useMemo)(()=>projectId ? [
                projectId
            ] : undefined, [
            projectId
        ]);
        const projectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
        if (project?.status === 'ARCHIVED') {
            replace('/jira/errors/project-archived');
            return null;
        }
        let content;
        if (loading) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton), null);
        else if (project == null || entityData == null || error) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8OqLl")).default), null), error && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceFailed), {
            experience: (0, (0, parcelRequire("k7McJ")).FETCH_PROJECT_EXPERIENCE),
            error: error
        }));
        else content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daQYX")).ProjectHookProvider), {
            project: project
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("54qG5")).BusinessEntityProvider), {
            data: entityData
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1Zr0i")).RealtimeProvider), {
            ids: projectIdList
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("12jwF")).AriProvider), {
            ari: projectAri
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5YBrl")).JqlProvider), {
            jqlContext: jqlContext
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gxGcZ")).FiltersProvider), {
            projects: projects
        }, children)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceSuccess), {
            experience: (0, (0, parcelRequire("k7McJ")).FETCH_PROJECT_EXPERIENCE)
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            containerId: String(project?.id),
            containerType: "project",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "businessProjectContext",
            attributes: analyticsAttributes,
            key: String(project?.id)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceStart), {
            experience: (0, (0, parcelRequire("k7McJ")).FETCH_PROJECT_EXPERIENCE)
        }), content);
    };
    var $b120e66bf4d03608$export$2e2bcd8739ae039 = $b120e66bf4d03608$var$ProjectContextProvider;
});
parcelRegister("12jwF", function(module, exports) {
    $parcel$export(module.exports, "AriProvider", ()=>$d9a27a44a6301e03$export$c806f8ac05dc61fa);
    $parcel$export(module.exports, "useEntityAri", ()=>$d9a27a44a6301e03$export$badcacdc306567b8);
    var $5uXOq = parcelRequire("5uXOq");
    const $d9a27a44a6301e03$var$AriContext = (0, $5uXOq.createContext)('');
    const $d9a27a44a6301e03$export$c806f8ac05dc61fa = ({ ari: ari, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($d9a27a44a6301e03$var$AriContext.Provider, {
            value: ari
        }, children);
    const $d9a27a44a6301e03$export$badcacdc306567b8 = ()=>(0, $5uXOq.useContext)($d9a27a44a6301e03$var$AriContext);
});
parcelRegister("54qG5", function(module, exports) {
    $parcel$export(module.exports, "BusinessEntityProvider", ()=>$a71d927d8f07dfcc$export$c800e064c3c327ef);
    $parcel$export(module.exports, "useBusinessEntity", ()=>$a71d927d8f07dfcc$export$ff2574b00bc1c100);
    var $5uXOq = parcelRequire("5uXOq");
    const $a71d927d8f07dfcc$var$BusinessEntityContext = (0, $5uXOq.createContext)(null);
    const $a71d927d8f07dfcc$export$c800e064c3c327ef = ({ data: data, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($a71d927d8f07dfcc$var$BusinessEntityContext.Provider, {
            value: data
        }, children);
    const $a71d927d8f07dfcc$export$ff2574b00bc1c100 = ()=>{
        const entity = (0, $5uXOq.useContext)($a71d927d8f07dfcc$var$BusinessEntityContext);
        return {
            data: entity
        };
    };
});
parcelRegister("5YBrl", function(module, exports) {
    $parcel$export(module.exports, "JqlProvider", ()=>$81e54c5b62a4ab4d$export$fdc879e2ba0da048);
    $parcel$export(module.exports, "useJqlContext", ()=>$81e54c5b62a4ab4d$export$f32e2f688fc08561);
    var $5uXOq = parcelRequire("5uXOq");
    const $81e54c5b62a4ab4d$var$JqlContext = (0, $5uXOq.createContext)('');
    const $81e54c5b62a4ab4d$export$fdc879e2ba0da048 = ({ jqlContext: jqlContext, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($81e54c5b62a4ab4d$var$JqlContext.Provider, {
            value: jqlContext
        }, children);
    const $81e54c5b62a4ab4d$export$f32e2f688fc08561 = ()=>(0, $5uXOq.useContext)($81e54c5b62a4ab4d$var$JqlContext);
});
parcelRegister("1Zr0i", function(module, exports) {
    $parcel$export(module.exports, "RealtimeProvider", ()=>$6a65786548fb921c$export$64d242981d970821);
    $parcel$export(module.exports, "useRealtimeContext", ()=>$6a65786548fb921c$export$f39c07717ad8c35b);
    var $5uXOq = parcelRequire("5uXOq");
    const $6a65786548fb921c$var$RealtimeContext = (0, $5uXOq.createContext)([]);
    const $6a65786548fb921c$export$64d242981d970821 = ({ ids: ids, children: children })=>{
        const projectsIds = (0, $5uXOq.useMemo)(()=>ids ? ids.map((pid)=>String(pid)) : [], [
            ids
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($6a65786548fb921c$var$RealtimeContext.Provider, {
            value: projectsIds
        }, children);
    };
    const $6a65786548fb921c$export$f39c07717ad8c35b = ()=>(0, $5uXOq.useContext)($6a65786548fb921c$var$RealtimeContext);
});
parcelRegister("daQYX", function(module, exports) {
    $parcel$export(module.exports, "ProjectHookProvider", ()=>$cf7f84dff81db95f$export$f1938a4916a14d9f);
    $parcel$export(module.exports, "useProject", ()=>$cf7f84dff81db95f$export$51b1383ef8844a7);
    var $5uXOq = parcelRequire("5uXOq");
    const $cf7f84dff81db95f$var$Context = (0, $5uXOq.createContext)(null);
    const $cf7f84dff81db95f$export$f1938a4916a14d9f = ({ project: project, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($cf7f84dff81db95f$var$Context.Provider, {
            value: project
        }, children);
    const $cf7f84dff81db95f$export$51b1383ef8844a7 = ()=>{
        const project = (0, $5uXOq.useContext)($cf7f84dff81db95f$var$Context);
        if (!project) throw new Error('useProject must be used within a ProjectHookProvider');
        return project;
    };
});
parcelRegister("gxGcZ", function(module, exports) {
    $parcel$export(module.exports, "FiltersProvider", ()=>$5ac2d1f4676106ae$export$905df3588d1d8c75);
    $parcel$export(module.exports, "useAssigneesFilterQuery", ()=>$5ac2d1f4676106ae$export$f39bce8705b01ff5);
    $parcel$export(module.exports, "useProjectFilter", ()=>$5ac2d1f4676106ae$export$b71768ffb8163578);
    $parcel$export(module.exports, "useAllowedFieldTypes", ()=>$5ac2d1f4676106ae$export$9dc8a291956c2fa9);
    var $5uXOq = parcelRequire("5uXOq");
    var $5fc53;
    var $gzkAf;
    const $5ac2d1f4676106ae$var$DEFAULT_VALUE = {
        assigneeQuery: '',
        projectFilter: {
            totalCount: 0,
            options: []
        }
    };
    const $5ac2d1f4676106ae$var$FiltersContext = (0, $5uXOq.createContext)($5ac2d1f4676106ae$var$DEFAULT_VALUE);
    const $5ac2d1f4676106ae$export$905df3588d1d8c75 = ({ projects: projects, children: children })=>{
        const value = (0, $5uXOq.useMemo)(()=>{
            if (!projects) return $5ac2d1f4676106ae$var$DEFAULT_VALUE;
            const assigneeQuery = `is assignee of (${projects.map((project)=>project.key).join(', ')})`;
            const projectFilter = {
                totalCount: projects.length,
                options: projects.map((project)=>({
                        label: project.name,
                        value: String(project.id),
                        avatar: project.avatarUrl,
                        square: true
                    }))
            };
            return {
                assigneeQuery: assigneeQuery,
                projectFilter: projectFilter
            };
        }, [
            projects
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($5ac2d1f4676106ae$var$FiltersContext.Provider, {
            value: value
        }, children);
    };
    const $5ac2d1f4676106ae$export$f39bce8705b01ff5 = ()=>(0, $5uXOq.useContext)($5ac2d1f4676106ae$var$FiltersContext).assigneeQuery;
    const $5ac2d1f4676106ae$export$b71768ffb8163578 = ()=>(0, $5uXOq.useContext)($5ac2d1f4676106ae$var$FiltersContext).projectFilter;
    const $5ac2d1f4676106ae$export$9dc8a291956c2fa9 = (inputAllowedFieldTypes)=>{
        const filtersContext = (0, $5uXOq.useContext)($5ac2d1f4676106ae$var$FiltersContext);
        return (0, $5uXOq.useMemo)(()=>{
            const result = new Set(inputAllowedFieldTypes ?? (0, (0, parcelRequire("gzkAf")).BUSINESS_FIELD_TYPES));
            if (filtersContext.projectFilter.totalCount <= 1) result.delete((0, (0, parcelRequire("5fc53")).PROJECT_TYPE));
            return result;
        }, [
            filtersContext,
            inputAllowedFieldTypes
        ]);
    };
});
parcelRegister("gzkAf", function(module, exports) {
    $parcel$export(module.exports, "POPUP_WIDTH", ()=>$92b04c6ea9a59b67$export$b6d617db656efcca);
    $parcel$export(module.exports, "SHOW_MORE_OPTIONS_BTN_SIZE", ()=>$92b04c6ea9a59b67$export$dd535f74d98d8b3);
    $parcel$export(module.exports, "OPTIONS_AVAILABLE_WIDTH", ()=>$92b04c6ea9a59b67$export$dba112976ea61483);
    $parcel$export(module.exports, "GAP_BETWEEN_OPTION", ()=>$92b04c6ea9a59b67$export$fe1082abeeda69ed);
    $parcel$export(module.exports, "OPTION_SPAN_PADDING", ()=>$92b04c6ea9a59b67$export$17ed91292eb6c163);
    $parcel$export(module.exports, "OPTION_DEFAULT_FONT_SIZE", ()=>$92b04c6ea9a59b67$export$fb22dccd99438559);
    $parcel$export(module.exports, "POPUP_OFFSET_TOP", ()=>$92b04c6ea9a59b67$export$15839778e99d81e7);
    $parcel$export(module.exports, "OPTION_MAX_WIDTH", ()=>$92b04c6ea9a59b67$export$39aa3a14ebf850c7);
    $parcel$export(module.exports, "DATE_RANGE_TYPE", ()=>$92b04c6ea9a59b67$export$1178808c606e043b);
    $parcel$export(module.exports, "BUSINESS_FIELD_TYPES", ()=>$92b04c6ea9a59b67$export$c269ba5d631cb115);
    $parcel$export(module.exports, "SOFTWARE_FIELD_TYPES", ()=>$92b04c6ea9a59b67$export$232814e45256d5dc);
    $parcel$export(module.exports, "IMPLEMENTED_TYPES", ()=>$92b04c6ea9a59b67$export$9615a3d79408a88a);
    $parcel$export(module.exports, "EXTRA_CUSTOM_FIELD_TYPES", ()=>$92b04c6ea9a59b67$export$a21166a4b76932b5);
    $parcel$export(module.exports, "SAVED_FILTERS_PER_PAGE", ()=>$92b04c6ea9a59b67$export$1989c7236a398e8a);
    var $gwIPs;
    var $5fc53;
    const $92b04c6ea9a59b67$export$b6d617db656efcca = 360;
    const $92b04c6ea9a59b67$export$90bfd0dcc25478e1 = (0, (0, parcelRequire("gwIPs")).gridSize) * 2.5;
    const $92b04c6ea9a59b67$export$dd535f74d98d8b3 = 32;
    const $92b04c6ea9a59b67$export$dba112976ea61483 = $92b04c6ea9a59b67$export$b6d617db656efcca - $92b04c6ea9a59b67$export$90bfd0dcc25478e1 * 2;
    const $92b04c6ea9a59b67$export$fe1082abeeda69ed = (0, (0, parcelRequire("gwIPs")).gridSize) / 2;
    const $92b04c6ea9a59b67$export$17ed91292eb6c163 = (0, (0, parcelRequire("gwIPs")).gridSize) * 2;
    const $92b04c6ea9a59b67$export$fb22dccd99438559 = 14;
    const $92b04c6ea9a59b67$export$15839778e99d81e7 = 215;
    const $92b04c6ea9a59b67$export$de3cbeaaf9d2669 = 28;
    const $92b04c6ea9a59b67$export$39aa3a14ebf850c7 = 150;
    const $92b04c6ea9a59b67$export$1178808c606e043b = 'dateRange';
    const $92b04c6ea9a59b67$export$c269ba5d631cb115 = [
        (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE),
        (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE),
        (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE),
        (0, (0, parcelRequire("5fc53")).CREATED),
        $92b04c6ea9a59b67$export$1178808c606e043b,
        (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
        (0, (0, parcelRequire("5fc53")).LABELS_TYPE),
        (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
        (0, (0, parcelRequire("5fc53")).PROJECT_TYPE),
        (0, (0, parcelRequire("5fc53")).REPORTER_TYPE),
        (0, (0, parcelRequire("5fc53")).STATUS_TYPE),
        (0, (0, parcelRequire("5fc53")).UPDATED),
        (0, (0, parcelRequire("5fc53")).USER_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).DATE_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE)
    ];
    const $92b04c6ea9a59b67$export$232814e45256d5dc = [
        (0, (0, parcelRequire("5fc53")).SPRINT_TYPE),
        (0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)
    ];
    const $92b04c6ea9a59b67$export$9615a3d79408a88a = new Set([
        ...$92b04c6ea9a59b67$export$c269ba5d631cb115,
        ...$92b04c6ea9a59b67$export$232814e45256d5dc
    ]);
    const $92b04c6ea9a59b67$export$a21166a4b76932b5 = new Set([
        (0, (0, parcelRequire("5fc53")).USER_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).DATE_CF_TYPE)
    ]);
    const $92b04c6ea9a59b67$export$90ca377eb0b24ff1 = {
        assignee: (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE),
        component: (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE),
        created: (0, (0, parcelRequire("5fc53")).CREATED),
        issuetype: (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
        labels: (0, (0, parcelRequire("5fc53")).LABELS_TYPE),
        priority: (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
        project: (0, (0, parcelRequire("5fc53")).PROJECT_TYPE),
        reporter: (0, (0, parcelRequire("5fc53")).REPORTER_TYPE),
        status: (0, (0, parcelRequire("5fc53")).STATUS_TYPE),
        type: (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
        updated: (0, (0, parcelRequire("5fc53")).UPDATED)
    };
    const $92b04c6ea9a59b67$export$6a2e733db5135f27 = (0, (0, parcelRequire("gwIPs")).gridSize) * 3.5;
    const $92b04c6ea9a59b67$export$1989c7236a398e8a = 50;
    const $92b04c6ea9a59b67$export$91fc9d65fca142a3 = 'users';
    const $92b04c6ea9a59b67$export$d74c70f8fb216c6b = 'recentlyUsedUsers';
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("k7McJ", function(module, exports) {
    $parcel$export(module.exports, "FETCH_PROJECT_EXPERIENCE", ()=>$47951bf9c4bef1f5$export$cb40bbf7ea51db63);
    const $47951bf9c4bef1f5$export$cb40bbf7ea51db63 = {
        experience: 'fetch-project',
        packageName: 'jiraBusinessEntityProjectProvider',
        teamName: 'wanjel'
    };
});
parcelRegister("8OqLl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a5cc2e237e9a9763$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $1jUsD;
    const $a5cc2e237e9a9763$var$NotFoundComponent = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("imwWS")), {
        moduleId: "./src/packages/business/entity/project-provider/src/ui/project-context/not-found/main.tsx"
    });
    const $a5cc2e237e9a9763$var$NotFoundAsync = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "not-found-component",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a5cc2e237e9a9763$var$NotFoundComponent, null));
    var $a5cc2e237e9a9763$export$2e2bcd8739ae039 = $a5cc2e237e9a9763$var$NotFoundAsync;
});
parcelRegister("imwWS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("azGse")
    ]).then(()=>parcelRequire('4zX1V'));
});
parcelRegister("7TJr2", function(module, exports) {
    $parcel$export(module.exports, "useSummaryFeatures", ()=>$96056f987bc938d6$export$ab34b4f862c26cc7);
    $parcel$export(module.exports, "default", ()=>$96056f987bc938d6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $96056f987bc938d6$var$defaultFeaturesContext = {
        featureView: 'summary',
        hasCreateItem: true,
        hasFeedbackFooter: true,
        hasHeader: true,
        hasInviteTeammateButton: true,
        hasManageTypesButton: true,
        hasShareButton: true,
        linksTarget: '_self'
    };
    const $96056f987bc938d6$var$SummaryFeaturesContext = (0, $5uXOq.createContext)(null);
    const $96056f987bc938d6$export$ab34b4f862c26cc7 = ()=>(0, $5uXOq.useContext)($96056f987bc938d6$var$SummaryFeaturesContext);
    const $96056f987bc938d6$var$SummaryFeaturesProvider = ({ children: children, ...props })=>{
        const value = (0, $5uXOq.useMemo)(()=>({
                ...$96056f987bc938d6$var$defaultFeaturesContext,
                ...props
            }), [
            props
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($96056f987bc938d6$var$SummaryFeaturesContext.Provider, {
            value: value
        }, children);
    };
    var $96056f987bc938d6$export$2e2bcd8739ae039 = $96056f987bc938d6$var$SummaryFeaturesProvider;
});
parcelRegister("67rvX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$85a3480f9ca78168$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eiOkd;
    var $cm8b5;
    var $8xg9P;
    var $6s1PB;
    var $iXVV6;
    var $5oFIy;
    var $7GkkF;
    var $95H4q;
    var $eM3wC;
    const $85a3480f9ca78168$var$Summary = ()=>{
        const view = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eM3wC")).default), null);
        const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('business_summary_page_inline_status');
        const isInlineStatusChangeEnabled = expConfig.get('isInlineStatusChangeEnabled', false);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceErrorBoundary), {
            experience: (0, (0, parcelRequire("7GkkF")).MAIN_EXPERIENCE),
            shouldStartExperience: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiOkd")).default), {
            withOverflow: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            objectType: "summary",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "summary"
        }, isInlineStatusChangeEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8xg9P")).WorkflowActionsProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("95H4q")).PrefetchedSummaryProvider), null, view)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("95H4q")).PrefetchedSummaryProvider), null, view), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null))));
    };
    var $85a3480f9ca78168$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($85a3480f9ca78168$var$Summary);
});
parcelRegister("eiOkd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b98d0f47ed36cd9a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6Ll2T;
    var $99gde;
    var $6cG4N;
    var $bUSNl;
    var $lLfAu;
    var $aXDiy;
    const $b98d0f47ed36cd9a$var$BusinessAppWrapper = ({ children: children, className: className, header: header, sidebarTheme: sidebarTheme, shouldAddPadding: shouldAddPadding = true, withSidebar: withSidebar = false, withDynamicHeight: withDynamicHeight = false, withOverflow: withOverflow = false })=>{
        const [{ content: sidebarContent }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const isSidebarOpen = withSidebar && sidebarContent != null;
        let content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, header, children);
        if (withSidebar) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lLfAu")).SidebarLayout), {
            theme: sidebarTheme
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: [
                $b98d0f47ed36cd9a$var$contentWrapperStyles,
                isSidebarOpen && $b98d0f47ed36cd9a$var$sidebarOpenContentWrapperStyles
            ]
        }, content));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aXDiy")).ThemedContainer), {
            shouldAddPadding: shouldAddPadding,
            isSidebarOpen: isSidebarOpen,
            withSidebar: withSidebar,
            withDynamicHeight: withDynamicHeight,
            withOverflow: withOverflow,
            id: (0, $c15b7ab4e654e0c4$export$e5e75ff4daca6597),
            className: className
        }, content);
    };
    const $b98d0f47ed36cd9a$var$contentWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        color: (0, (0, parcelRequire("6cG4N")).Tokens).COLOR_TEXT,
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        flexShrink: 1,
        maxWidth: '100%',
        minWidth: '0',
        width: 'auto'
    });
    const $b98d0f47ed36cd9a$var$sidebarOpenContentWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        paddingRight: 'space.300',
        paddingBottom: 'space.300'
    });
    var $b98d0f47ed36cd9a$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($b98d0f47ed36cd9a$var$BusinessAppWrapper);
});
const $c15b7ab4e654e0c4$export$e5e75ff4daca6597 = 'jwm-container';
parcelRegister("bUSNl", function(module, exports) {
    $parcel$export(module.exports, "getSidebarQueryParams", ()=>$39fc2da09b28cabf$export$ddc11e4d41e7cf62);
    $parcel$export(module.exports, "useSidebar", ()=>$39fc2da09b28cabf$export$54c70f22f548bff8);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $hE5wF;
    var $3hGWp;
    var $dCm1o;
    var $3sQ5x;
    var $iXqE5;
    var $jnA4H;
    const $39fc2da09b28cabf$export$86880b4b2e1a2384 = 'jwm.sidebar';
    const $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH_OLD = 360;
    const $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH = 435;
    const $39fc2da09b28cabf$export$ddc11e4d41e7cf62 = ()=>[
            (0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM),
            (0, (0, parcelRequire("hE5wF")).SELECTED_COMMENT_PARAM)
        ];
    const $39fc2da09b28cabf$export$f4c7df452942956a = ()=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH : $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH_OLD;
    const $39fc2da09b28cabf$var$setSidebarContent = (content)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                content: content
            });
        };
    const $39fc2da09b28cabf$var$setSidebarWidth = (width)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            const newWidth = Math.max(width, $39fc2da09b28cabf$export$f4c7df452942956a());
            if (newWidth === state.sidebarWidth) return;
            setState({
                ...state,
                sidebarWidth: newWidth
            });
            (0, (0, parcelRequire("jnA4H")).localStorage).set($39fc2da09b28cabf$export$86880b4b2e1a2384, newWidth);
        };
    const $39fc2da09b28cabf$var$setSidebarOnClose = (onSidebarClose)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                onSidebarClose: onSidebarClose
            });
        };
    const $39fc2da09b28cabf$var$closeSidebar = ()=>({ setState: setState, getState: getState })=>{
            const state = getState();
            state.onSidebarClose();
            setState({
                ...state,
                content: null,
                onSidebarClose: (0, ($parcel$interopDefault($8Rkzz)))
            });
        };
    const $39fc2da09b28cabf$var$actions = {
        setSidebarContent: $39fc2da09b28cabf$var$setSidebarContent,
        setSidebarWidth: $39fc2da09b28cabf$var$setSidebarWidth,
        setSidebarOnClose: $39fc2da09b28cabf$var$setSidebarOnClose,
        closeSidebar: $39fc2da09b28cabf$var$closeSidebar
    };
    const $39fc2da09b28cabf$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            content: null,
            sidebarWidth: (0, (0, parcelRequire("jnA4H")).localStorage).get($39fc2da09b28cabf$export$86880b4b2e1a2384) || $39fc2da09b28cabf$export$f4c7df452942956a(),
            onSidebarClose: (0, ($parcel$interopDefault($8Rkzz)))
        },
        actions: $39fc2da09b28cabf$var$actions,
        name: 'JWMSidebarStore'
    });
    const $39fc2da09b28cabf$var$useHook = (0, (0, parcelRequire("3sQ5x")).createHook)($39fc2da09b28cabf$var$Store);
    const $39fc2da09b28cabf$export$54c70f22f548bff8 = ()=>{
        const [state, hookActions] = $39fc2da09b28cabf$var$useHook();
        const sidebarQueryParams = $39fc2da09b28cabf$export$ddc11e4d41e7cf62();
        const [, setQueryParams] = (0, (0, parcelRequire("3hGWp")).useQueryParams)(...sidebarQueryParams);
        const resetSidebarQueryParams = (0, $5uXOq.useCallback)(()=>{
            const newQueryParams = sidebarQueryParams.reduce((acc, param)=>Object.assign(acc, {
                    [param]: undefined
                }), {});
            setQueryParams(newQueryParams);
        }, [
            setQueryParams,
            sidebarQueryParams
        ]);
        return [
            state,
            {
                ...hookActions,
                resetSidebarQueryParams: resetSidebarQueryParams
            }
        ];
    };
});
parcelRegister("hE5wF", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_RANK_SORTING_DIRECTION", ()=>$bfd6cbe4770149b5$export$8386e51ba415e85d);
    $parcel$export(module.exports, "DEFAULT_AVATAR_RES", ()=>$bfd6cbe4770149b5$export$159fe44438c210e9);
    $parcel$export(module.exports, "FILTER_PARAM", ()=>$bfd6cbe4770149b5$export$d8301e0b33832d94);
    $parcel$export(module.exports, "INLINE_CREATE_PARAM", ()=>$bfd6cbe4770149b5$export$599c163c1570a353);
    $parcel$export(module.exports, "INVITE_OPEN_PARAM", ()=>$bfd6cbe4770149b5$export$3a74d1a195d2f007);
    $parcel$export(module.exports, "SELECTED_ISSUE_PARAM", ()=>$bfd6cbe4770149b5$export$c070acdc9b0f1be5);
    $parcel$export(module.exports, "SELECTED_COMMENT_PARAM", ()=>$bfd6cbe4770149b5$export$3bcbd99d0f9ad6d8);
    $parcel$export(module.exports, "GROUP_BY_ASSIGNEE", ()=>$bfd6cbe4770149b5$export$dba794af6c0f2afc);
    $parcel$export(module.exports, "GROUP_BY_PRIORITY", ()=>$bfd6cbe4770149b5$export$56ecb5d2dfb80edc);
    $parcel$export(module.exports, "GROUP_BY_CATEGORY", ()=>$bfd6cbe4770149b5$export$22ef551f315f2786);
    $parcel$export(module.exports, "GROUP_BY_STATUS", ()=>$bfd6cbe4770149b5$export$6d69efb296b78a);
    $parcel$export(module.exports, "START_DATE_ALIAS_FIELD_ID", ()=>$bfd6cbe4770149b5$export$e23e1d1ea45171c2);
    $parcel$export(module.exports, "RANK_ALIAS_FIELD_ID", ()=>$bfd6cbe4770149b5$export$e35c6e217c75dc4b);
    $parcel$export(module.exports, "REMOTE_ISSUE_LINKS_TYPE", ()=>$bfd6cbe4770149b5$export$e5eab344feb92af9);
    $parcel$export(module.exports, "COMMENT_SUMMARY_TYPE", ()=>$bfd6cbe4770149b5$export$a311e1b78816c048);
    $parcel$export(module.exports, "CARD_COVERS_TYPE", ()=>$bfd6cbe4770149b5$export$f5583ff4ab4d63e5);
    $parcel$export(module.exports, "DEFAULT_PAGE_SIZE", ()=>$bfd6cbe4770149b5$export$5716e8bcb003888d);
    $parcel$export(module.exports, "STORY_POINTS_ALIAS_FIELD_ID", ()=>$bfd6cbe4770149b5$export$1f9fb9f15184100f);
    $parcel$export(module.exports, "STORY_POINT_ESTIMATE_ALIAS_FIELD_ID", ()=>$bfd6cbe4770149b5$export$c72ea455b368cdd9);
    const $bfd6cbe4770149b5$export$8386e51ba415e85d = (0, $2a9e000a443b1a95$export$1dee026a19752d6b);
    const $bfd6cbe4770149b5$export$159fe44438c210e9 = '48x48';
    const $bfd6cbe4770149b5$export$d8301e0b33832d94 = 'filter';
    const $bfd6cbe4770149b5$export$599c163c1570a353 = 'inlineCreate';
    const $bfd6cbe4770149b5$export$3a74d1a195d2f007 = 'inviteOpen';
    const $bfd6cbe4770149b5$export$e1e3f9fa6f04d6d = 'quickFilters';
    const $bfd6cbe4770149b5$export$c070acdc9b0f1be5 = 'selectedIssue';
    const $bfd6cbe4770149b5$export$3bcbd99d0f9ad6d8 = 'selectedComment';
    const $bfd6cbe4770149b5$export$dba794af6c0f2afc = 'assignee';
    const $bfd6cbe4770149b5$export$56ecb5d2dfb80edc = 'priority';
    const $bfd6cbe4770149b5$export$22ef551f315f2786 = 'category';
    const $bfd6cbe4770149b5$export$6d69efb296b78a = 'status';
    const $bfd6cbe4770149b5$export$e23e1d1ea45171c2 = 'startdate';
    const $bfd6cbe4770149b5$export$e35c6e217c75dc4b = 'rank';
    const $bfd6cbe4770149b5$export$e5eab344feb92af9 = 'remoteIssueLinks';
    const $bfd6cbe4770149b5$export$a311e1b78816c048 = 'commentsummary';
    const $bfd6cbe4770149b5$export$f5583ff4ab4d63e5 = 'cardCovers';
    const $bfd6cbe4770149b5$export$5716e8bcb003888d = 25;
    const $bfd6cbe4770149b5$export$1f9fb9f15184100f = 'storypoints';
    const $bfd6cbe4770149b5$export$c72ea455b368cdd9 = 'storypointestimate';
    const $bfd6cbe4770149b5$export$786b42b4618e6ee4 = 'sprint';
});
const $2a9e000a443b1a95$export$1dee026a19752d6b = 'ASC';
const $2a9e000a443b1a95$export$b6abcf7fa1d94f65 = 'DESC';
parcelRegister("jnA4H", function(module, exports) {
    $parcel$export(module.exports, "localStorage", ()=>$301038d04a64b539$export$c2ed3351cac403d1);
    var $bSSG7;
    const $301038d04a64b539$export$c2ed3351cac403d1 = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('jira_business_common');
});
parcelRegister("lLfAu", function(module, exports) {
    $parcel$export(module.exports, "SidebarLayout", ()=>$1dbab6fa0f2d1b51$export$8295a33ab8a36876);
    var $5uXOq = parcelRequire("5uXOq");
    var $6Ll2T;
    var $99gde;
    var $getxR;
    var $He4jn;
    var $bUSNl;
    var $eHSp3;
    const $1dbab6fa0f2d1b51$var$Sidebar = ({ children: children, sidebarWidth: sidebarWidth, theme: theme })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: [
                $1dbab6fa0f2d1b51$var$sidebarStyles,
                theme === 'business' && $1dbab6fa0f2d1b51$var$businessSidebarStyles
            ],
            style: {
                width: sidebarWidth
            }
        }, children);
    const $1dbab6fa0f2d1b51$export$8295a33ab8a36876 = ({ children: children, theme: theme = 'business' })=>{
        (0, (0, parcelRequire("getxR")).useSidebarQueryParams)();
        const [{ content: content, sidebarWidth: sidebarWidth }, { setSidebarContent: setSidebarContent }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const { onMouseDown: onMouseDown, isResizing: isResizing } = (0, (0, parcelRequire("He4jn")).useResizer)();
        (0, $5uXOq.useEffect)(()=>()=>{
                setSidebarContent(null);
            }, [
            setSidebarContent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eHSp3")).Wrapper), {
            isResizing: isResizing,
            "data-testid": "business-app-wrapper.ui.app-wrapper.sidebar-layout.sidebar-layout-wrapper"
        }, children, content && (0, ($parcel$interopDefault($5uXOq))).createElement($1dbab6fa0f2d1b51$var$Sidebar, {
            sidebarWidth: sidebarWidth,
            theme: theme
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eHSp3")).ResizeHandle), {
            onMouseDown: onMouseDown
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eHSp3")).SidebarContent), null, content)));
    };
    const $1dbab6fa0f2d1b51$var$sidebarStyles = (0, (0, parcelRequire("99gde")).xcss)({
        backgroundColor: 'elevation.surface',
        flexGrow: 0,
        flexShrink: 0,
        position: 'relative',
        zIndex: 'card',
        maxWidth: '75%'
    });
    const $1dbab6fa0f2d1b51$var$businessSidebarStyles = (0, (0, parcelRequire("99gde")).xcss)({
        borderTopLeftRadius: 'border.radius.200',
        borderTopRightRadius: 'border.radius.200',
        boxShadow: 'elevation.shadow.overlay',
        marginRight: 'space.300',
        marginTop: 'space.300'
    });
});
parcelRegister("getxR", function(module, exports) {
    $parcel$export(module.exports, "useSidebarQueryParams", ()=>$7ddee5a34b903b90$export$34adbeffbeceba68);
    var $5uXOq = parcelRequire("5uXOq");
    var $hE5wF;
    var $4R6GH;
    var $1XJ20;
    var $8zOmE;
    var $lwMsT;
    var $3hGWp;
    var $bUSNl;
    const $7ddee5a34b903b90$var$isEscapeEvent = (e)=>e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
    const $7ddee5a34b903b90$export$34adbeffbeceba68 = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const [{ content: content }, { setSidebarContent: setSidebarContent, resetSidebarQueryParams: resetSidebarQueryParams }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const sidebarQueryParams = (0, (0, parcelRequire("bUSNl")).getSidebarQueryParams)();
        const [queryParams, setQueryParams] = (0, (0, parcelRequire("3hGWp")).useQueryParams)(...sidebarQueryParams);
        const prevQueryParams = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(queryParams);
        const closeSidebar = (0, $5uXOq.useCallback)(()=>{
            resetSidebarQueryParams();
            setSidebarContent(null);
        }, [
            resetSidebarQueryParams,
            setSidebarContent
        ]);
        (0, $5uXOq.useEffect)(()=>{
            sidebarQueryParams.forEach((queryParam)=>{
                if (!prevQueryParams[queryParam] && queryParams[queryParam]) {
                    const newQueryParams = sidebarQueryParams.filter((param)=>param !== queryParam).reduce((acc, param)=>Object.assign(acc, {
                            [param]: undefined
                        }), {});
                    setQueryParams(newQueryParams);
                }
            });
        }, [
            prevQueryParams,
            queryParams,
            setQueryParams,
            sidebarQueryParams
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const handleKeydown = (event)=>{
                if (!queryParams[0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM] && (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) return;
                if (queryParams[0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM] && content?.key === 'unscheduledSidebar') return;
                if ($7ddee5a34b903b90$var$isEscapeEvent(event)) {
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'sidebar closed', 'esc');
                    closeSidebar();
                }
            };
            typeof document !== 'undefined' && document.addEventListener('keydown', handleKeydown);
            return ()=>{
                typeof document !== 'undefined' && document.removeEventListener('keydown', handleKeydown);
            };
        }, [
            closeSidebar,
            content?.key,
            createAnalyticsEvent,
            queryParams
        ]);
    };
});
parcelRegister("He4jn", function(module, exports) {
    $parcel$export(module.exports, "useResizer", ()=>$80d7a99fb39f1e91$export$faede3f1542958fc);
    var $5uXOq = parcelRequire("5uXOq");
    var $34ck9 = parcelRequire("34ck9");
    var $bUSNl;
    const $80d7a99fb39f1e91$var$THROTTLE_TIME = 16;
    const $80d7a99fb39f1e91$export$faede3f1542958fc = ()=>{
        const [{ sidebarWidth: sidebarWidth }, { setSidebarWidth: setSidebarWidth }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const startRef = (0, $5uXOq.useRef)(0);
        const width = (0, $5uXOq.useRef)(0);
        const [isResizing, setIsResizing] = (0, $5uXOq.useState)(false);
        const resize = (0, $5uXOq.useCallback)((0, ($parcel$interopDefault($34ck9)))((clientX)=>{
            const proposedWidth = width.current + startRef.current - clientX;
            setSidebarWidth(proposedWidth);
        }, $80d7a99fb39f1e91$var$THROTTLE_TIME), [
            setSidebarWidth
        ]);
        const onMouseMove = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
            resize(event.clientX);
        }, [
            resize
        ]);
        const onMouseUp = (0, $5uXOq.useCallback)(()=>{
            startRef.current = 0;
            width.current = 0;
            setIsResizing(false);
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        }, [
            onMouseMove
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                document.removeEventListener('mousemove', onMouseMove);
                document.removeEventListener('mouseup', onMouseUp);
            }, [
            onMouseMove,
            onMouseUp
        ]);
        const onMouseDown = (0, $5uXOq.useCallback)((event)=>{
            startRef.current = event.clientX;
            width.current = sidebarWidth;
            setIsResizing(true);
            document.addEventListener('mousemove', onMouseMove);
            document.addEventListener('mouseup', onMouseUp);
        }, [
            onMouseMove,
            onMouseUp,
            sidebarWidth
        ]);
        return {
            onMouseDown: onMouseDown,
            onMouseUp: onMouseUp,
            onMouseMove: onMouseMove,
            isResizing: isResizing
        };
    };
});
parcelRegister("eHSp3", function(module, exports) {
    $parcel$export(module.exports, "Wrapper", ()=>$71d20039839e60ab$export$e6dfd72ab29f8598);
    $parcel$export(module.exports, "SidebarContent", ()=>$71d20039839e60ab$export$49e8f7b58a4df4ea);
    $parcel$export(module.exports, "ResizeHandle", ()=>$71d20039839e60ab$export$33f2411a0ad35be7);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $71d20039839e60ab$export$e6dfd72ab29f8598 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isResizing: isResizing, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1fhb _4t3i1osq",
                __cmplp.isResizing ? "_80omuf7j" : "_80om73ad",
                __cmplp.className
            ])
        });
    });
    const $71d20039839e60ab$export$49e8f7b58a4df4ea = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18m91wug _13wustnw _1igsidpf _184nidpf _bhl91osq _1j101bpf _134m1txw _sojr1h6o",
                __cmplp.className
            ])
        });
    });
    const $71d20039839e60ab$export$33f2411a0ad35be7 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bsb1tcg _80omuf7j _kqswh2mm _1wpz1fhb _1pbybfng _1ltvxmi2 _4t3i1osq _aetrb3bt _16r2glyw _qc5othzt _18postnw _z0aiyh40 _15l2idpf _19doutpp _1qdg1osq _1jju194a _5u1r194a",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("aXDiy", function(module, exports) {
    $parcel$export(module.exports, "ThemedContainer", ()=>$0d3cb0cba7f538e9$export$2a4209ec8a7db359);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $0d3cb0cba7f538e9$export$2a4209ec8a7db359 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { withSidebar: withSidebar, withDynamicHeight: withDynamicHeight, shouldAddPadding: shouldAddPadding, isSidebarOpen: isSidebarOpen, withOverflow: withOverflow, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_vchhusvi _1e0c1txw _2lx21bp4 _1n261q9c _1bah1y6m _ca0qidpf",
                !__cmplp.withSidebar && "_syazfrbu",
                __cmplp.withDynamicHeight ? "_4t3i1wug" : "_4t3i1osq",
                __cmplp.withDynamicHeight ? "_1tke1osq" : "_1tke1wug",
                !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_u5f3idpf" : "_u5f31ejb",
                !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_n3tdidpf" : "_n3td1ejb",
                __cmplp.shouldAddPadding ? "_19bv1ejb" : "_19bvidpf",
                __cmplp.withOverflow ? "_1reo1wug _18m91wug" : "_1reoewfl _18m9ewfl",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("8xg9P", function(module, exports) {
    $parcel$export(module.exports, "WorkflowActionsProvider", ()=>$58b4801e95090525$export$52383769590f1f7d);
    $parcel$export(module.exports, "useIsWorkflowOperationInProgress", ()=>$58b4801e95090525$export$d8535539ef06db21);
    $parcel$export(module.exports, "useWorkflowOperationStatusId", ()=>$58b4801e95090525$export$fcd0c43b34e1ab49);
    $parcel$export(module.exports, "useStopWorkflowOperationInProgress", ()=>$58b4801e95090525$export$7d25f9f7a4197a33);
    $parcel$export(module.exports, "useStartDeleteOperation", ()=>$58b4801e95090525$export$f125869614239ac);
    $parcel$export(module.exports, "useStartAddOperation", ()=>$58b4801e95090525$export$a9547f77ff1cbe18);
    $parcel$export(module.exports, "useStartRenameOperation", ()=>$58b4801e95090525$export$1763316459ec74d5);
    var $5uXOq = parcelRequire("5uXOq");
    const $58b4801e95090525$export$98ff4de2f070152d = {
        DELETING: 'deleting-status',
        ADDING: 'adding-status',
        RENAMING: 'renaming-status'
    };
    const $58b4801e95090525$var$WorkflowActionsContext = (0, $5uXOq.createContext)(null);
    const $58b4801e95090525$export$52383769590f1f7d = ({ children: children })=>{
        const [operationInProgress, setOperationInProgress] = (0, $5uXOq.useState)(null);
        const [statusId, setStatusId] = (0, $5uXOq.useState)(null);
        const value = (0, $5uXOq.useMemo)(()=>({
                statusId: statusId,
                operationInProgress: operationInProgress,
                setStatusId: setStatusId,
                setOperationInProgress: setOperationInProgress
            }), [
            statusId,
            operationInProgress
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($58b4801e95090525$var$WorkflowActionsContext.Provider, {
            value: value
        }, children);
    };
    const $58b4801e95090525$export$1f652ba9a3f9f48e = ()=>{
        const context = (0, $5uXOq.useContext)($58b4801e95090525$var$WorkflowActionsContext);
        if (!context) throw new Error('WorkflowActionsContext must be used within a WorkflowActionsProvider');
        return context;
    };
    const $58b4801e95090525$export$d8535539ef06db21 = ()=>{
        const context = $58b4801e95090525$export$1f652ba9a3f9f48e();
        return context.operationInProgress != null;
    };
    const $58b4801e95090525$export$fcd0c43b34e1ab49 = ()=>{
        const context = $58b4801e95090525$export$1f652ba9a3f9f48e();
        return context.statusId;
    };
    const $58b4801e95090525$export$7d25f9f7a4197a33 = ()=>{
        const { setOperationInProgress: setOperationInProgress, setStatusId: setStatusId } = $58b4801e95090525$export$1f652ba9a3f9f48e();
        return (0, $5uXOq.useCallback)(()=>{
            setOperationInProgress(null);
            setStatusId(null);
        }, [
            setOperationInProgress,
            setStatusId
        ]);
    };
    const $58b4801e95090525$export$f125869614239ac = ()=>{
        const { setOperationInProgress: setOperationInProgress } = $58b4801e95090525$export$1f652ba9a3f9f48e();
        return (0, $5uXOq.useCallback)(()=>{
            setOperationInProgress($58b4801e95090525$export$98ff4de2f070152d.DELETING);
        }, [
            setOperationInProgress
        ]);
    };
    const $58b4801e95090525$export$a9547f77ff1cbe18 = ()=>{
        const { setOperationInProgress: setOperationInProgress, setStatusId: setStatusId } = $58b4801e95090525$export$1f652ba9a3f9f48e();
        return (0, $5uXOq.useCallback)((statusId)=>{
            setStatusId(statusId);
            setOperationInProgress($58b4801e95090525$export$98ff4de2f070152d.ADDING);
        }, [
            setOperationInProgress,
            setStatusId
        ]);
    };
    const $58b4801e95090525$export$1763316459ec74d5 = ()=>{
        const { setOperationInProgress: setOperationInProgress, setStatusId: setStatusId } = $58b4801e95090525$export$1f652ba9a3f9f48e();
        return (0, $5uXOq.useCallback)((statusId)=>{
            setStatusId(statusId);
            setOperationInProgress($58b4801e95090525$export$98ff4de2f070152d.RENAMING);
        }, [
            setStatusId,
            setOperationInProgress
        ]);
    };
});
parcelRegister("7GkkF", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_TYPE_MAX_LENGTH", ()=>$16de1e6714bec2e3$export$f29fab0bcf7a4b41);
    $parcel$export(module.exports, "MAIN_EXPERIENCE", ()=>$16de1e6714bec2e3$export$b3d8a68bfc68a411);
    $parcel$export(module.exports, "ACTIVITY_FEED_EXPERIENCE", ()=>$16de1e6714bec2e3$export$f313e3e286755e5f);
    $parcel$export(module.exports, "PROJECT_DETAILS_EXPERIENCE", ()=>$16de1e6714bec2e3$export$75f46ca6094c53d1);
    $parcel$export(module.exports, "RELATED_PROJECTS_EXPERIENCE", ()=>$16de1e6714bec2e3$export$35e64816b2aad93b);
    $parcel$export(module.exports, "RENAME_ISSUE_TYPE_EXPERIENCE", ()=>$16de1e6714bec2e3$export$9fcac75b786e7c43);
    $parcel$export(module.exports, "RENAME_STATUS_EXPERIENCE", ()=>$16de1e6714bec2e3$export$392da7a82d11d6ae);
    $parcel$export(module.exports, "CREATE_STATUS_EXPERIENCE", ()=>$16de1e6714bec2e3$export$b2eecf8364bcde91);
    var $gwIPs;
    const $16de1e6714bec2e3$var$PACKAGE_NAME = 'jiraBusinessSummary';
    const $16de1e6714bec2e3$export$d5647771ea34eda2 = 480;
    const $16de1e6714bec2e3$export$eddd9cbfc15b85f8 = (0, (0, parcelRequire("gwIPs")).gridSize);
    const $16de1e6714bec2e3$export$eb2dc4deee1bebc8 = 8;
    const $16de1e6714bec2e3$export$f29fab0bcf7a4b41 = 60;
    const $16de1e6714bec2e3$export$b5a4c2e8548137d2 = 1768;
    const $16de1e6714bec2e3$export$b3d8a68bfc68a411 = {
        experience: 'summary',
        experienceId: 'main',
        packageName: $16de1e6714bec2e3$var$PACKAGE_NAME,
        teamName: 'wanjel'
    };
    const $16de1e6714bec2e3$export$f313e3e286755e5f = {
        experience: 'activity-feed',
        packageName: $16de1e6714bec2e3$var$PACKAGE_NAME,
        teamName: 'wanjel'
    };
    const $16de1e6714bec2e3$export$9380dfa5ed375ae4 = {
        experience: 'overview-details',
        packageName: $16de1e6714bec2e3$var$PACKAGE_NAME,
        teamName: 'wanjel'
    };
    const $16de1e6714bec2e3$export$75f46ca6094c53d1 = {
        experience: 'project-details',
        packageName: $16de1e6714bec2e3$var$PACKAGE_NAME,
        teamName: 'wanjel'
    };
    const $16de1e6714bec2e3$export$35e64816b2aad93b = {
        experience: 'related-projects',
        packageName: $16de1e6714bec2e3$var$PACKAGE_NAME,
        teamName: 'wanjel'
    };
    const $16de1e6714bec2e3$export$9fcac75b786e7c43 = {
        experience: 'rename-issue-type',
        packageName: $16de1e6714bec2e3$var$PACKAGE_NAME,
        teamName: 'wanjel'
    };
    const $16de1e6714bec2e3$export$392da7a82d11d6ae = {
        experience: 'rename-status',
        packageName: $16de1e6714bec2e3$var$PACKAGE_NAME,
        teamName: 'wanjel'
    };
    const $16de1e6714bec2e3$export$b2eecf8364bcde91 = {
        experience: 'create-status',
        packageName: $16de1e6714bec2e3$var$PACKAGE_NAME,
        teamName: 'wanjel'
    };
});
parcelRegister("95H4q", function(module, exports) {
    $parcel$export(module.exports, "PrefetchedSummaryProvider", ()=>$e87c3437e981fb98$export$2fd85b6f3e7714fa);
    $parcel$export(module.exports, "useSummaryContext", ()=>$e87c3437e981fb98$export$fda0c570f177c6c0);
    $parcel$export(module.exports, "useOverviewItems", ()=>$e87c3437e981fb98$export$2c8a54273e8ece13);
    $parcel$export(module.exports, "useIssuesByStatus", ()=>$e87c3437e981fb98$export$e765c1bd3a21fadb);
    $parcel$export(module.exports, "useIssuesByPriority", ()=>$e87c3437e981fb98$export$ec9e74eb4d4222aa);
    $parcel$export(module.exports, "useIssuesByAssignee", ()=>$e87c3437e981fb98$export$90328bbff20c5812);
    $parcel$export(module.exports, "useIssuesByType", ()=>$e87c3437e981fb98$export$f3f76b41ba5a385);
    $parcel$export(module.exports, "useWorkflowsCount", ()=>$e87c3437e981fb98$export$ebeea0f5c9c2959);
    var $5uXOq = parcelRequire("5uXOq");
    var $3zj3N;
    const $e87c3437e981fb98$var$SummaryContext = (0, $5uXOq.createContext)({
        data: undefined,
        loading: true,
        error: undefined,
        refresh: ()=>undefined
    });
    const $e87c3437e981fb98$export$2fd85b6f3e7714fa = ({ children: children })=>{
        const { data: data, loading: loading, error: error, refresh: refresh } = (0, (0, parcelRequire("3zj3N")).useSummaryData)();
        const context = (0, $5uXOq.useMemo)(()=>({
                data: data,
                loading: false ? true : loading,
                error: error,
                refresh: refresh
            }), [
            data,
            loading,
            error,
            refresh
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($e87c3437e981fb98$var$SummaryContext.Provider, {
            value: context
        }, children);
    };
    const $e87c3437e981fb98$export$fda0c570f177c6c0 = ()=>(0, $5uXOq.useContext)($e87c3437e981fb98$var$SummaryContext);
    const $e87c3437e981fb98$export$2c8a54273e8ece13 = ()=>{
        const { data: data, loading: loading, error: error } = $e87c3437e981fb98$export$fda0c570f177c6c0();
        return {
            data: data?.overviewItems,
            loading: loading,
            error: error
        };
    };
    const $e87c3437e981fb98$export$e765c1bd3a21fadb = ()=>{
        const { data: data, loading: loading, error: error, refresh: refresh } = $e87c3437e981fb98$export$fda0c570f177c6c0();
        return {
            data: data?.issuesByStatus,
            loading: loading,
            error: error,
            refresh: refresh
        };
    };
    const $e87c3437e981fb98$export$ec9e74eb4d4222aa = ()=>{
        const { data: data, loading: loading, error: error } = $e87c3437e981fb98$export$fda0c570f177c6c0();
        return {
            data: data?.issuesByPriority,
            loading: loading,
            error: error
        };
    };
    const $e87c3437e981fb98$export$90328bbff20c5812 = ()=>{
        const { data: data, loading: loading, error: error } = $e87c3437e981fb98$export$fda0c570f177c6c0();
        return {
            data: data?.issuesByAssignee,
            loading: loading,
            error: error
        };
    };
    const $e87c3437e981fb98$export$f3f76b41ba5a385 = ()=>{
        const { data: data, loading: loading, error: error } = $e87c3437e981fb98$export$fda0c570f177c6c0();
        return {
            data: data?.issuesByType,
            loading: loading,
            error: error
        };
    };
    const $e87c3437e981fb98$export$ebeea0f5c9c2959 = ()=>{
        const { data: data, loading: loading, error: error } = $e87c3437e981fb98$export$fda0c570f177c6c0();
        return {
            data: {
                totalCount: data?.workflowsCount
            },
            loading: loading,
            error: error
        };
    };
});
parcelRegister("eM3wC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ec700f8f519d84e0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $6Ll2T;
    var $3srSR;
    var $99gde;
    var $e21nk;
    var $8UpTw;
    var $cm8b5;
    var $7Wnap;
    var $gN11a;
    var $7yduy;
    var $6cG4N;
    var $koVbs;
    var $7GkkF;
    var $3iDn2;
    var $7TJr2;
    var $95H4q;
    var $4rcis;
    var $26Ze8;
    var $u3iGU;
    var $jtzbv;
    var $fZDRX;
    var $gFWns;
    var $2vMT1;
    var $g3c4A;
    var $9lJRz;
    var $7e46m;
    var $2Fiz0;
    const $ec700f8f519d84e0$var$cardFallback = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iDn2")).ErrorCard), null);
    const $ec700f8f519d84e0$var$SummaryView = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { featureView: featureView, hasFeedbackFooter: hasFeedbackFooter, hasHeader: hasHeader } = (0, (0, parcelRequire("7TJr2")).useSummaryFeatures)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("95H4q")).useSummaryContext)();
        const isReady = data != null && !loading && !error;
        (0, $5uXOq.useEffect)(()=>{
            if (loading) (0, (0, parcelRequire("gN11a")).markViewMetric)('summary', (0, $a286480ec63fa4c8$export$23e322eb7c526958));
            else (0, (0, parcelRequire("gN11a")).markViewMetric)('summary', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
        }, [
            loading
        ]);
        const pageHeading = formatMessage((0, (0, parcelRequire("fZDRX")).default).summaryHeading);
        if (error != null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8UpTw")).ErrorPage), {
            error: error
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceFailed), {
            experience: (0, (0, parcelRequire("7GkkF")).MAIN_EXPERIENCE),
            error: error
        }));
        let position = 0;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Wnap")).RenderStartMark), {
            view: "summary",
            loading: loading
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e21nk")).BusinessDocumentTitle), {
            pageHeading: pageHeading
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($ec700f8f519d84e0$var$ResponsiveContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $ec700f8f519d84e0$var$headerWrapperStyles
        }, hasHeader && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jtzbv")).default), {
            isLoading: loading
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g3c4A")).default), {
            isSkeleton: loading
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gFWns")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3srSR")).default), {
            xcss: $ec700f8f519d84e0$var$cardContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2vMT1")).default), {
            position: position += 1
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceErrorBoundary), {
            experience: (0, (0, parcelRequire("7GkkF")).ACTIVITY_FEED_EXPERIENCE),
            shouldStartExperience: true,
            fallback: $ec700f8f519d84e0$var$cardFallback
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4rcis")).default), {
            position: position += 1
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("26Ze8")).default), {
            position: position += 1
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7e46m")).default), {
            position: position += 1
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2Fiz0")).default), {
            position: position += 1
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceErrorBoundary), {
            experience: (0, (0, parcelRequire("7GkkF")).RELATED_PROJECTS_EXPERIENCE),
            shouldStartExperience: true,
            fallback: $ec700f8f519d84e0$var$cardFallback
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9lJRz")).default), {
            position: position += 1
        }))), hasFeedbackFooter && (0, ($parcel$interopDefault($5uXOq))).createElement("footer", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("u3iGU")).default), {
            isLoading: loading
        }))), isReady && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Wnap")).PageLoadMetrics), {
            view: featureView
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceSuccess), {
            experience: (0, (0, parcelRequire("7GkkF")).MAIN_EXPERIENCE)
        })), !loading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7yduy")).JWMSpaStatePageReady), null));
    };
    var $ec700f8f519d84e0$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($ec700f8f519d84e0$var$SummaryView);
    const $ec700f8f519d84e0$var$headerWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        background: (0, (0, parcelRequire("6cG4N")).Tokens).ELEVATION_SURFACE_CONTRAST,
        borderRadius: 'border.radius.200',
        paddingLeft: 'space.400',
        paddingRight: 'space.400',
        paddingTop: 'space.300',
        paddingBottom: 'space.100',
        marginTop: 'space.200',
        marginBottom: 'space.100'
    });
    const $ec700f8f519d84e0$var$cardContainerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        gap: 'space.200',
        flexWrap: 'wrap'
    });
    const $ec700f8f519d84e0$var$ResponsiveContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _p12fa2f6 _1wpz1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("e21nk", function(module, exports) {
    $parcel$export(module.exports, "BusinessDocumentTitle", ()=>$aa5670652f17dfc4$export$416064ba09d98e69);
    var $5uXOq = parcelRequire("5uXOq");
    var $ew1Lk;
    var $54qG5;
    const $aa5670652f17dfc4$export$416064ba09d98e69 = (0, $5uXOq.memo)(({ pageHeading: pageHeading })=>{
        const { data: entity } = (0, (0, parcelRequire("54qG5")).useBusinessEntity)();
        const documentTitle = entity?.name ? `${pageHeading} - ${entity.name}` : pageHeading;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ew1Lk")).DocumentTitle), {
            title: documentTitle
        });
    });
});
parcelRegister("ew1Lk", function(module, exports) {
    $parcel$export(module.exports, "DocumentTitle", ()=>$41b549fa18234081$export$dd5ad0b65cf665da);
    var $5uXOq = parcelRequire("5uXOq");
    var $6nkVm;
    class $41b549fa18234081$export$dd5ad0b65cf665da extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                TitleSubscriber: (0, (0, parcelRequire("6nkVm")).DocumentTitleSubscriber)
            };
        }
        shouldComponentUpdate(nextProps) {
            return nextProps.title !== this.props.title;
        }
        render() {
            const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6nkVm")).DocumentTitleHelper), {
                    title: title,
                    setTitle: setTitle,
                    addDocumentTitle: addDocumentTitle,
                    contextArray: contextArray,
                    removeDocumentTitle: removeDocumentTitle,
                    TitleSubscriber: TitleSubscriber
                }));
        }
    }
});
const $a286480ec63fa4c8$export$747aad128920134d = 3000;
const $a286480ec63fa4c8$export$e4f8d353742c04ac = 4000;
const $a286480ec63fa4c8$export$540ffd289e5e0562 = 'timeWaitingForBackendData';
const $a286480ec63fa4c8$export$23e322eb7c526958 = 'REQUEST_START';
const $a286480ec63fa4c8$export$83ca21a50372ea3b = 'REQUEST_END';
const $a286480ec63fa4c8$export$821ca6ff41f300ec = 'jwm-availableFieldsQuery';
const $a286480ec63fa4c8$export$7b887ee35f2b465e = 'AVAILABLE_FIELDS_QUERY_START';
const $a286480ec63fa4c8$export$ac953882305d6102 = 'AVAILABLE_FIELDS_QUERY_END';
const $a286480ec63fa4c8$export$7f7f60b5526c5ee3 = 'jwm-ui-render-time';
const $a286480ec63fa4c8$export$b78f0bbf209e5f4 = 'UI_RENDER_START';
const $a286480ec63fa4c8$export$88ea1e280513690f = 'UI_RENDER_END';
parcelRegister("7Wnap", function(module, exports) {
    $parcel$export(module.exports, "RenderStartMark", ()=>$4c177752bab6a832$export$2128f295d6adb861);
    $parcel$export(module.exports, "PageLoadMetrics", ()=>$4c177752bab6a832$export$66b33c055cbb625e);
    var $5uXOq = parcelRequire("5uXOq");
    var $5rqex;
    var $gN11a;
    const $4c177752bab6a832$export$2128f295d6adb861 = ({ view: view, loading: loading })=>{
        if (loading === true) return null;
        (0, (0, parcelRequire("gN11a")).markViewMetric)(view, (0, $a286480ec63fa4c8$export$b78f0bbf209e5f4));
        return null;
    };
    const $4c177752bab6a832$export$66b33c055cbb625e = (0, $5uXOq.memo)(({ view: view, attributes: attributes, product: product = 'jwm' })=>{
        (0, (0, parcelRequire("gN11a")).markViewMetric)(view, (0, $a286480ec63fa4c8$export$88ea1e280513690f));
        const metric = (0, (0, parcelRequire("gN11a")).pageLoadMetrics)[view];
        return metric && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5rqex")).default), {
            appName: `${product}.${view}`,
            metric: metric,
            extra: attributes
        });
    });
});
parcelRegister("5rqex", function(module, exports) {
    $parcel$export(module.exports, "checkAndEmitApdexSignal", ()=>$ab527e70454bab7e$export$3082c88b693a5230);
    $parcel$export(module.exports, "default", ()=>$ab527e70454bab7e$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "baseDefaultProps", ()=>$ab527e70454bab7e$export$9b3029ee6188a41f);
    var $5uXOq = parcelRequire("5uXOq");
    var $czVoz;
    var $9TpzN;
    var $d7oXH;
    var $co1wz;
    var $2m0sQ;
    var $6G6w0;
    var $3wLoG;
    var $gtdbK;
    var $zbAs4;
    var $3B7oW;
    const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
        var emitSignal;
    };
    class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isExpectedToHaveSsr: false,
                withMarks: [],
                extra: {},
                emitOnAnimationFrame: false
            };
        }
        render() {
            const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
            const isUFODefined = (0, (0, parcelRequire("co1wz")).ff)('uip.ufo') && (0, (0, parcelRequire("2m0sQ")).GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
            if (isUFODefined) (0, (0, parcelRequire("zbAs4")).addUFOSSRDoneAsFMPToInteraction)();
            if (metric) {
                (0, (0, parcelRequire("gtdbK")).addBM3SSRDoneAsFMPToInteraction)(metric);
                (0, (0, parcelRequire("3B7oW")).trackBM3FeatureFlagsAccessed)(metric);
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("czVoz")).default), {
                data: extra
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9TpzN")).UFOBM3TimingsToUFO), {
                marks: metric?.getData()?.marks,
                timings: metric?.getData()?.config?.timings
            }), isUFODefined ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3wLoG")).StopUfo), {
                appName: appName,
                customData: extra,
                key: (0, (0, parcelRequire("d7oXH")).getInteractionId)().current
            }) : metric && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6G6w0")).StopBrowserMetrics3), {
                metric: metric,
                customData: extra,
                emitOnAnimationFrame: emitOnAnimationFrame
            }));
        }
    }
    const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;
});
parcelRegister("9TpzN", function(module, exports) {
    $parcel$export(module.exports, "getBm3Timings", ()=>$886eecd9178dd67d$export$f02972da195a43bb);
    $parcel$export(module.exports, "UFOBM3TimingsToUFO", ()=>$886eecd9178dd67d$export$30f0b5e5acd268bf);
    $parcel$export(module.exports, "addBM3TimingsToUFO", ()=>$886eecd9178dd67d$export$d93d677ef2f33c5c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bvsv1;
    var $d7oXH;
    var $knQnR;
    function $886eecd9178dd67d$export$f02972da195a43bb(marks, timingConfigs) {
        const bm3Timings = {};
        if (!marks || !timingConfigs) return bm3Timings;
        timingConfigs.forEach((item)=>{
            if (!item.startMark || !item.endMark) return;
            const startTime = marks[item.startMark];
            if (!startTime) return;
            const endTime = marks[item.endMark];
            if (!endTime) return;
            bm3Timings[item.key] = {
                startTime: startTime,
                endTime: endTime
            };
        });
        return bm3Timings;
    }
    function $886eecd9178dd67d$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
        const interactionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("bvsv1")).default));
        const interactionId = (0, (0, parcelRequire("d7oXH")).getInteractionId)().current;
        (0, $5uXOq.useMemo)(()=>{
            if (interactionContext != null && interactionId != null && marks != null && timings != null) {
                const interactionType = (0, (0, parcelRequire("knQnR")).getCurrentInteractionType)(interactionId);
                if (interactionType === 'press') return;
                const bm3Timings = $886eecd9178dd67d$export$f02972da195a43bb(marks, timings);
                interactionContext.addCustomTimings(bm3Timings);
            }
        }, [
            interactionContext,
            interactionId,
            marks,
            timings
        ]);
        return null;
    }
    function $886eecd9178dd67d$export$d93d677ef2f33c5c(marks, timingsConfig) {
        const interactionId = (0, (0, parcelRequire("d7oXH")).getInteractionId)().current;
        if (interactionId) {
            const interactionType = (0, (0, parcelRequire("knQnR")).getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $886eecd9178dd67d$export$f02972da195a43bb(marks, timingsConfig);
            (0, (0, parcelRequire("knQnR")).addCustomTiming)(interactionId, [], bm3Timings);
        }
    }
});
parcelRegister("6G6w0", function(module, exports) {
    $parcel$export(module.exports, "StopBrowserMetrics3", ()=>$84d0d168ebb35c8a$export$575e93c0f9905999);
    var $5uXOq = parcelRequire("5uXOq");
    var $bvsv1;
    var $9efn2;
    var $x9xyg;
    var $7N30e;
    var $co1wz;
    var $4dRjY;
    var $2SVPM;
    var $6b6Tk;
    const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
        !(0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
        if (stopTime !== undefined) {
            if (!(0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
            }
            metric.stop({
                customData: customData,
                stopTime: stopTime
            });
        } else metric.stop({
            customData: customData
        });
        if ((0, (0, parcelRequire("6b6Tk")).isAutomaticExposureCollectionEnabled)()) (0, (0, parcelRequire("7N30e")).stopLowPriorityEventDelay)();
    };
    class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            if (!metric) return;
            const start = (0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task') ? (0, (0, parcelRequire("9efn2")).browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_START', {
                startTime: start
            });
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_END');
            (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
            const bm3Data = metric.getData();
            if (emitOnAnimationFrame) {
                const stopTime = performance.now();
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: stopTime
                });
                if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                    (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_TASK_END');
                    (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
                });
                requestAnimationFrame(()=>{
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                        metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                    }
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                        $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                    }, 500);
                    else $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                });
            } else {
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: performance.now()
                });
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
            }
        }
        static{
            this.contextType = (0, (0, parcelRequire("bvsv1")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("4dRjY", function(module, exports) {
    $parcel$export(module.exports, "PRODUCT_START_MARK", ()=>$9953c23a4f71adac$export$8e54fca0a680fdfd);
    $parcel$export(module.exports, "MarkProductStart", ()=>$9953c23a4f71adac$export$2a999c5f84501025);
    var $x9xyg;
    const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
    const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
        if (!false) {
            performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
            (0, (0, parcelRequire("x9xyg")).setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
        }
        return null;
    };
});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';
parcelRegister("3wLoG", function(module, exports) {
    $parcel$export(module.exports, "StopUfo", ()=>$bc9c50f4292c4530$export$d91154f099475c5);
    var $5uXOq = parcelRequire("5uXOq");
    var $bvsv1;
    var $2m0sQ;
    class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { customData: customData, appName: appName } = this.props;
            (0, (0, parcelRequire("2m0sQ")).GlobalPageLoadExperience).success({
                force: true,
                metadata: customData
            });
            const name = appName || (0, (0, parcelRequire("2m0sQ")).GlobalPageLoadExperience).loadingPageLoadId;
            if (name) this.context?.addApdex({
                key: name,
                stopTime: performance.now()
            });
        }
        static{
            this.contextType = (0, (0, parcelRequire("bvsv1")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("gtdbK", function(module, exports) {
    $parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", ()=>$9088c71f7c9189f4$export$bf239ac2bfb04967);
    var $d7oXH;
    var $knQnR;
    function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
        const interactionId = (0, (0, parcelRequire("d7oXH")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && data?.isInitial) (0, (0, parcelRequire("knQnR")).addMetadata)(currentInteractionId, {
            __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
        });
    }
});
parcelRegister("zbAs4", function(module, exports) {
    $parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", ()=>$30d390cd1767d57f$export$e63862cd888fe05a);
    var $d7oXH;
    var $knQnR;
    var $2m0sQ;
    var $h9AzB;
    async function $30d390cd1767d57f$export$e63862cd888fe05a() {
        const interactionId = (0, (0, parcelRequire("d7oXH")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = await (0, (0, parcelRequire("2m0sQ")).GlobalPageLoadExperience).exportData();
        const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, (0, parcelRequire("h9AzB")).payloadPublisher).ssr?.getDoneMark();
        if (data.initial && fmpMark) (0, (0, parcelRequire("knQnR")).addMetadata)(currentInteractionId, {
            __legacy__ufoConfigSSRDoneAsFmp: true
        });
    }
});
parcelRegister("3B7oW", function(module, exports) {
    $parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", ()=>$afa764d83f81f55e$export$f00f1e874ce869e9);
    var $d7oXH;
    var $y7eb2;
    const $afa764d83f81f55e$var$startsAsObject = (value)=>{
        try {
            if (value.charAt(0) === '{') return true;
        } catch (e) {
            return false;
        }
        return false;
    };
    const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
    const $afa764d83f81f55e$var$isString = (input)=>{
        let result;
        try {
            result = typeof input === 'string' || input instanceof String;
        } catch (err) {
            result = false;
        }
        return result;
    };
    const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
    const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
    const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
    const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
        const interactionId = (0, (0, parcelRequire("d7oXH")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && config?.featureFlags?.length) {
            const allFeatureFlags = (0, (0, parcelRequire("y7eb2")).default)();
            config.featureFlags.forEach((featureFlagName)=>{
                const value = allFeatureFlags[featureFlagName];
                if (value === undefined) return;
                const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
                $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
            });
        }
    };
});
parcelRegister("7yduy", function(module, exports) {
    $parcel$export(module.exports, "JWMSpaStatePageReady", ()=>$150b436063f0aaae$export$d54524c142a057f);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZw8H;
    const $150b436063f0aaae$export$d54524c142a057f = ()=>{
        const [isReady, setIsReady] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            let id = window.requestAnimationFrame(()=>{
                id = window.requestAnimationFrame(()=>{
                    setIsReady(true);
                });
            });
            return ()=>{
                window.cancelAnimationFrame(id);
            };
        }, []);
        if (!isReady) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZw8H")).SpaStatePageReady), null);
    };
});
parcelRegister("3iDn2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$903ea2626a0025b0$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "ErrorCard", ()=>$903ea2626a0025b0$export$a2c93507c97cd090);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $2APCZ;
    var $cZ1Pf;
    var $koVbs;
    var $5qJQ3;
    var $hTpz8;
    const $903ea2626a0025b0$var$Card = (0, $5uXOq.forwardRef)(({ children: children, testId: testId, title: title, isLoading: isLoading = false, onPointerEnter: onPointerEnter, onPointerLeave: onPointerLeave }, ref)=>{
        let header;
        if (isLoading) header = (0, ($parcel$interopDefault($5uXOq))).createElement($903ea2626a0025b0$var$TitleSkeleton, null);
        else header = (0, ($parcel$interopDefault($5uXOq))).createElement($903ea2626a0025b0$var$Title, null, title);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($903ea2626a0025b0$var$Container, {
            ref: ref,
            "data-testid": testId,
            onPointerEnter: onPointerEnter,
            onPointerLeave: onPointerLeave
        }, header, children);
    });
    var $903ea2626a0025b0$export$2e2bcd8739ae039 = $903ea2626a0025b0$var$Card;
    const $903ea2626a0025b0$export$a2c93507c97cd090 = (0, $5uXOq.memo)(()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const refresh = (0, $5uXOq.useCallback)(()=>window.location.reload(), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($903ea2626a0025b0$var$ErrorContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5qJQ3")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement($903ea2626a0025b0$var$ErrorHeader, {
            size: "small",
            as: "h4"
        }, formatMessage((0, (0, parcelRequire("hTpz8")).default).title)), (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("hTpz8")).default).description)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
            appearance: "link",
            onClick: refresh
        }, formatMessage((0, (0, parcelRequire("hTpz8")).default).refresh)));
    });
    const $903ea2626a0025b0$var$TITLE_MARGIN_BOTTOM = "var(--ds-space-200, 16px)";
    const $903ea2626a0025b0$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _vchhusvi _11q7hp5a _2rkoftgi _1yt4vkk0 _4t3i1kdj _16jlkb7n _1o9zkb7n _i0dlf1ug _1ul91y37 _syaz1fxt _16qs1os1",
                __cmplp.className
            ])
        });
    });
    const $903ea2626a0025b0$var$Title = (0, $5uXOq.forwardRef)(({ as: C = "h4", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1fxt _16jlidpf _1o9zidpf _i0dl1wug _otyrpxbi _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
                __cmplp.className
            ])
        });
    });
    const $903ea2626a0025b0$var$TitleSkeleton = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhk1pnw _2rko1y44 _otyrpxbi _16jlidpf _1o9zidpf _i0dl1wug _1bsb1lit _4t3igktf",
                __cmplp.className
            ])
        });
    });
    const $903ea2626a0025b0$var$ErrorContainer = (0, $5uXOq.forwardRef)(({ as: C = $903ea2626a0025b0$var$Container, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bah1h6o _4cvr1h6o _y3gn1h6o",
                __cmplp.className
            ])
        });
    });
    const $903ea2626a0025b0$var$ErrorHeader = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("cZ1Pf")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pk1ejb",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("5qJQ3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5aff606d94b3a9f3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $5aff606d94b3a9f3$var$ErrorIllustration = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            height: "160",
            viewBox: "0 0 164 212",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#clip0)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M95.4299 74.1603L161.87 189.24C167.71 199.36 160.41 212 148.73 212H15.8499C4.16994 212 -3.13006 199.35 2.70994 189.24L69.1499 74.1603C74.9899 64.0403 89.5899 64.0403 95.4299 74.1603ZM87.8699 157.71L90.7499 113.36C91.0899 108.07 86.8899 103.58 81.5899 103.58C76.2799 103.58 72.0799 108.06 72.4299 113.36L75.3099 157.71C75.5299 161.02 78.2699 163.6 81.5899 163.6C84.8999 163.6 87.6499 161.02 87.8699 157.71ZM72.0299 181.25C72.0299 186.91 76.7899 191.35 82.4199 190.83C87.2699 190.38 91.1499 186.33 91.2499 181.46C91.3599 176.01 86.9399 171.52 81.5199 171.52C76.2899 171.51 72.0299 175.89 72.0299 181.25Z",
            fill: "url(#paint0_linear)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            opacity: "0.6"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.6",
            d: "M93.3498 27.1702L85.9398 0.450216C85.7698 -0.169784 84.8698 -0.129784 84.7498 0.500216L80.0898 25.6002L74.2898 24.5202C73.8498 24.4402 73.4698 24.8502 73.5898 25.2802L80.9998 52.0002C81.1698 52.6202 82.0698 52.5802 82.1898 51.9502L86.8498 26.8502L92.6498 27.9302C93.0998 28.0102 93.4698 27.6002 93.3498 27.1702Z",
            fill: "#C1C7D0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.6",
            d: "M66.7699 41.8103L55.8999 33.2603C55.6799 33.0803 55.3699 33.3303 55.4899 33.5903L61.0199 45.0203L58.3599 46.3103C58.1799 46.4003 58.1599 46.6403 58.3099 46.7603L69.1799 55.3103C69.3999 55.4903 69.7099 55.2403 69.5899 54.9803L64.0599 43.5503L66.7199 42.2603C66.8899 42.1803 66.9199 41.9303 66.7699 41.8103Z",
            fill: "#C1C7D0"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            opacity: "0.6"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            opacity: "0.6"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.6",
            d: "M102.78 56.7501C102.57 56.7501 102.37 56.6901 102.19 56.5601C101.81 56.2801 101.68 55.7801 101.86 55.3701C101.62 54.6001 99.57 52.5201 98.32 51.2601C95.35 48.2501 93.39 46.2601 94.48 44.7701C95.57 43.2901 98.06 44.5501 101.83 46.4701C103.15 47.1401 105.18 48.1701 106.28 48.5001C105.64 47.5501 104.04 45.9201 103 44.8701C100.03 41.8601 98.07 39.8701 99.16 38.3801C100.24 36.9001 102.74 38.1601 106.5 40.0801C107.82 40.7501 109.84 41.7801 110.95 42.1101C110.31 41.1601 108.71 39.5401 107.67 38.4901C104.7 35.4801 102.74 33.4901 103.83 32.0001C104.91 30.5201 107.4 31.7801 111.17 33.7001C112.75 34.5001 115.35 35.8301 116.15 35.8301C116.49 35.5401 117 35.5101 117.39 35.7901C117.84 36.1201 117.93 36.7401 117.61 37.1901C116.52 38.6701 114.04 37.4101 110.27 35.4901C108.95 34.8201 106.93 33.7901 105.83 33.4601C106.47 34.4101 108.07 36.0301 109.11 37.0801C112.08 40.0901 114.04 42.0801 112.95 43.5701C111.87 45.0501 109.38 43.7901 105.61 41.8701C104.29 41.2001 102.26 40.1701 101.16 39.8401C101.8 40.7901 103.4 42.4101 104.44 43.4701C107.41 46.4801 109.37 48.4701 108.28 49.9601C107.19 51.4401 104.7 50.1801 100.93 48.2601C99.61 47.5901 97.58 46.5501 96.48 46.2301C97.12 47.1801 98.72 48.8101 99.76 49.8601C102.73 52.8701 104.69 54.8601 103.6 56.3501C103.39 56.6101 103.09 56.7501 102.78 56.7501Z",
            fill: "#B3BAC5"
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            opacity: "0.6"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.6",
            d: "M108.34 71.0702C107.99 71.0702 107.65 70.8802 107.46 70.5502C106.42 68.6702 105.24 66.5302 106.55 65.3402C107.86 64.1402 109.89 65.5202 112.04 66.9702C112.91 67.5602 114.3 68.5002 114.97 68.6802C114.85 68.0002 114.04 66.5302 113.52 65.6102C112.26 63.3402 111.07 61.2002 112.38 60.0002C113.69 58.8002 115.72 60.1802 117.87 61.6302C118.83 62.2802 120.41 63.3502 120.97 63.3702C121.38 63.0702 121.95 63.1202 122.3 63.5002C122.67 63.9102 122.65 64.5402 122.24 64.9102C120.93 66.1102 118.9 64.7402 116.75 63.2802C115.88 62.6902 114.49 61.7502 113.82 61.5702C113.94 62.2502 114.75 63.7202 115.27 64.6402C116.53 66.9102 117.72 69.0502 116.41 70.2502C115.1 71.4502 113.07 70.0702 110.92 68.6202C110.05 68.0302 108.66 67.0902 107.99 66.9102C108.11 67.5902 108.92 69.0502 109.21 69.5802C109.48 70.0602 109.3 70.6702 108.82 70.9402C108.67 71.0302 108.5 71.0702 108.34 71.0702Z",
            fill: "#B3BAC5"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            opacity: "0.6"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.6",
            d: "M54.02 68.1797C53.8 68.1797 53.58 68.1397 53.35 68.0397C51.71 67.3497 52.11 64.9297 52.54 62.3697C52.71 61.3297 52.99 59.6697 52.87 58.9897C52.3 59.3797 51.31 60.7397 50.69 61.5897C49.16 63.6797 47.7 65.6597 46.07 64.9697C45.56 64.7597 45.32 64.1697 45.54 63.6597C45.74 63.1797 46.27 62.9397 46.75 63.0897C47.27 62.8797 48.4 61.3397 49.09 60.4097C50.62 58.3197 52.07 56.3297 53.71 57.0297C55.35 57.7197 54.95 60.1397 54.52 62.6997C54.35 63.7397 54.07 65.3997 54.19 66.0797C54.76 65.6897 55.75 64.3297 56.37 63.4797C57.9 61.3897 59.35 59.3997 60.99 60.0997C62.62 60.7897 62.23 63.1897 61.88 65.3097C61.79 65.8497 61.28 66.2197 60.73 66.1397C60.19 66.0497 59.81 65.5397 59.9 64.9897C60 64.3997 60.27 62.7497 60.16 62.0697C59.59 62.4597 58.6 63.8197 57.98 64.6697C56.65 66.4597 55.39 68.1797 54.02 68.1797Z",
            fill: "#B3BAC5"
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: "paint0_linear",
            x1: "26.1692",
            y1: "228.621",
            x2: "138.408",
            y2: "116.382",
            gradientUnits: "userSpaceOnUse"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            stopColor: "#C1C7D0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.297",
            stopColor: "#C6CBD4",
            stopOpacity: "0.8812"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.6301",
            stopColor: "#D3D7DE",
            stopOpacity: "0.748"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.9795",
            stopColor: "#E9EBEF",
            stopOpacity: "0.6082"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "1",
            stopColor: "#EBECF0",
            stopOpacity: "0.6"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip0"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M0.649902 0H163.93V212H0.649902V0Z",
            fill: "white"
        }))));
    var $5aff606d94b3a9f3$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($5aff606d94b3a9f3$var$ErrorIllustration);
});
parcelRegister("hTpz8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$da279f5498fd22ca$export$2e2bcd8739ae039);
    var $7VHMR;
    var $da279f5498fd22ca$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "business-summary.common.card.title",
            "defaultMessage": "Something's gone wrong"
        },
        description: {
            "id": "business-summary.common.card.description",
            "defaultMessage": "Looks like we're having trouble connecting to this section. Wait a few moments, then try again."
        },
        refresh: {
            "id": "business-summary.common.card.refresh",
            "defaultMessage": "Refresh"
        },
        new: {
            "id": "business-summary.common.card.new",
            "defaultMessage": "New"
        }
    });
});
parcelRegister("4rcis", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$09f777949c569443$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $f9ece;
    var $9JptI;
    var $iMVUf;
    var $7NUKB;
    var $113Tq;
    var $cm8b5;
    var $l8Afc;
    var $koVbs;
    var $l8ruj;
    var $7GkkF;
    var $3iDn2;
    var $dLD8P;
    var $kbgBa;
    var $RTUAQ;
    var $7TJr2;
    var $802L0;
    var $4iinS;
    var $cVaIM;
    var $7w9Ud;
    const $09f777949c569443$var$ActivityFeed = ({ position: position })=>{
        const { formatMessage: formatMessage, formatDate: formatDate } = (0, (0, parcelRequire("koVbs")).default)();
        const { hasCreateItem: hasCreateItem, linksTarget: linksTarget, issuesLinkUrl: issuesLinkUrl } = (0, (0, parcelRequire("7TJr2")).useSummaryFeatures)();
        const { data: data, loading: loading, loadingNext: loadingNext, hasNextPage: hasNextPage, fetchNext: fetchNext, error: error } = (0, (0, parcelRequire("RTUAQ")).default)();
        const { startHoverTimer: startHoverTimer, stopHoverTimer: stopHoverTimer, fireSectionAnalytics: fireSectionAnalytics } = (0, (0, parcelRequire("kbgBa")).useSectionAnalytics)(position, 'activityFeed');
        const { onScroll: onScroll } = (0, (0, parcelRequire("l8Afc")).useScrollToEnd)({
            onScrollToEnd: fetchNext,
            isDisabled: loadingNext || !hasNextPage,
            options: {
                onEndReachedThreshold: 150
            }
        });
        const itemsByDate = (0, $5uXOq.useMemo)(()=>data != null ? data.reduce((groups, item)=>{
                const publishedDate = new Date(item.published);
                const key = (0, (0, parcelRequire("f9ece")).default)(publishedDate, 'UTC', 'yyyy-MM-dd');
                const lastGroup = groups[groups.length - 1];
                if (lastGroup?.key === key) lastGroup.items.push(item);
                else {
                    let label;
                    if ((0, (0, parcelRequire("9JptI")).default)(publishedDate)) label = formatMessage((0, (0, parcelRequire("cVaIM")).default).today);
                    else if ((0, (0, parcelRequire("iMVUf")).default)(publishedDate)) label = formatMessage((0, (0, parcelRequire("cVaIM")).default).yesterday);
                    else label = formatDate(key, {
                        weekday: 'long',
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    });
                    groups.push({
                        key: key,
                        label: label,
                        items: [
                            item
                        ]
                    });
                }
                return groups;
            }, []) : null, [
            data,
            formatDate,
            formatMessage
        ]);
        if (error != null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iDn2")).ErrorCard), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceFailed), {
            experience: (0, (0, parcelRequire("7GkkF")).ACTIVITY_FEED_EXPERIENCE),
            error: error
        }));
        let content = null;
        if (loading) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7NUKB")).default), {
            name: "activity-feed"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($09f777949c569443$var$CenteredSkeleton, {
            testId: "business-summary.ui.summary-view.activity-feed.skeleton"
        }));
        else if (itemsByDate != null && itemsByDate.length === 0) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($09f777949c569443$var$Description, null, formatMessage((0, (0, parcelRequire("cVaIM")).default).descriptionWhenEmpty), hasCreateItem && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, ' ', (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dLD8P")).default), {
            href: `${issuesLinkUrl}?inlineCreate=true`,
            onClick: ()=>fireSectionAnalytics('view', {
                    inlineCreate: true
                }),
            target: linksTarget
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement($09f777949c569443$var$EmptyStateIllustration, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceSuccess), {
            experience: (0, (0, parcelRequire("7GkkF")).ACTIVITY_FEED_EXPERIENCE)
        }));
        else if (itemsByDate != null) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($09f777949c569443$var$Description, null, formatMessage((0, (0, parcelRequire("cVaIM")).default).description)), (0, ($parcel$interopDefault($5uXOq))).createElement($09f777949c569443$var$List, {
            onScroll: onScroll
        }, itemsByDate.map(({ key: key, label: label, items: items })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                key: key
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($09f777949c569443$var$GroupTitle, null, label), (0, ($parcel$interopDefault($5uXOq))).createElement($09f777949c569443$var$GroupContent, null, (0, ($parcel$interopDefault($5uXOq))).createElement($09f777949c569443$var$Items, null, items.map((item)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("802L0")).default), {
                    key: item.id,
                    item: item,
                    onClick: (target)=>fireSectionAnalytics(target)
                })))))), loadingNext && (0, ($parcel$interopDefault($5uXOq))).createElement($09f777949c569443$var$SpinnerWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("113Tq")).default), null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceSuccess), {
            experience: (0, (0, parcelRequire("7GkkF")).ACTIVITY_FEED_EXPERIENCE)
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "business-summary-activity-feed"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iDn2")).default), {
            title: formatMessage((0, (0, parcelRequire("cVaIM")).default).title),
            isLoading: loading,
            testId: "business-summary.ui.summary-view.activity-feed",
            onPointerEnter: startHoverTimer,
            onPointerLeave: stopHoverTimer
        }, content));
    };
    var $09f777949c569443$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($09f777949c569443$var$ActivityFeed);
    const $09f777949c569443$var$CenteredSkeleton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("7w9Ud")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug",
                __cmplp.className
            ])
        });
    });
    const $09f777949c569443$var$Description = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                __cmplp.className
            ])
        });
    });
    const $09f777949c569443$var$List = (0, $5uXOq.forwardRef)(({ as: C = "dl", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18m91wug _18s813hl _1yt41e2i _11q71mtt",
                __cmplp.className
            ])
        });
    });
    const $09f777949c569443$var$GroupTitle = (0, $5uXOq.forwardRef)(({ as: C = "dt", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1rc1 _11c81vlj _k48p1wq8 _1p1dangw _18s8swc3 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1hk51b66",
                __cmplp.className
            ])
        });
    });
    const $09f777949c569443$var$GroupContent = (0, $5uXOq.forwardRef)(({ as: C = "dd", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                __cmplp.className
            ])
        });
    });
    const $09f777949c569443$var$Items = (0, $5uXOq.forwardRef)(({ as: C = "ol", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
                __cmplp.className
            ])
        });
    });
    const $09f777949c569443$var$SpinnerWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c11p5 _1bah1h6o _18s8utpp",
                __cmplp.className
            ])
        });
    });
    const $09f777949c569443$var$EmptyStateIllustration = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("4iinS")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1lit _19pk1wug _2hwx1wug _otyr1wug _18u01wug",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("l8Afc", function(module, exports) {
    $parcel$export(module.exports, "useScrollToEnd", ()=>$ebddd9e1f1864b8e$export$296d94f94d195283);
    var $5uXOq = parcelRequire("5uXOq");
    var $34ck9 = parcelRequire("34ck9");
    const $ebddd9e1f1864b8e$var$DEFAULT_ON_END_REACHED_THRESHOLD = 300;
    const $ebddd9e1f1864b8e$var$DEFAULT_THROTTLE_TIME = 16;
    const $ebddd9e1f1864b8e$export$296d94f94d195283 = ({ onScrollToEnd: onScrollToEnd, isDisabled: isDisabled, options: options })=>{
        const onEndReachedThreshold = options?.onEndReachedThreshold ?? $ebddd9e1f1864b8e$var$DEFAULT_ON_END_REACHED_THRESHOLD;
        const throttleTime = options?.throttleTime ?? $ebddd9e1f1864b8e$var$DEFAULT_THROTTLE_TIME;
        const calculateEndReached = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($34ck9)))(({ clientHeight: clientHeight, scrollTop: scrollTop, scrollHeight: scrollHeight })=>{
                const distanceFromEnd = scrollHeight - scrollTop - clientHeight;
                if (distanceFromEnd < onEndReachedThreshold && isDisabled !== true) onScrollToEnd();
            }, throttleTime), [
            onScrollToEnd,
            throttleTime,
            isDisabled,
            onEndReachedThreshold
        ]);
        const onScroll = (0, $5uXOq.useCallback)((event)=>{
            const { clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop } = event.currentTarget;
            calculateEndReached({
                clientHeight: clientHeight,
                scrollHeight: scrollHeight,
                scrollTop: scrollTop
            });
        }, [
            calculateEndReached
        ]);
        return {
            onScroll: onScroll
        };
    };
});
parcelRegister("dLD8P", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1aef9c8ba9300bb3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $jWlFw;
    var $aSrJA;
    const $1aef9c8ba9300bb3$var$CreateItemLink = ({ href: href, onClick: onClick, target: target })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jWlFw")).default), {
            target: target,
            href: href,
            onClick: onClick
        }, formatMessage((0, (0, parcelRequire("aSrJA")).default).createAnItem));
    };
    var $1aef9c8ba9300bb3$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($1aef9c8ba9300bb3$var$CreateItemLink);
});
parcelRegister("jWlFw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e73352e33b68a93$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $hDzhb;
    const $7e73352e33b68a93$var$AccessibleLink = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("hDzhb")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4bfu18uv _1hms8stv _ajmmnqa1",
                __cmplp.className
            ])
        });
    });
    var $7e73352e33b68a93$export$2e2bcd8739ae039 = $7e73352e33b68a93$var$AccessibleLink;
});
parcelRegister("aSrJA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f9bf2f60c9204230$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f9bf2f60c9204230$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createAnItem: {
            "id": "business-summary.common.create-item-link.create-an-item",
            "defaultMessage": "Create an item"
        }
    });
});
parcelRegister("kbgBa", function(module, exports) {
    $parcel$export(module.exports, "useSectionAnalytics", ()=>$d374ce83cd61a927$export$97a66dbbb82ca183);
    $parcel$export(module.exports, "getCleanIssueTypesName", ()=>$d374ce83cd61a927$export$59d176c0028566cb);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $lwMsT;
    const $d374ce83cd61a927$export$97a66dbbb82ca183 = (position, sectionId)=>{
        const hasFiredAnalyticsEventRef = (0, $5uXOq.useRef)(false);
        const hoverStartTimeRef = (0, $5uXOq.useRef)(0);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const startHoverTimer = (0, $5uXOq.useCallback)(()=>{
            if (!hasFiredAnalyticsEventRef.current) hoverStartTimeRef.current = new Date().getTime();
        }, [
            hasFiredAnalyticsEventRef
        ]);
        const stopHoverTimer = (0, $5uXOq.useCallback)(()=>{
            if (hasFiredAnalyticsEventRef.current) return;
            const secondsHovered = Math.floor((new Date().getTime() - hoverStartTimeRef.current) / 1000);
            if (secondsHovered >= 3) {
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'section hovered', 'summarySection', {
                    position: position,
                    sectionId: sectionId,
                    secondsHovered: secondsHovered
                });
                hasFiredAnalyticsEventRef.current = true;
            }
        }, [
            createAnalyticsEvent,
            position,
            sectionId
        ]);
        const fireSectionAnalytics = (0, $5uXOq.useCallback)((target, attributes)=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'item clicked', 'summarySection', {
                ...attributes,
                position: position,
                sectionId: sectionId,
                target: target
            }), [
            position,
            sectionId,
            createAnalyticsEvent
        ]);
        return {
            startHoverTimer: startHoverTimer,
            stopHoverTimer: stopHoverTimer,
            fireSectionAnalytics: fireSectionAnalytics
        };
    };
    const $d374ce83cd61a927$export$59d176c0028566cb = (name)=>name.replace(/\s{2,}/g, ' ').trim();
});
parcelRegister("RTUAQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7de9cfde2df19a04$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $5GlnB;
    var $4NbWL;
    var $kqhaB;
    var $95H4q;
    const $7de9cfde2df19a04$var$useActivityFeed = ()=>{
        const { loading: loadingSummaryData } = (0, (0, parcelRequire("95H4q")).useSummaryContext)();
        const { data: initialData, loading: loading } = (0, (0, parcelRequire("kqhaB")).useActivityFeed)();
        const project = (0, (0, parcelRequire("daQYX")).useProject)();
        const fetchActivityFeed = (0, $5uXOq.useCallback)((after)=>(0, (0, parcelRequire("4NbWL")).fetchActivityFeed)(after, project.key), [
            project
        ]);
        const { data: data, loadingNext: loadingNext, error: error, hasNextPage: hasNextPage, reset: reset, fetchNext: fetchNext } = (0, (0, parcelRequire("5GlnB")).usePagination)(fetchActivityFeed, {
            fetchMode: 'replace'
        });
        (0, $5uXOq.useEffect)(()=>{
            if (initialData != null) reset(initialData);
        }, [
            initialData,
            reset
        ]);
        return {
            data: data,
            loading: loadingSummaryData || loading,
            loadingNext: loadingNext,
            error: error,
            hasNextPage: hasNextPage,
            fetchNext: fetchNext
        };
    };
    var $7de9cfde2df19a04$export$2e2bcd8739ae039 = $7de9cfde2df19a04$var$useActivityFeed;
});
parcelRegister("5GlnB", function(module, exports) {
    $parcel$export(module.exports, "usePagination", ()=>$b194f1a2630be1d4$export$f80c710216eae131);
    var $5uXOq = parcelRequire("5uXOq");
    var $ccvFs;
    function $b194f1a2630be1d4$var$init(options) {
        const fetchMode = options.fetchMode || 'append';
        return {
            data: null,
            pageInfo: null,
            ...options.initialData,
            loading: false,
            loadingNext: false,
            error: null,
            fetchMode: fetchMode
        };
    }
    function $b194f1a2630be1d4$var$resetState(state, initialData) {
        return {
            ...state,
            data: null,
            pageInfo: null,
            ...initialData,
            loading: false,
            loadingNext: false,
            error: null
        };
    }
    function $b194f1a2630be1d4$var$reducer(state, action) {
        switch(action.type){
            case 'reset':
                return $b194f1a2630be1d4$var$resetState(state, action.value);
            case 'fetch':
                return {
                    ...$b194f1a2630be1d4$var$resetState(state),
                    loading: true
                };
            case 'fetch-next':
                if (state.pageInfo == null) return {
                    ...state,
                    loading: true
                };
                return {
                    ...state,
                    loadingNext: true
                };
            case 'success':
                return {
                    ...state,
                    data: state.data == null || state.fetchMode === 'replace' ? action.value.data : [
                        ...state.data,
                        ...action.value.data
                    ],
                    pageInfo: action.value.pageInfo,
                    loading: false,
                    loadingNext: false,
                    error: null
                };
            case 'failure':
                return {
                    ...state,
                    loading: false,
                    loadingNext: false,
                    error: action.value
                };
            default:
                break;
        }
        return state;
    }
    function $b194f1a2630be1d4$export$f80c710216eae131(fetchCallback, options = Object.freeze({})) {
        const [state, dispatch] = (0, $5uXOq.useReducer)($b194f1a2630be1d4$var$reducer, options, $b194f1a2630be1d4$var$init);
        const stateRef = (0, $5uXOq.useRef)(state);
        stateRef.current = state;
        const doFetch = (0, $5uXOq.useCallback)((action, args)=>{
            dispatch({
                type: action
            });
            const cursor = action === 'fetch-next' ? stateRef.current.pageInfo?.endCursor ?? null : null;
            return fetchCallback(cursor, args).then((response)=>{
                dispatch({
                    type: 'success',
                    value: response
                });
                return response;
            }).catch((error)=>{
                if (error === (0, (0, parcelRequire("ccvFs")).ABORTED)) return null;
                dispatch({
                    type: 'failure',
                    value: error
                });
                throw error;
            });
        }, [
            fetchCallback
        ]);
        const fetch = (0, $5uXOq.useCallback)((args)=>doFetch('fetch', args), [
            doFetch
        ]);
        const fetchNext = (0, $5uXOq.useCallback)((args)=>{
            if (stateRef.current.loading || stateRef.current.error != null || stateRef.current.pageInfo?.hasNextPage === false) return Promise.resolve(null);
            return doFetch('fetch-next', args);
        }, [
            doFetch
        ]);
        const reset = (0, $5uXOq.useCallback)((resetData)=>dispatch({
                type: 'reset',
                value: resetData
            }), []);
        const { data: data, loading: loading, loadingNext: loadingNext, error: error, pageInfo: pageInfo } = state;
        const hasNextPage = pageInfo?.hasNextPage || false;
        return {
            data: data,
            loading: loading,
            loadingNext: loadingNext,
            error: error,
            hasNextPage: hasNextPage,
            fetch: fetch,
            fetchNext: fetchNext,
            reset: reset
        };
    }
});
parcelRegister("ccvFs", function(module, exports) {
    $parcel$export(module.exports, "ABORTED", ()=>$e04e223192d877be$export$23e29024ea698a35);
    $parcel$export(module.exports, "useAbortable", ()=>$e04e223192d877be$export$a487c7eb4387f959);
    var $5uXOq = parcelRequire("5uXOq");
    const $e04e223192d877be$export$23e29024ea698a35 = Symbol('ABORTED');
    const $e04e223192d877be$export$a487c7eb4387f959 = (fetch)=>{
        const prevControllerRef = (0, $5uXOq.useRef)(null);
        return (0, $5uXOq.useCallback)((...args)=>{
            if (prevControllerRef.current) prevControllerRef.current.abort();
            const controller = new AbortController();
            prevControllerRef.current = controller;
            return fetch(controller.signal, ...args).catch((error)=>{
                if (controller.signal.aborted) throw $e04e223192d877be$export$23e29024ea698a35;
                else throw error;
            });
        }, [
            fetch
        ]);
    };
});
parcelRegister("802L0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bd6094b584f9fc0c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $1IqIJ;
    var $1p96B;
    var $DVljb;
    var $7TJr2;
    var $h9fHt;
    const $bd6094b584f9fc0c$var$ActivityItem = ({ item: item, onClick: onClick })=>{
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        const { linksTarget: linksTarget } = (0, (0, parcelRequire("7TJr2")).useSummaryFeatures)();
        const title = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("h9fHt")).transformTitle)(item, onClick, linksTarget), [
            item,
            onClick,
            linksTarget
        ]);
        const content = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("h9fHt")).transformContent)(item), [
            item
        ]);
        const relativePublishedTime = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1p96B")).formatDistanceWithLocale)(new Date(item.published), new Date(), locale, true), [
            item,
            locale
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($bd6094b584f9fc0c$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($bd6094b584f9fc0c$var$FirstRow, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1IqIJ")).default), {
            src: item.author.avatarUrl,
            name: item.author.name
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($bd6094b584f9fc0c$var$Title, null, title, " ", (0, ($parcel$interopDefault($5uXOq))).createElement($bd6094b584f9fc0c$var$Published, null, relativePublishedTime))), content);
    };
    var $bd6094b584f9fc0c$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($bd6094b584f9fc0c$var$ActivityItem);
    const $bd6094b584f9fc0c$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt41bpf",
                __cmplp.className
            ])
        });
    });
    const $bd6094b584f9fc0c$var$FirstRow = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $bd6094b584f9fc0c$var$Title = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0u2gc _16jlkb7n _1o9zkb7n _i0dlf1ug",
                __cmplp.className
            ])
        });
    });
    const $bd6094b584f9fc0c$var$Published = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c8qk37 _syaz131l",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("h9fHt", function(module, exports) {
    $parcel$export(module.exports, "transformTitle", ()=>$14b9b87d9c9d853d$export$b7844e8a25b12dea);
    $parcel$export(module.exports, "transformContent", ()=>$14b9b87d9c9d853d$export$b7cb80c25ebba28e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $jWlFw;
    const $14b9b87d9c9d853d$export$b7844e8a25b12dea = (item, onClick, linkTarget)=>{
        const parser = new DOMParser();
        const { body: body } = parser.parseFromString(item.title, 'text/html');
        if (body == null) return null;
        const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
        let node = walker.firstChild();
        const result = [];
        let key = 0;
        do {
            if (node == null) continue;
            if (node.nodeType === Node.ELEMENT_NODE && node.nodeName === 'A') {
                const href = node.getAttribute('href') || '';
                if (href.startsWith('/browse/')) result.push((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jWlFw")).default), {
                    key: key++,
                    target: linkTarget,
                    href: href,
                    onClick: ()=>onClick('issue')
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($14b9b87d9c9d853d$var$TypeIcon, {
                    src: item.iconUrl,
                    alt: ""
                }), node.textContent));
                else result.push((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jWlFw")).default), {
                    key: key++,
                    target: linkTarget,
                    href: href,
                    onClick: ()=>onClick('user')
                }, node.textContent));
            } else result.push(node.textContent);
        }while (node = walker.nextSibling())
        return result;
    };
    function* $14b9b87d9c9d853d$var$infinite() {
        let index = 0;
        while(true)yield index++;
    }
    const $14b9b87d9c9d853d$var$mapSiblingNodes = (walker, keyGen)=>{
        const mappedNodes = [];
        let currentNode = walker.currentNode;
        while(currentNode){
            const { nodeType: nodeType } = currentNode;
            if (nodeType === Node.TEXT_NODE) mappedNodes.push(currentNode.textContent);
            else if (nodeType === Node.ELEMENT_NODE) {
                const nodeName = currentNode.nodeName.toLowerCase();
                if (nodeName in $14b9b87d9c9d853d$var$NODE_MAPPER_MAP) {
                    const result = $14b9b87d9c9d853d$var$NODE_MAPPER_MAP[nodeName](walker, keyGen);
                    if (result != null) mappedNodes.push(result);
                }
            }
            currentNode = walker.nextSibling();
        }
        if (mappedNodes.length === 0) return null;
        return mappedNodes;
    };
    const $14b9b87d9c9d853d$var$mapChildrenNodes = (walker, keyGen)=>{
        const firstChild = walker.firstChild();
        if (firstChild) {
            const result = $14b9b87d9c9d853d$var$mapSiblingNodes(walker, keyGen);
            walker.parentNode();
            return result;
        }
        return null;
    };
    const $14b9b87d9c9d853d$var$identity = (walker, keyGen)=>{
        const children = $14b9b87d9c9d853d$var$mapChildrenNodes(walker, keyGen);
        return (0, $5uXOq.createElement)(walker.currentNode.nodeName.toLowerCase(), {
            key: keyGen.next().value
        }, children);
    };
    const $14b9b87d9c9d853d$var$isNodeEmpty = (children)=>children.length === 1 && typeof children[0] === 'string' && children[0].trim().length === 0;
    const $14b9b87d9c9d853d$var$NODE_MAPPER_MAP = {
        a: (walker, keyGen)=>{
            const children = $14b9b87d9c9d853d$var$mapChildrenNodes(walker, keyGen);
            if (children == null || children.length === 0) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($14b9b87d9c9d853d$var$StyledAnchor, {
                key: keyGen.next().value,
                href: walker.currentNode.getAttribute('href'),
                target: "_blank"
            }, children);
        },
        b: $14b9b87d9c9d853d$var$identity,
        blockquote: (walker, keyGen)=>{
            const children = $14b9b87d9c9d853d$var$mapChildrenNodes(walker, keyGen);
            if (children == null || children.length === 0 || $14b9b87d9c9d853d$var$isNodeEmpty(children)) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement("blockquote", {
                key: keyGen.next().value
            }, children);
        },
        br: $14b9b87d9c9d853d$var$identity,
        div: (walker, keyGen)=>{
            const children = $14b9b87d9c9d853d$var$mapChildrenNodes(walker, keyGen);
            if (children == null || children.length === 0) return null;
            if (walker.currentNode.classList.contains('user-content')) {
                if ($14b9b87d9c9d853d$var$isNodeEmpty(children)) return null;
                return (0, ($parcel$interopDefault($5uXOq))).createElement("blockquote", {
                    key: keyGen.next().value
                }, children);
            }
            return children;
        },
        em: $14b9b87d9c9d853d$var$identity,
        font: $14b9b87d9c9d853d$var$mapChildrenNodes,
        h1: $14b9b87d9c9d853d$var$identity,
        h2: $14b9b87d9c9d853d$var$identity,
        h3: $14b9b87d9c9d853d$var$identity,
        h4: $14b9b87d9c9d853d$var$identity,
        h5: $14b9b87d9c9d853d$var$identity,
        h6: $14b9b87d9c9d853d$var$identity,
        hr: $14b9b87d9c9d853d$var$identity,
        img: (walker, keyGen)=>(0, ($parcel$interopDefault($5uXOq))).createElement("img", {
                key: keyGen.next().value,
                src: walker.currentNode.getAttribute('src'),
                alt: ""
            }),
        li: $14b9b87d9c9d853d$var$identity,
        ol: $14b9b87d9c9d853d$var$identity,
        p: $14b9b87d9c9d853d$var$identity,
        pre: $14b9b87d9c9d853d$var$identity,
        span: $14b9b87d9c9d853d$var$mapChildrenNodes,
        sub: $14b9b87d9c9d853d$var$identity,
        sup: $14b9b87d9c9d853d$var$identity,
        table: $14b9b87d9c9d853d$var$identity,
        tbody: $14b9b87d9c9d853d$var$identity,
        td: $14b9b87d9c9d853d$var$identity,
        th: $14b9b87d9c9d853d$var$identity,
        thead: $14b9b87d9c9d853d$var$identity,
        tr: $14b9b87d9c9d853d$var$identity,
        ul: $14b9b87d9c9d853d$var$identity
    };
    const $14b9b87d9c9d853d$export$b7cb80c25ebba28e = (item)=>{
        if (item.content == null) return null;
        const parser = new DOMParser();
        const { body: body } = parser.parseFromString(item.content, 'text/html');
        if (body == null) return null;
        const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
        const keyGen = $14b9b87d9c9d853d$var$infinite();
        const children = $14b9b87d9c9d853d$var$mapChildrenNodes(walker, keyGen);
        if (children == null || children.length === 0) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($14b9b87d9c9d853d$var$Content, {
            "data-testid": "business-summary.ui.summary-view.activity-feed.activity-item.content"
        }, children);
    };
    const $14b9b87d9c9d853d$var$Content = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s81hqg _1nmz1hna _yc8jglyw _1uukyh40 _17q5zu5n _chq7muej _6qesidpf _12ogidpf _102oidpf _3fjiidpf _1kvxidpf _pezqidpf _1ysjidpf _1yf6idpf _17d4idpf _5jhz13xq _gxop13xq _d1n81wth _2uss1pyq _1qqaudwz _1hnyglyw _1jhyglyw _6n1uidpf _1uzxidpf _11ucidpf _lnp5idpf _1vt11bs6 _18iqiti9 _xh9ft94y _98utnqa1 _1ellmuej _rtys1osq _19l3uuw1 _mezj1wug _bna71wug _wec71bs6 _wdakqbzx _kq6x1jtm _9cgvqk37 _16n385st _1d9ptcjq _b4pmglyw _dzke18iy _1owe18iy _93rbt94y _cquzt94y _knywnqa1 _1wxlnqa1 _jq3amuej _d15amuej _178i155y",
                __cmplp.className
            ])
        });
    });
    const $14b9b87d9c9d853d$var$TypeIcon = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i7vkz _1bsb7vkz _2hwxv77o _s7n4nkob _1e0c116y _n3tdv77o",
                __cmplp.className
            ])
        });
    });
    const $14b9b87d9c9d853d$var$StyledAnchor = (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4bfu18uv _1hms8stv _ajmmnqa1",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("4iinS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c8c125223d7fe6c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $7c8c125223d7fe6c$var$EmptyIllustration = ({ className: className })=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            viewBox: "0 0 246 232",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: className
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#activity_0_clip)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            opacity: "0.5"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.5",
            d: "M118.4 215.9C118.4 215.476 118.569 215.069 118.869 214.769C119.169 214.469 119.576 214.3 120 214.3C120.407 214.325 120.789 214.505 121.067 214.803C121.346 215.1 121.501 215.492 121.5 215.9C121.501 216.308 121.346 216.7 121.067 216.997C120.789 217.295 120.407 217.475 120 217.5C119.576 217.5 119.169 217.331 118.869 217.031C118.569 216.731 118.4 216.324 118.4 215.9ZM110.4 217.1C109.985 217.051 109.602 216.85 109.325 216.537C109.049 216.223 108.897 215.818 108.9 215.4C108.95 214.967 109.165 214.57 109.5 214.29C109.835 214.011 110.265 213.871 110.7 213.9C111.107 213.95 111.479 214.155 111.739 214.471C112 214.787 112.129 215.191 112.1 215.6C112.075 216.007 111.895 216.389 111.597 216.667C111.3 216.946 110.908 217.101 110.5 217.1H110.4ZM127.8 215.6C127.786 215.39 127.815 215.179 127.883 214.98C127.951 214.78 128.058 214.596 128.197 214.438C128.336 214.281 128.506 214.152 128.695 214.059C128.884 213.967 129.09 213.913 129.3 213.9C129.709 213.871 130.113 214.001 130.429 214.261C130.746 214.521 130.95 214.893 131 215.3C131.029 215.735 130.889 216.165 130.61 216.5C130.33 216.835 129.933 217.05 129.5 217.1H129.4C128.992 217.101 128.6 216.946 128.303 216.667C128.005 216.389 127.826 216.007 127.8 215.6ZM100.9 215.8C100.688 215.764 100.486 215.686 100.305 215.57C100.124 215.454 99.968 215.303 99.8467 215.126C99.7254 214.949 99.641 214.749 99.5986 214.538C99.5563 214.327 99.5567 214.11 99.6 213.9C99.6357 213.701 99.7111 213.512 99.8219 213.343C99.9326 213.174 100.076 213.029 100.244 212.917C100.413 212.805 100.602 212.728 100.8 212.69C100.999 212.653 101.203 212.656 101.4 212.7C101.608 212.723 101.808 212.79 101.989 212.895C102.169 213.001 102.326 213.143 102.448 213.312C102.571 213.482 102.656 213.675 102.7 213.88C102.743 214.084 102.743 214.295 102.7 214.5C102.65 214.88 102.456 215.227 102.159 215.468C101.861 215.71 101.482 215.829 101.1 215.8H100.9ZM137.2 214.5C137.139 214.078 137.239 213.648 137.479 213.296C137.72 212.945 138.085 212.696 138.5 212.6C138.91 212.542 139.327 212.645 139.662 212.887C139.998 213.129 140.227 213.493 140.3 213.9C140.344 214.097 140.347 214.301 140.31 214.5C140.272 214.698 140.195 214.887 140.083 215.056C139.971 215.224 139.826 215.367 139.657 215.478C139.489 215.589 139.299 215.664 139.1 215.7H138.8C138.441 215.695 138.092 215.576 137.805 215.36C137.517 215.145 137.306 214.843 137.2 214.5ZM91.5 213.6C91.1012 213.463 90.7677 213.182 90.5645 212.812C90.3612 212.442 90.3026 212.01 90.4 211.6C90.5375 211.201 90.8183 210.868 91.188 210.664C91.5576 210.461 91.9896 210.403 92.4 210.5C92.7863 210.655 93.107 210.939 93.3076 211.303C93.5081 211.668 93.5761 212.091 93.5 212.5C93.3908 212.833 93.1751 213.122 92.886 213.32C92.5968 213.519 92.2504 213.617 91.9 213.6H91.5ZM146.5 212.5C146.373 212.102 146.406 211.67 146.593 211.296C146.78 210.923 147.105 210.637 147.5 210.5C147.91 210.403 148.342 210.461 148.712 210.664C149.082 210.868 149.363 211.201 149.5 211.6C149.594 211.997 149.532 212.415 149.327 212.768C149.123 213.122 148.791 213.383 148.4 213.5H148C147.675 213.518 147.354 213.431 147.083 213.25C146.812 213.07 146.608 212.807 146.5 212.5ZM82.4 210.5C82.0235 210.344 81.7207 210.05 81.5534 209.678C81.3862 209.307 81.3671 208.885 81.5 208.5C81.656 208.123 81.9499 207.821 82.3216 207.653C82.6932 207.486 83.1147 207.467 83.5 207.6C83.6947 207.666 83.8737 207.772 84.0259 207.91C84.1781 208.049 84.3002 208.217 84.3846 208.404C84.469 208.592 84.5139 208.795 84.5166 209.001C84.5192 209.206 84.4796 209.41 84.4 209.6C84.3113 209.899 84.1253 210.159 83.8718 210.34C83.6182 210.522 83.3114 210.613 83 210.6H82.4V210.5ZM155.5 209.6C155.367 209.215 155.386 208.793 155.553 208.422C155.721 208.05 156.023 207.756 156.4 207.6C156.587 207.503 156.794 207.45 157.005 207.444C157.216 207.438 157.425 207.48 157.617 207.567C157.81 207.654 157.98 207.782 158.115 207.944C158.251 208.106 158.348 208.296 158.4 208.5C158.533 208.885 158.514 209.307 158.347 209.678C158.179 210.05 157.877 210.344 157.5 210.5H156.9C156.604 210.505 156.313 210.422 156.064 210.262C155.815 210.102 155.618 209.871 155.5 209.6ZM73.6 206.7C73.4065 206.605 73.2342 206.472 73.0935 206.308C72.9527 206.145 72.8465 205.955 72.7811 205.749C72.7157 205.544 72.6926 205.327 72.713 205.112C72.7334 204.898 72.797 204.689 72.9 204.5C73.0924 204.135 73.4182 203.859 73.8094 203.728C74.2007 203.598 74.6272 203.624 75 203.8C75.3649 203.992 75.6414 204.318 75.7718 204.709C75.9022 205.101 75.8765 205.527 75.7 205.9C75.5816 206.171 75.3854 206.402 75.1363 206.562C74.8872 206.722 74.5962 206.805 74.3 206.8H73.6V206.7ZM164.2 205.9C164.099 205.718 164.036 205.517 164.017 205.31C163.998 205.102 164.022 204.893 164.087 204.696C164.153 204.498 164.26 204.317 164.399 204.162C164.539 204.008 164.71 203.885 164.9 203.8C165.082 203.699 165.283 203.636 165.49 203.617C165.698 203.598 165.907 203.622 166.104 203.687C166.302 203.753 166.483 203.86 166.638 203.999C166.792 204.139 166.915 204.31 167 204.5C167.101 204.682 167.164 204.883 167.183 205.09C167.202 205.298 167.178 205.507 167.113 205.704C167.047 205.902 166.94 206.083 166.801 206.238C166.661 206.392 166.49 206.515 166.3 206.6L165.6 206.8C165.304 206.805 165.013 206.722 164.764 206.562C164.515 206.402 164.318 206.171 164.2 205.9ZM65.2 202C64.843 201.774 64.59 201.415 64.4963 201.003C64.4026 200.591 64.4758 200.158 64.7 199.8C64.9263 199.443 65.2847 199.19 65.6969 199.096C66.1091 199.003 66.5416 199.076 66.9 199.3C67.2379 199.542 67.4754 199.9 67.5676 200.305C67.6597 200.71 67.6001 201.136 67.4 201.5C67.2537 201.734 67.0456 201.924 66.7986 202.047C66.5515 202.171 66.2752 202.224 66 202.2L65.2 202ZM172.5 201.4C172.276 201.042 172.203 200.609 172.296 200.197C172.39 199.785 172.643 199.426 173 199.2C173.376 199.01 173.809 198.966 174.216 199.076C174.622 199.187 174.973 199.445 175.2 199.8C175.394 200.149 175.45 200.558 175.358 200.947C175.265 201.336 175.03 201.676 174.7 201.9L173.8 202.2C173.534 202.186 173.276 202.105 173.048 201.965C172.821 201.825 172.633 201.631 172.5 201.4ZM57.3 196.6C56.9681 196.326 56.7525 195.936 56.6968 195.509C56.6412 195.082 56.7495 194.65 57 194.3C57.2699 193.995 57.6405 193.796 58.0443 193.741C58.4481 193.686 58.8582 193.778 59.2 194C59.525 194.257 59.7378 194.629 59.7937 195.04C59.8497 195.45 59.7444 195.866 59.5 196.2C59.3621 196.419 59.1699 196.598 58.9421 196.721C58.7143 196.844 58.4587 196.905 58.2 196.9L57.3 196.6ZM180.4 196.2C180.156 195.866 180.05 195.45 180.106 195.04C180.162 194.629 180.375 194.257 180.7 194C180.86 193.866 181.047 193.766 181.248 193.708C181.448 193.65 181.659 193.635 181.866 193.663C182.074 193.691 182.273 193.763 182.451 193.872C182.629 193.982 182.782 194.128 182.9 194.3C183.144 194.634 183.25 195.05 183.194 195.461C183.138 195.871 182.925 196.243 182.6 196.5C182.306 196.702 181.957 196.807 181.6 196.8C181.368 196.793 181.141 196.735 180.934 196.632C180.727 196.528 180.545 196.381 180.4 196.2ZM49.9 190.4C49.6048 190.116 49.4299 189.729 49.4113 189.32C49.3927 188.911 49.5318 188.51 49.8 188.2C50.0842 187.905 50.4708 187.73 50.8801 187.711C51.2894 187.693 51.6903 187.832 52 188.1C52.1581 188.233 52.2868 188.398 52.3782 188.584C52.4695 188.769 52.5216 188.972 52.5309 189.178C52.5403 189.385 52.5069 189.591 52.4328 189.784C52.3586 189.977 52.2453 190.153 52.1 190.3C51.9708 190.466 51.8032 190.598 51.6116 190.686C51.42 190.773 51.2102 190.812 51 190.8C50.7992 190.81 50.5984 190.78 50.4094 190.712C50.2204 190.643 50.0472 190.537 49.9 190.4ZM187.7 190.2C187.453 189.881 187.327 189.485 187.346 189.082C187.364 188.679 187.525 188.295 187.8 188C188.126 187.725 188.544 187.583 188.97 187.601C189.396 187.62 189.799 187.798 190.1 188.1C190.368 188.41 190.507 188.811 190.489 189.22C190.47 189.629 190.295 190.016 190 190.3C189.713 190.604 189.318 190.784 188.9 190.8C188.67 190.787 188.445 190.727 188.238 190.623C188.032 190.52 187.849 190.376 187.7 190.2ZM43.1 183.6C42.8318 183.29 42.6927 182.889 42.7113 182.48C42.7299 182.071 42.9048 181.684 43.2 181.4C43.5098 181.132 43.9106 180.993 44.32 181.011C44.7293 181.03 45.1159 181.205 45.4 181.5C45.5453 181.647 45.6586 181.823 45.7327 182.016C45.8069 182.209 45.8403 182.415 45.831 182.622C45.8216 182.828 45.7695 183.031 45.6782 183.216C45.5868 183.402 45.4581 183.567 45.3 183.7C45.1766 183.848 45.0242 183.968 44.8521 184.054C44.6801 184.14 44.4921 184.19 44.3 184.2C44.0658 184.208 43.8331 184.158 43.6235 184.053C43.4138 183.948 43.2338 183.792 43.1 183.6ZM194.5 183.7C194.198 183.399 194.02 182.996 194.001 182.57C193.983 182.143 194.125 181.726 194.4 181.4C194.701 181.098 195.104 180.92 195.531 180.901C195.957 180.883 196.374 181.025 196.7 181.3C196.983 181.611 197.148 182.012 197.166 182.432C197.184 182.852 197.055 183.265 196.8 183.6C196.463 183.889 196.043 184.064 195.6 184.1C195.203 184.074 194.821 183.935 194.5 183.7ZM37 176.3C36.8634 176.131 36.7625 175.937 36.7035 175.728C36.6444 175.519 36.6284 175.301 36.6565 175.086C36.6845 174.87 36.7561 174.663 36.8667 174.477C36.9773 174.29 37.1248 174.128 37.3 174C37.6463 173.766 38.0704 173.677 38.4815 173.752C38.8926 173.827 39.2582 174.059 39.5 174.4C39.7444 174.734 39.8497 175.15 39.7937 175.561C39.7378 175.971 39.525 176.343 39.2 176.6C38.9064 176.802 38.5566 176.907 38.2 176.9C37.9658 176.908 37.7331 176.858 37.5235 176.753C37.3138 176.648 37.1338 176.492 37 176.3ZM200.7 176.5C200.375 176.243 200.162 175.871 200.106 175.461C200.05 175.05 200.156 174.634 200.4 174.3C200.518 174.128 200.672 173.982 200.85 173.872C201.028 173.763 201.226 173.691 201.434 173.663C201.641 173.635 201.852 173.65 202.052 173.708C202.253 173.766 202.44 173.866 202.6 174C202.925 174.257 203.138 174.629 203.194 175.04C203.25 175.45 203.144 175.866 202.9 176.2C202.745 176.394 202.547 176.549 202.321 176.654C202.095 176.758 201.848 176.808 201.6 176.8L200.7 176.5ZM31.5 168.3C31.3062 167.951 31.25 167.542 31.3425 167.153C31.435 166.764 31.6696 166.424 32 166.2C32.1729 166.075 32.3706 165.988 32.5798 165.945C32.7891 165.902 33.0051 165.904 33.2133 165.951C33.4216 165.999 33.6174 166.09 33.7876 166.219C33.9577 166.348 34.0983 166.512 34.2 166.7C34.4242 167.058 34.4975 167.491 34.4038 167.903C34.3101 168.315 34.0571 168.674 33.7 168.9L32.9 169.1C32.6167 169.103 32.3379 169.03 32.0919 168.889C31.8459 168.749 31.6417 168.545 31.5 168.3ZM206.2 168.8C205.845 168.573 205.587 168.222 205.476 167.816C205.366 167.409 205.41 166.976 205.6 166.6H205.7C205.791 166.415 205.922 166.252 206.083 166.123C206.244 165.995 206.432 165.903 206.632 165.855C206.833 165.808 207.042 165.805 207.243 165.847C207.445 165.889 207.635 165.976 207.8 166.1C207.985 166.191 208.148 166.322 208.277 166.483C208.405 166.644 208.497 166.832 208.545 167.032C208.592 167.233 208.595 167.442 208.553 167.643C208.511 167.845 208.424 168.035 208.3 168.2C208.167 168.431 207.979 168.625 207.752 168.765C207.525 168.905 207.266 168.986 207 169L206.2 168.8ZM26.8 160C26.6235 159.627 26.5978 159.201 26.7283 158.809C26.8587 158.418 27.1352 158.092 27.5 157.9C27.6895 157.797 27.8978 157.733 28.1125 157.713C28.3271 157.693 28.5437 157.716 28.7492 157.781C28.9547 157.846 29.1449 157.953 29.3083 158.093C29.4716 158.234 29.6049 158.406 29.7 158.6C29.8339 158.978 29.8378 159.39 29.711 159.77C29.5842 160.151 29.334 160.478 29 160.7H28.2C27.9277 160.704 27.6583 160.643 27.4147 160.521C27.171 160.399 26.9602 160.22 26.8 160ZM210.9 160.6C210.535 160.408 210.259 160.082 210.128 159.691C209.998 159.299 210.024 158.873 210.2 158.5C210.393 158.134 210.712 157.851 211.099 157.704C211.486 157.556 211.913 157.555 212.3 157.7C212.494 157.795 212.666 157.928 212.807 158.092C212.947 158.255 213.054 158.445 213.119 158.651C213.184 158.856 213.207 159.073 213.187 159.288C213.167 159.502 213.103 159.711 213 159.9C212.858 160.145 212.654 160.349 212.408 160.489C212.162 160.63 211.883 160.703 211.6 160.7H210.9V160.6ZM22.9 151.2C22.7624 150.801 22.7783 150.364 22.9447 149.976C23.111 149.588 23.4159 149.276 23.8 149.1C23.9968 149.019 24.2077 148.978 24.4204 148.98C24.6332 148.981 24.8435 149.025 25.039 149.109C25.2345 149.193 25.4114 149.315 25.5593 149.468C25.7071 149.621 25.8229 149.802 25.9 150C25.981 150.197 26.0218 150.408 26.0203 150.62C26.0187 150.833 25.9748 151.043 25.891 151.239C25.8072 151.435 25.6852 151.611 25.5322 151.759C25.3792 151.907 25.1983 152.023 25 152.1H24.4C24.0941 152.09 23.7958 152.002 23.5333 151.844C23.2709 151.687 23.0529 151.465 22.9 151.2ZM214.9 152C214.692 151.936 214.501 151.827 214.34 151.682C214.178 151.536 214.05 151.358 213.965 151.158C213.879 150.958 213.838 150.742 213.844 150.525C213.85 150.308 213.903 150.095 214 149.9C214.156 149.523 214.45 149.221 214.822 149.053C215.193 148.886 215.615 148.867 216 149C216.384 149.176 216.689 149.488 216.855 149.876C217.022 150.264 217.038 150.701 216.9 151.1C216.792 151.407 216.588 151.67 216.317 151.85C216.046 152.031 215.725 152.118 215.4 152.1H214.9V152ZM19.9 142.1C19.8232 141.897 19.7914 141.68 19.8067 141.463C19.822 141.247 19.884 141.036 19.9886 140.846C20.0932 140.656 20.2378 140.491 20.4124 140.362C20.587 140.233 20.7875 140.144 21 140.1C21.3973 140.006 21.8153 140.068 22.1685 140.273C22.5216 140.477 22.7834 140.809 22.9 141.2C22.9768 141.403 23.0087 141.62 22.9934 141.837C22.9781 142.053 22.916 142.264 22.8114 142.454C22.7069 142.644 22.5623 142.809 22.3877 142.938C22.213 143.067 22.0126 143.156 21.8 143.2H21.4C21.0627 143.212 20.7311 143.11 20.4589 142.911C20.1867 142.711 19.9898 142.425 19.9 142.1ZM218 143.1C217.614 142.945 217.293 142.661 217.092 142.297C216.892 141.932 216.824 141.509 216.9 141.1C217.037 140.701 217.318 140.368 217.688 140.164C218.058 139.961 218.49 139.903 218.9 140C219.295 140.137 219.621 140.423 219.807 140.796C219.994 141.17 220.028 141.602 219.9 142C219.81 142.325 219.613 142.611 219.341 142.811C219.069 143.01 218.737 143.112 218.4 143.1H218ZM17.7 132.7C17.6384 132.304 17.7275 131.9 17.9497 131.566C18.1719 131.233 18.511 130.995 18.9 130.9C19.1105 130.857 19.3275 130.856 19.5381 130.899C19.7487 130.941 19.9487 131.025 20.126 131.147C20.3033 131.268 20.4544 131.424 20.5702 131.605C20.686 131.786 20.7641 131.988 20.8 132.2C20.8584 132.61 20.7555 133.027 20.5131 133.362C20.2706 133.698 19.9075 133.926 19.5 134H19.2C18.8345 134.003 18.4804 133.873 18.2042 133.634C17.928 133.394 17.7487 133.062 17.7 132.7ZM220.3 133.9C219.885 133.804 219.52 133.555 219.279 133.204C219.039 132.852 218.939 132.422 219 132C219.095 131.59 219.348 131.235 219.704 131.01C220.059 130.786 220.489 130.71 220.9 130.8C221.099 130.836 221.288 130.911 221.457 131.022C221.626 131.133 221.771 131.276 221.883 131.444C221.995 131.613 222.072 131.802 222.11 132C222.147 132.199 222.144 132.403 222.1 132.6C222.051 132.962 221.872 133.294 221.596 133.534C221.32 133.773 220.965 133.903 220.6 133.9H220.3ZM16.4 123.2C16.3713 122.791 16.5005 122.387 16.761 122.071C17.0215 121.755 17.3934 121.55 17.8 121.5C18.2088 121.471 18.6129 121.601 18.9292 121.861C19.2455 122.121 19.4498 122.493 19.5 122.9C19.5312 123.32 19.4053 123.737 19.1466 124.07C18.8879 124.402 18.515 124.627 18.1 124.7H17.9C17.5022 124.7 17.1207 124.542 16.8394 124.261C16.5581 123.979 16.4 123.598 16.4 123.2ZM221.7 124.5C221.494 124.488 221.292 124.434 221.107 124.34C220.923 124.246 220.76 124.116 220.628 123.956C220.497 123.796 220.4 123.611 220.343 123.412C220.287 123.213 220.272 123.005 220.3 122.8C220.35 122.393 220.555 122.021 220.871 121.761C221.187 121.501 221.591 121.371 222 121.4C222.206 121.412 222.408 121.466 222.593 121.56C222.777 121.654 222.94 121.784 223.072 121.944C223.203 122.104 223.3 122.289 223.357 122.488C223.413 122.687 223.428 122.895 223.4 123.1C223.375 123.48 223.205 123.837 222.927 124.097C222.648 124.357 222.281 124.501 221.9 124.5H221.7ZM15.9 113.6C15.9255 113.193 16.1052 112.811 16.4026 112.533C16.6999 112.254 17.0924 112.099 17.5 112.1C17.9076 112.099 18.3001 112.254 18.5975 112.533C18.8948 112.811 19.0746 113.193 19.1 113.6C19.1 114.024 18.9315 114.431 18.6314 114.731C18.3313 115.031 17.9244 115.2 17.5 115.2C17.0757 115.2 16.6687 115.031 16.3687 114.731C16.0686 114.431 15.9 114.024 15.9 113.6ZM220.7 113.5C220.7 113.076 220.869 112.669 221.169 112.369C221.469 112.069 221.876 111.9 222.3 111.9C222.724 111.9 223.131 112.069 223.431 112.369C223.731 112.669 223.9 113.076 223.9 113.5C223.9 113.924 223.731 114.331 223.431 114.631C223.131 114.931 222.724 115.1 222.3 115.1C221.876 115.1 221.469 114.931 221.169 114.631C220.869 114.331 220.7 113.924 220.7 113.5ZM17.8 105.8C17.3847 105.751 17.002 105.55 16.7253 105.237C16.4485 104.923 16.2971 104.518 16.3 104.1C16.3128 103.89 16.3669 103.684 16.4593 103.495C16.5517 103.305 16.6806 103.136 16.8385 102.997C16.9965 102.858 17.1804 102.751 17.3797 102.683C17.579 102.615 17.7898 102.586 18 102.6C18.2103 102.613 18.416 102.667 18.6052 102.759C18.7945 102.852 18.9637 102.981 19.1031 103.138C19.2424 103.296 19.3492 103.48 19.4174 103.68C19.4855 103.879 19.5136 104.09 19.5 104.3C19.4746 104.707 19.2948 105.089 18.9975 105.367C18.7001 105.646 18.3076 105.801 17.9 105.8H17.8ZM220.3 104C220.272 103.795 220.287 103.587 220.343 103.388C220.4 103.189 220.497 103.004 220.628 102.844C220.76 102.684 220.923 102.554 221.107 102.46C221.292 102.366 221.494 102.312 221.7 102.3C221.905 102.272 222.113 102.287 222.312 102.343C222.511 102.4 222.696 102.497 222.856 102.628C223.016 102.76 223.146 102.923 223.24 103.107C223.334 103.292 223.388 103.494 223.4 103.7C223.428 103.905 223.413 104.113 223.357 104.312C223.3 104.511 223.203 104.696 223.072 104.856C222.94 105.016 222.777 105.146 222.593 105.24C222.408 105.334 222.206 105.388 222 105.4H221.9C221.703 105.414 221.505 105.388 221.318 105.325C221.131 105.262 220.958 105.162 220.809 105.032C220.66 104.902 220.539 104.744 220.452 104.567C220.364 104.39 220.313 104.197 220.3 104ZM18.9 96.4C18.4845 96.3041 18.1203 96.0555 17.8795 95.7035C17.6387 95.3516 17.5389 94.922 17.6 94.5C17.6955 94.0904 17.9483 93.7349 18.3039 93.5103C18.6595 93.2857 19.0892 93.2102 19.5 93.3C19.6989 93.3356 19.8885 93.4111 20.0575 93.5218C20.2265 93.6326 20.3713 93.7763 20.4834 93.9444C20.5955 94.1125 20.6724 94.3015 20.7097 94.5001C20.7469 94.6987 20.7436 94.9027 20.7 95.1C20.6513 95.4622 20.472 95.7942 20.1958 96.0336C19.9196 96.273 19.5655 96.4033 19.2 96.4H18.9ZM219 94.8C218.91 94.3891 218.986 93.9594 219.21 93.6039C219.435 93.2483 219.79 92.9954 220.2 92.9C220.622 92.8389 221.052 92.9386 221.404 93.1794C221.755 93.4202 222.004 93.7845 222.1 94.2C222.158 94.6099 222.055 95.0265 221.813 95.3622C221.571 95.6979 221.208 95.9265 220.8 96H220.5C220.149 96.0071 219.807 95.8909 219.533 95.6716C219.259 95.4523 219.07 95.1439 219 94.8ZM20.9 87.1C20.5089 86.9833 20.1772 86.7216 19.9727 86.3684C19.7683 86.0152 19.7065 85.5972 19.8 85.2C19.8575 84.9954 19.9551 84.8044 20.0872 84.6379C20.2193 84.4715 20.3832 84.333 20.5694 84.2306C20.7556 84.1282 20.9603 84.0639 21.1716 84.0415C21.3829 84.0191 21.5965 84.039 21.8 84.1C22.1911 84.2167 22.5228 84.4784 22.7273 84.8316C22.9318 85.1848 22.9936 85.6028 22.9 86C22.7944 86.3434 22.5826 86.6446 22.2952 86.8602C22.0077 87.0758 21.6593 87.1947 21.3 87.2H20.9V87.1ZM216.8 85.7C216.706 85.3027 216.768 84.8848 216.973 84.5316C217.177 84.1784 217.509 83.9167 217.9 83.8C218.298 83.6725 218.73 83.7058 219.104 83.8926C219.477 84.0795 219.763 84.4052 219.9 84.8C219.997 85.2104 219.939 85.6424 219.736 86.0121C219.532 86.3817 219.199 86.6625 218.8 86.8H218.4C218.05 86.8174 217.703 86.7192 217.414 86.5204C217.125 86.3217 216.909 86.0334 216.8 85.7ZM23.8 78.1C23.5956 78.0482 23.4055 77.951 23.244 77.8154C23.0824 77.6799 22.9536 77.5097 22.867 77.3174C22.7805 77.1251 22.7385 76.9157 22.7442 76.7049C22.7499 76.4941 22.8032 76.2873 22.9 76.1C23.056 75.7235 23.3499 75.4207 23.7216 75.2534C24.0932 75.0862 24.5147 75.0671 24.9 75.2C25.2766 75.356 25.5793 75.6499 25.7466 76.0215C25.9139 76.3932 25.933 76.8147 25.8 77.2C25.6922 77.5067 25.4876 77.7701 25.217 77.9505C24.9465 78.1308 24.6247 78.2184 24.3 78.2H23.8V78.1ZM213.9 76.9C213.819 76.7033 213.778 76.4923 213.78 76.2796C213.781 76.0669 213.825 75.8566 213.909 75.661C213.993 75.4655 214.115 75.2886 214.268 75.1408C214.421 74.9929 214.602 74.8771 214.8 74.8C215.185 74.6671 215.607 74.6862 215.978 74.8534C216.35 75.0207 216.644 75.3235 216.8 75.7C216.938 76.0993 216.922 76.5355 216.755 76.9237C216.589 77.3119 216.284 77.6243 215.9 77.8H215.3C215.004 77.805 214.713 77.7221 214.464 77.562C214.215 77.4018 214.018 77.1715 213.9 76.9ZM27.4 69.4C27.0352 69.2077 26.7587 68.8819 26.6283 68.4906C26.4978 68.0993 26.5235 67.6728 26.7 67.3C26.8924 66.9351 27.2182 66.6587 27.6094 66.5282C28.0007 66.3978 28.4272 66.4235 28.8 66.6C29.166 66.7928 29.4492 67.1124 29.5965 67.499C29.7438 67.8855 29.745 68.3126 29.6 68.7C29.4404 68.9592 29.2208 69.1763 28.9598 69.3329C28.6987 69.4895 28.4039 69.5811 28.1 69.6L27.4 69.4ZM210.1 68.4C209.999 68.2181 209.936 68.0171 209.917 67.8098C209.898 67.6024 209.922 67.3934 209.987 67.1958C210.053 66.9983 210.16 66.8166 210.299 66.6624C210.439 66.5082 210.61 66.3847 210.8 66.3C210.982 66.1987 211.183 66.1364 211.39 66.117C211.598 66.0976 211.807 66.1216 212.004 66.1874C212.202 66.2533 212.383 66.3595 212.538 66.4994C212.692 66.6393 212.815 66.8098 212.9 67C213.077 67.3728 213.102 67.7993 212.972 68.1906C212.841 68.5819 212.565 68.9077 212.2 69.1H211.5C211.226 69.113 210.954 69.0555 210.709 68.9329C210.463 68.8103 210.254 68.6268 210.1 68.4ZM31.9 61.1C31.543 60.8737 31.29 60.5153 31.1963 60.1031C31.1026 59.6909 31.1758 59.2584 31.4 58.9C31.5017 58.7122 31.6423 58.5482 31.8125 58.4191C31.9827 58.29 32.1784 58.1987 32.3867 58.1514C32.595 58.1041 32.811 58.1018 33.0202 58.1446C33.2295 58.1875 33.4271 58.2746 33.6 58.4C33.9305 58.6244 34.165 58.9644 34.2575 59.353C34.3501 59.7416 34.2939 60.1507 34.1 60.5C33.9584 60.7453 33.7541 60.9487 33.5082 61.0893C33.2622 61.2298 32.9833 61.3025 32.7 61.3L31.9 61.1ZM205.5 60.3C205.3 59.9356 205.24 59.5105 205.332 59.1051C205.425 58.6997 205.662 58.3421 206 58.1C206.173 57.9746 206.371 57.8875 206.58 57.8446C206.789 57.8018 207.005 57.8041 207.213 57.8514C207.422 57.8987 207.617 57.99 207.788 58.1191C207.958 58.2482 208.098 58.4122 208.2 58.6C208.424 58.9584 208.497 59.3909 208.404 59.8031C208.31 60.2153 208.057 60.5737 207.7 60.8L206.9 61C206.628 61.004 206.358 60.9425 206.115 60.8207C205.871 60.6989 205.66 60.5203 205.5 60.3ZM37.1 53.2C36.7751 52.9434 36.5622 52.5708 36.5063 52.1605C36.4504 51.7502 36.5556 51.3343 36.8 51C36.9184 50.8277 37.0715 50.682 37.2495 50.5724C37.4275 50.4627 37.6265 50.3915 37.8336 50.3632C38.0408 50.335 38.2516 50.3503 38.4524 50.4083C38.6533 50.4663 38.8398 50.5657 39 50.7C39.1723 50.8184 39.318 50.9715 39.4277 51.1495C39.5373 51.3275 39.6086 51.5265 39.6368 51.7336C39.6651 51.9408 39.6497 52.1515 39.5917 52.3524C39.5337 52.5533 39.4343 52.7398 39.3 52.9C39.1662 53.0925 38.9862 53.2483 38.7766 53.3531C38.5669 53.4579 38.3343 53.5084 38.1 53.5C37.7435 53.5074 37.3936 53.4024 37.1 53.2ZM200.2 52.6C199.978 52.2582 199.886 51.8481 199.941 51.4443C199.996 51.0404 200.195 50.6699 200.5 50.4C200.669 50.2634 200.863 50.1625 201.072 50.1034C201.281 50.0444 201.499 50.0284 201.714 50.0564C201.93 50.0845 202.137 50.156 202.323 50.2667C202.51 50.3773 202.672 50.5247 202.8 50.7C203.022 51.0418 203.114 51.4519 203.059 51.8557C203.004 52.2596 202.805 52.6301 202.5 52.9C202.201 53.0914 201.855 53.1953 201.5 53.2C201.254 53.1942 201.011 53.138 200.788 53.0348C200.564 52.9316 200.364 52.7836 200.2 52.6ZM43.1 45.8C42.7903 45.5293 42.5967 45.1497 42.5594 44.7401C42.5222 44.3304 42.6442 43.9221 42.9 43.6C43.0424 43.4391 43.2157 43.3085 43.4096 43.216C43.6036 43.1236 43.8141 43.0711 44.0288 43.0618C44.2434 43.0524 44.4578 43.0864 44.659 43.1617C44.8602 43.237 45.0442 43.3521 45.2 43.5C45.4952 43.7842 45.6701 44.1707 45.6888 44.5801C45.7074 44.9894 45.5682 45.3902 45.3 45.7C44.9763 46.0103 44.5483 46.1886 44.1 46.2C43.9144 46.2087 43.7292 46.1774 43.5567 46.1084C43.3842 46.0394 43.2284 45.9343 43.1 45.8ZM194.3 45.4C194.155 45.2528 194.041 45.0772 193.967 44.8841C193.893 44.691 193.86 44.4847 193.869 44.2781C193.878 44.0715 193.93 43.8691 194.022 43.6836C194.113 43.498 194.242 43.3334 194.4 43.2C194.71 42.9318 195.111 42.7927 195.52 42.8113C195.929 42.8299 196.316 43.0048 196.6 43.3C196.868 43.6098 197.007 44.0106 196.989 44.4199C196.97 44.8293 196.795 45.2158 196.5 45.5C196.353 45.637 196.18 45.743 195.991 45.8117C195.802 45.8804 195.601 45.9105 195.4 45.9C195.19 45.9119 194.98 45.8727 194.788 45.7856C194.597 45.6985 194.429 45.5662 194.3 45.4ZM49.6 39C49.3318 38.6902 49.1927 38.2894 49.2113 37.8801C49.2299 37.4707 49.4048 37.0842 49.7 36.8C49.8558 36.6521 50.0398 36.537 50.2411 36.4617C50.4423 36.3864 50.6566 36.3524 50.8713 36.3618C51.0859 36.3711 51.2965 36.4236 51.4904 36.516C51.6843 36.6085 51.8577 36.7391 52 36.9C52.2471 37.2189 52.3727 37.6153 52.3544 38.0184C52.3361 38.4214 52.175 38.8048 51.9 39.1C51.7528 39.237 51.5796 39.343 51.3907 39.4117C51.2017 39.4804 51.0008 39.5105 50.8 39.5C50.3517 39.4886 49.9238 39.3103 49.6 39ZM187.7 38.9C187.539 38.7576 187.409 38.5843 187.316 38.3904C187.224 38.1964 187.171 37.9859 187.162 37.7712C187.152 37.5566 187.186 37.3423 187.262 37.141C187.337 36.9398 187.452 36.7558 187.6 36.6C187.884 36.3048 188.271 36.1299 188.68 36.1113C189.089 36.0927 189.49 36.2318 189.8 36.5C190.102 36.801 190.28 37.2045 190.299 37.6305C190.317 38.0565 190.175 38.474 189.9 38.8C189.582 39.1191 189.15 39.2989 188.7 39.3C188.338 39.2559 187.993 39.118 187.7 38.9ZM56.8 32.8C56.5556 32.4657 56.4504 32.0498 56.5063 31.6395C56.5622 31.2292 56.7751 30.8566 57.1 30.6C57.4343 30.3556 57.8503 30.2503 58.2605 30.3063C58.6708 30.3622 59.0434 30.575 59.3 30.9C59.5444 31.2343 59.6497 31.6502 59.5937 32.0605C59.5378 32.4708 59.325 32.8434 59 33.1C58.743 33.3144 58.4314 33.4529 58.1 33.5C57.8447 33.4886 57.5951 33.4197 57.3701 33.2985C57.145 33.1773 56.9501 33.0069 56.8 32.8ZM180.5 32.9C180.175 32.6434 179.962 32.2708 179.906 31.8605C179.85 31.4502 179.956 31.0343 180.2 30.7C180.457 30.375 180.829 30.1622 181.24 30.1063C181.65 30.0503 182.066 30.1556 182.4 30.4C182.725 30.6566 182.938 31.0292 182.994 31.4395C183.05 31.8498 182.944 32.2657 182.7 32.6C182.545 32.7941 182.347 32.9494 182.121 33.0535C181.895 33.1577 181.648 33.2078 181.4 33.2C181.077 33.1933 180.763 33.0887 180.5 32.9ZM64.5 27.3C64.3914 27.1303 64.3181 26.9405 64.2844 26.7419C64.2508 26.5432 64.2575 26.3398 64.3041 26.1438C64.3508 25.9478 64.4365 25.7633 64.556 25.6011C64.6756 25.4389 64.8266 25.3025 65 25.2C65.1729 25.0746 65.3706 24.9875 65.5798 24.9446C65.7891 24.9018 66.0051 24.9041 66.2133 24.9514C66.4216 24.9987 66.6174 25.09 66.7876 25.2191C66.9577 25.3482 67.0983 25.5122 67.2 25.7C67.4001 26.0644 67.4597 26.4895 67.3676 26.8949C67.2754 27.3003 67.038 27.6579 66.7 27.9L65.8 28.1C65.5338 28.0855 65.2755 28.0047 65.0485 27.865C64.8214 27.7253 64.6329 27.5311 64.5 27.3ZM172.8 27.7C172.443 27.4737 172.19 27.1153 172.096 26.7031C172.003 26.2909 172.076 25.8584 172.3 25.5C172.526 25.1429 172.885 24.8899 173.297 24.7963C173.709 24.7026 174.142 24.7758 174.5 25C174.838 25.2421 175.075 25.5997 175.168 26.0051C175.26 26.4105 175.2 26.8356 175 27.2C174.84 27.4203 174.629 27.5989 174.385 27.7207C174.142 27.8425 173.872 27.904 173.6 27.9L172.8 27.7ZM72.7 22.6C72.5987 22.4181 72.5364 22.2171 72.517 22.0098C72.4976 21.8024 72.5216 21.5934 72.5875 21.3958C72.6533 21.1983 72.7596 21.0166 72.8995 20.8624C73.0394 20.7082 73.2098 20.5847 73.4 20.5C73.5819 20.3987 73.783 20.3364 73.9903 20.317C74.1976 20.2976 74.4067 20.3216 74.6042 20.3874C74.8017 20.4533 74.9834 20.5595 75.1376 20.6994C75.2919 20.8393 75.4153 21.0098 75.5 21.2C75.6013 21.3819 75.6637 21.5829 75.683 21.7902C75.7024 21.9976 75.6784 22.2066 75.6126 22.4042C75.5467 22.6017 75.4405 22.7834 75.3006 22.9376C75.1607 23.0918 74.9902 23.2153 74.8 23.3L74.1 23.5C73.8039 23.505 73.5129 23.4221 73.2638 23.262C73.0146 23.1018 72.8185 22.8715 72.7 22.6ZM164.7 23.1C164.51 23.0153 164.339 22.8918 164.199 22.7376C164.06 22.5834 163.953 22.4017 163.887 22.2042C163.822 22.0066 163.798 21.7976 163.817 21.5902C163.836 21.3829 163.899 21.1819 164 21C164.192 20.6351 164.518 20.3587 164.909 20.2282C165.301 20.0978 165.727 20.1235 166.1 20.3C166.465 20.4923 166.741 20.8181 166.872 21.2094C167.002 21.6007 166.977 22.0272 166.8 22.4C166.682 22.6715 166.485 22.9018 166.236 23.062C165.987 23.2221 165.696 23.305 165.4 23.3C165.276 23.3244 165.148 23.319 165.026 23.2842C164.904 23.2495 164.793 23.1863 164.7 23.1ZM81.3 18.6C81.1671 18.2147 81.1862 17.7932 81.3534 17.4215C81.5207 17.0499 81.8235 16.756 82.2 16.6C82.5853 16.4671 83.0068 16.4862 83.3785 16.6534C83.7502 16.8207 84.044 17.1235 84.2 17.5C84.333 17.8853 84.3139 18.3068 84.1466 18.6785C83.9794 19.0501 83.6766 19.344 83.3 19.5H82.7C82.4011 19.5195 82.1038 19.4426 81.8518 19.2806C81.5998 19.1186 81.4064 18.8801 81.3 18.6ZM156.1 19.4C155.723 19.244 155.421 18.9501 155.253 18.5785C155.086 18.2068 155.067 17.7853 155.2 17.4C155.264 17.1924 155.373 17.0013 155.518 16.8398C155.664 16.6783 155.842 16.5504 156.042 16.4648C156.242 16.3792 156.458 16.338 156.675 16.3441C156.892 16.3502 157.105 16.4034 157.3 16.5C157.677 16.656 157.979 16.9499 158.147 17.3215C158.314 17.6932 158.333 18.1147 158.2 18.5C158.06 18.7838 157.848 19.0258 157.584 19.2013C157.321 19.3769 157.016 19.4799 156.7 19.5H156.1V19.4ZM90.2 15.5C90.1232 15.297 90.0914 15.0798 90.1067 14.8634C90.122 14.6469 90.184 14.4364 90.2886 14.2462C90.3932 14.0561 90.5378 13.8909 90.7124 13.7621C90.887 13.6332 91.0875 13.5438 91.3 13.5C91.6973 13.4064 92.1153 13.4682 92.4685 13.6727C92.8216 13.8772 93.0834 14.2089 93.2 14.6C93.2611 14.8035 93.2809 15.0172 93.2585 15.2285C93.2361 15.4398 93.1718 15.6445 93.0694 15.8307C92.967 16.0168 92.8285 16.1808 92.6621 16.3128C92.4957 16.4449 92.3046 16.5426 92.1 16.6H91.7C91.3627 16.6122 91.0311 16.5102 90.7589 16.3106C90.4867 16.111 90.2898 15.8254 90.2 15.5ZM147.3 16.5C146.914 16.3452 146.593 16.0613 146.392 15.6967C146.192 15.332 146.124 14.9091 146.2 14.5C146.337 14.1012 146.618 13.7677 146.988 13.5644C147.358 13.3611 147.79 13.3025 148.2 13.4C148.599 13.5375 148.932 13.8183 149.136 14.1879C149.339 14.5576 149.397 14.9896 149.3 15.4C149.191 15.7334 148.975 16.0217 148.686 16.2204C148.397 16.4192 148.05 16.5174 147.7 16.5H147.3ZM99.4 13.2C99.3102 12.7891 99.3857 12.3594 99.6103 12.0039C99.8349 11.6483 100.19 11.3954 100.6 11.3C101.022 11.2389 101.452 11.3386 101.804 11.5794C102.156 11.8202 102.404 12.1845 102.5 12.6C102.558 13.0099 102.455 13.4265 102.213 13.7622C101.971 14.0979 101.608 14.3265 101.2 14.4H100.9C100.549 14.4071 100.207 14.2909 99.9327 14.0716C99.6587 13.8523 99.4702 13.5439 99.4 13.2ZM138.2 14.3C137.79 14.2046 137.435 13.9517 137.21 13.5961C136.986 13.2406 136.91 12.8109 137 12.4C137.094 12.0035 137.328 11.6542 137.658 11.4155C137.989 11.1769 138.394 11.0649 138.8 11.1C139.216 11.1959 139.58 11.4445 139.821 11.7965C140.061 12.1484 140.161 12.578 140.1 13C140.013 13.362 139.809 13.6853 139.52 13.9202C139.23 14.1551 138.872 14.2885 138.5 14.3H138.2ZM108.7 11.7C108.671 11.2913 108.801 10.8871 109.061 10.5708C109.321 10.2545 109.693 10.0502 110.1 10C110.305 9.97208 110.513 9.98684 110.712 10.0434C110.911 10.0999 111.096 10.1969 111.256 10.3284C111.416 10.4598 111.546 10.6229 111.64 10.8073C111.734 10.9917 111.788 11.1935 111.8 11.4C111.828 11.6049 111.813 11.8134 111.757 12.0123C111.7 12.2113 111.603 12.3964 111.472 12.556C111.34 12.7157 111.177 12.8464 110.993 12.94C110.808 13.0336 110.606 13.0881 110.4 13.1H110.3C109.908 13.1031 109.529 12.9622 109.234 12.7042C108.939 12.4461 108.749 12.0888 108.7 11.7ZM129 13.1C128.593 13.0498 128.221 12.8455 127.961 12.5292C127.701 12.2129 127.571 11.8087 127.6 11.4C127.613 11.1897 127.667 10.9841 127.759 10.7948C127.852 10.6055 127.981 10.4363 128.139 10.2969C128.296 10.1576 128.48 10.0508 128.68 9.98266C128.879 9.91454 129.09 9.88645 129.3 9.9C129.511 9.92468 129.715 9.99104 129.899 10.0952C130.084 10.1994 130.247 10.3393 130.377 10.5068C130.507 10.6744 130.603 10.8661 130.658 11.071C130.714 11.2758 130.728 11.4896 130.7 11.7C130.675 12.0802 130.505 12.4366 130.227 12.6966C129.948 12.9566 129.581 13.1008 129.2 13.1H129ZM118.1 11.1C118.1 10.6757 118.269 10.2687 118.569 9.96863C118.869 9.66857 119.276 9.5 119.7 9.5C120.124 9.5 120.531 9.66857 120.831 9.96863C121.131 10.2687 121.3 10.6757 121.3 11.1C121.3 11.5243 121.131 11.9313 120.831 12.2314C120.531 12.5314 120.124 12.7 119.7 12.7C119.276 12.7 118.869 12.5314 118.569 12.2314C118.269 11.9313 118.1 11.5243 118.1 11.1Z",
            fill: "#C1C7D0"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M112.8 131.5H62.4C51.5791 131.5 41.2015 135.799 33.55 143.45C25.8985 151.102 21.6 161.479 21.6 172.3C21.6 183.121 25.8985 193.498 33.55 201.15C41.2015 208.801 51.5791 213.1 62.4 213.1H64.8C70.1395 213.065 75.3444 214.775 79.6226 217.97C83.9008 221.165 87.0181 225.67 88.5 230.8C88.5 230.9 88.6 231 88.6 231.1H88.9C88.9362 231.059 88.9637 231.012 88.9809 230.96C88.9981 230.909 89.0046 230.854 89 230.8C90.5012 225.662 93.6373 221.154 97.9324 217.96C102.228 214.765 107.447 213.059 112.8 213.1C123.621 213.1 133.998 208.801 141.65 201.15C149.301 193.498 153.6 183.121 153.6 172.3C153.6 161.479 149.301 151.102 141.65 143.45C133.998 135.799 123.621 131.5 112.8 131.5Z",
            fill: "url(#activity_0_linear)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.1",
            d: "M112.8 131.5H72.7999C75.1944 143.066 81.5064 153.451 90.6704 160.903C99.8344 168.354 111.289 172.415 123.1 172.4H126C130.954 172.379 135.841 173.539 140.258 175.782C144.675 178.025 148.494 181.288 151.4 185.3C152.858 181.121 153.602 176.726 153.6 172.3C153.6 161.479 149.301 151.102 141.65 143.45C133.998 135.799 123.621 131.5 112.8 131.5Z",
            fill: "#091E42"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M194.4 61.6992H131C117.368 61.6992 104.294 67.1146 94.6547 76.7539C85.0153 86.3933 79.6 99.4671 79.6 113.099C79.6 126.731 85.0153 139.805 94.6547 149.445C104.294 159.084 117.368 164.499 131 164.499H133.9C140.633 164.451 147.197 166.603 152.594 170.629C157.992 174.654 161.926 180.332 163.8 186.799C163.8 186.899 163.9 186.999 163.9 187.099C163.927 187.14 163.964 187.174 164.008 187.198C164.052 187.221 164.1 187.233 164.15 187.233C164.199 187.233 164.248 187.221 164.292 187.198C164.335 187.174 164.373 187.14 164.4 187.099V186.799C166.308 180.333 170.265 174.661 175.676 170.639C181.087 166.617 187.658 164.462 194.4 164.499C208.032 164.499 221.106 159.084 230.745 149.445C240.385 139.805 245.8 126.731 245.8 113.099C245.8 99.4671 240.385 86.3933 230.745 76.7539C221.106 67.1146 208.032 61.6992 194.4 61.6992Z",
            fill: "url(#activity_1_linear)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.2",
            d: "M124 68.5992C124.036 66.4549 123.869 64.3119 123.5 62.1992C112.25 63.8756 101.872 69.2289 93.9849 77.4237C86.0977 85.6185 81.1451 96.1938 79.9 107.499C81.8913 106.975 83.941 106.706 86 106.699C90.9987 106.699 95.9482 105.713 100.565 103.797C105.182 101.881 109.376 99.0732 112.906 95.5339C116.435 91.9947 119.232 87.7938 121.136 83.1719C123.04 78.55 124.013 73.5979 124 68.5992Z",
            fill: "#172B4D"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M93.8001 21.0997H46.8001C41.8014 21.0997 36.8519 22.0859 32.235 24.0019C27.6181 25.9178 23.4245 28.7258 19.8946 32.265C16.3646 35.8042 13.5677 40.0051 11.6639 44.6271C9.7601 49.249 8.7869 54.2011 8.80006 59.1997C8.80006 69.278 12.8036 78.9434 19.93 86.0698C27.0564 93.1962 36.7218 97.1997 46.8001 97.1997H49.0001C54.0022 97.1762 58.8757 98.784 62.8818 101.78C66.8879 104.775 69.8082 108.995 71.2001 113.8V114C71.2001 114.2 71.4001 114.2 71.5001 114C71.6001 113.8 71.5001 113.8 71.6001 113.8C72.9622 108.978 75.8749 104.739 79.8876 101.739C83.9004 98.738 88.7898 97.1429 93.8001 97.1997C98.7987 97.2129 103.751 96.2397 108.373 94.3359C112.995 92.4321 117.196 89.6352 120.735 86.1052C124.274 82.5753 127.082 78.3818 128.998 73.7649C130.914 69.1479 131.9 64.1984 131.9 59.1997C131.913 54.1927 130.937 49.2324 129.027 44.6039C127.117 39.9754 124.311 35.7701 120.77 32.2296C117.23 28.689 113.024 25.8831 108.396 23.9731C103.767 22.063 98.8071 21.0865 93.8001 21.0997Z",
            fill: "url(#activity_2_linear)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M152 33.7996C161.168 33.7996 168.6 26.3675 168.6 17.1996C168.6 8.03168 161.168 0.599609 152 0.599609C142.832 0.599609 135.4 8.03168 135.4 17.1996C135.4 26.3675 142.832 33.7996 152 33.7996Z",
            fill: "#DFE1E5"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M157.6 20.9997C158.62 20.1721 159.432 19.1167 159.971 17.9183C160.509 16.72 160.759 15.4121 160.7 14.0997C160.436 11.9677 159.393 10.0088 157.771 8.60018C156.149 7.19156 154.063 6.43281 151.915 6.47006C149.767 6.50731 147.709 7.33791 146.137 8.80192C144.565 10.2659 143.59 12.2598 143.4 14.3997C143.389 15.6518 143.652 16.8912 144.171 18.0312C144.689 19.1712 145.45 20.1843 146.4 20.9997C146.933 21.4137 147.363 21.9446 147.658 22.5515C147.953 23.1584 148.104 23.825 148.1 24.4997C148.073 25.4047 147.784 26.2825 147.27 27.0276C146.755 27.7727 146.037 28.3533 145.2 28.6997C143.184 29.4935 141.348 30.6836 139.8 32.1997C143.608 33.7774 147.679 34.6254 151.8 34.6996C156.088 34.6741 160.332 33.8254 164.3 32.1997C161.8 31.0997 160.3 29.2997 158.9 28.6997C158.056 28.3641 157.33 27.7862 156.814 27.0387C156.298 26.2913 156.015 25.4078 156 24.4997C156.011 23.8374 156.159 23.1846 156.434 22.5823C156.709 21.9799 157.106 21.4411 157.6 20.9997Z",
            fill: "#97A0AF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M143.6 25.7988C143.386 25.7988 143.175 25.746 142.987 25.645C142.798 25.544 142.637 25.398 142.518 25.2199C142.4 25.0419 142.327 24.8372 142.306 24.6242C142.285 24.4112 142.318 24.1964 142.4 23.9988C142.922 22.977 143.196 21.8464 143.2 20.6988V14.4988C143.255 12.7498 143.825 11.0558 144.837 9.62864C145.85 8.2015 147.261 7.10454 148.893 6.47493C150.526 5.84532 152.308 5.711 154.017 6.08876C155.726 6.46652 157.285 7.33959 158.5 8.59882C159.26 9.37738 159.855 10.3011 160.25 11.3147C160.646 12.3284 160.833 13.4113 160.8 14.4988V20.6988C160.79 21.8608 161.101 23.0029 161.7 23.9988C161.782 24.1964 161.815 24.4112 161.794 24.6242C161.773 24.8372 161.7 25.0419 161.582 25.2199C161.463 25.398 161.302 25.544 161.113 25.645C160.925 25.746 160.714 25.7988 160.5 25.7988H143.6Z",
            fill: "#97A0AF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M17.5 144.399C26.668 144.399 34.1 136.967 34.1 127.799C34.1 118.631 26.668 111.199 17.5 111.199C8.3321 111.199 0.900024 118.631 0.900024 127.799C0.900024 136.967 8.3321 144.399 17.5 144.399Z",
            fill: "#4C9AFF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M22.8 131.398C23.8028 130.556 24.6024 129.498 25.1392 128.303C25.6759 127.108 25.936 125.808 25.9 124.498C25.8042 122.318 24.9019 120.252 23.3682 118.7C21.8345 117.147 19.7787 116.22 17.6 116.098C15.7947 116.028 14.0122 116.521 12.4999 117.51C10.9877 118.499 9.82079 119.934 9.16117 121.616C8.50156 123.298 8.38197 125.143 8.81901 126.896C9.25604 128.649 10.228 130.223 11.6 131.398C12.1036 131.832 12.5074 132.369 12.7836 132.973C13.0598 133.577 13.2019 134.234 13.2 134.898C13.1935 135.795 12.925 136.671 12.4276 137.417C11.9301 138.163 11.2254 138.748 10.4 139.098C8.35457 139.892 6.48563 141.082 4.90002 142.598C8.71488 144.154 12.7813 145.001 16.9 145.098C21.2217 145.083 25.4999 144.234 29.5 142.598C26.9 141.498 25.4 139.698 24 139.098C23.2845 138.791 22.6587 138.307 22.1813 137.692C21.7039 137.076 21.3905 136.35 21.2706 135.58C21.1507 134.811 21.2281 134.023 21.4956 133.292C21.7631 132.561 22.2119 131.909 22.8 131.398Z",
            fill: "#0065FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M189.6 206.1C198.768 206.1 206.2 198.668 206.2 189.5C206.2 180.332 198.768 172.9 189.6 172.9C180.432 172.9 173 180.332 173 189.5C173 198.668 180.432 206.1 189.6 206.1Z",
            fill: "#FFE380"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M190.1 207.402C193.994 207.32 197.835 206.471 201.4 204.902C199.944 203.415 198.211 202.226 196.3 201.402C195.493 201.036 194.81 200.445 194.331 199.7C193.852 198.955 193.598 198.088 193.6 197.202C193.604 196.548 193.738 195.901 193.996 195.3C194.254 194.699 194.629 194.156 195.1 193.702C196.022 192.869 196.757 191.85 197.257 190.712C197.757 189.575 198.01 188.344 198 187.102C198 182.102 194.2 178.202 189.5 178.402C184.8 178.602 181 182.102 181 187.102C180.995 188.334 181.241 189.555 181.723 190.689C182.204 191.824 182.911 192.849 183.8 193.702C184.304 194.135 184.707 194.672 184.984 195.277C185.26 195.881 185.402 196.538 185.4 197.202C185.402 198.088 185.148 198.955 184.669 199.7C184.19 200.445 183.507 201.036 182.7 201.402C180.789 202.226 179.056 203.415 177.6 204.902C181.165 206.471 185.006 207.32 188.9 207.402H190.1Z",
            fill: "#FFC400"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M197.4 197.701H181.6C181.351 197.702 181.111 197.611 180.926 197.444C180.741 197.278 180.625 197.049 180.6 196.801V186.601C180.628 184.246 181.559 181.991 183.2 180.301C184.878 178.642 187.14 177.708 189.5 177.701C191.86 177.701 194.124 178.639 195.793 180.308C197.462 181.977 198.4 184.241 198.4 186.601V196.801C198.401 196.928 198.375 197.054 198.323 197.17C198.272 197.287 198.197 197.391 198.102 197.476C198.008 197.561 197.896 197.625 197.775 197.664C197.654 197.702 197.526 197.715 197.4 197.701Z",
            fill: "#FFC400"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M103.8 46.9004H35.9V48.9004H103.8V46.9004Z",
            fill: "#FF991F"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M103.8 57.5996H35.9V59.5996H103.8V57.5996Z",
            fill: "#FF991F"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M103.8 68.4004H35.9V70.4004H103.8V68.4004Z",
            fill: "#FF991F"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M214.4 107.799C209 107.799 206.2 105.599 203.6 103.599C201 101.599 198.8 99.7988 194 99.7988C189.2 99.7988 186.9 101.599 184.4 103.599C181.9 105.599 179 107.799 173.6 107.799C168.2 107.799 165.4 105.599 162.7 103.599C160 101.599 157.9 99.7988 153.1 99.7988C148.3 99.7988 146 101.599 143.5 103.599C141 105.599 138.1 107.799 132.7 107.799C127.3 107.799 124.5 105.599 121.9 103.599C119.3 101.599 117 99.7988 112.3 99.7988V97.7988C117.7 97.7988 120.4 99.8988 123.1 101.999C125.8 104.099 127.9 105.799 132.7 105.799C137.5 105.799 139.8 103.899 142.3 101.999C144.8 100.099 147.7 97.7988 153.1 97.7988C158.5 97.7988 161.3 99.8988 164 101.999C166.7 104.099 168.8 105.799 173.6 105.799C178.4 105.799 180.7 103.899 183.2 101.999C185.7 100.099 188.5 97.7988 194 97.7988C199.5 97.7988 202.2 99.8988 204.8 101.999C207.4 104.099 209.7 105.799 214.4 105.799V107.799Z",
            fill: "#0049B0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M214.4 118.5C209 118.5 206.2 116.4 203.6 114.3C201 112.2 198.8 110.5 194 110.5C189.2 110.5 186.9 112.4 184.4 114.3C181.9 116.2 179 118.5 173.6 118.5C168.2 118.5 165.4 116.4 162.7 114.3C160 112.2 157.9 110.5 153.1 110.5C148.3 110.5 146 112.4 143.5 114.3C141 116.2 138.1 118.5 132.7 118.5C127.3 118.5 124.5 116.4 121.9 114.3C119.3 112.2 117 110.5 112.3 110.5V108.5C117.7 108.5 120.4 110.7 123.1 112.7C125.8 114.7 127.9 116.5 132.7 116.5C137.5 116.5 139.8 114.7 142.3 112.7C144.8 110.7 147.7 108.5 153.1 108.5C158.5 108.5 161.3 110.7 164 112.7C166.7 114.7 168.8 116.5 173.6 116.5C178.4 116.5 180.7 114.7 183.2 112.7C185.7 110.7 188.5 108.5 194 108.5C199.5 108.5 202.2 110.7 204.8 112.7C207.4 114.7 209.7 116.5 214.4 116.5V118.5Z",
            fill: "#0049B0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M214.4 129.199C209 129.199 206.2 127.099 203.6 124.999C201 122.899 198.8 121.199 194 121.199C189.2 121.199 186.9 123.099 184.4 124.999C181.9 126.899 179 129.199 173.6 129.199C168.2 129.199 165.4 127.099 162.7 124.999C160 122.899 157.9 121.199 153.1 121.199C148.3 121.199 146 123.099 143.5 124.999C141 126.899 138.1 129.199 132.7 129.199C127.3 129.199 124.5 127.099 121.9 124.999C119.3 122.899 117 121.199 112.3 121.199V119.199C117.7 119.199 120.4 121.399 123.1 123.499C125.8 125.599 127.9 127.199 132.7 127.199C137.5 127.199 139.8 125.399 142.3 123.499C144.8 121.599 147.7 119.199 153.1 119.199C158.5 119.199 161.3 121.399 164 123.499C166.7 125.599 168.8 127.199 173.6 127.199C178.4 127.199 180.7 125.399 183.2 123.499C185.7 121.599 188.5 119.199 194 119.199C199.5 119.199 202.2 121.399 204.8 123.499C207.4 125.599 209.7 127.199 214.4 127.199V129.199Z",
            fill: "#0049B0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M62.6001 183.3C61.0376 183.3 59.5102 182.837 58.2111 181.969C56.9119 181.101 55.8994 179.867 55.3014 178.423C54.7035 176.98 54.5471 175.391 54.8519 173.859C55.1567 172.326 55.9091 170.919 57.0139 169.814C58.1188 168.709 59.5264 167.957 61.0589 167.652C62.5913 167.347 64.1797 167.503 65.6233 168.101C67.0668 168.699 68.3006 169.712 69.1687 171.011C70.0367 172.31 70.5001 173.838 70.5001 175.4C70.5001 177.495 69.6678 179.505 68.1862 180.986C66.7047 182.468 64.6953 183.3 62.6001 183.3ZM62.6001 169.6C61.4289 169.6 60.2844 169.949 59.3121 170.602C58.3398 171.255 57.5837 172.182 57.1403 173.266C56.6968 174.35 56.586 175.541 56.8218 176.688C57.0577 177.835 57.6296 178.886 58.4648 179.707C59.3 180.528 60.3606 181.082 61.5116 181.299C62.6626 181.515 63.8519 181.384 64.9281 180.922C66.0042 180.46 66.9186 179.688 67.5547 178.705C68.1908 177.721 68.5199 176.571 68.5001 175.4C68.4738 173.853 67.8407 172.377 66.737 171.293C65.6334 170.208 64.1477 169.6 62.6001 169.6Z",
            fill: "#7A869A"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M87.6 183.299C86.4947 183.424 85.3755 183.314 84.3157 182.976C83.2558 182.639 82.2791 182.081 81.4496 181.34C80.62 180.599 79.9563 179.691 79.5019 178.676C79.0475 177.661 78.8126 176.561 78.8126 175.449C78.8126 174.337 79.0475 173.237 79.5019 172.221C79.9563 171.206 80.62 170.298 81.4496 169.557C82.2791 168.816 83.2558 168.259 84.3157 167.921C85.3755 167.584 86.4947 167.474 87.6 167.599C88.7053 167.474 89.8245 167.584 90.8844 167.921C91.9443 168.259 92.921 168.816 93.7505 169.557C94.58 170.298 95.2437 171.206 95.6981 172.221C96.1525 173.237 96.3874 174.337 96.3874 175.449C96.3874 176.561 96.1525 177.661 95.6981 178.676C95.2437 179.691 94.58 180.599 93.7505 181.34C92.921 182.081 91.9443 182.639 90.8844 182.976C89.8245 183.314 88.7053 183.424 87.6 183.299ZM87.6 169.599C86.4289 169.599 85.2843 169.948 84.312 170.601C83.3397 171.253 82.5837 172.181 82.1402 173.265C81.6968 174.349 81.5859 175.54 81.8218 176.687C82.0577 177.834 82.6296 178.885 83.4648 179.706C84.2999 180.527 85.3605 181.081 86.5115 181.297C87.6625 181.514 88.8518 181.382 89.928 180.92C91.0042 180.459 91.9186 179.687 92.5547 178.703C93.1908 177.72 93.5199 176.57 93.5 175.399C93.4738 173.851 92.8406 172.376 91.737 171.291C90.6334 170.206 89.1476 169.599 87.6 169.599Z",
            fill: "#7A869A"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M112.6 183.299C111.495 183.424 110.376 183.314 109.316 182.976C108.256 182.639 107.279 182.081 106.45 181.34C105.62 180.599 104.956 179.691 104.502 178.676C104.048 177.661 103.813 176.561 103.813 175.449C103.813 174.337 104.048 173.237 104.502 172.221C104.956 171.206 105.62 170.298 106.45 169.557C107.279 168.816 108.256 168.259 109.316 167.921C110.376 167.584 111.495 167.474 112.6 167.599C113.705 167.474 114.825 167.584 115.884 167.921C116.944 168.259 117.921 168.816 118.75 169.557C119.58 170.298 120.244 171.206 120.698 172.221C121.153 173.237 121.387 174.337 121.387 175.449C121.387 176.561 121.153 177.661 120.698 178.676C120.244 179.691 119.58 180.599 118.75 181.34C117.921 182.081 116.944 182.639 115.884 182.976C114.825 183.314 113.705 183.424 112.6 183.299ZM112.6 169.599C111.429 169.599 110.284 169.948 109.312 170.601C108.34 171.253 107.584 172.181 107.14 173.265C106.697 174.349 106.586 175.54 106.822 176.687C107.058 177.834 107.63 178.885 108.465 179.706C109.3 180.527 110.361 181.081 111.512 181.297C112.663 181.514 113.852 181.382 114.928 180.92C116.004 180.459 116.919 179.687 117.555 178.703C118.191 177.72 118.52 176.57 118.5 175.399C118.474 173.851 117.841 172.376 116.737 171.291C115.633 170.206 114.148 169.599 112.6 169.599Z",
            fill: "#7A869A"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: "activity_0_linear",
            x1: "46.18",
            y1: "213.75",
            x2: "129.04",
            y2: "130.89",
            gradientUnits: "userSpaceOnUse"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            stopColor: "#8993A4"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.17",
            stopColor: "#939DAC"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.46",
            stopColor: "#B0B6C1"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.83",
            stopColor: "#DDDFE3"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.85",
            stopColor: "#DFE1E5"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: "activity_1_linear",
            x1: "110.47",
            y1: "165.289",
            x2: "214.86",
            y2: "60.8992",
            gradientUnits: "userSpaceOnUse"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.16",
            stopColor: "#0052CC"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.25",
            stopColor: "#0059E0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.36",
            stopColor: "#0060F1"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.48",
            stopColor: "#0064FC"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.62",
            stopColor: "#0065FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.67",
            stopColor: "#0568FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.72",
            stopColor: "#1572FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.79",
            stopColor: "#2E82FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.86",
            stopColor: "#5198FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.93",
            stopColor: "#7EB4FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "1",
            stopColor: "#B2D4FF"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: "activity_2_linear",
            x1: "31.6601",
            y1: "97.8397",
            x2: "109.03",
            y2: "20.4697",
            gradientUnits: "userSpaceOnUse"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.16",
            stopColor: "#FF991F"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.21",
            stopColor: "#FF9E1B"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.49",
            stopColor: "#FFBA07"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.66",
            stopColor: "#FFC400"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.81",
            stopColor: "#FFD340"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.94",
            stopColor: "#FFDF6E"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "1",
            stopColor: "#FFE380"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "activity_0_clip"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M0.900024 0.599609H245.8V231.2H0.900024V0.599609Z",
            fill: "white"
        }))));
    var $7c8c125223d7fe6c$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($7c8c125223d7fe6c$var$EmptyIllustration);
});
parcelRegister("cVaIM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$902a303e374c9bf4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $902a303e374c9bf4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        today: {
            "id": "business-summary.summary-view.activity-feed.today",
            "defaultMessage": "Today"
        },
        yesterday: {
            "id": "business-summary.summary-view.activity-feed.yesterday",
            "defaultMessage": "Yesterday"
        },
        title: {
            "id": "business-summary.summary-view.activity-feed.title",
            "defaultMessage": "Recent activity"
        },
        description: {
            "id": "business-summary.summary-view.activity-feed.description",
            "defaultMessage": "Stay up to date with what's happening across the project. "
        },
        descriptionWhenEmpty: {
            "id": "business-summary.summary-view.activity-feed.description-when-empty",
            "defaultMessage": "Create a few items and invite teammates to your project to see your project activity."
        }
    });
});
parcelRegister("7w9Ud", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$558c5686824de552$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $558c5686824de552$var$Skeleton = ({ className: className, testId: testId })=>{
        const skeletonColor = `var(--ds-skeleton, ${(0, $72ba03e317f3d228$export$8d43898f60b96a82)})`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            viewBox: "0 0 476 296",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: className,
            "data-testid": testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "476",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            y: "16",
            width: "320",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "4",
            y: "70",
            width: "32",
            height: "32",
            rx: "16",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "52",
            y: "60",
            width: "420",
            height: "12",
            rx: "6",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "52",
            y: "80",
            width: "420",
            height: "12",
            rx: "6",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "52",
            y: "100",
            width: "93",
            height: "12",
            rx: "6",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "4",
            y: "162",
            width: "32",
            height: "32",
            rx: "16",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "52",
            y: "152",
            width: "420",
            height: "12",
            rx: "6",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "52",
            y: "172",
            width: "420",
            height: "12",
            rx: "6",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "52",
            y: "192",
            width: "93",
            height: "12",
            rx: "6",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "4",
            y: "254",
            width: "32",
            height: "32",
            rx: "16",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "52",
            y: "244",
            width: "420",
            height: "12",
            rx: "6",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "52",
            y: "264",
            width: "420",
            height: "12",
            rx: "6",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "52",
            y: "284",
            width: "93",
            height: "12",
            rx: "6",
            fill: skeletonColor
        }));
    };
    var $558c5686824de552$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($558c5686824de552$var$Skeleton);
});
var $72ba03e317f3d228$exports = {};
$parcel$export($72ba03e317f3d228$exports, "R50", ()=>$72ba03e317f3d228$export$4b84fd0e2c617bd);
$parcel$export($72ba03e317f3d228$exports, "R75", ()=>$72ba03e317f3d228$export$b34b069eff244586);
$parcel$export($72ba03e317f3d228$exports, "R100", ()=>$72ba03e317f3d228$export$be802dd0d8b57f35);
$parcel$export($72ba03e317f3d228$exports, "R200", ()=>$72ba03e317f3d228$export$60847d42f9da92a6);
$parcel$export($72ba03e317f3d228$exports, "R300", ()=>$72ba03e317f3d228$export$4a7404f376229999);
$parcel$export($72ba03e317f3d228$exports, "R400", ()=>$72ba03e317f3d228$export$2010d0fb4295b346);
$parcel$export($72ba03e317f3d228$exports, "R500", ()=>$72ba03e317f3d228$export$2837b5a1a71d5c02);
$parcel$export($72ba03e317f3d228$exports, "Y50", ()=>$72ba03e317f3d228$export$8d9596b529bbb9cf);
$parcel$export($72ba03e317f3d228$exports, "Y75", ()=>$72ba03e317f3d228$export$41060a744ab0b7ae);
$parcel$export($72ba03e317f3d228$exports, "Y100", ()=>$72ba03e317f3d228$export$1cc05bbbf340e559);
$parcel$export($72ba03e317f3d228$exports, "Y200", ()=>$72ba03e317f3d228$export$5aae31392d72caaa);
$parcel$export($72ba03e317f3d228$exports, "Y300", ()=>$72ba03e317f3d228$export$c6930421db9fa514);
$parcel$export($72ba03e317f3d228$exports, "Y400", ()=>$72ba03e317f3d228$export$59619663aa6500fb);
$parcel$export($72ba03e317f3d228$exports, "Y500", ()=>$72ba03e317f3d228$export$874739ea9e379ab6);
$parcel$export($72ba03e317f3d228$exports, "G50", ()=>$72ba03e317f3d228$export$8a6341c32b6a3ee6);
$parcel$export($72ba03e317f3d228$exports, "G75", ()=>$72ba03e317f3d228$export$69a3bf21b9686c2b);
$parcel$export($72ba03e317f3d228$exports, "G100", ()=>$72ba03e317f3d228$export$afbce1382ec95f73);
$parcel$export($72ba03e317f3d228$exports, "G200", ()=>$72ba03e317f3d228$export$747d86715d4175de);
$parcel$export($72ba03e317f3d228$exports, "G300", ()=>$72ba03e317f3d228$export$940e1f69e873f202);
$parcel$export($72ba03e317f3d228$exports, "G400", ()=>$72ba03e317f3d228$export$a49394138f7b8e85);
$parcel$export($72ba03e317f3d228$exports, "G500", ()=>$72ba03e317f3d228$export$6fa04827ac68a4fb);
$parcel$export($72ba03e317f3d228$exports, "B50", ()=>$72ba03e317f3d228$export$226de0355ed012f8);
$parcel$export($72ba03e317f3d228$exports, "B75", ()=>$72ba03e317f3d228$export$8c13c2ee36917869);
$parcel$export($72ba03e317f3d228$exports, "B100", ()=>$72ba03e317f3d228$export$ecfc1dff386a3e7a);
$parcel$export($72ba03e317f3d228$exports, "B200", ()=>$72ba03e317f3d228$export$215b7063051591f1);
$parcel$export($72ba03e317f3d228$exports, "B300", ()=>$72ba03e317f3d228$export$e62e8919cca44969);
$parcel$export($72ba03e317f3d228$exports, "B400", ()=>$72ba03e317f3d228$export$b3de0ae08da2ce64);
$parcel$export($72ba03e317f3d228$exports, "B500", ()=>$72ba03e317f3d228$export$a6ee3d71bc067634);
$parcel$export($72ba03e317f3d228$exports, "B600", ()=>$72ba03e317f3d228$export$67f15409e87642a1);
$parcel$export($72ba03e317f3d228$exports, "B700", ()=>$72ba03e317f3d228$export$f0539dbc42dbb067);
$parcel$export($72ba03e317f3d228$exports, "P50", ()=>$72ba03e317f3d228$export$363e4475840015bb);
$parcel$export($72ba03e317f3d228$exports, "P75", ()=>$72ba03e317f3d228$export$4b0a4417ed59760f);
$parcel$export($72ba03e317f3d228$exports, "P100", ()=>$72ba03e317f3d228$export$6011520a64d9a187);
$parcel$export($72ba03e317f3d228$exports, "P200", ()=>$72ba03e317f3d228$export$a7175d4e9206bc80);
$parcel$export($72ba03e317f3d228$exports, "P300", ()=>$72ba03e317f3d228$export$b48405b95304b5a1);
$parcel$export($72ba03e317f3d228$exports, "P400", ()=>$72ba03e317f3d228$export$c71e4279dd54a18d);
$parcel$export($72ba03e317f3d228$exports, "P500", ()=>$72ba03e317f3d228$export$147899de772240ec);
$parcel$export($72ba03e317f3d228$exports, "T50", ()=>$72ba03e317f3d228$export$2cf711fe14c66f06);
$parcel$export($72ba03e317f3d228$exports, "T75", ()=>$72ba03e317f3d228$export$7a8f4d33f6f9772c);
$parcel$export($72ba03e317f3d228$exports, "T100", ()=>$72ba03e317f3d228$export$776c9c497ef08533);
$parcel$export($72ba03e317f3d228$exports, "T200", ()=>$72ba03e317f3d228$export$69cb3ca10c1e330e);
$parcel$export($72ba03e317f3d228$exports, "T300", ()=>$72ba03e317f3d228$export$9dc1ef0f3f48059b);
$parcel$export($72ba03e317f3d228$exports, "T400", ()=>$72ba03e317f3d228$export$7c835c78b6fcdef8);
$parcel$export($72ba03e317f3d228$exports, "T500", ()=>$72ba03e317f3d228$export$6036577f95c3877e);
$parcel$export($72ba03e317f3d228$exports, "N0", ()=>$72ba03e317f3d228$export$29a4f05edc054374);
$parcel$export($72ba03e317f3d228$exports, "N10", ()=>$72ba03e317f3d228$export$e655ef011c4aa1a2);
$parcel$export($72ba03e317f3d228$exports, "N20", ()=>$72ba03e317f3d228$export$9fdfb749e33cdf97);
$parcel$export($72ba03e317f3d228$exports, "N30", ()=>$72ba03e317f3d228$export$3e51e8f1440314ba);
$parcel$export($72ba03e317f3d228$exports, "N40", ()=>$72ba03e317f3d228$export$1ce2d1575d444ceb);
$parcel$export($72ba03e317f3d228$exports, "N50", ()=>$72ba03e317f3d228$export$8754fc7e6d8b3000);
$parcel$export($72ba03e317f3d228$exports, "N60", ()=>$72ba03e317f3d228$export$c2e91cbeada39b8b);
$parcel$export($72ba03e317f3d228$exports, "N70", ()=>$72ba03e317f3d228$export$5f71e19f3a7ad9de);
$parcel$export($72ba03e317f3d228$exports, "N80", ()=>$72ba03e317f3d228$export$eaa8c8a70ac22806);
$parcel$export($72ba03e317f3d228$exports, "N90", ()=>$72ba03e317f3d228$export$7c87d337fb91a97d);
$parcel$export($72ba03e317f3d228$exports, "N100", ()=>$72ba03e317f3d228$export$d6447c357493214f);
$parcel$export($72ba03e317f3d228$exports, "N200", ()=>$72ba03e317f3d228$export$f563ee71e9ee74cd);
$parcel$export($72ba03e317f3d228$exports, "N300", ()=>$72ba03e317f3d228$export$e2ef2124cf4024b1);
$parcel$export($72ba03e317f3d228$exports, "N400", ()=>$72ba03e317f3d228$export$eece5f492e429f08);
$parcel$export($72ba03e317f3d228$exports, "N500", ()=>$72ba03e317f3d228$export$c39c0fe0f26207ae);
$parcel$export($72ba03e317f3d228$exports, "N600", ()=>$72ba03e317f3d228$export$7090862dc3038a9f);
$parcel$export($72ba03e317f3d228$exports, "N700", ()=>$72ba03e317f3d228$export$ad0bacf983b7ddaa);
$parcel$export($72ba03e317f3d228$exports, "N800", ()=>$72ba03e317f3d228$export$7d61b15e0da132af);
$parcel$export($72ba03e317f3d228$exports, "N900", ()=>$72ba03e317f3d228$export$fbda843f0a27fe96);
$parcel$export($72ba03e317f3d228$exports, "N10A", ()=>$72ba03e317f3d228$export$791e57b27ca738ef);
$parcel$export($72ba03e317f3d228$exports, "N20A", ()=>$72ba03e317f3d228$export$8d43898f60b96a82);
$parcel$export($72ba03e317f3d228$exports, "N30A", ()=>$72ba03e317f3d228$export$920c0d5c49070351);
$parcel$export($72ba03e317f3d228$exports, "N40A", ()=>$72ba03e317f3d228$export$46987b49aab6d1a8);
$parcel$export($72ba03e317f3d228$exports, "N50A", ()=>$72ba03e317f3d228$export$7d3359664e8bb0e5);
$parcel$export($72ba03e317f3d228$exports, "N60A", ()=>$72ba03e317f3d228$export$d2d3bedfb276cac0);
$parcel$export($72ba03e317f3d228$exports, "N70A", ()=>$72ba03e317f3d228$export$6e5e7499ff054f6d);
$parcel$export($72ba03e317f3d228$exports, "N80A", ()=>$72ba03e317f3d228$export$59264b346c877fa7);
$parcel$export($72ba03e317f3d228$exports, "N90A", ()=>$72ba03e317f3d228$export$d092757d7c64925c);
$parcel$export($72ba03e317f3d228$exports, "N100A", ()=>$72ba03e317f3d228$export$486ab785e4bac3c6);
$parcel$export($72ba03e317f3d228$exports, "N200A", ()=>$72ba03e317f3d228$export$fba592bbc6419fea);
$parcel$export($72ba03e317f3d228$exports, "N300A", ()=>$72ba03e317f3d228$export$13609db0e6812ab8);
$parcel$export($72ba03e317f3d228$exports, "N400A", ()=>$72ba03e317f3d228$export$fbae4efaa892d883);
$parcel$export($72ba03e317f3d228$exports, "N500A", ()=>$72ba03e317f3d228$export$f13946d26f440ce6);
$parcel$export($72ba03e317f3d228$exports, "N600A", ()=>$72ba03e317f3d228$export$19f58225ac52a306);
$parcel$export($72ba03e317f3d228$exports, "N700A", ()=>$72ba03e317f3d228$export$6384f09da70e7b62);
$parcel$export($72ba03e317f3d228$exports, "N800A", ()=>$72ba03e317f3d228$export$d0dccc730683edc2);
$parcel$export($72ba03e317f3d228$exports, "DN900", ()=>$72ba03e317f3d228$export$2f6319cf7d736c2a);
$parcel$export($72ba03e317f3d228$exports, "DN800", ()=>$72ba03e317f3d228$export$95126bc8884d6634);
$parcel$export($72ba03e317f3d228$exports, "DN700", ()=>$72ba03e317f3d228$export$8338d8c35d44ff1);
$parcel$export($72ba03e317f3d228$exports, "DN600", ()=>$72ba03e317f3d228$export$5368d76ae4fbbda7);
$parcel$export($72ba03e317f3d228$exports, "DN500", ()=>$72ba03e317f3d228$export$9f0a771d16ec8d36);
$parcel$export($72ba03e317f3d228$exports, "DN400", ()=>$72ba03e317f3d228$export$abcf8c38338b4aa5);
$parcel$export($72ba03e317f3d228$exports, "DN300", ()=>$72ba03e317f3d228$export$97e81faa16a182c7);
$parcel$export($72ba03e317f3d228$exports, "DN200", ()=>$72ba03e317f3d228$export$bfe21c59123ecf33);
$parcel$export($72ba03e317f3d228$exports, "DN100", ()=>$72ba03e317f3d228$export$ee82aa2ea6a1558);
$parcel$export($72ba03e317f3d228$exports, "DN90", ()=>$72ba03e317f3d228$export$682927c6ed76be02);
$parcel$export($72ba03e317f3d228$exports, "DN80", ()=>$72ba03e317f3d228$export$91fd9994c5be9757);
$parcel$export($72ba03e317f3d228$exports, "DN70", ()=>$72ba03e317f3d228$export$d281fbfe3cff2df6);
$parcel$export($72ba03e317f3d228$exports, "DN60", ()=>$72ba03e317f3d228$export$3902c91d8b98a753);
$parcel$export($72ba03e317f3d228$exports, "DN50", ()=>$72ba03e317f3d228$export$8e8133c1ba5845b5);
$parcel$export($72ba03e317f3d228$exports, "DN40", ()=>$72ba03e317f3d228$export$33ff357f6620b39);
$parcel$export($72ba03e317f3d228$exports, "DN30", ()=>$72ba03e317f3d228$export$633847cf062b69e0);
$parcel$export($72ba03e317f3d228$exports, "DN20", ()=>$72ba03e317f3d228$export$9776a6e503bdbf76);
$parcel$export($72ba03e317f3d228$exports, "DN10", ()=>$72ba03e317f3d228$export$6c813d5160dff5db);
$parcel$export($72ba03e317f3d228$exports, "DN0", ()=>$72ba03e317f3d228$export$3d4f271a500072a);
$parcel$export($72ba03e317f3d228$exports, "DN800A", ()=>$72ba03e317f3d228$export$fe151285c22759ec);
$parcel$export($72ba03e317f3d228$exports, "DN700A", ()=>$72ba03e317f3d228$export$a101c6190d0da34);
$parcel$export($72ba03e317f3d228$exports, "DN600A", ()=>$72ba03e317f3d228$export$4b16f52932fda51);
$parcel$export($72ba03e317f3d228$exports, "DN500A", ()=>$72ba03e317f3d228$export$a74bcd7b9845b0d8);
$parcel$export($72ba03e317f3d228$exports, "DN400A", ()=>$72ba03e317f3d228$export$9209c179316d1751);
$parcel$export($72ba03e317f3d228$exports, "DN300A", ()=>$72ba03e317f3d228$export$88f55133f636c8dd);
$parcel$export($72ba03e317f3d228$exports, "DN200A", ()=>$72ba03e317f3d228$export$51126f85d1009512);
$parcel$export($72ba03e317f3d228$exports, "DN100A", ()=>$72ba03e317f3d228$export$a069b547bd23af78);
$parcel$export($72ba03e317f3d228$exports, "DN90A", ()=>$72ba03e317f3d228$export$40cce05af3b2600a);
$parcel$export($72ba03e317f3d228$exports, "DN80A", ()=>$72ba03e317f3d228$export$b78942185925a0d);
$parcel$export($72ba03e317f3d228$exports, "DN70A", ()=>$72ba03e317f3d228$export$e058fb44b8eaafca);
$parcel$export($72ba03e317f3d228$exports, "DN60A", ()=>$72ba03e317f3d228$export$92b0b8de26920c18);
$parcel$export($72ba03e317f3d228$exports, "DN50A", ()=>$72ba03e317f3d228$export$67564f7459d3fc9e);
$parcel$export($72ba03e317f3d228$exports, "DN40A", ()=>$72ba03e317f3d228$export$77868e1ca884ffa3);
$parcel$export($72ba03e317f3d228$exports, "DN30A", ()=>$72ba03e317f3d228$export$2afd71d7d3ea2cd5);
$parcel$export($72ba03e317f3d228$exports, "DN20A", ()=>$72ba03e317f3d228$export$f2a0acaab9972c70);
$parcel$export($72ba03e317f3d228$exports, "DN10A", ()=>$72ba03e317f3d228$export$9ab70e67d6475361);
$parcel$export($72ba03e317f3d228$exports, "T30", ()=>$72ba03e317f3d228$export$d2adc5dedf09fced);
$parcel$export($72ba03e317f3d228$exports, "L50", ()=>$72ba03e317f3d228$export$f51762073d2bb381);
$parcel$export($72ba03e317f3d228$exports, "L75", ()=>$72ba03e317f3d228$export$95e26d54def96891);
const $72ba03e317f3d228$export$4b84fd0e2c617bd = '#FFEBE6';
const $72ba03e317f3d228$export$b34b069eff244586 = '#FFBDAD';
const $72ba03e317f3d228$export$be802dd0d8b57f35 = '#FF8F73';
const $72ba03e317f3d228$export$60847d42f9da92a6 = '#FF7452';
const $72ba03e317f3d228$export$4a7404f376229999 = '#FF5630';
const $72ba03e317f3d228$export$2010d0fb4295b346 = '#DE350B';
const $72ba03e317f3d228$export$2837b5a1a71d5c02 = '#BF2600';
const $72ba03e317f3d228$export$8d9596b529bbb9cf = '#FFFAE6';
const $72ba03e317f3d228$export$41060a744ab0b7ae = '#FFF0B3';
const $72ba03e317f3d228$export$1cc05bbbf340e559 = '#FFE380';
const $72ba03e317f3d228$export$5aae31392d72caaa = '#FFC400';
const $72ba03e317f3d228$export$c6930421db9fa514 = '#FFAB00';
const $72ba03e317f3d228$export$59619663aa6500fb = '#FF991F';
const $72ba03e317f3d228$export$874739ea9e379ab6 = '#FF8B00';
const $72ba03e317f3d228$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $72ba03e317f3d228$export$69a3bf21b9686c2b = '#ABF5D1';
const $72ba03e317f3d228$export$afbce1382ec95f73 = '#79F2C0';
const $72ba03e317f3d228$export$747d86715d4175de = '#57D9A3';
const $72ba03e317f3d228$export$940e1f69e873f202 = '#36B37E';
const $72ba03e317f3d228$export$a49394138f7b8e85 = '#00875A';
const $72ba03e317f3d228$export$6fa04827ac68a4fb = '#006644';
const $72ba03e317f3d228$export$226de0355ed012f8 = '#DEEBFF';
const $72ba03e317f3d228$export$8c13c2ee36917869 = '#B3D4FF';
const $72ba03e317f3d228$export$ecfc1dff386a3e7a = '#4C9AFF';
const $72ba03e317f3d228$export$215b7063051591f1 = '#2684FF';
const $72ba03e317f3d228$export$e62e8919cca44969 = '#0065FF';
const $72ba03e317f3d228$export$b3de0ae08da2ce64 = '#0052CC';
const $72ba03e317f3d228$export$a6ee3d71bc067634 = '#0747A6';
const $72ba03e317f3d228$export$67f15409e87642a1 = '#669DF1';
const $72ba03e317f3d228$export$f0539dbc42dbb067 = '#8FB8F6';
const $72ba03e317f3d228$export$363e4475840015bb = '#EAE6FF';
const $72ba03e317f3d228$export$4b0a4417ed59760f = '#C0B6F2';
const $72ba03e317f3d228$export$6011520a64d9a187 = '#998DD9';
const $72ba03e317f3d228$export$a7175d4e9206bc80 = '#8777D9';
const $72ba03e317f3d228$export$b48405b95304b5a1 = '#6554C0';
const $72ba03e317f3d228$export$c71e4279dd54a18d = '#5243AA';
const $72ba03e317f3d228$export$147899de772240ec = '#403294';
const $72ba03e317f3d228$export$2cf711fe14c66f06 = '#E6FCFF';
const $72ba03e317f3d228$export$7a8f4d33f6f9772c = '#B3F5FF';
const $72ba03e317f3d228$export$776c9c497ef08533 = '#79E2F2';
const $72ba03e317f3d228$export$69cb3ca10c1e330e = '#00C7E6';
const $72ba03e317f3d228$export$9dc1ef0f3f48059b = '#00B8D9';
const $72ba03e317f3d228$export$7c835c78b6fcdef8 = '#00A3BF';
const $72ba03e317f3d228$export$6036577f95c3877e = '#008DA6';
const $72ba03e317f3d228$export$29a4f05edc054374 = '#FFFFFF';
const $72ba03e317f3d228$export$e655ef011c4aa1a2 = '#FAFBFC';
const $72ba03e317f3d228$export$9fdfb749e33cdf97 = '#F4F5F7';
const $72ba03e317f3d228$export$3e51e8f1440314ba = '#EBECF0';
const $72ba03e317f3d228$export$1ce2d1575d444ceb = '#DFE1E6';
const $72ba03e317f3d228$export$8754fc7e6d8b3000 = '#C1C7D0';
const $72ba03e317f3d228$export$c2e91cbeada39b8b = '#B3BAC5';
const $72ba03e317f3d228$export$5f71e19f3a7ad9de = '#A5ADBA';
const $72ba03e317f3d228$export$eaa8c8a70ac22806 = '#97A0AF';
const $72ba03e317f3d228$export$7c87d337fb91a97d = '#8993A4';
const $72ba03e317f3d228$export$d6447c357493214f = '#7A869A';
const $72ba03e317f3d228$export$f563ee71e9ee74cd = '#6B778C';
const $72ba03e317f3d228$export$e2ef2124cf4024b1 = '#5E6C84';
const $72ba03e317f3d228$export$eece5f492e429f08 = '#505F79';
const $72ba03e317f3d228$export$c39c0fe0f26207ae = '#42526E';
const $72ba03e317f3d228$export$7090862dc3038a9f = '#344563';
const $72ba03e317f3d228$export$ad0bacf983b7ddaa = '#253858';
const $72ba03e317f3d228$export$7d61b15e0da132af = '#172B4D';
const $72ba03e317f3d228$export$fbda843f0a27fe96 = '#091E42';
const $72ba03e317f3d228$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $72ba03e317f3d228$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $72ba03e317f3d228$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $72ba03e317f3d228$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $72ba03e317f3d228$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $72ba03e317f3d228$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $72ba03e317f3d228$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $72ba03e317f3d228$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $72ba03e317f3d228$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $72ba03e317f3d228$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $72ba03e317f3d228$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $72ba03e317f3d228$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $72ba03e317f3d228$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $72ba03e317f3d228$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $72ba03e317f3d228$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $72ba03e317f3d228$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $72ba03e317f3d228$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $72ba03e317f3d228$export$2f6319cf7d736c2a = '#E6EDFA';
const $72ba03e317f3d228$export$95126bc8884d6634 = '#DCE5F5';
const $72ba03e317f3d228$export$8338d8c35d44ff1 = '#CED9EB';
const $72ba03e317f3d228$export$5368d76ae4fbbda7 = '#B8C7E0';
const $72ba03e317f3d228$export$9f0a771d16ec8d36 = '#ABBBD6';
const $72ba03e317f3d228$export$abcf8c38338b4aa5 = '#9FB0CC';
const $72ba03e317f3d228$export$97e81faa16a182c7 = '#8C9CB8';
const $72ba03e317f3d228$export$bfe21c59123ecf33 = '#7988A3';
const $72ba03e317f3d228$export$ee82aa2ea6a1558 = '#67758F';
const $72ba03e317f3d228$export$682927c6ed76be02 = '#56637A';
const $72ba03e317f3d228$export$91fd9994c5be9757 = '#455166';
const $72ba03e317f3d228$export$d281fbfe3cff2df6 = '#3B475C';
const $72ba03e317f3d228$export$3902c91d8b98a753 = '#313D52';
const $72ba03e317f3d228$export$8e8133c1ba5845b5 = '#283447';
const $72ba03e317f3d228$export$33ff357f6620b39 = '#202B3D';
const $72ba03e317f3d228$export$633847cf062b69e0 = '#1B2638';
const $72ba03e317f3d228$export$9776a6e503bdbf76 = '#121A29';
const $72ba03e317f3d228$export$6c813d5160dff5db = '#0E1624';
const $72ba03e317f3d228$export$3d4f271a500072a = '#0D1424';
const $72ba03e317f3d228$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $72ba03e317f3d228$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $72ba03e317f3d228$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $72ba03e317f3d228$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $72ba03e317f3d228$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $72ba03e317f3d228$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $72ba03e317f3d228$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $72ba03e317f3d228$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $72ba03e317f3d228$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $72ba03e317f3d228$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $72ba03e317f3d228$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $72ba03e317f3d228$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $72ba03e317f3d228$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $72ba03e317f3d228$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $72ba03e317f3d228$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $72ba03e317f3d228$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $72ba03e317f3d228$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $72ba03e317f3d228$export$d2adc5dedf09fced = '#292A2E';
const $72ba03e317f3d228$export$f51762073d2bb381 = '#94C748';
const $72ba03e317f3d228$export$95e26d54def96891 = '#B3DF72';
parcelRegister("26Ze8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c72ef7d8b3208c33$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lXVui = parcelRequire("lXVui");
    var $bkcQi;
    var $6OGL8;
    var $ixV1I;
    var $koMvQ;
    var $7NUKB;
    var $8Q4sF;
    var $koVbs;
    var $l8ruj;
    var $lVJAU;
    var $jWlFw;
    var $3iDn2;
    var $dLD8P;
    var $kbgBa;
    var $7TJr2;
    var $95H4q;
    var $j29sr;
    var $dN9tk;
    var $6mpCV;
    var $6r8in;
    (0, parcelRequire("ixV1I")).use([
        (0, (0, parcelRequire("bkcQi")).install),
        (0, (0, parcelRequire("6OGL8")).install),
        (0, (0, parcelRequire("koMvQ")).install)
    ]);
    const $c72ef7d8b3208c33$var$CHART_OPTIONS = {
        renderer: 'svg'
    };
    const $c72ef7d8b3208c33$var$BreakdownByPriority = ({ position: position })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { data: data, loading: loading } = (0, (0, parcelRequire("95H4q")).useIssuesByPriority)();
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const { hasCreateItem: hasCreateItem, linksTarget: linksTarget, issuesLinkUrl: issuesLinkUrl } = (0, (0, parcelRequire("7TJr2")).useSummaryFeatures)();
        const { startHoverTimer: startHoverTimer, stopHoverTimer: stopHoverTimer, fireSectionAnalytics: fireSectionAnalytics } = (0, (0, parcelRequire("kbgBa")).useSectionAnalytics)(position, 'breakdownByPriority');
        const sendClickAnalytics = (0, $5uXOq.useCallback)((count)=>{
            fireSectionAnalytics('viewWithFilter', {
                count: count
            });
        }, [
            fireSectionAnalytics
        ]);
        const chartData = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("6mpCV")).buildChartData)(data, formatMessage, issuesLinkUrl), [
            issuesLinkUrl,
            data,
            formatMessage
        ]);
        const chartEvents = (0, $5uXOq.useMemo)(()=>({
                click: ({ dataIndex: dataIndex, value: value })=>{
                    if (chartData != null) {
                        if (linksTarget === '_self') push(chartData.filterUrls[dataIndex]);
                        else window.open(chartData.filterUrls[dataIndex], '_blank');
                        sendClickAnalytics(value);
                    }
                }
            }), [
            chartData,
            sendClickAnalytics,
            push,
            linksTarget
        ]);
        let content = null;
        if (!loading && chartData != null) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dN9tk")).Description), null, chartData.totalCount === 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, (0, parcelRequire("j29sr")).default).descriptionWhenEmpty), hasCreateItem && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, ' ', (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dLD8P")).default), {
            href: `${issuesLinkUrl}?inlineCreate=true`,
            onClick: ()=>fireSectionAnalytics('view', {
                    inlineCreate: true
                }),
            target: linksTarget
        }))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Q4sF")).FormattedI18nMessage), {
            message: formatMessage((0, (0, parcelRequire("j29sr")).default).description, {
                linkStart: '{linkStart}',
                linkEnd: '{linkEnd}'
            }),
            componentsMapping: {
                link: ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jWlFw")).default), {
                        href: `${issuesLinkUrl}?direction=DESC&sortBy=priority`,
                        target: linksTarget,
                        onClick: ()=>fireSectionAnalytics('view', {
                                inlineCreate: false
                            })
                    }, children)
            }
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($lXVui))), {
            echarts: (0, parcelRequire("ixV1I")),
            option: chartData.option,
            opts: $c72ef7d8b3208c33$var$CHART_OPTIONS,
            onEvents: chartEvents
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6r8in")).default), {
            points: chartData.xAxisPoints,
            onClick: sendClickAnalytics
        }));
        else content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7NUKB")).default), {
            name: "breakdown-by-priority"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dN9tk")).StyledSkeleton), {
            testId: "business-summary.ui.summary-view.breakdown-by-priority.skeleton"
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "business-summary-breakdown-by-priority"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iDn2")).default), {
            title: formatMessage((0, (0, parcelRequire("j29sr")).default).title),
            isLoading: loading,
            testId: "business-summary.ui.summary-view.breakdown-by-priority",
            onPointerEnter: startHoverTimer,
            onPointerLeave: stopHoverTimer
        }, content));
    };
    var $c72ef7d8b3208c33$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($c72ef7d8b3208c33$var$BreakdownByPriority);
});
parcelRegister("lXVui", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $3VFsf;
    var $ffdbb37eea52750b$var$react_1 = (0, (0, parcelRequire("3VFsf")).__importStar)((parcelRequire("5uXOq")));
    var $grS0X = parcelRequire("grS0X");
    var $6gLUT = parcelRequire("6gLUT");
    var $eBzeD = parcelRequire("eBzeD");
    var $lj6jE = parcelRequire("lj6jE");
    var $1pywT = parcelRequire("1pywT");
    var $ffdbb37eea52750b$var$EChartsReactCore = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(EChartsReactCore, _super);
        function EChartsReactCore(props) {
            var _this = _super.call(this, props) || this;
            _this.echarts = props.echarts;
            _this.ele = null;
            _this.isInitialResize = true;
            return _this;
        }
        EChartsReactCore.prototype.componentDidMount = function() {
            this.renderNewEcharts();
        };
        EChartsReactCore.prototype.componentDidUpdate = function(prevProps) {
            var shouldSetOption = this.props.shouldSetOption;
            if ((0, $eBzeD.isFunction)(shouldSetOption) && !shouldSetOption(prevProps, this.props)) return;
            if (!(0, $1pywT.isEqual)(prevProps.theme, this.props.theme) || !(0, $1pywT.isEqual)(prevProps.opts, this.props.opts) || !(0, $1pywT.isEqual)(prevProps.onEvents, this.props.onEvents)) {
                this.dispose();
                this.renderNewEcharts();
                return;
            }
            var pickKeys = [
                'option',
                'notMerge',
                'lazyUpdate',
                'showLoading',
                'loadingOption'
            ];
            if (!(0, $1pywT.isEqual)((0, $6gLUT.pick)(this.props, pickKeys), (0, $6gLUT.pick)(prevProps, pickKeys))) this.updateEChartsOption();
            if (!(0, $1pywT.isEqual)(prevProps.style, this.props.style) || !(0, $1pywT.isEqual)(prevProps.className, this.props.className)) this.resize();
        };
        EChartsReactCore.prototype.componentWillUnmount = function() {
            this.dispose();
        };
        EChartsReactCore.prototype.getEchartsInstance = function() {
            return this.echarts.getInstanceByDom(this.ele) || this.echarts.init(this.ele, this.props.theme, this.props.opts);
        };
        EChartsReactCore.prototype.dispose = function() {
            if (this.ele) {
                try {
                    (0, $grS0X.clear)(this.ele);
                } catch (e) {
                    console.warn(e);
                }
                this.echarts.dispose(this.ele);
            }
        };
        EChartsReactCore.prototype.renderNewEcharts = function() {
            var _this = this;
            var _a = this.props, onEvents = _a.onEvents, onChartReady = _a.onChartReady;
            var echartsInstance = this.updateEChartsOption();
            this.bindEvents(echartsInstance, onEvents || {});
            if ((0, $eBzeD.isFunction)(onChartReady)) onChartReady(echartsInstance);
            if (this.ele) (0, $grS0X.bind)(this.ele, function() {
                _this.resize();
            });
        };
        EChartsReactCore.prototype.bindEvents = function(instance, events) {
            function _bindEvent(eventName, func) {
                if ((0, $lj6jE.isString)(eventName) && (0, $eBzeD.isFunction)(func)) instance.on(eventName, function(param) {
                    func(param, instance);
                });
            }
            for(var eventName in events)if (Object.prototype.hasOwnProperty.call(events, eventName)) _bindEvent(eventName, events[eventName]);
        };
        EChartsReactCore.prototype.updateEChartsOption = function() {
            var _a = this.props, option = _a.option, _b = _a.notMerge, notMerge = _b === void 0 ? false : _b, _c = _a.lazyUpdate, lazyUpdate = _c === void 0 ? false : _c, showLoading = _a.showLoading, _d = _a.loadingOption, loadingOption = _d === void 0 ? null : _d;
            var echartInstance = this.getEchartsInstance();
            echartInstance.setOption(option, notMerge, lazyUpdate);
            if (showLoading) echartInstance.showLoading(loadingOption);
            else echartInstance.hideLoading();
            return echartInstance;
        };
        EChartsReactCore.prototype.resize = function() {
            var echartsInstance = this.getEchartsInstance();
            if (!this.isInitialResize) try {
                echartsInstance.resize();
            } catch (e) {
                console.warn(e);
            }
            this.isInitialResize = false;
        };
        EChartsReactCore.prototype.render = function() {
            var _this = this;
            var _a = this.props, style = _a.style, _b = _a.className, className = _b === void 0 ? '' : _b;
            var newStyle = (0, (0, parcelRequire("3VFsf")).__assign)({
                height: 300
            }, style);
            return $ffdbb37eea52750b$var$react_1.default.createElement("div", {
                ref: function(e) {
                    _this.ele = e;
                },
                style: newStyle,
                className: "echarts-for-react " + className
            });
        };
        return EChartsReactCore;
    }($ffdbb37eea52750b$var$react_1.PureComponent);
    module.exports.default = $ffdbb37eea52750b$var$EChartsReactCore;
});
parcelRegister("grS0X", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ver = module.exports.clear = module.exports.bind = void 0;
    var $8x2zG = parcelRequire("8x2zG");
    var $bf9911179e98088f$var$bind = function bind(element, cb) {
        var sensor = (0, $8x2zG.getSensor)(element);
        sensor.bind(cb);
        return function() {
            sensor.unbind(cb);
        };
    };
    module.exports.bind = $bf9911179e98088f$var$bind;
    var $bf9911179e98088f$var$clear = function clear(element) {
        var sensor = (0, $8x2zG.getSensor)(element);
        (0, $8x2zG.removeSensor)(sensor);
    };
    module.exports.clear = $bf9911179e98088f$var$clear;
    var $bf9911179e98088f$var$ver = "1.0.1";
    module.exports.ver = $bf9911179e98088f$var$ver;
});
parcelRegister("8x2zG", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.removeSensor = module.exports.getSensor = void 0;
    var $6363670a61880ddf$var$_id = $6363670a61880ddf$var$_interopRequireDefault((parcelRequire("fiP6o")));
    var $gWzBv = parcelRequire("gWzBv");
    var $cdrHo = parcelRequire("cdrHo");
    function $6363670a61880ddf$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    var $6363670a61880ddf$var$Sensors = {};
    var $6363670a61880ddf$var$getSensor = function getSensor(element) {
        var sensorId = element.getAttribute($cdrHo.SizeSensorId);
        if (sensorId && $6363670a61880ddf$var$Sensors[sensorId]) return $6363670a61880ddf$var$Sensors[sensorId];
        var newId = (0, $6363670a61880ddf$var$_id["default"])();
        element.setAttribute($cdrHo.SizeSensorId, newId);
        var sensor = (0, $gWzBv.createSensor)(element);
        $6363670a61880ddf$var$Sensors[newId] = sensor;
        return sensor;
    };
    module.exports.getSensor = $6363670a61880ddf$var$getSensor;
    var $6363670a61880ddf$var$removeSensor = function removeSensor(sensor) {
        var sensorId = sensor.element.getAttribute($cdrHo.SizeSensorId);
        sensor.element.removeAttribute($cdrHo.SizeSensorId);
        sensor.destroy();
        if (sensorId && $6363670a61880ddf$var$Sensors[sensorId]) delete $6363670a61880ddf$var$Sensors[sensorId];
    };
    module.exports.removeSensor = $6363670a61880ddf$var$removeSensor;
});
parcelRegister("fiP6o", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports["default"] = void 0;
    var $b2402d3f57c74659$var$id = 1;
    var $b2402d3f57c74659$var$_default = function _default() {
        return "".concat($b2402d3f57c74659$var$id++);
    };
    module.exports["default"] = $b2402d3f57c74659$var$_default;
});
parcelRegister("gWzBv", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.createSensor = void 0;
    var $1oYX1 = parcelRequire("1oYX1");
    var $gxB4H = parcelRequire("gxB4H");
    var $c55dae5359197dfc$var$createSensor = typeof ResizeObserver !== 'undefined' ? $gxB4H.createSensor : $1oYX1.createSensor;
    module.exports.createSensor = $c55dae5359197dfc$var$createSensor;
});
parcelRegister("1oYX1", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.createSensor = void 0;
    var $10574fe90a26a00a$var$_debounce = $10574fe90a26a00a$var$_interopRequireDefault((parcelRequire("hwNQ2")));
    var $cdrHo = parcelRequire("cdrHo");
    function $10574fe90a26a00a$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    var $10574fe90a26a00a$var$createSensor = function createSensor(element) {
        var sensor = undefined;
        var listeners = [];
        var newSensor = function newSensor() {
            if (getComputedStyle(element).position === 'static') element.style.position = 'relative';
            var obj = document.createElement('object');
            obj.onload = function() {
                obj.contentDocument.defaultView.addEventListener('resize', resizeListener);
                resizeListener();
            };
            obj.style.display = 'block';
            obj.style.position = 'absolute';
            obj.style.top = '0';
            obj.style.left = '0';
            obj.style.height = '100%';
            obj.style.width = '100%';
            obj.style.overflow = 'hidden';
            obj.style.pointerEvents = 'none';
            obj.style.zIndex = '-1';
            obj.style.opacity = '0';
            obj.setAttribute('class', $cdrHo.SensorClassName);
            obj.setAttribute('tabindex', $cdrHo.SensorTabIndex);
            obj.type = 'text/html';
            element.appendChild(obj);
            obj.data = 'about:blank';
            return obj;
        };
        var resizeListener = (0, $10574fe90a26a00a$var$_debounce["default"])(function() {
            listeners.forEach(function(listener) {
                listener(element);
            });
        });
        var bind = function bind(cb) {
            if (!sensor) sensor = newSensor();
            if (listeners.indexOf(cb) === -1) listeners.push(cb);
        };
        var destroy = function destroy() {
            if (sensor && sensor.parentNode) {
                if (sensor.contentDocument) sensor.contentDocument.defaultView.removeEventListener('resize', resizeListener);
                sensor.parentNode.removeChild(sensor);
                sensor = undefined;
                listeners = [];
            }
        };
        var unbind = function unbind(cb) {
            var idx = listeners.indexOf(cb);
            if (idx !== -1) listeners.splice(idx, 1);
            if (listeners.length === 0 && sensor) destroy();
        };
        return {
            element: element,
            bind: bind,
            destroy: destroy,
            unbind: unbind
        };
    };
    module.exports.createSensor = $10574fe90a26a00a$var$createSensor;
});
parcelRegister("hwNQ2", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports["default"] = void 0;
    var $cc2c15b4a43e3633$var$_default = function _default(fn) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60;
        var timer = null;
        return function() {
            var _this = this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            clearTimeout(timer);
            timer = setTimeout(function() {
                fn.apply(_this, args);
            }, delay);
        };
    };
    module.exports["default"] = $cc2c15b4a43e3633$var$_default;
});
parcelRegister("cdrHo", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.SensorTabIndex = module.exports.SensorClassName = module.exports.SizeSensorId = void 0;
    var $8e4c2f559be5b9b7$var$SizeSensorId = 'size-sensor-id';
    module.exports.SizeSensorId = $8e4c2f559be5b9b7$var$SizeSensorId;
    var $8e4c2f559be5b9b7$var$SensorClassName = 'size-sensor-object';
    module.exports.SensorClassName = $8e4c2f559be5b9b7$var$SensorClassName;
    var $8e4c2f559be5b9b7$var$SensorTabIndex = '-1';
    module.exports.SensorTabIndex = $8e4c2f559be5b9b7$var$SensorTabIndex;
});
parcelRegister("gxB4H", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.createSensor = void 0;
    var $c0ac7cab0e8dcc43$var$_debounce = $c0ac7cab0e8dcc43$var$_interopRequireDefault((parcelRequire("hwNQ2")));
    function $c0ac7cab0e8dcc43$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    var $c0ac7cab0e8dcc43$var$createSensor = function createSensor(element) {
        var sensor = undefined;
        var listeners = [];
        var resizeListener = (0, $c0ac7cab0e8dcc43$var$_debounce["default"])(function() {
            listeners.forEach(function(listener) {
                listener(element);
            });
        });
        var newSensor = function newSensor() {
            var s = new ResizeObserver(resizeListener);
            s.observe(element);
            resizeListener();
            return s;
        };
        var bind = function bind(cb) {
            if (!sensor) sensor = newSensor();
            if (listeners.indexOf(cb) === -1) listeners.push(cb);
        };
        var destroy = function destroy() {
            sensor.disconnect();
            listeners = [];
            sensor = undefined;
        };
        var unbind = function unbind(cb) {
            var idx = listeners.indexOf(cb);
            if (idx !== -1) listeners.splice(idx, 1);
            if (listeners.length === 0 && sensor) destroy();
        };
        return {
            element: element,
            bind: bind,
            destroy: destroy,
            unbind: unbind
        };
    };
    module.exports.createSensor = $c0ac7cab0e8dcc43$var$createSensor;
});
parcelRegister("6gLUT", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.pick = void 0;
    function $490967eff7da5641$var$pick(obj, keys) {
        var r = {};
        keys.forEach(function(key) {
            r[key] = obj[key];
        });
        return r;
    }
    module.exports.pick = $490967eff7da5641$var$pick;
});
parcelRegister("eBzeD", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.isFunction = void 0;
    function $aa1fda532dd852be$var$isFunction(v) {
        return typeof v === 'function';
    }
    module.exports.isFunction = $aa1fda532dd852be$var$isFunction;
});
parcelRegister("lj6jE", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.isString = void 0;
    function $f83045889662a498$var$isString(v) {
        return typeof v === 'string';
    }
    module.exports.isString = $f83045889662a498$var$isString;
});
parcelRegister("1pywT", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.isEqual = void 0;
    var $3VFsf;
    var $1072e91c08f205e9$var$fast_deep_equal_1 = (0, (0, parcelRequire("3VFsf")).__importDefault)((parcelRequire("1SBaA")));
    module.exports.isEqual = $1072e91c08f205e9$var$fast_deep_equal_1.default;
});
parcelRegister("1SBaA", function(module, exports) {
    'use strict';
    module.exports = function equal(a, b) {
        if (a === b) return true;
        if (a && b && typeof a == 'object' && typeof b == 'object') {
            if (a.constructor !== b.constructor) return false;
            var length, i, keys;
            if (Array.isArray(a)) {
                length = a.length;
                if (length != b.length) return false;
                for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
                return true;
            }
            if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
            if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
            if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
            keys = Object.keys(a);
            length = keys.length;
            if (length !== Object.keys(b).length) return false;
            for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
            for(i = length; i-- !== 0;){
                var key = keys[i];
                if (!equal(a[key], b[key])) return false;
            }
            return true;
        }
        return a !== a && b !== b;
    };
});
parcelRegister("bkcQi", function(module, exports) {
    $parcel$export(module.exports, "install", ()=>$83eb863ca14abd03$export$4b3e715f166fdd78);
    var $bahqM;
    var $eL4bi;
    var $7jcIW;
    var $1b1Ai;
    var $hrdVR;
    function $83eb863ca14abd03$export$4b3e715f166fdd78(registers) {
        registers.registerChartView((0, (0, parcelRequire("hrdVR")).default));
        registers.registerSeriesModel((0, (0, parcelRequire("1b1Ai")).default));
        registers.registerLayout(registers.PRIORITY.VISUAL.LAYOUT, (0, parcelRequire("bahqM")).curry((0, (0, parcelRequire("eL4bi")).layout), 'bar'));
        registers.registerLayout(registers.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, (0, (0, parcelRequire("eL4bi")).largeLayout));
        registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, (0, parcelRequire("7jcIW")).default)('bar'));
        registers.registerAction({
            type: 'changeAxisOrder',
            event: 'changeAxisOrder',
            update: 'update'
        }, function(payload, ecModel) {
            var componentType = payload.componentType || 'series';
            ecModel.eachComponent({
                mainType: componentType,
                query: payload
            }, function(componentModel) {
                if (payload.sortInfo) componentModel.axis.setCategorySortInfo(payload.sortInfo);
            });
        });
    }
});
parcelRegister("bahqM", function(module, exports) {
    $parcel$export(module.exports, "$override", ()=>$820e264882d7264f$export$d35a04b83ea6803e);
    $parcel$export(module.exports, "guid", ()=>$820e264882d7264f$export$46e8f25c7328f77e);
    $parcel$export(module.exports, "logError", ()=>$820e264882d7264f$export$58da9968c3170cb1);
    $parcel$export(module.exports, "clone", ()=>$820e264882d7264f$export$9cd59f9826255e47);
    $parcel$export(module.exports, "isPrimitive", ()=>$820e264882d7264f$export$c3825b437cbdea5c);
    $parcel$export(module.exports, "isDom", ()=>$820e264882d7264f$export$9f57505b7bd8dae);
    $parcel$export(module.exports, "merge", ()=>$820e264882d7264f$export$4950aa0f605343fb);
    $parcel$export(module.exports, "isObject", ()=>$820e264882d7264f$export$a6cdc56e425d0d0a);
    $parcel$export(module.exports, "isArray", ()=>$820e264882d7264f$export$43bee75e5e14138e);
    $parcel$export(module.exports, "isBuiltInObject", ()=>$820e264882d7264f$export$fa523b2c4941fd4f);
    $parcel$export(module.exports, "mergeAll", ()=>$820e264882d7264f$export$18aef43295bbe906);
    $parcel$export(module.exports, "extend", ()=>$820e264882d7264f$export$8b58be045bf06082);
    $parcel$export(module.exports, "defaults", ()=>$820e264882d7264f$export$ebe90cb607ad99e);
    $parcel$export(module.exports, "keys", ()=>$820e264882d7264f$export$ed97f33186d4b816);
    $parcel$export(module.exports, "createCanvas", ()=>$820e264882d7264f$export$cd3d1f114b139967);
    $parcel$export(module.exports, "indexOf", ()=>$820e264882d7264f$export$305f7d4e9d4624f2);
    $parcel$export(module.exports, "inherits", ()=>$820e264882d7264f$export$69f1b2dcda23c5f8);
    $parcel$export(module.exports, "mixin", ()=>$820e264882d7264f$export$e36fc9d62a853069);
    $parcel$export(module.exports, "isArrayLike", ()=>$820e264882d7264f$export$1e2f57719e155213);
    $parcel$export(module.exports, "each", ()=>$820e264882d7264f$export$79b2f7037acddd43);
    $parcel$export(module.exports, "map", ()=>$820e264882d7264f$export$871de8747c9eaa88);
    $parcel$export(module.exports, "slice", ()=>$820e264882d7264f$export$58adb3bec8346d0f);
    $parcel$export(module.exports, "reduce", ()=>$820e264882d7264f$export$533b26079ad0b4b);
    $parcel$export(module.exports, "filter", ()=>$820e264882d7264f$export$3dea766d36a8935f);
    $parcel$export(module.exports, "find", ()=>$820e264882d7264f$export$71aa6c912b956294);
    $parcel$export(module.exports, "bind", ()=>$820e264882d7264f$export$2385a24977818dd0);
    $parcel$export(module.exports, "isFunction", ()=>$820e264882d7264f$export$f6e2535fb5126e54);
    $parcel$export(module.exports, "curry", ()=>$820e264882d7264f$export$c3095a23b368d1f2);
    $parcel$export(module.exports, "isString", ()=>$820e264882d7264f$export$844ec244b1367d54);
    $parcel$export(module.exports, "isStringSafe", ()=>$820e264882d7264f$export$29d0bb2a4e07b252);
    $parcel$export(module.exports, "isNumber", ()=>$820e264882d7264f$export$7e4aa119212bc614);
    $parcel$export(module.exports, "isTypedArray", ()=>$820e264882d7264f$export$b119cc7e1840e59c);
    $parcel$export(module.exports, "isGradientObject", ()=>$820e264882d7264f$export$fa2c283003ed971c);
    $parcel$export(module.exports, "isImagePatternObject", ()=>$820e264882d7264f$export$a49bbf3a55dcef7b);
    $parcel$export(module.exports, "isRegExp", ()=>$820e264882d7264f$export$49841c62b9eff15);
    $parcel$export(module.exports, "eqNaN", ()=>$820e264882d7264f$export$7d667b9a0c48c975);
    $parcel$export(module.exports, "retrieve", ()=>$820e264882d7264f$export$8a4d17b6e8486e66);
    $parcel$export(module.exports, "retrieve2", ()=>$820e264882d7264f$export$995e01f2f5c9d030);
    $parcel$export(module.exports, "retrieve3", ()=>$820e264882d7264f$export$2e94551289abb95b);
    $parcel$export(module.exports, "normalizeCssArray", ()=>$820e264882d7264f$export$f3a38102c49f4268);
    $parcel$export(module.exports, "assert", ()=>$820e264882d7264f$export$a7a9523472993e97);
    $parcel$export(module.exports, "trim", ()=>$820e264882d7264f$export$87c2784dc9fc4ab);
    $parcel$export(module.exports, "setAsPrimitive", ()=>$820e264882d7264f$export$112e66431016387b);
    $parcel$export(module.exports, "HashMap", ()=>$820e264882d7264f$export$60ef0b43d585640a);
    $parcel$export(module.exports, "createHashMap", ()=>$820e264882d7264f$export$55f8aa7ef875b0a4);
    $parcel$export(module.exports, "concatArray", ()=>$820e264882d7264f$export$4fd8af2c48c43416);
    $parcel$export(module.exports, "createObject", ()=>$820e264882d7264f$export$79c7e160a7743efd);
    $parcel$export(module.exports, "hasOwn", ()=>$820e264882d7264f$export$b5a638e9b3fff9f3);
    $parcel$export(module.exports, "noop", ()=>$820e264882d7264f$export$8793edee2d425525);
    var $820e264882d7264f$var$BUILTIN_OBJECT = {
        '[object Function]': true,
        '[object RegExp]': true,
        '[object Date]': true,
        '[object Error]': true,
        '[object CanvasGradient]': true,
        '[object CanvasPattern]': true,
        '[object Image]': true,
        '[object Canvas]': true
    };
    var $820e264882d7264f$var$TYPED_ARRAY = {
        '[object Int8Array]': true,
        '[object Uint8Array]': true,
        '[object Uint8ClampedArray]': true,
        '[object Int16Array]': true,
        '[object Uint16Array]': true,
        '[object Int32Array]': true,
        '[object Uint32Array]': true,
        '[object Float32Array]': true,
        '[object Float64Array]': true
    };
    var $820e264882d7264f$var$objToString = Object.prototype.toString;
    var $820e264882d7264f$var$arrayProto = Array.prototype;
    var $820e264882d7264f$var$nativeForEach = $820e264882d7264f$var$arrayProto.forEach;
    var $820e264882d7264f$var$nativeFilter = $820e264882d7264f$var$arrayProto.filter;
    var $820e264882d7264f$var$nativeSlice = $820e264882d7264f$var$arrayProto.slice;
    var $820e264882d7264f$var$nativeMap = $820e264882d7264f$var$arrayProto.map;
    var $820e264882d7264f$var$ctorFunction = (function() {}).constructor;
    var $820e264882d7264f$var$protoFunction = $820e264882d7264f$var$ctorFunction ? $820e264882d7264f$var$ctorFunction.prototype : null;
    var $820e264882d7264f$var$protoKey = '__proto__';
    var $820e264882d7264f$var$methods = {};
    function $820e264882d7264f$export$d35a04b83ea6803e(name, fn) {
        $820e264882d7264f$var$methods[name] = fn;
    }
    var $820e264882d7264f$var$idStart = 0x0907;
    function $820e264882d7264f$export$46e8f25c7328f77e() {
        return $820e264882d7264f$var$idStart++;
    }
    function $820e264882d7264f$export$58da9968c3170cb1() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (typeof console !== 'undefined') console.error.apply(console, args);
    }
    function $820e264882d7264f$export$9cd59f9826255e47(source) {
        if (source == null || typeof source !== 'object') return source;
        var result = source;
        var typeStr = $820e264882d7264f$var$objToString.call(source);
        if (typeStr === '[object Array]') {
            if (!$820e264882d7264f$export$c3825b437cbdea5c(source)) {
                result = [];
                for(var i = 0, len = source.length; i < len; i++)result[i] = $820e264882d7264f$export$9cd59f9826255e47(source[i]);
            }
        } else if ($820e264882d7264f$var$TYPED_ARRAY[typeStr]) {
            if (!$820e264882d7264f$export$c3825b437cbdea5c(source)) {
                var Ctor = source.constructor;
                if (Ctor.from) result = Ctor.from(source);
                else {
                    result = new Ctor(source.length);
                    for(var i = 0, len = source.length; i < len; i++)result[i] = $820e264882d7264f$export$9cd59f9826255e47(source[i]);
                }
            }
        } else if (!$820e264882d7264f$var$BUILTIN_OBJECT[typeStr] && !$820e264882d7264f$export$c3825b437cbdea5c(source) && !$820e264882d7264f$export$9f57505b7bd8dae(source)) {
            result = {};
            for(var key in source)if (source.hasOwnProperty(key) && key !== $820e264882d7264f$var$protoKey) result[key] = $820e264882d7264f$export$9cd59f9826255e47(source[key]);
        }
        return result;
    }
    function $820e264882d7264f$export$4950aa0f605343fb(target, source, overwrite) {
        if (!$820e264882d7264f$export$a6cdc56e425d0d0a(source) || !$820e264882d7264f$export$a6cdc56e425d0d0a(target)) return overwrite ? $820e264882d7264f$export$9cd59f9826255e47(source) : target;
        for(var key in source)if (source.hasOwnProperty(key) && key !== $820e264882d7264f$var$protoKey) {
            var targetProp = target[key];
            var sourceProp = source[key];
            if ($820e264882d7264f$export$a6cdc56e425d0d0a(sourceProp) && $820e264882d7264f$export$a6cdc56e425d0d0a(targetProp) && !$820e264882d7264f$export$43bee75e5e14138e(sourceProp) && !$820e264882d7264f$export$43bee75e5e14138e(targetProp) && !$820e264882d7264f$export$9f57505b7bd8dae(sourceProp) && !$820e264882d7264f$export$9f57505b7bd8dae(targetProp) && !$820e264882d7264f$export$fa523b2c4941fd4f(sourceProp) && !$820e264882d7264f$export$fa523b2c4941fd4f(targetProp) && !$820e264882d7264f$export$c3825b437cbdea5c(sourceProp) && !$820e264882d7264f$export$c3825b437cbdea5c(targetProp)) $820e264882d7264f$export$4950aa0f605343fb(targetProp, sourceProp, overwrite);
            else if (overwrite || !(key in target)) target[key] = $820e264882d7264f$export$9cd59f9826255e47(source[key]);
        }
        return target;
    }
    function $820e264882d7264f$export$18aef43295bbe906(targetAndSources, overwrite) {
        var result = targetAndSources[0];
        for(var i = 1, len = targetAndSources.length; i < len; i++)result = $820e264882d7264f$export$4950aa0f605343fb(result, targetAndSources[i], overwrite);
        return result;
    }
    function $820e264882d7264f$export$8b58be045bf06082(target, source) {
        if (Object.assign) Object.assign(target, source);
        else {
            for(var key in source)if (source.hasOwnProperty(key) && key !== $820e264882d7264f$var$protoKey) target[key] = source[key];
        }
        return target;
    }
    function $820e264882d7264f$export$ebe90cb607ad99e(target, source, overlay) {
        var keysArr = $820e264882d7264f$export$ed97f33186d4b816(source);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            if (overlay ? source[key] != null : target[key] == null) target[key] = source[key];
        }
        return target;
    }
    var $820e264882d7264f$export$cd3d1f114b139967 = function() {
        return $820e264882d7264f$var$methods.createCanvas();
    };
    $820e264882d7264f$var$methods.createCanvas = function() {
        return document.createElement('canvas');
    };
    function $820e264882d7264f$export$305f7d4e9d4624f2(array, value) {
        if (array) {
            if (array.indexOf) return array.indexOf(value);
            for(var i = 0, len = array.length; i < len; i++){
                if (array[i] === value) return i;
            }
        }
        return -1;
    }
    function $820e264882d7264f$export$69f1b2dcda23c5f8(clazz, baseClazz) {
        var clazzPrototype = clazz.prototype;
        function F() {}
        F.prototype = baseClazz.prototype;
        clazz.prototype = new F();
        for(var prop in clazzPrototype)if (clazzPrototype.hasOwnProperty(prop)) clazz.prototype[prop] = clazzPrototype[prop];
        clazz.prototype.constructor = clazz;
        clazz.superClass = baseClazz;
    }
    function $820e264882d7264f$export$e36fc9d62a853069(target, source, override) {
        target = 'prototype' in target ? target.prototype : target;
        source = 'prototype' in source ? source.prototype : source;
        if (Object.getOwnPropertyNames) {
            var keyList = Object.getOwnPropertyNames(source);
            for(var i = 0; i < keyList.length; i++){
                var key = keyList[i];
                if (key !== 'constructor') {
                    if (override ? source[key] != null : target[key] == null) target[key] = source[key];
                }
            }
        } else $820e264882d7264f$export$ebe90cb607ad99e(target, source, override);
    }
    function $820e264882d7264f$export$1e2f57719e155213(data) {
        if (!data) return false;
        if (typeof data === 'string') return false;
        return typeof data.length === 'number';
    }
    function $820e264882d7264f$export$79b2f7037acddd43(arr, cb, context) {
        if (!(arr && cb)) return;
        if (arr.forEach && arr.forEach === $820e264882d7264f$var$nativeForEach) arr.forEach(cb, context);
        else if (arr.length === +arr.length) for(var i = 0, len = arr.length; i < len; i++)cb.call(context, arr[i], i, arr);
        else {
            for(var key in arr)if (arr.hasOwnProperty(key)) cb.call(context, arr[key], key, arr);
        }
    }
    function $820e264882d7264f$export$871de8747c9eaa88(arr, cb, context) {
        if (!arr) return [];
        if (!cb) return $820e264882d7264f$export$58adb3bec8346d0f(arr);
        if (arr.map && arr.map === $820e264882d7264f$var$nativeMap) return arr.map(cb, context);
        else {
            var result = [];
            for(var i = 0, len = arr.length; i < len; i++)result.push(cb.call(context, arr[i], i, arr));
            return result;
        }
    }
    function $820e264882d7264f$export$533b26079ad0b4b(arr, cb, memo, context) {
        if (!(arr && cb)) return;
        for(var i = 0, len = arr.length; i < len; i++)memo = cb.call(context, memo, arr[i], i, arr);
        return memo;
    }
    function $820e264882d7264f$export$3dea766d36a8935f(arr, cb, context) {
        if (!arr) return [];
        if (!cb) return $820e264882d7264f$export$58adb3bec8346d0f(arr);
        if (arr.filter && arr.filter === $820e264882d7264f$var$nativeFilter) return arr.filter(cb, context);
        else {
            var result = [];
            for(var i = 0, len = arr.length; i < len; i++)if (cb.call(context, arr[i], i, arr)) result.push(arr[i]);
            return result;
        }
    }
    function $820e264882d7264f$export$71aa6c912b956294(arr, cb, context) {
        if (!(arr && cb)) return;
        for(var i = 0, len = arr.length; i < len; i++){
            if (cb.call(context, arr[i], i, arr)) return arr[i];
        }
    }
    function $820e264882d7264f$export$ed97f33186d4b816(obj) {
        if (!obj) return [];
        if (Object.keys) return Object.keys(obj);
        var keyList = [];
        for(var key in obj)if (obj.hasOwnProperty(key)) keyList.push(key);
        return keyList;
    }
    function $820e264882d7264f$var$bindPolyfill(func, context) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        return function() {
            return func.apply(context, args.concat($820e264882d7264f$var$nativeSlice.call(arguments)));
        };
    }
    var $820e264882d7264f$export$2385a24977818dd0 = $820e264882d7264f$var$protoFunction && $820e264882d7264f$export$f6e2535fb5126e54($820e264882d7264f$var$protoFunction.bind) ? $820e264882d7264f$var$protoFunction.call.bind($820e264882d7264f$var$protoFunction.bind) : $820e264882d7264f$var$bindPolyfill;
    function $820e264882d7264f$export$c3095a23b368d1f2(func) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        return function() {
            return func.apply(this, args.concat($820e264882d7264f$var$nativeSlice.call(arguments)));
        };
    }
    function $820e264882d7264f$export$43bee75e5e14138e(value) {
        if (Array.isArray) return Array.isArray(value);
        return $820e264882d7264f$var$objToString.call(value) === '[object Array]';
    }
    function $820e264882d7264f$export$f6e2535fb5126e54(value) {
        return typeof value === 'function';
    }
    function $820e264882d7264f$export$844ec244b1367d54(value) {
        return typeof value === 'string';
    }
    function $820e264882d7264f$export$29d0bb2a4e07b252(value) {
        return $820e264882d7264f$var$objToString.call(value) === '[object String]';
    }
    function $820e264882d7264f$export$7e4aa119212bc614(value) {
        return typeof value === 'number';
    }
    function $820e264882d7264f$export$a6cdc56e425d0d0a(value) {
        var type = typeof value;
        return type === 'function' || !!value && type === 'object';
    }
    function $820e264882d7264f$export$fa523b2c4941fd4f(value) {
        return !!$820e264882d7264f$var$BUILTIN_OBJECT[$820e264882d7264f$var$objToString.call(value)];
    }
    function $820e264882d7264f$export$b119cc7e1840e59c(value) {
        return !!$820e264882d7264f$var$TYPED_ARRAY[$820e264882d7264f$var$objToString.call(value)];
    }
    function $820e264882d7264f$export$9f57505b7bd8dae(value) {
        return typeof value === 'object' && typeof value.nodeType === 'number' && typeof value.ownerDocument === 'object';
    }
    function $820e264882d7264f$export$fa2c283003ed971c(value) {
        return value.colorStops != null;
    }
    function $820e264882d7264f$export$a49bbf3a55dcef7b(value) {
        return value.image != null;
    }
    function $820e264882d7264f$export$49841c62b9eff15(value) {
        return $820e264882d7264f$var$objToString.call(value) === '[object RegExp]';
    }
    function $820e264882d7264f$export$7d667b9a0c48c975(value) {
        return value !== value;
    }
    function $820e264882d7264f$export$8a4d17b6e8486e66() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        for(var i = 0, len = args.length; i < len; i++){
            if (args[i] != null) return args[i];
        }
    }
    function $820e264882d7264f$export$995e01f2f5c9d030(value0, value1) {
        return value0 != null ? value0 : value1;
    }
    function $820e264882d7264f$export$2e94551289abb95b(value0, value1, value2) {
        return value0 != null ? value0 : value1 != null ? value1 : value2;
    }
    function $820e264882d7264f$export$58adb3bec8346d0f(arr) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        return $820e264882d7264f$var$nativeSlice.apply(arr, args);
    }
    function $820e264882d7264f$export$f3a38102c49f4268(val) {
        if (typeof val === 'number') return [
            val,
            val,
            val,
            val
        ];
        var len = val.length;
        if (len === 2) return [
            val[0],
            val[1],
            val[0],
            val[1]
        ];
        else if (len === 3) return [
            val[0],
            val[1],
            val[2],
            val[1]
        ];
        return val;
    }
    function $820e264882d7264f$export$a7a9523472993e97(condition, message) {
        if (!condition) throw new Error(message);
    }
    function $820e264882d7264f$export$87c2784dc9fc4ab(str) {
        if (str == null) return null;
        else if (typeof str.trim === 'function') return str.trim();
        else return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    }
    var $820e264882d7264f$var$primitiveKey = '__ec_primitive__';
    function $820e264882d7264f$export$112e66431016387b(obj) {
        obj[$820e264882d7264f$var$primitiveKey] = true;
    }
    function $820e264882d7264f$export$c3825b437cbdea5c(obj) {
        return obj[$820e264882d7264f$var$primitiveKey];
    }
    var $820e264882d7264f$export$60ef0b43d585640a = function() {
        function HashMap(obj) {
            this.data = {};
            var isArr = $820e264882d7264f$export$43bee75e5e14138e(obj);
            this.data = {};
            var thisMap = this;
            obj instanceof HashMap ? obj.each(visit) : obj && $820e264882d7264f$export$79b2f7037acddd43(obj, visit);
            function visit(value, key) {
                isArr ? thisMap.set(value, key) : thisMap.set(key, value);
            }
        }
        HashMap.prototype.get = function(key) {
            return this.data.hasOwnProperty(key) ? this.data[key] : null;
        };
        HashMap.prototype.set = function(key, value) {
            return this.data[key] = value;
        };
        HashMap.prototype.each = function(cb, context) {
            for(var key in this.data)if (this.data.hasOwnProperty(key)) cb.call(context, this.data[key], key);
        };
        HashMap.prototype.keys = function() {
            return $820e264882d7264f$export$ed97f33186d4b816(this.data);
        };
        HashMap.prototype.removeKey = function(key) {
            delete this.data[key];
        };
        return HashMap;
    }();
    function $820e264882d7264f$export$55f8aa7ef875b0a4(obj) {
        return new $820e264882d7264f$export$60ef0b43d585640a(obj);
    }
    function $820e264882d7264f$export$4fd8af2c48c43416(a, b) {
        var newArray = new a.constructor(a.length + b.length);
        for(var i = 0; i < a.length; i++)newArray[i] = a[i];
        var offset = a.length;
        for(var i = 0; i < b.length; i++)newArray[i + offset] = b[i];
        return newArray;
    }
    function $820e264882d7264f$export$79c7e160a7743efd(proto, properties) {
        var obj;
        if (Object.create) obj = Object.create(proto);
        else {
            var StyleCtor = function() {};
            StyleCtor.prototype = proto;
            obj = new StyleCtor();
        }
        if (properties) $820e264882d7264f$export$8b58be045bf06082(obj, properties);
        return obj;
    }
    function $820e264882d7264f$export$b5a638e9b3fff9f3(own, prop) {
        return own.hasOwnProperty(prop);
    }
    function $820e264882d7264f$export$8793edee2d425525() {}
});
parcelRegister("eL4bi", function(module, exports) {
    $parcel$export(module.exports, "getLayoutOnAxis", ()=>$abe8b2c5f70c8df4$export$658df087977b9e84);
    $parcel$export(module.exports, "prepareLayoutBarSeries", ()=>$abe8b2c5f70c8df4$export$efbd0c3f5ab0d5e4);
    $parcel$export(module.exports, "makeColumnLayout", ()=>$abe8b2c5f70c8df4$export$20769dafc84e0299);
    $parcel$export(module.exports, "retrieveColumnLayout", ()=>$abe8b2c5f70c8df4$export$35920bb6556da1c2);
    $parcel$export(module.exports, "layout", ()=>$abe8b2c5f70c8df4$export$b3219800bda33a1f);
    $parcel$export(module.exports, "largeLayout", ()=>$abe8b2c5f70c8df4$export$1fcd87ee6628f095);
    var $bahqM;
    var $jmSNG;
    var $5R8Hi;
    var $9irlK;
    var $abe8b2c5f70c8df4$var$STACK_PREFIX = '__ec_stack_';
    var $abe8b2c5f70c8df4$var$LARGE_BAR_MIN_WIDTH = 0.5;
    var $abe8b2c5f70c8df4$var$LargeArr = typeof Float32Array !== 'undefined' ? Float32Array : Array;
    function $abe8b2c5f70c8df4$var$getSeriesStackId(seriesModel) {
        return seriesModel.get('stack') || $abe8b2c5f70c8df4$var$STACK_PREFIX + seriesModel.seriesIndex;
    }
    function $abe8b2c5f70c8df4$var$getAxisKey(axis) {
        return axis.dim + axis.index;
    }
    function $abe8b2c5f70c8df4$export$658df087977b9e84(opt) {
        var params = [];
        var baseAxis = opt.axis;
        var axisKey = 'axis0';
        if (baseAxis.type !== 'category') return;
        var bandWidth = baseAxis.getBandWidth();
        for(var i = 0; i < opt.count || 0; i++)params.push((0, parcelRequire("bahqM")).defaults({
            bandWidth: bandWidth,
            axisKey: axisKey,
            stackId: $abe8b2c5f70c8df4$var$STACK_PREFIX + i
        }, opt));
        var widthAndOffsets = $abe8b2c5f70c8df4$var$doCalBarWidthAndOffset(params);
        var result = [];
        for(var i = 0; i < opt.count; i++){
            var item = widthAndOffsets[axisKey][$abe8b2c5f70c8df4$var$STACK_PREFIX + i];
            item.offsetCenter = item.offset + item.width / 2;
            result.push(item);
        }
        return result;
    }
    function $abe8b2c5f70c8df4$export$efbd0c3f5ab0d5e4(seriesType, ecModel) {
        var seriesModels = [];
        ecModel.eachSeriesByType(seriesType, function(seriesModel) {
            if ($abe8b2c5f70c8df4$var$isOnCartesian(seriesModel) && !$abe8b2c5f70c8df4$var$isInLargeMode(seriesModel)) seriesModels.push(seriesModel);
        });
        return seriesModels;
    }
    function $abe8b2c5f70c8df4$var$getValueAxesMinGaps(barSeries) {
        var axisValues = {};
        (0, parcelRequire("bahqM")).each(barSeries, function(seriesModel) {
            var cartesian = seriesModel.coordinateSystem;
            var baseAxis = cartesian.getBaseAxis();
            if (baseAxis.type !== 'time' && baseAxis.type !== 'value') return;
            var data = seriesModel.getData();
            var key = baseAxis.dim + '_' + baseAxis.index;
            var dimIdx = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
            var store = data.getStore();
            for(var i = 0, cnt = store.count(); i < cnt; ++i){
                var value = store.get(dimIdx, i);
                if (!axisValues[key]) axisValues[key] = [
                    value
                ];
                else axisValues[key].push(value);
            }
        });
        var axisMinGaps = {};
        for(var key in axisValues)if (axisValues.hasOwnProperty(key)) {
            var valuesInAxis = axisValues[key];
            if (valuesInAxis) {
                valuesInAxis.sort(function(a, b) {
                    return a - b;
                });
                var min = null;
                for(var j = 1; j < valuesInAxis.length; ++j){
                    var delta = valuesInAxis[j] - valuesInAxis[j - 1];
                    if (delta > 0) min = min === null ? delta : Math.min(min, delta);
                }
                axisMinGaps[key] = min;
            }
        }
        return axisMinGaps;
    }
    function $abe8b2c5f70c8df4$export$20769dafc84e0299(barSeries) {
        var axisMinGaps = $abe8b2c5f70c8df4$var$getValueAxesMinGaps(barSeries);
        var seriesInfoList = [];
        (0, parcelRequire("bahqM")).each(barSeries, function(seriesModel) {
            var cartesian = seriesModel.coordinateSystem;
            var baseAxis = cartesian.getBaseAxis();
            var axisExtent = baseAxis.getExtent();
            var bandWidth;
            if (baseAxis.type === 'category') bandWidth = baseAxis.getBandWidth();
            else if (baseAxis.type === 'value' || baseAxis.type === 'time') {
                var key = baseAxis.dim + '_' + baseAxis.index;
                var minGap = axisMinGaps[key];
                var extentSpan = Math.abs(axisExtent[1] - axisExtent[0]);
                var scale = baseAxis.scale.getExtent();
                var scaleSpan = Math.abs(scale[1] - scale[0]);
                bandWidth = minGap ? extentSpan / scaleSpan * minGap : extentSpan;
            } else {
                var data = seriesModel.getData();
                bandWidth = Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
            }
            var barWidth = (0, (0, parcelRequire("jmSNG")).parsePercent)(seriesModel.get('barWidth'), bandWidth);
            var barMaxWidth = (0, (0, parcelRequire("jmSNG")).parsePercent)(seriesModel.get('barMaxWidth'), bandWidth);
            var barMinWidth = (0, (0, parcelRequire("jmSNG")).parsePercent)(seriesModel.get('barMinWidth') || 1, bandWidth);
            var barGap = seriesModel.get('barGap');
            var barCategoryGap = seriesModel.get('barCategoryGap');
            seriesInfoList.push({
                bandWidth: bandWidth,
                barWidth: barWidth,
                barMaxWidth: barMaxWidth,
                barMinWidth: barMinWidth,
                barGap: barGap,
                barCategoryGap: barCategoryGap,
                axisKey: $abe8b2c5f70c8df4$var$getAxisKey(baseAxis),
                stackId: $abe8b2c5f70c8df4$var$getSeriesStackId(seriesModel)
            });
        });
        return $abe8b2c5f70c8df4$var$doCalBarWidthAndOffset(seriesInfoList);
    }
    function $abe8b2c5f70c8df4$var$doCalBarWidthAndOffset(seriesInfoList) {
        var columnsMap = {};
        (0, parcelRequire("bahqM")).each(seriesInfoList, function(seriesInfo, idx) {
            var axisKey = seriesInfo.axisKey;
            var bandWidth = seriesInfo.bandWidth;
            var columnsOnAxis = columnsMap[axisKey] || {
                bandWidth: bandWidth,
                remainedWidth: bandWidth,
                autoWidthCount: 0,
                categoryGap: null,
                gap: '20%',
                stacks: {}
            };
            var stacks = columnsOnAxis.stacks;
            columnsMap[axisKey] = columnsOnAxis;
            var stackId = seriesInfo.stackId;
            if (!stacks[stackId]) columnsOnAxis.autoWidthCount++;
            stacks[stackId] = stacks[stackId] || {
                width: 0,
                maxWidth: 0
            };
            var barWidth = seriesInfo.barWidth;
            if (barWidth && !stacks[stackId].width) {
                stacks[stackId].width = barWidth;
                barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
                columnsOnAxis.remainedWidth -= barWidth;
            }
            var barMaxWidth = seriesInfo.barMaxWidth;
            barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
            var barMinWidth = seriesInfo.barMinWidth;
            barMinWidth && (stacks[stackId].minWidth = barMinWidth);
            var barGap = seriesInfo.barGap;
            barGap != null && (columnsOnAxis.gap = barGap);
            var barCategoryGap = seriesInfo.barCategoryGap;
            barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
        });
        var result = {};
        (0, parcelRequire("bahqM")).each(columnsMap, function(columnsOnAxis, coordSysName) {
            result[coordSysName] = {};
            var stacks = columnsOnAxis.stacks;
            var bandWidth = columnsOnAxis.bandWidth;
            var categoryGapPercent = columnsOnAxis.categoryGap;
            if (categoryGapPercent == null) {
                var columnCount = (0, parcelRequire("bahqM")).keys(stacks).length;
                categoryGapPercent = Math.max(35 - columnCount * 4, 15) + '%';
            }
            var categoryGap = (0, (0, parcelRequire("jmSNG")).parsePercent)(categoryGapPercent, bandWidth);
            var barGapPercent = (0, (0, parcelRequire("jmSNG")).parsePercent)(columnsOnAxis.gap, 1);
            var remainedWidth = columnsOnAxis.remainedWidth;
            var autoWidthCount = columnsOnAxis.autoWidthCount;
            var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
            autoWidth = Math.max(autoWidth, 0);
            (0, parcelRequire("bahqM")).each(stacks, function(column) {
                var maxWidth = column.maxWidth;
                var minWidth = column.minWidth;
                if (!column.width) {
                    var finalWidth = autoWidth;
                    if (maxWidth && maxWidth < finalWidth) finalWidth = Math.min(maxWidth, remainedWidth);
                    if (minWidth && minWidth > finalWidth) finalWidth = minWidth;
                    if (finalWidth !== autoWidth) {
                        column.width = finalWidth;
                        remainedWidth -= finalWidth + barGapPercent * finalWidth;
                        autoWidthCount--;
                    }
                } else {
                    var finalWidth = column.width;
                    if (maxWidth) finalWidth = Math.min(finalWidth, maxWidth);
                    if (minWidth) finalWidth = Math.max(finalWidth, minWidth);
                    column.width = finalWidth;
                    remainedWidth -= finalWidth + barGapPercent * finalWidth;
                    autoWidthCount--;
                }
            });
            autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
            autoWidth = Math.max(autoWidth, 0);
            var widthSum = 0;
            var lastColumn;
            (0, parcelRequire("bahqM")).each(stacks, function(column, idx) {
                if (!column.width) column.width = autoWidth;
                lastColumn = column;
                widthSum += column.width * (1 + barGapPercent);
            });
            if (lastColumn) widthSum -= lastColumn.width * barGapPercent;
            var offset = -widthSum / 2;
            (0, parcelRequire("bahqM")).each(stacks, function(column, stackId) {
                result[coordSysName][stackId] = result[coordSysName][stackId] || {
                    bandWidth: bandWidth,
                    offset: offset,
                    width: column.width
                };
                offset += column.width * (1 + barGapPercent);
            });
        });
        return result;
    }
    function $abe8b2c5f70c8df4$export$35920bb6556da1c2(barWidthAndOffset, axis, seriesModel) {
        if (barWidthAndOffset && axis) {
            var result = barWidthAndOffset[$abe8b2c5f70c8df4$var$getAxisKey(axis)];
            if (result != null && seriesModel != null) return result[$abe8b2c5f70c8df4$var$getSeriesStackId(seriesModel)];
            return result;
        }
    }
    function $abe8b2c5f70c8df4$export$b3219800bda33a1f(seriesType, ecModel) {
        var seriesModels = $abe8b2c5f70c8df4$export$efbd0c3f5ab0d5e4(seriesType, ecModel);
        var barWidthAndOffset = $abe8b2c5f70c8df4$export$20769dafc84e0299(seriesModels);
        var lastStackCoords = {};
        (0, parcelRequire("bahqM")).each(seriesModels, function(seriesModel) {
            var data = seriesModel.getData();
            var cartesian = seriesModel.coordinateSystem;
            var baseAxis = cartesian.getBaseAxis();
            var stackId = $abe8b2c5f70c8df4$var$getSeriesStackId(seriesModel);
            var columnLayoutInfo = barWidthAndOffset[$abe8b2c5f70c8df4$var$getAxisKey(baseAxis)][stackId];
            var columnOffset = columnLayoutInfo.offset;
            var columnWidth = columnLayoutInfo.width;
            var valueAxis = cartesian.getOtherAxis(baseAxis);
            var barMinHeight = seriesModel.get('barMinHeight') || 0;
            lastStackCoords[stackId] = lastStackCoords[stackId] || [];
            data.setLayout({
                bandWidth: columnLayoutInfo.bandWidth,
                offset: columnOffset,
                size: columnWidth
            });
            var valueDim = data.mapDimension(valueAxis.dim);
            var baseDim = data.mapDimension(baseAxis.dim);
            var stacked = (0, (0, parcelRequire("5R8Hi")).isDimensionStacked)(data, valueDim);
            var isValueAxisH = valueAxis.isHorizontal();
            var valueAxisStart = $abe8b2c5f70c8df4$var$getValueAxisStart(baseAxis, valueAxis, stacked);
            var store = data.getStore();
            var valueDimIdx = data.getDimensionIndex(valueDim);
            var baseDimIdx = data.getDimensionIndex(baseDim);
            for(var idx = 0, len = store.count(); idx < len; idx++){
                var value = store.get(valueDimIdx, idx);
                var baseValue = store.get(baseDimIdx, idx);
                var sign = value >= 0 ? 'p' : 'n';
                var baseCoord = valueAxisStart;
                if (stacked) {
                    if (!lastStackCoords[stackId][baseValue]) lastStackCoords[stackId][baseValue] = {
                        p: valueAxisStart,
                        n: valueAxisStart
                    };
                    baseCoord = lastStackCoords[stackId][baseValue][sign];
                }
                var x = void 0;
                var y = void 0;
                var width = void 0;
                var height = void 0;
                if (isValueAxisH) {
                    var coord = cartesian.dataToPoint([
                        value,
                        baseValue
                    ]);
                    x = baseCoord;
                    y = coord[1] + columnOffset;
                    width = coord[0] - valueAxisStart;
                    height = columnWidth;
                    if (Math.abs(width) < barMinHeight) width = (width < 0 ? -1 : 1) * barMinHeight;
                    if (!isNaN(width)) stacked && (lastStackCoords[stackId][baseValue][sign] += width);
                } else {
                    var coord = cartesian.dataToPoint([
                        baseValue,
                        value
                    ]);
                    x = coord[0] + columnOffset;
                    y = baseCoord;
                    width = columnWidth;
                    height = coord[1] - valueAxisStart;
                    if (Math.abs(height) < barMinHeight) height = (height <= 0 ? -1 : 1) * barMinHeight;
                    if (!isNaN(height)) stacked && (lastStackCoords[stackId][baseValue][sign] += height);
                }
                data.setItemLayout(idx, {
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        });
    }
    var $abe8b2c5f70c8df4$export$1fcd87ee6628f095 = {
        seriesType: 'bar',
        plan: (0, (0, parcelRequire("9irlK")).default)(),
        reset: function(seriesModel) {
            if (!$abe8b2c5f70c8df4$var$isOnCartesian(seriesModel) || !$abe8b2c5f70c8df4$var$isInLargeMode(seriesModel)) return;
            var data = seriesModel.getData();
            var cartesian = seriesModel.coordinateSystem;
            var coordLayout = cartesian.master.getRect();
            var baseAxis = cartesian.getBaseAxis();
            var valueAxis = cartesian.getOtherAxis(baseAxis);
            var valueDimI = data.getDimensionIndex(data.mapDimension(valueAxis.dim));
            var baseDimI = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
            var valueAxisHorizontal = valueAxis.isHorizontal();
            var valueDimIdx = valueAxisHorizontal ? 0 : 1;
            var barWidth = $abe8b2c5f70c8df4$export$35920bb6556da1c2($abe8b2c5f70c8df4$export$20769dafc84e0299([
                seriesModel
            ]), baseAxis, seriesModel).width;
            if (!(barWidth > $abe8b2c5f70c8df4$var$LARGE_BAR_MIN_WIDTH)) barWidth = $abe8b2c5f70c8df4$var$LARGE_BAR_MIN_WIDTH;
            return {
                progress: function(params, data) {
                    var count = params.count;
                    var largePoints = new $abe8b2c5f70c8df4$var$LargeArr(count * 2);
                    var largeBackgroundPoints = new $abe8b2c5f70c8df4$var$LargeArr(count * 2);
                    var largeDataIndices = new $abe8b2c5f70c8df4$var$LargeArr(count);
                    var dataIndex;
                    var coord = [];
                    var valuePair = [];
                    var pointsOffset = 0;
                    var idxOffset = 0;
                    var store = data.getStore();
                    while((dataIndex = params.next()) != null){
                        valuePair[valueDimIdx] = store.get(valueDimI, dataIndex);
                        valuePair[1 - valueDimIdx] = store.get(baseDimI, dataIndex);
                        coord = cartesian.dataToPoint(valuePair, null);
                        largeBackgroundPoints[pointsOffset] = valueAxisHorizontal ? coordLayout.x + coordLayout.width : coord[0];
                        largePoints[pointsOffset++] = coord[0];
                        largeBackgroundPoints[pointsOffset] = valueAxisHorizontal ? coord[1] : coordLayout.y + coordLayout.height;
                        largePoints[pointsOffset++] = coord[1];
                        largeDataIndices[idxOffset++] = dataIndex;
                    }
                    data.setLayout({
                        largePoints: largePoints,
                        largeDataIndices: largeDataIndices,
                        largeBackgroundPoints: largeBackgroundPoints,
                        barWidth: barWidth,
                        valueAxisStart: $abe8b2c5f70c8df4$var$getValueAxisStart(baseAxis, valueAxis, false),
                        backgroundStart: valueAxisHorizontal ? coordLayout.x : coordLayout.y,
                        valueAxisHorizontal: valueAxisHorizontal
                    });
                }
            };
        }
    };
    function $abe8b2c5f70c8df4$var$isOnCartesian(seriesModel) {
        return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'cartesian2d';
    }
    function $abe8b2c5f70c8df4$var$isInLargeMode(seriesModel) {
        return seriesModel.pipelineContext && seriesModel.pipelineContext.large;
    }
    function $abe8b2c5f70c8df4$var$getValueAxisStart(baseAxis, valueAxis, stacked) {
        return valueAxis.toGlobalCoord(valueAxis.dataToCoord(valueAxis.type === 'log' ? 1 : 0));
    }
});
parcelRegister("jmSNG", function(module, exports) {
    $parcel$export(module.exports, "linearMap", ()=>$e19a9495965944b5$export$d3f68fbaa670562);
    $parcel$export(module.exports, "parsePercent", ()=>$e19a9495965944b5$export$e8514cb5a5e2b40f);
    $parcel$export(module.exports, "round", ()=>$e19a9495965944b5$export$2077e0241d6afd3c);
    $parcel$export(module.exports, "asc", ()=>$e19a9495965944b5$export$debe6e778e0a6d32);
    $parcel$export(module.exports, "getPrecision", ()=>$e19a9495965944b5$export$e0c74b50bbd10f68);
    $parcel$export(module.exports, "getPrecisionSafe", ()=>$e19a9495965944b5$export$6d86ba4ca4984d31);
    $parcel$export(module.exports, "getPixelPrecision", ()=>$e19a9495965944b5$export$666260d9a2dda8a7);
    $parcel$export(module.exports, "getPercentWithPrecision", ()=>$e19a9495965944b5$export$70cc11b075afeb90);
    $parcel$export(module.exports, "addSafe", ()=>$e19a9495965944b5$export$d3389a301c3a5706);
    $parcel$export(module.exports, "MAX_SAFE_INTEGER", ()=>$e19a9495965944b5$export$18510406f204a1b9);
    $parcel$export(module.exports, "remRadian", ()=>$e19a9495965944b5$export$2ca6dd70a288b1c3);
    $parcel$export(module.exports, "isRadianAroundZero", ()=>$e19a9495965944b5$export$d1df570aea2868f);
    $parcel$export(module.exports, "parseDate", ()=>$e19a9495965944b5$export$6b862160d295c8e);
    $parcel$export(module.exports, "quantity", ()=>$e19a9495965944b5$export$82dd68b83a44b253);
    $parcel$export(module.exports, "quantityExponent", ()=>$e19a9495965944b5$export$97256a17b20a0c24);
    $parcel$export(module.exports, "nice", ()=>$e19a9495965944b5$export$7a695fe44258210b);
    $parcel$export(module.exports, "quantile", ()=>$e19a9495965944b5$export$651fb4afdb6caa4b);
    $parcel$export(module.exports, "reformIntervals", ()=>$e19a9495965944b5$export$12f7386070bc380a);
    $parcel$export(module.exports, "numericToNumber", ()=>$e19a9495965944b5$export$8b4007b942b45a96);
    $parcel$export(module.exports, "isNumeric", ()=>$e19a9495965944b5$export$e90fb89750dba83f);
    $parcel$export(module.exports, "getRandomIdBase", ()=>$e19a9495965944b5$export$474d2ec9aa44a22);
    $parcel$export(module.exports, "getLeastCommonMultiple", ()=>$e19a9495965944b5$export$680a45b749323f49);
    var $bahqM;
    var $e19a9495965944b5$var$RADIAN_EPSILON = 1e-4;
    var $e19a9495965944b5$var$ROUND_SUPPORTED_PRECISION_MAX = 20;
    function $e19a9495965944b5$var$_trim(str) {
        return str.replace(/^\s+|\s+$/g, '');
    }
    function $e19a9495965944b5$export$d3f68fbaa670562(val, domain, range, clamp) {
        var d0 = domain[0];
        var d1 = domain[1];
        var r0 = range[0];
        var r1 = range[1];
        var subDomain = d1 - d0;
        var subRange = r1 - r0;
        if (subDomain === 0) return subRange === 0 ? r0 : (r0 + r1) / 2;
        if (clamp) {
            if (subDomain > 0) {
                if (val <= d0) return r0;
                else if (val >= d1) return r1;
            } else {
                if (val >= d0) return r0;
                else if (val <= d1) return r1;
            }
        } else {
            if (val === d0) return r0;
            if (val === d1) return r1;
        }
        return (val - d0) / subDomain * subRange + r0;
    }
    function $e19a9495965944b5$export$e8514cb5a5e2b40f(percent, all) {
        switch(percent){
            case 'center':
            case 'middle':
                percent = '50%';
                break;
            case 'left':
            case 'top':
                percent = '0%';
                break;
            case 'right':
            case 'bottom':
                percent = '100%';
                break;
        }
        if (typeof percent === 'string') {
            if ($e19a9495965944b5$var$_trim(percent).match(/%$/)) return parseFloat(percent) / 100 * all;
            return parseFloat(percent);
        }
        return percent == null ? NaN : +percent;
    }
    function $e19a9495965944b5$export$2077e0241d6afd3c(x, precision, returnStr) {
        if (precision == null) precision = 10;
        precision = Math.min(Math.max(0, precision), $e19a9495965944b5$var$ROUND_SUPPORTED_PRECISION_MAX);
        x = (+x).toFixed(precision);
        return returnStr ? x : +x;
    }
    function $e19a9495965944b5$export$debe6e778e0a6d32(arr) {
        arr.sort(function(a, b) {
            return a - b;
        });
        return arr;
    }
    function $e19a9495965944b5$export$e0c74b50bbd10f68(val) {
        val = +val;
        if (isNaN(val)) return 0;
        if (val > 1e-14) {
            var e = 1;
            for(var i = 0; i < 15; i++, e *= 10){
                if (Math.round(val * e) / e === val) return i;
            }
        }
        return $e19a9495965944b5$export$6d86ba4ca4984d31(val);
    }
    function $e19a9495965944b5$export$6d86ba4ca4984d31(val) {
        var str = val.toString().toLowerCase();
        var eIndex = str.indexOf('e');
        var exp = eIndex > 0 ? +str.slice(eIndex + 1) : 0;
        var significandPartLen = eIndex > 0 ? eIndex : str.length;
        var dotIndex = str.indexOf('.');
        var decimalPartLen = dotIndex < 0 ? 0 : significandPartLen - 1 - dotIndex;
        return Math.max(0, decimalPartLen - exp);
    }
    function $e19a9495965944b5$export$666260d9a2dda8a7(dataExtent, pixelExtent) {
        var log = Math.log;
        var LN10 = Math.LN10;
        var dataQuantity = Math.floor(log(dataExtent[1] - dataExtent[0]) / LN10);
        var sizeQuantity = Math.round(log(Math.abs(pixelExtent[1] - pixelExtent[0])) / LN10);
        var precision = Math.min(Math.max(-dataQuantity + sizeQuantity, 0), 20);
        return !isFinite(precision) ? 20 : precision;
    }
    function $e19a9495965944b5$export$70cc11b075afeb90(valueList, idx, precision) {
        if (!valueList[idx]) return 0;
        var sum = (0, parcelRequire("bahqM")).reduce(valueList, function(acc, val) {
            return acc + (isNaN(val) ? 0 : val);
        }, 0);
        if (sum === 0) return 0;
        var digits = Math.pow(10, precision);
        var votesPerQuota = (0, parcelRequire("bahqM")).map(valueList, function(val) {
            return (isNaN(val) ? 0 : val) / sum * digits * 100;
        });
        var targetSeats = digits * 100;
        var seats = (0, parcelRequire("bahqM")).map(votesPerQuota, function(votes) {
            return Math.floor(votes);
        });
        var currentSum = (0, parcelRequire("bahqM")).reduce(seats, function(acc, val) {
            return acc + val;
        }, 0);
        var remainder = (0, parcelRequire("bahqM")).map(votesPerQuota, function(votes, idx) {
            return votes - seats[idx];
        });
        while(currentSum < targetSeats){
            var max = Number.NEGATIVE_INFINITY;
            var maxId = null;
            for(var i = 0, len = remainder.length; i < len; ++i)if (remainder[i] > max) {
                max = remainder[i];
                maxId = i;
            }
            ++seats[maxId];
            remainder[maxId] = 0;
            ++currentSum;
        }
        return seats[idx] / digits;
    }
    function $e19a9495965944b5$export$d3389a301c3a5706(val0, val1) {
        var maxPrecision = Math.max($e19a9495965944b5$export$e0c74b50bbd10f68(val0), $e19a9495965944b5$export$e0c74b50bbd10f68(val1));
        var sum = val0 + val1;
        return maxPrecision > $e19a9495965944b5$var$ROUND_SUPPORTED_PRECISION_MAX ? sum : $e19a9495965944b5$export$2077e0241d6afd3c(sum, maxPrecision);
    }
    var $e19a9495965944b5$export$18510406f204a1b9 = 9007199254740991;
    function $e19a9495965944b5$export$2ca6dd70a288b1c3(radian) {
        var pi2 = Math.PI * 2;
        return (radian % pi2 + pi2) % pi2;
    }
    function $e19a9495965944b5$export$d1df570aea2868f(val) {
        return val > -$e19a9495965944b5$var$RADIAN_EPSILON && val < $e19a9495965944b5$var$RADIAN_EPSILON;
    }
    var $e19a9495965944b5$var$TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d{1,2})(?::(\d{1,2})(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/;
    function $e19a9495965944b5$export$6b862160d295c8e(value) {
        if (value instanceof Date) return value;
        else if (typeof value === 'string') {
            var match = $e19a9495965944b5$var$TIME_REG.exec(value);
            if (!match) return new Date(NaN);
            if (!match[8]) return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0);
            else {
                var hour = +match[4] || 0;
                if (match[8].toUpperCase() !== 'Z') hour -= +match[8].slice(0, 3);
                return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0));
            }
        } else if (value == null) return new Date(NaN);
        return new Date(Math.round(value));
    }
    function $e19a9495965944b5$export$82dd68b83a44b253(val) {
        return Math.pow(10, $e19a9495965944b5$export$97256a17b20a0c24(val));
    }
    function $e19a9495965944b5$export$97256a17b20a0c24(val) {
        if (val === 0) return 0;
        var exp = Math.floor(Math.log(val) / Math.LN10);
        if (val / Math.pow(10, exp) >= 10) exp++;
        return exp;
    }
    function $e19a9495965944b5$export$7a695fe44258210b(val, round) {
        var exponent = $e19a9495965944b5$export$97256a17b20a0c24(val);
        var exp10 = Math.pow(10, exponent);
        var f = val / exp10;
        var nf;
        if (round) {
            if (f < 1.5) nf = 1;
            else if (f < 2.5) nf = 2;
            else if (f < 4) nf = 3;
            else if (f < 7) nf = 5;
            else nf = 10;
        } else {
            if (f < 1) nf = 1;
            else if (f < 2) nf = 2;
            else if (f < 3) nf = 3;
            else if (f < 5) nf = 5;
            else nf = 10;
        }
        val = nf * exp10;
        return exponent >= -20 ? +val.toFixed(exponent < 0 ? -exponent : 0) : val;
    }
    function $e19a9495965944b5$export$651fb4afdb6caa4b(ascArr, p) {
        var H = (ascArr.length - 1) * p + 1;
        var h = Math.floor(H);
        var v = +ascArr[h - 1];
        var e = H - h;
        return e ? v + e * (ascArr[h] - v) : v;
    }
    function $e19a9495965944b5$export$12f7386070bc380a(list) {
        list.sort(function(a, b) {
            return littleThan(a, b, 0) ? -1 : 1;
        });
        var curr = -Infinity;
        var currClose = 1;
        for(var i = 0; i < list.length;){
            var interval = list[i].interval;
            var close_1 = list[i].close;
            for(var lg = 0; lg < 2; lg++){
                if (interval[lg] <= curr) {
                    interval[lg] = curr;
                    close_1[lg] = !lg ? 1 - currClose : 1;
                }
                curr = interval[lg];
                currClose = close_1[lg];
            }
            if (interval[0] === interval[1] && close_1[0] * close_1[1] !== 1) list.splice(i, 1);
            else i++;
        }
        return list;
        function littleThan(a, b, lg) {
            return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
        }
    }
    function $e19a9495965944b5$export$8b4007b942b45a96(val) {
        var valFloat = parseFloat(val);
        return valFloat == val && (valFloat !== 0 || typeof val !== 'string' || val.indexOf('x') <= 0) ? valFloat : NaN;
    }
    function $e19a9495965944b5$export$e90fb89750dba83f(val) {
        return !isNaN($e19a9495965944b5$export$8b4007b942b45a96(val));
    }
    function $e19a9495965944b5$export$474d2ec9aa44a22() {
        return Math.round(Math.random() * 9);
    }
    function $e19a9495965944b5$export$a368fd580c0d0fe4(a, b) {
        if (b === 0) return a;
        return $e19a9495965944b5$export$a368fd580c0d0fe4(b, a % b);
    }
    function $e19a9495965944b5$export$680a45b749323f49(a, b) {
        if (a == null) return b;
        if (b == null) return a;
        return a * b / $e19a9495965944b5$export$a368fd580c0d0fe4(a, b);
    }
});
parcelRegister("5R8Hi", function(module, exports) {
    $parcel$export(module.exports, "enableDataStack", ()=>$4438a61210f14409$export$f2165f9e8499b278);
    $parcel$export(module.exports, "isDimensionStacked", ()=>$4438a61210f14409$export$1dedc39359ae35c);
    $parcel$export(module.exports, "getStackedDimension", ()=>$4438a61210f14409$export$909db2be4938fbdf);
    var $bahqM;
    var $2Om11;
    function $4438a61210f14409$export$f2165f9e8499b278(seriesModel, dimensionsInput, opt) {
        opt = opt || {};
        var byIndex = opt.byIndex;
        var stackedCoordDimension = opt.stackedCoordDimension;
        var dimensionDefineList;
        var schema;
        var store;
        if ($4438a61210f14409$var$isLegacyDimensionsInput(dimensionsInput)) dimensionDefineList = dimensionsInput;
        else {
            schema = dimensionsInput.schema;
            dimensionDefineList = schema.dimensions;
            store = dimensionsInput.store;
        }
        var mayStack = !!(seriesModel && seriesModel.get('stack'));
        var stackedByDimInfo;
        var stackedDimInfo;
        var stackResultDimension;
        var stackedOverDimension;
        (0, (0, parcelRequire("bahqM")).each)(dimensionDefineList, function(dimensionInfo, index) {
            if ((0, (0, parcelRequire("bahqM")).isString)(dimensionInfo)) dimensionDefineList[index] = dimensionInfo = {
                name: dimensionInfo
            };
            if (mayStack && !dimensionInfo.isExtraCoord) {
                if (!byIndex && !stackedByDimInfo && dimensionInfo.ordinalMeta) stackedByDimInfo = dimensionInfo;
                if (!stackedDimInfo && dimensionInfo.type !== 'ordinal' && dimensionInfo.type !== 'time' && (!stackedCoordDimension || stackedCoordDimension === dimensionInfo.coordDim)) stackedDimInfo = dimensionInfo;
            }
        });
        if (stackedDimInfo && !byIndex && !stackedByDimInfo) byIndex = true;
        if (stackedDimInfo) {
            stackResultDimension = '__\0ecstackresult_' + seriesModel.id;
            stackedOverDimension = '__\0ecstackedover_' + seriesModel.id;
            if (stackedByDimInfo) stackedByDimInfo.createInvertedIndices = true;
            var stackedDimCoordDim_1 = stackedDimInfo.coordDim;
            var stackedDimType = stackedDimInfo.type;
            var stackedDimCoordIndex_1 = 0;
            (0, (0, parcelRequire("bahqM")).each)(dimensionDefineList, function(dimensionInfo) {
                if (dimensionInfo.coordDim === stackedDimCoordDim_1) stackedDimCoordIndex_1++;
            });
            var stackedOverDimensionDefine = {
                name: stackResultDimension,
                coordDim: stackedDimCoordDim_1,
                coordDimIndex: stackedDimCoordIndex_1,
                type: stackedDimType,
                isExtraCoord: true,
                isCalculationCoord: true,
                storeDimIndex: dimensionDefineList.length
            };
            var stackResultDimensionDefine = {
                name: stackedOverDimension,
                coordDim: stackedOverDimension,
                coordDimIndex: stackedDimCoordIndex_1 + 1,
                type: stackedDimType,
                isExtraCoord: true,
                isCalculationCoord: true,
                storeDimIndex: dimensionDefineList.length + 1
            };
            if (schema) {
                if (store) {
                    stackedOverDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackedOverDimension, stackedDimType);
                    stackResultDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackResultDimension, stackedDimType);
                }
                schema.appendCalculationDimension(stackedOverDimensionDefine);
                schema.appendCalculationDimension(stackResultDimensionDefine);
            } else {
                dimensionDefineList.push(stackedOverDimensionDefine);
                dimensionDefineList.push(stackResultDimensionDefine);
            }
        }
        return {
            stackedDimension: stackedDimInfo && stackedDimInfo.name,
            stackedByDimension: stackedByDimInfo && stackedByDimInfo.name,
            isStackedByIndex: byIndex,
            stackedOverDimension: stackedOverDimension,
            stackResultDimension: stackResultDimension
        };
    }
    function $4438a61210f14409$var$isLegacyDimensionsInput(dimensionsInput) {
        return !(0, (0, parcelRequire("2Om11")).isSeriesDataSchema)(dimensionsInput.schema);
    }
    function $4438a61210f14409$export$1dedc39359ae35c(data, stackedDim) {
        return !!stackedDim && stackedDim === data.getCalculationInfo('stackedDimension');
    }
    function $4438a61210f14409$export$909db2be4938fbdf(data, targetDim) {
        return $4438a61210f14409$export$1dedc39359ae35c(data, targetDim) ? data.getCalculationInfo('stackResultDimension') : targetDim;
    }
});
parcelRegister("2Om11", function(module, exports) {
    $parcel$export(module.exports, "SeriesDataSchema", ()=>$20c1541ff90227ce$export$a1ef064685775f3e);
    $parcel$export(module.exports, "ensureSourceDimNameMap", ()=>$20c1541ff90227ce$export$be39ae17310c33f7);
    $parcel$export(module.exports, "shouldOmitUnusedDimensions", ()=>$20c1541ff90227ce$export$238b87930d825d87);
    $parcel$export(module.exports, "isSeriesDataSchema", ()=>$20c1541ff90227ce$export$fafbc856132a3a0e);
    $parcel$export(module.exports, "createDimNameMap", ()=>$20c1541ff90227ce$export$a477f5bebfd07944);
    var $bahqM;
    var $eaKsF;
    var $20liu;
    var $20c1541ff90227ce$var$inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $20c1541ff90227ce$var$dimTypeShort = {
        float: 'f',
        int: 'i',
        ordinal: 'o',
        number: 'n',
        time: 't'
    };
    var $20c1541ff90227ce$export$a1ef064685775f3e = function() {
        function SeriesDataSchema(opt) {
            this.dimensions = opt.dimensions;
            this._dimOmitted = opt.dimensionOmitted;
            this.source = opt.source;
            this._fullDimCount = opt.fullDimensionCount;
            this._updateDimOmitted(opt.dimensionOmitted);
        }
        SeriesDataSchema.prototype.isDimensionOmitted = function() {
            return this._dimOmitted;
        };
        SeriesDataSchema.prototype._updateDimOmitted = function(dimensionOmitted) {
            this._dimOmitted = dimensionOmitted;
            if (!dimensionOmitted) return;
            if (!this._dimNameMap) this._dimNameMap = $20c1541ff90227ce$export$be39ae17310c33f7(this.source);
        };
        SeriesDataSchema.prototype.getSourceDimensionIndex = function(dimName) {
            return (0, (0, parcelRequire("bahqM")).retrieve2)(this._dimNameMap.get(dimName), -1);
        };
        SeriesDataSchema.prototype.getSourceDimension = function(dimIndex) {
            var dimensionsDefine = this.source.dimensionsDefine;
            if (dimensionsDefine) return dimensionsDefine[dimIndex];
        };
        SeriesDataSchema.prototype.makeStoreSchema = function() {
            var dimCount = this._fullDimCount;
            var willRetrieveDataByName = (0, (0, parcelRequire("20liu")).shouldRetrieveDataByName)(this.source);
            var makeHashStrict = !$20c1541ff90227ce$export$238b87930d825d87(dimCount);
            var dimHash = '';
            var dims = [];
            for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < dimCount; fullDimIdx++){
                var property = void 0;
                var type = void 0;
                var ordinalMeta = void 0;
                var seriesDimDef = this.dimensions[seriesDimIdx];
                if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                    property = willRetrieveDataByName ? seriesDimDef.name : null;
                    type = seriesDimDef.type;
                    ordinalMeta = seriesDimDef.ordinalMeta;
                    seriesDimIdx++;
                } else {
                    var sourceDimDef = this.getSourceDimension(fullDimIdx);
                    if (sourceDimDef) {
                        property = willRetrieveDataByName ? sourceDimDef.name : null;
                        type = sourceDimDef.type;
                    }
                }
                dims.push({
                    property: property,
                    type: type,
                    ordinalMeta: ordinalMeta
                });
                if (willRetrieveDataByName && property != null && (!seriesDimDef || !seriesDimDef.isCalculationCoord)) dimHash += makeHashStrict ? property.replace(/\`/g, '`1').replace(/\$/g, '`2') : property;
                dimHash += '$';
                dimHash += $20c1541ff90227ce$var$dimTypeShort[type] || 'f';
                if (ordinalMeta) dimHash += ordinalMeta.uid;
                dimHash += '$';
            }
            var source = this.source;
            var hash = [
                source.seriesLayoutBy,
                source.startIndex,
                dimHash
            ].join('$$');
            return {
                dimensions: dims,
                hash: hash
            };
        };
        SeriesDataSchema.prototype.makeOutputDimensionNames = function() {
            var result = [];
            for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < this._fullDimCount; fullDimIdx++){
                var name_1 = void 0;
                var seriesDimDef = this.dimensions[seriesDimIdx];
                if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                    if (!seriesDimDef.isCalculationCoord) name_1 = seriesDimDef.name;
                    seriesDimIdx++;
                } else {
                    var sourceDimDef = this.getSourceDimension(fullDimIdx);
                    if (sourceDimDef) name_1 = sourceDimDef.name;
                }
                result.push(name_1);
            }
            return result;
        };
        SeriesDataSchema.prototype.appendCalculationDimension = function(dimDef) {
            this.dimensions.push(dimDef);
            dimDef.isCalculationCoord = true;
            this._fullDimCount++;
            this._updateDimOmitted(true);
        };
        return SeriesDataSchema;
    }();
    function $20c1541ff90227ce$export$fafbc856132a3a0e(schema) {
        return schema instanceof $20c1541ff90227ce$export$a1ef064685775f3e;
    }
    function $20c1541ff90227ce$export$a477f5bebfd07944(dimsDef) {
        var dataDimNameMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        for(var i = 0; i < (dimsDef || []).length; i++){
            var dimDefItemRaw = dimsDef[i];
            var userDimName = (0, (0, parcelRequire("bahqM")).isObject)(dimDefItemRaw) ? dimDefItemRaw.name : dimDefItemRaw;
            if (userDimName != null && dataDimNameMap.get(userDimName) == null) dataDimNameMap.set(userDimName, i);
        }
        return dataDimNameMap;
    }
    function $20c1541ff90227ce$export$be39ae17310c33f7(source) {
        var innerSource = $20c1541ff90227ce$var$inner(source);
        return innerSource.dimNameMap || (innerSource.dimNameMap = $20c1541ff90227ce$export$a477f5bebfd07944(source.dimensionsDefine));
    }
    function $20c1541ff90227ce$export$238b87930d825d87(dimCount) {
        return dimCount > 30;
    }
});
parcelRegister("eaKsF", function(module, exports) {
    $parcel$export(module.exports, "normalizeToArray", ()=>$a5160a25a687d9b6$export$4f07b212a02c8051);
    $parcel$export(module.exports, "defaultEmphasis", ()=>$a5160a25a687d9b6$export$abdcc6a26372f94b);
    $parcel$export(module.exports, "TEXT_STYLE_OPTIONS", ()=>$a5160a25a687d9b6$export$df45610347a602ad);
    $parcel$export(module.exports, "getDataItemValue", ()=>$a5160a25a687d9b6$export$2c944e12edb48d4b);
    $parcel$export(module.exports, "isDataItemOption", ()=>$a5160a25a687d9b6$export$3e1a543f33ef6883);
    $parcel$export(module.exports, "mappingToExists", ()=>$a5160a25a687d9b6$export$574f818966e4da87);
    $parcel$export(module.exports, "isComponentIdInternal", ()=>$a5160a25a687d9b6$export$feece3e7d52a102b);
    $parcel$export(module.exports, "convertOptionIdName", ()=>$a5160a25a687d9b6$export$fb1a222ba5dd6e51);
    $parcel$export(module.exports, "isNameSpecified", ()=>$a5160a25a687d9b6$export$beae19a2652b3368);
    $parcel$export(module.exports, "makeInternalComponentId", ()=>$a5160a25a687d9b6$export$1753133c42e665e8);
    $parcel$export(module.exports, "setComponentTypeToKeyInfo", ()=>$a5160a25a687d9b6$export$5ac61aca2ba0282d);
    $parcel$export(module.exports, "compressBatches", ()=>$a5160a25a687d9b6$export$6d12cabb0c9bf8e3);
    $parcel$export(module.exports, "queryDataIndex", ()=>$a5160a25a687d9b6$export$42b26cae8b8d10);
    $parcel$export(module.exports, "makeInner", ()=>$a5160a25a687d9b6$export$64df9f8d92ae083f);
    $parcel$export(module.exports, "parseFinder", ()=>$a5160a25a687d9b6$export$95de80076abac814);
    $parcel$export(module.exports, "preParseFinder", ()=>$a5160a25a687d9b6$export$fe600815775d9400);
    $parcel$export(module.exports, "queryReferringComponents", ()=>$a5160a25a687d9b6$export$dc741340f7e5f186);
    $parcel$export(module.exports, "SINGLE_REFERRING", ()=>$a5160a25a687d9b6$export$f076738ec84e693c);
    $parcel$export(module.exports, "MULTIPLE_REFERRING", ()=>$a5160a25a687d9b6$export$48d598924ce4892c);
    $parcel$export(module.exports, "setAttribute", ()=>$a5160a25a687d9b6$export$9fec4d97f1922e0b);
    $parcel$export(module.exports, "getAttribute", ()=>$a5160a25a687d9b6$export$735ee1799fd02602);
    $parcel$export(module.exports, "getTooltipRenderMode", ()=>$a5160a25a687d9b6$export$cc0a17a5d27b4e17);
    $parcel$export(module.exports, "groupData", ()=>$a5160a25a687d9b6$export$7ab5bda43e13168f);
    $parcel$export(module.exports, "interpolateRawValues", ()=>$a5160a25a687d9b6$export$bd0439821a1869f3);
    var $bahqM;
    var $hZfwb;
    var $jmSNG;
    var $hb2y5;
    var $a5160a25a687d9b6$var$DUMMY_COMPONENT_NAME_PREFIX = 'series\0';
    var $a5160a25a687d9b6$var$INTERNAL_COMPONENT_ID_PREFIX = '\0_ec_\0';
    function $a5160a25a687d9b6$export$4f07b212a02c8051(value) {
        return value instanceof Array ? value : value == null ? [] : [
            value
        ];
    }
    function $a5160a25a687d9b6$export$abdcc6a26372f94b(opt, key, subOpts) {
        if (opt) {
            opt[key] = opt[key] || {};
            opt.emphasis = opt.emphasis || {};
            opt.emphasis[key] = opt.emphasis[key] || {};
            for(var i = 0, len = subOpts.length; i < len; i++){
                var subOptName = subOpts[i];
                if (!opt.emphasis[key].hasOwnProperty(subOptName) && opt[key].hasOwnProperty(subOptName)) opt.emphasis[key][subOptName] = opt[key][subOptName];
            }
        }
    }
    var $a5160a25a687d9b6$export$df45610347a602ad = [
        'fontStyle',
        'fontWeight',
        'fontSize',
        'fontFamily',
        'rich',
        'tag',
        'color',
        'textBorderColor',
        'textBorderWidth',
        'width',
        'height',
        'lineHeight',
        'align',
        'verticalAlign',
        'baseline',
        'shadowColor',
        'shadowBlur',
        'shadowOffsetX',
        'shadowOffsetY',
        'textShadowColor',
        'textShadowBlur',
        'textShadowOffsetX',
        'textShadowOffsetY',
        'backgroundColor',
        'borderColor',
        'borderWidth',
        'borderRadius',
        'padding'
    ];
    function $a5160a25a687d9b6$export$2c944e12edb48d4b(dataItem) {
        return (0, (0, parcelRequire("bahqM")).isObject)(dataItem) && !(0, (0, parcelRequire("bahqM")).isArray)(dataItem) && !(dataItem instanceof Date) ? dataItem.value : dataItem;
    }
    function $a5160a25a687d9b6$export$3e1a543f33ef6883(dataItem) {
        return (0, (0, parcelRequire("bahqM")).isObject)(dataItem) && !(dataItem instanceof Array);
    }
    function $a5160a25a687d9b6$export$574f818966e4da87(existings, newCmptOptions, mode) {
        var isNormalMergeMode = mode === 'normalMerge';
        var isReplaceMergeMode = mode === 'replaceMerge';
        var isReplaceAllMode = mode === 'replaceAll';
        existings = existings || [];
        newCmptOptions = (newCmptOptions || []).slice();
        var existingIdIdxMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        (0, (0, parcelRequire("bahqM")).each)(newCmptOptions, function(cmptOption, index) {
            if (!(0, (0, parcelRequire("bahqM")).isObject)(cmptOption)) {
                newCmptOptions[index] = null;
                return;
            }
        });
        var result = $a5160a25a687d9b6$var$prepareResult(existings, existingIdIdxMap, mode);
        if (isNormalMergeMode || isReplaceMergeMode) $a5160a25a687d9b6$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions);
        if (isNormalMergeMode) $a5160a25a687d9b6$var$mappingByName(result, newCmptOptions);
        if (isNormalMergeMode || isReplaceMergeMode) $a5160a25a687d9b6$var$mappingByIndex(result, newCmptOptions, isReplaceMergeMode);
        else if (isReplaceAllMode) $a5160a25a687d9b6$var$mappingInReplaceAllMode(result, newCmptOptions);
        $a5160a25a687d9b6$var$makeIdAndName(result);
        return result;
    }
    function $a5160a25a687d9b6$var$prepareResult(existings, existingIdIdxMap, mode) {
        var result = [];
        if (mode === 'replaceAll') return result;
        for(var index = 0; index < existings.length; index++){
            var existing = existings[index];
            if (existing && existing.id != null) existingIdIdxMap.set(existing.id, index);
            result.push({
                existing: mode === 'replaceMerge' || $a5160a25a687d9b6$export$feece3e7d52a102b(existing) ? null : existing,
                newOption: null,
                keyInfo: null,
                brandNew: null
            });
        }
        return result;
    }
    function $a5160a25a687d9b6$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions) {
        (0, (0, parcelRequire("bahqM")).each)(newCmptOptions, function(cmptOption, index) {
            if (!cmptOption || cmptOption.id == null) return;
            var optionId = $a5160a25a687d9b6$var$makeComparableKey(cmptOption.id);
            var existingIdx = existingIdIdxMap.get(optionId);
            if (existingIdx != null) {
                var resultItem = result[existingIdx];
                (0, (0, parcelRequire("bahqM")).assert)(!resultItem.newOption, 'Duplicated option on id "' + optionId + '".');
                resultItem.newOption = cmptOption;
                resultItem.existing = existings[existingIdx];
                newCmptOptions[index] = null;
            }
        });
    }
    function $a5160a25a687d9b6$var$mappingByName(result, newCmptOptions) {
        (0, (0, parcelRequire("bahqM")).each)(newCmptOptions, function(cmptOption, index) {
            if (!cmptOption || cmptOption.name == null) return;
            for(var i = 0; i < result.length; i++){
                var existing = result[i].existing;
                if (!result[i].newOption && existing && (existing.id == null || cmptOption.id == null) && !$a5160a25a687d9b6$export$feece3e7d52a102b(cmptOption) && !$a5160a25a687d9b6$export$feece3e7d52a102b(existing) && $a5160a25a687d9b6$var$keyExistAndEqual('name', existing, cmptOption)) {
                    result[i].newOption = cmptOption;
                    newCmptOptions[index] = null;
                    return;
                }
            }
        });
    }
    function $a5160a25a687d9b6$var$mappingByIndex(result, newCmptOptions, brandNew) {
        (0, (0, parcelRequire("bahqM")).each)(newCmptOptions, function(cmptOption) {
            if (!cmptOption) return;
            var resultItem;
            var nextIdx = 0;
            while((resultItem = result[nextIdx]) && (resultItem.newOption || $a5160a25a687d9b6$export$feece3e7d52a102b(resultItem.existing) || resultItem.existing && cmptOption.id != null && !$a5160a25a687d9b6$var$keyExistAndEqual('id', cmptOption, resultItem.existing)))nextIdx++;
            if (resultItem) {
                resultItem.newOption = cmptOption;
                resultItem.brandNew = brandNew;
            } else result.push({
                newOption: cmptOption,
                brandNew: brandNew,
                existing: null,
                keyInfo: null
            });
            nextIdx++;
        });
    }
    function $a5160a25a687d9b6$var$mappingInReplaceAllMode(result, newCmptOptions) {
        (0, (0, parcelRequire("bahqM")).each)(newCmptOptions, function(cmptOption) {
            result.push({
                newOption: cmptOption,
                brandNew: true,
                existing: null,
                keyInfo: null
            });
        });
    }
    function $a5160a25a687d9b6$var$makeIdAndName(mapResult) {
        var idMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        (0, (0, parcelRequire("bahqM")).each)(mapResult, function(item) {
            var existing = item.existing;
            existing && idMap.set(existing.id, item);
        });
        (0, (0, parcelRequire("bahqM")).each)(mapResult, function(item) {
            var opt = item.newOption;
            (0, (0, parcelRequire("bahqM")).assert)(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, 'id duplicates: ' + (opt && opt.id));
            opt && opt.id != null && idMap.set(opt.id, item);
            !item.keyInfo && (item.keyInfo = {});
        });
        (0, (0, parcelRequire("bahqM")).each)(mapResult, function(item, index) {
            var existing = item.existing;
            var opt = item.newOption;
            var keyInfo = item.keyInfo;
            if (!(0, (0, parcelRequire("bahqM")).isObject)(opt)) return;
            keyInfo.name = opt.name != null ? $a5160a25a687d9b6$var$makeComparableKey(opt.name) : existing ? existing.name : $a5160a25a687d9b6$var$DUMMY_COMPONENT_NAME_PREFIX + index;
            if (existing) keyInfo.id = $a5160a25a687d9b6$var$makeComparableKey(existing.id);
            else if (opt.id != null) keyInfo.id = $a5160a25a687d9b6$var$makeComparableKey(opt.id);
            else {
                var idNum = 0;
                do keyInfo.id = '\0' + keyInfo.name + '\0' + idNum++;
                while (idMap.get(keyInfo.id))
            }
            idMap.set(keyInfo.id, item);
        });
    }
    function $a5160a25a687d9b6$var$keyExistAndEqual(attr, obj1, obj2) {
        var key1 = $a5160a25a687d9b6$export$fb1a222ba5dd6e51(obj1[attr], null);
        var key2 = $a5160a25a687d9b6$export$fb1a222ba5dd6e51(obj2[attr], null);
        return key1 != null && key2 != null && key1 === key2;
    }
    function $a5160a25a687d9b6$var$makeComparableKey(val) {
        return $a5160a25a687d9b6$export$fb1a222ba5dd6e51(val, '');
    }
    function $a5160a25a687d9b6$export$fb1a222ba5dd6e51(idOrName, defaultValue) {
        if (idOrName == null) return defaultValue;
        var type = typeof idOrName;
        return type === 'string' ? idOrName : type === 'number' || (0, (0, parcelRequire("bahqM")).isStringSafe)(idOrName) ? idOrName + '' : defaultValue;
    }
    function $a5160a25a687d9b6$var$warnInvalidateIdOrName(idOrName) {}
    function $a5160a25a687d9b6$var$isValidIdOrName(idOrName) {
        return (0, (0, parcelRequire("bahqM")).isStringSafe)(idOrName) || (0, (0, parcelRequire("jmSNG")).isNumeric)(idOrName);
    }
    function $a5160a25a687d9b6$export$beae19a2652b3368(componentModel) {
        var name = componentModel.name;
        return !!(name && name.indexOf($a5160a25a687d9b6$var$DUMMY_COMPONENT_NAME_PREFIX));
    }
    function $a5160a25a687d9b6$export$feece3e7d52a102b(cmptOption) {
        return cmptOption && cmptOption.id != null && $a5160a25a687d9b6$var$makeComparableKey(cmptOption.id).indexOf($a5160a25a687d9b6$var$INTERNAL_COMPONENT_ID_PREFIX) === 0;
    }
    function $a5160a25a687d9b6$export$1753133c42e665e8(idSuffix) {
        return $a5160a25a687d9b6$var$INTERNAL_COMPONENT_ID_PREFIX + idSuffix;
    }
    function $a5160a25a687d9b6$export$5ac61aca2ba0282d(mappingResult, mainType, componentModelCtor) {
        (0, (0, parcelRequire("bahqM")).each)(mappingResult, function(item) {
            var newOption = item.newOption;
            if ((0, (0, parcelRequire("bahqM")).isObject)(newOption)) {
                item.keyInfo.mainType = mainType;
                item.keyInfo.subType = $a5160a25a687d9b6$var$determineSubType(mainType, newOption, item.existing, componentModelCtor);
            }
        });
    }
    function $a5160a25a687d9b6$var$determineSubType(mainType, newCmptOption, existComponent, componentModelCtor) {
        var subType = newCmptOption.type ? newCmptOption.type : existComponent ? existComponent.subType : componentModelCtor.determineSubType(mainType, newCmptOption);
        return subType;
    }
    function $a5160a25a687d9b6$export$6d12cabb0c9bf8e3(batchA, batchB) {
        var mapA = {};
        var mapB = {};
        makeMap(batchA || [], mapA);
        makeMap(batchB || [], mapB, mapA);
        return [
            mapToArray(mapA),
            mapToArray(mapB)
        ];
        function makeMap(sourceBatch, map, otherMap) {
            for(var i = 0, len = sourceBatch.length; i < len; i++){
                var seriesId = $a5160a25a687d9b6$export$fb1a222ba5dd6e51(sourceBatch[i].seriesId, null);
                if (seriesId == null) return;
                var dataIndices = $a5160a25a687d9b6$export$4f07b212a02c8051(sourceBatch[i].dataIndex);
                var otherDataIndices = otherMap && otherMap[seriesId];
                for(var j = 0, lenj = dataIndices.length; j < lenj; j++){
                    var dataIndex = dataIndices[j];
                    if (otherDataIndices && otherDataIndices[dataIndex]) otherDataIndices[dataIndex] = null;
                    else (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
                }
            }
        }
        function mapToArray(map, isData) {
            var result = [];
            for(var i in map)if (map.hasOwnProperty(i) && map[i] != null) {
                if (isData) result.push(+i);
                else {
                    var dataIndices = mapToArray(map[i], true);
                    dataIndices.length && result.push({
                        seriesId: i,
                        dataIndex: dataIndices
                    });
                }
            }
            return result;
        }
    }
    function $a5160a25a687d9b6$export$42b26cae8b8d10(data, payload) {
        if (payload.dataIndexInside != null) return payload.dataIndexInside;
        else if (payload.dataIndex != null) return (0, (0, parcelRequire("bahqM")).isArray)(payload.dataIndex) ? (0, (0, parcelRequire("bahqM")).map)(payload.dataIndex, function(value) {
            return data.indexOfRawIndex(value);
        }) : data.indexOfRawIndex(payload.dataIndex);
        else if (payload.name != null) return (0, (0, parcelRequire("bahqM")).isArray)(payload.name) ? (0, (0, parcelRequire("bahqM")).map)(payload.name, function(value) {
            return data.indexOfName(value);
        }) : data.indexOfName(payload.name);
    }
    function $a5160a25a687d9b6$export$64df9f8d92ae083f() {
        var key = '__ec_inner_' + $a5160a25a687d9b6$var$innerUniqueIndex++;
        return function(hostObj) {
            return hostObj[key] || (hostObj[key] = {});
        };
    }
    var $a5160a25a687d9b6$var$innerUniqueIndex = (0, (0, parcelRequire("jmSNG")).getRandomIdBase)();
    function $a5160a25a687d9b6$export$95de80076abac814(ecModel, finderInput, opt) {
        var _a = $a5160a25a687d9b6$export$fe600815775d9400(finderInput, opt), mainTypeSpecified = _a.mainTypeSpecified, queryOptionMap = _a.queryOptionMap, others = _a.others;
        var result = others;
        var defaultMainType = opt ? opt.defaultMainType : null;
        if (!mainTypeSpecified && defaultMainType) queryOptionMap.set(defaultMainType, {});
        queryOptionMap.each(function(queryOption, mainType) {
            var queryResult = $a5160a25a687d9b6$export$dc741340f7e5f186(ecModel, mainType, queryOption, {
                useDefault: defaultMainType === mainType,
                enableAll: opt && opt.enableAll != null ? opt.enableAll : true,
                enableNone: opt && opt.enableNone != null ? opt.enableNone : true
            });
            result[mainType + 'Models'] = queryResult.models;
            result[mainType + 'Model'] = queryResult.models[0];
        });
        return result;
    }
    function $a5160a25a687d9b6$export$fe600815775d9400(finderInput, opt) {
        var finder;
        if ((0, (0, parcelRequire("bahqM")).isString)(finderInput)) {
            var obj = {};
            obj[finderInput + 'Index'] = 0;
            finder = obj;
        } else finder = finderInput;
        var queryOptionMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        var others = {};
        var mainTypeSpecified = false;
        (0, (0, parcelRequire("bahqM")).each)(finder, function(value, key) {
            if (key === 'dataIndex' || key === 'dataIndexInside') {
                others[key] = value;
                return;
            }
            var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
            var mainType = parsedKey[1];
            var queryType = (parsedKey[2] || '').toLowerCase();
            if (!mainType || !queryType || opt && opt.includeMainTypes && (0, (0, parcelRequire("bahqM")).indexOf)(opt.includeMainTypes, mainType) < 0) return;
            mainTypeSpecified = mainTypeSpecified || !!mainType;
            var queryOption = queryOptionMap.get(mainType) || queryOptionMap.set(mainType, {});
            queryOption[queryType] = value;
        });
        return {
            mainTypeSpecified: mainTypeSpecified,
            queryOptionMap: queryOptionMap,
            others: others
        };
    }
    var $a5160a25a687d9b6$export$f076738ec84e693c = {
        useDefault: true,
        enableAll: false,
        enableNone: false
    };
    var $a5160a25a687d9b6$export$48d598924ce4892c = {
        useDefault: false,
        enableAll: true,
        enableNone: true
    };
    function $a5160a25a687d9b6$export$dc741340f7e5f186(ecModel, mainType, userOption, opt) {
        opt = opt || $a5160a25a687d9b6$export$f076738ec84e693c;
        var indexOption = userOption.index;
        var idOption = userOption.id;
        var nameOption = userOption.name;
        var result = {
            models: null,
            specified: indexOption != null || idOption != null || nameOption != null
        };
        if (!result.specified) {
            var firstCmpt = void 0;
            result.models = opt.useDefault && (firstCmpt = ecModel.getComponent(mainType)) ? [
                firstCmpt
            ] : [];
            return result;
        }
        if (indexOption === 'none' || indexOption === false) {
            (0, (0, parcelRequire("bahqM")).assert)(opt.enableNone, '`"none"` or `false` is not a valid value on index option.');
            result.models = [];
            return result;
        }
        if (indexOption === 'all') {
            (0, (0, parcelRequire("bahqM")).assert)(opt.enableAll, '`"all"` is not a valid value on index option.');
            indexOption = idOption = nameOption = null;
        }
        result.models = ecModel.queryComponents({
            mainType: mainType,
            index: indexOption,
            id: idOption,
            name: nameOption
        });
        return result;
    }
    function $a5160a25a687d9b6$export$9fec4d97f1922e0b(dom, key, value) {
        dom.setAttribute ? dom.setAttribute(key, value) : dom[key] = value;
    }
    function $a5160a25a687d9b6$export$735ee1799fd02602(dom, key) {
        return dom.getAttribute ? dom.getAttribute(key) : dom[key];
    }
    function $a5160a25a687d9b6$export$cc0a17a5d27b4e17(renderModeOption) {
        if (renderModeOption === 'auto') return (0, (0, parcelRequire("hZfwb")).default).domSupported ? 'html' : 'richText';
        else return renderModeOption || 'html';
    }
    function $a5160a25a687d9b6$export$7ab5bda43e13168f(array, getKey) {
        var buckets = (0, (0, parcelRequire("bahqM")).createHashMap)();
        var keys = [];
        (0, (0, parcelRequire("bahqM")).each)(array, function(item) {
            var key = getKey(item);
            (buckets.get(key) || (keys.push(key), buckets.set(key, []))).push(item);
        });
        return {
            keys: keys,
            buckets: buckets
        };
    }
    function $a5160a25a687d9b6$export$bd0439821a1869f3(data, precision, sourceValue, targetValue, percent) {
        var isAutoPrecision = precision == null || precision === 'auto';
        if (targetValue == null) return targetValue;
        if (typeof targetValue === 'number') {
            var value = (0, (0, parcelRequire("hb2y5")).interpolateNumber)(sourceValue || 0, targetValue, percent);
            return (0, (0, parcelRequire("jmSNG")).round)(value, isAutoPrecision ? Math.max((0, (0, parcelRequire("jmSNG")).getPrecision)(sourceValue || 0), (0, (0, parcelRequire("jmSNG")).getPrecision)(targetValue)) : precision);
        } else if (typeof targetValue === 'string') return percent < 1 ? sourceValue : targetValue;
        else {
            var interpolated = [];
            var leftArr = sourceValue;
            var rightArr = targetValue;
            var length_1 = Math.max(leftArr ? leftArr.length : 0, rightArr.length);
            for(var i = 0; i < length_1; ++i){
                var info = data.getDimensionInfo(i);
                if (info && info.type === 'ordinal') interpolated[i] = (percent < 1 && leftArr ? leftArr : rightArr)[i];
                else {
                    var leftVal = leftArr && leftArr[i] ? leftArr[i] : 0;
                    var rightVal = rightArr[i];
                    var value = (0, (0, parcelRequire("hb2y5")).interpolateNumber)(leftVal, rightVal, percent);
                    interpolated[i] = (0, (0, parcelRequire("jmSNG")).round)(value, isAutoPrecision ? Math.max((0, (0, parcelRequire("jmSNG")).getPrecision)(leftVal), (0, (0, parcelRequire("jmSNG")).getPrecision)(rightVal)) : precision);
                }
            }
            return interpolated;
        }
    }
});
parcelRegister("hZfwb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1842bbf4a5e2f15$export$2e2bcd8739ae039);
    var $d1842bbf4a5e2f15$var$Browser = function() {
        function Browser() {
            this.firefox = false;
            this.ie = false;
            this.edge = false;
            this.newEdge = false;
            this.weChat = false;
        }
        return Browser;
    }();
    var $d1842bbf4a5e2f15$var$Env = function() {
        function Env() {
            this.browser = new $d1842bbf4a5e2f15$var$Browser();
            this.node = false;
            this.wxa = false;
            this.worker = false;
            this.canvasSupported = false;
            this.svgSupported = false;
            this.touchEventsSupported = false;
            this.pointerEventsSupported = false;
            this.domSupported = false;
            this.transformSupported = false;
            this.transform3dSupported = false;
        }
        return Env;
    }();
    var $d1842bbf4a5e2f15$var$env = new $d1842bbf4a5e2f15$var$Env();
    if (typeof wx === 'object' && typeof wx.getSystemInfoSync === 'function') {
        $d1842bbf4a5e2f15$var$env.wxa = true;
        $d1842bbf4a5e2f15$var$env.canvasSupported = true;
        $d1842bbf4a5e2f15$var$env.touchEventsSupported = true;
    } else if (typeof document === 'undefined' && typeof self !== 'undefined') {
        $d1842bbf4a5e2f15$var$env.worker = true;
        $d1842bbf4a5e2f15$var$env.canvasSupported = true;
    } else if (typeof navigator === 'undefined') {
        $d1842bbf4a5e2f15$var$env.node = true;
        $d1842bbf4a5e2f15$var$env.canvasSupported = true;
        $d1842bbf4a5e2f15$var$env.svgSupported = true;
    } else $d1842bbf4a5e2f15$var$detect(navigator.userAgent, $d1842bbf4a5e2f15$var$env);
    function $d1842bbf4a5e2f15$var$detect(ua, env) {
        var browser = env.browser;
        var firefox = ua.match(/Firefox\/([\d.]+)/);
        var ie = ua.match(/MSIE\s([\d.]+)/) || ua.match(/Trident\/.+?rv:(([\d.]+))/);
        var edge = ua.match(/Edge?\/([\d.]+)/);
        var weChat = /micromessenger/i.test(ua);
        if (firefox) {
            browser.firefox = true;
            browser.version = firefox[1];
        }
        if (ie) {
            browser.ie = true;
            browser.version = ie[1];
        }
        if (edge) {
            browser.edge = true;
            browser.version = edge[1];
            browser.newEdge = +edge[1].split('.')[0] > 18;
        }
        if (weChat) browser.weChat = true;
        env.canvasSupported = !!document.createElement('canvas').getContext;
        env.svgSupported = typeof SVGRect !== 'undefined';
        env.touchEventsSupported = 'ontouchstart' in window && !browser.ie && !browser.edge;
        env.pointerEventsSupported = 'onpointerdown' in window && (browser.edge || browser.ie && +browser.version >= 11);
        env.domSupported = typeof document !== 'undefined';
        var style = document.documentElement.style;
        env.transform3dSupported = (browser.ie && 'transition' in style || browser.edge || 'WebKitCSSMatrix' in window && 'm11' in new WebKitCSSMatrix() || 'MozPerspective' in style) && !('OTransition' in style);
        env.transformSupported = env.transform3dSupported || browser.ie && +browser.version >= 9;
    }
    var $d1842bbf4a5e2f15$export$2e2bcd8739ae039 = $d1842bbf4a5e2f15$var$env;
});
parcelRegister("hb2y5", function(module, exports) {
    $parcel$export(module.exports, "interpolateNumber", ()=>$c81570e1f313cc39$export$d871d53bd7eeb390);
    $parcel$export(module.exports, "cloneValue", ()=>$c81570e1f313cc39$export$c5e92b7f105af84e);
    $parcel$export(module.exports, "default", ()=>$c81570e1f313cc39$export$2e2bcd8739ae039);
    var $kj9w6;
    var $d6udH;
    var $bahqM;
    var $c81570e1f313cc39$var$arraySlice = Array.prototype.slice;
    function $c81570e1f313cc39$export$d871d53bd7eeb390(p0, p1, percent) {
        return (p1 - p0) * percent + p0;
    }
    function $c81570e1f313cc39$export$35d34bc0ed591a92(p0, p1, percent) {
        return percent > 0.5 ? p1 : p0;
    }
    function $c81570e1f313cc39$export$f8938d924b05a6eb(out, p0, p1, percent) {
        var len = p0.length;
        for(var i = 0; i < len; i++)out[i] = $c81570e1f313cc39$export$d871d53bd7eeb390(p0[i], p1[i], percent);
    }
    function $c81570e1f313cc39$export$3297a85eaaa37024(out, p0, p1, percent) {
        var len = p0.length;
        var len2 = len && p0[0].length;
        for(var i = 0; i < len; i++){
            if (!out[i]) out[i] = [];
            for(var j = 0; j < len2; j++)out[i][j] = $c81570e1f313cc39$export$d871d53bd7eeb390(p0[i][j], p1[i][j], percent);
        }
    }
    function $c81570e1f313cc39$var$add1DArray(out, p0, p1, sign) {
        var len = p0.length;
        for(var i = 0; i < len; i++)out[i] = p0[i] + p1[i] * sign;
        return out;
    }
    function $c81570e1f313cc39$var$add2DArray(out, p0, p1, sign) {
        var len = p0.length;
        var len2 = len && p0[0].length;
        for(var i = 0; i < len; i++){
            if (!out[i]) out[i] = [];
            for(var j = 0; j < len2; j++)out[i][j] = p0[i][j] + p1[i][j] * sign;
        }
        return out;
    }
    function $c81570e1f313cc39$var$fillArray(val0, val1, arrDim) {
        var arr0 = val0;
        var arr1 = val1;
        if (!arr0.push || !arr1.push) return;
        var arr0Len = arr0.length;
        var arr1Len = arr1.length;
        if (arr0Len !== arr1Len) {
            var isPreviousLarger = arr0Len > arr1Len;
            if (isPreviousLarger) arr0.length = arr1Len;
            else for(var i = arr0Len; i < arr1Len; i++)arr0.push(arrDim === 1 ? arr1[i] : $c81570e1f313cc39$var$arraySlice.call(arr1[i]));
        }
        var len2 = arr0[0] && arr0[0].length;
        for(var i = 0; i < arr0.length; i++){
            if (arrDim === 1) {
                if (isNaN(arr0[i])) arr0[i] = arr1[i];
            } else {
                for(var j = 0; j < len2; j++)if (isNaN(arr0[i][j])) arr0[i][j] = arr1[i][j];
            }
        }
    }
    function $c81570e1f313cc39$var$is1DArraySame(arr0, arr1) {
        var len = arr0.length;
        if (len !== arr1.length) return false;
        for(var i = 0; i < len; i++){
            if (arr0[i] !== arr1[i]) return false;
        }
        return true;
    }
    function $c81570e1f313cc39$var$catmullRomInterpolate(p0, p1, p2, p3, t, t2, t3) {
        var v0 = (p2 - p0) * 0.5;
        var v1 = (p3 - p1) * 0.5;
        return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
    }
    function $c81570e1f313cc39$var$catmullRomInterpolate1DArray(out, p0, p1, p2, p3, t, t2, t3) {
        var len = p0.length;
        for(var i = 0; i < len; i++)out[i] = $c81570e1f313cc39$var$catmullRomInterpolate(p0[i], p1[i], p2[i], p3[i], t, t2, t3);
    }
    function $c81570e1f313cc39$var$catmullRomInterpolate2DArray(out, p0, p1, p2, p3, t, t2, t3) {
        var len = p0.length;
        var len2 = p0[0].length;
        for(var i = 0; i < len; i++){
            if (!out[i]) out[1] = [];
            for(var j = 0; j < len2; j++)out[i][j] = $c81570e1f313cc39$var$catmullRomInterpolate(p0[i][j], p1[i][j], p2[i][j], p3[i][j], t, t2, t3);
        }
    }
    function $c81570e1f313cc39$export$c5e92b7f105af84e(value) {
        if ((0, (0, parcelRequire("bahqM")).isArrayLike)(value)) {
            var len = value.length;
            if ((0, (0, parcelRequire("bahqM")).isArrayLike)(value[0])) {
                var ret = [];
                for(var i = 0; i < len; i++)ret.push($c81570e1f313cc39$var$arraySlice.call(value[i]));
                return ret;
            }
            return $c81570e1f313cc39$var$arraySlice.call(value);
        }
        return value;
    }
    function $c81570e1f313cc39$var$rgba2String(rgba) {
        rgba[0] = Math.floor(rgba[0]);
        rgba[1] = Math.floor(rgba[1]);
        rgba[2] = Math.floor(rgba[2]);
        return 'rgba(' + rgba.join(',') + ')';
    }
    function $c81570e1f313cc39$var$guessArrayDim(value) {
        return (0, (0, parcelRequire("bahqM")).isArrayLike)(value && value[0]) ? 2 : 1;
    }
    var $c81570e1f313cc39$var$tmpRgba = [
        0,
        0,
        0,
        0
    ];
    var $c81570e1f313cc39$var$Track = function() {
        function Track(propName) {
            this.keyframes = [];
            this.maxTime = 0;
            this.arrDim = 0;
            this.interpolable = true;
            this._needsSort = false;
            this._isAllValueEqual = true;
            this._lastFrame = 0;
            this._lastFramePercent = 0;
            this.propName = propName;
        }
        Track.prototype.isFinished = function() {
            return this._finished;
        };
        Track.prototype.setFinished = function() {
            this._finished = true;
            if (this._additiveTrack) this._additiveTrack.setFinished();
        };
        Track.prototype.needsAnimate = function() {
            return !this._isAllValueEqual && this.keyframes.length >= 2 && this.interpolable && this.maxTime > 0;
        };
        Track.prototype.getAdditiveTrack = function() {
            return this._additiveTrack;
        };
        Track.prototype.addKeyframe = function(time, value) {
            if (time >= this.maxTime) this.maxTime = time;
            else this._needsSort = true;
            var keyframes = this.keyframes;
            var len = keyframes.length;
            if (this.interpolable) {
                if ((0, (0, parcelRequire("bahqM")).isArrayLike)(value)) {
                    var arrayDim = $c81570e1f313cc39$var$guessArrayDim(value);
                    if (len > 0 && this.arrDim !== arrayDim) {
                        this.interpolable = false;
                        return;
                    }
                    if (arrayDim === 1 && typeof value[0] !== 'number' || arrayDim === 2 && typeof value[0][0] !== 'number') {
                        this.interpolable = false;
                        return;
                    }
                    if (len > 0) {
                        var lastFrame = keyframes[len - 1];
                        if (this._isAllValueEqual) {
                            if (arrayDim === 1) {
                                if (!$c81570e1f313cc39$var$is1DArraySame(value, lastFrame.value)) this._isAllValueEqual = false;
                            } else this._isAllValueEqual = false;
                        }
                    }
                    this.arrDim = arrayDim;
                } else {
                    if (this.arrDim > 0) {
                        this.interpolable = false;
                        return;
                    }
                    if (typeof value === 'string') {
                        var colorArray = (0, parcelRequire("d6udH")).parse(value);
                        if (colorArray) {
                            value = colorArray;
                            this.isValueColor = true;
                        } else this.interpolable = false;
                    } else if (typeof value !== 'number' || isNaN(value)) {
                        this.interpolable = false;
                        return;
                    }
                    if (this._isAllValueEqual && len > 0) {
                        var lastFrame = keyframes[len - 1];
                        if (this.isValueColor && !$c81570e1f313cc39$var$is1DArraySame(lastFrame.value, value)) this._isAllValueEqual = false;
                        else if (lastFrame.value !== value) this._isAllValueEqual = false;
                    }
                }
            }
            var kf = {
                time: time,
                value: value,
                percent: 0
            };
            this.keyframes.push(kf);
            return kf;
        };
        Track.prototype.prepare = function(additiveTrack) {
            var kfs = this.keyframes;
            if (this._needsSort) kfs.sort(function(a, b) {
                return a.time - b.time;
            });
            var arrDim = this.arrDim;
            var kfsLen = kfs.length;
            var lastKf = kfs[kfsLen - 1];
            for(var i = 0; i < kfsLen; i++){
                kfs[i].percent = kfs[i].time / this.maxTime;
                if (arrDim > 0 && i !== kfsLen - 1) $c81570e1f313cc39$var$fillArray(kfs[i].value, lastKf.value, arrDim);
            }
            if (additiveTrack && this.needsAnimate() && additiveTrack.needsAnimate() && arrDim === additiveTrack.arrDim && this.isValueColor === additiveTrack.isValueColor && !additiveTrack._finished) {
                this._additiveTrack = additiveTrack;
                var startValue = kfs[0].value;
                for(var i = 0; i < kfsLen; i++){
                    if (arrDim === 0) {
                        if (this.isValueColor) kfs[i].additiveValue = $c81570e1f313cc39$var$add1DArray([], kfs[i].value, startValue, -1);
                        else kfs[i].additiveValue = kfs[i].value - startValue;
                    } else if (arrDim === 1) kfs[i].additiveValue = $c81570e1f313cc39$var$add1DArray([], kfs[i].value, startValue, -1);
                    else if (arrDim === 2) kfs[i].additiveValue = $c81570e1f313cc39$var$add2DArray([], kfs[i].value, startValue, -1);
                }
            }
        };
        Track.prototype.step = function(target, percent) {
            if (this._finished) return;
            if (this._additiveTrack && this._additiveTrack._finished) this._additiveTrack = null;
            var isAdditive = this._additiveTrack != null;
            var valueKey = isAdditive ? 'additiveValue' : 'value';
            var keyframes = this.keyframes;
            var kfsNum = this.keyframes.length;
            var propName = this.propName;
            var arrDim = this.arrDim;
            var isValueColor = this.isValueColor;
            var frameIdx;
            if (percent < 0) frameIdx = 0;
            else if (percent < this._lastFramePercent) {
                var start = Math.min(this._lastFrame + 1, kfsNum - 1);
                for(frameIdx = start; frameIdx >= 0; frameIdx--){
                    if (keyframes[frameIdx].percent <= percent) break;
                }
                frameIdx = Math.min(frameIdx, kfsNum - 2);
            } else {
                for(frameIdx = this._lastFrame; frameIdx < kfsNum; frameIdx++){
                    if (keyframes[frameIdx].percent > percent) break;
                }
                frameIdx = Math.min(frameIdx - 1, kfsNum - 2);
            }
            var nextFrame = keyframes[frameIdx + 1];
            var frame = keyframes[frameIdx];
            if (!(frame && nextFrame)) return;
            this._lastFrame = frameIdx;
            this._lastFramePercent = percent;
            var range = nextFrame.percent - frame.percent;
            if (range === 0) return;
            var w = (percent - frame.percent) / range;
            var targetArr = isAdditive ? this._additiveValue : isValueColor ? $c81570e1f313cc39$var$tmpRgba : target[propName];
            if ((arrDim > 0 || isValueColor) && !targetArr) targetArr = this._additiveValue = [];
            if (this.useSpline) {
                var p1 = keyframes[frameIdx][valueKey];
                var p0 = keyframes[frameIdx === 0 ? frameIdx : frameIdx - 1][valueKey];
                var p2 = keyframes[frameIdx > kfsNum - 2 ? kfsNum - 1 : frameIdx + 1][valueKey];
                var p3 = keyframes[frameIdx > kfsNum - 3 ? kfsNum - 1 : frameIdx + 2][valueKey];
                if (arrDim > 0) arrDim === 1 ? $c81570e1f313cc39$var$catmullRomInterpolate1DArray(targetArr, p0, p1, p2, p3, w, w * w, w * w * w) : $c81570e1f313cc39$var$catmullRomInterpolate2DArray(targetArr, p0, p1, p2, p3, w, w * w, w * w * w);
                else if (isValueColor) {
                    $c81570e1f313cc39$var$catmullRomInterpolate1DArray(targetArr, p0, p1, p2, p3, w, w * w, w * w * w);
                    if (!isAdditive) target[propName] = $c81570e1f313cc39$var$rgba2String(targetArr);
                } else {
                    var value = void 0;
                    if (!this.interpolable) value = p2;
                    else value = $c81570e1f313cc39$var$catmullRomInterpolate(p0, p1, p2, p3, w, w * w, w * w * w);
                    if (isAdditive) this._additiveValue = value;
                    else target[propName] = value;
                }
            } else {
                if (arrDim > 0) arrDim === 1 ? $c81570e1f313cc39$export$f8938d924b05a6eb(targetArr, frame[valueKey], nextFrame[valueKey], w) : $c81570e1f313cc39$export$3297a85eaaa37024(targetArr, frame[valueKey], nextFrame[valueKey], w);
                else if (isValueColor) {
                    $c81570e1f313cc39$export$f8938d924b05a6eb(targetArr, frame[valueKey], nextFrame[valueKey], w);
                    if (!isAdditive) target[propName] = $c81570e1f313cc39$var$rgba2String(targetArr);
                } else {
                    var value = void 0;
                    if (!this.interpolable) value = $c81570e1f313cc39$export$35d34bc0ed591a92(frame[valueKey], nextFrame[valueKey], w);
                    else value = $c81570e1f313cc39$export$d871d53bd7eeb390(frame[valueKey], nextFrame[valueKey], w);
                    if (isAdditive) this._additiveValue = value;
                    else target[propName] = value;
                }
            }
            if (isAdditive) this._addToTarget(target);
        };
        Track.prototype._addToTarget = function(target) {
            var arrDim = this.arrDim;
            var propName = this.propName;
            var additiveValue = this._additiveValue;
            if (arrDim === 0) {
                if (this.isValueColor) {
                    (0, parcelRequire("d6udH")).parse(target[propName], $c81570e1f313cc39$var$tmpRgba);
                    $c81570e1f313cc39$var$add1DArray($c81570e1f313cc39$var$tmpRgba, $c81570e1f313cc39$var$tmpRgba, additiveValue, 1);
                    target[propName] = $c81570e1f313cc39$var$rgba2String($c81570e1f313cc39$var$tmpRgba);
                } else target[propName] = target[propName] + additiveValue;
            } else if (arrDim === 1) $c81570e1f313cc39$var$add1DArray(target[propName], target[propName], additiveValue, 1);
            else if (arrDim === 2) $c81570e1f313cc39$var$add2DArray(target[propName], target[propName], additiveValue, 1);
        };
        return Track;
    }();
    var $c81570e1f313cc39$var$Animator = function() {
        function Animator(target, loop, additiveTo) {
            this._tracks = {};
            this._trackKeys = [];
            this._delay = 0;
            this._maxTime = 0;
            this._paused = false;
            this._started = 0;
            this._clip = null;
            this._target = target;
            this._loop = loop;
            if (loop && additiveTo) {
                (0, (0, parcelRequire("bahqM")).logError)('Can\' use additive animation on looped animation.');
                return;
            }
            this._additiveAnimators = additiveTo;
        }
        Animator.prototype.getTarget = function() {
            return this._target;
        };
        Animator.prototype.changeTarget = function(target) {
            this._target = target;
        };
        Animator.prototype.when = function(time, props) {
            return this.whenWithKeys(time, props, (0, (0, parcelRequire("bahqM")).keys)(props));
        };
        Animator.prototype.whenWithKeys = function(time, props, propNames) {
            var tracks = this._tracks;
            for(var i = 0; i < propNames.length; i++){
                var propName = propNames[i];
                var track = tracks[propName];
                if (!track) {
                    track = tracks[propName] = new $c81570e1f313cc39$var$Track(propName);
                    var initialValue = void 0;
                    var additiveTrack = this._getAdditiveTrack(propName);
                    if (additiveTrack) {
                        var lastFinalKf = additiveTrack.keyframes[additiveTrack.keyframes.length - 1];
                        initialValue = lastFinalKf && lastFinalKf.value;
                        if (additiveTrack.isValueColor && initialValue) initialValue = $c81570e1f313cc39$var$rgba2String(initialValue);
                    } else initialValue = this._target[propName];
                    if (initialValue == null) continue;
                    if (time !== 0) track.addKeyframe(0, $c81570e1f313cc39$export$c5e92b7f105af84e(initialValue));
                    this._trackKeys.push(propName);
                }
                track.addKeyframe(time, $c81570e1f313cc39$export$c5e92b7f105af84e(props[propName]));
            }
            this._maxTime = Math.max(this._maxTime, time);
            return this;
        };
        Animator.prototype.pause = function() {
            this._clip.pause();
            this._paused = true;
        };
        Animator.prototype.resume = function() {
            this._clip.resume();
            this._paused = false;
        };
        Animator.prototype.isPaused = function() {
            return !!this._paused;
        };
        Animator.prototype._doneCallback = function() {
            this._setTracksFinished();
            this._clip = null;
            var doneList = this._doneCbs;
            if (doneList) {
                var len = doneList.length;
                for(var i = 0; i < len; i++)doneList[i].call(this);
            }
        };
        Animator.prototype._abortedCallback = function() {
            this._setTracksFinished();
            var animation = this.animation;
            var abortedList = this._abortedCbs;
            if (animation) animation.removeClip(this._clip);
            this._clip = null;
            if (abortedList) for(var i = 0; i < abortedList.length; i++)abortedList[i].call(this);
        };
        Animator.prototype._setTracksFinished = function() {
            var tracks = this._tracks;
            var tracksKeys = this._trackKeys;
            for(var i = 0; i < tracksKeys.length; i++)tracks[tracksKeys[i]].setFinished();
        };
        Animator.prototype._getAdditiveTrack = function(trackName) {
            var additiveTrack;
            var additiveAnimators = this._additiveAnimators;
            if (additiveAnimators) for(var i = 0; i < additiveAnimators.length; i++){
                var track = additiveAnimators[i].getTrack(trackName);
                if (track) additiveTrack = track;
            }
            return additiveTrack;
        };
        Animator.prototype.start = function(easing, forceAnimate) {
            if (this._started > 0) return;
            this._started = 1;
            var self = this;
            var tracks = [];
            for(var i = 0; i < this._trackKeys.length; i++){
                var propName = this._trackKeys[i];
                var track = this._tracks[propName];
                var additiveTrack = this._getAdditiveTrack(propName);
                var kfs = track.keyframes;
                track.prepare(additiveTrack);
                if (track.needsAnimate()) tracks.push(track);
                else if (!track.interpolable) {
                    var lastKf = kfs[kfs.length - 1];
                    if (lastKf) self._target[track.propName] = lastKf.value;
                }
            }
            if (tracks.length || forceAnimate) {
                var clip = new (0, (0, parcelRequire("kj9w6")).default)({
                    life: this._maxTime,
                    loop: this._loop,
                    delay: this._delay,
                    onframe: function(percent) {
                        self._started = 2;
                        var additiveAnimators = self._additiveAnimators;
                        if (additiveAnimators) {
                            var stillHasAdditiveAnimator = false;
                            for(var i = 0; i < additiveAnimators.length; i++)if (additiveAnimators[i]._clip) {
                                stillHasAdditiveAnimator = true;
                                break;
                            }
                            if (!stillHasAdditiveAnimator) self._additiveAnimators = null;
                        }
                        for(var i = 0; i < tracks.length; i++)tracks[i].step(self._target, percent);
                        var onframeList = self._onframeCbs;
                        if (onframeList) for(var i = 0; i < onframeList.length; i++)onframeList[i](self._target, percent);
                    },
                    ondestroy: function() {
                        self._doneCallback();
                    }
                });
                this._clip = clip;
                if (this.animation) this.animation.addClip(clip);
                if (easing && easing !== 'spline') clip.easing = easing;
            } else this._doneCallback();
            return this;
        };
        Animator.prototype.stop = function(forwardToLast) {
            if (!this._clip) return;
            var clip = this._clip;
            if (forwardToLast) clip.onframe(1);
            this._abortedCallback();
        };
        Animator.prototype.delay = function(time) {
            this._delay = time;
            return this;
        };
        Animator.prototype.during = function(cb) {
            if (cb) {
                if (!this._onframeCbs) this._onframeCbs = [];
                this._onframeCbs.push(cb);
            }
            return this;
        };
        Animator.prototype.done = function(cb) {
            if (cb) {
                if (!this._doneCbs) this._doneCbs = [];
                this._doneCbs.push(cb);
            }
            return this;
        };
        Animator.prototype.aborted = function(cb) {
            if (cb) {
                if (!this._abortedCbs) this._abortedCbs = [];
                this._abortedCbs.push(cb);
            }
            return this;
        };
        Animator.prototype.getClip = function() {
            return this._clip;
        };
        Animator.prototype.getTrack = function(propName) {
            return this._tracks[propName];
        };
        Animator.prototype.stopTracks = function(propNames, forwardToLast) {
            if (!propNames.length || !this._clip) return true;
            var tracks = this._tracks;
            var tracksKeys = this._trackKeys;
            for(var i = 0; i < propNames.length; i++){
                var track = tracks[propNames[i]];
                if (track) {
                    if (forwardToLast) track.step(this._target, 1);
                    else if (this._started === 1) track.step(this._target, 0);
                    track.setFinished();
                }
            }
            var allAborted = true;
            for(var i = 0; i < tracksKeys.length; i++)if (!tracks[tracksKeys[i]].isFinished()) {
                allAborted = false;
                break;
            }
            if (allAborted) this._abortedCallback();
            return allAborted;
        };
        Animator.prototype.saveFinalToTarget = function(target, trackKeys) {
            if (!target) return;
            trackKeys = trackKeys || this._trackKeys;
            for(var i = 0; i < trackKeys.length; i++){
                var propName = trackKeys[i];
                var track = this._tracks[propName];
                if (!track || track.isFinished()) continue;
                var kfs = track.keyframes;
                var lastKf = kfs[kfs.length - 1];
                if (lastKf) {
                    var val = $c81570e1f313cc39$export$c5e92b7f105af84e(lastKf.value);
                    if (track.isValueColor) val = $c81570e1f313cc39$var$rgba2String(val);
                    target[propName] = val;
                }
            }
        };
        Animator.prototype.__changeFinalValue = function(finalProps, trackKeys) {
            trackKeys = trackKeys || (0, (0, parcelRequire("bahqM")).keys)(finalProps);
            for(var i = 0; i < trackKeys.length; i++){
                var propName = trackKeys[i];
                var track = this._tracks[propName];
                if (!track) continue;
                var kfs = track.keyframes;
                if (kfs.length > 1) {
                    var lastKf = kfs.pop();
                    track.addKeyframe(lastKf.time, finalProps[propName]);
                    track.prepare(track.getAdditiveTrack());
                }
            }
        };
        return Animator;
    }();
    var $c81570e1f313cc39$export$2e2bcd8739ae039 = $c81570e1f313cc39$var$Animator;
});
parcelRegister("kj9w6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ec8cf6d19967f888$export$2e2bcd8739ae039);
    var $2yJbE;
    var $ec8cf6d19967f888$var$Clip = function() {
        function Clip(opts) {
            this._initialized = false;
            this._startTime = 0;
            this._pausedTime = 0;
            this._paused = false;
            this._life = opts.life || 1000;
            this._delay = opts.delay || 0;
            this.loop = opts.loop == null ? false : opts.loop;
            this.gap = opts.gap || 0;
            this.easing = opts.easing || 'linear';
            this.onframe = opts.onframe;
            this.ondestroy = opts.ondestroy;
            this.onrestart = opts.onrestart;
        }
        Clip.prototype.step = function(globalTime, deltaTime) {
            if (!this._initialized) {
                this._startTime = globalTime + this._delay;
                this._initialized = true;
            }
            if (this._paused) {
                this._pausedTime += deltaTime;
                return;
            }
            var percent = (globalTime - this._startTime - this._pausedTime) / this._life;
            if (percent < 0) percent = 0;
            percent = Math.min(percent, 1);
            var easing = this.easing;
            var easingFunc = typeof easing === 'string' ? (0, (0, parcelRequire("2yJbE")).default)[easing] : easing;
            var schedule = typeof easingFunc === 'function' ? easingFunc(percent) : percent;
            this.onframe && this.onframe(schedule);
            if (percent === 1) {
                if (this.loop) {
                    this._restart(globalTime);
                    this.onrestart && this.onrestart();
                } else return true;
            }
            return false;
        };
        Clip.prototype._restart = function(globalTime) {
            var remainder = (globalTime - this._startTime - this._pausedTime) % this._life;
            this._startTime = globalTime - remainder + this.gap;
            this._pausedTime = 0;
        };
        Clip.prototype.pause = function() {
            this._paused = true;
        };
        Clip.prototype.resume = function() {
            this._paused = false;
        };
        return Clip;
    }();
    var $ec8cf6d19967f888$export$2e2bcd8739ae039 = $ec8cf6d19967f888$var$Clip;
});
parcelRegister("2yJbE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1dd1cef375de2720$export$2e2bcd8739ae039);
    var $1dd1cef375de2720$var$easing = {
        linear: function(k) {
            return k;
        },
        quadraticIn: function(k) {
            return k * k;
        },
        quadraticOut: function(k) {
            return k * (2 - k);
        },
        quadraticInOut: function(k) {
            if ((k *= 2) < 1) return 0.5 * k * k;
            return -0.5 * (--k * (k - 2) - 1);
        },
        cubicIn: function(k) {
            return k * k * k;
        },
        cubicOut: function(k) {
            return --k * k * k + 1;
        },
        cubicInOut: function(k) {
            if ((k *= 2) < 1) return 0.5 * k * k * k;
            return 0.5 * ((k -= 2) * k * k + 2);
        },
        quarticIn: function(k) {
            return k * k * k * k;
        },
        quarticOut: function(k) {
            return 1 - --k * k * k * k;
        },
        quarticInOut: function(k) {
            if ((k *= 2) < 1) return 0.5 * k * k * k * k;
            return -0.5 * ((k -= 2) * k * k * k - 2);
        },
        quinticIn: function(k) {
            return k * k * k * k * k;
        },
        quinticOut: function(k) {
            return --k * k * k * k * k + 1;
        },
        quinticInOut: function(k) {
            if ((k *= 2) < 1) return 0.5 * k * k * k * k * k;
            return 0.5 * ((k -= 2) * k * k * k * k + 2);
        },
        sinusoidalIn: function(k) {
            return 1 - Math.cos(k * Math.PI / 2);
        },
        sinusoidalOut: function(k) {
            return Math.sin(k * Math.PI / 2);
        },
        sinusoidalInOut: function(k) {
            return 0.5 * (1 - Math.cos(Math.PI * k));
        },
        exponentialIn: function(k) {
            return k === 0 ? 0 : Math.pow(1024, k - 1);
        },
        exponentialOut: function(k) {
            return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
        },
        exponentialInOut: function(k) {
            if (k === 0) return 0;
            if (k === 1) return 1;
            if ((k *= 2) < 1) return 0.5 * Math.pow(1024, k - 1);
            return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
        },
        circularIn: function(k) {
            return 1 - Math.sqrt(1 - k * k);
        },
        circularOut: function(k) {
            return Math.sqrt(1 - --k * k);
        },
        circularInOut: function(k) {
            if ((k *= 2) < 1) return -0.5 * (Math.sqrt(1 - k * k) - 1);
            return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
        },
        elasticIn: function(k) {
            var s;
            var a = 0.1;
            var p = 0.4;
            if (k === 0) return 0;
            if (k === 1) return 1;
            if (!a || a < 1) {
                a = 1;
                s = p / 4;
            } else s = p * Math.asin(1 / a) / (2 * Math.PI);
            return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
        },
        elasticOut: function(k) {
            var s;
            var a = 0.1;
            var p = 0.4;
            if (k === 0) return 0;
            if (k === 1) return 1;
            if (!a || a < 1) {
                a = 1;
                s = p / 4;
            } else s = p * Math.asin(1 / a) / (2 * Math.PI);
            return a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1;
        },
        elasticInOut: function(k) {
            var s;
            var a = 0.1;
            var p = 0.4;
            if (k === 0) return 0;
            if (k === 1) return 1;
            if (!a || a < 1) {
                a = 1;
                s = p / 4;
            } else s = p * Math.asin(1 / a) / (2 * Math.PI);
            if ((k *= 2) < 1) return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
            return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
        },
        backIn: function(k) {
            var s = 1.70158;
            return k * k * ((s + 1) * k - s);
        },
        backOut: function(k) {
            var s = 1.70158;
            return --k * k * ((s + 1) * k + s) + 1;
        },
        backInOut: function(k) {
            var s = 2.5949095;
            if ((k *= 2) < 1) return 0.5 * (k * k * ((s + 1) * k - s));
            return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
        },
        bounceIn: function(k) {
            return 1 - $1dd1cef375de2720$var$easing.bounceOut(1 - k);
        },
        bounceOut: function(k) {
            if (k < 1 / 2.75) return 7.5625 * k * k;
            else if (k < 2 / 2.75) return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
            else if (k < 2.5 / 2.75) return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
            else return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
        },
        bounceInOut: function(k) {
            if (k < 0.5) return $1dd1cef375de2720$var$easing.bounceIn(k * 2) * 0.5;
            return $1dd1cef375de2720$var$easing.bounceOut(k * 2 - 1) * 0.5 + 0.5;
        }
    };
    var $1dd1cef375de2720$export$2e2bcd8739ae039 = $1dd1cef375de2720$var$easing;
});
parcelRegister("d6udH", function(module, exports) {
    $parcel$export(module.exports, "parse", ()=>$98a346fa71cc3009$export$98e6a39c04603d36);
    $parcel$export(module.exports, "lift", ()=>$98a346fa71cc3009$export$590e8b2c435046d9);
    $parcel$export(module.exports, "stringify", ()=>$98a346fa71cc3009$export$fac44ee5b035f737);
    $parcel$export(module.exports, "toHex", ()=>$98a346fa71cc3009$export$7ea66e3774a60b67);
    $parcel$export(module.exports, "fastLerp", ()=>$98a346fa71cc3009$export$66cb3c0e9efc61c8);
    $parcel$export(module.exports, "fastMapToColor", ()=>$98a346fa71cc3009$export$daa5a65daad5df58);
    $parcel$export(module.exports, "lerp", ()=>$98a346fa71cc3009$export$3a89f8d6f6bf6c9f);
    $parcel$export(module.exports, "mapToColor", ()=>$98a346fa71cc3009$export$296e08242b78a3ec);
    $parcel$export(module.exports, "modifyHSL", ()=>$98a346fa71cc3009$export$d898ae866e27bf18);
    $parcel$export(module.exports, "modifyAlpha", ()=>$98a346fa71cc3009$export$ab4754bf42583a26);
    $parcel$export(module.exports, "lum", ()=>$98a346fa71cc3009$export$16c0ec21a6f9ef95);
    $parcel$export(module.exports, "random", ()=>$98a346fa71cc3009$export$4385e60b38654f68);
    var $h4RuA;
    var $98a346fa71cc3009$var$kCSSColorTable = {
        'transparent': [
            0,
            0,
            0,
            0
        ],
        'aliceblue': [
            240,
            248,
            255,
            1
        ],
        'antiquewhite': [
            250,
            235,
            215,
            1
        ],
        'aqua': [
            0,
            255,
            255,
            1
        ],
        'aquamarine': [
            127,
            255,
            212,
            1
        ],
        'azure': [
            240,
            255,
            255,
            1
        ],
        'beige': [
            245,
            245,
            220,
            1
        ],
        'bisque': [
            255,
            228,
            196,
            1
        ],
        'black': [
            0,
            0,
            0,
            1
        ],
        'blanchedalmond': [
            255,
            235,
            205,
            1
        ],
        'blue': [
            0,
            0,
            255,
            1
        ],
        'blueviolet': [
            138,
            43,
            226,
            1
        ],
        'brown': [
            165,
            42,
            42,
            1
        ],
        'burlywood': [
            222,
            184,
            135,
            1
        ],
        'cadetblue': [
            95,
            158,
            160,
            1
        ],
        'chartreuse': [
            127,
            255,
            0,
            1
        ],
        'chocolate': [
            210,
            105,
            30,
            1
        ],
        'coral': [
            255,
            127,
            80,
            1
        ],
        'cornflowerblue': [
            100,
            149,
            237,
            1
        ],
        'cornsilk': [
            255,
            248,
            220,
            1
        ],
        'crimson': [
            220,
            20,
            60,
            1
        ],
        'cyan': [
            0,
            255,
            255,
            1
        ],
        'darkblue': [
            0,
            0,
            139,
            1
        ],
        'darkcyan': [
            0,
            139,
            139,
            1
        ],
        'darkgoldenrod': [
            184,
            134,
            11,
            1
        ],
        'darkgray': [
            169,
            169,
            169,
            1
        ],
        'darkgreen': [
            0,
            100,
            0,
            1
        ],
        'darkgrey': [
            169,
            169,
            169,
            1
        ],
        'darkkhaki': [
            189,
            183,
            107,
            1
        ],
        'darkmagenta': [
            139,
            0,
            139,
            1
        ],
        'darkolivegreen': [
            85,
            107,
            47,
            1
        ],
        'darkorange': [
            255,
            140,
            0,
            1
        ],
        'darkorchid': [
            153,
            50,
            204,
            1
        ],
        'darkred': [
            139,
            0,
            0,
            1
        ],
        'darksalmon': [
            233,
            150,
            122,
            1
        ],
        'darkseagreen': [
            143,
            188,
            143,
            1
        ],
        'darkslateblue': [
            72,
            61,
            139,
            1
        ],
        'darkslategray': [
            47,
            79,
            79,
            1
        ],
        'darkslategrey': [
            47,
            79,
            79,
            1
        ],
        'darkturquoise': [
            0,
            206,
            209,
            1
        ],
        'darkviolet': [
            148,
            0,
            211,
            1
        ],
        'deeppink': [
            255,
            20,
            147,
            1
        ],
        'deepskyblue': [
            0,
            191,
            255,
            1
        ],
        'dimgray': [
            105,
            105,
            105,
            1
        ],
        'dimgrey': [
            105,
            105,
            105,
            1
        ],
        'dodgerblue': [
            30,
            144,
            255,
            1
        ],
        'firebrick': [
            178,
            34,
            34,
            1
        ],
        'floralwhite': [
            255,
            250,
            240,
            1
        ],
        'forestgreen': [
            34,
            139,
            34,
            1
        ],
        'fuchsia': [
            255,
            0,
            255,
            1
        ],
        'gainsboro': [
            220,
            220,
            220,
            1
        ],
        'ghostwhite': [
            248,
            248,
            255,
            1
        ],
        'gold': [
            255,
            215,
            0,
            1
        ],
        'goldenrod': [
            218,
            165,
            32,
            1
        ],
        'gray': [
            128,
            128,
            128,
            1
        ],
        'green': [
            0,
            128,
            0,
            1
        ],
        'greenyellow': [
            173,
            255,
            47,
            1
        ],
        'grey': [
            128,
            128,
            128,
            1
        ],
        'honeydew': [
            240,
            255,
            240,
            1
        ],
        'hotpink': [
            255,
            105,
            180,
            1
        ],
        'indianred': [
            205,
            92,
            92,
            1
        ],
        'indigo': [
            75,
            0,
            130,
            1
        ],
        'ivory': [
            255,
            255,
            240,
            1
        ],
        'khaki': [
            240,
            230,
            140,
            1
        ],
        'lavender': [
            230,
            230,
            250,
            1
        ],
        'lavenderblush': [
            255,
            240,
            245,
            1
        ],
        'lawngreen': [
            124,
            252,
            0,
            1
        ],
        'lemonchiffon': [
            255,
            250,
            205,
            1
        ],
        'lightblue': [
            173,
            216,
            230,
            1
        ],
        'lightcoral': [
            240,
            128,
            128,
            1
        ],
        'lightcyan': [
            224,
            255,
            255,
            1
        ],
        'lightgoldenrodyellow': [
            250,
            250,
            210,
            1
        ],
        'lightgray': [
            211,
            211,
            211,
            1
        ],
        'lightgreen': [
            144,
            238,
            144,
            1
        ],
        'lightgrey': [
            211,
            211,
            211,
            1
        ],
        'lightpink': [
            255,
            182,
            193,
            1
        ],
        'lightsalmon': [
            255,
            160,
            122,
            1
        ],
        'lightseagreen': [
            32,
            178,
            170,
            1
        ],
        'lightskyblue': [
            135,
            206,
            250,
            1
        ],
        'lightslategray': [
            119,
            136,
            153,
            1
        ],
        'lightslategrey': [
            119,
            136,
            153,
            1
        ],
        'lightsteelblue': [
            176,
            196,
            222,
            1
        ],
        'lightyellow': [
            255,
            255,
            224,
            1
        ],
        'lime': [
            0,
            255,
            0,
            1
        ],
        'limegreen': [
            50,
            205,
            50,
            1
        ],
        'linen': [
            250,
            240,
            230,
            1
        ],
        'magenta': [
            255,
            0,
            255,
            1
        ],
        'maroon': [
            128,
            0,
            0,
            1
        ],
        'mediumaquamarine': [
            102,
            205,
            170,
            1
        ],
        'mediumblue': [
            0,
            0,
            205,
            1
        ],
        'mediumorchid': [
            186,
            85,
            211,
            1
        ],
        'mediumpurple': [
            147,
            112,
            219,
            1
        ],
        'mediumseagreen': [
            60,
            179,
            113,
            1
        ],
        'mediumslateblue': [
            123,
            104,
            238,
            1
        ],
        'mediumspringgreen': [
            0,
            250,
            154,
            1
        ],
        'mediumturquoise': [
            72,
            209,
            204,
            1
        ],
        'mediumvioletred': [
            199,
            21,
            133,
            1
        ],
        'midnightblue': [
            25,
            25,
            112,
            1
        ],
        'mintcream': [
            245,
            255,
            250,
            1
        ],
        'mistyrose': [
            255,
            228,
            225,
            1
        ],
        'moccasin': [
            255,
            228,
            181,
            1
        ],
        'navajowhite': [
            255,
            222,
            173,
            1
        ],
        'navy': [
            0,
            0,
            128,
            1
        ],
        'oldlace': [
            253,
            245,
            230,
            1
        ],
        'olive': [
            128,
            128,
            0,
            1
        ],
        'olivedrab': [
            107,
            142,
            35,
            1
        ],
        'orange': [
            255,
            165,
            0,
            1
        ],
        'orangered': [
            255,
            69,
            0,
            1
        ],
        'orchid': [
            218,
            112,
            214,
            1
        ],
        'palegoldenrod': [
            238,
            232,
            170,
            1
        ],
        'palegreen': [
            152,
            251,
            152,
            1
        ],
        'paleturquoise': [
            175,
            238,
            238,
            1
        ],
        'palevioletred': [
            219,
            112,
            147,
            1
        ],
        'papayawhip': [
            255,
            239,
            213,
            1
        ],
        'peachpuff': [
            255,
            218,
            185,
            1
        ],
        'peru': [
            205,
            133,
            63,
            1
        ],
        'pink': [
            255,
            192,
            203,
            1
        ],
        'plum': [
            221,
            160,
            221,
            1
        ],
        'powderblue': [
            176,
            224,
            230,
            1
        ],
        'purple': [
            128,
            0,
            128,
            1
        ],
        'red': [
            255,
            0,
            0,
            1
        ],
        'rosybrown': [
            188,
            143,
            143,
            1
        ],
        'royalblue': [
            65,
            105,
            225,
            1
        ],
        'saddlebrown': [
            139,
            69,
            19,
            1
        ],
        'salmon': [
            250,
            128,
            114,
            1
        ],
        'sandybrown': [
            244,
            164,
            96,
            1
        ],
        'seagreen': [
            46,
            139,
            87,
            1
        ],
        'seashell': [
            255,
            245,
            238,
            1
        ],
        'sienna': [
            160,
            82,
            45,
            1
        ],
        'silver': [
            192,
            192,
            192,
            1
        ],
        'skyblue': [
            135,
            206,
            235,
            1
        ],
        'slateblue': [
            106,
            90,
            205,
            1
        ],
        'slategray': [
            112,
            128,
            144,
            1
        ],
        'slategrey': [
            112,
            128,
            144,
            1
        ],
        'snow': [
            255,
            250,
            250,
            1
        ],
        'springgreen': [
            0,
            255,
            127,
            1
        ],
        'steelblue': [
            70,
            130,
            180,
            1
        ],
        'tan': [
            210,
            180,
            140,
            1
        ],
        'teal': [
            0,
            128,
            128,
            1
        ],
        'thistle': [
            216,
            191,
            216,
            1
        ],
        'tomato': [
            255,
            99,
            71,
            1
        ],
        'turquoise': [
            64,
            224,
            208,
            1
        ],
        'violet': [
            238,
            130,
            238,
            1
        ],
        'wheat': [
            245,
            222,
            179,
            1
        ],
        'white': [
            255,
            255,
            255,
            1
        ],
        'whitesmoke': [
            245,
            245,
            245,
            1
        ],
        'yellow': [
            255,
            255,
            0,
            1
        ],
        'yellowgreen': [
            154,
            205,
            50,
            1
        ]
    };
    function $98a346fa71cc3009$var$clampCssByte(i) {
        i = Math.round(i);
        return i < 0 ? 0 : i > 255 ? 255 : i;
    }
    function $98a346fa71cc3009$var$clampCssAngle(i) {
        i = Math.round(i);
        return i < 0 ? 0 : i > 360 ? 360 : i;
    }
    function $98a346fa71cc3009$var$clampCssFloat(f) {
        return f < 0 ? 0 : f > 1 ? 1 : f;
    }
    function $98a346fa71cc3009$var$parseCssInt(val) {
        var str = val;
        if (str.length && str.charAt(str.length - 1) === '%') return $98a346fa71cc3009$var$clampCssByte(parseFloat(str) / 100 * 255);
        return $98a346fa71cc3009$var$clampCssByte(parseInt(str, 10));
    }
    function $98a346fa71cc3009$var$parseCssFloat(val) {
        var str = val;
        if (str.length && str.charAt(str.length - 1) === '%') return $98a346fa71cc3009$var$clampCssFloat(parseFloat(str) / 100);
        return $98a346fa71cc3009$var$clampCssFloat(parseFloat(str));
    }
    function $98a346fa71cc3009$var$cssHueToRgb(m1, m2, h) {
        if (h < 0) h += 1;
        else if (h > 1) h -= 1;
        if (h * 6 < 1) return m1 + (m2 - m1) * h * 6;
        if (h * 2 < 1) return m2;
        if (h * 3 < 2) return m1 + (m2 - m1) * (2 / 3 - h) * 6;
        return m1;
    }
    function $98a346fa71cc3009$var$lerpNumber(a, b, p) {
        return a + (b - a) * p;
    }
    function $98a346fa71cc3009$var$setRgba(out, r, g, b, a) {
        out[0] = r;
        out[1] = g;
        out[2] = b;
        out[3] = a;
        return out;
    }
    function $98a346fa71cc3009$var$copyRgba(out, a) {
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        return out;
    }
    var $98a346fa71cc3009$var$colorCache = new (0, (0, parcelRequire("h4RuA")).default)(20);
    var $98a346fa71cc3009$var$lastRemovedArr = null;
    function $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr) {
        if ($98a346fa71cc3009$var$lastRemovedArr) $98a346fa71cc3009$var$copyRgba($98a346fa71cc3009$var$lastRemovedArr, rgbaArr);
        $98a346fa71cc3009$var$lastRemovedArr = $98a346fa71cc3009$var$colorCache.put(colorStr, $98a346fa71cc3009$var$lastRemovedArr || rgbaArr.slice());
    }
    function $98a346fa71cc3009$export$98e6a39c04603d36(colorStr, rgbaArr) {
        if (!colorStr) return;
        rgbaArr = rgbaArr || [];
        var cached = $98a346fa71cc3009$var$colorCache.get(colorStr);
        if (cached) return $98a346fa71cc3009$var$copyRgba(rgbaArr, cached);
        colorStr = colorStr + '';
        var str = colorStr.replace(/ /g, '').toLowerCase();
        if (str in $98a346fa71cc3009$var$kCSSColorTable) {
            $98a346fa71cc3009$var$copyRgba(rgbaArr, $98a346fa71cc3009$var$kCSSColorTable[str]);
            $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        }
        var strLen = str.length;
        if (str.charAt(0) === '#') {
            if (strLen === 4 || strLen === 5) {
                var iv = parseInt(str.slice(1, 4), 16);
                if (!(iv >= 0 && iv <= 0xfff)) {
                    $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                $98a346fa71cc3009$var$setRgba(rgbaArr, (iv & 0xf00) >> 4 | (iv & 0xf00) >> 8, iv & 0xf0 | (iv & 0xf0) >> 4, iv & 0xf | (iv & 0xf) << 4, strLen === 5 ? parseInt(str.slice(4), 16) / 0xf : 1);
                $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            } else if (strLen === 7 || strLen === 9) {
                var iv = parseInt(str.slice(1, 7), 16);
                if (!(iv >= 0 && iv <= 0xffffff)) {
                    $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                $98a346fa71cc3009$var$setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, strLen === 9 ? parseInt(str.slice(7), 16) / 0xff : 1);
                $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            }
            return;
        }
        var op = str.indexOf('(');
        var ep = str.indexOf(')');
        if (op !== -1 && ep + 1 === strLen) {
            var fname = str.substr(0, op);
            var params = str.substr(op + 1, ep - (op + 1)).split(',');
            var alpha = 1;
            switch(fname){
                case 'rgba':
                    if (params.length !== 4) return params.length === 3 ? $98a346fa71cc3009$var$setRgba(rgbaArr, +params[0], +params[1], +params[2], 1) : $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    alpha = $98a346fa71cc3009$var$parseCssFloat(params.pop());
                case 'rgb':
                    if (params.length !== 3) {
                        $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
                        return;
                    }
                    $98a346fa71cc3009$var$setRgba(rgbaArr, $98a346fa71cc3009$var$parseCssInt(params[0]), $98a346fa71cc3009$var$parseCssInt(params[1]), $98a346fa71cc3009$var$parseCssInt(params[2]), alpha);
                    $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr);
                    return rgbaArr;
                case 'hsla':
                    if (params.length !== 4) {
                        $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
                        return;
                    }
                    params[3] = $98a346fa71cc3009$var$parseCssFloat(params[3]);
                    $98a346fa71cc3009$var$hsla2rgba(params, rgbaArr);
                    $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr);
                    return rgbaArr;
                case 'hsl':
                    if (params.length !== 3) {
                        $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
                        return;
                    }
                    $98a346fa71cc3009$var$hsla2rgba(params, rgbaArr);
                    $98a346fa71cc3009$var$putToCache(colorStr, rgbaArr);
                    return rgbaArr;
                default:
                    return;
            }
        }
        $98a346fa71cc3009$var$setRgba(rgbaArr, 0, 0, 0, 1);
        return;
    }
    function $98a346fa71cc3009$var$hsla2rgba(hsla, rgba) {
        var h = (parseFloat(hsla[0]) % 360 + 360) % 360 / 360;
        var s = $98a346fa71cc3009$var$parseCssFloat(hsla[1]);
        var l = $98a346fa71cc3009$var$parseCssFloat(hsla[2]);
        var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var m1 = l * 2 - m2;
        rgba = rgba || [];
        $98a346fa71cc3009$var$setRgba(rgba, $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$cssHueToRgb(m1, m2, h + 1 / 3) * 255), $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$cssHueToRgb(m1, m2, h) * 255), $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);
        if (hsla.length === 4) rgba[3] = hsla[3];
        return rgba;
    }
    function $98a346fa71cc3009$var$rgba2hsla(rgba) {
        if (!rgba) return;
        var R = rgba[0] / 255;
        var G = rgba[1] / 255;
        var B = rgba[2] / 255;
        var vMin = Math.min(R, G, B);
        var vMax = Math.max(R, G, B);
        var delta = vMax - vMin;
        var L = (vMax + vMin) / 2;
        var H;
        var S;
        if (delta === 0) {
            H = 0;
            S = 0;
        } else {
            if (L < 0.5) S = delta / (vMax + vMin);
            else S = delta / (2 - vMax - vMin);
            var deltaR = ((vMax - R) / 6 + delta / 2) / delta;
            var deltaG = ((vMax - G) / 6 + delta / 2) / delta;
            var deltaB = ((vMax - B) / 6 + delta / 2) / delta;
            if (R === vMax) H = deltaB - deltaG;
            else if (G === vMax) H = 1 / 3 + deltaR - deltaB;
            else if (B === vMax) H = 2 / 3 + deltaG - deltaR;
            if (H < 0) H += 1;
            if (H > 1) H -= 1;
        }
        var hsla = [
            H * 360,
            S,
            L
        ];
        if (rgba[3] != null) hsla.push(rgba[3]);
        return hsla;
    }
    function $98a346fa71cc3009$export$590e8b2c435046d9(color, level) {
        var colorArr = $98a346fa71cc3009$export$98e6a39c04603d36(color);
        if (colorArr) {
            for(var i = 0; i < 3; i++){
                if (level < 0) colorArr[i] = colorArr[i] * (1 - level) | 0;
                else colorArr[i] = (255 - colorArr[i]) * level + colorArr[i] | 0;
                if (colorArr[i] > 255) colorArr[i] = 255;
                else if (colorArr[i] < 0) colorArr[i] = 0;
            }
            return $98a346fa71cc3009$export$fac44ee5b035f737(colorArr, colorArr.length === 4 ? 'rgba' : 'rgb');
        }
    }
    function $98a346fa71cc3009$export$7ea66e3774a60b67(color) {
        var colorArr = $98a346fa71cc3009$export$98e6a39c04603d36(color);
        if (colorArr) return (16777216 + (colorArr[0] << 16) + (colorArr[1] << 8) + +colorArr[2]).toString(16).slice(1);
    }
    function $98a346fa71cc3009$export$66cb3c0e9efc61c8(normalizedValue, colors, out) {
        if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
        out = out || [];
        var value = normalizedValue * (colors.length - 1);
        var leftIndex = Math.floor(value);
        var rightIndex = Math.ceil(value);
        var leftColor = colors[leftIndex];
        var rightColor = colors[rightIndex];
        var dv = value - leftIndex;
        out[0] = $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$lerpNumber(leftColor[0], rightColor[0], dv));
        out[1] = $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$lerpNumber(leftColor[1], rightColor[1], dv));
        out[2] = $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$lerpNumber(leftColor[2], rightColor[2], dv));
        out[3] = $98a346fa71cc3009$var$clampCssFloat($98a346fa71cc3009$var$lerpNumber(leftColor[3], rightColor[3], dv));
        return out;
    }
    var $98a346fa71cc3009$export$daa5a65daad5df58 = $98a346fa71cc3009$export$66cb3c0e9efc61c8;
    function $98a346fa71cc3009$export$3a89f8d6f6bf6c9f(normalizedValue, colors, fullOutput) {
        if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
        var value = normalizedValue * (colors.length - 1);
        var leftIndex = Math.floor(value);
        var rightIndex = Math.ceil(value);
        var leftColor = $98a346fa71cc3009$export$98e6a39c04603d36(colors[leftIndex]);
        var rightColor = $98a346fa71cc3009$export$98e6a39c04603d36(colors[rightIndex]);
        var dv = value - leftIndex;
        var color = $98a346fa71cc3009$export$fac44ee5b035f737([
            $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$lerpNumber(leftColor[0], rightColor[0], dv)),
            $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$lerpNumber(leftColor[1], rightColor[1], dv)),
            $98a346fa71cc3009$var$clampCssByte($98a346fa71cc3009$var$lerpNumber(leftColor[2], rightColor[2], dv)),
            $98a346fa71cc3009$var$clampCssFloat($98a346fa71cc3009$var$lerpNumber(leftColor[3], rightColor[3], dv))
        ], 'rgba');
        return fullOutput ? {
            color: color,
            leftIndex: leftIndex,
            rightIndex: rightIndex,
            value: value
        } : color;
    }
    var $98a346fa71cc3009$export$296e08242b78a3ec = $98a346fa71cc3009$export$3a89f8d6f6bf6c9f;
    function $98a346fa71cc3009$export$d898ae866e27bf18(color, h, s, l) {
        var colorArr = $98a346fa71cc3009$export$98e6a39c04603d36(color);
        if (color) {
            colorArr = $98a346fa71cc3009$var$rgba2hsla(colorArr);
            h != null && (colorArr[0] = $98a346fa71cc3009$var$clampCssAngle(h));
            s != null && (colorArr[1] = $98a346fa71cc3009$var$parseCssFloat(s));
            l != null && (colorArr[2] = $98a346fa71cc3009$var$parseCssFloat(l));
            return $98a346fa71cc3009$export$fac44ee5b035f737($98a346fa71cc3009$var$hsla2rgba(colorArr), 'rgba');
        }
    }
    function $98a346fa71cc3009$export$ab4754bf42583a26(color, alpha) {
        var colorArr = $98a346fa71cc3009$export$98e6a39c04603d36(color);
        if (colorArr && alpha != null) {
            colorArr[3] = $98a346fa71cc3009$var$clampCssFloat(alpha);
            return $98a346fa71cc3009$export$fac44ee5b035f737(colorArr, 'rgba');
        }
    }
    function $98a346fa71cc3009$export$fac44ee5b035f737(arrColor, type) {
        if (!arrColor || !arrColor.length) return;
        var colorStr = arrColor[0] + ',' + arrColor[1] + ',' + arrColor[2];
        if (type === 'rgba' || type === 'hsva' || type === 'hsla') colorStr += ',' + arrColor[3];
        return type + '(' + colorStr + ')';
    }
    function $98a346fa71cc3009$export$16c0ec21a6f9ef95(color, backgroundLum) {
        var arr = $98a346fa71cc3009$export$98e6a39c04603d36(color);
        return arr ? (0.299 * arr[0] + 0.587 * arr[1] + 0.114 * arr[2]) * arr[3] / 255 + (1 - arr[3]) * backgroundLum : 0;
    }
    function $98a346fa71cc3009$export$4385e60b38654f68() {
        var r = Math.round(Math.random() * 255);
        var g = Math.round(Math.random() * 255);
        var b = Math.round(Math.random() * 255);
        return 'rgb(' + r + ',' + g + ',' + b + ')';
    }
});
parcelRegister("h4RuA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c6ec4ddc95ccc3f1$export$2e2bcd8739ae039);
    var $c6ec4ddc95ccc3f1$export$3bb977b3ba9d3b59 = function() {
        function Entry(val) {
            this.value = val;
        }
        return Entry;
    }();
    var $c6ec4ddc95ccc3f1$export$f0ef28713f767754 = function() {
        function LinkedList() {
            this._len = 0;
        }
        LinkedList.prototype.insert = function(val) {
            var entry = new $c6ec4ddc95ccc3f1$export$3bb977b3ba9d3b59(val);
            this.insertEntry(entry);
            return entry;
        };
        LinkedList.prototype.insertEntry = function(entry) {
            if (!this.head) this.head = this.tail = entry;
            else {
                this.tail.next = entry;
                entry.prev = this.tail;
                entry.next = null;
                this.tail = entry;
            }
            this._len++;
        };
        LinkedList.prototype.remove = function(entry) {
            var prev = entry.prev;
            var next = entry.next;
            if (prev) prev.next = next;
            else this.head = next;
            if (next) next.prev = prev;
            else this.tail = prev;
            entry.next = entry.prev = null;
            this._len--;
        };
        LinkedList.prototype.len = function() {
            return this._len;
        };
        LinkedList.prototype.clear = function() {
            this.head = this.tail = null;
            this._len = 0;
        };
        return LinkedList;
    }();
    var $c6ec4ddc95ccc3f1$var$LRU = function() {
        function LRU(maxSize) {
            this._list = new $c6ec4ddc95ccc3f1$export$f0ef28713f767754();
            this._maxSize = 10;
            this._map = {};
            this._maxSize = maxSize;
        }
        LRU.prototype.put = function(key, value) {
            var list = this._list;
            var map = this._map;
            var removed = null;
            if (map[key] == null) {
                var len = list.len();
                var entry = this._lastRemovedEntry;
                if (len >= this._maxSize && len > 0) {
                    var leastUsedEntry = list.head;
                    list.remove(leastUsedEntry);
                    delete map[leastUsedEntry.key];
                    removed = leastUsedEntry.value;
                    this._lastRemovedEntry = leastUsedEntry;
                }
                if (entry) entry.value = value;
                else entry = new $c6ec4ddc95ccc3f1$export$3bb977b3ba9d3b59(value);
                entry.key = key;
                list.insertEntry(entry);
                map[key] = entry;
            }
            return removed;
        };
        LRU.prototype.get = function(key) {
            var entry = this._map[key];
            var list = this._list;
            if (entry != null) {
                if (entry !== list.tail) {
                    list.remove(entry);
                    list.insertEntry(entry);
                }
                return entry.value;
            }
        };
        LRU.prototype.clear = function() {
            this._list.clear();
            this._map = {};
        };
        LRU.prototype.len = function() {
            return this._list.len();
        };
        return LRU;
    }();
    var $c6ec4ddc95ccc3f1$export$2e2bcd8739ae039 = $c6ec4ddc95ccc3f1$var$LRU;
});
parcelRegister("20liu", function(module, exports) {
    $parcel$export(module.exports, "isSourceInstance", ()=>$175c1a118c738be0$export$22b808bc02a60488);
    $parcel$export(module.exports, "createSource", ()=>$175c1a118c738be0$export$1921362e86c73c88);
    $parcel$export(module.exports, "detectSourceFormat", ()=>$175c1a118c738be0$export$52a469afa4653e57);
    $parcel$export(module.exports, "createSourceFromSeriesDataOption", ()=>$175c1a118c738be0$export$75aef3f97c0a5edf);
    $parcel$export(module.exports, "cloneSourceShallow", ()=>$175c1a118c738be0$export$e0365e7e3555ddd4);
    $parcel$export(module.exports, "shouldRetrieveDataByName", ()=>$175c1a118c738be0$export$8911336b527f8517);
    var $bahqM;
    var $2Rbm1;
    var $eaKsF;
    var $cNGs8;
    var $175c1a118c738be0$var$SourceImpl = function() {
        function SourceImpl(fields) {
            this.data = fields.data || (fields.sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_KEYED_COLUMNS) ? {} : []);
            this.sourceFormat = fields.sourceFormat || (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_UNKNOWN);
            this.seriesLayoutBy = fields.seriesLayoutBy || (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_COLUMN);
            this.startIndex = fields.startIndex || 0;
            this.dimensionsDetectedCount = fields.dimensionsDetectedCount;
            this.metaRawOption = fields.metaRawOption;
            var dimensionsDefine = this.dimensionsDefine = fields.dimensionsDefine;
            if (dimensionsDefine) for(var i = 0; i < dimensionsDefine.length; i++){
                var dim = dimensionsDefine[i];
                if (dim.type == null) {
                    if ((0, (0, parcelRequire("cNGs8")).guessOrdinal)(this, i) === (0, (0, parcelRequire("cNGs8")).BE_ORDINAL).Must) dim.type = 'ordinal';
                }
            }
        }
        return SourceImpl;
    }();
    function $175c1a118c738be0$export$22b808bc02a60488(val) {
        return val instanceof $175c1a118c738be0$var$SourceImpl;
    }
    function $175c1a118c738be0$export$1921362e86c73c88(sourceData, thisMetaRawOption, sourceFormat) {
        sourceFormat = sourceFormat || $175c1a118c738be0$export$52a469afa4653e57(sourceData);
        var seriesLayoutBy = thisMetaRawOption.seriesLayoutBy;
        var determined = $175c1a118c738be0$var$determineSourceDimensions(sourceData, sourceFormat, seriesLayoutBy, thisMetaRawOption.sourceHeader, thisMetaRawOption.dimensions);
        var source = new $175c1a118c738be0$var$SourceImpl({
            data: sourceData,
            sourceFormat: sourceFormat,
            seriesLayoutBy: seriesLayoutBy,
            dimensionsDefine: determined.dimensionsDefine,
            startIndex: determined.startIndex,
            dimensionsDetectedCount: determined.dimensionsDetectedCount,
            metaRawOption: (0, (0, parcelRequire("bahqM")).clone)(thisMetaRawOption)
        });
        return source;
    }
    function $175c1a118c738be0$export$75aef3f97c0a5edf(data) {
        return new $175c1a118c738be0$var$SourceImpl({
            data: data,
            sourceFormat: (0, (0, parcelRequire("bahqM")).isTypedArray)(data) ? (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_TYPED_ARRAY) : (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL)
        });
    }
    function $175c1a118c738be0$export$e0365e7e3555ddd4(source) {
        return new $175c1a118c738be0$var$SourceImpl({
            data: source.data,
            sourceFormat: source.sourceFormat,
            seriesLayoutBy: source.seriesLayoutBy,
            dimensionsDefine: (0, (0, parcelRequire("bahqM")).clone)(source.dimensionsDefine),
            startIndex: source.startIndex,
            dimensionsDetectedCount: source.dimensionsDetectedCount
        });
    }
    function $175c1a118c738be0$export$52a469afa4653e57(data) {
        var sourceFormat = (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_UNKNOWN);
        if ((0, (0, parcelRequire("bahqM")).isTypedArray)(data)) sourceFormat = (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_TYPED_ARRAY);
        else if ((0, (0, parcelRequire("bahqM")).isArray)(data)) {
            if (data.length === 0) sourceFormat = (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS);
            for(var i = 0, len = data.length; i < len; i++){
                var item = data[i];
                if (item == null) continue;
                else if ((0, (0, parcelRequire("bahqM")).isArray)(item)) {
                    sourceFormat = (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS);
                    break;
                } else if ((0, (0, parcelRequire("bahqM")).isObject)(item)) {
                    sourceFormat = (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS);
                    break;
                }
            }
        } else if ((0, (0, parcelRequire("bahqM")).isObject)(data)) {
            for(var key in data)if ((0, (0, parcelRequire("bahqM")).hasOwn)(data, key) && (0, (0, parcelRequire("bahqM")).isArrayLike)(data[key])) {
                sourceFormat = (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_KEYED_COLUMNS);
                break;
            }
        }
        return sourceFormat;
    }
    function $175c1a118c738be0$var$determineSourceDimensions(data, sourceFormat, seriesLayoutBy, sourceHeader, dimensionsDefine) {
        var dimensionsDetectedCount;
        var startIndex;
        if (!data) return {
            dimensionsDefine: $175c1a118c738be0$var$normalizeDimensionsOption(dimensionsDefine),
            startIndex: startIndex,
            dimensionsDetectedCount: dimensionsDetectedCount
        };
        if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS)) {
            var dataArrayRows = data;
            if (sourceHeader === 'auto' || sourceHeader == null) $175c1a118c738be0$var$arrayRowsTravelFirst(function(val) {
                if (val != null && val !== '-') {
                    if ((0, (0, parcelRequire("bahqM")).isString)(val)) startIndex == null && (startIndex = 1);
                    else startIndex = 0;
                }
            }, seriesLayoutBy, dataArrayRows, 10);
            else startIndex = (0, (0, parcelRequire("bahqM")).isNumber)(sourceHeader) ? sourceHeader : sourceHeader ? 1 : 0;
            if (!dimensionsDefine && startIndex === 1) {
                dimensionsDefine = [];
                $175c1a118c738be0$var$arrayRowsTravelFirst(function(val, index) {
                    dimensionsDefine[index] = val != null ? val + '' : '';
                }, seriesLayoutBy, dataArrayRows, Infinity);
            }
            dimensionsDetectedCount = dimensionsDefine ? dimensionsDefine.length : seriesLayoutBy === (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_ROW) ? dataArrayRows.length : dataArrayRows[0] ? dataArrayRows[0].length : null;
        } else if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS)) {
            if (!dimensionsDefine) dimensionsDefine = $175c1a118c738be0$var$objectRowsCollectDimensions(data);
        } else if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_KEYED_COLUMNS)) {
            if (!dimensionsDefine) {
                dimensionsDefine = [];
                (0, (0, parcelRequire("bahqM")).each)(data, function(colArr, key) {
                    dimensionsDefine.push(key);
                });
            }
        } else if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL)) {
            var value0 = (0, (0, parcelRequire("eaKsF")).getDataItemValue)(data[0]);
            dimensionsDetectedCount = (0, (0, parcelRequire("bahqM")).isArray)(value0) && value0.length || 1;
        }
        return {
            startIndex: startIndex,
            dimensionsDefine: $175c1a118c738be0$var$normalizeDimensionsOption(dimensionsDefine),
            dimensionsDetectedCount: dimensionsDetectedCount
        };
    }
    function $175c1a118c738be0$var$objectRowsCollectDimensions(data) {
        var firstIndex = 0;
        var obj;
        while(firstIndex < data.length && !(obj = data[firstIndex++]));
        if (obj) {
            var dimensions_1 = [];
            (0, (0, parcelRequire("bahqM")).each)(obj, function(value, key) {
                dimensions_1.push(key);
            });
            return dimensions_1;
        }
    }
    function $175c1a118c738be0$var$normalizeDimensionsOption(dimensionsDefine) {
        if (!dimensionsDefine) return;
        var nameMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        return (0, (0, parcelRequire("bahqM")).map)(dimensionsDefine, function(rawItem, index) {
            rawItem = (0, (0, parcelRequire("bahqM")).isObject)(rawItem) ? rawItem : {
                name: rawItem
            };
            var item = {
                name: rawItem.name,
                displayName: rawItem.displayName,
                type: rawItem.type
            };
            if (item.name == null) return item;
            item.name += '';
            if (item.displayName == null) item.displayName = item.name;
            var exist = nameMap.get(item.name);
            if (!exist) nameMap.set(item.name, {
                count: 1
            });
            else item.name += '-' + exist.count++;
            return item;
        });
    }
    function $175c1a118c738be0$var$arrayRowsTravelFirst(cb, seriesLayoutBy, data, maxLoop) {
        if (seriesLayoutBy === (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_ROW)) for(var i = 0; i < data.length && i < maxLoop; i++)cb(data[i] ? data[i][0] : null, i);
        else {
            var value0 = data[0] || [];
            for(var i = 0; i < value0.length && i < maxLoop; i++)cb(value0[i], i);
        }
    }
    function $175c1a118c738be0$export$8911336b527f8517(source) {
        var sourceFormat = source.sourceFormat;
        return sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS) || sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_KEYED_COLUMNS);
    }
});
parcelRegister("2Rbm1", function(module, exports) {
    $parcel$export(module.exports, "VISUAL_DIMENSIONS", ()=>$214956bc17bbe3d3$export$cd51b5ca77f6f0e4);
    $parcel$export(module.exports, "SOURCE_FORMAT_ORIGINAL", ()=>$214956bc17bbe3d3$export$2823037fb9d8f0c6);
    $parcel$export(module.exports, "SOURCE_FORMAT_ARRAY_ROWS", ()=>$214956bc17bbe3d3$export$fcd62ebf51387903);
    $parcel$export(module.exports, "SOURCE_FORMAT_OBJECT_ROWS", ()=>$214956bc17bbe3d3$export$703ae8a2d83f441);
    $parcel$export(module.exports, "SOURCE_FORMAT_KEYED_COLUMNS", ()=>$214956bc17bbe3d3$export$6a32b42c754a3cb8);
    $parcel$export(module.exports, "SOURCE_FORMAT_TYPED_ARRAY", ()=>$214956bc17bbe3d3$export$a918cb016a382d45);
    $parcel$export(module.exports, "SOURCE_FORMAT_UNKNOWN", ()=>$214956bc17bbe3d3$export$c78f1330778d30d);
    $parcel$export(module.exports, "SERIES_LAYOUT_BY_COLUMN", ()=>$214956bc17bbe3d3$export$7b3f3c6551b4949b);
    $parcel$export(module.exports, "SERIES_LAYOUT_BY_ROW", ()=>$214956bc17bbe3d3$export$d55da1467cdf7804);
    var $bahqM;
    var $214956bc17bbe3d3$export$cd51b5ca77f6f0e4 = (0, (0, parcelRequire("bahqM")).createHashMap)([
        'tooltip',
        'label',
        'itemName',
        'itemId',
        'itemGroupId',
        'seriesName'
    ]);
    var $214956bc17bbe3d3$export$2823037fb9d8f0c6 = 'original';
    var $214956bc17bbe3d3$export$fcd62ebf51387903 = 'arrayRows';
    var $214956bc17bbe3d3$export$703ae8a2d83f441 = 'objectRows';
    var $214956bc17bbe3d3$export$6a32b42c754a3cb8 = 'keyedColumns';
    var $214956bc17bbe3d3$export$a918cb016a382d45 = 'typedArray';
    var $214956bc17bbe3d3$export$c78f1330778d30d = 'unknown';
    var $214956bc17bbe3d3$export$7b3f3c6551b4949b = 'column';
    var $214956bc17bbe3d3$export$d55da1467cdf7804 = 'row';
});
parcelRegister("cNGs8", function(module, exports) {
    $parcel$export(module.exports, "BE_ORDINAL", ()=>$951afdda7935b9af$export$328749e9c5b40760);
    $parcel$export(module.exports, "resetSourceDefaulter", ()=>$951afdda7935b9af$export$b30cdea50aa00e6);
    $parcel$export(module.exports, "makeSeriesEncodeForAxisCoordSys", ()=>$951afdda7935b9af$export$37682b8fdd2e83d);
    $parcel$export(module.exports, "querySeriesUpstreamDatasetModel", ()=>$951afdda7935b9af$export$8da66f73a1eda454);
    $parcel$export(module.exports, "makeSeriesEncodeForNameBased", ()=>$951afdda7935b9af$export$60b8a57d1f2fed26);
    $parcel$export(module.exports, "queryDatasetUpstreamDatasetModels", ()=>$951afdda7935b9af$export$397ba553479711e7);
    $parcel$export(module.exports, "guessOrdinal", ()=>$951afdda7935b9af$export$c51adf1a2be01b9c);
    var $eaKsF;
    var $bahqM;
    var $2Rbm1;
    var $951afdda7935b9af$export$328749e9c5b40760 = {
        Must: 1,
        Might: 2,
        Not: 3
    };
    var $951afdda7935b9af$var$innerGlobalModel = (0, (0, parcelRequire("eaKsF")).makeInner)();
    function $951afdda7935b9af$export$b30cdea50aa00e6(ecModel) {
        $951afdda7935b9af$var$innerGlobalModel(ecModel).datasetMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
    }
    function $951afdda7935b9af$export$37682b8fdd2e83d(coordDimensions, seriesModel, source) {
        var encode = {};
        var datasetModel = $951afdda7935b9af$export$8da66f73a1eda454(seriesModel);
        if (!datasetModel || !coordDimensions) return encode;
        var encodeItemName = [];
        var encodeSeriesName = [];
        var ecModel = seriesModel.ecModel;
        var datasetMap = $951afdda7935b9af$var$innerGlobalModel(ecModel).datasetMap;
        var key = datasetModel.uid + '_' + source.seriesLayoutBy;
        var baseCategoryDimIndex;
        var categoryWayValueDimStart;
        coordDimensions = coordDimensions.slice();
        (0, (0, parcelRequire("bahqM")).each)(coordDimensions, function(coordDimInfoLoose, coordDimIdx) {
            var coordDimInfo = (0, (0, parcelRequire("bahqM")).isObject)(coordDimInfoLoose) ? coordDimInfoLoose : coordDimensions[coordDimIdx] = {
                name: coordDimInfoLoose
            };
            if (coordDimInfo.type === 'ordinal' && baseCategoryDimIndex == null) {
                baseCategoryDimIndex = coordDimIdx;
                categoryWayValueDimStart = getDataDimCountOnCoordDim(coordDimInfo);
            }
            encode[coordDimInfo.name] = [];
        });
        var datasetRecord = datasetMap.get(key) || datasetMap.set(key, {
            categoryWayDim: categoryWayValueDimStart,
            valueWayDim: 0
        });
        (0, (0, parcelRequire("bahqM")).each)(coordDimensions, function(coordDimInfo, coordDimIdx) {
            var coordDimName = coordDimInfo.name;
            var count = getDataDimCountOnCoordDim(coordDimInfo);
            if (baseCategoryDimIndex == null) {
                var start = datasetRecord.valueWayDim;
                pushDim(encode[coordDimName], start, count);
                pushDim(encodeSeriesName, start, count);
                datasetRecord.valueWayDim += count;
            } else if (baseCategoryDimIndex === coordDimIdx) {
                pushDim(encode[coordDimName], 0, count);
                pushDim(encodeItemName, 0, count);
            } else {
                var start = datasetRecord.categoryWayDim;
                pushDim(encode[coordDimName], start, count);
                pushDim(encodeSeriesName, start, count);
                datasetRecord.categoryWayDim += count;
            }
        });
        function pushDim(dimIdxArr, idxFrom, idxCount) {
            for(var i = 0; i < idxCount; i++)dimIdxArr.push(idxFrom + i);
        }
        function getDataDimCountOnCoordDim(coordDimInfo) {
            var dimsDef = coordDimInfo.dimsDef;
            return dimsDef ? dimsDef.length : 1;
        }
        encodeItemName.length && (encode.itemName = encodeItemName);
        encodeSeriesName.length && (encode.seriesName = encodeSeriesName);
        return encode;
    }
    function $951afdda7935b9af$export$60b8a57d1f2fed26(seriesModel, source, dimCount) {
        var encode = {};
        var datasetModel = $951afdda7935b9af$export$8da66f73a1eda454(seriesModel);
        if (!datasetModel) return encode;
        var sourceFormat = source.sourceFormat;
        var dimensionsDefine = source.dimensionsDefine;
        var potentialNameDimIndex;
        if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS) || sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_KEYED_COLUMNS)) (0, (0, parcelRequire("bahqM")).each)(dimensionsDefine, function(dim, idx) {
            if (((0, (0, parcelRequire("bahqM")).isObject)(dim) ? dim.name : dim) === 'name') potentialNameDimIndex = idx;
        });
        var idxResult = function() {
            var idxRes0 = {};
            var idxRes1 = {};
            var guessRecords = [];
            for(var i = 0, len = Math.min(5, dimCount); i < len; i++){
                var guessResult = $951afdda7935b9af$var$doGuessOrdinal(source.data, sourceFormat, source.seriesLayoutBy, dimensionsDefine, source.startIndex, i);
                guessRecords.push(guessResult);
                var isPureNumber = guessResult === $951afdda7935b9af$export$328749e9c5b40760.Not;
                if (isPureNumber && idxRes0.v == null && i !== potentialNameDimIndex) idxRes0.v = i;
                if (idxRes0.n == null || idxRes0.n === idxRes0.v || !isPureNumber && guessRecords[idxRes0.n] === $951afdda7935b9af$export$328749e9c5b40760.Not) idxRes0.n = i;
                if (fulfilled(idxRes0) && guessRecords[idxRes0.n] !== $951afdda7935b9af$export$328749e9c5b40760.Not) return idxRes0;
                if (!isPureNumber) {
                    if (guessResult === $951afdda7935b9af$export$328749e9c5b40760.Might && idxRes1.v == null && i !== potentialNameDimIndex) idxRes1.v = i;
                    if (idxRes1.n == null || idxRes1.n === idxRes1.v) idxRes1.n = i;
                }
            }
            function fulfilled(idxResult) {
                return idxResult.v != null && idxResult.n != null;
            }
            return fulfilled(idxRes0) ? idxRes0 : fulfilled(idxRes1) ? idxRes1 : null;
        }();
        if (idxResult) {
            encode.value = [
                idxResult.v
            ];
            var nameDimIndex = potentialNameDimIndex != null ? potentialNameDimIndex : idxResult.n;
            encode.itemName = [
                nameDimIndex
            ];
            encode.seriesName = [
                nameDimIndex
            ];
        }
        return encode;
    }
    function $951afdda7935b9af$export$8da66f73a1eda454(seriesModel) {
        var thisData = seriesModel.get('data', true);
        if (!thisData) return (0, (0, parcelRequire("eaKsF")).queryReferringComponents)(seriesModel.ecModel, 'dataset', {
            index: seriesModel.get('datasetIndex', true),
            id: seriesModel.get('datasetId', true)
        }, (0, (0, parcelRequire("eaKsF")).SINGLE_REFERRING)).models[0];
    }
    function $951afdda7935b9af$export$397ba553479711e7(datasetModel) {
        if (!datasetModel.get('transform', true) && !datasetModel.get('fromTransformResult', true)) return [];
        return (0, (0, parcelRequire("eaKsF")).queryReferringComponents)(datasetModel.ecModel, 'dataset', {
            index: datasetModel.get('fromDatasetIndex', true),
            id: datasetModel.get('fromDatasetId', true)
        }, (0, (0, parcelRequire("eaKsF")).SINGLE_REFERRING)).models;
    }
    function $951afdda7935b9af$export$c51adf1a2be01b9c(source, dimIndex) {
        return $951afdda7935b9af$var$doGuessOrdinal(source.data, source.sourceFormat, source.seriesLayoutBy, source.dimensionsDefine, source.startIndex, dimIndex);
    }
    function $951afdda7935b9af$var$doGuessOrdinal(data, sourceFormat, seriesLayoutBy, dimensionsDefine, startIndex, dimIndex) {
        var result;
        var maxLoop = 5;
        if ((0, (0, parcelRequire("bahqM")).isTypedArray)(data)) return $951afdda7935b9af$export$328749e9c5b40760.Not;
        var dimName;
        var dimType;
        if (dimensionsDefine) {
            var dimDefItem = dimensionsDefine[dimIndex];
            if ((0, (0, parcelRequire("bahqM")).isObject)(dimDefItem)) {
                dimName = dimDefItem.name;
                dimType = dimDefItem.type;
            } else if ((0, (0, parcelRequire("bahqM")).isString)(dimDefItem)) dimName = dimDefItem;
        }
        if (dimType != null) return dimType === 'ordinal' ? $951afdda7935b9af$export$328749e9c5b40760.Must : $951afdda7935b9af$export$328749e9c5b40760.Not;
        if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS)) {
            var dataArrayRows = data;
            if (seriesLayoutBy === (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_ROW)) {
                var sample = dataArrayRows[dimIndex];
                for(var i = 0; i < (sample || []).length && i < maxLoop; i++){
                    if ((result = detectValue(sample[startIndex + i])) != null) return result;
                }
            } else for(var i = 0; i < dataArrayRows.length && i < maxLoop; i++){
                var row = dataArrayRows[startIndex + i];
                if (row && (result = detectValue(row[dimIndex])) != null) return result;
            }
        } else if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS)) {
            var dataObjectRows = data;
            if (!dimName) return $951afdda7935b9af$export$328749e9c5b40760.Not;
            for(var i = 0; i < dataObjectRows.length && i < maxLoop; i++){
                var item = dataObjectRows[i];
                if (item && (result = detectValue(item[dimName])) != null) return result;
            }
        } else if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_KEYED_COLUMNS)) {
            var dataKeyedColumns = data;
            if (!dimName) return $951afdda7935b9af$export$328749e9c5b40760.Not;
            var sample = dataKeyedColumns[dimName];
            if (!sample || (0, (0, parcelRequire("bahqM")).isTypedArray)(sample)) return $951afdda7935b9af$export$328749e9c5b40760.Not;
            for(var i = 0; i < sample.length && i < maxLoop; i++){
                if ((result = detectValue(sample[i])) != null) return result;
            }
        } else if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL)) {
            var dataOriginal = data;
            for(var i = 0; i < dataOriginal.length && i < maxLoop; i++){
                var item = dataOriginal[i];
                var val = (0, (0, parcelRequire("eaKsF")).getDataItemValue)(item);
                if (!(0, (0, parcelRequire("bahqM")).isArray)(val)) return $951afdda7935b9af$export$328749e9c5b40760.Not;
                if ((result = detectValue(val[dimIndex])) != null) return result;
            }
        }
        function detectValue(val) {
            var beStr = (0, (0, parcelRequire("bahqM")).isString)(val);
            if (val != null && isFinite(val) && val !== '') return beStr ? $951afdda7935b9af$export$328749e9c5b40760.Might : $951afdda7935b9af$export$328749e9c5b40760.Not;
            else if (beStr && val !== '-') return $951afdda7935b9af$export$328749e9c5b40760.Must;
        }
        return $951afdda7935b9af$export$328749e9c5b40760.Not;
    }
});
parcelRegister("9irlK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c4b0292c57cf773$export$2e2bcd8739ae039);
    var $eaKsF;
    function $6c4b0292c57cf773$export$2e2bcd8739ae039() {
        var inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
        return function(seriesModel) {
            var fields = inner(seriesModel);
            var pipelineContext = seriesModel.pipelineContext;
            var originalLarge = !!fields.large;
            var originalProgressive = !!fields.progressiveRender;
            var large = fields.large = !!(pipelineContext && pipelineContext.large);
            var progressive = fields.progressiveRender = !!(pipelineContext && pipelineContext.progressiveRender);
            return !!(originalLarge !== large || originalProgressive !== progressive) && 'reset';
        };
    }
});
parcelRegister("7jcIW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$55242d779d1fe9b5$export$2e2bcd8739ae039);
    var $55242d779d1fe9b5$var$samplers = {
        average: function(frame) {
            var sum = 0;
            var count = 0;
            for(var i = 0; i < frame.length; i++)if (!isNaN(frame[i])) {
                sum += frame[i];
                count++;
            }
            return count === 0 ? NaN : sum / count;
        },
        sum: function(frame) {
            var sum = 0;
            for(var i = 0; i < frame.length; i++)sum += frame[i] || 0;
            return sum;
        },
        max: function(frame) {
            var max = -Infinity;
            for(var i = 0; i < frame.length; i++)frame[i] > max && (max = frame[i]);
            return isFinite(max) ? max : NaN;
        },
        min: function(frame) {
            var min = Infinity;
            for(var i = 0; i < frame.length; i++)frame[i] < min && (min = frame[i]);
            return isFinite(min) ? min : NaN;
        },
        nearest: function(frame) {
            return frame[0];
        }
    };
    var $55242d779d1fe9b5$var$indexSampler = function(frame) {
        return Math.round(frame.length / 2);
    };
    function $55242d779d1fe9b5$export$2e2bcd8739ae039(seriesType) {
        return {
            seriesType: seriesType,
            reset: function(seriesModel, ecModel, api) {
                var data = seriesModel.getData();
                var sampling = seriesModel.get('sampling');
                var coordSys = seriesModel.coordinateSystem;
                var count = data.count();
                if (count > 10 && coordSys.type === 'cartesian2d' && sampling) {
                    var baseAxis = coordSys.getBaseAxis();
                    var valueAxis = coordSys.getOtherAxis(baseAxis);
                    var extent = baseAxis.getExtent();
                    var dpr = api.getDevicePixelRatio();
                    var size = Math.abs(extent[1] - extent[0]) * (dpr || 1);
                    var rate = Math.round(count / size);
                    if (rate > 1) {
                        if (sampling === 'lttb') seriesModel.setData(data.lttbDownSample(data.mapDimension(valueAxis.dim), 1 / rate));
                        var sampler = void 0;
                        if (typeof sampling === 'string') sampler = $55242d779d1fe9b5$var$samplers[sampling];
                        else if (typeof sampling === 'function') sampler = sampling;
                        if (sampler) seriesModel.setData(data.downSample(data.mapDimension(valueAxis.dim), 1 / rate, sampler, $55242d779d1fe9b5$var$indexSampler));
                    }
                }
            }
        };
    }
});
parcelRegister("1b1Ai", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0db80c291205dc61$export$2e2bcd8739ae039);
    var $3VFsf;
    var $6GWLU;
    var $bAY5l;
    var $jvo6O;
    var $0db80c291205dc61$var$BarSeriesModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(BarSeriesModel, _super);
        function BarSeriesModel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = BarSeriesModel.type;
            return _this;
        }
        BarSeriesModel.prototype.getInitialData = function() {
            return (0, (0, parcelRequire("bAY5l")).default)(null, this, {
                useEncodeDefaulter: true,
                createInvertedIndices: !!this.get('realtimeSort', true) || null
            });
        };
        BarSeriesModel.prototype.getProgressive = function() {
            return this.get('large') ? this.get('progressive') : false;
        };
        BarSeriesModel.prototype.getProgressiveThreshold = function() {
            var progressiveThreshold = this.get('progressiveThreshold');
            var largeThreshold = this.get('largeThreshold');
            if (largeThreshold > progressiveThreshold) progressiveThreshold = largeThreshold;
            return progressiveThreshold;
        };
        BarSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
            return selectors.rect(data.getItemLayout(dataIndex));
        };
        BarSeriesModel.type = 'series.bar';
        BarSeriesModel.dependencies = [
            'grid',
            'polar'
        ];
        BarSeriesModel.defaultOption = (0, (0, parcelRequire("jvo6O")).inheritDefaultOption)((0, (0, parcelRequire("6GWLU")).default).defaultOption, {
            clip: true,
            roundCap: false,
            showBackground: false,
            backgroundStyle: {
                color: 'rgba(180, 180, 180, 0.2)',
                borderColor: null,
                borderWidth: 0,
                borderType: 'solid',
                borderRadius: 0,
                shadowBlur: 0,
                shadowColor: null,
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                opacity: 1
            },
            select: {
                itemStyle: {
                    borderColor: '#212121'
                }
            },
            realtimeSort: false
        });
        return BarSeriesModel;
    }((0, (0, parcelRequire("6GWLU")).default));
    var $0db80c291205dc61$export$2e2bcd8739ae039 = $0db80c291205dc61$var$BarSeriesModel;
});
parcelRegister("6GWLU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4df4412f90ffd718$export$2e2bcd8739ae039);
    var $3VFsf;
    var $1O7Ua;
    var $bAY5l;
    var $4df4412f90ffd718$var$BaseBarSeriesModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(BaseBarSeriesModel, _super);
        function BaseBarSeriesModel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = BaseBarSeriesModel.type;
            return _this;
        }
        BaseBarSeriesModel.prototype.getInitialData = function(option, ecModel) {
            return (0, (0, parcelRequire("bAY5l")).default)(null, this, {
                useEncodeDefaulter: true
            });
        };
        BaseBarSeriesModel.prototype.getMarkerPosition = function(value) {
            var coordSys = this.coordinateSystem;
            if (coordSys && coordSys.clampData) {
                var pt = coordSys.dataToPoint(coordSys.clampData(value));
                var data = this.getData();
                var offset = data.getLayout('offset');
                var size = data.getLayout('size');
                var offsetIndex = coordSys.getBaseAxis().isHorizontal() ? 0 : 1;
                pt[offsetIndex] += offset + size / 2;
                return pt;
            }
            return [
                NaN,
                NaN
            ];
        };
        BaseBarSeriesModel.type = 'series.__base_bar__';
        BaseBarSeriesModel.defaultOption = {
            zlevel: 0,
            z: 2,
            coordinateSystem: 'cartesian2d',
            legendHoverLink: true,
            barMinHeight: 0,
            barMinAngle: 0,
            large: false,
            largeThreshold: 400,
            progressive: 3e3,
            progressiveChunkMode: 'mod'
        };
        return BaseBarSeriesModel;
    }((0, (0, parcelRequire("1O7Ua")).default));
    (0, (0, parcelRequire("1O7Ua")).default).registerClass($4df4412f90ffd718$var$BaseBarSeriesModel);
    var $4df4412f90ffd718$export$2e2bcd8739ae039 = $4df4412f90ffd718$var$BaseBarSeriesModel;
});
parcelRegister("1O7Ua", function(module, exports) {
    $parcel$export(module.exports, "SERIES_UNIVERSAL_TRANSITION_PROP", ()=>$151097b3612ce5ca$export$e960441116ae2799);
    $parcel$export(module.exports, "default", ()=>$151097b3612ce5ca$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bahqM;
    var $hZfwb;
    var $eaKsF;
    var $h4UlH;
    var $aCu4v;
    var $guzSc;
    var $65MS1;
    var $92IK1;
    var $aLwh0;
    var $jTNWo;
    var $d88IV;
    var $151097b3612ce5ca$var$inner = (0, parcelRequire("eaKsF")).makeInner();
    function $151097b3612ce5ca$var$getSelectionKey(data, dataIndex) {
        return data.getName(dataIndex) || data.getId(dataIndex);
    }
    var $151097b3612ce5ca$export$e960441116ae2799 = '__universalTransitionEnabled';
    var $151097b3612ce5ca$var$SeriesModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(SeriesModel, _super);
        function SeriesModel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this._selectedDataIndicesMap = {};
            return _this;
        }
        SeriesModel.prototype.init = function(option, parentModel, ecModel) {
            this.seriesIndex = this.componentIndex;
            this.dataTask = (0, (0, parcelRequire("92IK1")).createTask)({
                count: $151097b3612ce5ca$var$dataTaskCount,
                reset: $151097b3612ce5ca$var$dataTaskReset
            });
            this.dataTask.context = {
                model: this
            };
            this.mergeDefaultAndTheme(option, ecModel);
            var sourceManager = $151097b3612ce5ca$var$inner(this).sourceManager = new (0, (0, parcelRequire("jTNWo")).SourceManager)(this);
            sourceManager.prepareSource();
            var data = this.getInitialData(option, ecModel);
            $151097b3612ce5ca$var$wrapData(data, this);
            this.dataTask.context.data = data;
            $151097b3612ce5ca$var$inner(this).dataBeforeProcessed = data;
            $151097b3612ce5ca$var$autoSeriesName(this);
            this._initSelectedMapFromData(data);
        };
        SeriesModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
            var layoutMode = (0, (0, parcelRequire("65MS1")).fetchLayoutMode)(this);
            var inputPositionParams = layoutMode ? (0, (0, parcelRequire("65MS1")).getLayoutParams)(option) : {};
            var themeSubType = this.subType;
            if ((0, (0, parcelRequire("h4UlH")).default).hasClass(themeSubType)) themeSubType += 'Series';
            (0, parcelRequire("bahqM")).merge(option, ecModel.getTheme().get(this.subType));
            (0, parcelRequire("bahqM")).merge(option, this.getDefaultOption());
            (0, parcelRequire("eaKsF")).defaultEmphasis(option, 'label', [
                'show'
            ]);
            this.fillDataTextStyle(option.data);
            if (layoutMode) (0, (0, parcelRequire("65MS1")).mergeLayoutParam)(option, inputPositionParams, layoutMode);
        };
        SeriesModel.prototype.mergeOption = function(newSeriesOption, ecModel) {
            newSeriesOption = (0, parcelRequire("bahqM")).merge(this.option, newSeriesOption, true);
            this.fillDataTextStyle(newSeriesOption.data);
            var layoutMode = (0, (0, parcelRequire("65MS1")).fetchLayoutMode)(this);
            if (layoutMode) (0, (0, parcelRequire("65MS1")).mergeLayoutParam)(this.option, newSeriesOption, layoutMode);
            var sourceManager = $151097b3612ce5ca$var$inner(this).sourceManager;
            sourceManager.dirty();
            sourceManager.prepareSource();
            var data = this.getInitialData(newSeriesOption, ecModel);
            $151097b3612ce5ca$var$wrapData(data, this);
            this.dataTask.dirty();
            this.dataTask.context.data = data;
            $151097b3612ce5ca$var$inner(this).dataBeforeProcessed = data;
            $151097b3612ce5ca$var$autoSeriesName(this);
            this._initSelectedMapFromData(data);
        };
        SeriesModel.prototype.fillDataTextStyle = function(data) {
            if (data && !(0, parcelRequire("bahqM")).isTypedArray(data)) {
                var props = [
                    'show'
                ];
                for(var i = 0; i < data.length; i++)if (data[i] && data[i].label) (0, parcelRequire("eaKsF")).defaultEmphasis(data[i], 'label', props);
            }
        };
        SeriesModel.prototype.getInitialData = function(option, ecModel) {
            return;
        };
        SeriesModel.prototype.appendData = function(params) {
            var data = this.getRawData();
            data.appendData(params.data);
        };
        SeriesModel.prototype.getData = function(dataType) {
            var task = $151097b3612ce5ca$var$getCurrentTask(this);
            if (task) {
                var data = task.context.data;
                return dataType == null ? data : data.getLinkedData(dataType);
            } else return $151097b3612ce5ca$var$inner(this).data;
        };
        SeriesModel.prototype.getAllData = function() {
            var mainData = this.getData();
            return mainData && mainData.getLinkedDataAll ? mainData.getLinkedDataAll() : [
                {
                    data: mainData
                }
            ];
        };
        SeriesModel.prototype.setData = function(data) {
            var task = $151097b3612ce5ca$var$getCurrentTask(this);
            if (task) {
                var context = task.context;
                context.outputData = data;
                if (task !== this.dataTask) context.data = data;
            }
            $151097b3612ce5ca$var$inner(this).data = data;
        };
        SeriesModel.prototype.getEncode = function() {
            var encode = this.get('encode', true);
            if (encode) return (0, parcelRequire("bahqM")).createHashMap(encode);
        };
        SeriesModel.prototype.getSourceManager = function() {
            return $151097b3612ce5ca$var$inner(this).sourceManager;
        };
        SeriesModel.prototype.getSource = function() {
            return this.getSourceManager().getSource();
        };
        SeriesModel.prototype.getRawData = function() {
            return $151097b3612ce5ca$var$inner(this).dataBeforeProcessed;
        };
        SeriesModel.prototype.getColorBy = function() {
            var colorBy = this.get('colorBy');
            return colorBy || 'series';
        };
        SeriesModel.prototype.isColorBySeries = function() {
            return this.getColorBy() === 'series';
        };
        SeriesModel.prototype.getBaseAxis = function() {
            var coordSys = this.coordinateSystem;
            return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
        };
        SeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
            return (0, (0, parcelRequire("d88IV")).defaultSeriesFormatTooltip)({
                series: this,
                dataIndex: dataIndex,
                multipleSeries: multipleSeries
            });
        };
        SeriesModel.prototype.isAnimationEnabled = function() {
            if ((0, (0, parcelRequire("hZfwb")).default).node) return false;
            var animationEnabled = this.getShallow('animation');
            if (animationEnabled) {
                if (this.getData().count() > this.getShallow('animationThreshold')) animationEnabled = false;
            }
            return !!animationEnabled;
        };
        SeriesModel.prototype.restoreData = function() {
            this.dataTask.dirty();
        };
        SeriesModel.prototype.getColorFromPalette = function(name, scope, requestColorNum) {
            var ecModel = this.ecModel;
            var color = (0, (0, parcelRequire("aCu4v")).PaletteMixin).prototype.getColorFromPalette.call(this, name, scope, requestColorNum);
            if (!color) color = ecModel.getColorFromPalette(name, scope, requestColorNum);
            return color;
        };
        SeriesModel.prototype.coordDimToDataDim = function(coordDim) {
            return this.getRawData().mapDimensionsAll(coordDim);
        };
        SeriesModel.prototype.getProgressive = function() {
            return this.get('progressive');
        };
        SeriesModel.prototype.getProgressiveThreshold = function() {
            return this.get('progressiveThreshold');
        };
        SeriesModel.prototype.select = function(innerDataIndices, dataType) {
            this._innerSelect(this.getData(dataType), innerDataIndices);
        };
        SeriesModel.prototype.unselect = function(innerDataIndices, dataType) {
            var selectedMap = this.option.selectedMap;
            if (!selectedMap) return;
            var data = this.getData(dataType);
            for(var i = 0; i < innerDataIndices.length; i++){
                var dataIndex = innerDataIndices[i];
                var nameOrId = $151097b3612ce5ca$var$getSelectionKey(data, dataIndex);
                selectedMap[nameOrId] = false;
                this._selectedDataIndicesMap[nameOrId] = -1;
            }
        };
        SeriesModel.prototype.toggleSelect = function(innerDataIndices, dataType) {
            var tmpArr = [];
            for(var i = 0; i < innerDataIndices.length; i++){
                tmpArr[0] = innerDataIndices[i];
                this.isSelected(innerDataIndices[i], dataType) ? this.unselect(tmpArr, dataType) : this.select(tmpArr, dataType);
            }
        };
        SeriesModel.prototype.getSelectedDataIndices = function() {
            var selectedDataIndicesMap = this._selectedDataIndicesMap;
            var nameOrIds = (0, parcelRequire("bahqM")).keys(selectedDataIndicesMap);
            var dataIndices = [];
            for(var i = 0; i < nameOrIds.length; i++){
                var dataIndex = selectedDataIndicesMap[nameOrIds[i]];
                if (dataIndex >= 0) dataIndices.push(dataIndex);
            }
            return dataIndices;
        };
        SeriesModel.prototype.isSelected = function(dataIndex, dataType) {
            var selectedMap = this.option.selectedMap;
            if (!selectedMap) return false;
            var data = this.getData(dataType);
            var nameOrId = $151097b3612ce5ca$var$getSelectionKey(data, dataIndex);
            return selectedMap[nameOrId] || false;
        };
        SeriesModel.prototype.isUniversalTransitionEnabled = function() {
            if (this[$151097b3612ce5ca$export$e960441116ae2799]) return true;
            var universalTransitionOpt = this.option.universalTransition;
            if (!universalTransitionOpt) return false;
            if (universalTransitionOpt === true) return true;
            return universalTransitionOpt && universalTransitionOpt.enabled;
        };
        SeriesModel.prototype._innerSelect = function(data, innerDataIndices) {
            var _a, _b;
            var selectedMode = this.option.selectedMode;
            var len = innerDataIndices.length;
            if (!selectedMode || !len) return;
            if (selectedMode === 'multiple') {
                var selectedMap = this.option.selectedMap || (this.option.selectedMap = {});
                for(var i = 0; i < len; i++){
                    var dataIndex = innerDataIndices[i];
                    var nameOrId = $151097b3612ce5ca$var$getSelectionKey(data, dataIndex);
                    selectedMap[nameOrId] = true;
                    this._selectedDataIndicesMap[nameOrId] = data.getRawIndex(dataIndex);
                }
            } else if (selectedMode === 'single' || selectedMode === true) {
                var lastDataIndex = innerDataIndices[len - 1];
                var nameOrId = $151097b3612ce5ca$var$getSelectionKey(data, lastDataIndex);
                this.option.selectedMap = (_a = {}, _a[nameOrId] = true, _a);
                this._selectedDataIndicesMap = (_b = {}, _b[nameOrId] = data.getRawIndex(lastDataIndex), _b);
            }
        };
        SeriesModel.prototype._initSelectedMapFromData = function(data) {
            if (this.option.selectedMap) return;
            var dataIndices = [];
            if (data.hasItemOption) data.each(function(idx) {
                var rawItem = data.getRawDataItem(idx);
                if (rawItem && rawItem.selected) dataIndices.push(idx);
            });
            if (dataIndices.length > 0) this._innerSelect(data, dataIndices);
        };
        SeriesModel.registerClass = function(clz) {
            return (0, (0, parcelRequire("h4UlH")).default).registerClass(clz);
        };
        SeriesModel.protoInitialize = function() {
            var proto = SeriesModel.prototype;
            proto.type = 'series.__base__';
            proto.seriesIndex = 0;
            proto.ignoreStyleOnData = false;
            proto.hasSymbolVisual = false;
            proto.defaultSymbol = 'circle';
            proto.visualStyleAccessPath = 'itemStyle';
            proto.visualDrawType = 'fill';
        }();
        return SeriesModel;
    }((0, (0, parcelRequire("h4UlH")).default));
    (0, parcelRequire("bahqM")).mixin($151097b3612ce5ca$var$SeriesModel, (0, (0, parcelRequire("guzSc")).DataFormatMixin));
    (0, parcelRequire("bahqM")).mixin($151097b3612ce5ca$var$SeriesModel, (0, (0, parcelRequire("aCu4v")).PaletteMixin));
    (0, (0, parcelRequire("aLwh0")).mountExtend)($151097b3612ce5ca$var$SeriesModel, (0, (0, parcelRequire("h4UlH")).default));
    function $151097b3612ce5ca$var$autoSeriesName(seriesModel) {
        var name = seriesModel.name;
        if (!(0, parcelRequire("eaKsF")).isNameSpecified(seriesModel)) seriesModel.name = $151097b3612ce5ca$var$getSeriesAutoName(seriesModel) || name;
    }
    function $151097b3612ce5ca$var$getSeriesAutoName(seriesModel) {
        var data = seriesModel.getRawData();
        var dataDims = data.mapDimensionsAll('seriesName');
        var nameArr = [];
        (0, parcelRequire("bahqM")).each(dataDims, function(dataDim) {
            var dimInfo = data.getDimensionInfo(dataDim);
            dimInfo.displayName && nameArr.push(dimInfo.displayName);
        });
        return nameArr.join(' ');
    }
    function $151097b3612ce5ca$var$dataTaskCount(context) {
        return context.model.getRawData().count();
    }
    function $151097b3612ce5ca$var$dataTaskReset(context) {
        var seriesModel = context.model;
        seriesModel.setData(seriesModel.getRawData().cloneShallow());
        return $151097b3612ce5ca$var$dataTaskProgress;
    }
    function $151097b3612ce5ca$var$dataTaskProgress(param, context) {
        if (context.outputData && param.end > context.outputData.count()) context.model.getRawData().cloneShallow(context.outputData);
    }
    function $151097b3612ce5ca$var$wrapData(data, seriesModel) {
        (0, parcelRequire("bahqM")).each((0, parcelRequire("bahqM")).concatArray(data.CHANGABLE_METHODS, data.DOWNSAMPLE_METHODS), function(methodName) {
            data.wrapMethod(methodName, (0, parcelRequire("bahqM")).curry($151097b3612ce5ca$var$onDataChange, seriesModel));
        });
    }
    function $151097b3612ce5ca$var$onDataChange(seriesModel, newList) {
        var task = $151097b3612ce5ca$var$getCurrentTask(seriesModel);
        if (task) task.setOutputEnd((newList || this).count());
        return newList;
    }
    function $151097b3612ce5ca$var$getCurrentTask(seriesModel) {
        var scheduler = (seriesModel.ecModel || {}).scheduler;
        var pipeline = scheduler && scheduler.getPipeline(seriesModel.uid);
        if (pipeline) {
            var task = pipeline.currentTask;
            if (task) {
                var agentStubMap = task.agentStubMap;
                if (agentStubMap) task = agentStubMap.get(seriesModel.uid);
            }
            return task;
        }
    }
    var $151097b3612ce5ca$export$2e2bcd8739ae039 = $151097b3612ce5ca$var$SeriesModel;
});
parcelRegister("h4UlH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c6ee8520f4778ed8$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bahqM;
    var $gaMkj;
    var $jvo6O;
    var $aLwh0;
    var $eaKsF;
    var $65MS1;
    var $c6ee8520f4778ed8$var$inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $c6ee8520f4778ed8$var$ComponentModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ComponentModel, _super);
        function ComponentModel(option, parentModel, ecModel) {
            var _this = _super.call(this, option, parentModel, ecModel) || this;
            _this.uid = (0, parcelRequire("jvo6O")).getUID('ec_cpt_model');
            return _this;
        }
        ComponentModel.prototype.init = function(option, parentModel, ecModel) {
            this.mergeDefaultAndTheme(option, ecModel);
        };
        ComponentModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
            var layoutMode = (0, parcelRequire("65MS1")).fetchLayoutMode(this);
            var inputPositionParams = layoutMode ? (0, parcelRequire("65MS1")).getLayoutParams(option) : {};
            var themeModel = ecModel.getTheme();
            (0, parcelRequire("bahqM")).merge(option, themeModel.get(this.mainType));
            (0, parcelRequire("bahqM")).merge(option, this.getDefaultOption());
            if (layoutMode) (0, parcelRequire("65MS1")).mergeLayoutParam(option, inputPositionParams, layoutMode);
        };
        ComponentModel.prototype.mergeOption = function(option, ecModel) {
            (0, parcelRequire("bahqM")).merge(this.option, option, true);
            var layoutMode = (0, parcelRequire("65MS1")).fetchLayoutMode(this);
            if (layoutMode) (0, parcelRequire("65MS1")).mergeLayoutParam(this.option, option, layoutMode);
        };
        ComponentModel.prototype.optionUpdated = function(newCptOption, isInit) {};
        ComponentModel.prototype.getDefaultOption = function() {
            var ctor = this.constructor;
            if (!(0, (0, parcelRequire("aLwh0")).isExtendedClass)(ctor)) return ctor.defaultOption;
            var fields = $c6ee8520f4778ed8$var$inner(this);
            if (!fields.defaultOption) {
                var optList = [];
                var clz = ctor;
                while(clz){
                    var opt = clz.prototype.defaultOption;
                    opt && optList.push(opt);
                    clz = clz.superClass;
                }
                var defaultOption = {};
                for(var i = optList.length - 1; i >= 0; i--)defaultOption = (0, parcelRequire("bahqM")).merge(defaultOption, optList[i], true);
                fields.defaultOption = defaultOption;
            }
            return fields.defaultOption;
        };
        ComponentModel.prototype.getReferringComponents = function(mainType, opt) {
            var indexKey = mainType + 'Index';
            var idKey = mainType + 'Id';
            return (0, (0, parcelRequire("eaKsF")).queryReferringComponents)(this.ecModel, mainType, {
                index: this.get(indexKey, true),
                id: this.get(idKey, true)
            }, opt);
        };
        ComponentModel.prototype.getBoxLayoutParams = function() {
            var boxLayoutModel = this;
            return {
                left: boxLayoutModel.get('left'),
                top: boxLayoutModel.get('top'),
                right: boxLayoutModel.get('right'),
                bottom: boxLayoutModel.get('bottom'),
                width: boxLayoutModel.get('width'),
                height: boxLayoutModel.get('height')
            };
        };
        ComponentModel.protoInitialize = function() {
            var proto = ComponentModel.prototype;
            proto.type = 'component';
            proto.id = '';
            proto.name = '';
            proto.mainType = '';
            proto.subType = '';
            proto.componentIndex = 0;
        }();
        return ComponentModel;
    }((0, (0, parcelRequire("gaMkj")).default));
    (0, (0, parcelRequire("aLwh0")).mountExtend)($c6ee8520f4778ed8$var$ComponentModel, (0, (0, parcelRequire("gaMkj")).default));
    (0, (0, parcelRequire("aLwh0")).enableClassManagement)($c6ee8520f4778ed8$var$ComponentModel);
    (0, parcelRequire("jvo6O")).enableSubTypeDefaulter($c6ee8520f4778ed8$var$ComponentModel);
    (0, parcelRequire("jvo6O")).enableTopologicalTravel($c6ee8520f4778ed8$var$ComponentModel, $c6ee8520f4778ed8$var$getDependencies);
    function $c6ee8520f4778ed8$var$getDependencies(componentType) {
        var deps = [];
        (0, parcelRequire("bahqM")).each($c6ee8520f4778ed8$var$ComponentModel.getClassesByMainType(componentType), function(clz) {
            deps = deps.concat(clz.dependencies || clz.prototype.dependencies || []);
        });
        deps = (0, parcelRequire("bahqM")).map(deps, function(type) {
            return (0, (0, parcelRequire("aLwh0")).parseClassType)(type).main;
        });
        if (componentType !== 'dataset' && (0, parcelRequire("bahqM")).indexOf(deps, 'dataset') <= 0) deps.unshift('dataset');
        return deps;
    }
    var $c6ee8520f4778ed8$export$2e2bcd8739ae039 = $c6ee8520f4778ed8$var$ComponentModel;
});
parcelRegister("gaMkj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc63113067804ddc$export$2e2bcd8739ae039);
    var $hZfwb;
    var $aLwh0;
    var $8P3Or;
    var $hyGik;
    var $46U6E;
    var $4rldO;
    var $bahqM;
    var $bc63113067804ddc$var$Model = function() {
        function Model(option, parentModel, ecModel) {
            this.parentModel = parentModel;
            this.ecModel = ecModel;
            this.option = option;
        }
        Model.prototype.init = function(option, parentModel, ecModel) {
            var rest = [];
            for(var _i = 3; _i < arguments.length; _i++)rest[_i - 3] = arguments[_i];
        };
        Model.prototype.mergeOption = function(option, ecModel) {
            (0, (0, parcelRequire("bahqM")).merge)(this.option, option, true);
        };
        Model.prototype.get = function(path, ignoreParent) {
            if (path == null) return this.option;
            return this._doGet(this.parsePath(path), !ignoreParent && this.parentModel);
        };
        Model.prototype.getShallow = function(key, ignoreParent) {
            var option = this.option;
            var val = option == null ? option : option[key];
            if (val == null && !ignoreParent) {
                var parentModel = this.parentModel;
                if (parentModel) val = parentModel.getShallow(key);
            }
            return val;
        };
        Model.prototype.getModel = function(path, parentModel) {
            var hasPath = path != null;
            var pathFinal = hasPath ? this.parsePath(path) : null;
            var obj = hasPath ? this._doGet(pathFinal) : this.option;
            parentModel = parentModel || this.parentModel && this.parentModel.getModel(this.resolveParentPath(pathFinal));
            return new Model(obj, parentModel, this.ecModel);
        };
        Model.prototype.isEmpty = function() {
            return this.option == null;
        };
        Model.prototype.restoreData = function() {};
        Model.prototype.clone = function() {
            var Ctor = this.constructor;
            return new Ctor((0, (0, parcelRequire("bahqM")).clone)(this.option));
        };
        Model.prototype.parsePath = function(path) {
            if (typeof path === 'string') return path.split('.');
            return path;
        };
        Model.prototype.resolveParentPath = function(path) {
            return path;
        };
        Model.prototype.isAnimationEnabled = function() {
            if (!(0, (0, parcelRequire("hZfwb")).default).node && this.option) {
                if (this.option.animation != null) return !!this.option.animation;
                else if (this.parentModel) return this.parentModel.isAnimationEnabled();
            }
        };
        Model.prototype._doGet = function(pathArr, parentModel) {
            var obj = this.option;
            if (!pathArr) return obj;
            for(var i = 0; i < pathArr.length; i++){
                if (!pathArr[i]) continue;
                obj = obj && typeof obj === 'object' ? obj[pathArr[i]] : null;
                if (obj == null) break;
            }
            if (obj == null && parentModel) obj = parentModel._doGet(this.resolveParentPath(pathArr), parentModel.parentModel);
            return obj;
        };
        return Model;
    }();
    (0, (0, parcelRequire("aLwh0")).enableClassExtend)($bc63113067804ddc$var$Model);
    (0, (0, parcelRequire("aLwh0")).enableClassCheck)($bc63113067804ddc$var$Model);
    (0, (0, parcelRequire("bahqM")).mixin)($bc63113067804ddc$var$Model, (0, (0, parcelRequire("46U6E")).LineStyleMixin));
    (0, (0, parcelRequire("bahqM")).mixin)($bc63113067804ddc$var$Model, (0, (0, parcelRequire("4rldO")).ItemStyleMixin));
    (0, (0, parcelRequire("bahqM")).mixin)($bc63113067804ddc$var$Model, (0, (0, parcelRequire("8P3Or")).AreaStyleMixin));
    (0, (0, parcelRequire("bahqM")).mixin)($bc63113067804ddc$var$Model, (0, (0, parcelRequire("hyGik")).default));
    var $bc63113067804ddc$export$2e2bcd8739ae039 = $bc63113067804ddc$var$Model;
});
parcelRegister("aLwh0", function(module, exports) {
    $parcel$export(module.exports, "parseClassType", ()=>$7d6753f3a830ddbc$export$fbe18865d303bf01);
    $parcel$export(module.exports, "isExtendedClass", ()=>$7d6753f3a830ddbc$export$4f3b818f3dd2d182);
    $parcel$export(module.exports, "enableClassExtend", ()=>$7d6753f3a830ddbc$export$cd4c3a4dca301c70);
    $parcel$export(module.exports, "mountExtend", ()=>$7d6753f3a830ddbc$export$c9c2d87774f1275d);
    $parcel$export(module.exports, "enableClassCheck", ()=>$7d6753f3a830ddbc$export$e1aac4552ae82081);
    $parcel$export(module.exports, "enableClassManagement", ()=>$7d6753f3a830ddbc$export$241315e45585454d);
    var $3VFsf;
    var $bahqM;
    var $7d6753f3a830ddbc$var$TYPE_DELIMITER = '.';
    var $7d6753f3a830ddbc$var$IS_CONTAINER = '___EC__COMPONENT__CONTAINER___';
    var $7d6753f3a830ddbc$var$IS_EXTENDED_CLASS = '___EC__EXTENDED_CLASS___';
    function $7d6753f3a830ddbc$export$fbe18865d303bf01(componentType) {
        var ret = {
            main: '',
            sub: ''
        };
        if (componentType) {
            var typeArr = componentType.split($7d6753f3a830ddbc$var$TYPE_DELIMITER);
            ret.main = typeArr[0] || '';
            ret.sub = typeArr[1] || '';
        }
        return ret;
    }
    function $7d6753f3a830ddbc$var$checkClassType(componentType) {
        (0, parcelRequire("bahqM")).assert(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
    }
    function $7d6753f3a830ddbc$export$4f3b818f3dd2d182(clz) {
        return !!(clz && clz[$7d6753f3a830ddbc$var$IS_EXTENDED_CLASS]);
    }
    function $7d6753f3a830ddbc$export$cd4c3a4dca301c70(rootClz, mandatoryMethods) {
        rootClz.$constructor = rootClz;
        rootClz.extend = function(proto) {
            var superClass = this;
            function ExtendedClass() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                if (!proto.$constructor) {
                    if (!$7d6753f3a830ddbc$var$isESClass(superClass)) superClass.apply(this, arguments);
                    else {
                        var ins = (0, parcelRequire("bahqM")).createObject(ExtendedClass.prototype, new (superClass.bind.apply(superClass, (0, (0, parcelRequire("3VFsf")).__spreadArray)([
                            void 0
                        ], args)))());
                        return ins;
                    }
                } else proto.$constructor.apply(this, arguments);
            }
            ExtendedClass[$7d6753f3a830ddbc$var$IS_EXTENDED_CLASS] = true;
            (0, parcelRequire("bahqM")).extend(ExtendedClass.prototype, proto);
            ExtendedClass.extend = this.extend;
            ExtendedClass.superCall = $7d6753f3a830ddbc$var$superCall;
            ExtendedClass.superApply = $7d6753f3a830ddbc$var$superApply;
            (0, parcelRequire("bahqM")).inherits(ExtendedClass, this);
            ExtendedClass.superClass = superClass;
            return ExtendedClass;
        };
    }
    function $7d6753f3a830ddbc$var$isESClass(fn) {
        return typeof fn === 'function' && /^class\s/.test(Function.prototype.toString.call(fn));
    }
    function $7d6753f3a830ddbc$export$c9c2d87774f1275d(SubClz, SupperClz) {
        SubClz.extend = SupperClz.extend;
    }
    var $7d6753f3a830ddbc$var$classBase = Math.round(Math.random() * 10);
    function $7d6753f3a830ddbc$export$e1aac4552ae82081(target) {
        var classAttr = [
            '__\0is_clz',
            $7d6753f3a830ddbc$var$classBase++
        ].join('_');
        target.prototype[classAttr] = true;
        target.isInstance = function(obj) {
            return !!(obj && obj[classAttr]);
        };
    }
    function $7d6753f3a830ddbc$var$superCall(context, methodName) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        return this.superClass.prototype[methodName].apply(context, args);
    }
    function $7d6753f3a830ddbc$var$superApply(context, methodName, args) {
        return this.superClass.prototype[methodName].apply(context, args);
    }
    function $7d6753f3a830ddbc$export$241315e45585454d(target) {
        var storage = {};
        target.registerClass = function(clz) {
            var componentFullType = clz.type || clz.prototype.type;
            if (componentFullType) {
                $7d6753f3a830ddbc$var$checkClassType(componentFullType);
                clz.prototype.type = componentFullType;
                var componentTypeInfo = $7d6753f3a830ddbc$export$fbe18865d303bf01(componentFullType);
                if (!componentTypeInfo.sub) storage[componentTypeInfo.main] = clz;
                else if (componentTypeInfo.sub !== $7d6753f3a830ddbc$var$IS_CONTAINER) {
                    var container = makeContainer(componentTypeInfo);
                    container[componentTypeInfo.sub] = clz;
                }
            }
            return clz;
        };
        target.getClass = function(mainType, subType, throwWhenNotFound) {
            var clz = storage[mainType];
            if (clz && clz[$7d6753f3a830ddbc$var$IS_CONTAINER]) clz = subType ? clz[subType] : null;
            if (throwWhenNotFound && !clz) throw new Error(!subType ? mainType + '.' + 'type should be specified.' : 'Component ' + mainType + '.' + (subType || '') + ' is used but not imported.');
            return clz;
        };
        target.getClassesByMainType = function(componentType) {
            var componentTypeInfo = $7d6753f3a830ddbc$export$fbe18865d303bf01(componentType);
            var result = [];
            var obj = storage[componentTypeInfo.main];
            if (obj && obj[$7d6753f3a830ddbc$var$IS_CONTAINER]) (0, parcelRequire("bahqM")).each(obj, function(o, type) {
                type !== $7d6753f3a830ddbc$var$IS_CONTAINER && result.push(o);
            });
            else result.push(obj);
            return result;
        };
        target.hasClass = function(componentType) {
            var componentTypeInfo = $7d6753f3a830ddbc$export$fbe18865d303bf01(componentType);
            return !!storage[componentTypeInfo.main];
        };
        target.getAllClassMainTypes = function() {
            var types = [];
            (0, parcelRequire("bahqM")).each(storage, function(obj, type) {
                types.push(type);
            });
            return types;
        };
        target.hasSubTypes = function(componentType) {
            var componentTypeInfo = $7d6753f3a830ddbc$export$fbe18865d303bf01(componentType);
            var obj = storage[componentTypeInfo.main];
            return obj && obj[$7d6753f3a830ddbc$var$IS_CONTAINER];
        };
        function makeContainer(componentTypeInfo) {
            var container = storage[componentTypeInfo.main];
            if (!container || !container[$7d6753f3a830ddbc$var$IS_CONTAINER]) {
                container = storage[componentTypeInfo.main] = {};
                container[$7d6753f3a830ddbc$var$IS_CONTAINER] = true;
            }
            return container;
        }
    }
});
parcelRegister("8P3Or", function(module, exports) {
    $parcel$export(module.exports, "AreaStyleMixin", ()=>$66c60b4522f41760$export$a3a0ed7e2dd84c9e);
    var $1BJbl;
    var $66c60b4522f41760$export$52de6e304d934d85 = [
        [
            'fill',
            'color'
        ],
        [
            'shadowBlur'
        ],
        [
            'shadowOffsetX'
        ],
        [
            'shadowOffsetY'
        ],
        [
            'opacity'
        ],
        [
            'shadowColor'
        ]
    ];
    var $66c60b4522f41760$var$getAreaStyle = (0, (0, parcelRequire("1BJbl")).default)($66c60b4522f41760$export$52de6e304d934d85);
    var $66c60b4522f41760$export$a3a0ed7e2dd84c9e = function() {
        function AreaStyleMixin() {}
        AreaStyleMixin.prototype.getAreaStyle = function(excludes, includes) {
            return $66c60b4522f41760$var$getAreaStyle(this, excludes, includes);
        };
        return AreaStyleMixin;
    }();
});
parcelRegister("1BJbl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$12bc4b5222290b4b$export$2e2bcd8739ae039);
    var $bahqM;
    function $12bc4b5222290b4b$export$2e2bcd8739ae039(properties, ignoreParent) {
        for(var i = 0; i < properties.length; i++)if (!properties[i][1]) properties[i][1] = properties[i][0];
        ignoreParent = ignoreParent || false;
        return function(model, excludes, includes) {
            var style = {};
            for(var i = 0; i < properties.length; i++){
                var propName = properties[i][1];
                if (excludes && (0, parcelRequire("bahqM")).indexOf(excludes, propName) >= 0 || includes && (0, parcelRequire("bahqM")).indexOf(includes, propName) < 0) continue;
                var val = model.getShallow(propName, ignoreParent);
                if (val != null) style[properties[i][0]] = val;
            }
            return style;
        };
    }
});
parcelRegister("hyGik", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cc866b770f3f8e08$export$2e2bcd8739ae039);
    var $gvLUt;
    var $4gEFv;
    var $cc866b770f3f8e08$var$PATH_COLOR = [
        'textStyle',
        'color'
    ];
    var $cc866b770f3f8e08$var$tmpRichText = new (0, (0, parcelRequire("4gEFv")).default)();
    var $cc866b770f3f8e08$var$TextStyleMixin = function() {
        function TextStyleMixin() {}
        TextStyleMixin.prototype.getTextColor = function(isEmphasis) {
            var ecModel = this.ecModel;
            return this.getShallow('color') || (!isEmphasis && ecModel ? ecModel.get($cc866b770f3f8e08$var$PATH_COLOR) : null);
        };
        TextStyleMixin.prototype.getFont = function() {
            return (0, (0, parcelRequire("gvLUt")).getFont)({
                fontStyle: this.getShallow('fontStyle'),
                fontWeight: this.getShallow('fontWeight'),
                fontSize: this.getShallow('fontSize'),
                fontFamily: this.getShallow('fontFamily')
            }, this.ecModel);
        };
        TextStyleMixin.prototype.getTextRect = function(text) {
            $cc866b770f3f8e08$var$tmpRichText.useStyle({
                text: text,
                fontStyle: this.getShallow('fontStyle'),
                fontWeight: this.getShallow('fontWeight'),
                fontSize: this.getShallow('fontSize'),
                fontFamily: this.getShallow('fontFamily'),
                verticalAlign: this.getShallow('verticalAlign') || this.getShallow('baseline'),
                padding: this.getShallow('padding'),
                lineHeight: this.getShallow('lineHeight'),
                rich: this.getShallow('rich')
            });
            $cc866b770f3f8e08$var$tmpRichText.update();
            return $cc866b770f3f8e08$var$tmpRichText.getBoundingRect();
        };
        return TextStyleMixin;
    }();
    var $cc866b770f3f8e08$export$2e2bcd8739ae039 = $cc866b770f3f8e08$var$TextStyleMixin;
});
parcelRegister("gvLUt", function(module, exports) {
    $parcel$export(module.exports, "setLabelStyle", ()=>$c054b479467e8395$export$9a13992917966657);
    $parcel$export(module.exports, "createTextStyle", ()=>$c054b479467e8395$export$f8998c3d0a13de59);
    $parcel$export(module.exports, "createTextConfig", ()=>$c054b479467e8395$export$e149afab8df6e053);
    $parcel$export(module.exports, "labelInner", ()=>$c054b479467e8395$export$f62786d3261ab0f4);
    $parcel$export(module.exports, "getLabelStatesModels", ()=>$c054b479467e8395$export$9739a32674be5893);
    $parcel$export(module.exports, "getFont", ()=>$c054b479467e8395$export$155316a870a9d61e);
    $parcel$export(module.exports, "setLabelValueAnimation", ()=>$c054b479467e8395$export$7bdbceaf9ab378f2);
    $parcel$export(module.exports, "animateLabelValue", ()=>$c054b479467e8395$export$dd6101605f5c186);
    var $4gEFv;
    var $bahqM;
    var $fIXXx;
    var $eaKsF;
    var $eYgMC;
    parcelRequire("fHITF");
    var $eYgMC;
    var $c054b479467e8395$var$EMPTY_OBJ = {};
    function $c054b479467e8395$export$b533918394a58529(label, labelTexts) {
        for(var i = 0; i < (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES).length; i++){
            var stateName = (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES)[i];
            var text = labelTexts[stateName];
            var state = label.ensureState(stateName);
            state.style = state.style || {};
            state.style.text = text;
        }
        var oldStates = label.currentStates.slice();
        label.clearStates(true);
        label.setStyle({
            text: labelTexts.normal
        });
        label.useStates(oldStates, true);
    }
    function $c054b479467e8395$var$getLabelText(opt, stateModels, interpolatedValue) {
        var labelFetcher = opt.labelFetcher;
        var labelDataIndex = opt.labelDataIndex;
        var labelDimIndex = opt.labelDimIndex;
        var normalModel = stateModels.normal;
        var baseText;
        if (labelFetcher) baseText = labelFetcher.getFormattedLabel(labelDataIndex, 'normal', null, labelDimIndex, normalModel && normalModel.get('formatter'), interpolatedValue != null ? {
            interpolatedValue: interpolatedValue
        } : null);
        if (baseText == null) baseText = (0, (0, parcelRequire("bahqM")).isFunction)(opt.defaultText) ? opt.defaultText(labelDataIndex, opt, interpolatedValue) : opt.defaultText;
        var statesText = {
            normal: baseText
        };
        for(var i = 0; i < (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES).length; i++){
            var stateName = (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES)[i];
            var stateModel = stateModels[stateName];
            statesText[stateName] = (0, (0, parcelRequire("bahqM")).retrieve2)(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, stateName, null, labelDimIndex, stateModel && stateModel.get('formatter')) : null, baseText);
        }
        return statesText;
    }
    function $c054b479467e8395$export$9a13992917966657(targetEl, labelStatesModels, opt, stateSpecified) {
        opt = opt || $c054b479467e8395$var$EMPTY_OBJ;
        var isSetOnText = targetEl instanceof (0, (0, parcelRequire("4gEFv")).default);
        var needsCreateText = false;
        for(var i = 0; i < (0, (0, parcelRequire("fIXXx")).DISPLAY_STATES).length; i++){
            var stateModel = labelStatesModels[(0, (0, parcelRequire("fIXXx")).DISPLAY_STATES)[i]];
            if (stateModel && stateModel.getShallow('show')) {
                needsCreateText = true;
                break;
            }
        }
        var textContent = isSetOnText ? targetEl : targetEl.getTextContent();
        if (needsCreateText) {
            if (!isSetOnText) {
                if (!textContent) {
                    textContent = new (0, (0, parcelRequire("4gEFv")).default)();
                    targetEl.setTextContent(textContent);
                }
                if (targetEl.stateProxy) textContent.stateProxy = targetEl.stateProxy;
            }
            var labelStatesTexts = $c054b479467e8395$var$getLabelText(opt, labelStatesModels);
            var normalModel = labelStatesModels.normal;
            var showNormal = !!normalModel.getShallow('show');
            var normalStyle = $c054b479467e8395$export$f8998c3d0a13de59(normalModel, stateSpecified && stateSpecified.normal, opt, false, !isSetOnText);
            normalStyle.text = labelStatesTexts.normal;
            if (!isSetOnText) targetEl.setTextConfig($c054b479467e8395$export$e149afab8df6e053(normalModel, opt, false));
            for(var i = 0; i < (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES).length; i++){
                var stateName = (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES)[i];
                var stateModel = labelStatesModels[stateName];
                if (stateModel) {
                    var stateObj = textContent.ensureState(stateName);
                    var stateShow = !!(0, (0, parcelRequire("bahqM")).retrieve2)(stateModel.getShallow('show'), showNormal);
                    if (stateShow !== showNormal) stateObj.ignore = !stateShow;
                    stateObj.style = $c054b479467e8395$export$f8998c3d0a13de59(stateModel, stateSpecified && stateSpecified[stateName], opt, true, !isSetOnText);
                    stateObj.style.text = labelStatesTexts[stateName];
                    if (!isSetOnText) {
                        var targetElEmphasisState = targetEl.ensureState(stateName);
                        targetElEmphasisState.textConfig = $c054b479467e8395$export$e149afab8df6e053(stateModel, opt, true);
                    }
                }
            }
            textContent.silent = !!normalModel.getShallow('silent');
            if (textContent.style.x != null) normalStyle.x = textContent.style.x;
            if (textContent.style.y != null) normalStyle.y = textContent.style.y;
            textContent.ignore = !showNormal;
            textContent.useStyle(normalStyle);
            textContent.dirty();
            if (opt.enableTextSetter) $c054b479467e8395$export$f62786d3261ab0f4(textContent).setLabelText = function(interpolatedValue) {
                var labelStatesTexts = $c054b479467e8395$var$getLabelText(opt, labelStatesModels, interpolatedValue);
                $c054b479467e8395$export$b533918394a58529(textContent, labelStatesTexts);
            };
        } else if (textContent) textContent.ignore = true;
        targetEl.dirty();
    }
    function $c054b479467e8395$export$9739a32674be5893(itemModel, labelName) {
        labelName = labelName || 'label';
        var statesModels = {
            normal: itemModel.getModel(labelName)
        };
        for(var i = 0; i < (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES).length; i++){
            var stateName = (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES)[i];
            statesModels[stateName] = itemModel.getModel([
                stateName,
                labelName
            ]);
        }
        return statesModels;
    }
    function $c054b479467e8395$export$f8998c3d0a13de59(textStyleModel, specifiedTextStyle, opt, isNotNormal, isAttached) {
        var textStyle = {};
        $c054b479467e8395$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached);
        specifiedTextStyle && (0, (0, parcelRequire("bahqM")).extend)(textStyle, specifiedTextStyle);
        return textStyle;
    }
    function $c054b479467e8395$export$e149afab8df6e053(textStyleModel, opt, isNotNormal) {
        opt = opt || {};
        var textConfig = {};
        var labelPosition;
        var labelRotate = textStyleModel.getShallow('rotate');
        var labelDistance = (0, (0, parcelRequire("bahqM")).retrieve2)(textStyleModel.getShallow('distance'), isNotNormal ? null : 5);
        var labelOffset = textStyleModel.getShallow('offset');
        labelPosition = textStyleModel.getShallow('position') || (isNotNormal ? null : 'inside');
        labelPosition === 'outside' && (labelPosition = opt.defaultOutsidePosition || 'top');
        if (labelPosition != null) textConfig.position = labelPosition;
        if (labelOffset != null) textConfig.offset = labelOffset;
        if (labelRotate != null) {
            labelRotate *= Math.PI / 180;
            textConfig.rotation = labelRotate;
        }
        if (labelDistance != null) textConfig.distance = labelDistance;
        textConfig.outsideFill = textStyleModel.get('color') === 'inherit' ? opt.inheritColor || null : 'auto';
        return textConfig;
    }
    function $c054b479467e8395$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached) {
        opt = opt || $c054b479467e8395$var$EMPTY_OBJ;
        var ecModel = textStyleModel.ecModel;
        var globalTextStyle = ecModel && ecModel.option.textStyle;
        var richItemNames = $c054b479467e8395$var$getRichItemNames(textStyleModel);
        var richResult;
        if (richItemNames) {
            richResult = {};
            for(var name_1 in richItemNames)if (richItemNames.hasOwnProperty(name_1)) {
                var richTextStyle = textStyleModel.getModel([
                    'rich',
                    name_1
                ]);
                $c054b479467e8395$var$setTokenTextStyle(richResult[name_1] = {}, richTextStyle, globalTextStyle, opt, isNotNormal, isAttached, false, true);
            }
        }
        if (richResult) textStyle.rich = richResult;
        var overflow = textStyleModel.get('overflow');
        if (overflow) textStyle.overflow = overflow;
        var margin = textStyleModel.get('minMargin');
        if (margin != null) textStyle.margin = margin;
        $c054b479467e8395$var$setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isNotNormal, isAttached, true, false);
    }
    function $c054b479467e8395$var$getRichItemNames(textStyleModel) {
        var richItemNameMap;
        while(textStyleModel && textStyleModel !== textStyleModel.ecModel){
            var rich = (textStyleModel.option || $c054b479467e8395$var$EMPTY_OBJ).rich;
            if (rich) {
                richItemNameMap = richItemNameMap || {};
                var richKeys = (0, (0, parcelRequire("bahqM")).keys)(rich);
                for(var i = 0; i < richKeys.length; i++){
                    var richKey = richKeys[i];
                    richItemNameMap[richKey] = 1;
                }
            }
            textStyleModel = textStyleModel.parentModel;
        }
        return richItemNameMap;
    }
    var $c054b479467e8395$var$TEXT_PROPS_WITH_GLOBAL = [
        'fontStyle',
        'fontWeight',
        'fontSize',
        'fontFamily',
        'textShadowColor',
        'textShadowBlur',
        'textShadowOffsetX',
        'textShadowOffsetY'
    ];
    var $c054b479467e8395$var$TEXT_PROPS_SELF = [
        'align',
        'lineHeight',
        'width',
        'height',
        'tag',
        'verticalAlign'
    ];
    var $c054b479467e8395$var$TEXT_PROPS_BOX = [
        'padding',
        'borderWidth',
        'borderRadius',
        'borderDashOffset',
        'backgroundColor',
        'borderColor',
        'shadowColor',
        'shadowBlur',
        'shadowOffsetX',
        'shadowOffsetY'
    ];
    function $c054b479467e8395$var$setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isNotNormal, isAttached, isBlock, inRich) {
        globalTextStyle = !isNotNormal && globalTextStyle || $c054b479467e8395$var$EMPTY_OBJ;
        var inheritColor = opt && opt.inheritColor;
        var fillColor = textStyleModel.getShallow('color');
        var strokeColor = textStyleModel.getShallow('textBorderColor');
        var opacity = (0, (0, parcelRequire("bahqM")).retrieve2)(textStyleModel.getShallow('opacity'), globalTextStyle.opacity);
        if (fillColor === 'inherit' || fillColor === 'auto') {
            if (inheritColor) fillColor = inheritColor;
            else fillColor = null;
        }
        if (strokeColor === 'inherit' || strokeColor === 'auto') {
            if (inheritColor) strokeColor = inheritColor;
            else strokeColor = null;
        }
        if (!isAttached) {
            fillColor = fillColor || globalTextStyle.color;
            strokeColor = strokeColor || globalTextStyle.textBorderColor;
        }
        if (fillColor != null) textStyle.fill = fillColor;
        if (strokeColor != null) textStyle.stroke = strokeColor;
        var textBorderWidth = (0, (0, parcelRequire("bahqM")).retrieve2)(textStyleModel.getShallow('textBorderWidth'), globalTextStyle.textBorderWidth);
        if (textBorderWidth != null) textStyle.lineWidth = textBorderWidth;
        var textBorderType = (0, (0, parcelRequire("bahqM")).retrieve2)(textStyleModel.getShallow('textBorderType'), globalTextStyle.textBorderType);
        if (textBorderType != null) textStyle.lineDash = textBorderType;
        var textBorderDashOffset = (0, (0, parcelRequire("bahqM")).retrieve2)(textStyleModel.getShallow('textBorderDashOffset'), globalTextStyle.textBorderDashOffset);
        if (textBorderDashOffset != null) textStyle.lineDashOffset = textBorderDashOffset;
        if (!isNotNormal && opacity == null && !inRich) opacity = opt && opt.defaultOpacity;
        if (opacity != null) textStyle.opacity = opacity;
        if (!isNotNormal && !isAttached) {
            if (textStyle.fill == null && opt.inheritColor) textStyle.fill = opt.inheritColor;
        }
        for(var i = 0; i < $c054b479467e8395$var$TEXT_PROPS_WITH_GLOBAL.length; i++){
            var key = $c054b479467e8395$var$TEXT_PROPS_WITH_GLOBAL[i];
            var val = (0, (0, parcelRequire("bahqM")).retrieve2)(textStyleModel.getShallow(key), globalTextStyle[key]);
            if (val != null) textStyle[key] = val;
        }
        for(var i = 0; i < $c054b479467e8395$var$TEXT_PROPS_SELF.length; i++){
            var key = $c054b479467e8395$var$TEXT_PROPS_SELF[i];
            var val = textStyleModel.getShallow(key);
            if (val != null) textStyle[key] = val;
        }
        if (textStyle.verticalAlign == null) {
            var baseline = textStyleModel.getShallow('baseline');
            if (baseline != null) textStyle.verticalAlign = baseline;
        }
        if (!isBlock || !opt.disableBox) {
            for(var i = 0; i < $c054b479467e8395$var$TEXT_PROPS_BOX.length; i++){
                var key = $c054b479467e8395$var$TEXT_PROPS_BOX[i];
                var val = textStyleModel.getShallow(key);
                if (val != null) textStyle[key] = val;
            }
            var borderType = textStyleModel.getShallow('borderType');
            if (borderType != null) textStyle.borderDash = borderType;
            if ((textStyle.backgroundColor === 'auto' || textStyle.backgroundColor === 'inherit') && inheritColor) textStyle.backgroundColor = inheritColor;
            if ((textStyle.borderColor === 'auto' || textStyle.borderColor === 'inherit') && inheritColor) textStyle.borderColor = inheritColor;
        }
    }
    function $c054b479467e8395$export$155316a870a9d61e(opt, ecModel) {
        var gTextStyleModel = ecModel && ecModel.getModel('textStyle');
        return (0, (0, parcelRequire("bahqM")).trim)([
            opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow('fontStyle') || '',
            opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow('fontWeight') || '',
            (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow('fontSize') || 12) + 'px',
            opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow('fontFamily') || 'sans-serif'
        ].join(' '));
    }
    var $c054b479467e8395$export$f62786d3261ab0f4 = (0, (0, parcelRequire("eaKsF")).makeInner)();
    function $c054b479467e8395$export$7bdbceaf9ab378f2(label, labelStatesModels, value, getDefaultText) {
        if (!label) return;
        var obj = $c054b479467e8395$export$f62786d3261ab0f4(label);
        obj.prevValue = obj.value;
        obj.value = value;
        var normalLabelModel = labelStatesModels.normal;
        obj.valueAnimation = normalLabelModel.get('valueAnimation');
        if (obj.valueAnimation) {
            obj.precision = normalLabelModel.get('precision');
            obj.defaultInterpolatedText = getDefaultText;
            obj.statesModels = labelStatesModels;
        }
    }
    function $c054b479467e8395$export$dd6101605f5c186(textEl, dataIndex, data, animatableModel, labelFetcher) {
        var labelInnerStore = $c054b479467e8395$export$f62786d3261ab0f4(textEl);
        if (!labelInnerStore.valueAnimation) return;
        var defaultInterpolatedText = labelInnerStore.defaultInterpolatedText;
        var currValue = (0, (0, parcelRequire("bahqM")).retrieve2)(labelInnerStore.interpolatedValue, labelInnerStore.prevValue);
        var targetValue = labelInnerStore.value;
        function during(percent) {
            var interpolated = (0, (0, parcelRequire("eaKsF")).interpolateRawValues)(data, labelInnerStore.precision, currValue, targetValue, percent);
            labelInnerStore.interpolatedValue = percent === 1 ? null : interpolated;
            var labelText = $c054b479467e8395$var$getLabelText({
                labelDataIndex: dataIndex,
                labelFetcher: labelFetcher,
                defaultText: defaultInterpolatedText ? defaultInterpolatedText(interpolated) : interpolated + ''
            }, labelInnerStore.statesModels, interpolated);
            $c054b479467e8395$export$b533918394a58529(textEl, labelText);
        }
        (labelInnerStore.prevValue == null ? (0, (0, parcelRequire("eYgMC")).initProps) : (0, (0, parcelRequire("eYgMC")).updateProps))(textEl, {}, animatableModel, dataIndex, null, during);
    }
});
parcelRegister("4gEFv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31b833f429060f54$export$2e2bcd8739ae039);
    var $3VFsf;
    var $h6fMM;
    var $45jlh;
    var $bahqM;
    var $b7ZX8;
    var $gcbBH;
    var $7Tw7u;
    var $1E3E8;
    var $lBQ88;
    var $31b833f429060f54$var$DEFAULT_RICH_TEXT_COLOR = {
        fill: '#000'
    };
    var $31b833f429060f54$var$DEFAULT_STROKE_LINE_WIDTH = 2;
    var $31b833f429060f54$export$21aaaa0607ee0e2b = {
        style: (0, (0, parcelRequire("bahqM")).defaults)({
            fill: true,
            stroke: true,
            fillOpacity: true,
            strokeOpacity: true,
            lineWidth: true,
            fontSize: true,
            lineHeight: true,
            width: true,
            height: true,
            textShadowColor: true,
            textShadowBlur: true,
            textShadowOffsetX: true,
            textShadowOffsetY: true,
            backgroundColor: true,
            padding: true,
            borderColor: true,
            borderWidth: true,
            borderRadius: true
        }, (0, (0, parcelRequire("lBQ88")).DEFAULT_COMMON_ANIMATION_PROPS).style)
    };
    var $31b833f429060f54$var$ZRText = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ZRText, _super);
        function ZRText(opts) {
            var _this = _super.call(this) || this;
            _this.type = 'text';
            _this._children = [];
            _this._defaultStyle = $31b833f429060f54$var$DEFAULT_RICH_TEXT_COLOR;
            _this.attr(opts);
            return _this;
        }
        ZRText.prototype.childrenRef = function() {
            return this._children;
        };
        ZRText.prototype.update = function() {
            _super.prototype.update.call(this);
            if (this.styleChanged()) this._updateSubTexts();
            for(var i = 0; i < this._children.length; i++){
                var child = this._children[i];
                child.zlevel = this.zlevel;
                child.z = this.z;
                child.z2 = this.z2;
                child.culling = this.culling;
                child.cursor = this.cursor;
                child.invisible = this.invisible;
            }
        };
        ZRText.prototype.updateTransform = function() {
            var innerTransformable = this.innerTransformable;
            if (innerTransformable) {
                innerTransformable.updateTransform();
                if (innerTransformable.transform) this.transform = innerTransformable.transform;
            } else _super.prototype.updateTransform.call(this);
        };
        ZRText.prototype.getLocalTransform = function(m) {
            var innerTransformable = this.innerTransformable;
            return innerTransformable ? innerTransformable.getLocalTransform(m) : _super.prototype.getLocalTransform.call(this, m);
        };
        ZRText.prototype.getComputedTransform = function() {
            if (this.__hostTarget) {
                this.__hostTarget.getComputedTransform();
                this.__hostTarget.updateInnerText(true);
            }
            return _super.prototype.getComputedTransform.call(this);
        };
        ZRText.prototype._updateSubTexts = function() {
            this._childCursor = 0;
            $31b833f429060f54$export$176336068cc5371f(this.style);
            this.style.rich ? this._updateRichTexts() : this._updatePlainTexts();
            this._children.length = this._childCursor;
            this.styleUpdated();
        };
        ZRText.prototype.addSelfToZr = function(zr) {
            _super.prototype.addSelfToZr.call(this, zr);
            for(var i = 0; i < this._children.length; i++)this._children[i].__zr = zr;
        };
        ZRText.prototype.removeSelfFromZr = function(zr) {
            _super.prototype.removeSelfFromZr.call(this, zr);
            for(var i = 0; i < this._children.length; i++)this._children[i].__zr = null;
        };
        ZRText.prototype.getBoundingRect = function() {
            if (this.styleChanged()) this._updateSubTexts();
            if (!this._rect) {
                var tmpRect = new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0);
                var children = this._children;
                var tmpMat = [];
                var rect = null;
                for(var i = 0; i < children.length; i++){
                    var child = children[i];
                    var childRect = child.getBoundingRect();
                    var transform = child.getLocalTransform(tmpMat);
                    if (transform) {
                        tmpRect.copy(childRect);
                        tmpRect.applyTransform(transform);
                        rect = rect || tmpRect.clone();
                        rect.union(tmpRect);
                    } else {
                        rect = rect || childRect.clone();
                        rect.union(childRect);
                    }
                }
                this._rect = rect || tmpRect;
            }
            return this._rect;
        };
        ZRText.prototype.setDefaultTextStyle = function(defaultTextStyle) {
            this._defaultStyle = defaultTextStyle || $31b833f429060f54$var$DEFAULT_RICH_TEXT_COLOR;
        };
        ZRText.prototype.setTextContent = function(textContent) {
            throw new Error('Can\'t attach text on another text');
        };
        ZRText.prototype._mergeStyle = function(targetStyle, sourceStyle) {
            if (!sourceStyle) return targetStyle;
            var sourceRich = sourceStyle.rich;
            var targetRich = targetStyle.rich || sourceRich && {};
            (0, (0, parcelRequire("bahqM")).extend)(targetStyle, sourceStyle);
            if (sourceRich && targetRich) {
                this._mergeRich(targetRich, sourceRich);
                targetStyle.rich = targetRich;
            } else if (targetRich) targetStyle.rich = targetRich;
            return targetStyle;
        };
        ZRText.prototype._mergeRich = function(targetRich, sourceRich) {
            var richNames = (0, (0, parcelRequire("bahqM")).keys)(sourceRich);
            for(var i = 0; i < richNames.length; i++){
                var richName = richNames[i];
                targetRich[richName] = targetRich[richName] || {};
                (0, (0, parcelRequire("bahqM")).extend)(targetRich[richName], sourceRich[richName]);
            }
        };
        ZRText.prototype.getAnimationStyleProps = function() {
            return $31b833f429060f54$export$21aaaa0607ee0e2b;
        };
        ZRText.prototype._getOrCreateChild = function(Ctor) {
            var child = this._children[this._childCursor];
            if (!child || !(child instanceof Ctor)) child = new Ctor();
            this._children[this._childCursor++] = child;
            child.__zr = this.__zr;
            child.parent = this;
            return child;
        };
        ZRText.prototype._updatePlainTexts = function() {
            var style = this.style;
            var textFont = style.font || (0, (0, parcelRequire("b7ZX8")).DEFAULT_FONT);
            var textPadding = style.padding;
            var text = $31b833f429060f54$var$getStyleText(style);
            var contentBlock = (0, (0, parcelRequire("h6fMM")).parsePlainText)(text, style);
            var needDrawBg = $31b833f429060f54$var$needDrawBackground(style);
            var bgColorDrawn = !!style.backgroundColor;
            var outerHeight = contentBlock.outerHeight;
            var textLines = contentBlock.lines;
            var lineHeight = contentBlock.lineHeight;
            var defaultStyle = this._defaultStyle;
            var baseX = style.x || 0;
            var baseY = style.y || 0;
            var textAlign = style.align || defaultStyle.align || 'left';
            var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign || 'top';
            var textX = baseX;
            var textY = (0, (0, parcelRequire("b7ZX8")).adjustTextY)(baseY, contentBlock.contentHeight, verticalAlign);
            if (needDrawBg || textPadding) {
                var outerWidth_1 = contentBlock.width;
                textPadding && (outerWidth_1 += textPadding[1] + textPadding[3]);
                var boxX = (0, (0, parcelRequire("b7ZX8")).adjustTextX)(baseX, outerWidth_1, textAlign);
                var boxY = (0, (0, parcelRequire("b7ZX8")).adjustTextY)(baseY, outerHeight, verticalAlign);
                needDrawBg && this._renderBackground(style, style, boxX, boxY, outerWidth_1, outerHeight);
            }
            textY += lineHeight / 2;
            if (textPadding) {
                textX = $31b833f429060f54$var$getTextXForPadding(baseX, textAlign, textPadding);
                if (verticalAlign === 'top') textY += textPadding[0];
                else if (verticalAlign === 'bottom') textY -= textPadding[2];
            }
            var defaultLineWidth = 0;
            var useDefaultFill = false;
            var textFill = $31b833f429060f54$var$getFill('fill' in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
            var textStroke = $31b833f429060f54$var$getStroke('stroke' in style ? style.stroke : !bgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $31b833f429060f54$var$DEFAULT_STROKE_LINE_WIDTH, defaultStyle.stroke) : null);
            var hasShadow = style.textShadowBlur > 0;
            var fixedBoundingRect = style.width != null && (style.overflow === 'truncate' || style.overflow === 'break' || style.overflow === 'breakAll');
            var calculatedLineHeight = contentBlock.calculatedLineHeight;
            for(var i = 0; i < textLines.length; i++){
                var el = this._getOrCreateChild((0, (0, parcelRequire("45jlh")).default));
                var subElStyle = el.createStyle();
                el.useStyle(subElStyle);
                subElStyle.text = textLines[i];
                subElStyle.x = textX;
                subElStyle.y = textY;
                if (textAlign) subElStyle.textAlign = textAlign;
                subElStyle.textBaseline = 'middle';
                subElStyle.opacity = style.opacity;
                subElStyle.strokeFirst = true;
                if (hasShadow) {
                    subElStyle.shadowBlur = style.textShadowBlur || 0;
                    subElStyle.shadowColor = style.textShadowColor || 'transparent';
                    subElStyle.shadowOffsetX = style.textShadowOffsetX || 0;
                    subElStyle.shadowOffsetY = style.textShadowOffsetY || 0;
                }
                if (textStroke) {
                    subElStyle.stroke = textStroke;
                    subElStyle.lineWidth = style.lineWidth || defaultLineWidth;
                    subElStyle.lineDash = style.lineDash;
                    subElStyle.lineDashOffset = style.lineDashOffset || 0;
                }
                if (textFill) subElStyle.fill = textFill;
                subElStyle.font = textFont;
                textY += lineHeight;
                if (fixedBoundingRect) el.setBoundingRect(new (0, (0, parcelRequire("1E3E8")).default)((0, (0, parcelRequire("b7ZX8")).adjustTextX)(subElStyle.x, style.width, subElStyle.textAlign), (0, (0, parcelRequire("b7ZX8")).adjustTextY)(subElStyle.y, calculatedLineHeight, subElStyle.textBaseline), style.width, calculatedLineHeight));
            }
        };
        ZRText.prototype._updateRichTexts = function() {
            var style = this.style;
            var text = $31b833f429060f54$var$getStyleText(style);
            var contentBlock = (0, (0, parcelRequire("h6fMM")).parseRichText)(text, style);
            var contentWidth = contentBlock.width;
            var outerWidth = contentBlock.outerWidth;
            var outerHeight = contentBlock.outerHeight;
            var textPadding = style.padding;
            var baseX = style.x || 0;
            var baseY = style.y || 0;
            var defaultStyle = this._defaultStyle;
            var textAlign = style.align || defaultStyle.align;
            var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign;
            var boxX = (0, (0, parcelRequire("b7ZX8")).adjustTextX)(baseX, outerWidth, textAlign);
            var boxY = (0, (0, parcelRequire("b7ZX8")).adjustTextY)(baseY, outerHeight, verticalAlign);
            var xLeft = boxX;
            var lineTop = boxY;
            if (textPadding) {
                xLeft += textPadding[3];
                lineTop += textPadding[0];
            }
            var xRight = xLeft + contentWidth;
            if ($31b833f429060f54$var$needDrawBackground(style)) this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
            var bgColorDrawn = !!style.backgroundColor;
            for(var i = 0; i < contentBlock.lines.length; i++){
                var line = contentBlock.lines[i];
                var tokens = line.tokens;
                var tokenCount = tokens.length;
                var lineHeight = line.lineHeight;
                var remainedWidth = line.width;
                var leftIndex = 0;
                var lineXLeft = xLeft;
                var lineXRight = xRight;
                var rightIndex = tokenCount - 1;
                var token = void 0;
                while(leftIndex < tokenCount && (token = tokens[leftIndex], !token.align || token.align === 'left')){
                    this._placeToken(token, style, lineHeight, lineTop, lineXLeft, 'left', bgColorDrawn);
                    remainedWidth -= token.width;
                    lineXLeft += token.width;
                    leftIndex++;
                }
                while(rightIndex >= 0 && (token = tokens[rightIndex], token.align === 'right')){
                    this._placeToken(token, style, lineHeight, lineTop, lineXRight, 'right', bgColorDrawn);
                    remainedWidth -= token.width;
                    lineXRight -= token.width;
                    rightIndex--;
                }
                lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - remainedWidth) / 2;
                while(leftIndex <= rightIndex){
                    token = tokens[leftIndex];
                    this._placeToken(token, style, lineHeight, lineTop, lineXLeft + token.width / 2, 'center', bgColorDrawn);
                    lineXLeft += token.width;
                    leftIndex++;
                }
                lineTop += lineHeight;
            }
        };
        ZRText.prototype._placeToken = function(token, style, lineHeight, lineTop, x, textAlign, parentBgColorDrawn) {
            var tokenStyle = style.rich[token.styleName] || {};
            tokenStyle.text = token.text;
            var verticalAlign = token.verticalAlign;
            var y = lineTop + lineHeight / 2;
            if (verticalAlign === 'top') y = lineTop + token.height / 2;
            else if (verticalAlign === 'bottom') y = lineTop + lineHeight - token.height / 2;
            var needDrawBg = !token.isLineHolder && $31b833f429060f54$var$needDrawBackground(tokenStyle);
            needDrawBg && this._renderBackground(tokenStyle, style, textAlign === 'right' ? x - token.width : textAlign === 'center' ? x - token.width / 2 : x, y - token.height / 2, token.width, token.height);
            var bgColorDrawn = !!tokenStyle.backgroundColor;
            var textPadding = token.textPadding;
            if (textPadding) {
                x = $31b833f429060f54$var$getTextXForPadding(x, textAlign, textPadding);
                y -= token.height / 2 - textPadding[0] - token.innerHeight / 2;
            }
            var el = this._getOrCreateChild((0, (0, parcelRequire("45jlh")).default));
            var subElStyle = el.createStyle();
            el.useStyle(subElStyle);
            var defaultStyle = this._defaultStyle;
            var useDefaultFill = false;
            var defaultLineWidth = 0;
            var textFill = $31b833f429060f54$var$getFill('fill' in tokenStyle ? tokenStyle.fill : 'fill' in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
            var textStroke = $31b833f429060f54$var$getStroke('stroke' in tokenStyle ? tokenStyle.stroke : 'stroke' in style ? style.stroke : !bgColorDrawn && !parentBgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $31b833f429060f54$var$DEFAULT_STROKE_LINE_WIDTH, defaultStyle.stroke) : null);
            var hasShadow = tokenStyle.textShadowBlur > 0 || style.textShadowBlur > 0;
            subElStyle.text = token.text;
            subElStyle.x = x;
            subElStyle.y = y;
            if (hasShadow) {
                subElStyle.shadowBlur = tokenStyle.textShadowBlur || style.textShadowBlur || 0;
                subElStyle.shadowColor = tokenStyle.textShadowColor || style.textShadowColor || 'transparent';
                subElStyle.shadowOffsetX = tokenStyle.textShadowOffsetX || style.textShadowOffsetX || 0;
                subElStyle.shadowOffsetY = tokenStyle.textShadowOffsetY || style.textShadowOffsetY || 0;
            }
            subElStyle.textAlign = textAlign;
            subElStyle.textBaseline = 'middle';
            subElStyle.font = token.font || (0, (0, parcelRequire("b7ZX8")).DEFAULT_FONT);
            subElStyle.opacity = (0, (0, parcelRequire("bahqM")).retrieve3)(tokenStyle.opacity, style.opacity, 1);
            if (textStroke) {
                subElStyle.lineWidth = (0, (0, parcelRequire("bahqM")).retrieve3)(tokenStyle.lineWidth, style.lineWidth, defaultLineWidth);
                subElStyle.lineDash = (0, (0, parcelRequire("bahqM")).retrieve2)(tokenStyle.lineDash, style.lineDash);
                subElStyle.lineDashOffset = style.lineDashOffset || 0;
                subElStyle.stroke = textStroke;
            }
            if (textFill) subElStyle.fill = textFill;
            var textWidth = token.contentWidth;
            var textHeight = token.contentHeight;
            el.setBoundingRect(new (0, (0, parcelRequire("1E3E8")).default)((0, (0, parcelRequire("b7ZX8")).adjustTextX)(subElStyle.x, textWidth, subElStyle.textAlign), (0, (0, parcelRequire("b7ZX8")).adjustTextY)(subElStyle.y, textHeight, subElStyle.textBaseline), textWidth, textHeight));
        };
        ZRText.prototype._renderBackground = function(style, topStyle, x, y, width, height) {
            var textBackgroundColor = style.backgroundColor;
            var textBorderWidth = style.borderWidth;
            var textBorderColor = style.borderColor;
            var isImageBg = textBackgroundColor && textBackgroundColor.image;
            var isPlainOrGradientBg = textBackgroundColor && !isImageBg;
            var textBorderRadius = style.borderRadius;
            var self = this;
            var rectEl;
            var imgEl;
            if (isPlainOrGradientBg || style.lineHeight || textBorderWidth && textBorderColor) {
                rectEl = this._getOrCreateChild((0, (0, parcelRequire("7Tw7u")).default));
                rectEl.useStyle(rectEl.createStyle());
                rectEl.style.fill = null;
                var rectShape = rectEl.shape;
                rectShape.x = x;
                rectShape.y = y;
                rectShape.width = width;
                rectShape.height = height;
                rectShape.r = textBorderRadius;
                rectEl.dirtyShape();
            }
            if (isPlainOrGradientBg) {
                var rectStyle = rectEl.style;
                rectStyle.fill = textBackgroundColor || null;
                rectStyle.fillOpacity = (0, (0, parcelRequire("bahqM")).retrieve2)(style.fillOpacity, 1);
            } else if (isImageBg) {
                imgEl = this._getOrCreateChild((0, (0, parcelRequire("gcbBH")).default));
                imgEl.onload = function() {
                    self.dirtyStyle();
                };
                var imgStyle = imgEl.style;
                imgStyle.image = textBackgroundColor.image;
                imgStyle.x = x;
                imgStyle.y = y;
                imgStyle.width = width;
                imgStyle.height = height;
            }
            if (textBorderWidth && textBorderColor) {
                var rectStyle = rectEl.style;
                rectStyle.lineWidth = textBorderWidth;
                rectStyle.stroke = textBorderColor;
                rectStyle.strokeOpacity = (0, (0, parcelRequire("bahqM")).retrieve2)(style.strokeOpacity, 1);
                rectStyle.lineDash = style.borderDash;
                rectStyle.lineDashOffset = style.borderDashOffset || 0;
                rectEl.strokeContainThreshold = 0;
                if (rectEl.hasFill() && rectEl.hasStroke()) {
                    rectStyle.strokeFirst = true;
                    rectStyle.lineWidth *= 2;
                }
            }
            var commonStyle = (rectEl || imgEl).style;
            commonStyle.shadowBlur = style.shadowBlur || 0;
            commonStyle.shadowColor = style.shadowColor || 'transparent';
            commonStyle.shadowOffsetX = style.shadowOffsetX || 0;
            commonStyle.shadowOffsetY = style.shadowOffsetY || 0;
            commonStyle.opacity = (0, (0, parcelRequire("bahqM")).retrieve3)(style.opacity, topStyle.opacity, 1);
        };
        ZRText.makeFont = function(style) {
            var font = '';
            if (style.fontSize || style.fontFamily || style.fontWeight) {
                var fontSize = '';
                if (typeof style.fontSize === 'string' && (style.fontSize.indexOf('px') !== -1 || style.fontSize.indexOf('rem') !== -1 || style.fontSize.indexOf('em') !== -1)) fontSize = style.fontSize;
                else if (!isNaN(+style.fontSize)) fontSize = style.fontSize + 'px';
                else fontSize = '12px';
                font = [
                    style.fontStyle,
                    style.fontWeight,
                    fontSize,
                    style.fontFamily || 'sans-serif'
                ].join(' ');
            }
            return font && (0, (0, parcelRequire("bahqM")).trim)(font) || style.textFont || style.font;
        };
        return ZRText;
    }((0, (0, parcelRequire("lBQ88")).default));
    var $31b833f429060f54$var$VALID_TEXT_ALIGN = {
        left: true,
        right: 1,
        center: 1
    };
    var $31b833f429060f54$var$VALID_TEXT_VERTICAL_ALIGN = {
        top: 1,
        bottom: 1,
        middle: 1
    };
    function $31b833f429060f54$export$176336068cc5371f(style) {
        $31b833f429060f54$var$normalizeStyle(style);
        (0, (0, parcelRequire("bahqM")).each)(style.rich, $31b833f429060f54$var$normalizeStyle);
        return style;
    }
    function $31b833f429060f54$var$normalizeStyle(style) {
        if (style) {
            style.font = $31b833f429060f54$var$ZRText.makeFont(style);
            var textAlign = style.align;
            textAlign === 'middle' && (textAlign = 'center');
            style.align = textAlign == null || $31b833f429060f54$var$VALID_TEXT_ALIGN[textAlign] ? textAlign : 'left';
            var verticalAlign = style.verticalAlign;
            verticalAlign === 'center' && (verticalAlign = 'middle');
            style.verticalAlign = verticalAlign == null || $31b833f429060f54$var$VALID_TEXT_VERTICAL_ALIGN[verticalAlign] ? verticalAlign : 'top';
            var textPadding = style.padding;
            if (textPadding) style.padding = (0, (0, parcelRequire("bahqM")).normalizeCssArray)(style.padding);
        }
    }
    function $31b833f429060f54$var$getStroke(stroke, lineWidth) {
        return stroke == null || lineWidth <= 0 || stroke === 'transparent' || stroke === 'none' ? null : stroke.image || stroke.colorStops ? '#000' : stroke;
    }
    function $31b833f429060f54$var$getFill(fill) {
        return fill == null || fill === 'none' ? null : fill.image || fill.colorStops ? '#000' : fill;
    }
    function $31b833f429060f54$var$getTextXForPadding(x, textAlign, textPadding) {
        return textAlign === 'right' ? x - textPadding[1] : textAlign === 'center' ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
    }
    function $31b833f429060f54$var$getStyleText(style) {
        var text = style.text;
        text != null && (text += '');
        return text;
    }
    function $31b833f429060f54$var$needDrawBackground(style) {
        return !!(style.backgroundColor || style.lineHeight || style.borderWidth && style.borderColor);
    }
    var $31b833f429060f54$export$2e2bcd8739ae039 = $31b833f429060f54$var$ZRText;
});
parcelRegister("h6fMM", function(module, exports) {
    $parcel$export(module.exports, "truncateText", ()=>$c72f3dec0993863b$export$59a943b34a82e690);
    $parcel$export(module.exports, "parsePlainText", ()=>$c72f3dec0993863b$export$5772575e34ef80f9);
    $parcel$export(module.exports, "parseRichText", ()=>$c72f3dec0993863b$export$15ec9472ff2d721);
    var $63nvx;
    var $bahqM;
    var $b7ZX8;
    var $c72f3dec0993863b$var$STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
    function $c72f3dec0993863b$export$59a943b34a82e690(text, containerWidth, font, ellipsis, options) {
        if (!containerWidth) return '';
        var textLines = (text + '').split('\n');
        options = $c72f3dec0993863b$var$prepareTruncateOptions(containerWidth, font, ellipsis, options);
        for(var i = 0, len = textLines.length; i < len; i++)textLines[i] = $c72f3dec0993863b$var$truncateSingleLine(textLines[i], options);
        return textLines.join('\n');
    }
    function $c72f3dec0993863b$var$prepareTruncateOptions(containerWidth, font, ellipsis, options) {
        options = options || {};
        var preparedOpts = (0, (0, parcelRequire("bahqM")).extend)({}, options);
        preparedOpts.font = font;
        ellipsis = (0, (0, parcelRequire("bahqM")).retrieve2)(ellipsis, '...');
        preparedOpts.maxIterations = (0, (0, parcelRequire("bahqM")).retrieve2)(options.maxIterations, 2);
        var minChar = preparedOpts.minChar = (0, (0, parcelRequire("bahqM")).retrieve2)(options.minChar, 0);
        preparedOpts.cnCharWidth = (0, (0, parcelRequire("b7ZX8")).getWidth)("\u56FD", font);
        var ascCharWidth = preparedOpts.ascCharWidth = (0, (0, parcelRequire("b7ZX8")).getWidth)('a', font);
        preparedOpts.placeholder = (0, (0, parcelRequire("bahqM")).retrieve2)(options.placeholder, '');
        var contentWidth = containerWidth = Math.max(0, containerWidth - 1);
        for(var i = 0; i < minChar && contentWidth >= ascCharWidth; i++)contentWidth -= ascCharWidth;
        var ellipsisWidth = (0, (0, parcelRequire("b7ZX8")).getWidth)(ellipsis, font);
        if (ellipsisWidth > contentWidth) {
            ellipsis = '';
            ellipsisWidth = 0;
        }
        contentWidth = containerWidth - ellipsisWidth;
        preparedOpts.ellipsis = ellipsis;
        preparedOpts.ellipsisWidth = ellipsisWidth;
        preparedOpts.contentWidth = contentWidth;
        preparedOpts.containerWidth = containerWidth;
        return preparedOpts;
    }
    function $c72f3dec0993863b$var$truncateSingleLine(textLine, options) {
        var containerWidth = options.containerWidth;
        var font = options.font;
        var contentWidth = options.contentWidth;
        if (!containerWidth) return '';
        var lineWidth = (0, (0, parcelRequire("b7ZX8")).getWidth)(textLine, font);
        if (lineWidth <= containerWidth) return textLine;
        for(var j = 0;; j++){
            if (lineWidth <= contentWidth || j >= options.maxIterations) {
                textLine += options.ellipsis;
                break;
            }
            var subLength = j === 0 ? $c72f3dec0993863b$var$estimateLength(textLine, contentWidth, options.ascCharWidth, options.cnCharWidth) : lineWidth > 0 ? Math.floor(textLine.length * contentWidth / lineWidth) : 0;
            textLine = textLine.substr(0, subLength);
            lineWidth = (0, (0, parcelRequire("b7ZX8")).getWidth)(textLine, font);
        }
        if (textLine === '') textLine = options.placeholder;
        return textLine;
    }
    function $c72f3dec0993863b$var$estimateLength(text, contentWidth, ascCharWidth, cnCharWidth) {
        var width = 0;
        var i = 0;
        for(var len = text.length; i < len && width < contentWidth; i++){
            var charCode = text.charCodeAt(i);
            width += 0 <= charCode && charCode <= 127 ? ascCharWidth : cnCharWidth;
        }
        return i;
    }
    function $c72f3dec0993863b$export$5772575e34ef80f9(text, style) {
        text != null && (text += '');
        var overflow = style.overflow;
        var padding = style.padding;
        var font = style.font;
        var truncate = overflow === 'truncate';
        var calculatedLineHeight = (0, (0, parcelRequire("b7ZX8")).getLineHeight)(font);
        var lineHeight = (0, (0, parcelRequire("bahqM")).retrieve2)(style.lineHeight, calculatedLineHeight);
        var truncateLineOverflow = style.lineOverflow === 'truncate';
        var width = style.width;
        var lines;
        if (width != null && overflow === 'break' || overflow === 'breakAll') lines = text ? $c72f3dec0993863b$var$wrapText(text, style.font, width, overflow === 'breakAll', 0).lines : [];
        else lines = text ? text.split('\n') : [];
        var contentHeight = lines.length * lineHeight;
        var height = (0, (0, parcelRequire("bahqM")).retrieve2)(style.height, contentHeight);
        if (contentHeight > height && truncateLineOverflow) {
            var lineCount = Math.floor(height / lineHeight);
            lines = lines.slice(0, lineCount);
        }
        var outerHeight = height;
        var outerWidth = width;
        if (padding) {
            outerHeight += padding[0] + padding[2];
            if (outerWidth != null) outerWidth += padding[1] + padding[3];
        }
        if (text && truncate && outerWidth != null) {
            var options = $c72f3dec0993863b$var$prepareTruncateOptions(width, font, style.ellipsis, {
                minChar: style.truncateMinChar,
                placeholder: style.placeholder
            });
            for(var i = 0; i < lines.length; i++)lines[i] = $c72f3dec0993863b$var$truncateSingleLine(lines[i], options);
        }
        if (width == null) {
            var maxWidth = 0;
            for(var i = 0; i < lines.length; i++)maxWidth = Math.max((0, (0, parcelRequire("b7ZX8")).getWidth)(lines[i], font), maxWidth);
            width = maxWidth;
        }
        return {
            lines: lines,
            height: height,
            outerHeight: outerHeight,
            lineHeight: lineHeight,
            calculatedLineHeight: calculatedLineHeight,
            contentHeight: contentHeight,
            width: width
        };
    }
    var $c72f3dec0993863b$var$RichTextToken = function() {
        function RichTextToken() {}
        return RichTextToken;
    }();
    var $c72f3dec0993863b$var$RichTextLine = function() {
        function RichTextLine(tokens) {
            this.tokens = [];
            if (tokens) this.tokens = tokens;
        }
        return RichTextLine;
    }();
    var $c72f3dec0993863b$export$ca607d3c98caaf7e = function() {
        function RichTextContentBlock() {
            this.width = 0;
            this.height = 0;
            this.contentWidth = 0;
            this.contentHeight = 0;
            this.outerWidth = 0;
            this.outerHeight = 0;
            this.lines = [];
        }
        return RichTextContentBlock;
    }();
    function $c72f3dec0993863b$export$15ec9472ff2d721(text, style) {
        var contentBlock = new $c72f3dec0993863b$export$ca607d3c98caaf7e();
        text != null && (text += '');
        if (!text) return contentBlock;
        var topWidth = style.width;
        var topHeight = style.height;
        var overflow = style.overflow;
        var wrapInfo = (overflow === 'break' || overflow === 'breakAll') && topWidth != null ? {
            width: topWidth,
            accumWidth: 0,
            breakAll: overflow === 'breakAll'
        } : null;
        var lastIndex = $c72f3dec0993863b$var$STYLE_REG.lastIndex = 0;
        var result;
        while((result = $c72f3dec0993863b$var$STYLE_REG.exec(text)) != null){
            var matchedIndex = result.index;
            if (matchedIndex > lastIndex) $c72f3dec0993863b$var$pushTokens(contentBlock, text.substring(lastIndex, matchedIndex), style, wrapInfo);
            $c72f3dec0993863b$var$pushTokens(contentBlock, result[2], style, wrapInfo, result[1]);
            lastIndex = $c72f3dec0993863b$var$STYLE_REG.lastIndex;
        }
        if (lastIndex < text.length) $c72f3dec0993863b$var$pushTokens(contentBlock, text.substring(lastIndex, text.length), style, wrapInfo);
        var pendingList = [];
        var calculatedHeight = 0;
        var calculatedWidth = 0;
        var stlPadding = style.padding;
        var truncate = overflow === 'truncate';
        var truncateLine = style.lineOverflow === 'truncate';
        function finishLine(line, lineWidth, lineHeight) {
            line.width = lineWidth;
            line.lineHeight = lineHeight;
            calculatedHeight += lineHeight;
            calculatedWidth = Math.max(calculatedWidth, lineWidth);
        }
        outer: for(var i = 0; i < contentBlock.lines.length; i++){
            var line = contentBlock.lines[i];
            var lineHeight = 0;
            var lineWidth = 0;
            for(var j = 0; j < line.tokens.length; j++){
                var token = line.tokens[j];
                var tokenStyle = token.styleName && style.rich[token.styleName] || {};
                var textPadding = token.textPadding = tokenStyle.padding;
                var paddingH = textPadding ? textPadding[1] + textPadding[3] : 0;
                var font = token.font = tokenStyle.font || style.font;
                token.contentHeight = (0, (0, parcelRequire("b7ZX8")).getLineHeight)(font);
                var tokenHeight = (0, (0, parcelRequire("bahqM")).retrieve2)(tokenStyle.height, token.contentHeight);
                token.innerHeight = tokenHeight;
                textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
                token.height = tokenHeight;
                token.lineHeight = (0, (0, parcelRequire("bahqM")).retrieve3)(tokenStyle.lineHeight, style.lineHeight, tokenHeight);
                token.align = tokenStyle && tokenStyle.align || style.align;
                token.verticalAlign = tokenStyle && tokenStyle.verticalAlign || 'middle';
                if (truncateLine && topHeight != null && calculatedHeight + token.lineHeight > topHeight) {
                    if (j > 0) {
                        line.tokens = line.tokens.slice(0, j);
                        finishLine(line, lineWidth, lineHeight);
                        contentBlock.lines = contentBlock.lines.slice(0, i + 1);
                    } else contentBlock.lines = contentBlock.lines.slice(0, i);
                    break outer;
                }
                var styleTokenWidth = tokenStyle.width;
                var tokenWidthNotSpecified = styleTokenWidth == null || styleTokenWidth === 'auto';
                if (typeof styleTokenWidth === 'string' && styleTokenWidth.charAt(styleTokenWidth.length - 1) === '%') {
                    token.percentWidth = styleTokenWidth;
                    pendingList.push(token);
                    token.contentWidth = (0, (0, parcelRequire("b7ZX8")).getWidth)(token.text, font);
                } else {
                    if (tokenWidthNotSpecified) {
                        var textBackgroundColor = tokenStyle.backgroundColor;
                        var bgImg = textBackgroundColor && textBackgroundColor.image;
                        if (bgImg) {
                            bgImg = (0, parcelRequire("63nvx")).findExistImage(bgImg);
                            if ((0, parcelRequire("63nvx")).isImageReady(bgImg)) token.width = Math.max(token.width, bgImg.width * tokenHeight / bgImg.height);
                        }
                    }
                    var remainTruncWidth = truncate && topWidth != null ? topWidth - lineWidth : null;
                    if (remainTruncWidth != null && remainTruncWidth < token.width) {
                        if (!tokenWidthNotSpecified || remainTruncWidth < paddingH) {
                            token.text = '';
                            token.width = token.contentWidth = 0;
                        } else {
                            token.text = $c72f3dec0993863b$export$59a943b34a82e690(token.text, remainTruncWidth - paddingH, font, style.ellipsis, {
                                minChar: style.truncateMinChar
                            });
                            token.width = token.contentWidth = (0, (0, parcelRequire("b7ZX8")).getWidth)(token.text, font);
                        }
                    } else token.contentWidth = (0, (0, parcelRequire("b7ZX8")).getWidth)(token.text, font);
                }
                token.width += paddingH;
                lineWidth += token.width;
                tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
            }
            finishLine(line, lineWidth, lineHeight);
        }
        contentBlock.outerWidth = contentBlock.width = (0, (0, parcelRequire("bahqM")).retrieve2)(topWidth, calculatedWidth);
        contentBlock.outerHeight = contentBlock.height = (0, (0, parcelRequire("bahqM")).retrieve2)(topHeight, calculatedHeight);
        contentBlock.contentHeight = calculatedHeight;
        contentBlock.contentWidth = calculatedWidth;
        if (stlPadding) {
            contentBlock.outerWidth += stlPadding[1] + stlPadding[3];
            contentBlock.outerHeight += stlPadding[0] + stlPadding[2];
        }
        for(var i = 0; i < pendingList.length; i++){
            var token = pendingList[i];
            var percentWidth = token.percentWidth;
            token.width = parseInt(percentWidth, 10) / 100 * contentBlock.width;
        }
        return contentBlock;
    }
    function $c72f3dec0993863b$var$pushTokens(block, str, style, wrapInfo, styleName) {
        var isEmptyStr = str === '';
        var tokenStyle = styleName && style.rich[styleName] || {};
        var lines = block.lines;
        var font = tokenStyle.font || style.font;
        var newLine = false;
        var strLines;
        var linesWidths;
        if (wrapInfo) {
            var tokenPadding = tokenStyle.padding;
            var tokenPaddingH = tokenPadding ? tokenPadding[1] + tokenPadding[3] : 0;
            if (tokenStyle.width != null && tokenStyle.width !== 'auto') {
                var outerWidth_1 = (0, (0, parcelRequire("b7ZX8")).parsePercent)(tokenStyle.width, wrapInfo.width) + tokenPaddingH;
                if (lines.length > 0) {
                    if (outerWidth_1 + wrapInfo.accumWidth > wrapInfo.width) {
                        strLines = str.split('\n');
                        newLine = true;
                    }
                }
                wrapInfo.accumWidth = outerWidth_1;
            } else {
                var res = $c72f3dec0993863b$var$wrapText(str, font, wrapInfo.width, wrapInfo.breakAll, wrapInfo.accumWidth);
                wrapInfo.accumWidth = res.accumWidth + tokenPaddingH;
                linesWidths = res.linesWidths;
                strLines = res.lines;
            }
        } else strLines = str.split('\n');
        for(var i = 0; i < strLines.length; i++){
            var text = strLines[i];
            var token = new $c72f3dec0993863b$var$RichTextToken();
            token.styleName = styleName;
            token.text = text;
            token.isLineHolder = !text && !isEmptyStr;
            if (typeof tokenStyle.width === 'number') token.width = tokenStyle.width;
            else token.width = linesWidths ? linesWidths[i] : (0, (0, parcelRequire("b7ZX8")).getWidth)(text, font);
            if (!i && !newLine) {
                var tokens = (lines[lines.length - 1] || (lines[0] = new $c72f3dec0993863b$var$RichTextLine())).tokens;
                var tokensLen = tokens.length;
                tokensLen === 1 && tokens[0].isLineHolder ? tokens[0] = token : (text || !tokensLen || isEmptyStr) && tokens.push(token);
            } else lines.push(new $c72f3dec0993863b$var$RichTextLine([
                token
            ]));
        }
    }
    function $c72f3dec0993863b$var$isLatin(ch) {
        var code = ch.charCodeAt(0);
        return code >= 0x21 && code <= 0xFF;
    }
    var $c72f3dec0993863b$var$breakCharMap = (0, (0, parcelRequire("bahqM")).reduce)(',&?/;] '.split(''), function(obj, ch) {
        obj[ch] = true;
        return obj;
    }, {});
    function $c72f3dec0993863b$var$isWordBreakChar(ch) {
        if ($c72f3dec0993863b$var$isLatin(ch)) {
            if ($c72f3dec0993863b$var$breakCharMap[ch]) return true;
            return false;
        }
        return true;
    }
    function $c72f3dec0993863b$var$wrapText(text, font, lineWidth, isBreakAll, lastAccumWidth) {
        var lines = [];
        var linesWidths = [];
        var line = '';
        var currentWord = '';
        var currentWordWidth = 0;
        var accumWidth = 0;
        for(var i = 0; i < text.length; i++){
            var ch = text.charAt(i);
            if (ch === '\n') {
                if (currentWord) {
                    line += currentWord;
                    accumWidth += currentWordWidth;
                }
                lines.push(line);
                linesWidths.push(accumWidth);
                line = '';
                currentWord = '';
                currentWordWidth = 0;
                accumWidth = 0;
                continue;
            }
            var chWidth = (0, (0, parcelRequire("b7ZX8")).getWidth)(ch, font);
            var inWord = isBreakAll ? false : !$c72f3dec0993863b$var$isWordBreakChar(ch);
            if (!lines.length ? lastAccumWidth + accumWidth + chWidth > lineWidth : accumWidth + chWidth > lineWidth) {
                if (!accumWidth) {
                    if (inWord) {
                        lines.push(currentWord);
                        linesWidths.push(currentWordWidth);
                        currentWord = ch;
                        currentWordWidth = chWidth;
                    } else {
                        lines.push(ch);
                        linesWidths.push(chWidth);
                    }
                } else if (line || currentWord) {
                    if (inWord) {
                        if (!line) {
                            line = currentWord;
                            currentWord = '';
                            currentWordWidth = 0;
                            accumWidth = currentWordWidth;
                        }
                        lines.push(line);
                        linesWidths.push(accumWidth - currentWordWidth);
                        currentWord += ch;
                        currentWordWidth += chWidth;
                        line = '';
                        accumWidth = currentWordWidth;
                    } else {
                        if (currentWord) {
                            line += currentWord;
                            accumWidth += currentWordWidth;
                            currentWord = '';
                            currentWordWidth = 0;
                        }
                        lines.push(line);
                        linesWidths.push(accumWidth);
                        line = ch;
                        accumWidth = chWidth;
                    }
                }
                continue;
            }
            accumWidth += chWidth;
            if (inWord) {
                currentWord += ch;
                currentWordWidth += chWidth;
            } else {
                if (currentWord) {
                    line += currentWord;
                    currentWord = '';
                    currentWordWidth = 0;
                }
                line += ch;
            }
        }
        if (!lines.length && !line) {
            line = text;
            currentWord = '';
            currentWordWidth = 0;
        }
        if (currentWord) line += currentWord;
        if (line) {
            lines.push(line);
            linesWidths.push(accumWidth);
        }
        if (lines.length === 1) accumWidth += lastAccumWidth;
        return {
            accumWidth: accumWidth,
            lines: lines,
            linesWidths: linesWidths
        };
    }
});
parcelRegister("63nvx", function(module, exports) {
    $parcel$export(module.exports, "findExistImage", ()=>$468542031e7bbc2a$export$1b614f30ac2c8867);
    $parcel$export(module.exports, "createOrUpdateImage", ()=>$468542031e7bbc2a$export$46c791b69ff9a0f);
    $parcel$export(module.exports, "isImageReady", ()=>$468542031e7bbc2a$export$37ca7dd901d0236d);
    var $h4RuA;
    var $468542031e7bbc2a$var$globalImageCache = new (0, (0, parcelRequire("h4RuA")).default)(50);
    function $468542031e7bbc2a$export$1b614f30ac2c8867(newImageOrSrc) {
        if (typeof newImageOrSrc === 'string') {
            var cachedImgObj = $468542031e7bbc2a$var$globalImageCache.get(newImageOrSrc);
            return cachedImgObj && cachedImgObj.image;
        } else return newImageOrSrc;
    }
    function $468542031e7bbc2a$export$46c791b69ff9a0f(newImageOrSrc, image, hostEl, onload, cbPayload) {
        if (!newImageOrSrc) return image;
        else if (typeof newImageOrSrc === 'string') {
            if (image && image.__zrImageSrc === newImageOrSrc || !hostEl) return image;
            var cachedImgObj = $468542031e7bbc2a$var$globalImageCache.get(newImageOrSrc);
            var pendingWrap = {
                hostEl: hostEl,
                cb: onload,
                cbPayload: cbPayload
            };
            if (cachedImgObj) {
                image = cachedImgObj.image;
                !$468542031e7bbc2a$export$37ca7dd901d0236d(image) && cachedImgObj.pending.push(pendingWrap);
            } else {
                image = new Image();
                image.onload = image.onerror = $468542031e7bbc2a$var$imageOnLoad;
                $468542031e7bbc2a$var$globalImageCache.put(newImageOrSrc, image.__cachedImgObj = {
                    image: image,
                    pending: [
                        pendingWrap
                    ]
                });
                image.src = image.__zrImageSrc = newImageOrSrc;
            }
            return image;
        } else return newImageOrSrc;
    }
    function $468542031e7bbc2a$var$imageOnLoad() {
        var cachedImgObj = this.__cachedImgObj;
        this.onload = this.onerror = this.__cachedImgObj = null;
        for(var i = 0; i < cachedImgObj.pending.length; i++){
            var pendingWrap = cachedImgObj.pending[i];
            var cb = pendingWrap.cb;
            cb && cb(this, pendingWrap.cbPayload);
            pendingWrap.hostEl.dirty();
        }
        cachedImgObj.pending.length = 0;
    }
    function $468542031e7bbc2a$export$37ca7dd901d0236d(image) {
        return image && image.width && image.height;
    }
});
parcelRegister("b7ZX8", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_FONT", ()=>$81a067b5a1d9459c$export$7d7a232b6d2cc80c);
    $parcel$export(module.exports, "getWidth", ()=>$81a067b5a1d9459c$export$3c49c185de0c2bfc);
    $parcel$export(module.exports, "getLineHeight", ()=>$81a067b5a1d9459c$export$56204a27a2958a55);
    $parcel$export(module.exports, "adjustTextX", ()=>$81a067b5a1d9459c$export$eb5a525ef00ef9a4);
    $parcel$export(module.exports, "adjustTextY", ()=>$81a067b5a1d9459c$export$bf7d6802d2badd9);
    $parcel$export(module.exports, "getBoundingRect", ()=>$81a067b5a1d9459c$export$c381147bfed79d9f);
    $parcel$export(module.exports, "parsePercent", ()=>$81a067b5a1d9459c$export$e8514cb5a5e2b40f);
    $parcel$export(module.exports, "calculateTextPosition", ()=>$81a067b5a1d9459c$export$eee3603b512feab7);
    var $1E3E8;
    var $bahqM;
    var $h4RuA;
    var $81a067b5a1d9459c$var$textWidthCache = {};
    var $81a067b5a1d9459c$export$7d7a232b6d2cc80c = '12px sans-serif';
    var $81a067b5a1d9459c$var$_ctx;
    var $81a067b5a1d9459c$var$_cachedFont;
    function $81a067b5a1d9459c$var$defaultMeasureText(text, font) {
        if (!$81a067b5a1d9459c$var$_ctx) $81a067b5a1d9459c$var$_ctx = (0, (0, parcelRequire("bahqM")).createCanvas)().getContext('2d');
        if ($81a067b5a1d9459c$var$_cachedFont !== font) $81a067b5a1d9459c$var$_cachedFont = $81a067b5a1d9459c$var$_ctx.font = font || $81a067b5a1d9459c$export$7d7a232b6d2cc80c;
        return $81a067b5a1d9459c$var$_ctx.measureText(text);
    }
    var $81a067b5a1d9459c$var$methods = {
        measureText: $81a067b5a1d9459c$var$defaultMeasureText
    };
    function $81a067b5a1d9459c$export$d35a04b83ea6803e(name, fn) {
        $81a067b5a1d9459c$var$methods[name] = fn;
    }
    function $81a067b5a1d9459c$export$3c49c185de0c2bfc(text, font) {
        font = font || $81a067b5a1d9459c$export$7d7a232b6d2cc80c;
        var cacheOfFont = $81a067b5a1d9459c$var$textWidthCache[font];
        if (!cacheOfFont) cacheOfFont = $81a067b5a1d9459c$var$textWidthCache[font] = new (0, (0, parcelRequire("h4RuA")).default)(500);
        var width = cacheOfFont.get(text);
        if (width == null) {
            width = $81a067b5a1d9459c$var$methods.measureText(text, font).width;
            cacheOfFont.put(text, width);
        }
        return width;
    }
    function $81a067b5a1d9459c$export$85aabf24202fbe9b(text, font, textAlign, textBaseline) {
        var width = $81a067b5a1d9459c$export$3c49c185de0c2bfc(text, font);
        var height = $81a067b5a1d9459c$export$56204a27a2958a55(font);
        var x = $81a067b5a1d9459c$export$eb5a525ef00ef9a4(0, width, textAlign);
        var y = $81a067b5a1d9459c$export$bf7d6802d2badd9(0, height, textBaseline);
        var rect = new (0, (0, parcelRequire("1E3E8")).default)(x, y, width, height);
        return rect;
    }
    function $81a067b5a1d9459c$export$c381147bfed79d9f(text, font, textAlign, textBaseline) {
        var textLines = ((text || '') + '').split('\n');
        var len = textLines.length;
        if (len === 1) return $81a067b5a1d9459c$export$85aabf24202fbe9b(textLines[0], font, textAlign, textBaseline);
        else {
            var uniondRect = new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0);
            for(var i = 0; i < textLines.length; i++){
                var rect = $81a067b5a1d9459c$export$85aabf24202fbe9b(textLines[i], font, textAlign, textBaseline);
                i === 0 ? uniondRect.copy(rect) : uniondRect.union(rect);
            }
            return uniondRect;
        }
    }
    function $81a067b5a1d9459c$export$eb5a525ef00ef9a4(x, width, textAlign) {
        if (textAlign === 'right') x -= width;
        else if (textAlign === 'center') x -= width / 2;
        return x;
    }
    function $81a067b5a1d9459c$export$bf7d6802d2badd9(y, height, verticalAlign) {
        if (verticalAlign === 'middle') y -= height / 2;
        else if (verticalAlign === 'bottom') y -= height;
        return y;
    }
    function $81a067b5a1d9459c$export$56204a27a2958a55(font) {
        return $81a067b5a1d9459c$export$3c49c185de0c2bfc("\u56FD", font);
    }
    function $81a067b5a1d9459c$export$866cc30a33805630(text, font) {
        return $81a067b5a1d9459c$var$methods.measureText(text, font);
    }
    function $81a067b5a1d9459c$export$e8514cb5a5e2b40f(value, maxValue) {
        if (typeof value === 'string') {
            if (value.lastIndexOf('%') >= 0) return parseFloat(value) / 100 * maxValue;
            return parseFloat(value);
        }
        return value;
    }
    function $81a067b5a1d9459c$export$eee3603b512feab7(out, opts, rect) {
        var textPosition = opts.position || 'inside';
        var distance = opts.distance != null ? opts.distance : 5;
        var height = rect.height;
        var width = rect.width;
        var halfHeight = height / 2;
        var x = rect.x;
        var y = rect.y;
        var textAlign = 'left';
        var textVerticalAlign = 'top';
        if (textPosition instanceof Array) {
            x += $81a067b5a1d9459c$export$e8514cb5a5e2b40f(textPosition[0], rect.width);
            y += $81a067b5a1d9459c$export$e8514cb5a5e2b40f(textPosition[1], rect.height);
            textAlign = null;
            textVerticalAlign = null;
        } else switch(textPosition){
            case 'left':
                x -= distance;
                y += halfHeight;
                textAlign = 'right';
                textVerticalAlign = 'middle';
                break;
            case 'right':
                x += distance + width;
                y += halfHeight;
                textVerticalAlign = 'middle';
                break;
            case 'top':
                x += width / 2;
                y -= distance;
                textAlign = 'center';
                textVerticalAlign = 'bottom';
                break;
            case 'bottom':
                x += width / 2;
                y += height + distance;
                textAlign = 'center';
                break;
            case 'inside':
                x += width / 2;
                y += halfHeight;
                textAlign = 'center';
                textVerticalAlign = 'middle';
                break;
            case 'insideLeft':
                x += distance;
                y += halfHeight;
                textVerticalAlign = 'middle';
                break;
            case 'insideRight':
                x += width - distance;
                y += halfHeight;
                textAlign = 'right';
                textVerticalAlign = 'middle';
                break;
            case 'insideTop':
                x += width / 2;
                y += distance;
                textAlign = 'center';
                break;
            case 'insideBottom':
                x += width / 2;
                y += height - distance;
                textAlign = 'center';
                textVerticalAlign = 'bottom';
                break;
            case 'insideTopLeft':
                x += distance;
                y += distance;
                break;
            case 'insideTopRight':
                x += width - distance;
                y += distance;
                textAlign = 'right';
                break;
            case 'insideBottomLeft':
                x += distance;
                y += height - distance;
                textVerticalAlign = 'bottom';
                break;
            case 'insideBottomRight':
                x += width - distance;
                y += height - distance;
                textAlign = 'right';
                textVerticalAlign = 'bottom';
                break;
        }
        out = out || {};
        out.x = x;
        out.y = y;
        out.align = textAlign;
        out.verticalAlign = textVerticalAlign;
        return out;
    }
});
parcelRegister("1E3E8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$132c5af5562dffd4$export$2e2bcd8739ae039);
    var $izqgC;
    var $bMDnR;
    var $132c5af5562dffd4$var$mathMin = Math.min;
    var $132c5af5562dffd4$var$mathMax = Math.max;
    var $132c5af5562dffd4$var$lt = new (0, (0, parcelRequire("bMDnR")).default)();
    var $132c5af5562dffd4$var$rb = new (0, (0, parcelRequire("bMDnR")).default)();
    var $132c5af5562dffd4$var$lb = new (0, (0, parcelRequire("bMDnR")).default)();
    var $132c5af5562dffd4$var$rt = new (0, (0, parcelRequire("bMDnR")).default)();
    var $132c5af5562dffd4$var$minTv = new (0, (0, parcelRequire("bMDnR")).default)();
    var $132c5af5562dffd4$var$maxTv = new (0, (0, parcelRequire("bMDnR")).default)();
    var $132c5af5562dffd4$var$BoundingRect = function() {
        function BoundingRect(x, y, width, height) {
            if (width < 0) {
                x = x + width;
                width = -width;
            }
            if (height < 0) {
                y = y + height;
                height = -height;
            }
            this.x = x;
            this.y = y;
            this.width = width;
            this.height = height;
        }
        BoundingRect.prototype.union = function(other) {
            var x = $132c5af5562dffd4$var$mathMin(other.x, this.x);
            var y = $132c5af5562dffd4$var$mathMin(other.y, this.y);
            if (isFinite(this.x) && isFinite(this.width)) this.width = $132c5af5562dffd4$var$mathMax(other.x + other.width, this.x + this.width) - x;
            else this.width = other.width;
            if (isFinite(this.y) && isFinite(this.height)) this.height = $132c5af5562dffd4$var$mathMax(other.y + other.height, this.y + this.height) - y;
            else this.height = other.height;
            this.x = x;
            this.y = y;
        };
        BoundingRect.prototype.applyTransform = function(m) {
            BoundingRect.applyTransform(this, this, m);
        };
        BoundingRect.prototype.calculateTransform = function(b) {
            var a = this;
            var sx = b.width / a.width;
            var sy = b.height / a.height;
            var m = (0, parcelRequire("izqgC")).create();
            (0, parcelRequire("izqgC")).translate(m, m, [
                -a.x,
                -a.y
            ]);
            (0, parcelRequire("izqgC")).scale(m, m, [
                sx,
                sy
            ]);
            (0, parcelRequire("izqgC")).translate(m, m, [
                b.x,
                b.y
            ]);
            return m;
        };
        BoundingRect.prototype.intersect = function(b, mtv) {
            if (!b) return false;
            if (!(b instanceof BoundingRect)) b = BoundingRect.create(b);
            var a = this;
            var ax0 = a.x;
            var ax1 = a.x + a.width;
            var ay0 = a.y;
            var ay1 = a.y + a.height;
            var bx0 = b.x;
            var bx1 = b.x + b.width;
            var by0 = b.y;
            var by1 = b.y + b.height;
            var overlap = !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
            if (mtv) {
                var dMin = Infinity;
                var dMax = 0;
                var d0 = Math.abs(ax1 - bx0);
                var d1 = Math.abs(bx1 - ax0);
                var d2 = Math.abs(ay1 - by0);
                var d3 = Math.abs(by1 - ay0);
                var dx = Math.min(d0, d1);
                var dy = Math.min(d2, d3);
                if (ax1 < bx0 || bx1 < ax0) {
                    if (dx > dMax) {
                        dMax = dx;
                        if (d0 < d1) (0, (0, parcelRequire("bMDnR")).default).set($132c5af5562dffd4$var$maxTv, -d0, 0);
                        else (0, (0, parcelRequire("bMDnR")).default).set($132c5af5562dffd4$var$maxTv, d1, 0);
                    }
                } else if (dx < dMin) {
                    dMin = dx;
                    if (d0 < d1) (0, (0, parcelRequire("bMDnR")).default).set($132c5af5562dffd4$var$minTv, d0, 0);
                    else (0, (0, parcelRequire("bMDnR")).default).set($132c5af5562dffd4$var$minTv, -d1, 0);
                }
                if (ay1 < by0 || by1 < ay0) {
                    if (dy > dMax) {
                        dMax = dy;
                        if (d2 < d3) (0, (0, parcelRequire("bMDnR")).default).set($132c5af5562dffd4$var$maxTv, 0, -d2);
                        else (0, (0, parcelRequire("bMDnR")).default).set($132c5af5562dffd4$var$maxTv, 0, d3);
                    }
                } else if (dx < dMin) {
                    dMin = dx;
                    if (d2 < d3) (0, (0, parcelRequire("bMDnR")).default).set($132c5af5562dffd4$var$minTv, 0, d2);
                    else (0, (0, parcelRequire("bMDnR")).default).set($132c5af5562dffd4$var$minTv, 0, -d3);
                }
            }
            if (mtv) (0, (0, parcelRequire("bMDnR")).default).copy(mtv, overlap ? $132c5af5562dffd4$var$minTv : $132c5af5562dffd4$var$maxTv);
            return overlap;
        };
        BoundingRect.prototype.contain = function(x, y) {
            var rect = this;
            return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
        };
        BoundingRect.prototype.clone = function() {
            return new BoundingRect(this.x, this.y, this.width, this.height);
        };
        BoundingRect.prototype.copy = function(other) {
            BoundingRect.copy(this, other);
        };
        BoundingRect.prototype.plain = function() {
            return {
                x: this.x,
                y: this.y,
                width: this.width,
                height: this.height
            };
        };
        BoundingRect.prototype.isFinite = function() {
            return isFinite(this.x) && isFinite(this.y) && isFinite(this.width) && isFinite(this.height);
        };
        BoundingRect.prototype.isZero = function() {
            return this.width === 0 || this.height === 0;
        };
        BoundingRect.create = function(rect) {
            return new BoundingRect(rect.x, rect.y, rect.width, rect.height);
        };
        BoundingRect.copy = function(target, source) {
            target.x = source.x;
            target.y = source.y;
            target.width = source.width;
            target.height = source.height;
        };
        BoundingRect.applyTransform = function(target, source, m) {
            if (!m) {
                if (target !== source) BoundingRect.copy(target, source);
                return;
            }
            if (m[1] < 1e-5 && m[1] > -0.00001 && m[2] < 1e-5 && m[2] > -0.00001) {
                var sx = m[0];
                var sy = m[3];
                var tx = m[4];
                var ty = m[5];
                target.x = source.x * sx + tx;
                target.y = source.y * sy + ty;
                target.width = source.width * sx;
                target.height = source.height * sy;
                if (target.width < 0) {
                    target.x += target.width;
                    target.width = -target.width;
                }
                if (target.height < 0) {
                    target.y += target.height;
                    target.height = -target.height;
                }
                return;
            }
            $132c5af5562dffd4$var$lt.x = $132c5af5562dffd4$var$lb.x = source.x;
            $132c5af5562dffd4$var$lt.y = $132c5af5562dffd4$var$rt.y = source.y;
            $132c5af5562dffd4$var$rb.x = $132c5af5562dffd4$var$rt.x = source.x + source.width;
            $132c5af5562dffd4$var$rb.y = $132c5af5562dffd4$var$lb.y = source.y + source.height;
            $132c5af5562dffd4$var$lt.transform(m);
            $132c5af5562dffd4$var$rt.transform(m);
            $132c5af5562dffd4$var$rb.transform(m);
            $132c5af5562dffd4$var$lb.transform(m);
            target.x = $132c5af5562dffd4$var$mathMin($132c5af5562dffd4$var$lt.x, $132c5af5562dffd4$var$rb.x, $132c5af5562dffd4$var$lb.x, $132c5af5562dffd4$var$rt.x);
            target.y = $132c5af5562dffd4$var$mathMin($132c5af5562dffd4$var$lt.y, $132c5af5562dffd4$var$rb.y, $132c5af5562dffd4$var$lb.y, $132c5af5562dffd4$var$rt.y);
            var maxX = $132c5af5562dffd4$var$mathMax($132c5af5562dffd4$var$lt.x, $132c5af5562dffd4$var$rb.x, $132c5af5562dffd4$var$lb.x, $132c5af5562dffd4$var$rt.x);
            var maxY = $132c5af5562dffd4$var$mathMax($132c5af5562dffd4$var$lt.y, $132c5af5562dffd4$var$rb.y, $132c5af5562dffd4$var$lb.y, $132c5af5562dffd4$var$rt.y);
            target.width = maxX - target.x;
            target.height = maxY - target.y;
        };
        return BoundingRect;
    }();
    var $132c5af5562dffd4$export$2e2bcd8739ae039 = $132c5af5562dffd4$var$BoundingRect;
});
parcelRegister("izqgC", function(module, exports) {
    $parcel$export(module.exports, "create", ()=>$d84fdef7d2e904e1$export$185802fd694ee1f5);
    $parcel$export(module.exports, "identity", ()=>$d84fdef7d2e904e1$export$f0954fd7d5368655);
    $parcel$export(module.exports, "copy", ()=>$d84fdef7d2e904e1$export$784d13d8ee351f07);
    $parcel$export(module.exports, "mul", ()=>$d84fdef7d2e904e1$export$6e3a27864ab166fe);
    $parcel$export(module.exports, "translate", ()=>$d84fdef7d2e904e1$export$d73ee8ef04f5226a);
    $parcel$export(module.exports, "rotate", ()=>$d84fdef7d2e904e1$export$bb628a54ab399bc9);
    $parcel$export(module.exports, "scale", ()=>$d84fdef7d2e904e1$export$dcdf75081b88279d);
    $parcel$export(module.exports, "invert", ()=>$d84fdef7d2e904e1$export$6897c284b6f9f4dc);
    $parcel$export(module.exports, "clone", ()=>$d84fdef7d2e904e1$export$9cd59f9826255e47);
    function $d84fdef7d2e904e1$export$185802fd694ee1f5() {
        return [
            1,
            0,
            0,
            1,
            0,
            0
        ];
    }
    function $d84fdef7d2e904e1$export$f0954fd7d5368655(out) {
        out[0] = 1;
        out[1] = 0;
        out[2] = 0;
        out[3] = 1;
        out[4] = 0;
        out[5] = 0;
        return out;
    }
    function $d84fdef7d2e904e1$export$784d13d8ee351f07(out, m) {
        out[0] = m[0];
        out[1] = m[1];
        out[2] = m[2];
        out[3] = m[3];
        out[4] = m[4];
        out[5] = m[5];
        return out;
    }
    function $d84fdef7d2e904e1$export$6e3a27864ab166fe(out, m1, m2) {
        var out0 = m1[0] * m2[0] + m1[2] * m2[1];
        var out1 = m1[1] * m2[0] + m1[3] * m2[1];
        var out2 = m1[0] * m2[2] + m1[2] * m2[3];
        var out3 = m1[1] * m2[2] + m1[3] * m2[3];
        var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
        var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
        out[0] = out0;
        out[1] = out1;
        out[2] = out2;
        out[3] = out3;
        out[4] = out4;
        out[5] = out5;
        return out;
    }
    function $d84fdef7d2e904e1$export$d73ee8ef04f5226a(out, a, v) {
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        out[4] = a[4] + v[0];
        out[5] = a[5] + v[1];
        return out;
    }
    function $d84fdef7d2e904e1$export$bb628a54ab399bc9(out, a, rad) {
        var aa = a[0];
        var ac = a[2];
        var atx = a[4];
        var ab = a[1];
        var ad = a[3];
        var aty = a[5];
        var st = Math.sin(rad);
        var ct = Math.cos(rad);
        out[0] = aa * ct + ab * st;
        out[1] = -aa * st + ab * ct;
        out[2] = ac * ct + ad * st;
        out[3] = -ac * st + ct * ad;
        out[4] = ct * atx + st * aty;
        out[5] = ct * aty - st * atx;
        return out;
    }
    function $d84fdef7d2e904e1$export$dcdf75081b88279d(out, a, v) {
        var vx = v[0];
        var vy = v[1];
        out[0] = a[0] * vx;
        out[1] = a[1] * vy;
        out[2] = a[2] * vx;
        out[3] = a[3] * vy;
        out[4] = a[4] * vx;
        out[5] = a[5] * vy;
        return out;
    }
    function $d84fdef7d2e904e1$export$6897c284b6f9f4dc(out, a) {
        var aa = a[0];
        var ac = a[2];
        var atx = a[4];
        var ab = a[1];
        var ad = a[3];
        var aty = a[5];
        var det = aa * ad - ab * ac;
        if (!det) return null;
        det = 1.0 / det;
        out[0] = ad * det;
        out[1] = -ab * det;
        out[2] = -ac * det;
        out[3] = aa * det;
        out[4] = (ac * aty - ad * atx) * det;
        out[5] = (ab * atx - aa * aty) * det;
        return out;
    }
    function $d84fdef7d2e904e1$export$9cd59f9826255e47(a) {
        var b = $d84fdef7d2e904e1$export$185802fd694ee1f5();
        $d84fdef7d2e904e1$export$784d13d8ee351f07(b, a);
        return b;
    }
});
parcelRegister("bMDnR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8942ba3a66d599f1$export$2e2bcd8739ae039);
    var $8942ba3a66d599f1$var$Point = function() {
        function Point(x, y) {
            this.x = x || 0;
            this.y = y || 0;
        }
        Point.prototype.copy = function(other) {
            this.x = other.x;
            this.y = other.y;
            return this;
        };
        Point.prototype.clone = function() {
            return new Point(this.x, this.y);
        };
        Point.prototype.set = function(x, y) {
            this.x = x;
            this.y = y;
            return this;
        };
        Point.prototype.equal = function(other) {
            return other.x === this.x && other.y === this.y;
        };
        Point.prototype.add = function(other) {
            this.x += other.x;
            this.y += other.y;
            return this;
        };
        Point.prototype.scale = function(scalar) {
            this.x *= scalar;
            this.y *= scalar;
        };
        Point.prototype.scaleAndAdd = function(other, scalar) {
            this.x += other.x * scalar;
            this.y += other.y * scalar;
        };
        Point.prototype.sub = function(other) {
            this.x -= other.x;
            this.y -= other.y;
            return this;
        };
        Point.prototype.dot = function(other) {
            return this.x * other.x + this.y * other.y;
        };
        Point.prototype.len = function() {
            return Math.sqrt(this.x * this.x + this.y * this.y);
        };
        Point.prototype.lenSquare = function() {
            return this.x * this.x + this.y * this.y;
        };
        Point.prototype.normalize = function() {
            var len = this.len();
            this.x /= len;
            this.y /= len;
            return this;
        };
        Point.prototype.distance = function(other) {
            var dx = this.x - other.x;
            var dy = this.y - other.y;
            return Math.sqrt(dx * dx + dy * dy);
        };
        Point.prototype.distanceSquare = function(other) {
            var dx = this.x - other.x;
            var dy = this.y - other.y;
            return dx * dx + dy * dy;
        };
        Point.prototype.negate = function() {
            this.x = -this.x;
            this.y = -this.y;
            return this;
        };
        Point.prototype.transform = function(m) {
            if (!m) return;
            var x = this.x;
            var y = this.y;
            this.x = m[0] * x + m[2] * y + m[4];
            this.y = m[1] * x + m[3] * y + m[5];
            return this;
        };
        Point.prototype.toArray = function(out) {
            out[0] = this.x;
            out[1] = this.y;
            return out;
        };
        Point.prototype.fromArray = function(input) {
            this.x = input[0];
            this.y = input[1];
        };
        Point.set = function(p, x, y) {
            p.x = x;
            p.y = y;
        };
        Point.copy = function(p, p2) {
            p.x = p2.x;
            p.y = p2.y;
        };
        Point.len = function(p) {
            return Math.sqrt(p.x * p.x + p.y * p.y);
        };
        Point.lenSquare = function(p) {
            return p.x * p.x + p.y * p.y;
        };
        Point.dot = function(p0, p1) {
            return p0.x * p1.x + p0.y * p1.y;
        };
        Point.add = function(out, p0, p1) {
            out.x = p0.x + p1.x;
            out.y = p0.y + p1.y;
        };
        Point.sub = function(out, p0, p1) {
            out.x = p0.x - p1.x;
            out.y = p0.y - p1.y;
        };
        Point.scale = function(out, p0, scalar) {
            out.x = p0.x * scalar;
            out.y = p0.y * scalar;
        };
        Point.scaleAndAdd = function(out, p0, p1, scalar) {
            out.x = p0.x + p1.x * scalar;
            out.y = p0.y + p1.y * scalar;
        };
        Point.lerp = function(out, p0, p1, t) {
            var onet = 1 - t;
            out.x = onet * p0.x + t * p1.x;
            out.y = onet * p0.y + t * p1.y;
        };
        return Point;
    }();
    var $8942ba3a66d599f1$export$2e2bcd8739ae039 = $8942ba3a66d599f1$var$Point;
});
parcelRegister("45jlh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2f96a200e6d0cf38$export$2e2bcd8739ae039);
    var $3VFsf;
    var $lBQ88;
    var $b7ZX8;
    var $ghQ8v;
    var $bahqM;
    var $2f96a200e6d0cf38$export$5fbb6d98091bcb56 = (0, (0, parcelRequire("bahqM")).defaults)({
        strokeFirst: true,
        font: (0, (0, parcelRequire("b7ZX8")).DEFAULT_FONT),
        x: 0,
        y: 0,
        textAlign: 'left',
        textBaseline: 'top',
        miterLimit: 2
    }, (0, (0, parcelRequire("ghQ8v")).DEFAULT_PATH_STYLE));
    var $2f96a200e6d0cf38$var$TSpan = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(TSpan, _super);
        function TSpan() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        TSpan.prototype.hasStroke = function() {
            var style = this.style;
            var stroke = style.stroke;
            return stroke != null && stroke !== 'none' && style.lineWidth > 0;
        };
        TSpan.prototype.hasFill = function() {
            var style = this.style;
            var fill = style.fill;
            return fill != null && fill !== 'none';
        };
        TSpan.prototype.createStyle = function(obj) {
            return (0, (0, parcelRequire("bahqM")).createObject)($2f96a200e6d0cf38$export$5fbb6d98091bcb56, obj);
        };
        TSpan.prototype.setBoundingRect = function(rect) {
            this._rect = rect;
        };
        TSpan.prototype.getBoundingRect = function() {
            var style = this.style;
            if (!this._rect) {
                var text = style.text;
                text != null ? text += '' : text = '';
                var rect = (0, (0, parcelRequire("b7ZX8")).getBoundingRect)(text, style.font, style.textAlign, style.textBaseline);
                rect.x += style.x || 0;
                rect.y += style.y || 0;
                if (this.hasStroke()) {
                    var w = style.lineWidth;
                    rect.x -= w / 2;
                    rect.y -= w / 2;
                    rect.width += w;
                    rect.height += w;
                }
                this._rect = rect;
            }
            return this._rect;
        };
        TSpan.initDefaultProps = function() {
            var tspanProto = TSpan.prototype;
            tspanProto.dirtyRectTolerance = 10;
        }();
        return TSpan;
    }((0, (0, parcelRequire("lBQ88")).default));
    $2f96a200e6d0cf38$var$TSpan.prototype.type = 'tspan';
    var $2f96a200e6d0cf38$export$2e2bcd8739ae039 = $2f96a200e6d0cf38$var$TSpan;
});
parcelRegister("lBQ88", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_COMMON_STYLE", ()=>$fbb57da3b649c75e$export$737672163db00fe3);
    $parcel$export(module.exports, "DEFAULT_COMMON_ANIMATION_PROPS", ()=>$fbb57da3b649c75e$export$9908943fb57fbe51);
    $parcel$export(module.exports, "default", ()=>$fbb57da3b649c75e$export$2e2bcd8739ae039);
    var $3VFsf;
    var $7KVc5;
    var $1E3E8;
    var $bahqM;
    var $aVawM;
    var $fbb57da3b649c75e$var$STYLE_MAGIC_KEY = '__zr_style_' + Math.round(Math.random() * 10);
    var $fbb57da3b649c75e$export$737672163db00fe3 = {
        shadowBlur: 0,
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        shadowColor: '#000',
        opacity: 1,
        blend: 'source-over'
    };
    var $fbb57da3b649c75e$export$9908943fb57fbe51 = {
        style: {
            shadowBlur: true,
            shadowOffsetX: true,
            shadowOffsetY: true,
            shadowColor: true,
            opacity: true
        }
    };
    $fbb57da3b649c75e$export$737672163db00fe3[$fbb57da3b649c75e$var$STYLE_MAGIC_KEY] = true;
    var $fbb57da3b649c75e$var$PRIMARY_STATES_KEYS = [
        'z',
        'z2',
        'invisible'
    ];
    var $fbb57da3b649c75e$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER = [
        'invisible'
    ];
    var $fbb57da3b649c75e$var$Displayable = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Displayable, _super);
        function Displayable(props) {
            return _super.call(this, props) || this;
        }
        Displayable.prototype._init = function(props) {
            var keysArr = (0, (0, parcelRequire("bahqM")).keys)(props);
            for(var i = 0; i < keysArr.length; i++){
                var key = keysArr[i];
                if (key === 'style') this.useStyle(props[key]);
                else _super.prototype.attrKV.call(this, key, props[key]);
            }
            if (!this.style) this.useStyle({});
        };
        Displayable.prototype.beforeBrush = function() {};
        Displayable.prototype.afterBrush = function() {};
        Displayable.prototype.innerBeforeBrush = function() {};
        Displayable.prototype.innerAfterBrush = function() {};
        Displayable.prototype.shouldBePainted = function(viewWidth, viewHeight, considerClipPath, considerAncestors) {
            var m = this.transform;
            if (this.ignore || this.invisible || this.style.opacity === 0 || this.culling && $fbb57da3b649c75e$var$isDisplayableCulled(this, viewWidth, viewHeight) || m && !m[0] && !m[3]) return false;
            if (considerClipPath && this.__clipPaths) for(var i = 0; i < this.__clipPaths.length; ++i){
                if (this.__clipPaths[i].isZeroArea()) return false;
            }
            if (considerAncestors && this.parent) {
                var parent_1 = this.parent;
                while(parent_1){
                    if (parent_1.ignore) return false;
                    parent_1 = parent_1.parent;
                }
            }
            return true;
        };
        Displayable.prototype.contain = function(x, y) {
            return this.rectContain(x, y);
        };
        Displayable.prototype.traverse = function(cb, context) {
            cb.call(context, this);
        };
        Displayable.prototype.rectContain = function(x, y) {
            var coord = this.transformCoordToLocal(x, y);
            var rect = this.getBoundingRect();
            return rect.contain(coord[0], coord[1]);
        };
        Displayable.prototype.getPaintRect = function() {
            var rect = this._paintRect;
            if (!this._paintRect || this.__dirty) {
                var transform = this.transform;
                var elRect = this.getBoundingRect();
                var style = this.style;
                var shadowSize = style.shadowBlur || 0;
                var shadowOffsetX = style.shadowOffsetX || 0;
                var shadowOffsetY = style.shadowOffsetY || 0;
                rect = this._paintRect || (this._paintRect = new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0));
                if (transform) (0, (0, parcelRequire("1E3E8")).default).applyTransform(rect, elRect, transform);
                else rect.copy(elRect);
                if (shadowSize || shadowOffsetX || shadowOffsetY) {
                    rect.width += shadowSize * 2 + Math.abs(shadowOffsetX);
                    rect.height += shadowSize * 2 + Math.abs(shadowOffsetY);
                    rect.x = Math.min(rect.x, rect.x + shadowOffsetX - shadowSize);
                    rect.y = Math.min(rect.y, rect.y + shadowOffsetY - shadowSize);
                }
                var tolerance = this.dirtyRectTolerance;
                if (!rect.isZero()) {
                    rect.x = Math.floor(rect.x - tolerance);
                    rect.y = Math.floor(rect.y - tolerance);
                    rect.width = Math.ceil(rect.width + 1 + tolerance * 2);
                    rect.height = Math.ceil(rect.height + 1 + tolerance * 2);
                }
            }
            return rect;
        };
        Displayable.prototype.setPrevPaintRect = function(paintRect) {
            if (paintRect) {
                this._prevPaintRect = this._prevPaintRect || new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0);
                this._prevPaintRect.copy(paintRect);
            } else this._prevPaintRect = null;
        };
        Displayable.prototype.getPrevPaintRect = function() {
            return this._prevPaintRect;
        };
        Displayable.prototype.animateStyle = function(loop) {
            return this.animate('style', loop);
        };
        Displayable.prototype.updateDuringAnimation = function(targetKey) {
            if (targetKey === 'style') this.dirtyStyle();
            else this.markRedraw();
        };
        Displayable.prototype.attrKV = function(key, value) {
            if (key !== 'style') _super.prototype.attrKV.call(this, key, value);
            else if (!this.style) this.useStyle(value);
            else this.setStyle(value);
        };
        Displayable.prototype.setStyle = function(keyOrObj, value) {
            if (typeof keyOrObj === 'string') this.style[keyOrObj] = value;
            else (0, (0, parcelRequire("bahqM")).extend)(this.style, keyOrObj);
            this.dirtyStyle();
            return this;
        };
        Displayable.prototype.dirtyStyle = function(notRedraw) {
            if (!notRedraw) this.markRedraw();
            this.__dirty |= (0, (0, parcelRequire("aVawM")).STYLE_CHANGED_BIT);
            if (this._rect) this._rect = null;
        };
        Displayable.prototype.dirty = function() {
            this.dirtyStyle();
        };
        Displayable.prototype.styleChanged = function() {
            return !!(this.__dirty & (0, (0, parcelRequire("aVawM")).STYLE_CHANGED_BIT));
        };
        Displayable.prototype.styleUpdated = function() {
            this.__dirty &= ~(0, (0, parcelRequire("aVawM")).STYLE_CHANGED_BIT);
        };
        Displayable.prototype.createStyle = function(obj) {
            return (0, (0, parcelRequire("bahqM")).createObject)($fbb57da3b649c75e$export$737672163db00fe3, obj);
        };
        Displayable.prototype.useStyle = function(obj) {
            if (!obj[$fbb57da3b649c75e$var$STYLE_MAGIC_KEY]) obj = this.createStyle(obj);
            if (this.__inHover) this.__hoverStyle = obj;
            else this.style = obj;
            this.dirtyStyle();
        };
        Displayable.prototype.isStyleObject = function(obj) {
            return obj[$fbb57da3b649c75e$var$STYLE_MAGIC_KEY];
        };
        Displayable.prototype._innerSaveToNormal = function(toState) {
            _super.prototype._innerSaveToNormal.call(this, toState);
            var normalState = this._normalState;
            if (toState.style && !normalState.style) normalState.style = this._mergeStyle(this.createStyle(), this.style);
            this._savePrimaryToNormal(toState, normalState, $fbb57da3b649c75e$var$PRIMARY_STATES_KEYS);
        };
        Displayable.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
            _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
            var needsRestoreToNormal = !(state && keepCurrentStates);
            var targetStyle;
            if (state && state.style) {
                if (transition) {
                    if (keepCurrentStates) targetStyle = state.style;
                    else {
                        targetStyle = this._mergeStyle(this.createStyle(), normalState.style);
                        this._mergeStyle(targetStyle, state.style);
                    }
                } else {
                    targetStyle = this._mergeStyle(this.createStyle(), keepCurrentStates ? this.style : normalState.style);
                    this._mergeStyle(targetStyle, state.style);
                }
            } else if (needsRestoreToNormal) targetStyle = normalState.style;
            if (targetStyle) {
                if (transition) {
                    var sourceStyle = this.style;
                    this.style = this.createStyle(needsRestoreToNormal ? {} : sourceStyle);
                    if (needsRestoreToNormal) {
                        var changedKeys = (0, (0, parcelRequire("bahqM")).keys)(sourceStyle);
                        for(var i = 0; i < changedKeys.length; i++){
                            var key = changedKeys[i];
                            if (key in targetStyle) {
                                targetStyle[key] = targetStyle[key];
                                this.style[key] = sourceStyle[key];
                            }
                        }
                    }
                    var targetKeys = (0, (0, parcelRequire("bahqM")).keys)(targetStyle);
                    for(var i = 0; i < targetKeys.length; i++){
                        var key = targetKeys[i];
                        this.style[key] = this.style[key];
                    }
                    this._transitionState(stateName, {
                        style: targetStyle
                    }, animationCfg, this.getAnimationStyleProps());
                } else this.useStyle(targetStyle);
            }
            var statesKeys = this.__inHover ? $fbb57da3b649c75e$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER : $fbb57da3b649c75e$var$PRIMARY_STATES_KEYS;
            for(var i = 0; i < statesKeys.length; i++){
                var key = statesKeys[i];
                if (state && state[key] != null) this[key] = state[key];
                else if (needsRestoreToNormal) {
                    if (normalState[key] != null) this[key] = normalState[key];
                }
            }
        };
        Displayable.prototype._mergeStates = function(states) {
            var mergedState = _super.prototype._mergeStates.call(this, states);
            var mergedStyle;
            for(var i = 0; i < states.length; i++){
                var state = states[i];
                if (state.style) {
                    mergedStyle = mergedStyle || {};
                    this._mergeStyle(mergedStyle, state.style);
                }
            }
            if (mergedStyle) mergedState.style = mergedStyle;
            return mergedState;
        };
        Displayable.prototype._mergeStyle = function(targetStyle, sourceStyle) {
            (0, (0, parcelRequire("bahqM")).extend)(targetStyle, sourceStyle);
            return targetStyle;
        };
        Displayable.prototype.getAnimationStyleProps = function() {
            return $fbb57da3b649c75e$export$9908943fb57fbe51;
        };
        Displayable.initDefaultProps = function() {
            var dispProto = Displayable.prototype;
            dispProto.type = 'displayable';
            dispProto.invisible = false;
            dispProto.z = 0;
            dispProto.z2 = 0;
            dispProto.zlevel = 0;
            dispProto.culling = false;
            dispProto.cursor = 'pointer';
            dispProto.rectHover = false;
            dispProto.incremental = false;
            dispProto._rect = null;
            dispProto.dirtyRectTolerance = 0;
            dispProto.__dirty = (0, (0, parcelRequire("aVawM")).REDRAW_BIT) | (0, (0, parcelRequire("aVawM")).STYLE_CHANGED_BIT);
        }();
        return Displayable;
    }((0, (0, parcelRequire("7KVc5")).default));
    var $fbb57da3b649c75e$var$tmpRect = new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0);
    var $fbb57da3b649c75e$var$viewRect = new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0);
    function $fbb57da3b649c75e$var$isDisplayableCulled(el, width, height) {
        $fbb57da3b649c75e$var$tmpRect.copy(el.getBoundingRect());
        if (el.transform) $fbb57da3b649c75e$var$tmpRect.applyTransform(el.transform);
        $fbb57da3b649c75e$var$viewRect.width = width;
        $fbb57da3b649c75e$var$viewRect.height = height;
        return !$fbb57da3b649c75e$var$tmpRect.intersect($fbb57da3b649c75e$var$viewRect);
    }
    var $fbb57da3b649c75e$export$2e2bcd8739ae039 = $fbb57da3b649c75e$var$Displayable;
});
parcelRegister("7KVc5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5a5931cff6ff005a$export$2e2bcd8739ae039);
    var $e6gef;
    var $hb2y5;
    var $1E3E8;
    var $bRKv5;
    var $b7ZX8;
    var $bahqM;
    var $7y1my;
    var $d6udH;
    var $hZfwb;
    var $aVawM;
    var $5a5931cff6ff005a$export$97b5e845c7286801 = '__zr_normal__';
    var $5a5931cff6ff005a$var$PRIMARY_STATES_KEYS = [
        'x',
        'y',
        'scaleX',
        'scaleY',
        'originX',
        'originY',
        'rotation',
        'ignore'
    ];
    var $5a5931cff6ff005a$var$DEFAULT_ANIMATABLE_MAP = {
        x: true,
        y: true,
        scaleX: true,
        scaleY: true,
        originX: true,
        originY: true,
        rotation: true,
        ignore: false
    };
    var $5a5931cff6ff005a$var$tmpTextPosCalcRes = {};
    var $5a5931cff6ff005a$var$tmpBoundingRect = new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0);
    var $5a5931cff6ff005a$var$Element = function() {
        function Element(props) {
            this.id = (0, (0, parcelRequire("bahqM")).guid)();
            this.animators = [];
            this.currentStates = [];
            this.states = {};
            this._init(props);
        }
        Element.prototype._init = function(props) {
            this.attr(props);
        };
        Element.prototype.drift = function(dx, dy, e) {
            switch(this.draggable){
                case 'horizontal':
                    dy = 0;
                    break;
                case 'vertical':
                    dx = 0;
                    break;
            }
            var m = this.transform;
            if (!m) m = this.transform = [
                1,
                0,
                0,
                1,
                0,
                0
            ];
            m[4] += dx;
            m[5] += dy;
            this.decomposeTransform();
            this.markRedraw();
        };
        Element.prototype.beforeUpdate = function() {};
        Element.prototype.afterUpdate = function() {};
        Element.prototype.update = function() {
            this.updateTransform();
            if (this.__dirty) this.updateInnerText();
        };
        Element.prototype.updateInnerText = function(forceUpdate) {
            var textEl = this._textContent;
            if (textEl && (!textEl.ignore || forceUpdate)) {
                if (!this.textConfig) this.textConfig = {};
                var textConfig = this.textConfig;
                var isLocal = textConfig.local;
                var innerTransformable = textEl.innerTransformable;
                var textAlign = void 0;
                var textVerticalAlign = void 0;
                var textStyleChanged = false;
                innerTransformable.parent = isLocal ? this : null;
                var innerOrigin = false;
                innerTransformable.copyTransform(textEl);
                if (textConfig.position != null) {
                    var layoutRect = $5a5931cff6ff005a$var$tmpBoundingRect;
                    if (textConfig.layoutRect) layoutRect.copy(textConfig.layoutRect);
                    else layoutRect.copy(this.getBoundingRect());
                    if (!isLocal) layoutRect.applyTransform(this.transform);
                    if (this.calculateTextPosition) this.calculateTextPosition($5a5931cff6ff005a$var$tmpTextPosCalcRes, textConfig, layoutRect);
                    else (0, (0, parcelRequire("b7ZX8")).calculateTextPosition)($5a5931cff6ff005a$var$tmpTextPosCalcRes, textConfig, layoutRect);
                    innerTransformable.x = $5a5931cff6ff005a$var$tmpTextPosCalcRes.x;
                    innerTransformable.y = $5a5931cff6ff005a$var$tmpTextPosCalcRes.y;
                    textAlign = $5a5931cff6ff005a$var$tmpTextPosCalcRes.align;
                    textVerticalAlign = $5a5931cff6ff005a$var$tmpTextPosCalcRes.verticalAlign;
                    var textOrigin = textConfig.origin;
                    if (textOrigin && textConfig.rotation != null) {
                        var relOriginX = void 0;
                        var relOriginY = void 0;
                        if (textOrigin === 'center') {
                            relOriginX = layoutRect.width * 0.5;
                            relOriginY = layoutRect.height * 0.5;
                        } else {
                            relOriginX = (0, (0, parcelRequire("b7ZX8")).parsePercent)(textOrigin[0], layoutRect.width);
                            relOriginY = (0, (0, parcelRequire("b7ZX8")).parsePercent)(textOrigin[1], layoutRect.height);
                        }
                        innerOrigin = true;
                        innerTransformable.originX = -innerTransformable.x + relOriginX + (isLocal ? 0 : layoutRect.x);
                        innerTransformable.originY = -innerTransformable.y + relOriginY + (isLocal ? 0 : layoutRect.y);
                    }
                }
                if (textConfig.rotation != null) innerTransformable.rotation = textConfig.rotation;
                var textOffset = textConfig.offset;
                if (textOffset) {
                    innerTransformable.x += textOffset[0];
                    innerTransformable.y += textOffset[1];
                    if (!innerOrigin) {
                        innerTransformable.originX = -textOffset[0];
                        innerTransformable.originY = -textOffset[1];
                    }
                }
                var isInside = textConfig.inside == null ? typeof textConfig.position === 'string' && textConfig.position.indexOf('inside') >= 0 : textConfig.inside;
                var innerTextDefaultStyle = this._innerTextDefaultStyle || (this._innerTextDefaultStyle = {});
                var textFill = void 0;
                var textStroke = void 0;
                var autoStroke = void 0;
                if (isInside && this.canBeInsideText()) {
                    textFill = textConfig.insideFill;
                    textStroke = textConfig.insideStroke;
                    if (textFill == null || textFill === 'auto') textFill = this.getInsideTextFill();
                    if (textStroke == null || textStroke === 'auto') {
                        textStroke = this.getInsideTextStroke(textFill);
                        autoStroke = true;
                    }
                } else {
                    textFill = textConfig.outsideFill;
                    textStroke = textConfig.outsideStroke;
                    if (textFill == null || textFill === 'auto') textFill = this.getOutsideFill();
                    if (textStroke == null || textStroke === 'auto') {
                        textStroke = this.getOutsideStroke(textFill);
                        autoStroke = true;
                    }
                }
                textFill = textFill || '#000';
                if (textFill !== innerTextDefaultStyle.fill || textStroke !== innerTextDefaultStyle.stroke || autoStroke !== innerTextDefaultStyle.autoStroke || textAlign !== innerTextDefaultStyle.align || textVerticalAlign !== innerTextDefaultStyle.verticalAlign) {
                    textStyleChanged = true;
                    innerTextDefaultStyle.fill = textFill;
                    innerTextDefaultStyle.stroke = textStroke;
                    innerTextDefaultStyle.autoStroke = autoStroke;
                    innerTextDefaultStyle.align = textAlign;
                    innerTextDefaultStyle.verticalAlign = textVerticalAlign;
                    textEl.setDefaultTextStyle(innerTextDefaultStyle);
                }
                textEl.__dirty |= (0, (0, parcelRequire("aVawM")).REDRAW_BIT);
                if (textStyleChanged) textEl.dirtyStyle(true);
            }
        };
        Element.prototype.canBeInsideText = function() {
            return true;
        };
        Element.prototype.getInsideTextFill = function() {
            return '#fff';
        };
        Element.prototype.getInsideTextStroke = function(textFill) {
            return '#000';
        };
        Element.prototype.getOutsideFill = function() {
            return this.__zr && this.__zr.isDarkMode() ? (0, (0, parcelRequire("7y1my")).LIGHT_LABEL_COLOR) : (0, (0, parcelRequire("7y1my")).DARK_LABEL_COLOR);
        };
        Element.prototype.getOutsideStroke = function(textFill) {
            var backgroundColor = this.__zr && this.__zr.getBackgroundColor();
            var colorArr = typeof backgroundColor === 'string' && (0, (0, parcelRequire("d6udH")).parse)(backgroundColor);
            if (!colorArr) colorArr = [
                255,
                255,
                255,
                1
            ];
            var alpha = colorArr[3];
            var isDark = this.__zr.isDarkMode();
            for(var i = 0; i < 3; i++)colorArr[i] = colorArr[i] * alpha + (isDark ? 0 : 255) * (1 - alpha);
            colorArr[3] = 1;
            return (0, (0, parcelRequire("d6udH")).stringify)(colorArr, 'rgba');
        };
        Element.prototype.traverse = function(cb, context) {};
        Element.prototype.attrKV = function(key, value) {
            if (key === 'textConfig') this.setTextConfig(value);
            else if (key === 'textContent') this.setTextContent(value);
            else if (key === 'clipPath') this.setClipPath(value);
            else if (key === 'extra') {
                this.extra = this.extra || {};
                (0, (0, parcelRequire("bahqM")).extend)(this.extra, value);
            } else this[key] = value;
        };
        Element.prototype.hide = function() {
            this.ignore = true;
            this.markRedraw();
        };
        Element.prototype.show = function() {
            this.ignore = false;
            this.markRedraw();
        };
        Element.prototype.attr = function(keyOrObj, value) {
            if (typeof keyOrObj === 'string') this.attrKV(keyOrObj, value);
            else if ((0, (0, parcelRequire("bahqM")).isObject)(keyOrObj)) {
                var obj = keyOrObj;
                var keysArr = (0, (0, parcelRequire("bahqM")).keys)(obj);
                for(var i = 0; i < keysArr.length; i++){
                    var key = keysArr[i];
                    this.attrKV(key, keyOrObj[key]);
                }
            }
            this.markRedraw();
            return this;
        };
        Element.prototype.saveCurrentToNormalState = function(toState) {
            this._innerSaveToNormal(toState);
            var normalState = this._normalState;
            for(var i = 0; i < this.animators.length; i++){
                var animator = this.animators[i];
                var fromStateTransition = animator.__fromStateTransition;
                if (fromStateTransition && fromStateTransition !== $5a5931cff6ff005a$export$97b5e845c7286801) continue;
                var targetName = animator.targetName;
                var target = targetName ? normalState[targetName] : normalState;
                animator.saveFinalToTarget(target);
            }
        };
        Element.prototype._innerSaveToNormal = function(toState) {
            var normalState = this._normalState;
            if (!normalState) normalState = this._normalState = {};
            if (toState.textConfig && !normalState.textConfig) normalState.textConfig = this.textConfig;
            this._savePrimaryToNormal(toState, normalState, $5a5931cff6ff005a$var$PRIMARY_STATES_KEYS);
        };
        Element.prototype._savePrimaryToNormal = function(toState, normalState, primaryKeys) {
            for(var i = 0; i < primaryKeys.length; i++){
                var key = primaryKeys[i];
                if (toState[key] != null && !(key in normalState)) normalState[key] = this[key];
            }
        };
        Element.prototype.hasState = function() {
            return this.currentStates.length > 0;
        };
        Element.prototype.getState = function(name) {
            return this.states[name];
        };
        Element.prototype.ensureState = function(name) {
            var states = this.states;
            if (!states[name]) states[name] = {};
            return states[name];
        };
        Element.prototype.clearStates = function(noAnimation) {
            this.useState($5a5931cff6ff005a$export$97b5e845c7286801, false, noAnimation);
        };
        Element.prototype.useState = function(stateName, keepCurrentStates, noAnimation, forceUseHoverLayer) {
            var toNormalState = stateName === $5a5931cff6ff005a$export$97b5e845c7286801;
            var hasStates = this.hasState();
            if (!hasStates && toNormalState) return;
            var currentStates = this.currentStates;
            var animationCfg = this.stateTransition;
            if ((0, (0, parcelRequire("bahqM")).indexOf)(currentStates, stateName) >= 0 && (keepCurrentStates || currentStates.length === 1)) return;
            var state;
            if (this.stateProxy && !toNormalState) state = this.stateProxy(stateName);
            if (!state) state = this.states && this.states[stateName];
            if (!state && !toNormalState) {
                (0, (0, parcelRequire("bahqM")).logError)("State " + stateName + " not exists.");
                return;
            }
            if (!toNormalState) this.saveCurrentToNormalState(state);
            var useHoverLayer = !!(state && state.hoverLayer || forceUseHoverLayer);
            if (useHoverLayer) this._toggleHoverLayerFlag(true);
            this._applyStateObj(stateName, state, this._normalState, keepCurrentStates, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
            var textContent = this._textContent;
            var textGuide = this._textGuide;
            if (textContent) textContent.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
            if (textGuide) textGuide.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
            if (toNormalState) {
                this.currentStates = [];
                this._normalState = {};
            } else if (!keepCurrentStates) this.currentStates = [
                stateName
            ];
            else this.currentStates.push(stateName);
            this._updateAnimationTargets();
            this.markRedraw();
            if (!useHoverLayer && this.__inHover) {
                this._toggleHoverLayerFlag(false);
                this.__dirty &= ~(0, (0, parcelRequire("aVawM")).REDRAW_BIT);
            }
            return state;
        };
        Element.prototype.useStates = function(states, noAnimation, forceUseHoverLayer) {
            if (!states.length) this.clearStates();
            else {
                var stateObjects = [];
                var currentStates = this.currentStates;
                var len = states.length;
                var notChange = len === currentStates.length;
                if (notChange) {
                    for(var i = 0; i < len; i++)if (states[i] !== currentStates[i]) {
                        notChange = false;
                        break;
                    }
                }
                if (notChange) return;
                for(var i = 0; i < len; i++){
                    var stateName = states[i];
                    var stateObj = void 0;
                    if (this.stateProxy) stateObj = this.stateProxy(stateName, states);
                    if (!stateObj) stateObj = this.states[stateName];
                    if (stateObj) stateObjects.push(stateObj);
                }
                var lastStateObj = stateObjects[len - 1];
                var useHoverLayer = !!(lastStateObj && lastStateObj.hoverLayer || forceUseHoverLayer);
                if (useHoverLayer) this._toggleHoverLayerFlag(true);
                var mergedState = this._mergeStates(stateObjects);
                var animationCfg = this.stateTransition;
                this.saveCurrentToNormalState(mergedState);
                this._applyStateObj(states.join(','), mergedState, this._normalState, false, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
                var textContent = this._textContent;
                var textGuide = this._textGuide;
                if (textContent) textContent.useStates(states, noAnimation, useHoverLayer);
                if (textGuide) textGuide.useStates(states, noAnimation, useHoverLayer);
                this._updateAnimationTargets();
                this.currentStates = states.slice();
                this.markRedraw();
                if (!useHoverLayer && this.__inHover) {
                    this._toggleHoverLayerFlag(false);
                    this.__dirty &= ~(0, (0, parcelRequire("aVawM")).REDRAW_BIT);
                }
            }
        };
        Element.prototype._updateAnimationTargets = function() {
            for(var i = 0; i < this.animators.length; i++){
                var animator = this.animators[i];
                if (animator.targetName) animator.changeTarget(this[animator.targetName]);
            }
        };
        Element.prototype.removeState = function(state) {
            var idx = (0, (0, parcelRequire("bahqM")).indexOf)(this.currentStates, state);
            if (idx >= 0) {
                var currentStates = this.currentStates.slice();
                currentStates.splice(idx, 1);
                this.useStates(currentStates);
            }
        };
        Element.prototype.replaceState = function(oldState, newState, forceAdd) {
            var currentStates = this.currentStates.slice();
            var idx = (0, (0, parcelRequire("bahqM")).indexOf)(currentStates, oldState);
            var newStateExists = (0, (0, parcelRequire("bahqM")).indexOf)(currentStates, newState) >= 0;
            if (idx >= 0) {
                if (!newStateExists) currentStates[idx] = newState;
                else currentStates.splice(idx, 1);
            } else if (forceAdd && !newStateExists) currentStates.push(newState);
            this.useStates(currentStates);
        };
        Element.prototype.toggleState = function(state, enable) {
            if (enable) this.useState(state, true);
            else this.removeState(state);
        };
        Element.prototype._mergeStates = function(states) {
            var mergedState = {};
            var mergedTextConfig;
            for(var i = 0; i < states.length; i++){
                var state = states[i];
                (0, (0, parcelRequire("bahqM")).extend)(mergedState, state);
                if (state.textConfig) {
                    mergedTextConfig = mergedTextConfig || {};
                    (0, (0, parcelRequire("bahqM")).extend)(mergedTextConfig, state.textConfig);
                }
            }
            if (mergedTextConfig) mergedState.textConfig = mergedTextConfig;
            return mergedState;
        };
        Element.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
            var needsRestoreToNormal = !(state && keepCurrentStates);
            if (state && state.textConfig) {
                this.textConfig = (0, (0, parcelRequire("bahqM")).extend)({}, keepCurrentStates ? this.textConfig : normalState.textConfig);
                (0, (0, parcelRequire("bahqM")).extend)(this.textConfig, state.textConfig);
            } else if (needsRestoreToNormal) {
                if (normalState.textConfig) this.textConfig = normalState.textConfig;
            }
            var transitionTarget = {};
            var hasTransition = false;
            for(var i = 0; i < $5a5931cff6ff005a$var$PRIMARY_STATES_KEYS.length; i++){
                var key = $5a5931cff6ff005a$var$PRIMARY_STATES_KEYS[i];
                var propNeedsTransition = transition && $5a5931cff6ff005a$var$DEFAULT_ANIMATABLE_MAP[key];
                if (state && state[key] != null) {
                    if (propNeedsTransition) {
                        hasTransition = true;
                        transitionTarget[key] = state[key];
                    } else this[key] = state[key];
                } else if (needsRestoreToNormal) {
                    if (normalState[key] != null) {
                        if (propNeedsTransition) {
                            hasTransition = true;
                            transitionTarget[key] = normalState[key];
                        } else this[key] = normalState[key];
                    }
                }
            }
            if (!transition) for(var i = 0; i < this.animators.length; i++){
                var animator = this.animators[i];
                var targetName = animator.targetName;
                animator.__changeFinalValue(targetName ? (state || normalState)[targetName] : state || normalState);
            }
            if (hasTransition) this._transitionState(stateName, transitionTarget, animationCfg);
        };
        Element.prototype._attachComponent = function(componentEl) {
            if (componentEl.__zr && !componentEl.__hostTarget) throw new Error('Text element has been added to zrender.');
            if (componentEl === this) throw new Error('Recursive component attachment.');
            var zr = this.__zr;
            if (zr) componentEl.addSelfToZr(zr);
            componentEl.__zr = zr;
            componentEl.__hostTarget = this;
        };
        Element.prototype._detachComponent = function(componentEl) {
            if (componentEl.__zr) componentEl.removeSelfFromZr(componentEl.__zr);
            componentEl.__zr = null;
            componentEl.__hostTarget = null;
        };
        Element.prototype.getClipPath = function() {
            return this._clipPath;
        };
        Element.prototype.setClipPath = function(clipPath) {
            if (this._clipPath && this._clipPath !== clipPath) this.removeClipPath();
            this._attachComponent(clipPath);
            this._clipPath = clipPath;
            this.markRedraw();
        };
        Element.prototype.removeClipPath = function() {
            var clipPath = this._clipPath;
            if (clipPath) {
                this._detachComponent(clipPath);
                this._clipPath = null;
                this.markRedraw();
            }
        };
        Element.prototype.getTextContent = function() {
            return this._textContent;
        };
        Element.prototype.setTextContent = function(textEl) {
            var previousTextContent = this._textContent;
            if (previousTextContent === textEl) return;
            if (previousTextContent && previousTextContent !== textEl) this.removeTextContent();
            if (textEl.__zr && !textEl.__hostTarget) throw new Error('Text element has been added to zrender.');
            textEl.innerTransformable = new (0, (0, parcelRequire("e6gef")).default)();
            this._attachComponent(textEl);
            this._textContent = textEl;
            this.markRedraw();
        };
        Element.prototype.setTextConfig = function(cfg) {
            if (!this.textConfig) this.textConfig = {};
            (0, (0, parcelRequire("bahqM")).extend)(this.textConfig, cfg);
            this.markRedraw();
        };
        Element.prototype.removeTextConfig = function() {
            this.textConfig = null;
            this.markRedraw();
        };
        Element.prototype.removeTextContent = function() {
            var textEl = this._textContent;
            if (textEl) {
                textEl.innerTransformable = null;
                this._detachComponent(textEl);
                this._textContent = null;
                this._innerTextDefaultStyle = null;
                this.markRedraw();
            }
        };
        Element.prototype.getTextGuideLine = function() {
            return this._textGuide;
        };
        Element.prototype.setTextGuideLine = function(guideLine) {
            if (this._textGuide && this._textGuide !== guideLine) this.removeTextGuideLine();
            this._attachComponent(guideLine);
            this._textGuide = guideLine;
            this.markRedraw();
        };
        Element.prototype.removeTextGuideLine = function() {
            var textGuide = this._textGuide;
            if (textGuide) {
                this._detachComponent(textGuide);
                this._textGuide = null;
                this.markRedraw();
            }
        };
        Element.prototype.markRedraw = function() {
            this.__dirty |= (0, (0, parcelRequire("aVawM")).REDRAW_BIT);
            var zr = this.__zr;
            if (zr) {
                if (this.__inHover) zr.refreshHover();
                else zr.refresh();
            }
            if (this.__hostTarget) this.__hostTarget.markRedraw();
        };
        Element.prototype.dirty = function() {
            this.markRedraw();
        };
        Element.prototype._toggleHoverLayerFlag = function(inHover) {
            this.__inHover = inHover;
            var textContent = this._textContent;
            var textGuide = this._textGuide;
            if (textContent) textContent.__inHover = inHover;
            if (textGuide) textGuide.__inHover = inHover;
        };
        Element.prototype.addSelfToZr = function(zr) {
            if (this.__zr === zr) return;
            this.__zr = zr;
            var animators = this.animators;
            if (animators) for(var i = 0; i < animators.length; i++)zr.animation.addAnimator(animators[i]);
            if (this._clipPath) this._clipPath.addSelfToZr(zr);
            if (this._textContent) this._textContent.addSelfToZr(zr);
            if (this._textGuide) this._textGuide.addSelfToZr(zr);
        };
        Element.prototype.removeSelfFromZr = function(zr) {
            if (!this.__zr) return;
            this.__zr = null;
            var animators = this.animators;
            if (animators) for(var i = 0; i < animators.length; i++)zr.animation.removeAnimator(animators[i]);
            if (this._clipPath) this._clipPath.removeSelfFromZr(zr);
            if (this._textContent) this._textContent.removeSelfFromZr(zr);
            if (this._textGuide) this._textGuide.removeSelfFromZr(zr);
        };
        Element.prototype.animate = function(key, loop) {
            var target = key ? this[key] : this;
            if (!target) {
                (0, (0, parcelRequire("bahqM")).logError)('Property "' + key + '" is not existed in element ' + this.id);
                return;
            }
            var animator = new (0, (0, parcelRequire("hb2y5")).default)(target, loop);
            this.addAnimator(animator, key);
            return animator;
        };
        Element.prototype.addAnimator = function(animator, key) {
            var zr = this.__zr;
            var el = this;
            animator.during(function() {
                el.updateDuringAnimation(key);
            }).done(function() {
                var animators = el.animators;
                var idx = (0, (0, parcelRequire("bahqM")).indexOf)(animators, animator);
                if (idx >= 0) animators.splice(idx, 1);
            });
            this.animators.push(animator);
            if (zr) zr.animation.addAnimator(animator);
            zr && zr.wakeUp();
        };
        Element.prototype.updateDuringAnimation = function(key) {
            this.markRedraw();
        };
        Element.prototype.stopAnimation = function(scope, forwardToLast) {
            var animators = this.animators;
            var len = animators.length;
            var leftAnimators = [];
            for(var i = 0; i < len; i++){
                var animator = animators[i];
                if (!scope || scope === animator.scope) animator.stop(forwardToLast);
                else leftAnimators.push(animator);
            }
            this.animators = leftAnimators;
            return this;
        };
        Element.prototype.animateTo = function(target, cfg, animationProps) {
            $5a5931cff6ff005a$var$animateTo(this, target, cfg, animationProps);
        };
        Element.prototype.animateFrom = function(target, cfg, animationProps) {
            $5a5931cff6ff005a$var$animateTo(this, target, cfg, animationProps, true);
        };
        Element.prototype._transitionState = function(stateName, target, cfg, animationProps) {
            var animators = $5a5931cff6ff005a$var$animateTo(this, target, cfg, animationProps);
            for(var i = 0; i < animators.length; i++)animators[i].__fromStateTransition = stateName;
        };
        Element.prototype.getBoundingRect = function() {
            return null;
        };
        Element.prototype.getPaintRect = function() {
            return null;
        };
        Element.initDefaultProps = function() {
            var elProto = Element.prototype;
            elProto.type = 'element';
            elProto.name = '';
            elProto.ignore = false;
            elProto.silent = false;
            elProto.isGroup = false;
            elProto.draggable = false;
            elProto.dragging = false;
            elProto.ignoreClip = false;
            elProto.__inHover = false;
            elProto.__dirty = (0, (0, parcelRequire("aVawM")).REDRAW_BIT);
            var logs = {};
            function logDeprecatedError(key, xKey, yKey) {
                if (!logs[key + xKey + yKey]) {
                    console.warn("DEPRECATED: '" + key + "' has been deprecated. use '" + xKey + "', '" + yKey + "' instead");
                    logs[key + xKey + yKey] = true;
                }
            }
            function createLegacyProperty(key, privateKey, xKey, yKey) {
                Object.defineProperty(elProto, key, {
                    get: function() {
                        logDeprecatedError(key, xKey, yKey);
                        if (!this[privateKey]) {
                            var pos = this[privateKey] = [];
                            enhanceArray(this, pos);
                        }
                        return this[privateKey];
                    },
                    set: function(pos) {
                        logDeprecatedError(key, xKey, yKey);
                        this[xKey] = pos[0];
                        this[yKey] = pos[1];
                        this[privateKey] = pos;
                        enhanceArray(this, pos);
                    }
                });
                function enhanceArray(self, pos) {
                    Object.defineProperty(pos, 0, {
                        get: function() {
                            return self[xKey];
                        },
                        set: function(val) {
                            self[xKey] = val;
                        }
                    });
                    Object.defineProperty(pos, 1, {
                        get: function() {
                            return self[yKey];
                        },
                        set: function(val) {
                            self[yKey] = val;
                        }
                    });
                }
            }
            if (Object.defineProperty && (!(0, (0, parcelRequire("hZfwb")).default).browser.ie || (0, (0, parcelRequire("hZfwb")).default).browser.version > 8)) {
                createLegacyProperty('position', '_legacyPos', 'x', 'y');
                createLegacyProperty('scale', '_legacyScale', 'scaleX', 'scaleY');
                createLegacyProperty('origin', '_legacyOrigin', 'originX', 'originY');
            }
        }();
        return Element;
    }();
    (0, (0, parcelRequire("bahqM")).mixin)($5a5931cff6ff005a$var$Element, (0, (0, parcelRequire("bRKv5")).default));
    (0, (0, parcelRequire("bahqM")).mixin)($5a5931cff6ff005a$var$Element, (0, (0, parcelRequire("e6gef")).default));
    function $5a5931cff6ff005a$var$animateTo(animatable, target, cfg, animationProps, reverse) {
        cfg = cfg || {};
        var animators = [];
        $5a5931cff6ff005a$var$animateToShallow(animatable, '', animatable, target, cfg, animationProps, animators, reverse);
        var finishCount = animators.length;
        var doneHappened = false;
        var cfgDone = cfg.done;
        var cfgAborted = cfg.aborted;
        var doneCb = function() {
            doneHappened = true;
            finishCount--;
            if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
        };
        var abortedCb = function() {
            finishCount--;
            if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
        };
        if (!finishCount) cfgDone && cfgDone();
        if (animators.length > 0 && cfg.during) animators[0].during(function(target, percent) {
            cfg.during(percent);
        });
        for(var i = 0; i < animators.length; i++){
            var animator = animators[i];
            if (doneCb) animator.done(doneCb);
            if (abortedCb) animator.aborted(abortedCb);
            animator.start(cfg.easing, cfg.force);
        }
        return animators;
    }
    function $5a5931cff6ff005a$var$copyArrShallow(source, target, len) {
        for(var i = 0; i < len; i++)source[i] = target[i];
    }
    function $5a5931cff6ff005a$var$is2DArray(value) {
        return (0, (0, parcelRequire("bahqM")).isArrayLike)(value[0]);
    }
    function $5a5931cff6ff005a$var$copyValue(target, source, key) {
        if ((0, (0, parcelRequire("bahqM")).isArrayLike)(source[key])) {
            if (!(0, (0, parcelRequire("bahqM")).isArrayLike)(target[key])) target[key] = [];
            if ((0, (0, parcelRequire("bahqM")).isTypedArray)(source[key])) {
                var len = source[key].length;
                if (target[key].length !== len) {
                    target[key] = new source[key].constructor(len);
                    $5a5931cff6ff005a$var$copyArrShallow(target[key], source[key], len);
                }
            } else {
                var sourceArr = source[key];
                var targetArr = target[key];
                var len0 = sourceArr.length;
                if ($5a5931cff6ff005a$var$is2DArray(sourceArr)) {
                    var len1 = sourceArr[0].length;
                    for(var i = 0; i < len0; i++)if (!targetArr[i]) targetArr[i] = Array.prototype.slice.call(sourceArr[i]);
                    else $5a5931cff6ff005a$var$copyArrShallow(targetArr[i], sourceArr[i], len1);
                } else $5a5931cff6ff005a$var$copyArrShallow(targetArr, sourceArr, len0);
                targetArr.length = sourceArr.length;
            }
        } else target[key] = source[key];
    }
    function $5a5931cff6ff005a$var$animateToShallow(animatable, topKey, source, target, cfg, animationProps, animators, reverse) {
        var animatableKeys = [];
        var changedKeys = [];
        var targetKeys = (0, (0, parcelRequire("bahqM")).keys)(target);
        var duration = cfg.duration;
        var delay = cfg.delay;
        var additive = cfg.additive;
        var setToFinal = cfg.setToFinal;
        var animateAll = !(0, (0, parcelRequire("bahqM")).isObject)(animationProps);
        for(var k = 0; k < targetKeys.length; k++){
            var innerKey = targetKeys[k];
            if (source[innerKey] != null && target[innerKey] != null && (animateAll || animationProps[innerKey])) {
                if ((0, (0, parcelRequire("bahqM")).isObject)(target[innerKey]) && !(0, (0, parcelRequire("bahqM")).isArrayLike)(target[innerKey])) {
                    if (topKey) {
                        if (!reverse) {
                            source[innerKey] = target[innerKey];
                            animatable.updateDuringAnimation(topKey);
                        }
                        continue;
                    }
                    $5a5931cff6ff005a$var$animateToShallow(animatable, innerKey, source[innerKey], target[innerKey], cfg, animationProps && animationProps[innerKey], animators, reverse);
                } else {
                    animatableKeys.push(innerKey);
                    changedKeys.push(innerKey);
                }
            } else if (!reverse) {
                source[innerKey] = target[innerKey];
                animatable.updateDuringAnimation(topKey);
                changedKeys.push(innerKey);
            }
        }
        var keyLen = animatableKeys.length;
        if (keyLen > 0 || cfg.force && !animators.length) {
            var existsAnimators = animatable.animators;
            var existsAnimatorsOnSameTarget = [];
            for(var i = 0; i < existsAnimators.length; i++)if (existsAnimators[i].targetName === topKey) existsAnimatorsOnSameTarget.push(existsAnimators[i]);
            if (!additive && existsAnimatorsOnSameTarget.length) for(var i = 0; i < existsAnimatorsOnSameTarget.length; i++){
                var allAborted = existsAnimatorsOnSameTarget[i].stopTracks(changedKeys);
                if (allAborted) {
                    var idx = (0, (0, parcelRequire("bahqM")).indexOf)(existsAnimators, existsAnimatorsOnSameTarget[i]);
                    existsAnimators.splice(idx, 1);
                }
            }
            var revertedSource = void 0;
            var reversedTarget = void 0;
            var sourceClone = void 0;
            if (reverse) {
                reversedTarget = {};
                if (setToFinal) revertedSource = {};
                for(var i = 0; i < keyLen; i++){
                    var innerKey = animatableKeys[i];
                    reversedTarget[innerKey] = source[innerKey];
                    if (setToFinal) revertedSource[innerKey] = target[innerKey];
                    else source[innerKey] = target[innerKey];
                }
            } else if (setToFinal) {
                sourceClone = {};
                for(var i = 0; i < keyLen; i++){
                    var innerKey = animatableKeys[i];
                    sourceClone[innerKey] = (0, (0, parcelRequire("hb2y5")).cloneValue)(source[innerKey]);
                    $5a5931cff6ff005a$var$copyValue(source, target, innerKey);
                }
            }
            var animator = new (0, (0, parcelRequire("hb2y5")).default)(source, false, additive ? existsAnimatorsOnSameTarget : null);
            animator.targetName = topKey;
            if (cfg.scope) animator.scope = cfg.scope;
            if (setToFinal && revertedSource) animator.whenWithKeys(0, revertedSource, animatableKeys);
            if (sourceClone) animator.whenWithKeys(0, sourceClone, animatableKeys);
            animator.whenWithKeys(duration == null ? 500 : duration, reverse ? reversedTarget : target, animatableKeys).delay(delay || 0);
            animatable.addAnimator(animator, topKey);
            animators.push(animator);
        }
    }
    var $5a5931cff6ff005a$export$2e2bcd8739ae039 = $5a5931cff6ff005a$var$Element;
});
parcelRegister("e6gef", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a43e36ee3f294c25$export$2e2bcd8739ae039);
    var $izqgC;
    var $eLEew;
    var $a43e36ee3f294c25$var$mIdentity = (0, parcelRequire("izqgC")).identity;
    var $a43e36ee3f294c25$var$EPSILON = 5e-5;
    function $a43e36ee3f294c25$var$isNotAroundZero(val) {
        return val > $a43e36ee3f294c25$var$EPSILON || val < -$a43e36ee3f294c25$var$EPSILON;
    }
    var $a43e36ee3f294c25$var$scaleTmp = [];
    var $a43e36ee3f294c25$var$tmpTransform = [];
    var $a43e36ee3f294c25$var$originTransform = (0, parcelRequire("izqgC")).create();
    var $a43e36ee3f294c25$var$abs = Math.abs;
    var $a43e36ee3f294c25$var$Transformable = function() {
        function Transformable() {}
        Transformable.prototype.getLocalTransform = function(m) {
            return Transformable.getLocalTransform(this, m);
        };
        Transformable.prototype.setPosition = function(arr) {
            this.x = arr[0];
            this.y = arr[1];
        };
        Transformable.prototype.setScale = function(arr) {
            this.scaleX = arr[0];
            this.scaleY = arr[1];
        };
        Transformable.prototype.setSkew = function(arr) {
            this.skewX = arr[0];
            this.skewY = arr[1];
        };
        Transformable.prototype.setOrigin = function(arr) {
            this.originX = arr[0];
            this.originY = arr[1];
        };
        Transformable.prototype.needLocalTransform = function() {
            return $a43e36ee3f294c25$var$isNotAroundZero(this.rotation) || $a43e36ee3f294c25$var$isNotAroundZero(this.x) || $a43e36ee3f294c25$var$isNotAroundZero(this.y) || $a43e36ee3f294c25$var$isNotAroundZero(this.scaleX - 1) || $a43e36ee3f294c25$var$isNotAroundZero(this.scaleY - 1);
        };
        Transformable.prototype.updateTransform = function() {
            var parentTransform = this.parent && this.parent.transform;
            var needLocalTransform = this.needLocalTransform();
            var m = this.transform;
            if (!(needLocalTransform || parentTransform)) {
                m && $a43e36ee3f294c25$var$mIdentity(m);
                return;
            }
            m = m || (0, parcelRequire("izqgC")).create();
            if (needLocalTransform) this.getLocalTransform(m);
            else $a43e36ee3f294c25$var$mIdentity(m);
            if (parentTransform) {
                if (needLocalTransform) (0, parcelRequire("izqgC")).mul(m, parentTransform, m);
                else (0, parcelRequire("izqgC")).copy(m, parentTransform);
            }
            this.transform = m;
            this._resolveGlobalScaleRatio(m);
        };
        Transformable.prototype._resolveGlobalScaleRatio = function(m) {
            var globalScaleRatio = this.globalScaleRatio;
            if (globalScaleRatio != null && globalScaleRatio !== 1) {
                this.getGlobalScale($a43e36ee3f294c25$var$scaleTmp);
                var relX = $a43e36ee3f294c25$var$scaleTmp[0] < 0 ? -1 : 1;
                var relY = $a43e36ee3f294c25$var$scaleTmp[1] < 0 ? -1 : 1;
                var sx = (($a43e36ee3f294c25$var$scaleTmp[0] - relX) * globalScaleRatio + relX) / $a43e36ee3f294c25$var$scaleTmp[0] || 0;
                var sy = (($a43e36ee3f294c25$var$scaleTmp[1] - relY) * globalScaleRatio + relY) / $a43e36ee3f294c25$var$scaleTmp[1] || 0;
                m[0] *= sx;
                m[1] *= sx;
                m[2] *= sy;
                m[3] *= sy;
            }
            this.invTransform = this.invTransform || (0, parcelRequire("izqgC")).create();
            (0, parcelRequire("izqgC")).invert(this.invTransform, m);
        };
        Transformable.prototype.getComputedTransform = function() {
            var transformNode = this;
            var ancestors = [];
            while(transformNode){
                ancestors.push(transformNode);
                transformNode = transformNode.parent;
            }
            while(transformNode = ancestors.pop())transformNode.updateTransform();
            return this.transform;
        };
        Transformable.prototype.setLocalTransform = function(m) {
            if (!m) return;
            var sx = m[0] * m[0] + m[1] * m[1];
            var sy = m[2] * m[2] + m[3] * m[3];
            var rotation = Math.atan2(m[1], m[0]);
            var shearX = Math.PI / 2 + rotation - Math.atan2(m[3], m[2]);
            sy = Math.sqrt(sy) * Math.cos(shearX);
            sx = Math.sqrt(sx);
            this.skewX = shearX;
            this.skewY = 0;
            this.rotation = -rotation;
            this.x = +m[4];
            this.y = +m[5];
            this.scaleX = sx;
            this.scaleY = sy;
            this.originX = 0;
            this.originY = 0;
        };
        Transformable.prototype.decomposeTransform = function() {
            if (!this.transform) return;
            var parent = this.parent;
            var m = this.transform;
            if (parent && parent.transform) {
                (0, parcelRequire("izqgC")).mul($a43e36ee3f294c25$var$tmpTransform, parent.invTransform, m);
                m = $a43e36ee3f294c25$var$tmpTransform;
            }
            var ox = this.originX;
            var oy = this.originY;
            if (ox || oy) {
                $a43e36ee3f294c25$var$originTransform[4] = ox;
                $a43e36ee3f294c25$var$originTransform[5] = oy;
                (0, parcelRequire("izqgC")).mul($a43e36ee3f294c25$var$tmpTransform, m, $a43e36ee3f294c25$var$originTransform);
                $a43e36ee3f294c25$var$tmpTransform[4] -= ox;
                $a43e36ee3f294c25$var$tmpTransform[5] -= oy;
                m = $a43e36ee3f294c25$var$tmpTransform;
            }
            this.setLocalTransform(m);
        };
        Transformable.prototype.getGlobalScale = function(out) {
            var m = this.transform;
            out = out || [];
            if (!m) {
                out[0] = 1;
                out[1] = 1;
                return out;
            }
            out[0] = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
            out[1] = Math.sqrt(m[2] * m[2] + m[3] * m[3]);
            if (m[0] < 0) out[0] = -out[0];
            if (m[3] < 0) out[1] = -out[1];
            return out;
        };
        Transformable.prototype.transformCoordToLocal = function(x, y) {
            var v2 = [
                x,
                y
            ];
            var invTransform = this.invTransform;
            if (invTransform) (0, parcelRequire("eLEew")).applyTransform(v2, v2, invTransform);
            return v2;
        };
        Transformable.prototype.transformCoordToGlobal = function(x, y) {
            var v2 = [
                x,
                y
            ];
            var transform = this.transform;
            if (transform) (0, parcelRequire("eLEew")).applyTransform(v2, v2, transform);
            return v2;
        };
        Transformable.prototype.getLineScale = function() {
            var m = this.transform;
            return m && $a43e36ee3f294c25$var$abs(m[0] - 1) > 1e-10 && $a43e36ee3f294c25$var$abs(m[3] - 1) > 1e-10 ? Math.sqrt($a43e36ee3f294c25$var$abs(m[0] * m[3] - m[2] * m[1])) : 1;
        };
        Transformable.prototype.copyTransform = function(source) {
            var target = this;
            for(var i = 0; i < $a43e36ee3f294c25$export$98ab6203ec3396e2.length; i++){
                var propName = $a43e36ee3f294c25$export$98ab6203ec3396e2[i];
                target[propName] = source[propName];
            }
        };
        Transformable.getLocalTransform = function(target, m) {
            m = m || [];
            var ox = target.originX || 0;
            var oy = target.originY || 0;
            var sx = target.scaleX;
            var sy = target.scaleY;
            var rotation = target.rotation || 0;
            var x = target.x;
            var y = target.y;
            var skewX = target.skewX ? Math.tan(target.skewX) : 0;
            var skewY = target.skewY ? Math.tan(-target.skewY) : 0;
            if (ox || oy) {
                m[4] = -ox * sx - skewX * oy * sy;
                m[5] = -oy * sy - skewY * ox * sx;
            } else m[4] = m[5] = 0;
            m[0] = sx;
            m[3] = sy;
            m[1] = skewY * sx;
            m[2] = skewX * sy;
            rotation && (0, parcelRequire("izqgC")).rotate(m, m, rotation);
            m[4] += ox + x;
            m[5] += oy + y;
            return m;
        };
        Transformable.initDefaultProps = function() {
            var proto = Transformable.prototype;
            proto.x = 0;
            proto.y = 0;
            proto.scaleX = 1;
            proto.scaleY = 1;
            proto.originX = 0;
            proto.originY = 0;
            proto.skewX = 0;
            proto.skewY = 0;
            proto.rotation = 0;
            proto.globalScaleRatio = 1;
        }();
        return Transformable;
    }();
    var $a43e36ee3f294c25$export$98ab6203ec3396e2 = [
        'x',
        'y',
        'originX',
        'originY',
        'rotation',
        'scaleX',
        'scaleY',
        'skewX',
        'skewY'
    ];
    var $a43e36ee3f294c25$export$2e2bcd8739ae039 = $a43e36ee3f294c25$var$Transformable;
});
parcelRegister("eLEew", function(module, exports) {
    $parcel$export(module.exports, "create", ()=>$ac04a9f644701697$export$185802fd694ee1f5);
    $parcel$export(module.exports, "copy", ()=>$ac04a9f644701697$export$784d13d8ee351f07);
    $parcel$export(module.exports, "clone", ()=>$ac04a9f644701697$export$9cd59f9826255e47);
    $parcel$export(module.exports, "set", ()=>$ac04a9f644701697$export$adaa4cf7ef1b65be);
    $parcel$export(module.exports, "add", ()=>$ac04a9f644701697$export$e16d8520af44a096);
    $parcel$export(module.exports, "scaleAndAdd", ()=>$ac04a9f644701697$export$19cedf1da84ba854);
    $parcel$export(module.exports, "sub", ()=>$ac04a9f644701697$export$f93b5905241a7cca);
    $parcel$export(module.exports, "len", ()=>$ac04a9f644701697$export$fc1400facf92c78);
    $parcel$export(module.exports, "lenSquare", ()=>$ac04a9f644701697$export$48e33bc611e4c25a);
    $parcel$export(module.exports, "length", ()=>$ac04a9f644701697$export$f24224f1c91d8156);
    $parcel$export(module.exports, "lengthSquare", ()=>$ac04a9f644701697$export$2f106540dd9a5136);
    $parcel$export(module.exports, "mul", ()=>$ac04a9f644701697$export$6e3a27864ab166fe);
    $parcel$export(module.exports, "div", ()=>$ac04a9f644701697$export$159d9494db57879b);
    $parcel$export(module.exports, "dot", ()=>$ac04a9f644701697$export$94132a0e348806d4);
    $parcel$export(module.exports, "scale", ()=>$ac04a9f644701697$export$dcdf75081b88279d);
    $parcel$export(module.exports, "normalize", ()=>$ac04a9f644701697$export$a3295358bff77e);
    $parcel$export(module.exports, "distance", ()=>$ac04a9f644701697$export$9f17032d917177de);
    $parcel$export(module.exports, "dist", ()=>$ac04a9f644701697$export$6c4a311cc157c764);
    $parcel$export(module.exports, "distanceSquare", ()=>$ac04a9f644701697$export$137c0a69d1ff4a79);
    $parcel$export(module.exports, "distSquare", ()=>$ac04a9f644701697$export$c68db45a034c13b0);
    $parcel$export(module.exports, "negate", ()=>$ac04a9f644701697$export$aef51622e549b8b0);
    $parcel$export(module.exports, "lerp", ()=>$ac04a9f644701697$export$3a89f8d6f6bf6c9f);
    $parcel$export(module.exports, "applyTransform", ()=>$ac04a9f644701697$export$9f9dcb98c894b623);
    $parcel$export(module.exports, "min", ()=>$ac04a9f644701697$export$96ec731ed4dcb222);
    $parcel$export(module.exports, "max", ()=>$ac04a9f644701697$export$8960430cfd85939f);
    function $ac04a9f644701697$export$185802fd694ee1f5(x, y) {
        if (x == null) x = 0;
        if (y == null) y = 0;
        return [
            x,
            y
        ];
    }
    function $ac04a9f644701697$export$784d13d8ee351f07(out, v) {
        out[0] = v[0];
        out[1] = v[1];
        return out;
    }
    function $ac04a9f644701697$export$9cd59f9826255e47(v) {
        return [
            v[0],
            v[1]
        ];
    }
    function $ac04a9f644701697$export$adaa4cf7ef1b65be(out, a, b) {
        out[0] = a;
        out[1] = b;
        return out;
    }
    function $ac04a9f644701697$export$e16d8520af44a096(out, v1, v2) {
        out[0] = v1[0] + v2[0];
        out[1] = v1[1] + v2[1];
        return out;
    }
    function $ac04a9f644701697$export$19cedf1da84ba854(out, v1, v2, a) {
        out[0] = v1[0] + v2[0] * a;
        out[1] = v1[1] + v2[1] * a;
        return out;
    }
    function $ac04a9f644701697$export$f93b5905241a7cca(out, v1, v2) {
        out[0] = v1[0] - v2[0];
        out[1] = v1[1] - v2[1];
        return out;
    }
    function $ac04a9f644701697$export$fc1400facf92c78(v) {
        return Math.sqrt($ac04a9f644701697$export$48e33bc611e4c25a(v));
    }
    var $ac04a9f644701697$export$f24224f1c91d8156 = $ac04a9f644701697$export$fc1400facf92c78;
    function $ac04a9f644701697$export$48e33bc611e4c25a(v) {
        return v[0] * v[0] + v[1] * v[1];
    }
    var $ac04a9f644701697$export$2f106540dd9a5136 = $ac04a9f644701697$export$48e33bc611e4c25a;
    function $ac04a9f644701697$export$6e3a27864ab166fe(out, v1, v2) {
        out[0] = v1[0] * v2[0];
        out[1] = v1[1] * v2[1];
        return out;
    }
    function $ac04a9f644701697$export$159d9494db57879b(out, v1, v2) {
        out[0] = v1[0] / v2[0];
        out[1] = v1[1] / v2[1];
        return out;
    }
    function $ac04a9f644701697$export$94132a0e348806d4(v1, v2) {
        return v1[0] * v2[0] + v1[1] * v2[1];
    }
    function $ac04a9f644701697$export$dcdf75081b88279d(out, v, s) {
        out[0] = v[0] * s;
        out[1] = v[1] * s;
        return out;
    }
    function $ac04a9f644701697$export$a3295358bff77e(out, v) {
        var d = $ac04a9f644701697$export$fc1400facf92c78(v);
        if (d === 0) {
            out[0] = 0;
            out[1] = 0;
        } else {
            out[0] = v[0] / d;
            out[1] = v[1] / d;
        }
        return out;
    }
    function $ac04a9f644701697$export$9f17032d917177de(v1, v2) {
        return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]));
    }
    var $ac04a9f644701697$export$6c4a311cc157c764 = $ac04a9f644701697$export$9f17032d917177de;
    function $ac04a9f644701697$export$137c0a69d1ff4a79(v1, v2) {
        return (v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]);
    }
    var $ac04a9f644701697$export$c68db45a034c13b0 = $ac04a9f644701697$export$137c0a69d1ff4a79;
    function $ac04a9f644701697$export$aef51622e549b8b0(out, v) {
        out[0] = -v[0];
        out[1] = -v[1];
        return out;
    }
    function $ac04a9f644701697$export$3a89f8d6f6bf6c9f(out, v1, v2, t) {
        out[0] = v1[0] + t * (v2[0] - v1[0]);
        out[1] = v1[1] + t * (v2[1] - v1[1]);
        return out;
    }
    function $ac04a9f644701697$export$9f9dcb98c894b623(out, v, m) {
        var x = v[0];
        var y = v[1];
        out[0] = m[0] * x + m[2] * y + m[4];
        out[1] = m[1] * x + m[3] * y + m[5];
        return out;
    }
    function $ac04a9f644701697$export$96ec731ed4dcb222(out, v1, v2) {
        out[0] = Math.min(v1[0], v2[0]);
        out[1] = Math.min(v1[1], v2[1]);
        return out;
    }
    function $ac04a9f644701697$export$8960430cfd85939f(out, v1, v2) {
        out[0] = Math.max(v1[0], v2[0]);
        out[1] = Math.max(v1[1], v2[1]);
        return out;
    }
});
parcelRegister("bRKv5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8a38b6f95cbd6cc6$export$2e2bcd8739ae039);
    var $8a38b6f95cbd6cc6$var$Eventful = function() {
        function Eventful(eventProcessors) {
            if (eventProcessors) this._$eventProcessor = eventProcessors;
        }
        Eventful.prototype.on = function(event, query, handler, context) {
            if (!this._$handlers) this._$handlers = {};
            var _h = this._$handlers;
            if (typeof query === 'function') {
                context = handler;
                handler = query;
                query = null;
            }
            if (!handler || !event) return this;
            var eventProcessor = this._$eventProcessor;
            if (query != null && eventProcessor && eventProcessor.normalizeQuery) query = eventProcessor.normalizeQuery(query);
            if (!_h[event]) _h[event] = [];
            for(var i = 0; i < _h[event].length; i++){
                if (_h[event][i].h === handler) return this;
            }
            var wrap = {
                h: handler,
                query: query,
                ctx: context || this,
                callAtLast: handler.zrEventfulCallAtLast
            };
            var lastIndex = _h[event].length - 1;
            var lastWrap = _h[event][lastIndex];
            lastWrap && lastWrap.callAtLast ? _h[event].splice(lastIndex, 0, wrap) : _h[event].push(wrap);
            return this;
        };
        Eventful.prototype.isSilent = function(eventName) {
            var _h = this._$handlers;
            return !_h || !_h[eventName] || !_h[eventName].length;
        };
        Eventful.prototype.off = function(eventType, handler) {
            var _h = this._$handlers;
            if (!_h) return this;
            if (!eventType) {
                this._$handlers = {};
                return this;
            }
            if (handler) {
                if (_h[eventType]) {
                    var newList = [];
                    for(var i = 0, l = _h[eventType].length; i < l; i++)if (_h[eventType][i].h !== handler) newList.push(_h[eventType][i]);
                    _h[eventType] = newList;
                }
                if (_h[eventType] && _h[eventType].length === 0) delete _h[eventType];
            } else delete _h[eventType];
            return this;
        };
        Eventful.prototype.trigger = function(eventType) {
            var args = [];
            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
            if (!this._$handlers) return this;
            var _h = this._$handlers[eventType];
            var eventProcessor = this._$eventProcessor;
            if (_h) {
                var argLen = args.length;
                var len = _h.length;
                for(var i = 0; i < len; i++){
                    var hItem = _h[i];
                    if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(eventType, hItem.query)) continue;
                    switch(argLen){
                        case 0:
                            hItem.h.call(hItem.ctx);
                            break;
                        case 1:
                            hItem.h.call(hItem.ctx, args[0]);
                            break;
                        case 2:
                            hItem.h.call(hItem.ctx, args[0], args[1]);
                            break;
                        default:
                            hItem.h.apply(hItem.ctx, args);
                            break;
                    }
                }
            }
            eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(eventType);
            return this;
        };
        Eventful.prototype.triggerWithContext = function(type) {
            var args = [];
            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
            if (!this._$handlers) return this;
            var _h = this._$handlers[type];
            var eventProcessor = this._$eventProcessor;
            if (_h) {
                var argLen = args.length;
                var ctx = args[argLen - 1];
                var len = _h.length;
                for(var i = 0; i < len; i++){
                    var hItem = _h[i];
                    if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) continue;
                    switch(argLen){
                        case 0:
                            hItem.h.call(ctx);
                            break;
                        case 1:
                            hItem.h.call(ctx, args[0]);
                            break;
                        case 2:
                            hItem.h.call(ctx, args[0], args[1]);
                            break;
                        default:
                            hItem.h.apply(ctx, args.slice(1, argLen - 1));
                            break;
                    }
                }
            }
            eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
            return this;
        };
        return Eventful;
    }();
    var $8a38b6f95cbd6cc6$export$2e2bcd8739ae039 = $8a38b6f95cbd6cc6$var$Eventful;
});
parcelRegister("7y1my", function(module, exports) {
    $parcel$export(module.exports, "devicePixelRatio", ()=>$57ecc3ffeb61d50b$export$508f096bfcdaac40);
    $parcel$export(module.exports, "DARK_MODE_THRESHOLD", ()=>$57ecc3ffeb61d50b$export$fd81e7ebc7dae256);
    $parcel$export(module.exports, "DARK_LABEL_COLOR", ()=>$57ecc3ffeb61d50b$export$f8ce94761f39398d);
    $parcel$export(module.exports, "LIGHT_LABEL_COLOR", ()=>$57ecc3ffeb61d50b$export$3c6e95f318c8369b);
    $parcel$export(module.exports, "LIGHTER_LABEL_COLOR", ()=>$57ecc3ffeb61d50b$export$27682248795c3c6b);
    var $57ecc3ffeb61d50b$var$dpr = 1;
    if (typeof window !== 'undefined') $57ecc3ffeb61d50b$var$dpr = Math.max(window.devicePixelRatio || window.screen && window.screen.deviceXDPI / window.screen.logicalXDPI || 1, 1);
    var $57ecc3ffeb61d50b$export$7cdcde344c85339c = 0;
    var $57ecc3ffeb61d50b$export$508f096bfcdaac40 = $57ecc3ffeb61d50b$var$dpr;
    var $57ecc3ffeb61d50b$export$fd81e7ebc7dae256 = 0.4;
    var $57ecc3ffeb61d50b$export$f8ce94761f39398d = '#333';
    var $57ecc3ffeb61d50b$export$3c6e95f318c8369b = '#ccc';
    var $57ecc3ffeb61d50b$export$27682248795c3c6b = '#eee';
});
parcelRegister("aVawM", function(module, exports) {
    $parcel$export(module.exports, "REDRAW_BIT", ()=>$7f3764d4456adf3b$export$a7b6db622c6c7dbd);
    $parcel$export(module.exports, "STYLE_CHANGED_BIT", ()=>$7f3764d4456adf3b$export$ada8b2beb3d76671);
    $parcel$export(module.exports, "SHAPE_CHANGED_BIT", ()=>$7f3764d4456adf3b$export$f75fe89a33ebe115);
    var $7f3764d4456adf3b$export$a7b6db622c6c7dbd = 1;
    var $7f3764d4456adf3b$export$ada8b2beb3d76671 = 2;
    var $7f3764d4456adf3b$export$f75fe89a33ebe115 = 4;
});
parcelRegister("ghQ8v", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_PATH_STYLE", ()=>$bdb6ad049d5f8c6b$export$deade517576e293a);
    $parcel$export(module.exports, "default", ()=>$bdb6ad049d5f8c6b$export$2e2bcd8739ae039);
    var $3VFsf;
    var $lBQ88;
    var $aA4Ws;
    var $k3yEY;
    var $bahqM;
    var $d6udH;
    var $7y1my;
    var $aVawM;
    var $bdb6ad049d5f8c6b$export$deade517576e293a = (0, (0, parcelRequire("bahqM")).defaults)({
        fill: '#000',
        stroke: null,
        strokePercent: 1,
        fillOpacity: 1,
        strokeOpacity: 1,
        lineDashOffset: 0,
        lineWidth: 1,
        lineCap: 'butt',
        miterLimit: 10,
        strokeNoScale: false,
        strokeFirst: false
    }, (0, (0, parcelRequire("lBQ88")).DEFAULT_COMMON_STYLE));
    var $bdb6ad049d5f8c6b$export$71bb6c3c6862c6a5 = {
        style: (0, (0, parcelRequire("bahqM")).defaults)({
            fill: true,
            stroke: true,
            strokePercent: true,
            fillOpacity: true,
            strokeOpacity: true,
            lineDashOffset: true,
            lineWidth: true,
            miterLimit: true
        }, (0, (0, parcelRequire("lBQ88")).DEFAULT_COMMON_ANIMATION_PROPS).style)
    };
    var $bdb6ad049d5f8c6b$var$pathCopyParams = [
        'x',
        'y',
        'rotation',
        'scaleX',
        'scaleY',
        'originX',
        'originY',
        'invisible',
        'culling',
        'z',
        'z2',
        'zlevel',
        'parent'
    ];
    var $bdb6ad049d5f8c6b$var$Path = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Path, _super);
        function Path(opts) {
            return _super.call(this, opts) || this;
        }
        Path.prototype.update = function() {
            var _this = this;
            _super.prototype.update.call(this);
            var style = this.style;
            if (style.decal) {
                var decalEl = this._decalEl = this._decalEl || new Path();
                if (decalEl.buildPath === Path.prototype.buildPath) decalEl.buildPath = function(ctx) {
                    _this.buildPath(ctx, _this.shape);
                };
                decalEl.silent = true;
                var decalElStyle = decalEl.style;
                for(var key in style)if (decalElStyle[key] !== style[key]) decalElStyle[key] = style[key];
                decalElStyle.fill = style.fill ? style.decal : null;
                decalElStyle.decal = null;
                decalElStyle.shadowColor = null;
                style.strokeFirst && (decalElStyle.stroke = null);
                for(var i = 0; i < $bdb6ad049d5f8c6b$var$pathCopyParams.length; ++i)decalEl[$bdb6ad049d5f8c6b$var$pathCopyParams[i]] = this[$bdb6ad049d5f8c6b$var$pathCopyParams[i]];
                decalEl.__dirty |= (0, (0, parcelRequire("aVawM")).REDRAW_BIT);
            } else if (this._decalEl) this._decalEl = null;
        };
        Path.prototype.getDecalElement = function() {
            return this._decalEl;
        };
        Path.prototype._init = function(props) {
            var keysArr = (0, (0, parcelRequire("bahqM")).keys)(props);
            this.shape = this.getDefaultShape();
            var defaultStyle = this.getDefaultStyle();
            if (defaultStyle) this.useStyle(defaultStyle);
            for(var i = 0; i < keysArr.length; i++){
                var key = keysArr[i];
                var value = props[key];
                if (key === 'style') {
                    if (!this.style) this.useStyle(value);
                    else (0, (0, parcelRequire("bahqM")).extend)(this.style, value);
                } else if (key === 'shape') (0, (0, parcelRequire("bahqM")).extend)(this.shape, value);
                else _super.prototype.attrKV.call(this, key, value);
            }
            if (!this.style) this.useStyle({});
        };
        Path.prototype.getDefaultStyle = function() {
            return null;
        };
        Path.prototype.getDefaultShape = function() {
            return {};
        };
        Path.prototype.canBeInsideText = function() {
            return this.hasFill();
        };
        Path.prototype.getInsideTextFill = function() {
            var pathFill = this.style.fill;
            if (pathFill !== 'none') {
                if ((0, (0, parcelRequire("bahqM")).isString)(pathFill)) {
                    var fillLum = (0, (0, parcelRequire("d6udH")).lum)(pathFill, 0);
                    if (fillLum > 0.5) return 0, (0, parcelRequire("7y1my")).DARK_LABEL_COLOR;
                    else if (fillLum > 0.2) return 0, (0, parcelRequire("7y1my")).LIGHTER_LABEL_COLOR;
                    return 0, (0, parcelRequire("7y1my")).LIGHT_LABEL_COLOR;
                } else if (pathFill) return 0, (0, parcelRequire("7y1my")).LIGHT_LABEL_COLOR;
            }
            return 0, (0, parcelRequire("7y1my")).DARK_LABEL_COLOR;
        };
        Path.prototype.getInsideTextStroke = function(textFill) {
            var pathFill = this.style.fill;
            if ((0, (0, parcelRequire("bahqM")).isString)(pathFill)) {
                var zr = this.__zr;
                var isDarkMode = !!(zr && zr.isDarkMode());
                var isDarkLabel = (0, (0, parcelRequire("d6udH")).lum)(textFill, 0) < (0, (0, parcelRequire("7y1my")).DARK_MODE_THRESHOLD);
                if (isDarkMode === isDarkLabel) return pathFill;
            }
        };
        Path.prototype.buildPath = function(ctx, shapeCfg, inBatch) {};
        Path.prototype.pathUpdated = function() {
            this.__dirty &= ~(0, (0, parcelRequire("aVawM")).SHAPE_CHANGED_BIT);
        };
        Path.prototype.getUpdatedPathProxy = function(inBatch) {
            !this.path && this.createPathProxy();
            this.path.beginPath();
            this.buildPath(this.path, this.shape, inBatch);
            return this.path;
        };
        Path.prototype.createPathProxy = function() {
            this.path = new (0, (0, parcelRequire("aA4Ws")).default)(false);
        };
        Path.prototype.hasStroke = function() {
            var style = this.style;
            var stroke = style.stroke;
            return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
        };
        Path.prototype.hasFill = function() {
            var style = this.style;
            var fill = style.fill;
            return fill != null && fill !== 'none';
        };
        Path.prototype.getBoundingRect = function() {
            var rect = this._rect;
            var style = this.style;
            var needsUpdateRect = !rect;
            if (needsUpdateRect) {
                var firstInvoke = false;
                if (!this.path) {
                    firstInvoke = true;
                    this.createPathProxy();
                }
                var path = this.path;
                if (firstInvoke || this.__dirty & (0, (0, parcelRequire("aVawM")).SHAPE_CHANGED_BIT)) {
                    path.beginPath();
                    this.buildPath(path, this.shape, false);
                    this.pathUpdated();
                }
                rect = path.getBoundingRect();
            }
            this._rect = rect;
            if (this.hasStroke() && this.path && this.path.len() > 0) {
                var rectWithStroke = this._rectWithStroke || (this._rectWithStroke = rect.clone());
                if (this.__dirty || needsUpdateRect) {
                    rectWithStroke.copy(rect);
                    var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                    var w = style.lineWidth;
                    if (!this.hasFill()) {
                        var strokeContainThreshold = this.strokeContainThreshold;
                        w = Math.max(w, strokeContainThreshold == null ? 4 : strokeContainThreshold);
                    }
                    if (lineScale > 1e-10) {
                        rectWithStroke.width += w / lineScale;
                        rectWithStroke.height += w / lineScale;
                        rectWithStroke.x -= w / lineScale / 2;
                        rectWithStroke.y -= w / lineScale / 2;
                    }
                }
                return rectWithStroke;
            }
            return rect;
        };
        Path.prototype.contain = function(x, y) {
            var localPos = this.transformCoordToLocal(x, y);
            var rect = this.getBoundingRect();
            var style = this.style;
            x = localPos[0];
            y = localPos[1];
            if (rect.contain(x, y)) {
                var pathProxy = this.path;
                if (this.hasStroke()) {
                    var lineWidth = style.lineWidth;
                    var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                    if (lineScale > 1e-10) {
                        if (!this.hasFill()) lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
                        if ((0, parcelRequire("k3yEY")).containStroke(pathProxy, lineWidth / lineScale, x, y)) return true;
                    }
                }
                if (this.hasFill()) return (0, parcelRequire("k3yEY")).contain(pathProxy, x, y);
            }
            return false;
        };
        Path.prototype.dirtyShape = function() {
            this.__dirty |= (0, (0, parcelRequire("aVawM")).SHAPE_CHANGED_BIT);
            if (this._rect) this._rect = null;
            if (this._decalEl) this._decalEl.dirtyShape();
            this.markRedraw();
        };
        Path.prototype.dirty = function() {
            this.dirtyStyle();
            this.dirtyShape();
        };
        Path.prototype.animateShape = function(loop) {
            return this.animate('shape', loop);
        };
        Path.prototype.updateDuringAnimation = function(targetKey) {
            if (targetKey === 'style') this.dirtyStyle();
            else if (targetKey === 'shape') this.dirtyShape();
            else this.markRedraw();
        };
        Path.prototype.attrKV = function(key, value) {
            if (key === 'shape') this.setShape(value);
            else _super.prototype.attrKV.call(this, key, value);
        };
        Path.prototype.setShape = function(keyOrObj, value) {
            var shape = this.shape;
            if (!shape) shape = this.shape = {};
            if (typeof keyOrObj === 'string') shape[keyOrObj] = value;
            else (0, (0, parcelRequire("bahqM")).extend)(shape, keyOrObj);
            this.dirtyShape();
            return this;
        };
        Path.prototype.shapeChanged = function() {
            return !!(this.__dirty & (0, (0, parcelRequire("aVawM")).SHAPE_CHANGED_BIT));
        };
        Path.prototype.createStyle = function(obj) {
            return (0, (0, parcelRequire("bahqM")).createObject)($bdb6ad049d5f8c6b$export$deade517576e293a, obj);
        };
        Path.prototype._innerSaveToNormal = function(toState) {
            _super.prototype._innerSaveToNormal.call(this, toState);
            var normalState = this._normalState;
            if (toState.shape && !normalState.shape) normalState.shape = (0, (0, parcelRequire("bahqM")).extend)({}, this.shape);
        };
        Path.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
            _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
            var needsRestoreToNormal = !(state && keepCurrentStates);
            var targetShape;
            if (state && state.shape) {
                if (transition) {
                    if (keepCurrentStates) targetShape = state.shape;
                    else {
                        targetShape = (0, (0, parcelRequire("bahqM")).extend)({}, normalState.shape);
                        (0, (0, parcelRequire("bahqM")).extend)(targetShape, state.shape);
                    }
                } else {
                    targetShape = (0, (0, parcelRequire("bahqM")).extend)({}, keepCurrentStates ? this.shape : normalState.shape);
                    (0, (0, parcelRequire("bahqM")).extend)(targetShape, state.shape);
                }
            } else if (needsRestoreToNormal) targetShape = normalState.shape;
            if (targetShape) {
                if (transition) {
                    this.shape = (0, (0, parcelRequire("bahqM")).extend)({}, this.shape);
                    var targetShapePrimaryProps = {};
                    var shapeKeys = (0, (0, parcelRequire("bahqM")).keys)(targetShape);
                    for(var i = 0; i < shapeKeys.length; i++){
                        var key = shapeKeys[i];
                        if (typeof targetShape[key] === 'object') this.shape[key] = targetShape[key];
                        else targetShapePrimaryProps[key] = targetShape[key];
                    }
                    this._transitionState(stateName, {
                        shape: targetShapePrimaryProps
                    }, animationCfg);
                } else {
                    this.shape = targetShape;
                    this.dirtyShape();
                }
            }
        };
        Path.prototype._mergeStates = function(states) {
            var mergedState = _super.prototype._mergeStates.call(this, states);
            var mergedShape;
            for(var i = 0; i < states.length; i++){
                var state = states[i];
                if (state.shape) {
                    mergedShape = mergedShape || {};
                    this._mergeStyle(mergedShape, state.shape);
                }
            }
            if (mergedShape) mergedState.shape = mergedShape;
            return mergedState;
        };
        Path.prototype.getAnimationStyleProps = function() {
            return $bdb6ad049d5f8c6b$export$71bb6c3c6862c6a5;
        };
        Path.prototype.isZeroArea = function() {
            return false;
        };
        Path.extend = function(defaultProps) {
            var Sub = function(_super) {
                (0, (0, parcelRequire("3VFsf")).__extends)(Sub, _super);
                function Sub(opts) {
                    var _this = _super.call(this, opts) || this;
                    defaultProps.init && defaultProps.init.call(_this, opts);
                    return _this;
                }
                Sub.prototype.getDefaultStyle = function() {
                    return (0, (0, parcelRequire("bahqM")).clone)(defaultProps.style);
                };
                Sub.prototype.getDefaultShape = function() {
                    return (0, (0, parcelRequire("bahqM")).clone)(defaultProps.shape);
                };
                return Sub;
            }(Path);
            for(var key in defaultProps)if (typeof defaultProps[key] === 'function') Sub.prototype[key] = defaultProps[key];
            return Sub;
        };
        Path.initDefaultProps = function() {
            var pathProto = Path.prototype;
            pathProto.type = 'path';
            pathProto.strokeContainThreshold = 5;
            pathProto.segmentIgnoreThreshold = 0;
            pathProto.subPixelOptimize = false;
            pathProto.autoBatch = false;
            pathProto.__dirty = (0, (0, parcelRequire("aVawM")).REDRAW_BIT) | (0, (0, parcelRequire("aVawM")).STYLE_CHANGED_BIT) | (0, (0, parcelRequire("aVawM")).SHAPE_CHANGED_BIT);
        }();
        return Path;
    }((0, (0, parcelRequire("lBQ88")).default));
    var $bdb6ad049d5f8c6b$export$2e2bcd8739ae039 = $bdb6ad049d5f8c6b$var$Path;
});
parcelRegister("aA4Ws", function(module, exports) {
    $parcel$export(module.exports, "normalizeArcAngles", ()=>$7b4119855d2b5b91$export$bc668021e937022a);
    $parcel$export(module.exports, "default", ()=>$7b4119855d2b5b91$export$2e2bcd8739ae039);
    var $eLEew;
    var $1E3E8;
    var $7y1my;
    var $13I82;
    var $dr1jo;
    var $7b4119855d2b5b91$var$CMD = {
        M: 1,
        L: 2,
        C: 3,
        Q: 4,
        A: 5,
        Z: 6,
        R: 7
    };
    var $7b4119855d2b5b91$var$tmpOutX = [];
    var $7b4119855d2b5b91$var$tmpOutY = [];
    var $7b4119855d2b5b91$var$min = [];
    var $7b4119855d2b5b91$var$max = [];
    var $7b4119855d2b5b91$var$min2 = [];
    var $7b4119855d2b5b91$var$max2 = [];
    var $7b4119855d2b5b91$var$mathMin = Math.min;
    var $7b4119855d2b5b91$var$mathMax = Math.max;
    var $7b4119855d2b5b91$var$mathCos = Math.cos;
    var $7b4119855d2b5b91$var$mathSin = Math.sin;
    var $7b4119855d2b5b91$var$mathSqrt = Math.sqrt;
    var $7b4119855d2b5b91$var$mathAbs = Math.abs;
    var $7b4119855d2b5b91$var$PI = Math.PI;
    var $7b4119855d2b5b91$var$PI2 = $7b4119855d2b5b91$var$PI * 2;
    var $7b4119855d2b5b91$var$hasTypedArray = typeof Float32Array !== 'undefined';
    var $7b4119855d2b5b91$var$tmpAngles = [];
    function $7b4119855d2b5b91$var$modPI2(radian) {
        var n = Math.round(radian / $7b4119855d2b5b91$var$PI * 1e8) / 1e8;
        return n % 2 * $7b4119855d2b5b91$var$PI;
    }
    function $7b4119855d2b5b91$export$bc668021e937022a(angles, anticlockwise) {
        var newStartAngle = $7b4119855d2b5b91$var$modPI2(angles[0]);
        if (newStartAngle < 0) newStartAngle += $7b4119855d2b5b91$var$PI2;
        var delta = newStartAngle - angles[0];
        var newEndAngle = angles[1];
        newEndAngle += delta;
        if (!anticlockwise && newEndAngle - newStartAngle >= $7b4119855d2b5b91$var$PI2) newEndAngle = newStartAngle + $7b4119855d2b5b91$var$PI2;
        else if (anticlockwise && newStartAngle - newEndAngle >= $7b4119855d2b5b91$var$PI2) newEndAngle = newStartAngle - $7b4119855d2b5b91$var$PI2;
        else if (!anticlockwise && newStartAngle > newEndAngle) newEndAngle = newStartAngle + ($7b4119855d2b5b91$var$PI2 - $7b4119855d2b5b91$var$modPI2(newStartAngle - newEndAngle));
        else if (anticlockwise && newStartAngle < newEndAngle) newEndAngle = newStartAngle - ($7b4119855d2b5b91$var$PI2 - $7b4119855d2b5b91$var$modPI2(newEndAngle - newStartAngle));
        angles[0] = newStartAngle;
        angles[1] = newEndAngle;
    }
    var $7b4119855d2b5b91$var$PathProxy = function() {
        function PathProxy(notSaveData) {
            this.dpr = 1;
            this._xi = 0;
            this._yi = 0;
            this._x0 = 0;
            this._y0 = 0;
            this._len = 0;
            if (notSaveData) this._saveData = false;
            if (this._saveData) this.data = [];
        }
        PathProxy.prototype.increaseVersion = function() {
            this._version++;
        };
        PathProxy.prototype.getVersion = function() {
            return this._version;
        };
        PathProxy.prototype.setScale = function(sx, sy, segmentIgnoreThreshold) {
            segmentIgnoreThreshold = segmentIgnoreThreshold || 0;
            if (segmentIgnoreThreshold > 0) {
                this._ux = $7b4119855d2b5b91$var$mathAbs(segmentIgnoreThreshold / (0, (0, parcelRequire("7y1my")).devicePixelRatio) / sx) || 0;
                this._uy = $7b4119855d2b5b91$var$mathAbs(segmentIgnoreThreshold / (0, (0, parcelRequire("7y1my")).devicePixelRatio) / sy) || 0;
            }
        };
        PathProxy.prototype.setDPR = function(dpr) {
            this.dpr = dpr;
        };
        PathProxy.prototype.setContext = function(ctx) {
            this._ctx = ctx;
        };
        PathProxy.prototype.getContext = function() {
            return this._ctx;
        };
        PathProxy.prototype.beginPath = function() {
            this._ctx && this._ctx.beginPath();
            this.reset();
            return this;
        };
        PathProxy.prototype.reset = function() {
            if (this._saveData) this._len = 0;
            if (this._lineDash) {
                this._lineDash = null;
                this._dashOffset = 0;
            }
            if (this._pathSegLen) {
                this._pathSegLen = null;
                this._pathLen = 0;
            }
            this._version++;
        };
        PathProxy.prototype.moveTo = function(x, y) {
            this._drawPendingPt();
            this.addData($7b4119855d2b5b91$var$CMD.M, x, y);
            this._ctx && this._ctx.moveTo(x, y);
            this._x0 = x;
            this._y0 = y;
            this._xi = x;
            this._yi = y;
            return this;
        };
        PathProxy.prototype.lineTo = function(x, y) {
            var dx = $7b4119855d2b5b91$var$mathAbs(x - this._xi);
            var dy = $7b4119855d2b5b91$var$mathAbs(y - this._yi);
            var exceedUnit = dx > this._ux || dy > this._uy;
            this.addData($7b4119855d2b5b91$var$CMD.L, x, y);
            if (this._ctx && exceedUnit) this._needsDash ? this._dashedLineTo(x, y) : this._ctx.lineTo(x, y);
            if (exceedUnit) {
                this._xi = x;
                this._yi = y;
                this._pendingPtDist = 0;
            } else {
                var d2 = dx * dx + dy * dy;
                if (d2 > this._pendingPtDist) {
                    this._pendingPtX = x;
                    this._pendingPtY = y;
                    this._pendingPtDist = d2;
                }
            }
            return this;
        };
        PathProxy.prototype.bezierCurveTo = function(x1, y1, x2, y2, x3, y3) {
            this._drawPendingPt();
            this.addData($7b4119855d2b5b91$var$CMD.C, x1, y1, x2, y2, x3, y3);
            if (this._ctx) this._needsDash ? this._dashedBezierTo(x1, y1, x2, y2, x3, y3) : this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
            this._xi = x3;
            this._yi = y3;
            return this;
        };
        PathProxy.prototype.quadraticCurveTo = function(x1, y1, x2, y2) {
            this._drawPendingPt();
            this.addData($7b4119855d2b5b91$var$CMD.Q, x1, y1, x2, y2);
            if (this._ctx) this._needsDash ? this._dashedQuadraticTo(x1, y1, x2, y2) : this._ctx.quadraticCurveTo(x1, y1, x2, y2);
            this._xi = x2;
            this._yi = y2;
            return this;
        };
        PathProxy.prototype.arc = function(cx, cy, r, startAngle, endAngle, anticlockwise) {
            this._drawPendingPt();
            $7b4119855d2b5b91$var$tmpAngles[0] = startAngle;
            $7b4119855d2b5b91$var$tmpAngles[1] = endAngle;
            $7b4119855d2b5b91$export$bc668021e937022a($7b4119855d2b5b91$var$tmpAngles, anticlockwise);
            startAngle = $7b4119855d2b5b91$var$tmpAngles[0];
            endAngle = $7b4119855d2b5b91$var$tmpAngles[1];
            var delta = endAngle - startAngle;
            this.addData($7b4119855d2b5b91$var$CMD.A, cx, cy, r, r, startAngle, delta, 0, anticlockwise ? 0 : 1);
            this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
            this._xi = $7b4119855d2b5b91$var$mathCos(endAngle) * r + cx;
            this._yi = $7b4119855d2b5b91$var$mathSin(endAngle) * r + cy;
            return this;
        };
        PathProxy.prototype.arcTo = function(x1, y1, x2, y2, radius) {
            this._drawPendingPt();
            if (this._ctx) this._ctx.arcTo(x1, y1, x2, y2, radius);
            return this;
        };
        PathProxy.prototype.rect = function(x, y, w, h) {
            this._drawPendingPt();
            this._ctx && this._ctx.rect(x, y, w, h);
            this.addData($7b4119855d2b5b91$var$CMD.R, x, y, w, h);
            return this;
        };
        PathProxy.prototype.closePath = function() {
            this._drawPendingPt();
            this.addData($7b4119855d2b5b91$var$CMD.Z);
            var ctx = this._ctx;
            var x0 = this._x0;
            var y0 = this._y0;
            if (ctx) {
                this._needsDash && this._dashedLineTo(x0, y0);
                ctx.closePath();
            }
            this._xi = x0;
            this._yi = y0;
            return this;
        };
        PathProxy.prototype.fill = function(ctx) {
            ctx && ctx.fill();
            this.toStatic();
        };
        PathProxy.prototype.stroke = function(ctx) {
            ctx && ctx.stroke();
            this.toStatic();
        };
        PathProxy.prototype.setLineDash = function(lineDash) {
            if (lineDash instanceof Array) {
                this._lineDash = lineDash;
                this._dashIdx = 0;
                var lineDashSum = 0;
                for(var i = 0; i < lineDash.length; i++)lineDashSum += lineDash[i];
                this._dashSum = lineDashSum;
                this._needsDash = true;
            } else {
                this._lineDash = null;
                this._needsDash = false;
            }
            return this;
        };
        PathProxy.prototype.setLineDashOffset = function(offset) {
            this._dashOffset = offset;
            return this;
        };
        PathProxy.prototype.len = function() {
            return this._len;
        };
        PathProxy.prototype.setData = function(data) {
            var len = data.length;
            if (!(this.data && this.data.length === len) && $7b4119855d2b5b91$var$hasTypedArray) this.data = new Float32Array(len);
            for(var i = 0; i < len; i++)this.data[i] = data[i];
            this._len = len;
        };
        PathProxy.prototype.appendPath = function(path) {
            if (!(path instanceof Array)) path = [
                path
            ];
            var len = path.length;
            var appendSize = 0;
            var offset = this._len;
            for(var i = 0; i < len; i++)appendSize += path[i].len();
            if ($7b4119855d2b5b91$var$hasTypedArray && this.data instanceof Float32Array) this.data = new Float32Array(offset + appendSize);
            for(var i = 0; i < len; i++){
                var appendPathData = path[i].data;
                for(var k = 0; k < appendPathData.length; k++)this.data[offset++] = appendPathData[k];
            }
            this._len = offset;
        };
        PathProxy.prototype.addData = function(cmd, a, b, c, d, e, f, g, h) {
            if (!this._saveData) return;
            var data = this.data;
            if (this._len + arguments.length > data.length) {
                this._expandData();
                data = this.data;
            }
            for(var i = 0; i < arguments.length; i++)data[this._len++] = arguments[i];
        };
        PathProxy.prototype._drawPendingPt = function() {
            if (this._pendingPtDist > 0) {
                this._ctx && this._ctx.lineTo(this._pendingPtX, this._pendingPtY);
                this._pendingPtDist = 0;
            }
        };
        PathProxy.prototype._expandData = function() {
            if (!(this.data instanceof Array)) {
                var newData = [];
                for(var i = 0; i < this._len; i++)newData[i] = this.data[i];
                this.data = newData;
            }
        };
        PathProxy.prototype._dashedLineTo = function(x1, y1) {
            var dashSum = this._dashSum;
            var lineDash = this._lineDash;
            var ctx = this._ctx;
            var offset = this._dashOffset;
            var x0 = this._xi;
            var y0 = this._yi;
            var dx = x1 - x0;
            var dy = y1 - y0;
            var dist = $7b4119855d2b5b91$var$mathSqrt(dx * dx + dy * dy);
            var x = x0;
            var y = y0;
            var nDash = lineDash.length;
            var dash;
            var idx;
            dx /= dist;
            dy /= dist;
            if (offset < 0) offset = dashSum + offset;
            offset %= dashSum;
            x -= offset * dx;
            y -= offset * dy;
            while(dx > 0 && x <= x1 || dx < 0 && x >= x1 || dx === 0 && (dy > 0 && y <= y1 || dy < 0 && y >= y1)){
                idx = this._dashIdx;
                dash = lineDash[idx];
                x += dx * dash;
                y += dy * dash;
                this._dashIdx = (idx + 1) % nDash;
                if (dx > 0 && x < x0 || dx < 0 && x > x0 || dy > 0 && y < y0 || dy < 0 && y > y0) continue;
                ctx[idx % 2 ? 'moveTo' : 'lineTo'](dx >= 0 ? $7b4119855d2b5b91$var$mathMin(x, x1) : $7b4119855d2b5b91$var$mathMax(x, x1), dy >= 0 ? $7b4119855d2b5b91$var$mathMin(y, y1) : $7b4119855d2b5b91$var$mathMax(y, y1));
            }
            dx = x - x1;
            dy = y - y1;
            this._dashOffset = -$7b4119855d2b5b91$var$mathSqrt(dx * dx + dy * dy);
        };
        PathProxy.prototype._dashedBezierTo = function(x1, y1, x2, y2, x3, y3) {
            var ctx = this._ctx;
            var dashSum = this._dashSum;
            var offset = this._dashOffset;
            var lineDash = this._lineDash;
            var x0 = this._xi;
            var y0 = this._yi;
            var bezierLen = 0;
            var idx = this._dashIdx;
            var nDash = lineDash.length;
            var t;
            var dx;
            var dy;
            var x;
            var y;
            var tmpLen = 0;
            if (offset < 0) offset = dashSum + offset;
            offset %= dashSum;
            for(t = 0; t < 1; t += 0.1){
                dx = (0, (0, parcelRequire("dr1jo")).cubicAt)(x0, x1, x2, x3, t + 0.1) - (0, (0, parcelRequire("dr1jo")).cubicAt)(x0, x1, x2, x3, t);
                dy = (0, (0, parcelRequire("dr1jo")).cubicAt)(y0, y1, y2, y3, t + 0.1) - (0, (0, parcelRequire("dr1jo")).cubicAt)(y0, y1, y2, y3, t);
                bezierLen += $7b4119855d2b5b91$var$mathSqrt(dx * dx + dy * dy);
            }
            for(; idx < nDash; idx++){
                tmpLen += lineDash[idx];
                if (tmpLen > offset) break;
            }
            t = (tmpLen - offset) / bezierLen;
            while(t <= 1){
                x = (0, (0, parcelRequire("dr1jo")).cubicAt)(x0, x1, x2, x3, t);
                y = (0, (0, parcelRequire("dr1jo")).cubicAt)(y0, y1, y2, y3, t);
                idx % 2 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
                t += lineDash[idx] / bezierLen;
                idx = (idx + 1) % nDash;
            }
            idx % 2 !== 0 && ctx.lineTo(x3, y3);
            dx = x3 - x;
            dy = y3 - y;
            this._dashOffset = -$7b4119855d2b5b91$var$mathSqrt(dx * dx + dy * dy);
        };
        PathProxy.prototype._dashedQuadraticTo = function(x1, y1, x2, y2) {
            var x3 = x2;
            var y3 = y2;
            x2 = (x2 + 2 * x1) / 3;
            y2 = (y2 + 2 * y1) / 3;
            x1 = (this._xi + 2 * x1) / 3;
            y1 = (this._yi + 2 * y1) / 3;
            this._dashedBezierTo(x1, y1, x2, y2, x3, y3);
        };
        PathProxy.prototype.toStatic = function() {
            if (!this._saveData) return;
            this._drawPendingPt();
            var data = this.data;
            if (data instanceof Array) {
                data.length = this._len;
                if ($7b4119855d2b5b91$var$hasTypedArray && this._len > 11) this.data = new Float32Array(data);
            }
        };
        PathProxy.prototype.getBoundingRect = function() {
            $7b4119855d2b5b91$var$min[0] = $7b4119855d2b5b91$var$min[1] = $7b4119855d2b5b91$var$min2[0] = $7b4119855d2b5b91$var$min2[1] = Number.MAX_VALUE;
            $7b4119855d2b5b91$var$max[0] = $7b4119855d2b5b91$var$max[1] = $7b4119855d2b5b91$var$max2[0] = $7b4119855d2b5b91$var$max2[1] = -Number.MAX_VALUE;
            var data = this.data;
            var xi = 0;
            var yi = 0;
            var x0 = 0;
            var y0 = 0;
            var i;
            for(i = 0; i < this._len;){
                var cmd = data[i++];
                var isFirst = i === 1;
                if (isFirst) {
                    xi = data[i];
                    yi = data[i + 1];
                    x0 = xi;
                    y0 = yi;
                }
                switch(cmd){
                    case $7b4119855d2b5b91$var$CMD.M:
                        xi = x0 = data[i++];
                        yi = y0 = data[i++];
                        $7b4119855d2b5b91$var$min2[0] = x0;
                        $7b4119855d2b5b91$var$min2[1] = y0;
                        $7b4119855d2b5b91$var$max2[0] = x0;
                        $7b4119855d2b5b91$var$max2[1] = y0;
                        break;
                    case $7b4119855d2b5b91$var$CMD.L:
                        (0, (0, parcelRequire("13I82")).fromLine)(xi, yi, data[i], data[i + 1], $7b4119855d2b5b91$var$min2, $7b4119855d2b5b91$var$max2);
                        xi = data[i++];
                        yi = data[i++];
                        break;
                    case $7b4119855d2b5b91$var$CMD.C:
                        (0, (0, parcelRequire("13I82")).fromCubic)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], $7b4119855d2b5b91$var$min2, $7b4119855d2b5b91$var$max2);
                        xi = data[i++];
                        yi = data[i++];
                        break;
                    case $7b4119855d2b5b91$var$CMD.Q:
                        (0, (0, parcelRequire("13I82")).fromQuadratic)(xi, yi, data[i++], data[i++], data[i], data[i + 1], $7b4119855d2b5b91$var$min2, $7b4119855d2b5b91$var$max2);
                        xi = data[i++];
                        yi = data[i++];
                        break;
                    case $7b4119855d2b5b91$var$CMD.A:
                        var cx = data[i++];
                        var cy = data[i++];
                        var rx = data[i++];
                        var ry = data[i++];
                        var startAngle = data[i++];
                        var endAngle = data[i++] + startAngle;
                        i += 1;
                        var anticlockwise = !data[i++];
                        if (isFirst) {
                            x0 = $7b4119855d2b5b91$var$mathCos(startAngle) * rx + cx;
                            y0 = $7b4119855d2b5b91$var$mathSin(startAngle) * ry + cy;
                        }
                        (0, (0, parcelRequire("13I82")).fromArc)(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, $7b4119855d2b5b91$var$min2, $7b4119855d2b5b91$var$max2);
                        xi = $7b4119855d2b5b91$var$mathCos(endAngle) * rx + cx;
                        yi = $7b4119855d2b5b91$var$mathSin(endAngle) * ry + cy;
                        break;
                    case $7b4119855d2b5b91$var$CMD.R:
                        x0 = xi = data[i++];
                        y0 = yi = data[i++];
                        var width = data[i++];
                        var height = data[i++];
                        (0, (0, parcelRequire("13I82")).fromLine)(x0, y0, x0 + width, y0 + height, $7b4119855d2b5b91$var$min2, $7b4119855d2b5b91$var$max2);
                        break;
                    case $7b4119855d2b5b91$var$CMD.Z:
                        xi = x0;
                        yi = y0;
                        break;
                }
                (0, parcelRequire("eLEew")).min($7b4119855d2b5b91$var$min, $7b4119855d2b5b91$var$min, $7b4119855d2b5b91$var$min2);
                (0, parcelRequire("eLEew")).max($7b4119855d2b5b91$var$max, $7b4119855d2b5b91$var$max, $7b4119855d2b5b91$var$max2);
            }
            if (i === 0) $7b4119855d2b5b91$var$min[0] = $7b4119855d2b5b91$var$min[1] = $7b4119855d2b5b91$var$max[0] = $7b4119855d2b5b91$var$max[1] = 0;
            return new (0, (0, parcelRequire("1E3E8")).default)($7b4119855d2b5b91$var$min[0], $7b4119855d2b5b91$var$min[1], $7b4119855d2b5b91$var$max[0] - $7b4119855d2b5b91$var$min[0], $7b4119855d2b5b91$var$max[1] - $7b4119855d2b5b91$var$min[1]);
        };
        PathProxy.prototype._calculateLength = function() {
            var data = this.data;
            var len = this._len;
            var ux = this._ux;
            var uy = this._uy;
            var xi = 0;
            var yi = 0;
            var x0 = 0;
            var y0 = 0;
            if (!this._pathSegLen) this._pathSegLen = [];
            var pathSegLen = this._pathSegLen;
            var pathTotalLen = 0;
            var segCount = 0;
            for(var i = 0; i < len;){
                var cmd = data[i++];
                var isFirst = i === 1;
                if (isFirst) {
                    xi = data[i];
                    yi = data[i + 1];
                    x0 = xi;
                    y0 = yi;
                }
                var l = -1;
                switch(cmd){
                    case $7b4119855d2b5b91$var$CMD.M:
                        xi = x0 = data[i++];
                        yi = y0 = data[i++];
                        break;
                    case $7b4119855d2b5b91$var$CMD.L:
                        var x2 = data[i++];
                        var y2 = data[i++];
                        var dx = x2 - xi;
                        var dy = y2 - yi;
                        if ($7b4119855d2b5b91$var$mathAbs(dx) > ux || $7b4119855d2b5b91$var$mathAbs(dy) > uy || i === len - 1) {
                            l = Math.sqrt(dx * dx + dy * dy);
                            xi = x2;
                            yi = y2;
                        }
                        break;
                    case $7b4119855d2b5b91$var$CMD.C:
                        var x1 = data[i++];
                        var y1 = data[i++];
                        var x2 = data[i++];
                        var y2 = data[i++];
                        var x3 = data[i++];
                        var y3 = data[i++];
                        l = (0, (0, parcelRequire("dr1jo")).cubicLength)(xi, yi, x1, y1, x2, y2, x3, y3, 10);
                        xi = x3;
                        yi = y3;
                        break;
                    case $7b4119855d2b5b91$var$CMD.Q:
                        var x1 = data[i++];
                        var y1 = data[i++];
                        var x2 = data[i++];
                        var y2 = data[i++];
                        l = (0, (0, parcelRequire("dr1jo")).quadraticLength)(xi, yi, x1, y1, x2, y2, 10);
                        xi = x2;
                        yi = y2;
                        break;
                    case $7b4119855d2b5b91$var$CMD.A:
                        var cx = data[i++];
                        var cy = data[i++];
                        var rx = data[i++];
                        var ry = data[i++];
                        var startAngle = data[i++];
                        var delta = data[i++];
                        var endAngle = delta + startAngle;
                        i += 1;
                        var anticlockwise = !data[i++];
                        if (isFirst) {
                            x0 = $7b4119855d2b5b91$var$mathCos(startAngle) * rx + cx;
                            y0 = $7b4119855d2b5b91$var$mathSin(startAngle) * ry + cy;
                        }
                        l = $7b4119855d2b5b91$var$mathMax(rx, ry) * $7b4119855d2b5b91$var$mathMin($7b4119855d2b5b91$var$PI2, Math.abs(delta));
                        xi = $7b4119855d2b5b91$var$mathCos(endAngle) * rx + cx;
                        yi = $7b4119855d2b5b91$var$mathSin(endAngle) * ry + cy;
                        break;
                    case $7b4119855d2b5b91$var$CMD.R:
                        x0 = xi = data[i++];
                        y0 = yi = data[i++];
                        var width = data[i++];
                        var height = data[i++];
                        l = width * 2 + height * 2;
                        break;
                    case $7b4119855d2b5b91$var$CMD.Z:
                        var dx = x0 - xi;
                        var dy = y0 - yi;
                        l = Math.sqrt(dx * dx + dy * dy);
                        xi = x0;
                        yi = y0;
                        break;
                }
                if (l >= 0) {
                    pathSegLen[segCount++] = l;
                    pathTotalLen += l;
                }
            }
            this._pathLen = pathTotalLen;
            return pathTotalLen;
        };
        PathProxy.prototype.rebuildPath = function(ctx, percent) {
            var d = this.data;
            var ux = this._ux;
            var uy = this._uy;
            var len = this._len;
            var x0;
            var y0;
            var xi;
            var yi;
            var x;
            var y;
            var drawPart = percent < 1;
            var pathSegLen;
            var pathTotalLen;
            var accumLength = 0;
            var segCount = 0;
            var displayedLength;
            var pendingPtDist = 0;
            var pendingPtX;
            var pendingPtY;
            if (drawPart) {
                if (!this._pathSegLen) this._calculateLength();
                pathSegLen = this._pathSegLen;
                pathTotalLen = this._pathLen;
                displayedLength = percent * pathTotalLen;
                if (!displayedLength) return;
            }
            lo: for(var i = 0; i < len;){
                var cmd = d[i++];
                var isFirst = i === 1;
                if (isFirst) {
                    xi = d[i];
                    yi = d[i + 1];
                    x0 = xi;
                    y0 = yi;
                }
                if (cmd !== $7b4119855d2b5b91$var$CMD.L && pendingPtDist > 0) {
                    ctx.lineTo(pendingPtX, pendingPtY);
                    pendingPtDist = 0;
                }
                switch(cmd){
                    case $7b4119855d2b5b91$var$CMD.M:
                        x0 = xi = d[i++];
                        y0 = yi = d[i++];
                        ctx.moveTo(xi, yi);
                        break;
                    case $7b4119855d2b5b91$var$CMD.L:
                        x = d[i++];
                        y = d[i++];
                        var dx = $7b4119855d2b5b91$var$mathAbs(x - xi);
                        var dy = $7b4119855d2b5b91$var$mathAbs(y - yi);
                        if (dx > ux || dy > uy) {
                            if (drawPart) {
                                var l = pathSegLen[segCount++];
                                if (accumLength + l > displayedLength) {
                                    var t = (displayedLength - accumLength) / l;
                                    ctx.lineTo(xi * (1 - t) + x * t, yi * (1 - t) + y * t);
                                    break lo;
                                }
                                accumLength += l;
                            }
                            ctx.lineTo(x, y);
                            xi = x;
                            yi = y;
                            pendingPtDist = 0;
                        } else {
                            var d2 = dx * dx + dy * dy;
                            if (d2 > pendingPtDist) {
                                pendingPtX = x;
                                pendingPtY = y;
                                pendingPtDist = d2;
                            }
                        }
                        break;
                    case $7b4119855d2b5b91$var$CMD.C:
                        var x1 = d[i++];
                        var y1 = d[i++];
                        var x2 = d[i++];
                        var y2 = d[i++];
                        var x3 = d[i++];
                        var y3 = d[i++];
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                var t = (displayedLength - accumLength) / l;
                                (0, (0, parcelRequire("dr1jo")).cubicSubdivide)(xi, x1, x2, x3, t, $7b4119855d2b5b91$var$tmpOutX);
                                (0, (0, parcelRequire("dr1jo")).cubicSubdivide)(yi, y1, y2, y3, t, $7b4119855d2b5b91$var$tmpOutY);
                                ctx.bezierCurveTo($7b4119855d2b5b91$var$tmpOutX[1], $7b4119855d2b5b91$var$tmpOutY[1], $7b4119855d2b5b91$var$tmpOutX[2], $7b4119855d2b5b91$var$tmpOutY[2], $7b4119855d2b5b91$var$tmpOutX[3], $7b4119855d2b5b91$var$tmpOutY[3]);
                                break lo;
                            }
                            accumLength += l;
                        }
                        ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
                        xi = x3;
                        yi = y3;
                        break;
                    case $7b4119855d2b5b91$var$CMD.Q:
                        var x1 = d[i++];
                        var y1 = d[i++];
                        var x2 = d[i++];
                        var y2 = d[i++];
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                var t = (displayedLength - accumLength) / l;
                                (0, (0, parcelRequire("dr1jo")).quadraticSubdivide)(xi, x1, x2, t, $7b4119855d2b5b91$var$tmpOutX);
                                (0, (0, parcelRequire("dr1jo")).quadraticSubdivide)(yi, y1, y2, t, $7b4119855d2b5b91$var$tmpOutY);
                                ctx.quadraticCurveTo($7b4119855d2b5b91$var$tmpOutX[1], $7b4119855d2b5b91$var$tmpOutY[1], $7b4119855d2b5b91$var$tmpOutX[2], $7b4119855d2b5b91$var$tmpOutY[2]);
                                break lo;
                            }
                            accumLength += l;
                        }
                        ctx.quadraticCurveTo(x1, y1, x2, y2);
                        xi = x2;
                        yi = y2;
                        break;
                    case $7b4119855d2b5b91$var$CMD.A:
                        var cx = d[i++];
                        var cy = d[i++];
                        var rx = d[i++];
                        var ry = d[i++];
                        var startAngle = d[i++];
                        var delta = d[i++];
                        var psi = d[i++];
                        var anticlockwise = !d[i++];
                        var r = rx > ry ? rx : ry;
                        var isEllipse = $7b4119855d2b5b91$var$mathAbs(rx - ry) > 1e-3;
                        var endAngle = startAngle + delta;
                        var breakBuild = false;
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                endAngle = startAngle + delta * (displayedLength - accumLength) / l;
                                breakBuild = true;
                            }
                            accumLength += l;
                        }
                        if (isEllipse && ctx.ellipse) ctx.ellipse(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise);
                        else ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
                        if (breakBuild) break lo;
                        if (isFirst) {
                            x0 = $7b4119855d2b5b91$var$mathCos(startAngle) * rx + cx;
                            y0 = $7b4119855d2b5b91$var$mathSin(startAngle) * ry + cy;
                        }
                        xi = $7b4119855d2b5b91$var$mathCos(endAngle) * rx + cx;
                        yi = $7b4119855d2b5b91$var$mathSin(endAngle) * ry + cy;
                        break;
                    case $7b4119855d2b5b91$var$CMD.R:
                        x0 = xi = d[i];
                        y0 = yi = d[i + 1];
                        x = d[i++];
                        y = d[i++];
                        var width = d[i++];
                        var height = d[i++];
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                var d_1 = displayedLength - accumLength;
                                ctx.moveTo(x, y);
                                ctx.lineTo(x + $7b4119855d2b5b91$var$mathMin(d_1, width), y);
                                d_1 -= width;
                                if (d_1 > 0) ctx.lineTo(x + width, y + $7b4119855d2b5b91$var$mathMin(d_1, height));
                                d_1 -= height;
                                if (d_1 > 0) ctx.lineTo(x + $7b4119855d2b5b91$var$mathMax(width - d_1, 0), y + height);
                                d_1 -= width;
                                if (d_1 > 0) ctx.lineTo(x, y + $7b4119855d2b5b91$var$mathMax(height - d_1, 0));
                                break lo;
                            }
                            accumLength += l;
                        }
                        ctx.rect(x, y, width, height);
                        break;
                    case $7b4119855d2b5b91$var$CMD.Z:
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                var t = (displayedLength - accumLength) / l;
                                ctx.lineTo(xi * (1 - t) + x0 * t, yi * (1 - t) + y0 * t);
                                break lo;
                            }
                            accumLength += l;
                        }
                        ctx.closePath();
                        xi = x0;
                        yi = y0;
                }
            }
        };
        PathProxy.prototype.clone = function() {
            var newProxy = new PathProxy();
            var data = this.data;
            newProxy.data = data.slice ? data.slice() : Array.prototype.slice.call(data);
            newProxy._len = this._len;
            return newProxy;
        };
        PathProxy.CMD = $7b4119855d2b5b91$var$CMD;
        PathProxy.initDefaultProps = function() {
            var proto = PathProxy.prototype;
            proto._saveData = true;
            proto._needsDash = false;
            proto._dashOffset = 0;
            proto._dashIdx = 0;
            proto._dashSum = 0;
            proto._ux = 0;
            proto._uy = 0;
            proto._pendingPtDist = 0;
            proto._version = 0;
        }();
        return PathProxy;
    }();
    var $7b4119855d2b5b91$export$2e2bcd8739ae039 = $7b4119855d2b5b91$var$PathProxy;
});
parcelRegister("13I82", function(module, exports) {
    $parcel$export(module.exports, "fromPoints", ()=>$0c584d4e3f9e2fa0$export$188c3cd07b4129dd);
    $parcel$export(module.exports, "fromLine", ()=>$0c584d4e3f9e2fa0$export$d2b1491e4450bf2c);
    $parcel$export(module.exports, "fromCubic", ()=>$0c584d4e3f9e2fa0$export$c1bc6be456bb6609);
    $parcel$export(module.exports, "fromQuadratic", ()=>$0c584d4e3f9e2fa0$export$16fbe795323a1f4c);
    $parcel$export(module.exports, "fromArc", ()=>$0c584d4e3f9e2fa0$export$161c8bb0e1d9ef49);
    var $eLEew;
    var $dr1jo;
    var $0c584d4e3f9e2fa0$var$mathMin = Math.min;
    var $0c584d4e3f9e2fa0$var$mathMax = Math.max;
    var $0c584d4e3f9e2fa0$var$mathSin = Math.sin;
    var $0c584d4e3f9e2fa0$var$mathCos = Math.cos;
    var $0c584d4e3f9e2fa0$var$PI2 = Math.PI * 2;
    var $0c584d4e3f9e2fa0$var$start = (0, parcelRequire("eLEew")).create();
    var $0c584d4e3f9e2fa0$var$end = (0, parcelRequire("eLEew")).create();
    var $0c584d4e3f9e2fa0$var$extremity = (0, parcelRequire("eLEew")).create();
    function $0c584d4e3f9e2fa0$export$188c3cd07b4129dd(points, min, max) {
        if (points.length === 0) return;
        var p = points[0];
        var left = p[0];
        var right = p[0];
        var top = p[1];
        var bottom = p[1];
        for(var i = 1; i < points.length; i++){
            p = points[i];
            left = $0c584d4e3f9e2fa0$var$mathMin(left, p[0]);
            right = $0c584d4e3f9e2fa0$var$mathMax(right, p[0]);
            top = $0c584d4e3f9e2fa0$var$mathMin(top, p[1]);
            bottom = $0c584d4e3f9e2fa0$var$mathMax(bottom, p[1]);
        }
        min[0] = left;
        min[1] = top;
        max[0] = right;
        max[1] = bottom;
    }
    function $0c584d4e3f9e2fa0$export$d2b1491e4450bf2c(x0, y0, x1, y1, min, max) {
        min[0] = $0c584d4e3f9e2fa0$var$mathMin(x0, x1);
        min[1] = $0c584d4e3f9e2fa0$var$mathMin(y0, y1);
        max[0] = $0c584d4e3f9e2fa0$var$mathMax(x0, x1);
        max[1] = $0c584d4e3f9e2fa0$var$mathMax(y0, y1);
    }
    var $0c584d4e3f9e2fa0$var$xDim = [];
    var $0c584d4e3f9e2fa0$var$yDim = [];
    function $0c584d4e3f9e2fa0$export$c1bc6be456bb6609(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
        var cubicExtrema = (0, parcelRequire("dr1jo")).cubicExtrema;
        var cubicAt = (0, parcelRequire("dr1jo")).cubicAt;
        var n = cubicExtrema(x0, x1, x2, x3, $0c584d4e3f9e2fa0$var$xDim);
        min[0] = Infinity;
        min[1] = Infinity;
        max[0] = -Infinity;
        max[1] = -Infinity;
        for(var i = 0; i < n; i++){
            var x = cubicAt(x0, x1, x2, x3, $0c584d4e3f9e2fa0$var$xDim[i]);
            min[0] = $0c584d4e3f9e2fa0$var$mathMin(x, min[0]);
            max[0] = $0c584d4e3f9e2fa0$var$mathMax(x, max[0]);
        }
        n = cubicExtrema(y0, y1, y2, y3, $0c584d4e3f9e2fa0$var$yDim);
        for(var i = 0; i < n; i++){
            var y = cubicAt(y0, y1, y2, y3, $0c584d4e3f9e2fa0$var$yDim[i]);
            min[1] = $0c584d4e3f9e2fa0$var$mathMin(y, min[1]);
            max[1] = $0c584d4e3f9e2fa0$var$mathMax(y, max[1]);
        }
        min[0] = $0c584d4e3f9e2fa0$var$mathMin(x0, min[0]);
        max[0] = $0c584d4e3f9e2fa0$var$mathMax(x0, max[0]);
        min[0] = $0c584d4e3f9e2fa0$var$mathMin(x3, min[0]);
        max[0] = $0c584d4e3f9e2fa0$var$mathMax(x3, max[0]);
        min[1] = $0c584d4e3f9e2fa0$var$mathMin(y0, min[1]);
        max[1] = $0c584d4e3f9e2fa0$var$mathMax(y0, max[1]);
        min[1] = $0c584d4e3f9e2fa0$var$mathMin(y3, min[1]);
        max[1] = $0c584d4e3f9e2fa0$var$mathMax(y3, max[1]);
    }
    function $0c584d4e3f9e2fa0$export$16fbe795323a1f4c(x0, y0, x1, y1, x2, y2, min, max) {
        var quadraticExtremum = (0, parcelRequire("dr1jo")).quadraticExtremum;
        var quadraticAt = (0, parcelRequire("dr1jo")).quadraticAt;
        var tx = $0c584d4e3f9e2fa0$var$mathMax($0c584d4e3f9e2fa0$var$mathMin(quadraticExtremum(x0, x1, x2), 1), 0);
        var ty = $0c584d4e3f9e2fa0$var$mathMax($0c584d4e3f9e2fa0$var$mathMin(quadraticExtremum(y0, y1, y2), 1), 0);
        var x = quadraticAt(x0, x1, x2, tx);
        var y = quadraticAt(y0, y1, y2, ty);
        min[0] = $0c584d4e3f9e2fa0$var$mathMin(x0, x2, x);
        min[1] = $0c584d4e3f9e2fa0$var$mathMin(y0, y2, y);
        max[0] = $0c584d4e3f9e2fa0$var$mathMax(x0, x2, x);
        max[1] = $0c584d4e3f9e2fa0$var$mathMax(y0, y2, y);
    }
    function $0c584d4e3f9e2fa0$export$161c8bb0e1d9ef49(x, y, rx, ry, startAngle, endAngle, anticlockwise, min, max) {
        var vec2Min = (0, parcelRequire("eLEew")).min;
        var vec2Max = (0, parcelRequire("eLEew")).max;
        var diff = Math.abs(startAngle - endAngle);
        if (diff % $0c584d4e3f9e2fa0$var$PI2 < 1e-4 && diff > 1e-4) {
            min[0] = x - rx;
            min[1] = y - ry;
            max[0] = x + rx;
            max[1] = y + ry;
            return;
        }
        $0c584d4e3f9e2fa0$var$start[0] = $0c584d4e3f9e2fa0$var$mathCos(startAngle) * rx + x;
        $0c584d4e3f9e2fa0$var$start[1] = $0c584d4e3f9e2fa0$var$mathSin(startAngle) * ry + y;
        $0c584d4e3f9e2fa0$var$end[0] = $0c584d4e3f9e2fa0$var$mathCos(endAngle) * rx + x;
        $0c584d4e3f9e2fa0$var$end[1] = $0c584d4e3f9e2fa0$var$mathSin(endAngle) * ry + y;
        vec2Min(min, $0c584d4e3f9e2fa0$var$start, $0c584d4e3f9e2fa0$var$end);
        vec2Max(max, $0c584d4e3f9e2fa0$var$start, $0c584d4e3f9e2fa0$var$end);
        startAngle = startAngle % $0c584d4e3f9e2fa0$var$PI2;
        if (startAngle < 0) startAngle = startAngle + $0c584d4e3f9e2fa0$var$PI2;
        endAngle = endAngle % $0c584d4e3f9e2fa0$var$PI2;
        if (endAngle < 0) endAngle = endAngle + $0c584d4e3f9e2fa0$var$PI2;
        if (startAngle > endAngle && !anticlockwise) endAngle += $0c584d4e3f9e2fa0$var$PI2;
        else if (startAngle < endAngle && anticlockwise) startAngle += $0c584d4e3f9e2fa0$var$PI2;
        if (anticlockwise) {
            var tmp = endAngle;
            endAngle = startAngle;
            startAngle = tmp;
        }
        for(var angle = 0; angle < endAngle; angle += Math.PI / 2)if (angle > startAngle) {
            $0c584d4e3f9e2fa0$var$extremity[0] = $0c584d4e3f9e2fa0$var$mathCos(angle) * rx + x;
            $0c584d4e3f9e2fa0$var$extremity[1] = $0c584d4e3f9e2fa0$var$mathSin(angle) * ry + y;
            vec2Min(min, $0c584d4e3f9e2fa0$var$extremity, min);
            vec2Max(max, $0c584d4e3f9e2fa0$var$extremity, max);
        }
    }
});
parcelRegister("dr1jo", function(module, exports) {
    $parcel$export(module.exports, "cubicAt", ()=>$9c7ed07589dafe64$export$547c21de482bbcb2);
    $parcel$export(module.exports, "cubicDerivativeAt", ()=>$9c7ed07589dafe64$export$55fce925c60b6271);
    $parcel$export(module.exports, "cubicRootAt", ()=>$9c7ed07589dafe64$export$ca5d13faa10b167e);
    $parcel$export(module.exports, "cubicExtrema", ()=>$9c7ed07589dafe64$export$df1a172f100d0457);
    $parcel$export(module.exports, "cubicSubdivide", ()=>$9c7ed07589dafe64$export$a2ee23a0567039da);
    $parcel$export(module.exports, "cubicProjectPoint", ()=>$9c7ed07589dafe64$export$dbaa3801d1284367);
    $parcel$export(module.exports, "cubicLength", ()=>$9c7ed07589dafe64$export$af1875d576f60d7c);
    $parcel$export(module.exports, "quadraticAt", ()=>$9c7ed07589dafe64$export$af17094a950f5073);
    $parcel$export(module.exports, "quadraticDerivativeAt", ()=>$9c7ed07589dafe64$export$7e161e77e6fff8cb);
    $parcel$export(module.exports, "quadraticRootAt", ()=>$9c7ed07589dafe64$export$fd895ac7ee764967);
    $parcel$export(module.exports, "quadraticExtremum", ()=>$9c7ed07589dafe64$export$752e1f8c6e7f7e11);
    $parcel$export(module.exports, "quadraticSubdivide", ()=>$9c7ed07589dafe64$export$117c659e21a7a060);
    $parcel$export(module.exports, "quadraticProjectPoint", ()=>$9c7ed07589dafe64$export$81915a594fe10dee);
    $parcel$export(module.exports, "quadraticLength", ()=>$9c7ed07589dafe64$export$8a68adee46f3cf55);
    var $eLEew;
    var $9c7ed07589dafe64$var$mathPow = Math.pow;
    var $9c7ed07589dafe64$var$mathSqrt = Math.sqrt;
    var $9c7ed07589dafe64$var$EPSILON = 1e-8;
    var $9c7ed07589dafe64$var$EPSILON_NUMERIC = 1e-4;
    var $9c7ed07589dafe64$var$THREE_SQRT = $9c7ed07589dafe64$var$mathSqrt(3);
    var $9c7ed07589dafe64$var$ONE_THIRD = 1 / 3;
    var $9c7ed07589dafe64$var$_v0 = (0, (0, parcelRequire("eLEew")).create)();
    var $9c7ed07589dafe64$var$_v1 = (0, (0, parcelRequire("eLEew")).create)();
    var $9c7ed07589dafe64$var$_v2 = (0, (0, parcelRequire("eLEew")).create)();
    function $9c7ed07589dafe64$var$isAroundZero(val) {
        return val > -$9c7ed07589dafe64$var$EPSILON && val < $9c7ed07589dafe64$var$EPSILON;
    }
    function $9c7ed07589dafe64$var$isNotAroundZero(val) {
        return val > $9c7ed07589dafe64$var$EPSILON || val < -$9c7ed07589dafe64$var$EPSILON;
    }
    function $9c7ed07589dafe64$export$547c21de482bbcb2(p0, p1, p2, p3, t) {
        var onet = 1 - t;
        return onet * onet * (onet * p0 + 3 * t * p1) + t * t * (t * p3 + 3 * onet * p2);
    }
    function $9c7ed07589dafe64$export$55fce925c60b6271(p0, p1, p2, p3, t) {
        var onet = 1 - t;
        return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet + (p3 - p2) * t * t);
    }
    function $9c7ed07589dafe64$export$ca5d13faa10b167e(p0, p1, p2, p3, val, roots) {
        var a = p3 + 3 * (p1 - p2) - p0;
        var b = 3 * (p2 - p1 * 2 + p0);
        var c = 3 * (p1 - p0);
        var d = p0 - val;
        var A = b * b - 3 * a * c;
        var B = b * c - 9 * a * d;
        var C = c * c - 3 * b * d;
        var n = 0;
        if ($9c7ed07589dafe64$var$isAroundZero(A) && $9c7ed07589dafe64$var$isAroundZero(B)) {
            if ($9c7ed07589dafe64$var$isAroundZero(b)) roots[0] = 0;
            else {
                var t1 = -c / b;
                if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            }
        } else {
            var disc = B * B - 4 * A * C;
            if ($9c7ed07589dafe64$var$isAroundZero(disc)) {
                var K = B / A;
                var t1 = -b / a + K;
                var t2 = -K / 2;
                if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
                if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
            } else if (disc > 0) {
                var discSqrt = $9c7ed07589dafe64$var$mathSqrt(disc);
                var Y1 = A * b + 1.5 * a * (-B + discSqrt);
                var Y2 = A * b + 1.5 * a * (-B - discSqrt);
                if (Y1 < 0) Y1 = -$9c7ed07589dafe64$var$mathPow(-Y1, $9c7ed07589dafe64$var$ONE_THIRD);
                else Y1 = $9c7ed07589dafe64$var$mathPow(Y1, $9c7ed07589dafe64$var$ONE_THIRD);
                if (Y2 < 0) Y2 = -$9c7ed07589dafe64$var$mathPow(-Y2, $9c7ed07589dafe64$var$ONE_THIRD);
                else Y2 = $9c7ed07589dafe64$var$mathPow(Y2, $9c7ed07589dafe64$var$ONE_THIRD);
                var t1 = (-b - (Y1 + Y2)) / (3 * a);
                if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            } else {
                var T = (2 * A * b - 3 * a * B) / (2 * $9c7ed07589dafe64$var$mathSqrt(A * A * A));
                var theta = Math.acos(T) / 3;
                var ASqrt = $9c7ed07589dafe64$var$mathSqrt(A);
                var tmp = Math.cos(theta);
                var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
                var t2 = (-b + ASqrt * (tmp + $9c7ed07589dafe64$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
                var t3 = (-b + ASqrt * (tmp - $9c7ed07589dafe64$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
                if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
                if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
                if (t3 >= 0 && t3 <= 1) roots[n++] = t3;
            }
        }
        return n;
    }
    function $9c7ed07589dafe64$export$df1a172f100d0457(p0, p1, p2, p3, extrema) {
        var b = 6 * p2 - 12 * p1 + 6 * p0;
        var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
        var c = 3 * p1 - 3 * p0;
        var n = 0;
        if ($9c7ed07589dafe64$var$isAroundZero(a)) {
            if ($9c7ed07589dafe64$var$isNotAroundZero(b)) {
                var t1 = -c / b;
                if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
            }
        } else {
            var disc = b * b - 4 * a * c;
            if ($9c7ed07589dafe64$var$isAroundZero(disc)) extrema[0] = -b / (2 * a);
            else if (disc > 0) {
                var discSqrt = $9c7ed07589dafe64$var$mathSqrt(disc);
                var t1 = (-b + discSqrt) / (2 * a);
                var t2 = (-b - discSqrt) / (2 * a);
                if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
                if (t2 >= 0 && t2 <= 1) extrema[n++] = t2;
            }
        }
        return n;
    }
    function $9c7ed07589dafe64$export$a2ee23a0567039da(p0, p1, p2, p3, t, out) {
        var p01 = (p1 - p0) * t + p0;
        var p12 = (p2 - p1) * t + p1;
        var p23 = (p3 - p2) * t + p2;
        var p012 = (p12 - p01) * t + p01;
        var p123 = (p23 - p12) * t + p12;
        var p0123 = (p123 - p012) * t + p012;
        out[0] = p0;
        out[1] = p01;
        out[2] = p012;
        out[3] = p0123;
        out[4] = p0123;
        out[5] = p123;
        out[6] = p23;
        out[7] = p3;
    }
    function $9c7ed07589dafe64$export$dbaa3801d1284367(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
        var t;
        var interval = 0.005;
        var d = Infinity;
        var prev;
        var next;
        var d1;
        var d2;
        $9c7ed07589dafe64$var$_v0[0] = x;
        $9c7ed07589dafe64$var$_v0[1] = y;
        for(var _t = 0; _t < 1; _t += 0.05){
            $9c7ed07589dafe64$var$_v1[0] = $9c7ed07589dafe64$export$547c21de482bbcb2(x0, x1, x2, x3, _t);
            $9c7ed07589dafe64$var$_v1[1] = $9c7ed07589dafe64$export$547c21de482bbcb2(y0, y1, y2, y3, _t);
            d1 = (0, (0, parcelRequire("eLEew")).distSquare)($9c7ed07589dafe64$var$_v0, $9c7ed07589dafe64$var$_v1);
            if (d1 < d) {
                t = _t;
                d = d1;
            }
        }
        d = Infinity;
        for(var i = 0; i < 32; i++){
            if (interval < $9c7ed07589dafe64$var$EPSILON_NUMERIC) break;
            prev = t - interval;
            next = t + interval;
            $9c7ed07589dafe64$var$_v1[0] = $9c7ed07589dafe64$export$547c21de482bbcb2(x0, x1, x2, x3, prev);
            $9c7ed07589dafe64$var$_v1[1] = $9c7ed07589dafe64$export$547c21de482bbcb2(y0, y1, y2, y3, prev);
            d1 = (0, (0, parcelRequire("eLEew")).distSquare)($9c7ed07589dafe64$var$_v1, $9c7ed07589dafe64$var$_v0);
            if (prev >= 0 && d1 < d) {
                t = prev;
                d = d1;
            } else {
                $9c7ed07589dafe64$var$_v2[0] = $9c7ed07589dafe64$export$547c21de482bbcb2(x0, x1, x2, x3, next);
                $9c7ed07589dafe64$var$_v2[1] = $9c7ed07589dafe64$export$547c21de482bbcb2(y0, y1, y2, y3, next);
                d2 = (0, (0, parcelRequire("eLEew")).distSquare)($9c7ed07589dafe64$var$_v2, $9c7ed07589dafe64$var$_v0);
                if (next <= 1 && d2 < d) {
                    t = next;
                    d = d2;
                } else interval *= 0.5;
            }
        }
        if (out) {
            out[0] = $9c7ed07589dafe64$export$547c21de482bbcb2(x0, x1, x2, x3, t);
            out[1] = $9c7ed07589dafe64$export$547c21de482bbcb2(y0, y1, y2, y3, t);
        }
        return $9c7ed07589dafe64$var$mathSqrt(d);
    }
    function $9c7ed07589dafe64$export$af1875d576f60d7c(x0, y0, x1, y1, x2, y2, x3, y3, iteration) {
        var px = x0;
        var py = y0;
        var d = 0;
        var step = 1 / iteration;
        for(var i = 1; i <= iteration; i++){
            var t = i * step;
            var x = $9c7ed07589dafe64$export$547c21de482bbcb2(x0, x1, x2, x3, t);
            var y = $9c7ed07589dafe64$export$547c21de482bbcb2(y0, y1, y2, y3, t);
            var dx = x - px;
            var dy = y - py;
            d += Math.sqrt(dx * dx + dy * dy);
            px = x;
            py = y;
        }
        return d;
    }
    function $9c7ed07589dafe64$export$af17094a950f5073(p0, p1, p2, t) {
        var onet = 1 - t;
        return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
    }
    function $9c7ed07589dafe64$export$7e161e77e6fff8cb(p0, p1, p2, t) {
        return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
    }
    function $9c7ed07589dafe64$export$fd895ac7ee764967(p0, p1, p2, val, roots) {
        var a = p0 - 2 * p1 + p2;
        var b = 2 * (p1 - p0);
        var c = p0 - val;
        var n = 0;
        if ($9c7ed07589dafe64$var$isAroundZero(a)) {
            if ($9c7ed07589dafe64$var$isNotAroundZero(b)) {
                var t1 = -c / b;
                if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            }
        } else {
            var disc = b * b - 4 * a * c;
            if ($9c7ed07589dafe64$var$isAroundZero(disc)) {
                var t1 = -b / (2 * a);
                if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            } else if (disc > 0) {
                var discSqrt = $9c7ed07589dafe64$var$mathSqrt(disc);
                var t1 = (-b + discSqrt) / (2 * a);
                var t2 = (-b - discSqrt) / (2 * a);
                if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
                if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
            }
        }
        return n;
    }
    function $9c7ed07589dafe64$export$752e1f8c6e7f7e11(p0, p1, p2) {
        var divider = p0 + p2 - 2 * p1;
        if (divider === 0) return 0.5;
        else return (p0 - p1) / divider;
    }
    function $9c7ed07589dafe64$export$117c659e21a7a060(p0, p1, p2, t, out) {
        var p01 = (p1 - p0) * t + p0;
        var p12 = (p2 - p1) * t + p1;
        var p012 = (p12 - p01) * t + p01;
        out[0] = p0;
        out[1] = p01;
        out[2] = p012;
        out[3] = p012;
        out[4] = p12;
        out[5] = p2;
    }
    function $9c7ed07589dafe64$export$81915a594fe10dee(x0, y0, x1, y1, x2, y2, x, y, out) {
        var t;
        var interval = 0.005;
        var d = Infinity;
        $9c7ed07589dafe64$var$_v0[0] = x;
        $9c7ed07589dafe64$var$_v0[1] = y;
        for(var _t = 0; _t < 1; _t += 0.05){
            $9c7ed07589dafe64$var$_v1[0] = $9c7ed07589dafe64$export$af17094a950f5073(x0, x1, x2, _t);
            $9c7ed07589dafe64$var$_v1[1] = $9c7ed07589dafe64$export$af17094a950f5073(y0, y1, y2, _t);
            var d1 = (0, (0, parcelRequire("eLEew")).distSquare)($9c7ed07589dafe64$var$_v0, $9c7ed07589dafe64$var$_v1);
            if (d1 < d) {
                t = _t;
                d = d1;
            }
        }
        d = Infinity;
        for(var i = 0; i < 32; i++){
            if (interval < $9c7ed07589dafe64$var$EPSILON_NUMERIC) break;
            var prev = t - interval;
            var next = t + interval;
            $9c7ed07589dafe64$var$_v1[0] = $9c7ed07589dafe64$export$af17094a950f5073(x0, x1, x2, prev);
            $9c7ed07589dafe64$var$_v1[1] = $9c7ed07589dafe64$export$af17094a950f5073(y0, y1, y2, prev);
            var d1 = (0, (0, parcelRequire("eLEew")).distSquare)($9c7ed07589dafe64$var$_v1, $9c7ed07589dafe64$var$_v0);
            if (prev >= 0 && d1 < d) {
                t = prev;
                d = d1;
            } else {
                $9c7ed07589dafe64$var$_v2[0] = $9c7ed07589dafe64$export$af17094a950f5073(x0, x1, x2, next);
                $9c7ed07589dafe64$var$_v2[1] = $9c7ed07589dafe64$export$af17094a950f5073(y0, y1, y2, next);
                var d2 = (0, (0, parcelRequire("eLEew")).distSquare)($9c7ed07589dafe64$var$_v2, $9c7ed07589dafe64$var$_v0);
                if (next <= 1 && d2 < d) {
                    t = next;
                    d = d2;
                } else interval *= 0.5;
            }
        }
        if (out) {
            out[0] = $9c7ed07589dafe64$export$af17094a950f5073(x0, x1, x2, t);
            out[1] = $9c7ed07589dafe64$export$af17094a950f5073(y0, y1, y2, t);
        }
        return $9c7ed07589dafe64$var$mathSqrt(d);
    }
    function $9c7ed07589dafe64$export$8a68adee46f3cf55(x0, y0, x1, y1, x2, y2, iteration) {
        var px = x0;
        var py = y0;
        var d = 0;
        var step = 1 / iteration;
        for(var i = 1; i <= iteration; i++){
            var t = i * step;
            var x = $9c7ed07589dafe64$export$af17094a950f5073(x0, x1, x2, t);
            var y = $9c7ed07589dafe64$export$af17094a950f5073(y0, y1, y2, t);
            var dx = x - px;
            var dy = y - py;
            d += Math.sqrt(dx * dx + dy * dy);
            px = x;
            py = y;
        }
        return d;
    }
});
parcelRegister("k3yEY", function(module, exports) {
    $parcel$export(module.exports, "contain", ()=>$e99ef93372091697$export$8893e2b90ba10d92);
    $parcel$export(module.exports, "containStroke", ()=>$e99ef93372091697$export$8d36b1b5d19157c5);
    var $aA4Ws;
    var $1oALq;
    var $bTFCK;
    var $1nzVA;
    var $69jpm;
    var $dr1jo;
    var $3Ytji;
    var $e99ef93372091697$var$CMD = (0, (0, parcelRequire("aA4Ws")).default).CMD;
    var $e99ef93372091697$var$PI2 = Math.PI * 2;
    var $e99ef93372091697$var$EPSILON = 1e-4;
    function $e99ef93372091697$var$isAroundEqual(a, b) {
        return Math.abs(a - b) < $e99ef93372091697$var$EPSILON;
    }
    var $e99ef93372091697$var$roots = [
        -1,
        -1,
        -1
    ];
    var $e99ef93372091697$var$extrema = [
        -1,
        -1
    ];
    function $e99ef93372091697$var$swapExtrema() {
        var tmp = $e99ef93372091697$var$extrema[0];
        $e99ef93372091697$var$extrema[0] = $e99ef93372091697$var$extrema[1];
        $e99ef93372091697$var$extrema[1] = tmp;
    }
    function $e99ef93372091697$var$windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
        if (y > y0 && y > y1 && y > y2 && y > y3 || y < y0 && y < y1 && y < y2 && y < y3) return 0;
        var nRoots = (0, parcelRequire("dr1jo")).cubicRootAt(y0, y1, y2, y3, y, $e99ef93372091697$var$roots);
        if (nRoots === 0) return 0;
        else {
            var w = 0;
            var nExtrema = -1;
            var y0_ = void 0;
            var y1_ = void 0;
            for(var i = 0; i < nRoots; i++){
                var t = $e99ef93372091697$var$roots[i];
                var unit = t === 0 || t === 1 ? 0.5 : 1;
                var x_ = (0, parcelRequire("dr1jo")).cubicAt(x0, x1, x2, x3, t);
                if (x_ < x) continue;
                if (nExtrema < 0) {
                    nExtrema = (0, parcelRequire("dr1jo")).cubicExtrema(y0, y1, y2, y3, $e99ef93372091697$var$extrema);
                    if ($e99ef93372091697$var$extrema[1] < $e99ef93372091697$var$extrema[0] && nExtrema > 1) $e99ef93372091697$var$swapExtrema();
                    y0_ = (0, parcelRequire("dr1jo")).cubicAt(y0, y1, y2, y3, $e99ef93372091697$var$extrema[0]);
                    if (nExtrema > 1) y1_ = (0, parcelRequire("dr1jo")).cubicAt(y0, y1, y2, y3, $e99ef93372091697$var$extrema[1]);
                }
                if (nExtrema === 2) {
                    if (t < $e99ef93372091697$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
                    else if (t < $e99ef93372091697$var$extrema[1]) w += y1_ < y0_ ? unit : -unit;
                    else w += y3 < y1_ ? unit : -unit;
                } else if (t < $e99ef93372091697$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
                else w += y3 < y0_ ? unit : -unit;
            }
            return w;
        }
    }
    function $e99ef93372091697$var$windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
        if (y > y0 && y > y1 && y > y2 || y < y0 && y < y1 && y < y2) return 0;
        var nRoots = (0, parcelRequire("dr1jo")).quadraticRootAt(y0, y1, y2, y, $e99ef93372091697$var$roots);
        if (nRoots === 0) return 0;
        else {
            var t = (0, parcelRequire("dr1jo")).quadraticExtremum(y0, y1, y2);
            if (t >= 0 && t <= 1) {
                var w = 0;
                var y_ = (0, parcelRequire("dr1jo")).quadraticAt(y0, y1, y2, t);
                for(var i = 0; i < nRoots; i++){
                    var unit = $e99ef93372091697$var$roots[i] === 0 || $e99ef93372091697$var$roots[i] === 1 ? 0.5 : 1;
                    var x_ = (0, parcelRequire("dr1jo")).quadraticAt(x0, x1, x2, $e99ef93372091697$var$roots[i]);
                    if (x_ < x) continue;
                    if ($e99ef93372091697$var$roots[i] < t) w += y_ < y0 ? unit : -unit;
                    else w += y2 < y_ ? unit : -unit;
                }
                return w;
            } else {
                var unit = $e99ef93372091697$var$roots[0] === 0 || $e99ef93372091697$var$roots[0] === 1 ? 0.5 : 1;
                var x_ = (0, parcelRequire("dr1jo")).quadraticAt(x0, x1, x2, $e99ef93372091697$var$roots[0]);
                if (x_ < x) return 0;
                return y2 < y0 ? unit : -unit;
            }
        }
    }
    function $e99ef93372091697$var$windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
        y -= cy;
        if (y > r || y < -r) return 0;
        var tmp = Math.sqrt(r * r - y * y);
        $e99ef93372091697$var$roots[0] = -tmp;
        $e99ef93372091697$var$roots[1] = tmp;
        var dTheta = Math.abs(startAngle - endAngle);
        if (dTheta < 1e-4) return 0;
        if (dTheta >= $e99ef93372091697$var$PI2 - 1e-4) {
            startAngle = 0;
            endAngle = $e99ef93372091697$var$PI2;
            var dir = anticlockwise ? 1 : -1;
            if (x >= $e99ef93372091697$var$roots[0] + cx && x <= $e99ef93372091697$var$roots[1] + cx) return dir;
            else return 0;
        }
        if (startAngle > endAngle) {
            var tmp_1 = startAngle;
            startAngle = endAngle;
            endAngle = tmp_1;
        }
        if (startAngle < 0) {
            startAngle += $e99ef93372091697$var$PI2;
            endAngle += $e99ef93372091697$var$PI2;
        }
        var w = 0;
        for(var i = 0; i < 2; i++){
            var x_ = $e99ef93372091697$var$roots[i];
            if (x_ + cx > x) {
                var angle = Math.atan2(y, x_);
                var dir = anticlockwise ? 1 : -1;
                if (angle < 0) angle = $e99ef93372091697$var$PI2 + angle;
                if (angle >= startAngle && angle <= endAngle || angle + $e99ef93372091697$var$PI2 >= startAngle && angle + $e99ef93372091697$var$PI2 <= endAngle) {
                    if (angle > Math.PI / 2 && angle < Math.PI * 1.5) dir = -dir;
                    w += dir;
                }
            }
        }
        return w;
    }
    function $e99ef93372091697$var$containPath(path, lineWidth, isStroke, x, y) {
        var data = path.data;
        var len = path.len();
        var w = 0;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        var x1;
        var y1;
        for(var i = 0; i < len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (cmd === $e99ef93372091697$var$CMD.M && i > 1) {
                if (!isStroke) w += (0, (0, parcelRequire("3Ytji")).default)(xi, yi, x0, y0, x, y);
            }
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            switch(cmd){
                case $e99ef93372091697$var$CMD.M:
                    x0 = data[i++];
                    y0 = data[i++];
                    xi = x0;
                    yi = y0;
                    break;
                case $e99ef93372091697$var$CMD.L:
                    if (isStroke) {
                        if ((0, parcelRequire("1oALq")).containStroke(xi, yi, data[i], data[i + 1], lineWidth, x, y)) return true;
                    } else w += (0, (0, parcelRequire("3Ytji")).default)(xi, yi, data[i], data[i + 1], x, y) || 0;
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $e99ef93372091697$var$CMD.C:
                    if (isStroke) {
                        if ((0, parcelRequire("bTFCK")).containStroke(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                    } else w += $e99ef93372091697$var$windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $e99ef93372091697$var$CMD.Q:
                    if (isStroke) {
                        if ((0, parcelRequire("1nzVA")).containStroke(xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                    } else w += $e99ef93372091697$var$windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $e99ef93372091697$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var theta = data[i++];
                    var dTheta = data[i++];
                    i += 1;
                    var anticlockwise = !!(1 - data[i++]);
                    x1 = Math.cos(theta) * rx + cx;
                    y1 = Math.sin(theta) * ry + cy;
                    if (!isFirst) w += (0, (0, parcelRequire("3Ytji")).default)(xi, yi, x1, y1, x, y);
                    else {
                        x0 = x1;
                        y0 = y1;
                    }
                    var _x = (x - cx) * ry / rx + cx;
                    if (isStroke) {
                        if ((0, parcelRequire("69jpm")).containStroke(cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) return true;
                    } else w += $e99ef93372091697$var$windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
                    xi = Math.cos(theta + dTheta) * rx + cx;
                    yi = Math.sin(theta + dTheta) * ry + cy;
                    break;
                case $e99ef93372091697$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    x1 = x0 + width;
                    y1 = y0 + height;
                    if (isStroke) {
                        if ((0, parcelRequire("1oALq")).containStroke(x0, y0, x1, y0, lineWidth, x, y) || (0, parcelRequire("1oALq")).containStroke(x1, y0, x1, y1, lineWidth, x, y) || (0, parcelRequire("1oALq")).containStroke(x1, y1, x0, y1, lineWidth, x, y) || (0, parcelRequire("1oALq")).containStroke(x0, y1, x0, y0, lineWidth, x, y)) return true;
                    } else {
                        w += (0, (0, parcelRequire("3Ytji")).default)(x1, y0, x1, y1, x, y);
                        w += (0, (0, parcelRequire("3Ytji")).default)(x0, y1, x0, y0, x, y);
                    }
                    break;
                case $e99ef93372091697$var$CMD.Z:
                    if (isStroke) {
                        if ((0, parcelRequire("1oALq")).containStroke(xi, yi, x0, y0, lineWidth, x, y)) return true;
                    } else w += (0, (0, parcelRequire("3Ytji")).default)(xi, yi, x0, y0, x, y);
                    xi = x0;
                    yi = y0;
                    break;
            }
        }
        if (!isStroke && !$e99ef93372091697$var$isAroundEqual(yi, y0)) w += (0, (0, parcelRequire("3Ytji")).default)(xi, yi, x0, y0, x, y) || 0;
        return w !== 0;
    }
    function $e99ef93372091697$export$8893e2b90ba10d92(pathProxy, x, y) {
        return $e99ef93372091697$var$containPath(pathProxy, 0, false, x, y);
    }
    function $e99ef93372091697$export$8d36b1b5d19157c5(pathProxy, lineWidth, x, y) {
        return $e99ef93372091697$var$containPath(pathProxy, lineWidth, true, x, y);
    }
});
parcelRegister("1oALq", function(module, exports) {
    $parcel$export(module.exports, "containStroke", ()=>$10448ce251a929f8$export$8d36b1b5d19157c5);
    function $10448ce251a929f8$export$8d36b1b5d19157c5(x0, y0, x1, y1, lineWidth, x, y) {
        if (lineWidth === 0) return false;
        var _l = lineWidth;
        var _a = 0;
        var _b = x0;
        if (y > y0 + _l && y > y1 + _l || y < y0 - _l && y < y1 - _l || x > x0 + _l && x > x1 + _l || x < x0 - _l && x < x1 - _l) return false;
        if (x0 !== x1) {
            _a = (y0 - y1) / (x0 - x1);
            _b = (x0 * y1 - x1 * y0) / (x0 - x1);
        } else return Math.abs(x - x0) <= _l / 2;
        var tmp = _a * x - y + _b;
        var _s = tmp * tmp / (_a * _a + 1);
        return _s <= _l / 2 * _l / 2;
    }
});
parcelRegister("bTFCK", function(module, exports) {
    $parcel$export(module.exports, "containStroke", ()=>$8a951e6f66d6987a$export$8d36b1b5d19157c5);
    var $dr1jo;
    function $8a951e6f66d6987a$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
        if (lineWidth === 0) return false;
        var _l = lineWidth;
        if (y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l) return false;
        var d = (0, parcelRequire("dr1jo")).cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
        return d <= _l / 2;
    }
});
parcelRegister("1nzVA", function(module, exports) {
    $parcel$export(module.exports, "containStroke", ()=>$1013ceeba79e2375$export$8d36b1b5d19157c5);
    var $dr1jo;
    function $1013ceeba79e2375$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
        if (lineWidth === 0) return false;
        var _l = lineWidth;
        if (y > y0 + _l && y > y1 + _l && y > y2 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l) return false;
        var d = (0, (0, parcelRequire("dr1jo")).quadraticProjectPoint)(x0, y0, x1, y1, x2, y2, x, y, null);
        return d <= _l / 2;
    }
});
parcelRegister("69jpm", function(module, exports) {
    $parcel$export(module.exports, "containStroke", ()=>$47a2a3596d9bac74$export$8d36b1b5d19157c5);
    var $kvt3T;
    var $47a2a3596d9bac74$var$PI2 = Math.PI * 2;
    function $47a2a3596d9bac74$export$8d36b1b5d19157c5(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
        if (lineWidth === 0) return false;
        var _l = lineWidth;
        x -= cx;
        y -= cy;
        var d = Math.sqrt(x * x + y * y);
        if (d - _l > r || d + _l < r) return false;
        if (Math.abs(startAngle - endAngle) % $47a2a3596d9bac74$var$PI2 < 1e-4) return true;
        if (anticlockwise) {
            var tmp = startAngle;
            startAngle = (0, (0, parcelRequire("kvt3T")).normalizeRadian)(endAngle);
            endAngle = (0, (0, parcelRequire("kvt3T")).normalizeRadian)(tmp);
        } else {
            startAngle = (0, (0, parcelRequire("kvt3T")).normalizeRadian)(startAngle);
            endAngle = (0, (0, parcelRequire("kvt3T")).normalizeRadian)(endAngle);
        }
        if (startAngle > endAngle) endAngle += $47a2a3596d9bac74$var$PI2;
        var angle = Math.atan2(y, x);
        if (angle < 0) angle += $47a2a3596d9bac74$var$PI2;
        return angle >= startAngle && angle <= endAngle || angle + $47a2a3596d9bac74$var$PI2 >= startAngle && angle + $47a2a3596d9bac74$var$PI2 <= endAngle;
    }
});
parcelRegister("kvt3T", function(module, exports) {
    $parcel$export(module.exports, "normalizeRadian", ()=>$eedd3ef967ea7890$export$d44861331f213635);
    var $eedd3ef967ea7890$var$PI2 = Math.PI * 2;
    function $eedd3ef967ea7890$export$d44861331f213635(angle) {
        angle %= $eedd3ef967ea7890$var$PI2;
        if (angle < 0) angle += $eedd3ef967ea7890$var$PI2;
        return angle;
    }
});
parcelRegister("3Ytji", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2e4db612d32f7532$export$2e2bcd8739ae039);
    function $2e4db612d32f7532$export$2e2bcd8739ae039(x0, y0, x1, y1, x, y) {
        if (y > y0 && y > y1 || y < y0 && y < y1) return 0;
        if (y1 === y0) return 0;
        var t = (y - y0) / (y1 - y0);
        var dir = y1 < y0 ? 1 : -1;
        if (t === 1 || t === 0) dir = y1 < y0 ? 0.5 : -0.5;
        var x_ = t * (x1 - x0) + x0;
        return x_ === x ? Infinity : x_ > x ? dir : 0;
    }
});
parcelRegister("gcbBH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bca6c53e2dabf533$export$2e2bcd8739ae039);
    var $3VFsf;
    var $lBQ88;
    var $1E3E8;
    var $bahqM;
    var $bca6c53e2dabf533$export$8993f922aeeac642 = (0, (0, parcelRequire("bahqM")).defaults)({
        x: 0,
        y: 0
    }, (0, (0, parcelRequire("lBQ88")).DEFAULT_COMMON_STYLE));
    var $bca6c53e2dabf533$export$4aba8ad70847a488 = {
        style: (0, (0, parcelRequire("bahqM")).defaults)({
            x: true,
            y: true,
            width: true,
            height: true,
            sx: true,
            sy: true,
            sWidth: true,
            sHeight: true
        }, (0, (0, parcelRequire("lBQ88")).DEFAULT_COMMON_ANIMATION_PROPS).style)
    };
    function $bca6c53e2dabf533$var$isImageLike(source) {
        return !!(source && typeof source !== 'string' && source.width && source.height);
    }
    var $bca6c53e2dabf533$var$ZRImage = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ZRImage, _super);
        function ZRImage() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        ZRImage.prototype.createStyle = function(obj) {
            return (0, (0, parcelRequire("bahqM")).createObject)($bca6c53e2dabf533$export$8993f922aeeac642, obj);
        };
        ZRImage.prototype._getSize = function(dim) {
            var style = this.style;
            var size = style[dim];
            if (size != null) return size;
            var imageSource = $bca6c53e2dabf533$var$isImageLike(style.image) ? style.image : this.__image;
            if (!imageSource) return 0;
            var otherDim = dim === 'width' ? 'height' : 'width';
            var otherDimSize = style[otherDim];
            if (otherDimSize == null) return imageSource[dim];
            else return imageSource[dim] / imageSource[otherDim] * otherDimSize;
        };
        ZRImage.prototype.getWidth = function() {
            return this._getSize('width');
        };
        ZRImage.prototype.getHeight = function() {
            return this._getSize('height');
        };
        ZRImage.prototype.getAnimationStyleProps = function() {
            return $bca6c53e2dabf533$export$4aba8ad70847a488;
        };
        ZRImage.prototype.getBoundingRect = function() {
            var style = this.style;
            if (!this._rect) this._rect = new (0, (0, parcelRequire("1E3E8")).default)(style.x || 0, style.y || 0, this.getWidth(), this.getHeight());
            return this._rect;
        };
        return ZRImage;
    }((0, (0, parcelRequire("lBQ88")).default));
    $bca6c53e2dabf533$var$ZRImage.prototype.type = 'image';
    var $bca6c53e2dabf533$export$2e2bcd8739ae039 = $bca6c53e2dabf533$var$ZRImage;
});
parcelRegister("7Tw7u", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5bf695c646bd738a$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $7AySl;
    var $2az2p;
    var $5bf695c646bd738a$export$51140d6b71bb4ed5 = function() {
        function RectShape() {
            this.x = 0;
            this.y = 0;
            this.width = 0;
            this.height = 0;
        }
        return RectShape;
    }();
    var $5bf695c646bd738a$var$subPixelOptimizeOutputShape = {};
    var $5bf695c646bd738a$var$Rect = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Rect, _super);
        function Rect(opts) {
            return _super.call(this, opts) || this;
        }
        Rect.prototype.getDefaultShape = function() {
            return new $5bf695c646bd738a$export$51140d6b71bb4ed5();
        };
        Rect.prototype.buildPath = function(ctx, shape) {
            var x;
            var y;
            var width;
            var height;
            if (this.subPixelOptimize) {
                var optimizedShape = (0, (0, parcelRequire("2az2p")).subPixelOptimizeRect)($5bf695c646bd738a$var$subPixelOptimizeOutputShape, shape, this.style);
                x = optimizedShape.x;
                y = optimizedShape.y;
                width = optimizedShape.width;
                height = optimizedShape.height;
                optimizedShape.r = shape.r;
                shape = optimizedShape;
            } else {
                x = shape.x;
                y = shape.y;
                width = shape.width;
                height = shape.height;
            }
            if (!shape.r) ctx.rect(x, y, width, height);
            else (0, parcelRequire("7AySl")).buildPath(ctx, shape);
        };
        Rect.prototype.isZeroArea = function() {
            return !this.shape.width || !this.shape.height;
        };
        return Rect;
    }((0, (0, parcelRequire("ghQ8v")).default));
    $5bf695c646bd738a$var$Rect.prototype.type = 'rect';
    var $5bf695c646bd738a$export$2e2bcd8739ae039 = $5bf695c646bd738a$var$Rect;
});
parcelRegister("7AySl", function(module, exports) {
    $parcel$export(module.exports, "buildPath", ()=>$5866f2ba314594b2$export$5cc7f731b5937e99);
    function $5866f2ba314594b2$export$5cc7f731b5937e99(ctx, shape) {
        var x = shape.x;
        var y = shape.y;
        var width = shape.width;
        var height = shape.height;
        var r = shape.r;
        var r1;
        var r2;
        var r3;
        var r4;
        if (width < 0) {
            x = x + width;
            width = -width;
        }
        if (height < 0) {
            y = y + height;
            height = -height;
        }
        if (typeof r === 'number') r1 = r2 = r3 = r4 = r;
        else if (r instanceof Array) {
            if (r.length === 1) r1 = r2 = r3 = r4 = r[0];
            else if (r.length === 2) {
                r1 = r3 = r[0];
                r2 = r4 = r[1];
            } else if (r.length === 3) {
                r1 = r[0];
                r2 = r4 = r[1];
                r3 = r[2];
            } else {
                r1 = r[0];
                r2 = r[1];
                r3 = r[2];
                r4 = r[3];
            }
        } else r1 = r2 = r3 = r4 = 0;
        var total;
        if (r1 + r2 > width) {
            total = r1 + r2;
            r1 *= width / total;
            r2 *= width / total;
        }
        if (r3 + r4 > width) {
            total = r3 + r4;
            r3 *= width / total;
            r4 *= width / total;
        }
        if (r2 + r3 > height) {
            total = r2 + r3;
            r2 *= height / total;
            r3 *= height / total;
        }
        if (r1 + r4 > height) {
            total = r1 + r4;
            r1 *= height / total;
            r4 *= height / total;
        }
        ctx.moveTo(x + r1, y);
        ctx.lineTo(x + width - r2, y);
        r2 !== 0 && ctx.arc(x + width - r2, y + r2, r2, -Math.PI / 2, 0);
        ctx.lineTo(x + width, y + height - r3);
        r3 !== 0 && ctx.arc(x + width - r3, y + height - r3, r3, 0, Math.PI / 2);
        ctx.lineTo(x + r4, y + height);
        r4 !== 0 && ctx.arc(x + r4, y + height - r4, r4, Math.PI / 2, Math.PI);
        ctx.lineTo(x, y + r1);
        r1 !== 0 && ctx.arc(x + r1, y + r1, r1, Math.PI, Math.PI * 1.5);
    }
});
parcelRegister("2az2p", function(module, exports) {
    $parcel$export(module.exports, "subPixelOptimizeLine", ()=>$1947b1c1b6b500f1$export$8b4b620d7f4aad1b);
    $parcel$export(module.exports, "subPixelOptimize", ()=>$1947b1c1b6b500f1$export$72c4fd4c1b8fcb10);
    $parcel$export(module.exports, "subPixelOptimizeRect", ()=>$1947b1c1b6b500f1$export$60e2aa74957d0b9d);
    var $1947b1c1b6b500f1$var$round = Math.round;
    function $1947b1c1b6b500f1$export$8b4b620d7f4aad1b(outputShape, inputShape, style) {
        if (!inputShape) return;
        var x1 = inputShape.x1;
        var x2 = inputShape.x2;
        var y1 = inputShape.y1;
        var y2 = inputShape.y2;
        outputShape.x1 = x1;
        outputShape.x2 = x2;
        outputShape.y1 = y1;
        outputShape.y2 = y2;
        var lineWidth = style && style.lineWidth;
        if (!lineWidth) return outputShape;
        if ($1947b1c1b6b500f1$var$round(x1 * 2) === $1947b1c1b6b500f1$var$round(x2 * 2)) outputShape.x1 = outputShape.x2 = $1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(x1, lineWidth, true);
        if ($1947b1c1b6b500f1$var$round(y1 * 2) === $1947b1c1b6b500f1$var$round(y2 * 2)) outputShape.y1 = outputShape.y2 = $1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(y1, lineWidth, true);
        return outputShape;
    }
    function $1947b1c1b6b500f1$export$60e2aa74957d0b9d(outputShape, inputShape, style) {
        if (!inputShape) return;
        var originX = inputShape.x;
        var originY = inputShape.y;
        var originWidth = inputShape.width;
        var originHeight = inputShape.height;
        outputShape.x = originX;
        outputShape.y = originY;
        outputShape.width = originWidth;
        outputShape.height = originHeight;
        var lineWidth = style && style.lineWidth;
        if (!lineWidth) return outputShape;
        outputShape.x = $1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(originX, lineWidth, true);
        outputShape.y = $1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(originY, lineWidth, true);
        outputShape.width = Math.max($1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(originX + originWidth, lineWidth, false) - outputShape.x, originWidth === 0 ? 0 : 1);
        outputShape.height = Math.max($1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(originY + originHeight, lineWidth, false) - outputShape.y, originHeight === 0 ? 0 : 1);
        return outputShape;
    }
    function $1947b1c1b6b500f1$export$72c4fd4c1b8fcb10(position, lineWidth, positiveOrNegative) {
        if (!lineWidth) return position;
        var doubledPosition = $1947b1c1b6b500f1$var$round(position * 2);
        return (doubledPosition + $1947b1c1b6b500f1$var$round(lineWidth)) % 2 === 0 ? doubledPosition / 2 : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
    }
});
parcelRegister("fIXXx", function(module, exports) {
    $parcel$export(module.exports, "HOVER_STATE_BLUR", ()=>$b72979b7cd946cce$export$1307d6a87d56baa);
    $parcel$export(module.exports, "HOVER_STATE_EMPHASIS", ()=>$b72979b7cd946cce$export$f0f2bee145debb31);
    $parcel$export(module.exports, "SPECIAL_STATES", ()=>$b72979b7cd946cce$export$151308dceb52d5b);
    $parcel$export(module.exports, "DISPLAY_STATES", ()=>$b72979b7cd946cce$export$57ee5306b85ad7d5);
    $parcel$export(module.exports, "Z2_EMPHASIS_LIFT", ()=>$b72979b7cd946cce$export$1cb9fc6ed5b9836c);
    $parcel$export(module.exports, "HIGHLIGHT_ACTION_TYPE", ()=>$b72979b7cd946cce$export$df035d873a9de64f);
    $parcel$export(module.exports, "DOWNPLAY_ACTION_TYPE", ()=>$b72979b7cd946cce$export$f8a2f7807cc185ea);
    $parcel$export(module.exports, "SELECT_ACTION_TYPE", ()=>$b72979b7cd946cce$export$89616263e7d38fe9);
    $parcel$export(module.exports, "UNSELECT_ACTION_TYPE", ()=>$b72979b7cd946cce$export$7636ad95c0f68a79);
    $parcel$export(module.exports, "TOGGLE_SELECT_ACTION_TYPE", ()=>$b72979b7cd946cce$export$1e90ed8a25542516);
    $parcel$export(module.exports, "setStatesFlag", ()=>$b72979b7cd946cce$export$868ba38adffa9e39);
    $parcel$export(module.exports, "setDefaultStateProxy", ()=>$b72979b7cd946cce$export$20f39bbe322fb9ab);
    $parcel$export(module.exports, "enterEmphasis", ()=>$b72979b7cd946cce$export$b2d02638cc34c042);
    $parcel$export(module.exports, "leaveEmphasis", ()=>$b72979b7cd946cce$export$11be6f716239ac55);
    $parcel$export(module.exports, "enterBlur", ()=>$b72979b7cd946cce$export$207f9cb3e1099375);
    $parcel$export(module.exports, "leaveBlur", ()=>$b72979b7cd946cce$export$fd4a9ec75456d3c1);
    $parcel$export(module.exports, "enterSelect", ()=>$b72979b7cd946cce$export$252d028dda8ef765);
    $parcel$export(module.exports, "leaveSelect", ()=>$b72979b7cd946cce$export$ea9a904bd6e32bd3);
    $parcel$export(module.exports, "allLeaveBlur", ()=>$b72979b7cd946cce$export$b2a593c7b5243584);
    $parcel$export(module.exports, "blurComponent", ()=>$b72979b7cd946cce$export$569da03256c8a55f);
    $parcel$export(module.exports, "blurSeriesFromHighlightPayload", ()=>$b72979b7cd946cce$export$64f1fd4daefef21b);
    $parcel$export(module.exports, "findComponentHighDownDispatchers", ()=>$b72979b7cd946cce$export$f31a644ccca0ef23);
    $parcel$export(module.exports, "handleGlobalMouseOverForHighDown", ()=>$b72979b7cd946cce$export$416765b6198234ff);
    $parcel$export(module.exports, "handleGlboalMouseOutForHighDown", ()=>$b72979b7cd946cce$export$2cbc9e6f4b583c84);
    $parcel$export(module.exports, "toggleSelectionFromPayload", ()=>$b72979b7cd946cce$export$1c7d489f62372d73);
    $parcel$export(module.exports, "isSelectChangePayload", ()=>$b72979b7cd946cce$export$72aea10e60e45351);
    $parcel$export(module.exports, "updateSeriesElementSelection", ()=>$b72979b7cd946cce$export$e4ea08ef52e0a73);
    $parcel$export(module.exports, "getAllSelectedIndices", ()=>$b72979b7cd946cce$export$c529643b619af6b3);
    $parcel$export(module.exports, "enableHoverEmphasis", ()=>$b72979b7cd946cce$export$5f393df0b5aee2e7);
    $parcel$export(module.exports, "setAsHighDownDispatcher", ()=>$b72979b7cd946cce$export$9ba15aea1e048d48);
    $parcel$export(module.exports, "enableHoverFocus", ()=>$b72979b7cd946cce$export$24972466b2b62ac2);
    $parcel$export(module.exports, "setStatesStylesFromModel", ()=>$b72979b7cd946cce$export$48b68047d330bbc9);
    $parcel$export(module.exports, "isHighDownDispatcher", ()=>$b72979b7cd946cce$export$77d1445f699c58b5);
    $parcel$export(module.exports, "enableComponentHighDownFeatures", ()=>$b72979b7cd946cce$export$4da05a9639f01954);
    $parcel$export(module.exports, "getHighlightDigit", ()=>$b72979b7cd946cce$export$824af40eb714530d);
    $parcel$export(module.exports, "isHighDownPayload", ()=>$b72979b7cd946cce$export$aebe71265c1b77bf);
    $parcel$export(module.exports, "savePathStates", ()=>$b72979b7cd946cce$export$9fe78019e6f395b6);
    var $h4RuA;
    var $bahqM;
    var $7QjoM;
    var $d6udH;
    var $eaKsF;
    var $ghQ8v;
    var $b72979b7cd946cce$var$_highlightNextDigit = 1;
    var $b72979b7cd946cce$var$_highlightKeyMap = {};
    var $b72979b7cd946cce$var$getSavedStates = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $b72979b7cd946cce$export$5542daa30722333e = 0;
    var $b72979b7cd946cce$export$1307d6a87d56baa = 1;
    var $b72979b7cd946cce$export$f0f2bee145debb31 = 2;
    var $b72979b7cd946cce$export$151308dceb52d5b = [
        'emphasis',
        'blur',
        'select'
    ];
    var $b72979b7cd946cce$export$57ee5306b85ad7d5 = [
        'normal',
        'emphasis',
        'blur',
        'select'
    ];
    var $b72979b7cd946cce$export$1cb9fc6ed5b9836c = 10;
    var $b72979b7cd946cce$export$3a2f97d39514bbc = 9;
    var $b72979b7cd946cce$export$df035d873a9de64f = 'highlight';
    var $b72979b7cd946cce$export$f8a2f7807cc185ea = 'downplay';
    var $b72979b7cd946cce$export$89616263e7d38fe9 = 'select';
    var $b72979b7cd946cce$export$7636ad95c0f68a79 = 'unselect';
    var $b72979b7cd946cce$export$1e90ed8a25542516 = 'toggleSelect';
    function $b72979b7cd946cce$var$hasFillOrStroke(fillOrStroke) {
        return fillOrStroke != null && fillOrStroke !== 'none';
    }
    var $b72979b7cd946cce$var$liftedColorCache = new (0, (0, parcelRequire("h4RuA")).default)(100);
    function $b72979b7cd946cce$var$liftColor(color) {
        if (typeof color !== 'string') return color;
        var liftedColor = $b72979b7cd946cce$var$liftedColorCache.get(color);
        if (!liftedColor) {
            liftedColor = (0, parcelRequire("d6udH")).lift(color, -0.1);
            $b72979b7cd946cce$var$liftedColorCache.put(color, liftedColor);
        }
        return liftedColor;
    }
    function $b72979b7cd946cce$var$doChangeHoverState(el, stateName, hoverStateEnum) {
        if (el.onHoverStateChange && (el.hoverState || 0) !== hoverStateEnum) el.onHoverStateChange(stateName);
        el.hoverState = hoverStateEnum;
    }
    function $b72979b7cd946cce$var$singleEnterEmphasis(el) {
        $b72979b7cd946cce$var$doChangeHoverState(el, 'emphasis', $b72979b7cd946cce$export$f0f2bee145debb31);
    }
    function $b72979b7cd946cce$var$singleLeaveEmphasis(el) {
        if (el.hoverState === $b72979b7cd946cce$export$f0f2bee145debb31) $b72979b7cd946cce$var$doChangeHoverState(el, 'normal', $b72979b7cd946cce$export$5542daa30722333e);
    }
    function $b72979b7cd946cce$var$singleEnterBlur(el) {
        $b72979b7cd946cce$var$doChangeHoverState(el, 'blur', $b72979b7cd946cce$export$1307d6a87d56baa);
    }
    function $b72979b7cd946cce$var$singleLeaveBlur(el) {
        if (el.hoverState === $b72979b7cd946cce$export$1307d6a87d56baa) $b72979b7cd946cce$var$doChangeHoverState(el, 'normal', $b72979b7cd946cce$export$5542daa30722333e);
    }
    function $b72979b7cd946cce$var$singleEnterSelect(el) {
        el.selected = true;
    }
    function $b72979b7cd946cce$var$singleLeaveSelect(el) {
        el.selected = false;
    }
    function $b72979b7cd946cce$var$updateElementState(el, updater, commonParam) {
        updater(el, commonParam);
    }
    function $b72979b7cd946cce$var$traverseUpdateState(el, updater, commonParam) {
        $b72979b7cd946cce$var$updateElementState(el, updater, commonParam);
        el.isGroup && el.traverse(function(child) {
            $b72979b7cd946cce$var$updateElementState(child, updater, commonParam);
        });
    }
    function $b72979b7cd946cce$export$868ba38adffa9e39(el, stateName) {
        switch(stateName){
            case 'emphasis':
                el.hoverState = $b72979b7cd946cce$export$f0f2bee145debb31;
                break;
            case 'normal':
                el.hoverState = $b72979b7cd946cce$export$5542daa30722333e;
                break;
            case 'blur':
                el.hoverState = $b72979b7cd946cce$export$1307d6a87d56baa;
                break;
            case 'select':
                el.selected = true;
        }
    }
    function $b72979b7cd946cce$export$35330f949342a669(el) {
        if (el.isGroup) el.traverse(function(child) {
            child.clearStates();
        });
        else el.clearStates();
    }
    function $b72979b7cd946cce$var$getFromStateStyle(el, props, toStateName, defaultValue) {
        var style = el.style;
        var fromState = {};
        for(var i = 0; i < props.length; i++){
            var propName = props[i];
            var val = style[propName];
            fromState[propName] = val == null ? defaultValue && defaultValue[propName] : val;
        }
        for(var i = 0; i < el.animators.length; i++){
            var animator = el.animators[i];
            if (animator.__fromStateTransition && animator.__fromStateTransition.indexOf(toStateName) < 0 && animator.targetName === 'style') animator.saveFinalToTarget(fromState, props);
        }
        return fromState;
    }
    function $b72979b7cd946cce$var$createEmphasisDefaultState(el, stateName, targetStates, state) {
        var hasSelect = targetStates && (0, (0, parcelRequire("bahqM")).indexOf)(targetStates, 'select') >= 0;
        var cloned = false;
        if (el instanceof (0, (0, parcelRequire("ghQ8v")).default)) {
            var store = $b72979b7cd946cce$var$getSavedStates(el);
            var fromFill = hasSelect ? store.selectFill || store.normalFill : store.normalFill;
            var fromStroke = hasSelect ? store.selectStroke || store.normalStroke : store.normalStroke;
            if ($b72979b7cd946cce$var$hasFillOrStroke(fromFill) || $b72979b7cd946cce$var$hasFillOrStroke(fromStroke)) {
                state = state || {};
                var emphasisStyle = state.style || {};
                if (emphasisStyle.fill === 'inherit') {
                    cloned = true;
                    state = (0, (0, parcelRequire("bahqM")).extend)({}, state);
                    emphasisStyle = (0, (0, parcelRequire("bahqM")).extend)({}, emphasisStyle);
                    emphasisStyle.fill = fromFill;
                } else if (!$b72979b7cd946cce$var$hasFillOrStroke(emphasisStyle.fill) && $b72979b7cd946cce$var$hasFillOrStroke(fromFill)) {
                    cloned = true;
                    state = (0, (0, parcelRequire("bahqM")).extend)({}, state);
                    emphasisStyle = (0, (0, parcelRequire("bahqM")).extend)({}, emphasisStyle);
                    emphasisStyle.fill = $b72979b7cd946cce$var$liftColor(fromFill);
                } else if (!$b72979b7cd946cce$var$hasFillOrStroke(emphasisStyle.stroke) && $b72979b7cd946cce$var$hasFillOrStroke(fromStroke)) {
                    if (!cloned) {
                        state = (0, (0, parcelRequire("bahqM")).extend)({}, state);
                        emphasisStyle = (0, (0, parcelRequire("bahqM")).extend)({}, emphasisStyle);
                    }
                    emphasisStyle.stroke = $b72979b7cd946cce$var$liftColor(fromStroke);
                }
                state.style = emphasisStyle;
            }
        }
        if (state) {
            if (state.z2 == null) {
                if (!cloned) state = (0, (0, parcelRequire("bahqM")).extend)({}, state);
                var z2EmphasisLift = el.z2EmphasisLift;
                state.z2 = el.z2 + (z2EmphasisLift != null ? z2EmphasisLift : $b72979b7cd946cce$export$1cb9fc6ed5b9836c);
            }
        }
        return state;
    }
    function $b72979b7cd946cce$var$createSelectDefaultState(el, stateName, state) {
        if (state) {
            if (state.z2 == null) {
                state = (0, (0, parcelRequire("bahqM")).extend)({}, state);
                var z2SelectLift = el.z2SelectLift;
                state.z2 = el.z2 + (z2SelectLift != null ? z2SelectLift : $b72979b7cd946cce$export$3a2f97d39514bbc);
            }
        }
        return state;
    }
    function $b72979b7cd946cce$var$createBlurDefaultState(el, stateName, state) {
        var hasBlur = (0, (0, parcelRequire("bahqM")).indexOf)(el.currentStates, stateName) >= 0;
        var currentOpacity = el.style.opacity;
        var fromState = !hasBlur ? $b72979b7cd946cce$var$getFromStateStyle(el, [
            'opacity'
        ], stateName, {
            opacity: 1
        }) : null;
        state = state || {};
        var blurStyle = state.style || {};
        if (blurStyle.opacity == null) {
            state = (0, (0, parcelRequire("bahqM")).extend)({}, state);
            blurStyle = (0, (0, parcelRequire("bahqM")).extend)({
                opacity: hasBlur ? currentOpacity : fromState.opacity * 0.1
            }, blurStyle);
            state.style = blurStyle;
        }
        return state;
    }
    function $b72979b7cd946cce$var$elementStateProxy(stateName, targetStates) {
        var state = this.states[stateName];
        if (this.style) {
            if (stateName === 'emphasis') return $b72979b7cd946cce$var$createEmphasisDefaultState(this, stateName, targetStates, state);
            else if (stateName === 'blur') return $b72979b7cd946cce$var$createBlurDefaultState(this, stateName, state);
            else if (stateName === 'select') return $b72979b7cd946cce$var$createSelectDefaultState(this, stateName, state);
        }
        return state;
    }
    function $b72979b7cd946cce$export$20f39bbe322fb9ab(el) {
        el.stateProxy = $b72979b7cd946cce$var$elementStateProxy;
        var textContent = el.getTextContent();
        var textGuide = el.getTextGuideLine();
        if (textContent) textContent.stateProxy = $b72979b7cd946cce$var$elementStateProxy;
        if (textGuide) textGuide.stateProxy = $b72979b7cd946cce$var$elementStateProxy;
    }
    function $b72979b7cd946cce$export$d899507e2598e4ae(el, e) {
        !$b72979b7cd946cce$var$shouldSilent(el, e) && !el.__highByOuter && $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleEnterEmphasis);
    }
    function $b72979b7cd946cce$export$784cba1f7fe58cca(el, e) {
        !$b72979b7cd946cce$var$shouldSilent(el, e) && !el.__highByOuter && $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleLeaveEmphasis);
    }
    function $b72979b7cd946cce$export$b2d02638cc34c042(el, highlightDigit) {
        el.__highByOuter |= 1 << (highlightDigit || 0);
        $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleEnterEmphasis);
    }
    function $b72979b7cd946cce$export$11be6f716239ac55(el, highlightDigit) {
        !(el.__highByOuter &= ~(1 << (highlightDigit || 0))) && $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleLeaveEmphasis);
    }
    function $b72979b7cd946cce$export$207f9cb3e1099375(el) {
        $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleEnterBlur);
    }
    function $b72979b7cd946cce$export$fd4a9ec75456d3c1(el) {
        $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleLeaveBlur);
    }
    function $b72979b7cd946cce$export$252d028dda8ef765(el) {
        $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleEnterSelect);
    }
    function $b72979b7cd946cce$export$ea9a904bd6e32bd3(el) {
        $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$var$singleLeaveSelect);
    }
    function $b72979b7cd946cce$var$shouldSilent(el, e) {
        return el.__highDownSilentOnTouch && e.zrByTouch;
    }
    function $b72979b7cd946cce$export$b2a593c7b5243584(api) {
        var model = api.getModel();
        model.eachComponent(function(componentType, componentModel) {
            var view = componentType === 'series' ? api.getViewOfSeriesModel(componentModel) : api.getViewOfComponentModel(componentModel);
            view.group.traverse(function(child) {
                $b72979b7cd946cce$var$singleLeaveBlur(child);
            });
        });
    }
    function $b72979b7cd946cce$export$7d399e067d6552e3(targetSeriesIndex, focus, blurScope, api) {
        var ecModel = api.getModel();
        blurScope = blurScope || 'coordinateSystem';
        function leaveBlurOfIndices(data, dataIndices) {
            for(var i = 0; i < dataIndices.length; i++){
                var itemEl = data.getItemGraphicEl(dataIndices[i]);
                itemEl && $b72979b7cd946cce$export$fd4a9ec75456d3c1(itemEl);
            }
        }
        if (targetSeriesIndex == null) return;
        if (!focus || focus === 'none') return;
        var targetSeriesModel = ecModel.getSeriesByIndex(targetSeriesIndex);
        var targetCoordSys = targetSeriesModel.coordinateSystem;
        if (targetCoordSys && targetCoordSys.master) targetCoordSys = targetCoordSys.master;
        var blurredSeries = [];
        ecModel.eachSeries(function(seriesModel) {
            var sameSeries = targetSeriesModel === seriesModel;
            var coordSys = seriesModel.coordinateSystem;
            if (coordSys && coordSys.master) coordSys = coordSys.master;
            var sameCoordSys = coordSys && targetCoordSys ? coordSys === targetCoordSys : sameSeries;
            if (!(blurScope === 'series' && !sameSeries || blurScope === 'coordinateSystem' && !sameCoordSys || focus === 'series' && sameSeries)) {
                var view = api.getViewOfSeriesModel(seriesModel);
                view.group.traverse(function(child) {
                    $b72979b7cd946cce$var$singleEnterBlur(child);
                });
                if ((0, (0, parcelRequire("bahqM")).isArrayLike)(focus)) leaveBlurOfIndices(seriesModel.getData(), focus);
                else if ((0, (0, parcelRequire("bahqM")).isObject)(focus)) {
                    var dataTypes = (0, (0, parcelRequire("bahqM")).keys)(focus);
                    for(var d = 0; d < dataTypes.length; d++)leaveBlurOfIndices(seriesModel.getData(dataTypes[d]), focus[dataTypes[d]]);
                }
                blurredSeries.push(seriesModel);
            }
        });
        ecModel.eachComponent(function(componentType, componentModel) {
            if (componentType === 'series') return;
            var view = api.getViewOfComponentModel(componentModel);
            if (view && view.blurSeries) view.blurSeries(blurredSeries, ecModel);
        });
    }
    function $b72979b7cd946cce$export$569da03256c8a55f(componentMainType, componentIndex, api) {
        if (componentMainType == null || componentIndex == null) return;
        var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
        if (!componentModel) return;
        var view = api.getViewOfComponentModel(componentModel);
        if (!view || !view.focusBlurEnabled) return;
        view.group.traverse(function(child) {
            $b72979b7cd946cce$var$singleEnterBlur(child);
        });
    }
    function $b72979b7cd946cce$export$64f1fd4daefef21b(seriesModel, payload, api) {
        var seriesIndex = seriesModel.seriesIndex;
        var data = seriesModel.getData(payload.dataType);
        var dataIndex = (0, (0, parcelRequire("eaKsF")).queryDataIndex)(data, payload);
        dataIndex = ((0, (0, parcelRequire("bahqM")).isArray)(dataIndex) ? dataIndex[0] : dataIndex) || 0;
        var el = data.getItemGraphicEl(dataIndex);
        if (!el) {
            var count = data.count();
            var current = 0;
            while(!el && current < count)el = data.getItemGraphicEl(current++);
        }
        if (el) {
            var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(el);
            $b72979b7cd946cce$export$7d399e067d6552e3(seriesIndex, ecData.focus, ecData.blurScope, api);
        } else {
            var focus_1 = seriesModel.get([
                'emphasis',
                'focus'
            ]);
            var blurScope = seriesModel.get([
                'emphasis',
                'blurScope'
            ]);
            if (focus_1 != null) $b72979b7cd946cce$export$7d399e067d6552e3(seriesIndex, focus_1, blurScope, api);
        }
    }
    function $b72979b7cd946cce$export$f31a644ccca0ef23(componentMainType, componentIndex, name, api) {
        var ret = {
            focusSelf: false,
            dispatchers: null
        };
        if (componentMainType == null || componentMainType === 'series' || componentIndex == null || name == null) return ret;
        var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
        if (!componentModel) return ret;
        var view = api.getViewOfComponentModel(componentModel);
        if (!view || !view.findHighDownDispatchers) return ret;
        var dispatchers = view.findHighDownDispatchers(name);
        var focusSelf;
        for(var i = 0; i < dispatchers.length; i++)if ((0, (0, parcelRequire("7QjoM")).getECData)(dispatchers[i]).focus === 'self') {
            focusSelf = true;
            break;
        }
        return {
            focusSelf: focusSelf,
            dispatchers: dispatchers
        };
    }
    function $b72979b7cd946cce$export$416765b6198234ff(dispatcher, e, api) {
        var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(dispatcher);
        var _a = $b72979b7cd946cce$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api), dispatchers = _a.dispatchers, focusSelf = _a.focusSelf;
        if (dispatchers) {
            if (focusSelf) $b72979b7cd946cce$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
            (0, (0, parcelRequire("bahqM")).each)(dispatchers, function(dispatcher) {
                return $b72979b7cd946cce$export$d899507e2598e4ae(dispatcher, e);
            });
        } else {
            $b72979b7cd946cce$export$7d399e067d6552e3(ecData.seriesIndex, ecData.focus, ecData.blurScope, api);
            if (ecData.focus === 'self') $b72979b7cd946cce$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
            $b72979b7cd946cce$export$d899507e2598e4ae(dispatcher, e);
        }
    }
    function $b72979b7cd946cce$export$2cbc9e6f4b583c84(dispatcher, e, api) {
        $b72979b7cd946cce$export$b2a593c7b5243584(api);
        var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(dispatcher);
        var dispatchers = $b72979b7cd946cce$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api).dispatchers;
        if (dispatchers) (0, (0, parcelRequire("bahqM")).each)(dispatchers, function(dispatcher) {
            return $b72979b7cd946cce$export$784cba1f7fe58cca(dispatcher, e);
        });
        else $b72979b7cd946cce$export$784cba1f7fe58cca(dispatcher, e);
    }
    function $b72979b7cd946cce$export$1c7d489f62372d73(seriesModel, payload, api) {
        if (!$b72979b7cd946cce$export$72aea10e60e45351(payload)) return;
        var dataType = payload.dataType;
        var data = seriesModel.getData(dataType);
        var dataIndex = (0, (0, parcelRequire("eaKsF")).queryDataIndex)(data, payload);
        if (!(0, (0, parcelRequire("bahqM")).isArray)(dataIndex)) dataIndex = [
            dataIndex
        ];
        seriesModel[payload.type === $b72979b7cd946cce$export$1e90ed8a25542516 ? 'toggleSelect' : payload.type === $b72979b7cd946cce$export$89616263e7d38fe9 ? 'select' : 'unselect'](dataIndex, dataType);
    }
    function $b72979b7cd946cce$export$e4ea08ef52e0a73(seriesModel) {
        var allData = seriesModel.getAllData();
        (0, (0, parcelRequire("bahqM")).each)(allData, function(_a) {
            var data = _a.data, type = _a.type;
            data.eachItemGraphicEl(function(el, idx) {
                seriesModel.isSelected(idx, type) ? $b72979b7cd946cce$export$252d028dda8ef765(el) : $b72979b7cd946cce$export$ea9a904bd6e32bd3(el);
            });
        });
    }
    function $b72979b7cd946cce$export$c529643b619af6b3(ecModel) {
        var ret = [];
        ecModel.eachSeries(function(seriesModel) {
            var allData = seriesModel.getAllData();
            (0, (0, parcelRequire("bahqM")).each)(allData, function(_a) {
                var data = _a.data, type = _a.type;
                var dataIndices = seriesModel.getSelectedDataIndices();
                if (dataIndices.length > 0) {
                    var item = {
                        dataIndex: dataIndices,
                        seriesIndex: seriesModel.seriesIndex
                    };
                    if (type != null) item.dataType = type;
                    ret.push(item);
                }
            });
        });
        return ret;
    }
    function $b72979b7cd946cce$export$5f393df0b5aee2e7(el, focus, blurScope) {
        $b72979b7cd946cce$export$9ba15aea1e048d48(el, true);
        $b72979b7cd946cce$var$traverseUpdateState(el, $b72979b7cd946cce$export$20f39bbe322fb9ab);
        $b72979b7cd946cce$export$24972466b2b62ac2(el, focus, blurScope);
    }
    function $b72979b7cd946cce$export$24972466b2b62ac2(el, focus, blurScope) {
        var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(el);
        if (focus != null) {
            ecData.focus = focus;
            ecData.blurScope = blurScope;
        } else if (ecData.focus) ecData.focus = null;
    }
    var $b72979b7cd946cce$var$OTHER_STATES = [
        'emphasis',
        'blur',
        'select'
    ];
    var $b72979b7cd946cce$var$defaultStyleGetterMap = {
        itemStyle: 'getItemStyle',
        lineStyle: 'getLineStyle',
        areaStyle: 'getAreaStyle'
    };
    function $b72979b7cd946cce$export$48b68047d330bbc9(el, itemModel, styleType, getter) {
        styleType = styleType || 'itemStyle';
        for(var i = 0; i < $b72979b7cd946cce$var$OTHER_STATES.length; i++){
            var stateName = $b72979b7cd946cce$var$OTHER_STATES[i];
            var model = itemModel.getModel([
                stateName,
                styleType
            ]);
            var state = el.ensureState(stateName);
            state.style = getter ? getter(model) : model[$b72979b7cd946cce$var$defaultStyleGetterMap[styleType]]();
        }
    }
    function $b72979b7cd946cce$export$9ba15aea1e048d48(el, asDispatcher) {
        var disable = asDispatcher === false;
        var extendedEl = el;
        if (el.highDownSilentOnTouch) extendedEl.__highDownSilentOnTouch = el.highDownSilentOnTouch;
        if (!disable || extendedEl.__highDownDispatcher) {
            extendedEl.__highByOuter = extendedEl.__highByOuter || 0;
            extendedEl.__highDownDispatcher = !disable;
        }
    }
    function $b72979b7cd946cce$export$77d1445f699c58b5(el) {
        return !!(el && el.__highDownDispatcher);
    }
    function $b72979b7cd946cce$export$4da05a9639f01954(el, componentModel, componentHighDownName) {
        var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(el);
        ecData.componentMainType = componentModel.mainType;
        ecData.componentIndex = componentModel.componentIndex;
        ecData.componentHighDownName = componentHighDownName;
    }
    function $b72979b7cd946cce$export$824af40eb714530d(highlightKey) {
        var highlightDigit = $b72979b7cd946cce$var$_highlightKeyMap[highlightKey];
        if (highlightDigit == null && $b72979b7cd946cce$var$_highlightNextDigit <= 32) highlightDigit = $b72979b7cd946cce$var$_highlightKeyMap[highlightKey] = $b72979b7cd946cce$var$_highlightNextDigit++;
        return highlightDigit;
    }
    function $b72979b7cd946cce$export$72aea10e60e45351(payload) {
        var payloadType = payload.type;
        return payloadType === $b72979b7cd946cce$export$89616263e7d38fe9 || payloadType === $b72979b7cd946cce$export$7636ad95c0f68a79 || payloadType === $b72979b7cd946cce$export$1e90ed8a25542516;
    }
    function $b72979b7cd946cce$export$aebe71265c1b77bf(payload) {
        var payloadType = payload.type;
        return payloadType === $b72979b7cd946cce$export$df035d873a9de64f || payloadType === $b72979b7cd946cce$export$f8a2f7807cc185ea;
    }
    function $b72979b7cd946cce$export$9fe78019e6f395b6(el) {
        var store = $b72979b7cd946cce$var$getSavedStates(el);
        store.normalFill = el.style.fill;
        store.normalStroke = el.style.stroke;
        var selectState = el.states.select || {};
        store.selectFill = selectState.style && selectState.style.fill || null;
        store.selectStroke = selectState.style && selectState.style.stroke || null;
    }
});
parcelRegister("7QjoM", function(module, exports) {
    $parcel$export(module.exports, "getECData", ()=>$5b5c6fe297852166$export$b1c39b2bacd1ddc2);
    $parcel$export(module.exports, "setCommonECData", ()=>$5b5c6fe297852166$export$30d6736ebb8e18d5);
    var $eaKsF;
    var $5b5c6fe297852166$export$b1c39b2bacd1ddc2 = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $5b5c6fe297852166$export$30d6736ebb8e18d5 = function(seriesIndex, dataType, dataIdx, el) {
        if (el) {
            var ecData = $5b5c6fe297852166$export$b1c39b2bacd1ddc2(el);
            ecData.dataIndex = dataIdx;
            ecData.dataType = dataType;
            ecData.seriesIndex = seriesIndex;
            if (el.type === 'group') el.traverse(function(child) {
                var childECData = $5b5c6fe297852166$export$b1c39b2bacd1ddc2(child);
                childECData.seriesIndex = seriesIndex;
                childECData.dataIndex = dataIdx;
                childECData.dataType = dataType;
            });
        }
    };
});
parcelRegister("eYgMC", function(module, exports) {
    $parcel$export(module.exports, "getAnimationConfig", ()=>$ae63b016ce1bd907$export$5cc7add7ab591d0a);
    $parcel$export(module.exports, "updateProps", ()=>$ae63b016ce1bd907$export$c8dce3c08436e91e);
    $parcel$export(module.exports, "initProps", ()=>$ae63b016ce1bd907$export$a121566aadcfe021);
    $parcel$export(module.exports, "isElementRemoved", ()=>$ae63b016ce1bd907$export$5b89d4b643713034);
    $parcel$export(module.exports, "removeElement", ()=>$ae63b016ce1bd907$export$f883456a56996078);
    $parcel$export(module.exports, "removeElementWithFadeOut", ()=>$ae63b016ce1bd907$export$6d0fd725cb4aee8a);
    $parcel$export(module.exports, "saveOldStyle", ()=>$ae63b016ce1bd907$export$bca7290a9faf0ec9);
    $parcel$export(module.exports, "getOldStyle", ()=>$ae63b016ce1bd907$export$ccb1f1e4d2fa86ac);
    var $bahqM;
    var $eaKsF;
    var $ae63b016ce1bd907$export$ae7433df314f6ec3 = (0, (0, parcelRequire("eaKsF")).makeInner)();
    function $ae63b016ce1bd907$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, extraOpts, extraDelayParams) {
        var animationPayload;
        if (animatableModel && animatableModel.ecModel) {
            var updatePayload = animatableModel.ecModel.getUpdatePayload();
            animationPayload = updatePayload && updatePayload.animation;
        }
        var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();
        var isUpdate = animationType === 'update';
        if (animationEnabled) {
            var duration = void 0;
            var easing = void 0;
            var delay = void 0;
            if (extraOpts) {
                duration = (0, (0, parcelRequire("bahqM")).retrieve2)(extraOpts.duration, 200);
                easing = (0, (0, parcelRequire("bahqM")).retrieve2)(extraOpts.easing, 'cubicOut');
                delay = 0;
            } else {
                duration = animatableModel.getShallow(isUpdate ? 'animationDurationUpdate' : 'animationDuration');
                easing = animatableModel.getShallow(isUpdate ? 'animationEasingUpdate' : 'animationEasing');
                delay = animatableModel.getShallow(isUpdate ? 'animationDelayUpdate' : 'animationDelay');
            }
            if (animationPayload) {
                animationPayload.duration != null && (duration = animationPayload.duration);
                animationPayload.easing != null && (easing = animationPayload.easing);
                animationPayload.delay != null && (delay = animationPayload.delay);
            }
            if (typeof delay === 'function') delay = delay(dataIndex, extraDelayParams);
            if (typeof duration === 'function') duration = duration(dataIndex);
            var config = {
                duration: duration || 0,
                delay: delay,
                easing: easing
            };
            return config;
        } else return null;
    }
    function $ae63b016ce1bd907$var$animateOrSetProps(animationType, el, props, animatableModel, dataIndex, cb, during) {
        var isFrom = false;
        var removeOpt;
        if (typeof dataIndex === 'function') {
            during = cb;
            cb = dataIndex;
            dataIndex = null;
        } else if ((0, (0, parcelRequire("bahqM")).isObject)(dataIndex)) {
            cb = dataIndex.cb;
            during = dataIndex.during;
            isFrom = dataIndex.isFrom;
            removeOpt = dataIndex.removeOpt;
            dataIndex = dataIndex.dataIndex;
        }
        var isRemove = animationType === 'remove';
        if (!isRemove) el.stopAnimation('remove');
        var animationConfig = $ae63b016ce1bd907$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, isRemove ? removeOpt || {} : null, animatableModel && animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);
        if (animationConfig && animationConfig.duration > 0) {
            var duration = animationConfig.duration;
            var animationDelay = animationConfig.delay;
            var animationEasing = animationConfig.easing;
            var animateConfig = {
                duration: duration,
                delay: animationDelay || 0,
                easing: animationEasing,
                done: cb,
                force: !!cb || !!during,
                setToFinal: !isRemove,
                scope: animationType,
                during: during
            };
            isFrom ? el.animateFrom(props, animateConfig) : el.animateTo(props, animateConfig);
        } else {
            el.stopAnimation();
            !isFrom && el.attr(props);
            during && during(1);
            cb && cb();
        }
    }
    function $ae63b016ce1bd907$export$c8dce3c08436e91e(el, props, animatableModel, dataIndex, cb, during) {
        $ae63b016ce1bd907$var$animateOrSetProps('update', el, props, animatableModel, dataIndex, cb, during);
    }
    function $ae63b016ce1bd907$export$a121566aadcfe021(el, props, animatableModel, dataIndex, cb, during) {
        $ae63b016ce1bd907$var$animateOrSetProps('init', el, props, animatableModel, dataIndex, cb, during);
    }
    function $ae63b016ce1bd907$export$5b89d4b643713034(el) {
        if (!el.__zr) return true;
        for(var i = 0; i < el.animators.length; i++){
            var animator = el.animators[i];
            if (animator.scope === 'remove') return true;
        }
        return false;
    }
    function $ae63b016ce1bd907$export$f883456a56996078(el, props, animatableModel, dataIndex, cb, during) {
        if ($ae63b016ce1bd907$export$5b89d4b643713034(el)) return;
        $ae63b016ce1bd907$var$animateOrSetProps('remove', el, props, animatableModel, dataIndex, cb, during);
    }
    function $ae63b016ce1bd907$var$fadeOutDisplayable(el, animatableModel, dataIndex, done) {
        el.removeTextContent();
        el.removeTextGuideLine();
        $ae63b016ce1bd907$export$f883456a56996078(el, {
            style: {
                opacity: 0
            }
        }, animatableModel, dataIndex, done);
    }
    function $ae63b016ce1bd907$export$6d0fd725cb4aee8a(el, animatableModel, dataIndex) {
        function doRemove() {
            el.parent && el.parent.remove(el);
        }
        if (!el.isGroup) $ae63b016ce1bd907$var$fadeOutDisplayable(el, animatableModel, dataIndex, doRemove);
        else el.traverse(function(disp) {
            if (!disp.isGroup) $ae63b016ce1bd907$var$fadeOutDisplayable(disp, animatableModel, dataIndex, doRemove);
        });
    }
    function $ae63b016ce1bd907$export$bca7290a9faf0ec9(el) {
        $ae63b016ce1bd907$export$ae7433df314f6ec3(el).oldStyle = el.style;
    }
    function $ae63b016ce1bd907$export$ccb1f1e4d2fa86ac(el) {
        return $ae63b016ce1bd907$export$ae7433df314f6ec3(el).oldStyle;
    }
});
parcelRegister("fHITF", function(module, exports) {
    $parcel$export(module.exports, "extendShape", ()=>$b6edb2bb66445620$export$d0d5398c9d612037);
    $parcel$export(module.exports, "extendPath", ()=>$b6edb2bb66445620$export$53b54a3137026af0);
    $parcel$export(module.exports, "registerShape", ()=>$b6edb2bb66445620$export$2b95b62e3aaf6fdd);
    $parcel$export(module.exports, "getShapeClass", ()=>$b6edb2bb66445620$export$51df4b5565a58189);
    $parcel$export(module.exports, "makePath", ()=>$b6edb2bb66445620$export$aa9bab72412f5613);
    $parcel$export(module.exports, "resizePath", ()=>$b6edb2bb66445620$export$566dbf1c62b04fc7);
    $parcel$export(module.exports, "makeImage", ()=>$b6edb2bb66445620$export$7a2bdede98851ac5);
    $parcel$export(module.exports, "mergePath", ()=>$b6edb2bb66445620$export$7b1dd269fbc4e903);
    $parcel$export(module.exports, "subPixelOptimizeLine", ()=>$b6edb2bb66445620$export$8b4b620d7f4aad1b);
    $parcel$export(module.exports, "subPixelOptimizeRect", ()=>$b6edb2bb66445620$export$60e2aa74957d0b9d);
    $parcel$export(module.exports, "subPixelOptimize", ()=>$b6edb2bb66445620$export$72c4fd4c1b8fcb10);
    $parcel$export(module.exports, "getTransform", ()=>$b6edb2bb66445620$export$fce0c6cfca85ed96);
    $parcel$export(module.exports, "applyTransform", ()=>$b6edb2bb66445620$export$9f9dcb98c894b623);
    $parcel$export(module.exports, "transformDirection", ()=>$b6edb2bb66445620$export$fff94e9792354cfa);
    $parcel$export(module.exports, "groupTransition", ()=>$b6edb2bb66445620$export$64fcab7860c216ae);
    $parcel$export(module.exports, "clipPointsByRect", ()=>$b6edb2bb66445620$export$e2f409471bbbc1dc);
    $parcel$export(module.exports, "clipRectByRect", ()=>$b6edb2bb66445620$export$d0d3709202b8b2a);
    $parcel$export(module.exports, "createIcon", ()=>$b6edb2bb66445620$export$274edc73af1ae9c8);
    $parcel$export(module.exports, "linePolygonIntersect", ()=>$b6edb2bb66445620$export$4f47c855a5e9ae9);
    $parcel$export(module.exports, "lineLineIntersect", ()=>$b6edb2bb66445620$export$6c0a70ea1d8d158b);
    $parcel$export(module.exports, "setTooltipConfig", ()=>$b6edb2bb66445620$export$fc6410d97fab306c);
    $parcel$export(module.exports, "updateProps", ()=>(parcelRequire("eYgMC")).updateProps);
    $parcel$export(module.exports, "initProps", ()=>(parcelRequire("eYgMC")).initProps);
    $parcel$export(module.exports, "removeElement", ()=>(parcelRequire("eYgMC")).removeElement);
    $parcel$export(module.exports, "removeElementWithFadeOut", ()=>(parcelRequire("eYgMC")).removeElementWithFadeOut);
    $parcel$export(module.exports, "isElementRemoved", ()=>(parcelRequire("eYgMC")).isElementRemoved);
    $parcel$export(module.exports, "Group", ()=>(parcelRequire("4KVOr")).default);
    $parcel$export(module.exports, "Image", ()=>(parcelRequire("gcbBH")).default);
    $parcel$export(module.exports, "Text", ()=>(parcelRequire("4gEFv")).default);
    $parcel$export(module.exports, "Circle", ()=>(parcelRequire("jjfok")).default);
    $parcel$export(module.exports, "Ellipse", ()=>(parcelRequire("kVeV8")).default);
    $parcel$export(module.exports, "Sector", ()=>(parcelRequire("elGBV")).default);
    $parcel$export(module.exports, "Ring", ()=>(parcelRequire("LCHOw")).default);
    $parcel$export(module.exports, "Polygon", ()=>(parcelRequire("lQwBc")).default);
    $parcel$export(module.exports, "Polyline", ()=>(parcelRequire("32bXc")).default);
    $parcel$export(module.exports, "Rect", ()=>(parcelRequire("7Tw7u")).default);
    $parcel$export(module.exports, "Line", ()=>(parcelRequire("cZb1F")).default);
    $parcel$export(module.exports, "BezierCurve", ()=>(parcelRequire("04gw0")).default);
    $parcel$export(module.exports, "Arc", ()=>(parcelRequire("ixXaU")).default);
    $parcel$export(module.exports, "IncrementalDisplayable", ()=>(parcelRequire("6sllV")).default);
    $parcel$export(module.exports, "CompoundPath", ()=>(parcelRequire("eGltS")).default);
    $parcel$export(module.exports, "LinearGradient", ()=>(parcelRequire("9J7f8")).default);
    $parcel$export(module.exports, "RadialGradient", ()=>(parcelRequire("faICo")).default);
    $parcel$export(module.exports, "BoundingRect", ()=>(parcelRequire("1E3E8")).default);
    $parcel$export(module.exports, "OrientedBoundingRect", ()=>(parcelRequire("lM5Gp")).default);
    $parcel$export(module.exports, "Point", ()=>(parcelRequire("bMDnR")).default);
    $parcel$export(module.exports, "Path", ()=>(parcelRequire("ghQ8v")).default);
    var $id1Rd;
    var $izqgC;
    var $eLEew;
    var $ghQ8v;
    var $e6gef;
    var $gcbBH;
    var $4KVOr;
    var $4gEFv;
    var $jjfok;
    var $kVeV8;
    var $elGBV;
    var $LCHOw;
    var $lQwBc;
    var $32bXc;
    var $7Tw7u;
    var $cZb1F;
    var $04gw0;
    var $ixXaU;
    var $eGltS;
    var $9J7f8;
    var $faICo;
    var $1E3E8;
    var $lM5Gp;
    var $bMDnR;
    var $6sllV;
    var $2az2p;
    var $bahqM;
    var $7QjoM;
    var $eYgMC;
    var $b6edb2bb66445620$var$mathMax = Math.max;
    var $b6edb2bb66445620$var$mathMin = Math.min;
    var $b6edb2bb66445620$var$_customShapeMap = {};
    function $b6edb2bb66445620$export$d0d5398c9d612037(opts) {
        return (0, (0, parcelRequire("ghQ8v")).default).extend(opts);
    }
    var $b6edb2bb66445620$var$extendPathFromString = (0, parcelRequire("id1Rd")).extendFromString;
    function $b6edb2bb66445620$export$53b54a3137026af0(pathData, opts) {
        return $b6edb2bb66445620$var$extendPathFromString(pathData, opts);
    }
    function $b6edb2bb66445620$export$2b95b62e3aaf6fdd(name, ShapeClass) {
        $b6edb2bb66445620$var$_customShapeMap[name] = ShapeClass;
    }
    function $b6edb2bb66445620$export$51df4b5565a58189(name) {
        if ($b6edb2bb66445620$var$_customShapeMap.hasOwnProperty(name)) return $b6edb2bb66445620$var$_customShapeMap[name];
    }
    function $b6edb2bb66445620$export$aa9bab72412f5613(pathData, opts, rect, layout) {
        var path = (0, parcelRequire("id1Rd")).createFromString(pathData, opts);
        if (rect) {
            if (layout === 'center') rect = $b6edb2bb66445620$var$centerGraphic(rect, path.getBoundingRect());
            $b6edb2bb66445620$export$566dbf1c62b04fc7(path, rect);
        }
        return path;
    }
    function $b6edb2bb66445620$export$7a2bdede98851ac5(imageUrl, rect, layout) {
        var zrImg = new (0, (0, parcelRequire("gcbBH")).default)({
            style: {
                image: imageUrl,
                x: rect.x,
                y: rect.y,
                width: rect.width,
                height: rect.height
            },
            onload: function(img) {
                if (layout === 'center') {
                    var boundingRect = {
                        width: img.width,
                        height: img.height
                    };
                    zrImg.setStyle($b6edb2bb66445620$var$centerGraphic(rect, boundingRect));
                }
            }
        });
        return zrImg;
    }
    function $b6edb2bb66445620$var$centerGraphic(rect, boundingRect) {
        var aspect = boundingRect.width / boundingRect.height;
        var width = rect.height * aspect;
        var height;
        if (width <= rect.width) height = rect.height;
        else {
            width = rect.width;
            height = width / aspect;
        }
        var cx = rect.x + rect.width / 2;
        var cy = rect.y + rect.height / 2;
        return {
            x: cx - width / 2,
            y: cy - height / 2,
            width: width,
            height: height
        };
    }
    var $b6edb2bb66445620$export$7b1dd269fbc4e903 = (0, parcelRequire("id1Rd")).mergePath;
    function $b6edb2bb66445620$export$566dbf1c62b04fc7(path, rect) {
        if (!path.applyTransform) return;
        var pathRect = path.getBoundingRect();
        var m = pathRect.calculateTransform(rect);
        path.applyTransform(m);
    }
    function $b6edb2bb66445620$export$8b4b620d7f4aad1b(param) {
        (0, parcelRequire("2az2p")).subPixelOptimizeLine(param.shape, param.shape, param.style);
        return param;
    }
    function $b6edb2bb66445620$export$60e2aa74957d0b9d(param) {
        (0, parcelRequire("2az2p")).subPixelOptimizeRect(param.shape, param.shape, param.style);
        return param;
    }
    var $b6edb2bb66445620$export$72c4fd4c1b8fcb10 = (0, parcelRequire("2az2p")).subPixelOptimize;
    function $b6edb2bb66445620$export$fce0c6cfca85ed96(target, ancestor) {
        var mat = (0, parcelRequire("izqgC")).identity([]);
        while(target && target !== ancestor){
            (0, parcelRequire("izqgC")).mul(mat, target.getLocalTransform(), mat);
            target = target.parent;
        }
        return mat;
    }
    function $b6edb2bb66445620$export$9f9dcb98c894b623(target, transform, invert) {
        if (transform && !(0, (0, parcelRequire("bahqM")).isArrayLike)(transform)) transform = (0, (0, parcelRequire("e6gef")).default).getLocalTransform(transform);
        if (invert) transform = (0, parcelRequire("izqgC")).invert([], transform);
        return (0, parcelRequire("eLEew")).applyTransform([], target, transform);
    }
    function $b6edb2bb66445620$export$fff94e9792354cfa(direction, transform, invert) {
        var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : Math.abs(2 * transform[4] / transform[0]);
        var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : Math.abs(2 * transform[4] / transform[2]);
        var vertex = [
            direction === 'left' ? -hBase : direction === 'right' ? hBase : 0,
            direction === 'top' ? -vBase : direction === 'bottom' ? vBase : 0
        ];
        vertex = $b6edb2bb66445620$export$9f9dcb98c894b623(vertex, transform, invert);
        return Math.abs(vertex[0]) > Math.abs(vertex[1]) ? vertex[0] > 0 ? 'right' : 'left' : vertex[1] > 0 ? 'bottom' : 'top';
    }
    function $b6edb2bb66445620$var$isNotGroup(el) {
        return !el.isGroup;
    }
    function $b6edb2bb66445620$var$isPath(el) {
        return el.shape != null;
    }
    function $b6edb2bb66445620$export$64fcab7860c216ae(g1, g2, animatableModel) {
        if (!g1 || !g2) return;
        function getElMap(g) {
            var elMap = {};
            g.traverse(function(el) {
                if ($b6edb2bb66445620$var$isNotGroup(el) && el.anid) elMap[el.anid] = el;
            });
            return elMap;
        }
        function getAnimatableProps(el) {
            var obj = {
                x: el.x,
                y: el.y,
                rotation: el.rotation
            };
            if ($b6edb2bb66445620$var$isPath(el)) obj.shape = (0, (0, parcelRequire("bahqM")).extend)({}, el.shape);
            return obj;
        }
        var elMap1 = getElMap(g1);
        g2.traverse(function(el) {
            if ($b6edb2bb66445620$var$isNotGroup(el) && el.anid) {
                var oldEl = elMap1[el.anid];
                if (oldEl) {
                    var newProp = getAnimatableProps(el);
                    el.attr(getAnimatableProps(oldEl));
                    (0, (0, parcelRequire("eYgMC")).updateProps)(el, newProp, animatableModel, (0, (0, parcelRequire("7QjoM")).getECData)(el).dataIndex);
                }
            }
        });
    }
    function $b6edb2bb66445620$export$e2f409471bbbc1dc(points, rect) {
        return (0, (0, parcelRequire("bahqM")).map)(points, function(point) {
            var x = point[0];
            x = $b6edb2bb66445620$var$mathMax(x, rect.x);
            x = $b6edb2bb66445620$var$mathMin(x, rect.x + rect.width);
            var y = point[1];
            y = $b6edb2bb66445620$var$mathMax(y, rect.y);
            y = $b6edb2bb66445620$var$mathMin(y, rect.y + rect.height);
            return [
                x,
                y
            ];
        });
    }
    function $b6edb2bb66445620$export$d0d3709202b8b2a(targetRect, rect) {
        var x = $b6edb2bb66445620$var$mathMax(targetRect.x, rect.x);
        var x2 = $b6edb2bb66445620$var$mathMin(targetRect.x + targetRect.width, rect.x + rect.width);
        var y = $b6edb2bb66445620$var$mathMax(targetRect.y, rect.y);
        var y2 = $b6edb2bb66445620$var$mathMin(targetRect.y + targetRect.height, rect.y + rect.height);
        if (x2 >= x && y2 >= y) return {
            x: x,
            y: y,
            width: x2 - x,
            height: y2 - y
        };
    }
    function $b6edb2bb66445620$export$274edc73af1ae9c8(iconStr, opt, rect) {
        var innerOpts = (0, (0, parcelRequire("bahqM")).extend)({
            rectHover: true
        }, opt);
        var style = innerOpts.style = {
            strokeNoScale: true
        };
        rect = rect || {
            x: -1,
            y: -1,
            width: 2,
            height: 2
        };
        if (iconStr) return iconStr.indexOf('image://') === 0 ? (style.image = iconStr.slice(8), (0, (0, parcelRequire("bahqM")).defaults)(style, rect), new (0, (0, parcelRequire("gcbBH")).default)(innerOpts)) : $b6edb2bb66445620$export$aa9bab72412f5613(iconStr.replace('path://', ''), innerOpts, rect, 'center');
    }
    function $b6edb2bb66445620$export$4f47c855a5e9ae9(a1x, a1y, a2x, a2y, points) {
        for(var i = 0, p2 = points[points.length - 1]; i < points.length; i++){
            var p = points[i];
            if ($b6edb2bb66445620$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, p[0], p[1], p2[0], p2[1])) return true;
            p2 = p;
        }
    }
    function $b6edb2bb66445620$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
        var mx = a2x - a1x;
        var my = a2y - a1y;
        var nx = b2x - b1x;
        var ny = b2y - b1y;
        var nmCrossProduct = $b6edb2bb66445620$var$crossProduct2d(nx, ny, mx, my);
        if ($b6edb2bb66445620$var$nearZero(nmCrossProduct)) return false;
        var b1a1x = a1x - b1x;
        var b1a1y = a1y - b1y;
        var q = $b6edb2bb66445620$var$crossProduct2d(b1a1x, b1a1y, mx, my) / nmCrossProduct;
        if (q < 0 || q > 1) return false;
        var p = $b6edb2bb66445620$var$crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
        if (p < 0 || p > 1) return false;
        return true;
    }
    function $b6edb2bb66445620$var$crossProduct2d(x1, y1, x2, y2) {
        return x1 * y2 - x2 * y1;
    }
    function $b6edb2bb66445620$var$nearZero(val) {
        return val <= 1e-6 && val >= -0.000001;
    }
    function $b6edb2bb66445620$export$fc6410d97fab306c(opt) {
        var itemTooltipOption = opt.itemTooltipOption;
        var componentModel = opt.componentModel;
        var itemName = opt.itemName;
        var itemTooltipOptionObj = (0, (0, parcelRequire("bahqM")).isString)(itemTooltipOption) ? {
            formatter: itemTooltipOption
        } : itemTooltipOption;
        var mainType = componentModel.mainType;
        var componentIndex = componentModel.componentIndex;
        var formatterParams = {
            componentType: mainType,
            name: itemName,
            $vars: [
                'name'
            ]
        };
        formatterParams[mainType + 'Index'] = componentIndex;
        var formatterParamsExtra = opt.formatterParamsExtra;
        if (formatterParamsExtra) (0, (0, parcelRequire("bahqM")).each)((0, (0, parcelRequire("bahqM")).keys)(formatterParamsExtra), function(key) {
            if (!(0, (0, parcelRequire("bahqM")).hasOwn)(formatterParams, key)) {
                formatterParams[key] = formatterParamsExtra[key];
                formatterParams.$vars.push(key);
            }
        });
        var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(opt.el);
        ecData.componentMainType = mainType;
        ecData.componentIndex = componentIndex;
        ecData.tooltipConfig = {
            name: itemName,
            option: (0, (0, parcelRequire("bahqM")).defaults)({
                content: itemName,
                formatterParams: formatterParams
            }, itemTooltipOptionObj)
        };
    }
    $b6edb2bb66445620$export$2b95b62e3aaf6fdd('circle', (0, (0, parcelRequire("jjfok")).default));
    $b6edb2bb66445620$export$2b95b62e3aaf6fdd('ellipse', (0, (0, parcelRequire("kVeV8")).default));
    $b6edb2bb66445620$export$2b95b62e3aaf6fdd('sector', (0, (0, parcelRequire("elGBV")).default));
    $b6edb2bb66445620$export$2b95b62e3aaf6fdd('ring', (0, (0, parcelRequire("LCHOw")).default));
    $b6edb2bb66445620$export$2b95b62e3aaf6fdd('polygon', (0, (0, parcelRequire("lQwBc")).default));
    $b6edb2bb66445620$export$2b95b62e3aaf6fdd('polyline', (0, (0, parcelRequire("32bXc")).default));
    $b6edb2bb66445620$export$2b95b62e3aaf6fdd('rect', (0, (0, parcelRequire("7Tw7u")).default));
    $b6edb2bb66445620$export$2b95b62e3aaf6fdd('line', (0, (0, parcelRequire("cZb1F")).default));
    $b6edb2bb66445620$export$2b95b62e3aaf6fdd('bezierCurve', (0, (0, parcelRequire("04gw0")).default));
    $b6edb2bb66445620$export$2b95b62e3aaf6fdd('arc', (0, (0, parcelRequire("ixXaU")).default));
});
parcelRegister("id1Rd", function(module, exports) {
    $parcel$export(module.exports, "createFromString", ()=>$d41ae1bdee61ce18$export$ae5b259626f00aeb);
    $parcel$export(module.exports, "extendFromString", ()=>$d41ae1bdee61ce18$export$68e3a51ba2ed417c);
    $parcel$export(module.exports, "mergePath", ()=>$d41ae1bdee61ce18$export$7b1dd269fbc4e903);
    $parcel$export(module.exports, "clonePath", ()=>$d41ae1bdee61ce18$export$18711d956bf1c3eb);
    var $3VFsf;
    var $ghQ8v;
    var $aA4Ws;
    var $cTDbe;
    var $bahqM;
    var $d41ae1bdee61ce18$var$mathSqrt = Math.sqrt;
    var $d41ae1bdee61ce18$var$mathSin = Math.sin;
    var $d41ae1bdee61ce18$var$mathCos = Math.cos;
    var $d41ae1bdee61ce18$var$PI = Math.PI;
    function $d41ae1bdee61ce18$var$vMag(v) {
        return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
    }
    function $d41ae1bdee61ce18$var$vRatio(u, v) {
        return (u[0] * v[0] + u[1] * v[1]) / ($d41ae1bdee61ce18$var$vMag(u) * $d41ae1bdee61ce18$var$vMag(v));
    }
    function $d41ae1bdee61ce18$var$vAngle(u, v) {
        return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos($d41ae1bdee61ce18$var$vRatio(u, v));
    }
    function $d41ae1bdee61ce18$var$processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
        var psi = psiDeg * ($d41ae1bdee61ce18$var$PI / 180.0);
        var xp = $d41ae1bdee61ce18$var$mathCos(psi) * (x1 - x2) / 2.0 + $d41ae1bdee61ce18$var$mathSin(psi) * (y1 - y2) / 2.0;
        var yp = -1 * $d41ae1bdee61ce18$var$mathSin(psi) * (x1 - x2) / 2.0 + $d41ae1bdee61ce18$var$mathCos(psi) * (y1 - y2) / 2.0;
        var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
        if (lambda > 1) {
            rx *= $d41ae1bdee61ce18$var$mathSqrt(lambda);
            ry *= $d41ae1bdee61ce18$var$mathSqrt(lambda);
        }
        var f = (fa === fs ? -1 : 1) * $d41ae1bdee61ce18$var$mathSqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp))) || 0;
        var cxp = f * rx * yp / ry;
        var cyp = f * -ry * xp / rx;
        var cx = (x1 + x2) / 2.0 + $d41ae1bdee61ce18$var$mathCos(psi) * cxp - $d41ae1bdee61ce18$var$mathSin(psi) * cyp;
        var cy = (y1 + y2) / 2.0 + $d41ae1bdee61ce18$var$mathSin(psi) * cxp + $d41ae1bdee61ce18$var$mathCos(psi) * cyp;
        var theta = $d41ae1bdee61ce18$var$vAngle([
            1,
            0
        ], [
            (xp - cxp) / rx,
            (yp - cyp) / ry
        ]);
        var u = [
            (xp - cxp) / rx,
            (yp - cyp) / ry
        ];
        var v = [
            (-1 * xp - cxp) / rx,
            (-1 * yp - cyp) / ry
        ];
        var dTheta = $d41ae1bdee61ce18$var$vAngle(u, v);
        if ($d41ae1bdee61ce18$var$vRatio(u, v) <= -1) dTheta = $d41ae1bdee61ce18$var$PI;
        if ($d41ae1bdee61ce18$var$vRatio(u, v) >= 1) dTheta = 0;
        if (dTheta < 0) {
            var n = Math.round(dTheta / $d41ae1bdee61ce18$var$PI * 1e6) / 1e6;
            dTheta = $d41ae1bdee61ce18$var$PI * 2 + n % 2 * $d41ae1bdee61ce18$var$PI;
        }
        path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
    }
    var $d41ae1bdee61ce18$var$commandReg = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/ig;
    var $d41ae1bdee61ce18$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
    function $d41ae1bdee61ce18$var$createPathProxyFromString(data) {
        var path = new (0, (0, parcelRequire("aA4Ws")).default)();
        if (!data) return path;
        var cpx = 0;
        var cpy = 0;
        var subpathX = cpx;
        var subpathY = cpy;
        var prevCmd;
        var CMD = (0, (0, parcelRequire("aA4Ws")).default).CMD;
        var cmdList = data.match($d41ae1bdee61ce18$var$commandReg);
        if (!cmdList) return path;
        for(var l = 0; l < cmdList.length; l++){
            var cmdText = cmdList[l];
            var cmdStr = cmdText.charAt(0);
            var cmd = void 0;
            var p = cmdText.match($d41ae1bdee61ce18$var$numberReg) || [];
            var pLen = p.length;
            for(var i = 0; i < pLen; i++)p[i] = parseFloat(p[i]);
            var off = 0;
            while(off < pLen){
                var ctlPtx = void 0;
                var ctlPty = void 0;
                var rx = void 0;
                var ry = void 0;
                var psi = void 0;
                var fa = void 0;
                var fs = void 0;
                var x1 = cpx;
                var y1 = cpy;
                var len = void 0;
                var pathData = void 0;
                switch(cmdStr){
                    case 'l':
                        cpx += p[off++];
                        cpy += p[off++];
                        cmd = CMD.L;
                        path.addData(cmd, cpx, cpy);
                        break;
                    case 'L':
                        cpx = p[off++];
                        cpy = p[off++];
                        cmd = CMD.L;
                        path.addData(cmd, cpx, cpy);
                        break;
                    case 'm':
                        cpx += p[off++];
                        cpy += p[off++];
                        cmd = CMD.M;
                        path.addData(cmd, cpx, cpy);
                        subpathX = cpx;
                        subpathY = cpy;
                        cmdStr = 'l';
                        break;
                    case 'M':
                        cpx = p[off++];
                        cpy = p[off++];
                        cmd = CMD.M;
                        path.addData(cmd, cpx, cpy);
                        subpathX = cpx;
                        subpathY = cpy;
                        cmdStr = 'L';
                        break;
                    case 'h':
                        cpx += p[off++];
                        cmd = CMD.L;
                        path.addData(cmd, cpx, cpy);
                        break;
                    case 'H':
                        cpx = p[off++];
                        cmd = CMD.L;
                        path.addData(cmd, cpx, cpy);
                        break;
                    case 'v':
                        cpy += p[off++];
                        cmd = CMD.L;
                        path.addData(cmd, cpx, cpy);
                        break;
                    case 'V':
                        cpy = p[off++];
                        cmd = CMD.L;
                        path.addData(cmd, cpx, cpy);
                        break;
                    case 'C':
                        cmd = CMD.C;
                        path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
                        cpx = p[off - 2];
                        cpy = p[off - 1];
                        break;
                    case 'c':
                        cmd = CMD.C;
                        path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
                        cpx += p[off - 2];
                        cpy += p[off - 1];
                        break;
                    case 'S':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        len = path.len();
                        pathData = path.data;
                        if (prevCmd === CMD.C) {
                            ctlPtx += cpx - pathData[len - 4];
                            ctlPty += cpy - pathData[len - 3];
                        }
                        cmd = CMD.C;
                        x1 = p[off++];
                        y1 = p[off++];
                        cpx = p[off++];
                        cpy = p[off++];
                        path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                        break;
                    case 's':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        len = path.len();
                        pathData = path.data;
                        if (prevCmd === CMD.C) {
                            ctlPtx += cpx - pathData[len - 4];
                            ctlPty += cpy - pathData[len - 3];
                        }
                        cmd = CMD.C;
                        x1 = cpx + p[off++];
                        y1 = cpy + p[off++];
                        cpx += p[off++];
                        cpy += p[off++];
                        path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                        break;
                    case 'Q':
                        x1 = p[off++];
                        y1 = p[off++];
                        cpx = p[off++];
                        cpy = p[off++];
                        cmd = CMD.Q;
                        path.addData(cmd, x1, y1, cpx, cpy);
                        break;
                    case 'q':
                        x1 = p[off++] + cpx;
                        y1 = p[off++] + cpy;
                        cpx += p[off++];
                        cpy += p[off++];
                        cmd = CMD.Q;
                        path.addData(cmd, x1, y1, cpx, cpy);
                        break;
                    case 'T':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        len = path.len();
                        pathData = path.data;
                        if (prevCmd === CMD.Q) {
                            ctlPtx += cpx - pathData[len - 4];
                            ctlPty += cpy - pathData[len - 3];
                        }
                        cpx = p[off++];
                        cpy = p[off++];
                        cmd = CMD.Q;
                        path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                        break;
                    case 't':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        len = path.len();
                        pathData = path.data;
                        if (prevCmd === CMD.Q) {
                            ctlPtx += cpx - pathData[len - 4];
                            ctlPty += cpy - pathData[len - 3];
                        }
                        cpx += p[off++];
                        cpy += p[off++];
                        cmd = CMD.Q;
                        path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                        break;
                    case 'A':
                        rx = p[off++];
                        ry = p[off++];
                        psi = p[off++];
                        fa = p[off++];
                        fs = p[off++];
                        x1 = cpx, y1 = cpy;
                        cpx = p[off++];
                        cpy = p[off++];
                        cmd = CMD.A;
                        $d41ae1bdee61ce18$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                        break;
                    case 'a':
                        rx = p[off++];
                        ry = p[off++];
                        psi = p[off++];
                        fa = p[off++];
                        fs = p[off++];
                        x1 = cpx, y1 = cpy;
                        cpx += p[off++];
                        cpy += p[off++];
                        cmd = CMD.A;
                        $d41ae1bdee61ce18$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                        break;
                }
            }
            if (cmdStr === 'z' || cmdStr === 'Z') {
                cmd = CMD.Z;
                path.addData(cmd);
                cpx = subpathX;
                cpy = subpathY;
            }
            prevCmd = cmd;
        }
        path.toStatic();
        return path;
    }
    var $d41ae1bdee61ce18$var$SVGPath = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(SVGPath, _super);
        function SVGPath() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        SVGPath.prototype.applyTransform = function(m) {};
        return SVGPath;
    }((0, (0, parcelRequire("ghQ8v")).default));
    function $d41ae1bdee61ce18$var$isPathProxy(path) {
        return path.setData != null;
    }
    function $d41ae1bdee61ce18$var$createPathOptions(str, opts) {
        var pathProxy = $d41ae1bdee61ce18$var$createPathProxyFromString(str);
        var innerOpts = (0, (0, parcelRequire("bahqM")).extend)({}, opts);
        innerOpts.buildPath = function(path) {
            if ($d41ae1bdee61ce18$var$isPathProxy(path)) {
                path.setData(pathProxy.data);
                var ctx = path.getContext();
                if (ctx) path.rebuildPath(ctx, 1);
            } else {
                var ctx = path;
                pathProxy.rebuildPath(ctx, 1);
            }
        };
        innerOpts.applyTransform = function(m) {
            (0, (0, parcelRequire("cTDbe")).default)(pathProxy, m);
            this.dirtyShape();
        };
        return innerOpts;
    }
    function $d41ae1bdee61ce18$export$ae5b259626f00aeb(str, opts) {
        return new $d41ae1bdee61ce18$var$SVGPath($d41ae1bdee61ce18$var$createPathOptions(str, opts));
    }
    function $d41ae1bdee61ce18$export$68e3a51ba2ed417c(str, defaultOpts) {
        var innerOpts = $d41ae1bdee61ce18$var$createPathOptions(str, defaultOpts);
        var Sub = function(_super) {
            (0, (0, parcelRequire("3VFsf")).__extends)(Sub, _super);
            function Sub(opts) {
                var _this = _super.call(this, opts) || this;
                _this.applyTransform = innerOpts.applyTransform;
                _this.buildPath = innerOpts.buildPath;
                return _this;
            }
            return Sub;
        }($d41ae1bdee61ce18$var$SVGPath);
        return Sub;
    }
    function $d41ae1bdee61ce18$export$7b1dd269fbc4e903(pathEls, opts) {
        var pathList = [];
        var len = pathEls.length;
        for(var i = 0; i < len; i++){
            var pathEl = pathEls[i];
            pathList.push(pathEl.getUpdatedPathProxy(true));
        }
        var pathBundle = new (0, (0, parcelRequire("ghQ8v")).default)(opts);
        pathBundle.createPathProxy();
        pathBundle.buildPath = function(path) {
            if ($d41ae1bdee61ce18$var$isPathProxy(path)) {
                path.appendPath(pathList);
                var ctx = path.getContext();
                if (ctx) path.rebuildPath(ctx, 1);
            }
        };
        return pathBundle;
    }
    function $d41ae1bdee61ce18$export$18711d956bf1c3eb(sourcePath, opts) {
        opts = opts || {};
        var path = new (0, (0, parcelRequire("ghQ8v")).default)();
        if (sourcePath.shape) path.setShape(sourcePath.shape);
        path.setStyle(sourcePath.style);
        if (opts.bakeTransform) (0, (0, parcelRequire("cTDbe")).default)(path.path, sourcePath.getComputedTransform());
        else if (opts.toLocal) path.setLocalTransform(sourcePath.getComputedTransform());
        else path.copyTransform(sourcePath);
        path.buildPath = sourcePath.buildPath;
        path.applyTransform = path.applyTransform;
        path.z = sourcePath.z;
        path.z2 = sourcePath.z2;
        path.zlevel = sourcePath.zlevel;
        return path;
    }
});
parcelRegister("cTDbe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96390378868b6806$export$2e2bcd8739ae039);
    var $aA4Ws;
    var $eLEew;
    var $96390378868b6806$var$CMD = (0, (0, parcelRequire("aA4Ws")).default).CMD;
    var $96390378868b6806$var$points = [
        [],
        [],
        []
    ];
    var $96390378868b6806$var$mathSqrt = Math.sqrt;
    var $96390378868b6806$var$mathAtan2 = Math.atan2;
    function $96390378868b6806$export$2e2bcd8739ae039(path, m) {
        if (!m) return;
        var data = path.data;
        var len = path.len();
        var cmd;
        var nPoint;
        var i;
        var j;
        var k;
        var p;
        var M = $96390378868b6806$var$CMD.M;
        var C = $96390378868b6806$var$CMD.C;
        var L = $96390378868b6806$var$CMD.L;
        var R = $96390378868b6806$var$CMD.R;
        var A = $96390378868b6806$var$CMD.A;
        var Q = $96390378868b6806$var$CMD.Q;
        for(i = 0, j = 0; i < len;){
            cmd = data[i++];
            j = i;
            nPoint = 0;
            switch(cmd){
                case M:
                    nPoint = 1;
                    break;
                case L:
                    nPoint = 1;
                    break;
                case C:
                    nPoint = 3;
                    break;
                case Q:
                    nPoint = 2;
                    break;
                case A:
                    var x = m[4];
                    var y = m[5];
                    var sx = $96390378868b6806$var$mathSqrt(m[0] * m[0] + m[1] * m[1]);
                    var sy = $96390378868b6806$var$mathSqrt(m[2] * m[2] + m[3] * m[3]);
                    var angle = $96390378868b6806$var$mathAtan2(-m[1] / sy, m[0] / sx);
                    data[i] *= sx;
                    data[i++] += x;
                    data[i] *= sy;
                    data[i++] += y;
                    data[i++] *= sx;
                    data[i++] *= sy;
                    data[i++] += angle;
                    data[i++] += angle;
                    i += 2;
                    j = i;
                    break;
                case R:
                    p[0] = data[i++];
                    p[1] = data[i++];
                    (0, (0, parcelRequire("eLEew")).applyTransform)(p, p, m);
                    data[j++] = p[0];
                    data[j++] = p[1];
                    p[0] += data[i++];
                    p[1] += data[i++];
                    (0, (0, parcelRequire("eLEew")).applyTransform)(p, p, m);
                    data[j++] = p[0];
                    data[j++] = p[1];
            }
            for(k = 0; k < nPoint; k++){
                var p_1 = $96390378868b6806$var$points[k];
                p_1[0] = data[i++];
                p_1[1] = data[i++];
                (0, (0, parcelRequire("eLEew")).applyTransform)(p_1, p_1, m);
                data[j++] = p_1[0];
                data[j++] = p_1[1];
            }
        }
        path.increaseVersion();
    }
});
parcelRegister("4KVOr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$37684daaaf15bf3f$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bahqM;
    var $7KVc5;
    var $1E3E8;
    var $37684daaaf15bf3f$var$Group = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Group, _super);
        function Group(opts) {
            var _this = _super.call(this) || this;
            _this.isGroup = true;
            _this._children = [];
            _this.attr(opts);
            return _this;
        }
        Group.prototype.childrenRef = function() {
            return this._children;
        };
        Group.prototype.children = function() {
            return this._children.slice();
        };
        Group.prototype.childAt = function(idx) {
            return this._children[idx];
        };
        Group.prototype.childOfName = function(name) {
            var children = this._children;
            for(var i = 0; i < children.length; i++){
                if (children[i].name === name) return children[i];
            }
        };
        Group.prototype.childCount = function() {
            return this._children.length;
        };
        Group.prototype.add = function(child) {
            if (child) {
                if (child !== this && child.parent !== this) {
                    this._children.push(child);
                    this._doAdd(child);
                }
                if (child.__hostTarget) throw 'This elemenet has been used as an attachment';
            }
            return this;
        };
        Group.prototype.addBefore = function(child, nextSibling) {
            if (child && child !== this && child.parent !== this && nextSibling && nextSibling.parent === this) {
                var children = this._children;
                var idx = children.indexOf(nextSibling);
                if (idx >= 0) {
                    children.splice(idx, 0, child);
                    this._doAdd(child);
                }
            }
            return this;
        };
        Group.prototype.replace = function(oldChild, newChild) {
            var idx = (0, parcelRequire("bahqM")).indexOf(this._children, oldChild);
            if (idx >= 0) this.replaceAt(newChild, idx);
            return this;
        };
        Group.prototype.replaceAt = function(child, index) {
            var children = this._children;
            var old = children[index];
            if (child && child !== this && child.parent !== this && child !== old) {
                children[index] = child;
                old.parent = null;
                var zr = this.__zr;
                if (zr) old.removeSelfFromZr(zr);
                this._doAdd(child);
            }
            return this;
        };
        Group.prototype._doAdd = function(child) {
            if (child.parent) child.parent.remove(child);
            child.parent = this;
            var zr = this.__zr;
            if (zr && zr !== child.__zr) child.addSelfToZr(zr);
            zr && zr.refresh();
        };
        Group.prototype.remove = function(child) {
            var zr = this.__zr;
            var children = this._children;
            var idx = (0, parcelRequire("bahqM")).indexOf(children, child);
            if (idx < 0) return this;
            children.splice(idx, 1);
            child.parent = null;
            if (zr) child.removeSelfFromZr(zr);
            zr && zr.refresh();
            return this;
        };
        Group.prototype.removeAll = function() {
            var children = this._children;
            var zr = this.__zr;
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (zr) child.removeSelfFromZr(zr);
                child.parent = null;
            }
            children.length = 0;
            return this;
        };
        Group.prototype.eachChild = function(cb, context) {
            var children = this._children;
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                cb.call(context, child, i);
            }
            return this;
        };
        Group.prototype.traverse = function(cb, context) {
            for(var i = 0; i < this._children.length; i++){
                var child = this._children[i];
                var stopped = cb.call(context, child);
                if (child.isGroup && !stopped) child.traverse(cb, context);
            }
            return this;
        };
        Group.prototype.addSelfToZr = function(zr) {
            _super.prototype.addSelfToZr.call(this, zr);
            for(var i = 0; i < this._children.length; i++){
                var child = this._children[i];
                child.addSelfToZr(zr);
            }
        };
        Group.prototype.removeSelfFromZr = function(zr) {
            _super.prototype.removeSelfFromZr.call(this, zr);
            for(var i = 0; i < this._children.length; i++){
                var child = this._children[i];
                child.removeSelfFromZr(zr);
            }
        };
        Group.prototype.getBoundingRect = function(includeChildren) {
            var tmpRect = new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0);
            var children = includeChildren || this._children;
            var tmpMat = [];
            var rect = null;
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (child.ignore || child.invisible) continue;
                var childRect = child.getBoundingRect();
                var transform = child.getLocalTransform(tmpMat);
                if (transform) {
                    (0, (0, parcelRequire("1E3E8")).default).applyTransform(tmpRect, childRect, transform);
                    rect = rect || tmpRect.clone();
                    rect.union(tmpRect);
                } else {
                    rect = rect || childRect.clone();
                    rect.union(childRect);
                }
            }
            return rect || tmpRect;
        };
        return Group;
    }((0, (0, parcelRequire("7KVc5")).default));
    $37684daaaf15bf3f$var$Group.prototype.type = 'group';
    var $37684daaaf15bf3f$export$2e2bcd8739ae039 = $37684daaaf15bf3f$var$Group;
});
parcelRegister("jjfok", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e0ebbb12e4687e45$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $e0ebbb12e4687e45$export$2c0b65c9c7b57845 = function() {
        function CircleShape() {
            this.cx = 0;
            this.cy = 0;
            this.r = 0;
        }
        return CircleShape;
    }();
    var $e0ebbb12e4687e45$var$Circle = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Circle, _super);
        function Circle(opts) {
            return _super.call(this, opts) || this;
        }
        Circle.prototype.getDefaultShape = function() {
            return new $e0ebbb12e4687e45$export$2c0b65c9c7b57845();
        };
        Circle.prototype.buildPath = function(ctx, shape, inBundle) {
            if (inBundle) ctx.moveTo(shape.cx + shape.r, shape.cy);
            ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2);
        };
        return Circle;
    }((0, (0, parcelRequire("ghQ8v")).default));
    $e0ebbb12e4687e45$var$Circle.prototype.type = 'circle';
    var $e0ebbb12e4687e45$export$2e2bcd8739ae039 = $e0ebbb12e4687e45$var$Circle;
});
parcelRegister("kVeV8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f3b4b46f050115c8$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $f3b4b46f050115c8$export$817919dfe2806d31 = function() {
        function EllipseShape() {
            this.cx = 0;
            this.cy = 0;
            this.rx = 0;
            this.ry = 0;
        }
        return EllipseShape;
    }();
    var $f3b4b46f050115c8$var$Ellipse = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Ellipse, _super);
        function Ellipse(opts) {
            return _super.call(this, opts) || this;
        }
        Ellipse.prototype.getDefaultShape = function() {
            return new $f3b4b46f050115c8$export$817919dfe2806d31();
        };
        Ellipse.prototype.buildPath = function(ctx, shape) {
            var k = 0.5522848;
            var x = shape.cx;
            var y = shape.cy;
            var a = shape.rx;
            var b = shape.ry;
            var ox = a * k;
            var oy = b * k;
            ctx.moveTo(x - a, y);
            ctx.bezierCurveTo(x - a, y - oy, x - ox, y - b, x, y - b);
            ctx.bezierCurveTo(x + ox, y - b, x + a, y - oy, x + a, y);
            ctx.bezierCurveTo(x + a, y + oy, x + ox, y + b, x, y + b);
            ctx.bezierCurveTo(x - ox, y + b, x - a, y + oy, x - a, y);
            ctx.closePath();
        };
        return Ellipse;
    }((0, (0, parcelRequire("ghQ8v")).default));
    $f3b4b46f050115c8$var$Ellipse.prototype.type = 'ellipse';
    var $f3b4b46f050115c8$export$2e2bcd8739ae039 = $f3b4b46f050115c8$var$Ellipse;
});
parcelRegister("elGBV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a724147a13426864$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $3kXtf;
    var $a724147a13426864$export$98af62de8a972c99 = function() {
        function SectorShape() {
            this.cx = 0;
            this.cy = 0;
            this.r0 = 0;
            this.r = 0;
            this.startAngle = 0;
            this.endAngle = Math.PI * 2;
            this.clockwise = true;
            this.cornerRadius = 0;
            this.innerCornerRadius = 0;
        }
        return SectorShape;
    }();
    var $a724147a13426864$var$Sector = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Sector, _super);
        function Sector(opts) {
            return _super.call(this, opts) || this;
        }
        Sector.prototype.getDefaultShape = function() {
            return new $a724147a13426864$export$98af62de8a972c99();
        };
        Sector.prototype.buildPath = function(ctx, shape) {
            (0, parcelRequire("3kXtf")).buildPath(ctx, shape);
        };
        Sector.prototype.isZeroArea = function() {
            return this.shape.startAngle === this.shape.endAngle || this.shape.r === this.shape.r0;
        };
        return Sector;
    }((0, (0, parcelRequire("ghQ8v")).default));
    $a724147a13426864$var$Sector.prototype.type = 'sector';
    var $a724147a13426864$export$2e2bcd8739ae039 = $a724147a13426864$var$Sector;
});
parcelRegister("3kXtf", function(module, exports) {
    $parcel$export(module.exports, "buildPath", ()=>$26e15f024d5166f6$export$5cc7f731b5937e99);
    var $aA4Ws;
    var $26e15f024d5166f6$var$PI = Math.PI;
    var $26e15f024d5166f6$var$PI2 = $26e15f024d5166f6$var$PI * 2;
    var $26e15f024d5166f6$var$mathSin = Math.sin;
    var $26e15f024d5166f6$var$mathCos = Math.cos;
    var $26e15f024d5166f6$var$mathACos = Math.acos;
    var $26e15f024d5166f6$var$mathATan2 = Math.atan2;
    var $26e15f024d5166f6$var$mathAbs = Math.abs;
    var $26e15f024d5166f6$var$mathSqrt = Math.sqrt;
    var $26e15f024d5166f6$var$mathMax = Math.max;
    var $26e15f024d5166f6$var$mathMin = Math.min;
    var $26e15f024d5166f6$var$e = 1e-4;
    function $26e15f024d5166f6$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
        var x10 = x1 - x0;
        var y10 = y1 - y0;
        var x32 = x3 - x2;
        var y32 = y3 - y2;
        var t = y32 * x10 - x32 * y10;
        if (t * t < $26e15f024d5166f6$var$e) return;
        t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
        return [
            x0 + t * x10,
            y0 + t * y10
        ];
    }
    function $26e15f024d5166f6$var$computeCornerTangents(x0, y0, x1, y1, radius, cr, clockwise) {
        var x01 = x0 - x1;
        var y01 = y0 - y1;
        var lo = (clockwise ? cr : -cr) / $26e15f024d5166f6$var$mathSqrt(x01 * x01 + y01 * y01);
        var ox = lo * y01;
        var oy = -lo * x01;
        var x11 = x0 + ox;
        var y11 = y0 + oy;
        var x10 = x1 + ox;
        var y10 = y1 + oy;
        var x00 = (x11 + x10) / 2;
        var y00 = (y11 + y10) / 2;
        var dx = x10 - x11;
        var dy = y10 - y11;
        var d2 = dx * dx + dy * dy;
        var r = radius - cr;
        var s = x11 * y10 - x10 * y11;
        var d = (dy < 0 ? -1 : 1) * $26e15f024d5166f6$var$mathSqrt($26e15f024d5166f6$var$mathMax(0, r * r * d2 - s * s));
        var cx0 = (s * dy - dx * d) / d2;
        var cy0 = (-s * dx - dy * d) / d2;
        var cx1 = (s * dy + dx * d) / d2;
        var cy1 = (-s * dx + dy * d) / d2;
        var dx0 = cx0 - x00;
        var dy0 = cy0 - y00;
        var dx1 = cx1 - x00;
        var dy1 = cy1 - y00;
        if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) {
            cx0 = cx1;
            cy0 = cy1;
        }
        return {
            cx: cx0,
            cy: cy0,
            x01: -ox,
            y01: -oy,
            x11: cx0 * (radius / r - 1),
            y11: cy0 * (radius / r - 1)
        };
    }
    function $26e15f024d5166f6$export$5cc7f731b5937e99(ctx, shape) {
        var radius = $26e15f024d5166f6$var$mathMax(shape.r, 0);
        var innerRadius = $26e15f024d5166f6$var$mathMax(shape.r0 || 0, 0);
        var hasRadius = radius > 0;
        var hasInnerRadius = innerRadius > 0;
        if (!hasRadius && !hasInnerRadius) return;
        if (!hasRadius) {
            radius = innerRadius;
            innerRadius = 0;
        }
        if (innerRadius > radius) {
            var tmp = radius;
            radius = innerRadius;
            innerRadius = tmp;
        }
        var clockwise = !!shape.clockwise;
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var arc;
        if (startAngle === endAngle) arc = 0;
        else {
            var tmpAngles = [
                startAngle,
                endAngle
            ];
            (0, (0, parcelRequire("aA4Ws")).normalizeArcAngles)(tmpAngles, !clockwise);
            arc = $26e15f024d5166f6$var$mathAbs(tmpAngles[0] - tmpAngles[1]);
        }
        var x = shape.cx;
        var y = shape.cy;
        var cornerRadius = shape.cornerRadius || 0;
        var innerCornerRadius = shape.innerCornerRadius || 0;
        if (!(radius > $26e15f024d5166f6$var$e)) ctx.moveTo(x, y);
        else if (arc > $26e15f024d5166f6$var$PI2 - $26e15f024d5166f6$var$e) {
            ctx.moveTo(x + radius * $26e15f024d5166f6$var$mathCos(startAngle), y + radius * $26e15f024d5166f6$var$mathSin(startAngle));
            ctx.arc(x, y, radius, startAngle, endAngle, !clockwise);
            if (innerRadius > $26e15f024d5166f6$var$e) {
                ctx.moveTo(x + innerRadius * $26e15f024d5166f6$var$mathCos(endAngle), y + innerRadius * $26e15f024d5166f6$var$mathSin(endAngle));
                ctx.arc(x, y, innerRadius, endAngle, startAngle, clockwise);
            }
        } else {
            var halfRd = $26e15f024d5166f6$var$mathAbs(radius - innerRadius) / 2;
            var cr = $26e15f024d5166f6$var$mathMin(halfRd, cornerRadius);
            var icr = $26e15f024d5166f6$var$mathMin(halfRd, innerCornerRadius);
            var cr0 = icr;
            var cr1 = cr;
            var xrs = radius * $26e15f024d5166f6$var$mathCos(startAngle);
            var yrs = radius * $26e15f024d5166f6$var$mathSin(startAngle);
            var xire = innerRadius * $26e15f024d5166f6$var$mathCos(endAngle);
            var yire = innerRadius * $26e15f024d5166f6$var$mathSin(endAngle);
            var xre = void 0;
            var yre = void 0;
            var xirs = void 0;
            var yirs = void 0;
            if (cr > $26e15f024d5166f6$var$e || icr > $26e15f024d5166f6$var$e) {
                xre = radius * $26e15f024d5166f6$var$mathCos(endAngle);
                yre = radius * $26e15f024d5166f6$var$mathSin(endAngle);
                xirs = innerRadius * $26e15f024d5166f6$var$mathCos(startAngle);
                yirs = innerRadius * $26e15f024d5166f6$var$mathSin(startAngle);
                if (arc < $26e15f024d5166f6$var$PI) {
                    var it_1 = $26e15f024d5166f6$var$intersect(xrs, yrs, xirs, yirs, xre, yre, xire, yire);
                    if (it_1) {
                        var x0 = xrs - it_1[0];
                        var y0 = yrs - it_1[1];
                        var x1 = xre - it_1[0];
                        var y1 = yre - it_1[1];
                        var a = 1 / $26e15f024d5166f6$var$mathSin($26e15f024d5166f6$var$mathACos((x0 * x1 + y0 * y1) / ($26e15f024d5166f6$var$mathSqrt(x0 * x0 + y0 * y0) * $26e15f024d5166f6$var$mathSqrt(x1 * x1 + y1 * y1))) / 2);
                        var b = $26e15f024d5166f6$var$mathSqrt(it_1[0] * it_1[0] + it_1[1] * it_1[1]);
                        cr0 = $26e15f024d5166f6$var$mathMin(icr, (innerRadius - b) / (a - 1));
                        cr1 = $26e15f024d5166f6$var$mathMin(cr, (radius - b) / (a + 1));
                    }
                }
            }
            if (!(arc > $26e15f024d5166f6$var$e)) ctx.moveTo(x + xrs, y + yrs);
            else if (cr1 > $26e15f024d5166f6$var$e) {
                var ct0 = $26e15f024d5166f6$var$computeCornerTangents(xirs, yirs, xrs, yrs, radius, cr1, clockwise);
                var ct1 = $26e15f024d5166f6$var$computeCornerTangents(xre, yre, xire, yire, radius, cr1, clockwise);
                ctx.moveTo(x + ct0.cx + ct0.x01, y + ct0.cy + ct0.y01);
                if (cr1 < cr) ctx.arc(x + ct0.cx, y + ct0.cy, cr1, $26e15f024d5166f6$var$mathATan2(ct0.y01, ct0.x01), $26e15f024d5166f6$var$mathATan2(ct1.y01, ct1.x01), !clockwise);
                else {
                    ctx.arc(x + ct0.cx, y + ct0.cy, cr1, $26e15f024d5166f6$var$mathATan2(ct0.y01, ct0.x01), $26e15f024d5166f6$var$mathATan2(ct0.y11, ct0.x11), !clockwise);
                    ctx.arc(x, y, radius, $26e15f024d5166f6$var$mathATan2(ct0.cy + ct0.y11, ct0.cx + ct0.x11), $26e15f024d5166f6$var$mathATan2(ct1.cy + ct1.y11, ct1.cx + ct1.x11), !clockwise);
                    ctx.arc(x + ct1.cx, y + ct1.cy, cr1, $26e15f024d5166f6$var$mathATan2(ct1.y11, ct1.x11), $26e15f024d5166f6$var$mathATan2(ct1.y01, ct1.x01), !clockwise);
                }
            } else {
                ctx.moveTo(x + xrs, y + yrs);
                ctx.arc(x, y, radius, startAngle, endAngle, !clockwise);
            }
            if (!(innerRadius > $26e15f024d5166f6$var$e) || !(arc > $26e15f024d5166f6$var$e)) ctx.lineTo(x + xire, y + yire);
            else if (cr0 > $26e15f024d5166f6$var$e) {
                var ct0 = $26e15f024d5166f6$var$computeCornerTangents(xire, yire, xre, yre, innerRadius, -cr0, clockwise);
                var ct1 = $26e15f024d5166f6$var$computeCornerTangents(xrs, yrs, xirs, yirs, innerRadius, -cr0, clockwise);
                ctx.lineTo(x + ct0.cx + ct0.x01, y + ct0.cy + ct0.y01);
                if (cr0 < icr) ctx.arc(x + ct0.cx, y + ct0.cy, cr0, $26e15f024d5166f6$var$mathATan2(ct0.y01, ct0.x01), $26e15f024d5166f6$var$mathATan2(ct1.y01, ct1.x01), !clockwise);
                else {
                    ctx.arc(x + ct0.cx, y + ct0.cy, cr0, $26e15f024d5166f6$var$mathATan2(ct0.y01, ct0.x01), $26e15f024d5166f6$var$mathATan2(ct0.y11, ct0.x11), !clockwise);
                    ctx.arc(x, y, innerRadius, $26e15f024d5166f6$var$mathATan2(ct0.cy + ct0.y11, ct0.cx + ct0.x11), $26e15f024d5166f6$var$mathATan2(ct1.cy + ct1.y11, ct1.cx + ct1.x11), clockwise);
                    ctx.arc(x + ct1.cx, y + ct1.cy, cr0, $26e15f024d5166f6$var$mathATan2(ct1.y11, ct1.x11), $26e15f024d5166f6$var$mathATan2(ct1.y01, ct1.x01), !clockwise);
                }
            } else {
                ctx.lineTo(x + xire, y + yire);
                ctx.arc(x, y, innerRadius, endAngle, startAngle, clockwise);
            }
        }
        ctx.closePath();
    }
});
parcelRegister("LCHOw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$08f26a0aa2f0a2fd$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $08f26a0aa2f0a2fd$export$4a506b3cd4ea73db = function() {
        function RingShape() {
            this.cx = 0;
            this.cy = 0;
            this.r = 0;
            this.r0 = 0;
        }
        return RingShape;
    }();
    var $08f26a0aa2f0a2fd$var$Ring = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Ring, _super);
        function Ring(opts) {
            return _super.call(this, opts) || this;
        }
        Ring.prototype.getDefaultShape = function() {
            return new $08f26a0aa2f0a2fd$export$4a506b3cd4ea73db();
        };
        Ring.prototype.buildPath = function(ctx, shape) {
            var x = shape.cx;
            var y = shape.cy;
            var PI2 = Math.PI * 2;
            ctx.moveTo(x + shape.r, y);
            ctx.arc(x, y, shape.r, 0, PI2, false);
            ctx.moveTo(x + shape.r0, y);
            ctx.arc(x, y, shape.r0, 0, PI2, true);
        };
        return Ring;
    }((0, (0, parcelRequire("ghQ8v")).default));
    $08f26a0aa2f0a2fd$var$Ring.prototype.type = 'ring';
    var $08f26a0aa2f0a2fd$export$2e2bcd8739ae039 = $08f26a0aa2f0a2fd$var$Ring;
});
parcelRegister("lQwBc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fe77bdccf816487a$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $gLMXf;
    var $fe77bdccf816487a$export$a34d87b9aaeedd46 = function() {
        function PolygonShape() {
            this.points = null;
            this.smooth = 0;
            this.smoothConstraint = null;
        }
        return PolygonShape;
    }();
    var $fe77bdccf816487a$var$Polygon = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Polygon, _super);
        function Polygon(opts) {
            return _super.call(this, opts) || this;
        }
        Polygon.prototype.getDefaultShape = function() {
            return new $fe77bdccf816487a$export$a34d87b9aaeedd46();
        };
        Polygon.prototype.buildPath = function(ctx, shape) {
            (0, parcelRequire("gLMXf")).buildPath(ctx, shape, true);
        };
        return Polygon;
    }((0, (0, parcelRequire("ghQ8v")).default));
    $fe77bdccf816487a$var$Polygon.prototype.type = 'polygon';
    var $fe77bdccf816487a$export$2e2bcd8739ae039 = $fe77bdccf816487a$var$Polygon;
});
parcelRegister("gLMXf", function(module, exports) {
    $parcel$export(module.exports, "buildPath", ()=>$c357027dbb0e6a00$export$5cc7f731b5937e99);
    var $bEkQR;
    var $4Fmqi;
    function $c357027dbb0e6a00$export$5cc7f731b5937e99(ctx, shape, closePath) {
        var smooth = shape.smooth;
        var points = shape.points;
        if (points && points.length >= 2) {
            if (smooth && smooth !== 'spline') {
                var controlPoints = (0, (0, parcelRequire("4Fmqi")).default)(points, smooth, closePath, shape.smoothConstraint);
                ctx.moveTo(points[0][0], points[0][1]);
                var len = points.length;
                for(var i = 0; i < (closePath ? len : len - 1); i++){
                    var cp1 = controlPoints[i * 2];
                    var cp2 = controlPoints[i * 2 + 1];
                    var p = points[(i + 1) % len];
                    ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
                }
            } else {
                if (smooth === 'spline') points = (0, (0, parcelRequire("bEkQR")).default)(points, closePath);
                ctx.moveTo(points[0][0], points[0][1]);
                for(var i = 1, l = points.length; i < l; i++)ctx.lineTo(points[i][0], points[i][1]);
            }
            closePath && ctx.closePath();
        }
    }
});
parcelRegister("bEkQR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87b39ad613612da7$export$2e2bcd8739ae039);
    var $eLEew;
    function $87b39ad613612da7$var$interpolate(p0, p1, p2, p3, t, t2, t3) {
        var v0 = (p2 - p0) * 0.5;
        var v1 = (p3 - p1) * 0.5;
        return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
    }
    function $87b39ad613612da7$export$2e2bcd8739ae039(points, isLoop) {
        var len = points.length;
        var ret = [];
        var distance = 0;
        for(var i = 1; i < len; i++)distance += (0, (0, parcelRequire("eLEew")).distance)(points[i - 1], points[i]);
        var segs = distance / 2;
        segs = segs < len ? len : segs;
        for(var i = 0; i < segs; i++){
            var pos = i / (segs - 1) * (isLoop ? len : len - 1);
            var idx = Math.floor(pos);
            var w = pos - idx;
            var p0 = void 0;
            var p1 = points[idx % len];
            var p2 = void 0;
            var p3 = void 0;
            if (!isLoop) {
                p0 = points[idx === 0 ? idx : idx - 1];
                p2 = points[idx > len - 2 ? len - 1 : idx + 1];
                p3 = points[idx > len - 3 ? len - 1 : idx + 2];
            } else {
                p0 = points[(idx - 1 + len) % len];
                p2 = points[(idx + 1) % len];
                p3 = points[(idx + 2) % len];
            }
            var w2 = w * w;
            var w3 = w * w2;
            ret.push([
                $87b39ad613612da7$var$interpolate(p0[0], p1[0], p2[0], p3[0], w, w2, w3),
                $87b39ad613612da7$var$interpolate(p0[1], p1[1], p2[1], p3[1], w, w2, w3)
            ]);
        }
        return ret;
    }
});
parcelRegister("4Fmqi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$365c6287f8cf6aea$export$2e2bcd8739ae039);
    var $eLEew;
    function $365c6287f8cf6aea$export$2e2bcd8739ae039(points, smooth, isLoop, constraint) {
        var cps = [];
        var v = [];
        var v1 = [];
        var v2 = [];
        var prevPoint;
        var nextPoint;
        var min;
        var max;
        if (constraint) {
            min = [
                Infinity,
                Infinity
            ];
            max = [
                -Infinity,
                -Infinity
            ];
            for(var i = 0, len = points.length; i < len; i++){
                (0, (0, parcelRequire("eLEew")).min)(min, min, points[i]);
                (0, (0, parcelRequire("eLEew")).max)(max, max, points[i]);
            }
            (0, (0, parcelRequire("eLEew")).min)(min, min, constraint[0]);
            (0, (0, parcelRequire("eLEew")).max)(max, max, constraint[1]);
        }
        for(var i = 0, len = points.length; i < len; i++){
            var point = points[i];
            if (isLoop) {
                prevPoint = points[i ? i - 1 : len - 1];
                nextPoint = points[(i + 1) % len];
            } else if (i === 0 || i === len - 1) {
                cps.push((0, (0, parcelRequire("eLEew")).clone)(points[i]));
                continue;
            } else {
                prevPoint = points[i - 1];
                nextPoint = points[i + 1];
            }
            (0, (0, parcelRequire("eLEew")).sub)(v, nextPoint, prevPoint);
            (0, (0, parcelRequire("eLEew")).scale)(v, v, smooth);
            var d0 = (0, (0, parcelRequire("eLEew")).distance)(point, prevPoint);
            var d1 = (0, (0, parcelRequire("eLEew")).distance)(point, nextPoint);
            var sum = d0 + d1;
            if (sum !== 0) {
                d0 /= sum;
                d1 /= sum;
            }
            (0, (0, parcelRequire("eLEew")).scale)(v1, v, -d0);
            (0, (0, parcelRequire("eLEew")).scale)(v2, v, d1);
            var cp0 = (0, (0, parcelRequire("eLEew")).add)([], point, v1);
            var cp1 = (0, (0, parcelRequire("eLEew")).add)([], point, v2);
            if (constraint) {
                (0, (0, parcelRequire("eLEew")).max)(cp0, cp0, min);
                (0, (0, parcelRequire("eLEew")).min)(cp0, cp0, max);
                (0, (0, parcelRequire("eLEew")).max)(cp1, cp1, min);
                (0, (0, parcelRequire("eLEew")).min)(cp1, cp1, max);
            }
            cps.push(cp0);
            cps.push(cp1);
        }
        if (isLoop) cps.push(cps.shift());
        return cps;
    }
});
parcelRegister("32bXc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$235ad4ce0d26a4ed$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $gLMXf;
    var $235ad4ce0d26a4ed$export$e9e5cc3985e19d11 = function() {
        function PolylineShape() {
            this.points = null;
            this.percent = 1;
            this.smooth = 0;
            this.smoothConstraint = null;
        }
        return PolylineShape;
    }();
    var $235ad4ce0d26a4ed$var$Polyline = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Polyline, _super);
        function Polyline(opts) {
            return _super.call(this, opts) || this;
        }
        Polyline.prototype.getDefaultStyle = function() {
            return {
                stroke: '#000',
                fill: null
            };
        };
        Polyline.prototype.getDefaultShape = function() {
            return new $235ad4ce0d26a4ed$export$e9e5cc3985e19d11();
        };
        Polyline.prototype.buildPath = function(ctx, shape) {
            (0, parcelRequire("gLMXf")).buildPath(ctx, shape, false);
        };
        return Polyline;
    }((0, (0, parcelRequire("ghQ8v")).default));
    $235ad4ce0d26a4ed$var$Polyline.prototype.type = 'polyline';
    var $235ad4ce0d26a4ed$export$2e2bcd8739ae039 = $235ad4ce0d26a4ed$var$Polyline;
});
parcelRegister("cZb1F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9743bc0ad02b6789$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $2az2p;
    var $9743bc0ad02b6789$var$subPixelOptimizeOutputShape = {};
    var $9743bc0ad02b6789$export$64b674d0815308 = function() {
        function LineShape() {
            this.x1 = 0;
            this.y1 = 0;
            this.x2 = 0;
            this.y2 = 0;
            this.percent = 1;
        }
        return LineShape;
    }();
    var $9743bc0ad02b6789$var$Line = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Line, _super);
        function Line(opts) {
            return _super.call(this, opts) || this;
        }
        Line.prototype.getDefaultStyle = function() {
            return {
                stroke: '#000',
                fill: null
            };
        };
        Line.prototype.getDefaultShape = function() {
            return new $9743bc0ad02b6789$export$64b674d0815308();
        };
        Line.prototype.buildPath = function(ctx, shape) {
            var x1;
            var y1;
            var x2;
            var y2;
            if (this.subPixelOptimize) {
                var optimizedShape = (0, (0, parcelRequire("2az2p")).subPixelOptimizeLine)($9743bc0ad02b6789$var$subPixelOptimizeOutputShape, shape, this.style);
                x1 = optimizedShape.x1;
                y1 = optimizedShape.y1;
                x2 = optimizedShape.x2;
                y2 = optimizedShape.y2;
            } else {
                x1 = shape.x1;
                y1 = shape.y1;
                x2 = shape.x2;
                y2 = shape.y2;
            }
            var percent = shape.percent;
            if (percent === 0) return;
            ctx.moveTo(x1, y1);
            if (percent < 1) {
                x2 = x1 * (1 - percent) + x2 * percent;
                y2 = y1 * (1 - percent) + y2 * percent;
            }
            ctx.lineTo(x2, y2);
        };
        Line.prototype.pointAt = function(p) {
            var shape = this.shape;
            return [
                shape.x1 * (1 - p) + shape.x2 * p,
                shape.y1 * (1 - p) + shape.y2 * p
            ];
        };
        return Line;
    }((0, (0, parcelRequire("ghQ8v")).default));
    $9743bc0ad02b6789$var$Line.prototype.type = 'line';
    var $9743bc0ad02b6789$export$2e2bcd8739ae039 = $9743bc0ad02b6789$var$Line;
});
parcelRegister("04gw0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$00cd2f675f351e5a$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $eLEew;
    var $dr1jo;
    var $00cd2f675f351e5a$var$out = [];
    var $00cd2f675f351e5a$export$e10089729fef29aa = function() {
        function BezierCurveShape() {
            this.x1 = 0;
            this.y1 = 0;
            this.x2 = 0;
            this.y2 = 0;
            this.cpx1 = 0;
            this.cpy1 = 0;
            this.percent = 1;
        }
        return BezierCurveShape;
    }();
    function $00cd2f675f351e5a$var$someVectorAt(shape, t, isTangent) {
        var cpx2 = shape.cpx2;
        var cpy2 = shape.cpy2;
        if (cpx2 === null || cpy2 === null) return [
            (isTangent ? (0, (0, parcelRequire("dr1jo")).cubicDerivativeAt) : (0, (0, parcelRequire("dr1jo")).cubicAt))(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t),
            (isTangent ? (0, (0, parcelRequire("dr1jo")).cubicDerivativeAt) : (0, (0, parcelRequire("dr1jo")).cubicAt))(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)
        ];
        else return [
            (isTangent ? (0, (0, parcelRequire("dr1jo")).quadraticDerivativeAt) : (0, (0, parcelRequire("dr1jo")).quadraticAt))(shape.x1, shape.cpx1, shape.x2, t),
            (isTangent ? (0, (0, parcelRequire("dr1jo")).quadraticDerivativeAt) : (0, (0, parcelRequire("dr1jo")).quadraticAt))(shape.y1, shape.cpy1, shape.y2, t)
        ];
    }
    var $00cd2f675f351e5a$var$BezierCurve = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(BezierCurve, _super);
        function BezierCurve(opts) {
            return _super.call(this, opts) || this;
        }
        BezierCurve.prototype.getDefaultStyle = function() {
            return {
                stroke: '#000',
                fill: null
            };
        };
        BezierCurve.prototype.getDefaultShape = function() {
            return new $00cd2f675f351e5a$export$e10089729fef29aa();
        };
        BezierCurve.prototype.buildPath = function(ctx, shape) {
            var x1 = shape.x1;
            var y1 = shape.y1;
            var x2 = shape.x2;
            var y2 = shape.y2;
            var cpx1 = shape.cpx1;
            var cpy1 = shape.cpy1;
            var cpx2 = shape.cpx2;
            var cpy2 = shape.cpy2;
            var percent = shape.percent;
            if (percent === 0) return;
            ctx.moveTo(x1, y1);
            if (cpx2 == null || cpy2 == null) {
                if (percent < 1) {
                    (0, (0, parcelRequire("dr1jo")).quadraticSubdivide)(x1, cpx1, x2, percent, $00cd2f675f351e5a$var$out);
                    cpx1 = $00cd2f675f351e5a$var$out[1];
                    x2 = $00cd2f675f351e5a$var$out[2];
                    (0, (0, parcelRequire("dr1jo")).quadraticSubdivide)(y1, cpy1, y2, percent, $00cd2f675f351e5a$var$out);
                    cpy1 = $00cd2f675f351e5a$var$out[1];
                    y2 = $00cd2f675f351e5a$var$out[2];
                }
                ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
            } else {
                if (percent < 1) {
                    (0, (0, parcelRequire("dr1jo")).cubicSubdivide)(x1, cpx1, cpx2, x2, percent, $00cd2f675f351e5a$var$out);
                    cpx1 = $00cd2f675f351e5a$var$out[1];
                    cpx2 = $00cd2f675f351e5a$var$out[2];
                    x2 = $00cd2f675f351e5a$var$out[3];
                    (0, (0, parcelRequire("dr1jo")).cubicSubdivide)(y1, cpy1, cpy2, y2, percent, $00cd2f675f351e5a$var$out);
                    cpy1 = $00cd2f675f351e5a$var$out[1];
                    cpy2 = $00cd2f675f351e5a$var$out[2];
                    y2 = $00cd2f675f351e5a$var$out[3];
                }
                ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
            }
        };
        BezierCurve.prototype.pointAt = function(t) {
            return $00cd2f675f351e5a$var$someVectorAt(this.shape, t, false);
        };
        BezierCurve.prototype.tangentAt = function(t) {
            var p = $00cd2f675f351e5a$var$someVectorAt(this.shape, t, true);
            return (0, parcelRequire("eLEew")).normalize(p, p);
        };
        return BezierCurve;
    }((0, (0, parcelRequire("ghQ8v")).default));
    $00cd2f675f351e5a$var$BezierCurve.prototype.type = 'bezier-curve';
    var $00cd2f675f351e5a$export$2e2bcd8739ae039 = $00cd2f675f351e5a$var$BezierCurve;
});
parcelRegister("ixXaU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d80935fda1e22f1c$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $d80935fda1e22f1c$export$a259dbdc51948277 = function() {
        function ArcShape() {
            this.cx = 0;
            this.cy = 0;
            this.r = 0;
            this.startAngle = 0;
            this.endAngle = Math.PI * 2;
            this.clockwise = true;
        }
        return ArcShape;
    }();
    var $d80935fda1e22f1c$var$Arc = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Arc, _super);
        function Arc(opts) {
            return _super.call(this, opts) || this;
        }
        Arc.prototype.getDefaultStyle = function() {
            return {
                stroke: '#000',
                fill: null
            };
        };
        Arc.prototype.getDefaultShape = function() {
            return new $d80935fda1e22f1c$export$a259dbdc51948277();
        };
        Arc.prototype.buildPath = function(ctx, shape) {
            var x = shape.cx;
            var y = shape.cy;
            var r = Math.max(shape.r, 0);
            var startAngle = shape.startAngle;
            var endAngle = shape.endAngle;
            var clockwise = shape.clockwise;
            var unitX = Math.cos(startAngle);
            var unitY = Math.sin(startAngle);
            ctx.moveTo(unitX * r + x, unitY * r + y);
            ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
        };
        return Arc;
    }((0, (0, parcelRequire("ghQ8v")).default));
    $d80935fda1e22f1c$var$Arc.prototype.type = 'arc';
    var $d80935fda1e22f1c$export$2e2bcd8739ae039 = $d80935fda1e22f1c$var$Arc;
});
parcelRegister("eGltS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ab05a69c83088c4b$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $ab05a69c83088c4b$var$CompoundPath = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(CompoundPath, _super);
        function CompoundPath() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = 'compound';
            return _this;
        }
        CompoundPath.prototype._updatePathDirty = function() {
            var paths = this.shape.paths;
            var dirtyPath = this.shapeChanged();
            for(var i = 0; i < paths.length; i++)dirtyPath = dirtyPath || paths[i].shapeChanged();
            if (dirtyPath) this.dirtyShape();
        };
        CompoundPath.prototype.beforeBrush = function() {
            this._updatePathDirty();
            var paths = this.shape.paths || [];
            var scale = this.getGlobalScale();
            for(var i = 0; i < paths.length; i++){
                if (!paths[i].path) paths[i].createPathProxy();
                paths[i].path.setScale(scale[0], scale[1], paths[i].segmentIgnoreThreshold);
            }
        };
        CompoundPath.prototype.buildPath = function(ctx, shape) {
            var paths = shape.paths || [];
            for(var i = 0; i < paths.length; i++)paths[i].buildPath(ctx, paths[i].shape, true);
        };
        CompoundPath.prototype.afterBrush = function() {
            var paths = this.shape.paths || [];
            for(var i = 0; i < paths.length; i++)paths[i].pathUpdated();
        };
        CompoundPath.prototype.getBoundingRect = function() {
            this._updatePathDirty.call(this);
            return (0, (0, parcelRequire("ghQ8v")).default).prototype.getBoundingRect.call(this);
        };
        return CompoundPath;
    }((0, (0, parcelRequire("ghQ8v")).default));
    var $ab05a69c83088c4b$export$2e2bcd8739ae039 = $ab05a69c83088c4b$var$CompoundPath;
});
parcelRegister("9J7f8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$714def5c08e9d5ff$export$2e2bcd8739ae039);
    var $3VFsf;
    var $jnhEE;
    var $714def5c08e9d5ff$var$LinearGradient = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(LinearGradient, _super);
        function LinearGradient(x, y, x2, y2, colorStops, globalCoord) {
            var _this = _super.call(this, colorStops) || this;
            _this.x = x == null ? 0 : x;
            _this.y = y == null ? 0 : y;
            _this.x2 = x2 == null ? 1 : x2;
            _this.y2 = y2 == null ? 0 : y2;
            _this.type = 'linear';
            _this.global = globalCoord || false;
            return _this;
        }
        return LinearGradient;
    }((0, (0, parcelRequire("jnhEE")).default));
    var $714def5c08e9d5ff$export$2e2bcd8739ae039 = $714def5c08e9d5ff$var$LinearGradient;
});
parcelRegister("jnhEE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e1addc27dbc63739$export$2e2bcd8739ae039);
    var $e1addc27dbc63739$var$Gradient = function() {
        function Gradient(colorStops) {
            this.colorStops = colorStops || [];
        }
        Gradient.prototype.addColorStop = function(offset, color) {
            this.colorStops.push({
                offset: offset,
                color: color
            });
        };
        return Gradient;
    }();
    var $e1addc27dbc63739$export$2e2bcd8739ae039 = $e1addc27dbc63739$var$Gradient;
});
parcelRegister("faICo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b0ba666d3a488180$export$2e2bcd8739ae039);
    var $3VFsf;
    var $jnhEE;
    var $b0ba666d3a488180$var$RadialGradient = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(RadialGradient, _super);
        function RadialGradient(x, y, r, colorStops, globalCoord) {
            var _this = _super.call(this, colorStops) || this;
            _this.x = x == null ? 0.5 : x;
            _this.y = y == null ? 0.5 : y;
            _this.r = r == null ? 0.5 : r;
            _this.type = 'radial';
            _this.global = globalCoord || false;
            return _this;
        }
        return RadialGradient;
    }((0, (0, parcelRequire("jnhEE")).default));
    var $b0ba666d3a488180$export$2e2bcd8739ae039 = $b0ba666d3a488180$var$RadialGradient;
});
parcelRegister("lM5Gp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fda27d30e90880c7$export$2e2bcd8739ae039);
    var $bMDnR;
    var $fda27d30e90880c7$var$extent = [
        0,
        0
    ];
    var $fda27d30e90880c7$var$extent2 = [
        0,
        0
    ];
    var $fda27d30e90880c7$var$minTv = new (0, (0, parcelRequire("bMDnR")).default)();
    var $fda27d30e90880c7$var$maxTv = new (0, (0, parcelRequire("bMDnR")).default)();
    var $fda27d30e90880c7$var$OrientedBoundingRect = function() {
        function OrientedBoundingRect(rect, transform) {
            this._corners = [];
            this._axes = [];
            this._origin = [
                0,
                0
            ];
            for(var i = 0; i < 4; i++)this._corners[i] = new (0, (0, parcelRequire("bMDnR")).default)();
            for(var i = 0; i < 2; i++)this._axes[i] = new (0, (0, parcelRequire("bMDnR")).default)();
            if (rect) this.fromBoundingRect(rect, transform);
        }
        OrientedBoundingRect.prototype.fromBoundingRect = function(rect, transform) {
            var corners = this._corners;
            var axes = this._axes;
            var x = rect.x;
            var y = rect.y;
            var x2 = x + rect.width;
            var y2 = y + rect.height;
            corners[0].set(x, y);
            corners[1].set(x2, y);
            corners[2].set(x2, y2);
            corners[3].set(x, y2);
            if (transform) for(var i = 0; i < 4; i++)corners[i].transform(transform);
            (0, (0, parcelRequire("bMDnR")).default).sub(axes[0], corners[1], corners[0]);
            (0, (0, parcelRequire("bMDnR")).default).sub(axes[1], corners[3], corners[0]);
            axes[0].normalize();
            axes[1].normalize();
            for(var i = 0; i < 2; i++)this._origin[i] = axes[i].dot(corners[0]);
        };
        OrientedBoundingRect.prototype.intersect = function(other, mtv) {
            var overlapped = true;
            var noMtv = !mtv;
            $fda27d30e90880c7$var$minTv.set(Infinity, Infinity);
            $fda27d30e90880c7$var$maxTv.set(0, 0);
            if (!this._intersectCheckOneSide(this, other, $fda27d30e90880c7$var$minTv, $fda27d30e90880c7$var$maxTv, noMtv, 1)) {
                overlapped = false;
                if (noMtv) return overlapped;
            }
            if (!this._intersectCheckOneSide(other, this, $fda27d30e90880c7$var$minTv, $fda27d30e90880c7$var$maxTv, noMtv, -1)) {
                overlapped = false;
                if (noMtv) return overlapped;
            }
            if (!noMtv) (0, (0, parcelRequire("bMDnR")).default).copy(mtv, overlapped ? $fda27d30e90880c7$var$minTv : $fda27d30e90880c7$var$maxTv);
            return overlapped;
        };
        OrientedBoundingRect.prototype._intersectCheckOneSide = function(self, other, minTv, maxTv, noMtv, inverse) {
            var overlapped = true;
            for(var i = 0; i < 2; i++){
                var axis = this._axes[i];
                this._getProjMinMaxOnAxis(i, self._corners, $fda27d30e90880c7$var$extent);
                this._getProjMinMaxOnAxis(i, other._corners, $fda27d30e90880c7$var$extent2);
                if ($fda27d30e90880c7$var$extent[1] < $fda27d30e90880c7$var$extent2[0] || $fda27d30e90880c7$var$extent[0] > $fda27d30e90880c7$var$extent2[1]) {
                    overlapped = false;
                    if (noMtv) return overlapped;
                    var dist0 = Math.abs($fda27d30e90880c7$var$extent2[0] - $fda27d30e90880c7$var$extent[1]);
                    var dist1 = Math.abs($fda27d30e90880c7$var$extent[0] - $fda27d30e90880c7$var$extent2[1]);
                    if (Math.min(dist0, dist1) > maxTv.len()) {
                        if (dist0 < dist1) (0, (0, parcelRequire("bMDnR")).default).scale(maxTv, axis, -dist0 * inverse);
                        else (0, (0, parcelRequire("bMDnR")).default).scale(maxTv, axis, dist1 * inverse);
                    }
                } else if (minTv) {
                    var dist0 = Math.abs($fda27d30e90880c7$var$extent2[0] - $fda27d30e90880c7$var$extent[1]);
                    var dist1 = Math.abs($fda27d30e90880c7$var$extent[0] - $fda27d30e90880c7$var$extent2[1]);
                    if (Math.min(dist0, dist1) < minTv.len()) {
                        if (dist0 < dist1) (0, (0, parcelRequire("bMDnR")).default).scale(minTv, axis, dist0 * inverse);
                        else (0, (0, parcelRequire("bMDnR")).default).scale(minTv, axis, -dist1 * inverse);
                    }
                }
            }
            return overlapped;
        };
        OrientedBoundingRect.prototype._getProjMinMaxOnAxis = function(dim, corners, out) {
            var axis = this._axes[dim];
            var origin = this._origin;
            var proj = corners[0].dot(axis) + origin[dim];
            var min = proj;
            var max = proj;
            for(var i = 1; i < corners.length; i++){
                var proj_1 = corners[i].dot(axis) + origin[dim];
                min = Math.min(proj_1, min);
                max = Math.max(proj_1, max);
            }
            out[0] = min;
            out[1] = max;
        };
        return OrientedBoundingRect;
    }();
    var $fda27d30e90880c7$export$2e2bcd8739ae039 = $fda27d30e90880c7$var$OrientedBoundingRect;
});
parcelRegister("6sllV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4b35ebcb0b796fce$export$2e2bcd8739ae039);
    var $3VFsf;
    var $lBQ88;
    var $1E3E8;
    var $4b35ebcb0b796fce$var$m = [];
    var $4b35ebcb0b796fce$var$IncrementalDisplayable = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(IncrementalDisplayable, _super);
        function IncrementalDisplayable() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.notClear = true;
            _this.incremental = true;
            _this._displayables = [];
            _this._temporaryDisplayables = [];
            _this._cursor = 0;
            return _this;
        }
        IncrementalDisplayable.prototype.traverse = function(cb, context) {
            cb.call(context, this);
        };
        IncrementalDisplayable.prototype.useStyle = function() {
            this.style = {};
        };
        IncrementalDisplayable.prototype.getCursor = function() {
            return this._cursor;
        };
        IncrementalDisplayable.prototype.innerAfterBrush = function() {
            this._cursor = this._displayables.length;
        };
        IncrementalDisplayable.prototype.clearDisplaybles = function() {
            this._displayables = [];
            this._temporaryDisplayables = [];
            this._cursor = 0;
            this.markRedraw();
            this.notClear = false;
        };
        IncrementalDisplayable.prototype.clearTemporalDisplayables = function() {
            this._temporaryDisplayables = [];
        };
        IncrementalDisplayable.prototype.addDisplayable = function(displayable, notPersistent) {
            if (notPersistent) this._temporaryDisplayables.push(displayable);
            else this._displayables.push(displayable);
            this.markRedraw();
        };
        IncrementalDisplayable.prototype.addDisplayables = function(displayables, notPersistent) {
            notPersistent = notPersistent || false;
            for(var i = 0; i < displayables.length; i++)this.addDisplayable(displayables[i], notPersistent);
        };
        IncrementalDisplayable.prototype.getDisplayables = function() {
            return this._displayables;
        };
        IncrementalDisplayable.prototype.getTemporalDisplayables = function() {
            return this._temporaryDisplayables;
        };
        IncrementalDisplayable.prototype.eachPendingDisplayable = function(cb) {
            for(var i = this._cursor; i < this._displayables.length; i++)cb && cb(this._displayables[i]);
            for(var i = 0; i < this._temporaryDisplayables.length; i++)cb && cb(this._temporaryDisplayables[i]);
        };
        IncrementalDisplayable.prototype.update = function() {
            this.updateTransform();
            for(var i = this._cursor; i < this._displayables.length; i++){
                var displayable = this._displayables[i];
                displayable.parent = this;
                displayable.update();
                displayable.parent = null;
            }
            for(var i = 0; i < this._temporaryDisplayables.length; i++){
                var displayable = this._temporaryDisplayables[i];
                displayable.parent = this;
                displayable.update();
                displayable.parent = null;
            }
        };
        IncrementalDisplayable.prototype.getBoundingRect = function() {
            if (!this._rect) {
                var rect = new (0, (0, parcelRequire("1E3E8")).default)(Infinity, Infinity, -Infinity, -Infinity);
                for(var i = 0; i < this._displayables.length; i++){
                    var displayable = this._displayables[i];
                    var childRect = displayable.getBoundingRect().clone();
                    if (displayable.needLocalTransform()) childRect.applyTransform(displayable.getLocalTransform($4b35ebcb0b796fce$var$m));
                    rect.union(childRect);
                }
                this._rect = rect;
            }
            return this._rect;
        };
        IncrementalDisplayable.prototype.contain = function(x, y) {
            var localPos = this.transformCoordToLocal(x, y);
            var rect = this.getBoundingRect();
            if (rect.contain(localPos[0], localPos[1])) for(var i = 0; i < this._displayables.length; i++){
                var displayable = this._displayables[i];
                if (displayable.contain(x, y)) return true;
            }
            return false;
        };
        return IncrementalDisplayable;
    }((0, (0, parcelRequire("lBQ88")).default));
    var $4b35ebcb0b796fce$export$2e2bcd8739ae039 = $4b35ebcb0b796fce$var$IncrementalDisplayable;
});
parcelRegister("46U6E", function(module, exports) {
    $parcel$export(module.exports, "LINE_STYLE_KEY_MAP", ()=>$2fe33e7a8dd518cd$export$9f34de5b59222949);
    $parcel$export(module.exports, "LineStyleMixin", ()=>$2fe33e7a8dd518cd$export$91eeeeed4a69a7e7);
    var $1BJbl;
    var $2fe33e7a8dd518cd$export$9f34de5b59222949 = [
        [
            'lineWidth',
            'width'
        ],
        [
            'stroke',
            'color'
        ],
        [
            'opacity'
        ],
        [
            'shadowBlur'
        ],
        [
            'shadowOffsetX'
        ],
        [
            'shadowOffsetY'
        ],
        [
            'shadowColor'
        ],
        [
            'lineDash',
            'type'
        ],
        [
            'lineDashOffset',
            'dashOffset'
        ],
        [
            'lineCap',
            'cap'
        ],
        [
            'lineJoin',
            'join'
        ],
        [
            'miterLimit'
        ]
    ];
    var $2fe33e7a8dd518cd$var$getLineStyle = (0, (0, parcelRequire("1BJbl")).default)($2fe33e7a8dd518cd$export$9f34de5b59222949);
    var $2fe33e7a8dd518cd$export$91eeeeed4a69a7e7 = function() {
        function LineStyleMixin() {}
        LineStyleMixin.prototype.getLineStyle = function(excludes) {
            return $2fe33e7a8dd518cd$var$getLineStyle(this, excludes);
        };
        return LineStyleMixin;
    }();
});
parcelRegister("4rldO", function(module, exports) {
    $parcel$export(module.exports, "ITEM_STYLE_KEY_MAP", ()=>$33ba2539bbc4d618$export$ffb0bba5dde0130b);
    $parcel$export(module.exports, "ItemStyleMixin", ()=>$33ba2539bbc4d618$export$e4f01e48d6fda412);
    var $1BJbl;
    var $33ba2539bbc4d618$export$ffb0bba5dde0130b = [
        [
            'fill',
            'color'
        ],
        [
            'stroke',
            'borderColor'
        ],
        [
            'lineWidth',
            'borderWidth'
        ],
        [
            'opacity'
        ],
        [
            'shadowBlur'
        ],
        [
            'shadowOffsetX'
        ],
        [
            'shadowOffsetY'
        ],
        [
            'shadowColor'
        ],
        [
            'lineDash',
            'borderType'
        ],
        [
            'lineDashOffset',
            'borderDashOffset'
        ],
        [
            'lineCap',
            'borderCap'
        ],
        [
            'lineJoin',
            'borderJoin'
        ],
        [
            'miterLimit',
            'borderMiterLimit'
        ]
    ];
    var $33ba2539bbc4d618$var$getItemStyle = (0, (0, parcelRequire("1BJbl")).default)($33ba2539bbc4d618$export$ffb0bba5dde0130b);
    var $33ba2539bbc4d618$export$e4f01e48d6fda412 = function() {
        function ItemStyleMixin() {}
        ItemStyleMixin.prototype.getItemStyle = function(excludes, includes) {
            return $33ba2539bbc4d618$var$getItemStyle(this, excludes, includes);
        };
        return ItemStyleMixin;
    }();
});
parcelRegister("jvo6O", function(module, exports) {
    $parcel$export(module.exports, "getUID", ()=>$e3339d183aa6ce79$export$6d2b3473b0986646);
    $parcel$export(module.exports, "enableSubTypeDefaulter", ()=>$e3339d183aa6ce79$export$b9faf30b7d655a6f);
    $parcel$export(module.exports, "enableTopologicalTravel", ()=>$e3339d183aa6ce79$export$ce592d345a3ec040);
    $parcel$export(module.exports, "inheritDefaultOption", ()=>$e3339d183aa6ce79$export$68acc510e46fef2);
    var $bahqM;
    var $aLwh0;
    var $e3339d183aa6ce79$var$base = Math.round(Math.random() * 10);
    function $e3339d183aa6ce79$export$6d2b3473b0986646(type) {
        return [
            type || '',
            $e3339d183aa6ce79$var$base++
        ].join('_');
    }
    function $e3339d183aa6ce79$export$b9faf30b7d655a6f(target) {
        var subTypeDefaulters = {};
        target.registerSubTypeDefaulter = function(componentType, defaulter) {
            var componentTypeInfo = (0, (0, parcelRequire("aLwh0")).parseClassType)(componentType);
            subTypeDefaulters[componentTypeInfo.main] = defaulter;
        };
        target.determineSubType = function(componentType, option) {
            var type = option.type;
            if (!type) {
                var componentTypeMain = (0, (0, parcelRequire("aLwh0")).parseClassType)(componentType).main;
                if (target.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) type = subTypeDefaulters[componentTypeMain](option);
            }
            return type;
        };
    }
    function $e3339d183aa6ce79$export$ce592d345a3ec040(entity, dependencyGetter) {
        entity.topologicalTravel = function(targetNameList, fullNameList, callback, context) {
            if (!targetNameList.length) return;
            var result = makeDepndencyGraph(fullNameList);
            var graph = result.graph;
            var noEntryList = result.noEntryList;
            var targetNameSet = {};
            (0, parcelRequire("bahqM")).each(targetNameList, function(name) {
                targetNameSet[name] = true;
            });
            while(noEntryList.length){
                var currComponentType = noEntryList.pop();
                var currVertex = graph[currComponentType];
                var isInTargetNameSet = !!targetNameSet[currComponentType];
                if (isInTargetNameSet) {
                    callback.call(context, currComponentType, currVertex.originalDeps.slice());
                    delete targetNameSet[currComponentType];
                }
                (0, parcelRequire("bahqM")).each(currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
            }
            (0, parcelRequire("bahqM")).each(targetNameSet, function() {
                var errMsg = '';
                throw new Error(errMsg);
            });
            function removeEdge(succComponentType) {
                graph[succComponentType].entryCount--;
                if (graph[succComponentType].entryCount === 0) noEntryList.push(succComponentType);
            }
            function removeEdgeAndAdd(succComponentType) {
                targetNameSet[succComponentType] = true;
                removeEdge(succComponentType);
            }
        };
        function makeDepndencyGraph(fullNameList) {
            var graph = {};
            var noEntryList = [];
            (0, parcelRequire("bahqM")).each(fullNameList, function(name) {
                var thisItem = createDependencyGraphItem(graph, name);
                var originalDeps = thisItem.originalDeps = dependencyGetter(name);
                var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
                thisItem.entryCount = availableDeps.length;
                if (thisItem.entryCount === 0) noEntryList.push(name);
                (0, parcelRequire("bahqM")).each(availableDeps, function(dependentName) {
                    if ((0, parcelRequire("bahqM")).indexOf(thisItem.predecessor, dependentName) < 0) thisItem.predecessor.push(dependentName);
                    var thatItem = createDependencyGraphItem(graph, dependentName);
                    if ((0, parcelRequire("bahqM")).indexOf(thatItem.successor, dependentName) < 0) thatItem.successor.push(name);
                });
            });
            return {
                graph: graph,
                noEntryList: noEntryList
            };
        }
        function createDependencyGraphItem(graph, name) {
            if (!graph[name]) graph[name] = {
                predecessor: [],
                successor: []
            };
            return graph[name];
        }
        function getAvailableDependencies(originalDeps, fullNameList) {
            var availableDeps = [];
            (0, parcelRequire("bahqM")).each(originalDeps, function(dep) {
                (0, parcelRequire("bahqM")).indexOf(fullNameList, dep) >= 0 && availableDeps.push(dep);
            });
            return availableDeps;
        }
    }
    function $e3339d183aa6ce79$export$68acc510e46fef2(superOption, subOption) {
        return (0, parcelRequire("bahqM")).merge((0, parcelRequire("bahqM")).merge({}, superOption, true), subOption, true);
    }
});
parcelRegister("65MS1", function(module, exports) {
    $parcel$export(module.exports, "LOCATION_PARAMS", ()=>$46f91e567ea0ce35$export$a9aa2cc018afbed);
    $parcel$export(module.exports, "box", ()=>$46f91e567ea0ce35$export$827f4ee28efc37);
    $parcel$export(module.exports, "getAvailableSize", ()=>$46f91e567ea0ce35$export$145a8938a85a22b1);
    $parcel$export(module.exports, "getLayoutRect", ()=>$46f91e567ea0ce35$export$4517a5ca639a7293);
    $parcel$export(module.exports, "positionElement", ()=>$46f91e567ea0ce35$export$74054bd96b5eeef1);
    $parcel$export(module.exports, "sizeCalculable", ()=>$46f91e567ea0ce35$export$7ede609e8ebc9650);
    $parcel$export(module.exports, "fetchLayoutMode", ()=>$46f91e567ea0ce35$export$3968a28a7cbd6063);
    $parcel$export(module.exports, "mergeLayoutParam", ()=>$46f91e567ea0ce35$export$1754cb91f16ca028);
    $parcel$export(module.exports, "getLayoutParams", ()=>$46f91e567ea0ce35$export$4b0d20af19c9875e);
    $parcel$export(module.exports, "copyLayoutParams", ()=>$46f91e567ea0ce35$export$7438999faea9b6cc);
    var $bahqM;
    var $1E3E8;
    var $jmSNG;
    var $dCJrM;
    var $46f91e567ea0ce35$var$each = (0, parcelRequire("bahqM")).each;
    var $46f91e567ea0ce35$export$a9aa2cc018afbed = [
        'left',
        'right',
        'top',
        'bottom',
        'width',
        'height'
    ];
    var $46f91e567ea0ce35$export$d7fd4338c7b20804 = [
        [
            'width',
            'left',
            'right'
        ],
        [
            'height',
            'top',
            'bottom'
        ]
    ];
    function $46f91e567ea0ce35$var$boxLayout(orient, group, gap, maxWidth, maxHeight) {
        var x = 0;
        var y = 0;
        if (maxWidth == null) maxWidth = Infinity;
        if (maxHeight == null) maxHeight = Infinity;
        var currentLineMaxSize = 0;
        group.eachChild(function(child, idx) {
            var rect = child.getBoundingRect();
            var nextChild = group.childAt(idx + 1);
            var nextChildRect = nextChild && nextChild.getBoundingRect();
            var nextX;
            var nextY;
            if (orient === 'horizontal') {
                var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
                nextX = x + moveX;
                if (nextX > maxWidth || child.newline) {
                    x = 0;
                    nextX = moveX;
                    y += currentLineMaxSize + gap;
                    currentLineMaxSize = rect.height;
                } else currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
            } else {
                var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
                nextY = y + moveY;
                if (nextY > maxHeight || child.newline) {
                    x += currentLineMaxSize + gap;
                    y = 0;
                    nextY = moveY;
                    currentLineMaxSize = rect.width;
                } else currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
            }
            if (child.newline) return;
            child.x = x;
            child.y = y;
            child.markRedraw();
            orient === 'horizontal' ? x = nextX + gap : y = nextY + gap;
        });
    }
    var $46f91e567ea0ce35$export$827f4ee28efc37 = $46f91e567ea0ce35$var$boxLayout;
    var $46f91e567ea0ce35$export$be20d9158c17374c = (0, parcelRequire("bahqM")).curry($46f91e567ea0ce35$var$boxLayout, 'vertical');
    var $46f91e567ea0ce35$export$ae65a483d943e7a7 = (0, parcelRequire("bahqM")).curry($46f91e567ea0ce35$var$boxLayout, 'horizontal');
    function $46f91e567ea0ce35$export$145a8938a85a22b1(positionInfo, containerRect, margin) {
        var containerWidth = containerRect.width;
        var containerHeight = containerRect.height;
        var x = (0, (0, parcelRequire("jmSNG")).parsePercent)(positionInfo.left, containerWidth);
        var y = (0, (0, parcelRequire("jmSNG")).parsePercent)(positionInfo.top, containerHeight);
        var x2 = (0, (0, parcelRequire("jmSNG")).parsePercent)(positionInfo.right, containerWidth);
        var y2 = (0, (0, parcelRequire("jmSNG")).parsePercent)(positionInfo.bottom, containerHeight);
        (isNaN(x) || isNaN(parseFloat(positionInfo.left))) && (x = 0);
        (isNaN(x2) || isNaN(parseFloat(positionInfo.right))) && (x2 = containerWidth);
        (isNaN(y) || isNaN(parseFloat(positionInfo.top))) && (y = 0);
        (isNaN(y2) || isNaN(parseFloat(positionInfo.bottom))) && (y2 = containerHeight);
        margin = (0, parcelRequire("dCJrM")).normalizeCssArray(margin || 0);
        return {
            width: Math.max(x2 - x - margin[1] - margin[3], 0),
            height: Math.max(y2 - y - margin[0] - margin[2], 0)
        };
    }
    function $46f91e567ea0ce35$export$4517a5ca639a7293(positionInfo, containerRect, margin) {
        margin = (0, parcelRequire("dCJrM")).normalizeCssArray(margin || 0);
        var containerWidth = containerRect.width;
        var containerHeight = containerRect.height;
        var left = (0, (0, parcelRequire("jmSNG")).parsePercent)(positionInfo.left, containerWidth);
        var top = (0, (0, parcelRequire("jmSNG")).parsePercent)(positionInfo.top, containerHeight);
        var right = (0, (0, parcelRequire("jmSNG")).parsePercent)(positionInfo.right, containerWidth);
        var bottom = (0, (0, parcelRequire("jmSNG")).parsePercent)(positionInfo.bottom, containerHeight);
        var width = (0, (0, parcelRequire("jmSNG")).parsePercent)(positionInfo.width, containerWidth);
        var height = (0, (0, parcelRequire("jmSNG")).parsePercent)(positionInfo.height, containerHeight);
        var verticalMargin = margin[2] + margin[0];
        var horizontalMargin = margin[1] + margin[3];
        var aspect = positionInfo.aspect;
        if (isNaN(width)) width = containerWidth - right - horizontalMargin - left;
        if (isNaN(height)) height = containerHeight - bottom - verticalMargin - top;
        if (aspect != null) {
            if (isNaN(width) && isNaN(height)) {
                if (aspect > containerWidth / containerHeight) width = containerWidth * 0.8;
                else height = containerHeight * 0.8;
            }
            if (isNaN(width)) width = aspect * height;
            if (isNaN(height)) height = width / aspect;
        }
        if (isNaN(left)) left = containerWidth - right - width - horizontalMargin;
        if (isNaN(top)) top = containerHeight - bottom - height - verticalMargin;
        switch(positionInfo.left || positionInfo.right){
            case 'center':
                left = containerWidth / 2 - width / 2 - margin[3];
                break;
            case 'right':
                left = containerWidth - width - horizontalMargin;
                break;
        }
        switch(positionInfo.top || positionInfo.bottom){
            case 'middle':
            case 'center':
                top = containerHeight / 2 - height / 2 - margin[0];
                break;
            case 'bottom':
                top = containerHeight - height - verticalMargin;
                break;
        }
        left = left || 0;
        top = top || 0;
        if (isNaN(width)) width = containerWidth - horizontalMargin - left - (right || 0);
        if (isNaN(height)) height = containerHeight - verticalMargin - top - (bottom || 0);
        var rect = new (0, (0, parcelRequire("1E3E8")).default)(left + margin[3], top + margin[0], width, height);
        rect.margin = margin;
        return rect;
    }
    function $46f91e567ea0ce35$export$74054bd96b5eeef1(el, positionInfo, containerRect, margin, opt) {
        var h = !opt || !opt.hv || opt.hv[0];
        var v = !opt || !opt.hv || opt.hv[1];
        var boundingMode = opt && opt.boundingMode || 'all';
        if (!h && !v) return;
        var rect;
        if (boundingMode === 'raw') rect = el.type === 'group' ? new (0, (0, parcelRequire("1E3E8")).default)(0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
        else {
            rect = el.getBoundingRect();
            if (el.needLocalTransform()) {
                var transform = el.getLocalTransform();
                rect = rect.clone();
                rect.applyTransform(transform);
            }
        }
        var layoutRect = $46f91e567ea0ce35$export$4517a5ca639a7293((0, parcelRequire("bahqM")).defaults({
            width: rect.width,
            height: rect.height
        }, positionInfo), containerRect, margin);
        var dx = h ? layoutRect.x - rect.x : 0;
        var dy = v ? layoutRect.y - rect.y : 0;
        if (boundingMode === 'raw') {
            el.x = dx;
            el.y = dy;
        } else {
            el.x += dx;
            el.y += dy;
        }
        el.markRedraw();
    }
    function $46f91e567ea0ce35$export$7ede609e8ebc9650(option, hvIdx) {
        return option[$46f91e567ea0ce35$export$d7fd4338c7b20804[hvIdx][0]] != null || option[$46f91e567ea0ce35$export$d7fd4338c7b20804[hvIdx][1]] != null && option[$46f91e567ea0ce35$export$d7fd4338c7b20804[hvIdx][2]] != null;
    }
    function $46f91e567ea0ce35$export$3968a28a7cbd6063(ins) {
        var layoutMode = ins.layoutMode || ins.constructor.layoutMode;
        return (0, parcelRequire("bahqM")).isObject(layoutMode) ? layoutMode : layoutMode ? {
            type: layoutMode
        } : null;
    }
    function $46f91e567ea0ce35$export$1754cb91f16ca028(targetOption, newOption, opt) {
        var ignoreSize = opt && opt.ignoreSize;
        !(0, parcelRequire("bahqM")).isArray(ignoreSize) && (ignoreSize = [
            ignoreSize,
            ignoreSize
        ]);
        var hResult = merge($46f91e567ea0ce35$export$d7fd4338c7b20804[0], 0);
        var vResult = merge($46f91e567ea0ce35$export$d7fd4338c7b20804[1], 1);
        copy($46f91e567ea0ce35$export$d7fd4338c7b20804[0], targetOption, hResult);
        copy($46f91e567ea0ce35$export$d7fd4338c7b20804[1], targetOption, vResult);
        function merge(names, hvIdx) {
            var newParams = {};
            var newValueCount = 0;
            var merged = {};
            var mergedValueCount = 0;
            var enoughParamNumber = 2;
            $46f91e567ea0ce35$var$each(names, function(name) {
                merged[name] = targetOption[name];
            });
            $46f91e567ea0ce35$var$each(names, function(name) {
                hasProp(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
                hasValue(newParams, name) && newValueCount++;
                hasValue(merged, name) && mergedValueCount++;
            });
            if (ignoreSize[hvIdx]) {
                if (hasValue(newOption, names[1])) merged[names[2]] = null;
                else if (hasValue(newOption, names[2])) merged[names[1]] = null;
                return merged;
            }
            if (mergedValueCount === enoughParamNumber || !newValueCount) return merged;
            else if (newValueCount >= enoughParamNumber) return newParams;
            else {
                for(var i = 0; i < names.length; i++){
                    var name_1 = names[i];
                    if (!hasProp(newParams, name_1) && hasProp(targetOption, name_1)) {
                        newParams[name_1] = targetOption[name_1];
                        break;
                    }
                }
                return newParams;
            }
        }
        function hasProp(obj, name) {
            return obj.hasOwnProperty(name);
        }
        function hasValue(obj, name) {
            return obj[name] != null && obj[name] !== 'auto';
        }
        function copy(names, target, source) {
            $46f91e567ea0ce35$var$each(names, function(name) {
                target[name] = source[name];
            });
        }
    }
    function $46f91e567ea0ce35$export$4b0d20af19c9875e(source) {
        return $46f91e567ea0ce35$export$7438999faea9b6cc({}, source);
    }
    function $46f91e567ea0ce35$export$7438999faea9b6cc(target, source) {
        source && target && $46f91e567ea0ce35$var$each($46f91e567ea0ce35$export$a9aa2cc018afbed, function(name) {
            source.hasOwnProperty(name) && (target[name] = source[name]);
        });
        return target;
    }
});
parcelRegister("dCJrM", function(module, exports) {
    $parcel$export(module.exports, "addCommas", ()=>$9eb213cc0c822e32$export$b6fe44657ce35c42);
    $parcel$export(module.exports, "toCamelCase", ()=>$9eb213cc0c822e32$export$86f54f62aa7a7514);
    $parcel$export(module.exports, "normalizeCssArray", ()=>$9eb213cc0c822e32$export$f3a38102c49f4268);
    $parcel$export(module.exports, "encodeHTML", ()=>$9eb213cc0c822e32$export$f9d6449b9af28dc1);
    $parcel$export(module.exports, "makeValueReadable", ()=>$9eb213cc0c822e32$export$3cd8db88714decfc);
    $parcel$export(module.exports, "formatTpl", ()=>$9eb213cc0c822e32$export$2028496a35766e41);
    $parcel$export(module.exports, "formatTplSimple", ()=>$9eb213cc0c822e32$export$2fa08233ee42f8e1);
    $parcel$export(module.exports, "getTooltipMarker", ()=>$9eb213cc0c822e32$export$1987a3dbdf3c45ca);
    $parcel$export(module.exports, "formatTime", ()=>$9eb213cc0c822e32$export$3203edd9e5edd663);
    $parcel$export(module.exports, "capitalFirst", ()=>$9eb213cc0c822e32$export$38a1e7552f497c0e);
    $parcel$export(module.exports, "convertToColorString", ()=>$9eb213cc0c822e32$export$cda04d03233e5555);
    $parcel$export(module.exports, "windowOpen", ()=>$9eb213cc0c822e32$export$13e13f9b96dbe8fa);
    var $bahqM;
    var $jmSNG;
    var $bc1Ad;
    var $h6fMM;
    var $2emZ2;
    function $9eb213cc0c822e32$export$b6fe44657ce35c42(x) {
        if (!(0, (0, parcelRequire("jmSNG")).isNumeric)(x)) return (0, parcelRequire("bahqM")).isString(x) ? x : '-';
        var parts = (x + '').split('.');
        return parts[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,') + (parts.length > 1 ? '.' + parts[1] : '');
    }
    function $9eb213cc0c822e32$export$86f54f62aa7a7514(str, upperCaseFirst) {
        str = (str || '').toLowerCase().replace(/-(.)/g, function(match, group1) {
            return group1.toUpperCase();
        });
        if (upperCaseFirst && str) str = str.charAt(0).toUpperCase() + str.slice(1);
        return str;
    }
    var $9eb213cc0c822e32$export$f3a38102c49f4268 = (0, parcelRequire("bahqM")).normalizeCssArray;
    var $9eb213cc0c822e32$var$replaceReg = /([&<>"'])/g;
    var $9eb213cc0c822e32$var$replaceMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        '\'': '&#39;'
    };
    function $9eb213cc0c822e32$export$f9d6449b9af28dc1(source) {
        return source == null ? '' : (source + '').replace($9eb213cc0c822e32$var$replaceReg, function(str, c) {
            return $9eb213cc0c822e32$var$replaceMap[c];
        });
    }
    function $9eb213cc0c822e32$export$3cd8db88714decfc(value, valueType, useUTC) {
        var USER_READABLE_DEFUALT_TIME_PATTERN = '{yyyy}-{MM}-{dd} {hh}:{mm}:{ss}';
        function stringToUserReadable(str) {
            return str && (0, parcelRequire("bahqM")).trim(str) ? str : '-';
        }
        function isNumberUserReadable(num) {
            return !!(num != null && !isNaN(num) && isFinite(num));
        }
        var isTypeTime = valueType === 'time';
        var isValueDate = value instanceof Date;
        if (isTypeTime || isValueDate) {
            var date = isTypeTime ? (0, (0, parcelRequire("jmSNG")).parseDate)(value) : value;
            if (!isNaN(+date)) return (0, (0, parcelRequire("bc1Ad")).format)(date, USER_READABLE_DEFUALT_TIME_PATTERN, useUTC);
            else if (isValueDate) return '-';
        }
        if (valueType === 'ordinal') return (0, parcelRequire("bahqM")).isStringSafe(value) ? stringToUserReadable(value) : (0, parcelRequire("bahqM")).isNumber(value) ? isNumberUserReadable(value) ? value + '' : '-' : '-';
        var numericResult = (0, (0, parcelRequire("jmSNG")).numericToNumber)(value);
        return isNumberUserReadable(numericResult) ? $9eb213cc0c822e32$export$b6fe44657ce35c42(numericResult) : (0, parcelRequire("bahqM")).isStringSafe(value) ? stringToUserReadable(value) : '-';
    }
    var $9eb213cc0c822e32$var$TPL_VAR_ALIAS = [
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g'
    ];
    var $9eb213cc0c822e32$var$wrapVar = function(varName, seriesIdx) {
        return '{' + varName + (seriesIdx == null ? '' : seriesIdx) + '}';
    };
    function $9eb213cc0c822e32$export$2028496a35766e41(tpl, paramsList, encode) {
        if (!(0, parcelRequire("bahqM")).isArray(paramsList)) paramsList = [
            paramsList
        ];
        var seriesLen = paramsList.length;
        if (!seriesLen) return '';
        var $vars = paramsList[0].$vars || [];
        for(var i = 0; i < $vars.length; i++){
            var alias = $9eb213cc0c822e32$var$TPL_VAR_ALIAS[i];
            tpl = tpl.replace($9eb213cc0c822e32$var$wrapVar(alias), $9eb213cc0c822e32$var$wrapVar(alias, 0));
        }
        for(var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++)for(var k = 0; k < $vars.length; k++){
            var val = paramsList[seriesIdx][$vars[k]];
            tpl = tpl.replace($9eb213cc0c822e32$var$wrapVar($9eb213cc0c822e32$var$TPL_VAR_ALIAS[k], seriesIdx), encode ? $9eb213cc0c822e32$export$f9d6449b9af28dc1(val) : val);
        }
        return tpl;
    }
    function $9eb213cc0c822e32$export$2fa08233ee42f8e1(tpl, param, encode) {
        (0, parcelRequire("bahqM")).each(param, function(value, key) {
            tpl = tpl.replace('{' + key + '}', encode ? $9eb213cc0c822e32$export$f9d6449b9af28dc1(value) : value);
        });
        return tpl;
    }
    function $9eb213cc0c822e32$export$1987a3dbdf3c45ca(inOpt, extraCssText) {
        var opt = (0, parcelRequire("bahqM")).isString(inOpt) ? {
            color: inOpt,
            extraCssText: extraCssText
        } : inOpt || {};
        var color = opt.color;
        var type = opt.type;
        extraCssText = opt.extraCssText;
        var renderMode = opt.renderMode || 'html';
        if (!color) return '';
        if (renderMode === 'html') return type === 'subItem' ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;border-radius:4px;width:4px;height:4px;background-color:' + $9eb213cc0c822e32$export$f9d6449b9af28dc1(color) + ';' + (extraCssText || '') + '"></span>' : '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:' + $9eb213cc0c822e32$export$f9d6449b9af28dc1(color) + ';' + (extraCssText || '') + '"></span>';
        else {
            var markerId = opt.markerId || 'markerX';
            return {
                renderMode: renderMode,
                content: '{' + markerId + '|}  ',
                style: type === 'subItem' ? {
                    width: 4,
                    height: 4,
                    borderRadius: 2,
                    backgroundColor: color
                } : {
                    width: 10,
                    height: 10,
                    borderRadius: 5,
                    backgroundColor: color
                }
            };
        }
    }
    function $9eb213cc0c822e32$export$3203edd9e5edd663(tpl, value, isUTC) {
        if (tpl === 'week' || tpl === 'month' || tpl === 'quarter' || tpl === 'half-year' || tpl === 'year') tpl = 'MM-dd\nyyyy';
        var date = (0, (0, parcelRequire("jmSNG")).parseDate)(value);
        var utc = isUTC ? 'UTC' : '';
        var y = date['get' + utc + 'FullYear']();
        var M = date['get' + utc + 'Month']() + 1;
        var d = date['get' + utc + 'Date']();
        var h = date['get' + utc + 'Hours']();
        var m = date['get' + utc + 'Minutes']();
        var s = date['get' + utc + 'Seconds']();
        var S = date['get' + utc + 'Milliseconds']();
        tpl = tpl.replace('MM', (0, (0, parcelRequire("bc1Ad")).pad)(M, 2)).replace('M', M).replace('yyyy', y).replace('yy', y % 100 + '').replace('dd', (0, (0, parcelRequire("bc1Ad")).pad)(d, 2)).replace('d', d).replace('hh', (0, (0, parcelRequire("bc1Ad")).pad)(h, 2)).replace('h', h).replace('mm', (0, (0, parcelRequire("bc1Ad")).pad)(m, 2)).replace('m', m).replace('ss', (0, (0, parcelRequire("bc1Ad")).pad)(s, 2)).replace('s', s).replace('SSS', (0, (0, parcelRequire("bc1Ad")).pad)(S, 3));
        return tpl;
    }
    function $9eb213cc0c822e32$export$38a1e7552f497c0e(str) {
        return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
    }
    function $9eb213cc0c822e32$export$cda04d03233e5555(color, defaultColor) {
        defaultColor = defaultColor || 'transparent';
        return (0, parcelRequire("bahqM")).isString(color) ? color : (0, parcelRequire("bahqM")).isObject(color) ? color.colorStops && (color.colorStops[0] || {}).color || defaultColor : defaultColor;
    }
    function $9eb213cc0c822e32$export$13e13f9b96dbe8fa(link, target) {
        if (target === '_blank' || target === 'blank') {
            var blank = window.open();
            blank.opener = null;
            blank.location.href = link;
        } else window.open(link, target);
    }
});
parcelRegister("bc1Ad", function(module, exports) {
    $parcel$export(module.exports, "ONE_SECOND", ()=>$82620b17ee17a85a$export$32c0454ceff7f92d);
    $parcel$export(module.exports, "ONE_MINUTE", ()=>$82620b17ee17a85a$export$35acaebf644db34e);
    $parcel$export(module.exports, "ONE_HOUR", ()=>$82620b17ee17a85a$export$82541edf19e5e3b0);
    $parcel$export(module.exports, "ONE_DAY", ()=>$82620b17ee17a85a$export$a97a1358cbb650ab);
    $parcel$export(module.exports, "ONE_YEAR", ()=>$82620b17ee17a85a$export$99cafda57477293d);
    $parcel$export(module.exports, "fullLeveledFormatter", ()=>$82620b17ee17a85a$export$445bdbd8d2334e40);
    $parcel$export(module.exports, "timeUnits", ()=>$82620b17ee17a85a$export$833c398a55654bb7);
    $parcel$export(module.exports, "pad", ()=>$82620b17ee17a85a$export$5d04458e2a6c373e);
    $parcel$export(module.exports, "getPrimaryTimeUnit", ()=>$82620b17ee17a85a$export$1da4b91a25d7e1c8);
    $parcel$export(module.exports, "isPrimaryTimeUnit", ()=>$82620b17ee17a85a$export$beb5920b69c13da);
    $parcel$export(module.exports, "getDefaultFormatPrecisionOfInterval", ()=>$82620b17ee17a85a$export$124c820721c4f66b);
    $parcel$export(module.exports, "format", ()=>$82620b17ee17a85a$export$d9468344d3651243);
    $parcel$export(module.exports, "fullYearGetterName", ()=>$82620b17ee17a85a$export$8d046fefed9a548e);
    $parcel$export(module.exports, "monthGetterName", ()=>$82620b17ee17a85a$export$5c242a801a23eec7);
    $parcel$export(module.exports, "dateGetterName", ()=>$82620b17ee17a85a$export$4189e6cbc9753260);
    $parcel$export(module.exports, "hoursGetterName", ()=>$82620b17ee17a85a$export$8b40b55b3c06cbe2);
    $parcel$export(module.exports, "minutesGetterName", ()=>$82620b17ee17a85a$export$8807847c5c71eded);
    $parcel$export(module.exports, "secondsGetterName", ()=>$82620b17ee17a85a$export$8f49e73e2eebd168);
    $parcel$export(module.exports, "millisecondsGetterName", ()=>$82620b17ee17a85a$export$312207a92d041116);
    $parcel$export(module.exports, "leveledFormat", ()=>$82620b17ee17a85a$export$fe777b6293828b5d);
    $parcel$export(module.exports, "getUnitValue", ()=>$82620b17ee17a85a$export$e04e41a1e24ffd3f);
    $parcel$export(module.exports, "fullYearSetterName", ()=>$82620b17ee17a85a$export$43fbeac90913b151);
    $parcel$export(module.exports, "monthSetterName", ()=>$82620b17ee17a85a$export$233f59998ed71c09);
    $parcel$export(module.exports, "dateSetterName", ()=>$82620b17ee17a85a$export$82fd379a67f37fa0);
    $parcel$export(module.exports, "hoursSetterName", ()=>$82620b17ee17a85a$export$b6f943e8d23c15bb);
    $parcel$export(module.exports, "minutesSetterName", ()=>$82620b17ee17a85a$export$50303078793fc7d);
    $parcel$export(module.exports, "secondsSetterName", ()=>$82620b17ee17a85a$export$a4a908acda9c3118);
    $parcel$export(module.exports, "millisecondsSetterName", ()=>$82620b17ee17a85a$export$c047afab75f6d84);
    var $bahqM;
    var $jmSNG;
    var $3OMoQ;
    var $gaMkj;
    var $82620b17ee17a85a$export$32c0454ceff7f92d = 1000;
    var $82620b17ee17a85a$export$35acaebf644db34e = $82620b17ee17a85a$export$32c0454ceff7f92d * 60;
    var $82620b17ee17a85a$export$82541edf19e5e3b0 = $82620b17ee17a85a$export$35acaebf644db34e * 60;
    var $82620b17ee17a85a$export$a97a1358cbb650ab = $82620b17ee17a85a$export$82541edf19e5e3b0 * 24;
    var $82620b17ee17a85a$export$99cafda57477293d = $82620b17ee17a85a$export$a97a1358cbb650ab * 365;
    var $82620b17ee17a85a$export$f7854271ddbda64e = {
        year: '{yyyy}',
        month: '{MMM}',
        day: '{d}',
        hour: '{HH}:{mm}',
        minute: '{HH}:{mm}',
        second: '{HH}:{mm}:{ss}',
        millisecond: '{HH}:{mm}:{ss} {SSS}',
        none: '{yyyy}-{MM}-{dd} {HH}:{mm}:{ss} {SSS}'
    };
    var $82620b17ee17a85a$var$fullDayFormatter = '{yyyy}-{MM}-{dd}';
    var $82620b17ee17a85a$export$445bdbd8d2334e40 = {
        year: '{yyyy}',
        month: '{yyyy}-{MM}',
        day: $82620b17ee17a85a$var$fullDayFormatter,
        hour: $82620b17ee17a85a$var$fullDayFormatter + ' ' + $82620b17ee17a85a$export$f7854271ddbda64e.hour,
        minute: $82620b17ee17a85a$var$fullDayFormatter + ' ' + $82620b17ee17a85a$export$f7854271ddbda64e.minute,
        second: $82620b17ee17a85a$var$fullDayFormatter + ' ' + $82620b17ee17a85a$export$f7854271ddbda64e.second,
        millisecond: $82620b17ee17a85a$export$f7854271ddbda64e.none
    };
    var $82620b17ee17a85a$export$87100da04d711986 = [
        'year',
        'month',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    var $82620b17ee17a85a$export$833c398a55654bb7 = [
        'year',
        'half-year',
        'quarter',
        'month',
        'week',
        'half-week',
        'day',
        'half-day',
        'quarter-day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function $82620b17ee17a85a$export$5d04458e2a6c373e(str, len) {
        str += '';
        return '0000'.substr(0, len - str.length) + str;
    }
    function $82620b17ee17a85a$export$1da4b91a25d7e1c8(timeUnit) {
        switch(timeUnit){
            case 'half-year':
            case 'quarter':
                return 'month';
            case 'week':
            case 'half-week':
                return 'day';
            case 'half-day':
            case 'quarter-day':
                return 'hour';
            default:
                return timeUnit;
        }
    }
    function $82620b17ee17a85a$export$beb5920b69c13da(timeUnit) {
        return timeUnit === $82620b17ee17a85a$export$1da4b91a25d7e1c8(timeUnit);
    }
    function $82620b17ee17a85a$export$124c820721c4f66b(timeUnit) {
        switch(timeUnit){
            case 'year':
            case 'month':
                return 'day';
            case 'millisecond':
                return 'millisecond';
            default:
                return 'second';
        }
    }
    function $82620b17ee17a85a$export$d9468344d3651243(time, template, isUTC, lang) {
        var date = (0, parcelRequire("jmSNG")).parseDate(time);
        var y = date[$82620b17ee17a85a$export$8d046fefed9a548e(isUTC)]();
        var M = date[$82620b17ee17a85a$export$5c242a801a23eec7(isUTC)]() + 1;
        var q = Math.floor((M - 1) / 4) + 1;
        var d = date[$82620b17ee17a85a$export$4189e6cbc9753260(isUTC)]();
        var e = date['get' + (isUTC ? 'UTC' : '') + 'Day']();
        var H = date[$82620b17ee17a85a$export$8b40b55b3c06cbe2(isUTC)]();
        var h = (H - 1) % 12 + 1;
        var m = date[$82620b17ee17a85a$export$8807847c5c71eded(isUTC)]();
        var s = date[$82620b17ee17a85a$export$8f49e73e2eebd168(isUTC)]();
        var S = date[$82620b17ee17a85a$export$312207a92d041116(isUTC)]();
        var localeModel = lang instanceof (0, (0, parcelRequire("gaMkj")).default) ? lang : (0, (0, parcelRequire("3OMoQ")).getLocaleModel)(lang || (0, (0, parcelRequire("3OMoQ")).SYSTEM_LANG)) || (0, (0, parcelRequire("3OMoQ")).getDefaultLocaleModel)();
        var timeModel = localeModel.getModel('time');
        var month = timeModel.get('month');
        var monthAbbr = timeModel.get('monthAbbr');
        var dayOfWeek = timeModel.get('dayOfWeek');
        var dayOfWeekAbbr = timeModel.get('dayOfWeekAbbr');
        return (template || '').replace(/{yyyy}/g, y + '').replace(/{yy}/g, y % 100 + '').replace(/{Q}/g, q + '').replace(/{MMMM}/g, month[M - 1]).replace(/{MMM}/g, monthAbbr[M - 1]).replace(/{MM}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(M, 2)).replace(/{M}/g, M + '').replace(/{dd}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(d, 2)).replace(/{d}/g, d + '').replace(/{eeee}/g, dayOfWeek[e]).replace(/{ee}/g, dayOfWeekAbbr[e]).replace(/{e}/g, e + '').replace(/{HH}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(H, 2)).replace(/{H}/g, H + '').replace(/{hh}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(h + '', 2)).replace(/{h}/g, h + '').replace(/{mm}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(m, 2)).replace(/{m}/g, m + '').replace(/{ss}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(s, 2)).replace(/{s}/g, s + '').replace(/{SSS}/g, $82620b17ee17a85a$export$5d04458e2a6c373e(S, 3)).replace(/{S}/g, S + '');
    }
    function $82620b17ee17a85a$export$fe777b6293828b5d(tick, idx, formatter, lang, isUTC) {
        var template = null;
        if (typeof formatter === 'string') template = formatter;
        else if (typeof formatter === 'function') template = formatter(tick.value, idx, {
            level: tick.level
        });
        else {
            var defaults = (0, parcelRequire("bahqM")).extend({}, $82620b17ee17a85a$export$f7854271ddbda64e);
            if (tick.level > 0) for(var i = 0; i < $82620b17ee17a85a$export$87100da04d711986.length; ++i)defaults[$82620b17ee17a85a$export$87100da04d711986[i]] = "{primary|" + defaults[$82620b17ee17a85a$export$87100da04d711986[i]] + "}";
            var mergedFormatter = formatter ? formatter.inherit === false ? formatter : (0, parcelRequire("bahqM")).defaults(formatter, defaults) : defaults;
            var unit = $82620b17ee17a85a$export$4dfb0417ad6555b7(tick.value, isUTC);
            if (mergedFormatter[unit]) template = mergedFormatter[unit];
            else if (mergedFormatter.inherit) {
                var targetId = $82620b17ee17a85a$export$833c398a55654bb7.indexOf(unit);
                for(var i = targetId - 1; i >= 0; --i)if (mergedFormatter[unit]) {
                    template = mergedFormatter[unit];
                    break;
                }
                template = template || defaults.none;
            }
            if ((0, parcelRequire("bahqM")).isArray(template)) {
                var levelId = tick.level == null ? 0 : tick.level >= 0 ? tick.level : template.length + tick.level;
                levelId = Math.min(levelId, template.length - 1);
                template = template[levelId];
            }
        }
        return $82620b17ee17a85a$export$d9468344d3651243(new Date(tick.value), template, isUTC, lang);
    }
    function $82620b17ee17a85a$export$4dfb0417ad6555b7(value, isUTC) {
        var date = (0, parcelRequire("jmSNG")).parseDate(value);
        var M = date[$82620b17ee17a85a$export$5c242a801a23eec7(isUTC)]() + 1;
        var d = date[$82620b17ee17a85a$export$4189e6cbc9753260(isUTC)]();
        var h = date[$82620b17ee17a85a$export$8b40b55b3c06cbe2(isUTC)]();
        var m = date[$82620b17ee17a85a$export$8807847c5c71eded(isUTC)]();
        var s = date[$82620b17ee17a85a$export$8f49e73e2eebd168(isUTC)]();
        var S = date[$82620b17ee17a85a$export$312207a92d041116(isUTC)]();
        var isSecond = S === 0;
        var isMinute = isSecond && s === 0;
        var isHour = isMinute && m === 0;
        var isDay = isHour && h === 0;
        var isMonth = isDay && d === 1;
        var isYear = isMonth && M === 1;
        if (isYear) return 'year';
        else if (isMonth) return 'month';
        else if (isDay) return 'day';
        else if (isHour) return 'hour';
        else if (isMinute) return 'minute';
        else if (isSecond) return 'second';
        else return 'millisecond';
    }
    function $82620b17ee17a85a$export$e04e41a1e24ffd3f(value, unit, isUTC) {
        var date = typeof value === 'number' ? (0, parcelRequire("jmSNG")).parseDate(value) : value;
        unit = unit || $82620b17ee17a85a$export$4dfb0417ad6555b7(value, isUTC);
        switch(unit){
            case 'year':
                return date[$82620b17ee17a85a$export$8d046fefed9a548e(isUTC)]();
            case 'half-year':
                return date[$82620b17ee17a85a$export$5c242a801a23eec7(isUTC)]() >= 6 ? 1 : 0;
            case 'quarter':
                return Math.floor((date[$82620b17ee17a85a$export$5c242a801a23eec7(isUTC)]() + 1) / 4);
            case 'month':
                return date[$82620b17ee17a85a$export$5c242a801a23eec7(isUTC)]();
            case 'day':
                return date[$82620b17ee17a85a$export$4189e6cbc9753260(isUTC)]();
            case 'half-day':
                return date[$82620b17ee17a85a$export$8b40b55b3c06cbe2(isUTC)]() / 24;
            case 'hour':
                return date[$82620b17ee17a85a$export$8b40b55b3c06cbe2(isUTC)]();
            case 'minute':
                return date[$82620b17ee17a85a$export$8807847c5c71eded(isUTC)]();
            case 'second':
                return date[$82620b17ee17a85a$export$8f49e73e2eebd168(isUTC)]();
            case 'millisecond':
                return date[$82620b17ee17a85a$export$312207a92d041116(isUTC)]();
        }
    }
    function $82620b17ee17a85a$export$8d046fefed9a548e(isUTC) {
        return isUTC ? 'getUTCFullYear' : 'getFullYear';
    }
    function $82620b17ee17a85a$export$5c242a801a23eec7(isUTC) {
        return isUTC ? 'getUTCMonth' : 'getMonth';
    }
    function $82620b17ee17a85a$export$4189e6cbc9753260(isUTC) {
        return isUTC ? 'getUTCDate' : 'getDate';
    }
    function $82620b17ee17a85a$export$8b40b55b3c06cbe2(isUTC) {
        return isUTC ? 'getUTCHours' : 'getHours';
    }
    function $82620b17ee17a85a$export$8807847c5c71eded(isUTC) {
        return isUTC ? 'getUTCMinutes' : 'getMinutes';
    }
    function $82620b17ee17a85a$export$8f49e73e2eebd168(isUTC) {
        return isUTC ? 'getUTCSeconds' : 'getSeconds';
    }
    function $82620b17ee17a85a$export$312207a92d041116(isUTC) {
        return isUTC ? 'getUTCMilliseconds' : 'getMilliseconds';
    }
    function $82620b17ee17a85a$export$43fbeac90913b151(isUTC) {
        return isUTC ? 'setUTCFullYear' : 'setFullYear';
    }
    function $82620b17ee17a85a$export$233f59998ed71c09(isUTC) {
        return isUTC ? 'setUTCMonth' : 'setMonth';
    }
    function $82620b17ee17a85a$export$82fd379a67f37fa0(isUTC) {
        return isUTC ? 'setUTCDate' : 'setDate';
    }
    function $82620b17ee17a85a$export$b6f943e8d23c15bb(isUTC) {
        return isUTC ? 'setUTCHours' : 'setHours';
    }
    function $82620b17ee17a85a$export$50303078793fc7d(isUTC) {
        return isUTC ? 'setUTCMinutes' : 'setMinutes';
    }
    function $82620b17ee17a85a$export$a4a908acda9c3118(isUTC) {
        return isUTC ? 'setUTCSeconds' : 'setSeconds';
    }
    function $82620b17ee17a85a$export$c047afab75f6d84(isUTC) {
        return isUTC ? 'setUTCMilliseconds' : 'setMilliseconds';
    }
});
parcelRegister("3OMoQ", function(module, exports) {
    $parcel$export(module.exports, "SYSTEM_LANG", ()=>$2c7b95ca3b098ed0$export$9a2147b3808d4c6b);
    $parcel$export(module.exports, "registerLocale", ()=>$2c7b95ca3b098ed0$export$bab6a7822cc1e2cd);
    $parcel$export(module.exports, "createLocaleObject", ()=>$2c7b95ca3b098ed0$export$ddc371781a6af754);
    $parcel$export(module.exports, "getLocaleModel", ()=>$2c7b95ca3b098ed0$export$37cc638e0e11865f);
    $parcel$export(module.exports, "getDefaultLocaleModel", ()=>$2c7b95ca3b098ed0$export$1188f179b2597821);
    var $gaMkj;
    var $hZfwb;
    var $dHSx1;
    var $1VLoR;
    var $bahqM;
    var $2c7b95ca3b098ed0$var$LOCALE_ZH = 'ZH';
    var $2c7b95ca3b098ed0$var$LOCALE_EN = 'EN';
    var $2c7b95ca3b098ed0$var$DEFAULT_LOCALE = $2c7b95ca3b098ed0$var$LOCALE_EN;
    var $2c7b95ca3b098ed0$var$localeStorage = {};
    var $2c7b95ca3b098ed0$var$localeModels = {};
    var $2c7b95ca3b098ed0$export$9a2147b3808d4c6b = !(0, (0, parcelRequire("hZfwb")).default).domSupported ? $2c7b95ca3b098ed0$var$DEFAULT_LOCALE : function() {
        var langStr = (document.documentElement.lang || navigator.language || navigator.browserLanguage).toUpperCase();
        return langStr.indexOf($2c7b95ca3b098ed0$var$LOCALE_ZH) > -1 ? $2c7b95ca3b098ed0$var$LOCALE_ZH : $2c7b95ca3b098ed0$var$DEFAULT_LOCALE;
    }();
    function $2c7b95ca3b098ed0$export$bab6a7822cc1e2cd(locale, localeObj) {
        locale = locale.toUpperCase();
        $2c7b95ca3b098ed0$var$localeModels[locale] = new (0, (0, parcelRequire("gaMkj")).default)(localeObj);
        $2c7b95ca3b098ed0$var$localeStorage[locale] = localeObj;
    }
    function $2c7b95ca3b098ed0$export$ddc371781a6af754(locale) {
        if ((0, (0, parcelRequire("bahqM")).isString)(locale)) {
            var localeObj = $2c7b95ca3b098ed0$var$localeStorage[locale.toUpperCase()] || {};
            if (locale === $2c7b95ca3b098ed0$var$LOCALE_ZH || locale === $2c7b95ca3b098ed0$var$LOCALE_EN) return (0, (0, parcelRequire("bahqM")).clone)(localeObj);
            else return (0, (0, parcelRequire("bahqM")).merge)((0, (0, parcelRequire("bahqM")).clone)(localeObj), (0, (0, parcelRequire("bahqM")).clone)($2c7b95ca3b098ed0$var$localeStorage[$2c7b95ca3b098ed0$var$DEFAULT_LOCALE]), false);
        } else return (0, (0, parcelRequire("bahqM")).merge)((0, (0, parcelRequire("bahqM")).clone)(locale), (0, (0, parcelRequire("bahqM")).clone)($2c7b95ca3b098ed0$var$localeStorage[$2c7b95ca3b098ed0$var$DEFAULT_LOCALE]), false);
    }
    function $2c7b95ca3b098ed0$export$37cc638e0e11865f(lang) {
        return $2c7b95ca3b098ed0$var$localeModels[lang];
    }
    function $2c7b95ca3b098ed0$export$1188f179b2597821() {
        return $2c7b95ca3b098ed0$var$localeModels[$2c7b95ca3b098ed0$var$DEFAULT_LOCALE];
    }
    $2c7b95ca3b098ed0$export$bab6a7822cc1e2cd($2c7b95ca3b098ed0$var$LOCALE_EN, (0, (0, parcelRequire("dHSx1")).default));
    $2c7b95ca3b098ed0$export$bab6a7822cc1e2cd($2c7b95ca3b098ed0$var$LOCALE_ZH, (0, (0, parcelRequire("1VLoR")).default));
});
parcelRegister("dHSx1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9fa9975bdbfffeb9$export$2e2bcd8739ae039);
    var $9fa9975bdbfffeb9$export$2e2bcd8739ae039 = {
        time: {
            month: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ],
            monthAbbr: [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec'
            ],
            dayOfWeek: [
                'Sunday',
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday'
            ],
            dayOfWeekAbbr: [
                'Sun',
                'Mon',
                'Tue',
                'Wed',
                'Thu',
                'Fri',
                'Sat'
            ]
        },
        legend: {
            selector: {
                all: 'All',
                inverse: 'Inv'
            }
        },
        toolbox: {
            brush: {
                title: {
                    rect: 'Box Select',
                    polygon: 'Lasso Select',
                    lineX: 'Horizontally Select',
                    lineY: 'Vertically Select',
                    keep: 'Keep Selections',
                    clear: 'Clear Selections'
                }
            },
            dataView: {
                title: 'Data View',
                lang: [
                    'Data View',
                    'Close',
                    'Refresh'
                ]
            },
            dataZoom: {
                title: {
                    zoom: 'Zoom',
                    back: 'Zoom Reset'
                }
            },
            magicType: {
                title: {
                    line: 'Switch to Line Chart',
                    bar: 'Switch to Bar Chart',
                    stack: 'Stack',
                    tiled: 'Tile'
                }
            },
            restore: {
                title: 'Restore'
            },
            saveAsImage: {
                title: 'Save as Image',
                lang: [
                    'Right Click to Save Image'
                ]
            }
        },
        series: {
            typeNames: {
                pie: 'Pie chart',
                bar: 'Bar chart',
                line: 'Line chart',
                scatter: 'Scatter plot',
                effectScatter: 'Ripple scatter plot',
                radar: 'Radar chart',
                tree: 'Tree',
                treemap: 'Treemap',
                boxplot: 'Boxplot',
                candlestick: 'Candlestick',
                k: 'K line chart',
                heatmap: 'Heat map',
                map: 'Map',
                parallel: 'Parallel coordinate map',
                lines: 'Line graph',
                graph: 'Relationship graph',
                sankey: 'Sankey diagram',
                funnel: 'Funnel chart',
                gauge: 'Gauge',
                pictorialBar: 'Pictorial bar',
                themeRiver: 'Theme River Map',
                sunburst: 'Sunburst'
            }
        },
        aria: {
            general: {
                withTitle: 'This is a chart about "{title}"',
                withoutTitle: 'This is a chart'
            },
            series: {
                single: {
                    prefix: '',
                    withName: ' with type {seriesType} named {seriesName}.',
                    withoutName: ' with type {seriesType}.'
                },
                multiple: {
                    prefix: '. It consists of {seriesCount} series count.',
                    withName: ' The {seriesId} series is a {seriesType} representing {seriesName}.',
                    withoutName: ' The {seriesId} series is a {seriesType}.',
                    separator: {
                        middle: '',
                        end: ''
                    }
                }
            },
            data: {
                allData: 'The data is as follows: ',
                partialData: 'The first {displayCnt} items are: ',
                withName: 'the data for {name} is {value}',
                withoutName: '{value}',
                separator: {
                    middle: ', ',
                    end: '. '
                }
            }
        }
    };
});
parcelRegister("1VLoR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$167fe1fc3be0ec4c$export$2e2bcd8739ae039);
    var $167fe1fc3be0ec4c$export$2e2bcd8739ae039 = {
        time: {
            month: [
                "\u4E00\u6708",
                "\u4E8C\u6708",
                "\u4E09\u6708",
                "\u56DB\u6708",
                "\u4E94\u6708",
                "\u516D\u6708",
                "\u4E03\u6708",
                "\u516B\u6708",
                "\u4E5D\u6708",
                "\u5341\u6708",
                "\u5341\u4E00\u6708",
                "\u5341\u4E8C\u6708"
            ],
            monthAbbr: [
                "1\u6708",
                "2\u6708",
                "3\u6708",
                "4\u6708",
                "5\u6708",
                "6\u6708",
                "7\u6708",
                "8\u6708",
                "9\u6708",
                "10\u6708",
                "11\u6708",
                "12\u6708"
            ],
            dayOfWeek: [
                "\u661F\u671F\u65E5",
                "\u661F\u671F\u4E00",
                "\u661F\u671F\u4E8C",
                "\u661F\u671F\u4E09",
                "\u661F\u671F\u56DB",
                "\u661F\u671F\u4E94",
                "\u661F\u671F\u516D"
            ],
            dayOfWeekAbbr: [
                "\u65E5",
                "\u4E00",
                "\u4E8C",
                "\u4E09",
                "\u56DB",
                "\u4E94",
                "\u516D"
            ]
        },
        legend: {
            selector: {
                all: "\u5168\u9009",
                inverse: "\u53CD\u9009"
            }
        },
        toolbox: {
            brush: {
                title: {
                    rect: "\u77E9\u5F62\u9009\u62E9",
                    polygon: "\u5708\u9009",
                    lineX: "\u6A2A\u5411\u9009\u62E9",
                    lineY: "\u7EB5\u5411\u9009\u62E9",
                    keep: "\u4FDD\u6301\u9009\u62E9",
                    clear: "\u6E05\u9664\u9009\u62E9"
                }
            },
            dataView: {
                title: "\u6570\u636E\u89C6\u56FE",
                lang: [
                    "\u6570\u636E\u89C6\u56FE",
                    "\u5173\u95ED",
                    "\u5237\u65B0"
                ]
            },
            dataZoom: {
                title: {
                    zoom: "\u533A\u57DF\u7F29\u653E",
                    back: "\u533A\u57DF\u7F29\u653E\u8FD8\u539F"
                }
            },
            magicType: {
                title: {
                    line: "\u5207\u6362\u4E3A\u6298\u7EBF\u56FE",
                    bar: "\u5207\u6362\u4E3A\u67F1\u72B6\u56FE",
                    stack: "\u5207\u6362\u4E3A\u5806\u53E0",
                    tiled: "\u5207\u6362\u4E3A\u5E73\u94FA"
                }
            },
            restore: {
                title: "\u8FD8\u539F"
            },
            saveAsImage: {
                title: "\u4FDD\u5B58\u4E3A\u56FE\u7247",
                lang: [
                    "\u53F3\u952E\u53E6\u5B58\u4E3A\u56FE\u7247"
                ]
            }
        },
        series: {
            typeNames: {
                pie: "\u997C\u56FE",
                bar: "\u67F1\u72B6\u56FE",
                line: "\u6298\u7EBF\u56FE",
                scatter: "\u6563\u70B9\u56FE",
                effectScatter: "\u6D9F\u6F2A\u6563\u70B9\u56FE",
                radar: "\u96F7\u8FBE\u56FE",
                tree: "\u6811\u56FE",
                treemap: "\u77E9\u5F62\u6811\u56FE",
                boxplot: "\u7BB1\u578B\u56FE",
                candlestick: "K\u7EBF\u56FE",
                k: "K\u7EBF\u56FE",
                heatmap: "\u70ED\u529B\u56FE",
                map: "\u5730\u56FE",
                parallel: "\u5E73\u884C\u5750\u6807\u56FE",
                lines: "\u7EBF\u56FE",
                graph: "\u5173\u7CFB\u56FE",
                sankey: "\u6851\u57FA\u56FE",
                funnel: "\u6F0F\u6597\u56FE",
                gauge: "\u4EEA\u8868\u76D8\u56FE",
                pictorialBar: "\u8C61\u5F62\u67F1\u56FE",
                themeRiver: "\u4E3B\u9898\u6CB3\u6D41\u56FE",
                sunburst: "\u65ED\u65E5\u56FE"
            }
        },
        aria: {
            general: {
                withTitle: "\u8FD9\u662F\u4E00\u4E2A\u5173\u4E8E\u201C{title}\u201D\u7684\u56FE\u8868\u3002",
                withoutTitle: "\u8FD9\u662F\u4E00\u4E2A\u56FE\u8868\uFF0C"
            },
            series: {
                single: {
                    prefix: '',
                    withName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\uFF0C\u8868\u793A{seriesName}\u3002",
                    withoutName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\u3002"
                },
                multiple: {
                    prefix: "\u5B83\u7531{seriesCount}\u4E2A\u56FE\u8868\u7CFB\u5217\u7EC4\u6210\u3002",
                    withName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A\u8868\u793A{seriesName}\u7684{seriesType}\uFF0C",
                    withoutName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A{seriesType}\uFF0C",
                    separator: {
                        middle: "\uFF1B",
                        end: "\u3002"
                    }
                }
            },
            data: {
                allData: "\u5176\u6570\u636E\u662F\u2014\u2014",
                partialData: "\u5176\u4E2D\uFF0C\u524D{displayCnt}\u9879\u662F\u2014\u2014",
                withName: "{name}\u7684\u6570\u636E\u662F{value}",
                withoutName: '{value}',
                separator: {
                    middle: "\uFF0C",
                    end: ''
                }
            }
        }
    };
});
parcelRegister("2emZ2", function(module, exports) {
    $parcel$export(module.exports, "getTextRect", ()=>$19feb79b579d02ba$export$372ffda650a6e70d);
    var $4gEFv;
    var $2cFRc;
    function $19feb79b579d02ba$export$372ffda650a6e70d(text, font, align, verticalAlign, padding, rich, truncate, lineHeight) {
        (0, (0, parcelRequire("2cFRc")).deprecateLog)('getTextRect is deprecated.');
        var textEl = new (0, (0, parcelRequire("4gEFv")).default)({
            style: {
                text: text,
                font: font,
                align: align,
                verticalAlign: verticalAlign,
                padding: padding,
                rich: rich,
                overflow: truncate ? 'truncate' : null,
                lineHeight: lineHeight
            }
        });
        return textEl.getBoundingRect();
    }
});
parcelRegister("2cFRc", function(module, exports) {
    $parcel$export(module.exports, "warn", ()=>$19ad2baf23da1928$export$c106dd0671a0fc2d);
    $parcel$export(module.exports, "error", ()=>$19ad2baf23da1928$export$a3bc9b8ed74fc);
    $parcel$export(module.exports, "deprecateLog", ()=>$19ad2baf23da1928$export$4a9c0b74eb885aa1);
    $parcel$export(module.exports, "throwError", ()=>$19ad2baf23da1928$export$8bf7aba4a9e09055);
    var $19ad2baf23da1928$var$ECHARTS_PREFIX = '[ECharts] ';
    var $19ad2baf23da1928$var$storedLogs = {};
    var $19ad2baf23da1928$var$hasConsole = typeof console !== 'undefined' && console.warn && console.log;
    function $19ad2baf23da1928$export$bef1f36f5486a6a3(str) {
        if ($19ad2baf23da1928$var$hasConsole) console.log($19ad2baf23da1928$var$ECHARTS_PREFIX + str);
    }
    function $19ad2baf23da1928$export$c106dd0671a0fc2d(str) {
        if ($19ad2baf23da1928$var$hasConsole) console.warn($19ad2baf23da1928$var$ECHARTS_PREFIX + str);
    }
    function $19ad2baf23da1928$export$a3bc9b8ed74fc(str) {
        if ($19ad2baf23da1928$var$hasConsole) console.error($19ad2baf23da1928$var$ECHARTS_PREFIX + str);
    }
    function $19ad2baf23da1928$export$4a9c0b74eb885aa1(str) {}
    function $19ad2baf23da1928$export$bbd91d66002c4ea6(oldOpt, newOpt, scope) {}
    function $19ad2baf23da1928$export$c3747c611a35af25() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    }
    function $19ad2baf23da1928$export$a68bb8b222a6bd43() {
        var hintInfo = [];
        for(var _i = 0; _i < arguments.length; _i++)hintInfo[_i] = arguments[_i];
        var msg = '';
        var makePrintableStringIfPossible_1;
        return msg;
    }
    function $19ad2baf23da1928$export$8bf7aba4a9e09055(msg) {
        throw new Error(msg);
    }
});
parcelRegister("aCu4v", function(module, exports) {
    $parcel$export(module.exports, "PaletteMixin", ()=>$7bb4c79f78d718b0$export$55a3c39e852b90f4);
    $parcel$export(module.exports, "getDecalFromPalette", ()=>$7bb4c79f78d718b0$export$e4d892222945a227);
    var $eaKsF;
    var $7bb4c79f78d718b0$var$innerColor = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $7bb4c79f78d718b0$var$innerDecal = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $7bb4c79f78d718b0$export$55a3c39e852b90f4 = function() {
        function PaletteMixin() {}
        PaletteMixin.prototype.getColorFromPalette = function(name, scope, requestNum) {
            var defaultPalette = (0, (0, parcelRequire("eaKsF")).normalizeToArray)(this.get('color', true));
            var layeredPalette = this.get('colorLayer', true);
            return $7bb4c79f78d718b0$var$getFromPalette(this, $7bb4c79f78d718b0$var$innerColor, defaultPalette, layeredPalette, name, scope, requestNum);
        };
        PaletteMixin.prototype.clearColorPalette = function() {
            $7bb4c79f78d718b0$var$clearPalette(this, $7bb4c79f78d718b0$var$innerColor);
        };
        return PaletteMixin;
    }();
    function $7bb4c79f78d718b0$export$e4d892222945a227(ecModel, name, scope, requestNum) {
        var defaultDecals = (0, (0, parcelRequire("eaKsF")).normalizeToArray)(ecModel.get([
            'aria',
            'decal',
            'decals'
        ]));
        return $7bb4c79f78d718b0$var$getFromPalette(ecModel, $7bb4c79f78d718b0$var$innerDecal, defaultDecals, null, name, scope, requestNum);
    }
    function $7bb4c79f78d718b0$var$getNearestPalette(palettes, requestColorNum) {
        var paletteNum = palettes.length;
        for(var i = 0; i < paletteNum; i++){
            if (palettes[i].length > requestColorNum) return palettes[i];
        }
        return palettes[paletteNum - 1];
    }
    function $7bb4c79f78d718b0$var$getFromPalette(that, inner, defaultPalette, layeredPalette, name, scope, requestNum) {
        scope = scope || that;
        var scopeFields = inner(scope);
        var paletteIdx = scopeFields.paletteIdx || 0;
        var paletteNameMap = scopeFields.paletteNameMap = scopeFields.paletteNameMap || {};
        if (paletteNameMap.hasOwnProperty(name)) return paletteNameMap[name];
        var palette = requestNum == null || !layeredPalette ? defaultPalette : $7bb4c79f78d718b0$var$getNearestPalette(layeredPalette, requestNum);
        palette = palette || defaultPalette;
        if (!palette || !palette.length) return;
        var pickedPaletteItem = palette[paletteIdx];
        if (name) paletteNameMap[name] = pickedPaletteItem;
        scopeFields.paletteIdx = (paletteIdx + 1) % palette.length;
        return pickedPaletteItem;
    }
    function $7bb4c79f78d718b0$var$clearPalette(that, inner) {
        inner(that).paletteIdx = 0;
        inner(that).paletteNameMap = {};
    }
});
parcelRegister("guzSc", function(module, exports) {
    $parcel$export(module.exports, "DataFormatMixin", ()=>$c01b465ef25e12c0$export$f23396ae04ea95a7);
    $parcel$export(module.exports, "normalizeTooltipFormatResult", ()=>$c01b465ef25e12c0$export$2d16fa82a50c4741);
    var $bahqM;
    var $9OHWG;
    var $dCJrM;
    var $c01b465ef25e12c0$var$DIMENSION_LABEL_REG = /\{@(.+?)\}/g;
    var $c01b465ef25e12c0$export$f23396ae04ea95a7 = function() {
        function DataFormatMixin() {}
        DataFormatMixin.prototype.getDataParams = function(dataIndex, dataType) {
            var data = this.getData(dataType);
            var rawValue = this.getRawValue(dataIndex, dataType);
            var rawDataIndex = data.getRawIndex(dataIndex);
            var name = data.getName(dataIndex);
            var itemOpt = data.getRawDataItem(dataIndex);
            var style = data.getItemVisual(dataIndex, 'style');
            var color = style && style[data.getItemVisual(dataIndex, 'drawType') || 'fill'];
            var borderColor = style && style.stroke;
            var mainType = this.mainType;
            var isSeries = mainType === 'series';
            var userOutput = data.userOutput && data.userOutput.get();
            return {
                componentType: mainType,
                componentSubType: this.subType,
                componentIndex: this.componentIndex,
                seriesType: isSeries ? this.subType : null,
                seriesIndex: this.seriesIndex,
                seriesId: isSeries ? this.id : null,
                seriesName: isSeries ? this.name : null,
                name: name,
                dataIndex: rawDataIndex,
                data: itemOpt,
                dataType: dataType,
                value: rawValue,
                color: color,
                borderColor: borderColor,
                dimensionNames: userOutput ? userOutput.fullDimensions : null,
                encode: userOutput ? userOutput.encode : null,
                $vars: [
                    'seriesName',
                    'name',
                    'value'
                ]
            };
        };
        DataFormatMixin.prototype.getFormattedLabel = function(dataIndex, status, dataType, labelDimIndex, formatter, extendParams) {
            status = status || 'normal';
            var data = this.getData(dataType);
            var params = this.getDataParams(dataIndex, dataType);
            if (extendParams) params.value = extendParams.interpolatedValue;
            if (labelDimIndex != null && (0, parcelRequire("bahqM")).isArray(params.value)) params.value = params.value[labelDimIndex];
            if (!formatter) {
                var itemModel = data.getItemModel(dataIndex);
                formatter = itemModel.get(status === 'normal' ? [
                    'label',
                    'formatter'
                ] : [
                    status,
                    'label',
                    'formatter'
                ]);
            }
            if (typeof formatter === 'function') {
                params.status = status;
                params.dimensionIndex = labelDimIndex;
                return formatter(params);
            } else if (typeof formatter === 'string') {
                var str = (0, (0, parcelRequire("dCJrM")).formatTpl)(formatter, params);
                return str.replace($c01b465ef25e12c0$var$DIMENSION_LABEL_REG, function(origin, dimStr) {
                    var len = dimStr.length;
                    var dimLoose = dimStr;
                    if (dimLoose.charAt(0) === '[' && dimLoose.charAt(len - 1) === ']') dimLoose = +dimLoose.slice(1, len - 1);
                    var val = (0, (0, parcelRequire("9OHWG")).retrieveRawValue)(data, dataIndex, dimLoose);
                    if (extendParams && (0, parcelRequire("bahqM")).isArray(extendParams.interpolatedValue)) {
                        var dimIndex = data.getDimensionIndex(dimLoose);
                        if (dimIndex >= 0) val = extendParams.interpolatedValue[dimIndex];
                    }
                    return val != null ? val + '' : '';
                });
            }
        };
        DataFormatMixin.prototype.getRawValue = function(idx, dataType) {
            return (0, (0, parcelRequire("9OHWG")).retrieveRawValue)(this.getData(dataType), idx);
        };
        DataFormatMixin.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
            return;
        };
        return DataFormatMixin;
    }();
    function $c01b465ef25e12c0$export$2d16fa82a50c4741(result) {
        var markupText;
        var markupFragment;
        if ((0, parcelRequire("bahqM")).isObject(result)) {
            if (result.type) markupFragment = result;
        } else markupText = result;
        return {
            markupText: markupText,
            markupFragment: markupFragment
        };
    }
});
parcelRegister("9OHWG", function(module, exports) {
    $parcel$export(module.exports, "DefaultDataProvider", ()=>$725adf3ea01375e6$export$b900d7c4c3952a40);
    $parcel$export(module.exports, "getRawSourceItemGetter", ()=>$725adf3ea01375e6$export$92c8ea8642b3957d);
    $parcel$export(module.exports, "getRawSourceDataCounter", ()=>$725adf3ea01375e6$export$803742e832f4b52c);
    $parcel$export(module.exports, "getRawSourceValueGetter", ()=>$725adf3ea01375e6$export$1752de8084789a14);
    $parcel$export(module.exports, "retrieveRawValue", ()=>$725adf3ea01375e6$export$cde9373da9aad801);
    var $bahqM;
    var $eaKsF;
    var $20liu;
    var $2Rbm1;
    var $725adf3ea01375e6$var$_a, $725adf3ea01375e6$var$_b, $725adf3ea01375e6$var$_c;
    var $725adf3ea01375e6$var$providerMethods;
    var $725adf3ea01375e6$var$mountMethods;
    var $725adf3ea01375e6$export$b900d7c4c3952a40 = function() {
        function DefaultDataProvider(sourceParam, dimSize) {
            var source = !(0, (0, parcelRequire("20liu")).isSourceInstance)(sourceParam) ? (0, (0, parcelRequire("20liu")).createSourceFromSeriesDataOption)(sourceParam) : sourceParam;
            this._source = source;
            var data = this._data = source.data;
            if (source.sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_TYPED_ARRAY)) {
                this._offset = 0;
                this._dimSize = dimSize;
                this._data = data;
            }
            $725adf3ea01375e6$var$mountMethods(this, data, source);
        }
        DefaultDataProvider.prototype.getSource = function() {
            return this._source;
        };
        DefaultDataProvider.prototype.count = function() {
            return 0;
        };
        DefaultDataProvider.prototype.getItem = function(idx, out) {
            return;
        };
        DefaultDataProvider.prototype.appendData = function(newData) {};
        DefaultDataProvider.prototype.clean = function() {};
        DefaultDataProvider.protoInitialize = function() {
            var proto = DefaultDataProvider.prototype;
            proto.pure = false;
            proto.persistent = true;
        }();
        DefaultDataProvider.internalField = function() {
            var _a;
            $725adf3ea01375e6$var$mountMethods = function(provider, data, source) {
                var sourceFormat = source.sourceFormat;
                var seriesLayoutBy = source.seriesLayoutBy;
                var startIndex = source.startIndex;
                var dimsDef = source.dimensionsDefine;
                var methods = $725adf3ea01375e6$var$providerMethods[$725adf3ea01375e6$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
                (0, (0, parcelRequire("bahqM")).extend)(provider, methods);
                if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_TYPED_ARRAY)) {
                    provider.getItem = getItemForTypedArray;
                    provider.count = countForTypedArray;
                    provider.fillStorage = fillStorageForTypedArray;
                } else {
                    var rawItemGetter = $725adf3ea01375e6$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy);
                    provider.getItem = (0, (0, parcelRequire("bahqM")).bind)(rawItemGetter, null, data, startIndex, dimsDef);
                    var rawCounter = $725adf3ea01375e6$export$803742e832f4b52c(sourceFormat, seriesLayoutBy);
                    provider.count = (0, (0, parcelRequire("bahqM")).bind)(rawCounter, null, data, startIndex, dimsDef);
                }
            };
            var getItemForTypedArray = function(idx, out) {
                idx = idx - this._offset;
                out = out || [];
                var data = this._data;
                var dimSize = this._dimSize;
                var offset = dimSize * idx;
                for(var i = 0; i < dimSize; i++)out[i] = data[offset + i];
                return out;
            };
            var fillStorageForTypedArray = function(start, end, storage, extent) {
                var data = this._data;
                var dimSize = this._dimSize;
                for(var dim = 0; dim < dimSize; dim++){
                    var dimExtent = extent[dim];
                    var min = dimExtent[0] == null ? Infinity : dimExtent[0];
                    var max = dimExtent[1] == null ? -Infinity : dimExtent[1];
                    var count = end - start;
                    var arr = storage[dim];
                    for(var i = 0; i < count; i++){
                        var val = data[i * dimSize + dim];
                        arr[start + i] = val;
                        val < min && (min = val);
                        val > max && (max = val);
                    }
                    dimExtent[0] = min;
                    dimExtent[1] = max;
                }
            };
            var countForTypedArray = function() {
                return this._data ? this._data.length / this._dimSize : 0;
            };
            $725adf3ea01375e6$var$providerMethods = (_a = {}, _a[(0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_COLUMN)] = {
                pure: true,
                appendData: appendDataSimply
            }, _a[(0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_ROW)] = {
                pure: true,
                appendData: function() {
                    throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
                }
            }, _a[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS] = {
                pure: true,
                appendData: appendDataSimply
            }, _a[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_KEYED_COLUMNS] = {
                pure: true,
                appendData: function(newData) {
                    var data = this._data;
                    (0, (0, parcelRequire("bahqM")).each)(newData, function(newCol, key) {
                        var oldCol = data[key] || (data[key] = []);
                        for(var i = 0; i < (newCol || []).length; i++)oldCol.push(newCol[i]);
                    });
                }
            }, _a[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL] = {
                appendData: appendDataSimply
            }, _a[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_TYPED_ARRAY] = {
                persistent: false,
                pure: true,
                appendData: function(newData) {
                    this._data = newData;
                },
                clean: function() {
                    this._offset += this.count();
                    this._data = null;
                }
            }, _a);
            function appendDataSimply(newData) {
                for(var i = 0; i < newData.length; i++)this._data.push(newData[i]);
            }
        }();
        return DefaultDataProvider;
    }();
    var $725adf3ea01375e6$var$getItemSimply = function(rawData, startIndex, dimsDef, idx) {
        return rawData[idx];
    };
    var $725adf3ea01375e6$var$rawSourceItemGetterMap = ($725adf3ea01375e6$var$_a = {}, $725adf3ea01375e6$var$_a[(0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_COLUMN)] = function(rawData, startIndex, dimsDef, idx) {
        return rawData[idx + startIndex];
    }, $725adf3ea01375e6$var$_a[(0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_ROW)] = function(rawData, startIndex, dimsDef, idx, out) {
        idx += startIndex;
        var item = out || [];
        var data = rawData;
        for(var i = 0; i < data.length; i++){
            var row = data[i];
            item[i] = row ? row[idx] : null;
        }
        return item;
    }, $725adf3ea01375e6$var$_a[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS] = $725adf3ea01375e6$var$getItemSimply, $725adf3ea01375e6$var$_a[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_KEYED_COLUMNS] = function(rawData, startIndex, dimsDef, idx, out) {
        var item = out || [];
        for(var i = 0; i < dimsDef.length; i++){
            var dimName = dimsDef[i].name;
            var col = rawData[dimName];
            item[i] = col ? col[idx] : null;
        }
        return item;
    }, $725adf3ea01375e6$var$_a[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL] = $725adf3ea01375e6$var$getItemSimply, $725adf3ea01375e6$var$_a);
    function $725adf3ea01375e6$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy) {
        var method = $725adf3ea01375e6$var$rawSourceItemGetterMap[$725adf3ea01375e6$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
        return method;
    }
    var $725adf3ea01375e6$var$countSimply = function(rawData, startIndex, dimsDef) {
        return rawData.length;
    };
    var $725adf3ea01375e6$var$rawSourceDataCounterMap = ($725adf3ea01375e6$var$_b = {}, $725adf3ea01375e6$var$_b[(0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_COLUMN)] = function(rawData, startIndex, dimsDef) {
        return Math.max(0, rawData.length - startIndex);
    }, $725adf3ea01375e6$var$_b[(0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_ROW)] = function(rawData, startIndex, dimsDef) {
        var row = rawData[0];
        return row ? Math.max(0, row.length - startIndex) : 0;
    }, $725adf3ea01375e6$var$_b[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS] = $725adf3ea01375e6$var$countSimply, $725adf3ea01375e6$var$_b[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_KEYED_COLUMNS] = function(rawData, startIndex, dimsDef) {
        var dimName = dimsDef[0].name;
        var col = rawData[dimName];
        return col ? col.length : 0;
    }, $725adf3ea01375e6$var$_b[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL] = $725adf3ea01375e6$var$countSimply, $725adf3ea01375e6$var$_b);
    function $725adf3ea01375e6$export$803742e832f4b52c(sourceFormat, seriesLayoutBy) {
        var method = $725adf3ea01375e6$var$rawSourceDataCounterMap[$725adf3ea01375e6$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
        return method;
    }
    var $725adf3ea01375e6$var$getRawValueSimply = function(dataItem, dimIndex, property) {
        return dataItem[dimIndex];
    };
    var $725adf3ea01375e6$var$rawSourceValueGetterMap = ($725adf3ea01375e6$var$_c = {}, $725adf3ea01375e6$var$_c[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS] = $725adf3ea01375e6$var$getRawValueSimply, $725adf3ea01375e6$var$_c[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS] = function(dataItem, dimIndex, property) {
        return dataItem[property];
    }, $725adf3ea01375e6$var$_c[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_KEYED_COLUMNS] = $725adf3ea01375e6$var$getRawValueSimply, $725adf3ea01375e6$var$_c[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL] = function(dataItem, dimIndex, property) {
        var value = (0, (0, parcelRequire("eaKsF")).getDataItemValue)(dataItem);
        return !(value instanceof Array) ? value : value[dimIndex];
    }, $725adf3ea01375e6$var$_c[0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_TYPED_ARRAY] = $725adf3ea01375e6$var$getRawValueSimply, $725adf3ea01375e6$var$_c);
    function $725adf3ea01375e6$export$1752de8084789a14(sourceFormat) {
        var method = $725adf3ea01375e6$var$rawSourceValueGetterMap[sourceFormat];
        return method;
    }
    function $725adf3ea01375e6$var$getMethodMapKey(sourceFormat, seriesLayoutBy) {
        return sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS) ? sourceFormat + '_' + seriesLayoutBy : sourceFormat;
    }
    function $725adf3ea01375e6$export$cde9373da9aad801(data, dataIndex, dim) {
        if (!data) return;
        var dataItem = data.getRawDataItem(dataIndex);
        if (dataItem == null) return;
        var store = data.getStore();
        var sourceFormat = store.getSource().sourceFormat;
        if (dim != null) {
            var dimIndex = data.getDimensionIndex(dim);
            var property = store.getDimensionProperty(dimIndex);
            return $725adf3ea01375e6$export$1752de8084789a14(sourceFormat)(dataItem, dimIndex, property);
        } else {
            var result = dataItem;
            if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL)) result = (0, (0, parcelRequire("eaKsF")).getDataItemValue)(dataItem);
            return result;
        }
    }
    function $725adf3ea01375e6$export$c8ae9e77e0ddc42a(data, dataIndex, attr) {
        if (!data) return;
        var sourceFormat = data.getStore().getSource().sourceFormat;
        if (sourceFormat !== (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL) && sourceFormat !== (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS)) return;
        var dataItem = data.getRawDataItem(dataIndex);
        if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL) && !(0, (0, parcelRequire("bahqM")).isObject)(dataItem)) dataItem = null;
        if (dataItem) return dataItem[attr];
    }
});
parcelRegister("92IK1", function(module, exports) {
    $parcel$export(module.exports, "createTask", ()=>$6957019fc0d13ee5$export$f7292ab7796be73c);
    var $bahqM;
    function $6957019fc0d13ee5$export$f7292ab7796be73c(define) {
        return new $6957019fc0d13ee5$export$2dea7024bcdd7731(define);
    }
    var $6957019fc0d13ee5$export$2dea7024bcdd7731 = function() {
        function Task(define) {
            define = define || {};
            this._reset = define.reset;
            this._plan = define.plan;
            this._count = define.count;
            this._onDirty = define.onDirty;
            this._dirty = true;
        }
        Task.prototype.perform = function(performArgs) {
            var upTask = this._upstream;
            var skip = performArgs && performArgs.skip;
            if (this._dirty && upTask) {
                var context = this.context;
                context.data = context.outputData = upTask.context.outputData;
            }
            if (this.__pipeline) this.__pipeline.currentTask = this;
            var planResult;
            if (this._plan && !skip) planResult = this._plan(this.context);
            var lastModBy = normalizeModBy(this._modBy);
            var lastModDataCount = this._modDataCount || 0;
            var modBy = normalizeModBy(performArgs && performArgs.modBy);
            var modDataCount = performArgs && performArgs.modDataCount || 0;
            if (lastModBy !== modBy || lastModDataCount !== modDataCount) planResult = 'reset';
            function normalizeModBy(val) {
                !(val >= 1) && (val = 1);
                return val;
            }
            var forceFirstProgress;
            if (this._dirty || planResult === 'reset') {
                this._dirty = false;
                forceFirstProgress = this._doReset(skip);
            }
            this._modBy = modBy;
            this._modDataCount = modDataCount;
            var step = performArgs && performArgs.step;
            if (upTask) this._dueEnd = upTask._outputDueEnd;
            else this._dueEnd = this._count ? this._count(this.context) : Infinity;
            if (this._progress) {
                var start = this._dueIndex;
                var end = Math.min(step != null ? this._dueIndex + step : Infinity, this._dueEnd);
                if (!skip && (forceFirstProgress || start < end)) {
                    var progress = this._progress;
                    if ((0, (0, parcelRequire("bahqM")).isArray)(progress)) for(var i = 0; i < progress.length; i++)this._doProgress(progress[i], start, end, modBy, modDataCount);
                    else this._doProgress(progress, start, end, modBy, modDataCount);
                }
                this._dueIndex = end;
                var outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : end;
                this._outputDueEnd = outputDueEnd;
            } else this._dueIndex = this._outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : this._dueEnd;
            return this.unfinished();
        };
        Task.prototype.dirty = function() {
            this._dirty = true;
            this._onDirty && this._onDirty(this.context);
        };
        Task.prototype._doProgress = function(progress, start, end, modBy, modDataCount) {
            $6957019fc0d13ee5$var$iterator.reset(start, end, modBy, modDataCount);
            this._callingProgress = progress;
            this._callingProgress({
                start: start,
                end: end,
                count: end - start,
                next: $6957019fc0d13ee5$var$iterator.next
            }, this.context);
        };
        Task.prototype._doReset = function(skip) {
            this._dueIndex = this._outputDueEnd = this._dueEnd = 0;
            this._settedOutputEnd = null;
            var progress;
            var forceFirstProgress;
            if (!skip && this._reset) {
                progress = this._reset(this.context);
                if (progress && progress.progress) {
                    forceFirstProgress = progress.forceFirstProgress;
                    progress = progress.progress;
                }
                if ((0, (0, parcelRequire("bahqM")).isArray)(progress) && !progress.length) progress = null;
            }
            this._progress = progress;
            this._modBy = this._modDataCount = null;
            var downstream = this._downstream;
            downstream && downstream.dirty();
            return forceFirstProgress;
        };
        Task.prototype.unfinished = function() {
            return this._progress && this._dueIndex < this._dueEnd;
        };
        Task.prototype.pipe = function(downTask) {
            if (this._downstream !== downTask || this._dirty) {
                this._downstream = downTask;
                downTask._upstream = this;
                downTask.dirty();
            }
        };
        Task.prototype.dispose = function() {
            if (this._disposed) return;
            this._upstream && (this._upstream._downstream = null);
            this._downstream && (this._downstream._upstream = null);
            this._dirty = false;
            this._disposed = true;
        };
        Task.prototype.getUpstream = function() {
            return this._upstream;
        };
        Task.prototype.getDownstream = function() {
            return this._downstream;
        };
        Task.prototype.setOutputEnd = function(end) {
            this._outputDueEnd = this._settedOutputEnd = end;
        };
        return Task;
    }();
    var $6957019fc0d13ee5$var$iterator = function() {
        var end;
        var current;
        var modBy;
        var modDataCount;
        var winCount;
        var it = {
            reset: function(s, e, sStep, sCount) {
                current = s;
                end = e;
                modBy = sStep;
                modDataCount = sCount;
                winCount = Math.ceil(modDataCount / modBy);
                it.next = modBy > 1 && modDataCount > 0 ? modNext : sequentialNext;
            }
        };
        return it;
        function sequentialNext() {
            return current < end ? current++ : null;
        }
        function modNext() {
            var dataIndex = current % winCount * modBy + Math.ceil(current / winCount);
            var result = current >= end ? null : dataIndex < modDataCount ? dataIndex : current;
            current++;
            return result;
        }
    }();
});
parcelRegister("jTNWo", function(module, exports) {
    $parcel$export(module.exports, "SourceManager", ()=>$e7c9e4985e212cda$export$af4db9ec7e200ea2);
    $parcel$export(module.exports, "disableTransformOptionMerge", ()=>$e7c9e4985e212cda$export$9451f4e9047441ec);
    var $bahqM;
    var $20liu;
    var $2Rbm1;
    var $cNGs8;
    var $05ab4;
    var $8c3gC;
    var $9OHWG;
    var $e7c9e4985e212cda$export$af4db9ec7e200ea2 = function() {
        function SourceManager(sourceHost) {
            this._sourceList = [];
            this._storeList = [];
            this._upstreamSignList = [];
            this._versionSignBase = 0;
            this._dirty = true;
            this._sourceHost = sourceHost;
        }
        SourceManager.prototype.dirty = function() {
            this._setLocalSource([], []);
            this._storeList = [];
            this._dirty = true;
        };
        SourceManager.prototype._setLocalSource = function(sourceList, upstreamSignList) {
            this._sourceList = sourceList;
            this._upstreamSignList = upstreamSignList;
            this._versionSignBase++;
            if (this._versionSignBase > 9e10) this._versionSignBase = 0;
        };
        SourceManager.prototype._getVersionSign = function() {
            return this._sourceHost.uid + '_' + this._versionSignBase;
        };
        SourceManager.prototype.prepareSource = function() {
            if (this._isDirty()) {
                this._createSource();
                this._dirty = false;
            }
        };
        SourceManager.prototype._createSource = function() {
            this._setLocalSource([], []);
            var sourceHost = this._sourceHost;
            var upSourceMgrList = this._getUpstreamSourceManagers();
            var hasUpstream = !!upSourceMgrList.length;
            var resultSourceList;
            var upstreamSignList;
            if ($e7c9e4985e212cda$var$isSeries(sourceHost)) {
                var seriesModel = sourceHost;
                var data = void 0;
                var sourceFormat = void 0;
                var upSource = void 0;
                if (hasUpstream) {
                    var upSourceMgr = upSourceMgrList[0];
                    upSourceMgr.prepareSource();
                    upSource = upSourceMgr.getSource();
                    data = upSource.data;
                    sourceFormat = upSource.sourceFormat;
                    upstreamSignList = [
                        upSourceMgr._getVersionSign()
                    ];
                } else {
                    data = seriesModel.get('data', true);
                    sourceFormat = (0, (0, parcelRequire("bahqM")).isTypedArray)(data) ? (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_TYPED_ARRAY) : (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL);
                    upstreamSignList = [];
                }
                var newMetaRawOption = this._getSourceMetaRawOption() || {};
                var upMetaRawOption = upSource && upSource.metaRawOption || {};
                var seriesLayoutBy = (0, (0, parcelRequire("bahqM")).retrieve2)(newMetaRawOption.seriesLayoutBy, upMetaRawOption.seriesLayoutBy) || null;
                var sourceHeader = (0, (0, parcelRequire("bahqM")).retrieve2)(newMetaRawOption.sourceHeader, upMetaRawOption.sourceHeader) || null;
                var dimensions = (0, (0, parcelRequire("bahqM")).retrieve2)(newMetaRawOption.dimensions, upMetaRawOption.dimensions);
                var needsCreateSource = seriesLayoutBy !== upMetaRawOption.seriesLayoutBy || !!sourceHeader !== !!upMetaRawOption.sourceHeader || dimensions;
                resultSourceList = needsCreateSource ? [
                    (0, (0, parcelRequire("20liu")).createSource)(data, {
                        seriesLayoutBy: seriesLayoutBy,
                        sourceHeader: sourceHeader,
                        dimensions: dimensions
                    }, sourceFormat)
                ] : [];
            } else {
                var datasetModel = sourceHost;
                if (hasUpstream) {
                    var result = this._applyTransform(upSourceMgrList);
                    resultSourceList = result.sourceList;
                    upstreamSignList = result.upstreamSignList;
                } else {
                    var sourceData = datasetModel.get('source', true);
                    resultSourceList = [
                        (0, (0, parcelRequire("20liu")).createSource)(sourceData, this._getSourceMetaRawOption(), null)
                    ];
                    upstreamSignList = [];
                }
            }
            this._setLocalSource(resultSourceList, upstreamSignList);
        };
        SourceManager.prototype._applyTransform = function(upMgrList) {
            var datasetModel = this._sourceHost;
            var transformOption = datasetModel.get('transform', true);
            var fromTransformResult = datasetModel.get('fromTransformResult', true);
            if (fromTransformResult != null) {
                var errMsg = '';
                if (upMgrList.length !== 1) $e7c9e4985e212cda$var$doThrow(errMsg);
            }
            var sourceList;
            var upSourceList = [];
            var upstreamSignList = [];
            (0, (0, parcelRequire("bahqM")).each)(upMgrList, function(upMgr) {
                upMgr.prepareSource();
                var upSource = upMgr.getSource(fromTransformResult || 0);
                var errMsg = '';
                if (fromTransformResult != null && !upSource) $e7c9e4985e212cda$var$doThrow(errMsg);
                upSourceList.push(upSource);
                upstreamSignList.push(upMgr._getVersionSign());
            });
            if (transformOption) sourceList = (0, (0, parcelRequire("05ab4")).applyDataTransform)(transformOption, upSourceList, {
                datasetIndex: datasetModel.componentIndex
            });
            else if (fromTransformResult != null) sourceList = [
                (0, (0, parcelRequire("20liu")).cloneSourceShallow)(upSourceList[0])
            ];
            return {
                sourceList: sourceList,
                upstreamSignList: upstreamSignList
            };
        };
        SourceManager.prototype._isDirty = function() {
            if (this._dirty) return true;
            var upSourceMgrList = this._getUpstreamSourceManagers();
            for(var i = 0; i < upSourceMgrList.length; i++){
                var upSrcMgr = upSourceMgrList[i];
                if (upSrcMgr._isDirty() || this._upstreamSignList[i] !== upSrcMgr._getVersionSign()) return true;
            }
        };
        SourceManager.prototype.getSource = function(sourceIndex) {
            sourceIndex = sourceIndex || 0;
            var source = this._sourceList[sourceIndex];
            if (!source) {
                var upSourceMgrList = this._getUpstreamSourceManagers();
                return upSourceMgrList[0] && upSourceMgrList[0].getSource(sourceIndex);
            }
            return source;
        };
        SourceManager.prototype.getSharedDataStore = function(seriesDimRequest) {
            var schema = seriesDimRequest.makeStoreSchema();
            return this._innerGetDataStore(schema.dimensions, seriesDimRequest.source, schema.hash);
        };
        SourceManager.prototype._innerGetDataStore = function(storeDims, seriesSource, sourceReadKey) {
            var sourceIndex = 0;
            var storeList = this._storeList;
            var cachedStoreMap = storeList[sourceIndex];
            if (!cachedStoreMap) cachedStoreMap = storeList[sourceIndex] = {};
            var cachedStore = cachedStoreMap[sourceReadKey];
            if (!cachedStore) {
                var upSourceMgr = this._getUpstreamSourceManagers()[0];
                if ($e7c9e4985e212cda$var$isSeries(this._sourceHost) && upSourceMgr) cachedStore = upSourceMgr._innerGetDataStore(storeDims, seriesSource, sourceReadKey);
                else {
                    cachedStore = new (0, (0, parcelRequire("8c3gC")).default)();
                    cachedStore.initData(new (0, (0, parcelRequire("9OHWG")).DefaultDataProvider)(seriesSource, storeDims.length), storeDims);
                }
                cachedStoreMap[sourceReadKey] = cachedStore;
            }
            return cachedStore;
        };
        SourceManager.prototype._getUpstreamSourceManagers = function() {
            var sourceHost = this._sourceHost;
            if ($e7c9e4985e212cda$var$isSeries(sourceHost)) {
                var datasetModel = (0, (0, parcelRequire("cNGs8")).querySeriesUpstreamDatasetModel)(sourceHost);
                return !datasetModel ? [] : [
                    datasetModel.getSourceManager()
                ];
            } else return (0, (0, parcelRequire("bahqM")).map)((0, (0, parcelRequire("cNGs8")).queryDatasetUpstreamDatasetModels)(sourceHost), function(datasetModel) {
                return datasetModel.getSourceManager();
            });
        };
        SourceManager.prototype._getSourceMetaRawOption = function() {
            var sourceHost = this._sourceHost;
            var seriesLayoutBy;
            var sourceHeader;
            var dimensions;
            if ($e7c9e4985e212cda$var$isSeries(sourceHost)) {
                seriesLayoutBy = sourceHost.get('seriesLayoutBy', true);
                sourceHeader = sourceHost.get('sourceHeader', true);
                dimensions = sourceHost.get('dimensions', true);
            } else if (!this._getUpstreamSourceManagers().length) {
                var model = sourceHost;
                seriesLayoutBy = model.get('seriesLayoutBy', true);
                sourceHeader = model.get('sourceHeader', true);
                dimensions = model.get('dimensions', true);
            }
            return {
                seriesLayoutBy: seriesLayoutBy,
                sourceHeader: sourceHeader,
                dimensions: dimensions
            };
        };
        return SourceManager;
    }();
    function $e7c9e4985e212cda$export$9451f4e9047441ec(datasetModel) {
        var transformOption = datasetModel.option.transform;
        transformOption && (0, (0, parcelRequire("bahqM")).setAsPrimitive)(datasetModel.option.transform);
    }
    function $e7c9e4985e212cda$var$isSeries(sourceHost) {
        return sourceHost.mainType === 'series';
    }
    function $e7c9e4985e212cda$var$doThrow(errMsg) {
        throw new Error(errMsg);
    }
});
parcelRegister("05ab4", function(module, exports) {
    $parcel$export(module.exports, "registerExternalTransform", ()=>$00f85ccb3288f539$export$92c96c6d8b255b7d);
    $parcel$export(module.exports, "applyDataTransform", ()=>$00f85ccb3288f539$export$42a68f09db16803f);
    var $2Rbm1;
    var $eaKsF;
    var $bahqM;
    var $9OHWG;
    var $2G90t;
    var $2cFRc;
    var $20liu;
    var $00f85ccb3288f539$export$ffc19e40a21f08eb = function() {
        function ExternalSource() {}
        ExternalSource.prototype.getRawData = function() {
            throw new Error('not supported');
        };
        ExternalSource.prototype.getRawDataItem = function(dataIndex) {
            throw new Error('not supported');
        };
        ExternalSource.prototype.cloneRawData = function() {
            return;
        };
        ExternalSource.prototype.getDimensionInfo = function(dim) {
            return;
        };
        ExternalSource.prototype.cloneAllDimensionInfo = function() {
            return;
        };
        ExternalSource.prototype.count = function() {
            return;
        };
        ExternalSource.prototype.retrieveValue = function(dataIndex, dimIndex) {
            return;
        };
        ExternalSource.prototype.retrieveValueFromItem = function(dataItem, dimIndex) {
            return;
        };
        ExternalSource.prototype.convertValue = function(rawVal, dimInfo) {
            return (0, (0, parcelRequire("2G90t")).parseDataValue)(rawVal, dimInfo);
        };
        return ExternalSource;
    }();
    function $00f85ccb3288f539$var$createExternalSource(internalSource, externalTransform) {
        var extSource = new $00f85ccb3288f539$export$ffc19e40a21f08eb();
        var data = internalSource.data;
        var sourceFormat = extSource.sourceFormat = internalSource.sourceFormat;
        var sourceHeaderCount = internalSource.startIndex;
        var errMsg = '';
        if (internalSource.seriesLayoutBy !== (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_COLUMN)) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
        var dimensions = [];
        var dimsByName = {};
        var dimsDef = internalSource.dimensionsDefine;
        if (dimsDef) (0, (0, parcelRequire("bahqM")).each)(dimsDef, function(dimDef, idx) {
            var name = dimDef.name;
            var dimDefExt = {
                index: idx,
                name: name,
                displayName: dimDef.displayName
            };
            dimensions.push(dimDefExt);
            if (name != null) {
                var errMsg_1 = '';
                if ((0, (0, parcelRequire("bahqM")).hasOwn)(dimsByName, name)) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg_1);
                dimsByName[name] = dimDefExt;
            }
        });
        else for(var i = 0; i < internalSource.dimensionsDetectedCount || 0; i++)dimensions.push({
            index: i
        });
        var rawItemGetter = (0, (0, parcelRequire("9OHWG")).getRawSourceItemGetter)(sourceFormat, (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_COLUMN));
        if (externalTransform.__isBuiltIn) {
            extSource.getRawDataItem = function(dataIndex) {
                return rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
            };
            extSource.getRawData = (0, (0, parcelRequire("bahqM")).bind)($00f85ccb3288f539$var$getRawData, null, internalSource);
        }
        extSource.cloneRawData = (0, (0, parcelRequire("bahqM")).bind)($00f85ccb3288f539$var$cloneRawData, null, internalSource);
        var rawCounter = (0, (0, parcelRequire("9OHWG")).getRawSourceDataCounter)(sourceFormat, (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_COLUMN));
        extSource.count = (0, (0, parcelRequire("bahqM")).bind)(rawCounter, null, data, sourceHeaderCount, dimensions);
        var rawValueGetter = (0, (0, parcelRequire("9OHWG")).getRawSourceValueGetter)(sourceFormat);
        extSource.retrieveValue = function(dataIndex, dimIndex) {
            var rawItem = rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
            return retrieveValueFromItem(rawItem, dimIndex);
        };
        var retrieveValueFromItem = extSource.retrieveValueFromItem = function(dataItem, dimIndex) {
            if (dataItem == null) return;
            var dimDef = dimensions[dimIndex];
            if (dimDef) return rawValueGetter(dataItem, dimIndex, dimDef.name);
        };
        extSource.getDimensionInfo = (0, (0, parcelRequire("bahqM")).bind)($00f85ccb3288f539$var$getDimensionInfo, null, dimensions, dimsByName);
        extSource.cloneAllDimensionInfo = (0, (0, parcelRequire("bahqM")).bind)($00f85ccb3288f539$var$cloneAllDimensionInfo, null, dimensions);
        return extSource;
    }
    function $00f85ccb3288f539$var$getRawData(upstream) {
        var sourceFormat = upstream.sourceFormat;
        if (!$00f85ccb3288f539$var$isSupportedSourceFormat(sourceFormat)) {
            var errMsg = '';
            (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
        }
        return upstream.data;
    }
    function $00f85ccb3288f539$var$cloneRawData(upstream) {
        var sourceFormat = upstream.sourceFormat;
        var data = upstream.data;
        if (!$00f85ccb3288f539$var$isSupportedSourceFormat(sourceFormat)) {
            var errMsg = '';
            (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
        }
        if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS)) {
            var result = [];
            for(var i = 0, len = data.length; i < len; i++)result.push(data[i].slice());
            return result;
        } else if (sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS)) {
            var result = [];
            for(var i = 0, len = data.length; i < len; i++)result.push((0, (0, parcelRequire("bahqM")).extend)({}, data[i]));
            return result;
        }
    }
    function $00f85ccb3288f539$var$getDimensionInfo(dimensions, dimsByName, dim) {
        if (dim == null) return;
        if (typeof dim === 'number' || !isNaN(dim) && !(0, (0, parcelRequire("bahqM")).hasOwn)(dimsByName, dim)) return dimensions[dim];
        else if ((0, (0, parcelRequire("bahqM")).hasOwn)(dimsByName, dim)) return dimsByName[dim];
    }
    function $00f85ccb3288f539$var$cloneAllDimensionInfo(dimensions) {
        return (0, (0, parcelRequire("bahqM")).clone)(dimensions);
    }
    var $00f85ccb3288f539$var$externalTransformMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
    function $00f85ccb3288f539$export$92c96c6d8b255b7d(externalTransform) {
        externalTransform = (0, (0, parcelRequire("bahqM")).clone)(externalTransform);
        var type = externalTransform.type;
        var errMsg = '';
        if (!type) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
        var typeParsed = type.split(':');
        if (typeParsed.length !== 2) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
        var isBuiltIn = false;
        if (typeParsed[0] === 'echarts') {
            type = typeParsed[1];
            isBuiltIn = true;
        }
        externalTransform.__isBuiltIn = isBuiltIn;
        $00f85ccb3288f539$var$externalTransformMap.set(type, externalTransform);
    }
    function $00f85ccb3288f539$export$42a68f09db16803f(rawTransOption, sourceList, infoForPrint) {
        var pipedTransOption = (0, (0, parcelRequire("eaKsF")).normalizeToArray)(rawTransOption);
        var pipeLen = pipedTransOption.length;
        var errMsg = '';
        if (!pipeLen) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
        for(var i = 0, len = pipeLen; i < len; i++){
            var transOption = pipedTransOption[i];
            sourceList = $00f85ccb3288f539$var$applySingleDataTransform(transOption, sourceList, infoForPrint, pipeLen === 1 ? null : i);
            if (i !== len - 1) sourceList.length = Math.max(sourceList.length, 1);
        }
        return sourceList;
    }
    function $00f85ccb3288f539$var$applySingleDataTransform(transOption, upSourceList, infoForPrint, pipeIndex) {
        var errMsg = '';
        if (!upSourceList.length) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
        if (!(0, (0, parcelRequire("bahqM")).isObject)(transOption)) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
        var transType = transOption.type;
        var externalTransform = $00f85ccb3288f539$var$externalTransformMap.get(transType);
        if (!externalTransform) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
        var extUpSourceList = (0, (0, parcelRequire("bahqM")).map)(upSourceList, function(upSource) {
            return $00f85ccb3288f539$var$createExternalSource(upSource, externalTransform);
        });
        var resultList = (0, (0, parcelRequire("eaKsF")).normalizeToArray)(externalTransform.transform({
            upstream: extUpSourceList[0],
            upstreamList: extUpSourceList,
            config: (0, (0, parcelRequire("bahqM")).clone)(transOption.config)
        }));
        var printStrArr;
        return (0, (0, parcelRequire("bahqM")).map)(resultList, function(result, resultIndex) {
            var errMsg = '';
            if (!(0, (0, parcelRequire("bahqM")).isObject)(result)) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
            if (!result.data) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
            var sourceFormat = (0, (0, parcelRequire("20liu")).detectSourceFormat)(result.data);
            if (!$00f85ccb3288f539$var$isSupportedSourceFormat(sourceFormat)) (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
            var resultMetaRawOption;
            var firstUpSource = upSourceList[0];
            if (firstUpSource && resultIndex === 0 && !result.dimensions) {
                var startIndex = firstUpSource.startIndex;
                if (startIndex) result.data = firstUpSource.data.slice(0, startIndex).concat(result.data);
                resultMetaRawOption = {
                    seriesLayoutBy: (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_COLUMN),
                    sourceHeader: startIndex,
                    dimensions: firstUpSource.metaRawOption.dimensions
                };
            } else resultMetaRawOption = {
                seriesLayoutBy: (0, (0, parcelRequire("2Rbm1")).SERIES_LAYOUT_BY_COLUMN),
                sourceHeader: 0,
                dimensions: result.dimensions
            };
            return (0, (0, parcelRequire("20liu")).createSource)(result.data, resultMetaRawOption, null);
        });
    }
    function $00f85ccb3288f539$var$isSupportedSourceFormat(sourceFormat) {
        return sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ARRAY_ROWS) || sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_OBJECT_ROWS);
    }
});
parcelRegister("2G90t", function(module, exports) {
    $parcel$export(module.exports, "parseDataValue", ()=>$1f367d921e7af2c3$export$cc7175145baad076);
    $parcel$export(module.exports, "getRawValueParser", ()=>$1f367d921e7af2c3$export$c88237b7c265b36b);
    $parcel$export(module.exports, "SortOrderComparator", ()=>$1f367d921e7af2c3$export$ed75a5d7b0144167);
    $parcel$export(module.exports, "createFilterComparator", ()=>$1f367d921e7af2c3$export$f2644c3485f94c4e);
    var $jmSNG;
    var $bahqM;
    var $2cFRc;
    function $1f367d921e7af2c3$export$cc7175145baad076(value, opt) {
        var dimType = opt && opt.type;
        if (dimType === 'ordinal') return value;
        if (dimType === 'time' && typeof value !== 'number' && value != null && value !== '-') value = +(0, (0, parcelRequire("jmSNG")).parseDate)(value);
        return value == null || value === '' ? NaN : +value;
    }
    var $1f367d921e7af2c3$var$valueParserMap = (0, (0, parcelRequire("bahqM")).createHashMap)({
        'number': function(val) {
            return parseFloat(val);
        },
        'time': function(val) {
            return +(0, (0, parcelRequire("jmSNG")).parseDate)(val);
        },
        'trim': function(val) {
            return typeof val === 'string' ? (0, (0, parcelRequire("bahqM")).trim)(val) : val;
        }
    });
    function $1f367d921e7af2c3$export$c88237b7c265b36b(type) {
        return $1f367d921e7af2c3$var$valueParserMap.get(type);
    }
    var $1f367d921e7af2c3$var$ORDER_COMPARISON_OP_MAP = {
        lt: function(lval, rval) {
            return lval < rval;
        },
        lte: function(lval, rval) {
            return lval <= rval;
        },
        gt: function(lval, rval) {
            return lval > rval;
        },
        gte: function(lval, rval) {
            return lval >= rval;
        }
    };
    var $1f367d921e7af2c3$var$FilterOrderComparator = function() {
        function FilterOrderComparator(op, rval) {
            if (typeof rval !== 'number') {
                var errMsg = '';
                (0, (0, parcelRequire("2cFRc")).throwError)(errMsg);
            }
            this._opFn = $1f367d921e7af2c3$var$ORDER_COMPARISON_OP_MAP[op];
            this._rvalFloat = (0, (0, parcelRequire("jmSNG")).numericToNumber)(rval);
        }
        FilterOrderComparator.prototype.evaluate = function(lval) {
            return typeof lval === 'number' ? this._opFn(lval, this._rvalFloat) : this._opFn((0, (0, parcelRequire("jmSNG")).numericToNumber)(lval), this._rvalFloat);
        };
        return FilterOrderComparator;
    }();
    var $1f367d921e7af2c3$export$ed75a5d7b0144167 = function() {
        function SortOrderComparator(order, incomparable) {
            var isDesc = order === 'desc';
            this._resultLT = isDesc ? 1 : -1;
            if (incomparable == null) incomparable = isDesc ? 'min' : 'max';
            this._incomparable = incomparable === 'min' ? -Infinity : Infinity;
        }
        SortOrderComparator.prototype.evaluate = function(lval, rval) {
            var lvalTypeof = typeof lval;
            var rvalTypeof = typeof rval;
            var lvalFloat = lvalTypeof === 'number' ? lval : (0, (0, parcelRequire("jmSNG")).numericToNumber)(lval);
            var rvalFloat = rvalTypeof === 'number' ? rval : (0, (0, parcelRequire("jmSNG")).numericToNumber)(rval);
            var lvalNotNumeric = isNaN(lvalFloat);
            var rvalNotNumeric = isNaN(rvalFloat);
            if (lvalNotNumeric) lvalFloat = this._incomparable;
            if (rvalNotNumeric) rvalFloat = this._incomparable;
            if (lvalNotNumeric && rvalNotNumeric) {
                var lvalIsStr = lvalTypeof === 'string';
                var rvalIsStr = rvalTypeof === 'string';
                if (lvalIsStr) lvalFloat = rvalIsStr ? lval : 0;
                if (rvalIsStr) rvalFloat = lvalIsStr ? rval : 0;
            }
            return lvalFloat < rvalFloat ? this._resultLT : lvalFloat > rvalFloat ? -this._resultLT : 0;
        };
        return SortOrderComparator;
    }();
    var $1f367d921e7af2c3$var$FilterEqualityComparator = function() {
        function FilterEqualityComparator(isEq, rval) {
            this._rval = rval;
            this._isEQ = isEq;
            this._rvalTypeof = typeof rval;
            this._rvalFloat = (0, (0, parcelRequire("jmSNG")).numericToNumber)(rval);
        }
        FilterEqualityComparator.prototype.evaluate = function(lval) {
            var eqResult = lval === this._rval;
            if (!eqResult) {
                var lvalTypeof = typeof lval;
                if (lvalTypeof !== this._rvalTypeof && (lvalTypeof === 'number' || this._rvalTypeof === 'number')) eqResult = (0, (0, parcelRequire("jmSNG")).numericToNumber)(lval) === this._rvalFloat;
            }
            return this._isEQ ? eqResult : !eqResult;
        };
        return FilterEqualityComparator;
    }();
    function $1f367d921e7af2c3$export$f2644c3485f94c4e(op, rval) {
        return op === 'eq' || op === 'ne' ? new $1f367d921e7af2c3$var$FilterEqualityComparator(op === 'eq', rval) : (0, (0, parcelRequire("bahqM")).hasOwn)($1f367d921e7af2c3$var$ORDER_COMPARISON_OP_MAP, op) ? new $1f367d921e7af2c3$var$FilterOrderComparator(op, rval) : null;
    }
});
parcelRegister("8c3gC", function(module, exports) {
    $parcel$export(module.exports, "CtorInt32Array", ()=>$5f71fa7e68f8e2cf$export$b60d945128546f53);
    $parcel$export(module.exports, "default", ()=>$5f71fa7e68f8e2cf$export$2e2bcd8739ae039);
    var $bahqM;
    var $2G90t;
    var $20liu;
    var $5f71fa7e68f8e2cf$var$UNDEFINED = 'undefined';
    var $5f71fa7e68f8e2cf$export$859a1fa4f1106aa0 = typeof Uint32Array === $5f71fa7e68f8e2cf$var$UNDEFINED ? Array : Uint32Array;
    var $5f71fa7e68f8e2cf$export$78cf73566f32c185 = typeof Uint16Array === $5f71fa7e68f8e2cf$var$UNDEFINED ? Array : Uint16Array;
    var $5f71fa7e68f8e2cf$export$b60d945128546f53 = typeof Int32Array === $5f71fa7e68f8e2cf$var$UNDEFINED ? Array : Int32Array;
    var $5f71fa7e68f8e2cf$export$365b104db51a490a = typeof Float64Array === $5f71fa7e68f8e2cf$var$UNDEFINED ? Array : Float64Array;
    var $5f71fa7e68f8e2cf$var$dataCtors = {
        'float': $5f71fa7e68f8e2cf$export$365b104db51a490a,
        'int': $5f71fa7e68f8e2cf$export$b60d945128546f53,
        'ordinal': Array,
        'number': Array,
        'time': $5f71fa7e68f8e2cf$export$365b104db51a490a
    };
    var $5f71fa7e68f8e2cf$var$defaultDimValueGetters;
    function $5f71fa7e68f8e2cf$var$getIndicesCtor(rawCount) {
        return rawCount > 65535 ? $5f71fa7e68f8e2cf$export$859a1fa4f1106aa0 : $5f71fa7e68f8e2cf$export$78cf73566f32c185;
    }
    function $5f71fa7e68f8e2cf$var$getInitialExtent() {
        return [
            Infinity,
            -Infinity
        ];
    }
    function $5f71fa7e68f8e2cf$var$cloneChunk(originalChunk) {
        var Ctor = originalChunk.constructor;
        return Ctor === Array ? originalChunk.slice() : new Ctor(originalChunk);
    }
    function $5f71fa7e68f8e2cf$var$prepareStore(store, dimIdx, dimType, end, append) {
        var DataCtor = $5f71fa7e68f8e2cf$var$dataCtors[dimType || 'float'];
        if (append) {
            var oldStore = store[dimIdx];
            var oldLen = oldStore && oldStore.length;
            if (!(oldLen === end)) {
                var newStore = new DataCtor(end);
                for(var j = 0; j < oldLen; j++)newStore[j] = oldStore[j];
                store[dimIdx] = newStore;
            }
        } else store[dimIdx] = new DataCtor(end);
    }
    var $5f71fa7e68f8e2cf$var$DataStore = function() {
        function DataStore() {
            this._chunks = [];
            this._rawExtent = [];
            this._extent = [];
            this._count = 0;
            this._rawCount = 0;
            this._calcDimNameToIdx = (0, (0, parcelRequire("bahqM")).createHashMap)();
        }
        DataStore.prototype.initData = function(provider, inputDimensions, dimValueGetter) {
            this._provider = provider;
            this._chunks = [];
            this._indices = null;
            this.getRawIndex = this._getRawIdxIdentity;
            var source = provider.getSource();
            var defaultGetter = this.defaultDimValueGetter = $5f71fa7e68f8e2cf$var$defaultDimValueGetters[source.sourceFormat];
            this._dimValueGetter = dimValueGetter || defaultGetter;
            this._rawExtent = [];
            var willRetrieveDataByName = (0, (0, parcelRequire("20liu")).shouldRetrieveDataByName)(source);
            this._dimensions = (0, (0, parcelRequire("bahqM")).map)(inputDimensions, function(dim) {
                return {
                    type: dim.type,
                    property: dim.property
                };
            });
            this._initDataFromProvider(0, provider.count());
        };
        DataStore.prototype.getProvider = function() {
            return this._provider;
        };
        DataStore.prototype.getSource = function() {
            return this._provider.getSource();
        };
        DataStore.prototype.ensureCalculationDimension = function(dimName, type) {
            var calcDimNameToIdx = this._calcDimNameToIdx;
            var dimensions = this._dimensions;
            var calcDimIdx = calcDimNameToIdx.get(dimName);
            if (calcDimIdx != null) {
                if (dimensions[calcDimIdx].type === type) return calcDimIdx;
            } else calcDimIdx = dimensions.length;
            dimensions[calcDimIdx] = {
                type: type
            };
            calcDimNameToIdx.set(dimName, calcDimIdx);
            this._chunks[calcDimIdx] = new $5f71fa7e68f8e2cf$var$dataCtors[type || 'float'](this._rawCount);
            this._rawExtent[calcDimIdx] = $5f71fa7e68f8e2cf$var$getInitialExtent();
            return calcDimIdx;
        };
        DataStore.prototype.collectOrdinalMeta = function(dimIdx, ordinalMeta) {
            var chunk = this._chunks[dimIdx];
            var dim = this._dimensions[dimIdx];
            var rawExtents = this._rawExtent;
            var offset = dim.ordinalOffset || 0;
            var len = chunk.length;
            if (offset === 0) rawExtents[dimIdx] = $5f71fa7e68f8e2cf$var$getInitialExtent();
            var dimRawExtent = rawExtents[dimIdx];
            for(var i = offset; i < len; i++){
                var val = chunk[i] = ordinalMeta.parseAndCollect(chunk[i]);
                dimRawExtent[0] = Math.min(val, dimRawExtent[0]);
                dimRawExtent[1] = Math.max(val, dimRawExtent[1]);
            }
            dim.ordinalMeta = ordinalMeta;
            dim.ordinalOffset = len;
            dim.type = 'ordinal';
        };
        DataStore.prototype.getOrdinalMeta = function(dimIdx) {
            var dimInfo = this._dimensions[dimIdx];
            var ordinalMeta = dimInfo.ordinalMeta;
            return ordinalMeta;
        };
        DataStore.prototype.getDimensionProperty = function(dimIndex) {
            var item = this._dimensions[dimIndex];
            return item && item.property;
        };
        DataStore.prototype.appendData = function(data) {
            var provider = this._provider;
            var start = this.count();
            provider.appendData(data);
            var end = provider.count();
            if (!provider.persistent) end += start;
            if (start < end) this._initDataFromProvider(start, end, true);
            return [
                start,
                end
            ];
        };
        DataStore.prototype.appendValues = function(values, minFillLen) {
            var chunks = this._chunks;
            var dimensions = this._dimensions;
            var dimLen = dimensions.length;
            var rawExtent = this._rawExtent;
            var start = this.count();
            var end = start + Math.max(values.length, minFillLen || 0);
            for(var i = 0; i < dimLen; i++){
                var dim = dimensions[i];
                $5f71fa7e68f8e2cf$var$prepareStore(chunks, i, dim.type, end, true);
            }
            var emptyDataItem = [];
            for(var idx = start; idx < end; idx++){
                var sourceIdx = idx - start;
                for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                    var dim = dimensions[dimIdx];
                    var val = $5f71fa7e68f8e2cf$var$defaultDimValueGetters.arrayRows.call(this, values[sourceIdx] || emptyDataItem, dim.property, sourceIdx, dimIdx);
                    chunks[dimIdx][idx] = val;
                    var dimRawExtent = rawExtent[dimIdx];
                    val < dimRawExtent[0] && (dimRawExtent[0] = val);
                    val > dimRawExtent[1] && (dimRawExtent[1] = val);
                }
            }
            this._rawCount = this._count = end;
            return {
                start: start,
                end: end
            };
        };
        DataStore.prototype._initDataFromProvider = function(start, end, append) {
            var provider = this._provider;
            var chunks = this._chunks;
            var dimensions = this._dimensions;
            var dimLen = dimensions.length;
            var rawExtent = this._rawExtent;
            var dimNames = (0, (0, parcelRequire("bahqM")).map)(dimensions, function(dim) {
                return dim.property;
            });
            for(var i = 0; i < dimLen; i++){
                var dim = dimensions[i];
                if (!rawExtent[i]) rawExtent[i] = $5f71fa7e68f8e2cf$var$getInitialExtent();
                $5f71fa7e68f8e2cf$var$prepareStore(chunks, i, dim.type, end, append);
            }
            if (provider.fillStorage) provider.fillStorage(start, end, chunks, rawExtent);
            else {
                var dataItem = [];
                for(var idx = start; idx < end; idx++){
                    dataItem = provider.getItem(idx, dataItem);
                    for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                        var dimStorage = chunks[dimIdx];
                        var val = this._dimValueGetter(dataItem, dimNames[dimIdx], idx, dimIdx);
                        dimStorage[idx] = val;
                        var dimRawExtent = rawExtent[dimIdx];
                        val < dimRawExtent[0] && (dimRawExtent[0] = val);
                        val > dimRawExtent[1] && (dimRawExtent[1] = val);
                    }
                }
            }
            if (!provider.persistent && provider.clean) provider.clean();
            this._rawCount = this._count = end;
            this._extent = [];
        };
        DataStore.prototype.count = function() {
            return this._count;
        };
        DataStore.prototype.get = function(dim, idx) {
            if (!(idx >= 0 && idx < this._count)) return NaN;
            var dimStore = this._chunks[dim];
            return dimStore ? dimStore[this.getRawIndex(idx)] : NaN;
        };
        DataStore.prototype.getValues = function(dimensions, idx) {
            var values = [];
            var dimArr = [];
            if (idx == null) {
                idx = dimensions;
                dimensions = [];
                for(var i = 0; i < this._dimensions.length; i++)dimArr.push(i);
            } else dimArr = dimensions;
            for(var i = 0, len = dimArr.length; i < len; i++)values.push(this.get(dimArr[i], idx));
            return values;
        };
        DataStore.prototype.getByRawIndex = function(dim, rawIdx) {
            if (!(rawIdx >= 0 && rawIdx < this._rawCount)) return NaN;
            var dimStore = this._chunks[dim];
            return dimStore ? dimStore[rawIdx] : NaN;
        };
        DataStore.prototype.getSum = function(dim) {
            var dimData = this._chunks[dim];
            var sum = 0;
            if (dimData) for(var i = 0, len = this.count(); i < len; i++){
                var value = this.get(dim, i);
                if (!isNaN(value)) sum += value;
            }
            return sum;
        };
        DataStore.prototype.getMedian = function(dim) {
            var dimDataArray = [];
            this.each([
                dim
            ], function(val) {
                if (!isNaN(val)) dimDataArray.push(val);
            });
            var sortedDimDataArray = dimDataArray.sort(function(a, b) {
                return a - b;
            });
            var len = this.count();
            return len === 0 ? 0 : len % 2 === 1 ? sortedDimDataArray[(len - 1) / 2] : (sortedDimDataArray[len / 2] + sortedDimDataArray[len / 2 - 1]) / 2;
        };
        DataStore.prototype.indexOfRawIndex = function(rawIndex) {
            if (rawIndex >= this._rawCount || rawIndex < 0) return -1;
            if (!this._indices) return rawIndex;
            var indices = this._indices;
            var rawDataIndex = indices[rawIndex];
            if (rawDataIndex != null && rawDataIndex < this._count && rawDataIndex === rawIndex) return rawIndex;
            var left = 0;
            var right = this._count - 1;
            while(left <= right){
                var mid = (left + right) / 2 | 0;
                if (indices[mid] < rawIndex) left = mid + 1;
                else if (indices[mid] > rawIndex) right = mid - 1;
                else return mid;
            }
            return -1;
        };
        DataStore.prototype.indicesOfNearest = function(dim, value, maxDistance) {
            var chunks = this._chunks;
            var dimData = chunks[dim];
            var nearestIndices = [];
            if (!dimData) return nearestIndices;
            if (maxDistance == null) maxDistance = Infinity;
            var minDist = Infinity;
            var minDiff = -1;
            var nearestIndicesLen = 0;
            for(var i = 0, len = this.count(); i < len; i++){
                var dataIndex = this.getRawIndex(i);
                var diff = value - dimData[dataIndex];
                var dist = Math.abs(diff);
                if (dist <= maxDistance) {
                    if (dist < minDist || dist === minDist && diff >= 0 && minDiff < 0) {
                        minDist = dist;
                        minDiff = diff;
                        nearestIndicesLen = 0;
                    }
                    if (diff === minDiff) nearestIndices[nearestIndicesLen++] = i;
                }
            }
            nearestIndices.length = nearestIndicesLen;
            return nearestIndices;
        };
        DataStore.prototype.getIndices = function() {
            var newIndices;
            var indices = this._indices;
            if (indices) {
                var Ctor = indices.constructor;
                var thisCount = this._count;
                if (Ctor === Array) {
                    newIndices = new Ctor(thisCount);
                    for(var i = 0; i < thisCount; i++)newIndices[i] = indices[i];
                } else newIndices = new Ctor(indices.buffer, 0, thisCount);
            } else {
                var Ctor = $5f71fa7e68f8e2cf$var$getIndicesCtor(this._rawCount);
                newIndices = new Ctor(this.count());
                for(var i = 0; i < newIndices.length; i++)newIndices[i] = i;
            }
            return newIndices;
        };
        DataStore.prototype.filter = function(dims, cb) {
            if (!this._count) return this;
            var newStore = this.clone();
            var count = newStore.count();
            var Ctor = $5f71fa7e68f8e2cf$var$getIndicesCtor(newStore._rawCount);
            var newIndices = new Ctor(count);
            var value = [];
            var dimSize = dims.length;
            var offset = 0;
            var dim0 = dims[0];
            var chunks = newStore._chunks;
            for(var i = 0; i < count; i++){
                var keep = void 0;
                var rawIdx = newStore.getRawIndex(i);
                if (dimSize === 0) keep = cb(i);
                else if (dimSize === 1) {
                    var val = chunks[dim0][rawIdx];
                    keep = cb(val, i);
                } else {
                    var k = 0;
                    for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                    value[k] = i;
                    keep = cb.apply(null, value);
                }
                if (keep) newIndices[offset++] = rawIdx;
            }
            if (offset < count) newStore._indices = newIndices;
            newStore._count = offset;
            newStore._extent = [];
            newStore._updateGetRawIdx();
            return newStore;
        };
        DataStore.prototype.selectRange = function(range) {
            var newStore = this.clone();
            var len = newStore._count;
            if (!len) return this;
            var dims = (0, (0, parcelRequire("bahqM")).keys)(range);
            var dimSize = dims.length;
            if (!dimSize) return this;
            var originalCount = newStore.count();
            var Ctor = $5f71fa7e68f8e2cf$var$getIndicesCtor(newStore._rawCount);
            var newIndices = new Ctor(originalCount);
            var offset = 0;
            var dim0 = dims[0];
            var min = range[dim0][0];
            var max = range[dim0][1];
            var storeArr = newStore._chunks;
            var quickFinished = false;
            if (!newStore._indices) {
                var idx = 0;
                if (dimSize === 1) {
                    var dimStorage = storeArr[dims[0]];
                    for(var i = 0; i < len; i++){
                        var val = dimStorage[i];
                        if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = idx;
                        idx++;
                    }
                    quickFinished = true;
                } else if (dimSize === 2) {
                    var dimStorage = storeArr[dims[0]];
                    var dimStorage2 = storeArr[dims[1]];
                    var min2 = range[dims[1]][0];
                    var max2 = range[dims[1]][1];
                    for(var i = 0; i < len; i++){
                        var val = dimStorage[i];
                        var val2 = dimStorage2[i];
                        if ((val >= min && val <= max || isNaN(val)) && (val2 >= min2 && val2 <= max2 || isNaN(val2))) newIndices[offset++] = idx;
                        idx++;
                    }
                    quickFinished = true;
                }
            }
            if (!quickFinished) {
                if (dimSize === 1) for(var i = 0; i < originalCount; i++){
                    var rawIndex = newStore.getRawIndex(i);
                    var val = storeArr[dims[0]][rawIndex];
                    if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = rawIndex;
                }
                else for(var i = 0; i < originalCount; i++){
                    var keep = true;
                    var rawIndex = newStore.getRawIndex(i);
                    for(var k = 0; k < dimSize; k++){
                        var dimk = dims[k];
                        var val = storeArr[dimk][rawIndex];
                        if (val < range[dimk][0] || val > range[dimk][1]) keep = false;
                    }
                    if (keep) newIndices[offset++] = newStore.getRawIndex(i);
                }
            }
            if (offset < originalCount) newStore._indices = newIndices;
            newStore._count = offset;
            newStore._extent = [];
            newStore._updateGetRawIdx();
            return newStore;
        };
        DataStore.prototype.map = function(dims, cb) {
            var target = this.clone(dims);
            this._updateDims(target, dims, cb);
            return target;
        };
        DataStore.prototype.modify = function(dims, cb) {
            this._updateDims(this, dims, cb);
        };
        DataStore.prototype._updateDims = function(target, dims, cb) {
            var targetChunks = target._chunks;
            var tmpRetValue = [];
            var dimSize = dims.length;
            var dataCount = target.count();
            var values = [];
            var rawExtent = target._rawExtent;
            for(var i = 0; i < dims.length; i++)rawExtent[dims[i]] = $5f71fa7e68f8e2cf$var$getInitialExtent();
            for(var dataIndex = 0; dataIndex < dataCount; dataIndex++){
                var rawIndex = target.getRawIndex(dataIndex);
                for(var k = 0; k < dimSize; k++)values[k] = targetChunks[dims[k]][rawIndex];
                values[dimSize] = dataIndex;
                var retValue = cb && cb.apply(null, values);
                if (retValue != null) {
                    if (typeof retValue !== 'object') {
                        tmpRetValue[0] = retValue;
                        retValue = tmpRetValue;
                    }
                    for(var i = 0; i < retValue.length; i++){
                        var dim = dims[i];
                        var val = retValue[i];
                        var rawExtentOnDim = rawExtent[dim];
                        var dimStore = targetChunks[dim];
                        if (dimStore) dimStore[rawIndex] = val;
                        if (val < rawExtentOnDim[0]) rawExtentOnDim[0] = val;
                        if (val > rawExtentOnDim[1]) rawExtentOnDim[1] = val;
                    }
                }
            }
        };
        DataStore.prototype.lttbDownSample = function(valueDimension, rate) {
            var target = this.clone([
                valueDimension
            ], true);
            var targetStorage = target._chunks;
            var dimStore = targetStorage[valueDimension];
            var len = this.count();
            var sampledIndex = 0;
            var frameSize = Math.floor(1 / rate);
            var currentRawIndex = this.getRawIndex(0);
            var maxArea;
            var area;
            var nextRawIndex;
            var newIndices = new ($5f71fa7e68f8e2cf$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize) + 2);
            newIndices[sampledIndex++] = currentRawIndex;
            for(var i = 1; i < len - 1; i += frameSize){
                var nextFrameStart = Math.min(i + frameSize, len - 1);
                var nextFrameEnd = Math.min(i + frameSize * 2, len);
                var avgX = (nextFrameEnd + nextFrameStart) / 2;
                var avgY = 0;
                for(var idx = nextFrameStart; idx < nextFrameEnd; idx++){
                    var rawIndex = this.getRawIndex(idx);
                    var y = dimStore[rawIndex];
                    if (isNaN(y)) continue;
                    avgY += y;
                }
                avgY /= nextFrameEnd - nextFrameStart;
                var frameStart = i;
                var frameEnd = Math.min(i + frameSize, len);
                var pointAX = i - 1;
                var pointAY = dimStore[currentRawIndex];
                maxArea = -1;
                nextRawIndex = frameStart;
                for(var idx = frameStart; idx < frameEnd; idx++){
                    var rawIndex = this.getRawIndex(idx);
                    var y = dimStore[rawIndex];
                    if (isNaN(y)) continue;
                    area = Math.abs((pointAX - avgX) * (y - pointAY) - (pointAX - idx) * (avgY - pointAY));
                    if (area > maxArea) {
                        maxArea = area;
                        nextRawIndex = rawIndex;
                    }
                }
                newIndices[sampledIndex++] = nextRawIndex;
                currentRawIndex = nextRawIndex;
            }
            newIndices[sampledIndex++] = this.getRawIndex(len - 1);
            target._count = sampledIndex;
            target._indices = newIndices;
            target.getRawIndex = this._getRawIdx;
            return target;
        };
        DataStore.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
            var target = this.clone([
                dimension
            ], true);
            var targetStorage = target._chunks;
            var frameValues = [];
            var frameSize = Math.floor(1 / rate);
            var dimStore = targetStorage[dimension];
            var len = this.count();
            var rawExtentOnDim = target._rawExtent[dimension] = $5f71fa7e68f8e2cf$var$getInitialExtent();
            var newIndices = new ($5f71fa7e68f8e2cf$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize));
            var offset = 0;
            for(var i = 0; i < len; i += frameSize){
                if (frameSize > len - i) {
                    frameSize = len - i;
                    frameValues.length = frameSize;
                }
                for(var k = 0; k < frameSize; k++){
                    var dataIdx = this.getRawIndex(i + k);
                    frameValues[k] = dimStore[dataIdx];
                }
                var value = sampleValue(frameValues);
                var sampleFrameIdx = this.getRawIndex(Math.min(i + sampleIndex(frameValues, value) || 0, len - 1));
                dimStore[sampleFrameIdx] = value;
                if (value < rawExtentOnDim[0]) rawExtentOnDim[0] = value;
                if (value > rawExtentOnDim[1]) rawExtentOnDim[1] = value;
                newIndices[offset++] = sampleFrameIdx;
            }
            target._count = offset;
            target._indices = newIndices;
            target._updateGetRawIdx();
            return target;
        };
        DataStore.prototype.each = function(dims, cb) {
            if (!this._count) return;
            var dimSize = dims.length;
            var chunks = this._chunks;
            for(var i = 0, len = this.count(); i < len; i++){
                var rawIdx = this.getRawIndex(i);
                switch(dimSize){
                    case 0:
                        cb(i);
                        break;
                    case 1:
                        cb(chunks[dims[0]][rawIdx], i);
                        break;
                    case 2:
                        cb(chunks[dims[0]][rawIdx], chunks[dims[1]][rawIdx], i);
                        break;
                    default:
                        var k = 0;
                        var value = [];
                        for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                        value[k] = i;
                        cb.apply(null, value);
                }
            }
        };
        DataStore.prototype.getDataExtent = function(dim) {
            var dimData = this._chunks[dim];
            var initialExtent = $5f71fa7e68f8e2cf$var$getInitialExtent();
            if (!dimData) return initialExtent;
            var currEnd = this.count();
            var useRaw = !this._indices;
            var dimExtent;
            if (useRaw) return this._rawExtent[dim].slice();
            dimExtent = this._extent[dim];
            if (dimExtent) return dimExtent.slice();
            dimExtent = initialExtent;
            var min = dimExtent[0];
            var max = dimExtent[1];
            for(var i = 0; i < currEnd; i++){
                var rawIdx = this.getRawIndex(i);
                var value = dimData[rawIdx];
                value < min && (min = value);
                value > max && (max = value);
            }
            dimExtent = [
                min,
                max
            ];
            this._extent[dim] = dimExtent;
            return dimExtent;
        };
        DataStore.prototype.getRawDataItem = function(idx) {
            var rawIdx = this.getRawIndex(idx);
            if (!this._provider.persistent) {
                var val = [];
                var chunks = this._chunks;
                for(var i = 0; i < chunks.length; i++)val.push(chunks[i][rawIdx]);
                return val;
            } else return this._provider.getItem(rawIdx);
        };
        DataStore.prototype.clone = function(clonedDims, ignoreIndices) {
            var target = new DataStore();
            var chunks = this._chunks;
            var clonedDimsMap = clonedDims && (0, (0, parcelRequire("bahqM")).reduce)(clonedDims, function(obj, dimIdx) {
                obj[dimIdx] = true;
                return obj;
            }, {});
            if (clonedDimsMap) for(var i = 0; i < chunks.length; i++)target._chunks[i] = !clonedDimsMap[i] ? chunks[i] : $5f71fa7e68f8e2cf$var$cloneChunk(chunks[i]);
            else target._chunks = chunks;
            this._copyCommonProps(target);
            if (!ignoreIndices) target._indices = this._cloneIndices();
            target._updateGetRawIdx();
            return target;
        };
        DataStore.prototype._copyCommonProps = function(target) {
            target._count = this._count;
            target._rawCount = this._rawCount;
            target._provider = this._provider;
            target._dimensions = this._dimensions;
            target._extent = (0, (0, parcelRequire("bahqM")).clone)(this._extent);
            target._rawExtent = (0, (0, parcelRequire("bahqM")).clone)(this._rawExtent);
        };
        DataStore.prototype._cloneIndices = function() {
            if (this._indices) {
                var Ctor = this._indices.constructor;
                var indices = void 0;
                if (Ctor === Array) {
                    var thisCount = this._indices.length;
                    indices = new Ctor(thisCount);
                    for(var i = 0; i < thisCount; i++)indices[i] = this._indices[i];
                } else indices = new Ctor(this._indices);
                return indices;
            }
            return null;
        };
        DataStore.prototype._getRawIdxIdentity = function(idx) {
            return idx;
        };
        DataStore.prototype._getRawIdx = function(idx) {
            if (idx < this._count && idx >= 0) return this._indices[idx];
            return -1;
        };
        DataStore.prototype._updateGetRawIdx = function() {
            this.getRawIndex = this._indices ? this._getRawIdx : this._getRawIdxIdentity;
        };
        DataStore.internalField = function() {
            function getDimValueSimply(dataItem, property, dataIndex, dimIndex) {
                return (0, (0, parcelRequire("2G90t")).parseDataValue)(dataItem[dimIndex], this._dimensions[dimIndex]);
            }
            $5f71fa7e68f8e2cf$var$defaultDimValueGetters = {
                arrayRows: getDimValueSimply,
                objectRows: function(dataItem, property, dataIndex, dimIndex) {
                    return (0, (0, parcelRequire("2G90t")).parseDataValue)(dataItem[property], this._dimensions[dimIndex]);
                },
                keyedColumns: getDimValueSimply,
                original: function(dataItem, property, dataIndex, dimIndex) {
                    var value = dataItem && (dataItem.value == null ? dataItem : dataItem.value);
                    return (0, (0, parcelRequire("2G90t")).parseDataValue)(value instanceof Array ? value[dimIndex] : value, this._dimensions[dimIndex]);
                },
                typedArray: function(dataItem, property, dataIndex, dimIndex) {
                    return dataItem[dimIndex];
                }
            };
        }();
        return DataStore;
    }();
    var $5f71fa7e68f8e2cf$export$2e2bcd8739ae039 = $5f71fa7e68f8e2cf$var$DataStore;
});
parcelRegister("d88IV", function(module, exports) {
    $parcel$export(module.exports, "defaultSeriesFormatTooltip", ()=>$98f2ca07d9209b02$export$3a110b9fb5c88b34);
    var $bahqM;
    var $j5lKL;
    var $9OHWG;
    var $eaKsF;
    function $98f2ca07d9209b02$export$3a110b9fb5c88b34(opt) {
        var series = opt.series;
        var dataIndex = opt.dataIndex;
        var multipleSeries = opt.multipleSeries;
        var data = series.getData();
        var tooltipDims = data.mapDimensionsAll('defaultedTooltip');
        var tooltipDimLen = tooltipDims.length;
        var value = series.getRawValue(dataIndex);
        var isValueArr = (0, (0, parcelRequire("bahqM")).isArray)(value);
        var markerColor = (0, (0, parcelRequire("j5lKL")).retrieveVisualColorForTooltipMarker)(series, dataIndex);
        var inlineValue;
        var inlineValueType;
        var subBlocks;
        var sortParam;
        if (tooltipDimLen > 1 || isValueArr && !tooltipDimLen) {
            var formatArrResult = $98f2ca07d9209b02$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, markerColor);
            inlineValue = formatArrResult.inlineValues;
            inlineValueType = formatArrResult.inlineValueTypes;
            subBlocks = formatArrResult.blocks;
            sortParam = formatArrResult.inlineValues[0];
        } else if (tooltipDimLen) {
            var dimInfo = data.getDimensionInfo(tooltipDims[0]);
            sortParam = inlineValue = (0, (0, parcelRequire("9OHWG")).retrieveRawValue)(data, dataIndex, tooltipDims[0]);
            inlineValueType = dimInfo.type;
        } else sortParam = inlineValue = isValueArr ? value[0] : value;
        var seriesNameSpecified = (0, (0, parcelRequire("eaKsF")).isNameSpecified)(series);
        var seriesName = seriesNameSpecified && series.name || '';
        var itemName = data.getName(dataIndex);
        var inlineName = multipleSeries ? seriesName : itemName;
        return (0, (0, parcelRequire("j5lKL")).createTooltipMarkup)('section', {
            header: seriesName,
            noHeader: multipleSeries || !seriesNameSpecified,
            sortParam: sortParam,
            blocks: [
                (0, (0, parcelRequire("j5lKL")).createTooltipMarkup)('nameValue', {
                    markerType: 'item',
                    markerColor: markerColor,
                    name: inlineName,
                    noName: !(0, (0, parcelRequire("bahqM")).trim)(inlineName),
                    value: inlineValue,
                    valueType: inlineValueType
                })
            ].concat(subBlocks || [])
        });
    }
    function $98f2ca07d9209b02$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, colorStr) {
        var data = series.getData();
        var isValueMultipleLine = (0, (0, parcelRequire("bahqM")).reduce)(value, function(isValueMultipleLine, val, idx) {
            var dimItem = data.getDimensionInfo(idx);
            return isValueMultipleLine = isValueMultipleLine || dimItem && dimItem.tooltip !== false && dimItem.displayName != null;
        }, false);
        var inlineValues = [];
        var inlineValueTypes = [];
        var blocks = [];
        tooltipDims.length ? (0, (0, parcelRequire("bahqM")).each)(tooltipDims, function(dim) {
            setEachItem((0, (0, parcelRequire("9OHWG")).retrieveRawValue)(data, dataIndex, dim), dim);
        }) : (0, (0, parcelRequire("bahqM")).each)(value, setEachItem);
        function setEachItem(val, dim) {
            var dimInfo = data.getDimensionInfo(dim);
            if (!dimInfo || dimInfo.otherDims.tooltip === false) return;
            if (isValueMultipleLine) blocks.push((0, (0, parcelRequire("j5lKL")).createTooltipMarkup)('nameValue', {
                markerType: 'subItem',
                markerColor: colorStr,
                name: dimInfo.displayName,
                value: val,
                valueType: dimInfo.type
            }));
            else {
                inlineValues.push(val);
                inlineValueTypes.push(dimInfo.type);
            }
        }
        return {
            inlineValues: inlineValues,
            inlineValueTypes: inlineValueTypes,
            blocks: blocks
        };
    }
});
parcelRegister("j5lKL", function(module, exports) {
    $parcel$export(module.exports, "createTooltipMarkup", ()=>$de4f5bb7bbbcf45e$export$cf63b23ce77d1921);
    $parcel$export(module.exports, "buildTooltipMarkup", ()=>$de4f5bb7bbbcf45e$export$6969ffb02c1cb49a);
    $parcel$export(module.exports, "retrieveVisualColorForTooltipMarker", ()=>$de4f5bb7bbbcf45e$export$ea15628039c0fa93);
    $parcel$export(module.exports, "getPaddingFromTooltipModel", ()=>$de4f5bb7bbbcf45e$export$3048212c802df496);
    $parcel$export(module.exports, "TooltipMarkupStyleCreator", ()=>$de4f5bb7bbbcf45e$export$2fba3afbcdcf3e18);
    var $dCJrM;
    var $bahqM;
    var $2G90t;
    var $jmSNG;
    var $de4f5bb7bbbcf45e$var$TOOLTIP_LINE_HEIGHT_CSS = 'line-height:1';
    function $de4f5bb7bbbcf45e$var$getTooltipTextStyle(textStyle, renderMode) {
        var nameFontColor = textStyle.color || '#6e7079';
        var nameFontSize = textStyle.fontSize || 12;
        var nameFontWeight = textStyle.fontWeight || '400';
        var valueFontColor = textStyle.color || '#464646';
        var valueFontSize = textStyle.fontSize || 14;
        var valueFontWeight = textStyle.fontWeight || '900';
        if (renderMode === 'html') return {
            nameStyle: "font-size:" + (0, (0, parcelRequire("dCJrM")).encodeHTML)(nameFontSize + '') + "px;color:" + (0, (0, parcelRequire("dCJrM")).encodeHTML)(nameFontColor) + ";font-weight:" + (0, (0, parcelRequire("dCJrM")).encodeHTML)(nameFontWeight + ''),
            valueStyle: "font-size:" + (0, (0, parcelRequire("dCJrM")).encodeHTML)(valueFontSize + '') + "px;color:" + (0, (0, parcelRequire("dCJrM")).encodeHTML)(valueFontColor) + ";font-weight:" + (0, (0, parcelRequire("dCJrM")).encodeHTML)(valueFontWeight + '')
        };
        else return {
            nameStyle: {
                fontSize: nameFontSize,
                fill: nameFontColor,
                fontWeight: nameFontWeight
            },
            valueStyle: {
                fontSize: valueFontSize,
                fill: valueFontColor,
                fontWeight: valueFontWeight
            }
        };
    }
    var $de4f5bb7bbbcf45e$var$HTML_GAPS = [
        0,
        10,
        20,
        30
    ];
    var $de4f5bb7bbbcf45e$var$RICH_TEXT_GAPS = [
        '',
        '\n',
        '\n\n',
        '\n\n\n'
    ];
    function $de4f5bb7bbbcf45e$export$cf63b23ce77d1921(type, option) {
        option.type = type;
        return option;
    }
    function $de4f5bb7bbbcf45e$var$getBuilder(fragment) {
        return (0, (0, parcelRequire("bahqM")).hasOwn)($de4f5bb7bbbcf45e$var$builderMap, fragment.type) && $de4f5bb7bbbcf45e$var$builderMap[fragment.type];
    }
    var $de4f5bb7bbbcf45e$var$builderMap = {
        section: {
            planLayout: function(fragment) {
                var subBlockLen = fragment.blocks.length;
                var thisBlockHasInnerGap = subBlockLen > 1 || subBlockLen > 0 && !fragment.noHeader;
                var thisGapLevelBetweenSubBlocks = 0;
                (0, (0, parcelRequire("bahqM")).each)(fragment.blocks, function(subBlock) {
                    $de4f5bb7bbbcf45e$var$getBuilder(subBlock).planLayout(subBlock);
                    var subGapLevel = subBlock.__gapLevelBetweenSubBlocks;
                    if (subGapLevel >= thisGapLevelBetweenSubBlocks) thisGapLevelBetweenSubBlocks = subGapLevel + (thisBlockHasInnerGap && (!subGapLevel || subBlock.type === 'section' && !subBlock.noHeader) ? 1 : 0);
                });
                fragment.__gapLevelBetweenSubBlocks = thisGapLevelBetweenSubBlocks;
            },
            build: function(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
                var noHeader = fragment.noHeader;
                var gaps = $de4f5bb7bbbcf45e$var$getGap(fragment);
                var subMarkupText = $de4f5bb7bbbcf45e$var$buildSubBlocks(ctx, fragment, noHeader ? topMarginForOuterGap : gaps.html, toolTipTextStyle);
                if (noHeader) return subMarkupText;
                var displayableHeader = (0, (0, parcelRequire("dCJrM")).makeValueReadable)(fragment.header, 'ordinal', ctx.useUTC);
                var nameStyle = $de4f5bb7bbbcf45e$var$getTooltipTextStyle(toolTipTextStyle, ctx.renderMode).nameStyle;
                if (ctx.renderMode === 'richText') return $de4f5bb7bbbcf45e$var$wrapInlineNameRichText(ctx, displayableHeader, nameStyle) + gaps.richText + subMarkupText;
                else return $de4f5bb7bbbcf45e$var$wrapBlockHTML("<div style=\"" + nameStyle + ";" + $de4f5bb7bbbcf45e$var$TOOLTIP_LINE_HEIGHT_CSS + ";\">" + (0, (0, parcelRequire("dCJrM")).encodeHTML)(displayableHeader) + '</div>' + subMarkupText, topMarginForOuterGap);
            }
        },
        nameValue: {
            planLayout: function(fragment) {
                fragment.__gapLevelBetweenSubBlocks = 0;
            },
            build: function(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
                var renderMode = ctx.renderMode;
                var noName = fragment.noName;
                var noValue = fragment.noValue;
                var noMarker = !fragment.markerType;
                var name = fragment.name;
                var value = fragment.value;
                var useUTC = ctx.useUTC;
                if (noName && noValue) return;
                var markerStr = noMarker ? '' : ctx.markupStyleCreator.makeTooltipMarker(fragment.markerType, fragment.markerColor || '#333', renderMode);
                var readableName = noName ? '' : (0, (0, parcelRequire("dCJrM")).makeValueReadable)(name, 'ordinal', useUTC);
                var valueTypeOption = fragment.valueType;
                var readableValueList = noValue ? [] : (0, (0, parcelRequire("bahqM")).isArray)(value) ? (0, (0, parcelRequire("bahqM")).map)(value, function(val, idx) {
                    return (0, (0, parcelRequire("dCJrM")).makeValueReadable)(val, (0, (0, parcelRequire("bahqM")).isArray)(valueTypeOption) ? valueTypeOption[idx] : valueTypeOption, useUTC);
                }) : [
                    (0, (0, parcelRequire("dCJrM")).makeValueReadable)(value, (0, (0, parcelRequire("bahqM")).isArray)(valueTypeOption) ? valueTypeOption[0] : valueTypeOption, useUTC)
                ];
                var valueAlignRight = !noMarker || !noName;
                var valueCloseToMarker = !noMarker && noName;
                var _a = $de4f5bb7bbbcf45e$var$getTooltipTextStyle(toolTipTextStyle, renderMode), nameStyle = _a.nameStyle, valueStyle = _a.valueStyle;
                return renderMode === 'richText' ? (noMarker ? '' : markerStr) + (noName ? '' : $de4f5bb7bbbcf45e$var$wrapInlineNameRichText(ctx, readableName, nameStyle)) + (noValue ? '' : $de4f5bb7bbbcf45e$var$wrapInlineValueRichText(ctx, readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)) : $de4f5bb7bbbcf45e$var$wrapBlockHTML((noMarker ? '' : markerStr) + (noName ? '' : $de4f5bb7bbbcf45e$var$wrapInlineNameHTML(readableName, !noMarker, nameStyle)) + (noValue ? '' : $de4f5bb7bbbcf45e$var$wrapInlineValueHTML(readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)), topMarginForOuterGap);
            }
        }
    };
    function $de4f5bb7bbbcf45e$var$buildSubBlocks(ctx, fragment, topMarginForOuterGap, tooltipTextStyle) {
        var subMarkupTextList = [];
        var subBlocks = fragment.blocks || [];
        (0, (0, parcelRequire("bahqM")).assert)(!subBlocks || (0, (0, parcelRequire("bahqM")).isArray)(subBlocks));
        subBlocks = subBlocks || [];
        var orderMode = ctx.orderMode;
        if (fragment.sortBlocks && orderMode) {
            subBlocks = subBlocks.slice();
            var orderMap = {
                valueAsc: 'asc',
                valueDesc: 'desc'
            };
            if ((0, (0, parcelRequire("bahqM")).hasOwn)(orderMap, orderMode)) {
                var comparator_1 = new (0, (0, parcelRequire("2G90t")).SortOrderComparator)(orderMap[orderMode], null);
                subBlocks.sort(function(a, b) {
                    return comparator_1.evaluate(a.sortParam, b.sortParam);
                });
            } else if (orderMode === 'seriesDesc') subBlocks.reverse();
        }
        var gaps = $de4f5bb7bbbcf45e$var$getGap(fragment);
        (0, (0, parcelRequire("bahqM")).each)(subBlocks, function(subBlock, idx) {
            var subMarkupText = $de4f5bb7bbbcf45e$var$getBuilder(subBlock).build(ctx, subBlock, idx > 0 ? gaps.html : 0, tooltipTextStyle);
            subMarkupText != null && subMarkupTextList.push(subMarkupText);
        });
        if (!subMarkupTextList.length) return;
        return ctx.renderMode === 'richText' ? subMarkupTextList.join(gaps.richText) : $de4f5bb7bbbcf45e$var$wrapBlockHTML(subMarkupTextList.join(''), topMarginForOuterGap);
    }
    function $de4f5bb7bbbcf45e$export$6969ffb02c1cb49a(fragment, markupStyleCreator, renderMode, orderMode, useUTC, toolTipTextStyle) {
        if (!fragment) return;
        var builder = $de4f5bb7bbbcf45e$var$getBuilder(fragment);
        builder.planLayout(fragment);
        var ctx = {
            useUTC: useUTC,
            renderMode: renderMode,
            orderMode: orderMode,
            markupStyleCreator: markupStyleCreator
        };
        return builder.build(ctx, fragment, 0, toolTipTextStyle);
    }
    function $de4f5bb7bbbcf45e$var$getGap(fragment) {
        var gapLevelBetweenSubBlocks = fragment.__gapLevelBetweenSubBlocks;
        return {
            html: $de4f5bb7bbbcf45e$var$HTML_GAPS[gapLevelBetweenSubBlocks],
            richText: $de4f5bb7bbbcf45e$var$RICH_TEXT_GAPS[gapLevelBetweenSubBlocks]
        };
    }
    function $de4f5bb7bbbcf45e$var$wrapBlockHTML(encodedContent, topGap) {
        var clearfix = '<div style="clear:both"></div>';
        var marginCSS = "margin: " + topGap + "px 0 0";
        return "<div style=\"" + marginCSS + ";" + $de4f5bb7bbbcf45e$var$TOOLTIP_LINE_HEIGHT_CSS + ";\">" + encodedContent + clearfix + '</div>';
    }
    function $de4f5bb7bbbcf45e$var$wrapInlineNameHTML(name, leftHasMarker, style) {
        var marginCss = leftHasMarker ? 'margin-left:2px' : '';
        return "<span style=\"" + style + ";" + marginCss + "\">" + (0, (0, parcelRequire("dCJrM")).encodeHTML)(name) + '</span>';
    }
    function $de4f5bb7bbbcf45e$var$wrapInlineValueHTML(valueList, alignRight, valueCloseToMarker, style) {
        var paddingStr = valueCloseToMarker ? '10px' : '20px';
        var alignCSS = alignRight ? "float:right;margin-left:" + paddingStr : '';
        return "<span style=\"" + alignCSS + ";" + style + "\">" + (0, (0, parcelRequire("bahqM")).map)(valueList, function(value) {
            return (0, (0, parcelRequire("dCJrM")).encodeHTML)(value);
        }).join('&nbsp;&nbsp;') + '</span>';
    }
    function $de4f5bb7bbbcf45e$var$wrapInlineNameRichText(ctx, name, style) {
        return ctx.markupStyleCreator.wrapRichTextStyle(name, style);
    }
    function $de4f5bb7bbbcf45e$var$wrapInlineValueRichText(ctx, valueList, alignRight, valueCloseToMarker, style) {
        var styles = [
            style
        ];
        var paddingLeft = valueCloseToMarker ? 10 : 20;
        alignRight && styles.push({
            padding: [
                0,
                0,
                0,
                paddingLeft
            ],
            align: 'right'
        });
        return ctx.markupStyleCreator.wrapRichTextStyle(valueList.join('  '), styles);
    }
    function $de4f5bb7bbbcf45e$export$ea15628039c0fa93(series, dataIndex) {
        var style = series.getData().getItemVisual(dataIndex, 'style');
        var color = style[series.visualDrawType];
        return (0, (0, parcelRequire("dCJrM")).convertToColorString)(color);
    }
    function $de4f5bb7bbbcf45e$export$3048212c802df496(model, renderMode) {
        var padding = model.get('padding');
        return padding != null ? padding : renderMode === 'richText' ? [
            8,
            10
        ] : 10;
    }
    var $de4f5bb7bbbcf45e$export$2fba3afbcdcf3e18 = function() {
        function TooltipMarkupStyleCreator() {
            this.richTextStyles = {};
            this._nextStyleNameId = (0, (0, parcelRequire("jmSNG")).getRandomIdBase)();
        }
        TooltipMarkupStyleCreator.prototype._generateStyleName = function() {
            return '__EC_aUTo_' + this._nextStyleNameId++;
        };
        TooltipMarkupStyleCreator.prototype.makeTooltipMarker = function(markerType, colorStr, renderMode) {
            var markerId = renderMode === 'richText' ? this._generateStyleName() : null;
            var marker = (0, (0, parcelRequire("dCJrM")).getTooltipMarker)({
                color: colorStr,
                type: markerType,
                renderMode: renderMode,
                markerId: markerId
            });
            if ((0, (0, parcelRequire("bahqM")).isString)(marker)) return marker;
            else {
                this.richTextStyles[markerId] = marker.style;
                return marker.content;
            }
        };
        TooltipMarkupStyleCreator.prototype.wrapRichTextStyle = function(text, styles) {
            var finalStl = {};
            if ((0, (0, parcelRequire("bahqM")).isArray)(styles)) (0, (0, parcelRequire("bahqM")).each)(styles, function(stl) {
                return (0, (0, parcelRequire("bahqM")).extend)(finalStl, stl);
            });
            else (0, (0, parcelRequire("bahqM")).extend)(finalStl, styles);
            var styleName = this._generateStyleName();
            this.richTextStyles[styleName] = finalStl;
            return "{" + styleName + "|" + text + "}";
        };
        return TooltipMarkupStyleCreator;
    }();
});
parcelRegister("bAY5l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8711aa3240a9c687$export$2e2bcd8739ae039);
    var $bahqM;
    var $liBXN;
    var $h9jiS;
    var $bnVGB;
    var $eaKsF;
    var $gyhNQ;
    var $lhMGv;
    var $20liu;
    var $5R8Hi;
    var $cNGs8;
    var $2Rbm1;
    function $8711aa3240a9c687$var$getCoordSysDimDefs(seriesModel, coordSysInfo) {
        var coordSysName = seriesModel.get('coordinateSystem');
        var registeredCoordSys = (0, (0, parcelRequire("gyhNQ")).default).get(coordSysName);
        var coordSysDimDefs;
        if (coordSysInfo && coordSysInfo.coordSysDims) coordSysDimDefs = (0, parcelRequire("bahqM")).map(coordSysInfo.coordSysDims, function(dim) {
            var dimInfo = {
                name: dim
            };
            var axisModel = coordSysInfo.axisMap.get(dim);
            if (axisModel) {
                var axisType = axisModel.get('type');
                dimInfo.type = (0, (0, parcelRequire("bnVGB")).getDimensionTypeByAxis)(axisType);
            }
            return dimInfo;
        });
        if (!coordSysDimDefs) coordSysDimDefs = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || [
            'x',
            'y'
        ];
        return coordSysDimDefs;
    }
    function $8711aa3240a9c687$var$injectOrdinalMeta(dimInfoList, createInvertedIndices, coordSysInfo) {
        var firstCategoryDimIndex;
        var hasNameEncode;
        coordSysInfo && (0, parcelRequire("bahqM")).each(dimInfoList, function(dimInfo, dimIndex) {
            var coordDim = dimInfo.coordDim;
            var categoryAxisModel = coordSysInfo.categoryAxisMap.get(coordDim);
            if (categoryAxisModel) {
                if (firstCategoryDimIndex == null) firstCategoryDimIndex = dimIndex;
                dimInfo.ordinalMeta = categoryAxisModel.getOrdinalMeta();
                if (createInvertedIndices) dimInfo.createInvertedIndices = true;
            }
            if (dimInfo.otherDims.itemName != null) hasNameEncode = true;
        });
        if (!hasNameEncode && firstCategoryDimIndex != null) dimInfoList[firstCategoryDimIndex].otherDims.itemName = 0;
        return firstCategoryDimIndex;
    }
    function $8711aa3240a9c687$var$createSeriesData(sourceRaw, seriesModel, opt) {
        opt = opt || {};
        var sourceManager = seriesModel.getSourceManager();
        var source;
        var isOriginalSource = false;
        if (sourceRaw) {
            isOriginalSource = true;
            source = (0, (0, parcelRequire("20liu")).createSourceFromSeriesDataOption)(sourceRaw);
        } else {
            source = sourceManager.getSource();
            isOriginalSource = source.sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL);
        }
        var coordSysInfo = (0, (0, parcelRequire("lhMGv")).getCoordSysInfoBySeries)(seriesModel);
        var coordSysDimDefs = $8711aa3240a9c687$var$getCoordSysDimDefs(seriesModel, coordSysInfo);
        var useEncodeDefaulter = opt.useEncodeDefaulter;
        var encodeDefaulter = (0, parcelRequire("bahqM")).isFunction(useEncodeDefaulter) ? useEncodeDefaulter : useEncodeDefaulter ? (0, parcelRequire("bahqM")).curry((0, (0, parcelRequire("cNGs8")).makeSeriesEncodeForAxisCoordSys), coordSysDimDefs, seriesModel) : null;
        var createDimensionOptions = {
            coordDimensions: coordSysDimDefs,
            generateCoord: opt.generateCoord,
            encodeDefine: seriesModel.getEncode(),
            encodeDefaulter: encodeDefaulter,
            canOmitUnusedDimensions: !isOriginalSource
        };
        var schema = (0, (0, parcelRequire("h9jiS")).default)(source, createDimensionOptions);
        var firstCategoryDimIndex = $8711aa3240a9c687$var$injectOrdinalMeta(schema.dimensions, opt.createInvertedIndices, coordSysInfo);
        var store = !isOriginalSource ? sourceManager.getSharedDataStore(schema) : null;
        var stackCalculationInfo = (0, (0, parcelRequire("5R8Hi")).enableDataStack)(seriesModel, {
            schema: schema,
            store: store
        });
        var data = new (0, (0, parcelRequire("liBXN")).default)(schema, seriesModel);
        data.setCalculationInfo(stackCalculationInfo);
        var dimValueGetter = firstCategoryDimIndex != null && $8711aa3240a9c687$var$isNeedCompleteOrdinalData(source) ? function(itemOpt, dimName, dataIndex, dimIndex) {
            return dimIndex === firstCategoryDimIndex ? dataIndex : this.defaultDimValueGetter(itemOpt, dimName, dataIndex, dimIndex);
        } : null;
        data.hasItemOption = false;
        data.initData(isOriginalSource ? source : store, null, dimValueGetter);
        return data;
    }
    function $8711aa3240a9c687$var$isNeedCompleteOrdinalData(source) {
        if (source.sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL)) {
            var sampleItem = $8711aa3240a9c687$var$firstDataNotNull(source.data || []);
            return sampleItem != null && !(0, parcelRequire("bahqM")).isArray((0, (0, parcelRequire("eaKsF")).getDataItemValue)(sampleItem));
        }
    }
    function $8711aa3240a9c687$var$firstDataNotNull(arr) {
        var i = 0;
        while(i < arr.length && arr[i] == null)i++;
        return arr[i];
    }
    var $8711aa3240a9c687$export$2e2bcd8739ae039 = $8711aa3240a9c687$var$createSeriesData;
});
parcelRegister("liBXN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f818ba28c897a2f2$export$2e2bcd8739ae039);
    var $bahqM;
    var $gaMkj;
    var $4wWkb;
    var $9OHWG;
    var $bnVGB;
    var $dhxbO;
    var $2Rbm1;
    var $eaKsF;
    var $7QjoM;
    var $20liu;
    var $8c3gC;
    var $2Om11;
    var $f818ba28c897a2f2$var$isObject = (0, parcelRequire("bahqM")).isObject;
    var $f818ba28c897a2f2$var$map = (0, parcelRequire("bahqM")).map;
    var $f818ba28c897a2f2$var$CtorInt32Array = typeof Int32Array === 'undefined' ? Array : Int32Array;
    var $f818ba28c897a2f2$var$ID_PREFIX = 'e\0\0';
    var $f818ba28c897a2f2$var$INDEX_NOT_FOUND = -1;
    var $f818ba28c897a2f2$var$TRANSFERABLE_PROPERTIES = [
        'hasItemOption',
        '_nameList',
        '_idList',
        '_invertedIndicesMap',
        '_dimSummary',
        'userOutput',
        '_rawData',
        '_dimValueGetter',
        '_nameDimIdx',
        '_idDimIdx',
        '_nameRepeatCount'
    ];
    var $f818ba28c897a2f2$var$CLONE_PROPERTIES = [
        '_approximateExtent'
    ];
    var $f818ba28c897a2f2$var$prepareInvertedIndex;
    var $f818ba28c897a2f2$var$getId;
    var $f818ba28c897a2f2$var$getIdNameFromStore;
    var $f818ba28c897a2f2$var$normalizeDimensions;
    var $f818ba28c897a2f2$var$transferProperties;
    var $f818ba28c897a2f2$var$cloneListForMapAndSample;
    var $f818ba28c897a2f2$var$makeIdFromName;
    var $f818ba28c897a2f2$var$SeriesData = function() {
        function SeriesData(dimensionsInput, hostModel) {
            this.type = 'list';
            this._dimOmitted = false;
            this._nameList = [];
            this._idList = [];
            this._visual = {};
            this._layout = {};
            this._itemVisuals = [];
            this._itemLayouts = [];
            this._graphicEls = [];
            this._approximateExtent = {};
            this._calculationInfo = {};
            this.hasItemOption = false;
            this.TRANSFERABLE_METHODS = [
                'cloneShallow',
                'downSample',
                'lttbDownSample',
                'map'
            ];
            this.CHANGABLE_METHODS = [
                'filterSelf',
                'selectRange'
            ];
            this.DOWNSAMPLE_METHODS = [
                'downSample',
                'lttbDownSample'
            ];
            var dimensions;
            var assignStoreDimIdx = false;
            if ((0, (0, parcelRequire("2Om11")).isSeriesDataSchema)(dimensionsInput)) {
                dimensions = dimensionsInput.dimensions;
                this._dimOmitted = dimensionsInput.isDimensionOmitted();
                this._schema = dimensionsInput;
            } else {
                assignStoreDimIdx = true;
                dimensions = dimensionsInput;
            }
            dimensions = dimensions || [
                'x',
                'y'
            ];
            var dimensionInfos = {};
            var dimensionNames = [];
            var invertedIndicesMap = {};
            var needsHasOwn = false;
            var emptyObj = {};
            for(var i = 0; i < dimensions.length; i++){
                var dimInfoInput = dimensions[i];
                var dimensionInfo = (0, parcelRequire("bahqM")).isString(dimInfoInput) ? new (0, (0, parcelRequire("dhxbO")).default)({
                    name: dimInfoInput
                }) : !(dimInfoInput instanceof (0, (0, parcelRequire("dhxbO")).default)) ? new (0, (0, parcelRequire("dhxbO")).default)(dimInfoInput) : dimInfoInput;
                var dimensionName = dimensionInfo.name;
                dimensionInfo.type = dimensionInfo.type || 'float';
                if (!dimensionInfo.coordDim) {
                    dimensionInfo.coordDim = dimensionName;
                    dimensionInfo.coordDimIndex = 0;
                }
                var otherDims = dimensionInfo.otherDims = dimensionInfo.otherDims || {};
                dimensionNames.push(dimensionName);
                dimensionInfos[dimensionName] = dimensionInfo;
                if (emptyObj[dimensionName] != null) needsHasOwn = true;
                if (dimensionInfo.createInvertedIndices) invertedIndicesMap[dimensionName] = [];
                if (otherDims.itemName === 0) this._nameDimIdx = i;
                if (otherDims.itemId === 0) this._idDimIdx = i;
                if (assignStoreDimIdx) dimensionInfo.storeDimIndex = i;
            }
            this.dimensions = dimensionNames;
            this._dimInfos = dimensionInfos;
            this._initGetDimensionInfo(needsHasOwn);
            this.hostModel = hostModel;
            this._invertedIndicesMap = invertedIndicesMap;
            if (this._dimOmitted) {
                var dimIdxToName_1 = this._dimIdxToName = (0, parcelRequire("bahqM")).createHashMap();
                (0, parcelRequire("bahqM")).each(dimensionNames, function(dimName) {
                    dimIdxToName_1.set(dimensionInfos[dimName].storeDimIndex, dimName);
                });
            }
        }
        SeriesData.prototype.getDimension = function(dim) {
            var dimIdx = this._recognizeDimIndex(dim);
            if (dimIdx == null) return dim;
            dimIdx = dim;
            if (!this._dimOmitted) return this.dimensions[dimIdx];
            var dimName = this._dimIdxToName.get(dimIdx);
            if (dimName != null) return dimName;
            var sourceDimDef = this._schema.getSourceDimension(dimIdx);
            if (sourceDimDef) return sourceDimDef.name;
        };
        SeriesData.prototype.getDimensionIndex = function(dim) {
            var dimIdx = this._recognizeDimIndex(dim);
            if (dimIdx != null) return dimIdx;
            if (dim == null) return -1;
            var dimInfo = this._getDimInfo(dim);
            return dimInfo ? dimInfo.storeDimIndex : this._dimOmitted ? this._schema.getSourceDimensionIndex(dim) : -1;
        };
        SeriesData.prototype._recognizeDimIndex = function(dim) {
            if (typeof dim === 'number' || dim != null && !isNaN(dim) && !this._getDimInfo(dim) && (!this._dimOmitted || this._schema.getSourceDimensionIndex(dim) < 0)) return +dim;
        };
        SeriesData.prototype._getStoreDimIndex = function(dim) {
            var dimIdx = this.getDimensionIndex(dim);
            return dimIdx;
        };
        SeriesData.prototype.getDimensionInfo = function(dim) {
            return this._getDimInfo(this.getDimension(dim));
        };
        SeriesData.prototype._initGetDimensionInfo = function(needsHasOwn) {
            var dimensionInfos = this._dimInfos;
            this._getDimInfo = needsHasOwn ? function(dimName) {
                return dimensionInfos.hasOwnProperty(dimName) ? dimensionInfos[dimName] : undefined;
            } : function(dimName) {
                return dimensionInfos[dimName];
            };
        };
        SeriesData.prototype.getDimensionsOnCoord = function() {
            return this._dimSummary.dataDimsOnCoord.slice();
        };
        SeriesData.prototype.mapDimension = function(coordDim, idx) {
            var dimensionsSummary = this._dimSummary;
            if (idx == null) return dimensionsSummary.encodeFirstDimNotExtra[coordDim];
            var dims = dimensionsSummary.encode[coordDim];
            return dims ? dims[idx] : null;
        };
        SeriesData.prototype.mapDimensionsAll = function(coordDim) {
            var dimensionsSummary = this._dimSummary;
            var dims = dimensionsSummary.encode[coordDim];
            return (dims || []).slice();
        };
        SeriesData.prototype.getStore = function() {
            return this._store;
        };
        SeriesData.prototype.initData = function(data, nameList, dimValueGetter) {
            var _this = this;
            var store;
            if (data instanceof (0, (0, parcelRequire("8c3gC")).default)) store = data;
            if (!store) {
                var dimensions = this.dimensions;
                var provider = (0, (0, parcelRequire("20liu")).isSourceInstance)(data) || (0, parcelRequire("bahqM")).isArrayLike(data) ? new (0, (0, parcelRequire("9OHWG")).DefaultDataProvider)(data, dimensions.length) : data;
                store = new (0, (0, parcelRequire("8c3gC")).default)();
                var dimensionInfos = $f818ba28c897a2f2$var$map(dimensions, function(dimName) {
                    return {
                        type: _this._dimInfos[dimName].type,
                        property: dimName
                    };
                });
                store.initData(provider, dimensionInfos, dimValueGetter);
            }
            this._store = store;
            this._nameList = (nameList || []).slice();
            this._idList = [];
            this._nameRepeatCount = {};
            this._doInit(0, store.count());
            this._dimSummary = (0, (0, parcelRequire("bnVGB")).summarizeDimensions)(this, this._schema);
            this.userOutput = this._dimSummary.userOutput;
        };
        SeriesData.prototype.appendData = function(data) {
            var range = this._store.appendData(data);
            this._doInit(range[0], range[1]);
        };
        SeriesData.prototype.appendValues = function(values, names) {
            var _a = this._store.appendValues(values, names.length), start = _a.start, end = _a.end;
            var shouldMakeIdFromName = this._shouldMakeIdFromName();
            this._updateOrdinalMeta();
            if (names) for(var idx = start; idx < end; idx++){
                var sourceIdx = idx - start;
                this._nameList[idx] = names[sourceIdx];
                if (shouldMakeIdFromName) $f818ba28c897a2f2$var$makeIdFromName(this, idx);
            }
        };
        SeriesData.prototype._updateOrdinalMeta = function() {
            var store = this._store;
            var dimensions = this.dimensions;
            for(var i = 0; i < dimensions.length; i++){
                var dimInfo = this._dimInfos[dimensions[i]];
                if (dimInfo.ordinalMeta) store.collectOrdinalMeta(dimInfo.storeDimIndex, dimInfo.ordinalMeta);
            }
        };
        SeriesData.prototype._shouldMakeIdFromName = function() {
            var provider = this._store.getProvider();
            return this._idDimIdx == null && provider.getSource().sourceFormat !== (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_TYPED_ARRAY) && !provider.fillStorage;
        };
        SeriesData.prototype._doInit = function(start, end) {
            if (start >= end) return;
            var store = this._store;
            var provider = store.getProvider();
            this._updateOrdinalMeta();
            var nameList = this._nameList;
            var idList = this._idList;
            var sourceFormat = provider.getSource().sourceFormat;
            var isFormatOriginal = sourceFormat === (0, (0, parcelRequire("2Rbm1")).SOURCE_FORMAT_ORIGINAL);
            if (isFormatOriginal && !provider.pure) {
                var sharedDataItem = [];
                for(var idx = start; idx < end; idx++){
                    var dataItem = provider.getItem(idx, sharedDataItem);
                    if (!this.hasItemOption && (0, (0, parcelRequire("eaKsF")).isDataItemOption)(dataItem)) this.hasItemOption = true;
                    if (dataItem) {
                        var itemName = dataItem.name;
                        if (nameList[idx] == null && itemName != null) nameList[idx] = (0, (0, parcelRequire("eaKsF")).convertOptionIdName)(itemName, null);
                        var itemId = dataItem.id;
                        if (idList[idx] == null && itemId != null) idList[idx] = (0, (0, parcelRequire("eaKsF")).convertOptionIdName)(itemId, null);
                    }
                }
            }
            if (this._shouldMakeIdFromName()) for(var idx = start; idx < end; idx++)$f818ba28c897a2f2$var$makeIdFromName(this, idx);
            $f818ba28c897a2f2$var$prepareInvertedIndex(this);
        };
        SeriesData.prototype.getApproximateExtent = function(dim) {
            return this._approximateExtent[dim] || this._store.getDataExtent(this._getStoreDimIndex(dim));
        };
        SeriesData.prototype.setApproximateExtent = function(extent, dim) {
            dim = this.getDimension(dim);
            this._approximateExtent[dim] = extent.slice();
        };
        SeriesData.prototype.getCalculationInfo = function(key) {
            return this._calculationInfo[key];
        };
        SeriesData.prototype.setCalculationInfo = function(key, value) {
            $f818ba28c897a2f2$var$isObject(key) ? (0, parcelRequire("bahqM")).extend(this._calculationInfo, key) : this._calculationInfo[key] = value;
        };
        SeriesData.prototype.getName = function(idx) {
            var rawIndex = this.getRawIndex(idx);
            var name = this._nameList[rawIndex];
            if (name == null && this._nameDimIdx != null) name = $f818ba28c897a2f2$var$getIdNameFromStore(this, this._nameDimIdx, rawIndex);
            if (name == null) name = '';
            return name;
        };
        SeriesData.prototype._getCategory = function(dimIdx, idx) {
            var ordinal = this._store.get(dimIdx, idx);
            var ordinalMeta = this._store.getOrdinalMeta(dimIdx);
            if (ordinalMeta) return ordinalMeta.categories[ordinal];
            return ordinal;
        };
        SeriesData.prototype.getId = function(idx) {
            return $f818ba28c897a2f2$var$getId(this, this.getRawIndex(idx));
        };
        SeriesData.prototype.count = function() {
            return this._store.count();
        };
        SeriesData.prototype.get = function(dim, idx) {
            var store = this._store;
            var dimInfo = this._dimInfos[dim];
            if (dimInfo) return store.get(dimInfo.storeDimIndex, idx);
        };
        SeriesData.prototype.getByRawIndex = function(dim, rawIdx) {
            var store = this._store;
            var dimInfo = this._dimInfos[dim];
            if (dimInfo) return store.getByRawIndex(dimInfo.storeDimIndex, rawIdx);
        };
        SeriesData.prototype.getIndices = function() {
            return this._store.getIndices();
        };
        SeriesData.prototype.getDataExtent = function(dim) {
            return this._store.getDataExtent(this._getStoreDimIndex(dim));
        };
        SeriesData.prototype.getSum = function(dim) {
            return this._store.getSum(this._getStoreDimIndex(dim));
        };
        SeriesData.prototype.getMedian = function(dim) {
            return this._store.getMedian(this._getStoreDimIndex(dim));
        };
        SeriesData.prototype.getValues = function(dimensions, idx) {
            var _this = this;
            var store = this._store;
            return (0, parcelRequire("bahqM")).isArray(dimensions) ? store.getValues($f818ba28c897a2f2$var$map(dimensions, function(dim) {
                return _this._getStoreDimIndex(dim);
            }), idx) : store.getValues(dimensions);
        };
        SeriesData.prototype.hasValue = function(idx) {
            var dataDimIndicesOnCoord = this._dimSummary.dataDimIndicesOnCoord;
            for(var i = 0, len = dataDimIndicesOnCoord.length; i < len; i++){
                if (isNaN(this._store.get(dataDimIndicesOnCoord[i], idx))) return false;
            }
            return true;
        };
        SeriesData.prototype.indexOfName = function(name) {
            for(var i = 0, len = this._store.count(); i < len; i++){
                if (this.getName(i) === name) return i;
            }
            return -1;
        };
        SeriesData.prototype.getRawIndex = function(idx) {
            return this._store.getRawIndex(idx);
        };
        SeriesData.prototype.indexOfRawIndex = function(rawIndex) {
            return this._store.indexOfRawIndex(rawIndex);
        };
        SeriesData.prototype.rawIndexOf = function(dim, value) {
            var invertedIndices = dim && this._invertedIndicesMap[dim];
            var rawIndex = invertedIndices[value];
            if (rawIndex == null || isNaN(rawIndex)) return $f818ba28c897a2f2$var$INDEX_NOT_FOUND;
            return rawIndex;
        };
        SeriesData.prototype.indicesOfNearest = function(dim, value, maxDistance) {
            return this._store.indicesOfNearest(this._getStoreDimIndex(dim), value, maxDistance);
        };
        SeriesData.prototype.each = function(dims, cb, ctx) {
            'use strict';
            if (typeof dims === 'function') {
                ctx = cb;
                cb = dims;
                dims = [];
            }
            var fCtx = ctx || this;
            var dimIndices = $f818ba28c897a2f2$var$map($f818ba28c897a2f2$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
            this._store.each(dimIndices, fCtx ? (0, parcelRequire("bahqM")).bind(cb, fCtx) : cb);
        };
        SeriesData.prototype.filterSelf = function(dims, cb, ctx) {
            'use strict';
            if (typeof dims === 'function') {
                ctx = cb;
                cb = dims;
                dims = [];
            }
            var fCtx = ctx || this;
            var dimIndices = $f818ba28c897a2f2$var$map($f818ba28c897a2f2$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
            this._store = this._store.filter(dimIndices, fCtx ? (0, parcelRequire("bahqM")).bind(cb, fCtx) : cb);
            return this;
        };
        SeriesData.prototype.selectRange = function(range) {
            'use strict';
            var _this = this;
            var innerRange = {};
            var dims = (0, parcelRequire("bahqM")).keys(range);
            var dimIndices = [];
            (0, parcelRequire("bahqM")).each(dims, function(dim) {
                var dimIdx = _this._getStoreDimIndex(dim);
                innerRange[dimIdx] = range[dim];
                dimIndices.push(dimIdx);
            });
            this._store = this._store.selectRange(innerRange);
            return this;
        };
        SeriesData.prototype.mapArray = function(dims, cb, ctx) {
            'use strict';
            if (typeof dims === 'function') {
                ctx = cb;
                cb = dims;
                dims = [];
            }
            ctx = ctx || this;
            var result = [];
            this.each(dims, function() {
                result.push(cb && cb.apply(this, arguments));
            }, ctx);
            return result;
        };
        SeriesData.prototype.map = function(dims, cb, ctx, ctxCompat) {
            'use strict';
            var fCtx = ctx || ctxCompat || this;
            var dimIndices = $f818ba28c897a2f2$var$map($f818ba28c897a2f2$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
            var list = $f818ba28c897a2f2$var$cloneListForMapAndSample(this);
            list._store = this._store.map(dimIndices, fCtx ? (0, parcelRequire("bahqM")).bind(cb, fCtx) : cb);
            return list;
        };
        SeriesData.prototype.modify = function(dims, cb, ctx, ctxCompat) {
            var _this = this;
            var fCtx = ctx || ctxCompat || this;
            var dimIndices = $f818ba28c897a2f2$var$map($f818ba28c897a2f2$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
            this._store.modify(dimIndices, fCtx ? (0, parcelRequire("bahqM")).bind(cb, fCtx) : cb);
        };
        SeriesData.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
            var list = $f818ba28c897a2f2$var$cloneListForMapAndSample(this);
            list._store = this._store.downSample(this._getStoreDimIndex(dimension), rate, sampleValue, sampleIndex);
            return list;
        };
        SeriesData.prototype.lttbDownSample = function(valueDimension, rate) {
            var list = $f818ba28c897a2f2$var$cloneListForMapAndSample(this);
            list._store = this._store.lttbDownSample(this._getStoreDimIndex(valueDimension), rate);
            return list;
        };
        SeriesData.prototype.getRawDataItem = function(idx) {
            return this._store.getRawDataItem(idx);
        };
        SeriesData.prototype.getItemModel = function(idx) {
            var hostModel = this.hostModel;
            var dataItem = this.getRawDataItem(idx);
            return new (0, (0, parcelRequire("gaMkj")).default)(dataItem, hostModel, hostModel && hostModel.ecModel);
        };
        SeriesData.prototype.diff = function(otherList) {
            var thisList = this;
            return new (0, (0, parcelRequire("4wWkb")).default)(otherList ? otherList.getStore().getIndices() : [], this.getStore().getIndices(), function(idx) {
                return $f818ba28c897a2f2$var$getId(otherList, idx);
            }, function(idx) {
                return $f818ba28c897a2f2$var$getId(thisList, idx);
            });
        };
        SeriesData.prototype.getVisual = function(key) {
            var visual = this._visual;
            return visual && visual[key];
        };
        SeriesData.prototype.setVisual = function(kvObj, val) {
            this._visual = this._visual || {};
            if ($f818ba28c897a2f2$var$isObject(kvObj)) (0, parcelRequire("bahqM")).extend(this._visual, kvObj);
            else this._visual[kvObj] = val;
        };
        SeriesData.prototype.getItemVisual = function(idx, key) {
            var itemVisual = this._itemVisuals[idx];
            var val = itemVisual && itemVisual[key];
            if (val == null) return this.getVisual(key);
            return val;
        };
        SeriesData.prototype.hasItemVisual = function() {
            return this._itemVisuals.length > 0;
        };
        SeriesData.prototype.ensureUniqueItemVisual = function(idx, key) {
            var itemVisuals = this._itemVisuals;
            var itemVisual = itemVisuals[idx];
            if (!itemVisual) itemVisual = itemVisuals[idx] = {};
            var val = itemVisual[key];
            if (val == null) {
                val = this.getVisual(key);
                if ((0, parcelRequire("bahqM")).isArray(val)) val = val.slice();
                else if ($f818ba28c897a2f2$var$isObject(val)) val = (0, parcelRequire("bahqM")).extend({}, val);
                itemVisual[key] = val;
            }
            return val;
        };
        SeriesData.prototype.setItemVisual = function(idx, key, value) {
            var itemVisual = this._itemVisuals[idx] || {};
            this._itemVisuals[idx] = itemVisual;
            if ($f818ba28c897a2f2$var$isObject(key)) (0, parcelRequire("bahqM")).extend(itemVisual, key);
            else itemVisual[key] = value;
        };
        SeriesData.prototype.clearAllVisual = function() {
            this._visual = {};
            this._itemVisuals = [];
        };
        SeriesData.prototype.setLayout = function(key, val) {
            if ($f818ba28c897a2f2$var$isObject(key)) {
                for(var name_1 in key)if (key.hasOwnProperty(name_1)) this.setLayout(name_1, key[name_1]);
                return;
            }
            this._layout[key] = val;
        };
        SeriesData.prototype.getLayout = function(key) {
            return this._layout[key];
        };
        SeriesData.prototype.getItemLayout = function(idx) {
            return this._itemLayouts[idx];
        };
        SeriesData.prototype.setItemLayout = function(idx, layout, merge) {
            this._itemLayouts[idx] = merge ? (0, parcelRequire("bahqM")).extend(this._itemLayouts[idx] || {}, layout) : layout;
        };
        SeriesData.prototype.clearItemLayouts = function() {
            this._itemLayouts.length = 0;
        };
        SeriesData.prototype.setItemGraphicEl = function(idx, el) {
            var seriesIndex = this.hostModel && this.hostModel.seriesIndex;
            (0, (0, parcelRequire("7QjoM")).setCommonECData)(seriesIndex, this.dataType, idx, el);
            this._graphicEls[idx] = el;
        };
        SeriesData.prototype.getItemGraphicEl = function(idx) {
            return this._graphicEls[idx];
        };
        SeriesData.prototype.eachItemGraphicEl = function(cb, context) {
            (0, parcelRequire("bahqM")).each(this._graphicEls, function(el, idx) {
                if (el) cb && cb.call(context, el, idx);
            });
        };
        SeriesData.prototype.cloneShallow = function(list) {
            if (!list) list = new SeriesData(this._schema ? this._schema : $f818ba28c897a2f2$var$map(this.dimensions, this._getDimInfo, this), this.hostModel);
            $f818ba28c897a2f2$var$transferProperties(list, this);
            list._store = this._store;
            return list;
        };
        SeriesData.prototype.wrapMethod = function(methodName, injectFunction) {
            var originalMethod = this[methodName];
            if (typeof originalMethod !== 'function') return;
            this.__wrappedMethods = this.__wrappedMethods || [];
            this.__wrappedMethods.push(methodName);
            this[methodName] = function() {
                var res = originalMethod.apply(this, arguments);
                return injectFunction.apply(this, [
                    res
                ].concat((0, parcelRequire("bahqM")).slice(arguments)));
            };
        };
        SeriesData.internalField = function() {
            $f818ba28c897a2f2$var$prepareInvertedIndex = function(data) {
                var invertedIndicesMap = data._invertedIndicesMap;
                (0, parcelRequire("bahqM")).each(invertedIndicesMap, function(invertedIndices, dim) {
                    var dimInfo = data._dimInfos[dim];
                    var ordinalMeta = dimInfo.ordinalMeta;
                    var store = data._store;
                    if (ordinalMeta) {
                        invertedIndices = invertedIndicesMap[dim] = new $f818ba28c897a2f2$var$CtorInt32Array(ordinalMeta.categories.length);
                        for(var i = 0; i < invertedIndices.length; i++)invertedIndices[i] = $f818ba28c897a2f2$var$INDEX_NOT_FOUND;
                        for(var i = 0; i < store.count(); i++)invertedIndices[store.get(dimInfo.storeDimIndex, i)] = i;
                    }
                });
            };
            $f818ba28c897a2f2$var$getIdNameFromStore = function(data, dimIdx, idx) {
                return (0, (0, parcelRequire("eaKsF")).convertOptionIdName)(data._getCategory(dimIdx, idx), null);
            };
            $f818ba28c897a2f2$var$getId = function(data, rawIndex) {
                var id = data._idList[rawIndex];
                if (id == null && data._idDimIdx != null) id = $f818ba28c897a2f2$var$getIdNameFromStore(data, data._idDimIdx, rawIndex);
                if (id == null) id = $f818ba28c897a2f2$var$ID_PREFIX + rawIndex;
                return id;
            };
            $f818ba28c897a2f2$var$normalizeDimensions = function(dimensions) {
                if (!(0, parcelRequire("bahqM")).isArray(dimensions)) dimensions = dimensions != null ? [
                    dimensions
                ] : [];
                return dimensions;
            };
            $f818ba28c897a2f2$var$cloneListForMapAndSample = function(original) {
                var list = new SeriesData(original._schema ? original._schema : $f818ba28c897a2f2$var$map(original.dimensions, original._getDimInfo, original), original.hostModel);
                $f818ba28c897a2f2$var$transferProperties(list, original);
                return list;
            };
            $f818ba28c897a2f2$var$transferProperties = function(target, source) {
                (0, parcelRequire("bahqM")).each($f818ba28c897a2f2$var$TRANSFERABLE_PROPERTIES.concat(source.__wrappedMethods || []), function(propName) {
                    if (source.hasOwnProperty(propName)) target[propName] = source[propName];
                });
                target.__wrappedMethods = source.__wrappedMethods;
                (0, parcelRequire("bahqM")).each($f818ba28c897a2f2$var$CLONE_PROPERTIES, function(propName) {
                    target[propName] = (0, parcelRequire("bahqM")).clone(source[propName]);
                });
                target._calculationInfo = (0, parcelRequire("bahqM")).extend({}, source._calculationInfo);
            };
            $f818ba28c897a2f2$var$makeIdFromName = function(data, idx) {
                var nameList = data._nameList;
                var idList = data._idList;
                var nameDimIdx = data._nameDimIdx;
                var idDimIdx = data._idDimIdx;
                var name = nameList[idx];
                var id = idList[idx];
                if (name == null && nameDimIdx != null) nameList[idx] = name = $f818ba28c897a2f2$var$getIdNameFromStore(data, nameDimIdx, idx);
                if (id == null && idDimIdx != null) idList[idx] = id = $f818ba28c897a2f2$var$getIdNameFromStore(data, idDimIdx, idx);
                if (id == null && name != null) {
                    var nameRepeatCount = data._nameRepeatCount;
                    var nmCnt = nameRepeatCount[name] = (nameRepeatCount[name] || 0) + 1;
                    id = name;
                    if (nmCnt > 1) id += '__ec__' + nmCnt;
                    idList[idx] = id;
                }
            };
        }();
        return SeriesData;
    }();
    var $f818ba28c897a2f2$export$2e2bcd8739ae039 = $f818ba28c897a2f2$var$SeriesData;
});
parcelRegister("4wWkb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$34c7649bb9fc460b$export$2e2bcd8739ae039);
    function $34c7649bb9fc460b$var$dataIndexMapValueLength(valNumOrArrLengthMoreThan2) {
        return valNumOrArrLengthMoreThan2 == null ? 0 : valNumOrArrLengthMoreThan2.length || 1;
    }
    function $34c7649bb9fc460b$var$defaultKeyGetter(item) {
        return item;
    }
    var $34c7649bb9fc460b$var$DataDiffer = function() {
        function DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context, diffMode) {
            this._old = oldArr;
            this._new = newArr;
            this._oldKeyGetter = oldKeyGetter || $34c7649bb9fc460b$var$defaultKeyGetter;
            this._newKeyGetter = newKeyGetter || $34c7649bb9fc460b$var$defaultKeyGetter;
            this.context = context;
            this._diffModeMultiple = diffMode === 'multiple';
        }
        DataDiffer.prototype.add = function(func) {
            this._add = func;
            return this;
        };
        DataDiffer.prototype.update = function(func) {
            this._update = func;
            return this;
        };
        DataDiffer.prototype.updateManyToOne = function(func) {
            this._updateManyToOne = func;
            return this;
        };
        DataDiffer.prototype.updateOneToMany = function(func) {
            this._updateOneToMany = func;
            return this;
        };
        DataDiffer.prototype.updateManyToMany = function(func) {
            this._updateManyToMany = func;
            return this;
        };
        DataDiffer.prototype.remove = function(func) {
            this._remove = func;
            return this;
        };
        DataDiffer.prototype.execute = function() {
            this[this._diffModeMultiple ? '_executeMultiple' : '_executeOneToOne']();
        };
        DataDiffer.prototype._executeOneToOne = function() {
            var oldArr = this._old;
            var newArr = this._new;
            var newDataIndexMap = {};
            var oldDataKeyArr = new Array(oldArr.length);
            var newDataKeyArr = new Array(newArr.length);
            this._initIndexMap(oldArr, null, oldDataKeyArr, '_oldKeyGetter');
            this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');
            for(var i = 0; i < oldArr.length; i++){
                var oldKey = oldDataKeyArr[i];
                var newIdxMapVal = newDataIndexMap[oldKey];
                var newIdxMapValLen = $34c7649bb9fc460b$var$dataIndexMapValueLength(newIdxMapVal);
                if (newIdxMapValLen > 1) {
                    var newIdx = newIdxMapVal.shift();
                    if (newIdxMapVal.length === 1) newDataIndexMap[oldKey] = newIdxMapVal[0];
                    this._update && this._update(newIdx, i);
                } else if (newIdxMapValLen === 1) {
                    newDataIndexMap[oldKey] = null;
                    this._update && this._update(newIdxMapVal, i);
                } else this._remove && this._remove(i);
            }
            this._performRestAdd(newDataKeyArr, newDataIndexMap);
        };
        DataDiffer.prototype._executeMultiple = function() {
            var oldArr = this._old;
            var newArr = this._new;
            var oldDataIndexMap = {};
            var newDataIndexMap = {};
            var oldDataKeyArr = [];
            var newDataKeyArr = [];
            this._initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, '_oldKeyGetter');
            this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');
            for(var i = 0; i < oldDataKeyArr.length; i++){
                var oldKey = oldDataKeyArr[i];
                var oldIdxMapVal = oldDataIndexMap[oldKey];
                var newIdxMapVal = newDataIndexMap[oldKey];
                var oldIdxMapValLen = $34c7649bb9fc460b$var$dataIndexMapValueLength(oldIdxMapVal);
                var newIdxMapValLen = $34c7649bb9fc460b$var$dataIndexMapValueLength(newIdxMapVal);
                if (oldIdxMapValLen > 1 && newIdxMapValLen === 1) {
                    this._updateManyToOne && this._updateManyToOne(newIdxMapVal, oldIdxMapVal);
                    newDataIndexMap[oldKey] = null;
                } else if (oldIdxMapValLen === 1 && newIdxMapValLen > 1) {
                    this._updateOneToMany && this._updateOneToMany(newIdxMapVal, oldIdxMapVal);
                    newDataIndexMap[oldKey] = null;
                } else if (oldIdxMapValLen === 1 && newIdxMapValLen === 1) {
                    this._update && this._update(newIdxMapVal, oldIdxMapVal);
                    newDataIndexMap[oldKey] = null;
                } else if (oldIdxMapValLen > 1 && newIdxMapValLen > 1) {
                    this._updateManyToMany && this._updateManyToMany(newIdxMapVal, oldIdxMapVal);
                    newDataIndexMap[oldKey] = null;
                } else if (oldIdxMapValLen > 1) for(var i_1 = 0; i_1 < oldIdxMapValLen; i_1++)this._remove && this._remove(oldIdxMapVal[i_1]);
                else this._remove && this._remove(oldIdxMapVal);
            }
            this._performRestAdd(newDataKeyArr, newDataIndexMap);
        };
        DataDiffer.prototype._performRestAdd = function(newDataKeyArr, newDataIndexMap) {
            for(var i = 0; i < newDataKeyArr.length; i++){
                var newKey = newDataKeyArr[i];
                var newIdxMapVal = newDataIndexMap[newKey];
                var idxMapValLen = $34c7649bb9fc460b$var$dataIndexMapValueLength(newIdxMapVal);
                if (idxMapValLen > 1) for(var j = 0; j < idxMapValLen; j++)this._add && this._add(newIdxMapVal[j]);
                else if (idxMapValLen === 1) this._add && this._add(newIdxMapVal);
                newDataIndexMap[newKey] = null;
            }
        };
        DataDiffer.prototype._initIndexMap = function(arr, map, keyArr, keyGetterName) {
            var cbModeMultiple = this._diffModeMultiple;
            for(var i = 0; i < arr.length; i++){
                var key = '_ec_' + this[keyGetterName](arr[i], i);
                if (!cbModeMultiple) keyArr[i] = key;
                if (!map) continue;
                var idxMapVal = map[key];
                var idxMapValLen = $34c7649bb9fc460b$var$dataIndexMapValueLength(idxMapVal);
                if (idxMapValLen === 0) {
                    map[key] = i;
                    if (cbModeMultiple) keyArr.push(key);
                } else if (idxMapValLen === 1) map[key] = [
                    idxMapVal,
                    i
                ];
                else idxMapVal.push(i);
            }
        };
        return DataDiffer;
    }();
    var $34c7649bb9fc460b$export$2e2bcd8739ae039 = $34c7649bb9fc460b$var$DataDiffer;
});
parcelRegister("bnVGB", function(module, exports) {
    $parcel$export(module.exports, "summarizeDimensions", ()=>$849e96f8af2f129f$export$505a22c3734846f1);
    $parcel$export(module.exports, "getDimensionTypeByAxis", ()=>$849e96f8af2f129f$export$af1622903e71278e);
    var $bahqM;
    var $2Rbm1;
    var $849e96f8af2f129f$var$DimensionUserOuput = function() {
        function DimensionUserOuput(encode, dimRequest) {
            this._encode = encode;
            this._schema = dimRequest;
        }
        DimensionUserOuput.prototype.get = function() {
            return {
                fullDimensions: this._getFullDimensionNames(),
                encode: this._encode
            };
        };
        DimensionUserOuput.prototype._getFullDimensionNames = function() {
            if (!this._cachedDimNames) this._cachedDimNames = this._schema ? this._schema.makeOutputDimensionNames() : [];
            return this._cachedDimNames;
        };
        return DimensionUserOuput;
    }();
    function $849e96f8af2f129f$export$505a22c3734846f1(data, schema) {
        var summary = {};
        var encode = summary.encode = {};
        var notExtraCoordDimMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        var defaultedLabel = [];
        var defaultedTooltip = [];
        var userOutputEncode = {};
        (0, (0, parcelRequire("bahqM")).each)(data.dimensions, function(dimName) {
            var dimItem = data.getDimensionInfo(dimName);
            var coordDim = dimItem.coordDim;
            if (coordDim) {
                var coordDimIndex = dimItem.coordDimIndex;
                $849e96f8af2f129f$var$getOrCreateEncodeArr(encode, coordDim)[coordDimIndex] = dimName;
                if (!dimItem.isExtraCoord) {
                    notExtraCoordDimMap.set(coordDim, 1);
                    if ($849e96f8af2f129f$var$mayLabelDimType(dimItem.type)) defaultedLabel[0] = dimName;
                    $849e96f8af2f129f$var$getOrCreateEncodeArr(userOutputEncode, coordDim)[coordDimIndex] = data.getDimensionIndex(dimItem.name);
                }
                if (dimItem.defaultTooltip) defaultedTooltip.push(dimName);
            }
            (0, (0, parcelRequire("2Rbm1")).VISUAL_DIMENSIONS).each(function(v, otherDim) {
                var encodeArr = $849e96f8af2f129f$var$getOrCreateEncodeArr(encode, otherDim);
                var dimIndex = dimItem.otherDims[otherDim];
                if (dimIndex != null && dimIndex !== false) encodeArr[dimIndex] = dimItem.name;
            });
        });
        var dataDimsOnCoord = [];
        var encodeFirstDimNotExtra = {};
        notExtraCoordDimMap.each(function(v, coordDim) {
            var dimArr = encode[coordDim];
            encodeFirstDimNotExtra[coordDim] = dimArr[0];
            dataDimsOnCoord = dataDimsOnCoord.concat(dimArr);
        });
        summary.dataDimsOnCoord = dataDimsOnCoord;
        summary.dataDimIndicesOnCoord = (0, (0, parcelRequire("bahqM")).map)(dataDimsOnCoord, function(dimName) {
            return data.getDimensionInfo(dimName).storeDimIndex;
        });
        summary.encodeFirstDimNotExtra = encodeFirstDimNotExtra;
        var encodeLabel = encode.label;
        if (encodeLabel && encodeLabel.length) defaultedLabel = encodeLabel.slice();
        var encodeTooltip = encode.tooltip;
        if (encodeTooltip && encodeTooltip.length) defaultedTooltip = encodeTooltip.slice();
        else if (!defaultedTooltip.length) defaultedTooltip = defaultedLabel.slice();
        encode.defaultedLabel = defaultedLabel;
        encode.defaultedTooltip = defaultedTooltip;
        summary.userOutput = new $849e96f8af2f129f$var$DimensionUserOuput(userOutputEncode, schema);
        return summary;
    }
    function $849e96f8af2f129f$var$getOrCreateEncodeArr(encode, dim) {
        if (!encode.hasOwnProperty(dim)) encode[dim] = [];
        return encode[dim];
    }
    function $849e96f8af2f129f$export$af1622903e71278e(axisType) {
        return axisType === 'category' ? 'ordinal' : axisType === 'time' ? 'time' : 'float';
    }
    function $849e96f8af2f129f$var$mayLabelDimType(dimType) {
        return !(dimType === 'ordinal' || dimType === 'time');
    }
});
parcelRegister("dhxbO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ab69ba7880d9dc2$export$2e2bcd8739ae039);
    var $bahqM;
    var $9ab69ba7880d9dc2$var$SeriesDimensionDefine = function() {
        function SeriesDimensionDefine(opt) {
            this.otherDims = {};
            if (opt != null) (0, parcelRequire("bahqM")).extend(this, opt);
        }
        return SeriesDimensionDefine;
    }();
    var $9ab69ba7880d9dc2$export$2e2bcd8739ae039 = $9ab69ba7880d9dc2$var$SeriesDimensionDefine;
});
parcelRegister("h9jiS", function(module, exports) {
    $parcel$export(module.exports, "createDimensions", ()=>$c7c240344387234c$export$8066c1b52b2e9504);
    $parcel$export(module.exports, "default", ()=>$c7c240344387234c$export$2e2bcd8739ae039);
    var $2Rbm1;
    var $dhxbO;
    var $bahqM;
    var $20liu;
    var $8c3gC;
    var $eaKsF;
    var $cNGs8;
    var $2Om11;
    function $c7c240344387234c$export$8066c1b52b2e9504(source, opt) {
        return $c7c240344387234c$export$2e2bcd8739ae039(source, opt).dimensions;
    }
    function $c7c240344387234c$export$2e2bcd8739ae039(source, opt) {
        if (!(0, (0, parcelRequire("20liu")).isSourceInstance)(source)) source = (0, (0, parcelRequire("20liu")).createSourceFromSeriesDataOption)(source);
        opt = opt || {};
        var sysDims = opt.coordDimensions || [];
        var dimsDef = opt.dimensionsDefine || source.dimensionsDefine || [];
        var coordDimNameMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        var resultList = [];
        var dimCount = $c7c240344387234c$var$getDimCount(source, sysDims, dimsDef, opt.dimensionsCount);
        var omitUnusedDimensions = opt.canOmitUnusedDimensions && (0, (0, parcelRequire("2Om11")).shouldOmitUnusedDimensions)(dimCount);
        var isUsingSourceDimensionsDef = dimsDef === source.dimensionsDefine;
        var dataDimNameMap = isUsingSourceDimensionsDef ? (0, (0, parcelRequire("2Om11")).ensureSourceDimNameMap)(source) : (0, (0, parcelRequire("2Om11")).createDimNameMap)(dimsDef);
        var encodeDef = opt.encodeDefine;
        if (!encodeDef && opt.encodeDefaulter) encodeDef = opt.encodeDefaulter(source, dimCount);
        var encodeDefMap = (0, (0, parcelRequire("bahqM")).createHashMap)(encodeDef);
        var indicesMap = new (0, (0, parcelRequire("8c3gC")).CtorInt32Array)(dimCount);
        for(var i = 0; i < indicesMap.length; i++)indicesMap[i] = -1;
        function getResultItem(dimIdx) {
            var idx = indicesMap[dimIdx];
            if (idx < 0) {
                var dimDefItemRaw = dimsDef[dimIdx];
                var dimDefItem = (0, (0, parcelRequire("bahqM")).isObject)(dimDefItemRaw) ? dimDefItemRaw : {
                    name: dimDefItemRaw
                };
                var resultItem = new (0, (0, parcelRequire("dhxbO")).default)();
                var userDimName = dimDefItem.name;
                if (userDimName != null && dataDimNameMap.get(userDimName) != null) resultItem.name = resultItem.displayName = userDimName;
                dimDefItem.type != null && (resultItem.type = dimDefItem.type);
                dimDefItem.displayName != null && (resultItem.displayName = dimDefItem.displayName);
                var newIdx = resultList.length;
                indicesMap[dimIdx] = newIdx;
                resultItem.storeDimIndex = dimIdx;
                resultList.push(resultItem);
                return resultItem;
            }
            return resultList[idx];
        }
        if (!omitUnusedDimensions) for(var i = 0; i < dimCount; i++)getResultItem(i);
        encodeDefMap.each(function(dataDimsRaw, coordDim) {
            var dataDims = (0, (0, parcelRequire("eaKsF")).normalizeToArray)(dataDimsRaw).slice();
            if (dataDims.length === 1 && !(0, (0, parcelRequire("bahqM")).isString)(dataDims[0]) && dataDims[0] < 0) {
                encodeDefMap.set(coordDim, false);
                return;
            }
            var validDataDims = encodeDefMap.set(coordDim, []);
            (0, (0, parcelRequire("bahqM")).each)(dataDims, function(resultDimIdxOrName, idx) {
                var resultDimIdx = (0, (0, parcelRequire("bahqM")).isString)(resultDimIdxOrName) ? dataDimNameMap.get(resultDimIdxOrName) : resultDimIdxOrName;
                if (resultDimIdx != null && resultDimIdx < dimCount) {
                    validDataDims[idx] = resultDimIdx;
                    applyDim(getResultItem(resultDimIdx), coordDim, idx);
                }
            });
        });
        var availDimIdx = 0;
        (0, (0, parcelRequire("bahqM")).each)(sysDims, function(sysDimItemRaw) {
            var coordDim;
            var sysDimItemDimsDef;
            var sysDimItemOtherDims;
            var sysDimItem;
            if ((0, (0, parcelRequire("bahqM")).isString)(sysDimItemRaw)) {
                coordDim = sysDimItemRaw;
                sysDimItem = {};
            } else {
                sysDimItem = sysDimItemRaw;
                coordDim = sysDimItem.name;
                var ordinalMeta = sysDimItem.ordinalMeta;
                sysDimItem.ordinalMeta = null;
                sysDimItem = (0, (0, parcelRequire("bahqM")).extend)({}, sysDimItem);
                sysDimItem.ordinalMeta = ordinalMeta;
                sysDimItemDimsDef = sysDimItem.dimsDef;
                sysDimItemOtherDims = sysDimItem.otherDims;
                sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
            }
            var dataDims = encodeDefMap.get(coordDim);
            if (dataDims === false) return;
            dataDims = (0, (0, parcelRequire("eaKsF")).normalizeToArray)(dataDims);
            if (!dataDims.length) for(var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++){
                while(availDimIdx < dimCount && getResultItem(availDimIdx).coordDim != null)availDimIdx++;
                availDimIdx < dimCount && dataDims.push(availDimIdx++);
            }
            (0, (0, parcelRequire("bahqM")).each)(dataDims, function(resultDimIdx, coordDimIndex) {
                var resultItem = getResultItem(resultDimIdx);
                if (isUsingSourceDimensionsDef && sysDimItem.type != null) resultItem.type = sysDimItem.type;
                applyDim((0, (0, parcelRequire("bahqM")).defaults)(resultItem, sysDimItem), coordDim, coordDimIndex);
                if (resultItem.name == null && sysDimItemDimsDef) {
                    var sysDimItemDimsDefItem = sysDimItemDimsDef[coordDimIndex];
                    !(0, (0, parcelRequire("bahqM")).isObject)(sysDimItemDimsDefItem) && (sysDimItemDimsDefItem = {
                        name: sysDimItemDimsDefItem
                    });
                    resultItem.name = resultItem.displayName = sysDimItemDimsDefItem.name;
                    resultItem.defaultTooltip = sysDimItemDimsDefItem.defaultTooltip;
                }
                sysDimItemOtherDims && (0, (0, parcelRequire("bahqM")).defaults)(resultItem.otherDims, sysDimItemOtherDims);
            });
        });
        function applyDim(resultItem, coordDim, coordDimIndex) {
            if ((0, (0, parcelRequire("2Rbm1")).VISUAL_DIMENSIONS).get(coordDim) != null) resultItem.otherDims[coordDim] = coordDimIndex;
            else {
                resultItem.coordDim = coordDim;
                resultItem.coordDimIndex = coordDimIndex;
                coordDimNameMap.set(coordDim, true);
            }
        }
        var generateCoord = opt.generateCoord;
        var generateCoordCount = opt.generateCoordCount;
        var fromZero = generateCoordCount != null;
        generateCoordCount = generateCoord ? generateCoordCount || 1 : 0;
        var extra = generateCoord || 'value';
        function ifNoNameFillWithCoordName(resultItem) {
            if (resultItem.name == null) resultItem.name = resultItem.coordDim;
        }
        if (!omitUnusedDimensions) for(var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++){
            var resultItem = getResultItem(resultDimIdx);
            var coordDim = resultItem.coordDim;
            if (coordDim == null) {
                resultItem.coordDim = $c7c240344387234c$var$genCoordDimName(extra, coordDimNameMap, fromZero);
                resultItem.coordDimIndex = 0;
                if (!generateCoord || generateCoordCount <= 0) resultItem.isExtraCoord = true;
                generateCoordCount--;
            }
            ifNoNameFillWithCoordName(resultItem);
            if (resultItem.type == null && ((0, (0, parcelRequire("cNGs8")).guessOrdinal)(source, resultDimIdx) === (0, (0, parcelRequire("cNGs8")).BE_ORDINAL).Must || resultItem.isExtraCoord && (resultItem.otherDims.itemName != null || resultItem.otherDims.seriesName != null))) resultItem.type = 'ordinal';
        }
        else {
            (0, (0, parcelRequire("bahqM")).each)(resultList, function(resultItem) {
                ifNoNameFillWithCoordName(resultItem);
            });
            resultList.sort(function(item0, item1) {
                return item0.storeDimIndex - item1.storeDimIndex;
            });
        }
        $c7c240344387234c$var$removeDuplication(resultList);
        return new (0, (0, parcelRequire("2Om11")).SeriesDataSchema)({
            source: source,
            dimensions: resultList,
            fullDimensionCount: dimCount,
            dimensionOmitted: omitUnusedDimensions
        });
    }
    function $c7c240344387234c$var$removeDuplication(result) {
        var duplicationMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        for(var i = 0; i < result.length; i++){
            var dim = result[i];
            var dimOriginalName = dim.name;
            var count = duplicationMap.get(dimOriginalName) || 0;
            if (count > 0) dim.name = dimOriginalName + (count - 1);
            count++;
            duplicationMap.set(dimOriginalName, count);
        }
    }
    function $c7c240344387234c$var$getDimCount(source, sysDims, dimsDef, optDimCount) {
        var dimCount = Math.max(source.dimensionsDetectedCount || 1, sysDims.length, dimsDef.length, optDimCount || 0);
        (0, (0, parcelRequire("bahqM")).each)(sysDims, function(sysDimItem) {
            var sysDimItemDimsDef;
            if ((0, (0, parcelRequire("bahqM")).isObject)(sysDimItem) && (sysDimItemDimsDef = sysDimItem.dimsDef)) dimCount = Math.max(dimCount, sysDimItemDimsDef.length);
        });
        return dimCount;
    }
    function $c7c240344387234c$var$genCoordDimName(name, map, fromZero) {
        var mapData = map.data;
        if (fromZero || mapData.hasOwnProperty(name)) {
            var i = 0;
            while(mapData.hasOwnProperty(name + i))i++;
            name += i;
        }
        map.set(name, true);
        return name;
    }
});
parcelRegister("gyhNQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0cda1a15c9ef40a$export$2e2bcd8739ae039);
    var $bahqM;
    var $c0cda1a15c9ef40a$var$coordinateSystemCreators = {};
    var $c0cda1a15c9ef40a$var$CoordinateSystemManager = function() {
        function CoordinateSystemManager() {
            this._coordinateSystems = [];
        }
        CoordinateSystemManager.prototype.create = function(ecModel, api) {
            var coordinateSystems = [];
            (0, parcelRequire("bahqM")).each($c0cda1a15c9ef40a$var$coordinateSystemCreators, function(creater, type) {
                var list = creater.create(ecModel, api);
                coordinateSystems = coordinateSystems.concat(list || []);
            });
            this._coordinateSystems = coordinateSystems;
        };
        CoordinateSystemManager.prototype.update = function(ecModel, api) {
            (0, parcelRequire("bahqM")).each(this._coordinateSystems, function(coordSys) {
                coordSys.update && coordSys.update(ecModel, api);
            });
        };
        CoordinateSystemManager.prototype.getCoordinateSystems = function() {
            return this._coordinateSystems.slice();
        };
        CoordinateSystemManager.register = function(type, creator) {
            $c0cda1a15c9ef40a$var$coordinateSystemCreators[type] = creator;
        };
        CoordinateSystemManager.get = function(type) {
            return $c0cda1a15c9ef40a$var$coordinateSystemCreators[type];
        };
        return CoordinateSystemManager;
    }();
    var $c0cda1a15c9ef40a$export$2e2bcd8739ae039 = $c0cda1a15c9ef40a$var$CoordinateSystemManager;
});
parcelRegister("lhMGv", function(module, exports) {
    $parcel$export(module.exports, "getCoordSysInfoBySeries", ()=>$f7f0f3461c4b4907$export$f2befeb2f4933656);
    var $bahqM;
    var $eaKsF;
    var $f7f0f3461c4b4907$var$CoordSysInfo = function() {
        function CoordSysInfo(coordSysName) {
            this.coordSysDims = [];
            this.axisMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
            this.categoryAxisMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
            this.coordSysName = coordSysName;
        }
        return CoordSysInfo;
    }();
    function $f7f0f3461c4b4907$export$f2befeb2f4933656(seriesModel) {
        var coordSysName = seriesModel.get('coordinateSystem');
        var result = new $f7f0f3461c4b4907$var$CoordSysInfo(coordSysName);
        var fetch = $f7f0f3461c4b4907$var$fetchers[coordSysName];
        if (fetch) {
            fetch(seriesModel, result, result.axisMap, result.categoryAxisMap);
            return result;
        }
    }
    var $f7f0f3461c4b4907$var$fetchers = {
        cartesian2d: function(seriesModel, result, axisMap, categoryAxisMap) {
            var xAxisModel = seriesModel.getReferringComponents('xAxis', (0, (0, parcelRequire("eaKsF")).SINGLE_REFERRING)).models[0];
            var yAxisModel = seriesModel.getReferringComponents('yAxis', (0, (0, parcelRequire("eaKsF")).SINGLE_REFERRING)).models[0];
            result.coordSysDims = [
                'x',
                'y'
            ];
            axisMap.set('x', xAxisModel);
            axisMap.set('y', yAxisModel);
            if ($f7f0f3461c4b4907$var$isCategory(xAxisModel)) {
                categoryAxisMap.set('x', xAxisModel);
                result.firstCategoryDimIndex = 0;
            }
            if ($f7f0f3461c4b4907$var$isCategory(yAxisModel)) {
                categoryAxisMap.set('y', yAxisModel);
                result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
            }
        },
        singleAxis: function(seriesModel, result, axisMap, categoryAxisMap) {
            var singleAxisModel = seriesModel.getReferringComponents('singleAxis', (0, (0, parcelRequire("eaKsF")).SINGLE_REFERRING)).models[0];
            result.coordSysDims = [
                'single'
            ];
            axisMap.set('single', singleAxisModel);
            if ($f7f0f3461c4b4907$var$isCategory(singleAxisModel)) {
                categoryAxisMap.set('single', singleAxisModel);
                result.firstCategoryDimIndex = 0;
            }
        },
        polar: function(seriesModel, result, axisMap, categoryAxisMap) {
            var polarModel = seriesModel.getReferringComponents('polar', (0, (0, parcelRequire("eaKsF")).SINGLE_REFERRING)).models[0];
            var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
            var angleAxisModel = polarModel.findAxisModel('angleAxis');
            result.coordSysDims = [
                'radius',
                'angle'
            ];
            axisMap.set('radius', radiusAxisModel);
            axisMap.set('angle', angleAxisModel);
            if ($f7f0f3461c4b4907$var$isCategory(radiusAxisModel)) {
                categoryAxisMap.set('radius', radiusAxisModel);
                result.firstCategoryDimIndex = 0;
            }
            if ($f7f0f3461c4b4907$var$isCategory(angleAxisModel)) {
                categoryAxisMap.set('angle', angleAxisModel);
                result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
            }
        },
        geo: function(seriesModel, result, axisMap, categoryAxisMap) {
            result.coordSysDims = [
                'lng',
                'lat'
            ];
        },
        parallel: function(seriesModel, result, axisMap, categoryAxisMap) {
            var ecModel = seriesModel.ecModel;
            var parallelModel = ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
            var coordSysDims = result.coordSysDims = parallelModel.dimensions.slice();
            (0, (0, parcelRequire("bahqM")).each)(parallelModel.parallelAxisIndex, function(axisIndex, index) {
                var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
                var axisDim = coordSysDims[index];
                axisMap.set(axisDim, axisModel);
                if ($f7f0f3461c4b4907$var$isCategory(axisModel)) {
                    categoryAxisMap.set(axisDim, axisModel);
                    if (result.firstCategoryDimIndex == null) result.firstCategoryDimIndex = index;
                }
            });
        }
    };
    function $f7f0f3461c4b4907$var$isCategory(axisModel) {
        return axisModel.get('type') === 'category';
    }
});
parcelRegister("hrdVR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb1fc3f08c69a560$export$2e2bcd8739ae039);
    var $3VFsf;
    var $ghQ8v;
    var $4KVOr;
    var $bahqM;
    var $eYgMC;
    parcelRequire("fHITF");
    var $7Tw7u;
    var $elGBV;
    var $eYgMC;
    var $7QjoM;
    var $fIXXx;
    var $gvLUt;
    var $ljaBy;
    var $5fMzf;
    var $eaQLm;
    var $loerw;
    var $40dMe;
    var $5MLZz;
    var $9dNYG;
    var $eYgMC;
    var $cb1fc3f08c69a560$var$_eventPos = [
        0,
        0
    ];
    var $cb1fc3f08c69a560$var$mathMax = Math.max;
    var $cb1fc3f08c69a560$var$mathMin = Math.min;
    function $cb1fc3f08c69a560$var$getClipArea(coord, data) {
        var coordSysClipArea = coord.getArea && coord.getArea();
        if ((0, (0, parcelRequire("40dMe")).isCoordinateSystemType)(coord, 'cartesian2d')) {
            var baseAxis = coord.getBaseAxis();
            if (baseAxis.type !== 'category' || !baseAxis.onBand) {
                var expandWidth = data.getLayout('bandWidth');
                if (baseAxis.isHorizontal()) {
                    coordSysClipArea.x -= expandWidth;
                    coordSysClipArea.width += expandWidth * 2;
                } else {
                    coordSysClipArea.y -= expandWidth;
                    coordSysClipArea.height += expandWidth * 2;
                }
            }
        }
        return coordSysClipArea;
    }
    var $cb1fc3f08c69a560$var$BarView = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(BarView, _super);
        function BarView() {
            var _this = _super.call(this) || this;
            _this.type = BarView.type;
            _this._isFirstFrame = true;
            return _this;
        }
        BarView.prototype.render = function(seriesModel, ecModel, api, payload) {
            this._model = seriesModel;
            this._removeOnRenderedListener(api);
            this._updateDrawMode(seriesModel);
            var coordinateSystemType = seriesModel.get('coordinateSystem');
            if (coordinateSystemType === 'cartesian2d' || coordinateSystemType === 'polar') this._isLargeDraw ? this._renderLarge(seriesModel, ecModel, api) : this._renderNormal(seriesModel, ecModel, api, payload);
        };
        BarView.prototype.incrementalPrepareRender = function(seriesModel) {
            this._clear();
            this._updateDrawMode(seriesModel);
            this._updateLargeClip(seriesModel);
        };
        BarView.prototype.incrementalRender = function(params, seriesModel) {
            this._incrementalRenderLarge(params, seriesModel);
        };
        BarView.prototype._updateDrawMode = function(seriesModel) {
            var isLargeDraw = seriesModel.pipelineContext.large;
            if (this._isLargeDraw == null || isLargeDraw !== this._isLargeDraw) {
                this._isLargeDraw = isLargeDraw;
                this._clear();
            }
        };
        BarView.prototype._renderNormal = function(seriesModel, ecModel, api, payload) {
            var group = this.group;
            var data = seriesModel.getData();
            var oldData = this._data;
            var coord = seriesModel.coordinateSystem;
            var baseAxis = coord.getBaseAxis();
            var isHorizontalOrRadial;
            if (coord.type === 'cartesian2d') isHorizontalOrRadial = baseAxis.isHorizontal();
            else if (coord.type === 'polar') isHorizontalOrRadial = baseAxis.dim === 'angle';
            var animationModel = seriesModel.isAnimationEnabled() ? seriesModel : null;
            var realtimeSortCfg = $cb1fc3f08c69a560$var$shouldRealtimeSort(seriesModel, coord);
            if (realtimeSortCfg) this._enableRealtimeSort(realtimeSortCfg, data, api);
            var needsClip = seriesModel.get('clip', true) || realtimeSortCfg;
            var coordSysClipArea = $cb1fc3f08c69a560$var$getClipArea(coord, data);
            group.removeClipPath();
            var roundCap = seriesModel.get('roundCap', true);
            var drawBackground = seriesModel.get('showBackground', true);
            var backgroundModel = seriesModel.getModel('backgroundStyle');
            var barBorderRadius = backgroundModel.get('borderRadius') || 0;
            var bgEls = [];
            var oldBgEls = this._backgroundEls;
            var isInitSort = payload && payload.isInitSort;
            var isChangeOrder = payload && payload.type === 'changeAxisOrder';
            function createBackground(dataIndex) {
                var bgLayout = $cb1fc3f08c69a560$var$getLayout[coord.type](data, dataIndex);
                var bgEl = $cb1fc3f08c69a560$var$createBackgroundEl(coord, isHorizontalOrRadial, bgLayout);
                bgEl.useStyle(backgroundModel.getItemStyle());
                if (coord.type === 'cartesian2d') bgEl.setShape('r', barBorderRadius);
                bgEls[dataIndex] = bgEl;
                return bgEl;
            }
            data.diff(oldData).add(function(dataIndex) {
                var itemModel = data.getItemModel(dataIndex);
                var layout = $cb1fc3f08c69a560$var$getLayout[coord.type](data, dataIndex, itemModel);
                if (drawBackground) createBackground(dataIndex);
                if (!data.hasValue(dataIndex) || !$cb1fc3f08c69a560$var$isValidLayout[coord.type](layout)) return;
                var isClipped = false;
                if (needsClip) isClipped = $cb1fc3f08c69a560$var$clip[coord.type](coordSysClipArea, layout);
                var el = $cb1fc3f08c69a560$var$elementCreator[coord.type](seriesModel, data, dataIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, false, roundCap);
                $cb1fc3f08c69a560$var$updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
                if (isInitSort) el.attr({
                    shape: layout
                });
                else if (realtimeSortCfg) $cb1fc3f08c69a560$var$updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, dataIndex, isHorizontalOrRadial, false, false);
                else (0, (0, parcelRequire("eYgMC")).initProps)(el, {
                    shape: layout
                }, seriesModel, dataIndex);
                data.setItemGraphicEl(dataIndex, el);
                group.add(el);
                el.ignore = isClipped;
            }).update(function(newIndex, oldIndex) {
                var itemModel = data.getItemModel(newIndex);
                var layout = $cb1fc3f08c69a560$var$getLayout[coord.type](data, newIndex, itemModel);
                if (drawBackground) {
                    var bgEl = void 0;
                    if (oldBgEls.length === 0) bgEl = createBackground(oldIndex);
                    else {
                        bgEl = oldBgEls[oldIndex];
                        bgEl.useStyle(backgroundModel.getItemStyle());
                        if (coord.type === 'cartesian2d') bgEl.setShape('r', barBorderRadius);
                        bgEls[newIndex] = bgEl;
                    }
                    var bgLayout = $cb1fc3f08c69a560$var$getLayout[coord.type](data, newIndex);
                    var shape = $cb1fc3f08c69a560$var$createBackgroundShape(isHorizontalOrRadial, bgLayout, coord);
                    (0, (0, parcelRequire("eYgMC")).updateProps)(bgEl, {
                        shape: shape
                    }, animationModel, newIndex);
                }
                var el = oldData.getItemGraphicEl(oldIndex);
                if (!data.hasValue(newIndex) || !$cb1fc3f08c69a560$var$isValidLayout[coord.type](layout)) {
                    group.remove(el);
                    return;
                }
                var isClipped = false;
                if (needsClip) {
                    isClipped = $cb1fc3f08c69a560$var$clip[coord.type](coordSysClipArea, layout);
                    if (isClipped) group.remove(el);
                }
                if (!el) el = $cb1fc3f08c69a560$var$elementCreator[coord.type](seriesModel, data, newIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, !!el, roundCap);
                else (0, (0, parcelRequire("eYgMC")).saveOldStyle)(el);
                if (!isChangeOrder) $cb1fc3f08c69a560$var$updateStyle(el, data, newIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
                if (isInitSort) el.attr({
                    shape: layout
                });
                else if (realtimeSortCfg) $cb1fc3f08c69a560$var$updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, newIndex, isHorizontalOrRadial, true, isChangeOrder);
                else (0, (0, parcelRequire("eYgMC")).updateProps)(el, {
                    shape: layout
                }, seriesModel, newIndex, null);
                data.setItemGraphicEl(newIndex, el);
                el.ignore = isClipped;
                group.add(el);
            }).remove(function(dataIndex) {
                var el = oldData.getItemGraphicEl(dataIndex);
                el && (0, (0, parcelRequire("eYgMC")).removeElementWithFadeOut)(el, seriesModel, dataIndex);
            }).execute();
            var bgGroup = this._backgroundGroup || (this._backgroundGroup = new (0, (0, parcelRequire("4KVOr")).default)());
            bgGroup.removeAll();
            for(var i = 0; i < bgEls.length; ++i)bgGroup.add(bgEls[i]);
            group.add(bgGroup);
            this._backgroundEls = bgEls;
            this._data = data;
        };
        BarView.prototype._renderLarge = function(seriesModel, ecModel, api) {
            this._clear();
            $cb1fc3f08c69a560$var$createLarge(seriesModel, this.group);
            this._updateLargeClip(seriesModel);
        };
        BarView.prototype._incrementalRenderLarge = function(params, seriesModel) {
            this._removeBackground();
            $cb1fc3f08c69a560$var$createLarge(seriesModel, this.group, true);
        };
        BarView.prototype._updateLargeClip = function(seriesModel) {
            var clipPath = seriesModel.get('clip', true) ? (0, (0, parcelRequire("5fMzf")).createClipPath)(seriesModel.coordinateSystem, false, seriesModel) : null;
            if (clipPath) this.group.setClipPath(clipPath);
            else this.group.removeClipPath();
        };
        BarView.prototype._enableRealtimeSort = function(realtimeSortCfg, data, api) {
            var _this = this;
            if (!data.count()) return;
            var baseAxis = realtimeSortCfg.baseAxis;
            if (this._isFirstFrame) {
                this._dispatchInitSort(data, realtimeSortCfg, api);
                this._isFirstFrame = false;
            } else {
                var orderMapping_1 = function(idx) {
                    var el = data.getItemGraphicEl(idx);
                    if (el) {
                        var shape = el.shape;
                        return (baseAxis.isHorizontal() ? Math.abs(shape.height) : Math.abs(shape.width)) || 0;
                    } else return 0;
                };
                this._onRendered = function() {
                    _this._updateSortWithinSameData(data, orderMapping_1, baseAxis, api);
                };
                api.getZr().on('rendered', this._onRendered);
            }
        };
        BarView.prototype._dataSort = function(data, baseAxis, orderMapping) {
            var info = [];
            data.each(data.mapDimension(baseAxis.dim), function(ordinalNumber, dataIdx) {
                var mappedValue = orderMapping(dataIdx);
                mappedValue = mappedValue == null ? NaN : mappedValue;
                info.push({
                    dataIndex: dataIdx,
                    mappedValue: mappedValue,
                    ordinalNumber: ordinalNumber
                });
            });
            info.sort(function(a, b) {
                return b.mappedValue - a.mappedValue;
            });
            return {
                ordinalNumbers: (0, (0, parcelRequire("bahqM")).map)(info, function(item) {
                    return item.ordinalNumber;
                })
            };
        };
        BarView.prototype._isOrderChangedWithinSameData = function(data, orderMapping, baseAxis) {
            var scale = baseAxis.scale;
            var ordinalDataDim = data.mapDimension(baseAxis.dim);
            var lastValue = Number.MAX_VALUE;
            for(var tickNum = 0, len = scale.getOrdinalMeta().categories.length; tickNum < len; ++tickNum){
                var rawIdx = data.rawIndexOf(ordinalDataDim, scale.getRawOrdinalNumber(tickNum));
                var value = rawIdx < 0 ? Number.MIN_VALUE : orderMapping(data.indexOfRawIndex(rawIdx));
                if (value > lastValue) return true;
                lastValue = value;
            }
            return false;
        };
        BarView.prototype._isOrderDifferentInView = function(orderInfo, baseAxis) {
            var scale = baseAxis.scale;
            var extent = scale.getExtent();
            var tickNum = Math.max(0, extent[0]);
            var tickMax = Math.min(extent[1], scale.getOrdinalMeta().categories.length - 1);
            for(; tickNum <= tickMax; ++tickNum){
                if (orderInfo.ordinalNumbers[tickNum] !== scale.getRawOrdinalNumber(tickNum)) return true;
            }
        };
        BarView.prototype._updateSortWithinSameData = function(data, orderMapping, baseAxis, api) {
            if (!this._isOrderChangedWithinSameData(data, orderMapping, baseAxis)) return;
            var sortInfo = this._dataSort(data, baseAxis, orderMapping);
            if (this._isOrderDifferentInView(sortInfo, baseAxis)) {
                this._removeOnRenderedListener(api);
                api.dispatchAction({
                    type: 'changeAxisOrder',
                    componentType: baseAxis.dim + 'Axis',
                    axisId: baseAxis.index,
                    sortInfo: sortInfo
                });
            }
        };
        BarView.prototype._dispatchInitSort = function(data, realtimeSortCfg, api) {
            var baseAxis = realtimeSortCfg.baseAxis;
            var sortResult = this._dataSort(data, baseAxis, function(dataIdx) {
                return data.get(data.mapDimension(realtimeSortCfg.otherAxis.dim), dataIdx);
            });
            api.dispatchAction({
                type: 'changeAxisOrder',
                componentType: baseAxis.dim + 'Axis',
                isInitSort: true,
                axisId: baseAxis.index,
                sortInfo: sortResult
            });
        };
        BarView.prototype.remove = function(ecModel, api) {
            this._clear(this._model);
            this._removeOnRenderedListener(api);
        };
        BarView.prototype.dispose = function(ecModel, api) {
            this._removeOnRenderedListener(api);
        };
        BarView.prototype._removeOnRenderedListener = function(api) {
            if (this._onRendered) {
                api.getZr().off('rendered', this._onRendered);
                this._onRendered = null;
            }
        };
        BarView.prototype._clear = function(model) {
            var group = this.group;
            var data = this._data;
            if (model && model.isAnimationEnabled() && data && !this._isLargeDraw) {
                this._removeBackground();
                this._backgroundEls = [];
                data.eachItemGraphicEl(function(el) {
                    (0, (0, parcelRequire("eYgMC")).removeElementWithFadeOut)(el, model, (0, (0, parcelRequire("7QjoM")).getECData)(el).dataIndex);
                });
            } else group.removeAll();
            this._data = null;
            this._isFirstFrame = true;
        };
        BarView.prototype._removeBackground = function() {
            this.group.remove(this._backgroundGroup);
            this._backgroundGroup = null;
        };
        BarView.type = 'bar';
        return BarView;
    }((0, (0, parcelRequire("loerw")).default));
    var $cb1fc3f08c69a560$var$clip = {
        cartesian2d: function(coordSysBoundingRect, layout) {
            var signWidth = layout.width < 0 ? -1 : 1;
            var signHeight = layout.height < 0 ? -1 : 1;
            if (signWidth < 0) {
                layout.x += layout.width;
                layout.width = -layout.width;
            }
            if (signHeight < 0) {
                layout.y += layout.height;
                layout.height = -layout.height;
            }
            var coordSysX2 = coordSysBoundingRect.x + coordSysBoundingRect.width;
            var coordSysY2 = coordSysBoundingRect.y + coordSysBoundingRect.height;
            var x = $cb1fc3f08c69a560$var$mathMax(layout.x, coordSysBoundingRect.x);
            var x2 = $cb1fc3f08c69a560$var$mathMin(layout.x + layout.width, coordSysX2);
            var y = $cb1fc3f08c69a560$var$mathMax(layout.y, coordSysBoundingRect.y);
            var y2 = $cb1fc3f08c69a560$var$mathMin(layout.y + layout.height, coordSysY2);
            var xClipped = x2 < x;
            var yClipped = y2 < y;
            layout.x = xClipped && x > coordSysX2 ? x2 : x;
            layout.y = yClipped && y > coordSysY2 ? y2 : y;
            layout.width = xClipped ? 0 : x2 - x;
            layout.height = yClipped ? 0 : y2 - y;
            if (signWidth < 0) {
                layout.x += layout.width;
                layout.width = -layout.width;
            }
            if (signHeight < 0) {
                layout.y += layout.height;
                layout.height = -layout.height;
            }
            return xClipped || yClipped;
        },
        polar: function(coordSysClipArea, layout) {
            var signR = layout.r0 <= layout.r ? 1 : -1;
            if (signR < 0) {
                var tmp = layout.r;
                layout.r = layout.r0;
                layout.r0 = tmp;
            }
            var r = $cb1fc3f08c69a560$var$mathMin(layout.r, coordSysClipArea.r);
            var r0 = $cb1fc3f08c69a560$var$mathMax(layout.r0, coordSysClipArea.r0);
            layout.r = r;
            layout.r0 = r0;
            var clipped = r - r0 < 0;
            if (signR < 0) {
                var tmp = layout.r;
                layout.r = layout.r0;
                layout.r0 = tmp;
            }
            return clipped;
        }
    };
    var $cb1fc3f08c69a560$var$elementCreator = {
        cartesian2d: function(seriesModel, data, newIndex, layout, isHorizontal, animationModel, axisModel, isUpdate, roundCap) {
            var rect = new (0, (0, parcelRequire("7Tw7u")).default)({
                shape: (0, (0, parcelRequire("bahqM")).extend)({}, layout),
                z2: 1
            });
            rect.__dataIndex = newIndex;
            rect.name = 'item';
            if (animationModel) {
                var rectShape = rect.shape;
                var animateProperty = isHorizontal ? 'height' : 'width';
                rectShape[animateProperty] = 0;
            }
            return rect;
        },
        polar: function(seriesModel, data, newIndex, layout, isRadial, animationModel, axisModel, isUpdate, roundCap) {
            var ShapeClass = !isRadial && roundCap ? (0, (0, parcelRequire("eaQLm")).default) : (0, (0, parcelRequire("elGBV")).default);
            var sector = new ShapeClass({
                shape: layout,
                z2: 1
            });
            sector.name = 'item';
            var positionMap = $cb1fc3f08c69a560$var$createPolarPositionMapping(isRadial);
            sector.calculateTextPosition = (0, (0, parcelRequire("9dNYG")).createSectorCalculateTextPosition)(positionMap, {
                isRoundCap: ShapeClass === (0, (0, parcelRequire("eaQLm")).default)
            });
            if (animationModel) {
                var sectorShape = sector.shape;
                var animateProperty = isRadial ? 'r' : 'endAngle';
                var animateTarget = {};
                sectorShape[animateProperty] = isRadial ? 0 : layout.startAngle;
                animateTarget[animateProperty] = layout[animateProperty];
                (isUpdate ? (0, (0, parcelRequire("eYgMC")).updateProps) : (0, (0, parcelRequire("eYgMC")).initProps))(sector, {
                    shape: animateTarget
                }, animationModel);
            }
            return sector;
        }
    };
    function $cb1fc3f08c69a560$var$shouldRealtimeSort(seriesModel, coordSys) {
        var realtimeSortOption = seriesModel.get('realtimeSort', true);
        var baseAxis = coordSys.getBaseAxis();
        if (realtimeSortOption && baseAxis.type === 'category' && coordSys.type === 'cartesian2d') return {
            baseAxis: baseAxis,
            otherAxis: coordSys.getOtherAxis(baseAxis)
        };
    }
    function $cb1fc3f08c69a560$var$updateRealtimeAnimation(realtimeSortCfg, seriesAnimationModel, el, layout, newIndex, isHorizontal, isUpdate, isChangeOrder) {
        var seriesTarget;
        var axisTarget;
        if (isHorizontal) {
            axisTarget = {
                x: layout.x,
                width: layout.width
            };
            seriesTarget = {
                y: layout.y,
                height: layout.height
            };
        } else {
            axisTarget = {
                y: layout.y,
                height: layout.height
            };
            seriesTarget = {
                x: layout.x,
                width: layout.width
            };
        }
        if (!isChangeOrder) (isUpdate ? (0, (0, parcelRequire("eYgMC")).updateProps) : (0, (0, parcelRequire("eYgMC")).initProps))(el, {
            shape: seriesTarget
        }, seriesAnimationModel, newIndex, null);
        var axisAnimationModel = seriesAnimationModel ? realtimeSortCfg.baseAxis.model : null;
        (isUpdate ? (0, (0, parcelRequire("eYgMC")).updateProps) : (0, (0, parcelRequire("eYgMC")).initProps))(el, {
            shape: axisTarget
        }, axisAnimationModel, newIndex);
    }
    function $cb1fc3f08c69a560$var$checkPropertiesNotValid(obj, props) {
        for(var i = 0; i < props.length; i++){
            if (!isFinite(obj[props[i]])) return true;
        }
        return false;
    }
    var $cb1fc3f08c69a560$var$rectPropties = [
        'x',
        'y',
        'width',
        'height'
    ];
    var $cb1fc3f08c69a560$var$polarPropties = [
        'cx',
        'cy',
        'r',
        'startAngle',
        'endAngle'
    ];
    var $cb1fc3f08c69a560$var$isValidLayout = {
        cartesian2d: function(layout) {
            return !$cb1fc3f08c69a560$var$checkPropertiesNotValid(layout, $cb1fc3f08c69a560$var$rectPropties);
        },
        polar: function(layout) {
            return !$cb1fc3f08c69a560$var$checkPropertiesNotValid(layout, $cb1fc3f08c69a560$var$polarPropties);
        }
    };
    var $cb1fc3f08c69a560$var$getLayout = {
        cartesian2d: function(data, dataIndex, itemModel) {
            var layout = data.getItemLayout(dataIndex);
            var fixedLineWidth = itemModel ? $cb1fc3f08c69a560$var$getLineWidth(itemModel, layout) : 0;
            var signX = layout.width > 0 ? 1 : -1;
            var signY = layout.height > 0 ? 1 : -1;
            return {
                x: layout.x + signX * fixedLineWidth / 2,
                y: layout.y + signY * fixedLineWidth / 2,
                width: layout.width - signX * fixedLineWidth,
                height: layout.height - signY * fixedLineWidth
            };
        },
        polar: function(data, dataIndex, itemModel) {
            var layout = data.getItemLayout(dataIndex);
            return {
                cx: layout.cx,
                cy: layout.cy,
                r0: layout.r0,
                r: layout.r,
                startAngle: layout.startAngle,
                endAngle: layout.endAngle,
                clockwise: layout.clockwise
            };
        }
    };
    function $cb1fc3f08c69a560$var$isZeroOnPolar(layout) {
        return layout.startAngle != null && layout.endAngle != null && layout.startAngle === layout.endAngle;
    }
    function $cb1fc3f08c69a560$var$createPolarPositionMapping(isRadial) {
        return function(isRadial) {
            var arcOrAngle = isRadial ? 'Arc' : 'Angle';
            return function(position) {
                switch(position){
                    case 'start':
                    case 'insideStart':
                    case 'end':
                    case 'insideEnd':
                        return position + arcOrAngle;
                    default:
                        return position;
                }
            };
        }(isRadial);
    }
    function $cb1fc3f08c69a560$var$updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, isPolar) {
        var style = data.getItemVisual(dataIndex, 'style');
        if (!isPolar) el.setShape('r', itemModel.get([
            'itemStyle',
            'borderRadius'
        ]) || 0);
        el.useStyle(style);
        var cursorStyle = itemModel.getShallow('cursor');
        cursorStyle && el.attr('cursor', cursorStyle);
        var labelPositionOutside = isPolar ? isHorizontalOrRadial ? layout.r >= layout.r0 ? 'endArc' : 'startArc' : layout.endAngle >= layout.startAngle ? 'endAngle' : 'startAngle' : isHorizontalOrRadial ? layout.height >= 0 ? 'bottom' : 'top' : layout.width >= 0 ? 'right' : 'left';
        var labelStatesModels = (0, (0, parcelRequire("gvLUt")).getLabelStatesModels)(itemModel);
        (0, (0, parcelRequire("gvLUt")).setLabelStyle)(el, labelStatesModels, {
            labelFetcher: seriesModel,
            labelDataIndex: dataIndex,
            defaultText: (0, (0, parcelRequire("5MLZz")).getDefaultLabel)(seriesModel.getData(), dataIndex),
            inheritColor: style.fill,
            defaultOpacity: style.opacity,
            defaultOutsidePosition: labelPositionOutside
        });
        var label = el.getTextContent();
        if (isPolar && label) {
            var position = itemModel.get([
                'label',
                'position'
            ]);
            el.textConfig.inside = position === 'middle' ? true : null;
            (0, (0, parcelRequire("9dNYG")).setSectorTextRotation)(el, position === 'outside' ? labelPositionOutside : position, $cb1fc3f08c69a560$var$createPolarPositionMapping(isHorizontalOrRadial), itemModel.get([
                'label',
                'rotate'
            ]));
        }
        (0, (0, parcelRequire("gvLUt")).setLabelValueAnimation)(label, labelStatesModels, seriesModel.getRawValue(dataIndex), function(value) {
            return (0, (0, parcelRequire("5MLZz")).getDefaultInterpolatedLabel)(data, value);
        });
        var emphasisModel = itemModel.getModel([
            'emphasis'
        ]);
        (0, (0, parcelRequire("fIXXx")).enableHoverEmphasis)(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'));
        (0, (0, parcelRequire("fIXXx")).setStatesStylesFromModel)(el, itemModel);
        if ($cb1fc3f08c69a560$var$isZeroOnPolar(layout)) {
            el.style.fill = 'none';
            el.style.stroke = 'none';
            (0, (0, parcelRequire("bahqM")).each)(el.states, function(state) {
                if (state.style) state.style.fill = state.style.stroke = 'none';
            });
        }
    }
    function $cb1fc3f08c69a560$var$getLineWidth(itemModel, rawLayout) {
        var borderColor = itemModel.get([
            'itemStyle',
            'borderColor'
        ]);
        if (!borderColor || borderColor === 'none') return 0;
        var lineWidth = itemModel.get([
            'itemStyle',
            'borderWidth'
        ]) || 0;
        var width = isNaN(rawLayout.width) ? Number.MAX_VALUE : Math.abs(rawLayout.width);
        var height = isNaN(rawLayout.height) ? Number.MAX_VALUE : Math.abs(rawLayout.height);
        return Math.min(lineWidth, width, height);
    }
    var $cb1fc3f08c69a560$var$LagePathShape = function() {
        function LagePathShape() {}
        return LagePathShape;
    }();
    var $cb1fc3f08c69a560$var$LargePath = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(LargePath, _super);
        function LargePath(opts) {
            var _this = _super.call(this, opts) || this;
            _this.type = 'largeBar';
            return _this;
        }
        LargePath.prototype.getDefaultShape = function() {
            return new $cb1fc3f08c69a560$var$LagePathShape();
        };
        LargePath.prototype.buildPath = function(ctx, shape) {
            var points = shape.points;
            var startPoint = this.__startPoint;
            var baseDimIdx = this.__baseDimIdx;
            for(var i = 0; i < points.length; i += 2){
                startPoint[baseDimIdx] = points[i + baseDimIdx];
                ctx.moveTo(startPoint[0], startPoint[1]);
                ctx.lineTo(points[i], points[i + 1]);
            }
        };
        return LargePath;
    }((0, (0, parcelRequire("ghQ8v")).default));
    function $cb1fc3f08c69a560$var$createLarge(seriesModel, group, incremental) {
        var data = seriesModel.getData();
        var startPoint = [];
        var baseDimIdx = data.getLayout('valueAxisHorizontal') ? 1 : 0;
        startPoint[1 - baseDimIdx] = data.getLayout('valueAxisStart');
        var largeDataIndices = data.getLayout('largeDataIndices');
        var barWidth = data.getLayout('barWidth');
        var backgroundModel = seriesModel.getModel('backgroundStyle');
        var drawBackground = seriesModel.get('showBackground', true);
        if (drawBackground) {
            var points = data.getLayout('largeBackgroundPoints');
            var backgroundStartPoint = [];
            backgroundStartPoint[1 - baseDimIdx] = data.getLayout('backgroundStart');
            var bgEl = new $cb1fc3f08c69a560$var$LargePath({
                shape: {
                    points: points
                },
                incremental: !!incremental,
                silent: true,
                z2: 0
            });
            bgEl.__startPoint = backgroundStartPoint;
            bgEl.__baseDimIdx = baseDimIdx;
            bgEl.__largeDataIndices = largeDataIndices;
            bgEl.__barWidth = barWidth;
            $cb1fc3f08c69a560$var$setLargeBackgroundStyle(bgEl, backgroundModel, data);
            group.add(bgEl);
        }
        var el = new $cb1fc3f08c69a560$var$LargePath({
            shape: {
                points: data.getLayout('largePoints')
            },
            incremental: !!incremental
        });
        el.__startPoint = startPoint;
        el.__baseDimIdx = baseDimIdx;
        el.__largeDataIndices = largeDataIndices;
        el.__barWidth = barWidth;
        group.add(el);
        $cb1fc3f08c69a560$var$setLargeStyle(el, seriesModel, data);
        (0, (0, parcelRequire("7QjoM")).getECData)(el).seriesIndex = seriesModel.seriesIndex;
        if (!seriesModel.get('silent')) {
            el.on('mousedown', $cb1fc3f08c69a560$var$largePathUpdateDataIndex);
            el.on('mousemove', $cb1fc3f08c69a560$var$largePathUpdateDataIndex);
        }
    }
    var $cb1fc3f08c69a560$var$largePathUpdateDataIndex = (0, (0, parcelRequire("ljaBy")).throttle)(function(event) {
        var largePath = this;
        var dataIndex = $cb1fc3f08c69a560$var$largePathFindDataIndex(largePath, event.offsetX, event.offsetY);
        (0, (0, parcelRequire("7QjoM")).getECData)(largePath).dataIndex = dataIndex >= 0 ? dataIndex : null;
    }, 30, false);
    function $cb1fc3f08c69a560$var$largePathFindDataIndex(largePath, x, y) {
        var baseDimIdx = largePath.__baseDimIdx;
        var valueDimIdx = 1 - baseDimIdx;
        var points = largePath.shape.points;
        var largeDataIndices = largePath.__largeDataIndices;
        var barWidthHalf = Math.abs(largePath.__barWidth / 2);
        var startValueVal = largePath.__startPoint[valueDimIdx];
        $cb1fc3f08c69a560$var$_eventPos[0] = x;
        $cb1fc3f08c69a560$var$_eventPos[1] = y;
        var pointerBaseVal = $cb1fc3f08c69a560$var$_eventPos[baseDimIdx];
        var pointerValueVal = $cb1fc3f08c69a560$var$_eventPos[1 - baseDimIdx];
        var baseLowerBound = pointerBaseVal - barWidthHalf;
        var baseUpperBound = pointerBaseVal + barWidthHalf;
        for(var i = 0, len = points.length / 2; i < len; i++){
            var ii = i * 2;
            var barBaseVal = points[ii + baseDimIdx];
            var barValueVal = points[ii + valueDimIdx];
            if (barBaseVal >= baseLowerBound && barBaseVal <= baseUpperBound && (startValueVal <= barValueVal ? pointerValueVal >= startValueVal && pointerValueVal <= barValueVal : pointerValueVal >= barValueVal && pointerValueVal <= startValueVal)) return largeDataIndices[i];
        }
        return -1;
    }
    function $cb1fc3f08c69a560$var$setLargeStyle(el, seriesModel, data) {
        var globalStyle = data.getVisual('style');
        el.useStyle((0, (0, parcelRequire("bahqM")).extend)({}, globalStyle));
        el.style.fill = null;
        el.style.stroke = globalStyle.fill;
        el.style.lineWidth = data.getLayout('barWidth');
    }
    function $cb1fc3f08c69a560$var$setLargeBackgroundStyle(el, backgroundModel, data) {
        var borderColor = backgroundModel.get('borderColor') || backgroundModel.get('color');
        var itemStyle = backgroundModel.getItemStyle();
        el.useStyle(itemStyle);
        el.style.fill = null;
        el.style.stroke = borderColor;
        el.style.lineWidth = data.getLayout('barWidth');
    }
    function $cb1fc3f08c69a560$var$createBackgroundShape(isHorizontalOrRadial, layout, coord) {
        if ((0, (0, parcelRequire("40dMe")).isCoordinateSystemType)(coord, 'cartesian2d')) {
            var rectShape = layout;
            var coordLayout = coord.getArea();
            return {
                x: isHorizontalOrRadial ? rectShape.x : coordLayout.x,
                y: isHorizontalOrRadial ? coordLayout.y : rectShape.y,
                width: isHorizontalOrRadial ? rectShape.width : coordLayout.width,
                height: isHorizontalOrRadial ? coordLayout.height : rectShape.height
            };
        } else {
            var coordLayout = coord.getArea();
            var sectorShape = layout;
            return {
                cx: coordLayout.cx,
                cy: coordLayout.cy,
                r0: isHorizontalOrRadial ? coordLayout.r0 : sectorShape.r0,
                r: isHorizontalOrRadial ? coordLayout.r : sectorShape.r,
                startAngle: isHorizontalOrRadial ? sectorShape.startAngle : 0,
                endAngle: isHorizontalOrRadial ? sectorShape.endAngle : Math.PI * 2
            };
        }
    }
    function $cb1fc3f08c69a560$var$createBackgroundEl(coord, isHorizontalOrRadial, layout) {
        var ElementClz = coord.type === 'polar' ? (0, (0, parcelRequire("elGBV")).default) : (0, (0, parcelRequire("7Tw7u")).default);
        return new ElementClz({
            shape: $cb1fc3f08c69a560$var$createBackgroundShape(isHorizontalOrRadial, layout, coord),
            silent: true,
            z2: 0
        });
    }
    var $cb1fc3f08c69a560$export$2e2bcd8739ae039 = $cb1fc3f08c69a560$var$BarView;
});
parcelRegister("ljaBy", function(module, exports) {
    $parcel$export(module.exports, "throttle", ()=>$f833992c62ea3b89$export$de363e709c412c8a);
    $parcel$export(module.exports, "createOrUpdate", ()=>$f833992c62ea3b89$export$958e3e1a02eac4b6);
    $parcel$export(module.exports, "clear", ()=>$f833992c62ea3b89$export$42ffd38884aecdac);
    var $f833992c62ea3b89$var$ORIGIN_METHOD = '\0__throttleOriginMethod';
    var $f833992c62ea3b89$var$RATE = '\0__throttleRate';
    var $f833992c62ea3b89$var$THROTTLE_TYPE = '\0__throttleType';
    function $f833992c62ea3b89$export$de363e709c412c8a(fn, delay, debounce) {
        var currCall;
        var lastCall = 0;
        var lastExec = 0;
        var timer = null;
        var diff;
        var scope;
        var args;
        var debounceNextCall;
        delay = delay || 0;
        function exec() {
            lastExec = new Date().getTime();
            timer = null;
            fn.apply(scope, args || []);
        }
        var cb = function() {
            var cbArgs = [];
            for(var _i = 0; _i < arguments.length; _i++)cbArgs[_i] = arguments[_i];
            currCall = new Date().getTime();
            scope = this;
            args = cbArgs;
            var thisDelay = debounceNextCall || delay;
            var thisDebounce = debounceNextCall || debounce;
            debounceNextCall = null;
            diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
            clearTimeout(timer);
            if (thisDebounce) timer = setTimeout(exec, thisDelay);
            else if (diff >= 0) exec();
            else timer = setTimeout(exec, -diff);
            lastCall = currCall;
        };
        cb.clear = function() {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
        };
        cb.debounceNextCall = function(debounceDelay) {
            debounceNextCall = debounceDelay;
        };
        return cb;
    }
    function $f833992c62ea3b89$export$958e3e1a02eac4b6(obj, fnAttr, rate, throttleType) {
        var fn = obj[fnAttr];
        if (!fn) return;
        var originFn = fn[$f833992c62ea3b89$var$ORIGIN_METHOD] || fn;
        var lastThrottleType = fn[$f833992c62ea3b89$var$THROTTLE_TYPE];
        var lastRate = fn[$f833992c62ea3b89$var$RATE];
        if (lastRate !== rate || lastThrottleType !== throttleType) {
            if (rate == null || !throttleType) return obj[fnAttr] = originFn;
            fn = obj[fnAttr] = $f833992c62ea3b89$export$de363e709c412c8a(originFn, rate, throttleType === 'debounce');
            fn[$f833992c62ea3b89$var$ORIGIN_METHOD] = originFn;
            fn[$f833992c62ea3b89$var$THROTTLE_TYPE] = throttleType;
            fn[$f833992c62ea3b89$var$RATE] = rate;
        }
        return fn;
    }
    function $f833992c62ea3b89$export$42ffd38884aecdac(obj, fnAttr) {
        var fn = obj[fnAttr];
        if (fn && fn[$f833992c62ea3b89$var$ORIGIN_METHOD]) obj[fnAttr] = fn[$f833992c62ea3b89$var$ORIGIN_METHOD];
    }
});
parcelRegister("5fMzf", function(module, exports) {
    $parcel$export(module.exports, "createGridClipPath", ()=>$3d3406f7f3673e0b$export$83958787eb658d14);
    $parcel$export(module.exports, "createPolarClipPath", ()=>$3d3406f7f3673e0b$export$13dc2b2230df3cb5);
    $parcel$export(module.exports, "createClipPath", ()=>$3d3406f7f3673e0b$export$e0fe5081209d01c9);
    var $eYgMC;
    parcelRequire("fHITF");
    var $7Tw7u;
    var $elGBV;
    var $jmSNG;
    function $3d3406f7f3673e0b$export$83958787eb658d14(cartesian, hasAnimation, seriesModel, done, during) {
        var rect = cartesian.getArea();
        var x = rect.x;
        var y = rect.y;
        var width = rect.width;
        var height = rect.height;
        var lineWidth = seriesModel.get([
            'lineStyle',
            'width'
        ]) || 2;
        x -= lineWidth / 2;
        y -= lineWidth / 2;
        width += lineWidth;
        height += lineWidth;
        x = Math.floor(x);
        width = Math.round(width);
        var clipPath = new (0, parcelRequire("7Tw7u")).default({
            shape: {
                x: x,
                y: y,
                width: width,
                height: height
            }
        });
        if (hasAnimation) {
            var baseAxis = cartesian.getBaseAxis();
            var isHorizontal = baseAxis.isHorizontal();
            var isAxisInversed = baseAxis.inverse;
            if (isHorizontal) {
                if (isAxisInversed) clipPath.shape.x += width;
                clipPath.shape.width = 0;
            } else {
                if (!isAxisInversed) clipPath.shape.y += height;
                clipPath.shape.height = 0;
            }
            var duringCb = typeof during === 'function' ? function(percent) {
                during(percent, clipPath);
            } : null;
            (0, parcelRequire("eYgMC")).initProps(clipPath, {
                shape: {
                    width: width,
                    height: height,
                    x: x,
                    y: y
                }
            }, seriesModel, null, done, duringCb);
        }
        return clipPath;
    }
    function $3d3406f7f3673e0b$export$13dc2b2230df3cb5(polar, hasAnimation, seriesModel) {
        var sectorArea = polar.getArea();
        var r0 = (0, (0, parcelRequire("jmSNG")).round)(sectorArea.r0, 1);
        var r = (0, (0, parcelRequire("jmSNG")).round)(sectorArea.r, 1);
        var clipPath = new (0, parcelRequire("elGBV")).default({
            shape: {
                cx: (0, (0, parcelRequire("jmSNG")).round)(polar.cx, 1),
                cy: (0, (0, parcelRequire("jmSNG")).round)(polar.cy, 1),
                r0: r0,
                r: r,
                startAngle: sectorArea.startAngle,
                endAngle: sectorArea.endAngle,
                clockwise: sectorArea.clockwise
            }
        });
        if (hasAnimation) {
            var isRadial = polar.getBaseAxis().dim === 'angle';
            if (isRadial) clipPath.shape.endAngle = sectorArea.startAngle;
            else clipPath.shape.r = r0;
            (0, parcelRequire("eYgMC")).initProps(clipPath, {
                shape: {
                    endAngle: sectorArea.endAngle,
                    r: r
                }
            }, seriesModel);
        }
        return clipPath;
    }
    function $3d3406f7f3673e0b$export$e0fe5081209d01c9(coordSys, hasAnimation, seriesModel, done, during) {
        if (!coordSys) return null;
        else if (coordSys.type === 'polar') return $3d3406f7f3673e0b$export$13dc2b2230df3cb5(coordSys, hasAnimation, seriesModel);
        else if (coordSys.type === 'cartesian2d') return $3d3406f7f3673e0b$export$83958787eb658d14(coordSys, hasAnimation, seriesModel, done, during);
        return null;
    }
});
parcelRegister("eaQLm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a51aed73fd415b38$export$2e2bcd8739ae039);
    var $3VFsf;
    parcelRequire("fHITF");
    var $ghQ8v;
    var $a51aed73fd415b38$var$SausageShape = function() {
        function SausageShape() {
            this.cx = 0;
            this.cy = 0;
            this.r0 = 0;
            this.r = 0;
            this.startAngle = 0;
            this.endAngle = Math.PI * 2;
            this.clockwise = true;
        }
        return SausageShape;
    }();
    var $a51aed73fd415b38$var$SausagePath = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(SausagePath, _super);
        function SausagePath(opts) {
            var _this = _super.call(this, opts) || this;
            _this.type = 'sausage';
            return _this;
        }
        SausagePath.prototype.getDefaultShape = function() {
            return new $a51aed73fd415b38$var$SausageShape();
        };
        SausagePath.prototype.buildPath = function(ctx, shape) {
            var x = shape.cx;
            var y = shape.cy;
            var r0 = Math.max(shape.r0 || 0, 0);
            var r = Math.max(shape.r, 0);
            var dr = (r - r0) * 0.5;
            var rCenter = r0 + dr;
            var startAngle = shape.startAngle;
            var endAngle = shape.endAngle;
            var clockwise = shape.clockwise;
            var unitStartX = Math.cos(startAngle);
            var unitStartY = Math.sin(startAngle);
            var unitEndX = Math.cos(endAngle);
            var unitEndY = Math.sin(endAngle);
            var lessThanCircle = clockwise ? endAngle - startAngle < Math.PI * 2 : startAngle - endAngle < Math.PI * 2;
            if (lessThanCircle) {
                ctx.moveTo(unitStartX * r0 + x, unitStartY * r0 + y);
                ctx.arc(unitStartX * rCenter + x, unitStartY * rCenter + y, dr, -Math.PI + startAngle, startAngle, !clockwise);
            }
            ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
            ctx.moveTo(unitEndX * r + x, unitEndY * r + y);
            ctx.arc(unitEndX * rCenter + x, unitEndY * rCenter + y, dr, endAngle - Math.PI * 2, endAngle - Math.PI, !clockwise);
            if (r0 !== 0) {
                ctx.arc(x, y, r0, endAngle, startAngle, clockwise);
                ctx.moveTo(unitStartX * r0 + x, unitEndY * r0 + y);
            }
            ctx.closePath();
        };
        return SausagePath;
    }((0, (0, parcelRequire("ghQ8v")).default));
    var $a51aed73fd415b38$export$2e2bcd8739ae039 = $a51aed73fd415b38$var$SausagePath;
});
parcelRegister("loerw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f9270aeb44680e6f$export$2e2bcd8739ae039);
    var $bahqM;
    var $4KVOr;
    var $jvo6O;
    var $aLwh0;
    var $eaKsF;
    var $fIXXx;
    var $92IK1;
    var $9irlK;
    var $f9270aeb44680e6f$var$inner = (0, parcelRequire("eaKsF")).makeInner();
    var $f9270aeb44680e6f$var$renderPlanner = (0, (0, parcelRequire("9irlK")).default)();
    var $f9270aeb44680e6f$var$ChartView = function() {
        function ChartView() {
            this.group = new (0, (0, parcelRequire("4KVOr")).default)();
            this.uid = (0, parcelRequire("jvo6O")).getUID('viewChart');
            this.renderTask = (0, (0, parcelRequire("92IK1")).createTask)({
                plan: $f9270aeb44680e6f$var$renderTaskPlan,
                reset: $f9270aeb44680e6f$var$renderTaskReset
            });
            this.renderTask.context = {
                view: this
            };
        }
        ChartView.prototype.init = function(ecModel, api) {};
        ChartView.prototype.render = function(seriesModel, ecModel, api, payload) {};
        ChartView.prototype.highlight = function(seriesModel, ecModel, api, payload) {
            $f9270aeb44680e6f$var$toggleHighlight(seriesModel.getData(), payload, 'emphasis');
        };
        ChartView.prototype.downplay = function(seriesModel, ecModel, api, payload) {
            $f9270aeb44680e6f$var$toggleHighlight(seriesModel.getData(), payload, 'normal');
        };
        ChartView.prototype.remove = function(ecModel, api) {
            this.group.removeAll();
        };
        ChartView.prototype.dispose = function(ecModel, api) {};
        ChartView.prototype.updateView = function(seriesModel, ecModel, api, payload) {
            this.render(seriesModel, ecModel, api, payload);
        };
        ChartView.prototype.updateLayout = function(seriesModel, ecModel, api, payload) {
            this.render(seriesModel, ecModel, api, payload);
        };
        ChartView.prototype.updateVisual = function(seriesModel, ecModel, api, payload) {
            this.render(seriesModel, ecModel, api, payload);
        };
        ChartView.markUpdateMethod = function(payload, methodName) {
            $f9270aeb44680e6f$var$inner(payload).updateMethod = methodName;
        };
        ChartView.protoInitialize = function() {
            var proto = ChartView.prototype;
            proto.type = 'chart';
        }();
        return ChartView;
    }();
    function $f9270aeb44680e6f$var$elSetState(el, state, highlightDigit) {
        if (el) (state === 'emphasis' ? (0, (0, parcelRequire("fIXXx")).enterEmphasis) : (0, (0, parcelRequire("fIXXx")).leaveEmphasis))(el, highlightDigit);
    }
    function $f9270aeb44680e6f$var$toggleHighlight(data, payload, state) {
        var dataIndex = (0, parcelRequire("eaKsF")).queryDataIndex(data, payload);
        var highlightDigit = payload && payload.highlightKey != null ? (0, (0, parcelRequire("fIXXx")).getHighlightDigit)(payload.highlightKey) : null;
        if (dataIndex != null) (0, (0, parcelRequire("bahqM")).each)((0, parcelRequire("eaKsF")).normalizeToArray(dataIndex), function(dataIdx) {
            $f9270aeb44680e6f$var$elSetState(data.getItemGraphicEl(dataIdx), state, highlightDigit);
        });
        else data.eachItemGraphicEl(function(el) {
            $f9270aeb44680e6f$var$elSetState(el, state, highlightDigit);
        });
    }
    (0, parcelRequire("aLwh0")).enableClassExtend($f9270aeb44680e6f$var$ChartView, [
        'dispose'
    ]);
    (0, parcelRequire("aLwh0")).enableClassManagement($f9270aeb44680e6f$var$ChartView);
    function $f9270aeb44680e6f$var$renderTaskPlan(context) {
        return $f9270aeb44680e6f$var$renderPlanner(context.model);
    }
    function $f9270aeb44680e6f$var$renderTaskReset(context) {
        var seriesModel = context.model;
        var ecModel = context.ecModel;
        var api = context.api;
        var payload = context.payload;
        var progressiveRender = seriesModel.pipelineContext.progressiveRender;
        var view = context.view;
        var updateMethod = payload && $f9270aeb44680e6f$var$inner(payload).updateMethod;
        var methodName = progressiveRender ? 'incrementalPrepareRender' : updateMethod && view[updateMethod] ? updateMethod : 'render';
        if (methodName !== 'render') view[methodName](seriesModel, ecModel, api, payload);
        return $f9270aeb44680e6f$var$progressMethodMap[methodName];
    }
    var $f9270aeb44680e6f$var$progressMethodMap = {
        incrementalPrepareRender: {
            progress: function(params, context) {
                context.view.incrementalRender(params, context.model, context.ecModel, context.api, context.payload);
            }
        },
        render: {
            forceFirstProgress: true,
            progress: function(params, context) {
                context.view.render(context.model, context.ecModel, context.api, context.payload);
            }
        }
    };
    var $f9270aeb44680e6f$export$2e2bcd8739ae039 = $f9270aeb44680e6f$var$ChartView;
});
parcelRegister("40dMe", function(module, exports) {
    $parcel$export(module.exports, "isCoordinateSystemType", ()=>$2ea1d953c3a29c60$export$8567506e6336616);
    function $2ea1d953c3a29c60$export$8567506e6336616(coordSys, type) {
        return coordSys.type === type;
    }
});
parcelRegister("5MLZz", function(module, exports) {
    $parcel$export(module.exports, "getDefaultLabel", ()=>$4366a9b1a430c1e7$export$5ff20667590927ed);
    $parcel$export(module.exports, "getDefaultInterpolatedLabel", ()=>$4366a9b1a430c1e7$export$5f84815e91ca6775);
    var $9OHWG;
    var $bahqM;
    function $4366a9b1a430c1e7$export$5ff20667590927ed(data, dataIndex) {
        var labelDims = data.mapDimensionsAll('defaultedLabel');
        var len = labelDims.length;
        if (len === 1) {
            var rawVal = (0, (0, parcelRequire("9OHWG")).retrieveRawValue)(data, dataIndex, labelDims[0]);
            return rawVal != null ? rawVal + '' : null;
        } else if (len) {
            var vals = [];
            for(var i = 0; i < labelDims.length; i++)vals.push((0, (0, parcelRequire("9OHWG")).retrieveRawValue)(data, dataIndex, labelDims[i]));
            return vals.join(' ');
        }
    }
    function $4366a9b1a430c1e7$export$5f84815e91ca6775(data, interpolatedValue) {
        var labelDims = data.mapDimensionsAll('defaultedLabel');
        if (!(0, (0, parcelRequire("bahqM")).isArray)(interpolatedValue)) return interpolatedValue + '';
        var vals = [];
        for(var i = 0; i < labelDims.length; i++){
            var dimIndex = data.getDimensionIndex(labelDims[i]);
            if (dimIndex >= 0) vals.push(interpolatedValue[dimIndex]);
        }
        return vals.join(' ');
    }
});
parcelRegister("9dNYG", function(module, exports) {
    $parcel$export(module.exports, "createSectorCalculateTextPosition", ()=>$6b6c187953b9d25e$export$359a1e2d210ed734);
    $parcel$export(module.exports, "setSectorTextRotation", ()=>$6b6c187953b9d25e$export$672ce504c0db395a);
    var $b7ZX8;
    var $bahqM;
    function $6b6c187953b9d25e$export$359a1e2d210ed734(positionMapping, opts) {
        opts = opts || {};
        var isRoundCap = opts.isRoundCap;
        return function(out, opts, boundingRect) {
            var textPosition = opts.position;
            if (!textPosition || textPosition instanceof Array) return (0, (0, parcelRequire("b7ZX8")).calculateTextPosition)(out, opts, boundingRect);
            var mappedSectorPosition = positionMapping(textPosition);
            var distance = opts.distance != null ? opts.distance : 5;
            var sector = this.shape;
            var cx = sector.cx;
            var cy = sector.cy;
            var r = sector.r;
            var r0 = sector.r0;
            var middleR = (r + r0) / 2;
            var startAngle = sector.startAngle;
            var endAngle = sector.endAngle;
            var middleAngle = (startAngle + endAngle) / 2;
            var extraDist = isRoundCap ? Math.abs(r - r0) / 2 : 0;
            var mathCos = Math.cos;
            var mathSin = Math.sin;
            var x = cx + r * mathCos(startAngle);
            var y = cy + r * mathSin(startAngle);
            var textAlign = 'left';
            var textVerticalAlign = 'top';
            switch(mappedSectorPosition){
                case 'startArc':
                    x = cx + (r0 - distance) * mathCos(middleAngle);
                    y = cy + (r0 - distance) * mathSin(middleAngle);
                    textAlign = 'center';
                    textVerticalAlign = 'top';
                    break;
                case 'insideStartArc':
                    x = cx + (r0 + distance) * mathCos(middleAngle);
                    y = cy + (r0 + distance) * mathSin(middleAngle);
                    textAlign = 'center';
                    textVerticalAlign = 'bottom';
                    break;
                case 'startAngle':
                    x = cx + middleR * mathCos(startAngle) + $6b6c187953b9d25e$var$adjustAngleDistanceX(startAngle, distance + extraDist, false);
                    y = cy + middleR * mathSin(startAngle) + $6b6c187953b9d25e$var$adjustAngleDistanceY(startAngle, distance + extraDist, false);
                    textAlign = 'right';
                    textVerticalAlign = 'middle';
                    break;
                case 'insideStartAngle':
                    x = cx + middleR * mathCos(startAngle) + $6b6c187953b9d25e$var$adjustAngleDistanceX(startAngle, -distance + extraDist, false);
                    y = cy + middleR * mathSin(startAngle) + $6b6c187953b9d25e$var$adjustAngleDistanceY(startAngle, -distance + extraDist, false);
                    textAlign = 'left';
                    textVerticalAlign = 'middle';
                    break;
                case 'middle':
                    x = cx + middleR * mathCos(middleAngle);
                    y = cy + middleR * mathSin(middleAngle);
                    textAlign = 'center';
                    textVerticalAlign = 'middle';
                    break;
                case 'endArc':
                    x = cx + (r + distance) * mathCos(middleAngle);
                    y = cy + (r + distance) * mathSin(middleAngle);
                    textAlign = 'center';
                    textVerticalAlign = 'bottom';
                    break;
                case 'insideEndArc':
                    x = cx + (r - distance) * mathCos(middleAngle);
                    y = cy + (r - distance) * mathSin(middleAngle);
                    textAlign = 'center';
                    textVerticalAlign = 'top';
                    break;
                case 'endAngle':
                    x = cx + middleR * mathCos(endAngle) + $6b6c187953b9d25e$var$adjustAngleDistanceX(endAngle, distance + extraDist, true);
                    y = cy + middleR * mathSin(endAngle) + $6b6c187953b9d25e$var$adjustAngleDistanceY(endAngle, distance + extraDist, true);
                    textAlign = 'left';
                    textVerticalAlign = 'middle';
                    break;
                case 'insideEndAngle':
                    x = cx + middleR * mathCos(endAngle) + $6b6c187953b9d25e$var$adjustAngleDistanceX(endAngle, -distance + extraDist, true);
                    y = cy + middleR * mathSin(endAngle) + $6b6c187953b9d25e$var$adjustAngleDistanceY(endAngle, -distance + extraDist, true);
                    textAlign = 'right';
                    textVerticalAlign = 'middle';
                    break;
                default:
                    return (0, (0, parcelRequire("b7ZX8")).calculateTextPosition)(out, opts, boundingRect);
            }
            out = out || {};
            out.x = x;
            out.y = y;
            out.align = textAlign;
            out.verticalAlign = textVerticalAlign;
            return out;
        };
    }
    function $6b6c187953b9d25e$export$672ce504c0db395a(sector, textPosition, positionMapping, rotateType) {
        if (typeof rotateType === 'number') {
            sector.setTextConfig({
                rotation: rotateType
            });
            return;
        } else if ((0, (0, parcelRequire("bahqM")).isArray)(textPosition)) {
            sector.setTextConfig({
                rotation: 0
            });
            return;
        }
        var shape = sector.shape;
        var startAngle = shape.clockwise ? shape.startAngle : shape.endAngle;
        var endAngle = shape.clockwise ? shape.endAngle : shape.startAngle;
        var middleAngle = (startAngle + endAngle) / 2;
        var anchorAngle;
        var mappedSectorPosition = positionMapping(textPosition);
        switch(mappedSectorPosition){
            case 'startArc':
            case 'insideStartArc':
            case 'middle':
            case 'insideEndArc':
            case 'endArc':
                anchorAngle = middleAngle;
                break;
            case 'startAngle':
            case 'insideStartAngle':
                anchorAngle = startAngle;
                break;
            case 'endAngle':
            case 'insideEndAngle':
                anchorAngle = endAngle;
                break;
            default:
                sector.setTextConfig({
                    rotation: 0
                });
                return;
        }
        var rotate = Math.PI * 1.5 - anchorAngle;
        if (mappedSectorPosition === 'middle' && rotate > Math.PI / 2 && rotate < Math.PI * 1.5) rotate -= Math.PI;
        sector.setTextConfig({
            rotation: rotate
        });
    }
    function $6b6c187953b9d25e$var$adjustAngleDistanceX(angle, distance, isEnd) {
        return distance * Math.sin(angle) * (isEnd ? -1 : 1);
    }
    function $6b6c187953b9d25e$var$adjustAngleDistanceY(angle, distance, isEnd) {
        return distance * Math.cos(angle) * (isEnd ? 1 : -1);
    }
});
parcelRegister("6OGL8", function(module, exports) {
    $parcel$export(module.exports, "install", ()=>$4f6894ac64afab25$export$4b3e715f166fdd78);
    var $iWOYl;
    var $hi3Y7;
    var $alpND;
    function $4f6894ac64afab25$export$4b3e715f166fdd78(registers) {
        (0, (0, parcelRequire("alpND")).use)((0, (0, parcelRequire("iWOYl")).install));
        (0, (0, parcelRequire("alpND")).use)((0, (0, parcelRequire("hi3Y7")).install));
    }
});
parcelRegister("iWOYl", function(module, exports) {
    $parcel$export(module.exports, "install", ()=>$dcb52eca8f57248f$export$4b3e715f166fdd78);
    var $3VFsf;
    var $fkskt;
    var $9sf2Q;
    parcelRequire("fHITF");
    var $7Tw7u;
    var $bahqM;
    var $1UrP6;
    var $aLiaH;
    var $1xCHp;
    var $2rHnA;
    var $dcb52eca8f57248f$var$GridView = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(GridView, _super);
        function GridView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = 'grid';
            return _this;
        }
        GridView.prototype.render = function(gridModel, ecModel) {
            this.group.removeAll();
            if (gridModel.get('show')) this.group.add(new (0, (0, parcelRequire("7Tw7u")).default)({
                shape: gridModel.coordinateSystem.getRect(),
                style: (0, (0, parcelRequire("bahqM")).defaults)({
                    fill: gridModel.get('backgroundColor')
                }, gridModel.getItemStyle()),
                silent: true,
                z2: -1
            }));
        };
        GridView.type = 'grid';
        return GridView;
    }((0, (0, parcelRequire("fkskt")).default));
    var $dcb52eca8f57248f$var$extraOption = {
        offset: 0
    };
    function $dcb52eca8f57248f$export$4b3e715f166fdd78(registers) {
        registers.registerComponentView($dcb52eca8f57248f$var$GridView);
        registers.registerComponentModel((0, (0, parcelRequire("9sf2Q")).default));
        registers.registerCoordinateSystem('cartesian2d', (0, (0, parcelRequire("1xCHp")).default));
        (0, (0, parcelRequire("aLiaH")).default)(registers, 'x', (0, (0, parcelRequire("1UrP6")).CartesianAxisModel), $dcb52eca8f57248f$var$extraOption);
        (0, (0, parcelRequire("aLiaH")).default)(registers, 'y', (0, (0, parcelRequire("1UrP6")).CartesianAxisModel), $dcb52eca8f57248f$var$extraOption);
        registers.registerComponentView((0, (0, parcelRequire("2rHnA")).CartesianXAxisView));
        registers.registerComponentView((0, (0, parcelRequire("2rHnA")).CartesianYAxisView));
        registers.registerPreprocessor(function(option) {
            if (option.xAxis && option.yAxis && !option.grid) option.grid = {};
        });
    }
});
parcelRegister("fkskt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b28eb2e2a247a7d9$export$2e2bcd8739ae039);
    var $4KVOr;
    var $jvo6O;
    var $aLwh0;
    var $b28eb2e2a247a7d9$var$ComponentView = function() {
        function ComponentView() {
            this.group = new (0, (0, parcelRequire("4KVOr")).default)();
            this.uid = (0, parcelRequire("jvo6O")).getUID('viewComponent');
        }
        ComponentView.prototype.init = function(ecModel, api) {};
        ComponentView.prototype.render = function(model, ecModel, api, payload) {};
        ComponentView.prototype.dispose = function(ecModel, api) {};
        ComponentView.prototype.updateView = function(model, ecModel, api, payload) {};
        ComponentView.prototype.updateLayout = function(model, ecModel, api, payload) {};
        ComponentView.prototype.updateVisual = function(model, ecModel, api, payload) {};
        ComponentView.prototype.blurSeries = function(seriesModels, ecModel) {};
        return ComponentView;
    }();
    (0, parcelRequire("aLwh0")).enableClassExtend($b28eb2e2a247a7d9$var$ComponentView);
    (0, parcelRequire("aLwh0")).enableClassManagement($b28eb2e2a247a7d9$var$ComponentView);
    var $b28eb2e2a247a7d9$export$2e2bcd8739ae039 = $b28eb2e2a247a7d9$var$ComponentView;
});
parcelRegister("9sf2Q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6e226630804759b0$export$2e2bcd8739ae039);
    var $3VFsf;
    var $h4UlH;
    var $6e226630804759b0$var$GridModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(GridModel, _super);
        function GridModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        GridModel.type = 'grid';
        GridModel.dependencies = [
            'xAxis',
            'yAxis'
        ];
        GridModel.layoutMode = 'box';
        GridModel.defaultOption = {
            show: false,
            zlevel: 0,
            z: 0,
            left: '10%',
            top: 60,
            right: '10%',
            bottom: 70,
            containLabel: false,
            backgroundColor: 'rgba(0,0,0,0)',
            borderWidth: 1,
            borderColor: '#ccc'
        };
        return GridModel;
    }((0, (0, parcelRequire("h4UlH")).default));
    var $6e226630804759b0$export$2e2bcd8739ae039 = $6e226630804759b0$var$GridModel;
});
parcelRegister("1UrP6", function(module, exports) {
    $parcel$export(module.exports, "CartesianAxisModel", ()=>$16409a80acd4e1a4$export$483dc37e6ad83a3c);
    var $3VFsf;
    var $bahqM;
    var $h4UlH;
    var $5pBRm;
    var $eaKsF;
    var $16409a80acd4e1a4$export$483dc37e6ad83a3c = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(CartesianAxisModel, _super);
        function CartesianAxisModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        CartesianAxisModel.prototype.getCoordSysModel = function() {
            return this.getReferringComponents('grid', (0, (0, parcelRequire("eaKsF")).SINGLE_REFERRING)).models[0];
        };
        CartesianAxisModel.type = 'cartesian2dAxis';
        return CartesianAxisModel;
    }((0, (0, parcelRequire("h4UlH")).default));
    (0, parcelRequire("bahqM")).mixin($16409a80acd4e1a4$export$483dc37e6ad83a3c, (0, (0, parcelRequire("5pBRm")).AxisModelCommonMixin));
    var $16409a80acd4e1a4$export$2e2bcd8739ae039 = $16409a80acd4e1a4$export$483dc37e6ad83a3c;
});
parcelRegister("5pBRm", function(module, exports) {
    $parcel$export(module.exports, "AxisModelCommonMixin", ()=>$3f0ca7b2a67ba541$export$5c54b224726edb5a);
    var $3f0ca7b2a67ba541$export$5c54b224726edb5a = function() {
        function AxisModelCommonMixin() {}
        AxisModelCommonMixin.prototype.getNeedCrossZero = function() {
            var option = this.option;
            return !option.scale;
        };
        AxisModelCommonMixin.prototype.getCoordSysModel = function() {
            return;
        };
        return AxisModelCommonMixin;
    }();
});
parcelRegister("aLiaH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7d5c63a9e257cb04$export$2e2bcd8739ae039);
    var $3VFsf;
    var $erX9x;
    var $65MS1;
    var $6Vrdy;
    var $7vTvv;
    var $bahqM;
    function $7d5c63a9e257cb04$export$2e2bcd8739ae039(registers, axisName, BaseAxisModelClass, extraDefaultOption) {
        (0, (0, parcelRequire("bahqM")).each)((0, (0, parcelRequire("7vTvv")).AXIS_TYPES), function(v, axisType) {
            var defaultOption = (0, (0, parcelRequire("bahqM")).merge)((0, (0, parcelRequire("bahqM")).merge)({}, (0, (0, parcelRequire("erX9x")).default)[axisType], true), extraDefaultOption, true);
            var AxisModel = function(_super) {
                (0, (0, parcelRequire("3VFsf")).__extends)(AxisModel, _super);
                function AxisModel() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.type = axisName + 'Axis.' + axisType;
                    return _this;
                }
                AxisModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
                    var layoutMode = (0, (0, parcelRequire("65MS1")).fetchLayoutMode)(this);
                    var inputPositionParams = layoutMode ? (0, (0, parcelRequire("65MS1")).getLayoutParams)(option) : {};
                    var themeModel = ecModel.getTheme();
                    (0, (0, parcelRequire("bahqM")).merge)(option, themeModel.get(axisType + 'Axis'));
                    (0, (0, parcelRequire("bahqM")).merge)(option, this.getDefaultOption());
                    option.type = $7d5c63a9e257cb04$var$getAxisType(option);
                    if (layoutMode) (0, (0, parcelRequire("65MS1")).mergeLayoutParam)(option, inputPositionParams, layoutMode);
                };
                AxisModel.prototype.optionUpdated = function() {
                    var thisOption = this.option;
                    if (thisOption.type === 'category') this.__ordinalMeta = (0, (0, parcelRequire("6Vrdy")).default).createByAxisModel(this);
                };
                AxisModel.prototype.getCategories = function(rawData) {
                    var option = this.option;
                    if (option.type === 'category') {
                        if (rawData) return option.data;
                        return this.__ordinalMeta.categories;
                    }
                };
                AxisModel.prototype.getOrdinalMeta = function() {
                    return this.__ordinalMeta;
                };
                AxisModel.type = axisName + 'Axis.' + axisType;
                AxisModel.defaultOption = defaultOption;
                return AxisModel;
            }(BaseAxisModelClass);
            registers.registerComponentModel(AxisModel);
        });
        registers.registerSubTypeDefaulter(axisName + 'Axis', $7d5c63a9e257cb04$var$getAxisType);
    }
    function $7d5c63a9e257cb04$var$getAxisType(option) {
        return option.type || (option.data ? 'category' : 'value');
    }
});
parcelRegister("erX9x", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a85178cf0b0fc4bc$export$2e2bcd8739ae039);
    var $bahqM;
    var $a85178cf0b0fc4bc$var$defaultOption = {
        show: true,
        zlevel: 0,
        z: 0,
        inverse: false,
        name: '',
        nameLocation: 'end',
        nameRotate: null,
        nameTruncate: {
            maxWidth: null,
            ellipsis: '...',
            placeholder: '.'
        },
        nameTextStyle: {},
        nameGap: 15,
        silent: false,
        triggerEvent: false,
        tooltip: {
            show: false
        },
        axisPointer: {},
        axisLine: {
            show: true,
            onZero: true,
            onZeroAxisIndex: null,
            lineStyle: {
                color: '#6E7079',
                width: 1,
                type: 'solid'
            },
            symbol: [
                'none',
                'none'
            ],
            symbolSize: [
                10,
                15
            ]
        },
        axisTick: {
            show: true,
            inside: false,
            length: 5,
            lineStyle: {
                width: 1
            }
        },
        axisLabel: {
            show: true,
            inside: false,
            rotate: 0,
            showMinLabel: null,
            showMaxLabel: null,
            margin: 8,
            fontSize: 12
        },
        splitLine: {
            show: true,
            lineStyle: {
                color: [
                    '#E0E6F1'
                ],
                width: 1,
                type: 'solid'
            }
        },
        splitArea: {
            show: false,
            areaStyle: {
                color: [
                    'rgba(250,250,250,0.2)',
                    'rgba(210,219,238,0.2)'
                ]
            }
        }
    };
    var $a85178cf0b0fc4bc$var$categoryAxis = (0, parcelRequire("bahqM")).merge({
        boundaryGap: true,
        deduplication: null,
        splitLine: {
            show: false
        },
        axisTick: {
            alignWithLabel: false,
            interval: 'auto'
        },
        axisLabel: {
            interval: 'auto'
        }
    }, $a85178cf0b0fc4bc$var$defaultOption);
    var $a85178cf0b0fc4bc$var$valueAxis = (0, parcelRequire("bahqM")).merge({
        boundaryGap: [
            0,
            0
        ],
        axisLine: {
            show: 'auto'
        },
        axisTick: {
            show: 'auto'
        },
        splitNumber: 5,
        minorTick: {
            show: false,
            splitNumber: 5,
            length: 3,
            lineStyle: {}
        },
        minorSplitLine: {
            show: false,
            lineStyle: {
                color: '#F4F7FD',
                width: 1
            }
        }
    }, $a85178cf0b0fc4bc$var$defaultOption);
    var $a85178cf0b0fc4bc$var$timeAxis = (0, parcelRequire("bahqM")).merge({
        scale: true,
        splitNumber: 6,
        axisLabel: {
            showMinLabel: false,
            showMaxLabel: false,
            rich: {
                primary: {
                    fontWeight: 'bold'
                }
            }
        },
        splitLine: {
            show: false
        }
    }, $a85178cf0b0fc4bc$var$valueAxis);
    var $a85178cf0b0fc4bc$var$logAxis = (0, parcelRequire("bahqM")).defaults({
        scale: true,
        logBase: 10
    }, $a85178cf0b0fc4bc$var$valueAxis);
    var $a85178cf0b0fc4bc$export$2e2bcd8739ae039 = {
        category: $a85178cf0b0fc4bc$var$categoryAxis,
        value: $a85178cf0b0fc4bc$var$valueAxis,
        time: $a85178cf0b0fc4bc$var$timeAxis,
        log: $a85178cf0b0fc4bc$var$logAxis
    };
});
parcelRegister("6Vrdy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$50ad2dcdb048637a$export$2e2bcd8739ae039);
    var $bahqM;
    var $50ad2dcdb048637a$var$uidBase = 0;
    var $50ad2dcdb048637a$var$OrdinalMeta = function() {
        function OrdinalMeta(opt) {
            this.categories = opt.categories || [];
            this._needCollect = opt.needCollect;
            this._deduplication = opt.deduplication;
            this.uid = ++$50ad2dcdb048637a$var$uidBase;
        }
        OrdinalMeta.createByAxisModel = function(axisModel) {
            var option = axisModel.option;
            var data = option.data;
            var categories = data && (0, (0, parcelRequire("bahqM")).map)(data, $50ad2dcdb048637a$var$getName);
            return new OrdinalMeta({
                categories: categories,
                needCollect: !categories,
                deduplication: option.dedplication !== false
            });
        };
        OrdinalMeta.prototype.getOrdinal = function(category) {
            return this._getOrCreateMap().get(category);
        };
        OrdinalMeta.prototype.parseAndCollect = function(category) {
            var index;
            var needCollect = this._needCollect;
            if (typeof category !== 'string' && !needCollect) return category;
            if (needCollect && !this._deduplication) {
                index = this.categories.length;
                this.categories[index] = category;
                return index;
            }
            var map = this._getOrCreateMap();
            index = map.get(category);
            if (index == null) {
                if (needCollect) {
                    index = this.categories.length;
                    this.categories[index] = category;
                    map.set(category, index);
                } else index = NaN;
            }
            return index;
        };
        OrdinalMeta.prototype._getOrCreateMap = function() {
            return this._map || (this._map = (0, (0, parcelRequire("bahqM")).createHashMap)(this.categories));
        };
        return OrdinalMeta;
    }();
    function $50ad2dcdb048637a$var$getName(obj) {
        if ((0, (0, parcelRequire("bahqM")).isObject)(obj) && obj.value != null) return obj.value;
        else return obj + '';
    }
    var $50ad2dcdb048637a$export$2e2bcd8739ae039 = $50ad2dcdb048637a$var$OrdinalMeta;
});
parcelRegister("7vTvv", function(module, exports) {
    $parcel$export(module.exports, "AXIS_TYPES", ()=>$57867c39181fdac2$export$2e0057d176d6f690);
    var $57867c39181fdac2$export$2e0057d176d6f690 = {
        value: 1,
        category: 1,
        time: 1,
        log: 1
    };
});
parcelRegister("1xCHp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$11f6e45ff2a10529$export$2e2bcd8739ae039);
    var $bahqM;
    var $65MS1;
    var $3GIoT;
    var $SsPct;
    var $kBKMx;
    var $eaKsF;
    var $dBIJY;
    var $11f6e45ff2a10529$var$Grid = function() {
        function Grid(gridModel, ecModel, api) {
            this.type = 'grid';
            this._coordsMap = {};
            this._coordsList = [];
            this._axesMap = {};
            this._axesList = [];
            this.axisPointerEnabled = true;
            this.dimensions = (0, (0, parcelRequire("SsPct")).cartesian2DDimensions);
            this._initCartesian(gridModel, ecModel, api);
            this.model = gridModel;
        }
        Grid.prototype.getRect = function() {
            return this._rect;
        };
        Grid.prototype.update = function(ecModel, api) {
            var axesMap = this._axesMap;
            this._updateScale(ecModel, this.model);
            (0, (0, parcelRequire("bahqM")).each)(axesMap.x, function(xAxis) {
                (0, (0, parcelRequire("3GIoT")).niceScaleExtent)(xAxis.scale, xAxis.model);
            });
            (0, (0, parcelRequire("bahqM")).each)(axesMap.y, function(yAxis) {
                (0, (0, parcelRequire("3GIoT")).niceScaleExtent)(yAxis.scale, yAxis.model);
            });
            var onZeroRecords = {};
            (0, (0, parcelRequire("bahqM")).each)(axesMap.x, function(xAxis) {
                $11f6e45ff2a10529$var$fixAxisOnZero(axesMap, 'y', xAxis, onZeroRecords);
            });
            (0, (0, parcelRequire("bahqM")).each)(axesMap.y, function(yAxis) {
                $11f6e45ff2a10529$var$fixAxisOnZero(axesMap, 'x', yAxis, onZeroRecords);
            });
            this.resize(this.model, api);
        };
        Grid.prototype.resize = function(gridModel, api, ignoreContainLabel) {
            var boxLayoutParams = gridModel.getBoxLayoutParams();
            var isContainLabel = !ignoreContainLabel && gridModel.get('containLabel');
            var gridRect = (0, (0, parcelRequire("65MS1")).getLayoutRect)(boxLayoutParams, {
                width: api.getWidth(),
                height: api.getHeight()
            });
            this._rect = gridRect;
            var axesList = this._axesList;
            adjustAxes();
            if (isContainLabel) {
                (0, (0, parcelRequire("bahqM")).each)(axesList, function(axis) {
                    if (!axis.model.get([
                        'axisLabel',
                        'inside'
                    ])) {
                        var labelUnionRect = (0, (0, parcelRequire("3GIoT")).estimateLabelUnionRect)(axis);
                        if (labelUnionRect) {
                            var dim = axis.isHorizontal() ? 'height' : 'width';
                            var margin = axis.model.get([
                                'axisLabel',
                                'margin'
                            ]);
                            gridRect[dim] -= labelUnionRect[dim] + margin;
                            if (axis.position === 'top') gridRect.y += labelUnionRect.height + margin;
                            else if (axis.position === 'left') gridRect.x += labelUnionRect.width + margin;
                        }
                    }
                });
                adjustAxes();
            }
            (0, (0, parcelRequire("bahqM")).each)(this._coordsList, function(coord) {
                coord.calcAffineTransform();
            });
            function adjustAxes() {
                (0, (0, parcelRequire("bahqM")).each)(axesList, function(axis) {
                    var isHorizontal = axis.isHorizontal();
                    var extent = isHorizontal ? [
                        0,
                        gridRect.width
                    ] : [
                        0,
                        gridRect.height
                    ];
                    var idx = axis.inverse ? 1 : 0;
                    axis.setExtent(extent[idx], extent[1 - idx]);
                    $11f6e45ff2a10529$var$updateAxisTransform(axis, isHorizontal ? gridRect.x : gridRect.y);
                });
            }
        };
        Grid.prototype.getAxis = function(dim, axisIndex) {
            var axesMapOnDim = this._axesMap[dim];
            if (axesMapOnDim != null) return axesMapOnDim[axisIndex || 0];
        };
        Grid.prototype.getAxes = function() {
            return this._axesList.slice();
        };
        Grid.prototype.getCartesian = function(xAxisIndex, yAxisIndex) {
            if (xAxisIndex != null && yAxisIndex != null) {
                var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
                return this._coordsMap[key];
            }
            if ((0, (0, parcelRequire("bahqM")).isObject)(xAxisIndex)) {
                yAxisIndex = xAxisIndex.yAxisIndex;
                xAxisIndex = xAxisIndex.xAxisIndex;
            }
            for(var i = 0, coordList = this._coordsList; i < coordList.length; i++){
                if (coordList[i].getAxis('x').index === xAxisIndex || coordList[i].getAxis('y').index === yAxisIndex) return coordList[i];
            }
        };
        Grid.prototype.getCartesians = function() {
            return this._coordsList.slice();
        };
        Grid.prototype.convertToPixel = function(ecModel, finder, value) {
            var target = this._findConvertTarget(finder);
            return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
        };
        Grid.prototype.convertFromPixel = function(ecModel, finder, value) {
            var target = this._findConvertTarget(finder);
            return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
        };
        Grid.prototype._findConvertTarget = function(finder) {
            var seriesModel = finder.seriesModel;
            var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents('xAxis', (0, (0, parcelRequire("eaKsF")).SINGLE_REFERRING)).models[0];
            var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents('yAxis', (0, (0, parcelRequire("eaKsF")).SINGLE_REFERRING)).models[0];
            var gridModel = finder.gridModel;
            var coordsList = this._coordsList;
            var cartesian;
            var axis;
            if (seriesModel) {
                cartesian = seriesModel.coordinateSystem;
                (0, (0, parcelRequire("bahqM")).indexOf)(coordsList, cartesian) < 0 && (cartesian = null);
            } else if (xAxisModel && yAxisModel) cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
            else if (xAxisModel) axis = this.getAxis('x', xAxisModel.componentIndex);
            else if (yAxisModel) axis = this.getAxis('y', yAxisModel.componentIndex);
            else if (gridModel) {
                var grid = gridModel.coordinateSystem;
                if (grid === this) cartesian = this._coordsList[0];
            }
            return {
                cartesian: cartesian,
                axis: axis
            };
        };
        Grid.prototype.containPoint = function(point) {
            var coord = this._coordsList[0];
            if (coord) return coord.containPoint(point);
        };
        Grid.prototype._initCartesian = function(gridModel, ecModel, api) {
            var _this = this;
            var grid = this;
            var axisPositionUsed = {
                left: false,
                right: false,
                top: false,
                bottom: false
            };
            var axesMap = {
                x: {},
                y: {}
            };
            var axesCount = {
                x: 0,
                y: 0
            };
            ecModel.eachComponent('xAxis', createAxisCreator('x'), this);
            ecModel.eachComponent('yAxis', createAxisCreator('y'), this);
            if (!axesCount.x || !axesCount.y) {
                this._axesMap = {};
                this._axesList = [];
                return;
            }
            this._axesMap = axesMap;
            (0, (0, parcelRequire("bahqM")).each)(axesMap.x, function(xAxis, xAxisIndex) {
                (0, (0, parcelRequire("bahqM")).each)(axesMap.y, function(yAxis, yAxisIndex) {
                    var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
                    var cartesian = new (0, (0, parcelRequire("SsPct")).default)(key);
                    cartesian.master = _this;
                    cartesian.model = gridModel;
                    _this._coordsMap[key] = cartesian;
                    _this._coordsList.push(cartesian);
                    cartesian.addAxis(xAxis);
                    cartesian.addAxis(yAxis);
                });
            });
            function createAxisCreator(dimName) {
                return function(axisModel, idx) {
                    if (!$11f6e45ff2a10529$var$isAxisUsedInTheGrid(axisModel, gridModel)) return;
                    var axisPosition = axisModel.get('position');
                    if (dimName === 'x') {
                        if (axisPosition !== 'top' && axisPosition !== 'bottom') axisPosition = axisPositionUsed.bottom ? 'top' : 'bottom';
                    } else if (axisPosition !== 'left' && axisPosition !== 'right') axisPosition = axisPositionUsed.left ? 'right' : 'left';
                    axisPositionUsed[axisPosition] = true;
                    var axis = new (0, (0, parcelRequire("kBKMx")).default)(dimName, (0, (0, parcelRequire("3GIoT")).createScaleByModel)(axisModel), [
                        0,
                        0
                    ], axisModel.get('type'), axisPosition);
                    var isCategory = axis.type === 'category';
                    axis.onBand = isCategory && axisModel.get('boundaryGap');
                    axis.inverse = axisModel.get('inverse');
                    axisModel.axis = axis;
                    axis.model = axisModel;
                    axis.grid = grid;
                    axis.index = idx;
                    grid._axesList.push(axis);
                    axesMap[dimName][idx] = axis;
                    axesCount[dimName]++;
                };
            }
        };
        Grid.prototype._updateScale = function(ecModel, gridModel) {
            (0, (0, parcelRequire("bahqM")).each)(this._axesList, function(axis) {
                axis.scale.setExtent(Infinity, -Infinity);
                if (axis.type === 'category') {
                    var categorySortInfo = axis.model.get('categorySortInfo');
                    axis.scale.setSortInfo(categorySortInfo);
                }
            });
            ecModel.eachSeries(function(seriesModel) {
                if ((0, (0, parcelRequire("dBIJY")).isCartesian2DSeries)(seriesModel)) {
                    var axesModelMap = (0, (0, parcelRequire("dBIJY")).findAxisModels)(seriesModel);
                    var xAxisModel = axesModelMap.xAxisModel;
                    var yAxisModel = axesModelMap.yAxisModel;
                    if (!$11f6e45ff2a10529$var$isAxisUsedInTheGrid(xAxisModel, gridModel) || !$11f6e45ff2a10529$var$isAxisUsedInTheGrid(yAxisModel, gridModel)) return;
                    var cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
                    var data = seriesModel.getData();
                    var xAxis = cartesian.getAxis('x');
                    var yAxis = cartesian.getAxis('y');
                    if (data.type === 'list') {
                        unionExtent(data, xAxis);
                        unionExtent(data, yAxis);
                    }
                }
            }, this);
            function unionExtent(data, axis) {
                (0, (0, parcelRequire("bahqM")).each)((0, (0, parcelRequire("3GIoT")).getDataDimensionsOnAxis)(data, axis.dim), function(dim) {
                    axis.scale.unionExtentFromData(data, dim);
                });
            }
        };
        Grid.prototype.getTooltipAxes = function(dim) {
            var baseAxes = [];
            var otherAxes = [];
            (0, (0, parcelRequire("bahqM")).each)(this.getCartesians(), function(cartesian) {
                var baseAxis = dim != null && dim !== 'auto' ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
                var otherAxis = cartesian.getOtherAxis(baseAxis);
                (0, (0, parcelRequire("bahqM")).indexOf)(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
                (0, (0, parcelRequire("bahqM")).indexOf)(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
            });
            return {
                baseAxes: baseAxes,
                otherAxes: otherAxes
            };
        };
        Grid.create = function(ecModel, api) {
            var grids = [];
            ecModel.eachComponent('grid', function(gridModel, idx) {
                var grid = new Grid(gridModel, ecModel, api);
                grid.name = 'grid_' + idx;
                grid.resize(gridModel, api, true);
                gridModel.coordinateSystem = grid;
                grids.push(grid);
            });
            ecModel.eachSeries(function(seriesModel) {
                if (!(0, (0, parcelRequire("dBIJY")).isCartesian2DSeries)(seriesModel)) return;
                var axesModelMap = (0, (0, parcelRequire("dBIJY")).findAxisModels)(seriesModel);
                var xAxisModel = axesModelMap.xAxisModel;
                var yAxisModel = axesModelMap.yAxisModel;
                var gridModel = xAxisModel.getCoordSysModel();
                var grid = gridModel.coordinateSystem;
                seriesModel.coordinateSystem = grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
            });
            return grids;
        };
        Grid.dimensions = (0, (0, parcelRequire("SsPct")).cartesian2DDimensions);
        return Grid;
    }();
    function $11f6e45ff2a10529$var$isAxisUsedInTheGrid(axisModel, gridModel) {
        return axisModel.getCoordSysModel() === gridModel;
    }
    function $11f6e45ff2a10529$var$fixAxisOnZero(axesMap, otherAxisDim, axis, onZeroRecords) {
        axis.getAxesOnZeroOf = function() {
            return otherAxisOnZeroOf ? [
                otherAxisOnZeroOf
            ] : [];
        };
        var otherAxes = axesMap[otherAxisDim];
        var otherAxisOnZeroOf;
        var axisModel = axis.model;
        var onZero = axisModel.get([
            'axisLine',
            'onZero'
        ]);
        var onZeroAxisIndex = axisModel.get([
            'axisLine',
            'onZeroAxisIndex'
        ]);
        if (!onZero) return;
        if (onZeroAxisIndex != null) {
            if ($11f6e45ff2a10529$var$canOnZeroToAxis(otherAxes[onZeroAxisIndex])) otherAxisOnZeroOf = otherAxes[onZeroAxisIndex];
        } else {
            for(var idx in otherAxes)if (otherAxes.hasOwnProperty(idx) && $11f6e45ff2a10529$var$canOnZeroToAxis(otherAxes[idx]) && !onZeroRecords[getOnZeroRecordKey(otherAxes[idx])]) {
                otherAxisOnZeroOf = otherAxes[idx];
                break;
            }
        }
        if (otherAxisOnZeroOf) onZeroRecords[getOnZeroRecordKey(otherAxisOnZeroOf)] = true;
        function getOnZeroRecordKey(axis) {
            return axis.dim + '_' + axis.index;
        }
    }
    function $11f6e45ff2a10529$var$canOnZeroToAxis(axis) {
        return axis && axis.type !== 'category' && axis.type !== 'time' && (0, (0, parcelRequire("3GIoT")).ifAxisCrossZero)(axis);
    }
    function $11f6e45ff2a10529$var$updateAxisTransform(axis, coordBase) {
        var axisExtent = axis.getExtent();
        var axisExtentSum = axisExtent[0] + axisExtent[1];
        axis.toGlobalCoord = axis.dim === 'x' ? function(coord) {
            return coord + coordBase;
        } : function(coord) {
            return axisExtentSum - coord + coordBase;
        };
        axis.toLocalCoord = axis.dim === 'x' ? function(coord) {
            return coord - coordBase;
        } : function(coord) {
            return axisExtentSum - coord + coordBase;
        };
    }
    var $11f6e45ff2a10529$export$2e2bcd8739ae039 = $11f6e45ff2a10529$var$Grid;
});
parcelRegister("3GIoT", function(module, exports) {
    $parcel$export(module.exports, "getScaleExtent", ()=>$2af7bc5b57211b12$export$9c0ba8df7eb7b328);
    $parcel$export(module.exports, "niceScaleExtent", ()=>$2af7bc5b57211b12$export$51f3e70a54405d5a);
    $parcel$export(module.exports, "createScaleByModel", ()=>$2af7bc5b57211b12$export$8941c4cacdc8f5a5);
    $parcel$export(module.exports, "ifAxisCrossZero", ()=>$2af7bc5b57211b12$export$3eac36a69f37d52);
    $parcel$export(module.exports, "makeLabelFormatter", ()=>$2af7bc5b57211b12$export$742f19a75415b2ae);
    $parcel$export(module.exports, "getAxisRawValue", ()=>$2af7bc5b57211b12$export$a5a32f324c1fa457);
    $parcel$export(module.exports, "estimateLabelUnionRect", ()=>$2af7bc5b57211b12$export$fef1c7f0af0b48d);
    $parcel$export(module.exports, "getOptionCategoryInterval", ()=>$2af7bc5b57211b12$export$6d0bc2429155c088);
    $parcel$export(module.exports, "shouldShowAllLabels", ()=>$2af7bc5b57211b12$export$c2911c025243d6a6);
    $parcel$export(module.exports, "getDataDimensionsOnAxis", ()=>$2af7bc5b57211b12$export$e4cf30b1e74cd69d);
    $parcel$export(module.exports, "unionAxisExtentFromData", ()=>$2af7bc5b57211b12$export$635fe7f20d0f4c70);
    var $bahqM;
    var $acOy6;
    var $6kObD;
    var $fEgWg;
    var $eL4bi;
    var $1E3E8;
    var $1MU9l;
    var $73kgw;
    var $5R8Hi;
    var $lo2Vo;
    function $2af7bc5b57211b12$export$9c0ba8df7eb7b328(scale, model) {
        var scaleType = scale.type;
        var rawExtentResult = (0, (0, parcelRequire("lo2Vo")).ensureScaleRawExtentInfo)(scale, model, scale.getExtent()).calculate();
        scale.setBlank(rawExtentResult.isBlank);
        var min = rawExtentResult.min;
        var max = rawExtentResult.max;
        var ecModel = model.ecModel;
        if (ecModel && scaleType === 'time') {
            var barSeriesModels = (0, (0, parcelRequire("eL4bi")).prepareLayoutBarSeries)('bar', ecModel);
            var isBaseAxisAndHasBarSeries_1 = false;
            (0, parcelRequire("bahqM")).each(barSeriesModels, function(seriesModel) {
                isBaseAxisAndHasBarSeries_1 = isBaseAxisAndHasBarSeries_1 || seriesModel.getBaseAxis() === model.axis;
            });
            if (isBaseAxisAndHasBarSeries_1) {
                var barWidthAndOffset = (0, (0, parcelRequire("eL4bi")).makeColumnLayout)(barSeriesModels);
                var adjustedScale = $2af7bc5b57211b12$var$adjustScaleForOverflow(min, max, model, barWidthAndOffset);
                min = adjustedScale.min;
                max = adjustedScale.max;
            }
        }
        return {
            extent: [
                min,
                max
            ],
            fixMin: rawExtentResult.minFixed,
            fixMax: rawExtentResult.maxFixed
        };
    }
    function $2af7bc5b57211b12$var$adjustScaleForOverflow(min, max, model, barWidthAndOffset) {
        var axisExtent = model.axis.getExtent();
        var axisLength = axisExtent[1] - axisExtent[0];
        var barsOnCurrentAxis = (0, (0, parcelRequire("eL4bi")).retrieveColumnLayout)(barWidthAndOffset, model.axis);
        if (barsOnCurrentAxis === undefined) return {
            min: min,
            max: max
        };
        var minOverflow = Infinity;
        (0, parcelRequire("bahqM")).each(barsOnCurrentAxis, function(item) {
            minOverflow = Math.min(item.offset, minOverflow);
        });
        var maxOverflow = -Infinity;
        (0, parcelRequire("bahqM")).each(barsOnCurrentAxis, function(item) {
            maxOverflow = Math.max(item.offset + item.width, maxOverflow);
        });
        minOverflow = Math.abs(minOverflow);
        maxOverflow = Math.abs(maxOverflow);
        var totalOverFlow = minOverflow + maxOverflow;
        var oldRange = max - min;
        var oldRangePercentOfNew = 1 - (minOverflow + maxOverflow) / axisLength;
        var overflowBuffer = oldRange / oldRangePercentOfNew - oldRange;
        max += overflowBuffer * (maxOverflow / totalOverFlow);
        min -= overflowBuffer * (minOverflow / totalOverFlow);
        return {
            min: min,
            max: max
        };
    }
    function $2af7bc5b57211b12$export$51f3e70a54405d5a(scale, inModel) {
        var model = inModel;
        var extentInfo = $2af7bc5b57211b12$export$9c0ba8df7eb7b328(scale, model);
        var extent = extentInfo.extent;
        var splitNumber = model.get('splitNumber');
        if (scale instanceof (0, (0, parcelRequire("73kgw")).default)) scale.base = model.get('logBase');
        var scaleType = scale.type;
        scale.setExtent(extent[0], extent[1]);
        scale.niceExtent({
            splitNumber: splitNumber,
            fixMin: extentInfo.fixMin,
            fixMax: extentInfo.fixMax,
            minInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('minInterval') : null,
            maxInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('maxInterval') : null
        });
        var interval = model.get('interval');
        if (interval != null) scale.setInterval && scale.setInterval(interval);
    }
    function $2af7bc5b57211b12$export$8941c4cacdc8f5a5(model, axisType) {
        axisType = axisType || model.get('type');
        if (axisType) switch(axisType){
            case 'category':
                return new (0, (0, parcelRequire("acOy6")).default)({
                    ordinalMeta: model.getOrdinalMeta ? model.getOrdinalMeta() : model.getCategories(),
                    extent: [
                        Infinity,
                        -Infinity
                    ]
                });
            case 'time':
                return new (0, (0, parcelRequire("1MU9l")).default)({
                    locale: model.ecModel.getLocaleModel(),
                    useUTC: model.ecModel.get('useUTC')
                });
            default:
                return new ((0, (0, parcelRequire("fEgWg")).default).getClass(axisType) || (0, (0, parcelRequire("6kObD")).default))();
        }
    }
    function $2af7bc5b57211b12$export$3eac36a69f37d52(axis) {
        var dataExtent = axis.scale.getExtent();
        var min = dataExtent[0];
        var max = dataExtent[1];
        return !(min > 0 && max > 0 || min < 0 && max < 0);
    }
    function $2af7bc5b57211b12$export$742f19a75415b2ae(axis) {
        var labelFormatter = axis.getLabelModel().get('formatter');
        var categoryTickStart = axis.type === 'category' ? axis.scale.getExtent()[0] : null;
        if (axis.scale.type === 'time') return function(tpl) {
            return function(tick, idx) {
                return axis.scale.getFormattedLabel(tick, idx, tpl);
            };
        }(labelFormatter);
        else if (typeof labelFormatter === 'string') return function(tpl) {
            return function(tick) {
                var label = axis.scale.getLabel(tick);
                var text = tpl.replace('{value}', label != null ? label : '');
                return text;
            };
        }(labelFormatter);
        else if (typeof labelFormatter === 'function') return function(cb) {
            return function(tick, idx) {
                if (categoryTickStart != null) idx = tick.value - categoryTickStart;
                return cb($2af7bc5b57211b12$export$a5a32f324c1fa457(axis, tick), idx, tick.level != null ? {
                    level: tick.level
                } : null);
            };
        }(labelFormatter);
        else return function(tick) {
            return axis.scale.getLabel(tick);
        };
    }
    function $2af7bc5b57211b12$export$a5a32f324c1fa457(axis, tick) {
        return axis.type === 'category' ? axis.scale.getLabel(tick) : tick.value;
    }
    function $2af7bc5b57211b12$export$fef1c7f0af0b48d(axis) {
        var axisModel = axis.model;
        var scale = axis.scale;
        if (!axisModel.get([
            'axisLabel',
            'show'
        ]) || scale.isBlank()) return;
        var realNumberScaleTicks;
        var tickCount;
        var categoryScaleExtent = scale.getExtent();
        if (scale instanceof (0, (0, parcelRequire("acOy6")).default)) tickCount = scale.count();
        else {
            realNumberScaleTicks = scale.getTicks();
            tickCount = realNumberScaleTicks.length;
        }
        var axisLabelModel = axis.getLabelModel();
        var labelFormatter = $2af7bc5b57211b12$export$742f19a75415b2ae(axis);
        var rect;
        var step = 1;
        if (tickCount > 40) step = Math.ceil(tickCount / 40);
        for(var i = 0; i < tickCount; i += step){
            var tick = realNumberScaleTicks ? realNumberScaleTicks[i] : {
                value: categoryScaleExtent[0] + i
            };
            var label = labelFormatter(tick, i);
            var unrotatedSingleRect = axisLabelModel.getTextRect(label);
            var singleRect = $2af7bc5b57211b12$var$rotateTextRect(unrotatedSingleRect, axisLabelModel.get('rotate') || 0);
            rect ? rect.union(singleRect) : rect = singleRect;
        }
        return rect;
    }
    function $2af7bc5b57211b12$var$rotateTextRect(textRect, rotate) {
        var rotateRadians = rotate * Math.PI / 180;
        var beforeWidth = textRect.width;
        var beforeHeight = textRect.height;
        var afterWidth = beforeWidth * Math.abs(Math.cos(rotateRadians)) + Math.abs(beforeHeight * Math.sin(rotateRadians));
        var afterHeight = beforeWidth * Math.abs(Math.sin(rotateRadians)) + Math.abs(beforeHeight * Math.cos(rotateRadians));
        var rotatedRect = new (0, (0, parcelRequire("1E3E8")).default)(textRect.x, textRect.y, afterWidth, afterHeight);
        return rotatedRect;
    }
    function $2af7bc5b57211b12$export$6d0bc2429155c088(model) {
        var interval = model.get('interval');
        return interval == null ? 'auto' : interval;
    }
    function $2af7bc5b57211b12$export$c2911c025243d6a6(axis) {
        return axis.type === 'category' && $2af7bc5b57211b12$export$6d0bc2429155c088(axis.getLabelModel()) === 0;
    }
    function $2af7bc5b57211b12$export$e4cf30b1e74cd69d(data, axisDim) {
        var dataDimMap = {};
        (0, parcelRequire("bahqM")).each(data.mapDimensionsAll(axisDim), function(dataDim) {
            dataDimMap[(0, (0, parcelRequire("5R8Hi")).getStackedDimension)(data, dataDim)] = true;
        });
        return (0, parcelRequire("bahqM")).keys(dataDimMap);
    }
    function $2af7bc5b57211b12$export$635fe7f20d0f4c70(dataExtent, data, axisDim) {
        if (data) (0, parcelRequire("bahqM")).each($2af7bc5b57211b12$export$e4cf30b1e74cd69d(data, axisDim), function(dim) {
            var seriesExtent = data.getApproximateExtent(dim);
            seriesExtent[0] < dataExtent[0] && (dataExtent[0] = seriesExtent[0]);
            seriesExtent[1] > dataExtent[1] && (dataExtent[1] = seriesExtent[1]);
        });
    }
});
parcelRegister("acOy6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$76e23c609ca21282$export$2e2bcd8739ae039);
    var $3VFsf;
    var $fEgWg;
    var $6Vrdy;
    var $32MHg;
    var $bahqM;
    var $76e23c609ca21282$var$OrdinalScale = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(OrdinalScale, _super);
        function OrdinalScale(setting) {
            var _this = _super.call(this, setting) || this;
            _this.type = 'ordinal';
            var ordinalMeta = _this.getSetting('ordinalMeta');
            if (!ordinalMeta) ordinalMeta = new (0, (0, parcelRequire("6Vrdy")).default)({});
            if ((0, (0, parcelRequire("bahqM")).isArray)(ordinalMeta)) ordinalMeta = new (0, (0, parcelRequire("6Vrdy")).default)({
                categories: (0, (0, parcelRequire("bahqM")).map)(ordinalMeta, function(item) {
                    return (0, (0, parcelRequire("bahqM")).isObject)(item) ? item.value : item;
                })
            });
            _this._ordinalMeta = ordinalMeta;
            _this._extent = _this.getSetting('extent') || [
                0,
                ordinalMeta.categories.length - 1
            ];
            return _this;
        }
        OrdinalScale.prototype.parse = function(val) {
            return typeof val === 'string' ? this._ordinalMeta.getOrdinal(val) : Math.round(val);
        };
        OrdinalScale.prototype.contain = function(rank) {
            rank = this.parse(rank);
            return (0, parcelRequire("32MHg")).contain(rank, this._extent) && this._ordinalMeta.categories[rank] != null;
        };
        OrdinalScale.prototype.normalize = function(val) {
            val = this._getTickNumber(this.parse(val));
            return (0, parcelRequire("32MHg")).normalize(val, this._extent);
        };
        OrdinalScale.prototype.scale = function(val) {
            val = Math.round((0, parcelRequire("32MHg")).scale(val, this._extent));
            return this.getRawOrdinalNumber(val);
        };
        OrdinalScale.prototype.getTicks = function() {
            var ticks = [];
            var extent = this._extent;
            var rank = extent[0];
            while(rank <= extent[1]){
                ticks.push({
                    value: rank
                });
                rank++;
            }
            return ticks;
        };
        OrdinalScale.prototype.getMinorTicks = function(splitNumber) {
            return;
        };
        OrdinalScale.prototype.setSortInfo = function(info) {
            if (info == null) {
                this._ordinalNumbersByTick = this._ticksByOrdinalNumber = null;
                return;
            }
            var infoOrdinalNumbers = info.ordinalNumbers;
            var ordinalsByTick = this._ordinalNumbersByTick = [];
            var ticksByOrdinal = this._ticksByOrdinalNumber = [];
            var tickNum = 0;
            var allCategoryLen = this._ordinalMeta.categories.length;
            for(var len = Math.min(allCategoryLen, infoOrdinalNumbers.length); tickNum < len; ++tickNum){
                var ordinalNumber = infoOrdinalNumbers[tickNum];
                ordinalsByTick[tickNum] = ordinalNumber;
                ticksByOrdinal[ordinalNumber] = tickNum;
            }
            var unusedOrdinal = 0;
            for(; tickNum < allCategoryLen; ++tickNum){
                while(ticksByOrdinal[unusedOrdinal] != null)unusedOrdinal++;
                ordinalsByTick.push(unusedOrdinal);
                ticksByOrdinal[unusedOrdinal] = tickNum;
            }
        };
        OrdinalScale.prototype._getTickNumber = function(ordinal) {
            var ticksByOrdinalNumber = this._ticksByOrdinalNumber;
            return ticksByOrdinalNumber && ordinal >= 0 && ordinal < ticksByOrdinalNumber.length ? ticksByOrdinalNumber[ordinal] : ordinal;
        };
        OrdinalScale.prototype.getRawOrdinalNumber = function(tickNumber) {
            var ordinalNumbersByTick = this._ordinalNumbersByTick;
            return ordinalNumbersByTick && tickNumber >= 0 && tickNumber < ordinalNumbersByTick.length ? ordinalNumbersByTick[tickNumber] : tickNumber;
        };
        OrdinalScale.prototype.getLabel = function(tick) {
            if (!this.isBlank()) {
                var ordinalNumber = this.getRawOrdinalNumber(tick.value);
                var cateogry = this._ordinalMeta.categories[ordinalNumber];
                return cateogry == null ? '' : cateogry + '';
            }
        };
        OrdinalScale.prototype.count = function() {
            return this._extent[1] - this._extent[0] + 1;
        };
        OrdinalScale.prototype.unionExtentFromData = function(data, dim) {
            this.unionExtent(data.getApproximateExtent(dim));
        };
        OrdinalScale.prototype.isInExtentRange = function(value) {
            value = this._getTickNumber(value);
            return this._extent[0] <= value && this._extent[1] >= value;
        };
        OrdinalScale.prototype.getOrdinalMeta = function() {
            return this._ordinalMeta;
        };
        OrdinalScale.prototype.niceTicks = function() {};
        OrdinalScale.prototype.niceExtent = function() {};
        OrdinalScale.type = 'ordinal';
        return OrdinalScale;
    }((0, (0, parcelRequire("fEgWg")).default));
    (0, (0, parcelRequire("fEgWg")).default).registerClass($76e23c609ca21282$var$OrdinalScale);
    var $76e23c609ca21282$export$2e2bcd8739ae039 = $76e23c609ca21282$var$OrdinalScale;
});
parcelRegister("fEgWg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b647bb1e30834d31$export$2e2bcd8739ae039);
    var $aLwh0;
    var $b647bb1e30834d31$var$Scale = function() {
        function Scale(setting) {
            this._setting = setting || {};
            this._extent = [
                Infinity,
                -Infinity
            ];
        }
        Scale.prototype.getSetting = function(name) {
            return this._setting[name];
        };
        Scale.prototype.unionExtent = function(other) {
            var extent = this._extent;
            other[0] < extent[0] && (extent[0] = other[0]);
            other[1] > extent[1] && (extent[1] = other[1]);
        };
        Scale.prototype.unionExtentFromData = function(data, dim) {
            this.unionExtent(data.getApproximateExtent(dim));
        };
        Scale.prototype.getExtent = function() {
            return this._extent.slice();
        };
        Scale.prototype.setExtent = function(start, end) {
            var thisExtent = this._extent;
            if (!isNaN(start)) thisExtent[0] = start;
            if (!isNaN(end)) thisExtent[1] = end;
        };
        Scale.prototype.isInExtentRange = function(value) {
            return this._extent[0] <= value && this._extent[1] >= value;
        };
        Scale.prototype.isBlank = function() {
            return this._isBlank;
        };
        Scale.prototype.setBlank = function(isBlank) {
            this._isBlank = isBlank;
        };
        return Scale;
    }();
    (0, parcelRequire("aLwh0")).enableClassManagement($b647bb1e30834d31$var$Scale);
    var $b647bb1e30834d31$export$2e2bcd8739ae039 = $b647bb1e30834d31$var$Scale;
});
parcelRegister("32MHg", function(module, exports) {
    $parcel$export(module.exports, "intervalScaleNiceTicks", ()=>$2377552e030bbd2b$export$eeea879a611eb991);
    $parcel$export(module.exports, "getIntervalPrecision", ()=>$2377552e030bbd2b$export$86a060b060d3d31a);
    $parcel$export(module.exports, "contain", ()=>$2377552e030bbd2b$export$8893e2b90ba10d92);
    $parcel$export(module.exports, "normalize", ()=>$2377552e030bbd2b$export$a3295358bff77e);
    $parcel$export(module.exports, "scale", ()=>$2377552e030bbd2b$export$dcdf75081b88279d);
    var $jmSNG;
    var $2377552e030bbd2b$var$roundNumber = (0, parcelRequire("jmSNG")).round;
    function $2377552e030bbd2b$export$eeea879a611eb991(extent, splitNumber, minInterval, maxInterval) {
        var result = {};
        var span = extent[1] - extent[0];
        var interval = result.interval = (0, parcelRequire("jmSNG")).nice(span / splitNumber, true);
        if (minInterval != null && interval < minInterval) interval = result.interval = minInterval;
        if (maxInterval != null && interval > maxInterval) interval = result.interval = maxInterval;
        var precision = result.intervalPrecision = $2377552e030bbd2b$export$86a060b060d3d31a(interval);
        var niceTickExtent = result.niceTickExtent = [
            $2377552e030bbd2b$var$roundNumber(Math.ceil(extent[0] / interval) * interval, precision),
            $2377552e030bbd2b$var$roundNumber(Math.floor(extent[1] / interval) * interval, precision)
        ];
        $2377552e030bbd2b$export$624b8c8c438031ad(niceTickExtent, extent);
        return result;
    }
    function $2377552e030bbd2b$export$86a060b060d3d31a(interval) {
        return (0, parcelRequire("jmSNG")).getPrecision(interval) + 2;
    }
    function $2377552e030bbd2b$var$clamp(niceTickExtent, idx, extent) {
        niceTickExtent[idx] = Math.max(Math.min(niceTickExtent[idx], extent[1]), extent[0]);
    }
    function $2377552e030bbd2b$export$624b8c8c438031ad(niceTickExtent, extent) {
        !isFinite(niceTickExtent[0]) && (niceTickExtent[0] = extent[0]);
        !isFinite(niceTickExtent[1]) && (niceTickExtent[1] = extent[1]);
        $2377552e030bbd2b$var$clamp(niceTickExtent, 0, extent);
        $2377552e030bbd2b$var$clamp(niceTickExtent, 1, extent);
        if (niceTickExtent[0] > niceTickExtent[1]) niceTickExtent[0] = niceTickExtent[1];
    }
    function $2377552e030bbd2b$export$8893e2b90ba10d92(val, extent) {
        return val >= extent[0] && val <= extent[1];
    }
    function $2377552e030bbd2b$export$a3295358bff77e(val, extent) {
        if (extent[1] === extent[0]) return 0.5;
        return (val - extent[0]) / (extent[1] - extent[0]);
    }
    function $2377552e030bbd2b$export$dcdf75081b88279d(val, extent) {
        return val * (extent[1] - extent[0]) + extent[0];
    }
});
parcelRegister("6kObD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$49cb8a61b3174199$export$2e2bcd8739ae039);
    var $3VFsf;
    var $jmSNG;
    var $dCJrM;
    var $fEgWg;
    var $32MHg;
    var $49cb8a61b3174199$var$roundNumber = (0, parcelRequire("jmSNG")).round;
    var $49cb8a61b3174199$var$IntervalScale = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(IntervalScale, _super);
        function IntervalScale() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = 'interval';
            _this._interval = 0;
            _this._intervalPrecision = 2;
            return _this;
        }
        IntervalScale.prototype.parse = function(val) {
            return val;
        };
        IntervalScale.prototype.contain = function(val) {
            return (0, parcelRequire("32MHg")).contain(val, this._extent);
        };
        IntervalScale.prototype.normalize = function(val) {
            return (0, parcelRequire("32MHg")).normalize(val, this._extent);
        };
        IntervalScale.prototype.scale = function(val) {
            return (0, parcelRequire("32MHg")).scale(val, this._extent);
        };
        IntervalScale.prototype.setExtent = function(start, end) {
            var thisExtent = this._extent;
            if (!isNaN(start)) thisExtent[0] = parseFloat(start);
            if (!isNaN(end)) thisExtent[1] = parseFloat(end);
        };
        IntervalScale.prototype.unionExtent = function(other) {
            var extent = this._extent;
            other[0] < extent[0] && (extent[0] = other[0]);
            other[1] > extent[1] && (extent[1] = other[1]);
            this.setExtent(extent[0], extent[1]);
        };
        IntervalScale.prototype.getInterval = function() {
            return this._interval;
        };
        IntervalScale.prototype.setInterval = function(interval) {
            this._interval = interval;
            this._niceExtent = this._extent.slice();
            this._intervalPrecision = (0, parcelRequire("32MHg")).getIntervalPrecision(interval);
        };
        IntervalScale.prototype.getTicks = function(expandToNicedExtent) {
            var interval = this._interval;
            var extent = this._extent;
            var niceTickExtent = this._niceExtent;
            var intervalPrecision = this._intervalPrecision;
            var ticks = [];
            if (!interval) return ticks;
            var safeLimit = 10000;
            if (extent[0] < niceTickExtent[0]) {
                if (expandToNicedExtent) ticks.push({
                    value: $49cb8a61b3174199$var$roundNumber(niceTickExtent[0] - interval, intervalPrecision)
                });
                else ticks.push({
                    value: extent[0]
                });
            }
            var tick = niceTickExtent[0];
            while(tick <= niceTickExtent[1]){
                ticks.push({
                    value: tick
                });
                tick = $49cb8a61b3174199$var$roundNumber(tick + interval, intervalPrecision);
                if (tick === ticks[ticks.length - 1].value) break;
                if (ticks.length > safeLimit) return [];
            }
            var lastNiceTick = ticks.length ? ticks[ticks.length - 1].value : niceTickExtent[1];
            if (extent[1] > lastNiceTick) {
                if (expandToNicedExtent) ticks.push({
                    value: $49cb8a61b3174199$var$roundNumber(lastNiceTick + interval, intervalPrecision)
                });
                else ticks.push({
                    value: extent[1]
                });
            }
            return ticks;
        };
        IntervalScale.prototype.getMinorTicks = function(splitNumber) {
            var ticks = this.getTicks(true);
            var minorTicks = [];
            var extent = this.getExtent();
            for(var i = 1; i < ticks.length; i++){
                var nextTick = ticks[i];
                var prevTick = ticks[i - 1];
                var count = 0;
                var minorTicksGroup = [];
                var interval = nextTick.value - prevTick.value;
                var minorInterval = interval / splitNumber;
                while(count < splitNumber - 1){
                    var minorTick = $49cb8a61b3174199$var$roundNumber(prevTick.value + (count + 1) * minorInterval);
                    if (minorTick > extent[0] && minorTick < extent[1]) minorTicksGroup.push(minorTick);
                    count++;
                }
                minorTicks.push(minorTicksGroup);
            }
            return minorTicks;
        };
        IntervalScale.prototype.getLabel = function(data, opt) {
            if (data == null) return '';
            var precision = opt && opt.precision;
            if (precision == null) precision = (0, parcelRequire("jmSNG")).getPrecision(data.value) || 0;
            else if (precision === 'auto') precision = this._intervalPrecision;
            var dataNum = $49cb8a61b3174199$var$roundNumber(data.value, precision, true);
            return (0, parcelRequire("dCJrM")).addCommas(dataNum);
        };
        IntervalScale.prototype.niceTicks = function(splitNumber, minInterval, maxInterval) {
            splitNumber = splitNumber || 5;
            var extent = this._extent;
            var span = extent[1] - extent[0];
            if (!isFinite(span)) return;
            if (span < 0) {
                span = -span;
                extent.reverse();
            }
            var result = (0, parcelRequire("32MHg")).intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval);
            this._intervalPrecision = result.intervalPrecision;
            this._interval = result.interval;
            this._niceExtent = result.niceTickExtent;
        };
        IntervalScale.prototype.niceExtent = function(opt) {
            var extent = this._extent;
            if (extent[0] === extent[1]) {
                if (extent[0] !== 0) {
                    var expandSize = extent[0];
                    if (!opt.fixMax) {
                        extent[1] += expandSize / 2;
                        extent[0] -= expandSize / 2;
                    } else extent[0] -= expandSize / 2;
                } else extent[1] = 1;
            }
            var span = extent[1] - extent[0];
            if (!isFinite(span)) {
                extent[0] = 0;
                extent[1] = 1;
            }
            this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval);
            var interval = this._interval;
            if (!opt.fixMin) extent[0] = $49cb8a61b3174199$var$roundNumber(Math.floor(extent[0] / interval) * interval);
            if (!opt.fixMax) extent[1] = $49cb8a61b3174199$var$roundNumber(Math.ceil(extent[1] / interval) * interval);
        };
        IntervalScale.type = 'interval';
        return IntervalScale;
    }((0, (0, parcelRequire("fEgWg")).default));
    (0, (0, parcelRequire("fEgWg")).default).registerClass($49cb8a61b3174199$var$IntervalScale);
    var $49cb8a61b3174199$export$2e2bcd8739ae039 = $49cb8a61b3174199$var$IntervalScale;
});
parcelRegister("1MU9l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$14d5d447dd592e99$export$2e2bcd8739ae039);
    var $3VFsf;
    var $jmSNG;
    var $bc1Ad;
    var $32MHg;
    var $6kObD;
    var $fEgWg;
    var $bahqM;
    var $14d5d447dd592e99$var$bisect = function(a, x, lo, hi) {
        while(lo < hi){
            var mid = lo + hi >>> 1;
            if (a[mid][1] < x) lo = mid + 1;
            else hi = mid;
        }
        return lo;
    };
    var $14d5d447dd592e99$var$TimeScale = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(TimeScale, _super);
        function TimeScale(settings) {
            var _this = _super.call(this, settings) || this;
            _this.type = 'time';
            return _this;
        }
        TimeScale.prototype.getLabel = function(tick) {
            var useUTC = this.getSetting('useUTC');
            return (0, (0, parcelRequire("bc1Ad")).format)(tick.value, (0, (0, parcelRequire("bc1Ad")).fullLeveledFormatter)[(0, (0, parcelRequire("bc1Ad")).getDefaultFormatPrecisionOfInterval)((0, (0, parcelRequire("bc1Ad")).getPrimaryTimeUnit)(this._minLevelUnit))] || (0, (0, parcelRequire("bc1Ad")).fullLeveledFormatter).second, useUTC, this.getSetting('locale'));
        };
        TimeScale.prototype.getFormattedLabel = function(tick, idx, labelFormatter) {
            var isUTC = this.getSetting('useUTC');
            var lang = this.getSetting('locale');
            return (0, (0, parcelRequire("bc1Ad")).leveledFormat)(tick, idx, labelFormatter, lang, isUTC);
        };
        TimeScale.prototype.getTicks = function(expandToNicedExtent) {
            var interval = this._interval;
            var extent = this._extent;
            var ticks = [];
            if (!interval) return ticks;
            ticks.push({
                value: extent[0],
                level: 0
            });
            var useUTC = this.getSetting('useUTC');
            var innerTicks = $14d5d447dd592e99$var$getIntervalTicks(this._minLevelUnit, this._approxInterval, useUTC, extent);
            ticks = ticks.concat(innerTicks);
            ticks.push({
                value: extent[1],
                level: 0
            });
            return ticks;
        };
        TimeScale.prototype.niceExtent = function(opt) {
            var extent = this._extent;
            if (extent[0] === extent[1]) {
                extent[0] -= (0, (0, parcelRequire("bc1Ad")).ONE_DAY);
                extent[1] += (0, (0, parcelRequire("bc1Ad")).ONE_DAY);
            }
            if (extent[1] === -Infinity && extent[0] === Infinity) {
                var d = new Date();
                extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
                extent[0] = extent[1] - (0, (0, parcelRequire("bc1Ad")).ONE_DAY);
            }
            this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval);
        };
        TimeScale.prototype.niceTicks = function(approxTickNum, minInterval, maxInterval) {
            approxTickNum = approxTickNum || 10;
            var extent = this._extent;
            var span = extent[1] - extent[0];
            this._approxInterval = span / approxTickNum;
            if (minInterval != null && this._approxInterval < minInterval) this._approxInterval = minInterval;
            if (maxInterval != null && this._approxInterval > maxInterval) this._approxInterval = maxInterval;
            var scaleIntervalsLen = $14d5d447dd592e99$var$scaleIntervals.length;
            var idx = Math.min($14d5d447dd592e99$var$bisect($14d5d447dd592e99$var$scaleIntervals, this._approxInterval, 0, scaleIntervalsLen), scaleIntervalsLen - 1);
            this._interval = $14d5d447dd592e99$var$scaleIntervals[idx][1];
            this._minLevelUnit = $14d5d447dd592e99$var$scaleIntervals[Math.max(idx - 1, 0)][0];
        };
        TimeScale.prototype.parse = function(val) {
            return typeof val === 'number' ? val : +(0, parcelRequire("jmSNG")).parseDate(val);
        };
        TimeScale.prototype.contain = function(val) {
            return (0, parcelRequire("32MHg")).contain(this.parse(val), this._extent);
        };
        TimeScale.prototype.normalize = function(val) {
            return (0, parcelRequire("32MHg")).normalize(this.parse(val), this._extent);
        };
        TimeScale.prototype.scale = function(val) {
            return (0, parcelRequire("32MHg")).scale(val, this._extent);
        };
        TimeScale.type = 'time';
        return TimeScale;
    }((0, (0, parcelRequire("6kObD")).default));
    var $14d5d447dd592e99$var$scaleIntervals = [
        [
            'second',
            (0, (0, parcelRequire("bc1Ad")).ONE_SECOND)
        ],
        [
            'minute',
            (0, (0, parcelRequire("bc1Ad")).ONE_MINUTE)
        ],
        [
            'hour',
            (0, (0, parcelRequire("bc1Ad")).ONE_HOUR)
        ],
        [
            'quarter-day',
            (0, (0, parcelRequire("bc1Ad")).ONE_HOUR) * 6
        ],
        [
            'half-day',
            (0, (0, parcelRequire("bc1Ad")).ONE_HOUR) * 12
        ],
        [
            'day',
            (0, (0, parcelRequire("bc1Ad")).ONE_DAY) * 1.2
        ],
        [
            'half-week',
            (0, (0, parcelRequire("bc1Ad")).ONE_DAY) * 3.5
        ],
        [
            'week',
            (0, (0, parcelRequire("bc1Ad")).ONE_DAY) * 7
        ],
        [
            'month',
            (0, (0, parcelRequire("bc1Ad")).ONE_DAY) * 31
        ],
        [
            'quarter',
            (0, (0, parcelRequire("bc1Ad")).ONE_DAY) * 95
        ],
        [
            'half-year',
            (0, (0, parcelRequire("bc1Ad")).ONE_YEAR) / 2
        ],
        [
            'year',
            (0, (0, parcelRequire("bc1Ad")).ONE_YEAR)
        ]
    ];
    function $14d5d447dd592e99$var$isUnitValueSame(unit, valueA, valueB, isUTC) {
        var dateA = (0, parcelRequire("jmSNG")).parseDate(valueA);
        var dateB = (0, parcelRequire("jmSNG")).parseDate(valueB);
        var isSame = function(unit) {
            return (0, (0, parcelRequire("bc1Ad")).getUnitValue)(dateA, unit, isUTC) === (0, (0, parcelRequire("bc1Ad")).getUnitValue)(dateB, unit, isUTC);
        };
        var isSameYear = function() {
            return isSame('year');
        };
        var isSameMonth = function() {
            return isSameYear() && isSame('month');
        };
        var isSameDay = function() {
            return isSameMonth() && isSame('day');
        };
        var isSameHour = function() {
            return isSameDay() && isSame('hour');
        };
        var isSameMinute = function() {
            return isSameHour() && isSame('minute');
        };
        var isSameSecond = function() {
            return isSameMinute() && isSame('second');
        };
        var isSameMilliSecond = function() {
            return isSameSecond() && isSame('millisecond');
        };
        switch(unit){
            case 'year':
                return isSameYear();
            case 'month':
                return isSameMonth();
            case 'day':
                return isSameDay();
            case 'hour':
                return isSameHour();
            case 'minute':
                return isSameMinute();
            case 'second':
                return isSameSecond();
            case 'millisecond':
                return isSameMilliSecond();
        }
    }
    function $14d5d447dd592e99$var$getDateInterval(approxInterval, daysInMonth) {
        approxInterval /= (0, (0, parcelRequire("bc1Ad")).ONE_DAY);
        return approxInterval > 16 ? 16 : approxInterval > 7.5 ? 7 : approxInterval > 3.5 ? 4 : approxInterval > 1.5 ? 2 : 1;
    }
    function $14d5d447dd592e99$var$getMonthInterval(approxInterval) {
        var APPROX_ONE_MONTH = 30 * (0, (0, parcelRequire("bc1Ad")).ONE_DAY);
        approxInterval /= APPROX_ONE_MONTH;
        return approxInterval > 6 ? 6 : approxInterval > 3 ? 3 : approxInterval > 2 ? 2 : 1;
    }
    function $14d5d447dd592e99$var$getHourInterval(approxInterval) {
        approxInterval /= (0, (0, parcelRequire("bc1Ad")).ONE_HOUR);
        return approxInterval > 12 ? 12 : approxInterval > 6 ? 6 : approxInterval > 3.5 ? 4 : approxInterval > 2 ? 2 : 1;
    }
    function $14d5d447dd592e99$var$getMinutesAndSecondsInterval(approxInterval, isMinutes) {
        approxInterval /= isMinutes ? (0, (0, parcelRequire("bc1Ad")).ONE_MINUTE) : (0, (0, parcelRequire("bc1Ad")).ONE_SECOND);
        return approxInterval > 30 ? 30 : approxInterval > 20 ? 20 : approxInterval > 15 ? 15 : approxInterval > 10 ? 10 : approxInterval > 5 ? 5 : approxInterval > 2 ? 2 : 1;
    }
    function $14d5d447dd592e99$var$getMillisecondsInterval(approxInterval) {
        return (0, parcelRequire("jmSNG")).nice(approxInterval, true);
    }
    function $14d5d447dd592e99$var$getFirstTimestampOfUnit(date, unitName, isUTC) {
        var outDate = new Date(date);
        switch((0, (0, parcelRequire("bc1Ad")).getPrimaryTimeUnit)(unitName)){
            case 'year':
            case 'month':
                outDate[(0, (0, parcelRequire("bc1Ad")).monthSetterName)(isUTC)](0);
            case 'day':
                outDate[(0, (0, parcelRequire("bc1Ad")).dateSetterName)(isUTC)](1);
            case 'hour':
                outDate[(0, (0, parcelRequire("bc1Ad")).hoursSetterName)(isUTC)](0);
            case 'minute':
                outDate[(0, (0, parcelRequire("bc1Ad")).minutesSetterName)(isUTC)](0);
            case 'second':
                outDate[(0, (0, parcelRequire("bc1Ad")).secondsSetterName)(isUTC)](0);
                outDate[(0, (0, parcelRequire("bc1Ad")).millisecondsSetterName)(isUTC)](0);
        }
        return outDate.getTime();
    }
    function $14d5d447dd592e99$var$getIntervalTicks(bottomUnitName, approxInterval, isUTC, extent) {
        var safeLimit = 10000;
        var unitNames = (0, (0, parcelRequire("bc1Ad")).timeUnits);
        var iter = 0;
        function addTicksInSpan(interval, minTimestamp, maxTimestamp, getMethodName, setMethodName, isDate, out) {
            var date = new Date(minTimestamp);
            var dateTime = minTimestamp;
            var d = date[getMethodName]();
            while(dateTime < maxTimestamp && dateTime <= extent[1]){
                out.push({
                    value: dateTime
                });
                d += interval;
                date[setMethodName](d);
                dateTime = date.getTime();
            }
            out.push({
                value: dateTime,
                notAdd: true
            });
        }
        function addLevelTicks(unitName, lastLevelTicks, levelTicks) {
            var newAddedTicks = [];
            var isFirstLevel = !lastLevelTicks.length;
            if ($14d5d447dd592e99$var$isUnitValueSame((0, (0, parcelRequire("bc1Ad")).getPrimaryTimeUnit)(unitName), extent[0], extent[1], isUTC)) return;
            if (isFirstLevel) lastLevelTicks = [
                {
                    value: $14d5d447dd592e99$var$getFirstTimestampOfUnit(new Date(extent[0]), unitName, isUTC)
                },
                {
                    value: extent[1]
                }
            ];
            for(var i = 0; i < lastLevelTicks.length - 1; i++){
                var startTick = lastLevelTicks[i].value;
                var endTick = lastLevelTicks[i + 1].value;
                if (startTick === endTick) continue;
                var interval = void 0;
                var getterName = void 0;
                var setterName = void 0;
                var isDate = false;
                switch(unitName){
                    case 'year':
                        interval = Math.max(1, Math.round(approxInterval / (0, (0, parcelRequire("bc1Ad")).ONE_DAY) / 365));
                        getterName = (0, (0, parcelRequire("bc1Ad")).fullYearGetterName)(isUTC);
                        setterName = (0, (0, parcelRequire("bc1Ad")).fullYearSetterName)(isUTC);
                        break;
                    case 'half-year':
                    case 'quarter':
                    case 'month':
                        interval = $14d5d447dd592e99$var$getMonthInterval(approxInterval);
                        getterName = (0, (0, parcelRequire("bc1Ad")).monthGetterName)(isUTC);
                        setterName = (0, (0, parcelRequire("bc1Ad")).monthSetterName)(isUTC);
                        break;
                    case 'week':
                    case 'half-week':
                    case 'day':
                        interval = $14d5d447dd592e99$var$getDateInterval(approxInterval, 31);
                        getterName = (0, (0, parcelRequire("bc1Ad")).dateGetterName)(isUTC);
                        setterName = (0, (0, parcelRequire("bc1Ad")).dateSetterName)(isUTC);
                        isDate = true;
                        break;
                    case 'half-day':
                    case 'quarter-day':
                    case 'hour':
                        interval = $14d5d447dd592e99$var$getHourInterval(approxInterval);
                        getterName = (0, (0, parcelRequire("bc1Ad")).hoursGetterName)(isUTC);
                        setterName = (0, (0, parcelRequire("bc1Ad")).hoursSetterName)(isUTC);
                        break;
                    case 'minute':
                        interval = $14d5d447dd592e99$var$getMinutesAndSecondsInterval(approxInterval, true);
                        getterName = (0, (0, parcelRequire("bc1Ad")).minutesGetterName)(isUTC);
                        setterName = (0, (0, parcelRequire("bc1Ad")).minutesSetterName)(isUTC);
                        break;
                    case 'second':
                        interval = $14d5d447dd592e99$var$getMinutesAndSecondsInterval(approxInterval, false);
                        getterName = (0, (0, parcelRequire("bc1Ad")).secondsGetterName)(isUTC);
                        setterName = (0, (0, parcelRequire("bc1Ad")).secondsSetterName)(isUTC);
                        break;
                    case 'millisecond':
                        interval = $14d5d447dd592e99$var$getMillisecondsInterval(approxInterval);
                        getterName = (0, (0, parcelRequire("bc1Ad")).millisecondsGetterName)(isUTC);
                        setterName = (0, (0, parcelRequire("bc1Ad")).millisecondsSetterName)(isUTC);
                        break;
                }
                addTicksInSpan(interval, startTick, endTick, getterName, setterName, isDate, newAddedTicks);
                if (unitName === 'year' && levelTicks.length > 1 && i === 0) levelTicks.unshift({
                    value: levelTicks[0].value - interval
                });
            }
            for(var i = 0; i < newAddedTicks.length; i++)levelTicks.push(newAddedTicks[i]);
            return newAddedTicks;
        }
        var levelsTicks = [];
        var currentLevelTicks = [];
        var tickCount = 0;
        var lastLevelTickCount = 0;
        for(var i = 0; i < unitNames.length && iter++ < safeLimit; ++i){
            var primaryTimeUnit = (0, (0, parcelRequire("bc1Ad")).getPrimaryTimeUnit)(unitNames[i]);
            if (!(0, (0, parcelRequire("bc1Ad")).isPrimaryTimeUnit)(unitNames[i])) continue;
            addLevelTicks(unitNames[i], levelsTicks[levelsTicks.length - 1] || [], currentLevelTicks);
            var nextPrimaryTimeUnit = unitNames[i + 1] ? (0, (0, parcelRequire("bc1Ad")).getPrimaryTimeUnit)(unitNames[i + 1]) : null;
            if (primaryTimeUnit !== nextPrimaryTimeUnit) {
                if (currentLevelTicks.length) {
                    lastLevelTickCount = tickCount;
                    currentLevelTicks.sort(function(a, b) {
                        return a.value - b.value;
                    });
                    var levelTicksRemoveDuplicated = [];
                    for(var i_1 = 0; i_1 < currentLevelTicks.length; ++i_1){
                        var tickValue = currentLevelTicks[i_1].value;
                        if (i_1 === 0 || currentLevelTicks[i_1 - 1].value !== tickValue) {
                            levelTicksRemoveDuplicated.push(currentLevelTicks[i_1]);
                            if (tickValue >= extent[0] && tickValue <= extent[1]) tickCount++;
                        }
                    }
                    var targetTickNum = (extent[1] - extent[0]) / approxInterval;
                    if (tickCount > targetTickNum * 1.5 && lastLevelTickCount > targetTickNum / 1.5) break;
                    levelsTicks.push(levelTicksRemoveDuplicated);
                    if (tickCount > targetTickNum || bottomUnitName === unitNames[i]) break;
                }
                currentLevelTicks = [];
            }
        }
        var levelsTicksInExtent = (0, (0, parcelRequire("bahqM")).filter)((0, (0, parcelRequire("bahqM")).map)(levelsTicks, function(levelTicks) {
            return (0, (0, parcelRequire("bahqM")).filter)(levelTicks, function(tick) {
                return tick.value >= extent[0] && tick.value <= extent[1] && !tick.notAdd;
            });
        }), function(levelTicks) {
            return levelTicks.length > 0;
        });
        var ticks = [];
        var maxLevel = levelsTicksInExtent.length - 1;
        for(var i = 0; i < levelsTicksInExtent.length; ++i){
            var levelTicks = levelsTicksInExtent[i];
            for(var k = 0; k < levelTicks.length; ++k)ticks.push({
                value: levelTicks[k].value,
                level: maxLevel - i
            });
        }
        ticks.sort(function(a, b) {
            return a.value - b.value;
        });
        var result = [];
        for(var i = 0; i < ticks.length; ++i)if (i === 0 || ticks[i].value !== ticks[i - 1].value) result.push(ticks[i]);
        return result;
    }
    (0, (0, parcelRequire("fEgWg")).default).registerClass($14d5d447dd592e99$var$TimeScale);
    var $14d5d447dd592e99$export$2e2bcd8739ae039 = $14d5d447dd592e99$var$TimeScale;
});
parcelRegister("73kgw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5228888966b0d10c$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bahqM;
    var $fEgWg;
    var $jmSNG;
    var $32MHg;
    var $6kObD;
    var $5228888966b0d10c$var$scaleProto = (0, (0, parcelRequire("fEgWg")).default).prototype;
    var $5228888966b0d10c$var$intervalScaleProto = (0, (0, parcelRequire("6kObD")).default).prototype;
    var $5228888966b0d10c$var$roundingErrorFix = (0, parcelRequire("jmSNG")).round;
    var $5228888966b0d10c$var$mathFloor = Math.floor;
    var $5228888966b0d10c$var$mathCeil = Math.ceil;
    var $5228888966b0d10c$var$mathPow = Math.pow;
    var $5228888966b0d10c$var$mathLog = Math.log;
    var $5228888966b0d10c$var$LogScale = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(LogScale, _super);
        function LogScale() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = 'log';
            _this.base = 10;
            _this._originalScale = new (0, (0, parcelRequire("6kObD")).default)();
            _this._interval = 0;
            return _this;
        }
        LogScale.prototype.getTicks = function(expandToNicedExtent) {
            var originalScale = this._originalScale;
            var extent = this._extent;
            var originalExtent = originalScale.getExtent();
            var ticks = $5228888966b0d10c$var$intervalScaleProto.getTicks.call(this, expandToNicedExtent);
            return (0, parcelRequire("bahqM")).map(ticks, function(tick) {
                var val = tick.value;
                var powVal = (0, parcelRequire("jmSNG")).round($5228888966b0d10c$var$mathPow(this.base, val));
                powVal = val === extent[0] && this._fixMin ? $5228888966b0d10c$var$fixRoundingError(powVal, originalExtent[0]) : powVal;
                powVal = val === extent[1] && this._fixMax ? $5228888966b0d10c$var$fixRoundingError(powVal, originalExtent[1]) : powVal;
                return {
                    value: powVal
                };
            }, this);
        };
        LogScale.prototype.setExtent = function(start, end) {
            var base = this.base;
            start = $5228888966b0d10c$var$mathLog(start) / $5228888966b0d10c$var$mathLog(base);
            end = $5228888966b0d10c$var$mathLog(end) / $5228888966b0d10c$var$mathLog(base);
            $5228888966b0d10c$var$intervalScaleProto.setExtent.call(this, start, end);
        };
        LogScale.prototype.getExtent = function() {
            var base = this.base;
            var extent = $5228888966b0d10c$var$scaleProto.getExtent.call(this);
            extent[0] = $5228888966b0d10c$var$mathPow(base, extent[0]);
            extent[1] = $5228888966b0d10c$var$mathPow(base, extent[1]);
            var originalScale = this._originalScale;
            var originalExtent = originalScale.getExtent();
            this._fixMin && (extent[0] = $5228888966b0d10c$var$fixRoundingError(extent[0], originalExtent[0]));
            this._fixMax && (extent[1] = $5228888966b0d10c$var$fixRoundingError(extent[1], originalExtent[1]));
            return extent;
        };
        LogScale.prototype.unionExtent = function(extent) {
            this._originalScale.unionExtent(extent);
            var base = this.base;
            extent[0] = $5228888966b0d10c$var$mathLog(extent[0]) / $5228888966b0d10c$var$mathLog(base);
            extent[1] = $5228888966b0d10c$var$mathLog(extent[1]) / $5228888966b0d10c$var$mathLog(base);
            $5228888966b0d10c$var$scaleProto.unionExtent.call(this, extent);
        };
        LogScale.prototype.unionExtentFromData = function(data, dim) {
            this.unionExtent(data.getApproximateExtent(dim));
        };
        LogScale.prototype.niceTicks = function(approxTickNum) {
            approxTickNum = approxTickNum || 10;
            var extent = this._extent;
            var span = extent[1] - extent[0];
            if (span === Infinity || span <= 0) return;
            var interval = (0, parcelRequire("jmSNG")).quantity(span);
            var err = approxTickNum / span * interval;
            if (err <= 0.5) interval *= 10;
            while(!isNaN(interval) && Math.abs(interval) < 1 && Math.abs(interval) > 0)interval *= 10;
            var niceExtent = [
                (0, parcelRequire("jmSNG")).round($5228888966b0d10c$var$mathCeil(extent[0] / interval) * interval),
                (0, parcelRequire("jmSNG")).round($5228888966b0d10c$var$mathFloor(extent[1] / interval) * interval)
            ];
            this._interval = interval;
            this._niceExtent = niceExtent;
        };
        LogScale.prototype.niceExtent = function(opt) {
            $5228888966b0d10c$var$intervalScaleProto.niceExtent.call(this, opt);
            this._fixMin = opt.fixMin;
            this._fixMax = opt.fixMax;
        };
        LogScale.prototype.parse = function(val) {
            return val;
        };
        LogScale.prototype.contain = function(val) {
            val = $5228888966b0d10c$var$mathLog(val) / $5228888966b0d10c$var$mathLog(this.base);
            return (0, parcelRequire("32MHg")).contain(val, this._extent);
        };
        LogScale.prototype.normalize = function(val) {
            val = $5228888966b0d10c$var$mathLog(val) / $5228888966b0d10c$var$mathLog(this.base);
            return (0, parcelRequire("32MHg")).normalize(val, this._extent);
        };
        LogScale.prototype.scale = function(val) {
            val = (0, parcelRequire("32MHg")).scale(val, this._extent);
            return $5228888966b0d10c$var$mathPow(this.base, val);
        };
        LogScale.type = 'log';
        return LogScale;
    }((0, (0, parcelRequire("fEgWg")).default));
    var $5228888966b0d10c$var$proto = $5228888966b0d10c$var$LogScale.prototype;
    $5228888966b0d10c$var$proto.getMinorTicks = $5228888966b0d10c$var$intervalScaleProto.getMinorTicks;
    $5228888966b0d10c$var$proto.getLabel = $5228888966b0d10c$var$intervalScaleProto.getLabel;
    function $5228888966b0d10c$var$fixRoundingError(val, originalVal) {
        return $5228888966b0d10c$var$roundingErrorFix(val, (0, parcelRequire("jmSNG")).getPrecision(originalVal));
    }
    (0, (0, parcelRequire("fEgWg")).default).registerClass($5228888966b0d10c$var$LogScale);
    var $5228888966b0d10c$export$2e2bcd8739ae039 = $5228888966b0d10c$var$LogScale;
});
parcelRegister("lo2Vo", function(module, exports) {
    $parcel$export(module.exports, "parseAxisModelMinMax", ()=>$f91e1bac53937426$export$d02f2e65dfc3c2b);
    $parcel$export(module.exports, "ensureScaleRawExtentInfo", ()=>$f91e1bac53937426$export$5c3dbcbeb9ce7f5a);
    var $bahqM;
    var $b7ZX8;
    var $f91e1bac53937426$export$c35454f678e99c82 = function() {
        function ScaleRawExtentInfo(scale, model, originalExtent) {
            this._prepareParams(scale, model, originalExtent);
        }
        ScaleRawExtentInfo.prototype._prepareParams = function(scale, model, dataExtent) {
            if (dataExtent[1] < dataExtent[0]) dataExtent = [
                NaN,
                NaN
            ];
            this._dataMin = dataExtent[0];
            this._dataMax = dataExtent[1];
            var isOrdinal = this._isOrdinal = scale.type === 'ordinal';
            this._needCrossZero = model.getNeedCrossZero && model.getNeedCrossZero();
            var modelMinRaw = this._modelMinRaw = model.get('min', true);
            if ((0, (0, parcelRequire("bahqM")).isFunction)(modelMinRaw)) this._modelMinNum = $f91e1bac53937426$export$d02f2e65dfc3c2b(scale, modelMinRaw({
                min: dataExtent[0],
                max: dataExtent[1]
            }));
            else if (modelMinRaw !== 'dataMin') this._modelMinNum = $f91e1bac53937426$export$d02f2e65dfc3c2b(scale, modelMinRaw);
            var modelMaxRaw = this._modelMaxRaw = model.get('max', true);
            if ((0, (0, parcelRequire("bahqM")).isFunction)(modelMaxRaw)) this._modelMaxNum = $f91e1bac53937426$export$d02f2e65dfc3c2b(scale, modelMaxRaw({
                min: dataExtent[0],
                max: dataExtent[1]
            }));
            else if (modelMaxRaw !== 'dataMax') this._modelMaxNum = $f91e1bac53937426$export$d02f2e65dfc3c2b(scale, modelMaxRaw);
            if (isOrdinal) this._axisDataLen = model.getCategories().length;
            else {
                var boundaryGap = model.get('boundaryGap');
                var boundaryGapArr = (0, (0, parcelRequire("bahqM")).isArray)(boundaryGap) ? boundaryGap : [
                    boundaryGap || 0,
                    boundaryGap || 0
                ];
                if (typeof boundaryGapArr[0] === 'boolean' || typeof boundaryGapArr[1] === 'boolean') this._boundaryGapInner = [
                    0,
                    0
                ];
                else this._boundaryGapInner = [
                    (0, (0, parcelRequire("b7ZX8")).parsePercent)(boundaryGapArr[0], 1),
                    (0, (0, parcelRequire("b7ZX8")).parsePercent)(boundaryGapArr[1], 1)
                ];
            }
        };
        ScaleRawExtentInfo.prototype.calculate = function() {
            var isOrdinal = this._isOrdinal;
            var dataMin = this._dataMin;
            var dataMax = this._dataMax;
            var axisDataLen = this._axisDataLen;
            var boundaryGapInner = this._boundaryGapInner;
            var span = !isOrdinal ? dataMax - dataMin || Math.abs(dataMin) : null;
            var min = this._modelMinRaw === 'dataMin' ? dataMin : this._modelMinNum;
            var max = this._modelMaxRaw === 'dataMax' ? dataMax : this._modelMaxNum;
            var minFixed = min != null;
            var maxFixed = max != null;
            if (min == null) min = isOrdinal ? axisDataLen ? 0 : NaN : dataMin - boundaryGapInner[0] * span;
            if (max == null) max = isOrdinal ? axisDataLen ? axisDataLen - 1 : NaN : dataMax + boundaryGapInner[1] * span;
            (min == null || !isFinite(min)) && (min = NaN);
            (max == null || !isFinite(max)) && (max = NaN);
            if (min > max) {
                min = NaN;
                max = NaN;
            }
            var isBlank = (0, (0, parcelRequire("bahqM")).eqNaN)(min) || (0, (0, parcelRequire("bahqM")).eqNaN)(max) || isOrdinal && !axisDataLen;
            if (this._needCrossZero) {
                if (min > 0 && max > 0 && !minFixed) min = 0;
                if (min < 0 && max < 0 && !maxFixed) max = 0;
            }
            var determinedMin = this._determinedMin;
            var determinedMax = this._determinedMax;
            if (determinedMin != null) {
                min = determinedMin;
                minFixed = true;
            }
            if (determinedMax != null) {
                max = determinedMax;
                maxFixed = true;
            }
            return {
                min: min,
                max: max,
                minFixed: minFixed,
                maxFixed: maxFixed,
                isBlank: isBlank
            };
        };
        ScaleRawExtentInfo.prototype.modifyDataMinMax = function(minMaxName, val) {
            this[$f91e1bac53937426$var$DATA_MIN_MAX_ATTR[minMaxName]] = val;
        };
        ScaleRawExtentInfo.prototype.setDeterminedMinMax = function(minMaxName, val) {
            var attr = $f91e1bac53937426$var$DETERMINED_MIN_MAX_ATTR[minMaxName];
            this[attr] = val;
        };
        ScaleRawExtentInfo.prototype.freeze = function() {
            this.frozen = true;
        };
        return ScaleRawExtentInfo;
    }();
    var $f91e1bac53937426$var$DETERMINED_MIN_MAX_ATTR = {
        min: '_determinedMin',
        max: '_determinedMax'
    };
    var $f91e1bac53937426$var$DATA_MIN_MAX_ATTR = {
        min: '_dataMin',
        max: '_dataMax'
    };
    function $f91e1bac53937426$export$5c3dbcbeb9ce7f5a(scale, model, originalExtent) {
        var rawExtentInfo = scale.rawExtentInfo;
        if (rawExtentInfo) return rawExtentInfo;
        rawExtentInfo = new $f91e1bac53937426$export$c35454f678e99c82(scale, model, originalExtent);
        scale.rawExtentInfo = rawExtentInfo;
        return rawExtentInfo;
    }
    function $f91e1bac53937426$export$d02f2e65dfc3c2b(scale, minMax) {
        return minMax == null ? null : (0, (0, parcelRequire("bahqM")).eqNaN)(minMax) ? NaN : scale.parse(minMax);
    }
});
parcelRegister("SsPct", function(module, exports) {
    $parcel$export(module.exports, "cartesian2DDimensions", ()=>$0a3b6744500b73ac$export$988a008d2b9120f4);
    $parcel$export(module.exports, "default", ()=>$0a3b6744500b73ac$export$2e2bcd8739ae039);
    var $3VFsf;
    var $1E3E8;
    var $7j9L9;
    var $izqgC;
    var $eLEew;
    var $0a3b6744500b73ac$export$988a008d2b9120f4 = [
        'x',
        'y'
    ];
    function $0a3b6744500b73ac$var$canCalculateAffineTransform(scale) {
        return scale.type === 'interval' || scale.type === 'time';
    }
    var $0a3b6744500b73ac$var$Cartesian2D = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Cartesian2D, _super);
        function Cartesian2D() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = 'cartesian2d';
            _this.dimensions = $0a3b6744500b73ac$export$988a008d2b9120f4;
            return _this;
        }
        Cartesian2D.prototype.calcAffineTransform = function() {
            this._transform = this._invTransform = null;
            var xAxisScale = this.getAxis('x').scale;
            var yAxisScale = this.getAxis('y').scale;
            if (!$0a3b6744500b73ac$var$canCalculateAffineTransform(xAxisScale) || !$0a3b6744500b73ac$var$canCalculateAffineTransform(yAxisScale)) return;
            var xScaleExtent = xAxisScale.getExtent();
            var yScaleExtent = yAxisScale.getExtent();
            var start = this.dataToPoint([
                xScaleExtent[0],
                yScaleExtent[0]
            ]);
            var end = this.dataToPoint([
                xScaleExtent[1],
                yScaleExtent[1]
            ]);
            var xScaleSpan = xScaleExtent[1] - xScaleExtent[0];
            var yScaleSpan = yScaleExtent[1] - yScaleExtent[0];
            if (!xScaleSpan || !yScaleSpan) return;
            var scaleX = (end[0] - start[0]) / xScaleSpan;
            var scaleY = (end[1] - start[1]) / yScaleSpan;
            var translateX = start[0] - xScaleExtent[0] * scaleX;
            var translateY = start[1] - yScaleExtent[0] * scaleY;
            var m = this._transform = [
                scaleX,
                0,
                0,
                scaleY,
                translateX,
                translateY
            ];
            this._invTransform = (0, (0, parcelRequire("izqgC")).invert)([], m);
        };
        Cartesian2D.prototype.getBaseAxis = function() {
            return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAxis('x');
        };
        Cartesian2D.prototype.containPoint = function(point) {
            var axisX = this.getAxis('x');
            var axisY = this.getAxis('y');
            return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
        };
        Cartesian2D.prototype.containData = function(data) {
            return this.getAxis('x').containData(data[0]) && this.getAxis('y').containData(data[1]);
        };
        Cartesian2D.prototype.dataToPoint = function(data, clamp, out) {
            out = out || [];
            var xVal = data[0];
            var yVal = data[1];
            if (this._transform && xVal != null && isFinite(xVal) && yVal != null && isFinite(yVal)) return (0, (0, parcelRequire("eLEew")).applyTransform)(out, data, this._transform);
            var xAxis = this.getAxis('x');
            var yAxis = this.getAxis('y');
            out[0] = xAxis.toGlobalCoord(xAxis.dataToCoord(xVal, clamp));
            out[1] = yAxis.toGlobalCoord(yAxis.dataToCoord(yVal, clamp));
            return out;
        };
        Cartesian2D.prototype.clampData = function(data, out) {
            var xScale = this.getAxis('x').scale;
            var yScale = this.getAxis('y').scale;
            var xAxisExtent = xScale.getExtent();
            var yAxisExtent = yScale.getExtent();
            var x = xScale.parse(data[0]);
            var y = yScale.parse(data[1]);
            out = out || [];
            out[0] = Math.min(Math.max(Math.min(xAxisExtent[0], xAxisExtent[1]), x), Math.max(xAxisExtent[0], xAxisExtent[1]));
            out[1] = Math.min(Math.max(Math.min(yAxisExtent[0], yAxisExtent[1]), y), Math.max(yAxisExtent[0], yAxisExtent[1]));
            return out;
        };
        Cartesian2D.prototype.pointToData = function(point, clamp) {
            var out = [];
            if (this._invTransform) return (0, (0, parcelRequire("eLEew")).applyTransform)(out, point, this._invTransform);
            var xAxis = this.getAxis('x');
            var yAxis = this.getAxis('y');
            out[0] = xAxis.coordToData(xAxis.toLocalCoord(point[0]), clamp);
            out[1] = yAxis.coordToData(yAxis.toLocalCoord(point[1]), clamp);
            return out;
        };
        Cartesian2D.prototype.getOtherAxis = function(axis) {
            return this.getAxis(axis.dim === 'x' ? 'y' : 'x');
        };
        Cartesian2D.prototype.getArea = function() {
            var xExtent = this.getAxis('x').getGlobalExtent();
            var yExtent = this.getAxis('y').getGlobalExtent();
            var x = Math.min(xExtent[0], xExtent[1]);
            var y = Math.min(yExtent[0], yExtent[1]);
            var width = Math.max(xExtent[0], xExtent[1]) - x;
            var height = Math.max(yExtent[0], yExtent[1]) - y;
            return new (0, (0, parcelRequire("1E3E8")).default)(x, y, width, height);
        };
        return Cartesian2D;
    }((0, (0, parcelRequire("7j9L9")).default));
    var $0a3b6744500b73ac$export$2e2bcd8739ae039 = $0a3b6744500b73ac$var$Cartesian2D;
});
parcelRegister("7j9L9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5521e0c9b22643f8$export$2e2bcd8739ae039);
    var $bahqM;
    var $5521e0c9b22643f8$var$Cartesian = function() {
        function Cartesian(name) {
            this.type = 'cartesian';
            this._dimList = [];
            this._axes = {};
            this.name = name || '';
        }
        Cartesian.prototype.getAxis = function(dim) {
            return this._axes[dim];
        };
        Cartesian.prototype.getAxes = function() {
            return (0, parcelRequire("bahqM")).map(this._dimList, function(dim) {
                return this._axes[dim];
            }, this);
        };
        Cartesian.prototype.getAxesByScale = function(scaleType) {
            scaleType = scaleType.toLowerCase();
            return (0, parcelRequire("bahqM")).filter(this.getAxes(), function(axis) {
                return axis.scale.type === scaleType;
            });
        };
        Cartesian.prototype.addAxis = function(axis) {
            var dim = axis.dim;
            this._axes[dim] = axis;
            this._dimList.push(dim);
        };
        return Cartesian;
    }();
    var $5521e0c9b22643f8$export$2e2bcd8739ae039 = $5521e0c9b22643f8$var$Cartesian;
});
parcelRegister("kBKMx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f00b8d3b69958a3f$export$2e2bcd8739ae039);
    var $3VFsf;
    var $g6Gq1;
    var $f00b8d3b69958a3f$var$Axis2D = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Axis2D, _super);
        function Axis2D(dim, scale, coordExtent, axisType, position) {
            var _this = _super.call(this, dim, scale, coordExtent) || this;
            _this.index = 0;
            _this.type = axisType || 'value';
            _this.position = position || 'bottom';
            return _this;
        }
        Axis2D.prototype.isHorizontal = function() {
            var position = this.position;
            return position === 'top' || position === 'bottom';
        };
        Axis2D.prototype.getGlobalExtent = function(asc) {
            var ret = this.getExtent();
            ret[0] = this.toGlobalCoord(ret[0]);
            ret[1] = this.toGlobalCoord(ret[1]);
            asc && ret[0] > ret[1] && ret.reverse();
            return ret;
        };
        Axis2D.prototype.pointToData = function(point, clamp) {
            return this.coordToData(this.toLocalCoord(point[this.dim === 'x' ? 0 : 1]), clamp);
        };
        Axis2D.prototype.setCategorySortInfo = function(info) {
            if (this.type !== 'category') return false;
            this.model.option.categorySortInfo = info;
            this.scale.setSortInfo(info);
        };
        return Axis2D;
    }((0, (0, parcelRequire("g6Gq1")).default));
    var $f00b8d3b69958a3f$export$2e2bcd8739ae039 = $f00b8d3b69958a3f$var$Axis2D;
});
parcelRegister("g6Gq1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bb9e1c59fe00c8ac$export$2e2bcd8739ae039);
    var $bahqM;
    var $jmSNG;
    var $ftAX6;
    var $bb9e1c59fe00c8ac$var$NORMALIZED_EXTENT = [
        0,
        1
    ];
    var $bb9e1c59fe00c8ac$var$Axis = function() {
        function Axis(dim, scale, extent) {
            this.onBand = false;
            this.inverse = false;
            this.dim = dim;
            this.scale = scale;
            this._extent = extent || [
                0,
                0
            ];
        }
        Axis.prototype.contain = function(coord) {
            var extent = this._extent;
            var min = Math.min(extent[0], extent[1]);
            var max = Math.max(extent[0], extent[1]);
            return coord >= min && coord <= max;
        };
        Axis.prototype.containData = function(data) {
            return this.scale.contain(data);
        };
        Axis.prototype.getExtent = function() {
            return this._extent.slice();
        };
        Axis.prototype.getPixelPrecision = function(dataExtent) {
            return (0, (0, parcelRequire("jmSNG")).getPixelPrecision)(dataExtent || this.scale.getExtent(), this._extent);
        };
        Axis.prototype.setExtent = function(start, end) {
            var extent = this._extent;
            extent[0] = start;
            extent[1] = end;
        };
        Axis.prototype.dataToCoord = function(data, clamp) {
            var extent = this._extent;
            var scale = this.scale;
            data = scale.normalize(data);
            if (this.onBand && scale.type === 'ordinal') {
                extent = extent.slice();
                $bb9e1c59fe00c8ac$var$fixExtentWithBands(extent, scale.count());
            }
            return (0, (0, parcelRequire("jmSNG")).linearMap)(data, $bb9e1c59fe00c8ac$var$NORMALIZED_EXTENT, extent, clamp);
        };
        Axis.prototype.coordToData = function(coord, clamp) {
            var extent = this._extent;
            var scale = this.scale;
            if (this.onBand && scale.type === 'ordinal') {
                extent = extent.slice();
                $bb9e1c59fe00c8ac$var$fixExtentWithBands(extent, scale.count());
            }
            var t = (0, (0, parcelRequire("jmSNG")).linearMap)(coord, extent, $bb9e1c59fe00c8ac$var$NORMALIZED_EXTENT, clamp);
            return this.scale.scale(t);
        };
        Axis.prototype.pointToData = function(point, clamp) {
            return;
        };
        Axis.prototype.getTicksCoords = function(opt) {
            opt = opt || {};
            var tickModel = opt.tickModel || this.getTickModel();
            var result = (0, (0, parcelRequire("ftAX6")).createAxisTicks)(this, tickModel);
            var ticks = result.ticks;
            var ticksCoords = (0, (0, parcelRequire("bahqM")).map)(ticks, function(tickVal) {
                return {
                    coord: this.dataToCoord(this.scale.type === 'ordinal' ? this.scale.getRawOrdinalNumber(tickVal) : tickVal),
                    tickValue: tickVal
                };
            }, this);
            var alignWithLabel = tickModel.get('alignWithLabel');
            $bb9e1c59fe00c8ac$var$fixOnBandTicksCoords(this, ticksCoords, alignWithLabel, opt.clamp);
            return ticksCoords;
        };
        Axis.prototype.getMinorTicksCoords = function() {
            if (this.scale.type === 'ordinal') return [];
            var minorTickModel = this.model.getModel('minorTick');
            var splitNumber = minorTickModel.get('splitNumber');
            if (!(splitNumber > 0 && splitNumber < 100)) splitNumber = 5;
            var minorTicks = this.scale.getMinorTicks(splitNumber);
            var minorTicksCoords = (0, (0, parcelRequire("bahqM")).map)(minorTicks, function(minorTicksGroup) {
                return (0, (0, parcelRequire("bahqM")).map)(minorTicksGroup, function(minorTick) {
                    return {
                        coord: this.dataToCoord(minorTick),
                        tickValue: minorTick
                    };
                }, this);
            }, this);
            return minorTicksCoords;
        };
        Axis.prototype.getViewLabels = function() {
            return (0, (0, parcelRequire("ftAX6")).createAxisLabels)(this).labels;
        };
        Axis.prototype.getLabelModel = function() {
            return this.model.getModel('axisLabel');
        };
        Axis.prototype.getTickModel = function() {
            return this.model.getModel('axisTick');
        };
        Axis.prototype.getBandWidth = function() {
            var axisExtent = this._extent;
            var dataExtent = this.scale.getExtent();
            var len = dataExtent[1] - dataExtent[0] + (this.onBand ? 1 : 0);
            len === 0 && (len = 1);
            var size = Math.abs(axisExtent[1] - axisExtent[0]);
            return Math.abs(size) / len;
        };
        Axis.prototype.calculateCategoryInterval = function() {
            return (0, (0, parcelRequire("ftAX6")).calculateCategoryInterval)(this);
        };
        return Axis;
    }();
    function $bb9e1c59fe00c8ac$var$fixExtentWithBands(extent, nTick) {
        var size = extent[1] - extent[0];
        var len = nTick;
        var margin = size / len / 2;
        extent[0] += margin;
        extent[1] -= margin;
    }
    function $bb9e1c59fe00c8ac$var$fixOnBandTicksCoords(axis, ticksCoords, alignWithLabel, clamp) {
        var ticksLen = ticksCoords.length;
        if (!axis.onBand || alignWithLabel || !ticksLen) return;
        var axisExtent = axis.getExtent();
        var last;
        var diffSize;
        if (ticksLen === 1) {
            ticksCoords[0].coord = axisExtent[0];
            last = ticksCoords[1] = {
                coord: axisExtent[0]
            };
        } else {
            var crossLen = ticksCoords[ticksLen - 1].tickValue - ticksCoords[0].tickValue;
            var shift_1 = (ticksCoords[ticksLen - 1].coord - ticksCoords[0].coord) / crossLen;
            (0, (0, parcelRequire("bahqM")).each)(ticksCoords, function(ticksItem) {
                ticksItem.coord -= shift_1 / 2;
            });
            var dataExtent = axis.scale.getExtent();
            diffSize = 1 + dataExtent[1] - ticksCoords[ticksLen - 1].tickValue;
            last = {
                coord: ticksCoords[ticksLen - 1].coord + shift_1 * diffSize
            };
            ticksCoords.push(last);
        }
        var inverse = axisExtent[0] > axisExtent[1];
        if (littleThan(ticksCoords[0].coord, axisExtent[0])) clamp ? ticksCoords[0].coord = axisExtent[0] : ticksCoords.shift();
        if (clamp && littleThan(axisExtent[0], ticksCoords[0].coord)) ticksCoords.unshift({
            coord: axisExtent[0]
        });
        if (littleThan(axisExtent[1], last.coord)) clamp ? last.coord = axisExtent[1] : ticksCoords.pop();
        if (clamp && littleThan(last.coord, axisExtent[1])) ticksCoords.push({
            coord: axisExtent[1]
        });
        function littleThan(a, b) {
            a = (0, (0, parcelRequire("jmSNG")).round)(a);
            b = (0, (0, parcelRequire("jmSNG")).round)(b);
            return inverse ? a > b : a < b;
        }
    }
    var $bb9e1c59fe00c8ac$export$2e2bcd8739ae039 = $bb9e1c59fe00c8ac$var$Axis;
});
parcelRegister("ftAX6", function(module, exports) {
    $parcel$export(module.exports, "createAxisLabels", ()=>$b4463a620840f7ae$export$10216ebd3e3e485e);
    $parcel$export(module.exports, "createAxisTicks", ()=>$b4463a620840f7ae$export$7cccf6836ae8323c);
    $parcel$export(module.exports, "calculateCategoryInterval", ()=>$b4463a620840f7ae$export$9ea1d3f146a5a65f);
    var $bahqM;
    var $b7ZX8;
    var $eaKsF;
    var $3GIoT;
    var $b4463a620840f7ae$var$inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
    function $b4463a620840f7ae$export$10216ebd3e3e485e(axis) {
        return axis.type === 'category' ? $b4463a620840f7ae$var$makeCategoryLabels(axis) : $b4463a620840f7ae$var$makeRealNumberLabels(axis);
    }
    function $b4463a620840f7ae$export$7cccf6836ae8323c(axis, tickModel) {
        return axis.type === 'category' ? $b4463a620840f7ae$var$makeCategoryTicks(axis, tickModel) : {
            ticks: (0, parcelRequire("bahqM")).map(axis.scale.getTicks(), function(tick) {
                return tick.value;
            })
        };
    }
    function $b4463a620840f7ae$var$makeCategoryLabels(axis) {
        var labelModel = axis.getLabelModel();
        var result = $b4463a620840f7ae$var$makeCategoryLabelsActually(axis, labelModel);
        return !labelModel.get('show') || axis.scale.isBlank() ? {
            labels: [],
            labelCategoryInterval: result.labelCategoryInterval
        } : result;
    }
    function $b4463a620840f7ae$var$makeCategoryLabelsActually(axis, labelModel) {
        var labelsCache = $b4463a620840f7ae$var$getListCache(axis, 'labels');
        var optionLabelInterval = (0, (0, parcelRequire("3GIoT")).getOptionCategoryInterval)(labelModel);
        var result = $b4463a620840f7ae$var$listCacheGet(labelsCache, optionLabelInterval);
        if (result) return result;
        var labels;
        var numericLabelInterval;
        if ((0, parcelRequire("bahqM")).isFunction(optionLabelInterval)) labels = $b4463a620840f7ae$var$makeLabelsByCustomizedCategoryInterval(axis, optionLabelInterval);
        else {
            numericLabelInterval = optionLabelInterval === 'auto' ? $b4463a620840f7ae$var$makeAutoCategoryInterval(axis) : optionLabelInterval;
            labels = $b4463a620840f7ae$var$makeLabelsByNumericCategoryInterval(axis, numericLabelInterval);
        }
        return $b4463a620840f7ae$var$listCacheSet(labelsCache, optionLabelInterval, {
            labels: labels,
            labelCategoryInterval: numericLabelInterval
        });
    }
    function $b4463a620840f7ae$var$makeCategoryTicks(axis, tickModel) {
        var ticksCache = $b4463a620840f7ae$var$getListCache(axis, 'ticks');
        var optionTickInterval = (0, (0, parcelRequire("3GIoT")).getOptionCategoryInterval)(tickModel);
        var result = $b4463a620840f7ae$var$listCacheGet(ticksCache, optionTickInterval);
        if (result) return result;
        var ticks;
        var tickCategoryInterval;
        if (!tickModel.get('show') || axis.scale.isBlank()) ticks = [];
        if ((0, parcelRequire("bahqM")).isFunction(optionTickInterval)) ticks = $b4463a620840f7ae$var$makeLabelsByCustomizedCategoryInterval(axis, optionTickInterval, true);
        else if (optionTickInterval === 'auto') {
            var labelsResult = $b4463a620840f7ae$var$makeCategoryLabelsActually(axis, axis.getLabelModel());
            tickCategoryInterval = labelsResult.labelCategoryInterval;
            ticks = (0, parcelRequire("bahqM")).map(labelsResult.labels, function(labelItem) {
                return labelItem.tickValue;
            });
        } else {
            tickCategoryInterval = optionTickInterval;
            ticks = $b4463a620840f7ae$var$makeLabelsByNumericCategoryInterval(axis, tickCategoryInterval, true);
        }
        return $b4463a620840f7ae$var$listCacheSet(ticksCache, optionTickInterval, {
            ticks: ticks,
            tickCategoryInterval: tickCategoryInterval
        });
    }
    function $b4463a620840f7ae$var$makeRealNumberLabels(axis) {
        var ticks = axis.scale.getTicks();
        var labelFormatter = (0, (0, parcelRequire("3GIoT")).makeLabelFormatter)(axis);
        return {
            labels: (0, parcelRequire("bahqM")).map(ticks, function(tick, idx) {
                return {
                    level: tick.level,
                    formattedLabel: labelFormatter(tick, idx),
                    rawLabel: axis.scale.getLabel(tick),
                    tickValue: tick.value
                };
            })
        };
    }
    function $b4463a620840f7ae$var$getListCache(axis, prop) {
        return $b4463a620840f7ae$var$inner(axis)[prop] || ($b4463a620840f7ae$var$inner(axis)[prop] = []);
    }
    function $b4463a620840f7ae$var$listCacheGet(cache, key) {
        for(var i = 0; i < cache.length; i++){
            if (cache[i].key === key) return cache[i].value;
        }
    }
    function $b4463a620840f7ae$var$listCacheSet(cache, key, value) {
        cache.push({
            key: key,
            value: value
        });
        return value;
    }
    function $b4463a620840f7ae$var$makeAutoCategoryInterval(axis) {
        var result = $b4463a620840f7ae$var$inner(axis).autoInterval;
        return result != null ? result : $b4463a620840f7ae$var$inner(axis).autoInterval = axis.calculateCategoryInterval();
    }
    function $b4463a620840f7ae$export$9ea1d3f146a5a65f(axis) {
        var params = $b4463a620840f7ae$var$fetchAutoCategoryIntervalCalculationParams(axis);
        var labelFormatter = (0, (0, parcelRequire("3GIoT")).makeLabelFormatter)(axis);
        var rotation = (params.axisRotate - params.labelRotate) / 180 * Math.PI;
        var ordinalScale = axis.scale;
        var ordinalExtent = ordinalScale.getExtent();
        var tickCount = ordinalScale.count();
        if (ordinalExtent[1] - ordinalExtent[0] < 1) return 0;
        var step = 1;
        if (tickCount > 40) step = Math.max(1, Math.floor(tickCount / 40));
        var tickValue = ordinalExtent[0];
        var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
        var unitW = Math.abs(unitSpan * Math.cos(rotation));
        var unitH = Math.abs(unitSpan * Math.sin(rotation));
        var maxW = 0;
        var maxH = 0;
        for(; tickValue <= ordinalExtent[1]; tickValue += step){
            var width = 0;
            var height = 0;
            var rect = (0, parcelRequire("b7ZX8")).getBoundingRect(labelFormatter({
                value: tickValue
            }), params.font, 'center', 'top');
            width = rect.width * 1.3;
            height = rect.height * 1.3;
            maxW = Math.max(maxW, width, 7);
            maxH = Math.max(maxH, height, 7);
        }
        var dw = maxW / unitW;
        var dh = maxH / unitH;
        isNaN(dw) && (dw = Infinity);
        isNaN(dh) && (dh = Infinity);
        var interval = Math.max(0, Math.floor(Math.min(dw, dh)));
        var cache = $b4463a620840f7ae$var$inner(axis.model);
        var axisExtent = axis.getExtent();
        var lastAutoInterval = cache.lastAutoInterval;
        var lastTickCount = cache.lastTickCount;
        if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 && lastAutoInterval > interval && cache.axisExtent0 === axisExtent[0] && cache.axisExtent1 === axisExtent[1]) interval = lastAutoInterval;
        else {
            cache.lastTickCount = tickCount;
            cache.lastAutoInterval = interval;
            cache.axisExtent0 = axisExtent[0];
            cache.axisExtent1 = axisExtent[1];
        }
        return interval;
    }
    function $b4463a620840f7ae$var$fetchAutoCategoryIntervalCalculationParams(axis) {
        var labelModel = axis.getLabelModel();
        return {
            axisRotate: axis.getRotate ? axis.getRotate() : axis.isHorizontal && !axis.isHorizontal() ? 90 : 0,
            labelRotate: labelModel.get('rotate') || 0,
            font: labelModel.getFont()
        };
    }
    function $b4463a620840f7ae$var$makeLabelsByNumericCategoryInterval(axis, categoryInterval, onlyTick) {
        var labelFormatter = (0, (0, parcelRequire("3GIoT")).makeLabelFormatter)(axis);
        var ordinalScale = axis.scale;
        var ordinalExtent = ordinalScale.getExtent();
        var labelModel = axis.getLabelModel();
        var result = [];
        var step = Math.max((categoryInterval || 0) + 1, 1);
        var startTick = ordinalExtent[0];
        var tickCount = ordinalScale.count();
        if (startTick !== 0 && step > 1 && tickCount / step > 2) startTick = Math.round(Math.ceil(startTick / step) * step);
        var showAllLabel = (0, (0, parcelRequire("3GIoT")).shouldShowAllLabels)(axis);
        var includeMinLabel = labelModel.get('showMinLabel') || showAllLabel;
        var includeMaxLabel = labelModel.get('showMaxLabel') || showAllLabel;
        if (includeMinLabel && startTick !== ordinalExtent[0]) addItem(ordinalExtent[0]);
        var tickValue = startTick;
        for(; tickValue <= ordinalExtent[1]; tickValue += step)addItem(tickValue);
        if (includeMaxLabel && tickValue - step !== ordinalExtent[1]) addItem(ordinalExtent[1]);
        function addItem(tickValue) {
            var tickObj = {
                value: tickValue
            };
            result.push(onlyTick ? tickValue : {
                formattedLabel: labelFormatter(tickObj),
                rawLabel: ordinalScale.getLabel(tickObj),
                tickValue: tickValue
            });
        }
        return result;
    }
    function $b4463a620840f7ae$var$makeLabelsByCustomizedCategoryInterval(axis, categoryInterval, onlyTick) {
        var ordinalScale = axis.scale;
        var labelFormatter = (0, (0, parcelRequire("3GIoT")).makeLabelFormatter)(axis);
        var result = [];
        (0, parcelRequire("bahqM")).each(ordinalScale.getTicks(), function(tick) {
            var rawLabel = ordinalScale.getLabel(tick);
            var tickValue = tick.value;
            if (categoryInterval(tick.value, rawLabel)) result.push(onlyTick ? tickValue : {
                formattedLabel: labelFormatter(tick),
                rawLabel: rawLabel,
                tickValue: tickValue
            });
        });
        return result;
    }
});
parcelRegister("dBIJY", function(module, exports) {
    $parcel$export(module.exports, "layout", ()=>$9e816f987642cbea$export$b3219800bda33a1f);
    $parcel$export(module.exports, "isCartesian2DSeries", ()=>$9e816f987642cbea$export$c2a0b77974c5e35d);
    $parcel$export(module.exports, "findAxisModels", ()=>$9e816f987642cbea$export$8220131ac1d61d28);
    var $bahqM;
    var $eaKsF;
    function $9e816f987642cbea$export$b3219800bda33a1f(gridModel, axisModel, opt) {
        opt = opt || {};
        var grid = gridModel.coordinateSystem;
        var axis = axisModel.axis;
        var layout = {};
        var otherAxisOnZeroOf = axis.getAxesOnZeroOf()[0];
        var rawAxisPosition = axis.position;
        var axisPosition = otherAxisOnZeroOf ? 'onZero' : rawAxisPosition;
        var axisDim = axis.dim;
        var rect = grid.getRect();
        var rectBound = [
            rect.x,
            rect.x + rect.width,
            rect.y,
            rect.y + rect.height
        ];
        var idx = {
            left: 0,
            right: 1,
            top: 0,
            bottom: 1,
            onZero: 2
        };
        var axisOffset = axisModel.get('offset') || 0;
        var posBound = axisDim === 'x' ? [
            rectBound[2] - axisOffset,
            rectBound[3] + axisOffset
        ] : [
            rectBound[0] - axisOffset,
            rectBound[1] + axisOffset
        ];
        if (otherAxisOnZeroOf) {
            var onZeroCoord = otherAxisOnZeroOf.toGlobalCoord(otherAxisOnZeroOf.dataToCoord(0));
            posBound[idx.onZero] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
        }
        layout.position = [
            axisDim === 'y' ? posBound[idx[axisPosition]] : rectBound[0],
            axisDim === 'x' ? posBound[idx[axisPosition]] : rectBound[3]
        ];
        layout.rotation = Math.PI / 2 * (axisDim === 'x' ? 0 : 1);
        var dirMap = {
            top: -1,
            bottom: 1,
            left: -1,
            right: 1
        };
        layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
        layout.labelOffset = otherAxisOnZeroOf ? posBound[idx[rawAxisPosition]] - posBound[idx.onZero] : 0;
        if (axisModel.get([
            'axisTick',
            'inside'
        ])) layout.tickDirection = -layout.tickDirection;
        if ((0, parcelRequire("bahqM")).retrieve(opt.labelInside, axisModel.get([
            'axisLabel',
            'inside'
        ]))) layout.labelDirection = -layout.labelDirection;
        var labelRotate = axisModel.get([
            'axisLabel',
            'rotate'
        ]);
        layout.labelRotate = axisPosition === 'top' ? -labelRotate : labelRotate;
        layout.z2 = 1;
        return layout;
    }
    function $9e816f987642cbea$export$c2a0b77974c5e35d(seriesModel) {
        return seriesModel.get('coordinateSystem') === 'cartesian2d';
    }
    function $9e816f987642cbea$export$8220131ac1d61d28(seriesModel) {
        var axisModelMap = {
            xAxisModel: null,
            yAxisModel: null
        };
        (0, parcelRequire("bahqM")).each(axisModelMap, function(v, key) {
            var axisType = key.replace(/Model$/, '');
            var axisModel = seriesModel.getReferringComponents(axisType, (0, (0, parcelRequire("eaKsF")).SINGLE_REFERRING)).models[0];
            axisModelMap[key] = axisModel;
        });
        return axisModelMap;
    }
});
parcelRegister("2rHnA", function(module, exports) {
    $parcel$export(module.exports, "CartesianXAxisView", ()=>$1c7fc0a7283d68cb$export$b6d40cd875b8a1c8);
    $parcel$export(module.exports, "CartesianYAxisView", ()=>$1c7fc0a7283d68cb$export$417e1bdd0616e0dc);
    var $3VFsf;
    var $bahqM;
    var $4KVOr;
    var $fHITF;
    var $cZb1F;
    var $asa08;
    var $atJL7;
    var $dBIJY;
    var $6dLRi;
    var $1c7fc0a7283d68cb$var$axisBuilderAttrs = [
        'axisLine',
        'axisTickLabel',
        'axisName'
    ];
    var $1c7fc0a7283d68cb$var$selfBuilderAttrs = [
        'splitArea',
        'splitLine',
        'minorSplitLine'
    ];
    var $1c7fc0a7283d68cb$var$CartesianAxisView = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(CartesianAxisView, _super);
        function CartesianAxisView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = CartesianAxisView.type;
            _this.axisPointerClass = 'CartesianAxisPointer';
            return _this;
        }
        CartesianAxisView.prototype.render = function(axisModel, ecModel, api, payload) {
            this.group.removeAll();
            var oldAxisGroup = this._axisGroup;
            this._axisGroup = new (0, parcelRequire("4KVOr")).default();
            this.group.add(this._axisGroup);
            if (!axisModel.get('show')) return;
            var gridModel = axisModel.getCoordSysModel();
            var layout = (0, parcelRequire("dBIJY")).layout(gridModel, axisModel);
            var axisBuilder = new (0, (0, parcelRequire("asa08")).default)(axisModel, (0, parcelRequire("bahqM")).extend({
                handleAutoShown: function(elementType) {
                    var cartesians = gridModel.coordinateSystem.getCartesians();
                    for(var i = 0; i < cartesians.length; i++){
                        var otherAxisType = cartesians[i].getOtherAxis(axisModel.axis).type;
                        if (otherAxisType === 'value' || otherAxisType === 'log') return true;
                    }
                    return false;
                }
            }, layout));
            (0, parcelRequire("bahqM")).each($1c7fc0a7283d68cb$var$axisBuilderAttrs, axisBuilder.add, axisBuilder);
            this._axisGroup.add(axisBuilder.getGroup());
            (0, parcelRequire("bahqM")).each($1c7fc0a7283d68cb$var$selfBuilderAttrs, function(name) {
                if (axisModel.get([
                    name,
                    'show'
                ])) $1c7fc0a7283d68cb$var$axisElementBuilders[name](this, this._axisGroup, axisModel, gridModel);
            }, this);
            var isInitialSortFromBarRacing = payload && payload.type === 'changeAxisOrder' && payload.isInitSort;
            if (!isInitialSortFromBarRacing) (0, parcelRequire("fHITF")).groupTransition(oldAxisGroup, this._axisGroup, axisModel);
            _super.prototype.render.call(this, axisModel, ecModel, api, payload);
        };
        CartesianAxisView.prototype.remove = function() {
            (0, (0, parcelRequire("6dLRi")).rectCoordAxisHandleRemove)(this);
        };
        CartesianAxisView.type = 'cartesianAxis';
        return CartesianAxisView;
    }((0, (0, parcelRequire("atJL7")).default));
    var $1c7fc0a7283d68cb$var$axisElementBuilders = {
        splitLine: function(axisView, axisGroup, axisModel, gridModel) {
            var axis = axisModel.axis;
            if (axis.scale.isBlank()) return;
            var splitLineModel = axisModel.getModel('splitLine');
            var lineStyleModel = splitLineModel.getModel('lineStyle');
            var lineColors = lineStyleModel.get('color');
            lineColors = (0, parcelRequire("bahqM")).isArray(lineColors) ? lineColors : [
                lineColors
            ];
            var gridRect = gridModel.coordinateSystem.getRect();
            var isHorizontal = axis.isHorizontal();
            var lineCount = 0;
            var ticksCoords = axis.getTicksCoords({
                tickModel: splitLineModel
            });
            var p1 = [];
            var p2 = [];
            var lineStyle = lineStyleModel.getLineStyle();
            for(var i = 0; i < ticksCoords.length; i++){
                var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
                if (isHorizontal) {
                    p1[0] = tickCoord;
                    p1[1] = gridRect.y;
                    p2[0] = tickCoord;
                    p2[1] = gridRect.y + gridRect.height;
                } else {
                    p1[0] = gridRect.x;
                    p1[1] = tickCoord;
                    p2[0] = gridRect.x + gridRect.width;
                    p2[1] = tickCoord;
                }
                var colorIndex = lineCount++ % lineColors.length;
                var tickValue = ticksCoords[i].tickValue;
                axisGroup.add(new (0, parcelRequire("cZb1F")).default({
                    anid: tickValue != null ? 'line_' + ticksCoords[i].tickValue : null,
                    subPixelOptimize: true,
                    autoBatch: true,
                    shape: {
                        x1: p1[0],
                        y1: p1[1],
                        x2: p2[0],
                        y2: p2[1]
                    },
                    style: (0, parcelRequire("bahqM")).defaults({
                        stroke: lineColors[colorIndex]
                    }, lineStyle),
                    silent: true
                }));
            }
        },
        minorSplitLine: function(axisView, axisGroup, axisModel, gridModel) {
            var axis = axisModel.axis;
            var minorSplitLineModel = axisModel.getModel('minorSplitLine');
            var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
            var gridRect = gridModel.coordinateSystem.getRect();
            var isHorizontal = axis.isHorizontal();
            var minorTicksCoords = axis.getMinorTicksCoords();
            if (!minorTicksCoords.length) return;
            var p1 = [];
            var p2 = [];
            var lineStyle = lineStyleModel.getLineStyle();
            for(var i = 0; i < minorTicksCoords.length; i++)for(var k = 0; k < minorTicksCoords[i].length; k++){
                var tickCoord = axis.toGlobalCoord(minorTicksCoords[i][k].coord);
                if (isHorizontal) {
                    p1[0] = tickCoord;
                    p1[1] = gridRect.y;
                    p2[0] = tickCoord;
                    p2[1] = gridRect.y + gridRect.height;
                } else {
                    p1[0] = gridRect.x;
                    p1[1] = tickCoord;
                    p2[0] = gridRect.x + gridRect.width;
                    p2[1] = tickCoord;
                }
                axisGroup.add(new (0, parcelRequire("cZb1F")).default({
                    anid: 'minor_line_' + minorTicksCoords[i][k].tickValue,
                    subPixelOptimize: true,
                    autoBatch: true,
                    shape: {
                        x1: p1[0],
                        y1: p1[1],
                        x2: p2[0],
                        y2: p2[1]
                    },
                    style: lineStyle,
                    silent: true
                }));
            }
        },
        splitArea: function(axisView, axisGroup, axisModel, gridModel) {
            (0, (0, parcelRequire("6dLRi")).rectCoordAxisBuildSplitArea)(axisView, axisGroup, axisModel, gridModel);
        }
    };
    var $1c7fc0a7283d68cb$export$b6d40cd875b8a1c8 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(CartesianXAxisView, _super);
        function CartesianXAxisView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = CartesianXAxisView.type;
            return _this;
        }
        CartesianXAxisView.type = 'xAxis';
        return CartesianXAxisView;
    }($1c7fc0a7283d68cb$var$CartesianAxisView);
    var $1c7fc0a7283d68cb$export$417e1bdd0616e0dc = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(CartesianYAxisView, _super);
        function CartesianYAxisView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = $1c7fc0a7283d68cb$export$b6d40cd875b8a1c8.type;
            return _this;
        }
        CartesianYAxisView.type = 'yAxis';
        return CartesianYAxisView;
    }($1c7fc0a7283d68cb$var$CartesianAxisView);
    var $1c7fc0a7283d68cb$export$2e2bcd8739ae039 = $1c7fc0a7283d68cb$var$CartesianAxisView;
});
parcelRegister("asa08", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$79c446f32aef3809$export$2e2bcd8739ae039);
    var $bahqM;
    var $4KVOr;
    parcelRequire("fHITF");
    var $cZb1F;
    var $fHITF;
    var $4gEFv;
    var $7QjoM;
    var $gvLUt;
    var $gaMkj;
    var $jmSNG;
    var $7yklO;
    var $izqgC;
    var $eLEew;
    var $3GIoT;
    var $3LB2b;
    var $79c446f32aef3809$var$PI = Math.PI;
    var $79c446f32aef3809$var$AxisBuilder = function() {
        function AxisBuilder(axisModel, opt) {
            this.group = new (0, parcelRequire("4KVOr")).default();
            this.opt = opt;
            this.axisModel = axisModel;
            (0, (0, parcelRequire("bahqM")).defaults)(opt, {
                labelOffset: 0,
                nameDirection: 1,
                tickDirection: 1,
                labelDirection: 1,
                silent: true,
                handleAutoShown: function() {
                    return true;
                }
            });
            var transformGroup = new (0, parcelRequire("4KVOr")).default({
                x: opt.position[0],
                y: opt.position[1],
                rotation: opt.rotation
            });
            transformGroup.updateTransform();
            this._transformGroup = transformGroup;
        }
        AxisBuilder.prototype.hasBuilder = function(name) {
            return !!$79c446f32aef3809$var$builders[name];
        };
        AxisBuilder.prototype.add = function(name) {
            $79c446f32aef3809$var$builders[name](this.opt, this.axisModel, this.group, this._transformGroup);
        };
        AxisBuilder.prototype.getGroup = function() {
            return this.group;
        };
        AxisBuilder.innerTextLayout = function(axisRotation, textRotation, direction) {
            var rotationDiff = (0, (0, parcelRequire("jmSNG")).remRadian)(textRotation - axisRotation);
            var textAlign;
            var textVerticalAlign;
            if ((0, (0, parcelRequire("jmSNG")).isRadianAroundZero)(rotationDiff)) {
                textVerticalAlign = direction > 0 ? 'top' : 'bottom';
                textAlign = 'center';
            } else if ((0, (0, parcelRequire("jmSNG")).isRadianAroundZero)(rotationDiff - $79c446f32aef3809$var$PI)) {
                textVerticalAlign = direction > 0 ? 'bottom' : 'top';
                textAlign = 'center';
            } else {
                textVerticalAlign = 'middle';
                if (rotationDiff > 0 && rotationDiff < $79c446f32aef3809$var$PI) textAlign = direction > 0 ? 'right' : 'left';
                else textAlign = direction > 0 ? 'left' : 'right';
            }
            return {
                rotation: rotationDiff,
                textAlign: textAlign,
                textVerticalAlign: textVerticalAlign
            };
        };
        AxisBuilder.makeAxisEventDataBase = function(axisModel) {
            var eventData = {
                componentType: axisModel.mainType,
                componentIndex: axisModel.componentIndex
            };
            eventData[axisModel.mainType + 'Index'] = axisModel.componentIndex;
            return eventData;
        };
        AxisBuilder.isLabelSilent = function(axisModel) {
            var tooltipOpt = axisModel.get('tooltip');
            return axisModel.get('silent') || !(axisModel.get('triggerEvent') || tooltipOpt && tooltipOpt.show);
        };
        return AxisBuilder;
    }();
    var $79c446f32aef3809$var$builders = {
        axisLine: function(opt, axisModel, group, transformGroup) {
            var shown = axisModel.get([
                'axisLine',
                'show'
            ]);
            if (shown === 'auto' && opt.handleAutoShown) shown = opt.handleAutoShown('axisLine');
            if (!shown) return;
            var extent = axisModel.axis.getExtent();
            var matrix = transformGroup.transform;
            var pt1 = [
                extent[0],
                0
            ];
            var pt2 = [
                extent[1],
                0
            ];
            if (matrix) {
                (0, (0, parcelRequire("eLEew")).applyTransform)(pt1, pt1, matrix);
                (0, (0, parcelRequire("eLEew")).applyTransform)(pt2, pt2, matrix);
            }
            var lineStyle = (0, (0, parcelRequire("bahqM")).extend)({
                lineCap: 'round'
            }, axisModel.getModel([
                'axisLine',
                'lineStyle'
            ]).getLineStyle());
            var line = new (0, parcelRequire("cZb1F")).default({
                subPixelOptimize: true,
                shape: {
                    x1: pt1[0],
                    y1: pt1[1],
                    x2: pt2[0],
                    y2: pt2[1]
                },
                style: lineStyle,
                strokeContainThreshold: opt.strokeContainThreshold || 5,
                silent: true,
                z2: 1
            });
            line.anid = 'line';
            group.add(line);
            var arrows = axisModel.get([
                'axisLine',
                'symbol'
            ]);
            if (arrows != null) {
                var arrowSize = axisModel.get([
                    'axisLine',
                    'symbolSize'
                ]);
                if (typeof arrows === 'string') arrows = [
                    arrows,
                    arrows
                ];
                if (typeof arrowSize === 'string' || typeof arrowSize === 'number') arrowSize = [
                    arrowSize,
                    arrowSize
                ];
                var arrowOffset = (0, (0, parcelRequire("7yklO")).normalizeSymbolOffset)(axisModel.get([
                    'axisLine',
                    'symbolOffset'
                ]) || 0, arrowSize);
                var symbolWidth_1 = arrowSize[0];
                var symbolHeight_1 = arrowSize[1];
                (0, (0, parcelRequire("bahqM")).each)([
                    {
                        rotate: opt.rotation + Math.PI / 2,
                        offset: arrowOffset[0],
                        r: 0
                    },
                    {
                        rotate: opt.rotation - Math.PI / 2,
                        offset: arrowOffset[1],
                        r: Math.sqrt((pt1[0] - pt2[0]) * (pt1[0] - pt2[0]) + (pt1[1] - pt2[1]) * (pt1[1] - pt2[1]))
                    }
                ], function(point, index) {
                    if (arrows[index] !== 'none' && arrows[index] != null) {
                        var symbol = (0, (0, parcelRequire("7yklO")).createSymbol)(arrows[index], -symbolWidth_1 / 2, -symbolHeight_1 / 2, symbolWidth_1, symbolHeight_1, lineStyle.stroke, true);
                        var r = point.r + point.offset;
                        symbol.attr({
                            rotation: point.rotate,
                            x: pt1[0] + r * Math.cos(opt.rotation),
                            y: pt1[1] - r * Math.sin(opt.rotation),
                            silent: true,
                            z2: 11
                        });
                        group.add(symbol);
                    }
                });
            }
        },
        axisTickLabel: function(opt, axisModel, group, transformGroup) {
            var ticksEls = $79c446f32aef3809$var$buildAxisMajorTicks(group, transformGroup, axisModel, opt);
            var labelEls = $79c446f32aef3809$var$buildAxisLabel(group, transformGroup, axisModel, opt);
            $79c446f32aef3809$var$fixMinMaxLabelShow(axisModel, labelEls, ticksEls);
            $79c446f32aef3809$var$buildAxisMinorTicks(group, transformGroup, axisModel, opt.tickDirection);
            if (axisModel.get([
                'axisLabel',
                'hideOverlap'
            ])) {
                var labelList = (0, (0, parcelRequire("3LB2b")).prepareLayoutList)((0, (0, parcelRequire("bahqM")).map)(labelEls, function(label) {
                    return {
                        label: label,
                        priority: label.z2,
                        defaultAttr: {
                            ignore: label.ignore
                        }
                    };
                }));
                (0, (0, parcelRequire("3LB2b")).hideOverlap)(labelList);
            }
        },
        axisName: function(opt, axisModel, group, transformGroup) {
            var name = (0, (0, parcelRequire("bahqM")).retrieve)(opt.axisName, axisModel.get('name'));
            if (!name) return;
            var nameLocation = axisModel.get('nameLocation');
            var nameDirection = opt.nameDirection;
            var textStyleModel = axisModel.getModel('nameTextStyle');
            var gap = axisModel.get('nameGap') || 0;
            var extent = axisModel.axis.getExtent();
            var gapSignal = extent[0] > extent[1] ? -1 : 1;
            var pos = [
                nameLocation === 'start' ? extent[0] - gapSignal * gap : nameLocation === 'end' ? extent[1] + gapSignal * gap : (extent[0] + extent[1]) / 2,
                $79c446f32aef3809$var$isNameLocationCenter(nameLocation) ? opt.labelOffset + nameDirection * gap : 0
            ];
            var labelLayout;
            var nameRotation = axisModel.get('nameRotate');
            if (nameRotation != null) nameRotation = nameRotation * $79c446f32aef3809$var$PI / 180;
            var axisNameAvailableWidth;
            if ($79c446f32aef3809$var$isNameLocationCenter(nameLocation)) labelLayout = $79c446f32aef3809$var$AxisBuilder.innerTextLayout(opt.rotation, nameRotation != null ? nameRotation : opt.rotation, nameDirection);
            else {
                labelLayout = $79c446f32aef3809$var$endTextLayout(opt.rotation, nameLocation, nameRotation || 0, extent);
                axisNameAvailableWidth = opt.axisNameAvailableWidth;
                if (axisNameAvailableWidth != null) {
                    axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
                    !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
                }
            }
            var textFont = textStyleModel.getFont();
            var truncateOpt = axisModel.get('nameTruncate', true) || {};
            var ellipsis = truncateOpt.ellipsis;
            var maxWidth = (0, (0, parcelRequire("bahqM")).retrieve)(opt.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth);
            var textEl = new (0, parcelRequire("4gEFv")).default({
                x: pos[0],
                y: pos[1],
                rotation: labelLayout.rotation,
                silent: $79c446f32aef3809$var$AxisBuilder.isLabelSilent(axisModel),
                style: (0, (0, parcelRequire("gvLUt")).createTextStyle)(textStyleModel, {
                    text: name,
                    font: textFont,
                    overflow: 'truncate',
                    width: maxWidth,
                    ellipsis: ellipsis,
                    fill: textStyleModel.getTextColor() || axisModel.get([
                        'axisLine',
                        'lineStyle',
                        'color'
                    ]),
                    align: textStyleModel.get('align') || labelLayout.textAlign,
                    verticalAlign: textStyleModel.get('verticalAlign') || labelLayout.textVerticalAlign
                }),
                z2: 1
            });
            (0, parcelRequire("fHITF")).setTooltipConfig({
                el: textEl,
                componentModel: axisModel,
                itemName: name
            });
            textEl.__fullText = name;
            textEl.anid = 'name';
            if (axisModel.get('triggerEvent')) {
                var eventData = $79c446f32aef3809$var$AxisBuilder.makeAxisEventDataBase(axisModel);
                eventData.targetType = 'axisName';
                eventData.name = name;
                (0, (0, parcelRequire("7QjoM")).getECData)(textEl).eventData = eventData;
            }
            transformGroup.add(textEl);
            textEl.updateTransform();
            group.add(textEl);
            textEl.decomposeTransform();
        }
    };
    function $79c446f32aef3809$var$endTextLayout(rotation, textPosition, textRotate, extent) {
        var rotationDiff = (0, (0, parcelRequire("jmSNG")).remRadian)(textRotate - rotation);
        var textAlign;
        var textVerticalAlign;
        var inverse = extent[0] > extent[1];
        var onLeft = textPosition === 'start' && !inverse || textPosition !== 'start' && inverse;
        if ((0, (0, parcelRequire("jmSNG")).isRadianAroundZero)(rotationDiff - $79c446f32aef3809$var$PI / 2)) {
            textVerticalAlign = onLeft ? 'bottom' : 'top';
            textAlign = 'center';
        } else if ((0, (0, parcelRequire("jmSNG")).isRadianAroundZero)(rotationDiff - $79c446f32aef3809$var$PI * 1.5)) {
            textVerticalAlign = onLeft ? 'top' : 'bottom';
            textAlign = 'center';
        } else {
            textVerticalAlign = 'middle';
            if (rotationDiff < $79c446f32aef3809$var$PI * 1.5 && rotationDiff > $79c446f32aef3809$var$PI / 2) textAlign = onLeft ? 'left' : 'right';
            else textAlign = onLeft ? 'right' : 'left';
        }
        return {
            rotation: rotationDiff,
            textAlign: textAlign,
            textVerticalAlign: textVerticalAlign
        };
    }
    function $79c446f32aef3809$var$fixMinMaxLabelShow(axisModel, labelEls, tickEls) {
        if ((0, (0, parcelRequire("3GIoT")).shouldShowAllLabels)(axisModel.axis)) return;
        var showMinLabel = axisModel.get([
            'axisLabel',
            'showMinLabel'
        ]);
        var showMaxLabel = axisModel.get([
            'axisLabel',
            'showMaxLabel'
        ]);
        labelEls = labelEls || [];
        tickEls = tickEls || [];
        var firstLabel = labelEls[0];
        var nextLabel = labelEls[1];
        var lastLabel = labelEls[labelEls.length - 1];
        var prevLabel = labelEls[labelEls.length - 2];
        var firstTick = tickEls[0];
        var nextTick = tickEls[1];
        var lastTick = tickEls[tickEls.length - 1];
        var prevTick = tickEls[tickEls.length - 2];
        if (showMinLabel === false) {
            $79c446f32aef3809$var$ignoreEl(firstLabel);
            $79c446f32aef3809$var$ignoreEl(firstTick);
        } else if ($79c446f32aef3809$var$isTwoLabelOverlapped(firstLabel, nextLabel)) {
            if (showMinLabel) {
                $79c446f32aef3809$var$ignoreEl(nextLabel);
                $79c446f32aef3809$var$ignoreEl(nextTick);
            } else {
                $79c446f32aef3809$var$ignoreEl(firstLabel);
                $79c446f32aef3809$var$ignoreEl(firstTick);
            }
        }
        if (showMaxLabel === false) {
            $79c446f32aef3809$var$ignoreEl(lastLabel);
            $79c446f32aef3809$var$ignoreEl(lastTick);
        } else if ($79c446f32aef3809$var$isTwoLabelOverlapped(prevLabel, lastLabel)) {
            if (showMaxLabel) {
                $79c446f32aef3809$var$ignoreEl(prevLabel);
                $79c446f32aef3809$var$ignoreEl(prevTick);
            } else {
                $79c446f32aef3809$var$ignoreEl(lastLabel);
                $79c446f32aef3809$var$ignoreEl(lastTick);
            }
        }
    }
    function $79c446f32aef3809$var$ignoreEl(el) {
        el && (el.ignore = true);
    }
    function $79c446f32aef3809$var$isTwoLabelOverlapped(current, next) {
        var firstRect = current && current.getBoundingRect().clone();
        var nextRect = next && next.getBoundingRect().clone();
        if (!firstRect || !nextRect) return;
        var mRotationBack = (0, parcelRequire("izqgC")).identity([]);
        (0, parcelRequire("izqgC")).rotate(mRotationBack, mRotationBack, -current.rotation);
        firstRect.applyTransform((0, parcelRequire("izqgC")).mul([], mRotationBack, current.getLocalTransform()));
        nextRect.applyTransform((0, parcelRequire("izqgC")).mul([], mRotationBack, next.getLocalTransform()));
        return firstRect.intersect(nextRect);
    }
    function $79c446f32aef3809$var$isNameLocationCenter(nameLocation) {
        return nameLocation === 'middle' || nameLocation === 'center';
    }
    function $79c446f32aef3809$var$createTicks(ticksCoords, tickTransform, tickEndCoord, tickLineStyle, anidPrefix) {
        var tickEls = [];
        var pt1 = [];
        var pt2 = [];
        for(var i = 0; i < ticksCoords.length; i++){
            var tickCoord = ticksCoords[i].coord;
            pt1[0] = tickCoord;
            pt1[1] = 0;
            pt2[0] = tickCoord;
            pt2[1] = tickEndCoord;
            if (tickTransform) {
                (0, (0, parcelRequire("eLEew")).applyTransform)(pt1, pt1, tickTransform);
                (0, (0, parcelRequire("eLEew")).applyTransform)(pt2, pt2, tickTransform);
            }
            var tickEl = new (0, parcelRequire("cZb1F")).default({
                subPixelOptimize: true,
                shape: {
                    x1: pt1[0],
                    y1: pt1[1],
                    x2: pt2[0],
                    y2: pt2[1]
                },
                style: tickLineStyle,
                z2: 2,
                autoBatch: true,
                silent: true
            });
            tickEl.anid = anidPrefix + '_' + ticksCoords[i].tickValue;
            tickEls.push(tickEl);
        }
        return tickEls;
    }
    function $79c446f32aef3809$var$buildAxisMajorTicks(group, transformGroup, axisModel, opt) {
        var axis = axisModel.axis;
        var tickModel = axisModel.getModel('axisTick');
        var shown = tickModel.get('show');
        if (shown === 'auto' && opt.handleAutoShown) shown = opt.handleAutoShown('axisTick');
        if (!shown || axis.scale.isBlank()) return;
        var lineStyleModel = tickModel.getModel('lineStyle');
        var tickEndCoord = opt.tickDirection * tickModel.get('length');
        var ticksCoords = axis.getTicksCoords();
        var ticksEls = $79c446f32aef3809$var$createTicks(ticksCoords, transformGroup.transform, tickEndCoord, (0, (0, parcelRequire("bahqM")).defaults)(lineStyleModel.getLineStyle(), {
            stroke: axisModel.get([
                'axisLine',
                'lineStyle',
                'color'
            ])
        }), 'ticks');
        for(var i = 0; i < ticksEls.length; i++)group.add(ticksEls[i]);
        return ticksEls;
    }
    function $79c446f32aef3809$var$buildAxisMinorTicks(group, transformGroup, axisModel, tickDirection) {
        var axis = axisModel.axis;
        var minorTickModel = axisModel.getModel('minorTick');
        if (!minorTickModel.get('show') || axis.scale.isBlank()) return;
        var minorTicksCoords = axis.getMinorTicksCoords();
        if (!minorTicksCoords.length) return;
        var lineStyleModel = minorTickModel.getModel('lineStyle');
        var tickEndCoord = tickDirection * minorTickModel.get('length');
        var minorTickLineStyle = (0, (0, parcelRequire("bahqM")).defaults)(lineStyleModel.getLineStyle(), (0, (0, parcelRequire("bahqM")).defaults)(axisModel.getModel('axisTick').getLineStyle(), {
            stroke: axisModel.get([
                'axisLine',
                'lineStyle',
                'color'
            ])
        }));
        for(var i = 0; i < minorTicksCoords.length; i++){
            var minorTicksEls = $79c446f32aef3809$var$createTicks(minorTicksCoords[i], transformGroup.transform, tickEndCoord, minorTickLineStyle, 'minorticks_' + i);
            for(var k = 0; k < minorTicksEls.length; k++)group.add(minorTicksEls[k]);
        }
    }
    function $79c446f32aef3809$var$buildAxisLabel(group, transformGroup, axisModel, opt) {
        var axis = axisModel.axis;
        var show = (0, (0, parcelRequire("bahqM")).retrieve)(opt.axisLabelShow, axisModel.get([
            'axisLabel',
            'show'
        ]));
        if (!show || axis.scale.isBlank()) return;
        var labelModel = axisModel.getModel('axisLabel');
        var labelMargin = labelModel.get('margin');
        var labels = axis.getViewLabels();
        var labelRotation = ((0, (0, parcelRequire("bahqM")).retrieve)(opt.labelRotate, labelModel.get('rotate')) || 0) * $79c446f32aef3809$var$PI / 180;
        var labelLayout = $79c446f32aef3809$var$AxisBuilder.innerTextLayout(opt.rotation, labelRotation, opt.labelDirection);
        var rawCategoryData = axisModel.getCategories && axisModel.getCategories(true);
        var labelEls = [];
        var silent = $79c446f32aef3809$var$AxisBuilder.isLabelSilent(axisModel);
        var triggerEvent = axisModel.get('triggerEvent');
        (0, (0, parcelRequire("bahqM")).each)(labels, function(labelItem, index) {
            var tickValue = axis.scale.type === 'ordinal' ? axis.scale.getRawOrdinalNumber(labelItem.tickValue) : labelItem.tickValue;
            var formattedLabel = labelItem.formattedLabel;
            var rawLabel = labelItem.rawLabel;
            var itemLabelModel = labelModel;
            if (rawCategoryData && rawCategoryData[tickValue]) {
                var rawCategoryItem = rawCategoryData[tickValue];
                if ((0, (0, parcelRequire("bahqM")).isObject)(rawCategoryItem) && rawCategoryItem.textStyle) itemLabelModel = new (0, (0, parcelRequire("gaMkj")).default)(rawCategoryItem.textStyle, labelModel, axisModel.ecModel);
            }
            var textColor = itemLabelModel.getTextColor() || axisModel.get([
                'axisLine',
                'lineStyle',
                'color'
            ]);
            var tickCoord = axis.dataToCoord(tickValue);
            var textEl = new (0, parcelRequire("4gEFv")).default({
                x: tickCoord,
                y: opt.labelOffset + opt.labelDirection * labelMargin,
                rotation: labelLayout.rotation,
                silent: silent,
                z2: 10 + (labelItem.level || 0),
                style: (0, (0, parcelRequire("gvLUt")).createTextStyle)(itemLabelModel, {
                    text: formattedLabel,
                    align: itemLabelModel.getShallow('align', true) || labelLayout.textAlign,
                    verticalAlign: itemLabelModel.getShallow('verticalAlign', true) || itemLabelModel.getShallow('baseline', true) || labelLayout.textVerticalAlign,
                    fill: typeof textColor === 'function' ? textColor(axis.type === 'category' ? rawLabel : axis.type === 'value' ? tickValue + '' : tickValue, index) : textColor
                })
            });
            textEl.anid = 'label_' + tickValue;
            if (triggerEvent) {
                var eventData = $79c446f32aef3809$var$AxisBuilder.makeAxisEventDataBase(axisModel);
                eventData.targetType = 'axisLabel';
                eventData.value = rawLabel;
                (0, (0, parcelRequire("7QjoM")).getECData)(textEl).eventData = eventData;
            }
            transformGroup.add(textEl);
            textEl.updateTransform();
            labelEls.push(textEl);
            group.add(textEl);
            textEl.decomposeTransform();
        });
        return labelEls;
    }
    var $79c446f32aef3809$export$2e2bcd8739ae039 = $79c446f32aef3809$var$AxisBuilder;
});
parcelRegister("7yklO", function(module, exports) {
    $parcel$export(module.exports, "symbolBuildProxies", ()=>$57fb7e9c020cd915$export$33fc3b478d332725);
    $parcel$export(module.exports, "createSymbol", ()=>$57fb7e9c020cd915$export$af050e04da3a02e8);
    $parcel$export(module.exports, "normalizeSymbolSize", ()=>$57fb7e9c020cd915$export$a84524f03e8e8dfb);
    $parcel$export(module.exports, "normalizeSymbolOffset", ()=>$57fb7e9c020cd915$export$e3e292895c033f6d);
    var $bahqM;
    parcelRequire("fHITF");
    var $jjfok;
    var $cZb1F;
    var $fHITF;
    var $ghQ8v;
    var $7Tw7u;
    var $1E3E8;
    var $b7ZX8;
    var $jmSNG;
    var $57fb7e9c020cd915$var$Triangle = (0, parcelRequire("ghQ8v")).default.extend({
        type: 'triangle',
        shape: {
            cx: 0,
            cy: 0,
            width: 0,
            height: 0
        },
        buildPath: function(path, shape) {
            var cx = shape.cx;
            var cy = shape.cy;
            var width = shape.width / 2;
            var height = shape.height / 2;
            path.moveTo(cx, cy - height);
            path.lineTo(cx + width, cy + height);
            path.lineTo(cx - width, cy + height);
            path.closePath();
        }
    });
    var $57fb7e9c020cd915$var$Diamond = (0, parcelRequire("ghQ8v")).default.extend({
        type: 'diamond',
        shape: {
            cx: 0,
            cy: 0,
            width: 0,
            height: 0
        },
        buildPath: function(path, shape) {
            var cx = shape.cx;
            var cy = shape.cy;
            var width = shape.width / 2;
            var height = shape.height / 2;
            path.moveTo(cx, cy - height);
            path.lineTo(cx + width, cy);
            path.lineTo(cx, cy + height);
            path.lineTo(cx - width, cy);
            path.closePath();
        }
    });
    var $57fb7e9c020cd915$var$Pin = (0, parcelRequire("ghQ8v")).default.extend({
        type: 'pin',
        shape: {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        },
        buildPath: function(path, shape) {
            var x = shape.x;
            var y = shape.y;
            var w = shape.width / 5 * 3;
            var h = Math.max(w, shape.height);
            var r = w / 2;
            var dy = r * r / (h - r);
            var cy = y - h + r + dy;
            var angle = Math.asin(dy / r);
            var dx = Math.cos(angle) * r;
            var tanX = Math.sin(angle);
            var tanY = Math.cos(angle);
            var cpLen = r * 0.6;
            var cpLen2 = r * 0.7;
            path.moveTo(x - dx, cy + dy);
            path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
            path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
            path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
            path.closePath();
        }
    });
    var $57fb7e9c020cd915$var$Arrow = (0, parcelRequire("ghQ8v")).default.extend({
        type: 'arrow',
        shape: {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        },
        buildPath: function(ctx, shape) {
            var height = shape.height;
            var width = shape.width;
            var x = shape.x;
            var y = shape.y;
            var dx = width / 3 * 2;
            ctx.moveTo(x, y);
            ctx.lineTo(x + dx, y + height);
            ctx.lineTo(x, y + height / 4 * 3);
            ctx.lineTo(x - dx, y + height);
            ctx.lineTo(x, y);
            ctx.closePath();
        }
    });
    var $57fb7e9c020cd915$var$symbolCtors = {
        line: (0, parcelRequire("cZb1F")).default,
        rect: (0, parcelRequire("7Tw7u")).default,
        roundRect: (0, parcelRequire("7Tw7u")).default,
        square: (0, parcelRequire("7Tw7u")).default,
        circle: (0, parcelRequire("jjfok")).default,
        diamond: $57fb7e9c020cd915$var$Diamond,
        pin: $57fb7e9c020cd915$var$Pin,
        arrow: $57fb7e9c020cd915$var$Arrow,
        triangle: $57fb7e9c020cd915$var$Triangle
    };
    var $57fb7e9c020cd915$var$symbolShapeMakers = {
        line: function(x, y, w, h, shape) {
            shape.x1 = x;
            shape.y1 = y + h / 2;
            shape.x2 = x + w;
            shape.y2 = y + h / 2;
        },
        rect: function(x, y, w, h, shape) {
            shape.x = x;
            shape.y = y;
            shape.width = w;
            shape.height = h;
        },
        roundRect: function(x, y, w, h, shape) {
            shape.x = x;
            shape.y = y;
            shape.width = w;
            shape.height = h;
            shape.r = Math.min(w, h) / 4;
        },
        square: function(x, y, w, h, shape) {
            var size = Math.min(w, h);
            shape.x = x;
            shape.y = y;
            shape.width = size;
            shape.height = size;
        },
        circle: function(x, y, w, h, shape) {
            shape.cx = x + w / 2;
            shape.cy = y + h / 2;
            shape.r = Math.min(w, h) / 2;
        },
        diamond: function(x, y, w, h, shape) {
            shape.cx = x + w / 2;
            shape.cy = y + h / 2;
            shape.width = w;
            shape.height = h;
        },
        pin: function(x, y, w, h, shape) {
            shape.x = x + w / 2;
            shape.y = y + h / 2;
            shape.width = w;
            shape.height = h;
        },
        arrow: function(x, y, w, h, shape) {
            shape.x = x + w / 2;
            shape.y = y + h / 2;
            shape.width = w;
            shape.height = h;
        },
        triangle: function(x, y, w, h, shape) {
            shape.cx = x + w / 2;
            shape.cy = y + h / 2;
            shape.width = w;
            shape.height = h;
        }
    };
    var $57fb7e9c020cd915$export$33fc3b478d332725 = {};
    (0, (0, parcelRequire("bahqM")).each)($57fb7e9c020cd915$var$symbolCtors, function(Ctor, name) {
        $57fb7e9c020cd915$export$33fc3b478d332725[name] = new Ctor();
    });
    var $57fb7e9c020cd915$var$SymbolClz = (0, parcelRequire("ghQ8v")).default.extend({
        type: 'symbol',
        shape: {
            symbolType: '',
            x: 0,
            y: 0,
            width: 0,
            height: 0
        },
        calculateTextPosition: function(out, config, rect) {
            var res = (0, (0, parcelRequire("b7ZX8")).calculateTextPosition)(out, config, rect);
            var shape = this.shape;
            if (shape && shape.symbolType === 'pin' && config.position === 'inside') res.y = rect.y + rect.height * 0.4;
            return res;
        },
        buildPath: function(ctx, shape, inBundle) {
            var symbolType = shape.symbolType;
            if (symbolType !== 'none') {
                var proxySymbol = $57fb7e9c020cd915$export$33fc3b478d332725[symbolType];
                if (!proxySymbol) {
                    symbolType = 'rect';
                    proxySymbol = $57fb7e9c020cd915$export$33fc3b478d332725[symbolType];
                }
                $57fb7e9c020cd915$var$symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
                proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
            }
        }
    });
    function $57fb7e9c020cd915$var$symbolPathSetColor(color, innerColor) {
        if (this.type !== 'image') {
            var symbolStyle = this.style;
            if (this.__isEmptyBrush) {
                symbolStyle.stroke = color;
                symbolStyle.fill = innerColor || '#fff';
                symbolStyle.lineWidth = 2;
            } else if (this.shape.symbolType === 'line') symbolStyle.stroke = color;
            else symbolStyle.fill = color;
            this.markRedraw();
        }
    }
    function $57fb7e9c020cd915$export$af050e04da3a02e8(symbolType, x, y, w, h, color, keepAspect) {
        var isEmpty = symbolType.indexOf('empty') === 0;
        if (isEmpty) symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
        var symbolPath;
        if (symbolType.indexOf('image://') === 0) symbolPath = (0, parcelRequire("fHITF")).makeImage(symbolType.slice(8), new (0, (0, parcelRequire("1E3E8")).default)(x, y, w, h), keepAspect ? 'center' : 'cover');
        else if (symbolType.indexOf('path://') === 0) symbolPath = (0, parcelRequire("fHITF")).makePath(symbolType.slice(7), {}, new (0, (0, parcelRequire("1E3E8")).default)(x, y, w, h), keepAspect ? 'center' : 'cover');
        else symbolPath = new $57fb7e9c020cd915$var$SymbolClz({
            shape: {
                symbolType: symbolType,
                x: x,
                y: y,
                width: w,
                height: h
            }
        });
        symbolPath.__isEmptyBrush = isEmpty;
        symbolPath.setColor = $57fb7e9c020cd915$var$symbolPathSetColor;
        if (color) symbolPath.setColor(color);
        return symbolPath;
    }
    function $57fb7e9c020cd915$export$a84524f03e8e8dfb(symbolSize) {
        if (!(0, (0, parcelRequire("bahqM")).isArray)(symbolSize)) symbolSize = [
            +symbolSize,
            +symbolSize
        ];
        return [
            symbolSize[0] || 0,
            symbolSize[1] || 0
        ];
    }
    function $57fb7e9c020cd915$export$e3e292895c033f6d(symbolOffset, symbolSize) {
        if (symbolOffset == null) return;
        if (!(0, (0, parcelRequire("bahqM")).isArray)(symbolOffset)) symbolOffset = [
            symbolOffset,
            symbolOffset
        ];
        return [
            (0, (0, parcelRequire("jmSNG")).parsePercent)(symbolOffset[0], symbolSize[0]) || 0,
            (0, (0, parcelRequire("jmSNG")).parsePercent)((0, (0, parcelRequire("bahqM")).retrieve2)(symbolOffset[1], symbolOffset[0]), symbolSize[1]) || 0
        ];
    }
});
parcelRegister("3LB2b", function(module, exports) {
    $parcel$export(module.exports, "prepareLayoutList", ()=>$2be27d213439fed1$export$6c403cad1ae3e239);
    $parcel$export(module.exports, "shiftLayoutOnX", ()=>$2be27d213439fed1$export$b6b2b07f8ed32bd6);
    $parcel$export(module.exports, "shiftLayoutOnY", ()=>$2be27d213439fed1$export$118c25e0932528e4);
    $parcel$export(module.exports, "hideOverlap", ()=>$2be27d213439fed1$export$8ce774e164a49410);
    var $1E3E8;
    var $lM5Gp;
    function $2be27d213439fed1$export$6c403cad1ae3e239(input) {
        var list = [];
        for(var i = 0; i < input.length; i++){
            var rawItem = input[i];
            if (rawItem.defaultAttr.ignore) continue;
            var label = rawItem.label;
            var transform = label.getComputedTransform();
            var localRect = label.getBoundingRect();
            var isAxisAligned = !transform || transform[1] < 1e-5 && transform[2] < 1e-5;
            var minMargin = label.style.margin || 0;
            var globalRect = localRect.clone();
            globalRect.applyTransform(transform);
            globalRect.x -= minMargin / 2;
            globalRect.y -= minMargin / 2;
            globalRect.width += minMargin;
            globalRect.height += minMargin;
            var obb = isAxisAligned ? new (0, (0, parcelRequire("lM5Gp")).default)(localRect, transform) : null;
            list.push({
                label: label,
                labelLine: rawItem.labelLine,
                rect: globalRect,
                localRect: localRect,
                obb: obb,
                priority: rawItem.priority,
                defaultAttr: rawItem.defaultAttr,
                layoutOption: rawItem.computedLayoutOption,
                axisAligned: isAxisAligned,
                transform: transform
            });
        }
        return list;
    }
    function $2be27d213439fed1$var$shiftLayout(list, xyDim, sizeDim, minBound, maxBound, balanceShift) {
        var len = list.length;
        if (len < 2) return;
        list.sort(function(a, b) {
            return a.rect[xyDim] - b.rect[xyDim];
        });
        var lastPos = 0;
        var delta;
        var adjusted = false;
        var shifts = [];
        var totalShifts = 0;
        for(var i = 0; i < len; i++){
            var item = list[i];
            var rect = item.rect;
            delta = rect[xyDim] - lastPos;
            if (delta < 0) {
                rect[xyDim] -= delta;
                item.label[xyDim] -= delta;
                adjusted = true;
            }
            var shift = Math.max(-delta, 0);
            shifts.push(shift);
            totalShifts += shift;
            lastPos = rect[xyDim] + rect[sizeDim];
        }
        if (totalShifts > 0 && balanceShift) shiftList(-totalShifts / len, 0, len);
        var first = list[0];
        var last = list[len - 1];
        var minGap;
        var maxGap;
        updateMinMaxGap();
        minGap < 0 && squeezeGaps(-minGap, 0.8);
        maxGap < 0 && squeezeGaps(maxGap, 0.8);
        updateMinMaxGap();
        takeBoundsGap(minGap, maxGap, 1);
        takeBoundsGap(maxGap, minGap, -1);
        updateMinMaxGap();
        if (minGap < 0) squeezeWhenBailout(-minGap);
        if (maxGap < 0) squeezeWhenBailout(maxGap);
        function updateMinMaxGap() {
            minGap = first.rect[xyDim] - minBound;
            maxGap = maxBound - last.rect[xyDim] - last.rect[sizeDim];
        }
        function takeBoundsGap(gapThisBound, gapOtherBound, moveDir) {
            if (gapThisBound < 0) {
                var moveFromMaxGap = Math.min(gapOtherBound, -gapThisBound);
                if (moveFromMaxGap > 0) {
                    shiftList(moveFromMaxGap * moveDir, 0, len);
                    var remained = moveFromMaxGap + gapThisBound;
                    if (remained < 0) squeezeGaps(-remained * moveDir, 1);
                } else squeezeGaps(-gapThisBound * moveDir, 1);
            }
        }
        function shiftList(delta, start, end) {
            if (delta !== 0) adjusted = true;
            for(var i = start; i < end; i++){
                var item = list[i];
                var rect = item.rect;
                rect[xyDim] += delta;
                item.label[xyDim] += delta;
            }
        }
        function squeezeGaps(delta, maxSqeezePercent) {
            var gaps = [];
            var totalGaps = 0;
            for(var i = 1; i < len; i++){
                var prevItemRect = list[i - 1].rect;
                var gap = Math.max(list[i].rect[xyDim] - prevItemRect[xyDim] - prevItemRect[sizeDim], 0);
                gaps.push(gap);
                totalGaps += gap;
            }
            if (!totalGaps) return;
            var squeezePercent = Math.min(Math.abs(delta) / totalGaps, maxSqeezePercent);
            if (delta > 0) for(var i = 0; i < len - 1; i++){
                var movement = gaps[i] * squeezePercent;
                shiftList(movement, 0, i + 1);
            }
            else for(var i = len - 1; i > 0; i--){
                var movement = gaps[i - 1] * squeezePercent;
                shiftList(-movement, i, len);
            }
        }
        function squeezeWhenBailout(delta) {
            var dir = delta < 0 ? -1 : 1;
            delta = Math.abs(delta);
            var moveForEachLabel = Math.ceil(delta / (len - 1));
            for(var i = 0; i < len - 1; i++){
                if (dir > 0) shiftList(moveForEachLabel, 0, i + 1);
                else shiftList(-moveForEachLabel, len - i - 1, len);
                delta -= moveForEachLabel;
                if (delta <= 0) return;
            }
        }
        return adjusted;
    }
    function $2be27d213439fed1$export$b6b2b07f8ed32bd6(list, leftBound, rightBound, balanceShift) {
        return $2be27d213439fed1$var$shiftLayout(list, 'x', 'width', leftBound, rightBound, balanceShift);
    }
    function $2be27d213439fed1$export$118c25e0932528e4(list, topBound, bottomBound, balanceShift) {
        return $2be27d213439fed1$var$shiftLayout(list, 'y', 'height', topBound, bottomBound, balanceShift);
    }
    function $2be27d213439fed1$export$8ce774e164a49410(labelList) {
        var displayedLabels = [];
        labelList.sort(function(a, b) {
            return b.priority - a.priority;
        });
        var globalRect = new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0);
        function hideEl(el) {
            if (!el.ignore) {
                var emphasisState = el.ensureState('emphasis');
                if (emphasisState.ignore == null) emphasisState.ignore = false;
            }
            el.ignore = true;
        }
        for(var i = 0; i < labelList.length; i++){
            var labelItem = labelList[i];
            var isAxisAligned = labelItem.axisAligned;
            var localRect = labelItem.localRect;
            var transform = labelItem.transform;
            var label = labelItem.label;
            var labelLine = labelItem.labelLine;
            globalRect.copy(labelItem.rect);
            globalRect.width -= 0.1;
            globalRect.height -= 0.1;
            globalRect.x += 0.05;
            globalRect.y += 0.05;
            var obb = labelItem.obb;
            var overlapped = false;
            for(var j = 0; j < displayedLabels.length; j++){
                var existsTextCfg = displayedLabels[j];
                if (!globalRect.intersect(existsTextCfg.rect)) continue;
                if (isAxisAligned && existsTextCfg.axisAligned) {
                    overlapped = true;
                    break;
                }
                if (!existsTextCfg.obb) existsTextCfg.obb = new (0, (0, parcelRequire("lM5Gp")).default)(existsTextCfg.localRect, existsTextCfg.transform);
                if (!obb) obb = new (0, (0, parcelRequire("lM5Gp")).default)(localRect, transform);
                if (obb.intersect(existsTextCfg.obb)) {
                    overlapped = true;
                    break;
                }
            }
            if (overlapped) {
                hideEl(label);
                labelLine && hideEl(labelLine);
            } else {
                label.attr('ignore', labelItem.defaultAttr.ignore);
                labelLine && labelLine.attr('ignore', labelItem.defaultAttr.labelGuideIgnore);
                displayedLabels.push(labelItem);
            }
        }
    }
});
parcelRegister("atJL7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7a101b97b7710a5f$export$2e2bcd8739ae039);
    var $3VFsf;
    var $8QSpd;
    var $fkskt;
    var $7a101b97b7710a5f$var$axisPointerClazz = {};
    var $7a101b97b7710a5f$var$AxisView = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(AxisView, _super);
        function AxisView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = AxisView.type;
            return _this;
        }
        AxisView.prototype.render = function(axisModel, ecModel, api, payload) {
            this.axisPointerClass && (0, parcelRequire("8QSpd")).fixValue(axisModel);
            _super.prototype.render.apply(this, arguments);
            this._doUpdateAxisPointerClass(axisModel, api, true);
        };
        AxisView.prototype.updateAxisPointer = function(axisModel, ecModel, api, payload) {
            this._doUpdateAxisPointerClass(axisModel, api, false);
        };
        AxisView.prototype.remove = function(ecModel, api) {
            var axisPointer = this._axisPointer;
            axisPointer && axisPointer.remove(api);
        };
        AxisView.prototype.dispose = function(ecModel, api) {
            this._disposeAxisPointer(api);
            _super.prototype.dispose.apply(this, arguments);
        };
        AxisView.prototype._doUpdateAxisPointerClass = function(axisModel, api, forceRender) {
            var Clazz = AxisView.getAxisPointerClass(this.axisPointerClass);
            if (!Clazz) return;
            var axisPointerModel = (0, parcelRequire("8QSpd")).getAxisPointerModel(axisModel);
            axisPointerModel ? (this._axisPointer || (this._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : this._disposeAxisPointer(api);
        };
        AxisView.prototype._disposeAxisPointer = function(api) {
            this._axisPointer && this._axisPointer.dispose(api);
            this._axisPointer = null;
        };
        AxisView.registerAxisPointerClass = function(type, clazz) {
            $7a101b97b7710a5f$var$axisPointerClazz[type] = clazz;
        };
        AxisView.getAxisPointerClass = function(type) {
            return type && $7a101b97b7710a5f$var$axisPointerClazz[type];
        };
        AxisView.type = 'axis';
        return AxisView;
    }((0, (0, parcelRequire("fkskt")).default));
    var $7a101b97b7710a5f$export$2e2bcd8739ae039 = $7a101b97b7710a5f$var$AxisView;
});
parcelRegister("8QSpd", function(module, exports) {
    $parcel$export(module.exports, "collect", ()=>$671d61e645e8595c$export$bb44f104e3c54dae);
    $parcel$export(module.exports, "makeKey", ()=>$671d61e645e8595c$export$d01b444bafb1a792);
    $parcel$export(module.exports, "fixValue", ()=>$671d61e645e8595c$export$f5ea32e3629d8043);
    $parcel$export(module.exports, "getAxisInfo", ()=>$671d61e645e8595c$export$bd39458db76002ab);
    $parcel$export(module.exports, "getAxisPointerModel", ()=>$671d61e645e8595c$export$3b06fce3f68b734);
    var $gaMkj;
    var $bahqM;
    function $671d61e645e8595c$export$bb44f104e3c54dae(ecModel, api) {
        var result = {
            axesInfo: {},
            seriesInvolved: false,
            coordSysAxesInfo: {},
            coordSysMap: {}
        };
        $671d61e645e8595c$var$collectAxesInfo(result, ecModel, api);
        result.seriesInvolved && $671d61e645e8595c$var$collectSeriesInfo(result, ecModel);
        return result;
    }
    function $671d61e645e8595c$var$collectAxesInfo(result, ecModel, api) {
        var globalTooltipModel = ecModel.getComponent('tooltip');
        var globalAxisPointerModel = ecModel.getComponent('axisPointer');
        var linksOption = globalAxisPointerModel.get('link', true) || [];
        var linkGroups = [];
        (0, (0, parcelRequire("bahqM")).each)(api.getCoordinateSystems(), function(coordSys) {
            if (!coordSys.axisPointerEnabled) return;
            var coordSysKey = $671d61e645e8595c$export$d01b444bafb1a792(coordSys.model);
            var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
            result.coordSysMap[coordSysKey] = coordSys;
            var coordSysModel = coordSys.model;
            var baseTooltipModel = coordSysModel.getModel('tooltip', globalTooltipModel);
            (0, (0, parcelRequire("bahqM")).each)(coordSys.getAxes(), (0, (0, parcelRequire("bahqM")).curry)(saveTooltipAxisInfo, false, null));
            if (coordSys.getTooltipAxes && globalTooltipModel && baseTooltipModel.get('show')) {
                var triggerAxis = baseTooltipModel.get('trigger') === 'axis';
                var cross = baseTooltipModel.get([
                    'axisPointer',
                    'type'
                ]) === 'cross';
                var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get([
                    'axisPointer',
                    'axis'
                ]));
                if (triggerAxis || cross) (0, (0, parcelRequire("bahqM")).each)(tooltipAxes.baseAxes, (0, (0, parcelRequire("bahqM")).curry)(saveTooltipAxisInfo, cross ? 'cross' : true, triggerAxis));
                if (cross) (0, (0, parcelRequire("bahqM")).each)(tooltipAxes.otherAxes, (0, (0, parcelRequire("bahqM")).curry)(saveTooltipAxisInfo, 'cross', false));
            }
            function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
                var axisPointerModel = axis.model.getModel('axisPointer', globalAxisPointerModel);
                var axisPointerShow = axisPointerModel.get('show');
                if (!axisPointerShow || axisPointerShow === 'auto' && !fromTooltip && !$671d61e645e8595c$var$isHandleTrigger(axisPointerModel)) return;
                if (triggerTooltip == null) triggerTooltip = axisPointerModel.get('triggerTooltip');
                axisPointerModel = fromTooltip ? $671d61e645e8595c$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
                var snap = axisPointerModel.get('snap');
                var axisKey = $671d61e645e8595c$export$d01b444bafb1a792(axis.model);
                var involveSeries = triggerTooltip || snap || axis.type === 'category';
                var axisInfo = result.axesInfo[axisKey] = {
                    key: axisKey,
                    axis: axis,
                    coordSys: coordSys,
                    axisPointerModel: axisPointerModel,
                    triggerTooltip: triggerTooltip,
                    involveSeries: involveSeries,
                    snap: snap,
                    useHandle: $671d61e645e8595c$var$isHandleTrigger(axisPointerModel),
                    seriesModels: [],
                    linkGroup: null
                };
                axesInfoInCoordSys[axisKey] = axisInfo;
                result.seriesInvolved = result.seriesInvolved || involveSeries;
                var groupIndex = $671d61e645e8595c$var$getLinkGroupIndex(linksOption, axis);
                if (groupIndex != null) {
                    var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
                        axesInfo: {}
                    });
                    linkGroup.axesInfo[axisKey] = axisInfo;
                    linkGroup.mapper = linksOption[groupIndex].mapper;
                    axisInfo.linkGroup = linkGroup;
                }
            }
        });
    }
    function $671d61e645e8595c$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
        var tooltipAxisPointerModel = baseTooltipModel.getModel('axisPointer');
        var fields = [
            'type',
            'snap',
            'lineStyle',
            'shadowStyle',
            'label',
            'animation',
            'animationDurationUpdate',
            'animationEasingUpdate',
            'z'
        ];
        var volatileOption = {};
        (0, (0, parcelRequire("bahqM")).each)(fields, function(field) {
            volatileOption[field] = (0, (0, parcelRequire("bahqM")).clone)(tooltipAxisPointerModel.get(field));
        });
        volatileOption.snap = axis.type !== 'category' && !!triggerTooltip;
        if (tooltipAxisPointerModel.get('type') === 'cross') volatileOption.type = 'line';
        var labelOption = volatileOption.label || (volatileOption.label = {});
        labelOption.show == null && (labelOption.show = false);
        if (fromTooltip === 'cross') {
            var tooltipAxisPointerLabelShow = tooltipAxisPointerModel.get([
                'label',
                'show'
            ]);
            labelOption.show = tooltipAxisPointerLabelShow != null ? tooltipAxisPointerLabelShow : true;
            if (!triggerTooltip) {
                var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get('crossStyle');
                crossStyle && (0, (0, parcelRequire("bahqM")).defaults)(labelOption, crossStyle.textStyle);
            }
        }
        return axis.model.getModel('axisPointer', new (0, (0, parcelRequire("gaMkj")).default)(volatileOption, globalAxisPointerModel, ecModel));
    }
    function $671d61e645e8595c$var$collectSeriesInfo(result, ecModel) {
        ecModel.eachSeries(function(seriesModel) {
            var coordSys = seriesModel.coordinateSystem;
            var seriesTooltipTrigger = seriesModel.get([
                'tooltip',
                'trigger'
            ], true);
            var seriesTooltipShow = seriesModel.get([
                'tooltip',
                'show'
            ], true);
            if (!coordSys || seriesTooltipTrigger === 'none' || seriesTooltipTrigger === false || seriesTooltipTrigger === 'item' || seriesTooltipShow === false || seriesModel.get([
                'axisPointer',
                'show'
            ], true) === false) return;
            (0, (0, parcelRequire("bahqM")).each)(result.coordSysAxesInfo[$671d61e645e8595c$export$d01b444bafb1a792(coordSys.model)], function(axisInfo) {
                var axis = axisInfo.axis;
                if (coordSys.getAxis(axis.dim) === axis) {
                    axisInfo.seriesModels.push(seriesModel);
                    axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
                    axisInfo.seriesDataCount += seriesModel.getData().count();
                }
            });
        });
    }
    function $671d61e645e8595c$var$getLinkGroupIndex(linksOption, axis) {
        var axisModel = axis.model;
        var dim = axis.dim;
        for(var i = 0; i < linksOption.length; i++){
            var linkOption = linksOption[i] || {};
            if ($671d61e645e8595c$var$checkPropInLink(linkOption[dim + 'AxisId'], axisModel.id) || $671d61e645e8595c$var$checkPropInLink(linkOption[dim + 'AxisIndex'], axisModel.componentIndex) || $671d61e645e8595c$var$checkPropInLink(linkOption[dim + 'AxisName'], axisModel.name)) return i;
        }
    }
    function $671d61e645e8595c$var$checkPropInLink(linkPropValue, axisPropValue) {
        return linkPropValue === 'all' || (0, (0, parcelRequire("bahqM")).isArray)(linkPropValue) && (0, (0, parcelRequire("bahqM")).indexOf)(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
    }
    function $671d61e645e8595c$export$f5ea32e3629d8043(axisModel) {
        var axisInfo = $671d61e645e8595c$export$bd39458db76002ab(axisModel);
        if (!axisInfo) return;
        var axisPointerModel = axisInfo.axisPointerModel;
        var scale = axisInfo.axis.scale;
        var option = axisPointerModel.option;
        var status = axisPointerModel.get('status');
        var value = axisPointerModel.get('value');
        if (value != null) value = scale.parse(value);
        var useHandle = $671d61e645e8595c$var$isHandleTrigger(axisPointerModel);
        if (status == null) option.status = useHandle ? 'show' : 'hide';
        var extent = scale.getExtent().slice();
        extent[0] > extent[1] && extent.reverse();
        if (value == null || value > extent[1]) value = extent[1];
        if (value < extent[0]) value = extent[0];
        option.value = value;
        if (useHandle) option.status = axisInfo.axis.scale.isBlank() ? 'hide' : 'show';
    }
    function $671d61e645e8595c$export$bd39458db76002ab(axisModel) {
        var coordSysAxesInfo = (axisModel.ecModel.getComponent('axisPointer') || {}).coordSysAxesInfo;
        return coordSysAxesInfo && coordSysAxesInfo.axesInfo[$671d61e645e8595c$export$d01b444bafb1a792(axisModel)];
    }
    function $671d61e645e8595c$export$3b06fce3f68b734(axisModel) {
        var axisInfo = $671d61e645e8595c$export$bd39458db76002ab(axisModel);
        return axisInfo && axisInfo.axisPointerModel;
    }
    function $671d61e645e8595c$var$isHandleTrigger(axisPointerModel) {
        return !!axisPointerModel.get([
            'handle',
            'show'
        ]);
    }
    function $671d61e645e8595c$export$d01b444bafb1a792(model) {
        return model.type + '||' + model.id;
    }
});
parcelRegister("6dLRi", function(module, exports) {
    $parcel$export(module.exports, "rectCoordAxisBuildSplitArea", ()=>$487914b46b0b3c46$export$c80b7ef1527ec8c9);
    $parcel$export(module.exports, "rectCoordAxisHandleRemove", ()=>$487914b46b0b3c46$export$48ebf2d6ce8ad076);
    var $bahqM;
    parcelRequire("fHITF");
    var $7Tw7u;
    var $eaKsF;
    var $487914b46b0b3c46$var$inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
    function $487914b46b0b3c46$export$c80b7ef1527ec8c9(axisView, axisGroup, axisModel, gridModel) {
        var axis = axisModel.axis;
        if (axis.scale.isBlank()) return;
        var splitAreaModel = axisModel.getModel('splitArea');
        var areaStyleModel = splitAreaModel.getModel('areaStyle');
        var areaColors = areaStyleModel.get('color');
        var gridRect = gridModel.coordinateSystem.getRect();
        var ticksCoords = axis.getTicksCoords({
            tickModel: splitAreaModel,
            clamp: true
        });
        if (!ticksCoords.length) return;
        var areaColorsLen = areaColors.length;
        var lastSplitAreaColors = $487914b46b0b3c46$var$inner(axisView).splitAreaColors;
        var newSplitAreaColors = (0, parcelRequire("bahqM")).createHashMap();
        var colorIndex = 0;
        if (lastSplitAreaColors) for(var i = 0; i < ticksCoords.length; i++){
            var cIndex = lastSplitAreaColors.get(ticksCoords[i].tickValue);
            if (cIndex != null) {
                colorIndex = (cIndex + (areaColorsLen - 1) * i) % areaColorsLen;
                break;
            }
        }
        var prev = axis.toGlobalCoord(ticksCoords[0].coord);
        var areaStyle = areaStyleModel.getAreaStyle();
        areaColors = (0, parcelRequire("bahqM")).isArray(areaColors) ? areaColors : [
            areaColors
        ];
        for(var i = 1; i < ticksCoords.length; i++){
            var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
            var x = void 0;
            var y = void 0;
            var width = void 0;
            var height = void 0;
            if (axis.isHorizontal()) {
                x = prev;
                y = gridRect.y;
                width = tickCoord - x;
                height = gridRect.height;
                prev = x + width;
            } else {
                x = gridRect.x;
                y = prev;
                width = gridRect.width;
                height = tickCoord - y;
                prev = y + height;
            }
            var tickValue = ticksCoords[i - 1].tickValue;
            tickValue != null && newSplitAreaColors.set(tickValue, colorIndex);
            axisGroup.add(new (0, parcelRequire("7Tw7u")).default({
                anid: tickValue != null ? 'area_' + tickValue : null,
                shape: {
                    x: x,
                    y: y,
                    width: width,
                    height: height
                },
                style: (0, parcelRequire("bahqM")).defaults({
                    fill: areaColors[colorIndex]
                }, areaStyle),
                autoBatch: true,
                silent: true
            }));
            colorIndex = (colorIndex + 1) % areaColorsLen;
        }
        $487914b46b0b3c46$var$inner(axisView).splitAreaColors = newSplitAreaColors;
    }
    function $487914b46b0b3c46$export$48ebf2d6ce8ad076(axisView) {
        $487914b46b0b3c46$var$inner(axisView).splitAreaColors = null;
    }
});
parcelRegister("hi3Y7", function(module, exports) {
    $parcel$export(module.exports, "install", ()=>$c9673230869c3336$export$4b3e715f166fdd78);
    var $atJL7;
    var $4SGoL;
    var $5UrR7;
    var $gPvBV;
    var $bahqM;
    var $8QSpd;
    var $5TxwA;
    function $c9673230869c3336$export$4b3e715f166fdd78(registers) {
        (0, (0, parcelRequire("atJL7")).default).registerAxisPointerClass('CartesianAxisPointer', (0, (0, parcelRequire("4SGoL")).default));
        registers.registerComponentModel((0, (0, parcelRequire("5UrR7")).default));
        registers.registerComponentView((0, (0, parcelRequire("gPvBV")).default));
        registers.registerPreprocessor(function(option) {
            if (option) {
                (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
                var link = option.axisPointer.link;
                if (link && !(0, (0, parcelRequire("bahqM")).isArray)(link)) option.axisPointer.link = [
                    link
                ];
            }
        });
        registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, function(ecModel, api) {
            ecModel.getComponent('axisPointer').coordSysAxesInfo = (0, (0, parcelRequire("8QSpd")).collect)(ecModel, api);
        });
        registers.registerAction({
            type: 'updateAxisPointer',
            event: 'updateAxisPointer',
            update: ':updateAxisPointer'
        }, (0, (0, parcelRequire("5TxwA")).default));
    }
});
parcelRegister("4SGoL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$38dd17fca85a901b$export$2e2bcd8739ae039);
    var $3VFsf;
    var $fOZs6;
    var $eSE0c;
    var $dBIJY;
    var $38dd17fca85a901b$var$CartesianAxisPointer = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(CartesianAxisPointer, _super);
        function CartesianAxisPointer() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        CartesianAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
            var axis = axisModel.axis;
            var grid = axis.grid;
            var axisPointerType = axisPointerModel.get('type');
            var otherExtent = $38dd17fca85a901b$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
            var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));
            if (axisPointerType && axisPointerType !== 'none') {
                var elStyle = (0, parcelRequire("eSE0c")).buildElStyle(axisPointerModel);
                var pointerOption = $38dd17fca85a901b$var$pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
                pointerOption.style = elStyle;
                elOption.graphicKey = pointerOption.type;
                elOption.pointer = pointerOption;
            }
            var layoutInfo = (0, parcelRequire("dBIJY")).layout(grid.model, axisModel);
            (0, parcelRequire("eSE0c")).buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
        };
        CartesianAxisPointer.prototype.getHandleTransform = function(value, axisModel, axisPointerModel) {
            var layoutInfo = (0, parcelRequire("dBIJY")).layout(axisModel.axis.grid.model, axisModel, {
                labelInside: false
            });
            layoutInfo.labelMargin = axisPointerModel.get([
                'handle',
                'margin'
            ]);
            var pos = (0, parcelRequire("eSE0c")).getTransformedPosition(axisModel.axis, value, layoutInfo);
            return {
                x: pos[0],
                y: pos[1],
                rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
            };
        };
        CartesianAxisPointer.prototype.updateHandleTransform = function(transform, delta, axisModel, axisPointerModel) {
            var axis = axisModel.axis;
            var grid = axis.grid;
            var axisExtent = axis.getGlobalExtent(true);
            var otherExtent = $38dd17fca85a901b$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
            var dimIndex = axis.dim === 'x' ? 0 : 1;
            var currPosition = [
                transform.x,
                transform.y
            ];
            currPosition[dimIndex] += delta[dimIndex];
            currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
            currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
            var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
            var cursorPoint = [
                cursorOtherValue,
                cursorOtherValue
            ];
            cursorPoint[dimIndex] = currPosition[dimIndex];
            var tooltipOptions = [
                {
                    verticalAlign: 'middle'
                },
                {
                    align: 'center'
                }
            ];
            return {
                x: currPosition[0],
                y: currPosition[1],
                rotation: transform.rotation,
                cursorPoint: cursorPoint,
                tooltipOption: tooltipOptions[dimIndex]
            };
        };
        return CartesianAxisPointer;
    }((0, (0, parcelRequire("fOZs6")).default));
    function $38dd17fca85a901b$var$getCartesian(grid, axis) {
        var opt = {};
        opt[axis.dim + 'AxisIndex'] = axis.index;
        return grid.getCartesian(opt);
    }
    var $38dd17fca85a901b$var$pointerShapeBuilder = {
        line: function(axis, pixelValue, otherExtent) {
            var targetShape = (0, parcelRequire("eSE0c")).makeLineShape([
                pixelValue,
                otherExtent[0]
            ], [
                pixelValue,
                otherExtent[1]
            ], $38dd17fca85a901b$var$getAxisDimIndex(axis));
            return {
                type: 'Line',
                subPixelOptimize: true,
                shape: targetShape
            };
        },
        shadow: function(axis, pixelValue, otherExtent) {
            var bandWidth = Math.max(1, axis.getBandWidth());
            var span = otherExtent[1] - otherExtent[0];
            return {
                type: 'Rect',
                shape: (0, parcelRequire("eSE0c")).makeRectShape([
                    pixelValue - bandWidth / 2,
                    otherExtent[0]
                ], [
                    bandWidth,
                    span
                ], $38dd17fca85a901b$var$getAxisDimIndex(axis))
            };
        }
    };
    function $38dd17fca85a901b$var$getAxisDimIndex(axis) {
        return axis.dim === 'x' ? 0 : 1;
    }
    var $38dd17fca85a901b$export$2e2bcd8739ae039 = $38dd17fca85a901b$var$CartesianAxisPointer;
});
parcelRegister("fOZs6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b84b31aa9defeeb8$export$2e2bcd8739ae039);
    var $bahqM;
    var $fHITF;
    var $8QSpd;
    var $65X4x;
    var $ljaBy;
    var $eaKsF;
    var $b84b31aa9defeeb8$var$inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $b84b31aa9defeeb8$var$clone = (0, parcelRequire("bahqM")).clone;
    var $b84b31aa9defeeb8$var$bind = (0, parcelRequire("bahqM")).bind;
    var $b84b31aa9defeeb8$var$BaseAxisPointer = function() {
        function BaseAxisPointer() {
            this._dragging = false;
            this.animationThreshold = 15;
        }
        BaseAxisPointer.prototype.render = function(axisModel, axisPointerModel, api, forceRender) {
            var value = axisPointerModel.get('value');
            var status = axisPointerModel.get('status');
            this._axisModel = axisModel;
            this._axisPointerModel = axisPointerModel;
            this._api = api;
            if (!forceRender && this._lastValue === value && this._lastStatus === status) return;
            this._lastValue = value;
            this._lastStatus = status;
            var group = this._group;
            var handle = this._handle;
            if (!status || status === 'hide') {
                group && group.hide();
                handle && handle.hide();
                return;
            }
            group && group.show();
            handle && handle.show();
            var elOption = {};
            this.makeElOption(elOption, value, axisModel, axisPointerModel, api);
            var graphicKey = elOption.graphicKey;
            if (graphicKey !== this._lastGraphicKey) this.clear(api);
            this._lastGraphicKey = graphicKey;
            var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);
            if (!group) {
                group = this._group = new (0, parcelRequire("fHITF")).Group();
                this.createPointerEl(group, elOption, axisModel, axisPointerModel);
                this.createLabelEl(group, elOption, axisModel, axisPointerModel);
                api.getZr().add(group);
            } else {
                var doUpdateProps = (0, parcelRequire("bahqM")).curry($b84b31aa9defeeb8$var$updateProps, axisPointerModel, moveAnimation);
                this.updatePointerEl(group, elOption, doUpdateProps);
                this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
            }
            $b84b31aa9defeeb8$var$updateMandatoryProps(group, axisPointerModel, true);
            this._renderHandle(value);
        };
        BaseAxisPointer.prototype.remove = function(api) {
            this.clear(api);
        };
        BaseAxisPointer.prototype.dispose = function(api) {
            this.clear(api);
        };
        BaseAxisPointer.prototype.determineAnimation = function(axisModel, axisPointerModel) {
            var animation = axisPointerModel.get('animation');
            var axis = axisModel.axis;
            var isCategoryAxis = axis.type === 'category';
            var useSnap = axisPointerModel.get('snap');
            if (!useSnap && !isCategoryAxis) return false;
            if (animation === 'auto' || animation == null) {
                var animationThreshold = this.animationThreshold;
                if (isCategoryAxis && axis.getBandWidth() > animationThreshold) return true;
                if (useSnap) {
                    var seriesDataCount = (0, parcelRequire("8QSpd")).getAxisInfo(axisModel).seriesDataCount;
                    var axisExtent = axis.getExtent();
                    return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
                }
                return false;
            }
            return animation === true;
        };
        BaseAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {};
        BaseAxisPointer.prototype.createPointerEl = function(group, elOption, axisModel, axisPointerModel) {
            var pointerOption = elOption.pointer;
            if (pointerOption) {
                var pointerEl = $b84b31aa9defeeb8$var$inner(group).pointerEl = new (0, parcelRequire("fHITF"))[pointerOption.type]($b84b31aa9defeeb8$var$clone(elOption.pointer));
                group.add(pointerEl);
            }
        };
        BaseAxisPointer.prototype.createLabelEl = function(group, elOption, axisModel, axisPointerModel) {
            if (elOption.label) {
                var labelEl = $b84b31aa9defeeb8$var$inner(group).labelEl = new (0, parcelRequire("fHITF")).Text($b84b31aa9defeeb8$var$clone(elOption.label));
                group.add(labelEl);
                $b84b31aa9defeeb8$var$updateLabelShowHide(labelEl, axisPointerModel);
            }
        };
        BaseAxisPointer.prototype.updatePointerEl = function(group, elOption, updateProps) {
            var pointerEl = $b84b31aa9defeeb8$var$inner(group).pointerEl;
            if (pointerEl && elOption.pointer) {
                pointerEl.setStyle(elOption.pointer.style);
                updateProps(pointerEl, {
                    shape: elOption.pointer.shape
                });
            }
        };
        BaseAxisPointer.prototype.updateLabelEl = function(group, elOption, updateProps, axisPointerModel) {
            var labelEl = $b84b31aa9defeeb8$var$inner(group).labelEl;
            if (labelEl) {
                labelEl.setStyle(elOption.label.style);
                updateProps(labelEl, {
                    x: elOption.label.x,
                    y: elOption.label.y
                });
                $b84b31aa9defeeb8$var$updateLabelShowHide(labelEl, axisPointerModel);
            }
        };
        BaseAxisPointer.prototype._renderHandle = function(value) {
            if (this._dragging || !this.updateHandleTransform) return;
            var axisPointerModel = this._axisPointerModel;
            var zr = this._api.getZr();
            var handle = this._handle;
            var handleModel = axisPointerModel.getModel('handle');
            var status = axisPointerModel.get('status');
            if (!handleModel.get('show') || !status || status === 'hide') {
                handle && zr.remove(handle);
                this._handle = null;
                return;
            }
            var isInit;
            if (!this._handle) {
                isInit = true;
                handle = this._handle = (0, parcelRequire("fHITF")).createIcon(handleModel.get('icon'), {
                    cursor: 'move',
                    draggable: true,
                    onmousemove: function(e) {
                        (0, parcelRequire("65X4x")).stop(e.event);
                    },
                    onmousedown: $b84b31aa9defeeb8$var$bind(this._onHandleDragMove, this, 0, 0),
                    drift: $b84b31aa9defeeb8$var$bind(this._onHandleDragMove, this),
                    ondragend: $b84b31aa9defeeb8$var$bind(this._onHandleDragEnd, this)
                });
                zr.add(handle);
            }
            $b84b31aa9defeeb8$var$updateMandatoryProps(handle, axisPointerModel, false);
            handle.setStyle(handleModel.getItemStyle(null, [
                'color',
                'borderColor',
                'borderWidth',
                'opacity',
                'shadowColor',
                'shadowBlur',
                'shadowOffsetX',
                'shadowOffsetY'
            ]));
            var handleSize = handleModel.get('size');
            if (!(0, parcelRequire("bahqM")).isArray(handleSize)) handleSize = [
                handleSize,
                handleSize
            ];
            handle.scaleX = handleSize[0] / 2;
            handle.scaleY = handleSize[1] / 2;
            (0, parcelRequire("ljaBy")).createOrUpdate(this, '_doDispatchAxisPointer', handleModel.get('throttle') || 0, 'fixRate');
            this._moveHandleToValue(value, isInit);
        };
        BaseAxisPointer.prototype._moveHandleToValue = function(value, isInit) {
            $b84b31aa9defeeb8$var$updateProps(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, $b84b31aa9defeeb8$var$getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
        };
        BaseAxisPointer.prototype._onHandleDragMove = function(dx, dy) {
            var handle = this._handle;
            if (!handle) return;
            this._dragging = true;
            var trans = this.updateHandleTransform($b84b31aa9defeeb8$var$getHandleTransProps(handle), [
                dx,
                dy
            ], this._axisModel, this._axisPointerModel);
            this._payloadInfo = trans;
            handle.stopAnimation();
            handle.attr($b84b31aa9defeeb8$var$getHandleTransProps(trans));
            $b84b31aa9defeeb8$var$inner(handle).lastProp = null;
            this._doDispatchAxisPointer();
        };
        BaseAxisPointer.prototype._doDispatchAxisPointer = function() {
            var handle = this._handle;
            if (!handle) return;
            var payloadInfo = this._payloadInfo;
            var axisModel = this._axisModel;
            this._api.dispatchAction({
                type: 'updateAxisPointer',
                x: payloadInfo.cursorPoint[0],
                y: payloadInfo.cursorPoint[1],
                tooltipOption: payloadInfo.tooltipOption,
                axesInfo: [
                    {
                        axisDim: axisModel.axis.dim,
                        axisIndex: axisModel.componentIndex
                    }
                ]
            });
        };
        BaseAxisPointer.prototype._onHandleDragEnd = function() {
            this._dragging = false;
            var handle = this._handle;
            if (!handle) return;
            var value = this._axisPointerModel.get('value');
            this._moveHandleToValue(value);
            this._api.dispatchAction({
                type: 'hideTip'
            });
        };
        BaseAxisPointer.prototype.clear = function(api) {
            this._lastValue = null;
            this._lastStatus = null;
            var zr = api.getZr();
            var group = this._group;
            var handle = this._handle;
            if (zr && group) {
                this._lastGraphicKey = null;
                group && zr.remove(group);
                handle && zr.remove(handle);
                this._group = null;
                this._handle = null;
                this._payloadInfo = null;
            }
        };
        BaseAxisPointer.prototype.doClear = function() {};
        BaseAxisPointer.prototype.buildLabel = function(xy, wh, xDimIndex) {
            xDimIndex = xDimIndex || 0;
            return {
                x: xy[xDimIndex],
                y: xy[1 - xDimIndex],
                width: wh[xDimIndex],
                height: wh[1 - xDimIndex]
            };
        };
        return BaseAxisPointer;
    }();
    function $b84b31aa9defeeb8$var$updateProps(animationModel, moveAnimation, el, props) {
        if (!$b84b31aa9defeeb8$var$propsEqual($b84b31aa9defeeb8$var$inner(el).lastProp, props)) {
            $b84b31aa9defeeb8$var$inner(el).lastProp = props;
            moveAnimation ? (0, parcelRequire("fHITF")).updateProps(el, props, animationModel) : (el.stopAnimation(), el.attr(props));
        }
    }
    function $b84b31aa9defeeb8$var$propsEqual(lastProps, newProps) {
        if ((0, parcelRequire("bahqM")).isObject(lastProps) && (0, parcelRequire("bahqM")).isObject(newProps)) {
            var equals_1 = true;
            (0, parcelRequire("bahqM")).each(newProps, function(item, key) {
                equals_1 = equals_1 && $b84b31aa9defeeb8$var$propsEqual(lastProps[key], item);
            });
            return !!equals_1;
        } else return lastProps === newProps;
    }
    function $b84b31aa9defeeb8$var$updateLabelShowHide(labelEl, axisPointerModel) {
        labelEl[axisPointerModel.get([
            'label',
            'show'
        ]) ? 'show' : 'hide']();
    }
    function $b84b31aa9defeeb8$var$getHandleTransProps(trans) {
        return {
            x: trans.x || 0,
            y: trans.y || 0,
            rotation: trans.rotation || 0
        };
    }
    function $b84b31aa9defeeb8$var$updateMandatoryProps(group, axisPointerModel, silent) {
        var z = axisPointerModel.get('z');
        var zlevel = axisPointerModel.get('zlevel');
        group && group.traverse(function(el) {
            if (el.type !== 'group') {
                z != null && (el.z = z);
                zlevel != null && (el.zlevel = zlevel);
                el.silent = silent;
            }
        });
    }
    var $b84b31aa9defeeb8$export$2e2bcd8739ae039 = $b84b31aa9defeeb8$var$BaseAxisPointer;
});
parcelRegister("65X4x", function(module, exports) {
    $parcel$export(module.exports, "clientToLocal", ()=>$47010835ddffd941$export$7d5fecde839eee88);
    $parcel$export(module.exports, "getNativeEvent", ()=>$47010835ddffd941$export$4abe0e945399ac1d);
    $parcel$export(module.exports, "normalizeEvent", ()=>$47010835ddffd941$export$40fadb093aebad71);
    $parcel$export(module.exports, "addEventListener", ()=>$47010835ddffd941$export$3f65cefe8380dbea);
    $parcel$export(module.exports, "removeEventListener", ()=>$47010835ddffd941$export$8ff9f68337b520c0);
    $parcel$export(module.exports, "stop", ()=>$47010835ddffd941$export$fa6813432f753b0d);
    $parcel$export(module.exports, "isMiddleOrRightButtonOnMouseUpDown", ()=>$47010835ddffd941$export$b7ae4cded3e71bd2);
    var $hZfwb;
    var $6AZf6;
    var $47010835ddffd941$var$isDomLevel2 = typeof window !== 'undefined' && !!window.addEventListener;
    var $47010835ddffd941$var$MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
    var $47010835ddffd941$var$_calcOut = [];
    function $47010835ddffd941$export$7d5fecde839eee88(el, e, out, calculate) {
        out = out || {};
        if (calculate || !(0, (0, parcelRequire("hZfwb")).default).canvasSupported) $47010835ddffd941$var$calculateZrXY(el, e, out);
        else if ((0, (0, parcelRequire("hZfwb")).default).browser.firefox && (0, (0, parcelRequire("hZfwb")).default).browser.version < '39' && e.layerX != null && e.layerX !== e.offsetX) {
            out.zrX = e.layerX;
            out.zrY = e.layerY;
        } else if (e.offsetX != null) {
            out.zrX = e.offsetX;
            out.zrY = e.offsetY;
        } else $47010835ddffd941$var$calculateZrXY(el, e, out);
        return out;
    }
    function $47010835ddffd941$var$calculateZrXY(el, e, out) {
        if ((0, (0, parcelRequire("hZfwb")).default).domSupported && el.getBoundingClientRect) {
            var ex = e.clientX;
            var ey = e.clientY;
            if ((0, (0, parcelRequire("6AZf6")).isCanvasEl)(el)) {
                var box = el.getBoundingClientRect();
                out.zrX = ex - box.left;
                out.zrY = ey - box.top;
                return;
            } else if ((0, (0, parcelRequire("6AZf6")).transformCoordWithViewport)($47010835ddffd941$var$_calcOut, el, ex, ey)) {
                out.zrX = $47010835ddffd941$var$_calcOut[0];
                out.zrY = $47010835ddffd941$var$_calcOut[1];
                return;
            }
        }
        out.zrX = out.zrY = 0;
    }
    function $47010835ddffd941$export$4abe0e945399ac1d(e) {
        return e || window.event;
    }
    function $47010835ddffd941$export$40fadb093aebad71(el, e, calculate) {
        e = $47010835ddffd941$export$4abe0e945399ac1d(e);
        if (e.zrX != null) return e;
        var eventType = e.type;
        var isTouch = eventType && eventType.indexOf('touch') >= 0;
        if (!isTouch) {
            $47010835ddffd941$export$7d5fecde839eee88(el, e, e, calculate);
            var wheelDelta = $47010835ddffd941$var$getWheelDeltaMayPolyfill(e);
            e.zrDelta = wheelDelta ? wheelDelta / 120 : -(e.detail || 0) / 3;
        } else {
            var touch = eventType !== 'touchend' ? e.targetTouches[0] : e.changedTouches[0];
            touch && $47010835ddffd941$export$7d5fecde839eee88(el, touch, e, calculate);
        }
        var button = e.button;
        if (e.which == null && button !== undefined && $47010835ddffd941$var$MOUSE_EVENT_REG.test(e.type)) e.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
        return e;
    }
    function $47010835ddffd941$var$getWheelDeltaMayPolyfill(e) {
        var rawWheelDelta = e.wheelDelta;
        if (rawWheelDelta) return rawWheelDelta;
        var deltaX = e.deltaX;
        var deltaY = e.deltaY;
        if (deltaX == null || deltaY == null) return rawWheelDelta;
        var delta = deltaY !== 0 ? Math.abs(deltaY) : Math.abs(deltaX);
        var sign = deltaY > 0 ? -1 : deltaY < 0 ? 1 : deltaX > 0 ? -1 : 1;
        return 3 * delta * sign;
    }
    function $47010835ddffd941$export$3f65cefe8380dbea(el, name, handler, opt) {
        if ($47010835ddffd941$var$isDomLevel2) el.addEventListener(name, handler, opt);
        else el.attachEvent('on' + name, handler);
    }
    function $47010835ddffd941$export$8ff9f68337b520c0(el, name, handler, opt) {
        if ($47010835ddffd941$var$isDomLevel2) el.removeEventListener(name, handler, opt);
        else el.detachEvent('on' + name, handler);
    }
    var $47010835ddffd941$export$fa6813432f753b0d = $47010835ddffd941$var$isDomLevel2 ? function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.cancelBubble = true;
    } : function(e) {
        e.returnValue = false;
        e.cancelBubble = true;
    };
    function $47010835ddffd941$export$b7ae4cded3e71bd2(e) {
        return e.which === 2 || e.which === 3;
    }
    function $47010835ddffd941$export$a564e1c0090572c3(e) {
        return e.which > 1;
    }
});
parcelRegister("6AZf6", function(module, exports) {
    $parcel$export(module.exports, "transformLocalCoord", ()=>$4cd59c60322a6a09$export$8c5c02e118307e20);
    $parcel$export(module.exports, "transformCoordWithViewport", ()=>$4cd59c60322a6a09$export$1219648acc517df4);
    $parcel$export(module.exports, "isCanvasEl", ()=>$4cd59c60322a6a09$export$1b92e4fe606eff6d);
    var $hZfwb;
    var $8QVDM;
    var $4cd59c60322a6a09$var$EVENT_SAVED_PROP = '___zrEVENTSAVED';
    var $4cd59c60322a6a09$var$_calcOut = [];
    function $4cd59c60322a6a09$export$8c5c02e118307e20(out, elFrom, elTarget, inX, inY) {
        return $4cd59c60322a6a09$export$1219648acc517df4($4cd59c60322a6a09$var$_calcOut, elFrom, inX, inY, true) && $4cd59c60322a6a09$export$1219648acc517df4(out, elTarget, $4cd59c60322a6a09$var$_calcOut[0], $4cd59c60322a6a09$var$_calcOut[1]);
    }
    function $4cd59c60322a6a09$export$1219648acc517df4(out, el, inX, inY, inverse) {
        if (el.getBoundingClientRect && (0, (0, parcelRequire("hZfwb")).default).domSupported && !$4cd59c60322a6a09$export$1b92e4fe606eff6d(el)) {
            var saved = el[$4cd59c60322a6a09$var$EVENT_SAVED_PROP] || (el[$4cd59c60322a6a09$var$EVENT_SAVED_PROP] = {});
            var markers = $4cd59c60322a6a09$var$prepareCoordMarkers(el, saved);
            var transformer = $4cd59c60322a6a09$var$preparePointerTransformer(markers, saved, inverse);
            if (transformer) {
                transformer(out, inX, inY);
                return true;
            }
        }
        return false;
    }
    function $4cd59c60322a6a09$var$prepareCoordMarkers(el, saved) {
        var markers = saved.markers;
        if (markers) return markers;
        markers = saved.markers = [];
        var propLR = [
            'left',
            'right'
        ];
        var propTB = [
            'top',
            'bottom'
        ];
        for(var i = 0; i < 4; i++){
            var marker = document.createElement('div');
            var stl = marker.style;
            var idxLR = i % 2;
            var idxTB = (i >> 1) % 2;
            stl.cssText = [
                'position: absolute',
                'visibility: hidden',
                'padding: 0',
                'margin: 0',
                'border-width: 0',
                'user-select: none',
                'width:0',
                'height:0',
                propLR[idxLR] + ':0',
                propTB[idxTB] + ':0',
                propLR[1 - idxLR] + ':auto',
                propTB[1 - idxTB] + ':auto',
                ''
            ].join('!important;');
            el.appendChild(marker);
            markers.push(marker);
        }
        return markers;
    }
    function $4cd59c60322a6a09$var$preparePointerTransformer(markers, saved, inverse) {
        var transformerName = inverse ? 'invTrans' : 'trans';
        var transformer = saved[transformerName];
        var oldSrcCoords = saved.srcCoords;
        var srcCoords = [];
        var destCoords = [];
        var oldCoordTheSame = true;
        for(var i = 0; i < 4; i++){
            var rect = markers[i].getBoundingClientRect();
            var ii = 2 * i;
            var x = rect.left;
            var y = rect.top;
            srcCoords.push(x, y);
            oldCoordTheSame = oldCoordTheSame && oldSrcCoords && x === oldSrcCoords[ii] && y === oldSrcCoords[ii + 1];
            destCoords.push(markers[i].offsetLeft, markers[i].offsetTop);
        }
        return oldCoordTheSame && transformer ? transformer : (saved.srcCoords = srcCoords, saved[transformerName] = inverse ? (0, (0, parcelRequire("8QVDM")).buildTransformer)(destCoords, srcCoords) : (0, (0, parcelRequire("8QVDM")).buildTransformer)(srcCoords, destCoords));
    }
    function $4cd59c60322a6a09$export$1b92e4fe606eff6d(el) {
        return el.nodeName.toUpperCase() === 'CANVAS';
    }
});
parcelRegister("8QVDM", function(module, exports) {
    $parcel$export(module.exports, "buildTransformer", ()=>$671fe44ca8a82f31$export$fbdb2748a8171a7e);
    var $671fe44ca8a82f31$var$LN2 = Math.log(2);
    function $671fe44ca8a82f31$var$determinant(rows, rank, rowStart, rowMask, colMask, detCache) {
        var cacheKey = rowMask + '-' + colMask;
        var fullRank = rows.length;
        if (detCache.hasOwnProperty(cacheKey)) return detCache[cacheKey];
        if (rank === 1) {
            var colStart = Math.round(Math.log((1 << fullRank) - 1 & ~colMask) / $671fe44ca8a82f31$var$LN2);
            return rows[rowStart][colStart];
        }
        var subRowMask = rowMask | 1 << rowStart;
        var subRowStart = rowStart + 1;
        while(rowMask & 1 << subRowStart)subRowStart++;
        var sum = 0;
        for(var j = 0, colLocalIdx = 0; j < fullRank; j++){
            var colTag = 1 << j;
            if (!(colTag & colMask)) {
                sum += (colLocalIdx % 2 ? -1 : 1) * rows[rowStart][j] * $671fe44ca8a82f31$var$determinant(rows, rank - 1, subRowStart, subRowMask, colMask | colTag, detCache);
                colLocalIdx++;
            }
        }
        detCache[cacheKey] = sum;
        return sum;
    }
    function $671fe44ca8a82f31$export$fbdb2748a8171a7e(src, dest) {
        var mA = [
            [
                src[0],
                src[1],
                1,
                0,
                0,
                0,
                -dest[0] * src[0],
                -dest[0] * src[1]
            ],
            [
                0,
                0,
                0,
                src[0],
                src[1],
                1,
                -dest[1] * src[0],
                -dest[1] * src[1]
            ],
            [
                src[2],
                src[3],
                1,
                0,
                0,
                0,
                -dest[2] * src[2],
                -dest[2] * src[3]
            ],
            [
                0,
                0,
                0,
                src[2],
                src[3],
                1,
                -dest[3] * src[2],
                -dest[3] * src[3]
            ],
            [
                src[4],
                src[5],
                1,
                0,
                0,
                0,
                -dest[4] * src[4],
                -dest[4] * src[5]
            ],
            [
                0,
                0,
                0,
                src[4],
                src[5],
                1,
                -dest[5] * src[4],
                -dest[5] * src[5]
            ],
            [
                src[6],
                src[7],
                1,
                0,
                0,
                0,
                -dest[6] * src[6],
                -dest[6] * src[7]
            ],
            [
                0,
                0,
                0,
                src[6],
                src[7],
                1,
                -dest[7] * src[6],
                -dest[7] * src[7]
            ]
        ];
        var detCache = {};
        var det = $671fe44ca8a82f31$var$determinant(mA, 8, 0, 0, 0, detCache);
        if (det === 0) return;
        var vh = [];
        for(var i = 0; i < 8; i++)for(var j = 0; j < 8; j++){
            vh[j] == null && (vh[j] = 0);
            vh[j] += ((i + j) % 2 ? -1 : 1) * $671fe44ca8a82f31$var$determinant(mA, 7, i === 0 ? 1 : 0, 1 << i, 1 << j, detCache) / det * dest[i];
        }
        return function(out, srcPointX, srcPointY) {
            var pk = srcPointX * vh[6] + srcPointY * vh[7] + 1;
            out[0] = (srcPointX * vh[0] + srcPointY * vh[1] + vh[2]) / pk;
            out[1] = (srcPointX * vh[3] + srcPointY * vh[4] + vh[5]) / pk;
        };
    }
});
parcelRegister("eSE0c", function(module, exports) {
    $parcel$export(module.exports, "buildElStyle", ()=>$ad552373bbd775da$export$b7fe459c7cc50060);
    $parcel$export(module.exports, "buildLabelElOption", ()=>$ad552373bbd775da$export$8206a9937c45910f);
    $parcel$export(module.exports, "getValueLabel", ()=>$ad552373bbd775da$export$7cffee0f9aed39d0);
    $parcel$export(module.exports, "getTransformedPosition", ()=>$ad552373bbd775da$export$4bb66440324c3a3d);
    $parcel$export(module.exports, "buildCartesianSingleLabelElOption", ()=>$ad552373bbd775da$export$fd3eb3812211a173);
    $parcel$export(module.exports, "makeLineShape", ()=>$ad552373bbd775da$export$885fa0ad5a826207);
    $parcel$export(module.exports, "makeRectShape", ()=>$ad552373bbd775da$export$a8b35248bcc02756);
    $parcel$export(module.exports, "makeSectorShape", ()=>$ad552373bbd775da$export$b0cf82e7ebc0d7d0);
    var $bahqM;
    var $fHITF;
    var $b7ZX8;
    var $dCJrM;
    var $izqgC;
    var $3GIoT;
    var $asa08;
    var $gvLUt;
    function $ad552373bbd775da$export$b7fe459c7cc50060(axisPointerModel) {
        var axisPointerType = axisPointerModel.get('type');
        var styleModel = axisPointerModel.getModel(axisPointerType + 'Style');
        var style;
        if (axisPointerType === 'line') {
            style = styleModel.getLineStyle();
            style.fill = null;
        } else if (axisPointerType === 'shadow') {
            style = styleModel.getAreaStyle();
            style.stroke = null;
        }
        return style;
    }
    function $ad552373bbd775da$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, labelPos) {
        var value = axisPointerModel.get('value');
        var text = $ad552373bbd775da$export$7cffee0f9aed39d0(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get('seriesDataIndices'), {
            precision: axisPointerModel.get([
                'label',
                'precision'
            ]),
            formatter: axisPointerModel.get([
                'label',
                'formatter'
            ])
        });
        var labelModel = axisPointerModel.getModel('label');
        var paddings = (0, parcelRequire("dCJrM")).normalizeCssArray(labelModel.get('padding') || 0);
        var font = labelModel.getFont();
        var textRect = (0, parcelRequire("b7ZX8")).getBoundingRect(text, font);
        var position = labelPos.position;
        var width = textRect.width + paddings[1] + paddings[3];
        var height = textRect.height + paddings[0] + paddings[2];
        var align = labelPos.align;
        align === 'right' && (position[0] -= width);
        align === 'center' && (position[0] -= width / 2);
        var verticalAlign = labelPos.verticalAlign;
        verticalAlign === 'bottom' && (position[1] -= height);
        verticalAlign === 'middle' && (position[1] -= height / 2);
        $ad552373bbd775da$var$confineInContainer(position, width, height, api);
        var bgColor = labelModel.get('backgroundColor');
        if (!bgColor || bgColor === 'auto') bgColor = axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ]);
        elOption.label = {
            x: position[0],
            y: position[1],
            style: (0, (0, parcelRequire("gvLUt")).createTextStyle)(labelModel, {
                text: text,
                font: font,
                fill: labelModel.getTextColor(),
                padding: paddings,
                backgroundColor: bgColor
            }),
            z2: 10
        };
    }
    function $ad552373bbd775da$var$confineInContainer(position, width, height, api) {
        var viewWidth = api.getWidth();
        var viewHeight = api.getHeight();
        position[0] = Math.min(position[0] + width, viewWidth) - width;
        position[1] = Math.min(position[1] + height, viewHeight) - height;
        position[0] = Math.max(position[0], 0);
        position[1] = Math.max(position[1], 0);
    }
    function $ad552373bbd775da$export$7cffee0f9aed39d0(value, axis, ecModel, seriesDataIndices, opt) {
        value = axis.scale.parse(value);
        var text = axis.scale.getLabel({
            value: value
        }, {
            precision: opt.precision
        });
        var formatter = opt.formatter;
        if (formatter) {
            var params_1 = {
                value: (0, parcelRequire("3GIoT")).getAxisRawValue(axis, {
                    value: value
                }),
                axisDimension: axis.dim,
                axisIndex: axis.index,
                seriesData: []
            };
            (0, parcelRequire("bahqM")).each(seriesDataIndices, function(idxItem) {
                var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
                var dataIndex = idxItem.dataIndexInside;
                var dataParams = series && series.getDataParams(dataIndex);
                dataParams && params_1.seriesData.push(dataParams);
            });
            if ((0, parcelRequire("bahqM")).isString(formatter)) text = formatter.replace('{value}', text);
            else if ((0, parcelRequire("bahqM")).isFunction(formatter)) text = formatter(params_1);
        }
        return text;
    }
    function $ad552373bbd775da$export$4bb66440324c3a3d(axis, value, layoutInfo) {
        var transform = (0, parcelRequire("izqgC")).create();
        (0, parcelRequire("izqgC")).rotate(transform, transform, layoutInfo.rotation);
        (0, parcelRequire("izqgC")).translate(transform, transform, layoutInfo.position);
        return (0, parcelRequire("fHITF")).applyTransform([
            axis.dataToCoord(value),
            (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)
        ], transform);
    }
    function $ad552373bbd775da$export$fd3eb3812211a173(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
        var textLayout = (0, (0, parcelRequire("asa08")).default).innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
        layoutInfo.labelMargin = axisPointerModel.get([
            'label',
            'margin'
        ]);
        $ad552373bbd775da$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, {
            position: $ad552373bbd775da$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo),
            align: textLayout.textAlign,
            verticalAlign: textLayout.textVerticalAlign
        });
    }
    function $ad552373bbd775da$export$885fa0ad5a826207(p1, p2, xDimIndex) {
        xDimIndex = xDimIndex || 0;
        return {
            x1: p1[xDimIndex],
            y1: p1[1 - xDimIndex],
            x2: p2[xDimIndex],
            y2: p2[1 - xDimIndex]
        };
    }
    function $ad552373bbd775da$export$a8b35248bcc02756(xy, wh, xDimIndex) {
        xDimIndex = xDimIndex || 0;
        return {
            x: xy[xDimIndex],
            y: xy[1 - xDimIndex],
            width: wh[xDimIndex],
            height: wh[1 - xDimIndex]
        };
    }
    function $ad552373bbd775da$export$b0cf82e7ebc0d7d0(cx, cy, r0, r, startAngle, endAngle) {
        return {
            cx: cx,
            cy: cy,
            r0: r0,
            r: r,
            startAngle: startAngle,
            endAngle: endAngle,
            clockwise: true
        };
    }
});
parcelRegister("5UrR7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$44d7ca4f96167e1d$export$2e2bcd8739ae039);
    var $3VFsf;
    var $h4UlH;
    var $44d7ca4f96167e1d$var$AxisPointerModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(AxisPointerModel, _super);
        function AxisPointerModel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = AxisPointerModel.type;
            return _this;
        }
        AxisPointerModel.type = 'axisPointer';
        AxisPointerModel.defaultOption = {
            show: 'auto',
            zlevel: 0,
            z: 50,
            type: 'line',
            snap: false,
            triggerTooltip: true,
            value: null,
            status: null,
            link: [],
            animation: null,
            animationDurationUpdate: 200,
            lineStyle: {
                color: '#B9BEC9',
                width: 1,
                type: 'dashed'
            },
            shadowStyle: {
                color: 'rgba(210,219,238,0.2)'
            },
            label: {
                show: true,
                formatter: null,
                precision: 'auto',
                margin: 3,
                color: '#fff',
                padding: [
                    5,
                    7,
                    5,
                    7
                ],
                backgroundColor: 'auto',
                borderColor: null,
                borderWidth: 0,
                borderRadius: 3
            },
            handle: {
                show: false,
                icon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z',
                size: 45,
                margin: 50,
                color: '#333',
                shadowBlur: 3,
                shadowColor: '#aaa',
                shadowOffsetX: 0,
                shadowOffsetY: 2,
                throttle: 40
            }
        };
        return AxisPointerModel;
    }((0, (0, parcelRequire("h4UlH")).default));
    var $44d7ca4f96167e1d$export$2e2bcd8739ae039 = $44d7ca4f96167e1d$var$AxisPointerModel;
});
parcelRegister("gPvBV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c409edfe4aa8d133$export$2e2bcd8739ae039);
    var $3VFsf;
    var $iNebh;
    var $fkskt;
    var $c409edfe4aa8d133$var$AxisPointerView = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(AxisPointerView, _super);
        function AxisPointerView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = AxisPointerView.type;
            return _this;
        }
        AxisPointerView.prototype.render = function(globalAxisPointerModel, ecModel, api) {
            var globalTooltipModel = ecModel.getComponent('tooltip');
            var triggerOn = globalAxisPointerModel.get('triggerOn') || globalTooltipModel && globalTooltipModel.get('triggerOn') || 'mousemove|click';
            (0, parcelRequire("iNebh")).register('axisPointer', api, function(currTrigger, e, dispatchAction) {
                if (triggerOn !== 'none' && (currTrigger === 'leave' || triggerOn.indexOf(currTrigger) >= 0)) dispatchAction({
                    type: 'updateAxisPointer',
                    currTrigger: currTrigger,
                    x: e && e.offsetX,
                    y: e && e.offsetY
                });
            });
        };
        AxisPointerView.prototype.remove = function(ecModel, api) {
            (0, parcelRequire("iNebh")).unregister('axisPointer', api);
        };
        AxisPointerView.prototype.dispose = function(ecModel, api) {
            (0, parcelRequire("iNebh")).unregister('axisPointer', api);
        };
        AxisPointerView.type = 'axisPointer';
        return AxisPointerView;
    }((0, (0, parcelRequire("fkskt")).default));
    var $c409edfe4aa8d133$export$2e2bcd8739ae039 = $c409edfe4aa8d133$var$AxisPointerView;
});
parcelRegister("iNebh", function(module, exports) {
    $parcel$export(module.exports, "register", ()=>$dae7cd9e0e79e4d2$export$6503ec6e8aabbaf);
    $parcel$export(module.exports, "unregister", ()=>$dae7cd9e0e79e4d2$export$d07f55d4c15c0440);
    var $bahqM;
    var $hZfwb;
    var $eaKsF;
    var $dae7cd9e0e79e4d2$var$inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $dae7cd9e0e79e4d2$var$each = (0, parcelRequire("bahqM")).each;
    function $dae7cd9e0e79e4d2$export$6503ec6e8aabbaf(key, api, handler) {
        if ((0, (0, parcelRequire("hZfwb")).default).node) return;
        var zr = api.getZr();
        $dae7cd9e0e79e4d2$var$inner(zr).records || ($dae7cd9e0e79e4d2$var$inner(zr).records = {});
        $dae7cd9e0e79e4d2$var$initGlobalListeners(zr, api);
        var record = $dae7cd9e0e79e4d2$var$inner(zr).records[key] || ($dae7cd9e0e79e4d2$var$inner(zr).records[key] = {});
        record.handler = handler;
    }
    function $dae7cd9e0e79e4d2$var$initGlobalListeners(zr, api) {
        if ($dae7cd9e0e79e4d2$var$inner(zr).initialized) return;
        $dae7cd9e0e79e4d2$var$inner(zr).initialized = true;
        useHandler('click', (0, parcelRequire("bahqM")).curry($dae7cd9e0e79e4d2$var$doEnter, 'click'));
        useHandler('mousemove', (0, parcelRequire("bahqM")).curry($dae7cd9e0e79e4d2$var$doEnter, 'mousemove'));
        useHandler('globalout', $dae7cd9e0e79e4d2$var$onLeave);
        function useHandler(eventType, cb) {
            zr.on(eventType, function(e) {
                var dis = $dae7cd9e0e79e4d2$var$makeDispatchAction(api);
                $dae7cd9e0e79e4d2$var$each($dae7cd9e0e79e4d2$var$inner(zr).records, function(record) {
                    record && cb(record, e, dis.dispatchAction);
                });
                $dae7cd9e0e79e4d2$var$dispatchTooltipFinally(dis.pendings, api);
            });
        }
    }
    function $dae7cd9e0e79e4d2$var$dispatchTooltipFinally(pendings, api) {
        var showLen = pendings.showTip.length;
        var hideLen = pendings.hideTip.length;
        var actuallyPayload;
        if (showLen) actuallyPayload = pendings.showTip[showLen - 1];
        else if (hideLen) actuallyPayload = pendings.hideTip[hideLen - 1];
        if (actuallyPayload) {
            actuallyPayload.dispatchAction = null;
            api.dispatchAction(actuallyPayload);
        }
    }
    function $dae7cd9e0e79e4d2$var$onLeave(record, e, dispatchAction) {
        record.handler('leave', null, dispatchAction);
    }
    function $dae7cd9e0e79e4d2$var$doEnter(currTrigger, record, e, dispatchAction) {
        record.handler(currTrigger, e, dispatchAction);
    }
    function $dae7cd9e0e79e4d2$var$makeDispatchAction(api) {
        var pendings = {
            showTip: [],
            hideTip: []
        };
        var dispatchAction = function(payload) {
            var pendingList = pendings[payload.type];
            if (pendingList) pendingList.push(payload);
            else {
                payload.dispatchAction = dispatchAction;
                api.dispatchAction(payload);
            }
        };
        return {
            dispatchAction: dispatchAction,
            pendings: pendings
        };
    }
    function $dae7cd9e0e79e4d2$export$d07f55d4c15c0440(key, api) {
        if ((0, (0, parcelRequire("hZfwb")).default).node) return;
        var zr = api.getZr();
        var record = ($dae7cd9e0e79e4d2$var$inner(zr).records || {})[key];
        if (record) $dae7cd9e0e79e4d2$var$inner(zr).records[key] = null;
    }
});
parcelRegister("5TxwA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$44ac1811f8c8020d$export$2e2bcd8739ae039);
    var $eaKsF;
    var $8QSpd;
    var $4LkI5;
    var $bahqM;
    var $44ac1811f8c8020d$var$inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
    function $44ac1811f8c8020d$export$2e2bcd8739ae039(payload, ecModel, api) {
        var currTrigger = payload.currTrigger;
        var point = [
            payload.x,
            payload.y
        ];
        var finder = payload;
        var dispatchAction = payload.dispatchAction || (0, (0, parcelRequire("bahqM")).bind)(api.dispatchAction, api);
        var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;
        if (!coordSysAxesInfo) return;
        if ($44ac1811f8c8020d$var$illegalPoint(point)) point = (0, (0, parcelRequire("4LkI5")).default)({
            seriesIndex: finder.seriesIndex,
            dataIndex: finder.dataIndex
        }, ecModel).point;
        var isIllegalPoint = $44ac1811f8c8020d$var$illegalPoint(point);
        var inputAxesInfo = finder.axesInfo;
        var axesInfo = coordSysAxesInfo.axesInfo;
        var shouldHide = currTrigger === 'leave' || $44ac1811f8c8020d$var$illegalPoint(point);
        var outputPayload = {};
        var showValueMap = {};
        var dataByCoordSys = {
            list: [],
            map: {}
        };
        var updaters = {
            showPointer: (0, (0, parcelRequire("bahqM")).curry)($44ac1811f8c8020d$var$showPointer, showValueMap),
            showTooltip: (0, (0, parcelRequire("bahqM")).curry)($44ac1811f8c8020d$var$showTooltip, dataByCoordSys)
        };
        (0, (0, parcelRequire("bahqM")).each)(coordSysAxesInfo.coordSysMap, function(coordSys, coordSysKey) {
            var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
            (0, (0, parcelRequire("bahqM")).each)(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function(axisInfo, key) {
                var axis = axisInfo.axis;
                var inputAxisInfo = $44ac1811f8c8020d$var$findInputAxisInfo(inputAxesInfo, axisInfo);
                if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
                    var val = inputAxisInfo && inputAxisInfo.value;
                    if (val == null && !isIllegalPoint) val = axis.pointToData(point);
                    val != null && $44ac1811f8c8020d$var$processOnAxis(axisInfo, val, updaters, false, outputPayload);
                }
            });
        });
        var linkTriggers = {};
        (0, (0, parcelRequire("bahqM")).each)(axesInfo, function(tarAxisInfo, tarKey) {
            var linkGroup = tarAxisInfo.linkGroup;
            if (linkGroup && !showValueMap[tarKey]) (0, (0, parcelRequire("bahqM")).each)(linkGroup.axesInfo, function(srcAxisInfo, srcKey) {
                var srcValItem = showValueMap[srcKey];
                if (srcAxisInfo !== tarAxisInfo && srcValItem) {
                    var val = srcValItem.value;
                    linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, $44ac1811f8c8020d$var$makeMapperParam(srcAxisInfo), $44ac1811f8c8020d$var$makeMapperParam(tarAxisInfo))));
                    linkTriggers[tarAxisInfo.key] = val;
                }
            });
        });
        (0, (0, parcelRequire("bahqM")).each)(linkTriggers, function(val, tarKey) {
            $44ac1811f8c8020d$var$processOnAxis(axesInfo[tarKey], val, updaters, true, outputPayload);
        });
        $44ac1811f8c8020d$var$updateModelActually(showValueMap, axesInfo, outputPayload);
        $44ac1811f8c8020d$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
        $44ac1811f8c8020d$var$dispatchHighDownActually(axesInfo, dispatchAction, api);
        return outputPayload;
    }
    function $44ac1811f8c8020d$var$processOnAxis(axisInfo, newValue, updaters, noSnap, outputFinder) {
        var axis = axisInfo.axis;
        if (axis.scale.isBlank() || !axis.containData(newValue)) return;
        if (!axisInfo.involveSeries) {
            updaters.showPointer(axisInfo, newValue);
            return;
        }
        var payloadInfo = $44ac1811f8c8020d$var$buildPayloadsBySeries(newValue, axisInfo);
        var payloadBatch = payloadInfo.payloadBatch;
        var snapToValue = payloadInfo.snapToValue;
        if (payloadBatch[0] && outputFinder.seriesIndex == null) (0, (0, parcelRequire("bahqM")).extend)(outputFinder, payloadBatch[0]);
        if (!noSnap && axisInfo.snap) {
            if (axis.containData(snapToValue) && snapToValue != null) newValue = snapToValue;
        }
        updaters.showPointer(axisInfo, newValue, payloadBatch);
        updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
    }
    function $44ac1811f8c8020d$var$buildPayloadsBySeries(value, axisInfo) {
        var axis = axisInfo.axis;
        var dim = axis.dim;
        var snapToValue = value;
        var payloadBatch = [];
        var minDist = Number.MAX_VALUE;
        var minDiff = -1;
        (0, (0, parcelRequire("bahqM")).each)(axisInfo.seriesModels, function(series, idx) {
            var dataDim = series.getData().mapDimensionsAll(dim);
            var seriesNestestValue;
            var dataIndices;
            if (series.getAxisTooltipData) {
                var result = series.getAxisTooltipData(dataDim, value, axis);
                dataIndices = result.dataIndices;
                seriesNestestValue = result.nestestValue;
            } else {
                dataIndices = series.getData().indicesOfNearest(dataDim[0], value, axis.type === 'category' ? 0.5 : null);
                if (!dataIndices.length) return;
                seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
            }
            if (seriesNestestValue == null || !isFinite(seriesNestestValue)) return;
            var diff = value - seriesNestestValue;
            var dist = Math.abs(diff);
            if (dist <= minDist) {
                if (dist < minDist || diff >= 0 && minDiff < 0) {
                    minDist = dist;
                    minDiff = diff;
                    snapToValue = seriesNestestValue;
                    payloadBatch.length = 0;
                }
                (0, (0, parcelRequire("bahqM")).each)(dataIndices, function(dataIndex) {
                    payloadBatch.push({
                        seriesIndex: series.seriesIndex,
                        dataIndexInside: dataIndex,
                        dataIndex: series.getData().getRawIndex(dataIndex)
                    });
                });
            }
        });
        return {
            payloadBatch: payloadBatch,
            snapToValue: snapToValue
        };
    }
    function $44ac1811f8c8020d$var$showPointer(showValueMap, axisInfo, value, payloadBatch) {
        showValueMap[axisInfo.key] = {
            value: value,
            payloadBatch: payloadBatch
        };
    }
    function $44ac1811f8c8020d$var$showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
        var payloadBatch = payloadInfo.payloadBatch;
        var axis = axisInfo.axis;
        var axisModel = axis.model;
        var axisPointerModel = axisInfo.axisPointerModel;
        if (!axisInfo.triggerTooltip || !payloadBatch.length) return;
        var coordSysModel = axisInfo.coordSys.model;
        var coordSysKey = (0, parcelRequire("8QSpd")).makeKey(coordSysModel);
        var coordSysItem = dataByCoordSys.map[coordSysKey];
        if (!coordSysItem) {
            coordSysItem = dataByCoordSys.map[coordSysKey] = {
                coordSysId: coordSysModel.id,
                coordSysIndex: coordSysModel.componentIndex,
                coordSysType: coordSysModel.type,
                coordSysMainType: coordSysModel.mainType,
                dataByAxis: []
            };
            dataByCoordSys.list.push(coordSysItem);
        }
        coordSysItem.dataByAxis.push({
            axisDim: axis.dim,
            axisIndex: axisModel.componentIndex,
            axisType: axisModel.type,
            axisId: axisModel.id,
            value: value,
            valueLabelOpt: {
                precision: axisPointerModel.get([
                    'label',
                    'precision'
                ]),
                formatter: axisPointerModel.get([
                    'label',
                    'formatter'
                ])
            },
            seriesDataIndices: payloadBatch.slice()
        });
    }
    function $44ac1811f8c8020d$var$updateModelActually(showValueMap, axesInfo, outputPayload) {
        var outputAxesInfo = outputPayload.axesInfo = [];
        (0, (0, parcelRequire("bahqM")).each)(axesInfo, function(axisInfo, key) {
            var option = axisInfo.axisPointerModel.option;
            var valItem = showValueMap[key];
            if (valItem) {
                !axisInfo.useHandle && (option.status = 'show');
                option.value = valItem.value;
                option.seriesDataIndices = (valItem.payloadBatch || []).slice();
            } else !axisInfo.useHandle && (option.status = 'hide');
            option.status === 'show' && outputAxesInfo.push({
                axisDim: axisInfo.axis.dim,
                axisIndex: axisInfo.axis.model.componentIndex,
                value: option.value
            });
        });
    }
    function $44ac1811f8c8020d$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
        if ($44ac1811f8c8020d$var$illegalPoint(point) || !dataByCoordSys.list.length) {
            dispatchAction({
                type: 'hideTip'
            });
            return;
        }
        var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
        dispatchAction({
            type: 'showTip',
            escapeConnect: true,
            x: point[0],
            y: point[1],
            tooltipOption: payload.tooltipOption,
            position: payload.position,
            dataIndexInside: sampleItem.dataIndexInside,
            dataIndex: sampleItem.dataIndex,
            seriesIndex: sampleItem.seriesIndex,
            dataByCoordSys: dataByCoordSys.list
        });
    }
    function $44ac1811f8c8020d$var$dispatchHighDownActually(axesInfo, dispatchAction, api) {
        var zr = api.getZr();
        var highDownKey = 'axisPointerLastHighlights';
        var lastHighlights = $44ac1811f8c8020d$var$inner(zr)[highDownKey] || {};
        var newHighlights = $44ac1811f8c8020d$var$inner(zr)[highDownKey] = {};
        (0, (0, parcelRequire("bahqM")).each)(axesInfo, function(axisInfo, key) {
            var option = axisInfo.axisPointerModel.option;
            option.status === 'show' && (0, (0, parcelRequire("bahqM")).each)(option.seriesDataIndices, function(batchItem) {
                var key = batchItem.seriesIndex + ' | ' + batchItem.dataIndex;
                newHighlights[key] = batchItem;
            });
        });
        var toHighlight = [];
        var toDownplay = [];
        (0, (0, parcelRequire("bahqM")).each)(lastHighlights, function(batchItem, key) {
            !newHighlights[key] && toDownplay.push(batchItem);
        });
        (0, (0, parcelRequire("bahqM")).each)(newHighlights, function(batchItem, key) {
            !lastHighlights[key] && toHighlight.push(batchItem);
        });
        toDownplay.length && api.dispatchAction({
            type: 'downplay',
            escapeConnect: true,
            notBlur: true,
            batch: toDownplay
        });
        toHighlight.length && api.dispatchAction({
            type: 'highlight',
            escapeConnect: true,
            notBlur: true,
            batch: toHighlight
        });
    }
    function $44ac1811f8c8020d$var$findInputAxisInfo(inputAxesInfo, axisInfo) {
        for(var i = 0; i < (inputAxesInfo || []).length; i++){
            var inputAxisInfo = inputAxesInfo[i];
            if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) return inputAxisInfo;
        }
    }
    function $44ac1811f8c8020d$var$makeMapperParam(axisInfo) {
        var axisModel = axisInfo.axis.model;
        var item = {};
        var dim = item.axisDim = axisInfo.axis.dim;
        item.axisIndex = item[dim + 'AxisIndex'] = axisModel.componentIndex;
        item.axisName = item[dim + 'AxisName'] = axisModel.name;
        item.axisId = item[dim + 'AxisId'] = axisModel.id;
        return item;
    }
    function $44ac1811f8c8020d$var$illegalPoint(point) {
        return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
    }
});
parcelRegister("4LkI5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$377b9dcb49ed57dc$export$2e2bcd8739ae039);
    var $bahqM;
    var $eaKsF;
    function $377b9dcb49ed57dc$export$2e2bcd8739ae039(finder, ecModel) {
        var point = [];
        var seriesIndex = finder.seriesIndex;
        var seriesModel;
        if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) return {
            point: []
        };
        var data = seriesModel.getData();
        var dataIndex = (0, parcelRequire("eaKsF")).queryDataIndex(data, finder);
        if (dataIndex == null || dataIndex < 0 || (0, parcelRequire("bahqM")).isArray(dataIndex)) return {
            point: []
        };
        var el = data.getItemGraphicEl(dataIndex);
        var coordSys = seriesModel.coordinateSystem;
        if (seriesModel.getTooltipPosition) point = seriesModel.getTooltipPosition(dataIndex) || [];
        else if (coordSys && coordSys.dataToPoint) {
            if (finder.isStacked) {
                var baseAxis = coordSys.getBaseAxis();
                var valueAxis = coordSys.getOtherAxis(baseAxis);
                var valueAxisDim = valueAxis.dim;
                var baseAxisDim = baseAxis.dim;
                var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
                var baseDim = data.mapDimension(baseAxisDim);
                var stackedData = [];
                stackedData[baseDataOffset] = data.get(baseDim, dataIndex);
                stackedData[1 - baseDataOffset] = data.get(data.getCalculationInfo('stackResultDimension'), dataIndex);
                point = coordSys.dataToPoint(stackedData) || [];
            } else point = coordSys.dataToPoint(data.getValues((0, parcelRequire("bahqM")).map(coordSys.dimensions, function(dim) {
                return data.mapDimension(dim);
            }), dataIndex)) || [];
        } else if (el) {
            var rect = el.getBoundingRect().clone();
            rect.applyTransform(el.transform);
            point = [
                rect.x + rect.width / 2,
                rect.y + rect.height / 2
            ];
        }
        return {
            point: point,
            el: el
        };
    }
});
parcelRegister("alpND", function(module, exports) {
    $parcel$export(module.exports, "use", ()=>$787fe0d1b8504a01$export$1f96ae73734a86cc);
    var $8pqpA;
    var $fkskt;
    var $loerw;
    var $h4UlH;
    var $1O7Ua;
    var $bahqM;
    var $9Y5KT;
    var $787fe0d1b8504a01$var$extensions = [];
    var $787fe0d1b8504a01$var$extensionRegisters = {
        registerPreprocessor: (0, (0, parcelRequire("8pqpA")).registerPreprocessor),
        registerProcessor: (0, (0, parcelRequire("8pqpA")).registerProcessor),
        registerPostInit: (0, (0, parcelRequire("8pqpA")).registerPostInit),
        registerPostUpdate: (0, (0, parcelRequire("8pqpA")).registerPostUpdate),
        registerUpdateLifecycle: (0, (0, parcelRequire("8pqpA")).registerUpdateLifecycle),
        registerAction: (0, (0, parcelRequire("8pqpA")).registerAction),
        registerCoordinateSystem: (0, (0, parcelRequire("8pqpA")).registerCoordinateSystem),
        registerLayout: (0, (0, parcelRequire("8pqpA")).registerLayout),
        registerVisual: (0, (0, parcelRequire("8pqpA")).registerVisual),
        registerTransform: (0, (0, parcelRequire("8pqpA")).registerTransform),
        registerLoading: (0, (0, parcelRequire("8pqpA")).registerLoading),
        registerMap: (0, (0, parcelRequire("8pqpA")).registerMap),
        PRIORITY: (0, (0, parcelRequire("8pqpA")).PRIORITY),
        ComponentModel: (0, (0, parcelRequire("h4UlH")).default),
        ComponentView: (0, (0, parcelRequire("fkskt")).default),
        SeriesModel: (0, (0, parcelRequire("1O7Ua")).default),
        ChartView: (0, (0, parcelRequire("loerw")).default),
        registerComponentModel: function(ComponentModelClass) {
            (0, (0, parcelRequire("h4UlH")).default).registerClass(ComponentModelClass);
        },
        registerComponentView: function(ComponentViewClass) {
            (0, (0, parcelRequire("fkskt")).default).registerClass(ComponentViewClass);
        },
        registerSeriesModel: function(SeriesModelClass) {
            (0, (0, parcelRequire("1O7Ua")).default).registerClass(SeriesModelClass);
        },
        registerChartView: function(ChartViewClass) {
            (0, (0, parcelRequire("loerw")).default).registerClass(ChartViewClass);
        },
        registerSubTypeDefaulter: function(componentType, defaulter) {
            (0, (0, parcelRequire("h4UlH")).default).registerSubTypeDefaulter(componentType, defaulter);
        },
        registerPainter: function(painterType, PainterCtor) {
            (0, (0, parcelRequire("9Y5KT")).registerPainter)(painterType, PainterCtor);
        }
    };
    function $787fe0d1b8504a01$export$1f96ae73734a86cc(ext) {
        if ((0, (0, parcelRequire("bahqM")).isArray)(ext)) {
            (0, (0, parcelRequire("bahqM")).each)(ext, function(singleExt) {
                $787fe0d1b8504a01$export$1f96ae73734a86cc(singleExt);
            });
            return;
        }
        if ((0, (0, parcelRequire("bahqM")).indexOf)($787fe0d1b8504a01$var$extensions, ext) >= 0) return;
        $787fe0d1b8504a01$var$extensions.push(ext);
        if ((0, (0, parcelRequire("bahqM")).isFunction)(ext)) ext = {
            install: ext
        };
        ext.install($787fe0d1b8504a01$var$extensionRegisters);
    }
});
parcelRegister("8pqpA", function(module, exports) {
    $parcel$export(module.exports, "version", ()=>$61f525521022d020$export$83d89fbfd8236492);
    $parcel$export(module.exports, "dependencies", ()=>$61f525521022d020$export$b74ff737e0e298b5);
    $parcel$export(module.exports, "PRIORITY", ()=>$61f525521022d020$export$bb34f3538ba26c7e);
    $parcel$export(module.exports, "init", ()=>$61f525521022d020$export$2cd8252107eb640b);
    $parcel$export(module.exports, "getInstanceByDom", ()=>$61f525521022d020$export$33b6fbccd4f643f8);
    $parcel$export(module.exports, "connect", ()=>$61f525521022d020$export$64605811ab45167f);
    $parcel$export(module.exports, "disConnect", ()=>$61f525521022d020$export$87cd6834112ecb52);
    $parcel$export(module.exports, "disconnect", ()=>$61f525521022d020$export$37dfea93db2e14ed);
    $parcel$export(module.exports, "dispose", ()=>$61f525521022d020$export$fcfbbcec2cb820d5);
    $parcel$export(module.exports, "getInstanceById", ()=>$61f525521022d020$export$89b4be35062c4a3f);
    $parcel$export(module.exports, "registerTheme", ()=>$61f525521022d020$export$f9c59eed5de5ff80);
    $parcel$export(module.exports, "registerPreprocessor", ()=>$61f525521022d020$export$77095792a057b768);
    $parcel$export(module.exports, "registerProcessor", ()=>$61f525521022d020$export$d575e6557ac1729f);
    $parcel$export(module.exports, "registerPostInit", ()=>$61f525521022d020$export$c8c249911ee8c1ed);
    $parcel$export(module.exports, "registerUpdateLifecycle", ()=>$61f525521022d020$export$c9ec4b5faef04865);
    $parcel$export(module.exports, "registerPostUpdate", ()=>$61f525521022d020$export$99560909c18c76bb);
    $parcel$export(module.exports, "registerAction", ()=>$61f525521022d020$export$408c24786cd729c6);
    $parcel$export(module.exports, "registerCoordinateSystem", ()=>$61f525521022d020$export$1dd5e025a8a37dd);
    $parcel$export(module.exports, "getCoordinateSystemDimensions", ()=>$61f525521022d020$export$fc2638719e4159b9);
    $parcel$export(module.exports, "registerLayout", ()=>$61f525521022d020$export$d768f97700ca6bea);
    $parcel$export(module.exports, "registerVisual", ()=>$61f525521022d020$export$5f32c1eb94c381bb);
    $parcel$export(module.exports, "registerLoading", ()=>$61f525521022d020$export$e06b68a82007c015);
    $parcel$export(module.exports, "setCanvasCreator", ()=>$61f525521022d020$export$10425ea7a243b114);
    $parcel$export(module.exports, "registerMap", ()=>$61f525521022d020$export$d456de060be2dba1);
    $parcel$export(module.exports, "getMap", ()=>$61f525521022d020$export$b8586192aead8a7e);
    $parcel$export(module.exports, "registerTransform", ()=>$61f525521022d020$export$f01d71dd0389d7e4);
    $parcel$export(module.exports, "dataTool", ()=>$61f525521022d020$export$73cae5e090579589);
    $parcel$export(module.exports, "registerLocale", ()=>(parcelRequire("3OMoQ")).registerLocale);
    var $3VFsf;
    var $9Y5KT;
    var $bahqM;
    var $d6udH;
    var $hZfwb;
    var $aVBu2;
    var $bRKv5;
    var $74g78;
    var $iEvqc;
    var $gyhNQ;
    var $6LzFt;
    var $driCQ;
    var $iMppY;
    var $1O7Ua;
    var $fkskt;
    var $loerw;
    parcelRequire("fHITF");
    var $gcbBH;
    var $ghQ8v;
    var $7Tw7u;
    var $eYgMC;
    var $7QjoM;
    var $fIXXx;
    var $eaKsF;
    var $ljaBy;
    var $cvEVp;
    var $4G956;
    var $14WFd;
    var $31FQc;
    var $dMJCs;
    var $aLwh0;
    var $cbv5T;
    var $7wiHx;
    var $fk5Gm;
    var $2cFRc;
    var $1nKsD;
    var $05ab4;
    var $3OMoQ;
    var $6IsbX;
    var $g2DhS;
    var $fEzwg;
    var $8cCW2;
    var $61f525521022d020$var$hasWindow = typeof window !== 'undefined';
    var $61f525521022d020$export$83d89fbfd8236492 = '5.2.1';
    var $61f525521022d020$export$b74ff737e0e298b5 = {
        zrender: '5.2.1'
    };
    var $61f525521022d020$var$TEST_FRAME_REMAIN_TIME = 1;
    var $61f525521022d020$var$PRIORITY_PROCESSOR_SERIES_FILTER = 800;
    var $61f525521022d020$var$PRIORITY_PROCESSOR_DATASTACK = 900;
    var $61f525521022d020$var$PRIORITY_PROCESSOR_FILTER = 1000;
    var $61f525521022d020$var$PRIORITY_PROCESSOR_DEFAULT = 2000;
    var $61f525521022d020$var$PRIORITY_PROCESSOR_STATISTIC = 5000;
    var $61f525521022d020$var$PRIORITY_VISUAL_LAYOUT = 1000;
    var $61f525521022d020$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT = 1100;
    var $61f525521022d020$var$PRIORITY_VISUAL_GLOBAL = 2000;
    var $61f525521022d020$var$PRIORITY_VISUAL_CHART = 3000;
    var $61f525521022d020$var$PRIORITY_VISUAL_COMPONENT = 4000;
    var $61f525521022d020$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM = 4500;
    var $61f525521022d020$var$PRIORITY_VISUAL_POST_CHART_LAYOUT = 4600;
    var $61f525521022d020$var$PRIORITY_VISUAL_BRUSH = 5000;
    var $61f525521022d020$var$PRIORITY_VISUAL_ARIA = 6000;
    var $61f525521022d020$var$PRIORITY_VISUAL_DECAL = 7000;
    var $61f525521022d020$export$bb34f3538ba26c7e = {
        PROCESSOR: {
            FILTER: $61f525521022d020$var$PRIORITY_PROCESSOR_FILTER,
            SERIES_FILTER: $61f525521022d020$var$PRIORITY_PROCESSOR_SERIES_FILTER,
            STATISTIC: $61f525521022d020$var$PRIORITY_PROCESSOR_STATISTIC
        },
        VISUAL: {
            LAYOUT: $61f525521022d020$var$PRIORITY_VISUAL_LAYOUT,
            PROGRESSIVE_LAYOUT: $61f525521022d020$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT,
            GLOBAL: $61f525521022d020$var$PRIORITY_VISUAL_GLOBAL,
            CHART: $61f525521022d020$var$PRIORITY_VISUAL_CHART,
            POST_CHART_LAYOUT: $61f525521022d020$var$PRIORITY_VISUAL_POST_CHART_LAYOUT,
            COMPONENT: $61f525521022d020$var$PRIORITY_VISUAL_COMPONENT,
            BRUSH: $61f525521022d020$var$PRIORITY_VISUAL_BRUSH,
            CHART_ITEM: $61f525521022d020$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM,
            ARIA: $61f525521022d020$var$PRIORITY_VISUAL_ARIA,
            DECAL: $61f525521022d020$var$PRIORITY_VISUAL_DECAL
        }
    };
    var $61f525521022d020$var$IN_MAIN_PROCESS_KEY = '__flagInMainProcess';
    var $61f525521022d020$var$PENDING_UPDATE = '__pendingUpdate';
    var $61f525521022d020$var$STATUS_NEEDS_UPDATE_KEY = '__needsUpdateStatus';
    var $61f525521022d020$var$ACTION_REG = /^[a-zA-Z0-9_]+$/;
    var $61f525521022d020$var$CONNECT_STATUS_KEY = '__connectUpdateStatus';
    var $61f525521022d020$var$CONNECT_STATUS_PENDING = 0;
    var $61f525521022d020$var$CONNECT_STATUS_UPDATING = 1;
    var $61f525521022d020$var$CONNECT_STATUS_UPDATED = 2;
    function $61f525521022d020$var$createRegisterEventWithLowercaseECharts(method) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.isDisposed()) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            return $61f525521022d020$var$toLowercaseNameAndCallEventful(this, method, args);
        };
    }
    function $61f525521022d020$var$createRegisterEventWithLowercaseMessageCenter(method) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return $61f525521022d020$var$toLowercaseNameAndCallEventful(this, method, args);
        };
    }
    function $61f525521022d020$var$toLowercaseNameAndCallEventful(host, method, args) {
        args[0] = args[0] && args[0].toLowerCase();
        return (0, (0, parcelRequire("bRKv5")).default).prototype[method].apply(host, args);
    }
    var $61f525521022d020$var$MessageCenter = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(MessageCenter, _super);
        function MessageCenter() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return MessageCenter;
    }((0, (0, parcelRequire("bRKv5")).default));
    var $61f525521022d020$var$messageCenterProto = $61f525521022d020$var$MessageCenter.prototype;
    $61f525521022d020$var$messageCenterProto.on = $61f525521022d020$var$createRegisterEventWithLowercaseMessageCenter('on');
    $61f525521022d020$var$messageCenterProto.off = $61f525521022d020$var$createRegisterEventWithLowercaseMessageCenter('off');
    var $61f525521022d020$var$prepare;
    var $61f525521022d020$var$prepareView;
    var $61f525521022d020$var$updateDirectly;
    var $61f525521022d020$var$updateMethods;
    var $61f525521022d020$var$doConvertPixel;
    var $61f525521022d020$var$updateStreamModes;
    var $61f525521022d020$var$doDispatchAction;
    var $61f525521022d020$var$flushPendingActions;
    var $61f525521022d020$var$triggerUpdatedEvent;
    var $61f525521022d020$var$bindRenderedEvent;
    var $61f525521022d020$var$bindMouseEvent;
    var $61f525521022d020$var$clearColorPalette;
    var $61f525521022d020$var$render;
    var $61f525521022d020$var$renderComponents;
    var $61f525521022d020$var$renderSeries;
    var $61f525521022d020$var$createExtensionAPI;
    var $61f525521022d020$var$enableConnect;
    var $61f525521022d020$var$markStatusToUpdate;
    var $61f525521022d020$var$applyChangedStates;
    var $61f525521022d020$var$ECharts = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ECharts, _super);
        function ECharts(dom, theme, opts) {
            var _this = _super.call(this, new (0, (0, parcelRequire("cbv5T")).ECEventProcessor)()) || this;
            _this._chartsViews = [];
            _this._chartsMap = {};
            _this._componentsViews = [];
            _this._componentsMap = {};
            _this._pendingActions = [];
            opts = opts || {};
            if (typeof theme === 'string') theme = $61f525521022d020$var$themeStorage[theme];
            _this._dom = dom;
            var defaultRenderer = 'canvas';
            var defaultUseDirtyRect = false;
            var root, devUseDirtyRect;
            var zr = _this._zr = (0, parcelRequire("9Y5KT")).init(dom, {
                renderer: opts.renderer || defaultRenderer,
                devicePixelRatio: opts.devicePixelRatio,
                width: opts.width,
                height: opts.height,
                useDirtyRect: opts.useDirtyRect == null ? defaultUseDirtyRect : opts.useDirtyRect
            });
            _this._throttledZrFlush = (0, (0, parcelRequire("ljaBy")).throttle)((0, (0, parcelRequire("bahqM")).bind)(zr.flush, zr), 17);
            theme = (0, (0, parcelRequire("bahqM")).clone)(theme);
            theme && (0, (0, parcelRequire("driCQ")).default)(theme, true);
            _this._theme = theme;
            _this._locale = (0, (0, parcelRequire("3OMoQ")).createLocaleObject)(opts.locale || (0, (0, parcelRequire("3OMoQ")).SYSTEM_LANG));
            _this._coordSysMgr = new (0, (0, parcelRequire("gyhNQ")).default)();
            var api = _this._api = $61f525521022d020$var$createExtensionAPI(_this);
            function prioritySortFunc(a, b) {
                return a.__prio - b.__prio;
            }
            (0, (0, parcelRequire("aVBu2")).default)($61f525521022d020$var$visualFuncs, prioritySortFunc);
            (0, (0, parcelRequire("aVBu2")).default)($61f525521022d020$var$dataProcessorFuncs, prioritySortFunc);
            _this._scheduler = new (0, (0, parcelRequire("14WFd")).default)(_this, api, $61f525521022d020$var$dataProcessorFuncs, $61f525521022d020$var$visualFuncs);
            _this._messageCenter = new $61f525521022d020$var$MessageCenter();
            _this._initEvents();
            _this.resize = (0, (0, parcelRequire("bahqM")).bind)(_this.resize, _this);
            zr.animation.on('frame', _this._onframe, _this);
            $61f525521022d020$var$bindRenderedEvent(zr, _this);
            $61f525521022d020$var$bindMouseEvent(zr, _this);
            (0, (0, parcelRequire("bahqM")).setAsPrimitive)(_this);
            return _this;
        }
        ECharts.prototype._onframe = function() {
            if (this._disposed) return;
            $61f525521022d020$var$applyChangedStates(this);
            var scheduler = this._scheduler;
            if (this[$61f525521022d020$var$PENDING_UPDATE]) {
                var silent = this[$61f525521022d020$var$PENDING_UPDATE].silent;
                this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = true;
                $61f525521022d020$var$prepare(this);
                $61f525521022d020$var$updateMethods.update.call(this, null, this[$61f525521022d020$var$PENDING_UPDATE].updateParams);
                this._zr.flush();
                this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = false;
                this[$61f525521022d020$var$PENDING_UPDATE] = null;
                $61f525521022d020$var$flushPendingActions.call(this, silent);
                $61f525521022d020$var$triggerUpdatedEvent.call(this, silent);
            } else if (scheduler.unfinished) {
                var remainTime = $61f525521022d020$var$TEST_FRAME_REMAIN_TIME;
                var ecModel = this._model;
                var api = this._api;
                scheduler.unfinished = false;
                do {
                    var startTime = +new Date();
                    scheduler.performSeriesTasks(ecModel);
                    scheduler.performDataProcessorTasks(ecModel);
                    $61f525521022d020$var$updateStreamModes(this, ecModel);
                    scheduler.performVisualTasks(ecModel);
                    $61f525521022d020$var$renderSeries(this, this._model, api, 'remain', {});
                    remainTime -= +new Date() - startTime;
                }while (remainTime > 0 && scheduler.unfinished)
                if (!scheduler.unfinished) this._zr.flush();
            }
        };
        ECharts.prototype.getDom = function() {
            return this._dom;
        };
        ECharts.prototype.getId = function() {
            return this.id;
        };
        ECharts.prototype.getZr = function() {
            return this._zr;
        };
        ECharts.prototype.setOption = function(option, notMerge, lazyUpdate) {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            var silent;
            var replaceMerge;
            var transitionOpt;
            if ((0, (0, parcelRequire("bahqM")).isObject)(notMerge)) {
                lazyUpdate = notMerge.lazyUpdate;
                silent = notMerge.silent;
                replaceMerge = notMerge.replaceMerge;
                transitionOpt = notMerge.transition;
                notMerge = notMerge.notMerge;
            }
            this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = true;
            if (!this._model || notMerge) {
                var optionManager = new (0, (0, parcelRequire("6LzFt")).default)(this._api);
                var theme = this._theme;
                var ecModel = this._model = new (0, (0, parcelRequire("74g78")).default)();
                ecModel.scheduler = this._scheduler;
                ecModel.init(null, null, null, theme, this._locale, optionManager);
            }
            this._model.setOption(option, {
                replaceMerge: replaceMerge
            }, $61f525521022d020$var$optionPreprocessorFuncs);
            var updateParams = {
                seriesTransition: transitionOpt,
                optionChanged: true
            };
            if (lazyUpdate) {
                this[$61f525521022d020$var$PENDING_UPDATE] = {
                    silent: silent,
                    updateParams: updateParams
                };
                this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = false;
                this.getZr().wakeUp();
            } else {
                $61f525521022d020$var$prepare(this);
                $61f525521022d020$var$updateMethods.update.call(this, null, updateParams);
                this._zr.flush();
                this[$61f525521022d020$var$PENDING_UPDATE] = null;
                this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = false;
                $61f525521022d020$var$flushPendingActions.call(this, silent);
                $61f525521022d020$var$triggerUpdatedEvent.call(this, silent);
            }
        };
        ECharts.prototype.setTheme = function() {
            console.error('ECharts#setTheme() is DEPRECATED in ECharts 3.0');
        };
        ECharts.prototype.getModel = function() {
            return this._model;
        };
        ECharts.prototype.getOption = function() {
            return this._model && this._model.getOption();
        };
        ECharts.prototype.getWidth = function() {
            return this._zr.getWidth();
        };
        ECharts.prototype.getHeight = function() {
            return this._zr.getHeight();
        };
        ECharts.prototype.getDevicePixelRatio = function() {
            return this._zr.painter.dpr || $61f525521022d020$var$hasWindow && window.devicePixelRatio || 1;
        };
        ECharts.prototype.getRenderedCanvas = function(opts) {
            if (!(0, (0, parcelRequire("hZfwb")).default).canvasSupported) return;
            opts = opts || {};
            return this._zr.painter.getRenderedCanvas({
                backgroundColor: opts.backgroundColor || this._model.get('backgroundColor'),
                pixelRatio: opts.pixelRatio || this.getDevicePixelRatio()
            });
        };
        ECharts.prototype.getSvgDataURL = function() {
            if (!(0, (0, parcelRequire("hZfwb")).default).svgSupported) return;
            var zr = this._zr;
            var list = zr.storage.getDisplayList();
            (0, (0, parcelRequire("bahqM")).each)(list, function(el) {
                el.stopAnimation(null, true);
            });
            return zr.painter.toDataURL();
        };
        ECharts.prototype.getDataURL = function(opts) {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            opts = opts || {};
            var excludeComponents = opts.excludeComponents;
            var ecModel = this._model;
            var excludesComponentViews = [];
            var self = this;
            (0, (0, parcelRequire("bahqM")).each)(excludeComponents, function(componentType) {
                ecModel.eachComponent({
                    mainType: componentType
                }, function(component) {
                    var view = self._componentsMap[component.__viewId];
                    if (!view.group.ignore) {
                        excludesComponentViews.push(view);
                        view.group.ignore = true;
                    }
                });
            });
            var url = this._zr.painter.getType() === 'svg' ? this.getSvgDataURL() : this.getRenderedCanvas(opts).toDataURL('image/' + (opts && opts.type || 'png'));
            (0, (0, parcelRequire("bahqM")).each)(excludesComponentViews, function(view) {
                view.group.ignore = false;
            });
            return url;
        };
        ECharts.prototype.getConnectedDataURL = function(opts) {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            if (!(0, (0, parcelRequire("hZfwb")).default).canvasSupported) return;
            var isSvg = opts.type === 'svg';
            var groupId = this.group;
            var mathMin = Math.min;
            var mathMax = Math.max;
            var MAX_NUMBER = Infinity;
            if ($61f525521022d020$var$connectedGroups[groupId]) {
                var left_1 = MAX_NUMBER;
                var top_1 = MAX_NUMBER;
                var right_1 = -MAX_NUMBER;
                var bottom_1 = -MAX_NUMBER;
                var canvasList_1 = [];
                var dpr_1 = opts && opts.pixelRatio || this.getDevicePixelRatio();
                (0, (0, parcelRequire("bahqM")).each)($61f525521022d020$var$instances, function(chart, id) {
                    if (chart.group === groupId) {
                        var canvas = isSvg ? chart.getZr().painter.getSvgDom().innerHTML : chart.getRenderedCanvas((0, (0, parcelRequire("bahqM")).clone)(opts));
                        var boundingRect = chart.getDom().getBoundingClientRect();
                        left_1 = mathMin(boundingRect.left, left_1);
                        top_1 = mathMin(boundingRect.top, top_1);
                        right_1 = mathMax(boundingRect.right, right_1);
                        bottom_1 = mathMax(boundingRect.bottom, bottom_1);
                        canvasList_1.push({
                            dom: canvas,
                            left: boundingRect.left,
                            top: boundingRect.top
                        });
                    }
                });
                left_1 *= dpr_1;
                top_1 *= dpr_1;
                right_1 *= dpr_1;
                bottom_1 *= dpr_1;
                var width = right_1 - left_1;
                var height = bottom_1 - top_1;
                var targetCanvas = (0, (0, parcelRequire("bahqM")).createCanvas)();
                var zr_1 = (0, parcelRequire("9Y5KT")).init(targetCanvas, {
                    renderer: isSvg ? 'svg' : 'canvas'
                });
                zr_1.resize({
                    width: width,
                    height: height
                });
                if (isSvg) {
                    var content_1 = '';
                    (0, (0, parcelRequire("bahqM")).each)(canvasList_1, function(item) {
                        var x = item.left - left_1;
                        var y = item.top - top_1;
                        content_1 += '<g transform="translate(' + x + ',' + y + ')">' + item.dom + '</g>';
                    });
                    zr_1.painter.getSvgRoot().innerHTML = content_1;
                    if (opts.connectedBackgroundColor) zr_1.painter.setBackgroundColor(opts.connectedBackgroundColor);
                    zr_1.refreshImmediately();
                    return zr_1.painter.toDataURL();
                } else {
                    if (opts.connectedBackgroundColor) zr_1.add(new (0, parcelRequire("7Tw7u")).default({
                        shape: {
                            x: 0,
                            y: 0,
                            width: width,
                            height: height
                        },
                        style: {
                            fill: opts.connectedBackgroundColor
                        }
                    }));
                    (0, (0, parcelRequire("bahqM")).each)(canvasList_1, function(item) {
                        var img = new (0, parcelRequire("gcbBH")).default({
                            style: {
                                x: item.left * dpr_1 - left_1,
                                y: item.top * dpr_1 - top_1,
                                image: item.dom
                            }
                        });
                        zr_1.add(img);
                    });
                    zr_1.refreshImmediately();
                    return targetCanvas.toDataURL('image/' + (opts && opts.type || 'png'));
                }
            } else return this.getDataURL(opts);
        };
        ECharts.prototype.convertToPixel = function(finder, value) {
            return $61f525521022d020$var$doConvertPixel(this, 'convertToPixel', finder, value);
        };
        ECharts.prototype.convertFromPixel = function(finder, value) {
            return $61f525521022d020$var$doConvertPixel(this, 'convertFromPixel', finder, value);
        };
        ECharts.prototype.containPixel = function(finder, value) {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            var ecModel = this._model;
            var result;
            var findResult = (0, parcelRequire("eaKsF")).parseFinder(ecModel, finder);
            (0, (0, parcelRequire("bahqM")).each)(findResult, function(models, key) {
                key.indexOf('Models') >= 0 && (0, (0, parcelRequire("bahqM")).each)(models, function(model) {
                    var coordSys = model.coordinateSystem;
                    if (coordSys && coordSys.containPoint) result = result || !!coordSys.containPoint(value);
                    else if (key === 'seriesModels') {
                        var view = this._chartsMap[model.__viewId];
                        if (view && view.containPoint) result = result || view.containPoint(value, model);
                    }
                }, this);
            }, this);
            return !!result;
        };
        ECharts.prototype.getVisual = function(finder, visualType) {
            var ecModel = this._model;
            var parsedFinder = (0, parcelRequire("eaKsF")).parseFinder(ecModel, finder, {
                defaultMainType: 'series'
            });
            var seriesModel = parsedFinder.seriesModel;
            var data = seriesModel.getData();
            var dataIndexInside = parsedFinder.hasOwnProperty('dataIndexInside') ? parsedFinder.dataIndexInside : parsedFinder.hasOwnProperty('dataIndex') ? data.indexOfRawIndex(parsedFinder.dataIndex) : null;
            return dataIndexInside != null ? (0, (0, parcelRequire("fk5Gm")).getItemVisualFromData)(data, dataIndexInside, visualType) : (0, (0, parcelRequire("fk5Gm")).getVisualFromData)(data, visualType);
        };
        ECharts.prototype.getViewOfComponentModel = function(componentModel) {
            return this._componentsMap[componentModel.__viewId];
        };
        ECharts.prototype.getViewOfSeriesModel = function(seriesModel) {
            return this._chartsMap[seriesModel.__viewId];
        };
        ECharts.prototype._initEvents = function() {
            var _this = this;
            (0, (0, parcelRequire("bahqM")).each)($61f525521022d020$var$MOUSE_EVENT_NAMES, function(eveName) {
                var handler = function(e) {
                    var ecModel = _this.getModel();
                    var el = e.target;
                    var params;
                    var isGlobalOut = eveName === 'globalout';
                    if (isGlobalOut) params = {};
                    else el && (0, (0, parcelRequire("6IsbX")).findEventDispatcher)(el, function(parent) {
                        var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(parent);
                        if (ecData && ecData.dataIndex != null) {
                            var dataModel = ecData.dataModel || ecModel.getSeriesByIndex(ecData.seriesIndex);
                            params = dataModel && dataModel.getDataParams(ecData.dataIndex, ecData.dataType) || {};
                            return true;
                        } else if (ecData.eventData) {
                            params = (0, (0, parcelRequire("bahqM")).extend)({}, ecData.eventData);
                            return true;
                        }
                    }, true);
                    if (params) {
                        var componentType = params.componentType;
                        var componentIndex = params.componentIndex;
                        if (componentType === 'markLine' || componentType === 'markPoint' || componentType === 'markArea') {
                            componentType = 'series';
                            componentIndex = params.seriesIndex;
                        }
                        var model = componentType && componentIndex != null && ecModel.getComponent(componentType, componentIndex);
                        var view = model && _this[model.mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId];
                        params.event = e;
                        params.type = eveName;
                        _this._$eventProcessor.eventInfo = {
                            targetEl: el,
                            packedEvent: params,
                            model: model,
                            view: view
                        };
                        _this.trigger(eveName, params);
                    }
                };
                handler.zrEventfulCallAtLast = true;
                _this._zr.on(eveName, handler, _this);
            });
            (0, (0, parcelRequire("bahqM")).each)($61f525521022d020$var$eventActionMap, function(actionType, eventType) {
                _this._messageCenter.on(eventType, function(event) {
                    this.trigger(eventType, event);
                }, _this);
            });
            (0, (0, parcelRequire("bahqM")).each)([
                'selectchanged'
            ], function(eventType) {
                _this._messageCenter.on(eventType, function(event) {
                    this.trigger(eventType, event);
                }, _this);
            });
            (0, (0, parcelRequire("1nKsD")).handleLegacySelectEvents)(this._messageCenter, this, this._api);
        };
        ECharts.prototype.isDisposed = function() {
            return this._disposed;
        };
        ECharts.prototype.clear = function() {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            this.setOption({
                series: []
            }, true);
        };
        ECharts.prototype.dispose = function() {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            this._disposed = true;
            (0, parcelRequire("eaKsF")).setAttribute(this.getDom(), $61f525521022d020$var$DOM_ATTRIBUTE_KEY, '');
            var chart = this;
            var api = chart._api;
            var ecModel = chart._model;
            (0, (0, parcelRequire("bahqM")).each)(chart._componentsViews, function(component) {
                component.dispose(ecModel, api);
            });
            (0, (0, parcelRequire("bahqM")).each)(chart._chartsViews, function(chart) {
                chart.dispose(ecModel, api);
            });
            chart._zr.dispose();
            chart._dom = chart._model = chart._chartsMap = chart._componentsMap = chart._chartsViews = chart._componentsViews = chart._scheduler = chart._api = chart._zr = chart._throttledZrFlush = chart._theme = chart._coordSysMgr = chart._messageCenter = null;
            delete $61f525521022d020$var$instances[chart.id];
        };
        ECharts.prototype.resize = function(opts) {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            this._zr.resize(opts);
            var ecModel = this._model;
            this._loadingFX && this._loadingFX.resize();
            if (!ecModel) return;
            var needPrepare = ecModel.resetOption('media');
            var silent = opts && opts.silent;
            if (this[$61f525521022d020$var$PENDING_UPDATE]) {
                if (silent == null) silent = this[$61f525521022d020$var$PENDING_UPDATE].silent;
                needPrepare = true;
                this[$61f525521022d020$var$PENDING_UPDATE] = null;
            }
            this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = true;
            needPrepare && $61f525521022d020$var$prepare(this);
            $61f525521022d020$var$updateMethods.update.call(this, {
                type: 'resize',
                animation: (0, (0, parcelRequire("bahqM")).extend)({
                    duration: 0
                }, opts && opts.animation)
            });
            this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = false;
            $61f525521022d020$var$flushPendingActions.call(this, silent);
            $61f525521022d020$var$triggerUpdatedEvent.call(this, silent);
        };
        ECharts.prototype.showLoading = function(name, cfg) {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            if ((0, (0, parcelRequire("bahqM")).isObject)(name)) {
                cfg = name;
                name = '';
            }
            name = name || 'default';
            this.hideLoading();
            if (!$61f525521022d020$var$loadingEffects[name]) return;
            var el = $61f525521022d020$var$loadingEffects[name](this._api, cfg);
            var zr = this._zr;
            this._loadingFX = el;
            zr.add(el);
        };
        ECharts.prototype.hideLoading = function() {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            this._loadingFX && this._zr.remove(this._loadingFX);
            this._loadingFX = null;
        };
        ECharts.prototype.makeActionFromEvent = function(eventObj) {
            var payload = (0, (0, parcelRequire("bahqM")).extend)({}, eventObj);
            payload.type = $61f525521022d020$var$eventActionMap[eventObj.type];
            return payload;
        };
        ECharts.prototype.dispatchAction = function(payload, opt) {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            if (!(0, (0, parcelRequire("bahqM")).isObject)(opt)) opt = {
                silent: !!opt
            };
            if (!$61f525521022d020$var$actions[payload.type]) return;
            if (!this._model) return;
            if (this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY]) {
                this._pendingActions.push(payload);
                return;
            }
            var silent = opt.silent;
            $61f525521022d020$var$doDispatchAction.call(this, payload, silent);
            var flush = opt.flush;
            if (flush) this._zr.flush();
            else if (flush !== false && (0, (0, parcelRequire("hZfwb")).default).browser.weChat) this._throttledZrFlush();
            $61f525521022d020$var$flushPendingActions.call(this, silent);
            $61f525521022d020$var$triggerUpdatedEvent.call(this, silent);
        };
        ECharts.prototype.updateLabelLayout = function() {
            (0, (0, parcelRequire("8cCW2")).default).trigger('series:layoutlabels', this._model, this._api, {
                updatedSeries: []
            });
        };
        ECharts.prototype.appendData = function(params) {
            if (this._disposed) {
                $61f525521022d020$var$disposedWarning(this.id);
                return;
            }
            var seriesIndex = params.seriesIndex;
            var ecModel = this.getModel();
            var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
            seriesModel.appendData(params);
            this._scheduler.unfinished = true;
            this.getZr().wakeUp();
        };
        ECharts.internalField = function() {
            $61f525521022d020$var$prepare = function(ecIns) {
                var scheduler = ecIns._scheduler;
                scheduler.restorePipelines(ecIns._model);
                scheduler.prepareStageTasks();
                $61f525521022d020$var$prepareView(ecIns, true);
                $61f525521022d020$var$prepareView(ecIns, false);
                scheduler.plan();
            };
            $61f525521022d020$var$prepareView = function(ecIns, isComponent) {
                var ecModel = ecIns._model;
                var scheduler = ecIns._scheduler;
                var viewList = isComponent ? ecIns._componentsViews : ecIns._chartsViews;
                var viewMap = isComponent ? ecIns._componentsMap : ecIns._chartsMap;
                var zr = ecIns._zr;
                var api = ecIns._api;
                for(var i = 0; i < viewList.length; i++)viewList[i].__alive = false;
                isComponent ? ecModel.eachComponent(function(componentType, model) {
                    componentType !== 'series' && doPrepare(model);
                }) : ecModel.eachSeries(doPrepare);
                function doPrepare(model) {
                    var requireNewView = model.__requireNewView;
                    model.__requireNewView = false;
                    var viewId = '_ec_' + model.id + '_' + model.type;
                    var view = !requireNewView && viewMap[viewId];
                    if (!view) {
                        var classType = (0, (0, parcelRequire("aLwh0")).parseClassType)(model.type);
                        var Clazz = isComponent ? (0, (0, parcelRequire("fkskt")).default).getClass(classType.main, classType.sub) : (0, (0, parcelRequire("loerw")).default).getClass(classType.sub);
                        view = new Clazz();
                        view.init(ecModel, api);
                        viewMap[viewId] = view;
                        viewList.push(view);
                        zr.add(view.group);
                    }
                    model.__viewId = view.__id = viewId;
                    view.__alive = true;
                    view.__model = model;
                    view.group.__ecComponentInfo = {
                        mainType: model.mainType,
                        index: model.componentIndex
                    };
                    !isComponent && scheduler.prepareView(view, model, ecModel, api);
                }
                for(var i = 0; i < viewList.length;){
                    var view = viewList[i];
                    if (!view.__alive) {
                        !isComponent && view.renderTask.dispose();
                        zr.remove(view.group);
                        view.dispose(ecModel, api);
                        viewList.splice(i, 1);
                        if (viewMap[view.__id] === view) delete viewMap[view.__id];
                        view.__id = view.group.__ecComponentInfo = null;
                    } else i++;
                }
            };
            $61f525521022d020$var$updateDirectly = function(ecIns, method, payload, mainType, subType) {
                var ecModel = ecIns._model;
                ecModel.setUpdatePayload(payload);
                if (!mainType) {
                    (0, (0, parcelRequire("bahqM")).each)([].concat(ecIns._componentsViews).concat(ecIns._chartsViews), callView);
                    return;
                }
                var query = {};
                query[mainType + 'Id'] = payload[mainType + 'Id'];
                query[mainType + 'Index'] = payload[mainType + 'Index'];
                query[mainType + 'Name'] = payload[mainType + 'Name'];
                var condition = {
                    mainType: mainType,
                    query: query
                };
                subType && (condition.subType = subType);
                var excludeSeriesId = payload.excludeSeriesId;
                var excludeSeriesIdMap;
                if (excludeSeriesId != null) {
                    excludeSeriesIdMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
                    (0, (0, parcelRequire("bahqM")).each)((0, parcelRequire("eaKsF")).normalizeToArray(excludeSeriesId), function(id) {
                        var modelId = (0, parcelRequire("eaKsF")).convertOptionIdName(id, null);
                        if (modelId != null) excludeSeriesIdMap.set(modelId, true);
                    });
                }
                if ((0, (0, parcelRequire("fIXXx")).isHighDownPayload)(payload)) (0, (0, parcelRequire("fIXXx")).allLeaveBlur)(ecIns._api);
                ecModel && ecModel.eachComponent(condition, function(model) {
                    var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) !== null;
                    if (isExcluded) return;
                    if ((0, (0, parcelRequire("fIXXx")).isHighDownPayload)(payload)) {
                        if (model instanceof (0, (0, parcelRequire("1O7Ua")).default)) {
                            if (payload.type === (0, (0, parcelRequire("fIXXx")).HIGHLIGHT_ACTION_TYPE) && !payload.notBlur) (0, (0, parcelRequire("fIXXx")).blurSeriesFromHighlightPayload)(model, payload, ecIns._api);
                        } else {
                            var _a = (0, (0, parcelRequire("fIXXx")).findComponentHighDownDispatchers)(model.mainType, model.componentIndex, payload.name, ecIns._api), focusSelf = _a.focusSelf, dispatchers = _a.dispatchers;
                            if (payload.type === (0, (0, parcelRequire("fIXXx")).HIGHLIGHT_ACTION_TYPE) && focusSelf && !payload.notBlur) (0, (0, parcelRequire("fIXXx")).blurComponent)(model.mainType, model.componentIndex, ecIns._api);
                            if (dispatchers) (0, (0, parcelRequire("bahqM")).each)(dispatchers, function(dispatcher) {
                                payload.type === (0, (0, parcelRequire("fIXXx")).HIGHLIGHT_ACTION_TYPE) ? (0, (0, parcelRequire("fIXXx")).enterEmphasis)(dispatcher) : (0, (0, parcelRequire("fIXXx")).leaveEmphasis)(dispatcher);
                            });
                        }
                    } else if ((0, (0, parcelRequire("fIXXx")).isSelectChangePayload)(payload)) {
                        if (model instanceof (0, (0, parcelRequire("1O7Ua")).default)) {
                            (0, (0, parcelRequire("fIXXx")).toggleSelectionFromPayload)(model, payload, ecIns._api);
                            (0, (0, parcelRequire("fIXXx")).updateSeriesElementSelection)(model);
                            $61f525521022d020$var$markStatusToUpdate(ecIns);
                        }
                    }
                }, ecIns);
                ecModel && ecModel.eachComponent(condition, function(model) {
                    var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) !== null;
                    if (isExcluded) return;
                    callView(ecIns[mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId]);
                }, ecIns);
                function callView(view) {
                    view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
                }
            };
            $61f525521022d020$var$updateMethods = {
                prepareAndUpdate: function(payload) {
                    $61f525521022d020$var$prepare(this);
                    $61f525521022d020$var$updateMethods.update.call(this, payload, {
                        optionChanged: payload.newOption != null
                    });
                },
                update: function(payload, updateParams) {
                    var ecModel = this._model;
                    var api = this._api;
                    var zr = this._zr;
                    var coordSysMgr = this._coordSysMgr;
                    var scheduler = this._scheduler;
                    if (!ecModel) return;
                    ecModel.setUpdatePayload(payload);
                    scheduler.restoreData(ecModel, payload);
                    scheduler.performSeriesTasks(ecModel);
                    coordSysMgr.create(ecModel, api);
                    scheduler.performDataProcessorTasks(ecModel, payload);
                    $61f525521022d020$var$updateStreamModes(this, ecModel);
                    coordSysMgr.update(ecModel, api);
                    $61f525521022d020$var$clearColorPalette(ecModel);
                    scheduler.performVisualTasks(ecModel, payload);
                    $61f525521022d020$var$render(this, ecModel, api, payload, updateParams);
                    var backgroundColor = ecModel.get('backgroundColor') || 'transparent';
                    var darkMode = ecModel.get('darkMode');
                    if (!(0, (0, parcelRequire("hZfwb")).default).canvasSupported) {
                        var colorArr = (0, parcelRequire("d6udH")).parse(backgroundColor);
                        backgroundColor = (0, parcelRequire("d6udH")).stringify(colorArr, 'rgb');
                        if (colorArr[3] === 0) backgroundColor = 'transparent';
                    } else {
                        zr.setBackgroundColor(backgroundColor);
                        if (darkMode != null && darkMode !== 'auto') zr.setDarkMode(darkMode);
                    }
                    (0, (0, parcelRequire("8cCW2")).default).trigger('afterupdate', ecModel, api);
                },
                updateTransform: function(payload) {
                    var _this = this;
                    var ecModel = this._model;
                    var api = this._api;
                    if (!ecModel) return;
                    ecModel.setUpdatePayload(payload);
                    var componentDirtyList = [];
                    ecModel.eachComponent(function(componentType, componentModel) {
                        if (componentType === 'series') return;
                        var componentView = _this.getViewOfComponentModel(componentModel);
                        if (componentView && componentView.__alive) {
                            if (componentView.updateTransform) {
                                var result = componentView.updateTransform(componentModel, ecModel, api, payload);
                                result && result.update && componentDirtyList.push(componentView);
                            } else componentDirtyList.push(componentView);
                        }
                    });
                    var seriesDirtyMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
                    ecModel.eachSeries(function(seriesModel) {
                        var chartView = _this._chartsMap[seriesModel.__viewId];
                        if (chartView.updateTransform) {
                            var result = chartView.updateTransform(seriesModel, ecModel, api, payload);
                            result && result.update && seriesDirtyMap.set(seriesModel.uid, 1);
                        } else seriesDirtyMap.set(seriesModel.uid, 1);
                    });
                    $61f525521022d020$var$clearColorPalette(ecModel);
                    this._scheduler.performVisualTasks(ecModel, payload, {
                        setDirty: true,
                        dirtyMap: seriesDirtyMap
                    });
                    $61f525521022d020$var$renderSeries(this, ecModel, api, payload, {}, seriesDirtyMap);
                    (0, (0, parcelRequire("8cCW2")).default).trigger('afterupdate', ecModel, api);
                },
                updateView: function(payload) {
                    var ecModel = this._model;
                    if (!ecModel) return;
                    ecModel.setUpdatePayload(payload);
                    (0, (0, parcelRequire("loerw")).default).markUpdateMethod(payload, 'updateView');
                    $61f525521022d020$var$clearColorPalette(ecModel);
                    this._scheduler.performVisualTasks(ecModel, payload, {
                        setDirty: true
                    });
                    $61f525521022d020$var$render(this, ecModel, this._api, payload, {});
                    (0, (0, parcelRequire("8cCW2")).default).trigger('afterupdate', ecModel, this._api);
                },
                updateVisual: function(payload) {
                    var _this = this;
                    var ecModel = this._model;
                    if (!ecModel) return;
                    ecModel.setUpdatePayload(payload);
                    ecModel.eachSeries(function(seriesModel) {
                        seriesModel.getData().clearAllVisual();
                    });
                    (0, (0, parcelRequire("loerw")).default).markUpdateMethod(payload, 'updateVisual');
                    $61f525521022d020$var$clearColorPalette(ecModel);
                    this._scheduler.performVisualTasks(ecModel, payload, {
                        visualType: 'visual',
                        setDirty: true
                    });
                    ecModel.eachComponent(function(componentType, componentModel) {
                        if (componentType !== 'series') {
                            var componentView = _this.getViewOfComponentModel(componentModel);
                            componentView && componentView.__alive && componentView.updateVisual(componentModel, ecModel, _this._api, payload);
                        }
                    });
                    ecModel.eachSeries(function(seriesModel) {
                        var chartView = _this._chartsMap[seriesModel.__viewId];
                        chartView.updateVisual(seriesModel, ecModel, _this._api, payload);
                    });
                    (0, (0, parcelRequire("8cCW2")).default).trigger('afterupdate', ecModel, this._api);
                },
                updateLayout: function(payload) {
                    $61f525521022d020$var$updateMethods.update.call(this, payload);
                }
            };
            $61f525521022d020$var$doConvertPixel = function(ecIns, methodName, finder, value) {
                if (ecIns._disposed) {
                    $61f525521022d020$var$disposedWarning(ecIns.id);
                    return;
                }
                var ecModel = ecIns._model;
                var coordSysList = ecIns._coordSysMgr.getCoordinateSystems();
                var result;
                var parsedFinder = (0, parcelRequire("eaKsF")).parseFinder(ecModel, finder);
                for(var i = 0; i < coordSysList.length; i++){
                    var coordSys = coordSysList[i];
                    if (coordSys[methodName] && (result = coordSys[methodName](ecModel, parsedFinder, value)) != null) return result;
                }
            };
            $61f525521022d020$var$updateStreamModes = function(ecIns, ecModel) {
                var chartsMap = ecIns._chartsMap;
                var scheduler = ecIns._scheduler;
                ecModel.eachSeries(function(seriesModel) {
                    scheduler.updateStreamModes(seriesModel, chartsMap[seriesModel.__viewId]);
                });
            };
            $61f525521022d020$var$doDispatchAction = function(payload, silent) {
                var _this = this;
                var ecModel = this.getModel();
                var payloadType = payload.type;
                var escapeConnect = payload.escapeConnect;
                var actionWrap = $61f525521022d020$var$actions[payloadType];
                var actionInfo = actionWrap.actionInfo;
                var cptTypeTmp = (actionInfo.update || 'update').split(':');
                var updateMethod = cptTypeTmp.pop();
                var cptType = cptTypeTmp[0] != null && (0, (0, parcelRequire("aLwh0")).parseClassType)(cptTypeTmp[0]);
                this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = true;
                var payloads = [
                    payload
                ];
                var batched = false;
                if (payload.batch) {
                    batched = true;
                    payloads = (0, (0, parcelRequire("bahqM")).map)(payload.batch, function(item) {
                        item = (0, (0, parcelRequire("bahqM")).defaults)((0, (0, parcelRequire("bahqM")).extend)({}, item), payload);
                        item.batch = null;
                        return item;
                    });
                }
                var eventObjBatch = [];
                var eventObj;
                var isSelectChange = (0, (0, parcelRequire("fIXXx")).isSelectChangePayload)(payload);
                var isHighDown = (0, (0, parcelRequire("fIXXx")).isHighDownPayload)(payload);
                (0, (0, parcelRequire("bahqM")).each)(payloads, function(batchItem) {
                    eventObj = actionWrap.action(batchItem, _this._model, _this._api);
                    eventObj = eventObj || (0, (0, parcelRequire("bahqM")).extend)({}, batchItem);
                    eventObj.type = actionInfo.event || eventObj.type;
                    eventObjBatch.push(eventObj);
                    if (isHighDown) {
                        var _a = (0, parcelRequire("eaKsF")).preParseFinder(payload), queryOptionMap = _a.queryOptionMap, mainTypeSpecified = _a.mainTypeSpecified;
                        var componentMainType = mainTypeSpecified ? queryOptionMap.keys()[0] : 'series';
                        $61f525521022d020$var$updateDirectly(_this, updateMethod, batchItem, componentMainType);
                        $61f525521022d020$var$markStatusToUpdate(_this);
                    } else if (isSelectChange) {
                        $61f525521022d020$var$updateDirectly(_this, updateMethod, batchItem, 'series');
                        $61f525521022d020$var$markStatusToUpdate(_this);
                    } else if (cptType) $61f525521022d020$var$updateDirectly(_this, updateMethod, batchItem, cptType.main, cptType.sub);
                });
                if (updateMethod !== 'none' && !isHighDown && !isSelectChange && !cptType) {
                    if (this[$61f525521022d020$var$PENDING_UPDATE]) {
                        $61f525521022d020$var$prepare(this);
                        $61f525521022d020$var$updateMethods.update.call(this, payload);
                        this[$61f525521022d020$var$PENDING_UPDATE] = null;
                    } else $61f525521022d020$var$updateMethods[updateMethod].call(this, payload);
                }
                if (batched) eventObj = {
                    type: actionInfo.event || payloadType,
                    escapeConnect: escapeConnect,
                    batch: eventObjBatch
                };
                else eventObj = eventObjBatch[0];
                this[$61f525521022d020$var$IN_MAIN_PROCESS_KEY] = false;
                if (!silent) {
                    var messageCenter = this._messageCenter;
                    messageCenter.trigger(eventObj.type, eventObj);
                    if (isSelectChange) {
                        var newObj = {
                            type: 'selectchanged',
                            escapeConnect: escapeConnect,
                            selected: (0, (0, parcelRequire("fIXXx")).getAllSelectedIndices)(ecModel),
                            isFromClick: payload.isFromClick || false,
                            fromAction: payload.type,
                            fromActionPayload: payload
                        };
                        messageCenter.trigger(newObj.type, newObj);
                    }
                }
            };
            $61f525521022d020$var$flushPendingActions = function(silent) {
                var pendingActions = this._pendingActions;
                while(pendingActions.length){
                    var payload = pendingActions.shift();
                    $61f525521022d020$var$doDispatchAction.call(this, payload, silent);
                }
            };
            $61f525521022d020$var$triggerUpdatedEvent = function(silent) {
                !silent && this.trigger('updated');
            };
            $61f525521022d020$var$bindRenderedEvent = function(zr, ecIns) {
                zr.on('rendered', function(params) {
                    ecIns.trigger('rendered', params);
                    if (zr.animation.isFinished() && !ecIns[$61f525521022d020$var$PENDING_UPDATE] && !ecIns._scheduler.unfinished && !ecIns._pendingActions.length) ecIns.trigger('finished');
                });
            };
            $61f525521022d020$var$bindMouseEvent = function(zr, ecIns) {
                zr.on('mouseover', function(e) {
                    var el = e.target;
                    var dispatcher = (0, (0, parcelRequire("6IsbX")).findEventDispatcher)(el, (0, (0, parcelRequire("fIXXx")).isHighDownDispatcher));
                    if (dispatcher) {
                        (0, (0, parcelRequire("fIXXx")).handleGlobalMouseOverForHighDown)(dispatcher, e, ecIns._api);
                        $61f525521022d020$var$markStatusToUpdate(ecIns);
                    }
                }).on('mouseout', function(e) {
                    var el = e.target;
                    var dispatcher = (0, (0, parcelRequire("6IsbX")).findEventDispatcher)(el, (0, (0, parcelRequire("fIXXx")).isHighDownDispatcher));
                    if (dispatcher) {
                        (0, (0, parcelRequire("fIXXx")).handleGlboalMouseOutForHighDown)(dispatcher, e, ecIns._api);
                        $61f525521022d020$var$markStatusToUpdate(ecIns);
                    }
                }).on('click', function(e) {
                    var el = e.target;
                    var dispatcher = (0, (0, parcelRequire("6IsbX")).findEventDispatcher)(el, function(target) {
                        return (0, (0, parcelRequire("7QjoM")).getECData)(target).dataIndex != null;
                    }, true);
                    if (dispatcher) {
                        var actionType = dispatcher.selected ? 'unselect' : 'select';
                        var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(dispatcher);
                        ecIns._api.dispatchAction({
                            type: actionType,
                            dataType: ecData.dataType,
                            dataIndexInside: ecData.dataIndex,
                            seriesIndex: ecData.seriesIndex,
                            isFromClick: true
                        });
                    }
                });
            };
            $61f525521022d020$var$clearColorPalette = function(ecModel) {
                ecModel.clearColorPalette();
                ecModel.eachSeries(function(seriesModel) {
                    seriesModel.clearColorPalette();
                });
            };
            $61f525521022d020$var$render = function(ecIns, ecModel, api, payload, updateParams) {
                $61f525521022d020$var$renderComponents(ecIns, ecModel, api, payload, updateParams);
                (0, (0, parcelRequire("bahqM")).each)(ecIns._chartsViews, function(chart) {
                    chart.__alive = false;
                });
                $61f525521022d020$var$renderSeries(ecIns, ecModel, api, payload, updateParams);
                (0, (0, parcelRequire("bahqM")).each)(ecIns._chartsViews, function(chart) {
                    if (!chart.__alive) chart.remove(ecModel, api);
                });
            };
            $61f525521022d020$var$renderComponents = function(ecIns, ecModel, api, payload, updateParams, dirtyList) {
                (0, (0, parcelRequire("bahqM")).each)(dirtyList || ecIns._componentsViews, function(componentView) {
                    var componentModel = componentView.__model;
                    clearStates(componentModel, componentView);
                    componentView.render(componentModel, ecModel, api, payload);
                    updateZ(componentModel, componentView);
                    updateStates(componentModel, componentView);
                });
            };
            $61f525521022d020$var$renderSeries = function(ecIns, ecModel, api, payload, updateParams, dirtyMap) {
                var scheduler = ecIns._scheduler;
                updateParams = (0, (0, parcelRequire("bahqM")).extend)(updateParams || {}, {
                    updatedSeries: ecModel.getSeries()
                });
                (0, (0, parcelRequire("8cCW2")).default).trigger('series:beforeupdate', ecModel, api, updateParams);
                var unfinished = false;
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = ecIns._chartsMap[seriesModel.__viewId];
                    chartView.__alive = true;
                    var renderTask = chartView.renderTask;
                    scheduler.updatePayload(renderTask, payload);
                    clearStates(seriesModel, chartView);
                    if (dirtyMap && dirtyMap.get(seriesModel.uid)) renderTask.dirty();
                    if (renderTask.perform(scheduler.getPerformArgs(renderTask))) unfinished = true;
                    chartView.group.silent = !!seriesModel.get('silent');
                    updateBlend(seriesModel, chartView);
                    (0, (0, parcelRequire("fIXXx")).updateSeriesElementSelection)(seriesModel);
                });
                scheduler.unfinished = unfinished || scheduler.unfinished;
                (0, (0, parcelRequire("8cCW2")).default).trigger('series:layoutlabels', ecModel, api, updateParams);
                (0, (0, parcelRequire("8cCW2")).default).trigger('series:transition', ecModel, api, updateParams);
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = ecIns._chartsMap[seriesModel.__viewId];
                    updateZ(seriesModel, chartView);
                    updateStates(seriesModel, chartView);
                });
                updateHoverLayerStatus(ecIns, ecModel);
                (0, (0, parcelRequire("8cCW2")).default).trigger('series:afterupdate', ecModel, api, updateParams);
            };
            $61f525521022d020$var$markStatusToUpdate = function(ecIns) {
                ecIns[$61f525521022d020$var$STATUS_NEEDS_UPDATE_KEY] = true;
                ecIns.getZr().wakeUp();
            };
            $61f525521022d020$var$applyChangedStates = function(ecIns) {
                if (!ecIns[$61f525521022d020$var$STATUS_NEEDS_UPDATE_KEY]) return;
                ecIns.getZr().storage.traverse(function(el) {
                    if ((0, parcelRequire("eYgMC")).isElementRemoved(el)) return;
                    applyElementStates(el);
                });
                ecIns[$61f525521022d020$var$STATUS_NEEDS_UPDATE_KEY] = false;
            };
            function applyElementStates(el) {
                var newStates = [];
                var oldStates = el.currentStates;
                for(var i = 0; i < oldStates.length; i++){
                    var stateName = oldStates[i];
                    if (!(stateName === 'emphasis' || stateName === 'blur' || stateName === 'select')) newStates.push(stateName);
                }
                if (el.selected && el.states.select) newStates.push('select');
                if (el.hoverState === (0, (0, parcelRequire("fIXXx")).HOVER_STATE_EMPHASIS) && el.states.emphasis) newStates.push('emphasis');
                else if (el.hoverState === (0, (0, parcelRequire("fIXXx")).HOVER_STATE_BLUR) && el.states.blur) newStates.push('blur');
                el.useStates(newStates);
            }
            function updateHoverLayerStatus(ecIns, ecModel) {
                var zr = ecIns._zr;
                var storage = zr.storage;
                var elCount = 0;
                storage.traverse(function(el) {
                    if (!el.isGroup) elCount++;
                });
                if (elCount > ecModel.get('hoverLayerThreshold') && !(0, (0, parcelRequire("hZfwb")).default).node && !(0, (0, parcelRequire("hZfwb")).default).worker) ecModel.eachSeries(function(seriesModel) {
                    if (seriesModel.preventUsingHoverLayer) return;
                    var chartView = ecIns._chartsMap[seriesModel.__viewId];
                    if (chartView.__alive) chartView.group.traverse(function(el) {
                        if (el.states.emphasis) el.states.emphasis.hoverLayer = true;
                    });
                });
            }
            function updateBlend(seriesModel, chartView) {
                var blendMode = seriesModel.get('blendMode') || null;
                chartView.group.traverse(function(el) {
                    if (!el.isGroup) el.style.blend = blendMode;
                    if (el.eachPendingDisplayable) el.eachPendingDisplayable(function(displayable) {
                        displayable.style.blend = blendMode;
                    });
                });
            }
            function updateZ(model, view) {
                if (model.preventAutoZ) return;
                _updateZ(view.group, model.get('z') || 0, model.get('zlevel') || 0, -Infinity);
            }
            function _updateZ(el, z, zlevel, maxZ2) {
                var label = el.getTextContent();
                var labelLine = el.getTextGuideLine();
                var isGroup = el.isGroup;
                if (isGroup) {
                    var children = el.childrenRef();
                    for(var i = 0; i < children.length; i++)maxZ2 = Math.max(_updateZ(children[i], z, zlevel, maxZ2), maxZ2);
                } else {
                    el.z = z;
                    el.zlevel = zlevel;
                    maxZ2 = Math.max(el.z2, maxZ2);
                }
                if (label) {
                    label.z = z;
                    label.zlevel = zlevel;
                    isFinite(maxZ2) && (label.z2 = maxZ2 + 2);
                }
                if (labelLine) {
                    var textGuideLineConfig = el.textGuideLineConfig;
                    labelLine.z = z;
                    labelLine.zlevel = zlevel;
                    isFinite(maxZ2) && (labelLine.z2 = maxZ2 + (textGuideLineConfig && textGuideLineConfig.showAbove ? 1 : -1));
                }
                return maxZ2;
            }
            function clearStates(model, view) {
                view.group.traverse(function(el) {
                    if ((0, parcelRequire("eYgMC")).isElementRemoved(el)) return;
                    var textContent = el.getTextContent();
                    var textGuide = el.getTextGuideLine();
                    if (el.stateTransition) el.stateTransition = null;
                    if (textContent && textContent.stateTransition) textContent.stateTransition = null;
                    if (textGuide && textGuide.stateTransition) textGuide.stateTransition = null;
                    if (el.hasState()) {
                        el.prevStates = el.currentStates;
                        el.clearStates();
                    } else if (el.prevStates) el.prevStates = null;
                });
            }
            function updateStates(model, view) {
                var stateAnimationModel = model.getModel('stateAnimation');
                var enableAnimation = model.isAnimationEnabled();
                var duration = stateAnimationModel.get('duration');
                var stateTransition = duration > 0 ? {
                    duration: duration,
                    delay: stateAnimationModel.get('delay'),
                    easing: stateAnimationModel.get('easing')
                } : null;
                view.group.traverse(function(el) {
                    if (el.states && el.states.emphasis) {
                        if ((0, parcelRequire("eYgMC")).isElementRemoved(el)) return;
                        if (el instanceof (0, parcelRequire("ghQ8v")).default) (0, (0, parcelRequire("fIXXx")).savePathStates)(el);
                        if (el.__dirty) {
                            var prevStates = el.prevStates;
                            if (prevStates) el.useStates(prevStates);
                        }
                        if (enableAnimation) {
                            el.stateTransition = stateTransition;
                            var textContent = el.getTextContent();
                            var textGuide = el.getTextGuideLine();
                            if (textContent) textContent.stateTransition = stateTransition;
                            if (textGuide) textGuide.stateTransition = stateTransition;
                        }
                        if (el.__dirty) applyElementStates(el);
                    }
                });
            }
            $61f525521022d020$var$createExtensionAPI = function(ecIns) {
                return new (function(_super) {
                    (0, (0, parcelRequire("3VFsf")).__extends)(class_1, _super);
                    function class_1() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    class_1.prototype.getCoordinateSystems = function() {
                        return ecIns._coordSysMgr.getCoordinateSystems();
                    };
                    class_1.prototype.getComponentByElement = function(el) {
                        while(el){
                            var modelInfo = el.__ecComponentInfo;
                            if (modelInfo != null) return ecIns._model.getComponent(modelInfo.mainType, modelInfo.index);
                            el = el.parent;
                        }
                    };
                    class_1.prototype.enterEmphasis = function(el, highlightDigit) {
                        (0, (0, parcelRequire("fIXXx")).enterEmphasis)(el, highlightDigit);
                        $61f525521022d020$var$markStatusToUpdate(ecIns);
                    };
                    class_1.prototype.leaveEmphasis = function(el, highlightDigit) {
                        (0, (0, parcelRequire("fIXXx")).leaveEmphasis)(el, highlightDigit);
                        $61f525521022d020$var$markStatusToUpdate(ecIns);
                    };
                    class_1.prototype.enterBlur = function(el) {
                        (0, (0, parcelRequire("fIXXx")).enterBlur)(el);
                        $61f525521022d020$var$markStatusToUpdate(ecIns);
                    };
                    class_1.prototype.leaveBlur = function(el) {
                        (0, (0, parcelRequire("fIXXx")).leaveBlur)(el);
                        $61f525521022d020$var$markStatusToUpdate(ecIns);
                    };
                    class_1.prototype.enterSelect = function(el) {
                        (0, (0, parcelRequire("fIXXx")).enterSelect)(el);
                        $61f525521022d020$var$markStatusToUpdate(ecIns);
                    };
                    class_1.prototype.leaveSelect = function(el) {
                        (0, (0, parcelRequire("fIXXx")).leaveSelect)(el);
                        $61f525521022d020$var$markStatusToUpdate(ecIns);
                    };
                    class_1.prototype.getModel = function() {
                        return ecIns.getModel();
                    };
                    class_1.prototype.getViewOfComponentModel = function(componentModel) {
                        return ecIns.getViewOfComponentModel(componentModel);
                    };
                    class_1.prototype.getViewOfSeriesModel = function(seriesModel) {
                        return ecIns.getViewOfSeriesModel(seriesModel);
                    };
                    return class_1;
                }((0, (0, parcelRequire("iEvqc")).default)))(ecIns);
            };
            $61f525521022d020$var$enableConnect = function(chart) {
                function updateConnectedChartsStatus(charts, status) {
                    for(var i = 0; i < charts.length; i++){
                        var otherChart = charts[i];
                        otherChart[$61f525521022d020$var$CONNECT_STATUS_KEY] = status;
                    }
                }
                (0, (0, parcelRequire("bahqM")).each)($61f525521022d020$var$eventActionMap, function(actionType, eventType) {
                    chart._messageCenter.on(eventType, function(event) {
                        if ($61f525521022d020$var$connectedGroups[chart.group] && chart[$61f525521022d020$var$CONNECT_STATUS_KEY] !== $61f525521022d020$var$CONNECT_STATUS_PENDING) {
                            if (event && event.escapeConnect) return;
                            var action_1 = chart.makeActionFromEvent(event);
                            var otherCharts_1 = [];
                            (0, (0, parcelRequire("bahqM")).each)($61f525521022d020$var$instances, function(otherChart) {
                                if (otherChart !== chart && otherChart.group === chart.group) otherCharts_1.push(otherChart);
                            });
                            updateConnectedChartsStatus(otherCharts_1, $61f525521022d020$var$CONNECT_STATUS_PENDING);
                            (0, (0, parcelRequire("bahqM")).each)(otherCharts_1, function(otherChart) {
                                if (otherChart[$61f525521022d020$var$CONNECT_STATUS_KEY] !== $61f525521022d020$var$CONNECT_STATUS_UPDATING) otherChart.dispatchAction(action_1);
                            });
                            updateConnectedChartsStatus(otherCharts_1, $61f525521022d020$var$CONNECT_STATUS_UPDATED);
                        }
                    });
                });
            };
        }();
        return ECharts;
    }((0, (0, parcelRequire("bRKv5")).default));
    var $61f525521022d020$var$echartsProto = $61f525521022d020$var$ECharts.prototype;
    $61f525521022d020$var$echartsProto.on = $61f525521022d020$var$createRegisterEventWithLowercaseECharts('on');
    $61f525521022d020$var$echartsProto.off = $61f525521022d020$var$createRegisterEventWithLowercaseECharts('off');
    $61f525521022d020$var$echartsProto.one = function(eventName, cb, ctx) {
        var self = this;
        (0, (0, parcelRequire("2cFRc")).deprecateLog)('ECharts#one is deprecated.');
        function wrapped() {
            var args2 = [];
            for(var _i = 0; _i < arguments.length; _i++)args2[_i] = arguments[_i];
            cb && cb.apply && cb.apply(this, args2);
            self.off(eventName, wrapped);
        }
        this.on.call(this, eventName, wrapped, ctx);
    };
    var $61f525521022d020$var$MOUSE_EVENT_NAMES = [
        'click',
        'dblclick',
        'mouseover',
        'mouseout',
        'mousemove',
        'mousedown',
        'mouseup',
        'globalout',
        'contextmenu'
    ];
    function $61f525521022d020$var$disposedWarning(id) {}
    var $61f525521022d020$var$actions = {};
    var $61f525521022d020$var$eventActionMap = {};
    var $61f525521022d020$var$dataProcessorFuncs = [];
    var $61f525521022d020$var$optionPreprocessorFuncs = [];
    var $61f525521022d020$var$visualFuncs = [];
    var $61f525521022d020$var$themeStorage = {};
    var $61f525521022d020$var$loadingEffects = {};
    var $61f525521022d020$var$instances = {};
    var $61f525521022d020$var$connectedGroups = {};
    var $61f525521022d020$var$idBase = +new Date() - 0;
    var $61f525521022d020$var$groupIdBase = +new Date() - 0;
    var $61f525521022d020$var$DOM_ATTRIBUTE_KEY = '_echarts_instance_';
    function $61f525521022d020$export$2cd8252107eb640b(dom, theme, opts) {
        var existInstance = $61f525521022d020$export$33b6fbccd4f643f8(dom);
        if (existInstance) return existInstance;
        var chart = new $61f525521022d020$var$ECharts(dom, theme, opts);
        chart.id = 'ec_' + $61f525521022d020$var$idBase++;
        $61f525521022d020$var$instances[chart.id] = chart;
        (0, parcelRequire("eaKsF")).setAttribute(dom, $61f525521022d020$var$DOM_ATTRIBUTE_KEY, chart.id);
        $61f525521022d020$var$enableConnect(chart);
        (0, (0, parcelRequire("8cCW2")).default).trigger('afterinit', chart);
        return chart;
    }
    function $61f525521022d020$export$64605811ab45167f(groupId) {
        if ((0, (0, parcelRequire("bahqM")).isArray)(groupId)) {
            var charts = groupId;
            groupId = null;
            (0, (0, parcelRequire("bahqM")).each)(charts, function(chart) {
                if (chart.group != null) groupId = chart.group;
            });
            groupId = groupId || 'g_' + $61f525521022d020$var$groupIdBase++;
            (0, (0, parcelRequire("bahqM")).each)(charts, function(chart) {
                chart.group = groupId;
            });
        }
        $61f525521022d020$var$connectedGroups[groupId] = true;
        return groupId;
    }
    function $61f525521022d020$export$87cd6834112ecb52(groupId) {
        $61f525521022d020$var$connectedGroups[groupId] = false;
    }
    var $61f525521022d020$export$37dfea93db2e14ed = $61f525521022d020$export$87cd6834112ecb52;
    function $61f525521022d020$export$fcfbbcec2cb820d5(chart) {
        if (typeof chart === 'string') chart = $61f525521022d020$var$instances[chart];
        else if (!(chart instanceof $61f525521022d020$var$ECharts)) chart = $61f525521022d020$export$33b6fbccd4f643f8(chart);
        if (chart instanceof $61f525521022d020$var$ECharts && !chart.isDisposed()) chart.dispose();
    }
    function $61f525521022d020$export$33b6fbccd4f643f8(dom) {
        return $61f525521022d020$var$instances[(0, parcelRequire("eaKsF")).getAttribute(dom, $61f525521022d020$var$DOM_ATTRIBUTE_KEY)];
    }
    function $61f525521022d020$export$89b4be35062c4a3f(key) {
        return $61f525521022d020$var$instances[key];
    }
    function $61f525521022d020$export$f9c59eed5de5ff80(name, theme) {
        $61f525521022d020$var$themeStorage[name] = theme;
    }
    function $61f525521022d020$export$77095792a057b768(preprocessorFunc) {
        if ((0, (0, parcelRequire("bahqM")).indexOf)($61f525521022d020$var$optionPreprocessorFuncs, preprocessorFunc) < 0) $61f525521022d020$var$optionPreprocessorFuncs.push(preprocessorFunc);
    }
    function $61f525521022d020$export$d575e6557ac1729f(priority, processor) {
        $61f525521022d020$var$normalizeRegister($61f525521022d020$var$dataProcessorFuncs, priority, processor, $61f525521022d020$var$PRIORITY_PROCESSOR_DEFAULT);
    }
    function $61f525521022d020$export$c8c249911ee8c1ed(postInitFunc) {
        $61f525521022d020$export$c9ec4b5faef04865('afterinit', postInitFunc);
    }
    function $61f525521022d020$export$99560909c18c76bb(postUpdateFunc) {
        $61f525521022d020$export$c9ec4b5faef04865('afterupdate', postUpdateFunc);
    }
    function $61f525521022d020$export$c9ec4b5faef04865(name, cb) {
        (0, (0, parcelRequire("8cCW2")).default).on(name, cb);
    }
    function $61f525521022d020$export$408c24786cd729c6(actionInfo, eventName, action) {
        if (typeof eventName === 'function') {
            action = eventName;
            eventName = '';
        }
        var actionType = (0, (0, parcelRequire("bahqM")).isObject)(actionInfo) ? actionInfo.type : [
            actionInfo,
            actionInfo = {
                event: eventName
            }
        ][0];
        actionInfo.event = (actionInfo.event || actionType).toLowerCase();
        eventName = actionInfo.event;
        if ($61f525521022d020$var$eventActionMap[eventName]) return;
        (0, (0, parcelRequire("bahqM")).assert)($61f525521022d020$var$ACTION_REG.test(actionType) && $61f525521022d020$var$ACTION_REG.test(eventName));
        if (!$61f525521022d020$var$actions[actionType]) $61f525521022d020$var$actions[actionType] = {
            action: action,
            actionInfo: actionInfo
        };
        $61f525521022d020$var$eventActionMap[eventName] = actionType;
    }
    function $61f525521022d020$export$1dd5e025a8a37dd(type, coordSysCreator) {
        (0, (0, parcelRequire("gyhNQ")).default).register(type, coordSysCreator);
    }
    function $61f525521022d020$export$fc2638719e4159b9(type) {
        var coordSysCreator = (0, (0, parcelRequire("gyhNQ")).default).get(type);
        if (coordSysCreator) return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
    }
    function $61f525521022d020$export$d768f97700ca6bea(priority, layoutTask) {
        $61f525521022d020$var$normalizeRegister($61f525521022d020$var$visualFuncs, priority, layoutTask, $61f525521022d020$var$PRIORITY_VISUAL_LAYOUT, 'layout');
    }
    function $61f525521022d020$export$5f32c1eb94c381bb(priority, visualTask) {
        $61f525521022d020$var$normalizeRegister($61f525521022d020$var$visualFuncs, priority, visualTask, $61f525521022d020$var$PRIORITY_VISUAL_CHART, 'visual');
    }
    var $61f525521022d020$var$registeredTasks = [];
    function $61f525521022d020$var$normalizeRegister(targetList, priority, fn, defaultPriority, visualType) {
        if ((0, (0, parcelRequire("bahqM")).isFunction)(priority) || (0, (0, parcelRequire("bahqM")).isObject)(priority)) {
            fn = priority;
            priority = defaultPriority;
        }
        if ((0, (0, parcelRequire("bahqM")).indexOf)($61f525521022d020$var$registeredTasks, fn) >= 0) return;
        $61f525521022d020$var$registeredTasks.push(fn);
        var stageHandler = (0, (0, parcelRequire("14WFd")).default).wrapStageHandler(fn, visualType);
        stageHandler.__prio = priority;
        stageHandler.__raw = fn;
        targetList.push(stageHandler);
    }
    function $61f525521022d020$export$e06b68a82007c015(name, loadingFx) {
        $61f525521022d020$var$loadingEffects[name] = loadingFx;
    }
    function $61f525521022d020$export$10425ea7a243b114(creator) {
        (0, (0, parcelRequire("bahqM")).$override)('createCanvas', creator);
    }
    function $61f525521022d020$export$d456de060be2dba1(mapName, geoJson, specialAreas) {
        (0, (0, parcelRequire("fEzwg")).default).registerMap(mapName, geoJson, specialAreas);
    }
    function $61f525521022d020$export$b8586192aead8a7e(mapName) {
        return (0, (0, parcelRequire("fEzwg")).default).getMapForUser(mapName);
    }
    var $61f525521022d020$export$f01d71dd0389d7e4 = (0, (0, parcelRequire("05ab4")).registerExternalTransform);
    $61f525521022d020$export$5f32c1eb94c381bb($61f525521022d020$var$PRIORITY_VISUAL_GLOBAL, (0, (0, parcelRequire("cvEVp")).seriesStyleTask));
    $61f525521022d020$export$5f32c1eb94c381bb($61f525521022d020$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, (0, parcelRequire("cvEVp")).dataStyleTask));
    $61f525521022d020$export$5f32c1eb94c381bb($61f525521022d020$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, (0, parcelRequire("cvEVp")).dataColorPaletteTask));
    $61f525521022d020$export$5f32c1eb94c381bb($61f525521022d020$var$PRIORITY_VISUAL_GLOBAL, (0, (0, parcelRequire("7wiHx")).seriesSymbolTask));
    $61f525521022d020$export$5f32c1eb94c381bb($61f525521022d020$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, (0, parcelRequire("7wiHx")).dataSymbolTask));
    $61f525521022d020$export$5f32c1eb94c381bb($61f525521022d020$var$PRIORITY_VISUAL_DECAL, (0, (0, parcelRequire("g2DhS")).default));
    $61f525521022d020$export$77095792a057b768((0, (0, parcelRequire("driCQ")).default));
    $61f525521022d020$export$d575e6557ac1729f($61f525521022d020$var$PRIORITY_PROCESSOR_DATASTACK, (0, (0, parcelRequire("iMppY")).default));
    $61f525521022d020$export$e06b68a82007c015('default', (0, (0, parcelRequire("4G956")).default));
    $61f525521022d020$export$408c24786cd729c6({
        type: (0, (0, parcelRequire("fIXXx")).HIGHLIGHT_ACTION_TYPE),
        event: (0, (0, parcelRequire("fIXXx")).HIGHLIGHT_ACTION_TYPE),
        update: (0, (0, parcelRequire("fIXXx")).HIGHLIGHT_ACTION_TYPE)
    }, (0, (0, parcelRequire("bahqM")).noop));
    $61f525521022d020$export$408c24786cd729c6({
        type: (0, (0, parcelRequire("fIXXx")).DOWNPLAY_ACTION_TYPE),
        event: (0, (0, parcelRequire("fIXXx")).DOWNPLAY_ACTION_TYPE),
        update: (0, (0, parcelRequire("fIXXx")).DOWNPLAY_ACTION_TYPE)
    }, (0, (0, parcelRequire("bahqM")).noop));
    $61f525521022d020$export$408c24786cd729c6({
        type: (0, (0, parcelRequire("fIXXx")).SELECT_ACTION_TYPE),
        event: (0, (0, parcelRequire("fIXXx")).SELECT_ACTION_TYPE),
        update: (0, (0, parcelRequire("fIXXx")).SELECT_ACTION_TYPE)
    }, (0, (0, parcelRequire("bahqM")).noop));
    $61f525521022d020$export$408c24786cd729c6({
        type: (0, (0, parcelRequire("fIXXx")).UNSELECT_ACTION_TYPE),
        event: (0, (0, parcelRequire("fIXXx")).UNSELECT_ACTION_TYPE),
        update: (0, (0, parcelRequire("fIXXx")).UNSELECT_ACTION_TYPE)
    }, (0, (0, parcelRequire("bahqM")).noop));
    $61f525521022d020$export$408c24786cd729c6({
        type: (0, (0, parcelRequire("fIXXx")).TOGGLE_SELECT_ACTION_TYPE),
        event: (0, (0, parcelRequire("fIXXx")).TOGGLE_SELECT_ACTION_TYPE),
        update: (0, (0, parcelRequire("fIXXx")).TOGGLE_SELECT_ACTION_TYPE)
    }, (0, (0, parcelRequire("bahqM")).noop));
    $61f525521022d020$export$f9c59eed5de5ff80('light', (0, (0, parcelRequire("31FQc")).default));
    $61f525521022d020$export$f9c59eed5de5ff80('dark', (0, (0, parcelRequire("dMJCs")).default));
    var $61f525521022d020$export$73cae5e090579589 = {};
});
parcelRegister("9Y5KT", function(module, exports) {
    $parcel$export(module.exports, "init", ()=>$741e2e865750343c$export$2cd8252107eb640b);
    $parcel$export(module.exports, "dispose", ()=>$741e2e865750343c$export$fcfbbcec2cb820d5);
    $parcel$export(module.exports, "disposeAll", ()=>$741e2e865750343c$export$825f692fb04800ef);
    $parcel$export(module.exports, "getInstance", ()=>$741e2e865750343c$export$8bedcca5bbd73999);
    $parcel$export(module.exports, "registerPainter", ()=>$741e2e865750343c$export$a3e793ccb11823a5);
    $parcel$export(module.exports, "version", ()=>$741e2e865750343c$export$83d89fbfd8236492);
    var $hZfwb;
    var $bahqM;
    var $jaJTK;
    var $66sfA;
    var $F44Dl;
    var $bHSYT;
    var $d6udH;
    var $7y1my;
    var $4KVOr;
    var $741e2e865750343c$var$useVML = !(0, (0, parcelRequire("hZfwb")).default).canvasSupported;
    var $741e2e865750343c$var$painterCtors = {};
    var $741e2e865750343c$var$instances = {};
    function $741e2e865750343c$var$delInstance(id) {
        delete $741e2e865750343c$var$instances[id];
    }
    function $741e2e865750343c$var$isDarkMode(backgroundColor) {
        if (!backgroundColor) return false;
        if (typeof backgroundColor === 'string') return (0, (0, parcelRequire("d6udH")).lum)(backgroundColor, 1) < (0, (0, parcelRequire("7y1my")).DARK_MODE_THRESHOLD);
        else if (backgroundColor.colorStops) {
            var colorStops = backgroundColor.colorStops;
            var totalLum = 0;
            var len = colorStops.length;
            for(var i = 0; i < len; i++)totalLum += (0, (0, parcelRequire("d6udH")).lum)(colorStops[i].color, 1);
            totalLum /= len;
            return totalLum < (0, (0, parcelRequire("7y1my")).DARK_MODE_THRESHOLD);
        }
        return false;
    }
    var $741e2e865750343c$var$ZRender = function() {
        function ZRender(id, dom, opts) {
            var _this = this;
            this._sleepAfterStill = 10;
            this._stillFrameAccum = 0;
            this._needsRefresh = true;
            this._needsRefreshHover = true;
            this._darkMode = false;
            opts = opts || {};
            this.dom = dom;
            this.id = id;
            var storage = new (0, (0, parcelRequire("66sfA")).default)();
            var rendererType = opts.renderer || 'canvas';
            if ($741e2e865750343c$var$useVML) throw new Error('IE8 support has been dropped since 5.0');
            if (!$741e2e865750343c$var$painterCtors[rendererType]) rendererType = (0, parcelRequire("bahqM")).keys($741e2e865750343c$var$painterCtors)[0];
            if (!$741e2e865750343c$var$painterCtors[rendererType]) throw new Error("Renderer '" + rendererType + "' is not imported. Please import it first.");
            opts.useDirtyRect = opts.useDirtyRect == null ? false : opts.useDirtyRect;
            var painter = new $741e2e865750343c$var$painterCtors[rendererType](dom, storage, opts, id);
            this.storage = storage;
            this.painter = painter;
            var handerProxy = !(0, (0, parcelRequire("hZfwb")).default).node && !(0, (0, parcelRequire("hZfwb")).default).worker ? new (0, (0, parcelRequire("bHSYT")).default)(painter.getViewportRoot(), painter.root) : null;
            this.handler = new (0, (0, parcelRequire("jaJTK")).default)(storage, painter, handerProxy, painter.root);
            this.animation = new (0, (0, parcelRequire("F44Dl")).default)({
                stage: {
                    update: function() {
                        return _this._flush(true);
                    }
                }
            });
            this.animation.start();
        }
        ZRender.prototype.add = function(el) {
            if (!el) return;
            this.storage.addRoot(el);
            el.addSelfToZr(this);
            this.refresh();
        };
        ZRender.prototype.remove = function(el) {
            if (!el) return;
            this.storage.delRoot(el);
            el.removeSelfFromZr(this);
            this.refresh();
        };
        ZRender.prototype.configLayer = function(zLevel, config) {
            if (this.painter.configLayer) this.painter.configLayer(zLevel, config);
            this.refresh();
        };
        ZRender.prototype.setBackgroundColor = function(backgroundColor) {
            if (this.painter.setBackgroundColor) this.painter.setBackgroundColor(backgroundColor);
            this.refresh();
            this._backgroundColor = backgroundColor;
            this._darkMode = $741e2e865750343c$var$isDarkMode(backgroundColor);
        };
        ZRender.prototype.getBackgroundColor = function() {
            return this._backgroundColor;
        };
        ZRender.prototype.setDarkMode = function(darkMode) {
            this._darkMode = darkMode;
        };
        ZRender.prototype.isDarkMode = function() {
            return this._darkMode;
        };
        ZRender.prototype.refreshImmediately = function(fromInside) {
            if (!fromInside) this.animation.update(true);
            this._needsRefresh = false;
            this.painter.refresh();
            this._needsRefresh = false;
        };
        ZRender.prototype.refresh = function() {
            this._needsRefresh = true;
            this.animation.start();
        };
        ZRender.prototype.flush = function() {
            this._flush(false);
        };
        ZRender.prototype._flush = function(fromInside) {
            var triggerRendered;
            var start = new Date().getTime();
            if (this._needsRefresh) {
                triggerRendered = true;
                this.refreshImmediately(fromInside);
            }
            if (this._needsRefreshHover) {
                triggerRendered = true;
                this.refreshHoverImmediately();
            }
            var end = new Date().getTime();
            if (triggerRendered) {
                this._stillFrameAccum = 0;
                this.trigger('rendered', {
                    elapsedTime: end - start
                });
            } else if (this._sleepAfterStill > 0) {
                this._stillFrameAccum++;
                if (this._stillFrameAccum > this._sleepAfterStill) this.animation.stop();
            }
        };
        ZRender.prototype.setSleepAfterStill = function(stillFramesCount) {
            this._sleepAfterStill = stillFramesCount;
        };
        ZRender.prototype.wakeUp = function() {
            this.animation.start();
            this._stillFrameAccum = 0;
        };
        ZRender.prototype.addHover = function(el) {};
        ZRender.prototype.removeHover = function(el) {};
        ZRender.prototype.clearHover = function() {};
        ZRender.prototype.refreshHover = function() {
            this._needsRefreshHover = true;
        };
        ZRender.prototype.refreshHoverImmediately = function() {
            this._needsRefreshHover = false;
            if (this.painter.refreshHover && this.painter.getType() === 'canvas') this.painter.refreshHover();
        };
        ZRender.prototype.resize = function(opts) {
            opts = opts || {};
            this.painter.resize(opts.width, opts.height);
            this.handler.resize();
        };
        ZRender.prototype.clearAnimation = function() {
            this.animation.clear();
        };
        ZRender.prototype.getWidth = function() {
            return this.painter.getWidth();
        };
        ZRender.prototype.getHeight = function() {
            return this.painter.getHeight();
        };
        ZRender.prototype.pathToImage = function(e, dpr) {
            if (this.painter.pathToImage) return this.painter.pathToImage(e, dpr);
        };
        ZRender.prototype.setCursorStyle = function(cursorStyle) {
            this.handler.setCursorStyle(cursorStyle);
        };
        ZRender.prototype.findHover = function(x, y) {
            return this.handler.findHover(x, y);
        };
        ZRender.prototype.on = function(eventName, eventHandler, context) {
            this.handler.on(eventName, eventHandler, context);
            return this;
        };
        ZRender.prototype.off = function(eventName, eventHandler) {
            this.handler.off(eventName, eventHandler);
        };
        ZRender.prototype.trigger = function(eventName, event) {
            this.handler.trigger(eventName, event);
        };
        ZRender.prototype.clear = function() {
            var roots = this.storage.getRoots();
            for(var i = 0; i < roots.length; i++)if (roots[i] instanceof (0, (0, parcelRequire("4KVOr")).default)) roots[i].removeSelfFromZr(this);
            this.storage.delAllRoots();
            this.painter.clear();
        };
        ZRender.prototype.dispose = function() {
            this.animation.stop();
            this.clear();
            this.storage.dispose();
            this.painter.dispose();
            this.handler.dispose();
            this.animation = this.storage = this.painter = this.handler = null;
            $741e2e865750343c$var$delInstance(this.id);
        };
        return ZRender;
    }();
    function $741e2e865750343c$export$2cd8252107eb640b(dom, opts) {
        var zr = new $741e2e865750343c$var$ZRender((0, parcelRequire("bahqM")).guid(), dom, opts);
        $741e2e865750343c$var$instances[zr.id] = zr;
        return zr;
    }
    function $741e2e865750343c$export$fcfbbcec2cb820d5(zr) {
        zr.dispose();
    }
    function $741e2e865750343c$export$825f692fb04800ef() {
        for(var key in $741e2e865750343c$var$instances)if ($741e2e865750343c$var$instances.hasOwnProperty(key)) $741e2e865750343c$var$instances[key].dispose();
        $741e2e865750343c$var$instances = {};
    }
    function $741e2e865750343c$export$8bedcca5bbd73999(id) {
        return $741e2e865750343c$var$instances[id];
    }
    function $741e2e865750343c$export$a3e793ccb11823a5(name, Ctor) {
        $741e2e865750343c$var$painterCtors[name] = Ctor;
    }
    var $741e2e865750343c$export$83d89fbfd8236492 = '5.2.1';
});
parcelRegister("jaJTK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$df528de50090e0a1$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bahqM;
    var $eLEew;
    var $8qDpt;
    var $bRKv5;
    var $65X4x;
    var $jYjcX;
    var $df528de50090e0a1$var$SILENT = 'silent';
    function $df528de50090e0a1$var$makeEventPacket(eveType, targetInfo, event) {
        return {
            type: eveType,
            event: event,
            target: targetInfo.target,
            topTarget: targetInfo.topTarget,
            cancelBubble: false,
            offsetX: event.zrX,
            offsetY: event.zrY,
            gestureEvent: event.gestureEvent,
            pinchX: event.pinchX,
            pinchY: event.pinchY,
            pinchScale: event.pinchScale,
            wheelDelta: event.zrDelta,
            zrByTouch: event.zrByTouch,
            which: event.which,
            stop: $df528de50090e0a1$var$stopEvent
        };
    }
    function $df528de50090e0a1$var$stopEvent() {
        (0, parcelRequire("65X4x")).stop(this.event);
    }
    var $df528de50090e0a1$var$EmptyProxy = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(EmptyProxy, _super);
        function EmptyProxy() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.handler = null;
            return _this;
        }
        EmptyProxy.prototype.dispose = function() {};
        EmptyProxy.prototype.setCursor = function() {};
        return EmptyProxy;
    }((0, (0, parcelRequire("bRKv5")).default));
    var $df528de50090e0a1$var$HoveredResult = function() {
        function HoveredResult(x, y) {
            this.x = x;
            this.y = y;
        }
        return HoveredResult;
    }();
    var $df528de50090e0a1$var$handlerNames = [
        'click',
        'dblclick',
        'mousewheel',
        'mouseout',
        'mouseup',
        'mousedown',
        'mousemove',
        'contextmenu'
    ];
    var $df528de50090e0a1$var$Handler = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Handler, _super);
        function Handler(storage, painter, proxy, painterRoot) {
            var _this = _super.call(this) || this;
            _this._hovered = new $df528de50090e0a1$var$HoveredResult(0, 0);
            _this.storage = storage;
            _this.painter = painter;
            _this.painterRoot = painterRoot;
            proxy = proxy || new $df528de50090e0a1$var$EmptyProxy();
            _this.proxy = null;
            _this.setHandlerProxy(proxy);
            _this._draggingMgr = new (0, (0, parcelRequire("8qDpt")).default)(_this);
            return _this;
        }
        Handler.prototype.setHandlerProxy = function(proxy) {
            if (this.proxy) this.proxy.dispose();
            if (proxy) {
                (0, parcelRequire("bahqM")).each($df528de50090e0a1$var$handlerNames, function(name) {
                    proxy.on && proxy.on(name, this[name], this);
                }, this);
                proxy.handler = this;
            }
            this.proxy = proxy;
        };
        Handler.prototype.mousemove = function(event) {
            var x = event.zrX;
            var y = event.zrY;
            var isOutside = $df528de50090e0a1$var$isOutsideBoundary(this, x, y);
            var lastHovered = this._hovered;
            var lastHoveredTarget = lastHovered.target;
            if (lastHoveredTarget && !lastHoveredTarget.__zr) {
                lastHovered = this.findHover(lastHovered.x, lastHovered.y);
                lastHoveredTarget = lastHovered.target;
            }
            var hovered = this._hovered = isOutside ? new $df528de50090e0a1$var$HoveredResult(x, y) : this.findHover(x, y);
            var hoveredTarget = hovered.target;
            var proxy = this.proxy;
            proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : 'default');
            if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(lastHovered, 'mouseout', event);
            this.dispatchToElement(hovered, 'mousemove', event);
            if (hoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(hovered, 'mouseover', event);
        };
        Handler.prototype.mouseout = function(event) {
            var eventControl = event.zrEventControl;
            if (eventControl !== 'only_globalout') this.dispatchToElement(this._hovered, 'mouseout', event);
            if (eventControl !== 'no_globalout') this.trigger('globalout', {
                type: 'globalout',
                event: event
            });
        };
        Handler.prototype.resize = function() {
            this._hovered = new $df528de50090e0a1$var$HoveredResult(0, 0);
        };
        Handler.prototype.dispatch = function(eventName, eventArgs) {
            var handler = this[eventName];
            handler && handler.call(this, eventArgs);
        };
        Handler.prototype.dispose = function() {
            this.proxy.dispose();
            this.storage = null;
            this.proxy = null;
            this.painter = null;
        };
        Handler.prototype.setCursorStyle = function(cursorStyle) {
            var proxy = this.proxy;
            proxy.setCursor && proxy.setCursor(cursorStyle);
        };
        Handler.prototype.dispatchToElement = function(targetInfo, eventName, event) {
            targetInfo = targetInfo || {};
            var el = targetInfo.target;
            if (el && el.silent) return;
            var eventKey = 'on' + eventName;
            var eventPacket = $df528de50090e0a1$var$makeEventPacket(eventName, targetInfo, event);
            while(el){
                el[eventKey] && (eventPacket.cancelBubble = !!el[eventKey].call(el, eventPacket));
                el.trigger(eventName, eventPacket);
                el = el.__hostTarget ? el.__hostTarget : el.parent;
                if (eventPacket.cancelBubble) break;
            }
            if (!eventPacket.cancelBubble) {
                this.trigger(eventName, eventPacket);
                if (this.painter && this.painter.eachOtherLayer) this.painter.eachOtherLayer(function(layer) {
                    if (typeof layer[eventKey] === 'function') layer[eventKey].call(layer, eventPacket);
                    if (layer.trigger) layer.trigger(eventName, eventPacket);
                });
            }
        };
        Handler.prototype.findHover = function(x, y, exclude) {
            var list = this.storage.getDisplayList();
            var out = new $df528de50090e0a1$var$HoveredResult(x, y);
            for(var i = list.length - 1; i >= 0; i--){
                var hoverCheckResult = void 0;
                if (list[i] !== exclude && !list[i].ignore && (hoverCheckResult = $df528de50090e0a1$var$isHover(list[i], x, y))) {
                    !out.topTarget && (out.topTarget = list[i]);
                    if (hoverCheckResult !== $df528de50090e0a1$var$SILENT) {
                        out.target = list[i];
                        break;
                    }
                }
            }
            return out;
        };
        Handler.prototype.processGesture = function(event, stage) {
            if (!this._gestureMgr) this._gestureMgr = new (0, (0, parcelRequire("jYjcX")).GestureMgr)();
            var gestureMgr = this._gestureMgr;
            stage === 'start' && gestureMgr.clear();
            var gestureInfo = gestureMgr.recognize(event, this.findHover(event.zrX, event.zrY, null).target, this.proxy.dom);
            stage === 'end' && gestureMgr.clear();
            if (gestureInfo) {
                var type = gestureInfo.type;
                event.gestureEvent = type;
                var res = new $df528de50090e0a1$var$HoveredResult();
                res.target = gestureInfo.target;
                this.dispatchToElement(res, type, gestureInfo.event);
            }
        };
        return Handler;
    }((0, (0, parcelRequire("bRKv5")).default));
    (0, parcelRequire("bahqM")).each([
        'click',
        'mousedown',
        'mouseup',
        'mousewheel',
        'dblclick',
        'contextmenu'
    ], function(name) {
        $df528de50090e0a1$var$Handler.prototype[name] = function(event) {
            var x = event.zrX;
            var y = event.zrY;
            var isOutside = $df528de50090e0a1$var$isOutsideBoundary(this, x, y);
            var hovered;
            var hoveredTarget;
            if (name !== 'mouseup' || !isOutside) {
                hovered = this.findHover(x, y);
                hoveredTarget = hovered.target;
            }
            if (name === 'mousedown') {
                this._downEl = hoveredTarget;
                this._downPoint = [
                    event.zrX,
                    event.zrY
                ];
                this._upEl = hoveredTarget;
            } else if (name === 'mouseup') this._upEl = hoveredTarget;
            else if (name === 'click') {
                if (this._downEl !== this._upEl || !this._downPoint || (0, parcelRequire("eLEew")).dist(this._downPoint, [
                    event.zrX,
                    event.zrY
                ]) > 4) return;
                this._downPoint = null;
            }
            this.dispatchToElement(hovered, name, event);
        };
    });
    function $df528de50090e0a1$var$isHover(displayable, x, y) {
        if (displayable[displayable.rectHover ? 'rectContain' : 'contain'](x, y)) {
            var el = displayable;
            var isSilent = void 0;
            var ignoreClip = false;
            while(el){
                if (el.ignoreClip) ignoreClip = true;
                if (!ignoreClip) {
                    var clipPath = el.getClipPath();
                    if (clipPath && !clipPath.contain(x, y)) return false;
                    if (el.silent) isSilent = true;
                }
                var hostEl = el.__hostTarget;
                el = hostEl ? hostEl : el.parent;
            }
            return isSilent ? $df528de50090e0a1$var$SILENT : true;
        }
        return false;
    }
    function $df528de50090e0a1$var$isOutsideBoundary(handlerInstance, x, y) {
        var painter = handlerInstance.painter;
        return x < 0 || x > painter.getWidth() || y < 0 || y > painter.getHeight();
    }
    var $df528de50090e0a1$export$2e2bcd8739ae039 = $df528de50090e0a1$var$Handler;
});
parcelRegister("8qDpt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$622f526eb8ccffa3$export$2e2bcd8739ae039);
    var $622f526eb8ccffa3$var$Param = function() {
        function Param(target, e) {
            this.target = target;
            this.topTarget = e && e.topTarget;
        }
        return Param;
    }();
    var $622f526eb8ccffa3$var$Draggable = function() {
        function Draggable(handler) {
            this.handler = handler;
            handler.on('mousedown', this._dragStart, this);
            handler.on('mousemove', this._drag, this);
            handler.on('mouseup', this._dragEnd, this);
        }
        Draggable.prototype._dragStart = function(e) {
            var draggingTarget = e.target;
            while(draggingTarget && !draggingTarget.draggable)draggingTarget = draggingTarget.parent;
            if (draggingTarget) {
                this._draggingTarget = draggingTarget;
                draggingTarget.dragging = true;
                this._x = e.offsetX;
                this._y = e.offsetY;
                this.handler.dispatchToElement(new $622f526eb8ccffa3$var$Param(draggingTarget, e), 'dragstart', e.event);
            }
        };
        Draggable.prototype._drag = function(e) {
            var draggingTarget = this._draggingTarget;
            if (draggingTarget) {
                var x = e.offsetX;
                var y = e.offsetY;
                var dx = x - this._x;
                var dy = y - this._y;
                this._x = x;
                this._y = y;
                draggingTarget.drift(dx, dy, e);
                this.handler.dispatchToElement(new $622f526eb8ccffa3$var$Param(draggingTarget, e), 'drag', e.event);
                var dropTarget = this.handler.findHover(x, y, draggingTarget).target;
                var lastDropTarget = this._dropTarget;
                this._dropTarget = dropTarget;
                if (draggingTarget !== dropTarget) {
                    if (lastDropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $622f526eb8ccffa3$var$Param(lastDropTarget, e), 'dragleave', e.event);
                    if (dropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $622f526eb8ccffa3$var$Param(dropTarget, e), 'dragenter', e.event);
                }
            }
        };
        Draggable.prototype._dragEnd = function(e) {
            var draggingTarget = this._draggingTarget;
            if (draggingTarget) draggingTarget.dragging = false;
            this.handler.dispatchToElement(new $622f526eb8ccffa3$var$Param(draggingTarget, e), 'dragend', e.event);
            if (this._dropTarget) this.handler.dispatchToElement(new $622f526eb8ccffa3$var$Param(this._dropTarget, e), 'drop', e.event);
            this._draggingTarget = null;
            this._dropTarget = null;
        };
        return Draggable;
    }();
    var $622f526eb8ccffa3$export$2e2bcd8739ae039 = $622f526eb8ccffa3$var$Draggable;
});
parcelRegister("jYjcX", function(module, exports) {
    $parcel$export(module.exports, "GestureMgr", ()=>$e8a28537c27906ba$export$f7557d6f27e9503);
    var $65X4x;
    var $e8a28537c27906ba$export$f7557d6f27e9503 = function() {
        function GestureMgr() {
            this._track = [];
        }
        GestureMgr.prototype.recognize = function(event, target, root) {
            this._doTrack(event, target, root);
            return this._recognize(event);
        };
        GestureMgr.prototype.clear = function() {
            this._track.length = 0;
            return this;
        };
        GestureMgr.prototype._doTrack = function(event, target, root) {
            var touches = event.touches;
            if (!touches) return;
            var trackItem = {
                points: [],
                touches: [],
                target: target,
                event: event
            };
            for(var i = 0, len = touches.length; i < len; i++){
                var touch = touches[i];
                var pos = (0, parcelRequire("65X4x")).clientToLocal(root, touch, {});
                trackItem.points.push([
                    pos.zrX,
                    pos.zrY
                ]);
                trackItem.touches.push(touch);
            }
            this._track.push(trackItem);
        };
        GestureMgr.prototype._recognize = function(event) {
            for(var eventName in $e8a28537c27906ba$var$recognizers)if ($e8a28537c27906ba$var$recognizers.hasOwnProperty(eventName)) {
                var gestureInfo = $e8a28537c27906ba$var$recognizers[eventName](this._track, event);
                if (gestureInfo) return gestureInfo;
            }
        };
        return GestureMgr;
    }();
    function $e8a28537c27906ba$var$dist(pointPair) {
        var dx = pointPair[1][0] - pointPair[0][0];
        var dy = pointPair[1][1] - pointPair[0][1];
        return Math.sqrt(dx * dx + dy * dy);
    }
    function $e8a28537c27906ba$var$center(pointPair) {
        return [
            (pointPair[0][0] + pointPair[1][0]) / 2,
            (pointPair[0][1] + pointPair[1][1]) / 2
        ];
    }
    var $e8a28537c27906ba$var$recognizers = {
        pinch: function(tracks, event) {
            var trackLen = tracks.length;
            if (!trackLen) return;
            var pinchEnd = (tracks[trackLen - 1] || {}).points;
            var pinchPre = (tracks[trackLen - 2] || {}).points || pinchEnd;
            if (pinchPre && pinchPre.length > 1 && pinchEnd && pinchEnd.length > 1) {
                var pinchScale = $e8a28537c27906ba$var$dist(pinchEnd) / $e8a28537c27906ba$var$dist(pinchPre);
                !isFinite(pinchScale) && (pinchScale = 1);
                event.pinchScale = pinchScale;
                var pinchCenter = $e8a28537c27906ba$var$center(pinchEnd);
                event.pinchX = pinchCenter[0];
                event.pinchY = pinchCenter[1];
                return {
                    type: 'pinch',
                    target: tracks[0].target,
                    event: event
                };
            }
        }
    };
});
parcelRegister("66sfA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4719378990e09024$export$2e2bcd8739ae039);
    var $bahqM;
    var $hZfwb;
    var $aVBu2;
    var $aVawM;
    var $4719378990e09024$var$invalidZErrorLogged = false;
    function $4719378990e09024$var$logInvalidZError() {
        if ($4719378990e09024$var$invalidZErrorLogged) return;
        $4719378990e09024$var$invalidZErrorLogged = true;
        console.warn('z / z2 / zlevel of displayable is invalid, which may cause unexpected errors');
    }
    function $4719378990e09024$var$shapeCompareFunc(a, b) {
        if (a.zlevel === b.zlevel) {
            if (a.z === b.z) return a.z2 - b.z2;
            return a.z - b.z;
        }
        return a.zlevel - b.zlevel;
    }
    var $4719378990e09024$var$Storage = function() {
        function Storage() {
            this._roots = [];
            this._displayList = [];
            this._displayListLen = 0;
            this.displayableSortFunc = $4719378990e09024$var$shapeCompareFunc;
        }
        Storage.prototype.traverse = function(cb, context) {
            for(var i = 0; i < this._roots.length; i++)this._roots[i].traverse(cb, context);
        };
        Storage.prototype.getDisplayList = function(update, includeIgnore) {
            includeIgnore = includeIgnore || false;
            var displayList = this._displayList;
            if (update || !displayList.length) this.updateDisplayList(includeIgnore);
            return displayList;
        };
        Storage.prototype.updateDisplayList = function(includeIgnore) {
            this._displayListLen = 0;
            var roots = this._roots;
            var displayList = this._displayList;
            for(var i = 0, len = roots.length; i < len; i++)this._updateAndAddDisplayable(roots[i], null, includeIgnore);
            displayList.length = this._displayListLen;
            (0, (0, parcelRequire("hZfwb")).default).canvasSupported && (0, (0, parcelRequire("aVBu2")).default)(displayList, $4719378990e09024$var$shapeCompareFunc);
        };
        Storage.prototype._updateAndAddDisplayable = function(el, clipPaths, includeIgnore) {
            if (el.ignore && !includeIgnore) return;
            el.beforeUpdate();
            el.update();
            el.afterUpdate();
            var userSetClipPath = el.getClipPath();
            if (el.ignoreClip) clipPaths = null;
            else if (userSetClipPath) {
                if (clipPaths) clipPaths = clipPaths.slice();
                else clipPaths = [];
                var currentClipPath = userSetClipPath;
                var parentClipPath = el;
                while(currentClipPath){
                    currentClipPath.parent = parentClipPath;
                    currentClipPath.updateTransform();
                    clipPaths.push(currentClipPath);
                    parentClipPath = currentClipPath;
                    currentClipPath = currentClipPath.getClipPath();
                }
            }
            if (el.childrenRef) {
                var children = el.childrenRef();
                for(var i = 0; i < children.length; i++){
                    var child = children[i];
                    if (el.__dirty) child.__dirty |= (0, (0, parcelRequire("aVawM")).REDRAW_BIT);
                    this._updateAndAddDisplayable(child, clipPaths, includeIgnore);
                }
                el.__dirty = 0;
            } else {
                var disp = el;
                if (clipPaths && clipPaths.length) disp.__clipPaths = clipPaths;
                else if (disp.__clipPaths && disp.__clipPaths.length > 0) disp.__clipPaths = [];
                if (isNaN(disp.z)) {
                    $4719378990e09024$var$logInvalidZError();
                    disp.z = 0;
                }
                if (isNaN(disp.z2)) {
                    $4719378990e09024$var$logInvalidZError();
                    disp.z2 = 0;
                }
                if (isNaN(disp.zlevel)) {
                    $4719378990e09024$var$logInvalidZError();
                    disp.zlevel = 0;
                }
                this._displayList[this._displayListLen++] = disp;
            }
            var decalEl = el.getDecalElement && el.getDecalElement();
            if (decalEl) this._updateAndAddDisplayable(decalEl, clipPaths, includeIgnore);
            var textGuide = el.getTextGuideLine();
            if (textGuide) this._updateAndAddDisplayable(textGuide, clipPaths, includeIgnore);
            var textEl = el.getTextContent();
            if (textEl) this._updateAndAddDisplayable(textEl, clipPaths, includeIgnore);
        };
        Storage.prototype.addRoot = function(el) {
            if (el.__zr && el.__zr.storage === this) return;
            this._roots.push(el);
        };
        Storage.prototype.delRoot = function(el) {
            if (el instanceof Array) {
                for(var i = 0, l = el.length; i < l; i++)this.delRoot(el[i]);
                return;
            }
            var idx = (0, parcelRequire("bahqM")).indexOf(this._roots, el);
            if (idx >= 0) this._roots.splice(idx, 1);
        };
        Storage.prototype.delAllRoots = function() {
            this._roots = [];
            this._displayList = [];
            this._displayListLen = 0;
            return;
        };
        Storage.prototype.getRoots = function() {
            return this._roots;
        };
        Storage.prototype.dispose = function() {
            this._displayList = null;
            this._roots = null;
        };
        return Storage;
    }();
    var $4719378990e09024$export$2e2bcd8739ae039 = $4719378990e09024$var$Storage;
});
parcelRegister("aVBu2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7f4c4daf73fbe3de$export$2e2bcd8739ae039);
    var $7f4c4daf73fbe3de$var$DEFAULT_MIN_MERGE = 32;
    var $7f4c4daf73fbe3de$var$DEFAULT_MIN_GALLOPING = 7;
    var $7f4c4daf73fbe3de$var$DEFAULT_TMP_STORAGE_LENGTH = 256;
    function $7f4c4daf73fbe3de$var$minRunLength(n) {
        var r = 0;
        while(n >= $7f4c4daf73fbe3de$var$DEFAULT_MIN_MERGE){
            r |= n & 1;
            n >>= 1;
        }
        return n + r;
    }
    function $7f4c4daf73fbe3de$var$makeAscendingRun(array, lo, hi, compare) {
        var runHi = lo + 1;
        if (runHi === hi) return 1;
        if (compare(array[runHi++], array[lo]) < 0) {
            while(runHi < hi && compare(array[runHi], array[runHi - 1]) < 0)runHi++;
            $7f4c4daf73fbe3de$var$reverseRun(array, lo, runHi);
        } else while(runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0)runHi++;
        return runHi - lo;
    }
    function $7f4c4daf73fbe3de$var$reverseRun(array, lo, hi) {
        hi--;
        while(lo < hi){
            var t = array[lo];
            array[lo++] = array[hi];
            array[hi--] = t;
        }
    }
    function $7f4c4daf73fbe3de$var$binaryInsertionSort(array, lo, hi, start, compare) {
        if (start === lo) start++;
        for(; start < hi; start++){
            var pivot = array[start];
            var left = lo;
            var right = start;
            var mid;
            while(left < right){
                mid = left + right >>> 1;
                if (compare(pivot, array[mid]) < 0) right = mid;
                else left = mid + 1;
            }
            var n = start - left;
            switch(n){
                case 3:
                    array[left + 3] = array[left + 2];
                case 2:
                    array[left + 2] = array[left + 1];
                case 1:
                    array[left + 1] = array[left];
                    break;
                default:
                    while(n > 0){
                        array[left + n] = array[left + n - 1];
                        n--;
                    }
            }
            array[left] = pivot;
        }
    }
    function $7f4c4daf73fbe3de$var$gallopLeft(value, array, start, length, hint, compare) {
        var lastOffset = 0;
        var maxOffset = 0;
        var offset = 1;
        if (compare(value, array[start + hint]) > 0) {
            maxOffset = length - hint;
            while(offset < maxOffset && compare(value, array[start + hint + offset]) > 0){
                lastOffset = offset;
                offset = (offset << 1) + 1;
                if (offset <= 0) offset = maxOffset;
            }
            if (offset > maxOffset) offset = maxOffset;
            lastOffset += hint;
            offset += hint;
        } else {
            maxOffset = hint + 1;
            while(offset < maxOffset && compare(value, array[start + hint - offset]) <= 0){
                lastOffset = offset;
                offset = (offset << 1) + 1;
                if (offset <= 0) offset = maxOffset;
            }
            if (offset > maxOffset) offset = maxOffset;
            var tmp = lastOffset;
            lastOffset = hint - offset;
            offset = hint - tmp;
        }
        lastOffset++;
        while(lastOffset < offset){
            var m = lastOffset + (offset - lastOffset >>> 1);
            if (compare(value, array[start + m]) > 0) lastOffset = m + 1;
            else offset = m;
        }
        return offset;
    }
    function $7f4c4daf73fbe3de$var$gallopRight(value, array, start, length, hint, compare) {
        var lastOffset = 0;
        var maxOffset = 0;
        var offset = 1;
        if (compare(value, array[start + hint]) < 0) {
            maxOffset = hint + 1;
            while(offset < maxOffset && compare(value, array[start + hint - offset]) < 0){
                lastOffset = offset;
                offset = (offset << 1) + 1;
                if (offset <= 0) offset = maxOffset;
            }
            if (offset > maxOffset) offset = maxOffset;
            var tmp = lastOffset;
            lastOffset = hint - offset;
            offset = hint - tmp;
        } else {
            maxOffset = length - hint;
            while(offset < maxOffset && compare(value, array[start + hint + offset]) >= 0){
                lastOffset = offset;
                offset = (offset << 1) + 1;
                if (offset <= 0) offset = maxOffset;
            }
            if (offset > maxOffset) offset = maxOffset;
            lastOffset += hint;
            offset += hint;
        }
        lastOffset++;
        while(lastOffset < offset){
            var m = lastOffset + (offset - lastOffset >>> 1);
            if (compare(value, array[start + m]) < 0) offset = m;
            else lastOffset = m + 1;
        }
        return offset;
    }
    function $7f4c4daf73fbe3de$var$TimSort(array, compare) {
        var minGallop = $7f4c4daf73fbe3de$var$DEFAULT_MIN_GALLOPING;
        var length = 0;
        var tmpStorageLength = $7f4c4daf73fbe3de$var$DEFAULT_TMP_STORAGE_LENGTH;
        var stackLength = 0;
        var runStart;
        var runLength;
        var stackSize = 0;
        length = array.length;
        if (length < 2 * $7f4c4daf73fbe3de$var$DEFAULT_TMP_STORAGE_LENGTH) tmpStorageLength = length >>> 1;
        var tmp = [];
        stackLength = length < 120 ? 5 : length < 1542 ? 10 : length < 119151 ? 19 : 40;
        runStart = [];
        runLength = [];
        function pushRun(_runStart, _runLength) {
            runStart[stackSize] = _runStart;
            runLength[stackSize] = _runLength;
            stackSize += 1;
        }
        function mergeRuns() {
            while(stackSize > 1){
                var n = stackSize - 2;
                if (n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1] || n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1]) {
                    if (runLength[n - 1] < runLength[n + 1]) n--;
                } else if (runLength[n] > runLength[n + 1]) break;
                mergeAt(n);
            }
        }
        function forceMergeRuns() {
            while(stackSize > 1){
                var n = stackSize - 2;
                if (n > 0 && runLength[n - 1] < runLength[n + 1]) n--;
                mergeAt(n);
            }
        }
        function mergeAt(i) {
            var start1 = runStart[i];
            var length1 = runLength[i];
            var start2 = runStart[i + 1];
            var length2 = runLength[i + 1];
            runLength[i] = length1 + length2;
            if (i === stackSize - 3) {
                runStart[i + 1] = runStart[i + 2];
                runLength[i + 1] = runLength[i + 2];
            }
            stackSize--;
            var k = $7f4c4daf73fbe3de$var$gallopRight(array[start2], array, start1, length1, 0, compare);
            start1 += k;
            length1 -= k;
            if (length1 === 0) return;
            length2 = $7f4c4daf73fbe3de$var$gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);
            if (length2 === 0) return;
            if (length1 <= length2) mergeLow(start1, length1, start2, length2);
            else mergeHigh(start1, length1, start2, length2);
        }
        function mergeLow(start1, length1, start2, length2) {
            var i = 0;
            for(i = 0; i < length1; i++)tmp[i] = array[start1 + i];
            var cursor1 = 0;
            var cursor2 = start2;
            var dest = start1;
            array[dest++] = array[cursor2++];
            if (--length2 === 0) {
                for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
                return;
            }
            if (length1 === 1) {
                for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
                array[dest + length2] = tmp[cursor1];
                return;
            }
            var _minGallop = minGallop;
            var count1;
            var count2;
            var exit;
            while(true){
                count1 = 0;
                count2 = 0;
                exit = false;
                do if (compare(array[cursor2], tmp[cursor1]) < 0) {
                    array[dest++] = array[cursor2++];
                    count2++;
                    count1 = 0;
                    if (--length2 === 0) {
                        exit = true;
                        break;
                    }
                } else {
                    array[dest++] = tmp[cursor1++];
                    count1++;
                    count2 = 0;
                    if (--length1 === 1) {
                        exit = true;
                        break;
                    }
                }
                while ((count1 | count2) < _minGallop)
                if (exit) break;
                do {
                    count1 = $7f4c4daf73fbe3de$var$gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);
                    if (count1 !== 0) {
                        for(i = 0; i < count1; i++)array[dest + i] = tmp[cursor1 + i];
                        dest += count1;
                        cursor1 += count1;
                        length1 -= count1;
                        if (length1 <= 1) {
                            exit = true;
                            break;
                        }
                    }
                    array[dest++] = array[cursor2++];
                    if (--length2 === 0) {
                        exit = true;
                        break;
                    }
                    count2 = $7f4c4daf73fbe3de$var$gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);
                    if (count2 !== 0) {
                        for(i = 0; i < count2; i++)array[dest + i] = array[cursor2 + i];
                        dest += count2;
                        cursor2 += count2;
                        length2 -= count2;
                        if (length2 === 0) {
                            exit = true;
                            break;
                        }
                    }
                    array[dest++] = tmp[cursor1++];
                    if (--length1 === 1) {
                        exit = true;
                        break;
                    }
                    _minGallop--;
                }while (count1 >= $7f4c4daf73fbe3de$var$DEFAULT_MIN_GALLOPING || count2 >= $7f4c4daf73fbe3de$var$DEFAULT_MIN_GALLOPING)
                if (exit) break;
                if (_minGallop < 0) _minGallop = 0;
                _minGallop += 2;
            }
            minGallop = _minGallop;
            minGallop < 1 && (minGallop = 1);
            if (length1 === 1) {
                for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
                array[dest + length2] = tmp[cursor1];
            } else if (length1 === 0) throw new Error();
            else for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
        }
        function mergeHigh(start1, length1, start2, length2) {
            var i = 0;
            for(i = 0; i < length2; i++)tmp[i] = array[start2 + i];
            var cursor1 = start1 + length1 - 1;
            var cursor2 = length2 - 1;
            var dest = start2 + length2 - 1;
            var customCursor = 0;
            var customDest = 0;
            array[dest--] = array[cursor1--];
            if (--length1 === 0) {
                customCursor = dest - (length2 - 1);
                for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
                return;
            }
            if (length2 === 1) {
                dest -= length1;
                cursor1 -= length1;
                customDest = dest + 1;
                customCursor = cursor1 + 1;
                for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
                array[dest] = tmp[cursor2];
                return;
            }
            var _minGallop = minGallop;
            while(true){
                var count1 = 0;
                var count2 = 0;
                var exit = false;
                do if (compare(tmp[cursor2], array[cursor1]) < 0) {
                    array[dest--] = array[cursor1--];
                    count1++;
                    count2 = 0;
                    if (--length1 === 0) {
                        exit = true;
                        break;
                    }
                } else {
                    array[dest--] = tmp[cursor2--];
                    count2++;
                    count1 = 0;
                    if (--length2 === 1) {
                        exit = true;
                        break;
                    }
                }
                while ((count1 | count2) < _minGallop)
                if (exit) break;
                do {
                    count1 = length1 - $7f4c4daf73fbe3de$var$gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);
                    if (count1 !== 0) {
                        dest -= count1;
                        cursor1 -= count1;
                        length1 -= count1;
                        customDest = dest + 1;
                        customCursor = cursor1 + 1;
                        for(i = count1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
                        if (length1 === 0) {
                            exit = true;
                            break;
                        }
                    }
                    array[dest--] = tmp[cursor2--];
                    if (--length2 === 1) {
                        exit = true;
                        break;
                    }
                    count2 = length2 - $7f4c4daf73fbe3de$var$gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);
                    if (count2 !== 0) {
                        dest -= count2;
                        cursor2 -= count2;
                        length2 -= count2;
                        customDest = dest + 1;
                        customCursor = cursor2 + 1;
                        for(i = 0; i < count2; i++)array[customDest + i] = tmp[customCursor + i];
                        if (length2 <= 1) {
                            exit = true;
                            break;
                        }
                    }
                    array[dest--] = array[cursor1--];
                    if (--length1 === 0) {
                        exit = true;
                        break;
                    }
                    _minGallop--;
                }while (count1 >= $7f4c4daf73fbe3de$var$DEFAULT_MIN_GALLOPING || count2 >= $7f4c4daf73fbe3de$var$DEFAULT_MIN_GALLOPING)
                if (exit) break;
                if (_minGallop < 0) _minGallop = 0;
                _minGallop += 2;
            }
            minGallop = _minGallop;
            if (minGallop < 1) minGallop = 1;
            if (length2 === 1) {
                dest -= length1;
                cursor1 -= length1;
                customDest = dest + 1;
                customCursor = cursor1 + 1;
                for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
                array[dest] = tmp[cursor2];
            } else if (length2 === 0) throw new Error();
            else {
                customCursor = dest - (length2 - 1);
                for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
            }
        }
        return {
            mergeRuns: mergeRuns,
            forceMergeRuns: forceMergeRuns,
            pushRun: pushRun
        };
    }
    function $7f4c4daf73fbe3de$export$2e2bcd8739ae039(array, compare, lo, hi) {
        if (!lo) lo = 0;
        if (!hi) hi = array.length;
        var remaining = hi - lo;
        if (remaining < 2) return;
        var runLength = 0;
        if (remaining < $7f4c4daf73fbe3de$var$DEFAULT_MIN_MERGE) {
            runLength = $7f4c4daf73fbe3de$var$makeAscendingRun(array, lo, hi, compare);
            $7f4c4daf73fbe3de$var$binaryInsertionSort(array, lo, hi, lo + runLength, compare);
            return;
        }
        var ts = $7f4c4daf73fbe3de$var$TimSort(array, compare);
        var minRun = $7f4c4daf73fbe3de$var$minRunLength(remaining);
        do {
            runLength = $7f4c4daf73fbe3de$var$makeAscendingRun(array, lo, hi, compare);
            if (runLength < minRun) {
                var force = remaining;
                if (force > minRun) force = minRun;
                $7f4c4daf73fbe3de$var$binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
                runLength = force;
            }
            ts.pushRun(lo, runLength);
            ts.mergeRuns();
            remaining -= runLength;
            lo += runLength;
        }while (remaining !== 0)
        ts.forceMergeRuns();
    }
});
parcelRegister("F44Dl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$07b6fd689a4caf84$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bRKv5;
    var $04xko;
    var $hb2y5;
    var $07b6fd689a4caf84$var$Animation = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Animation, _super);
        function Animation(opts) {
            var _this = _super.call(this) || this;
            _this._running = false;
            _this._time = 0;
            _this._pausedTime = 0;
            _this._pauseStart = 0;
            _this._paused = false;
            opts = opts || {};
            _this.stage = opts.stage || {};
            _this.onframe = opts.onframe || function() {};
            return _this;
        }
        Animation.prototype.addClip = function(clip) {
            if (clip.animation) this.removeClip(clip);
            if (!this._clipsHead) this._clipsHead = this._clipsTail = clip;
            else {
                this._clipsTail.next = clip;
                clip.prev = this._clipsTail;
                clip.next = null;
                this._clipsTail = clip;
            }
            clip.animation = this;
        };
        Animation.prototype.addAnimator = function(animator) {
            animator.animation = this;
            var clip = animator.getClip();
            if (clip) this.addClip(clip);
        };
        Animation.prototype.removeClip = function(clip) {
            if (!clip.animation) return;
            var prev = clip.prev;
            var next = clip.next;
            if (prev) prev.next = next;
            else this._clipsHead = next;
            if (next) next.prev = prev;
            else this._clipsTail = prev;
            clip.next = clip.prev = clip.animation = null;
        };
        Animation.prototype.removeAnimator = function(animator) {
            var clip = animator.getClip();
            if (clip) this.removeClip(clip);
            animator.animation = null;
        };
        Animation.prototype.update = function(notTriggerFrameAndStageUpdate) {
            var time = new Date().getTime() - this._pausedTime;
            var delta = time - this._time;
            var clip = this._clipsHead;
            while(clip){
                var nextClip = clip.next;
                var finished = clip.step(time, delta);
                if (finished) {
                    clip.ondestroy && clip.ondestroy();
                    this.removeClip(clip);
                    clip = nextClip;
                } else clip = nextClip;
            }
            this._time = time;
            if (!notTriggerFrameAndStageUpdate) {
                this.onframe(delta);
                this.trigger('frame', delta);
                this.stage.update && this.stage.update();
            }
        };
        Animation.prototype._startLoop = function() {
            var self = this;
            this._running = true;
            function step() {
                if (self._running) {
                    (0, (0, parcelRequire("04xko")).default)(step);
                    !self._paused && self.update();
                }
            }
            (0, (0, parcelRequire("04xko")).default)(step);
        };
        Animation.prototype.start = function() {
            if (this._running) return;
            this._time = new Date().getTime();
            this._pausedTime = 0;
            this._startLoop();
        };
        Animation.prototype.stop = function() {
            this._running = false;
        };
        Animation.prototype.pause = function() {
            if (!this._paused) {
                this._pauseStart = new Date().getTime();
                this._paused = true;
            }
        };
        Animation.prototype.resume = function() {
            if (this._paused) {
                this._pausedTime += new Date().getTime() - this._pauseStart;
                this._paused = false;
            }
        };
        Animation.prototype.clear = function() {
            var clip = this._clipsHead;
            while(clip){
                var nextClip = clip.next;
                clip.prev = clip.next = clip.animation = null;
                clip = nextClip;
            }
            this._clipsHead = this._clipsTail = null;
        };
        Animation.prototype.isFinished = function() {
            return this._clipsHead == null;
        };
        Animation.prototype.animate = function(target, options) {
            options = options || {};
            this.start();
            var animator = new (0, (0, parcelRequire("hb2y5")).default)(target, options.loop);
            this.addAnimator(animator);
            return animator;
        };
        return Animation;
    }((0, (0, parcelRequire("bRKv5")).default));
    var $07b6fd689a4caf84$export$2e2bcd8739ae039 = $07b6fd689a4caf84$var$Animation;
});
parcelRegister("04xko", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$00da3a149d316342$export$2e2bcd8739ae039);
    var $00da3a149d316342$var$requestAnimationFrame;
    $00da3a149d316342$var$requestAnimationFrame = typeof window !== 'undefined' && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function(func) {
        return setTimeout(func, 16);
    };
    var $00da3a149d316342$export$2e2bcd8739ae039 = $00da3a149d316342$var$requestAnimationFrame;
});
parcelRegister("bHSYT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$885e5bfc09439923$export$2e2bcd8739ae039);
    var $3VFsf;
    var $65X4x;
    var $bahqM;
    var $bRKv5;
    var $hZfwb;
    var $885e5bfc09439923$var$TOUCH_CLICK_DELAY = 300;
    var $885e5bfc09439923$var$globalEventSupported = (0, (0, parcelRequire("hZfwb")).default).domSupported;
    var $885e5bfc09439923$var$localNativeListenerNames = function() {
        var mouseHandlerNames = [
            'click',
            'dblclick',
            'mousewheel',
            'wheel',
            'mouseout',
            'mouseup',
            'mousedown',
            'mousemove',
            'contextmenu'
        ];
        var touchHandlerNames = [
            'touchstart',
            'touchend',
            'touchmove'
        ];
        var pointerEventNameMap = {
            pointerdown: 1,
            pointerup: 1,
            pointermove: 1,
            pointerout: 1
        };
        var pointerHandlerNames = (0, parcelRequire("bahqM")).map(mouseHandlerNames, function(name) {
            var nm = name.replace('mouse', 'pointer');
            return pointerEventNameMap.hasOwnProperty(nm) ? nm : name;
        });
        return {
            mouse: mouseHandlerNames,
            touch: touchHandlerNames,
            pointer: pointerHandlerNames
        };
    }();
    var $885e5bfc09439923$var$globalNativeListenerNames = {
        mouse: [
            'mousemove',
            'mouseup'
        ],
        pointer: [
            'pointermove',
            'pointerup'
        ]
    };
    var $885e5bfc09439923$var$wheelEventSupported = false;
    function $885e5bfc09439923$var$isPointerFromTouch(event) {
        var pointerType = event.pointerType;
        return pointerType === 'pen' || pointerType === 'touch';
    }
    function $885e5bfc09439923$var$setTouchTimer(scope) {
        scope.touching = true;
        if (scope.touchTimer != null) {
            clearTimeout(scope.touchTimer);
            scope.touchTimer = null;
        }
        scope.touchTimer = setTimeout(function() {
            scope.touching = false;
            scope.touchTimer = null;
        }, 700);
    }
    function $885e5bfc09439923$var$markTouch(event) {
        event && (event.zrByTouch = true);
    }
    function $885e5bfc09439923$var$normalizeGlobalEvent(instance, event) {
        return (0, (0, parcelRequire("65X4x")).normalizeEvent)(instance.dom, new $885e5bfc09439923$var$FakeGlobalEvent(instance, event), true);
    }
    function $885e5bfc09439923$var$isLocalEl(instance, el) {
        var elTmp = el;
        var isLocal = false;
        while(elTmp && elTmp.nodeType !== 9 && !(isLocal = elTmp.domBelongToZr || elTmp !== el && elTmp === instance.painterRoot))elTmp = elTmp.parentNode;
        return isLocal;
    }
    var $885e5bfc09439923$var$FakeGlobalEvent = function() {
        function FakeGlobalEvent(instance, event) {
            this.stopPropagation = (0, parcelRequire("bahqM")).noop;
            this.stopImmediatePropagation = (0, parcelRequire("bahqM")).noop;
            this.preventDefault = (0, parcelRequire("bahqM")).noop;
            this.type = event.type;
            this.target = this.currentTarget = instance.dom;
            this.pointerType = event.pointerType;
            this.clientX = event.clientX;
            this.clientY = event.clientY;
        }
        return FakeGlobalEvent;
    }();
    var $885e5bfc09439923$var$localDOMHandlers = {
        mousedown: function(event) {
            event = (0, (0, parcelRequire("65X4x")).normalizeEvent)(this.dom, event);
            this.__mayPointerCapture = [
                event.zrX,
                event.zrY
            ];
            this.trigger('mousedown', event);
        },
        mousemove: function(event) {
            event = (0, (0, parcelRequire("65X4x")).normalizeEvent)(this.dom, event);
            var downPoint = this.__mayPointerCapture;
            if (downPoint && (event.zrX !== downPoint[0] || event.zrY !== downPoint[1])) this.__togglePointerCapture(true);
            this.trigger('mousemove', event);
        },
        mouseup: function(event) {
            event = (0, (0, parcelRequire("65X4x")).normalizeEvent)(this.dom, event);
            this.__togglePointerCapture(false);
            this.trigger('mouseup', event);
        },
        mouseout: function(event) {
            event = (0, (0, parcelRequire("65X4x")).normalizeEvent)(this.dom, event);
            var element = event.toElement || event.relatedTarget;
            if (!$885e5bfc09439923$var$isLocalEl(this, element)) {
                if (this.__pointerCapturing) event.zrEventControl = 'no_globalout';
                this.trigger('mouseout', event);
            }
        },
        wheel: function(event) {
            $885e5bfc09439923$var$wheelEventSupported = true;
            event = (0, (0, parcelRequire("65X4x")).normalizeEvent)(this.dom, event);
            this.trigger('mousewheel', event);
        },
        mousewheel: function(event) {
            if ($885e5bfc09439923$var$wheelEventSupported) return;
            event = (0, (0, parcelRequire("65X4x")).normalizeEvent)(this.dom, event);
            this.trigger('mousewheel', event);
        },
        touchstart: function(event) {
            event = (0, (0, parcelRequire("65X4x")).normalizeEvent)(this.dom, event);
            $885e5bfc09439923$var$markTouch(event);
            this.__lastTouchMoment = new Date();
            this.handler.processGesture(event, 'start');
            $885e5bfc09439923$var$localDOMHandlers.mousemove.call(this, event);
            $885e5bfc09439923$var$localDOMHandlers.mousedown.call(this, event);
        },
        touchmove: function(event) {
            event = (0, (0, parcelRequire("65X4x")).normalizeEvent)(this.dom, event);
            $885e5bfc09439923$var$markTouch(event);
            this.handler.processGesture(event, 'change');
            $885e5bfc09439923$var$localDOMHandlers.mousemove.call(this, event);
        },
        touchend: function(event) {
            event = (0, (0, parcelRequire("65X4x")).normalizeEvent)(this.dom, event);
            $885e5bfc09439923$var$markTouch(event);
            this.handler.processGesture(event, 'end');
            $885e5bfc09439923$var$localDOMHandlers.mouseup.call(this, event);
            if (+new Date() - +this.__lastTouchMoment < $885e5bfc09439923$var$TOUCH_CLICK_DELAY) $885e5bfc09439923$var$localDOMHandlers.click.call(this, event);
        },
        pointerdown: function(event) {
            $885e5bfc09439923$var$localDOMHandlers.mousedown.call(this, event);
        },
        pointermove: function(event) {
            if (!$885e5bfc09439923$var$isPointerFromTouch(event)) $885e5bfc09439923$var$localDOMHandlers.mousemove.call(this, event);
        },
        pointerup: function(event) {
            $885e5bfc09439923$var$localDOMHandlers.mouseup.call(this, event);
        },
        pointerout: function(event) {
            if (!$885e5bfc09439923$var$isPointerFromTouch(event)) $885e5bfc09439923$var$localDOMHandlers.mouseout.call(this, event);
        }
    };
    (0, parcelRequire("bahqM")).each([
        'click',
        'dblclick',
        'contextmenu'
    ], function(name) {
        $885e5bfc09439923$var$localDOMHandlers[name] = function(event) {
            event = (0, (0, parcelRequire("65X4x")).normalizeEvent)(this.dom, event);
            this.trigger(name, event);
        };
    });
    var $885e5bfc09439923$var$globalDOMHandlers = {
        pointermove: function(event) {
            if (!$885e5bfc09439923$var$isPointerFromTouch(event)) $885e5bfc09439923$var$globalDOMHandlers.mousemove.call(this, event);
        },
        pointerup: function(event) {
            $885e5bfc09439923$var$globalDOMHandlers.mouseup.call(this, event);
        },
        mousemove: function(event) {
            this.trigger('mousemove', event);
        },
        mouseup: function(event) {
            var pointerCaptureReleasing = this.__pointerCapturing;
            this.__togglePointerCapture(false);
            this.trigger('mouseup', event);
            if (pointerCaptureReleasing) {
                event.zrEventControl = 'only_globalout';
                this.trigger('mouseout', event);
            }
        }
    };
    function $885e5bfc09439923$var$mountLocalDOMEventListeners(instance, scope) {
        var domHandlers = scope.domHandlers;
        if ((0, (0, parcelRequire("hZfwb")).default).pointerEventsSupported) (0, parcelRequire("bahqM")).each($885e5bfc09439923$var$localNativeListenerNames.pointer, function(nativeEventName) {
            $885e5bfc09439923$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                domHandlers[nativeEventName].call(instance, event);
            });
        });
        else {
            if ((0, (0, parcelRequire("hZfwb")).default).touchEventsSupported) (0, parcelRequire("bahqM")).each($885e5bfc09439923$var$localNativeListenerNames.touch, function(nativeEventName) {
                $885e5bfc09439923$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                    domHandlers[nativeEventName].call(instance, event);
                    $885e5bfc09439923$var$setTouchTimer(scope);
                });
            });
            (0, parcelRequire("bahqM")).each($885e5bfc09439923$var$localNativeListenerNames.mouse, function(nativeEventName) {
                $885e5bfc09439923$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                    event = (0, (0, parcelRequire("65X4x")).getNativeEvent)(event);
                    if (!scope.touching) domHandlers[nativeEventName].call(instance, event);
                });
            });
        }
    }
    function $885e5bfc09439923$var$mountGlobalDOMEventListeners(instance, scope) {
        if ((0, (0, parcelRequire("hZfwb")).default).pointerEventsSupported) (0, parcelRequire("bahqM")).each($885e5bfc09439923$var$globalNativeListenerNames.pointer, mount);
        else if (!(0, (0, parcelRequire("hZfwb")).default).touchEventsSupported) (0, parcelRequire("bahqM")).each($885e5bfc09439923$var$globalNativeListenerNames.mouse, mount);
        function mount(nativeEventName) {
            function nativeEventListener(event) {
                event = (0, (0, parcelRequire("65X4x")).getNativeEvent)(event);
                if (!$885e5bfc09439923$var$isLocalEl(instance, event.target)) {
                    event = $885e5bfc09439923$var$normalizeGlobalEvent(instance, event);
                    scope.domHandlers[nativeEventName].call(instance, event);
                }
            }
            $885e5bfc09439923$var$mountSingleDOMEventListener(scope, nativeEventName, nativeEventListener, {
                capture: true
            });
        }
    }
    function $885e5bfc09439923$var$mountSingleDOMEventListener(scope, nativeEventName, listener, opt) {
        scope.mounted[nativeEventName] = listener;
        scope.listenerOpts[nativeEventName] = opt;
        (0, (0, parcelRequire("65X4x")).addEventListener)(scope.domTarget, nativeEventName, listener, opt);
    }
    function $885e5bfc09439923$var$unmountDOMEventListeners(scope) {
        var mounted = scope.mounted;
        for(var nativeEventName in mounted)if (mounted.hasOwnProperty(nativeEventName)) (0, (0, parcelRequire("65X4x")).removeEventListener)(scope.domTarget, nativeEventName, mounted[nativeEventName], scope.listenerOpts[nativeEventName]);
        scope.mounted = {};
    }
    var $885e5bfc09439923$var$DOMHandlerScope = function() {
        function DOMHandlerScope(domTarget, domHandlers) {
            this.mounted = {};
            this.listenerOpts = {};
            this.touching = false;
            this.domTarget = domTarget;
            this.domHandlers = domHandlers;
        }
        return DOMHandlerScope;
    }();
    var $885e5bfc09439923$var$HandlerDomProxy = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(HandlerDomProxy, _super);
        function HandlerDomProxy(dom, painterRoot) {
            var _this = _super.call(this) || this;
            _this.__pointerCapturing = false;
            _this.dom = dom;
            _this.painterRoot = painterRoot;
            _this._localHandlerScope = new $885e5bfc09439923$var$DOMHandlerScope(dom, $885e5bfc09439923$var$localDOMHandlers);
            if ($885e5bfc09439923$var$globalEventSupported) _this._globalHandlerScope = new $885e5bfc09439923$var$DOMHandlerScope(document, $885e5bfc09439923$var$globalDOMHandlers);
            $885e5bfc09439923$var$mountLocalDOMEventListeners(_this, _this._localHandlerScope);
            return _this;
        }
        HandlerDomProxy.prototype.dispose = function() {
            $885e5bfc09439923$var$unmountDOMEventListeners(this._localHandlerScope);
            if ($885e5bfc09439923$var$globalEventSupported) $885e5bfc09439923$var$unmountDOMEventListeners(this._globalHandlerScope);
        };
        HandlerDomProxy.prototype.setCursor = function(cursorStyle) {
            this.dom.style && (this.dom.style.cursor = cursorStyle || 'default');
        };
        HandlerDomProxy.prototype.__togglePointerCapture = function(isPointerCapturing) {
            this.__mayPointerCapture = null;
            if ($885e5bfc09439923$var$globalEventSupported && +this.__pointerCapturing ^ +isPointerCapturing) {
                this.__pointerCapturing = isPointerCapturing;
                var globalHandlerScope = this._globalHandlerScope;
                isPointerCapturing ? $885e5bfc09439923$var$mountGlobalDOMEventListeners(this, globalHandlerScope) : $885e5bfc09439923$var$unmountDOMEventListeners(globalHandlerScope);
            }
        };
        return HandlerDomProxy;
    }((0, (0, parcelRequire("bRKv5")).default));
    var $885e5bfc09439923$export$2e2bcd8739ae039 = $885e5bfc09439923$var$HandlerDomProxy;
});
parcelRegister("74g78", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$525568051e570380$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bahqM;
    var $eaKsF;
    var $gaMkj;
    var $h4UlH;
    var $34Vzq;
    var $cNGs8;
    var $iSVvO;
    var $aCu4v;
    var $2cFRc;
    var $525568051e570380$var$reCreateSeriesIndices;
    var $525568051e570380$var$assertSeriesInitialized;
    var $525568051e570380$var$initBase;
    var $525568051e570380$var$OPTION_INNER_KEY = '\0_ec_inner';
    var $525568051e570380$var$OPTION_INNER_VALUE = 1;
    var $525568051e570380$var$BUITIN_COMPONENTS_MAP = {
        grid: 'GridComponent',
        polar: 'PolarComponent',
        geo: 'GeoComponent',
        singleAxis: 'SingleAxisComponent',
        parallel: 'ParallelComponent',
        calendar: 'CalendarComponent',
        graphic: 'GraphicComponent',
        toolbox: 'ToolboxComponent',
        tooltip: 'TooltipComponent',
        axisPointer: 'AxisPointerComponent',
        brush: 'BrushComponent',
        title: 'TitleComponent',
        timeline: 'TimelineComponent',
        markPoint: 'MarkPointComponent',
        markLine: 'MarkLineComponent',
        markArea: 'MarkAreaComponent',
        legend: 'LegendComponent',
        dataZoom: 'DataZoomComponent',
        visualMap: 'VisualMapComponent',
        xAxis: 'GridComponent',
        yAxis: 'GridComponent',
        angleAxis: 'PolarComponent',
        radiusAxis: 'PolarComponent'
    };
    var $525568051e570380$var$BUILTIN_CHARTS_MAP = {
        line: 'LineChart',
        bar: 'BarChart',
        pie: 'PieChart',
        scatter: 'ScatterChart',
        radar: 'RadarChart',
        map: 'MapChart',
        tree: 'TreeChart',
        treemap: 'TreemapChart',
        graph: 'GraphChart',
        gauge: 'GaugeChart',
        funnel: 'FunnelChart',
        parallel: 'ParallelChart',
        sankey: 'SankeyChart',
        boxplot: 'BoxplotChart',
        candlestick: 'CandlestickChart',
        effectScatter: 'EffectScatterChart',
        lines: 'LinesChart',
        heatmap: 'HeatmapChart',
        pictorialBar: 'PictorialBarChart',
        themeRiver: 'ThemeRiverChart',
        sunburst: 'SunburstChart',
        custom: 'CustomChart'
    };
    var $525568051e570380$var$componetsMissingLogPrinted = {};
    function $525568051e570380$var$checkMissingComponents(option) {
        (0, (0, parcelRequire("bahqM")).each)(option, function(componentOption, mainType) {
            if (!(0, (0, parcelRequire("h4UlH")).default).hasClass(mainType)) {
                var componentImportName = $525568051e570380$var$BUITIN_COMPONENTS_MAP[mainType];
                if (componentImportName && !$525568051e570380$var$componetsMissingLogPrinted[componentImportName]) {
                    (0, (0, parcelRequire("2cFRc")).error)("Component " + mainType + " is used but not imported.\nimport { " + componentImportName + " } from 'echarts/components';\necharts.use([" + componentImportName + "]);");
                    $525568051e570380$var$componetsMissingLogPrinted[componentImportName] = true;
                }
            }
        });
    }
    var $525568051e570380$var$GlobalModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(GlobalModel, _super);
        function GlobalModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        GlobalModel.prototype.init = function(option, parentModel, ecModel, theme, locale, optionManager) {
            theme = theme || {};
            this.option = null;
            this._theme = new (0, (0, parcelRequire("gaMkj")).default)(theme);
            this._locale = new (0, (0, parcelRequire("gaMkj")).default)(locale);
            this._optionManager = optionManager;
        };
        GlobalModel.prototype.setOption = function(option, opts, optionPreprocessorFuncs) {
            var innerOpt = $525568051e570380$var$normalizeSetOptionInput(opts);
            this._optionManager.setOption(option, optionPreprocessorFuncs, innerOpt);
            this._resetOption(null, innerOpt);
        };
        GlobalModel.prototype.resetOption = function(type, opt) {
            return this._resetOption(type, $525568051e570380$var$normalizeSetOptionInput(opt));
        };
        GlobalModel.prototype._resetOption = function(type, opt) {
            var optionChanged = false;
            var optionManager = this._optionManager;
            if (!type || type === 'recreate') {
                var baseOption = optionManager.mountOption(type === 'recreate');
                if (!this.option || type === 'recreate') $525568051e570380$var$initBase(this, baseOption);
                else {
                    this.restoreData();
                    this._mergeOption(baseOption, opt);
                }
                optionChanged = true;
            }
            if (type === 'timeline' || type === 'media') this.restoreData();
            if (!type || type === 'recreate' || type === 'timeline') {
                var timelineOption = optionManager.getTimelineOption(this);
                if (timelineOption) {
                    optionChanged = true;
                    this._mergeOption(timelineOption, opt);
                }
            }
            if (!type || type === 'recreate' || type === 'media') {
                var mediaOptions = optionManager.getMediaOption(this);
                if (mediaOptions.length) (0, (0, parcelRequire("bahqM")).each)(mediaOptions, function(mediaOption) {
                    optionChanged = true;
                    this._mergeOption(mediaOption, opt);
                }, this);
            }
            return optionChanged;
        };
        GlobalModel.prototype.mergeOption = function(option) {
            this._mergeOption(option, null);
        };
        GlobalModel.prototype._mergeOption = function(newOption, opt) {
            var option = this.option;
            var componentsMap = this._componentsMap;
            var componentsCount = this._componentsCount;
            var newCmptTypes = [];
            var newCmptTypeMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
            var replaceMergeMainTypeMap = opt && opt.replaceMergeMainTypeMap;
            (0, (0, parcelRequire("cNGs8")).resetSourceDefaulter)(this);
            (0, (0, parcelRequire("bahqM")).each)(newOption, function(componentOption, mainType) {
                if (componentOption == null) return;
                if (!(0, (0, parcelRequire("h4UlH")).default).hasClass(mainType)) option[mainType] = option[mainType] == null ? (0, (0, parcelRequire("bahqM")).clone)(componentOption) : (0, (0, parcelRequire("bahqM")).merge)(option[mainType], componentOption, true);
                else if (mainType) {
                    newCmptTypes.push(mainType);
                    newCmptTypeMap.set(mainType, true);
                }
            });
            if (replaceMergeMainTypeMap) replaceMergeMainTypeMap.each(function(val, mainTypeInReplaceMerge) {
                if ((0, (0, parcelRequire("h4UlH")).default).hasClass(mainTypeInReplaceMerge) && !newCmptTypeMap.get(mainTypeInReplaceMerge)) {
                    newCmptTypes.push(mainTypeInReplaceMerge);
                    newCmptTypeMap.set(mainTypeInReplaceMerge, true);
                }
            });
            (0, (0, parcelRequire("h4UlH")).default).topologicalTravel(newCmptTypes, (0, (0, parcelRequire("h4UlH")).default).getAllClassMainTypes(), visitComponent, this);
            function visitComponent(mainType) {
                var newCmptOptionList = (0, (0, parcelRequire("iSVvO")).concatInternalOptions)(this, mainType, (0, parcelRequire("eaKsF")).normalizeToArray(newOption[mainType]));
                var oldCmptList = componentsMap.get(mainType);
                var mergeMode = !oldCmptList ? 'replaceAll' : replaceMergeMainTypeMap && replaceMergeMainTypeMap.get(mainType) ? 'replaceMerge' : 'normalMerge';
                var mappingResult = (0, parcelRequire("eaKsF")).mappingToExists(oldCmptList, newCmptOptionList, mergeMode);
                (0, parcelRequire("eaKsF")).setComponentTypeToKeyInfo(mappingResult, mainType, (0, (0, parcelRequire("h4UlH")).default));
                option[mainType] = null;
                componentsMap.set(mainType, null);
                componentsCount.set(mainType, 0);
                var optionsByMainType = [];
                var cmptsByMainType = [];
                var cmptsCountByMainType = 0;
                (0, (0, parcelRequire("bahqM")).each)(mappingResult, function(resultItem, index) {
                    var componentModel = resultItem.existing;
                    var newCmptOption = resultItem.newOption;
                    if (!newCmptOption) {
                        if (componentModel) {
                            componentModel.mergeOption({}, this);
                            componentModel.optionUpdated({}, false);
                        }
                    } else {
                        var isSeriesType = mainType === 'series';
                        var ComponentModelClass = (0, (0, parcelRequire("h4UlH")).default).getClass(mainType, resultItem.keyInfo.subType, !isSeriesType);
                        if (!ComponentModelClass) {
                            var subType, seriesImportName;
                            return;
                        }
                        if (componentModel && componentModel.constructor === ComponentModelClass) {
                            componentModel.name = resultItem.keyInfo.name;
                            componentModel.mergeOption(newCmptOption, this);
                            componentModel.optionUpdated(newCmptOption, false);
                        } else {
                            var extraOpt = (0, (0, parcelRequire("bahqM")).extend)({
                                componentIndex: index
                            }, resultItem.keyInfo);
                            componentModel = new ComponentModelClass(newCmptOption, this, this, extraOpt);
                            (0, (0, parcelRequire("bahqM")).extend)(componentModel, extraOpt);
                            if (resultItem.brandNew) componentModel.__requireNewView = true;
                            componentModel.init(newCmptOption, this, this);
                            componentModel.optionUpdated(null, true);
                        }
                    }
                    if (componentModel) {
                        optionsByMainType.push(componentModel.option);
                        cmptsByMainType.push(componentModel);
                        cmptsCountByMainType++;
                    } else {
                        optionsByMainType.push(void 0);
                        cmptsByMainType.push(void 0);
                    }
                }, this);
                option[mainType] = optionsByMainType;
                componentsMap.set(mainType, cmptsByMainType);
                componentsCount.set(mainType, cmptsCountByMainType);
                if (mainType === 'series') $525568051e570380$var$reCreateSeriesIndices(this);
            }
            if (!this._seriesIndices) $525568051e570380$var$reCreateSeriesIndices(this);
        };
        GlobalModel.prototype.getOption = function() {
            var option = (0, (0, parcelRequire("bahqM")).clone)(this.option);
            (0, (0, parcelRequire("bahqM")).each)(option, function(optInMainType, mainType) {
                if ((0, (0, parcelRequire("h4UlH")).default).hasClass(mainType)) {
                    var opts = (0, parcelRequire("eaKsF")).normalizeToArray(optInMainType);
                    var realLen = opts.length;
                    var metNonInner = false;
                    for(var i = realLen - 1; i >= 0; i--)if (opts[i] && !(0, parcelRequire("eaKsF")).isComponentIdInternal(opts[i])) metNonInner = true;
                    else {
                        opts[i] = null;
                        !metNonInner && realLen--;
                    }
                    opts.length = realLen;
                    option[mainType] = opts;
                }
            });
            delete option[$525568051e570380$var$OPTION_INNER_KEY];
            return option;
        };
        GlobalModel.prototype.getTheme = function() {
            return this._theme;
        };
        GlobalModel.prototype.getLocaleModel = function() {
            return this._locale;
        };
        GlobalModel.prototype.setUpdatePayload = function(payload) {
            this._payload = payload;
        };
        GlobalModel.prototype.getUpdatePayload = function() {
            return this._payload;
        };
        GlobalModel.prototype.getComponent = function(mainType, idx) {
            var list = this._componentsMap.get(mainType);
            if (list) {
                var cmpt = list[idx || 0];
                if (cmpt) return cmpt;
                else if (idx == null) for(var i = 0; i < list.length; i++){
                    if (list[i]) return list[i];
                }
            }
        };
        GlobalModel.prototype.queryComponents = function(condition) {
            var mainType = condition.mainType;
            if (!mainType) return [];
            var index = condition.index;
            var id = condition.id;
            var name = condition.name;
            var cmpts = this._componentsMap.get(mainType);
            if (!cmpts || !cmpts.length) return [];
            var result;
            if (index != null) {
                result = [];
                (0, (0, parcelRequire("bahqM")).each)((0, parcelRequire("eaKsF")).normalizeToArray(index), function(idx) {
                    cmpts[idx] && result.push(cmpts[idx]);
                });
            } else if (id != null) result = $525568051e570380$var$queryByIdOrName('id', id, cmpts);
            else if (name != null) result = $525568051e570380$var$queryByIdOrName('name', name, cmpts);
            else result = (0, (0, parcelRequire("bahqM")).filter)(cmpts, function(cmpt) {
                return !!cmpt;
            });
            return $525568051e570380$var$filterBySubType(result, condition);
        };
        GlobalModel.prototype.findComponents = function(condition) {
            var query = condition.query;
            var mainType = condition.mainType;
            var queryCond = getQueryCond(query);
            var result = queryCond ? this.queryComponents(queryCond) : (0, (0, parcelRequire("bahqM")).filter)(this._componentsMap.get(mainType), function(cmpt) {
                return !!cmpt;
            });
            return doFilter($525568051e570380$var$filterBySubType(result, condition));
            function getQueryCond(q) {
                var indexAttr = mainType + 'Index';
                var idAttr = mainType + 'Id';
                var nameAttr = mainType + 'Name';
                return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
                    mainType: mainType,
                    index: q[indexAttr],
                    id: q[idAttr],
                    name: q[nameAttr]
                } : null;
            }
            function doFilter(res) {
                return condition.filter ? (0, (0, parcelRequire("bahqM")).filter)(res, condition.filter) : res;
            }
        };
        GlobalModel.prototype.eachComponent = function(mainType, cb, context) {
            var componentsMap = this._componentsMap;
            if ((0, (0, parcelRequire("bahqM")).isFunction)(mainType)) {
                var ctxForAll_1 = cb;
                var cbForAll_1 = mainType;
                componentsMap.each(function(cmpts, componentType) {
                    for(var i = 0; cmpts && i < cmpts.length; i++){
                        var cmpt = cmpts[i];
                        cmpt && cbForAll_1.call(ctxForAll_1, componentType, cmpt, cmpt.componentIndex);
                    }
                });
            } else {
                var cmpts = (0, (0, parcelRequire("bahqM")).isString)(mainType) ? componentsMap.get(mainType) : (0, (0, parcelRequire("bahqM")).isObject)(mainType) ? this.findComponents(mainType) : null;
                for(var i = 0; cmpts && i < cmpts.length; i++){
                    var cmpt = cmpts[i];
                    cmpt && cb.call(context, cmpt, cmpt.componentIndex);
                }
            }
        };
        GlobalModel.prototype.getSeriesByName = function(name) {
            var nameStr = (0, parcelRequire("eaKsF")).convertOptionIdName(name, null);
            return (0, (0, parcelRequire("bahqM")).filter)(this._componentsMap.get('series'), function(oneSeries) {
                return !!oneSeries && nameStr != null && oneSeries.name === nameStr;
            });
        };
        GlobalModel.prototype.getSeriesByIndex = function(seriesIndex) {
            return this._componentsMap.get('series')[seriesIndex];
        };
        GlobalModel.prototype.getSeriesByType = function(subType) {
            return (0, (0, parcelRequire("bahqM")).filter)(this._componentsMap.get('series'), function(oneSeries) {
                return !!oneSeries && oneSeries.subType === subType;
            });
        };
        GlobalModel.prototype.getSeries = function() {
            return (0, (0, parcelRequire("bahqM")).filter)(this._componentsMap.get('series'), function(oneSeries) {
                return !!oneSeries;
            });
        };
        GlobalModel.prototype.getSeriesCount = function() {
            return this._componentsCount.get('series');
        };
        GlobalModel.prototype.eachSeries = function(cb, context) {
            $525568051e570380$var$assertSeriesInitialized(this);
            (0, (0, parcelRequire("bahqM")).each)(this._seriesIndices, function(rawSeriesIndex) {
                var series = this._componentsMap.get('series')[rawSeriesIndex];
                cb.call(context, series, rawSeriesIndex);
            }, this);
        };
        GlobalModel.prototype.eachRawSeries = function(cb, context) {
            (0, (0, parcelRequire("bahqM")).each)(this._componentsMap.get('series'), function(series) {
                series && cb.call(context, series, series.componentIndex);
            });
        };
        GlobalModel.prototype.eachSeriesByType = function(subType, cb, context) {
            $525568051e570380$var$assertSeriesInitialized(this);
            (0, (0, parcelRequire("bahqM")).each)(this._seriesIndices, function(rawSeriesIndex) {
                var series = this._componentsMap.get('series')[rawSeriesIndex];
                if (series.subType === subType) cb.call(context, series, rawSeriesIndex);
            }, this);
        };
        GlobalModel.prototype.eachRawSeriesByType = function(subType, cb, context) {
            return (0, (0, parcelRequire("bahqM")).each)(this.getSeriesByType(subType), cb, context);
        };
        GlobalModel.prototype.isSeriesFiltered = function(seriesModel) {
            $525568051e570380$var$assertSeriesInitialized(this);
            return this._seriesIndicesMap.get(seriesModel.componentIndex) == null;
        };
        GlobalModel.prototype.getCurrentSeriesIndices = function() {
            return (this._seriesIndices || []).slice();
        };
        GlobalModel.prototype.filterSeries = function(cb, context) {
            $525568051e570380$var$assertSeriesInitialized(this);
            var newSeriesIndices = [];
            (0, (0, parcelRequire("bahqM")).each)(this._seriesIndices, function(seriesRawIdx) {
                var series = this._componentsMap.get('series')[seriesRawIdx];
                cb.call(context, series, seriesRawIdx) && newSeriesIndices.push(seriesRawIdx);
            }, this);
            this._seriesIndices = newSeriesIndices;
            this._seriesIndicesMap = (0, (0, parcelRequire("bahqM")).createHashMap)(newSeriesIndices);
        };
        GlobalModel.prototype.restoreData = function(payload) {
            $525568051e570380$var$reCreateSeriesIndices(this);
            var componentsMap = this._componentsMap;
            var componentTypes = [];
            componentsMap.each(function(components, componentType) {
                if ((0, (0, parcelRequire("h4UlH")).default).hasClass(componentType)) componentTypes.push(componentType);
            });
            (0, (0, parcelRequire("h4UlH")).default).topologicalTravel(componentTypes, (0, (0, parcelRequire("h4UlH")).default).getAllClassMainTypes(), function(componentType) {
                (0, (0, parcelRequire("bahqM")).each)(componentsMap.get(componentType), function(component) {
                    if (component && (componentType !== 'series' || !$525568051e570380$var$isNotTargetSeries(component, payload))) component.restoreData();
                });
            });
        };
        GlobalModel.internalField = function() {
            $525568051e570380$var$reCreateSeriesIndices = function(ecModel) {
                var seriesIndices = ecModel._seriesIndices = [];
                (0, (0, parcelRequire("bahqM")).each)(ecModel._componentsMap.get('series'), function(series) {
                    series && seriesIndices.push(series.componentIndex);
                });
                ecModel._seriesIndicesMap = (0, (0, parcelRequire("bahqM")).createHashMap)(seriesIndices);
            };
            $525568051e570380$var$assertSeriesInitialized = function(ecModel) {};
            $525568051e570380$var$initBase = function(ecModel, baseOption) {
                ecModel.option = {};
                ecModel.option[$525568051e570380$var$OPTION_INNER_KEY] = $525568051e570380$var$OPTION_INNER_VALUE;
                ecModel._componentsMap = (0, (0, parcelRequire("bahqM")).createHashMap)({
                    series: []
                });
                ecModel._componentsCount = (0, (0, parcelRequire("bahqM")).createHashMap)();
                var airaOption = baseOption.aria;
                if ((0, (0, parcelRequire("bahqM")).isObject)(airaOption) && airaOption.enabled == null) airaOption.enabled = true;
                $525568051e570380$var$mergeTheme(baseOption, ecModel._theme.option);
                (0, (0, parcelRequire("bahqM")).merge)(baseOption, (0, (0, parcelRequire("34Vzq")).default), false);
                ecModel._mergeOption(baseOption, null);
            };
        }();
        return GlobalModel;
    }((0, (0, parcelRequire("gaMkj")).default));
    function $525568051e570380$var$isNotTargetSeries(seriesModel, payload) {
        if (payload) {
            var index = payload.seriesIndex;
            var id = payload.seriesId;
            var name_1 = payload.seriesName;
            return index != null && seriesModel.componentIndex !== index || id != null && seriesModel.id !== id || name_1 != null && seriesModel.name !== name_1;
        }
    }
    function $525568051e570380$var$mergeTheme(option, theme) {
        var notMergeColorLayer = option.color && !option.colorLayer;
        (0, (0, parcelRequire("bahqM")).each)(theme, function(themeItem, name) {
            if (name === 'colorLayer' && notMergeColorLayer) return;
            if (!(0, (0, parcelRequire("h4UlH")).default).hasClass(name)) {
                if (typeof themeItem === 'object') option[name] = !option[name] ? (0, (0, parcelRequire("bahqM")).clone)(themeItem) : (0, (0, parcelRequire("bahqM")).merge)(option[name], themeItem, false);
                else if (option[name] == null) option[name] = themeItem;
            }
        });
    }
    function $525568051e570380$var$queryByIdOrName(attr, idOrName, cmpts) {
        if ((0, (0, parcelRequire("bahqM")).isArray)(idOrName)) {
            var keyMap_1 = (0, (0, parcelRequire("bahqM")).createHashMap)();
            (0, (0, parcelRequire("bahqM")).each)(idOrName, function(idOrNameItem) {
                if (idOrNameItem != null) {
                    var idName = (0, parcelRequire("eaKsF")).convertOptionIdName(idOrNameItem, null);
                    idName != null && keyMap_1.set(idOrNameItem, true);
                }
            });
            return (0, (0, parcelRequire("bahqM")).filter)(cmpts, function(cmpt) {
                return cmpt && keyMap_1.get(cmpt[attr]);
            });
        } else {
            var idName_1 = (0, parcelRequire("eaKsF")).convertOptionIdName(idOrName, null);
            return (0, (0, parcelRequire("bahqM")).filter)(cmpts, function(cmpt) {
                return cmpt && idName_1 != null && cmpt[attr] === idName_1;
            });
        }
    }
    function $525568051e570380$var$filterBySubType(components, condition) {
        return condition.hasOwnProperty('subType') ? (0, (0, parcelRequire("bahqM")).filter)(components, function(cmpt) {
            return cmpt && cmpt.subType === condition.subType;
        }) : components;
    }
    function $525568051e570380$var$normalizeSetOptionInput(opts) {
        var replaceMergeMainTypeMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        opts && (0, (0, parcelRequire("bahqM")).each)((0, parcelRequire("eaKsF")).normalizeToArray(opts.replaceMerge), function(mainType) {
            replaceMergeMainTypeMap.set(mainType, true);
        });
        return {
            replaceMergeMainTypeMap: replaceMergeMainTypeMap
        };
    }
    (0, (0, parcelRequire("bahqM")).mixin)($525568051e570380$var$GlobalModel, (0, (0, parcelRequire("aCu4v")).PaletteMixin));
    var $525568051e570380$export$2e2bcd8739ae039 = $525568051e570380$var$GlobalModel;
});
parcelRegister("34Vzq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$23de6718d94f8f53$export$2e2bcd8739ae039);
    var $23de6718d94f8f53$var$platform = '';
    if (typeof navigator !== 'undefined') $23de6718d94f8f53$var$platform = navigator.platform || '';
    var $23de6718d94f8f53$var$decalColor = 'rgba(0, 0, 0, 0.2)';
    var $23de6718d94f8f53$export$2e2bcd8739ae039 = {
        darkMode: 'auto',
        colorBy: 'series',
        color: [
            '#5470c6',
            '#91cc75',
            '#fac858',
            '#ee6666',
            '#73c0de',
            '#3ba272',
            '#fc8452',
            '#9a60b4',
            '#ea7ccc'
        ],
        gradientColor: [
            '#f6efa6',
            '#d88273',
            '#bf444c'
        ],
        aria: {
            decal: {
                decals: [
                    {
                        color: $23de6718d94f8f53$var$decalColor,
                        dashArrayX: [
                            1,
                            0
                        ],
                        dashArrayY: [
                            2,
                            5
                        ],
                        symbolSize: 1,
                        rotation: Math.PI / 6
                    },
                    {
                        color: $23de6718d94f8f53$var$decalColor,
                        symbol: 'circle',
                        dashArrayX: [
                            [
                                8,
                                8
                            ],
                            [
                                0,
                                8,
                                8,
                                0
                            ]
                        ],
                        dashArrayY: [
                            6,
                            0
                        ],
                        symbolSize: 0.8
                    },
                    {
                        color: $23de6718d94f8f53$var$decalColor,
                        dashArrayX: [
                            1,
                            0
                        ],
                        dashArrayY: [
                            4,
                            3
                        ],
                        rotation: -Math.PI / 4
                    },
                    {
                        color: $23de6718d94f8f53$var$decalColor,
                        dashArrayX: [
                            [
                                6,
                                6
                            ],
                            [
                                0,
                                6,
                                6,
                                0
                            ]
                        ],
                        dashArrayY: [
                            6,
                            0
                        ]
                    },
                    {
                        color: $23de6718d94f8f53$var$decalColor,
                        dashArrayX: [
                            [
                                1,
                                0
                            ],
                            [
                                1,
                                6
                            ]
                        ],
                        dashArrayY: [
                            1,
                            0,
                            6,
                            0
                        ],
                        rotation: Math.PI / 4
                    },
                    {
                        color: $23de6718d94f8f53$var$decalColor,
                        symbol: 'triangle',
                        dashArrayX: [
                            [
                                9,
                                9
                            ],
                            [
                                0,
                                9,
                                9,
                                0
                            ]
                        ],
                        dashArrayY: [
                            7,
                            2
                        ],
                        symbolSize: 0.75
                    }
                ]
            }
        },
        textStyle: {
            fontFamily: $23de6718d94f8f53$var$platform.match(/^Win/) ? 'Microsoft YaHei' : 'sans-serif',
            fontSize: 12,
            fontStyle: 'normal',
            fontWeight: 'normal'
        },
        blendMode: null,
        stateAnimation: {
            duration: 300,
            easing: 'cubicOut'
        },
        animation: 'auto',
        animationDuration: 1000,
        animationDurationUpdate: 500,
        animationEasing: 'cubicInOut',
        animationEasingUpdate: 'cubicInOut',
        animationThreshold: 2000,
        progressiveThreshold: 3000,
        progressive: 400,
        hoverLayerThreshold: 3000,
        useUTC: false
    };
});
parcelRegister("iSVvO", function(module, exports) {
    $parcel$export(module.exports, "registerInternalOptionCreator", ()=>$dbf9e1d336044ced$export$5a90be4668898d38);
    $parcel$export(module.exports, "concatInternalOptions", ()=>$dbf9e1d336044ced$export$c713a6a3b43f401d);
    var $bahqM;
    var $dbf9e1d336044ced$var$internalOptionCreatorMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
    function $dbf9e1d336044ced$export$5a90be4668898d38(mainType, creator) {
        (0, (0, parcelRequire("bahqM")).assert)($dbf9e1d336044ced$var$internalOptionCreatorMap.get(mainType) == null && creator);
        $dbf9e1d336044ced$var$internalOptionCreatorMap.set(mainType, creator);
    }
    function $dbf9e1d336044ced$export$c713a6a3b43f401d(ecModel, mainType, newCmptOptionList) {
        var internalOptionCreator = $dbf9e1d336044ced$var$internalOptionCreatorMap.get(mainType);
        if (!internalOptionCreator) return newCmptOptionList;
        var internalOptions = internalOptionCreator(ecModel);
        if (!internalOptions) return newCmptOptionList;
        var i;
        return newCmptOptionList.concat(internalOptions);
    }
});
parcelRegister("iEvqc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d9445617d131115d$export$2e2bcd8739ae039);
    var $bahqM;
    var $d9445617d131115d$var$availableMethods = [
        'getDom',
        'getZr',
        'getWidth',
        'getHeight',
        'getDevicePixelRatio',
        'dispatchAction',
        'isDisposed',
        'on',
        'off',
        'getDataURL',
        'getConnectedDataURL',
        'getOption',
        'getId',
        'updateLabelLayout'
    ];
    var $d9445617d131115d$var$ExtensionAPI = function() {
        function ExtensionAPI(ecInstance) {
            (0, parcelRequire("bahqM")).each($d9445617d131115d$var$availableMethods, function(methodName) {
                this[methodName] = (0, parcelRequire("bahqM")).bind(ecInstance[methodName], ecInstance);
            }, this);
        }
        return ExtensionAPI;
    }();
    var $d9445617d131115d$export$2e2bcd8739ae039 = $d9445617d131115d$var$ExtensionAPI;
});
parcelRegister("6LzFt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4ed2ccc95e9b6d0d$export$2e2bcd8739ae039);
    var $eaKsF;
    var $bahqM;
    var $4ed2ccc95e9b6d0d$var$QUERY_REG = /^(min|max)?(.+)$/;
    var $4ed2ccc95e9b6d0d$var$OptionManager = function() {
        function OptionManager(api) {
            this._timelineOptions = [];
            this._mediaList = [];
            this._currentMediaIndices = [];
            this._api = api;
        }
        OptionManager.prototype.setOption = function(rawOption, optionPreprocessorFuncs, opt) {
            if (rawOption) {
                (0, (0, parcelRequire("bahqM")).each)((0, (0, parcelRequire("eaKsF")).normalizeToArray)(rawOption.series), function(series) {
                    series && series.data && (0, (0, parcelRequire("bahqM")).isTypedArray)(series.data) && (0, (0, parcelRequire("bahqM")).setAsPrimitive)(series.data);
                });
                (0, (0, parcelRequire("bahqM")).each)((0, (0, parcelRequire("eaKsF")).normalizeToArray)(rawOption.dataset), function(dataset) {
                    dataset && dataset.source && (0, (0, parcelRequire("bahqM")).isTypedArray)(dataset.source) && (0, (0, parcelRequire("bahqM")).setAsPrimitive)(dataset.source);
                });
            }
            rawOption = (0, (0, parcelRequire("bahqM")).clone)(rawOption);
            var optionBackup = this._optionBackup;
            var newParsedOption = $4ed2ccc95e9b6d0d$var$parseRawOption(rawOption, optionPreprocessorFuncs, !optionBackup);
            this._newBaseOption = newParsedOption.baseOption;
            if (optionBackup) {
                if (newParsedOption.timelineOptions.length) optionBackup.timelineOptions = newParsedOption.timelineOptions;
                if (newParsedOption.mediaList.length) optionBackup.mediaList = newParsedOption.mediaList;
                if (newParsedOption.mediaDefault) optionBackup.mediaDefault = newParsedOption.mediaDefault;
            } else this._optionBackup = newParsedOption;
        };
        OptionManager.prototype.mountOption = function(isRecreate) {
            var optionBackup = this._optionBackup;
            this._timelineOptions = optionBackup.timelineOptions;
            this._mediaList = optionBackup.mediaList;
            this._mediaDefault = optionBackup.mediaDefault;
            this._currentMediaIndices = [];
            return (0, (0, parcelRequire("bahqM")).clone)(isRecreate ? optionBackup.baseOption : this._newBaseOption);
        };
        OptionManager.prototype.getTimelineOption = function(ecModel) {
            var option;
            var timelineOptions = this._timelineOptions;
            if (timelineOptions.length) {
                var timelineModel = ecModel.getComponent('timeline');
                if (timelineModel) option = (0, (0, parcelRequire("bahqM")).clone)(timelineOptions[timelineModel.getCurrentIndex()]);
            }
            return option;
        };
        OptionManager.prototype.getMediaOption = function(ecModel) {
            var ecWidth = this._api.getWidth();
            var ecHeight = this._api.getHeight();
            var mediaList = this._mediaList;
            var mediaDefault = this._mediaDefault;
            var indices = [];
            var result = [];
            if (!mediaList.length && !mediaDefault) return result;
            for(var i = 0, len = mediaList.length; i < len; i++)if ($4ed2ccc95e9b6d0d$var$applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) indices.push(i);
            if (!indices.length && mediaDefault) indices = [
                -1
            ];
            if (indices.length && !$4ed2ccc95e9b6d0d$var$indicesEquals(indices, this._currentMediaIndices)) result = (0, (0, parcelRequire("bahqM")).map)(indices, function(index) {
                return (0, (0, parcelRequire("bahqM")).clone)(index === -1 ? mediaDefault.option : mediaList[index].option);
            });
            this._currentMediaIndices = indices;
            return result;
        };
        return OptionManager;
    }();
    function $4ed2ccc95e9b6d0d$var$parseRawOption(rawOption, optionPreprocessorFuncs, isNew) {
        var mediaList = [];
        var mediaDefault;
        var baseOption;
        var declaredBaseOption = rawOption.baseOption;
        var timelineOnRoot = rawOption.timeline;
        var timelineOptionsOnRoot = rawOption.options;
        var mediaOnRoot = rawOption.media;
        var hasMedia = !!rawOption.media;
        var hasTimeline = !!(timelineOptionsOnRoot || timelineOnRoot || declaredBaseOption && declaredBaseOption.timeline);
        if (declaredBaseOption) {
            baseOption = declaredBaseOption;
            if (!baseOption.timeline) baseOption.timeline = timelineOnRoot;
        } else {
            if (hasTimeline || hasMedia) rawOption.options = rawOption.media = null;
            baseOption = rawOption;
        }
        if (hasMedia) {
            if ((0, (0, parcelRequire("bahqM")).isArray)(mediaOnRoot)) (0, (0, parcelRequire("bahqM")).each)(mediaOnRoot, function(singleMedia) {
                if (singleMedia && singleMedia.option) {
                    if (singleMedia.query) mediaList.push(singleMedia);
                    else if (!mediaDefault) mediaDefault = singleMedia;
                }
            });
        }
        doPreprocess(baseOption);
        (0, (0, parcelRequire("bahqM")).each)(timelineOptionsOnRoot, function(option) {
            return doPreprocess(option);
        });
        (0, (0, parcelRequire("bahqM")).each)(mediaList, function(media) {
            return doPreprocess(media.option);
        });
        function doPreprocess(option) {
            (0, (0, parcelRequire("bahqM")).each)(optionPreprocessorFuncs, function(preProcess) {
                preProcess(option, isNew);
            });
        }
        return {
            baseOption: baseOption,
            timelineOptions: timelineOptionsOnRoot || [],
            mediaDefault: mediaDefault,
            mediaList: mediaList
        };
    }
    function $4ed2ccc95e9b6d0d$var$applyMediaQuery(query, ecWidth, ecHeight) {
        var realMap = {
            width: ecWidth,
            height: ecHeight,
            aspectratio: ecWidth / ecHeight
        };
        var applicatable = true;
        (0, (0, parcelRequire("bahqM")).each)(query, function(value, attr) {
            var matched = attr.match($4ed2ccc95e9b6d0d$var$QUERY_REG);
            if (!matched || !matched[1] || !matched[2]) return;
            var operator = matched[1];
            var realAttr = matched[2].toLowerCase();
            if (!$4ed2ccc95e9b6d0d$var$compare(realMap[realAttr], value, operator)) applicatable = false;
        });
        return applicatable;
    }
    function $4ed2ccc95e9b6d0d$var$compare(real, expect, operator) {
        if (operator === 'min') return real >= expect;
        else if (operator === 'max') return real <= expect;
        else return real === expect;
    }
    function $4ed2ccc95e9b6d0d$var$indicesEquals(indices1, indices2) {
        return indices1.join(',') === indices2.join(',');
    }
    var $4ed2ccc95e9b6d0d$export$2e2bcd8739ae039 = $4ed2ccc95e9b6d0d$var$OptionManager;
});
parcelRegister("driCQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9c8c3e9bb43407b9$export$2e2bcd8739ae039);
    var $bahqM;
    var $9rY8k;
    var $eaKsF;
    function $9c8c3e9bb43407b9$var$get(opt, path) {
        var pathArr = path.split(',');
        var obj = opt;
        for(var i = 0; i < pathArr.length; i++){
            obj = obj && obj[pathArr[i]];
            if (obj == null) break;
        }
        return obj;
    }
    function $9c8c3e9bb43407b9$var$set(opt, path, val, overwrite) {
        var pathArr = path.split(',');
        var obj = opt;
        var key;
        var i = 0;
        for(; i < pathArr.length - 1; i++){
            key = pathArr[i];
            if (obj[key] == null) obj[key] = {};
            obj = obj[key];
        }
        if (overwrite || obj[pathArr[i]] == null) obj[pathArr[i]] = val;
    }
    function $9c8c3e9bb43407b9$var$compatLayoutProperties(option) {
        option && (0, (0, parcelRequire("bahqM")).each)($9c8c3e9bb43407b9$var$LAYOUT_PROPERTIES, function(prop) {
            if (prop[0] in option && !(prop[1] in option)) option[prop[1]] = option[prop[0]];
        });
    }
    var $9c8c3e9bb43407b9$var$LAYOUT_PROPERTIES = [
        [
            'x',
            'left'
        ],
        [
            'y',
            'top'
        ],
        [
            'x2',
            'right'
        ],
        [
            'y2',
            'bottom'
        ]
    ];
    var $9c8c3e9bb43407b9$var$COMPATITABLE_COMPONENTS = [
        'grid',
        'geo',
        'parallel',
        'legend',
        'toolbox',
        'title',
        'visualMap',
        'dataZoom',
        'timeline'
    ];
    var $9c8c3e9bb43407b9$var$BAR_ITEM_STYLE_MAP = [
        [
            'borderRadius',
            'barBorderRadius'
        ],
        [
            'borderColor',
            'barBorderColor'
        ],
        [
            'borderWidth',
            'barBorderWidth'
        ]
    ];
    function $9c8c3e9bb43407b9$var$compatBarItemStyle(option) {
        var itemStyle = option && option.itemStyle;
        if (itemStyle) for(var i = 0; i < $9c8c3e9bb43407b9$var$BAR_ITEM_STYLE_MAP.length; i++){
            var oldName = $9c8c3e9bb43407b9$var$BAR_ITEM_STYLE_MAP[i][1];
            var newName = $9c8c3e9bb43407b9$var$BAR_ITEM_STYLE_MAP[i][0];
            if (itemStyle[oldName] != null) itemStyle[newName] = itemStyle[oldName];
        }
    }
    function $9c8c3e9bb43407b9$var$compatPieLabel(option) {
        if (!option) return;
        if (option.alignTo === 'edge' && option.margin != null && option.edgeDistance == null) option.edgeDistance = option.margin;
    }
    function $9c8c3e9bb43407b9$var$compatSunburstState(option) {
        if (!option) return;
        if (option.downplay && !option.blur) option.blur = option.downplay;
    }
    function $9c8c3e9bb43407b9$var$compatGraphFocus(option) {
        if (!option) return;
        if (option.focusNodeAdjacency != null) {
            option.emphasis = option.emphasis || {};
            if (option.emphasis.focus == null) option.emphasis.focus = 'adjacency';
        }
    }
    function $9c8c3e9bb43407b9$var$traverseTree(data, cb) {
        if (data) for(var i = 0; i < data.length; i++){
            cb(data[i]);
            data[i] && $9c8c3e9bb43407b9$var$traverseTree(data[i].children, cb);
        }
    }
    function $9c8c3e9bb43407b9$export$2e2bcd8739ae039(option, isTheme) {
        (0, (0, parcelRequire("9rY8k")).default)(option, isTheme);
        option.series = (0, (0, parcelRequire("eaKsF")).normalizeToArray)(option.series);
        (0, (0, parcelRequire("bahqM")).each)(option.series, function(seriesOpt) {
            if (!(0, (0, parcelRequire("bahqM")).isObject)(seriesOpt)) return;
            var seriesType = seriesOpt.type;
            if (seriesType === 'line') {
                if (seriesOpt.clipOverflow != null) seriesOpt.clip = seriesOpt.clipOverflow;
            } else if (seriesType === 'pie' || seriesType === 'gauge') {
                if (seriesOpt.clockWise != null) seriesOpt.clockwise = seriesOpt.clockWise;
                $9c8c3e9bb43407b9$var$compatPieLabel(seriesOpt.label);
                var data = seriesOpt.data;
                if (data && !(0, (0, parcelRequire("bahqM")).isTypedArray)(data)) for(var i = 0; i < data.length; i++)$9c8c3e9bb43407b9$var$compatPieLabel(data[i]);
                if (seriesOpt.hoverOffset != null) {
                    seriesOpt.emphasis = seriesOpt.emphasis || {};
                    seriesOpt.emphasis.scaleSize = null;
                }
            } else if (seriesType === 'gauge') {
                var pointerColor = $9c8c3e9bb43407b9$var$get(seriesOpt, 'pointer.color');
                pointerColor != null && $9c8c3e9bb43407b9$var$set(seriesOpt, 'itemStyle.color', pointerColor);
            } else if (seriesType === 'bar') {
                $9c8c3e9bb43407b9$var$compatBarItemStyle(seriesOpt);
                $9c8c3e9bb43407b9$var$compatBarItemStyle(seriesOpt.backgroundStyle);
                $9c8c3e9bb43407b9$var$compatBarItemStyle(seriesOpt.emphasis);
                var data = seriesOpt.data;
                if (data && !(0, (0, parcelRequire("bahqM")).isTypedArray)(data)) {
                    for(var i = 0; i < data.length; i++)if (typeof data[i] === 'object') {
                        $9c8c3e9bb43407b9$var$compatBarItemStyle(data[i]);
                        $9c8c3e9bb43407b9$var$compatBarItemStyle(data[i] && data[i].emphasis);
                    }
                }
            } else if (seriesType === 'sunburst') {
                var highlightPolicy = seriesOpt.highlightPolicy;
                if (highlightPolicy) {
                    seriesOpt.emphasis = seriesOpt.emphasis || {};
                    if (!seriesOpt.emphasis.focus) seriesOpt.emphasis.focus = highlightPolicy;
                }
                $9c8c3e9bb43407b9$var$compatSunburstState(seriesOpt);
                $9c8c3e9bb43407b9$var$traverseTree(seriesOpt.data, $9c8c3e9bb43407b9$var$compatSunburstState);
            } else if (seriesType === 'graph' || seriesType === 'sankey') $9c8c3e9bb43407b9$var$compatGraphFocus(seriesOpt);
            else if (seriesType === 'map') {
                if (seriesOpt.mapType && !seriesOpt.map) seriesOpt.map = seriesOpt.mapType;
                if (seriesOpt.mapLocation) (0, (0, parcelRequire("bahqM")).defaults)(seriesOpt, seriesOpt.mapLocation);
            }
            if (seriesOpt.hoverAnimation != null) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                if (seriesOpt.emphasis && seriesOpt.emphasis.scale == null) seriesOpt.emphasis.scale = seriesOpt.hoverAnimation;
            }
            $9c8c3e9bb43407b9$var$compatLayoutProperties(seriesOpt);
        });
        if (option.dataRange) option.visualMap = option.dataRange;
        (0, (0, parcelRequire("bahqM")).each)($9c8c3e9bb43407b9$var$COMPATITABLE_COMPONENTS, function(componentName) {
            var options = option[componentName];
            if (options) {
                if (!(0, (0, parcelRequire("bahqM")).isArray)(options)) options = [
                    options
                ];
                (0, (0, parcelRequire("bahqM")).each)(options, function(option) {
                    $9c8c3e9bb43407b9$var$compatLayoutProperties(option);
                });
            }
        });
    }
});
parcelRegister("9rY8k", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6e1547e334933782$export$2e2bcd8739ae039);
    var $bahqM;
    var $eaKsF;
    var $6e1547e334933782$var$each = (0, parcelRequire("bahqM")).each;
    var $6e1547e334933782$var$isObject = (0, parcelRequire("bahqM")).isObject;
    var $6e1547e334933782$var$POSSIBLE_STYLES = [
        'areaStyle',
        'lineStyle',
        'nodeStyle',
        'linkStyle',
        'chordStyle',
        'label',
        'labelLine'
    ];
    function $6e1547e334933782$var$compatEC2ItemStyle(opt) {
        var itemStyleOpt = opt && opt.itemStyle;
        if (!itemStyleOpt) return;
        for(var i = 0, len = $6e1547e334933782$var$POSSIBLE_STYLES.length; i < len; i++){
            var styleName = $6e1547e334933782$var$POSSIBLE_STYLES[i];
            var normalItemStyleOpt = itemStyleOpt.normal;
            var emphasisItemStyleOpt = itemStyleOpt.emphasis;
            if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
                opt[styleName] = opt[styleName] || {};
                if (!opt[styleName].normal) opt[styleName].normal = normalItemStyleOpt[styleName];
                else (0, parcelRequire("bahqM")).merge(opt[styleName].normal, normalItemStyleOpt[styleName]);
                normalItemStyleOpt[styleName] = null;
            }
            if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
                opt[styleName] = opt[styleName] || {};
                if (!opt[styleName].emphasis) opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
                else (0, parcelRequire("bahqM")).merge(opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
                emphasisItemStyleOpt[styleName] = null;
            }
        }
    }
    function $6e1547e334933782$var$convertNormalEmphasis(opt, optType, useExtend) {
        if (opt && opt[optType] && (opt[optType].normal || opt[optType].emphasis)) {
            var normalOpt = opt[optType].normal;
            var emphasisOpt = opt[optType].emphasis;
            if (normalOpt) {
                if (useExtend) {
                    opt[optType].normal = opt[optType].emphasis = null;
                    (0, parcelRequire("bahqM")).defaults(opt[optType], normalOpt);
                } else opt[optType] = normalOpt;
            }
            if (emphasisOpt) {
                opt.emphasis = opt.emphasis || {};
                opt.emphasis[optType] = emphasisOpt;
                if (emphasisOpt.focus) opt.emphasis.focus = emphasisOpt.focus;
                if (emphasisOpt.blurScope) opt.emphasis.blurScope = emphasisOpt.blurScope;
            }
        }
    }
    function $6e1547e334933782$var$removeEC3NormalStatus(opt) {
        $6e1547e334933782$var$convertNormalEmphasis(opt, 'itemStyle');
        $6e1547e334933782$var$convertNormalEmphasis(opt, 'lineStyle');
        $6e1547e334933782$var$convertNormalEmphasis(opt, 'areaStyle');
        $6e1547e334933782$var$convertNormalEmphasis(opt, 'label');
        $6e1547e334933782$var$convertNormalEmphasis(opt, 'labelLine');
        $6e1547e334933782$var$convertNormalEmphasis(opt, 'upperLabel');
        $6e1547e334933782$var$convertNormalEmphasis(opt, 'edgeLabel');
    }
    function $6e1547e334933782$var$compatTextStyle(opt, propName) {
        var labelOptSingle = $6e1547e334933782$var$isObject(opt) && opt[propName];
        var textStyle = $6e1547e334933782$var$isObject(labelOptSingle) && labelOptSingle.textStyle;
        if (textStyle) for(var i = 0, len = (0, parcelRequire("eaKsF")).TEXT_STYLE_OPTIONS.length; i < len; i++){
            var textPropName = (0, parcelRequire("eaKsF")).TEXT_STYLE_OPTIONS[i];
            if (textStyle.hasOwnProperty(textPropName)) labelOptSingle[textPropName] = textStyle[textPropName];
        }
    }
    function $6e1547e334933782$var$compatEC3CommonStyles(opt) {
        if (opt) {
            $6e1547e334933782$var$removeEC3NormalStatus(opt);
            $6e1547e334933782$var$compatTextStyle(opt, 'label');
            opt.emphasis && $6e1547e334933782$var$compatTextStyle(opt.emphasis, 'label');
        }
    }
    function $6e1547e334933782$var$processSeries(seriesOpt) {
        if (!$6e1547e334933782$var$isObject(seriesOpt)) return;
        $6e1547e334933782$var$compatEC2ItemStyle(seriesOpt);
        $6e1547e334933782$var$removeEC3NormalStatus(seriesOpt);
        $6e1547e334933782$var$compatTextStyle(seriesOpt, 'label');
        $6e1547e334933782$var$compatTextStyle(seriesOpt, 'upperLabel');
        $6e1547e334933782$var$compatTextStyle(seriesOpt, 'edgeLabel');
        if (seriesOpt.emphasis) {
            $6e1547e334933782$var$compatTextStyle(seriesOpt.emphasis, 'label');
            $6e1547e334933782$var$compatTextStyle(seriesOpt.emphasis, 'upperLabel');
            $6e1547e334933782$var$compatTextStyle(seriesOpt.emphasis, 'edgeLabel');
        }
        var markPoint = seriesOpt.markPoint;
        if (markPoint) {
            $6e1547e334933782$var$compatEC2ItemStyle(markPoint);
            $6e1547e334933782$var$compatEC3CommonStyles(markPoint);
        }
        var markLine = seriesOpt.markLine;
        if (markLine) {
            $6e1547e334933782$var$compatEC2ItemStyle(markLine);
            $6e1547e334933782$var$compatEC3CommonStyles(markLine);
        }
        var markArea = seriesOpt.markArea;
        if (markArea) $6e1547e334933782$var$compatEC3CommonStyles(markArea);
        var data = seriesOpt.data;
        if (seriesOpt.type === 'graph') {
            data = data || seriesOpt.nodes;
            var edgeData = seriesOpt.links || seriesOpt.edges;
            if (edgeData && !(0, parcelRequire("bahqM")).isTypedArray(edgeData)) for(var i = 0; i < edgeData.length; i++)$6e1547e334933782$var$compatEC3CommonStyles(edgeData[i]);
            (0, parcelRequire("bahqM")).each(seriesOpt.categories, function(opt) {
                $6e1547e334933782$var$removeEC3NormalStatus(opt);
            });
        }
        if (data && !(0, parcelRequire("bahqM")).isTypedArray(data)) for(var i = 0; i < data.length; i++)$6e1547e334933782$var$compatEC3CommonStyles(data[i]);
        markPoint = seriesOpt.markPoint;
        if (markPoint && markPoint.data) {
            var mpData = markPoint.data;
            for(var i = 0; i < mpData.length; i++)$6e1547e334933782$var$compatEC3CommonStyles(mpData[i]);
        }
        markLine = seriesOpt.markLine;
        if (markLine && markLine.data) {
            var mlData = markLine.data;
            for(var i = 0; i < mlData.length; i++)if ((0, parcelRequire("bahqM")).isArray(mlData[i])) {
                $6e1547e334933782$var$compatEC3CommonStyles(mlData[i][0]);
                $6e1547e334933782$var$compatEC3CommonStyles(mlData[i][1]);
            } else $6e1547e334933782$var$compatEC3CommonStyles(mlData[i]);
        }
        if (seriesOpt.type === 'gauge') {
            $6e1547e334933782$var$compatTextStyle(seriesOpt, 'axisLabel');
            $6e1547e334933782$var$compatTextStyle(seriesOpt, 'title');
            $6e1547e334933782$var$compatTextStyle(seriesOpt, 'detail');
        } else if (seriesOpt.type === 'treemap') {
            $6e1547e334933782$var$convertNormalEmphasis(seriesOpt.breadcrumb, 'itemStyle');
            (0, parcelRequire("bahqM")).each(seriesOpt.levels, function(opt) {
                $6e1547e334933782$var$removeEC3NormalStatus(opt);
            });
        } else if (seriesOpt.type === 'tree') $6e1547e334933782$var$removeEC3NormalStatus(seriesOpt.leaves);
    }
    function $6e1547e334933782$var$toArr(o) {
        return (0, parcelRequire("bahqM")).isArray(o) ? o : o ? [
            o
        ] : [];
    }
    function $6e1547e334933782$var$toObj(o) {
        return ((0, parcelRequire("bahqM")).isArray(o) ? o[0] : o) || {};
    }
    function $6e1547e334933782$export$2e2bcd8739ae039(option, isTheme) {
        $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.series), function(seriesOpt) {
            $6e1547e334933782$var$isObject(seriesOpt) && $6e1547e334933782$var$processSeries(seriesOpt);
        });
        var axes = [
            'xAxis',
            'yAxis',
            'radiusAxis',
            'angleAxis',
            'singleAxis',
            'parallelAxis',
            'radar'
        ];
        isTheme && axes.push('valueAxis', 'categoryAxis', 'logAxis', 'timeAxis');
        $6e1547e334933782$var$each(axes, function(axisName) {
            $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option[axisName]), function(axisOpt) {
                if (axisOpt) {
                    $6e1547e334933782$var$compatTextStyle(axisOpt, 'axisLabel');
                    $6e1547e334933782$var$compatTextStyle(axisOpt.axisPointer, 'label');
                }
            });
        });
        $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.parallel), function(parallelOpt) {
            var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
            $6e1547e334933782$var$compatTextStyle(parallelAxisDefault, 'axisLabel');
            $6e1547e334933782$var$compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, 'label');
        });
        $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.calendar), function(calendarOpt) {
            $6e1547e334933782$var$convertNormalEmphasis(calendarOpt, 'itemStyle');
            $6e1547e334933782$var$compatTextStyle(calendarOpt, 'dayLabel');
            $6e1547e334933782$var$compatTextStyle(calendarOpt, 'monthLabel');
            $6e1547e334933782$var$compatTextStyle(calendarOpt, 'yearLabel');
        });
        $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.radar), function(radarOpt) {
            $6e1547e334933782$var$compatTextStyle(radarOpt, 'name');
            if (radarOpt.name && radarOpt.axisName == null) {
                radarOpt.axisName = radarOpt.name;
                delete radarOpt.name;
            }
            if (radarOpt.nameGap != null && radarOpt.axisNameGap == null) {
                radarOpt.axisNameGap = radarOpt.nameGap;
                delete radarOpt.nameGap;
            }
        });
        $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.geo), function(geoOpt) {
            if ($6e1547e334933782$var$isObject(geoOpt)) {
                $6e1547e334933782$var$compatEC3CommonStyles(geoOpt);
                $6e1547e334933782$var$each($6e1547e334933782$var$toArr(geoOpt.regions), function(regionObj) {
                    $6e1547e334933782$var$compatEC3CommonStyles(regionObj);
                });
            }
        });
        $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.timeline), function(timelineOpt) {
            $6e1547e334933782$var$compatEC3CommonStyles(timelineOpt);
            $6e1547e334933782$var$convertNormalEmphasis(timelineOpt, 'label');
            $6e1547e334933782$var$convertNormalEmphasis(timelineOpt, 'itemStyle');
            $6e1547e334933782$var$convertNormalEmphasis(timelineOpt, 'controlStyle', true);
            var data = timelineOpt.data;
            (0, parcelRequire("bahqM")).isArray(data) && (0, parcelRequire("bahqM")).each(data, function(item) {
                if ((0, parcelRequire("bahqM")).isObject(item)) {
                    $6e1547e334933782$var$convertNormalEmphasis(item, 'label');
                    $6e1547e334933782$var$convertNormalEmphasis(item, 'itemStyle');
                }
            });
        });
        $6e1547e334933782$var$each($6e1547e334933782$var$toArr(option.toolbox), function(toolboxOpt) {
            $6e1547e334933782$var$convertNormalEmphasis(toolboxOpt, 'iconStyle');
            $6e1547e334933782$var$each(toolboxOpt.feature, function(featureOpt) {
                $6e1547e334933782$var$convertNormalEmphasis(featureOpt, 'iconStyle');
            });
        });
        $6e1547e334933782$var$compatTextStyle($6e1547e334933782$var$toObj(option.axisPointer), 'label');
        $6e1547e334933782$var$compatTextStyle($6e1547e334933782$var$toObj(option.tooltip).axisPointer, 'label');
    }
});
parcelRegister("iMppY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dac06d23d0856818$export$2e2bcd8739ae039);
    var $bahqM;
    var $jmSNG;
    function $dac06d23d0856818$export$2e2bcd8739ae039(ecModel) {
        var stackInfoMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        ecModel.eachSeries(function(seriesModel) {
            var stack = seriesModel.get('stack');
            if (stack) {
                var stackInfoList = stackInfoMap.get(stack) || stackInfoMap.set(stack, []);
                var data = seriesModel.getData();
                var stackInfo = {
                    stackResultDimension: data.getCalculationInfo('stackResultDimension'),
                    stackedOverDimension: data.getCalculationInfo('stackedOverDimension'),
                    stackedDimension: data.getCalculationInfo('stackedDimension'),
                    stackedByDimension: data.getCalculationInfo('stackedByDimension'),
                    isStackedByIndex: data.getCalculationInfo('isStackedByIndex'),
                    data: data,
                    seriesModel: seriesModel
                };
                if (!stackInfo.stackedDimension || !(stackInfo.isStackedByIndex || stackInfo.stackedByDimension)) return;
                stackInfoList.length && data.setCalculationInfo('stackedOnSeries', stackInfoList[stackInfoList.length - 1].seriesModel);
                stackInfoList.push(stackInfo);
            }
        });
        stackInfoMap.each($dac06d23d0856818$var$calculateStack);
    }
    function $dac06d23d0856818$var$calculateStack(stackInfoList) {
        (0, (0, parcelRequire("bahqM")).each)(stackInfoList, function(targetStackInfo, idxInStack) {
            var resultVal = [];
            var resultNaN = [
                NaN,
                NaN
            ];
            var dims = [
                targetStackInfo.stackResultDimension,
                targetStackInfo.stackedOverDimension
            ];
            var targetData = targetStackInfo.data;
            var isStackedByIndex = targetStackInfo.isStackedByIndex;
            targetData.modify(dims, function(v0, v1, dataIndex) {
                var sum = targetData.get(targetStackInfo.stackedDimension, dataIndex);
                if (isNaN(sum)) return resultNaN;
                var byValue;
                var stackedDataRawIndex;
                if (isStackedByIndex) stackedDataRawIndex = targetData.getRawIndex(dataIndex);
                else byValue = targetData.get(targetStackInfo.stackedByDimension, dataIndex);
                var stackedOver = NaN;
                for(var j = idxInStack - 1; j >= 0; j--){
                    var stackInfo = stackInfoList[j];
                    if (!isStackedByIndex) stackedDataRawIndex = stackInfo.data.rawIndexOf(stackInfo.stackedByDimension, byValue);
                    if (stackedDataRawIndex >= 0) {
                        var val = stackInfo.data.getByRawIndex(stackInfo.stackResultDimension, stackedDataRawIndex);
                        if (sum >= 0 && val > 0 || sum <= 0 && val < 0) {
                            sum = (0, (0, parcelRequire("jmSNG")).addSafe)(sum, val);
                            stackedOver = val;
                            break;
                        }
                    }
                }
                resultVal[0] = sum;
                resultVal[1] = stackedOver;
                return resultVal;
            });
        });
    }
});
parcelRegister("cvEVp", function(module, exports) {
    $parcel$export(module.exports, "seriesStyleTask", ()=>$91b820231b41a759$export$7ce4d65f9b69240);
    $parcel$export(module.exports, "dataStyleTask", ()=>$91b820231b41a759$export$f7dcb66a065003d1);
    $parcel$export(module.exports, "dataColorPaletteTask", ()=>$91b820231b41a759$export$cf9758b0d6dc0aa9);
    var $bahqM;
    var $1BJbl;
    var $4rldO;
    var $46U6E;
    var $gaMkj;
    var $eaKsF;
    var $91b820231b41a759$var$inner = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $91b820231b41a759$var$defaultStyleMappers = {
        itemStyle: (0, (0, parcelRequire("1BJbl")).default)((0, (0, parcelRequire("4rldO")).ITEM_STYLE_KEY_MAP), true),
        lineStyle: (0, (0, parcelRequire("1BJbl")).default)((0, (0, parcelRequire("46U6E")).LINE_STYLE_KEY_MAP), true)
    };
    var $91b820231b41a759$var$defaultColorKey = {
        lineStyle: 'stroke',
        itemStyle: 'fill'
    };
    function $91b820231b41a759$var$getStyleMapper(seriesModel, stylePath) {
        var styleMapper = seriesModel.visualStyleMapper || $91b820231b41a759$var$defaultStyleMappers[stylePath];
        if (!styleMapper) {
            console.warn("Unkown style type '" + stylePath + "'.");
            return $91b820231b41a759$var$defaultStyleMappers.itemStyle;
        }
        return styleMapper;
    }
    function $91b820231b41a759$var$getDefaultColorKey(seriesModel, stylePath) {
        var colorKey = seriesModel.visualDrawType || $91b820231b41a759$var$defaultColorKey[stylePath];
        if (!colorKey) {
            console.warn("Unkown style type '" + stylePath + "'.");
            return 'fill';
        }
        return colorKey;
    }
    var $91b820231b41a759$export$7ce4d65f9b69240 = {
        createOnAllSeries: true,
        performRawSeries: true,
        reset: function(seriesModel, ecModel) {
            var data = seriesModel.getData();
            var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
            var styleModel = seriesModel.getModel(stylePath);
            var getStyle = $91b820231b41a759$var$getStyleMapper(seriesModel, stylePath);
            var globalStyle = getStyle(styleModel);
            var decalOption = styleModel.getShallow('decal');
            if (decalOption) {
                data.setVisual('decal', decalOption);
                decalOption.dirty = true;
            }
            var colorKey = $91b820231b41a759$var$getDefaultColorKey(seriesModel, stylePath);
            var color = globalStyle[colorKey];
            var colorCallback = (0, (0, parcelRequire("bahqM")).isFunction)(color) ? color : null;
            var hasAutoColor = globalStyle.fill === 'auto' || globalStyle.stroke === 'auto';
            if (!globalStyle[colorKey] || colorCallback || hasAutoColor) {
                var colorPalette = seriesModel.getColorFromPalette(seriesModel.name, null, ecModel.getSeriesCount());
                if (!globalStyle[colorKey]) {
                    globalStyle[colorKey] = colorPalette;
                    data.setVisual('colorFromPalette', true);
                }
                globalStyle.fill = globalStyle.fill === 'auto' || typeof globalStyle.fill === 'function' ? colorPalette : globalStyle.fill;
                globalStyle.stroke = globalStyle.stroke === 'auto' || typeof globalStyle.stroke === 'function' ? colorPalette : globalStyle.stroke;
            }
            data.setVisual('style', globalStyle);
            data.setVisual('drawType', colorKey);
            if (!ecModel.isSeriesFiltered(seriesModel) && colorCallback) {
                data.setVisual('colorFromPalette', false);
                return {
                    dataEach: function(data, idx) {
                        var dataParams = seriesModel.getDataParams(idx);
                        var itemStyle = (0, (0, parcelRequire("bahqM")).extend)({}, globalStyle);
                        itemStyle[colorKey] = colorCallback(dataParams);
                        data.setItemVisual(idx, 'style', itemStyle);
                    }
                };
            }
        }
    };
    var $91b820231b41a759$var$sharedModel = new (0, (0, parcelRequire("gaMkj")).default)();
    var $91b820231b41a759$export$f7dcb66a065003d1 = {
        createOnAllSeries: true,
        performRawSeries: true,
        reset: function(seriesModel, ecModel) {
            if (seriesModel.ignoreStyleOnData || ecModel.isSeriesFiltered(seriesModel)) return;
            var data = seriesModel.getData();
            var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
            var getStyle = $91b820231b41a759$var$getStyleMapper(seriesModel, stylePath);
            var colorKey = data.getVisual('drawType');
            return {
                dataEach: data.hasItemOption ? function(data, idx) {
                    var rawItem = data.getRawDataItem(idx);
                    if (rawItem && rawItem[stylePath]) {
                        $91b820231b41a759$var$sharedModel.option = rawItem[stylePath];
                        var style = getStyle($91b820231b41a759$var$sharedModel);
                        var existsStyle = data.ensureUniqueItemVisual(idx, 'style');
                        (0, (0, parcelRequire("bahqM")).extend)(existsStyle, style);
                        if ($91b820231b41a759$var$sharedModel.option.decal) {
                            data.setItemVisual(idx, 'decal', $91b820231b41a759$var$sharedModel.option.decal);
                            $91b820231b41a759$var$sharedModel.option.decal.dirty = true;
                        }
                        if (colorKey in style) data.setItemVisual(idx, 'colorFromPalette', false);
                    }
                } : null
            };
        }
    };
    var $91b820231b41a759$export$cf9758b0d6dc0aa9 = {
        performRawSeries: true,
        overallReset: function(ecModel) {
            var paletteScopeGroupByType = (0, (0, parcelRequire("bahqM")).createHashMap)();
            ecModel.eachSeries(function(seriesModel) {
                var colorBy = seriesModel.getColorBy();
                if (seriesModel.isColorBySeries()) return;
                var key = seriesModel.type + '-' + colorBy;
                var colorScope = paletteScopeGroupByType.get(key);
                if (!colorScope) {
                    colorScope = {};
                    paletteScopeGroupByType.set(key, colorScope);
                }
                $91b820231b41a759$var$inner(seriesModel).scope = colorScope;
            });
            ecModel.eachSeries(function(seriesModel) {
                if (seriesModel.isColorBySeries() || ecModel.isSeriesFiltered(seriesModel)) return;
                var dataAll = seriesModel.getRawData();
                var idxMap = {};
                var data = seriesModel.getData();
                var colorScope = $91b820231b41a759$var$inner(seriesModel).scope;
                var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
                var colorKey = $91b820231b41a759$var$getDefaultColorKey(seriesModel, stylePath);
                data.each(function(idx) {
                    var rawIdx = data.getRawIndex(idx);
                    idxMap[rawIdx] = idx;
                });
                dataAll.each(function(rawIdx) {
                    var idx = idxMap[rawIdx];
                    var fromPalette = data.getItemVisual(idx, 'colorFromPalette');
                    if (fromPalette) {
                        var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
                        var name_1 = dataAll.getName(rawIdx) || rawIdx + '';
                        var dataCount = dataAll.count();
                        itemStyle[colorKey] = seriesModel.getColorFromPalette(name_1, colorScope, dataCount);
                    }
                });
            });
        }
    };
});
parcelRegister("4G956", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3682210406d5dc21$export$2e2bcd8739ae039);
    var $bahqM;
    parcelRequire("fHITF");
    var $ixXaU;
    var $7Tw7u;
    var $4KVOr;
    var $4gEFv;
    var $3682210406d5dc21$var$PI = Math.PI;
    function $3682210406d5dc21$export$2e2bcd8739ae039(api, opts) {
        opts = opts || {};
        (0, parcelRequire("bahqM")).defaults(opts, {
            text: 'loading',
            textColor: '#000',
            fontSize: 12,
            fontWeight: 'normal',
            fontStyle: 'normal',
            fontFamily: 'sans-serif',
            maskColor: 'rgba(255, 255, 255, 0.8)',
            showSpinner: true,
            color: '#5470c6',
            spinnerRadius: 10,
            lineWidth: 5,
            zlevel: 0
        });
        var group = new (0, parcelRequire("4KVOr")).default();
        var mask = new (0, parcelRequire("7Tw7u")).default({
            style: {
                fill: opts.maskColor
            },
            zlevel: opts.zlevel,
            z: 10000
        });
        group.add(mask);
        var textContent = new (0, parcelRequire("4gEFv")).default({
            style: {
                text: opts.text,
                fill: opts.textColor,
                fontSize: opts.fontSize,
                fontWeight: opts.fontWeight,
                fontStyle: opts.fontStyle,
                fontFamily: opts.fontFamily
            },
            zlevel: opts.zlevel,
            z: 10001
        });
        var labelRect = new (0, parcelRequire("7Tw7u")).default({
            style: {
                fill: 'none'
            },
            textContent: textContent,
            textConfig: {
                position: 'right',
                distance: 10
            },
            zlevel: opts.zlevel,
            z: 10001
        });
        group.add(labelRect);
        var arc;
        if (opts.showSpinner) {
            arc = new (0, parcelRequire("ixXaU")).default({
                shape: {
                    startAngle: -$3682210406d5dc21$var$PI / 2,
                    endAngle: -$3682210406d5dc21$var$PI / 2 + 0.1,
                    r: opts.spinnerRadius
                },
                style: {
                    stroke: opts.color,
                    lineCap: 'round',
                    lineWidth: opts.lineWidth
                },
                zlevel: opts.zlevel,
                z: 10001
            });
            arc.animateShape(true).when(1000, {
                endAngle: $3682210406d5dc21$var$PI * 3 / 2
            }).start('circularInOut');
            arc.animateShape(true).when(1000, {
                startAngle: $3682210406d5dc21$var$PI * 3 / 2
            }).delay(300).start('circularInOut');
            group.add(arc);
        }
        group.resize = function() {
            var textWidth = textContent.getBoundingRect().width;
            var r = opts.showSpinner ? opts.spinnerRadius : 0;
            var cx = (api.getWidth() - r * 2 - (opts.showSpinner && textWidth ? 10 : 0) - textWidth) / 2 - (opts.showSpinner && textWidth ? 0 : 5 + textWidth / 2) + (opts.showSpinner ? 0 : textWidth / 2) + (textWidth ? 0 : r);
            var cy = api.getHeight() / 2;
            opts.showSpinner && arc.setShape({
                cx: cx,
                cy: cy
            });
            labelRect.setShape({
                x: cx - r,
                y: cy - r,
                width: r * 2,
                height: r * 2
            });
            mask.setShape({
                x: 0,
                y: 0,
                width: api.getWidth(),
                height: api.getHeight()
            });
        };
        group.resize();
        return group;
    }
});
parcelRegister("14WFd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0c93ab8c51628eb2$export$2e2bcd8739ae039);
    var $bahqM;
    var $92IK1;
    var $jvo6O;
    var $74g78;
    var $iEvqc;
    var $eaKsF;
    var $0c93ab8c51628eb2$var$Scheduler = function() {
        function Scheduler(ecInstance, api, dataProcessorHandlers, visualHandlers) {
            this._stageTaskMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
            this.ecInstance = ecInstance;
            this.api = api;
            dataProcessorHandlers = this._dataProcessorHandlers = dataProcessorHandlers.slice();
            visualHandlers = this._visualHandlers = visualHandlers.slice();
            this._allHandlers = dataProcessorHandlers.concat(visualHandlers);
        }
        Scheduler.prototype.restoreData = function(ecModel, payload) {
            ecModel.restoreData(payload);
            this._stageTaskMap.each(function(taskRecord) {
                var overallTask = taskRecord.overallTask;
                overallTask && overallTask.dirty();
            });
        };
        Scheduler.prototype.getPerformArgs = function(task, isBlock) {
            if (!task.__pipeline) return;
            var pipeline = this._pipelineMap.get(task.__pipeline.id);
            var pCtx = pipeline.context;
            var incremental = !isBlock && pipeline.progressiveEnabled && (!pCtx || pCtx.progressiveRender) && task.__idxInPipeline > pipeline.blockIndex;
            var step = incremental ? pipeline.step : null;
            var modDataCount = pCtx && pCtx.modDataCount;
            var modBy = modDataCount != null ? Math.ceil(modDataCount / step) : null;
            return {
                step: step,
                modBy: modBy,
                modDataCount: modDataCount
            };
        };
        Scheduler.prototype.getPipeline = function(pipelineId) {
            return this._pipelineMap.get(pipelineId);
        };
        Scheduler.prototype.updateStreamModes = function(seriesModel, view) {
            var pipeline = this._pipelineMap.get(seriesModel.uid);
            var data = seriesModel.getData();
            var dataLen = data.count();
            var progressiveRender = pipeline.progressiveEnabled && view.incrementalPrepareRender && dataLen >= pipeline.threshold;
            var large = seriesModel.get('large') && dataLen >= seriesModel.get('largeThreshold');
            var modDataCount = seriesModel.get('progressiveChunkMode') === 'mod' ? dataLen : null;
            seriesModel.pipelineContext = pipeline.context = {
                progressiveRender: progressiveRender,
                modDataCount: modDataCount,
                large: large
            };
        };
        Scheduler.prototype.restorePipelines = function(ecModel) {
            var scheduler = this;
            var pipelineMap = scheduler._pipelineMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
            ecModel.eachSeries(function(seriesModel) {
                var progressive = seriesModel.getProgressive();
                var pipelineId = seriesModel.uid;
                pipelineMap.set(pipelineId, {
                    id: pipelineId,
                    head: null,
                    tail: null,
                    threshold: seriesModel.getProgressiveThreshold(),
                    progressiveEnabled: progressive && !(seriesModel.preventIncremental && seriesModel.preventIncremental()),
                    blockIndex: -1,
                    step: Math.round(progressive || 700),
                    count: 0
                });
                scheduler._pipe(seriesModel, seriesModel.dataTask);
            });
        };
        Scheduler.prototype.prepareStageTasks = function() {
            var stageTaskMap = this._stageTaskMap;
            var ecModel = this.api.getModel();
            var api = this.api;
            (0, (0, parcelRequire("bahqM")).each)(this._allHandlers, function(handler) {
                var record = stageTaskMap.get(handler.uid) || stageTaskMap.set(handler.uid, {});
                var errMsg = '';
                (0, (0, parcelRequire("bahqM")).assert)(!(handler.reset && handler.overallReset), errMsg);
                handler.reset && this._createSeriesStageTask(handler, record, ecModel, api);
                handler.overallReset && this._createOverallStageTask(handler, record, ecModel, api);
            }, this);
        };
        Scheduler.prototype.prepareView = function(view, model, ecModel, api) {
            var renderTask = view.renderTask;
            var context = renderTask.context;
            context.model = model;
            context.ecModel = ecModel;
            context.api = api;
            renderTask.__block = !view.incrementalPrepareRender;
            this._pipe(model, renderTask);
        };
        Scheduler.prototype.performDataProcessorTasks = function(ecModel, payload) {
            this._performStageTasks(this._dataProcessorHandlers, ecModel, payload, {
                block: true
            });
        };
        Scheduler.prototype.performVisualTasks = function(ecModel, payload, opt) {
            this._performStageTasks(this._visualHandlers, ecModel, payload, opt);
        };
        Scheduler.prototype._performStageTasks = function(stageHandlers, ecModel, payload, opt) {
            opt = opt || {};
            var unfinished = false;
            var scheduler = this;
            (0, (0, parcelRequire("bahqM")).each)(stageHandlers, function(stageHandler, idx) {
                if (opt.visualType && opt.visualType !== stageHandler.visualType) return;
                var stageHandlerRecord = scheduler._stageTaskMap.get(stageHandler.uid);
                var seriesTaskMap = stageHandlerRecord.seriesTaskMap;
                var overallTask = stageHandlerRecord.overallTask;
                if (overallTask) {
                    var overallNeedDirty_1;
                    var agentStubMap = overallTask.agentStubMap;
                    agentStubMap.each(function(stub) {
                        if (needSetDirty(opt, stub)) {
                            stub.dirty();
                            overallNeedDirty_1 = true;
                        }
                    });
                    overallNeedDirty_1 && overallTask.dirty();
                    scheduler.updatePayload(overallTask, payload);
                    var performArgs_1 = scheduler.getPerformArgs(overallTask, opt.block);
                    agentStubMap.each(function(stub) {
                        stub.perform(performArgs_1);
                    });
                    if (overallTask.perform(performArgs_1)) unfinished = true;
                } else if (seriesTaskMap) seriesTaskMap.each(function(task, pipelineId) {
                    if (needSetDirty(opt, task)) task.dirty();
                    var performArgs = scheduler.getPerformArgs(task, opt.block);
                    performArgs.skip = !stageHandler.performRawSeries && ecModel.isSeriesFiltered(task.context.model);
                    scheduler.updatePayload(task, payload);
                    if (task.perform(performArgs)) unfinished = true;
                });
            });
            function needSetDirty(opt, task) {
                return opt.setDirty && (!opt.dirtyMap || opt.dirtyMap.get(task.__pipeline.id));
            }
            this.unfinished = unfinished || this.unfinished;
        };
        Scheduler.prototype.performSeriesTasks = function(ecModel) {
            var unfinished;
            ecModel.eachSeries(function(seriesModel) {
                unfinished = seriesModel.dataTask.perform() || unfinished;
            });
            this.unfinished = unfinished || this.unfinished;
        };
        Scheduler.prototype.plan = function() {
            this._pipelineMap.each(function(pipeline) {
                var task = pipeline.tail;
                do {
                    if (task.__block) {
                        pipeline.blockIndex = task.__idxInPipeline;
                        break;
                    }
                    task = task.getUpstream();
                }while (task)
            });
        };
        Scheduler.prototype.updatePayload = function(task, payload) {
            payload !== 'remain' && (task.context.payload = payload);
        };
        Scheduler.prototype._createSeriesStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
            var scheduler = this;
            var oldSeriesTaskMap = stageHandlerRecord.seriesTaskMap;
            var newSeriesTaskMap = stageHandlerRecord.seriesTaskMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
            var seriesType = stageHandler.seriesType;
            var getTargetSeries = stageHandler.getTargetSeries;
            if (stageHandler.createOnAllSeries) ecModel.eachRawSeries(create);
            else if (seriesType) ecModel.eachRawSeriesByType(seriesType, create);
            else if (getTargetSeries) getTargetSeries(ecModel, api).each(create);
            function create(seriesModel) {
                var pipelineId = seriesModel.uid;
                var task = newSeriesTaskMap.set(pipelineId, oldSeriesTaskMap && oldSeriesTaskMap.get(pipelineId) || (0, (0, parcelRequire("92IK1")).createTask)({
                    plan: $0c93ab8c51628eb2$var$seriesTaskPlan,
                    reset: $0c93ab8c51628eb2$var$seriesTaskReset,
                    count: $0c93ab8c51628eb2$var$seriesTaskCount
                }));
                task.context = {
                    model: seriesModel,
                    ecModel: ecModel,
                    api: api,
                    useClearVisual: stageHandler.isVisual && !stageHandler.isLayout,
                    plan: stageHandler.plan,
                    reset: stageHandler.reset,
                    scheduler: scheduler
                };
                scheduler._pipe(seriesModel, task);
            }
        };
        Scheduler.prototype._createOverallStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
            var scheduler = this;
            var overallTask = stageHandlerRecord.overallTask = stageHandlerRecord.overallTask || (0, (0, parcelRequire("92IK1")).createTask)({
                reset: $0c93ab8c51628eb2$var$overallTaskReset
            });
            overallTask.context = {
                ecModel: ecModel,
                api: api,
                overallReset: stageHandler.overallReset,
                scheduler: scheduler
            };
            var oldAgentStubMap = overallTask.agentStubMap;
            var newAgentStubMap = overallTask.agentStubMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
            var seriesType = stageHandler.seriesType;
            var getTargetSeries = stageHandler.getTargetSeries;
            var overallProgress = true;
            var shouldOverallTaskDirty = false;
            var errMsg = '';
            (0, (0, parcelRequire("bahqM")).assert)(!stageHandler.createOnAllSeries, errMsg);
            if (seriesType) ecModel.eachRawSeriesByType(seriesType, createStub);
            else if (getTargetSeries) getTargetSeries(ecModel, api).each(createStub);
            else {
                overallProgress = false;
                (0, (0, parcelRequire("bahqM")).each)(ecModel.getSeries(), createStub);
            }
            function createStub(seriesModel) {
                var pipelineId = seriesModel.uid;
                var stub = newAgentStubMap.set(pipelineId, oldAgentStubMap && oldAgentStubMap.get(pipelineId) || (shouldOverallTaskDirty = true, (0, (0, parcelRequire("92IK1")).createTask)({
                    reset: $0c93ab8c51628eb2$var$stubReset,
                    onDirty: $0c93ab8c51628eb2$var$stubOnDirty
                })));
                stub.context = {
                    model: seriesModel,
                    overallProgress: overallProgress
                };
                stub.agent = overallTask;
                stub.__block = overallProgress;
                scheduler._pipe(seriesModel, stub);
            }
            if (shouldOverallTaskDirty) overallTask.dirty();
        };
        Scheduler.prototype._pipe = function(seriesModel, task) {
            var pipelineId = seriesModel.uid;
            var pipeline = this._pipelineMap.get(pipelineId);
            !pipeline.head && (pipeline.head = task);
            pipeline.tail && pipeline.tail.pipe(task);
            pipeline.tail = task;
            task.__idxInPipeline = pipeline.count++;
            task.__pipeline = pipeline;
        };
        Scheduler.wrapStageHandler = function(stageHandler, visualType) {
            if ((0, (0, parcelRequire("bahqM")).isFunction)(stageHandler)) stageHandler = {
                overallReset: stageHandler,
                seriesType: $0c93ab8c51628eb2$var$detectSeriseType(stageHandler)
            };
            stageHandler.uid = (0, (0, parcelRequire("jvo6O")).getUID)('stageHandler');
            visualType && (stageHandler.visualType = visualType);
            return stageHandler;
        };
        return Scheduler;
    }();
    function $0c93ab8c51628eb2$var$overallTaskReset(context) {
        context.overallReset(context.ecModel, context.api, context.payload);
    }
    function $0c93ab8c51628eb2$var$stubReset(context) {
        return context.overallProgress && $0c93ab8c51628eb2$var$stubProgress;
    }
    function $0c93ab8c51628eb2$var$stubProgress() {
        this.agent.dirty();
        this.getDownstream().dirty();
    }
    function $0c93ab8c51628eb2$var$stubOnDirty() {
        this.agent && this.agent.dirty();
    }
    function $0c93ab8c51628eb2$var$seriesTaskPlan(context) {
        return context.plan ? context.plan(context.model, context.ecModel, context.api, context.payload) : null;
    }
    function $0c93ab8c51628eb2$var$seriesTaskReset(context) {
        if (context.useClearVisual) context.data.clearAllVisual();
        var resetDefines = context.resetDefines = (0, (0, parcelRequire("eaKsF")).normalizeToArray)(context.reset(context.model, context.ecModel, context.api, context.payload));
        return resetDefines.length > 1 ? (0, (0, parcelRequire("bahqM")).map)(resetDefines, function(v, idx) {
            return $0c93ab8c51628eb2$var$makeSeriesTaskProgress(idx);
        }) : $0c93ab8c51628eb2$var$singleSeriesTaskProgress;
    }
    var $0c93ab8c51628eb2$var$singleSeriesTaskProgress = $0c93ab8c51628eb2$var$makeSeriesTaskProgress(0);
    function $0c93ab8c51628eb2$var$makeSeriesTaskProgress(resetDefineIdx) {
        return function(params, context) {
            var data = context.data;
            var resetDefine = context.resetDefines[resetDefineIdx];
            if (resetDefine && resetDefine.dataEach) for(var i = params.start; i < params.end; i++)resetDefine.dataEach(data, i);
            else if (resetDefine && resetDefine.progress) resetDefine.progress(params, data);
        };
    }
    function $0c93ab8c51628eb2$var$seriesTaskCount(context) {
        return context.data.count();
    }
    function $0c93ab8c51628eb2$var$detectSeriseType(legacyFunc) {
        $0c93ab8c51628eb2$var$seriesType = null;
        try {
            legacyFunc($0c93ab8c51628eb2$var$ecModelMock, $0c93ab8c51628eb2$var$apiMock);
        } catch (e) {}
        return $0c93ab8c51628eb2$var$seriesType;
    }
    var $0c93ab8c51628eb2$var$ecModelMock = {};
    var $0c93ab8c51628eb2$var$apiMock = {};
    var $0c93ab8c51628eb2$var$seriesType;
    $0c93ab8c51628eb2$var$mockMethods($0c93ab8c51628eb2$var$ecModelMock, (0, (0, parcelRequire("74g78")).default));
    $0c93ab8c51628eb2$var$mockMethods($0c93ab8c51628eb2$var$apiMock, (0, (0, parcelRequire("iEvqc")).default));
    $0c93ab8c51628eb2$var$ecModelMock.eachSeriesByType = $0c93ab8c51628eb2$var$ecModelMock.eachRawSeriesByType = function(type) {
        $0c93ab8c51628eb2$var$seriesType = type;
    };
    $0c93ab8c51628eb2$var$ecModelMock.eachComponent = function(cond) {
        if (cond.mainType === 'series' && cond.subType) $0c93ab8c51628eb2$var$seriesType = cond.subType;
    };
    function $0c93ab8c51628eb2$var$mockMethods(target, Clz) {
        for(var name_1 in Clz.prototype)target[name_1] = (0, (0, parcelRequire("bahqM")).noop);
    }
    var $0c93ab8c51628eb2$export$2e2bcd8739ae039 = $0c93ab8c51628eb2$var$Scheduler;
});
parcelRegister("31FQc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2341ebce6d7d92ac$export$2e2bcd8739ae039);
    var $2341ebce6d7d92ac$var$colorAll = [
        '#37A2DA',
        '#32C5E9',
        '#67E0E3',
        '#9FE6B8',
        '#FFDB5C',
        '#ff9f7f',
        '#fb7293',
        '#E062AE',
        '#E690D1',
        '#e7bcf3',
        '#9d96f5',
        '#8378EA',
        '#96BFFF'
    ];
    var $2341ebce6d7d92ac$export$2e2bcd8739ae039 = {
        color: $2341ebce6d7d92ac$var$colorAll,
        colorLayer: [
            [
                '#37A2DA',
                '#ffd85c',
                '#fd7b5f'
            ],
            [
                '#37A2DA',
                '#67E0E3',
                '#FFDB5C',
                '#ff9f7f',
                '#E062AE',
                '#9d96f5'
            ],
            [
                '#37A2DA',
                '#32C5E9',
                '#9FE6B8',
                '#FFDB5C',
                '#ff9f7f',
                '#fb7293',
                '#e7bcf3',
                '#8378EA',
                '#96BFFF'
            ],
            $2341ebce6d7d92ac$var$colorAll
        ]
    };
});
parcelRegister("dMJCs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a093251ea09c66fc$export$2e2bcd8739ae039);
    var $a093251ea09c66fc$var$contrastColor = '#B9B8CE';
    var $a093251ea09c66fc$var$backgroundColor = '#100C2A';
    var $a093251ea09c66fc$var$axisCommon = function() {
        return {
            axisLine: {
                lineStyle: {
                    color: $a093251ea09c66fc$var$contrastColor
                }
            },
            splitLine: {
                lineStyle: {
                    color: '#484753'
                }
            },
            splitArea: {
                areaStyle: {
                    color: [
                        'rgba(255,255,255,0.02)',
                        'rgba(255,255,255,0.05)'
                    ]
                }
            },
            minorSplitLine: {
                lineStyle: {
                    color: '#20203B'
                }
            }
        };
    };
    var $a093251ea09c66fc$var$colorPalette = [
        '#4992ff',
        '#7cffb2',
        '#fddd60',
        '#ff6e76',
        '#58d9f9',
        '#05c091',
        '#ff8a45',
        '#8d48e3',
        '#dd79ff'
    ];
    var $a093251ea09c66fc$var$theme = {
        darkMode: true,
        color: $a093251ea09c66fc$var$colorPalette,
        backgroundColor: $a093251ea09c66fc$var$backgroundColor,
        axisPointer: {
            lineStyle: {
                color: '#817f91'
            },
            crossStyle: {
                color: '#817f91'
            },
            label: {
                color: '#fff'
            }
        },
        legend: {
            textStyle: {
                color: $a093251ea09c66fc$var$contrastColor
            }
        },
        textStyle: {
            color: $a093251ea09c66fc$var$contrastColor
        },
        title: {
            textStyle: {
                color: '#EEF1FA'
            },
            subtextStyle: {
                color: '#B9B8CE'
            }
        },
        toolbox: {
            iconStyle: {
                borderColor: $a093251ea09c66fc$var$contrastColor
            }
        },
        dataZoom: {
            borderColor: '#71708A',
            textStyle: {
                color: $a093251ea09c66fc$var$contrastColor
            },
            brushStyle: {
                color: 'rgba(135,163,206,0.3)'
            },
            handleStyle: {
                color: '#353450',
                borderColor: '#C5CBE3'
            },
            moveHandleStyle: {
                color: '#B0B6C3',
                opacity: 0.3
            },
            fillerColor: 'rgba(135,163,206,0.2)',
            emphasis: {
                handleStyle: {
                    borderColor: '#91B7F2',
                    color: '#4D587D'
                },
                moveHandleStyle: {
                    color: '#636D9A',
                    opacity: 0.7
                }
            },
            dataBackground: {
                lineStyle: {
                    color: '#71708A',
                    width: 1
                },
                areaStyle: {
                    color: '#71708A'
                }
            },
            selectedDataBackground: {
                lineStyle: {
                    color: '#87A3CE'
                },
                areaStyle: {
                    color: '#87A3CE'
                }
            }
        },
        visualMap: {
            textStyle: {
                color: $a093251ea09c66fc$var$contrastColor
            }
        },
        timeline: {
            lineStyle: {
                color: $a093251ea09c66fc$var$contrastColor
            },
            label: {
                color: $a093251ea09c66fc$var$contrastColor
            },
            controlStyle: {
                color: $a093251ea09c66fc$var$contrastColor,
                borderColor: $a093251ea09c66fc$var$contrastColor
            }
        },
        calendar: {
            itemStyle: {
                color: $a093251ea09c66fc$var$backgroundColor
            },
            dayLabel: {
                color: $a093251ea09c66fc$var$contrastColor
            },
            monthLabel: {
                color: $a093251ea09c66fc$var$contrastColor
            },
            yearLabel: {
                color: $a093251ea09c66fc$var$contrastColor
            }
        },
        timeAxis: $a093251ea09c66fc$var$axisCommon(),
        logAxis: $a093251ea09c66fc$var$axisCommon(),
        valueAxis: $a093251ea09c66fc$var$axisCommon(),
        categoryAxis: $a093251ea09c66fc$var$axisCommon(),
        line: {
            symbol: 'circle'
        },
        graph: {
            color: $a093251ea09c66fc$var$colorPalette
        },
        gauge: {
            title: {
                color: $a093251ea09c66fc$var$contrastColor
            },
            axisLine: {
                lineStyle: {
                    color: [
                        [
                            1,
                            'rgba(207,212,219,0.2)'
                        ]
                    ]
                }
            },
            axisLabel: {
                color: $a093251ea09c66fc$var$contrastColor
            },
            detail: {
                color: '#EEF1FA'
            }
        },
        candlestick: {
            itemStyle: {
                color: '#f64e56',
                color0: '#54ea92',
                borderColor: '#f64e56',
                borderColor0: '#54ea92'
            }
        }
    };
    $a093251ea09c66fc$var$theme.categoryAxis.splitLine.show = false;
    var $a093251ea09c66fc$export$2e2bcd8739ae039 = $a093251ea09c66fc$var$theme;
});
parcelRegister("cbv5T", function(module, exports) {
    $parcel$export(module.exports, "ECEventProcessor", ()=>$8deea1bcfc845e61$export$d0fd09f950257b52);
    var $bahqM;
    var $aLwh0;
    var $8deea1bcfc845e61$export$d0fd09f950257b52 = function() {
        function ECEventProcessor() {}
        ECEventProcessor.prototype.normalizeQuery = function(query) {
            var cptQuery = {};
            var dataQuery = {};
            var otherQuery = {};
            if ((0, parcelRequire("bahqM")).isString(query)) {
                var condCptType = (0, (0, parcelRequire("aLwh0")).parseClassType)(query);
                cptQuery.mainType = condCptType.main || null;
                cptQuery.subType = condCptType.sub || null;
            } else {
                var suffixes_1 = [
                    'Index',
                    'Name',
                    'Id'
                ];
                var dataKeys_1 = {
                    name: 1,
                    dataIndex: 1,
                    dataType: 1
                };
                (0, parcelRequire("bahqM")).each(query, function(val, key) {
                    var reserved = false;
                    for(var i = 0; i < suffixes_1.length; i++){
                        var propSuffix = suffixes_1[i];
                        var suffixPos = key.lastIndexOf(propSuffix);
                        if (suffixPos > 0 && suffixPos === key.length - propSuffix.length) {
                            var mainType = key.slice(0, suffixPos);
                            if (mainType !== 'data') {
                                cptQuery.mainType = mainType;
                                cptQuery[propSuffix.toLowerCase()] = val;
                                reserved = true;
                            }
                        }
                    }
                    if (dataKeys_1.hasOwnProperty(key)) {
                        dataQuery[key] = val;
                        reserved = true;
                    }
                    if (!reserved) otherQuery[key] = val;
                });
            }
            return {
                cptQuery: cptQuery,
                dataQuery: dataQuery,
                otherQuery: otherQuery
            };
        };
        ECEventProcessor.prototype.filter = function(eventType, query) {
            var eventInfo = this.eventInfo;
            if (!eventInfo) return true;
            var targetEl = eventInfo.targetEl;
            var packedEvent = eventInfo.packedEvent;
            var model = eventInfo.model;
            var view = eventInfo.view;
            if (!model || !view) return true;
            var cptQuery = query.cptQuery;
            var dataQuery = query.dataQuery;
            return check(cptQuery, model, 'mainType') && check(cptQuery, model, 'subType') && check(cptQuery, model, 'index', 'componentIndex') && check(cptQuery, model, 'name') && check(cptQuery, model, 'id') && check(dataQuery, packedEvent, 'name') && check(dataQuery, packedEvent, 'dataIndex') && check(dataQuery, packedEvent, 'dataType') && (!view.filterForExposedEvent || view.filterForExposedEvent(eventType, query.otherQuery, targetEl, packedEvent));
            function check(query, host, prop, propOnHost) {
                return query[prop] == null || host[propOnHost || prop] === query[prop];
            }
        };
        ECEventProcessor.prototype.afterTrigger = function() {
            this.eventInfo = null;
        };
        return ECEventProcessor;
    }();
});
parcelRegister("7wiHx", function(module, exports) {
    $parcel$export(module.exports, "seriesSymbolTask", ()=>$579a0738784e30ca$export$144ac3beded415d9);
    $parcel$export(module.exports, "dataSymbolTask", ()=>$579a0738784e30ca$export$435b956f7f1071fb);
    var $bahqM;
    var $579a0738784e30ca$export$144ac3beded415d9 = {
        createOnAllSeries: true,
        performRawSeries: true,
        reset: function(seriesModel, ecModel) {
            var data = seriesModel.getData();
            if (seriesModel.legendIcon) data.setVisual('legendIcon', seriesModel.legendIcon);
            if (!seriesModel.hasSymbolVisual) return;
            var symbolType = seriesModel.get('symbol');
            var symbolSize = seriesModel.get('symbolSize');
            var keepAspect = seriesModel.get('symbolKeepAspect');
            var symbolRotate = seriesModel.get('symbolRotate');
            var symbolOffset = seriesModel.get('symbolOffset');
            var hasSymbolTypeCallback = (0, (0, parcelRequire("bahqM")).isFunction)(symbolType);
            var hasSymbolSizeCallback = (0, (0, parcelRequire("bahqM")).isFunction)(symbolSize);
            var hasSymbolRotateCallback = (0, (0, parcelRequire("bahqM")).isFunction)(symbolRotate);
            var hasSymbolOffsetCallback = (0, (0, parcelRequire("bahqM")).isFunction)(symbolOffset);
            var hasCallback = hasSymbolTypeCallback || hasSymbolSizeCallback || hasSymbolRotateCallback || hasSymbolOffsetCallback;
            var seriesSymbol = !hasSymbolTypeCallback && symbolType ? symbolType : seriesModel.defaultSymbol;
            var seriesSymbolSize = !hasSymbolSizeCallback ? symbolSize : null;
            var seriesSymbolRotate = !hasSymbolRotateCallback ? symbolRotate : null;
            var seriesSymbolOffset = !hasSymbolOffsetCallback ? symbolOffset : null;
            data.setVisual({
                legendIcon: seriesModel.legendIcon || seriesSymbol,
                symbol: seriesSymbol,
                symbolSize: seriesSymbolSize,
                symbolKeepAspect: keepAspect,
                symbolRotate: seriesSymbolRotate,
                symbolOffset: seriesSymbolOffset
            });
            if (ecModel.isSeriesFiltered(seriesModel)) return;
            function dataEach(data, idx) {
                var rawValue = seriesModel.getRawValue(idx);
                var params = seriesModel.getDataParams(idx);
                hasSymbolTypeCallback && data.setItemVisual(idx, 'symbol', symbolType(rawValue, params));
                hasSymbolSizeCallback && data.setItemVisual(idx, 'symbolSize', symbolSize(rawValue, params));
                hasSymbolRotateCallback && data.setItemVisual(idx, 'symbolRotate', symbolRotate(rawValue, params));
                hasSymbolOffsetCallback && data.setItemVisual(idx, 'symbolOffset', symbolOffset(rawValue, params));
            }
            return {
                dataEach: hasCallback ? dataEach : null
            };
        }
    };
    var $579a0738784e30ca$export$435b956f7f1071fb = {
        createOnAllSeries: true,
        performRawSeries: true,
        reset: function(seriesModel, ecModel) {
            if (!seriesModel.hasSymbolVisual) return;
            if (ecModel.isSeriesFiltered(seriesModel)) return;
            var data = seriesModel.getData();
            function dataEach(data, idx) {
                var itemModel = data.getItemModel(idx);
                var itemSymbolType = itemModel.getShallow('symbol', true);
                var itemSymbolSize = itemModel.getShallow('symbolSize', true);
                var itemSymbolRotate = itemModel.getShallow('symbolRotate', true);
                var itemSymbolOffset = itemModel.getShallow('symbolOffset', true);
                var itemSymbolKeepAspect = itemModel.getShallow('symbolKeepAspect', true);
                if (itemSymbolType != null) data.setItemVisual(idx, 'symbol', itemSymbolType);
                if (itemSymbolSize != null) data.setItemVisual(idx, 'symbolSize', itemSymbolSize);
                if (itemSymbolRotate != null) data.setItemVisual(idx, 'symbolRotate', itemSymbolRotate);
                if (itemSymbolOffset != null) data.setItemVisual(idx, 'symbolOffset', itemSymbolOffset);
                if (itemSymbolKeepAspect != null) data.setItemVisual(idx, 'symbolKeepAspect', itemSymbolKeepAspect);
            }
            return {
                dataEach: data.hasItemOption ? dataEach : null
            };
        }
    };
});
parcelRegister("fk5Gm", function(module, exports) {
    $parcel$export(module.exports, "getItemVisualFromData", ()=>$b27d21a8d98c0d1c$export$91d919a86b2df624);
    $parcel$export(module.exports, "getVisualFromData", ()=>$b27d21a8d98c0d1c$export$d76e333a86ea1a2);
    $parcel$export(module.exports, "setItemVisualFromData", ()=>$b27d21a8d98c0d1c$export$3aab879e9d0e7c75);
    function $b27d21a8d98c0d1c$export$91d919a86b2df624(data, dataIndex, key) {
        switch(key){
            case 'color':
                var style = data.getItemVisual(dataIndex, 'style');
                return style[data.getVisual('drawType')];
            case 'opacity':
                return data.getItemVisual(dataIndex, 'style').opacity;
            case 'symbol':
            case 'symbolSize':
            case 'liftZ':
                return data.getItemVisual(dataIndex, key);
            default:
        }
    }
    function $b27d21a8d98c0d1c$export$d76e333a86ea1a2(data, key) {
        switch(key){
            case 'color':
                var style = data.getVisual('style');
                return style[data.getVisual('drawType')];
            case 'opacity':
                return data.getVisual('style').opacity;
            case 'symbol':
            case 'symbolSize':
            case 'liftZ':
                return data.getVisual(key);
            default:
        }
    }
    function $b27d21a8d98c0d1c$export$3aab879e9d0e7c75(data, dataIndex, key, value) {
        switch(key){
            case 'color':
                var style = data.ensureUniqueItemVisual(dataIndex, 'style');
                style[data.getVisual('drawType')] = value;
                data.setItemVisual(dataIndex, 'colorFromPalette', false);
                break;
            case 'opacity':
                data.ensureUniqueItemVisual(dataIndex, 'style').opacity = value;
                break;
            case 'symbol':
            case 'symbolSize':
            case 'liftZ':
                data.setItemVisual(dataIndex, key, value);
                break;
            default:
        }
    }
});
parcelRegister("1nKsD", function(module, exports) {
    $parcel$export(module.exports, "createLegacyDataSelectAction", ()=>$101bfa9c2a38d115$export$62942ba95693dbfc);
    $parcel$export(module.exports, "handleLegacySelectEvents", ()=>$101bfa9c2a38d115$export$2575c83262e49d0c);
    var $bahqM;
    var $eaKsF;
    function $101bfa9c2a38d115$export$62942ba95693dbfc(seriesType, ecRegisterAction) {
        function getSeriesIndices(ecModel, payload) {
            var seriesIndices = [];
            ecModel.eachComponent({
                mainType: 'series',
                subType: seriesType,
                query: payload
            }, function(seriesModel) {
                seriesIndices.push(seriesModel.seriesIndex);
            });
            return seriesIndices;
        }
        (0, (0, parcelRequire("bahqM")).each)([
            [
                seriesType + 'ToggleSelect',
                'toggleSelect'
            ],
            [
                seriesType + 'Select',
                'select'
            ],
            [
                seriesType + 'UnSelect',
                'unselect'
            ]
        ], function(eventsMap) {
            ecRegisterAction(eventsMap[0], function(payload, ecModel, api) {
                payload = (0, (0, parcelRequire("bahqM")).extend)({}, payload);
                api.dispatchAction((0, (0, parcelRequire("bahqM")).extend)(payload, {
                    type: eventsMap[1],
                    seriesIndex: getSeriesIndices(ecModel, payload)
                }));
            });
        });
    }
    function $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents(type, eventPostfix, ecIns, ecModel, payload) {
        var legacyEventName = type + eventPostfix;
        if (!ecIns.isSilent(legacyEventName)) ecModel.eachComponent({
            mainType: 'series',
            subType: 'pie'
        }, function(seriesModel) {
            var seriesIndex = seriesModel.seriesIndex;
            var selected = payload.selected;
            for(var i = 0; i < selected.length; i++)if (selected[i].seriesIndex === seriesIndex) {
                var data = seriesModel.getData();
                var dataIndex = (0, (0, parcelRequire("eaKsF")).queryDataIndex)(data, payload.fromActionPayload);
                ecIns.trigger(legacyEventName, {
                    type: legacyEventName,
                    seriesId: seriesModel.id,
                    name: (0, (0, parcelRequire("bahqM")).isArray)(dataIndex) ? data.getName(dataIndex[0]) : data.getName(dataIndex),
                    selected: (0, (0, parcelRequire("bahqM")).extend)({}, seriesModel.option.selectedMap)
                });
            }
        });
    }
    function $101bfa9c2a38d115$export$2575c83262e49d0c(messageCenter, ecIns, api) {
        messageCenter.on('selectchanged', function(params) {
            var ecModel = api.getModel();
            if (params.isFromClick) {
                $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents('map', 'selectchanged', ecIns, ecModel, params);
                $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents('pie', 'selectchanged', ecIns, ecModel, params);
            } else if (params.fromAction === 'select') {
                $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents('map', 'selected', ecIns, ecModel, params);
                $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents('pie', 'selected', ecIns, ecModel, params);
            } else if (params.fromAction === 'unselect') {
                $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents('map', 'unselected', ecIns, ecModel, params);
                $101bfa9c2a38d115$var$handleSeriesLegacySelectEvents('pie', 'unselected', ecIns, ecModel, params);
            }
        });
    }
});
parcelRegister("6IsbX", function(module, exports) {
    $parcel$export(module.exports, "findEventDispatcher", ()=>$4e3cb87918e3df6d$export$8a4fca9e04eb4df6);
    function $4e3cb87918e3df6d$export$8a4fca9e04eb4df6(target, det, returnFirstMatch) {
        var found;
        while(target){
            if (det(target)) {
                found = target;
                if (returnFirstMatch) break;
            }
            target = target.__hostTarget || target.parent;
        }
        return found;
    }
});
parcelRegister("g2DhS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$badb4ee06d190426$export$2e2bcd8739ae039);
    var $9LEsz;
    function $badb4ee06d190426$export$2e2bcd8739ae039(ecModel, api) {
        ecModel.eachRawSeries(function(seriesModel) {
            if (ecModel.isSeriesFiltered(seriesModel)) return;
            var data = seriesModel.getData();
            if (data.hasItemVisual()) data.each(function(idx) {
                var decal = data.getItemVisual(idx, 'decal');
                if (decal) {
                    var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
                    itemStyle.decal = (0, (0, parcelRequire("9LEsz")).createOrUpdatePatternFromDecal)(decal, api);
                }
            });
            var decal = data.getVisual('decal');
            if (decal) {
                var style = data.getVisual('style');
                style.decal = (0, (0, parcelRequire("9LEsz")).createOrUpdatePatternFromDecal)(decal, api);
            }
        });
    }
});
parcelRegister("9LEsz", function(module, exports) {
    $parcel$export(module.exports, "createOrUpdatePatternFromDecal", ()=>$71c7e35019979000$export$a3ba048e1a648972);
    var $822uQ;
    var $h4RuA;
    var $bahqM;
    var $jmSNG;
    var $7yklO;
    var $aSzOj;
    var $71c7e35019979000$var$decalMap = new (0, (0, parcelRequire("822uQ")).default)();
    var $71c7e35019979000$var$decalCache = new (0, (0, parcelRequire("h4RuA")).default)(100);
    var $71c7e35019979000$var$decalKeys = [
        'symbol',
        'symbolSize',
        'symbolKeepAspect',
        'color',
        'backgroundColor',
        'dashArrayX',
        'dashArrayY',
        'maxTileWidth',
        'maxTileHeight'
    ];
    function $71c7e35019979000$export$a3ba048e1a648972(decalObject, api) {
        if (decalObject === 'none') return null;
        var dpr = api.getDevicePixelRatio();
        var zr = api.getZr();
        var isSVG = zr.painter.type === 'svg';
        if (decalObject.dirty) $71c7e35019979000$var$decalMap["delete"](decalObject);
        var oldPattern = $71c7e35019979000$var$decalMap.get(decalObject);
        if (oldPattern) return oldPattern;
        var decalOpt = (0, (0, parcelRequire("bahqM")).defaults)(decalObject, {
            symbol: 'rect',
            symbolSize: 1,
            symbolKeepAspect: true,
            color: 'rgba(0, 0, 0, 0.2)',
            backgroundColor: null,
            dashArrayX: 5,
            dashArrayY: 5,
            rotation: 0,
            maxTileWidth: 512,
            maxTileHeight: 512
        });
        if (decalOpt.backgroundColor === 'none') decalOpt.backgroundColor = null;
        var pattern = {
            repeat: 'repeat'
        };
        setPatternnSource(pattern);
        pattern.rotation = decalOpt.rotation;
        pattern.scaleX = pattern.scaleY = isSVG ? 1 : 1 / dpr;
        $71c7e35019979000$var$decalMap.set(decalObject, pattern);
        decalObject.dirty = false;
        return pattern;
        function setPatternnSource(pattern) {
            var keys = [
                dpr
            ];
            var isValidKey = true;
            for(var i = 0; i < $71c7e35019979000$var$decalKeys.length; ++i){
                var value = decalOpt[$71c7e35019979000$var$decalKeys[i]];
                var valueType = typeof value;
                if (value != null && !(0, (0, parcelRequire("bahqM")).isArray)(value) && valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') {
                    isValidKey = false;
                    break;
                }
                keys.push(value);
            }
            var cacheKey;
            if (isValidKey) {
                cacheKey = keys.join(',') + (isSVG ? '-svg' : '');
                var cache = $71c7e35019979000$var$decalCache.get(cacheKey);
                if (cache) isSVG ? pattern.svgElement = cache : pattern.image = cache;
            }
            var dashArrayX = $71c7e35019979000$var$normalizeDashArrayX(decalOpt.dashArrayX);
            var dashArrayY = $71c7e35019979000$var$normalizeDashArrayY(decalOpt.dashArrayY);
            var symbolArray = $71c7e35019979000$var$normalizeSymbolArray(decalOpt.symbol);
            var lineBlockLengthsX = $71c7e35019979000$var$getLineBlockLengthX(dashArrayX);
            var lineBlockLengthY = $71c7e35019979000$var$getLineBlockLengthY(dashArrayY);
            var canvas = !isSVG && (0, (0, parcelRequire("bahqM")).createCanvas)();
            var svgRoot = isSVG && zr.painter.createSVGElement('g');
            var pSize = getPatternSize();
            var ctx;
            if (canvas) {
                canvas.width = pSize.width * dpr;
                canvas.height = pSize.height * dpr;
                ctx = canvas.getContext('2d');
            }
            brushDecal();
            if (isValidKey) $71c7e35019979000$var$decalCache.put(cacheKey, canvas || svgRoot);
            pattern.image = canvas;
            pattern.svgElement = svgRoot;
            pattern.svgWidth = pSize.width;
            pattern.svgHeight = pSize.height;
            function getPatternSize() {
                var width = 1;
                for(var i = 0, xlen = lineBlockLengthsX.length; i < xlen; ++i)width = (0, (0, parcelRequire("jmSNG")).getLeastCommonMultiple)(width, lineBlockLengthsX[i]);
                var symbolRepeats = 1;
                for(var i = 0, xlen = symbolArray.length; i < xlen; ++i)symbolRepeats = (0, (0, parcelRequire("jmSNG")).getLeastCommonMultiple)(symbolRepeats, symbolArray[i].length);
                width *= symbolRepeats;
                var height = lineBlockLengthY * lineBlockLengthsX.length * symbolArray.length;
                var warn;
                return {
                    width: Math.max(1, Math.min(width, decalOpt.maxTileWidth)),
                    height: Math.max(1, Math.min(height, decalOpt.maxTileHeight))
                };
            }
            function brushDecal() {
                if (ctx) {
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    if (decalOpt.backgroundColor) {
                        ctx.fillStyle = decalOpt.backgroundColor;
                        ctx.fillRect(0, 0, canvas.width, canvas.height);
                    }
                }
                var ySum = 0;
                for(var i = 0; i < dashArrayY.length; ++i)ySum += dashArrayY[i];
                if (ySum <= 0) return;
                var y = -lineBlockLengthY;
                var yId = 0;
                var yIdTotal = 0;
                var xId0 = 0;
                while(y < pSize.height){
                    if (yId % 2 === 0) {
                        var symbolYId = yIdTotal / 2 % symbolArray.length;
                        var x = 0;
                        var xId1 = 0;
                        var xId1Total = 0;
                        while(x < pSize.width * 2){
                            var xSum = 0;
                            for(var i = 0; i < dashArrayX[xId0].length; ++i)xSum += dashArrayX[xId0][i];
                            if (xSum <= 0) break;
                            if (xId1 % 2 === 0) {
                                var size = (1 - decalOpt.symbolSize) * 0.5;
                                var left = x + dashArrayX[xId0][xId1] * size;
                                var top_1 = y + dashArrayY[yId] * size;
                                var width = dashArrayX[xId0][xId1] * decalOpt.symbolSize;
                                var height = dashArrayY[yId] * decalOpt.symbolSize;
                                var symbolXId = xId1Total / 2 % symbolArray[symbolYId].length;
                                brushSymbol(left, top_1, width, height, symbolArray[symbolYId][symbolXId]);
                            }
                            x += dashArrayX[xId0][xId1];
                            ++xId1Total;
                            ++xId1;
                            if (xId1 === dashArrayX[xId0].length) xId1 = 0;
                        }
                        ++xId0;
                        if (xId0 === dashArrayX.length) xId0 = 0;
                    }
                    y += dashArrayY[yId];
                    ++yIdTotal;
                    ++yId;
                    if (yId === dashArrayY.length) yId = 0;
                }
                function brushSymbol(x, y, width, height, symbolType) {
                    var scale = isSVG ? 1 : dpr;
                    var symbol = (0, (0, parcelRequire("7yklO")).createSymbol)(symbolType, x * scale, y * scale, width * scale, height * scale, decalOpt.color, decalOpt.symbolKeepAspect);
                    if (isSVG) svgRoot.appendChild(zr.painter.paintOne(symbol));
                    else (0, (0, parcelRequire("aSzOj")).brushSingle)(ctx, symbol);
                }
            }
        }
    }
    function $71c7e35019979000$var$normalizeSymbolArray(symbol) {
        if (!symbol || symbol.length === 0) return [
            [
                'rect'
            ]
        ];
        if (typeof symbol === 'string') return [
            [
                symbol
            ]
        ];
        var isAllString = true;
        for(var i = 0; i < symbol.length; ++i)if (typeof symbol[i] !== 'string') {
            isAllString = false;
            break;
        }
        if (isAllString) return $71c7e35019979000$var$normalizeSymbolArray([
            symbol
        ]);
        var result = [];
        for(var i = 0; i < symbol.length; ++i)if (typeof symbol[i] === 'string') result.push([
            symbol[i]
        ]);
        else result.push(symbol[i]);
        return result;
    }
    function $71c7e35019979000$var$normalizeDashArrayX(dash) {
        if (!dash || dash.length === 0) return [
            [
                0,
                0
            ]
        ];
        if (typeof dash === 'number') {
            var dashValue = Math.ceil(dash);
            return [
                [
                    dashValue,
                    dashValue
                ]
            ];
        }
        var isAllNumber = true;
        for(var i = 0; i < dash.length; ++i)if (typeof dash[i] !== 'number') {
            isAllNumber = false;
            break;
        }
        if (isAllNumber) return $71c7e35019979000$var$normalizeDashArrayX([
            dash
        ]);
        var result = [];
        for(var i = 0; i < dash.length; ++i)if (typeof dash[i] === 'number') {
            var dashValue = Math.ceil(dash[i]);
            result.push([
                dashValue,
                dashValue
            ]);
        } else {
            var dashValue = (0, (0, parcelRequire("bahqM")).map)(dash[i], function(n) {
                return Math.ceil(n);
            });
            if (dashValue.length % 2 === 1) result.push(dashValue.concat(dashValue));
            else result.push(dashValue);
        }
        return result;
    }
    function $71c7e35019979000$var$normalizeDashArrayY(dash) {
        if (!dash || typeof dash === 'object' && dash.length === 0) return [
            0,
            0
        ];
        if (typeof dash === 'number') {
            var dashValue_1 = Math.ceil(dash);
            return [
                dashValue_1,
                dashValue_1
            ];
        }
        var dashValue = (0, (0, parcelRequire("bahqM")).map)(dash, function(n) {
            return Math.ceil(n);
        });
        return dash.length % 2 ? dashValue.concat(dashValue) : dashValue;
    }
    function $71c7e35019979000$var$getLineBlockLengthX(dash) {
        return (0, (0, parcelRequire("bahqM")).map)(dash, function(line) {
            return $71c7e35019979000$var$getLineBlockLengthY(line);
        });
    }
    function $71c7e35019979000$var$getLineBlockLengthY(dash) {
        var blockLength = 0;
        for(var i = 0; i < dash.length; ++i)blockLength += dash[i];
        if (dash.length % 2 === 1) return blockLength * 2;
        return blockLength;
    }
});
parcelRegister("822uQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5d9072624d2c732b$export$2e2bcd8739ae039);
    var $5d9072624d2c732b$var$wmUniqueIndex = Math.round(Math.random() * 9);
    var $5d9072624d2c732b$var$supportDefineProperty = typeof Object.defineProperty === 'function';
    var $5d9072624d2c732b$var$WeakMap = function() {
        function WeakMap() {
            this._id = '__ec_inner_' + $5d9072624d2c732b$var$wmUniqueIndex++;
        }
        WeakMap.prototype.get = function(key) {
            return this._guard(key)[this._id];
        };
        WeakMap.prototype.set = function(key, value) {
            var target = this._guard(key);
            if ($5d9072624d2c732b$var$supportDefineProperty) Object.defineProperty(target, this._id, {
                value: value,
                enumerable: false,
                configurable: true
            });
            else target[this._id] = value;
            return this;
        };
        WeakMap.prototype["delete"] = function(key) {
            if (this.has(key)) {
                delete this._guard(key)[this._id];
                return true;
            }
            return false;
        };
        WeakMap.prototype.has = function(key) {
            return !!this._guard(key)[this._id];
        };
        WeakMap.prototype._guard = function(key) {
            if (key !== Object(key)) throw TypeError('Value of WeakMap is not a non-null object.');
            return key;
        };
        return WeakMap;
    }();
    var $5d9072624d2c732b$export$2e2bcd8739ae039 = $5d9072624d2c732b$var$WeakMap;
});
parcelRegister("aSzOj", function(module, exports) {
    $parcel$export(module.exports, "createCanvasPattern", ()=>$7ebab9bfc20d8461$export$8eb5db6b7bc27903);
    $parcel$export(module.exports, "brushSingle", ()=>$7ebab9bfc20d8461$export$567881adfc3eb7f3);
    $parcel$export(module.exports, "brush", ()=>$7ebab9bfc20d8461$export$da5d6544e8c27bc1);
    var $lBQ88;
    var $aA4Ws;
    var $63nvx;
    var $dPYp9;
    var $ghQ8v;
    var $gcbBH;
    var $45jlh;
    var $b7ZX8;
    var $bahqM;
    var $cpB91;
    var $6sllV;
    var $aVawM;
    var $7ebab9bfc20d8461$var$pathProxyForDraw = new (0, (0, parcelRequire("aA4Ws")).default)(true);
    function $7ebab9bfc20d8461$var$styleHasStroke(style) {
        var stroke = style.stroke;
        return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
    }
    function $7ebab9bfc20d8461$var$isValidStrokeFillStyle(strokeOrFill) {
        return typeof strokeOrFill === 'string' && strokeOrFill !== 'none';
    }
    function $7ebab9bfc20d8461$var$styleHasFill(style) {
        var fill = style.fill;
        return fill != null && fill !== 'none';
    }
    function $7ebab9bfc20d8461$var$doFillPath(ctx, style) {
        if (style.fillOpacity != null && style.fillOpacity !== 1) {
            var originalGlobalAlpha = ctx.globalAlpha;
            ctx.globalAlpha = style.fillOpacity * style.opacity;
            ctx.fill();
            ctx.globalAlpha = originalGlobalAlpha;
        } else ctx.fill();
    }
    function $7ebab9bfc20d8461$var$doStrokePath(ctx, style) {
        if (style.strokeOpacity != null && style.strokeOpacity !== 1) {
            var originalGlobalAlpha = ctx.globalAlpha;
            ctx.globalAlpha = style.strokeOpacity * style.opacity;
            ctx.stroke();
            ctx.globalAlpha = originalGlobalAlpha;
        } else ctx.stroke();
    }
    function $7ebab9bfc20d8461$export$8eb5db6b7bc27903(ctx, pattern, el) {
        var image = (0, (0, parcelRequire("63nvx")).createOrUpdateImage)(pattern.image, pattern.__image, el);
        if ((0, (0, parcelRequire("63nvx")).isImageReady)(image)) {
            var canvasPattern = ctx.createPattern(image, pattern.repeat || 'repeat');
            if (typeof DOMMatrix === 'function' && canvasPattern.setTransform) {
                var matrix = new DOMMatrix();
                matrix.rotateSelf(0, 0, (pattern.rotation || 0) / Math.PI * 180);
                matrix.scaleSelf(pattern.scaleX || 1, pattern.scaleY || 1);
                matrix.translateSelf(pattern.x || 0, pattern.y || 0);
                canvasPattern.setTransform(matrix);
            }
            return canvasPattern;
        }
    }
    function $7ebab9bfc20d8461$var$brushPath(ctx, el, style, inBatch) {
        var hasStroke = $7ebab9bfc20d8461$var$styleHasStroke(style);
        var hasFill = $7ebab9bfc20d8461$var$styleHasFill(style);
        var strokePercent = style.strokePercent;
        var strokePart = strokePercent < 1;
        var firstDraw = !el.path;
        if ((!el.silent || strokePart) && firstDraw) el.createPathProxy();
        var path = el.path || $7ebab9bfc20d8461$var$pathProxyForDraw;
        if (!inBatch) {
            var fill = style.fill;
            var stroke = style.stroke;
            var hasFillGradient = hasFill && !!fill.colorStops;
            var hasStrokeGradient = hasStroke && !!stroke.colorStops;
            var hasFillPattern = hasFill && !!fill.image;
            var hasStrokePattern = hasStroke && !!stroke.image;
            var fillGradient = void 0;
            var strokeGradient = void 0;
            var fillPattern = void 0;
            var strokePattern = void 0;
            var rect = void 0;
            if (hasFillGradient || hasStrokeGradient) rect = el.getBoundingRect();
            if (hasFillGradient) {
                fillGradient = el.__dirty ? (0, (0, parcelRequire("dPYp9")).getCanvasGradient)(ctx, fill, rect) : el.__canvasFillGradient;
                el.__canvasFillGradient = fillGradient;
            }
            if (hasStrokeGradient) {
                strokeGradient = el.__dirty ? (0, (0, parcelRequire("dPYp9")).getCanvasGradient)(ctx, stroke, rect) : el.__canvasStrokeGradient;
                el.__canvasStrokeGradient = strokeGradient;
            }
            if (hasFillPattern) {
                fillPattern = el.__dirty || !el.__canvasFillPattern ? $7ebab9bfc20d8461$export$8eb5db6b7bc27903(ctx, fill, el) : el.__canvasFillPattern;
                el.__canvasFillPattern = fillPattern;
            }
            if (hasStrokePattern) {
                strokePattern = el.__dirty || !el.__canvasStrokePattern ? $7ebab9bfc20d8461$export$8eb5db6b7bc27903(ctx, stroke, el) : el.__canvasStrokePattern;
                el.__canvasStrokePattern = fillPattern;
            }
            if (hasFillGradient) ctx.fillStyle = fillGradient;
            else if (hasFillPattern) {
                if (fillPattern) ctx.fillStyle = fillPattern;
                else hasFill = false;
            }
            if (hasStrokeGradient) ctx.strokeStyle = strokeGradient;
            else if (hasStrokePattern) {
                if (strokePattern) ctx.strokeStyle = strokePattern;
                else hasStroke = false;
            }
        }
        var lineDash = style.lineDash && style.lineWidth > 0 && (0, (0, parcelRequire("cpB91")).normalizeLineDash)(style.lineDash, style.lineWidth);
        var lineDashOffset = style.lineDashOffset;
        var ctxLineDash = !!ctx.setLineDash;
        var scale = el.getGlobalScale();
        path.setScale(scale[0], scale[1], el.segmentIgnoreThreshold);
        if (lineDash) {
            var lineScale_1 = style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1;
            if (lineScale_1 && lineScale_1 !== 1) {
                lineDash = (0, (0, parcelRequire("bahqM")).map)(lineDash, function(rawVal) {
                    return rawVal / lineScale_1;
                });
                lineDashOffset /= lineScale_1;
            }
        }
        var needsRebuild = true;
        if (firstDraw || el.__dirty & (0, (0, parcelRequire("aVawM")).SHAPE_CHANGED_BIT) || lineDash && !ctxLineDash && hasStroke) {
            path.setDPR(ctx.dpr);
            if (strokePart) path.setContext(null);
            else {
                path.setContext(ctx);
                needsRebuild = false;
            }
            path.reset();
            if (lineDash && !ctxLineDash) {
                path.setLineDash(lineDash);
                path.setLineDashOffset(lineDashOffset);
            }
            el.buildPath(path, el.shape, inBatch);
            path.toStatic();
            el.pathUpdated();
        }
        if (needsRebuild) path.rebuildPath(ctx, strokePart ? strokePercent : 1);
        if (lineDash && ctxLineDash) {
            ctx.setLineDash(lineDash);
            ctx.lineDashOffset = lineDashOffset;
        }
        if (!inBatch) {
            if (style.strokeFirst) {
                if (hasStroke) $7ebab9bfc20d8461$var$doStrokePath(ctx, style);
                if (hasFill) $7ebab9bfc20d8461$var$doFillPath(ctx, style);
            } else {
                if (hasFill) $7ebab9bfc20d8461$var$doFillPath(ctx, style);
                if (hasStroke) $7ebab9bfc20d8461$var$doStrokePath(ctx, style);
            }
        }
        if (lineDash && ctxLineDash) ctx.setLineDash([]);
    }
    function $7ebab9bfc20d8461$var$brushImage(ctx, el, style) {
        var image = el.__image = (0, (0, parcelRequire("63nvx")).createOrUpdateImage)(style.image, el.__image, el, el.onload);
        if (!image || !(0, (0, parcelRequire("63nvx")).isImageReady)(image)) return;
        var x = style.x || 0;
        var y = style.y || 0;
        var width = el.getWidth();
        var height = el.getHeight();
        var aspect = image.width / image.height;
        if (width == null && height != null) width = height * aspect;
        else if (height == null && width != null) height = width / aspect;
        else if (width == null && height == null) {
            width = image.width;
            height = image.height;
        }
        if (style.sWidth && style.sHeight) {
            var sx = style.sx || 0;
            var sy = style.sy || 0;
            ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
        } else if (style.sx && style.sy) {
            var sx = style.sx;
            var sy = style.sy;
            var sWidth = width - sx;
            var sHeight = height - sy;
            ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
        } else ctx.drawImage(image, x, y, width, height);
    }
    function $7ebab9bfc20d8461$var$brushText(ctx, el, style) {
        var text = style.text;
        text != null && (text += '');
        if (text) {
            ctx.font = style.font || (0, (0, parcelRequire("b7ZX8")).DEFAULT_FONT);
            ctx.textAlign = style.textAlign;
            ctx.textBaseline = style.textBaseline;
            var hasLineDash = void 0;
            if (ctx.setLineDash) {
                var lineDash = style.lineDash && style.lineWidth > 0 && (0, (0, parcelRequire("cpB91")).normalizeLineDash)(style.lineDash, style.lineWidth);
                var lineDashOffset = style.lineDashOffset;
                if (lineDash) {
                    var lineScale_2 = style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1;
                    if (lineScale_2 && lineScale_2 !== 1) {
                        lineDash = (0, (0, parcelRequire("bahqM")).map)(lineDash, function(rawVal) {
                            return rawVal / lineScale_2;
                        });
                        lineDashOffset /= lineScale_2;
                    }
                    ctx.setLineDash(lineDash);
                    ctx.lineDashOffset = lineDashOffset;
                    hasLineDash = true;
                }
            }
            if (style.strokeFirst) {
                if ($7ebab9bfc20d8461$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
                if ($7ebab9bfc20d8461$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
            } else {
                if ($7ebab9bfc20d8461$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
                if ($7ebab9bfc20d8461$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
            }
            if (hasLineDash) ctx.setLineDash([]);
        }
    }
    var $7ebab9bfc20d8461$var$SHADOW_NUMBER_PROPS = [
        'shadowBlur',
        'shadowOffsetX',
        'shadowOffsetY'
    ];
    var $7ebab9bfc20d8461$var$STROKE_PROPS = [
        [
            'lineCap',
            'butt'
        ],
        [
            'lineJoin',
            'miter'
        ],
        [
            'miterLimit',
            10
        ]
    ];
    function $7ebab9bfc20d8461$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope) {
        var styleChanged = false;
        if (!forceSetAll) {
            prevStyle = prevStyle || {};
            if (style === prevStyle) return false;
        }
        if (forceSetAll || style.opacity !== prevStyle.opacity) {
            if (!styleChanged) {
                $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            var opacity = Math.max(Math.min(style.opacity, 1), 0);
            ctx.globalAlpha = isNaN(opacity) ? (0, (0, parcelRequire("lBQ88")).DEFAULT_COMMON_STYLE).opacity : opacity;
        }
        if (forceSetAll || style.blend !== prevStyle.blend) {
            if (!styleChanged) {
                $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx.globalCompositeOperation = style.blend || (0, (0, parcelRequire("lBQ88")).DEFAULT_COMMON_STYLE).blend;
        }
        for(var i = 0; i < $7ebab9bfc20d8461$var$SHADOW_NUMBER_PROPS.length; i++){
            var propName = $7ebab9bfc20d8461$var$SHADOW_NUMBER_PROPS[i];
            if (forceSetAll || style[propName] !== prevStyle[propName]) {
                if (!styleChanged) {
                    $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                    styleChanged = true;
                }
                ctx[propName] = ctx.dpr * (style[propName] || 0);
            }
        }
        if (forceSetAll || style.shadowColor !== prevStyle.shadowColor) {
            if (!styleChanged) {
                $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx.shadowColor = style.shadowColor || (0, (0, parcelRequire("lBQ88")).DEFAULT_COMMON_STYLE).shadowColor;
        }
        return styleChanged;
    }
    function $7ebab9bfc20d8461$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetAll, scope) {
        var style = $7ebab9bfc20d8461$var$getStyle(el, scope.inHover);
        var prevStyle = forceSetAll ? null : prevEl && $7ebab9bfc20d8461$var$getStyle(prevEl, scope.inHover) || {};
        if (style === prevStyle) return false;
        var styleChanged = $7ebab9bfc20d8461$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope);
        if (forceSetAll || style.fill !== prevStyle.fill) {
            if (!styleChanged) {
                $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            $7ebab9bfc20d8461$var$isValidStrokeFillStyle(style.fill) && (ctx.fillStyle = style.fill);
        }
        if (forceSetAll || style.stroke !== prevStyle.stroke) {
            if (!styleChanged) {
                $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            $7ebab9bfc20d8461$var$isValidStrokeFillStyle(style.stroke) && (ctx.strokeStyle = style.stroke);
        }
        if (forceSetAll || style.opacity !== prevStyle.opacity) {
            if (!styleChanged) {
                $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
        }
        if (el.hasStroke()) {
            var lineWidth = style.lineWidth;
            var newLineWidth = lineWidth / (style.strokeNoScale && el && el.getLineScale ? el.getLineScale() : 1);
            if (ctx.lineWidth !== newLineWidth) {
                if (!styleChanged) {
                    $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                    styleChanged = true;
                }
                ctx.lineWidth = newLineWidth;
            }
        }
        for(var i = 0; i < $7ebab9bfc20d8461$var$STROKE_PROPS.length; i++){
            var prop = $7ebab9bfc20d8461$var$STROKE_PROPS[i];
            var propName = prop[0];
            if (forceSetAll || style[propName] !== prevStyle[propName]) {
                if (!styleChanged) {
                    $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                    styleChanged = true;
                }
                ctx[propName] = style[propName] || prop[1];
            }
        }
        return styleChanged;
    }
    function $7ebab9bfc20d8461$var$bindImageStyle(ctx, el, prevEl, forceSetAll, scope) {
        return $7ebab9bfc20d8461$var$bindCommonProps(ctx, $7ebab9bfc20d8461$var$getStyle(el, scope.inHover), prevEl && $7ebab9bfc20d8461$var$getStyle(prevEl, scope.inHover), forceSetAll, scope);
    }
    function $7ebab9bfc20d8461$var$setContextTransform(ctx, el) {
        var m = el.transform;
        var dpr = ctx.dpr || 1;
        if (m) ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
        else ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function $7ebab9bfc20d8461$var$updateClipStatus(clipPaths, ctx, scope) {
        var allClipped = false;
        for(var i = 0; i < clipPaths.length; i++){
            var clipPath = clipPaths[i];
            allClipped = allClipped || clipPath.isZeroArea();
            $7ebab9bfc20d8461$var$setContextTransform(ctx, clipPath);
            ctx.beginPath();
            clipPath.buildPath(ctx, clipPath.shape);
            ctx.clip();
        }
        scope.allClipped = allClipped;
    }
    function $7ebab9bfc20d8461$var$isTransformChanged(m0, m1) {
        if (m0 && m1) return m0[0] !== m1[0] || m0[1] !== m1[1] || m0[2] !== m1[2] || m0[3] !== m1[3] || m0[4] !== m1[4] || m0[5] !== m1[5];
        else if (!m0 && !m1) return false;
        return true;
    }
    var $7ebab9bfc20d8461$var$DRAW_TYPE_PATH = 1;
    var $7ebab9bfc20d8461$var$DRAW_TYPE_IMAGE = 2;
    var $7ebab9bfc20d8461$var$DRAW_TYPE_TEXT = 3;
    var $7ebab9bfc20d8461$var$DRAW_TYPE_INCREMENTAL = 4;
    function $7ebab9bfc20d8461$var$canPathBatch(style) {
        var hasFill = $7ebab9bfc20d8461$var$styleHasFill(style);
        var hasStroke = $7ebab9bfc20d8461$var$styleHasStroke(style);
        return !(style.lineDash || !(+hasFill ^ +hasStroke) || hasFill && typeof style.fill !== 'string' || hasStroke && typeof style.stroke !== 'string' || style.strokePercent < 1 || style.strokeOpacity < 1 || style.fillOpacity < 1);
    }
    function $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope) {
        scope.batchFill && ctx.fill();
        scope.batchStroke && ctx.stroke();
        scope.batchFill = '';
        scope.batchStroke = '';
    }
    function $7ebab9bfc20d8461$var$getStyle(el, inHover) {
        return inHover ? el.__hoverStyle || el.style : el.style;
    }
    function $7ebab9bfc20d8461$export$567881adfc3eb7f3(ctx, el) {
        $7ebab9bfc20d8461$export$da5d6544e8c27bc1(ctx, el, {
            inHover: false,
            viewWidth: 0,
            viewHeight: 0
        }, true);
    }
    function $7ebab9bfc20d8461$export$da5d6544e8c27bc1(ctx, el, scope, isLast) {
        var m = el.transform;
        if (!el.shouldBePainted(scope.viewWidth, scope.viewHeight, false, false)) {
            el.__dirty &= ~(0, (0, parcelRequire("aVawM")).REDRAW_BIT);
            el.__isRendered = false;
            return;
        }
        var clipPaths = el.__clipPaths;
        var prevElClipPaths = scope.prevElClipPaths;
        var forceSetTransform = false;
        var forceSetStyle = false;
        if (!prevElClipPaths || (0, (0, parcelRequire("dPYp9")).isClipPathChanged)(clipPaths, prevElClipPaths)) {
            if (prevElClipPaths && prevElClipPaths.length) {
                $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                ctx.restore();
                forceSetStyle = forceSetTransform = true;
                scope.prevElClipPaths = null;
                scope.allClipped = false;
                scope.prevEl = null;
            }
            if (clipPaths && clipPaths.length) {
                $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
                ctx.save();
                $7ebab9bfc20d8461$var$updateClipStatus(clipPaths, ctx, scope);
                forceSetTransform = true;
            }
            scope.prevElClipPaths = clipPaths;
        }
        if (scope.allClipped) {
            el.__isRendered = false;
            return;
        }
        el.beforeBrush && el.beforeBrush();
        el.innerBeforeBrush();
        var prevEl = scope.prevEl;
        if (!prevEl) forceSetStyle = forceSetTransform = true;
        var canBatchPath = el instanceof (0, (0, parcelRequire("ghQ8v")).default) && el.autoBatch && $7ebab9bfc20d8461$var$canPathBatch(el.style);
        if (forceSetTransform || $7ebab9bfc20d8461$var$isTransformChanged(m, prevEl.transform)) {
            $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
            $7ebab9bfc20d8461$var$setContextTransform(ctx, el);
        } else if (!canBatchPath) $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
        var style = $7ebab9bfc20d8461$var$getStyle(el, scope.inHover);
        if (el instanceof (0, (0, parcelRequire("ghQ8v")).default)) {
            if (scope.lastDrawType !== $7ebab9bfc20d8461$var$DRAW_TYPE_PATH) {
                forceSetStyle = true;
                scope.lastDrawType = $7ebab9bfc20d8461$var$DRAW_TYPE_PATH;
            }
            $7ebab9bfc20d8461$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
            if (!canBatchPath || !scope.batchFill && !scope.batchStroke) ctx.beginPath();
            $7ebab9bfc20d8461$var$brushPath(ctx, el, style, canBatchPath);
            if (canBatchPath) {
                scope.batchFill = style.fill || '';
                scope.batchStroke = style.stroke || '';
            }
        } else {
            if (el instanceof (0, (0, parcelRequire("45jlh")).default)) {
                if (scope.lastDrawType !== $7ebab9bfc20d8461$var$DRAW_TYPE_TEXT) {
                    forceSetStyle = true;
                    scope.lastDrawType = $7ebab9bfc20d8461$var$DRAW_TYPE_TEXT;
                }
                $7ebab9bfc20d8461$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
                $7ebab9bfc20d8461$var$brushText(ctx, el, style);
            } else if (el instanceof (0, (0, parcelRequire("gcbBH")).default)) {
                if (scope.lastDrawType !== $7ebab9bfc20d8461$var$DRAW_TYPE_IMAGE) {
                    forceSetStyle = true;
                    scope.lastDrawType = $7ebab9bfc20d8461$var$DRAW_TYPE_IMAGE;
                }
                $7ebab9bfc20d8461$var$bindImageStyle(ctx, el, prevEl, forceSetStyle, scope);
                $7ebab9bfc20d8461$var$brushImage(ctx, el, style);
            } else if (el instanceof (0, (0, parcelRequire("6sllV")).default)) {
                if (scope.lastDrawType !== $7ebab9bfc20d8461$var$DRAW_TYPE_INCREMENTAL) {
                    forceSetStyle = true;
                    scope.lastDrawType = $7ebab9bfc20d8461$var$DRAW_TYPE_INCREMENTAL;
                }
                $7ebab9bfc20d8461$var$brushIncremental(ctx, el, scope);
            }
        }
        if (canBatchPath && isLast) $7ebab9bfc20d8461$var$flushPathDrawn(ctx, scope);
        el.innerAfterBrush();
        el.afterBrush && el.afterBrush();
        scope.prevEl = el;
        el.__dirty = 0;
        el.__isRendered = true;
    }
    function $7ebab9bfc20d8461$var$brushIncremental(ctx, el, scope) {
        var displayables = el.getDisplayables();
        var temporalDisplayables = el.getTemporalDisplayables();
        ctx.save();
        var innerScope = {
            prevElClipPaths: null,
            prevEl: null,
            allClipped: false,
            viewWidth: scope.viewWidth,
            viewHeight: scope.viewHeight,
            inHover: scope.inHover
        };
        var i;
        var len;
        for(i = el.getCursor(), len = displayables.length; i < len; i++){
            var displayable = displayables[i];
            displayable.beforeBrush && displayable.beforeBrush();
            displayable.innerBeforeBrush();
            $7ebab9bfc20d8461$export$da5d6544e8c27bc1(ctx, displayable, innerScope, i === len - 1);
            displayable.innerAfterBrush();
            displayable.afterBrush && displayable.afterBrush();
            innerScope.prevEl = displayable;
        }
        for(var i_1 = 0, len_1 = temporalDisplayables.length; i_1 < len_1; i_1++){
            var displayable = temporalDisplayables[i_1];
            displayable.beforeBrush && displayable.beforeBrush();
            displayable.innerBeforeBrush();
            $7ebab9bfc20d8461$export$da5d6544e8c27bc1(ctx, displayable, innerScope, i_1 === len_1 - 1);
            displayable.innerAfterBrush();
            displayable.afterBrush && displayable.afterBrush();
            innerScope.prevEl = displayable;
        }
        el.clearTemporalDisplayables();
        el.notClear = true;
        ctx.restore();
    }
});
parcelRegister("dPYp9", function(module, exports) {
    $parcel$export(module.exports, "getCanvasGradient", ()=>$a12ee4e4c244a026$export$3dab6afd018d48c7);
    $parcel$export(module.exports, "isClipPathChanged", ()=>$a12ee4e4c244a026$export$beeddc5150cb2e83);
    function $a12ee4e4c244a026$export$235c7ac50fe1db0a(ctx, obj, rect) {
        var x = obj.x == null ? 0 : obj.x;
        var x2 = obj.x2 == null ? 1 : obj.x2;
        var y = obj.y == null ? 0 : obj.y;
        var y2 = obj.y2 == null ? 0 : obj.y2;
        if (!obj.global) {
            x = x * rect.width + rect.x;
            x2 = x2 * rect.width + rect.x;
            y = y * rect.height + rect.y;
            y2 = y2 * rect.height + rect.y;
        }
        x = isNaN(x) ? 0 : x;
        x2 = isNaN(x2) ? 1 : x2;
        y = isNaN(y) ? 0 : y;
        y2 = isNaN(y2) ? 0 : y2;
        var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
        return canvasGradient;
    }
    function $a12ee4e4c244a026$export$57f098206d57a443(ctx, obj, rect) {
        var width = rect.width;
        var height = rect.height;
        var min = Math.min(width, height);
        var x = obj.x == null ? 0.5 : obj.x;
        var y = obj.y == null ? 0.5 : obj.y;
        var r = obj.r == null ? 0.5 : obj.r;
        if (!obj.global) {
            x = x * width + rect.x;
            y = y * height + rect.y;
            r = r * min;
        }
        var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
        return canvasGradient;
    }
    function $a12ee4e4c244a026$export$3dab6afd018d48c7(ctx, obj, rect) {
        var canvasGradient = obj.type === 'radial' ? $a12ee4e4c244a026$export$57f098206d57a443(ctx, obj, rect) : $a12ee4e4c244a026$export$235c7ac50fe1db0a(ctx, obj, rect);
        var colorStops = obj.colorStops;
        for(var i = 0; i < colorStops.length; i++)canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
        return canvasGradient;
    }
    function $a12ee4e4c244a026$export$beeddc5150cb2e83(clipPaths, prevClipPaths) {
        if (clipPaths === prevClipPaths || !clipPaths && !prevClipPaths) return false;
        if (!clipPaths || !prevClipPaths || clipPaths.length !== prevClipPaths.length) return true;
        for(var i = 0; i < clipPaths.length; i++){
            if (clipPaths[i] !== prevClipPaths[i]) return true;
        }
        return false;
    }
});
parcelRegister("cpB91", function(module, exports) {
    $parcel$export(module.exports, "normalizeLineDash", ()=>$9094a1fa7d97ce08$export$9efb2ae8a603855d);
    var $bahqM;
    function $9094a1fa7d97ce08$export$9efb2ae8a603855d(lineType, lineWidth) {
        if (!lineType || lineType === 'solid' || !(lineWidth > 0)) return null;
        lineWidth = lineWidth || 1;
        return lineType === 'dashed' ? [
            4 * lineWidth,
            2 * lineWidth
        ] : lineType === 'dotted' ? [
            lineWidth
        ] : (0, (0, parcelRequire("bahqM")).isNumber)(lineType) ? [
            lineType
        ] : (0, (0, parcelRequire("bahqM")).isArray)(lineType) ? lineType : null;
    }
});
parcelRegister("fEzwg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b65624d7bef03239$export$2e2bcd8739ae039);
    var $bahqM;
    var $fBEGW;
    var $2iWFB;
    var $b65624d7bef03239$var$storage = (0, (0, parcelRequire("bahqM")).createHashMap)();
    var $b65624d7bef03239$export$2e2bcd8739ae039 = {
        registerMap: function(mapName, rawDef, rawSpecialAreas) {
            if (rawDef.svg) {
                var resource = new (0, (0, parcelRequire("fBEGW")).GeoSVGResource)(mapName, rawDef.svg);
                $b65624d7bef03239$var$storage.set(mapName, resource);
            } else {
                var geoJSON = rawDef.geoJson || rawDef.geoJSON;
                if (geoJSON && !rawDef.features) rawSpecialAreas = rawDef.specialAreas;
                else geoJSON = rawDef;
                var resource = new (0, (0, parcelRequire("2iWFB")).GeoJSONResource)(mapName, geoJSON, rawSpecialAreas);
                $b65624d7bef03239$var$storage.set(mapName, resource);
            }
        },
        getGeoResource: function(mapName) {
            return $b65624d7bef03239$var$storage.get(mapName);
        },
        getMapForUser: function(mapName) {
            var resource = $b65624d7bef03239$var$storage.get(mapName);
            return resource && resource.type === 'geoJSON' && resource.getMapForUser();
        },
        load: function(mapName, nameMap, nameProperty) {
            var resource = $b65624d7bef03239$var$storage.get(mapName);
            if (!resource) return;
            return resource.load(nameMap, nameProperty);
        }
    };
});
parcelRegister("fBEGW", function(module, exports) {
    $parcel$export(module.exports, "GeoSVGResource", ()=>$b5c9e032bcec003b$export$be52c950efae1f84);
    var $KN3aA;
    var $4KVOr;
    var $7Tw7u;
    var $bahqM;
    var $1E3E8;
    var $bsT8u;
    var $b8QyH;
    var $b5c9e032bcec003b$var$REGION_AVAILABLE_SVG_TAG_MAP = (0, (0, parcelRequire("bahqM")).createHashMap)([
        'rect',
        'circle',
        'line',
        'ellipse',
        'polygon',
        'polyline',
        'path',
        'text',
        'tspan',
        'g'
    ]);
    var $b5c9e032bcec003b$export$be52c950efae1f84 = function() {
        function GeoSVGResource(mapName, svg) {
            this.type = 'geoSVG';
            this._usedGraphicMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
            this._freedGraphics = [];
            this._mapName = mapName;
            this._parsedXML = (0, (0, parcelRequire("bsT8u")).parseXML)(svg);
        }
        GeoSVGResource.prototype.load = function() {
            var firstGraphic = this._firstGraphic;
            if (!firstGraphic) {
                firstGraphic = this._firstGraphic = this._buildGraphic(this._parsedXML);
                this._freedGraphics.push(firstGraphic);
                this._boundingRect = this._firstGraphic.boundingRect.clone();
                var _a = $b5c9e032bcec003b$var$createRegions(firstGraphic.named), regions = _a.regions, regionsMap = _a.regionsMap;
                this._regions = regions;
                this._regionsMap = regionsMap;
            }
            return {
                boundingRect: this._boundingRect,
                regions: this._regions,
                regionsMap: this._regionsMap
            };
        };
        GeoSVGResource.prototype._buildGraphic = function(svgXML) {
            var result;
            var rootFromParse;
            try {
                result = svgXML && (0, (0, parcelRequire("KN3aA")).parseSVG)(svgXML, {
                    ignoreViewBox: true,
                    ignoreRootClip: true
                }) || {};
                rootFromParse = result.root;
                (0, (0, parcelRequire("bahqM")).assert)(rootFromParse != null);
            } catch (e) {
                throw new Error('Invalid svg format\n' + e.message);
            }
            var root = new (0, (0, parcelRequire("4KVOr")).default)();
            root.add(rootFromParse);
            root.isGeoSVGGraphicRoot = true;
            var svgWidth = result.width;
            var svgHeight = result.height;
            var viewBoxRect = result.viewBoxRect;
            var boundingRect = this._boundingRect;
            if (!boundingRect) {
                var bRectX = void 0;
                var bRectY = void 0;
                var bRectWidth = void 0;
                var bRectHeight = void 0;
                if (svgWidth != null) {
                    bRectX = 0;
                    bRectWidth = svgWidth;
                } else if (viewBoxRect) {
                    bRectX = viewBoxRect.x;
                    bRectWidth = viewBoxRect.width;
                }
                if (svgHeight != null) {
                    bRectY = 0;
                    bRectHeight = svgHeight;
                } else if (viewBoxRect) {
                    bRectY = viewBoxRect.y;
                    bRectHeight = viewBoxRect.height;
                }
                if (bRectX == null || bRectY == null) {
                    var calculatedBoundingRect = rootFromParse.getBoundingRect();
                    if (bRectX == null) {
                        bRectX = calculatedBoundingRect.x;
                        bRectWidth = calculatedBoundingRect.width;
                    }
                    if (bRectY == null) {
                        bRectY = calculatedBoundingRect.y;
                        bRectHeight = calculatedBoundingRect.height;
                    }
                }
                boundingRect = this._boundingRect = new (0, (0, parcelRequire("1E3E8")).default)(bRectX, bRectY, bRectWidth, bRectHeight);
            }
            if (viewBoxRect) {
                var viewBoxTransform = (0, (0, parcelRequire("KN3aA")).makeViewBoxTransform)(viewBoxRect, boundingRect);
                rootFromParse.scaleX = rootFromParse.scaleY = viewBoxTransform.scale;
                rootFromParse.x = viewBoxTransform.x;
                rootFromParse.y = viewBoxTransform.y;
            }
            root.setClipPath(new (0, (0, parcelRequire("7Tw7u")).default)({
                shape: boundingRect.plain()
            }));
            var named = [];
            (0, (0, parcelRequire("bahqM")).each)(result.named, function(namedItem) {
                if ($b5c9e032bcec003b$var$REGION_AVAILABLE_SVG_TAG_MAP.get(namedItem.svgNodeTagLower) != null) {
                    named.push(namedItem);
                    $b5c9e032bcec003b$var$setSilent(namedItem.el);
                }
            });
            return {
                root: root,
                boundingRect: boundingRect,
                named: named
            };
        };
        GeoSVGResource.prototype.useGraphic = function(hostKey) {
            var usedRootMap = this._usedGraphicMap;
            var svgGraphic = usedRootMap.get(hostKey);
            if (svgGraphic) return svgGraphic;
            svgGraphic = this._freedGraphics.pop() || this._buildGraphic(this._parsedXML);
            usedRootMap.set(hostKey, svgGraphic);
            return svgGraphic;
        };
        GeoSVGResource.prototype.freeGraphic = function(hostKey) {
            var usedRootMap = this._usedGraphicMap;
            var svgGraphic = usedRootMap.get(hostKey);
            if (svgGraphic) {
                usedRootMap.removeKey(hostKey);
                this._freedGraphics.push(svgGraphic);
            }
        };
        return GeoSVGResource;
    }();
    function $b5c9e032bcec003b$var$setSilent(el) {
        el.silent = false;
        if (el.isGroup) el.traverse(function(child) {
            child.silent = false;
        });
    }
    function $b5c9e032bcec003b$var$createRegions(named) {
        var regions = [];
        var regionsMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
        (0, (0, parcelRequire("bahqM")).each)(named, function(namedItem) {
            if (namedItem.namedFrom != null) return;
            var region = new (0, (0, parcelRequire("b8QyH")).GeoSVGRegion)(namedItem.name, namedItem.el);
            regions.push(region);
            regionsMap.set(namedItem.name, region);
        });
        return {
            regions: regions,
            regionsMap: regionsMap
        };
    }
});
parcelRegister("KN3aA", function(module, exports) {
    $parcel$export(module.exports, "makeViewBoxTransform", ()=>$08ca58536684a52b$export$3e2db4420f14f50f);
    $parcel$export(module.exports, "parseSVG", ()=>$08ca58536684a52b$export$1919f5101c220601);
    var $4KVOr;
    var $gcbBH;
    var $jjfok;
    var $7Tw7u;
    var $kVeV8;
    var $cZb1F;
    var $lQwBc;
    var $32bXc;
    var $izqgC;
    var $id1Rd;
    var $bahqM;
    var $9J7f8;
    var $faICo;
    var $45jlh;
    var $bsT8u;
    var $08ca58536684a52b$var$nodeParsers;
    var $08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP = {
        'fill': 'fill',
        'stroke': 'stroke',
        'stroke-width': 'lineWidth',
        'opacity': 'opacity',
        'fill-opacity': 'fillOpacity',
        'stroke-opacity': 'strokeOpacity',
        'stroke-dasharray': 'lineDash',
        'stroke-dashoffset': 'lineDashOffset',
        'stroke-linecap': 'lineCap',
        'stroke-linejoin': 'lineJoin',
        'stroke-miterlimit': 'miterLimit',
        'font-family': 'fontFamily',
        'font-size': 'fontSize',
        'font-style': 'fontStyle',
        'font-weight': 'fontWeight',
        'text-anchor': 'textAlign',
        'visibility': 'visibility',
        'display': 'display'
    };
    var $08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS = (0, (0, parcelRequire("bahqM")).keys)($08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP);
    var $08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP = {
        'alignment-baseline': 'textBaseline',
        'stop-color': 'stopColor'
    };
    var $08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS = (0, (0, parcelRequire("bahqM")).keys)($08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP);
    var $08ca58536684a52b$var$SVGParser = function() {
        function SVGParser() {
            this._defs = {};
            this._root = null;
        }
        SVGParser.prototype.parse = function(xml, opt) {
            opt = opt || {};
            var svg = (0, (0, parcelRequire("bsT8u")).parseXML)(xml);
            if (!svg) throw new Error('Illegal svg');
            this._defsUsePending = [];
            var root = new (0, (0, parcelRequire("4KVOr")).default)();
            this._root = root;
            var named = [];
            var viewBox = svg.getAttribute('viewBox') || '';
            var width = parseFloat(svg.getAttribute('width') || opt.width);
            var height = parseFloat(svg.getAttribute('height') || opt.height);
            isNaN(width) && (width = null);
            isNaN(height) && (height = null);
            $08ca58536684a52b$var$parseAttributes(svg, root, null, true, false);
            var child = svg.firstChild;
            while(child){
                this._parseNode(child, root, named, null, false, false);
                child = child.nextSibling;
            }
            $08ca58536684a52b$var$applyDefs(this._defs, this._defsUsePending);
            this._defsUsePending = [];
            var viewBoxRect;
            var viewBoxTransform;
            if (viewBox) {
                var viewBoxArr = $08ca58536684a52b$var$splitNumberSequence(viewBox);
                if (viewBoxArr.length >= 4) viewBoxRect = {
                    x: parseFloat(viewBoxArr[0] || 0),
                    y: parseFloat(viewBoxArr[1] || 0),
                    width: parseFloat(viewBoxArr[2]),
                    height: parseFloat(viewBoxArr[3])
                };
            }
            if (viewBoxRect && width != null && height != null) {
                viewBoxTransform = $08ca58536684a52b$export$3e2db4420f14f50f(viewBoxRect, {
                    x: 0,
                    y: 0,
                    width: width,
                    height: height
                });
                if (!opt.ignoreViewBox) {
                    var elRoot = root;
                    root = new (0, (0, parcelRequire("4KVOr")).default)();
                    root.add(elRoot);
                    elRoot.scaleX = elRoot.scaleY = viewBoxTransform.scale;
                    elRoot.x = viewBoxTransform.x;
                    elRoot.y = viewBoxTransform.y;
                }
            }
            if (!opt.ignoreRootClip && width != null && height != null) root.setClipPath(new (0, (0, parcelRequire("7Tw7u")).default)({
                shape: {
                    x: 0,
                    y: 0,
                    width: width,
                    height: height
                }
            }));
            return {
                root: root,
                width: width,
                height: height,
                viewBoxRect: viewBoxRect,
                viewBoxTransform: viewBoxTransform,
                named: named
            };
        };
        SVGParser.prototype._parseNode = function(xmlNode, parentGroup, named, namedFrom, isInDefs, isInText) {
            var nodeName = xmlNode.nodeName.toLowerCase();
            var el;
            var namedFromForSub = namedFrom;
            if (nodeName === 'defs') isInDefs = true;
            if (nodeName === 'text') isInText = true;
            if (nodeName === 'defs' || nodeName === 'switch') el = parentGroup;
            else {
                if (!isInDefs) {
                    var parser_1 = $08ca58536684a52b$var$nodeParsers[nodeName];
                    if (parser_1 && (0, (0, parcelRequire("bahqM")).hasOwn)($08ca58536684a52b$var$nodeParsers, nodeName)) {
                        el = parser_1.call(this, xmlNode, parentGroup);
                        var nameAttr = xmlNode.getAttribute('name');
                        if (nameAttr) {
                            var newNamed = {
                                name: nameAttr,
                                namedFrom: null,
                                svgNodeTagLower: nodeName,
                                el: el
                            };
                            named.push(newNamed);
                            if (nodeName === 'g') namedFromForSub = newNamed;
                        } else if (namedFrom) named.push({
                            name: namedFrom.name,
                            namedFrom: namedFrom,
                            svgNodeTagLower: nodeName,
                            el: el
                        });
                        parentGroup.add(el);
                    }
                }
                var parser = $08ca58536684a52b$var$paintServerParsers[nodeName];
                if (parser && (0, (0, parcelRequire("bahqM")).hasOwn)($08ca58536684a52b$var$paintServerParsers, nodeName)) {
                    var def = parser.call(this, xmlNode);
                    var id = xmlNode.getAttribute('id');
                    if (id) this._defs[id] = def;
                }
            }
            if (el && el.isGroup) {
                var child = xmlNode.firstChild;
                while(child){
                    if (child.nodeType === 1) this._parseNode(child, el, named, namedFromForSub, isInDefs, isInText);
                    else if (child.nodeType === 3 && isInText) this._parseText(child, el);
                    child = child.nextSibling;
                }
            }
        };
        SVGParser.prototype._parseText = function(xmlNode, parentGroup) {
            var text = new (0, (0, parcelRequire("45jlh")).default)({
                style: {
                    text: xmlNode.textContent
                },
                silent: true,
                x: this._textX || 0,
                y: this._textY || 0
            });
            $08ca58536684a52b$var$inheritStyle(parentGroup, text);
            $08ca58536684a52b$var$parseAttributes(xmlNode, text, this._defsUsePending, false, false);
            $08ca58536684a52b$var$applyTextAlignment(text, parentGroup);
            var textStyle = text.style;
            var fontSize = textStyle.fontSize;
            if (fontSize && fontSize < 9) {
                textStyle.fontSize = 9;
                text.scaleX *= fontSize / 9;
                text.scaleY *= fontSize / 9;
            }
            var font = (textStyle.fontSize || textStyle.fontFamily) && [
                textStyle.fontStyle,
                textStyle.fontWeight,
                (textStyle.fontSize || 12) + 'px',
                textStyle.fontFamily || 'sans-serif'
            ].join(' ');
            textStyle.font = font;
            var rect = text.getBoundingRect();
            this._textX += rect.width;
            parentGroup.add(text);
            return text;
        };
        SVGParser.internalField = function() {
            $08ca58536684a52b$var$nodeParsers = {
                'g': function(xmlNode, parentGroup) {
                    var g = new (0, (0, parcelRequire("4KVOr")).default)();
                    $08ca58536684a52b$var$inheritStyle(parentGroup, g);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, g, this._defsUsePending, false, false);
                    return g;
                },
                'rect': function(xmlNode, parentGroup) {
                    var rect = new (0, (0, parcelRequire("7Tw7u")).default)();
                    $08ca58536684a52b$var$inheritStyle(parentGroup, rect);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, rect, this._defsUsePending, false, false);
                    rect.setShape({
                        x: parseFloat(xmlNode.getAttribute('x') || '0'),
                        y: parseFloat(xmlNode.getAttribute('y') || '0'),
                        width: parseFloat(xmlNode.getAttribute('width') || '0'),
                        height: parseFloat(xmlNode.getAttribute('height') || '0')
                    });
                    rect.silent = true;
                    return rect;
                },
                'circle': function(xmlNode, parentGroup) {
                    var circle = new (0, (0, parcelRequire("jjfok")).default)();
                    $08ca58536684a52b$var$inheritStyle(parentGroup, circle);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, circle, this._defsUsePending, false, false);
                    circle.setShape({
                        cx: parseFloat(xmlNode.getAttribute('cx') || '0'),
                        cy: parseFloat(xmlNode.getAttribute('cy') || '0'),
                        r: parseFloat(xmlNode.getAttribute('r') || '0')
                    });
                    circle.silent = true;
                    return circle;
                },
                'line': function(xmlNode, parentGroup) {
                    var line = new (0, (0, parcelRequire("cZb1F")).default)();
                    $08ca58536684a52b$var$inheritStyle(parentGroup, line);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, line, this._defsUsePending, false, false);
                    line.setShape({
                        x1: parseFloat(xmlNode.getAttribute('x1') || '0'),
                        y1: parseFloat(xmlNode.getAttribute('y1') || '0'),
                        x2: parseFloat(xmlNode.getAttribute('x2') || '0'),
                        y2: parseFloat(xmlNode.getAttribute('y2') || '0')
                    });
                    line.silent = true;
                    return line;
                },
                'ellipse': function(xmlNode, parentGroup) {
                    var ellipse = new (0, (0, parcelRequire("kVeV8")).default)();
                    $08ca58536684a52b$var$inheritStyle(parentGroup, ellipse);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, ellipse, this._defsUsePending, false, false);
                    ellipse.setShape({
                        cx: parseFloat(xmlNode.getAttribute('cx') || '0'),
                        cy: parseFloat(xmlNode.getAttribute('cy') || '0'),
                        rx: parseFloat(xmlNode.getAttribute('rx') || '0'),
                        ry: parseFloat(xmlNode.getAttribute('ry') || '0')
                    });
                    ellipse.silent = true;
                    return ellipse;
                },
                'polygon': function(xmlNode, parentGroup) {
                    var pointsStr = xmlNode.getAttribute('points');
                    var pointsArr;
                    if (pointsStr) pointsArr = $08ca58536684a52b$var$parsePoints(pointsStr);
                    var polygon = new (0, (0, parcelRequire("lQwBc")).default)({
                        shape: {
                            points: pointsArr || []
                        },
                        silent: true
                    });
                    $08ca58536684a52b$var$inheritStyle(parentGroup, polygon);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, polygon, this._defsUsePending, false, false);
                    return polygon;
                },
                'polyline': function(xmlNode, parentGroup) {
                    var pointsStr = xmlNode.getAttribute('points');
                    var pointsArr;
                    if (pointsStr) pointsArr = $08ca58536684a52b$var$parsePoints(pointsStr);
                    var polyline = new (0, (0, parcelRequire("32bXc")).default)({
                        shape: {
                            points: pointsArr || []
                        },
                        silent: true
                    });
                    $08ca58536684a52b$var$inheritStyle(parentGroup, polyline);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, polyline, this._defsUsePending, false, false);
                    return polyline;
                },
                'image': function(xmlNode, parentGroup) {
                    var img = new (0, (0, parcelRequire("gcbBH")).default)();
                    $08ca58536684a52b$var$inheritStyle(parentGroup, img);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, img, this._defsUsePending, false, false);
                    img.setStyle({
                        image: xmlNode.getAttribute('xlink:href') || xmlNode.getAttribute('href'),
                        x: +xmlNode.getAttribute('x'),
                        y: +xmlNode.getAttribute('y'),
                        width: +xmlNode.getAttribute('width'),
                        height: +xmlNode.getAttribute('height')
                    });
                    img.silent = true;
                    return img;
                },
                'text': function(xmlNode, parentGroup) {
                    var x = xmlNode.getAttribute('x') || '0';
                    var y = xmlNode.getAttribute('y') || '0';
                    var dx = xmlNode.getAttribute('dx') || '0';
                    var dy = xmlNode.getAttribute('dy') || '0';
                    this._textX = parseFloat(x) + parseFloat(dx);
                    this._textY = parseFloat(y) + parseFloat(dy);
                    var g = new (0, (0, parcelRequire("4KVOr")).default)();
                    $08ca58536684a52b$var$inheritStyle(parentGroup, g);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, g, this._defsUsePending, false, true);
                    return g;
                },
                'tspan': function(xmlNode, parentGroup) {
                    var x = xmlNode.getAttribute('x');
                    var y = xmlNode.getAttribute('y');
                    if (x != null) this._textX = parseFloat(x);
                    if (y != null) this._textY = parseFloat(y);
                    var dx = xmlNode.getAttribute('dx') || '0';
                    var dy = xmlNode.getAttribute('dy') || '0';
                    var g = new (0, (0, parcelRequire("4KVOr")).default)();
                    $08ca58536684a52b$var$inheritStyle(parentGroup, g);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, g, this._defsUsePending, false, true);
                    this._textX += parseFloat(dx);
                    this._textY += parseFloat(dy);
                    return g;
                },
                'path': function(xmlNode, parentGroup) {
                    var d = xmlNode.getAttribute('d') || '';
                    var path = (0, (0, parcelRequire("id1Rd")).createFromString)(d);
                    $08ca58536684a52b$var$inheritStyle(parentGroup, path);
                    $08ca58536684a52b$var$parseAttributes(xmlNode, path, this._defsUsePending, false, false);
                    path.silent = true;
                    return path;
                }
            };
        }();
        return SVGParser;
    }();
    var $08ca58536684a52b$var$paintServerParsers = {
        'lineargradient': function(xmlNode) {
            var x1 = parseInt(xmlNode.getAttribute('x1') || '0', 10);
            var y1 = parseInt(xmlNode.getAttribute('y1') || '0', 10);
            var x2 = parseInt(xmlNode.getAttribute('x2') || '10', 10);
            var y2 = parseInt(xmlNode.getAttribute('y2') || '0', 10);
            var gradient = new (0, (0, parcelRequire("9J7f8")).default)(x1, y1, x2, y2);
            $08ca58536684a52b$var$parsePaintServerUnit(xmlNode, gradient);
            $08ca58536684a52b$var$parseGradientColorStops(xmlNode, gradient);
            return gradient;
        },
        'radialgradient': function(xmlNode) {
            var cx = parseInt(xmlNode.getAttribute('cx') || '0', 10);
            var cy = parseInt(xmlNode.getAttribute('cy') || '0', 10);
            var r = parseInt(xmlNode.getAttribute('r') || '0', 10);
            var gradient = new (0, (0, parcelRequire("faICo")).default)(cx, cy, r);
            $08ca58536684a52b$var$parsePaintServerUnit(xmlNode, gradient);
            $08ca58536684a52b$var$parseGradientColorStops(xmlNode, gradient);
            return gradient;
        }
    };
    function $08ca58536684a52b$var$parsePaintServerUnit(xmlNode, gradient) {
        var gradientUnits = xmlNode.getAttribute('gradientUnits');
        if (gradientUnits === 'userSpaceOnUse') gradient.global = true;
    }
    function $08ca58536684a52b$var$parseGradientColorStops(xmlNode, gradient) {
        var stop = xmlNode.firstChild;
        while(stop){
            if (stop.nodeType === 1 && stop.nodeName.toLocaleLowerCase() === 'stop') {
                var offsetStr = stop.getAttribute('offset');
                var offset = void 0;
                if (offsetStr && offsetStr.indexOf('%') > 0) offset = parseInt(offsetStr, 10) / 100;
                else if (offsetStr) offset = parseFloat(offsetStr);
                else offset = 0;
                var styleVals = {};
                $08ca58536684a52b$var$parseInlineStyle(stop, styleVals, styleVals);
                var stopColor = styleVals.stopColor || stop.getAttribute('stop-color') || '#000000';
                gradient.colorStops.push({
                    offset: offset,
                    color: stopColor
                });
            }
            stop = stop.nextSibling;
        }
    }
    function $08ca58536684a52b$var$inheritStyle(parent, child) {
        if (parent && parent.__inheritedStyle) {
            if (!child.__inheritedStyle) child.__inheritedStyle = {};
            (0, (0, parcelRequire("bahqM")).defaults)(child.__inheritedStyle, parent.__inheritedStyle);
        }
    }
    function $08ca58536684a52b$var$parsePoints(pointsString) {
        var list = $08ca58536684a52b$var$splitNumberSequence(pointsString);
        var points = [];
        for(var i = 0; i < list.length; i += 2){
            var x = parseFloat(list[i]);
            var y = parseFloat(list[i + 1]);
            points.push([
                x,
                y
            ]);
        }
        return points;
    }
    function $08ca58536684a52b$var$parseAttributes(xmlNode, el, defsUsePending, onlyInlineStyle, isTextGroup) {
        var disp = el;
        var inheritedStyle = disp.__inheritedStyle = disp.__inheritedStyle || {};
        var selfStyle = {};
        if (xmlNode.nodeType === 1) {
            $08ca58536684a52b$var$parseTransformAttribute(xmlNode, el);
            $08ca58536684a52b$var$parseInlineStyle(xmlNode, inheritedStyle, selfStyle);
            if (!onlyInlineStyle) $08ca58536684a52b$var$parseAttributeStyle(xmlNode, inheritedStyle, selfStyle);
        }
        disp.style = disp.style || {};
        if (inheritedStyle.fill != null) disp.style.fill = $08ca58536684a52b$var$getFillStrokeStyle(disp, 'fill', inheritedStyle.fill, defsUsePending);
        if (inheritedStyle.stroke != null) disp.style.stroke = $08ca58536684a52b$var$getFillStrokeStyle(disp, 'stroke', inheritedStyle.stroke, defsUsePending);
        (0, (0, parcelRequire("bahqM")).each)([
            'lineWidth',
            'opacity',
            'fillOpacity',
            'strokeOpacity',
            'miterLimit',
            'fontSize'
        ], function(propName) {
            if (inheritedStyle[propName] != null) disp.style[propName] = parseFloat(inheritedStyle[propName]);
        });
        (0, (0, parcelRequire("bahqM")).each)([
            'lineDashOffset',
            'lineCap',
            'lineJoin',
            'fontWeight',
            'fontFamily',
            'fontStyle',
            'textAlign'
        ], function(propName) {
            if (inheritedStyle[propName] != null) disp.style[propName] = inheritedStyle[propName];
        });
        if (isTextGroup) disp.__selfStyle = selfStyle;
        if (inheritedStyle.lineDash) disp.style.lineDash = (0, (0, parcelRequire("bahqM")).map)($08ca58536684a52b$var$splitNumberSequence(inheritedStyle.lineDash), function(str) {
            return parseFloat(str);
        });
        if (inheritedStyle.visibility === 'hidden' || inheritedStyle.visibility === 'collapse') disp.invisible = true;
        if (inheritedStyle.display === 'none') disp.ignore = true;
    }
    function $08ca58536684a52b$var$applyTextAlignment(text, parentGroup) {
        var parentSelfStyle = parentGroup.__selfStyle;
        if (parentSelfStyle) {
            var textBaseline = parentSelfStyle.textBaseline;
            var zrTextBaseline = textBaseline;
            if (!textBaseline || textBaseline === 'auto') zrTextBaseline = 'alphabetic';
            else if (textBaseline === 'baseline') zrTextBaseline = 'alphabetic';
            else if (textBaseline === 'before-edge' || textBaseline === 'text-before-edge') zrTextBaseline = 'top';
            else if (textBaseline === 'after-edge' || textBaseline === 'text-after-edge') zrTextBaseline = 'bottom';
            else if (textBaseline === 'central' || textBaseline === 'mathematical') zrTextBaseline = 'middle';
            text.style.textBaseline = zrTextBaseline;
        }
        var parentInheritedStyle = parentGroup.__inheritedStyle;
        if (parentInheritedStyle) {
            var textAlign = parentInheritedStyle.textAlign;
            var zrTextAlign = textAlign;
            if (textAlign) {
                if (textAlign === 'middle') zrTextAlign = 'center';
                text.style.textAlign = zrTextAlign;
            }
        }
    }
    var $08ca58536684a52b$var$urlRegex = /^url\(\s*#(.*?)\)/;
    function $08ca58536684a52b$var$getFillStrokeStyle(el, method, str, defsUsePending) {
        var urlMatch = str && str.match($08ca58536684a52b$var$urlRegex);
        if (urlMatch) {
            var url = (0, (0, parcelRequire("bahqM")).trim)(urlMatch[1]);
            defsUsePending.push([
                el,
                method,
                url
            ]);
            return;
        }
        if (str === 'none') str = null;
        return str;
    }
    function $08ca58536684a52b$var$applyDefs(defs, defsUsePending) {
        for(var i = 0; i < defsUsePending.length; i++){
            var item = defsUsePending[i];
            item[0].style[item[1]] = defs[item[2]];
        }
    }
    var $08ca58536684a52b$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
    function $08ca58536684a52b$var$splitNumberSequence(rawStr) {
        return rawStr.match($08ca58536684a52b$var$numberReg) || [];
    }
    var $08ca58536684a52b$var$transformRegex = /(translate|scale|rotate|skewX|skewY|matrix)\(([\-\s0-9\.eE,]*)\)/g;
    var $08ca58536684a52b$var$DEGREE_TO_ANGLE = Math.PI / 180;
    function $08ca58536684a52b$var$parseTransformAttribute(xmlNode, node) {
        var transform = xmlNode.getAttribute('transform');
        if (transform) {
            transform = transform.replace(/,/g, ' ');
            var transformOps_1 = [];
            var mt = null;
            transform.replace($08ca58536684a52b$var$transformRegex, function(str, type, value) {
                transformOps_1.push(type, value);
                return '';
            });
            for(var i = transformOps_1.length - 1; i > 0; i -= 2){
                var value = transformOps_1[i];
                var type = transformOps_1[i - 1];
                var valueArr = $08ca58536684a52b$var$splitNumberSequence(value);
                mt = mt || (0, parcelRequire("izqgC")).create();
                switch(type){
                    case 'translate':
                        (0, parcelRequire("izqgC")).translate(mt, mt, [
                            parseFloat(valueArr[0]),
                            parseFloat(valueArr[1] || '0')
                        ]);
                        break;
                    case 'scale':
                        (0, parcelRequire("izqgC")).scale(mt, mt, [
                            parseFloat(valueArr[0]),
                            parseFloat(valueArr[1] || valueArr[0])
                        ]);
                        break;
                    case 'rotate':
                        (0, parcelRequire("izqgC")).rotate(mt, mt, -parseFloat(valueArr[0]) * $08ca58536684a52b$var$DEGREE_TO_ANGLE);
                        break;
                    case 'skewX':
                        var sx = Math.tan(parseFloat(valueArr[0]) * $08ca58536684a52b$var$DEGREE_TO_ANGLE);
                        (0, parcelRequire("izqgC")).mul(mt, [
                            1,
                            0,
                            sx,
                            1,
                            0,
                            0
                        ], mt);
                        break;
                    case 'skewY':
                        var sy = Math.tan(parseFloat(valueArr[0]) * $08ca58536684a52b$var$DEGREE_TO_ANGLE);
                        (0, parcelRequire("izqgC")).mul(mt, [
                            1,
                            sy,
                            0,
                            1,
                            0,
                            0
                        ], mt);
                        break;
                    case 'matrix':
                        mt[0] = parseFloat(valueArr[0]);
                        mt[1] = parseFloat(valueArr[1]);
                        mt[2] = parseFloat(valueArr[2]);
                        mt[3] = parseFloat(valueArr[3]);
                        mt[4] = parseFloat(valueArr[4]);
                        mt[5] = parseFloat(valueArr[5]);
                        break;
                }
            }
            node.setLocalTransform(mt);
        }
    }
    var $08ca58536684a52b$var$styleRegex = /([^\s:;]+)\s*:\s*([^:;]+)/g;
    function $08ca58536684a52b$var$parseInlineStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
        var style = xmlNode.getAttribute('style');
        if (!style) return;
        $08ca58536684a52b$var$styleRegex.lastIndex = 0;
        var styleRegResult;
        while((styleRegResult = $08ca58536684a52b$var$styleRegex.exec(style)) != null){
            var svgStlAttr = styleRegResult[1];
            var zrInheritableStlAttr = (0, (0, parcelRequire("bahqM")).hasOwn)($08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP, svgStlAttr) ? $08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP[svgStlAttr] : null;
            if (zrInheritableStlAttr) inheritableStyleResult[zrInheritableStlAttr] = styleRegResult[2];
            var zrSelfStlAttr = (0, (0, parcelRequire("bahqM")).hasOwn)($08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP, svgStlAttr) ? $08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP[svgStlAttr] : null;
            if (zrSelfStlAttr) selfStyleResult[zrSelfStlAttr] = styleRegResult[2];
        }
    }
    function $08ca58536684a52b$var$parseAttributeStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
        for(var i = 0; i < $08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS.length; i++){
            var svgAttrName = $08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS[i];
            var attrValue = xmlNode.getAttribute(svgAttrName);
            if (attrValue != null) inheritableStyleResult[$08ca58536684a52b$var$INHERITABLE_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
        }
        for(var i = 0; i < $08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS.length; i++){
            var svgAttrName = $08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS[i];
            var attrValue = xmlNode.getAttribute(svgAttrName);
            if (attrValue != null) selfStyleResult[$08ca58536684a52b$var$SELF_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
        }
    }
    function $08ca58536684a52b$export$3e2db4420f14f50f(viewBoxRect, boundingRect) {
        var scaleX = boundingRect.width / viewBoxRect.width;
        var scaleY = boundingRect.height / viewBoxRect.height;
        var scale = Math.min(scaleX, scaleY);
        return {
            scale: scale,
            x: -(viewBoxRect.x + viewBoxRect.width / 2) * scale + (boundingRect.x + boundingRect.width / 2),
            y: -(viewBoxRect.y + viewBoxRect.height / 2) * scale + (boundingRect.y + boundingRect.height / 2)
        };
    }
    function $08ca58536684a52b$export$1919f5101c220601(xml, opt) {
        var parser = new $08ca58536684a52b$var$SVGParser();
        return parser.parse(xml, opt);
    }
});
parcelRegister("bsT8u", function(module, exports) {
    $parcel$export(module.exports, "parseXML", ()=>$858d140ea42b55af$export$eacefc55fad2867e);
    var $bahqM;
    function $858d140ea42b55af$export$eacefc55fad2867e(svg) {
        if ((0, (0, parcelRequire("bahqM")).isString)(svg)) {
            var parser = new DOMParser();
            svg = parser.parseFromString(svg, 'text/xml');
        }
        var svgNode = svg;
        if (svgNode.nodeType === 9) svgNode = svgNode.firstChild;
        while(svgNode.nodeName.toLowerCase() !== 'svg' || svgNode.nodeType !== 1)svgNode = svgNode.nextSibling;
        return svgNode;
    }
});
parcelRegister("b8QyH", function(module, exports) {
    $parcel$export(module.exports, "GeoJSONRegion", ()=>$81c9361a69c93c5f$export$ee84fcb463f24b3d);
    $parcel$export(module.exports, "GeoSVGRegion", ()=>$81c9361a69c93c5f$export$5f3d89e7254f3e69);
    var $3VFsf;
    var $1E3E8;
    var $13I82;
    var $eLEew;
    var $hjZ9y;
    var $izqgC;
    var $81c9361a69c93c5f$var$TMP_TRANSFORM = [];
    var $81c9361a69c93c5f$export$b1f97c3099fc6872 = function() {
        function Region(name) {
            this.name = name;
        }
        Region.prototype.getCenter = function() {
            return;
        };
        return Region;
    }();
    var $81c9361a69c93c5f$export$ee84fcb463f24b3d = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(GeoJSONRegion, _super);
        function GeoJSONRegion(name, geometries, cp) {
            var _this = _super.call(this, name) || this;
            _this.type = 'geoJSON';
            _this.geometries = geometries;
            if (!cp) {
                var rect = _this.getBoundingRect();
                cp = [
                    rect.x + rect.width / 2,
                    rect.y + rect.height / 2
                ];
            } else cp = [
                cp[0],
                cp[1]
            ];
            _this._center = cp;
            return _this;
        }
        GeoJSONRegion.prototype.getBoundingRect = function() {
            var rect = this._rect;
            if (rect) return rect;
            var MAX_NUMBER = Number.MAX_VALUE;
            var min = [
                MAX_NUMBER,
                MAX_NUMBER
            ];
            var max = [
                -MAX_NUMBER,
                -MAX_NUMBER
            ];
            var min2 = [];
            var max2 = [];
            var geometries = this.geometries;
            var i = 0;
            for(; i < geometries.length; i++){
                if (geometries[i].type !== 'polygon') continue;
                var exterior = geometries[i].exterior;
                (0, parcelRequire("13I82")).fromPoints(exterior, min2, max2);
                (0, parcelRequire("eLEew")).min(min, min, min2);
                (0, parcelRequire("eLEew")).max(max, max, max2);
            }
            if (i === 0) min[0] = min[1] = max[0] = max[1] = 0;
            return this._rect = new (0, (0, parcelRequire("1E3E8")).default)(min[0], min[1], max[0] - min[0], max[1] - min[1]);
        };
        GeoJSONRegion.prototype.contain = function(coord) {
            var rect = this.getBoundingRect();
            var geometries = this.geometries;
            if (!rect.contain(coord[0], coord[1])) return false;
            loopGeo: for(var i = 0, len = geometries.length; i < len; i++){
                if (geometries[i].type !== 'polygon') continue;
                var exterior = geometries[i].exterior;
                var interiors = geometries[i].interiors;
                if ((0, parcelRequire("hjZ9y")).contain(exterior, coord[0], coord[1])) {
                    for(var k = 0; k < (interiors ? interiors.length : 0); k++){
                        if ((0, parcelRequire("hjZ9y")).contain(interiors[k], coord[0], coord[1])) continue loopGeo;
                    }
                    return true;
                }
            }
            return false;
        };
        GeoJSONRegion.prototype.transformTo = function(x, y, width, height) {
            var rect = this.getBoundingRect();
            var aspect = rect.width / rect.height;
            if (!width) width = aspect * height;
            else if (!height) height = width / aspect;
            var target = new (0, (0, parcelRequire("1E3E8")).default)(x, y, width, height);
            var transform = rect.calculateTransform(target);
            var geometries = this.geometries;
            for(var i = 0; i < geometries.length; i++){
                if (geometries[i].type !== 'polygon') continue;
                var exterior = geometries[i].exterior;
                var interiors = geometries[i].interiors;
                for(var p = 0; p < exterior.length; p++)(0, parcelRequire("eLEew")).applyTransform(exterior[p], exterior[p], transform);
                for(var h = 0; h < (interiors ? interiors.length : 0); h++)for(var p = 0; p < interiors[h].length; p++)(0, parcelRequire("eLEew")).applyTransform(interiors[h][p], interiors[h][p], transform);
            }
            rect = this._rect;
            rect.copy(target);
            this._center = [
                rect.x + rect.width / 2,
                rect.y + rect.height / 2
            ];
        };
        GeoJSONRegion.prototype.cloneShallow = function(name) {
            name == null && (name = this.name);
            var newRegion = new GeoJSONRegion(name, this.geometries, this._center);
            newRegion._rect = this._rect;
            newRegion.transformTo = null;
            return newRegion;
        };
        GeoJSONRegion.prototype.getCenter = function() {
            return this._center;
        };
        GeoJSONRegion.prototype.setCenter = function(center) {
            this._center = center;
        };
        return GeoJSONRegion;
    }($81c9361a69c93c5f$export$b1f97c3099fc6872);
    var $81c9361a69c93c5f$export$5f3d89e7254f3e69 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(GeoSVGRegion, _super);
        function GeoSVGRegion(name, elOnlyForCalculate) {
            var _this = _super.call(this, name) || this;
            _this.type = 'geoSVG';
            _this._elOnlyForCalculate = elOnlyForCalculate;
            return _this;
        }
        GeoSVGRegion.prototype.getCenter = function() {
            var center = this._center;
            if (!center) center = this._center = this._calculateCenter();
            return center;
        };
        GeoSVGRegion.prototype._calculateCenter = function() {
            var el = this._elOnlyForCalculate;
            var rect = el.getBoundingRect();
            var center = [
                rect.x + rect.width / 2,
                rect.y + rect.height / 2
            ];
            var mat = (0, parcelRequire("izqgC")).identity($81c9361a69c93c5f$var$TMP_TRANSFORM);
            var target = el;
            while(target && !target.isGeoSVGGraphicRoot){
                (0, parcelRequire("izqgC")).mul(mat, target.getLocalTransform(), mat);
                target = target.parent;
            }
            (0, parcelRequire("izqgC")).invert(mat, mat);
            (0, parcelRequire("eLEew")).applyTransform(center, center, mat);
            return center;
        };
        return GeoSVGRegion;
    }($81c9361a69c93c5f$export$b1f97c3099fc6872);
});
parcelRegister("hjZ9y", function(module, exports) {
    $parcel$export(module.exports, "contain", ()=>$c9c3a5bccc65a1b5$export$8893e2b90ba10d92);
    var $3Ytji;
    var $c9c3a5bccc65a1b5$var$EPSILON = 1e-8;
    function $c9c3a5bccc65a1b5$var$isAroundEqual(a, b) {
        return Math.abs(a - b) < $c9c3a5bccc65a1b5$var$EPSILON;
    }
    function $c9c3a5bccc65a1b5$export$8893e2b90ba10d92(points, x, y) {
        var w = 0;
        var p = points[0];
        if (!p) return false;
        for(var i = 1; i < points.length; i++){
            var p2 = points[i];
            w += (0, (0, parcelRequire("3Ytji")).default)(p[0], p[1], p2[0], p2[1], x, y);
            p = p2;
        }
        var p0 = points[0];
        if (!$c9c3a5bccc65a1b5$var$isAroundEqual(p[0], p0[0]) || !$c9c3a5bccc65a1b5$var$isAroundEqual(p[1], p0[1])) w += (0, (0, parcelRequire("3Ytji")).default)(p[0], p[1], p0[0], p0[1], x, y);
        return w !== 0;
    }
});
parcelRegister("2iWFB", function(module, exports) {
    $parcel$export(module.exports, "GeoJSONResource", ()=>$1adac5d85fe37b79$export$859cf85c67f2df51);
    var $bahqM;
    var $gyzY7;
    var $eEvpA;
    var $5i7yG;
    var $huNXv;
    var $ducHh;
    var $1E3E8;
    var $1adac5d85fe37b79$var$DEFAULT_NAME_PROPERTY = 'name';
    var $1adac5d85fe37b79$export$859cf85c67f2df51 = function() {
        function GeoJSONResource(mapName, geoJSON, specialAreas) {
            this.type = 'geoJSON';
            this._parsedMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
            this._mapName = mapName;
            this._specialAreas = specialAreas;
            this._geoJSON = $1adac5d85fe37b79$var$parseInput(geoJSON);
        }
        GeoJSONResource.prototype.load = function(nameMap, nameProperty) {
            nameProperty = nameProperty || $1adac5d85fe37b79$var$DEFAULT_NAME_PROPERTY;
            var parsed = this._parsedMap.get(nameProperty);
            if (!parsed) {
                var rawRegions = this._parseToRegions(nameProperty);
                parsed = this._parsedMap.set(nameProperty, {
                    regions: rawRegions,
                    boundingRect: $1adac5d85fe37b79$var$calculateBoundingRect(rawRegions)
                });
            }
            var regionsMap = (0, (0, parcelRequire("bahqM")).createHashMap)();
            var finalRegions = [];
            (0, (0, parcelRequire("bahqM")).each)(parsed.regions, function(region) {
                var regionName = region.name;
                if (nameMap && nameMap.hasOwnProperty(regionName)) region = region.cloneShallow(regionName = nameMap[regionName]);
                finalRegions.push(region);
                regionsMap.set(regionName, region);
            });
            return {
                regions: finalRegions,
                boundingRect: parsed.boundingRect || new (0, (0, parcelRequire("1E3E8")).default)(0, 0, 0, 0),
                regionsMap: regionsMap
            };
        };
        GeoJSONResource.prototype._parseToRegions = function(nameProperty) {
            var mapName = this._mapName;
            var geoJSON = this._geoJSON;
            var rawRegions;
            try {
                rawRegions = geoJSON ? (0, (0, parcelRequire("gyzY7")).default)(geoJSON, nameProperty) : [];
            } catch (e) {
                throw new Error('Invalid geoJson format\n' + e.message);
            }
            (0, (0, parcelRequire("eEvpA")).default)(mapName, rawRegions);
            (0, (0, parcelRequire("bahqM")).each)(rawRegions, function(region) {
                var regionName = region.name;
                (0, (0, parcelRequire("5i7yG")).default)(mapName, region);
                (0, (0, parcelRequire("huNXv")).default)(mapName, region);
                (0, (0, parcelRequire("ducHh")).default)(mapName, region);
                var specialArea = this._specialAreas && this._specialAreas[regionName];
                if (specialArea) region.transformTo(specialArea.left, specialArea.top, specialArea.width, specialArea.height);
            }, this);
            return rawRegions;
        };
        GeoJSONResource.prototype.getMapForUser = function() {
            return {
                geoJson: this._geoJSON,
                geoJSON: this._geoJSON,
                specialAreas: this._specialAreas
            };
        };
        return GeoJSONResource;
    }();
    function $1adac5d85fe37b79$var$calculateBoundingRect(regions) {
        var rect;
        for(var i = 0; i < regions.length; i++){
            var regionRect = regions[i].getBoundingRect();
            rect = rect || regionRect.clone();
            rect.union(regionRect);
        }
        return rect;
    }
    function $1adac5d85fe37b79$var$parseInput(source) {
        return !(0, (0, parcelRequire("bahqM")).isString)(source) ? source : typeof JSON !== 'undefined' && JSON.parse ? JSON.parse(source) : new Function('return (' + source + ');')();
    }
});
parcelRegister("gyzY7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0dbb8f34f2c3106$export$2e2bcd8739ae039);
    var $bahqM;
    var $b8QyH;
    function $c0dbb8f34f2c3106$var$decode(json) {
        if (!json.UTF8Encoding) return json;
        var jsonCompressed = json;
        var encodeScale = jsonCompressed.UTF8Scale;
        if (encodeScale == null) encodeScale = 1024;
        var features = jsonCompressed.features;
        for(var f = 0; f < features.length; f++){
            var feature = features[f];
            var geometry = feature.geometry;
            if (geometry.type === 'Polygon') {
                var coordinates = geometry.coordinates;
                for(var c = 0; c < coordinates.length; c++)coordinates[c] = $c0dbb8f34f2c3106$var$decodePolygon(coordinates[c], geometry.encodeOffsets[c], encodeScale);
            } else if (geometry.type === 'MultiPolygon') {
                var coordinates = geometry.coordinates;
                for(var c = 0; c < coordinates.length; c++){
                    var coordinate = coordinates[c];
                    for(var c2 = 0; c2 < coordinate.length; c2++)coordinate[c2] = $c0dbb8f34f2c3106$var$decodePolygon(coordinate[c2], geometry.encodeOffsets[c][c2], encodeScale);
                }
            }
        }
        jsonCompressed.UTF8Encoding = false;
        return jsonCompressed;
    }
    function $c0dbb8f34f2c3106$var$decodePolygon(coordinate, encodeOffsets, encodeScale) {
        var result = [];
        var prevX = encodeOffsets[0];
        var prevY = encodeOffsets[1];
        for(var i = 0; i < coordinate.length; i += 2){
            var x = coordinate.charCodeAt(i) - 64;
            var y = coordinate.charCodeAt(i + 1) - 64;
            x = x >> 1 ^ -(x & 1);
            y = y >> 1 ^ -(y & 1);
            x += prevX;
            y += prevY;
            prevX = x;
            prevY = y;
            result.push([
                x / encodeScale,
                y / encodeScale
            ]);
        }
        return result;
    }
    function $c0dbb8f34f2c3106$export$2e2bcd8739ae039(geoJson, nameProperty) {
        geoJson = $c0dbb8f34f2c3106$var$decode(geoJson);
        return (0, parcelRequire("bahqM")).map((0, parcelRequire("bahqM")).filter(geoJson.features, function(featureObj) {
            return featureObj.geometry && featureObj.properties && featureObj.geometry.coordinates.length > 0;
        }), function(featureObj) {
            var properties = featureObj.properties;
            var geo = featureObj.geometry;
            var geometries = [];
            if (geo.type === 'Polygon') {
                var coordinates = geo.coordinates;
                geometries.push({
                    type: 'polygon',
                    exterior: coordinates[0],
                    interiors: coordinates.slice(1)
                });
            }
            if (geo.type === 'MultiPolygon') {
                var coordinates = geo.coordinates;
                (0, parcelRequire("bahqM")).each(coordinates, function(item) {
                    if (item[0]) geometries.push({
                        type: 'polygon',
                        exterior: item[0],
                        interiors: item.slice(1)
                    });
                });
            }
            var region = new (0, (0, parcelRequire("b8QyH")).GeoJSONRegion)(properties[nameProperty || 'name'], geometries, properties.cp);
            region.properties = properties;
            return region;
        });
    }
});
parcelRegister("eEvpA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aaad2ad12dd4ec6c$export$2e2bcd8739ae039);
    var $bahqM;
    var $b8QyH;
    var $aaad2ad12dd4ec6c$var$geoCoord = [
        126,
        25
    ];
    var $aaad2ad12dd4ec6c$var$nanhaiName = "\u5357\u6D77\u8BF8\u5C9B";
    var $aaad2ad12dd4ec6c$var$points = [
        [
            [
                0,
                3.5
            ],
            [
                7,
                11.2
            ],
            [
                15,
                11.9
            ],
            [
                30,
                7
            ],
            [
                42,
                0.7
            ],
            [
                52,
                0.7
            ],
            [
                56,
                7.7
            ],
            [
                59,
                0.7
            ],
            [
                64,
                0.7
            ],
            [
                64,
                0
            ],
            [
                5,
                0
            ],
            [
                0,
                3.5
            ]
        ],
        [
            [
                13,
                16.1
            ],
            [
                19,
                14.7
            ],
            [
                16,
                21.7
            ],
            [
                11,
                23.1
            ],
            [
                13,
                16.1
            ]
        ],
        [
            [
                12,
                32.2
            ],
            [
                14,
                38.5
            ],
            [
                15,
                38.5
            ],
            [
                13,
                32.2
            ],
            [
                12,
                32.2
            ]
        ],
        [
            [
                16,
                47.6
            ],
            [
                12,
                53.2
            ],
            [
                13,
                53.2
            ],
            [
                18,
                47.6
            ],
            [
                16,
                47.6
            ]
        ],
        [
            [
                6,
                64.4
            ],
            [
                8,
                70
            ],
            [
                9,
                70
            ],
            [
                8,
                64.4
            ],
            [
                6,
                64.4
            ]
        ],
        [
            [
                23,
                82.6
            ],
            [
                29,
                79.8
            ],
            [
                30,
                79.8
            ],
            [
                25,
                82.6
            ],
            [
                23,
                82.6
            ]
        ],
        [
            [
                37,
                70.7
            ],
            [
                43,
                62.3
            ],
            [
                44,
                62.3
            ],
            [
                39,
                70.7
            ],
            [
                37,
                70.7
            ]
        ],
        [
            [
                48,
                51.1
            ],
            [
                51,
                45.5
            ],
            [
                53,
                45.5
            ],
            [
                50,
                51.1
            ],
            [
                48,
                51.1
            ]
        ],
        [
            [
                51,
                35
            ],
            [
                51,
                28.7
            ],
            [
                53,
                28.7
            ],
            [
                53,
                35
            ],
            [
                51,
                35
            ]
        ],
        [
            [
                52,
                22.4
            ],
            [
                55,
                17.5
            ],
            [
                56,
                17.5
            ],
            [
                53,
                22.4
            ],
            [
                52,
                22.4
            ]
        ],
        [
            [
                58,
                12.6
            ],
            [
                62,
                7
            ],
            [
                63,
                7
            ],
            [
                60,
                12.6
            ],
            [
                58,
                12.6
            ]
        ],
        [
            [
                0,
                3.5
            ],
            [
                0,
                93.1
            ],
            [
                64,
                93.1
            ],
            [
                64,
                0
            ],
            [
                63,
                0
            ],
            [
                63,
                92.4
            ],
            [
                1,
                92.4
            ],
            [
                1,
                3.5
            ],
            [
                0,
                3.5
            ]
        ]
    ];
    for(var $aaad2ad12dd4ec6c$var$i = 0; $aaad2ad12dd4ec6c$var$i < $aaad2ad12dd4ec6c$var$points.length; $aaad2ad12dd4ec6c$var$i++)for(var $aaad2ad12dd4ec6c$var$k = 0; $aaad2ad12dd4ec6c$var$k < $aaad2ad12dd4ec6c$var$points[$aaad2ad12dd4ec6c$var$i].length; $aaad2ad12dd4ec6c$var$k++){
        $aaad2ad12dd4ec6c$var$points[$aaad2ad12dd4ec6c$var$i][$aaad2ad12dd4ec6c$var$k][0] /= 10.5;
        $aaad2ad12dd4ec6c$var$points[$aaad2ad12dd4ec6c$var$i][$aaad2ad12dd4ec6c$var$k][1] /= -14;
        $aaad2ad12dd4ec6c$var$points[$aaad2ad12dd4ec6c$var$i][$aaad2ad12dd4ec6c$var$k][0] += $aaad2ad12dd4ec6c$var$geoCoord[0];
        $aaad2ad12dd4ec6c$var$points[$aaad2ad12dd4ec6c$var$i][$aaad2ad12dd4ec6c$var$k][1] += $aaad2ad12dd4ec6c$var$geoCoord[1];
    }
    function $aaad2ad12dd4ec6c$export$2e2bcd8739ae039(mapType, regions) {
        if (mapType === 'china') {
            for(var i = 0; i < regions.length; i++){
                if (regions[i].name === $aaad2ad12dd4ec6c$var$nanhaiName) return;
            }
            regions.push(new (0, (0, parcelRequire("b8QyH")).GeoJSONRegion)($aaad2ad12dd4ec6c$var$nanhaiName, (0, parcelRequire("bahqM")).map($aaad2ad12dd4ec6c$var$points, function(exterior) {
                return {
                    type: 'polygon',
                    exterior: exterior
                };
            }), $aaad2ad12dd4ec6c$var$geoCoord));
        }
    }
});
parcelRegister("5i7yG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3da47f1dbbeac6bc$export$2e2bcd8739ae039);
    var $3da47f1dbbeac6bc$var$coordsOffsetMap = {
        "\u5357\u6D77\u8BF8\u5C9B": [
            32,
            80
        ],
        "\u5E7F\u4E1C": [
            0,
            -10
        ],
        "\u9999\u6E2F": [
            10,
            5
        ],
        "\u6FB3\u95E8": [
            -10,
            10
        ],
        "\u5929\u6D25": [
            5,
            5
        ]
    };
    function $3da47f1dbbeac6bc$export$2e2bcd8739ae039(mapType, region) {
        if (mapType === 'china') {
            var coordFix = $3da47f1dbbeac6bc$var$coordsOffsetMap[region.name];
            if (coordFix) {
                var cp = region.getCenter();
                cp[0] += coordFix[0] / 10.5;
                cp[1] += -coordFix[1] / 14;
                region.setCenter(cp);
            }
        }
    }
});
parcelRegister("huNXv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cbcbfdc69414efb9$export$2e2bcd8739ae039);
    var $cbcbfdc69414efb9$var$geoCoordMap = {
        'Russia': [
            100,
            60
        ],
        'United States': [
            -99,
            38
        ],
        'United States of America': [
            -99,
            38
        ]
    };
    function $cbcbfdc69414efb9$export$2e2bcd8739ae039(mapType, region) {
        if (mapType === 'world') {
            var geoCoord = $cbcbfdc69414efb9$var$geoCoordMap[region.name];
            if (geoCoord) {
                var cp = [
                    geoCoord[0],
                    geoCoord[1]
                ];
                region.setCenter(cp);
            }
        }
    }
});
parcelRegister("ducHh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9d17ed1a4c54aaef$export$2e2bcd8739ae039);
    var $9d17ed1a4c54aaef$var$points = [
        [
            [
                123.45165252685547,
                25.73527164402261
            ],
            [
                123.49731445312499,
                25.73527164402261
            ],
            [
                123.49731445312499,
                25.750734064600884
            ],
            [
                123.45165252685547,
                25.750734064600884
            ],
            [
                123.45165252685547,
                25.73527164402261
            ]
        ]
    ];
    function $9d17ed1a4c54aaef$export$2e2bcd8739ae039(mapType, region) {
        if (mapType === 'china' && region.name === "\u53F0\u6E7E") region.geometries.push({
            type: 'polygon',
            exterior: $9d17ed1a4c54aaef$var$points[0]
        });
    }
});
parcelRegister("8cCW2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5f8da56db6246248$export$2e2bcd8739ae039);
    var $bRKv5;
    var $5f8da56db6246248$var$lifecycle = new (0, (0, parcelRequire("bRKv5")).default)();
    var $5f8da56db6246248$export$2e2bcd8739ae039 = $5f8da56db6246248$var$lifecycle;
});
parcelRegister("ixV1I", function(module, exports) {
    var $jtdCU;
    $parcel$exportWildcard(module.exports, (0, parcelRequire("jtdCU")));
});
parcelRegister("jtdCU", function(module, exports) {
    var $8pqpA;
    var $a7GWb;
    var $alpND;
    var $fKViU;
    (0, (0, parcelRequire("alpND")).use)((0, (0, parcelRequire("fKViU")).installLabelLayout));
    $parcel$exportWildcard(module.exports, (0, parcelRequire("8pqpA")));
    $parcel$exportWildcard(module.exports, (0, parcelRequire("a7GWb")));
});
parcelRegister("a7GWb", function(module, exports) {
    $parcel$export(module.exports, "extendComponentModel", ()=>$75ebdd55a0204a2b$export$4dd01020bb736662);
    $parcel$export(module.exports, "extendComponentView", ()=>$75ebdd55a0204a2b$export$a4336148da8ef02);
    $parcel$export(module.exports, "extendSeriesModel", ()=>$75ebdd55a0204a2b$export$fe6d3114e3fc260c);
    $parcel$export(module.exports, "extendChartView", ()=>$75ebdd55a0204a2b$export$c750883d1b603e83);
    $parcel$export(module.exports, "zrender", ()=>(parcelRequire("9Y5KT")));
    $parcel$export(module.exports, "matrix", ()=>(parcelRequire("izqgC")));
    $parcel$export(module.exports, "vector", ()=>(parcelRequire("eLEew")));
    $parcel$export(module.exports, "zrUtil", ()=>(parcelRequire("bahqM")));
    $parcel$export(module.exports, "color", ()=>(parcelRequire("d6udH")));
    $parcel$export(module.exports, "throttle", ()=>(parcelRequire("ljaBy")).throttle);
    $parcel$export(module.exports, "helper", ()=>(parcelRequire("anaTl")));
    $parcel$export(module.exports, "use", ()=>(parcelRequire("alpND")).use);
    $parcel$export(module.exports, "parseGeoJSON", ()=>(parcelRequire("gyzY7")).default);
    $parcel$export(module.exports, "parseGeoJson", ()=>(parcelRequire("gyzY7")).default);
    $parcel$export(module.exports, "number", ()=>(parcelRequire("hJg2M")));
    $parcel$export(module.exports, "time", ()=>(parcelRequire("ats4w")));
    $parcel$export(module.exports, "graphic", ()=>(parcelRequire("fwli1")));
    $parcel$export(module.exports, "format", ()=>(parcelRequire("byxPd")));
    $parcel$export(module.exports, "util", ()=>(parcelRequire("fvUv7")));
    $parcel$export(module.exports, "env", ()=>(parcelRequire("hZfwb")).default);
    $parcel$export(module.exports, "List", ()=>(parcelRequire("liBXN")).default);
    $parcel$export(module.exports, "Model", ()=>(parcelRequire("gaMkj")).default);
    $parcel$export(module.exports, "Axis", ()=>(parcelRequire("g6Gq1")).default);
    $parcel$export(module.exports, "ComponentModel", ()=>(parcelRequire("h4UlH")).default);
    $parcel$export(module.exports, "ComponentView", ()=>(parcelRequire("fkskt")).default);
    $parcel$export(module.exports, "SeriesModel", ()=>(parcelRequire("1O7Ua")).default);
    $parcel$export(module.exports, "ChartView", ()=>(parcelRequire("loerw")).default);
    $parcel$export(module.exports, "innerDrawElementOnCanvas", ()=>(parcelRequire("aSzOj")).brushSingle);
    var $h4UlH;
    var $fkskt;
    var $1O7Ua;
    var $loerw;
    var $liBXN;
    var $9Y5KT;
    var $izqgC;
    var $eLEew;
    var $bahqM;
    var $d6udH;
    var $ljaBy;
    var $anaTl;
    var $alpND;
    var $gyzY7;
    var $hJg2M;
    var $ats4w;
    var $fwli1;
    var $byxPd;
    var $fvUv7;
    var $hZfwb;
    var $gaMkj;
    var $g6Gq1;
    var $aSzOj;
    function $75ebdd55a0204a2b$export$4dd01020bb736662(proto) {
        var Model = (0, (0, parcelRequire("h4UlH")).default).extend(proto);
        (0, (0, parcelRequire("h4UlH")).default).registerClass(Model);
        return Model;
    }
    function $75ebdd55a0204a2b$export$a4336148da8ef02(proto) {
        var View = (0, (0, parcelRequire("fkskt")).default).extend(proto);
        (0, (0, parcelRequire("fkskt")).default).registerClass(View);
        return View;
    }
    function $75ebdd55a0204a2b$export$fe6d3114e3fc260c(proto) {
        var Model = (0, (0, parcelRequire("1O7Ua")).default).extend(proto);
        (0, (0, parcelRequire("1O7Ua")).default).registerClass(Model);
        return Model;
    }
    function $75ebdd55a0204a2b$export$c750883d1b603e83(proto) {
        var View = (0, (0, parcelRequire("loerw")).default).extend(proto);
        (0, (0, parcelRequire("loerw")).default).registerClass(View);
        return View;
    }
});
parcelRegister("anaTl", function(module, exports) {
    $parcel$export(module.exports, "createList", ()=>$78d480381111bb0c$export$5897d8d7c7a3d871);
    $parcel$export(module.exports, "dataStack", ()=>$78d480381111bb0c$export$d6100971d5a3a0a7);
    $parcel$export(module.exports, "createScale", ()=>$78d480381111bb0c$export$587d9c3c553380c6);
    $parcel$export(module.exports, "mixinAxisModelCommonMethods", ()=>$78d480381111bb0c$export$4665cbe3470e4d57);
    $parcel$export(module.exports, "createTextStyle", ()=>$78d480381111bb0c$export$f8998c3d0a13de59);
    $parcel$export(module.exports, "getLayoutRect", ()=>(parcelRequire("65MS1")).getLayoutRect);
    $parcel$export(module.exports, "createDimensions", ()=>(parcelRequire("h9jiS")).createDimensions);
    $parcel$export(module.exports, "createSymbol", ()=>(parcelRequire("7yklO")).createSymbol);
    $parcel$export(module.exports, "getECData", ()=>(parcelRequire("7QjoM")).getECData);
    $parcel$export(module.exports, "enableHoverEmphasis", ()=>(parcelRequire("fIXXx")).enableHoverEmphasis);
    var $bahqM;
    var $bAY5l;
    var $3GIoT;
    var $5pBRm;
    var $gaMkj;
    var $65MS1;
    var $5R8Hi;
    var $7QjoM;
    var $gvLUt;
    var $h9jiS;
    var $7yklO;
    var $fIXXx;
    function $78d480381111bb0c$export$5897d8d7c7a3d871(seriesModel) {
        return (0, (0, parcelRequire("bAY5l")).default)(null, seriesModel);
    }
    var $78d480381111bb0c$export$d6100971d5a3a0a7 = {
        isDimensionStacked: (0, (0, parcelRequire("5R8Hi")).isDimensionStacked),
        enableDataStack: (0, (0, parcelRequire("5R8Hi")).enableDataStack),
        getStackedDimension: (0, (0, parcelRequire("5R8Hi")).getStackedDimension)
    };
    function $78d480381111bb0c$export$587d9c3c553380c6(dataExtent, option) {
        var axisModel = option;
        if (!(option instanceof (0, (0, parcelRequire("gaMkj")).default))) axisModel = new (0, (0, parcelRequire("gaMkj")).default)(option);
        var scale = (0, parcelRequire("3GIoT")).createScaleByModel(axisModel);
        scale.setExtent(dataExtent[0], dataExtent[1]);
        (0, parcelRequire("3GIoT")).niceScaleExtent(scale, axisModel);
        return scale;
    }
    function $78d480381111bb0c$export$4665cbe3470e4d57(Model) {
        (0, parcelRequire("bahqM")).mixin(Model, (0, (0, parcelRequire("5pBRm")).AxisModelCommonMixin));
    }
    function $78d480381111bb0c$export$f8998c3d0a13de59(textStyleModel, opts) {
        opts = opts || {};
        return (0, (0, parcelRequire("gvLUt")).createTextStyle)(textStyleModel, null, null, opts.state !== 'normal');
    }
});
parcelRegister("hJg2M", function(module, exports) {
    $parcel$export(module.exports, "linearMap", ()=>(parcelRequire("jmSNG")).linearMap);
    $parcel$export(module.exports, "round", ()=>(parcelRequire("jmSNG")).round);
    $parcel$export(module.exports, "asc", ()=>(parcelRequire("jmSNG")).asc);
    $parcel$export(module.exports, "getPrecision", ()=>(parcelRequire("jmSNG")).getPrecision);
    $parcel$export(module.exports, "getPrecisionSafe", ()=>(parcelRequire("jmSNG")).getPrecisionSafe);
    $parcel$export(module.exports, "getPixelPrecision", ()=>(parcelRequire("jmSNG")).getPixelPrecision);
    $parcel$export(module.exports, "getPercentWithPrecision", ()=>(parcelRequire("jmSNG")).getPercentWithPrecision);
    $parcel$export(module.exports, "MAX_SAFE_INTEGER", ()=>(parcelRequire("jmSNG")).MAX_SAFE_INTEGER);
    $parcel$export(module.exports, "remRadian", ()=>(parcelRequire("jmSNG")).remRadian);
    $parcel$export(module.exports, "isRadianAroundZero", ()=>(parcelRequire("jmSNG")).isRadianAroundZero);
    $parcel$export(module.exports, "parseDate", ()=>(parcelRequire("jmSNG")).parseDate);
    $parcel$export(module.exports, "quantity", ()=>(parcelRequire("jmSNG")).quantity);
    $parcel$export(module.exports, "quantityExponent", ()=>(parcelRequire("jmSNG")).quantityExponent);
    $parcel$export(module.exports, "nice", ()=>(parcelRequire("jmSNG")).nice);
    $parcel$export(module.exports, "quantile", ()=>(parcelRequire("jmSNG")).quantile);
    $parcel$export(module.exports, "reformIntervals", ()=>(parcelRequire("jmSNG")).reformIntervals);
    $parcel$export(module.exports, "isNumeric", ()=>(parcelRequire("jmSNG")).isNumeric);
    $parcel$export(module.exports, "numericToNumber", ()=>(parcelRequire("jmSNG")).numericToNumber);
    var $jmSNG;
});
parcelRegister("ats4w", function(module, exports) {
    $parcel$export(module.exports, "parse", ()=>(parcelRequire("jmSNG")).parseDate);
    $parcel$export(module.exports, "format", ()=>(parcelRequire("bc1Ad")).format);
    var $jmSNG;
    var $bc1Ad;
});
parcelRegister("fwli1", function(module, exports) {
    $parcel$export(module.exports, "extendShape", ()=>(parcelRequire("fHITF")).extendShape);
    $parcel$export(module.exports, "extendPath", ()=>(parcelRequire("fHITF")).extendPath);
    $parcel$export(module.exports, "makePath", ()=>(parcelRequire("fHITF")).makePath);
    $parcel$export(module.exports, "makeImage", ()=>(parcelRequire("fHITF")).makeImage);
    $parcel$export(module.exports, "mergePath", ()=>(parcelRequire("fHITF")).mergePath);
    $parcel$export(module.exports, "resizePath", ()=>(parcelRequire("fHITF")).resizePath);
    $parcel$export(module.exports, "createIcon", ()=>(parcelRequire("fHITF")).createIcon);
    $parcel$export(module.exports, "updateProps", ()=>(parcelRequire("eYgMC")).updateProps);
    $parcel$export(module.exports, "initProps", ()=>(parcelRequire("eYgMC")).initProps);
    $parcel$export(module.exports, "getTransform", ()=>(parcelRequire("fHITF")).getTransform);
    $parcel$export(module.exports, "clipPointsByRect", ()=>(parcelRequire("fHITF")).clipPointsByRect);
    $parcel$export(module.exports, "clipRectByRect", ()=>(parcelRequire("fHITF")).clipRectByRect);
    $parcel$export(module.exports, "registerShape", ()=>(parcelRequire("fHITF")).registerShape);
    $parcel$export(module.exports, "getShapeClass", ()=>(parcelRequire("fHITF")).getShapeClass);
    $parcel$export(module.exports, "Group", ()=>(parcelRequire("4KVOr")).default);
    $parcel$export(module.exports, "Image", ()=>(parcelRequire("gcbBH")).default);
    $parcel$export(module.exports, "Text", ()=>(parcelRequire("4gEFv")).default);
    $parcel$export(module.exports, "Circle", ()=>(parcelRequire("jjfok")).default);
    $parcel$export(module.exports, "Ellipse", ()=>(parcelRequire("kVeV8")).default);
    $parcel$export(module.exports, "Sector", ()=>(parcelRequire("elGBV")).default);
    $parcel$export(module.exports, "Ring", ()=>(parcelRequire("LCHOw")).default);
    $parcel$export(module.exports, "Polygon", ()=>(parcelRequire("lQwBc")).default);
    $parcel$export(module.exports, "Polyline", ()=>(parcelRequire("32bXc")).default);
    $parcel$export(module.exports, "Rect", ()=>(parcelRequire("7Tw7u")).default);
    $parcel$export(module.exports, "Line", ()=>(parcelRequire("cZb1F")).default);
    $parcel$export(module.exports, "BezierCurve", ()=>(parcelRequire("04gw0")).default);
    $parcel$export(module.exports, "Arc", ()=>(parcelRequire("ixXaU")).default);
    $parcel$export(module.exports, "IncrementalDisplayable", ()=>(parcelRequire("6sllV")).default);
    $parcel$export(module.exports, "CompoundPath", ()=>(parcelRequire("eGltS")).default);
    $parcel$export(module.exports, "LinearGradient", ()=>(parcelRequire("9J7f8")).default);
    $parcel$export(module.exports, "RadialGradient", ()=>(parcelRequire("faICo")).default);
    $parcel$export(module.exports, "BoundingRect", ()=>(parcelRequire("1E3E8")).default);
    parcelRequire("fHITF");
    var $ixXaU;
    var $04gw0;
    var $jjfok;
    var $fHITF;
    var $kVeV8;
    var $gcbBH;
    var $cZb1F;
    var $lQwBc;
    var $32bXc;
    var $7Tw7u;
    var $LCHOw;
    var $elGBV;
    var $eYgMC;
    var $1E3E8;
    var $eGltS;
    var $4KVOr;
    var $6sllV;
    var $eYgMC;
    var $9J7f8;
    var $faICo;
    var $4gEFv;
});
parcelRegister("byxPd", function(module, exports) {
    $parcel$export(module.exports, "addCommas", ()=>(parcelRequire("dCJrM")).addCommas);
    $parcel$export(module.exports, "toCamelCase", ()=>(parcelRequire("dCJrM")).toCamelCase);
    $parcel$export(module.exports, "normalizeCssArray", ()=>(parcelRequire("dCJrM")).normalizeCssArray);
    $parcel$export(module.exports, "encodeHTML", ()=>(parcelRequire("dCJrM")).encodeHTML);
    $parcel$export(module.exports, "formatTpl", ()=>(parcelRequire("dCJrM")).formatTpl);
    $parcel$export(module.exports, "getTooltipMarker", ()=>(parcelRequire("dCJrM")).getTooltipMarker);
    $parcel$export(module.exports, "formatTime", ()=>(parcelRequire("dCJrM")).formatTime);
    $parcel$export(module.exports, "capitalFirst", ()=>(parcelRequire("dCJrM")).capitalFirst);
    $parcel$export(module.exports, "truncateText", ()=>(parcelRequire("h6fMM")).truncateText);
    $parcel$export(module.exports, "getTextRect", ()=>(parcelRequire("2emZ2")).getTextRect);
    var $dCJrM;
    var $2emZ2;
    var $h6fMM;
});
parcelRegister("fvUv7", function(module, exports) {
    $parcel$export(module.exports, "map", ()=>(parcelRequire("bahqM")).map);
    $parcel$export(module.exports, "each", ()=>(parcelRequire("bahqM")).each);
    $parcel$export(module.exports, "indexOf", ()=>(parcelRequire("bahqM")).indexOf);
    $parcel$export(module.exports, "inherits", ()=>(parcelRequire("bahqM")).inherits);
    $parcel$export(module.exports, "reduce", ()=>(parcelRequire("bahqM")).reduce);
    $parcel$export(module.exports, "filter", ()=>(parcelRequire("bahqM")).filter);
    $parcel$export(module.exports, "bind", ()=>(parcelRequire("bahqM")).bind);
    $parcel$export(module.exports, "curry", ()=>(parcelRequire("bahqM")).curry);
    $parcel$export(module.exports, "isArray", ()=>(parcelRequire("bahqM")).isArray);
    $parcel$export(module.exports, "isString", ()=>(parcelRequire("bahqM")).isString);
    $parcel$export(module.exports, "isObject", ()=>(parcelRequire("bahqM")).isObject);
    $parcel$export(module.exports, "isFunction", ()=>(parcelRequire("bahqM")).isFunction);
    $parcel$export(module.exports, "extend", ()=>(parcelRequire("bahqM")).extend);
    $parcel$export(module.exports, "defaults", ()=>(parcelRequire("bahqM")).defaults);
    $parcel$export(module.exports, "clone", ()=>(parcelRequire("bahqM")).clone);
    $parcel$export(module.exports, "merge", ()=>(parcelRequire("bahqM")).merge);
    var $bahqM;
});
parcelRegister("fKViU", function(module, exports) {
    $parcel$export(module.exports, "installLabelLayout", ()=>$b7879a416965ee89$export$5320d1b3745c02a5);
    var $eaKsF;
    var $JIQqQ;
    var $b7879a416965ee89$var$getLabelManager = (0, (0, parcelRequire("eaKsF")).makeInner)();
    function $b7879a416965ee89$export$5320d1b3745c02a5(registers) {
        registers.registerUpdateLifecycle('series:beforeupdate', function(ecModel, api, params) {
            var labelManager = $b7879a416965ee89$var$getLabelManager(api).labelManager;
            if (!labelManager) labelManager = $b7879a416965ee89$var$getLabelManager(api).labelManager = new (0, (0, parcelRequire("JIQqQ")).default)();
            labelManager.clearLabels();
        });
        registers.registerUpdateLifecycle('series:layoutlabels', function(ecModel, api, params) {
            var labelManager = $b7879a416965ee89$var$getLabelManager(api).labelManager;
            params.updatedSeries.forEach(function(series) {
                labelManager.addLabelsOfSeries(api.getViewOfSeriesModel(series));
            });
            labelManager.updateLayoutConfig(api);
            labelManager.layout(api);
            labelManager.processLabelsOverall();
        });
    }
});
parcelRegister("JIQqQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0896fd4d6c482b72$export$2e2bcd8739ae039);
    var $1E3E8;
    var $eYgMC;
    parcelRequire("fHITF");
    var $eYgMC;
    var $7QjoM;
    var $jmSNG;
    var $e6gef;
    var $fxCHE;
    var $eaKsF;
    var $bahqM;
    var $3LB2b;
    var $gvLUt;
    function $0896fd4d6c482b72$var$cloneArr(points) {
        if (points) {
            var newPoints = [];
            for(var i = 0; i < points.length; i++)newPoints.push(points[i].slice());
            return newPoints;
        }
    }
    function $0896fd4d6c482b72$var$prepareLayoutCallbackParams(labelItem, hostEl) {
        var label = labelItem.label;
        var labelLine = hostEl && hostEl.getTextGuideLine();
        return {
            dataIndex: labelItem.dataIndex,
            dataType: labelItem.dataType,
            seriesIndex: labelItem.seriesModel.seriesIndex,
            text: labelItem.label.style.text,
            rect: labelItem.hostRect,
            labelRect: labelItem.rect,
            align: label.style.align,
            verticalAlign: label.style.verticalAlign,
            labelLinePoints: $0896fd4d6c482b72$var$cloneArr(labelLine && labelLine.shape.points)
        };
    }
    var $0896fd4d6c482b72$var$LABEL_OPTION_TO_STYLE_KEYS = [
        'align',
        'verticalAlign',
        'width',
        'height',
        'fontSize'
    ];
    var $0896fd4d6c482b72$var$dummyTransformable = new (0, (0, parcelRequire("e6gef")).default)();
    var $0896fd4d6c482b72$var$labelLayoutInnerStore = (0, (0, parcelRequire("eaKsF")).makeInner)();
    var $0896fd4d6c482b72$var$labelLineAnimationStore = (0, (0, parcelRequire("eaKsF")).makeInner)();
    function $0896fd4d6c482b72$var$extendWithKeys(target, source, keys) {
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (source[key] != null) target[key] = source[key];
        }
    }
    var $0896fd4d6c482b72$var$LABEL_LAYOUT_PROPS = [
        'x',
        'y',
        'rotation'
    ];
    var $0896fd4d6c482b72$var$LabelManager = function() {
        function LabelManager() {
            this._labelList = [];
            this._chartViewList = [];
        }
        LabelManager.prototype.clearLabels = function() {
            this._labelList = [];
            this._chartViewList = [];
        };
        LabelManager.prototype._addLabel = function(dataIndex, dataType, seriesModel, label, layoutOption) {
            var labelStyle = label.style;
            var hostEl = label.__hostTarget;
            var textConfig = hostEl.textConfig || {};
            var labelTransform = label.getComputedTransform();
            var labelRect = label.getBoundingRect().plain();
            (0, (0, parcelRequire("1E3E8")).default).applyTransform(labelRect, labelRect, labelTransform);
            if (labelTransform) $0896fd4d6c482b72$var$dummyTransformable.setLocalTransform(labelTransform);
            else {
                $0896fd4d6c482b72$var$dummyTransformable.x = $0896fd4d6c482b72$var$dummyTransformable.y = $0896fd4d6c482b72$var$dummyTransformable.rotation = $0896fd4d6c482b72$var$dummyTransformable.originX = $0896fd4d6c482b72$var$dummyTransformable.originY = 0;
                $0896fd4d6c482b72$var$dummyTransformable.scaleX = $0896fd4d6c482b72$var$dummyTransformable.scaleY = 1;
            }
            var host = label.__hostTarget;
            var hostRect;
            if (host) {
                hostRect = host.getBoundingRect().plain();
                var transform = host.getComputedTransform();
                (0, (0, parcelRequire("1E3E8")).default).applyTransform(hostRect, hostRect, transform);
            }
            var labelGuide = hostRect && host.getTextGuideLine();
            this._labelList.push({
                label: label,
                labelLine: labelGuide,
                seriesModel: seriesModel,
                dataIndex: dataIndex,
                dataType: dataType,
                layoutOption: layoutOption,
                computedLayoutOption: null,
                rect: labelRect,
                hostRect: hostRect,
                priority: hostRect ? hostRect.width * hostRect.height : 0,
                defaultAttr: {
                    ignore: label.ignore,
                    labelGuideIgnore: labelGuide && labelGuide.ignore,
                    x: $0896fd4d6c482b72$var$dummyTransformable.x,
                    y: $0896fd4d6c482b72$var$dummyTransformable.y,
                    scaleX: $0896fd4d6c482b72$var$dummyTransformable.scaleX,
                    scaleY: $0896fd4d6c482b72$var$dummyTransformable.scaleY,
                    rotation: $0896fd4d6c482b72$var$dummyTransformable.rotation,
                    style: {
                        x: labelStyle.x,
                        y: labelStyle.y,
                        align: labelStyle.align,
                        verticalAlign: labelStyle.verticalAlign,
                        width: labelStyle.width,
                        height: labelStyle.height,
                        fontSize: labelStyle.fontSize
                    },
                    cursor: label.cursor,
                    attachedPos: textConfig.position,
                    attachedRot: textConfig.rotation
                }
            });
        };
        LabelManager.prototype.addLabelsOfSeries = function(chartView) {
            var _this = this;
            this._chartViewList.push(chartView);
            var seriesModel = chartView.__model;
            var layoutOption = seriesModel.get('labelLayout');
            if (!((0, (0, parcelRequire("bahqM")).isFunction)(layoutOption) || (0, (0, parcelRequire("bahqM")).keys)(layoutOption).length)) return;
            chartView.group.traverse(function(child) {
                if (child.ignore) return true;
                var textEl = child.getTextContent();
                var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(child);
                if (textEl && !textEl.disableLabelLayout) _this._addLabel(ecData.dataIndex, ecData.dataType, seriesModel, textEl, layoutOption);
            });
        };
        LabelManager.prototype.updateLayoutConfig = function(api) {
            var width = api.getWidth();
            var height = api.getHeight();
            function createDragHandler(el, labelLineModel) {
                return function() {
                    (0, (0, parcelRequire("fxCHE")).updateLabelLinePoints)(el, labelLineModel);
                };
            }
            for(var i = 0; i < this._labelList.length; i++){
                var labelItem = this._labelList[i];
                var label = labelItem.label;
                var hostEl = label.__hostTarget;
                var defaultLabelAttr = labelItem.defaultAttr;
                var layoutOption = void 0;
                if (typeof labelItem.layoutOption === 'function') layoutOption = labelItem.layoutOption($0896fd4d6c482b72$var$prepareLayoutCallbackParams(labelItem, hostEl));
                else layoutOption = labelItem.layoutOption;
                layoutOption = layoutOption || {};
                labelItem.computedLayoutOption = layoutOption;
                var degreeToRadian = Math.PI / 180;
                if (hostEl) hostEl.setTextConfig({
                    local: false,
                    position: layoutOption.x != null || layoutOption.y != null ? null : defaultLabelAttr.attachedPos,
                    rotation: layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.attachedRot,
                    offset: [
                        layoutOption.dx || 0,
                        layoutOption.dy || 0
                    ]
                });
                var needsUpdateLabelLine = false;
                if (layoutOption.x != null) {
                    label.x = (0, (0, parcelRequire("jmSNG")).parsePercent)(layoutOption.x, width);
                    label.setStyle('x', 0);
                    needsUpdateLabelLine = true;
                } else {
                    label.x = defaultLabelAttr.x;
                    label.setStyle('x', defaultLabelAttr.style.x);
                }
                if (layoutOption.y != null) {
                    label.y = (0, (0, parcelRequire("jmSNG")).parsePercent)(layoutOption.y, height);
                    label.setStyle('y', 0);
                    needsUpdateLabelLine = true;
                } else {
                    label.y = defaultLabelAttr.y;
                    label.setStyle('y', defaultLabelAttr.style.y);
                }
                if (layoutOption.labelLinePoints) {
                    var guideLine = hostEl.getTextGuideLine();
                    if (guideLine) {
                        guideLine.setShape({
                            points: layoutOption.labelLinePoints
                        });
                        needsUpdateLabelLine = false;
                    }
                }
                var labelLayoutStore = $0896fd4d6c482b72$var$labelLayoutInnerStore(label);
                labelLayoutStore.needsUpdateLabelLine = needsUpdateLabelLine;
                label.rotation = layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.rotation;
                label.scaleX = defaultLabelAttr.scaleX;
                label.scaleY = defaultLabelAttr.scaleY;
                for(var k = 0; k < $0896fd4d6c482b72$var$LABEL_OPTION_TO_STYLE_KEYS.length; k++){
                    var key = $0896fd4d6c482b72$var$LABEL_OPTION_TO_STYLE_KEYS[k];
                    label.setStyle(key, layoutOption[key] != null ? layoutOption[key] : defaultLabelAttr.style[key]);
                }
                if (layoutOption.draggable) {
                    label.draggable = true;
                    label.cursor = 'move';
                    if (hostEl) {
                        var hostModel = labelItem.seriesModel;
                        if (labelItem.dataIndex != null) {
                            var data = labelItem.seriesModel.getData(labelItem.dataType);
                            hostModel = data.getItemModel(labelItem.dataIndex);
                        }
                        label.on('drag', createDragHandler(hostEl, hostModel.getModel('labelLine')));
                    }
                } else {
                    label.off('drag');
                    label.cursor = defaultLabelAttr.cursor;
                }
            }
        };
        LabelManager.prototype.layout = function(api) {
            var width = api.getWidth();
            var height = api.getHeight();
            var labelList = (0, (0, parcelRequire("3LB2b")).prepareLayoutList)(this._labelList);
            var labelsNeedsAdjustOnX = (0, (0, parcelRequire("bahqM")).filter)(labelList, function(item) {
                return item.layoutOption.moveOverlap === 'shiftX';
            });
            var labelsNeedsAdjustOnY = (0, (0, parcelRequire("bahqM")).filter)(labelList, function(item) {
                return item.layoutOption.moveOverlap === 'shiftY';
            });
            (0, (0, parcelRequire("3LB2b")).shiftLayoutOnX)(labelsNeedsAdjustOnX, 0, width);
            (0, (0, parcelRequire("3LB2b")).shiftLayoutOnY)(labelsNeedsAdjustOnY, 0, height);
            var labelsNeedsHideOverlap = (0, (0, parcelRequire("bahqM")).filter)(labelList, function(item) {
                return item.layoutOption.hideOverlap;
            });
            (0, (0, parcelRequire("3LB2b")).hideOverlap)(labelsNeedsHideOverlap);
        };
        LabelManager.prototype.processLabelsOverall = function() {
            var _this = this;
            (0, (0, parcelRequire("bahqM")).each)(this._chartViewList, function(chartView) {
                var seriesModel = chartView.__model;
                var ignoreLabelLineUpdate = chartView.ignoreLabelLineUpdate;
                var animationEnabled = seriesModel.isAnimationEnabled();
                chartView.group.traverse(function(child) {
                    if (child.ignore) return true;
                    var needsUpdateLabelLine = !ignoreLabelLineUpdate;
                    var label = child.getTextContent();
                    if (!needsUpdateLabelLine && label) needsUpdateLabelLine = $0896fd4d6c482b72$var$labelLayoutInnerStore(label).needsUpdateLabelLine;
                    if (needsUpdateLabelLine) _this._updateLabelLine(child, seriesModel);
                    if (animationEnabled) _this._animateLabels(child, seriesModel);
                });
            });
        };
        LabelManager.prototype._updateLabelLine = function(el, seriesModel) {
            var textEl = el.getTextContent();
            var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(el);
            var dataIndex = ecData.dataIndex;
            if (textEl && dataIndex != null) {
                var data = seriesModel.getData(ecData.dataType);
                var itemModel = data.getItemModel(dataIndex);
                var defaultStyle = {};
                var visualStyle = data.getItemVisual(dataIndex, 'style');
                var visualType = data.getVisual('drawType');
                defaultStyle.stroke = visualStyle[visualType];
                var labelLineModel = itemModel.getModel('labelLine');
                (0, (0, parcelRequire("fxCHE")).setLabelLineStyle)(el, (0, (0, parcelRequire("fxCHE")).getLabelLineStatesModels)(itemModel), defaultStyle);
                (0, (0, parcelRequire("fxCHE")).updateLabelLinePoints)(el, labelLineModel);
            }
        };
        LabelManager.prototype._animateLabels = function(el, seriesModel) {
            var textEl = el.getTextContent();
            var guideLine = el.getTextGuideLine();
            if (textEl && !textEl.ignore && !textEl.invisible && !el.disableLabelAnimation && !(0, (0, parcelRequire("eYgMC")).isElementRemoved)(el)) {
                var layoutStore = $0896fd4d6c482b72$var$labelLayoutInnerStore(textEl);
                var oldLayout = layoutStore.oldLayout;
                var ecData = (0, (0, parcelRequire("7QjoM")).getECData)(el);
                var dataIndex = ecData.dataIndex;
                var newProps = {
                    x: textEl.x,
                    y: textEl.y,
                    rotation: textEl.rotation
                };
                var data = seriesModel.getData(ecData.dataType);
                if (!oldLayout) {
                    textEl.attr(newProps);
                    if (!(0, (0, parcelRequire("gvLUt")).labelInner)(textEl).valueAnimation) {
                        var oldOpacity = (0, (0, parcelRequire("bahqM")).retrieve2)(textEl.style.opacity, 1);
                        textEl.style.opacity = 0;
                        (0, (0, parcelRequire("eYgMC")).initProps)(textEl, {
                            style: {
                                opacity: oldOpacity
                            }
                        }, seriesModel, dataIndex);
                    }
                } else {
                    textEl.attr(oldLayout);
                    var prevStates = el.prevStates;
                    if (prevStates) {
                        if ((0, (0, parcelRequire("bahqM")).indexOf)(prevStates, 'select') >= 0) textEl.attr(layoutStore.oldLayoutSelect);
                        if ((0, (0, parcelRequire("bahqM")).indexOf)(prevStates, 'emphasis') >= 0) textEl.attr(layoutStore.oldLayoutEmphasis);
                    }
                    (0, (0, parcelRequire("eYgMC")).updateProps)(textEl, newProps, seriesModel, dataIndex);
                }
                layoutStore.oldLayout = newProps;
                if (textEl.states.select) {
                    var layoutSelect = layoutStore.oldLayoutSelect = {};
                    $0896fd4d6c482b72$var$extendWithKeys(layoutSelect, newProps, $0896fd4d6c482b72$var$LABEL_LAYOUT_PROPS);
                    $0896fd4d6c482b72$var$extendWithKeys(layoutSelect, textEl.states.select, $0896fd4d6c482b72$var$LABEL_LAYOUT_PROPS);
                }
                if (textEl.states.emphasis) {
                    var layoutEmphasis = layoutStore.oldLayoutEmphasis = {};
                    $0896fd4d6c482b72$var$extendWithKeys(layoutEmphasis, newProps, $0896fd4d6c482b72$var$LABEL_LAYOUT_PROPS);
                    $0896fd4d6c482b72$var$extendWithKeys(layoutEmphasis, textEl.states.emphasis, $0896fd4d6c482b72$var$LABEL_LAYOUT_PROPS);
                }
                (0, (0, parcelRequire("gvLUt")).animateLabelValue)(textEl, dataIndex, data, seriesModel, seriesModel);
            }
            if (guideLine && !guideLine.ignore && !guideLine.invisible) {
                var layoutStore = $0896fd4d6c482b72$var$labelLineAnimationStore(guideLine);
                var oldLayout = layoutStore.oldLayout;
                var newLayout = {
                    points: guideLine.shape.points
                };
                if (!oldLayout) {
                    guideLine.setShape(newLayout);
                    guideLine.style.strokePercent = 0;
                    (0, (0, parcelRequire("eYgMC")).initProps)(guideLine, {
                        style: {
                            strokePercent: 1
                        }
                    }, seriesModel);
                } else {
                    guideLine.attr({
                        shape: oldLayout
                    });
                    (0, (0, parcelRequire("eYgMC")).updateProps)(guideLine, {
                        shape: newLayout
                    }, seriesModel);
                }
                layoutStore.oldLayout = newLayout;
            }
        };
        return LabelManager;
    }();
    var $0896fd4d6c482b72$export$2e2bcd8739ae039 = $0896fd4d6c482b72$var$LabelManager;
});
parcelRegister("fxCHE", function(module, exports) {
    $parcel$export(module.exports, "updateLabelLinePoints", ()=>$02eb7bb47d256bbb$export$cc93ba643cd97d83);
    $parcel$export(module.exports, "limitTurnAngle", ()=>$02eb7bb47d256bbb$export$ac52062003fbe6a);
    $parcel$export(module.exports, "limitSurfaceAngle", ()=>$02eb7bb47d256bbb$export$973e1fdb2708f71b);
    $parcel$export(module.exports, "setLabelLineStyle", ()=>$02eb7bb47d256bbb$export$c09e0b0574bdd2dc);
    $parcel$export(module.exports, "getLabelLineStatesModels", ()=>$02eb7bb47d256bbb$export$2979fdbf5ebce521);
    parcelRequire("fHITF");
    var $ghQ8v;
    var $32bXc;
    var $bMDnR;
    var $aA4Ws;
    var $kvt3T;
    var $dr1jo;
    var $bahqM;
    var $izqgC;
    var $eLEew;
    var $fIXXx;
    var $02eb7bb47d256bbb$var$PI2 = Math.PI * 2;
    var $02eb7bb47d256bbb$var$CMD = (0, (0, parcelRequire("aA4Ws")).default).CMD;
    var $02eb7bb47d256bbb$var$DEFAULT_SEARCH_SPACE = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    function $02eb7bb47d256bbb$var$getCandidateAnchor(pos, distance, rect, outPt, outDir) {
        var width = rect.width;
        var height = rect.height;
        switch(pos){
            case 'top':
                outPt.set(rect.x + width / 2, rect.y - distance);
                outDir.set(0, -1);
                break;
            case 'bottom':
                outPt.set(rect.x + width / 2, rect.y + height + distance);
                outDir.set(0, 1);
                break;
            case 'left':
                outPt.set(rect.x - distance, rect.y + height / 2);
                outDir.set(-1, 0);
                break;
            case 'right':
                outPt.set(rect.x + width + distance, rect.y + height / 2);
                outDir.set(1, 0);
                break;
        }
    }
    function $02eb7bb47d256bbb$var$projectPointToArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y, out) {
        x -= cx;
        y -= cy;
        var d = Math.sqrt(x * x + y * y);
        x /= d;
        y /= d;
        var ox = x * r + cx;
        var oy = y * r + cy;
        if (Math.abs(startAngle - endAngle) % $02eb7bb47d256bbb$var$PI2 < 1e-4) {
            out[0] = ox;
            out[1] = oy;
            return d - r;
        }
        if (anticlockwise) {
            var tmp = startAngle;
            startAngle = (0, (0, parcelRequire("kvt3T")).normalizeRadian)(endAngle);
            endAngle = (0, (0, parcelRequire("kvt3T")).normalizeRadian)(tmp);
        } else {
            startAngle = (0, (0, parcelRequire("kvt3T")).normalizeRadian)(startAngle);
            endAngle = (0, (0, parcelRequire("kvt3T")).normalizeRadian)(endAngle);
        }
        if (startAngle > endAngle) endAngle += $02eb7bb47d256bbb$var$PI2;
        var angle = Math.atan2(y, x);
        if (angle < 0) angle += $02eb7bb47d256bbb$var$PI2;
        if (angle >= startAngle && angle <= endAngle || angle + $02eb7bb47d256bbb$var$PI2 >= startAngle && angle + $02eb7bb47d256bbb$var$PI2 <= endAngle) {
            out[0] = ox;
            out[1] = oy;
            return d - r;
        }
        var x1 = r * Math.cos(startAngle) + cx;
        var y1 = r * Math.sin(startAngle) + cy;
        var x2 = r * Math.cos(endAngle) + cx;
        var y2 = r * Math.sin(endAngle) + cy;
        var d1 = (x1 - x) * (x1 - x) + (y1 - y) * (y1 - y);
        var d2 = (x2 - x) * (x2 - x) + (y2 - y) * (y2 - y);
        if (d1 < d2) {
            out[0] = x1;
            out[1] = y1;
            return Math.sqrt(d1);
        } else {
            out[0] = x2;
            out[1] = y2;
            return Math.sqrt(d2);
        }
    }
    function $02eb7bb47d256bbb$var$projectPointToLine(x1, y1, x2, y2, x, y, out, limitToEnds) {
        var dx = x - x1;
        var dy = y - y1;
        var dx1 = x2 - x1;
        var dy1 = y2 - y1;
        var lineLen = Math.sqrt(dx1 * dx1 + dy1 * dy1);
        dx1 /= lineLen;
        dy1 /= lineLen;
        var projectedLen = dx * dx1 + dy * dy1;
        var t = projectedLen / lineLen;
        if (limitToEnds) t = Math.min(Math.max(t, 0), 1);
        t *= lineLen;
        var ox = out[0] = x1 + t * dx1;
        var oy = out[1] = y1 + t * dy1;
        return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
    }
    function $02eb7bb47d256bbb$var$projectPointToRect(x1, y1, width, height, x, y, out) {
        if (width < 0) {
            x1 = x1 + width;
            width = -width;
        }
        if (height < 0) {
            y1 = y1 + height;
            height = -height;
        }
        var x2 = x1 + width;
        var y2 = y1 + height;
        var ox = out[0] = Math.min(Math.max(x, x1), x2);
        var oy = out[1] = Math.min(Math.max(y, y1), y2);
        return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
    }
    var $02eb7bb47d256bbb$var$tmpPt = [];
    function $02eb7bb47d256bbb$var$nearestPointOnRect(pt, rect, out) {
        var dist = $02eb7bb47d256bbb$var$projectPointToRect(rect.x, rect.y, rect.width, rect.height, pt.x, pt.y, $02eb7bb47d256bbb$var$tmpPt);
        out.set($02eb7bb47d256bbb$var$tmpPt[0], $02eb7bb47d256bbb$var$tmpPt[1]);
        return dist;
    }
    function $02eb7bb47d256bbb$var$nearestPointOnPath(pt, path, out) {
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        var x1;
        var y1;
        var minDist = Infinity;
        var data = path.data;
        var x = pt.x;
        var y = pt.y;
        for(var i = 0; i < data.length;){
            var cmd = data[i++];
            if (i === 1) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            var d = minDist;
            switch(cmd){
                case $02eb7bb47d256bbb$var$CMD.M:
                    x0 = data[i++];
                    y0 = data[i++];
                    xi = x0;
                    yi = y0;
                    break;
                case $02eb7bb47d256bbb$var$CMD.L:
                    d = $02eb7bb47d256bbb$var$projectPointToLine(xi, yi, data[i], data[i + 1], x, y, $02eb7bb47d256bbb$var$tmpPt, true);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $02eb7bb47d256bbb$var$CMD.C:
                    d = (0, (0, parcelRequire("dr1jo")).cubicProjectPoint)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y, $02eb7bb47d256bbb$var$tmpPt);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $02eb7bb47d256bbb$var$CMD.Q:
                    d = (0, (0, parcelRequire("dr1jo")).quadraticProjectPoint)(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y, $02eb7bb47d256bbb$var$tmpPt);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $02eb7bb47d256bbb$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var theta = data[i++];
                    var dTheta = data[i++];
                    i += 1;
                    var anticlockwise = !!(1 - data[i++]);
                    x1 = Math.cos(theta) * rx + cx;
                    y1 = Math.sin(theta) * ry + cy;
                    if (i <= 1) {
                        x0 = x1;
                        y0 = y1;
                    }
                    var _x = (x - cx) * ry / rx + cx;
                    d = $02eb7bb47d256bbb$var$projectPointToArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y, $02eb7bb47d256bbb$var$tmpPt);
                    xi = Math.cos(theta + dTheta) * rx + cx;
                    yi = Math.sin(theta + dTheta) * ry + cy;
                    break;
                case $02eb7bb47d256bbb$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    d = $02eb7bb47d256bbb$var$projectPointToRect(x0, y0, width, height, x, y, $02eb7bb47d256bbb$var$tmpPt);
                    break;
                case $02eb7bb47d256bbb$var$CMD.Z:
                    d = $02eb7bb47d256bbb$var$projectPointToLine(xi, yi, x0, y0, x, y, $02eb7bb47d256bbb$var$tmpPt, true);
                    xi = x0;
                    yi = y0;
                    break;
            }
            if (d < minDist) {
                minDist = d;
                out.set($02eb7bb47d256bbb$var$tmpPt[0], $02eb7bb47d256bbb$var$tmpPt[1]);
            }
        }
        return minDist;
    }
    var $02eb7bb47d256bbb$var$pt0 = new (0, (0, parcelRequire("bMDnR")).default)();
    var $02eb7bb47d256bbb$var$pt1 = new (0, (0, parcelRequire("bMDnR")).default)();
    var $02eb7bb47d256bbb$var$pt2 = new (0, (0, parcelRequire("bMDnR")).default)();
    var $02eb7bb47d256bbb$var$dir = new (0, (0, parcelRequire("bMDnR")).default)();
    var $02eb7bb47d256bbb$var$dir2 = new (0, (0, parcelRequire("bMDnR")).default)();
    function $02eb7bb47d256bbb$export$cc93ba643cd97d83(target, labelLineModel) {
        if (!target) return;
        var labelLine = target.getTextGuideLine();
        var label = target.getTextContent();
        if (!(label && labelLine)) return;
        var labelGuideConfig = target.textGuideLineConfig || {};
        var points = [
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ]
        ];
        var searchSpace = labelGuideConfig.candidates || $02eb7bb47d256bbb$var$DEFAULT_SEARCH_SPACE;
        var labelRect = label.getBoundingRect().clone();
        labelRect.applyTransform(label.getComputedTransform());
        var minDist = Infinity;
        var anchorPoint = labelGuideConfig.anchor;
        var targetTransform = target.getComputedTransform();
        var targetInversedTransform = targetTransform && (0, (0, parcelRequire("izqgC")).invert)([], targetTransform);
        var len = labelLineModel.get('length2') || 0;
        if (anchorPoint) $02eb7bb47d256bbb$var$pt2.copy(anchorPoint);
        for(var i = 0; i < searchSpace.length; i++){
            var candidate = searchSpace[i];
            $02eb7bb47d256bbb$var$getCandidateAnchor(candidate, 0, labelRect, $02eb7bb47d256bbb$var$pt0, $02eb7bb47d256bbb$var$dir);
            (0, (0, parcelRequire("bMDnR")).default).scaleAndAdd($02eb7bb47d256bbb$var$pt1, $02eb7bb47d256bbb$var$pt0, $02eb7bb47d256bbb$var$dir, len);
            $02eb7bb47d256bbb$var$pt1.transform(targetInversedTransform);
            var boundingRect = target.getBoundingRect();
            var dist = anchorPoint ? anchorPoint.distance($02eb7bb47d256bbb$var$pt1) : target instanceof (0, (0, parcelRequire("ghQ8v")).default) ? $02eb7bb47d256bbb$var$nearestPointOnPath($02eb7bb47d256bbb$var$pt1, target.path, $02eb7bb47d256bbb$var$pt2) : $02eb7bb47d256bbb$var$nearestPointOnRect($02eb7bb47d256bbb$var$pt1, boundingRect, $02eb7bb47d256bbb$var$pt2);
            if (dist < minDist) {
                minDist = dist;
                $02eb7bb47d256bbb$var$pt1.transform(targetTransform);
                $02eb7bb47d256bbb$var$pt2.transform(targetTransform);
                $02eb7bb47d256bbb$var$pt2.toArray(points[0]);
                $02eb7bb47d256bbb$var$pt1.toArray(points[1]);
                $02eb7bb47d256bbb$var$pt0.toArray(points[2]);
            }
        }
        $02eb7bb47d256bbb$export$ac52062003fbe6a(points, labelLineModel.get('minTurnAngle'));
        labelLine.setShape({
            points: points
        });
    }
    var $02eb7bb47d256bbb$var$tmpArr = [];
    var $02eb7bb47d256bbb$var$tmpProjPoint = new (0, (0, parcelRequire("bMDnR")).default)();
    function $02eb7bb47d256bbb$export$ac52062003fbe6a(linePoints, minTurnAngle) {
        if (!(minTurnAngle <= 180 && minTurnAngle > 0)) return;
        minTurnAngle = minTurnAngle / 180 * Math.PI;
        $02eb7bb47d256bbb$var$pt0.fromArray(linePoints[0]);
        $02eb7bb47d256bbb$var$pt1.fromArray(linePoints[1]);
        $02eb7bb47d256bbb$var$pt2.fromArray(linePoints[2]);
        (0, (0, parcelRequire("bMDnR")).default).sub($02eb7bb47d256bbb$var$dir, $02eb7bb47d256bbb$var$pt0, $02eb7bb47d256bbb$var$pt1);
        (0, (0, parcelRequire("bMDnR")).default).sub($02eb7bb47d256bbb$var$dir2, $02eb7bb47d256bbb$var$pt2, $02eb7bb47d256bbb$var$pt1);
        var len1 = $02eb7bb47d256bbb$var$dir.len();
        var len2 = $02eb7bb47d256bbb$var$dir2.len();
        if (len1 < 1e-3 || len2 < 1e-3) return;
        $02eb7bb47d256bbb$var$dir.scale(1 / len1);
        $02eb7bb47d256bbb$var$dir2.scale(1 / len2);
        var angleCos = $02eb7bb47d256bbb$var$dir.dot($02eb7bb47d256bbb$var$dir2);
        var minTurnAngleCos = Math.cos(minTurnAngle);
        if (minTurnAngleCos < angleCos) {
            var d = $02eb7bb47d256bbb$var$projectPointToLine($02eb7bb47d256bbb$var$pt1.x, $02eb7bb47d256bbb$var$pt1.y, $02eb7bb47d256bbb$var$pt2.x, $02eb7bb47d256bbb$var$pt2.y, $02eb7bb47d256bbb$var$pt0.x, $02eb7bb47d256bbb$var$pt0.y, $02eb7bb47d256bbb$var$tmpArr, false);
            $02eb7bb47d256bbb$var$tmpProjPoint.fromArray($02eb7bb47d256bbb$var$tmpArr);
            $02eb7bb47d256bbb$var$tmpProjPoint.scaleAndAdd($02eb7bb47d256bbb$var$dir2, d / Math.tan(Math.PI - minTurnAngle));
            var t = $02eb7bb47d256bbb$var$pt2.x !== $02eb7bb47d256bbb$var$pt1.x ? ($02eb7bb47d256bbb$var$tmpProjPoint.x - $02eb7bb47d256bbb$var$pt1.x) / ($02eb7bb47d256bbb$var$pt2.x - $02eb7bb47d256bbb$var$pt1.x) : ($02eb7bb47d256bbb$var$tmpProjPoint.y - $02eb7bb47d256bbb$var$pt1.y) / ($02eb7bb47d256bbb$var$pt2.y - $02eb7bb47d256bbb$var$pt1.y);
            if (isNaN(t)) return;
            if (t < 0) (0, (0, parcelRequire("bMDnR")).default).copy($02eb7bb47d256bbb$var$tmpProjPoint, $02eb7bb47d256bbb$var$pt1);
            else if (t > 1) (0, (0, parcelRequire("bMDnR")).default).copy($02eb7bb47d256bbb$var$tmpProjPoint, $02eb7bb47d256bbb$var$pt2);
            $02eb7bb47d256bbb$var$tmpProjPoint.toArray(linePoints[1]);
        }
    }
    function $02eb7bb47d256bbb$export$973e1fdb2708f71b(linePoints, surfaceNormal, maxSurfaceAngle) {
        if (!(maxSurfaceAngle <= 180 && maxSurfaceAngle > 0)) return;
        maxSurfaceAngle = maxSurfaceAngle / 180 * Math.PI;
        $02eb7bb47d256bbb$var$pt0.fromArray(linePoints[0]);
        $02eb7bb47d256bbb$var$pt1.fromArray(linePoints[1]);
        $02eb7bb47d256bbb$var$pt2.fromArray(linePoints[2]);
        (0, (0, parcelRequire("bMDnR")).default).sub($02eb7bb47d256bbb$var$dir, $02eb7bb47d256bbb$var$pt1, $02eb7bb47d256bbb$var$pt0);
        (0, (0, parcelRequire("bMDnR")).default).sub($02eb7bb47d256bbb$var$dir2, $02eb7bb47d256bbb$var$pt2, $02eb7bb47d256bbb$var$pt1);
        var len1 = $02eb7bb47d256bbb$var$dir.len();
        var len2 = $02eb7bb47d256bbb$var$dir2.len();
        if (len1 < 1e-3 || len2 < 1e-3) return;
        $02eb7bb47d256bbb$var$dir.scale(1 / len1);
        $02eb7bb47d256bbb$var$dir2.scale(1 / len2);
        var angleCos = $02eb7bb47d256bbb$var$dir.dot(surfaceNormal);
        var maxSurfaceAngleCos = Math.cos(maxSurfaceAngle);
        if (angleCos < maxSurfaceAngleCos) {
            var d = $02eb7bb47d256bbb$var$projectPointToLine($02eb7bb47d256bbb$var$pt1.x, $02eb7bb47d256bbb$var$pt1.y, $02eb7bb47d256bbb$var$pt2.x, $02eb7bb47d256bbb$var$pt2.y, $02eb7bb47d256bbb$var$pt0.x, $02eb7bb47d256bbb$var$pt0.y, $02eb7bb47d256bbb$var$tmpArr, false);
            $02eb7bb47d256bbb$var$tmpProjPoint.fromArray($02eb7bb47d256bbb$var$tmpArr);
            var HALF_PI = Math.PI / 2;
            var angle2 = Math.acos($02eb7bb47d256bbb$var$dir2.dot(surfaceNormal));
            var newAngle = HALF_PI + angle2 - maxSurfaceAngle;
            if (newAngle >= HALF_PI) (0, (0, parcelRequire("bMDnR")).default).copy($02eb7bb47d256bbb$var$tmpProjPoint, $02eb7bb47d256bbb$var$pt2);
            else {
                $02eb7bb47d256bbb$var$tmpProjPoint.scaleAndAdd($02eb7bb47d256bbb$var$dir2, d / Math.tan(Math.PI / 2 - newAngle));
                var t = $02eb7bb47d256bbb$var$pt2.x !== $02eb7bb47d256bbb$var$pt1.x ? ($02eb7bb47d256bbb$var$tmpProjPoint.x - $02eb7bb47d256bbb$var$pt1.x) / ($02eb7bb47d256bbb$var$pt2.x - $02eb7bb47d256bbb$var$pt1.x) : ($02eb7bb47d256bbb$var$tmpProjPoint.y - $02eb7bb47d256bbb$var$pt1.y) / ($02eb7bb47d256bbb$var$pt2.y - $02eb7bb47d256bbb$var$pt1.y);
                if (isNaN(t)) return;
                if (t < 0) (0, (0, parcelRequire("bMDnR")).default).copy($02eb7bb47d256bbb$var$tmpProjPoint, $02eb7bb47d256bbb$var$pt1);
                else if (t > 1) (0, (0, parcelRequire("bMDnR")).default).copy($02eb7bb47d256bbb$var$tmpProjPoint, $02eb7bb47d256bbb$var$pt2);
            }
            $02eb7bb47d256bbb$var$tmpProjPoint.toArray(linePoints[1]);
        }
    }
    function $02eb7bb47d256bbb$var$setLabelLineState(labelLine, ignore, stateName, stateModel) {
        var isNormal = stateName === 'normal';
        var stateObj = isNormal ? labelLine : labelLine.ensureState(stateName);
        stateObj.ignore = ignore;
        var smooth = stateModel.get('smooth');
        if (smooth && smooth === true) smooth = 0.3;
        stateObj.shape = stateObj.shape || {};
        if (smooth > 0) stateObj.shape.smooth = smooth;
        var styleObj = stateModel.getModel('lineStyle').getLineStyle();
        isNormal ? labelLine.useStyle(styleObj) : stateObj.style = styleObj;
    }
    function $02eb7bb47d256bbb$var$buildLabelLinePath(path, shape) {
        var smooth = shape.smooth;
        var points = shape.points;
        if (!points) return;
        path.moveTo(points[0][0], points[0][1]);
        if (smooth > 0 && points.length >= 3) {
            var len1 = (0, parcelRequire("eLEew")).dist(points[0], points[1]);
            var len2 = (0, parcelRequire("eLEew")).dist(points[1], points[2]);
            if (!len1 || !len2) {
                path.lineTo(points[1][0], points[1][1]);
                path.lineTo(points[2][0], points[2][1]);
                return;
            }
            var moveLen = Math.min(len1, len2) * smooth;
            var midPoint0 = (0, parcelRequire("eLEew")).lerp([], points[1], points[0], moveLen / len1);
            var midPoint2 = (0, parcelRequire("eLEew")).lerp([], points[1], points[2], moveLen / len2);
            var midPoint1 = (0, parcelRequire("eLEew")).lerp([], midPoint0, midPoint2, 0.5);
            path.bezierCurveTo(midPoint0[0], midPoint0[1], midPoint0[0], midPoint0[1], midPoint1[0], midPoint1[1]);
            path.bezierCurveTo(midPoint2[0], midPoint2[1], midPoint2[0], midPoint2[1], points[2][0], points[2][1]);
        } else for(var i = 1; i < points.length; i++)path.lineTo(points[i][0], points[i][1]);
    }
    function $02eb7bb47d256bbb$export$c09e0b0574bdd2dc(targetEl, statesModels, defaultStyle) {
        var labelLine = targetEl.getTextGuideLine();
        var label = targetEl.getTextContent();
        if (!label) {
            if (labelLine) targetEl.removeTextGuideLine();
            return;
        }
        var normalModel = statesModels.normal;
        var showNormal = normalModel.get('show');
        var labelIgnoreNormal = label.ignore;
        for(var i = 0; i < (0, (0, parcelRequire("fIXXx")).DISPLAY_STATES).length; i++){
            var stateName = (0, (0, parcelRequire("fIXXx")).DISPLAY_STATES)[i];
            var stateModel = statesModels[stateName];
            var isNormal = stateName === 'normal';
            if (stateModel) {
                var stateShow = stateModel.get('show');
                var isLabelIgnored = isNormal ? labelIgnoreNormal : (0, (0, parcelRequire("bahqM")).retrieve2)(label.states[stateName] && label.states[stateName].ignore, labelIgnoreNormal);
                if (isLabelIgnored || !(0, (0, parcelRequire("bahqM")).retrieve2)(stateShow, showNormal)) {
                    var stateObj = isNormal ? labelLine : labelLine && labelLine.states.normal;
                    if (stateObj) stateObj.ignore = true;
                    continue;
                }
                if (!labelLine) {
                    labelLine = new (0, (0, parcelRequire("32bXc")).default)();
                    targetEl.setTextGuideLine(labelLine);
                    if (!isNormal && (labelIgnoreNormal || !showNormal)) $02eb7bb47d256bbb$var$setLabelLineState(labelLine, true, 'normal', statesModels.normal);
                    if (targetEl.stateProxy) labelLine.stateProxy = targetEl.stateProxy;
                }
                $02eb7bb47d256bbb$var$setLabelLineState(labelLine, false, stateName, stateModel);
            }
        }
        if (labelLine) {
            (0, (0, parcelRequire("bahqM")).defaults)(labelLine.style, defaultStyle);
            labelLine.style.fill = null;
            var showAbove = normalModel.get('showAbove');
            var labelLineConfig = targetEl.textGuideLineConfig = targetEl.textGuideLineConfig || {};
            labelLineConfig.showAbove = showAbove || false;
            labelLine.buildPath = $02eb7bb47d256bbb$var$buildLabelLinePath;
        }
    }
    function $02eb7bb47d256bbb$export$2979fdbf5ebce521(itemModel, labelLineName) {
        labelLineName = labelLineName || 'labelLine';
        var statesModels = {
            normal: itemModel.getModel(labelLineName)
        };
        for(var i = 0; i < (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES).length; i++){
            var stateName = (0, (0, parcelRequire("fIXXx")).SPECIAL_STATES)[i];
            statesModels[stateName] = itemModel.getModel([
                stateName,
                labelLineName
            ]);
        }
        return statesModels;
    }
});
parcelRegister("koMvQ", function(module, exports) {
    $parcel$export(module.exports, "install", ()=>$ed9bae1f5fcebf9c$export$4b3e715f166fdd78);
    var $9d3yg;
    function $ed9bae1f5fcebf9c$export$4b3e715f166fdd78(registers) {
        registers.registerPainter('svg', (0, (0, parcelRequire("9d3yg")).default));
    }
});
parcelRegister("9d3yg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6b481536a5986ad8$export$2e2bcd8739ae039);
    var $dE0Hq;
    var $bahqM;
    var $ghQ8v;
    var $gcbBH;
    var $45jlh;
    var $iN8gp;
    var $9mQ8G;
    var $brSrY;
    var $i53xG;
    var $b6V4m;
    var $k0bb8;
    function $6b481536a5986ad8$var$parseInt10(val) {
        return parseInt(val, 10);
    }
    function $6b481536a5986ad8$var$getSvgProxy(el) {
        if (el instanceof (0, (0, parcelRequire("ghQ8v")).default)) return 0, (0, parcelRequire("k0bb8")).path;
        else if (el instanceof (0, (0, parcelRequire("gcbBH")).default)) return 0, (0, parcelRequire("k0bb8")).image;
        else if (el instanceof (0, (0, parcelRequire("45jlh")).default)) return 0, (0, parcelRequire("k0bb8")).text;
        else return 0, (0, parcelRequire("k0bb8")).path;
    }
    function $6b481536a5986ad8$var$checkParentAvailable(parent, child) {
        return child && parent && child.parentNode !== parent;
    }
    function $6b481536a5986ad8$var$insertAfter(parent, child, prevSibling) {
        if ($6b481536a5986ad8$var$checkParentAvailable(parent, child) && prevSibling) {
            var nextSibling = prevSibling.nextSibling;
            nextSibling ? parent.insertBefore(child, nextSibling) : parent.appendChild(child);
        }
    }
    function $6b481536a5986ad8$var$prepend(parent, child) {
        if ($6b481536a5986ad8$var$checkParentAvailable(parent, child)) {
            var firstChild = parent.firstChild;
            firstChild ? parent.insertBefore(child, firstChild) : parent.appendChild(child);
        }
    }
    function $6b481536a5986ad8$var$remove(parent, child) {
        if (child && parent && child.parentNode === parent) parent.removeChild(child);
    }
    function $6b481536a5986ad8$var$removeFromMyParent(child) {
        if (child && child.parentNode) child.parentNode.removeChild(child);
    }
    function $6b481536a5986ad8$var$getSvgElement(displayable) {
        return displayable.__svgEl;
    }
    var $6b481536a5986ad8$var$SVGPainter = function() {
        function SVGPainter(root, storage, opts, zrId) {
            this.type = 'svg';
            this.refreshHover = $6b481536a5986ad8$var$createMethodNotSupport('refreshHover');
            this.pathToImage = $6b481536a5986ad8$var$createMethodNotSupport('pathToImage');
            this.configLayer = $6b481536a5986ad8$var$createMethodNotSupport('configLayer');
            this.root = root;
            this.storage = storage;
            this._opts = opts = (0, parcelRequire("bahqM")).extend({}, opts || {});
            var svgDom = (0, (0, parcelRequire("dE0Hq")).createElement)('svg');
            svgDom.setAttributeNS('http://www.w3.org/2000/xmlns/', 'xmlns', 'http://www.w3.org/2000/svg');
            svgDom.setAttributeNS('http://www.w3.org/2000/xmlns/', 'xmlns:xlink', 'http://www.w3.org/1999/xlink');
            svgDom.setAttribute('version', '1.1');
            svgDom.setAttribute('baseProfile', 'full');
            svgDom.style.cssText = 'user-select:none;position:absolute;left:0;top:0;';
            var bgRoot = (0, (0, parcelRequire("dE0Hq")).createElement)('g');
            svgDom.appendChild(bgRoot);
            var svgRoot = (0, (0, parcelRequire("dE0Hq")).createElement)('g');
            svgDom.appendChild(svgRoot);
            this._gradientManager = new (0, (0, parcelRequire("9mQ8G")).default)(zrId, svgRoot);
            this._patternManager = new (0, (0, parcelRequire("brSrY")).default)(zrId, svgRoot);
            this._clipPathManager = new (0, (0, parcelRequire("i53xG")).default)(zrId, svgRoot);
            this._shadowManager = new (0, (0, parcelRequire("b6V4m")).default)(zrId, svgRoot);
            var viewport = document.createElement('div');
            viewport.style.cssText = 'overflow:hidden;position:relative';
            this._svgDom = svgDom;
            this._svgRoot = svgRoot;
            this._backgroundRoot = bgRoot;
            this._viewport = viewport;
            root.appendChild(viewport);
            viewport.appendChild(svgDom);
            this.resize(opts.width, opts.height);
            this._visibleList = [];
        }
        SVGPainter.prototype.getType = function() {
            return 'svg';
        };
        SVGPainter.prototype.getViewportRoot = function() {
            return this._viewport;
        };
        SVGPainter.prototype.getSvgDom = function() {
            return this._svgDom;
        };
        SVGPainter.prototype.getSvgRoot = function() {
            return this._svgRoot;
        };
        SVGPainter.prototype.getViewportRootOffset = function() {
            var viewportRoot = this.getViewportRoot();
            if (viewportRoot) return {
                offsetLeft: viewportRoot.offsetLeft || 0,
                offsetTop: viewportRoot.offsetTop || 0
            };
        };
        SVGPainter.prototype.refresh = function() {
            var list = this.storage.getDisplayList(true);
            this._paintList(list);
        };
        SVGPainter.prototype.setBackgroundColor = function(backgroundColor) {
            if (this._backgroundRoot && this._backgroundNode) this._backgroundRoot.removeChild(this._backgroundNode);
            var bgNode = (0, (0, parcelRequire("dE0Hq")).createElement)('rect');
            bgNode.setAttribute('width', this.getWidth());
            bgNode.setAttribute('height', this.getHeight());
            bgNode.setAttribute('x', 0);
            bgNode.setAttribute('y', 0);
            bgNode.setAttribute('id', 0);
            var _a = (0, (0, parcelRequire("dE0Hq")).normalizeColor)(backgroundColor), color = _a.color, opacity = _a.opacity;
            bgNode.setAttribute('fill', color);
            bgNode.setAttribute('fill-opacity', opacity);
            this._backgroundRoot.appendChild(bgNode);
            this._backgroundNode = bgNode;
        };
        SVGPainter.prototype.createSVGElement = function(tag) {
            return (0, (0, parcelRequire("dE0Hq")).createElement)(tag);
        };
        SVGPainter.prototype.paintOne = function(el) {
            var svgProxy = $6b481536a5986ad8$var$getSvgProxy(el);
            svgProxy && svgProxy.brush(el);
            return $6b481536a5986ad8$var$getSvgElement(el);
        };
        SVGPainter.prototype._paintList = function(list) {
            var gradientManager = this._gradientManager;
            var patternManager = this._patternManager;
            var clipPathManager = this._clipPathManager;
            var shadowManager = this._shadowManager;
            gradientManager.markAllUnused();
            patternManager.markAllUnused();
            clipPathManager.markAllUnused();
            shadowManager.markAllUnused();
            var svgRoot = this._svgRoot;
            var visibleList = this._visibleList;
            var listLen = list.length;
            var newVisibleList = [];
            for(var i = 0; i < listLen; i++){
                var displayable = list[i];
                var svgProxy = $6b481536a5986ad8$var$getSvgProxy(displayable);
                var svgElement = $6b481536a5986ad8$var$getSvgElement(displayable);
                if (!displayable.invisible) {
                    if (displayable.__dirty || !svgElement) {
                        svgProxy && svgProxy.brush(displayable);
                        svgElement = $6b481536a5986ad8$var$getSvgElement(displayable);
                        if (svgElement && displayable.style) {
                            gradientManager.update(displayable.style.fill);
                            gradientManager.update(displayable.style.stroke);
                            patternManager.update(displayable.style.fill);
                            patternManager.update(displayable.style.stroke);
                            shadowManager.update(svgElement, displayable);
                        }
                        displayable.__dirty = 0;
                    }
                    if (svgElement) newVisibleList.push(displayable);
                }
            }
            var diff = (0, (0, parcelRequire("iN8gp")).default)(visibleList, newVisibleList);
            var prevSvgElement;
            var topPrevSvgElement;
            for(var i = 0; i < diff.length; i++){
                var item = diff[i];
                if (item.removed) for(var k = 0; k < item.count; k++){
                    var displayable = visibleList[item.indices[k]];
                    var svgElement = $6b481536a5986ad8$var$getSvgElement(displayable);
                    (0, (0, parcelRequire("i53xG")).hasClipPath)(displayable) ? $6b481536a5986ad8$var$removeFromMyParent(svgElement) : $6b481536a5986ad8$var$remove(svgRoot, svgElement);
                }
            }
            var prevDisplayable;
            var currentClipGroup;
            for(var i = 0; i < diff.length; i++){
                var item = diff[i];
                if (item.removed) continue;
                for(var k = 0; k < item.count; k++){
                    var displayable = newVisibleList[item.indices[k]];
                    var clipGroup = clipPathManager.update(displayable, prevDisplayable);
                    if (clipGroup !== currentClipGroup) {
                        prevSvgElement = topPrevSvgElement;
                        if (clipGroup) {
                            prevSvgElement ? $6b481536a5986ad8$var$insertAfter(svgRoot, clipGroup, prevSvgElement) : $6b481536a5986ad8$var$prepend(svgRoot, clipGroup);
                            topPrevSvgElement = clipGroup;
                            prevSvgElement = null;
                        }
                        currentClipGroup = clipGroup;
                    }
                    var svgElement = $6b481536a5986ad8$var$getSvgElement(displayable);
                    prevSvgElement ? $6b481536a5986ad8$var$insertAfter(currentClipGroup || svgRoot, svgElement, prevSvgElement) : $6b481536a5986ad8$var$prepend(currentClipGroup || svgRoot, svgElement);
                    prevSvgElement = svgElement || prevSvgElement;
                    if (!currentClipGroup) topPrevSvgElement = prevSvgElement;
                    gradientManager.markUsed(displayable);
                    gradientManager.addWithoutUpdate(svgElement, displayable);
                    patternManager.markUsed(displayable);
                    patternManager.addWithoutUpdate(svgElement, displayable);
                    clipPathManager.markUsed(displayable);
                    prevDisplayable = displayable;
                }
            }
            gradientManager.removeUnused();
            patternManager.removeUnused();
            clipPathManager.removeUnused();
            shadowManager.removeUnused();
            this._visibleList = newVisibleList;
        };
        SVGPainter.prototype.resize = function(width, height) {
            var viewport = this._viewport;
            viewport.style.display = 'none';
            var opts = this._opts;
            width != null && (opts.width = width);
            height != null && (opts.height = height);
            width = this._getSize(0);
            height = this._getSize(1);
            viewport.style.display = '';
            if (this._width !== width || this._height !== height) {
                this._width = width;
                this._height = height;
                var viewportStyle = viewport.style;
                viewportStyle.width = width + 'px';
                viewportStyle.height = height + 'px';
                var svgRoot = this._svgDom;
                svgRoot.setAttribute('width', width + '');
                svgRoot.setAttribute('height', height + '');
            }
            if (this._backgroundNode) {
                this._backgroundNode.setAttribute('width', width);
                this._backgroundNode.setAttribute('height', height);
            }
        };
        SVGPainter.prototype.getWidth = function() {
            return this._width;
        };
        SVGPainter.prototype.getHeight = function() {
            return this._height;
        };
        SVGPainter.prototype._getSize = function(whIdx) {
            var opts = this._opts;
            var wh = [
                'width',
                'height'
            ][whIdx];
            var cwh = [
                'clientWidth',
                'clientHeight'
            ][whIdx];
            var plt = [
                'paddingLeft',
                'paddingTop'
            ][whIdx];
            var prb = [
                'paddingRight',
                'paddingBottom'
            ][whIdx];
            if (opts[wh] != null && opts[wh] !== 'auto') return parseFloat(opts[wh]);
            var root = this.root;
            var stl = document.defaultView.getComputedStyle(root);
            return (root[cwh] || $6b481536a5986ad8$var$parseInt10(stl[wh]) || $6b481536a5986ad8$var$parseInt10(root.style[wh])) - ($6b481536a5986ad8$var$parseInt10(stl[plt]) || 0) - ($6b481536a5986ad8$var$parseInt10(stl[prb]) || 0) | 0;
        };
        SVGPainter.prototype.dispose = function() {
            this.root.innerHTML = '';
            this._svgRoot = this._backgroundRoot = this._svgDom = this._backgroundNode = this._viewport = this.storage = null;
        };
        SVGPainter.prototype.clear = function() {
            var viewportNode = this._viewport;
            if (viewportNode && viewportNode.parentNode) viewportNode.parentNode.removeChild(viewportNode);
        };
        SVGPainter.prototype.toDataURL = function() {
            this.refresh();
            var svgDom = this._svgDom;
            var outerHTML = svgDom.outerHTML || (svgDom.parentNode && svgDom.parentNode).innerHTML;
            var html = encodeURIComponent(outerHTML.replace(/></g, '>\n\r<'));
            return 'data:image/svg+xml;charset=UTF-8,' + html;
        };
        return SVGPainter;
    }();
    function $6b481536a5986ad8$var$createMethodNotSupport(method) {
        return function() {
            (0, parcelRequire("bahqM")).logError('In SVG mode painter not support method "' + method + '"');
        };
    }
    var $6b481536a5986ad8$export$2e2bcd8739ae039 = $6b481536a5986ad8$var$SVGPainter;
});
parcelRegister("dE0Hq", function(module, exports) {
    $parcel$export(module.exports, "createElement", ()=>$9eef8dacfbb7af72$export$c8a8987d4410bf2d);
    $parcel$export(module.exports, "normalizeColor", ()=>$9eef8dacfbb7af72$export$4cde5df63f53f473);
    var $d6udH;
    function $9eef8dacfbb7af72$export$c8a8987d4410bf2d(name) {
        return document.createElementNS('http://www.w3.org/2000/svg', name);
    }
    function $9eef8dacfbb7af72$export$4cde5df63f53f473(color) {
        var opacity;
        if (!color || color === 'transparent') color = 'none';
        else if (typeof color === 'string' && color.indexOf('rgba') > -1) {
            var arr = (0, (0, parcelRequire("d6udH")).parse)(color);
            if (arr) {
                color = 'rgb(' + arr[0] + ',' + arr[1] + ',' + arr[2] + ')';
                opacity = arr[3];
            }
        }
        return {
            color: color,
            opacity: opacity == null ? 1 : opacity
        };
    }
});
parcelRegister("iN8gp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dae3369130c6c165$export$2e2bcd8739ae039);
    function $dae3369130c6c165$var$diff(oldArr, newArr, equals) {
        if (!equals) equals = function(a, b) {
            return a === b;
        };
        oldArr = oldArr.slice();
        newArr = newArr.slice();
        var newLen = newArr.length;
        var oldLen = oldArr.length;
        var editLength = 1;
        var maxEditLength = newLen + oldLen;
        var bestPath = [
            {
                newPos: -1,
                components: []
            }
        ];
        var oldPos = $dae3369130c6c165$var$extractCommon(bestPath[0], newArr, oldArr, 0, equals);
        if (bestPath[0].newPos + 1 >= newLen && oldPos + 1 >= oldLen) {
            var indices = [];
            for(var i = 0; i < newArr.length; i++)indices.push(i);
            return [
                {
                    indices: indices,
                    count: newArr.length,
                    added: false,
                    removed: false
                }
            ];
        }
        function execEditLength() {
            for(var diagonalPath = -1 * editLength; diagonalPath <= editLength; diagonalPath += 2){
                var basePath;
                var addPath = bestPath[diagonalPath - 1];
                var removePath = bestPath[diagonalPath + 1];
                var oldPos = (removePath ? removePath.newPos : 0) - diagonalPath;
                if (addPath) bestPath[diagonalPath - 1] = undefined;
                var canAdd = addPath && addPath.newPos + 1 < newLen;
                var canRemove = removePath && 0 <= oldPos && oldPos < oldLen;
                if (!canAdd && !canRemove) {
                    bestPath[diagonalPath] = undefined;
                    continue;
                }
                if (!canAdd || canRemove && addPath.newPos < removePath.newPos) {
                    basePath = $dae3369130c6c165$var$clonePath(removePath);
                    $dae3369130c6c165$var$pushComponent(basePath.components, false, true);
                } else {
                    basePath = addPath;
                    basePath.newPos++;
                    $dae3369130c6c165$var$pushComponent(basePath.components, true, false);
                }
                oldPos = $dae3369130c6c165$var$extractCommon(basePath, newArr, oldArr, diagonalPath, equals);
                if (basePath.newPos + 1 >= newLen && oldPos + 1 >= oldLen) return $dae3369130c6c165$var$buildValues(basePath.components);
                else bestPath[diagonalPath] = basePath;
            }
            editLength++;
        }
        while(editLength <= maxEditLength){
            var ret = execEditLength();
            if (ret) return ret;
        }
    }
    function $dae3369130c6c165$var$extractCommon(basePath, newArr, oldArr, diagonalPath, equals) {
        var newLen = newArr.length;
        var oldLen = oldArr.length;
        var newPos = basePath.newPos;
        var oldPos = newPos - diagonalPath;
        var commonCount = 0;
        while(newPos + 1 < newLen && oldPos + 1 < oldLen && equals(newArr[newPos + 1], oldArr[oldPos + 1])){
            newPos++;
            oldPos++;
            commonCount++;
        }
        if (commonCount) basePath.components.push({
            count: commonCount,
            added: false,
            removed: false,
            indices: []
        });
        basePath.newPos = newPos;
        return oldPos;
    }
    function $dae3369130c6c165$var$pushComponent(components, added, removed) {
        var last = components[components.length - 1];
        if (last && last.added === added && last.removed === removed) components[components.length - 1] = {
            count: last.count + 1,
            added: added,
            removed: removed,
            indices: []
        };
        else components.push({
            count: 1,
            added: added,
            removed: removed,
            indices: []
        });
    }
    function $dae3369130c6c165$var$buildValues(components) {
        var componentPos = 0;
        var componentLen = components.length;
        var newPos = 0;
        var oldPos = 0;
        for(; componentPos < componentLen; componentPos++){
            var component = components[componentPos];
            if (!component.removed) {
                var indices = [];
                for(var i = newPos; i < newPos + component.count; i++)indices.push(i);
                component.indices = indices;
                newPos += component.count;
                if (!component.added) oldPos += component.count;
            } else {
                for(var i = oldPos; i < oldPos + component.count; i++)component.indices.push(i);
                oldPos += component.count;
            }
        }
        return components;
    }
    function $dae3369130c6c165$var$clonePath(path) {
        return {
            newPos: path.newPos,
            components: path.components.slice(0)
        };
    }
    function $dae3369130c6c165$export$2e2bcd8739ae039(oldArr, newArr, equal) {
        return $dae3369130c6c165$var$diff(oldArr, newArr, equal);
    }
});
parcelRegister("9mQ8G", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6d1e9cd7c4fb6054$export$2e2bcd8739ae039);
    var $3VFsf;
    var $akOIm;
    var $bahqM;
    var $d6udH;
    function $6d1e9cd7c4fb6054$var$isLinearGradient(value) {
        return value.type === 'linear';
    }
    function $6d1e9cd7c4fb6054$var$isRadialGradient(value) {
        return value.type === 'radial';
    }
    function $6d1e9cd7c4fb6054$var$isGradient(value) {
        return value && (value.type === 'linear' || value.type === 'radial');
    }
    var $6d1e9cd7c4fb6054$var$GradientManager = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(GradientManager, _super);
        function GradientManager(zrId, svgRoot) {
            return _super.call(this, zrId, svgRoot, [
                'linearGradient',
                'radialGradient'
            ], '__gradient_in_use__') || this;
        }
        GradientManager.prototype.addWithoutUpdate = function(svgElement, displayable) {
            if (displayable && displayable.style) {
                var that_1 = this;
                (0, parcelRequire("bahqM")).each([
                    'fill',
                    'stroke'
                ], function(fillOrStroke) {
                    var value = displayable.style[fillOrStroke];
                    if ($6d1e9cd7c4fb6054$var$isGradient(value)) {
                        var gradient = value;
                        var defs = that_1.getDefs(true);
                        var dom = void 0;
                        if (gradient.__dom) {
                            dom = gradient.__dom;
                            if (!defs.contains(gradient.__dom)) that_1.addDom(dom);
                        } else dom = that_1.add(gradient);
                        that_1.markUsed(displayable);
                        var id = dom.getAttribute('id');
                        svgElement.setAttribute(fillOrStroke, 'url(#' + id + ')');
                    }
                });
            }
        };
        GradientManager.prototype.add = function(gradient) {
            var dom;
            if ($6d1e9cd7c4fb6054$var$isLinearGradient(gradient)) dom = this.createElement('linearGradient');
            else if ($6d1e9cd7c4fb6054$var$isRadialGradient(gradient)) dom = this.createElement('radialGradient');
            else {
                (0, parcelRequire("bahqM")).logError('Illegal gradient type.');
                return null;
            }
            gradient.id = gradient.id || this.nextId++;
            dom.setAttribute('id', 'zr' + this._zrId + '-gradient-' + gradient.id);
            this.updateDom(gradient, dom);
            this.addDom(dom);
            return dom;
        };
        GradientManager.prototype.update = function(gradient) {
            if (!$6d1e9cd7c4fb6054$var$isGradient(gradient)) return;
            var that = this;
            this.doUpdate(gradient, function() {
                var dom = gradient.__dom;
                if (!dom) return;
                var tagName = dom.tagName;
                var type = gradient.type;
                if (type === 'linear' && tagName === 'linearGradient' || type === 'radial' && tagName === 'radialGradient') that.updateDom(gradient, gradient.__dom);
                else {
                    that.removeDom(gradient);
                    that.add(gradient);
                }
            });
        };
        GradientManager.prototype.updateDom = function(gradient, dom) {
            if ($6d1e9cd7c4fb6054$var$isLinearGradient(gradient)) {
                dom.setAttribute('x1', gradient.x + '');
                dom.setAttribute('y1', gradient.y + '');
                dom.setAttribute('x2', gradient.x2 + '');
                dom.setAttribute('y2', gradient.y2 + '');
            } else if ($6d1e9cd7c4fb6054$var$isRadialGradient(gradient)) {
                dom.setAttribute('cx', gradient.x + '');
                dom.setAttribute('cy', gradient.y + '');
                dom.setAttribute('r', gradient.r + '');
            } else {
                (0, parcelRequire("bahqM")).logError('Illegal gradient type.');
                return;
            }
            if (gradient.global) dom.setAttribute('gradientUnits', 'userSpaceOnUse');
            else dom.setAttribute('gradientUnits', 'objectBoundingBox');
            dom.innerHTML = '';
            var colors = gradient.colorStops;
            for(var i = 0, len = colors.length; i < len; ++i){
                var stop_1 = this.createElement('stop');
                stop_1.setAttribute('offset', colors[i].offset * 100 + '%');
                var color = colors[i].color;
                if (color.indexOf('rgba') > -1) {
                    var opacity = (0, parcelRequire("d6udH")).parse(color)[3];
                    var hex = (0, parcelRequire("d6udH")).toHex(color);
                    stop_1.setAttribute('stop-color', '#' + hex);
                    stop_1.setAttribute('stop-opacity', opacity + '');
                } else stop_1.setAttribute('stop-color', colors[i].color);
                dom.appendChild(stop_1);
            }
            gradient.__dom = dom;
        };
        GradientManager.prototype.markUsed = function(displayable) {
            if (displayable.style) {
                var gradient = displayable.style.fill;
                if (gradient && gradient.__dom) _super.prototype.markDomUsed.call(this, gradient.__dom);
                gradient = displayable.style.stroke;
                if (gradient && gradient.__dom) _super.prototype.markDomUsed.call(this, gradient.__dom);
            }
        };
        return GradientManager;
    }((0, (0, parcelRequire("akOIm")).default));
    var $6d1e9cd7c4fb6054$export$2e2bcd8739ae039 = $6d1e9cd7c4fb6054$var$GradientManager;
});
parcelRegister("akOIm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$78631c76dc8428b5$export$2e2bcd8739ae039);
    var $dE0Hq;
    var $bahqM;
    var $ghQ8v;
    var $gcbBH;
    var $45jlh;
    var $k0bb8;
    var $78631c76dc8428b5$var$MARK_UNUSED = '0';
    var $78631c76dc8428b5$var$MARK_USED = '1';
    var $78631c76dc8428b5$var$Definable = function() {
        function Definable(zrId, svgRoot, tagNames, markLabel, domName) {
            this.nextId = 0;
            this._domName = '_dom';
            this.createElement = (0, (0, parcelRequire("dE0Hq")).createElement);
            this._zrId = zrId;
            this._svgRoot = svgRoot;
            this._tagNames = typeof tagNames === 'string' ? [
                tagNames
            ] : tagNames;
            this._markLabel = markLabel;
            if (domName) this._domName = domName;
        }
        Definable.prototype.getDefs = function(isForceCreating) {
            var svgRoot = this._svgRoot;
            var defs = this._svgRoot.getElementsByTagName('defs');
            if (defs.length === 0) {
                if (isForceCreating) {
                    var defs_1 = svgRoot.insertBefore(this.createElement('defs'), svgRoot.firstChild);
                    if (!defs_1.contains) defs_1.contains = function(el) {
                        var children = defs_1.children;
                        if (!children) return false;
                        for(var i = children.length - 1; i >= 0; --i){
                            if (children[i] === el) return true;
                        }
                        return false;
                    };
                    return defs_1;
                } else return null;
            } else return defs[0];
        };
        Definable.prototype.doUpdate = function(target, onUpdate) {
            if (!target) return;
            var defs = this.getDefs(false);
            if (target[this._domName] && defs.contains(target[this._domName])) {
                if (typeof onUpdate === 'function') onUpdate(target);
            } else {
                var dom = this.add(target);
                if (dom) target[this._domName] = dom;
            }
        };
        Definable.prototype.add = function(target) {
            return null;
        };
        Definable.prototype.addDom = function(dom) {
            var defs = this.getDefs(true);
            if (dom.parentNode !== defs) defs.appendChild(dom);
        };
        Definable.prototype.removeDom = function(target) {
            var defs = this.getDefs(false);
            if (defs && target[this._domName]) {
                defs.removeChild(target[this._domName]);
                target[this._domName] = null;
            }
        };
        Definable.prototype.getDoms = function() {
            var defs = this.getDefs(false);
            if (!defs) return [];
            var doms = [];
            (0, parcelRequire("bahqM")).each(this._tagNames, function(tagName) {
                var tags = defs.getElementsByTagName(tagName);
                for(var i = 0; i < tags.length; i++)doms.push(tags[i]);
            });
            return doms;
        };
        Definable.prototype.markAllUnused = function() {
            var doms = this.getDoms();
            var that = this;
            (0, parcelRequire("bahqM")).each(doms, function(dom) {
                dom[that._markLabel] = $78631c76dc8428b5$var$MARK_UNUSED;
            });
        };
        Definable.prototype.markDomUsed = function(dom) {
            dom && (dom[this._markLabel] = $78631c76dc8428b5$var$MARK_USED);
        };
        Definable.prototype.markDomUnused = function(dom) {
            dom && (dom[this._markLabel] = $78631c76dc8428b5$var$MARK_UNUSED);
        };
        Definable.prototype.isDomUnused = function(dom) {
            return dom && dom[this._markLabel] !== $78631c76dc8428b5$var$MARK_USED;
        };
        Definable.prototype.removeUnused = function() {
            var _this = this;
            var defs = this.getDefs(false);
            if (!defs) return;
            var doms = this.getDoms();
            (0, parcelRequire("bahqM")).each(doms, function(dom) {
                if (_this.isDomUnused(dom)) defs.removeChild(dom);
            });
        };
        Definable.prototype.getSvgProxy = function(displayable) {
            if (displayable instanceof (0, (0, parcelRequire("ghQ8v")).default)) return 0, (0, parcelRequire("k0bb8")).path;
            else if (displayable instanceof (0, (0, parcelRequire("gcbBH")).default)) return 0, (0, parcelRequire("k0bb8")).image;
            else if (displayable instanceof (0, (0, parcelRequire("45jlh")).default)) return 0, (0, parcelRequire("k0bb8")).text;
            else return 0, (0, parcelRequire("k0bb8")).path;
        };
        Definable.prototype.getSvgElement = function(displayable) {
            return displayable.__svgEl;
        };
        return Definable;
    }();
    var $78631c76dc8428b5$export$2e2bcd8739ae039 = $78631c76dc8428b5$var$Definable;
});
parcelRegister("k0bb8", function(module, exports) {
    $parcel$export(module.exports, "path", ()=>$e8fc7a90186e67dc$export$bb654e07daaf8c3a);
    $parcel$export(module.exports, "image", ()=>$e8fc7a90186e67dc$export$5c452ff88e35e47d);
    $parcel$export(module.exports, "text", ()=>$e8fc7a90186e67dc$export$6f093cfa640b7166);
    var $dE0Hq;
    var $gcbBH;
    var $b7ZX8;
    var $bahqM;
    var $cpB91;
    var $e8fc7a90186e67dc$var$NONE = 'none';
    var $e8fc7a90186e67dc$var$mathRound = Math.round;
    var $e8fc7a90186e67dc$var$mathSin = Math.sin;
    var $e8fc7a90186e67dc$var$mathCos = Math.cos;
    var $e8fc7a90186e67dc$var$PI = Math.PI;
    var $e8fc7a90186e67dc$var$PI2 = Math.PI * 2;
    var $e8fc7a90186e67dc$var$degree = 180 / $e8fc7a90186e67dc$var$PI;
    var $e8fc7a90186e67dc$var$EPSILON = 1e-4;
    function $e8fc7a90186e67dc$var$round3(val) {
        return $e8fc7a90186e67dc$var$mathRound(val * 1e3) / 1e3;
    }
    function $e8fc7a90186e67dc$var$round4(val) {
        return $e8fc7a90186e67dc$var$mathRound(val * 1e4) / 1e4;
    }
    function $e8fc7a90186e67dc$var$isAroundZero(val) {
        return val < $e8fc7a90186e67dc$var$EPSILON && val > -$e8fc7a90186e67dc$var$EPSILON;
    }
    function $e8fc7a90186e67dc$var$pathHasFill(style) {
        var fill = style.fill;
        return fill != null && fill !== $e8fc7a90186e67dc$var$NONE;
    }
    function $e8fc7a90186e67dc$var$pathHasStroke(style) {
        var stroke = style.stroke;
        return stroke != null && stroke !== $e8fc7a90186e67dc$var$NONE;
    }
    function $e8fc7a90186e67dc$var$setTransform(svgEl, m) {
        if (m) $e8fc7a90186e67dc$var$attr(svgEl, 'transform', 'matrix(' + $e8fc7a90186e67dc$var$round3(m[0]) + ',' + $e8fc7a90186e67dc$var$round3(m[1]) + ',' + $e8fc7a90186e67dc$var$round3(m[2]) + ',' + $e8fc7a90186e67dc$var$round3(m[3]) + ',' + $e8fc7a90186e67dc$var$round4(m[4]) + ',' + $e8fc7a90186e67dc$var$round4(m[5]) + ')');
    }
    function $e8fc7a90186e67dc$var$attr(el, key, val) {
        if (!val || val.type !== 'linear' && val.type !== 'radial') el.setAttribute(key, val);
    }
    function $e8fc7a90186e67dc$var$attrXLink(el, key, val) {
        el.setAttributeNS('http://www.w3.org/1999/xlink', key, val);
    }
    function $e8fc7a90186e67dc$var$attrXML(el, key, val) {
        el.setAttributeNS('http://www.w3.org/XML/1998/namespace', key, val);
    }
    function $e8fc7a90186e67dc$var$bindStyle(svgEl, style, el) {
        var opacity = style.opacity == null ? 1 : style.opacity;
        if (el instanceof (0, (0, parcelRequire("gcbBH")).default)) {
            $e8fc7a90186e67dc$var$attr(svgEl, 'opacity', opacity + '');
            return;
        }
        if ($e8fc7a90186e67dc$var$pathHasFill(style)) {
            var fill = (0, (0, parcelRequire("dE0Hq")).normalizeColor)(style.fill);
            $e8fc7a90186e67dc$var$attr(svgEl, 'fill', fill.color);
            $e8fc7a90186e67dc$var$attr(svgEl, 'fill-opacity', (style.fillOpacity != null ? style.fillOpacity * fill.opacity * opacity : fill.opacity * opacity) + '');
        } else $e8fc7a90186e67dc$var$attr(svgEl, 'fill', $e8fc7a90186e67dc$var$NONE);
        if ($e8fc7a90186e67dc$var$pathHasStroke(style)) {
            var stroke = (0, (0, parcelRequire("dE0Hq")).normalizeColor)(style.stroke);
            $e8fc7a90186e67dc$var$attr(svgEl, 'stroke', stroke.color);
            var strokeWidth = style.lineWidth;
            var strokeScale_1 = style.strokeNoScale ? el.getLineScale() : 1;
            $e8fc7a90186e67dc$var$attr(svgEl, 'stroke-width', (strokeScale_1 ? strokeWidth / strokeScale_1 : 0) + '');
            $e8fc7a90186e67dc$var$attr(svgEl, 'paint-order', style.strokeFirst ? 'stroke' : 'fill');
            $e8fc7a90186e67dc$var$attr(svgEl, 'stroke-opacity', (style.strokeOpacity != null ? style.strokeOpacity * stroke.opacity * opacity : stroke.opacity * opacity) + '');
            var lineDash = style.lineDash && strokeWidth > 0 && (0, (0, parcelRequire("cpB91")).normalizeLineDash)(style.lineDash, strokeWidth);
            if (lineDash) {
                var lineDashOffset = style.lineDashOffset;
                if (strokeScale_1 && strokeScale_1 !== 1) {
                    lineDash = (0, (0, parcelRequire("bahqM")).map)(lineDash, function(rawVal) {
                        return rawVal / strokeScale_1;
                    });
                    if (lineDashOffset) {
                        lineDashOffset /= strokeScale_1;
                        lineDashOffset = $e8fc7a90186e67dc$var$mathRound(lineDashOffset);
                    }
                }
                $e8fc7a90186e67dc$var$attr(svgEl, 'stroke-dasharray', lineDash.join(','));
                $e8fc7a90186e67dc$var$attr(svgEl, 'stroke-dashoffset', (lineDashOffset || 0) + '');
            } else $e8fc7a90186e67dc$var$attr(svgEl, 'stroke-dasharray', $e8fc7a90186e67dc$var$NONE);
            style.lineCap && $e8fc7a90186e67dc$var$attr(svgEl, 'stroke-linecap', style.lineCap);
            style.lineJoin && $e8fc7a90186e67dc$var$attr(svgEl, 'stroke-linejoin', style.lineJoin);
            style.miterLimit && $e8fc7a90186e67dc$var$attr(svgEl, 'stroke-miterlimit', style.miterLimit + '');
        } else $e8fc7a90186e67dc$var$attr(svgEl, 'stroke', $e8fc7a90186e67dc$var$NONE);
    }
    var $e8fc7a90186e67dc$var$SVGPathRebuilder = function() {
        function SVGPathRebuilder() {}
        SVGPathRebuilder.prototype.reset = function() {
            this._d = [];
            this._str = '';
        };
        SVGPathRebuilder.prototype.moveTo = function(x, y) {
            this._add('M', x, y);
        };
        SVGPathRebuilder.prototype.lineTo = function(x, y) {
            this._add('L', x, y);
        };
        SVGPathRebuilder.prototype.bezierCurveTo = function(x, y, x2, y2, x3, y3) {
            this._add('C', x, y, x2, y2, x3, y3);
        };
        SVGPathRebuilder.prototype.quadraticCurveTo = function(x, y, x2, y2) {
            this._add('Q', x, y, x2, y2);
        };
        SVGPathRebuilder.prototype.arc = function(cx, cy, r, startAngle, endAngle, anticlockwise) {
            this.ellipse(cx, cy, r, r, 0, startAngle, endAngle, anticlockwise);
        };
        SVGPathRebuilder.prototype.ellipse = function(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise) {
            var firstCmd = this._d.length === 0;
            var dTheta = endAngle - startAngle;
            var clockwise = !anticlockwise;
            var dThetaPositive = Math.abs(dTheta);
            var isCircle = $e8fc7a90186e67dc$var$isAroundZero(dThetaPositive - $e8fc7a90186e67dc$var$PI2) || (clockwise ? dTheta >= $e8fc7a90186e67dc$var$PI2 : -dTheta >= $e8fc7a90186e67dc$var$PI2);
            var unifiedTheta = dTheta > 0 ? dTheta % $e8fc7a90186e67dc$var$PI2 : dTheta % $e8fc7a90186e67dc$var$PI2 + $e8fc7a90186e67dc$var$PI2;
            var large = false;
            if (isCircle) large = true;
            else if ($e8fc7a90186e67dc$var$isAroundZero(dThetaPositive)) large = false;
            else large = unifiedTheta >= $e8fc7a90186e67dc$var$PI === !!clockwise;
            var x0 = $e8fc7a90186e67dc$var$round4(cx + rx * $e8fc7a90186e67dc$var$mathCos(startAngle));
            var y0 = $e8fc7a90186e67dc$var$round4(cy + ry * $e8fc7a90186e67dc$var$mathSin(startAngle));
            if (isCircle) {
                if (clockwise) dTheta = $e8fc7a90186e67dc$var$PI2 - 1e-4;
                else dTheta = -$e8fc7a90186e67dc$var$PI2 + 1e-4;
                large = true;
                if (firstCmd) this._d.push('M', x0, y0);
            }
            var x = $e8fc7a90186e67dc$var$round4(cx + rx * $e8fc7a90186e67dc$var$mathCos(startAngle + dTheta));
            var y = $e8fc7a90186e67dc$var$round4(cy + ry * $e8fc7a90186e67dc$var$mathSin(startAngle + dTheta));
            if (isNaN(x0) || isNaN(y0) || isNaN(rx) || isNaN(ry) || isNaN(psi) || isNaN($e8fc7a90186e67dc$var$degree) || isNaN(x) || isNaN(y)) return '';
            this._d.push('A', $e8fc7a90186e67dc$var$round4(rx), $e8fc7a90186e67dc$var$round4(ry), $e8fc7a90186e67dc$var$mathRound(psi * $e8fc7a90186e67dc$var$degree), +large, +clockwise, x, y);
        };
        SVGPathRebuilder.prototype.rect = function(x, y, w, h) {
            this._add('M', x, y);
            this._add('L', x + w, y);
            this._add('L', x + w, y + h);
            this._add('L', x, y + h);
            this._add('L', x, y);
            this._add('Z');
        };
        SVGPathRebuilder.prototype.closePath = function() {
            if (this._d.length > 0) this._add('Z');
        };
        SVGPathRebuilder.prototype._add = function(cmd, a, b, c, d, e, f, g, h) {
            this._d.push(cmd);
            for(var i = 1; i < arguments.length; i++){
                var val = arguments[i];
                if (isNaN(val)) {
                    this._invalid = true;
                    return;
                }
                this._d.push($e8fc7a90186e67dc$var$round4(val));
            }
        };
        SVGPathRebuilder.prototype.generateStr = function() {
            this._str = this._invalid ? '' : this._d.join(' ');
            this._d = [];
        };
        SVGPathRebuilder.prototype.getStr = function() {
            return this._str;
        };
        return SVGPathRebuilder;
    }();
    var $e8fc7a90186e67dc$export$bb654e07daaf8c3a = {
        brush: function(el) {
            var style = el.style;
            var svgEl = el.__svgEl;
            if (!svgEl) {
                svgEl = (0, (0, parcelRequire("dE0Hq")).createElement)('path');
                el.__svgEl = svgEl;
            }
            if (!el.path) el.createPathProxy();
            var path = el.path;
            if (el.shapeChanged()) {
                path.beginPath();
                el.buildPath(path, el.shape);
                el.pathUpdated();
            }
            var pathVersion = path.getVersion();
            var elExt = el;
            var svgPathBuilder = elExt.__svgPathBuilder;
            if (elExt.__svgPathVersion !== pathVersion || !svgPathBuilder || el.style.strokePercent < 1) {
                if (!svgPathBuilder) svgPathBuilder = elExt.__svgPathBuilder = new $e8fc7a90186e67dc$var$SVGPathRebuilder();
                svgPathBuilder.reset();
                path.rebuildPath(svgPathBuilder, el.style.strokePercent);
                svgPathBuilder.generateStr();
                elExt.__svgPathVersion = pathVersion;
            }
            $e8fc7a90186e67dc$var$attr(svgEl, 'd', svgPathBuilder.getStr());
            $e8fc7a90186e67dc$var$bindStyle(svgEl, style, el);
            $e8fc7a90186e67dc$var$setTransform(svgEl, el.transform);
        }
    };
    var $e8fc7a90186e67dc$export$5c452ff88e35e47d = {
        brush: function(el) {
            var style = el.style;
            var image = style.image;
            if (image instanceof HTMLImageElement) image = image.src;
            else if (image instanceof HTMLCanvasElement) image = image.toDataURL();
            if (!image) return;
            var x = style.x || 0;
            var y = style.y || 0;
            var dw = style.width;
            var dh = style.height;
            var svgEl = el.__svgEl;
            if (!svgEl) {
                svgEl = (0, (0, parcelRequire("dE0Hq")).createElement)('image');
                el.__svgEl = svgEl;
            }
            if (image !== el.__imageSrc) {
                $e8fc7a90186e67dc$var$attrXLink(svgEl, 'href', image);
                el.__imageSrc = image;
            }
            $e8fc7a90186e67dc$var$attr(svgEl, 'width', dw + '');
            $e8fc7a90186e67dc$var$attr(svgEl, 'height', dh + '');
            $e8fc7a90186e67dc$var$attr(svgEl, 'x', x + '');
            $e8fc7a90186e67dc$var$attr(svgEl, 'y', y + '');
            $e8fc7a90186e67dc$var$bindStyle(svgEl, style, el);
            $e8fc7a90186e67dc$var$setTransform(svgEl, el.transform);
        }
    };
    var $e8fc7a90186e67dc$var$TEXT_ALIGN_TO_ANCHOR = {
        left: 'start',
        right: 'end',
        center: 'middle',
        middle: 'middle'
    };
    function $e8fc7a90186e67dc$var$adjustTextY(y, lineHeight, textBaseline) {
        if (textBaseline === 'top') y += lineHeight / 2;
        else if (textBaseline === 'bottom') y -= lineHeight / 2;
        return y;
    }
    var $e8fc7a90186e67dc$export$6f093cfa640b7166 = {
        brush: function(el) {
            var style = el.style;
            var text = style.text;
            text != null && (text += '');
            if (!text || isNaN(style.x) || isNaN(style.y)) return;
            var textSvgEl = el.__svgEl;
            if (!textSvgEl) {
                textSvgEl = (0, (0, parcelRequire("dE0Hq")).createElement)('text');
                $e8fc7a90186e67dc$var$attrXML(textSvgEl, 'xml:space', 'preserve');
                el.__svgEl = textSvgEl;
            }
            var font = style.font || (0, (0, parcelRequire("b7ZX8")).DEFAULT_FONT);
            var textSvgElStyle = textSvgEl.style;
            textSvgElStyle.font = font;
            textSvgEl.textContent = text;
            $e8fc7a90186e67dc$var$bindStyle(textSvgEl, style, el);
            $e8fc7a90186e67dc$var$setTransform(textSvgEl, el.transform);
            var x = style.x || 0;
            var y = $e8fc7a90186e67dc$var$adjustTextY(style.y || 0, (0, (0, parcelRequire("b7ZX8")).getLineHeight)(font), style.textBaseline);
            var textAlign = $e8fc7a90186e67dc$var$TEXT_ALIGN_TO_ANCHOR[style.textAlign] || style.textAlign;
            $e8fc7a90186e67dc$var$attr(textSvgEl, 'dominant-baseline', 'central');
            $e8fc7a90186e67dc$var$attr(textSvgEl, 'text-anchor', textAlign);
            $e8fc7a90186e67dc$var$attr(textSvgEl, 'x', x + '');
            $e8fc7a90186e67dc$var$attr(textSvgEl, 'y', y + '');
        }
    };
});
parcelRegister("brSrY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$855c73ff662bd5dc$export$2e2bcd8739ae039);
    var $3VFsf;
    var $akOIm;
    var $bahqM;
    var $63nvx;
    var $822uQ;
    function $855c73ff662bd5dc$var$isPattern(value) {
        return value && (!!value.image || !!value.svgElement);
    }
    var $855c73ff662bd5dc$var$patternDomMap = new (0, (0, parcelRequire("822uQ")).default)();
    var $855c73ff662bd5dc$var$PatternManager = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(PatternManager, _super);
        function PatternManager(zrId, svgRoot) {
            return _super.call(this, zrId, svgRoot, [
                'pattern'
            ], '__pattern_in_use__') || this;
        }
        PatternManager.prototype.addWithoutUpdate = function(svgElement, displayable) {
            if (displayable && displayable.style) {
                var that_1 = this;
                (0, parcelRequire("bahqM")).each([
                    'fill',
                    'stroke'
                ], function(fillOrStroke) {
                    var pattern = displayable.style[fillOrStroke];
                    if ($855c73ff662bd5dc$var$isPattern(pattern)) {
                        var defs = that_1.getDefs(true);
                        var dom = $855c73ff662bd5dc$var$patternDomMap.get(pattern);
                        if (dom) {
                            if (!defs.contains(dom)) that_1.addDom(dom);
                        } else dom = that_1.add(pattern);
                        that_1.markUsed(displayable);
                        var id = dom.getAttribute('id');
                        svgElement.setAttribute(fillOrStroke, 'url(#' + id + ')');
                    }
                });
            }
        };
        PatternManager.prototype.add = function(pattern) {
            if (!$855c73ff662bd5dc$var$isPattern(pattern)) return;
            var dom = this.createElement('pattern');
            pattern.id = pattern.id == null ? this.nextId++ : pattern.id;
            dom.setAttribute('id', 'zr' + this._zrId + '-pattern-' + pattern.id);
            dom.setAttribute('x', '0');
            dom.setAttribute('y', '0');
            dom.setAttribute('patternUnits', 'userSpaceOnUse');
            this.updateDom(pattern, dom);
            this.addDom(dom);
            return dom;
        };
        PatternManager.prototype.update = function(pattern) {
            if (!$855c73ff662bd5dc$var$isPattern(pattern)) return;
            var that = this;
            this.doUpdate(pattern, function() {
                var dom = $855c73ff662bd5dc$var$patternDomMap.get(pattern);
                that.updateDom(pattern, dom);
            });
        };
        PatternManager.prototype.updateDom = function(pattern, patternDom) {
            var svgElement = pattern.svgElement;
            if (svgElement instanceof SVGElement) {
                if (svgElement.parentNode !== patternDom) {
                    patternDom.innerHTML = '';
                    patternDom.appendChild(svgElement);
                    patternDom.setAttribute('width', pattern.svgWidth + '');
                    patternDom.setAttribute('height', pattern.svgHeight + '');
                }
            } else {
                var img = void 0;
                var prevImage = patternDom.getElementsByTagName('image');
                if (prevImage.length) {
                    if (pattern.image) img = prevImage[0];
                    else {
                        patternDom.removeChild(prevImage[0]);
                        return;
                    }
                } else if (pattern.image) img = this.createElement('image');
                if (img) {
                    var imageSrc = void 0;
                    var patternImage = pattern.image;
                    if (typeof patternImage === 'string') imageSrc = patternImage;
                    else if (patternImage instanceof HTMLImageElement) imageSrc = patternImage.src;
                    else if (patternImage instanceof HTMLCanvasElement) imageSrc = patternImage.toDataURL();
                    if (imageSrc) {
                        img.setAttribute('href', imageSrc);
                        img.setAttribute('x', '0');
                        img.setAttribute('y', '0');
                        var hostEl = {
                            dirty: function() {}
                        };
                        var createdImage = (0, (0, parcelRequire("63nvx")).createOrUpdateImage)(imageSrc, img, hostEl, function(img) {
                            patternDom.setAttribute('width', img.width + '');
                            patternDom.setAttribute('height', img.height + '');
                        });
                        if (createdImage && createdImage.width && createdImage.height) {
                            patternDom.setAttribute('width', createdImage.width + '');
                            patternDom.setAttribute('height', createdImage.height + '');
                        }
                        patternDom.appendChild(img);
                    }
                }
            }
            var x = pattern.x || 0;
            var y = pattern.y || 0;
            var rotation = (pattern.rotation || 0) / Math.PI * 180;
            var scaleX = pattern.scaleX || 1;
            var scaleY = pattern.scaleY || 1;
            var transform = "translate(" + x + ", " + y + ") rotate(" + rotation + ") scale(" + scaleX + ", " + scaleY + ")";
            patternDom.setAttribute('patternTransform', transform);
            $855c73ff662bd5dc$var$patternDomMap.set(pattern, patternDom);
        };
        PatternManager.prototype.markUsed = function(displayable) {
            if (displayable.style) {
                if ($855c73ff662bd5dc$var$isPattern(displayable.style.fill)) _super.prototype.markDomUsed.call(this, $855c73ff662bd5dc$var$patternDomMap.get(displayable.style.fill));
                if ($855c73ff662bd5dc$var$isPattern(displayable.style.stroke)) _super.prototype.markDomUsed.call(this, $855c73ff662bd5dc$var$patternDomMap.get(displayable.style.stroke));
            }
        };
        return PatternManager;
    }((0, (0, parcelRequire("akOIm")).default));
    var $855c73ff662bd5dc$export$2e2bcd8739ae039 = $855c73ff662bd5dc$var$PatternManager;
});
parcelRegister("i53xG", function(module, exports) {
    $parcel$export(module.exports, "hasClipPath", ()=>$d29b710c2ddb799a$export$3918818844b1239b);
    $parcel$export(module.exports, "default", ()=>$d29b710c2ddb799a$export$2e2bcd8739ae039);
    var $3VFsf;
    var $akOIm;
    var $bahqM;
    var $dPYp9;
    function $d29b710c2ddb799a$var$generateClipPathsKey(clipPaths) {
        var key = [];
        if (clipPaths) for(var i = 0; i < clipPaths.length; i++){
            var clipPath = clipPaths[i];
            key.push(clipPath.id);
        }
        return key.join(',');
    }
    function $d29b710c2ddb799a$export$3918818844b1239b(displayable) {
        var clipPaths = displayable.__clipPaths;
        return clipPaths && clipPaths.length > 0;
    }
    var $d29b710c2ddb799a$var$ClippathManager = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ClippathManager, _super);
        function ClippathManager(zrId, svgRoot) {
            var _this = _super.call(this, zrId, svgRoot, 'clipPath', '__clippath_in_use__') || this;
            _this._refGroups = {};
            _this._keyDuplicateCount = {};
            return _this;
        }
        ClippathManager.prototype.markAllUnused = function() {
            _super.prototype.markAllUnused.call(this);
            var refGroups = this._refGroups;
            for(var key in refGroups)if (refGroups.hasOwnProperty(key)) this.markDomUnused(refGroups[key]);
            this._keyDuplicateCount = {};
        };
        ClippathManager.prototype._getClipPathGroup = function(displayable, prevDisplayable) {
            if (!$d29b710c2ddb799a$export$3918818844b1239b(displayable)) return;
            var clipPaths = displayable.__clipPaths;
            var keyDuplicateCount = this._keyDuplicateCount;
            var clipPathKey = $d29b710c2ddb799a$var$generateClipPathsKey(clipPaths);
            if ((0, (0, parcelRequire("dPYp9")).isClipPathChanged)(clipPaths, prevDisplayable && prevDisplayable.__clipPaths)) {
                keyDuplicateCount[clipPathKey] = keyDuplicateCount[clipPathKey] || 0;
                keyDuplicateCount[clipPathKey] && (clipPathKey += '-' + keyDuplicateCount[clipPathKey]);
                keyDuplicateCount[clipPathKey]++;
            }
            return this._refGroups[clipPathKey] || (this._refGroups[clipPathKey] = this.createElement('g'));
        };
        ClippathManager.prototype.update = function(displayable, prevDisplayable) {
            var clipGroup = this._getClipPathGroup(displayable, prevDisplayable);
            if (clipGroup) {
                this.markDomUsed(clipGroup);
                this.updateDom(clipGroup, displayable.__clipPaths);
            }
            return clipGroup;
        };
        ClippathManager.prototype.updateDom = function(parentEl, clipPaths) {
            if (clipPaths && clipPaths.length > 0) {
                var defs = this.getDefs(true);
                var clipPath = clipPaths[0];
                var clipPathEl = void 0;
                var id = void 0;
                if (clipPath._dom) {
                    id = clipPath._dom.getAttribute('id');
                    clipPathEl = clipPath._dom;
                    if (!defs.contains(clipPathEl)) defs.appendChild(clipPathEl);
                } else {
                    id = 'zr' + this._zrId + '-clip-' + this.nextId;
                    ++this.nextId;
                    clipPathEl = this.createElement('clipPath');
                    clipPathEl.setAttribute('id', id);
                    defs.appendChild(clipPathEl);
                    clipPath._dom = clipPathEl;
                }
                var svgProxy = this.getSvgProxy(clipPath);
                svgProxy.brush(clipPath);
                var pathEl = this.getSvgElement(clipPath);
                clipPathEl.innerHTML = '';
                clipPathEl.appendChild(pathEl);
                parentEl.setAttribute('clip-path', 'url(#' + id + ')');
                if (clipPaths.length > 1) this.updateDom(clipPathEl, clipPaths.slice(1));
            } else if (parentEl) parentEl.setAttribute('clip-path', 'none');
        };
        ClippathManager.prototype.markUsed = function(displayable) {
            var _this = this;
            if (displayable.__clipPaths) (0, parcelRequire("bahqM")).each(displayable.__clipPaths, function(clipPath) {
                if (clipPath._dom) _super.prototype.markDomUsed.call(_this, clipPath._dom);
            });
        };
        ClippathManager.prototype.removeUnused = function() {
            _super.prototype.removeUnused.call(this);
            var newRefGroupsMap = {};
            var refGroups = this._refGroups;
            for(var key in refGroups)if (refGroups.hasOwnProperty(key)) {
                var group = refGroups[key];
                if (!this.isDomUnused(group)) newRefGroupsMap[key] = group;
                else if (group.parentNode) group.parentNode.removeChild(group);
            }
            this._refGroups = newRefGroupsMap;
        };
        return ClippathManager;
    }((0, (0, parcelRequire("akOIm")).default));
    var $d29b710c2ddb799a$export$2e2bcd8739ae039 = $d29b710c2ddb799a$var$ClippathManager;
});
parcelRegister("b6V4m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$816c8609515aa333$export$2e2bcd8739ae039);
    var $3VFsf;
    var $akOIm;
    var $dE0Hq;
    var $816c8609515aa333$var$ShadowManager = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ShadowManager, _super);
        function ShadowManager(zrId, svgRoot) {
            var _this = _super.call(this, zrId, svgRoot, [
                'filter'
            ], '__filter_in_use__', '_shadowDom') || this;
            _this._shadowDomMap = {};
            _this._shadowDomPool = [];
            return _this;
        }
        ShadowManager.prototype._getFromPool = function() {
            var shadowDom = this._shadowDomPool.pop();
            if (!shadowDom) {
                shadowDom = this.createElement('filter');
                shadowDom.setAttribute('id', 'zr' + this._zrId + '-shadow-' + this.nextId++);
                var domChild = this.createElement('feDropShadow');
                shadowDom.appendChild(domChild);
                this.addDom(shadowDom);
            }
            return shadowDom;
        };
        ShadowManager.prototype.update = function(svgElement, displayable) {
            var style = displayable.style;
            if ($816c8609515aa333$var$hasShadow(style)) {
                var shadowKey = $816c8609515aa333$var$getShadowKey(displayable);
                var shadowDom = displayable._shadowDom = this._shadowDomMap[shadowKey];
                if (!shadowDom) {
                    shadowDom = this._getFromPool();
                    this._shadowDomMap[shadowKey] = shadowDom;
                }
                this.updateDom(svgElement, displayable, shadowDom);
            } else this.remove(svgElement, displayable);
        };
        ShadowManager.prototype.remove = function(svgElement, displayable) {
            if (displayable._shadowDom != null) {
                displayable._shadowDom = null;
                svgElement.removeAttribute('filter');
            }
        };
        ShadowManager.prototype.updateDom = function(svgElement, displayable, shadowDom) {
            var domChild = shadowDom.children[0];
            var style = displayable.style;
            var globalScale = displayable.getGlobalScale();
            var scaleX = globalScale[0];
            var scaleY = globalScale[1];
            if (!scaleX || !scaleY) return;
            var offsetX = style.shadowOffsetX || 0;
            var offsetY = style.shadowOffsetY || 0;
            var blur = style.shadowBlur;
            var normalizedColor = (0, (0, parcelRequire("dE0Hq")).normalizeColor)(style.shadowColor);
            domChild.setAttribute('dx', offsetX / scaleX + '');
            domChild.setAttribute('dy', offsetY / scaleY + '');
            domChild.setAttribute('flood-color', normalizedColor.color);
            domChild.setAttribute('flood-opacity', normalizedColor.opacity + '');
            var stdDx = blur / 2 / scaleX;
            var stdDy = blur / 2 / scaleY;
            var stdDeviation = stdDx + ' ' + stdDy;
            domChild.setAttribute('stdDeviation', stdDeviation);
            shadowDom.setAttribute('x', '-100%');
            shadowDom.setAttribute('y', '-100%');
            shadowDom.setAttribute('width', '300%');
            shadowDom.setAttribute('height', '300%');
            displayable._shadowDom = shadowDom;
            var id = shadowDom.getAttribute('id');
            svgElement.setAttribute('filter', 'url(#' + id + ')');
        };
        ShadowManager.prototype.removeUnused = function() {
            var defs = this.getDefs(false);
            if (!defs) return;
            var shadowDomsPool = this._shadowDomPool;
            var shadowDomMap = this._shadowDomMap;
            for(var key in shadowDomMap)if (shadowDomMap.hasOwnProperty(key)) shadowDomsPool.push(shadowDomMap[key]);
            this._shadowDomMap = {};
        };
        return ShadowManager;
    }((0, (0, parcelRequire("akOIm")).default));
    var $816c8609515aa333$export$2e2bcd8739ae039 = $816c8609515aa333$var$ShadowManager;
    function $816c8609515aa333$var$hasShadow(style) {
        return style && (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY);
    }
    function $816c8609515aa333$var$getShadowKey(displayable) {
        var style = displayable.style;
        var globalScale = displayable.getGlobalScale();
        return [
            style.shadowColor,
            (style.shadowBlur || 0).toFixed(2),
            (style.shadowOffsetX || 0).toFixed(2),
            (style.shadowOffsetY || 0).toFixed(2),
            globalScale[0],
            globalScale[1]
        ].join(',');
    }
});
parcelRegister("8Q4sF", function(module, exports) {
    $parcel$export(module.exports, "FormattedI18nMessage", ()=>$7c8c20575fbc9bfc$export$200d7bd7633253ce);
    var $5uXOq = parcelRequire("5uXOq");
    var $gHDlh;
    var $9Byym;
    const $7c8c20575fbc9bfc$export$200d7bd7633253ce = (props)=>{
        const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
        const messageParts = (0, $5uXOq.useMemo)(()=>{
            const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, (0, parcelRequire("9Byym")).getTags)(componentsMapping);
            try {
                const parts = [];
                let token = '';
                let TagComponent;
                let closeTagLookup;
                for(let i = 0; i < message.length; i += 1){
                    const letter = message[i];
                    token += letter;
                    if ((0, (0, parcelRequire("9Byym")).isCloseTagDelimiter)(letter)) {
                        const firstTagFound = (0, (0, parcelRequire("9Byym")).findTag)(token, {
                            tags: openTags
                        });
                        if (firstTagFound !== null && firstTagFound !== undefined) {
                            if (TagComponent) throw new (0, (0, parcelRequire("gHDlh")).MalformedMessageError)();
                            const text = token.replace(firstTagFound, '');
                            parts.push(text);
                            const tagInfo = tags[firstTagFound];
                            TagComponent = tagInfo.component;
                            closeTagLookup = tagInfo.close;
                            token = '';
                        }
                    }
                    if (closeTagLookup !== null && closeTagLookup !== undefined && (0, (0, parcelRequire("9Byym")).isCloseTagDelimiter)(letter) && (0, (0, parcelRequire("9Byym")).isAnyTag)(token, {
                        tags: [
                            closeTagLookup
                        ]
                    })) {
                        if (!TagComponent) throw new (0, (0, parcelRequire("gHDlh")).MalformedMessageError)();
                        const text = token.replace(closeTagLookup, '');
                        parts.push((0, ($parcel$interopDefault($5uXOq))).createElement(TagComponent, null, text));
                        TagComponent = undefined;
                        token = '';
                        closeTagLookup = undefined;
                    }
                    if ((0, (0, parcelRequire("9Byym")).isCloseTagDelimiter)(letter) && (0, (0, parcelRequire("9Byym")).isAnyTag)(token, {
                        tags: closeTags
                    })) {
                        if (!TagComponent) throw new (0, (0, parcelRequire("gHDlh")).MalformedMessageError)();
                    }
                }
                if (TagComponent || closeTagLookup) throw new (0, (0, parcelRequire("gHDlh")).MalformedMessageError)();
                if (token.length > 0) parts.push(token);
                return parts;
            } catch (e) {
                if (e instanceof (0, (0, parcelRequire("gHDlh")).MalformedMessageError)) {
                    (0, (0, parcelRequire("gHDlh")).logMalformedMessageError)({
                        message: message,
                        packageName: packageName
                    });
                    return [
                        (0, (0, parcelRequire("gHDlh")).getMalformedMessage)({
                            message: message,
                            closeTags: closeTags,
                            openTags: openTags
                        })
                    ];
                }
                throw e;
            }
        }, [
            message,
            packageName,
            componentsMapping
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, messageParts.map((item, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                key: index
            }, item)));
    };
});
parcelRegister("gHDlh", function(module, exports) {
    $parcel$export(module.exports, "getMalformedMessage", ()=>$ecff24857c176a60$export$f085cf20ec1f69ab);
    $parcel$export(module.exports, "logMalformedMessageError", ()=>$ecff24857c176a60$export$954c3e6aad1c9429);
    $parcel$export(module.exports, "MalformedMessageError", ()=>$ecff24857c176a60$export$40d900e818b9630e);
    var $dJl1T;
    var $jcw0u;
    const $ecff24857c176a60$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
            ...openTags,
            ...closeTags
        ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
    const $ecff24857c176a60$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
        if (packageName !== null && packageName !== undefined) {
            const errorMessage = `Malformed message: ${message}`;
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    packageName: packageName,
                    id: (0, $5514815b06163219$export$f3390a0e172fee41)
                },
                attributes: {
                    message: errorMessage
                }
            });
            const location = `${packageName}.${(0, $5514815b06163219$export$f3390a0e172fee41)}`;
            (0, (0, parcelRequire("dJl1T")).default).unsafeErrorWithCustomerData(location, errorMessage);
        }
    };
    class $ecff24857c176a60$export$40d900e818b9630e extends Error {
        constructor(){
            super('Malformed i18n message');
        }
    }
});
const $5514815b06163219$export$f3390a0e172fee41 = 'formattedI18NMessage';
parcelRegister("9Byym", function(module, exports) {
    $parcel$export(module.exports, "getTags", ()=>$84498158f946a67b$export$af63d7414243dad3);
    $parcel$export(module.exports, "isAnyTag", ()=>$84498158f946a67b$export$38ffa64fc639355f);
    $parcel$export(module.exports, "findTag", ()=>$84498158f946a67b$export$dfca0f74034f8657);
    $parcel$export(module.exports, "isCloseTagDelimiter", ()=>$84498158f946a67b$export$d5170904651e91b1);
    const $84498158f946a67b$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce((acc, [key, value])=>{
            const open = `{${key}Start}`;
            const close = `{${key}End}`;
            acc.tags[open] = {
                close: close,
                component: value
            };
            acc.openTags.push(open);
            acc.closeTags.push(close);
            return acc;
        }, {
            tags: {},
            openTags: [],
            closeTags: []
        });
    const $84498158f946a67b$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
    const $84498158f946a67b$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
    const $84498158f946a67b$export$d5170904651e91b1 = (letter)=>letter === (0, $7ed9c0b663db8b35$export$a10c567c3288a6b4);
});
const $7ed9c0b663db8b35$export$a10c567c3288a6b4 = '}';
parcelRegister("j29sr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f159de5a54539b9e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f159de5a54539b9e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "business-summary.summary-view.breakdown-by-priority.title",
            "defaultMessage": "Priority breakdown"
        },
        description: {
            "id": "business-summary.summary-view.breakdown-by-priority.description",
            "defaultMessage": "Get a holistic view of how work is being prioritized. {linkStart}See what your team's been focusing on{linkEnd}"
        },
        descriptionWhenEmpty: {
            "id": "business-summary.summary-view.breakdown-by-priority.description-when-empty",
            "defaultMessage": "You'll need to create a few items before you can start prioritizing work."
        },
        noPriorityLabel: {
            "id": "business-summary.summary-view.breakdown-by-priority.no-priority-label",
            "defaultMessage": "None"
        },
        morePrioritiesLabel: {
            "id": "business-summary.summary-view.breakdown-by-priority.more-priorities-label",
            "defaultMessage": "More"
        }
    });
});
parcelRegister("dN9tk", function(module, exports) {
    $parcel$export(module.exports, "Description", ()=>$ce4a4cb702dd34f9$export$393edc798c47379d);
    $parcel$export(module.exports, "StyledSkeleton", ()=>$ce4a4cb702dd34f9$export$e4ecddc59e33f387);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $liytA;
    const $ce4a4cb702dd34f9$export$393edc798c47379d = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                __cmplp.className
            ])
        });
    });
    const $ce4a4cb702dd34f9$export$e4ecddc59e33f387 = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("liytA")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkpxbi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("liytA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$95226c0a96ca49bb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $95226c0a96ca49bb$var$Skeleton = ({ className: className, testId: testId })=>{
        const skeletonColor = `var(--ds-skeleton, ${(0, $72ba03e317f3d228$export$8d43898f60b96a82)})`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            className: className,
            fill: "none",
            preserveAspectRatio: "none",
            viewBox: "0 0 476 328",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            y: "0",
            width: "476",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            y: "16",
            width: "320",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            y: "32",
            width: "48",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            y: "72",
            width: "20",
            height: "20",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "28",
            y: "81",
            width: "443",
            height: "2",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            y: "120",
            width: "20",
            height: "20",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "28",
            y: "129",
            width: "443",
            height: "2",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            y: "168",
            width: "20",
            height: "20",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "28",
            y: "177",
            width: "443",
            height: "2",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            y: "216",
            width: "20",
            height: "20",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "28",
            y: "225",
            width: "443",
            height: "2",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            y: "264",
            width: "20",
            height: "20",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "28",
            y: "273",
            width: "443",
            height: "2",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "50",
            y: "296",
            width: "32",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "106",
            y: "296",
            width: "32",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "162",
            y: "296",
            width: "32",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "218",
            y: "296",
            width: "32",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "274",
            y: "296",
            width: "32",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "330",
            y: "296",
            width: "32",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "386",
            y: "296",
            width: "32",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "442",
            y: "296",
            width: "32",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }));
    };
    var $95226c0a96ca49bb$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($95226c0a96ca49bb$var$Skeleton);
});
parcelRegister("6mpCV", function(module, exports) {
    $parcel$export(module.exports, "buildChartData", ()=>$bd56bf6a8c75f6c6$export$bbcf2eea793fdd45);
    var $5uXOq = parcelRequire("5uXOq");
    var $9nYxs;
    var $jjkOL;
    var $gwIPs;
    var $j29sr;
    const $bd56bf6a8c75f6c6$var$KNOWN_PRIORITY_BAR_COLORS = {
        Highest: (0, $72ba03e317f3d228$export$2010d0fb4295b346),
        High: (0, $72ba03e317f3d228$export$60847d42f9da92a6),
        Medium: (0, $72ba03e317f3d228$export$c6930421db9fa514),
        Low: (0, $72ba03e317f3d228$export$ecfc1dff386a3e7a),
        Lowest: (0, $72ba03e317f3d228$export$e62e8919cca44969),
        None: (0, $72ba03e317f3d228$export$d6447c357493214f)
    };
    const $bd56bf6a8c75f6c6$var$OTHER_BAR_COLORS = [
        (0, $72ba03e317f3d228$export$940e1f69e873f202),
        (0, $72ba03e317f3d228$export$9dc1ef0f3f48059b),
        (0, $72ba03e317f3d228$export$b48405b95304b5a1),
        (0, $72ba03e317f3d228$export$4a7404f376229999)
    ];
    const $bd56bf6a8c75f6c6$var$MAX_BARS = 8;
    const $bd56bf6a8c75f6c6$var$createFilterUrlFromPriorities = (issuesLinkUrl, ...priorities)=>{
        if (priorities.length === 0) return '';
        const escapedPriorities = priorities.map((priority)=>priority == null ? 'EMPTY' : `'${priority.split("'").join("\\'")}'`);
        let filter;
        if (priorities.length === 1) filter = encodeURIComponent(`${(0, $cd053842fd66588d$export$c49e48bfa75ab23c)} AND priority = ${escapedPriorities[0]}`);
        else filter = encodeURIComponent(`${(0, $cd053842fd66588d$export$c49e48bfa75ab23c)} AND priority in (${escapedPriorities.join(',')})`);
        return `${issuesLinkUrl}?filter=${filter}`;
    };
    const $bd56bf6a8c75f6c6$var$createYAxisPoint = (value, color)=>({
            itemStyle: {
                color: color
            },
            value: value
        });
    const $bd56bf6a8c75f6c6$export$bbcf2eea793fdd45 = (priorityGroupData, formatMessage, issuesLinkUrl)=>{
        if (priorityGroupData == null) return null;
        const option = {
            grid: {
                left: (0, $9a5b1000afa9b618$export$e6b9649c5bb30e80),
                right: 0,
                top: 30,
                bottom: 10
            },
            xAxis: {
                axisLabel: {
                    interval: 0,
                    show: false
                },
                axisLine: {
                    show: false
                },
                axisTick: {
                    show: false
                },
                data: [],
                type: 'category'
            },
            yAxis: {
                axisLabel: {
                    color: `var(--ds-text-subtlest, ${(0, $72ba03e317f3d228$export$d6447c357493214f)})`,
                    fontFamily: (0, parcelRequire("gwIPs")).fontFamily
                },
                max: undefined,
                min: undefined,
                minInterval: 1,
                splitLine: {
                    lineStyle: {
                        color: `var(--ds-border-disabled, ${(0, $72ba03e317f3d228$export$3e51e8f1440314ba)})`,
                        width: 2
                    }
                },
                type: 'value'
            },
            series: [
                {
                    animation: false,
                    barWidth: '50%',
                    data: [],
                    type: 'bar',
                    emphasis: {
                        itemStyle: {
                            color: 'inherit',
                            opacity: 0.9
                        }
                    }
                }
            ]
        };
        const filterUrls = [];
        const xAxisPoints = [];
        const yAxisPoints = [];
        let colors = [
            ...$bd56bf6a8c75f6c6$var$OTHER_BAR_COLORS
        ];
        let totalCount = 0;
        let priorityGroups;
        let otherGroups;
        if (priorityGroupData.length <= $bd56bf6a8c75f6c6$var$MAX_BARS) priorityGroups = priorityGroupData;
        else {
            priorityGroups = priorityGroupData.slice(0, $bd56bf6a8c75f6c6$var$MAX_BARS - 1);
            otherGroups = priorityGroupData.slice($bd56bf6a8c75f6c6$var$MAX_BARS - 1);
        }
        priorityGroups.forEach((priorityGroup)=>{
            const { count: count, priority: { iconUrl: iconUrl, name: name } } = priorityGroup;
            if (colors.length === 0) colors = [
                ...$bd56bf6a8c75f6c6$var$OTHER_BAR_COLORS
            ];
            const filterUrl = $bd56bf6a8c75f6c6$var$createFilterUrlFromPriorities(issuesLinkUrl, name);
            filterUrls.push(filterUrl);
            const xAxisName = name || formatMessage((0, (0, parcelRequire("j29sr")).default).noPriorityLabel);
            const noPriorityIcon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9nYxs"))))), {
                label: "",
                size: "medium",
                primaryColor: "var(--ds-text-subtle, #7A869A)"
            });
            const xAxisPointIcon = iconUrl || noPriorityIcon;
            const barColor = $bd56bf6a8c75f6c6$var$KNOWN_PRIORITY_BAR_COLORS[xAxisName] || colors.pop();
            xAxisPoints.push({
                icon: xAxisPointIcon,
                filterUrl: filterUrl,
                name: xAxisName,
                count: count
            });
            yAxisPoints.push($bd56bf6a8c75f6c6$var$createYAxisPoint(count, barColor));
            totalCount += count;
        });
        if (otherGroups) {
            const xAxisName = formatMessage((0, (0, parcelRequire("j29sr")).default).morePrioritiesLabel);
            const barColor = (0, $72ba03e317f3d228$export$f563ee71e9ee74cd);
            const otherCount = otherGroups.reduce((countSoFar, { count: count })=>countSoFar + count, 0);
            const priorities = otherGroups.map(({ priority: { name: name } })=>name);
            const filterUrl = $bd56bf6a8c75f6c6$var$createFilterUrlFromPriorities(issuesLinkUrl, ...priorities);
            filterUrls.push(filterUrl);
            xAxisPoints.push({
                icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jjkOL"))))), {
                    label: "",
                    size: "medium",
                    primaryColor: "var(--ds-text-subtlest, #6b778c)"
                }),
                filterUrl: filterUrl,
                name: xAxisName,
                count: otherCount
            });
            yAxisPoints.push($bd56bf6a8c75f6c6$var$createYAxisPoint(otherCount, barColor));
            totalCount += otherCount;
        }
        if (totalCount === 0) {
            const { yAxis: yAxis } = option;
            yAxis.min = 0;
            yAxis.max = 5;
        }
        option.series[0].data = yAxisPoints;
        return {
            filterUrls: filterUrls,
            option: option,
            totalCount: totalCount,
            xAxisPoints: xAxisPoints
        };
    };
});
parcelRegister("9nYxs", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $6d5538bae992bf46$var$_react = $6d5538bae992bf46$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $6d5538bae992bf46$var$_minus = $6d5538bae992bf46$var$_interopRequireDefault((parcelRequire("eOWxw")));
    function $6d5538bae992bf46$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $6d5538bae992bf46$var$EditorHorizontalRuleIcon = (props)=>$6d5538bae992bf46$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><rect width="14" height="2" x="5" y="11" fill="currentcolor" fill-rule="evenodd" rx="1"/></svg>`
        }, props, {
            newIcon: $6d5538bae992bf46$var$_minus.default
        }));
    $6d5538bae992bf46$var$EditorHorizontalRuleIcon.displayName = 'EditorHorizontalRuleIcon';
    var $6d5538bae992bf46$var$_default = module.exports.default = $6d5538bae992bf46$var$EditorHorizontalRuleIcon;
});
parcelRegister("eOWxw", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $aca324f6ac1b369b$var$_react = $aca324f6ac1b369b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $aca324f6ac1b369b$var$_UNSAFE_baseNew = $aca324f6ac1b369b$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $aca324f6ac1b369b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $aca324f6ac1b369b$var$MinusIcon = (props)=>$aca324f6ac1b369b$var$_react.default.createElement($aca324f6ac1b369b$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M2 8h12"/>`
        }, props));
    $aca324f6ac1b369b$var$MinusIcon.displayName = 'MinusIcon';
    var $aca324f6ac1b369b$var$_default = module.exports.default = $aca324f6ac1b369b$var$MinusIcon;
});
parcelRegister("jjkOL", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e0eff0a840409e00$var$_react = $e0eff0a840409e00$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $e0eff0a840409e00$var$_showMoreHorizontal = $e0eff0a840409e00$var$_interopRequireDefault((parcelRequire("4mxtl")));
    function $e0eff0a840409e00$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e0eff0a840409e00$var$EditorMoreIcon = (props)=>$e0eff0a840409e00$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 14a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m-4.5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m9 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"/></svg>`
        }, props, {
            newIcon: $e0eff0a840409e00$var$_showMoreHorizontal.default
        }));
    $e0eff0a840409e00$var$EditorMoreIcon.displayName = 'EditorMoreIcon';
    var $e0eff0a840409e00$var$_default = module.exports.default = $e0eff0a840409e00$var$EditorMoreIcon;
});
const $cd053842fd66588d$export$d5aac1de7fafa2b0 = 'statusCategory = Done AND statusCategoryChangedDate >= -1w';
const $cd053842fd66588d$export$b10a33c38cc20983 = 'updatedDate >= -1w';
const $cd053842fd66588d$export$48eb4b4c930c6378 = 'createdDate >= -1w';
const $cd053842fd66588d$export$2573f5b8014b4068 = 'statusCategory != Done AND (duedate >= 0d AND duedate < 1w)';
const $cd053842fd66588d$export$8cca17e1017ba894 = '(statusCategory != Done OR (statusCategory = Done AND statusCategoryChangedDate >= -2w))';
const $cd053842fd66588d$export$c49e48bfa75ab23c = 'statusCategory != Done';
const $cd053842fd66588d$export$c0ecd9bd08a86184 = 8;
const $cd053842fd66588d$export$27f4fb65edc908d0 = `
  fragment IssuesByAssigneeFragment on JWMItemGroupConnection {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      field {
        ... on UserField {
          userValue {
            accountId,
            avatarUrl,
            displayName
          }
        }
      }
      id,
      totalCount
    }
  }
`;
const $cd053842fd66588d$export$5b2a5373659a0414 = `
  fragment IssuesByTypeFragment on JWMItemGroupConnection {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      field {
        ... on IssueTypeField {
              id
              name
              iconUrl
        }
      }
      id,
      totalCount
    }
  }
`;
const $9a5b1000afa9b618$export$e6b9649c5bb30e80 = 30;
parcelRegister("6r8in", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff84e3e60bebd1e9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $hDzhb;
    var $7TJr2;
    const $ff84e3e60bebd1e9$var$XAxis = ({ points: points, onClick: onClick })=>{
        const { linksTarget: linksTarget } = (0, (0, parcelRequire("7TJr2")).useSummaryFeatures)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ff84e3e60bebd1e9$var$AxisWrapper, null, points.map(({ icon: icon, filterUrl: filterUrl, name: name, count: count }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement($ff84e3e60bebd1e9$var$AxisItem, {
                key: index
            }, typeof icon === 'string' ? (0, ($parcel$interopDefault($5uXOq))).createElement($ff84e3e60bebd1e9$var$Image, {
                alt: "",
                src: icon
            }) : icon, (0, ($parcel$interopDefault($5uXOq))).createElement($ff84e3e60bebd1e9$var$PriorityLink, {
                href: filterUrl,
                target: linksTarget,
                onClick: ()=>onClick(count)
            }, name))));
    };
    var $ff84e3e60bebd1e9$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($ff84e3e60bebd1e9$var$XAxis);
    const $ff84e3e60bebd1e9$var$AxisWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c11p5 _1ejii47z _wij21bp4 _18u01ul9",
                __cmplp.className
            ])
        });
    });
    const $ff84e3e60bebd1e9$var$AxisItem = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $ff84e3e60bebd1e9$var$PriorityLink = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("hDzhb")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_p12f1osq _y3gn1h6o _1bto1l2s _o5721q9c _1reo15vq _18m915vq _k48pbfng _1wyb1crf _19pkv77o",
                __cmplp.className
            ])
        });
    });
    const $ff84e3e60bebd1e9$var$Image = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1tcg _1bsb1tcg",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("u3iGU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f69a83ef79cb3102$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $53NAg;
    var $jPxJ7;
    var $6cG4N;
    var $koVbs;
    var $22OQR;
    var $2YBIF;
    const $f69a83ef79cb3102$var$FEEDBACK_GROUP_ID = 'jwm-feedback-summary';
    const $f69a83ef79cb3102$var$FeedbackBanner = ({ isLoading: isLoading })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const buttonRef = (0, $5uXOq.useRef)(null);
        const openFeedbackModal = (0, (0, parcelRequire("jPxJ7")).useFeedbackCollector)();
        const onSubmitFeedbackClick = (0, $5uXOq.useCallback)(()=>{
            openFeedbackModal($f69a83ef79cb3102$var$FEEDBACK_GROUP_ID, (0, ($parcel$interopDefault($8Rkzz))), buttonRef);
        }, [
            openFeedbackModal
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($f69a83ef79cb3102$var$FeedbackBannerWrapper, {
            isLoading: isLoading,
            "data-testid": "business-summary.ui.summary-view.feedback-banner"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("53NAg"))))), {
            LEGACY_size: "medium",
            LEGACY_primaryColor: (0, (0, parcelRequire("6cG4N")).Tokens).COLOR_TEXT_SUBTLE,
            LEGACY_secondaryColor: (0, (0, parcelRequire("6cG4N")).Tokens).COLOR_ELEVATION_SURFACE,
            label: "",
            color: "currentColor"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($f69a83ef79cb3102$var$ParagraphWrapper, null, formatMessage((0, (0, parcelRequire("2YBIF")).default).inviteFeedbackMessage), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
            appearance: "link",
            spacing: "none",
            onClick: onSubmitFeedbackClick,
            ref: buttonRef
        }, formatMessage((0, (0, parcelRequire("2YBIF")).default).submitFeedbackCallToAction))));
    };
    var $f69a83ef79cb3102$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($f69a83ef79cb3102$var$FeedbackBanner);
    const $f69a83ef79cb3102$var$FeedbackBannerWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o _4cvr1h6o _18s8hzmq _syazfrbu _11q71iew _1yt418iy _2rkoiti9 _1bsb1ns9",
                __cmplp.isLoading ? "_3um015vq" : "_3um0ewfl",
                __cmplp.className
            ])
        });
    });
    const $f69a83ef79cb3102$var$ParagraphWrapper = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s8171m _vwz41tcg",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("53NAg", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3af3b1e9caa2bc0d$var$_react = $3af3b1e9caa2bc0d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3af3b1e9caa2bc0d$var$_information = $3af3b1e9caa2bc0d$var$_interopRequireDefault((parcelRequire("ee4ko")));
    var $3af3b1e9caa2bc0d$var$_info = $3af3b1e9caa2bc0d$var$_interopRequireDefault((parcelRequire("6Uj3U")));
    function $3af3b1e9caa2bc0d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3af3b1e9caa2bc0d$var$InformationIcon = (props)=>$3af3b1e9caa2bc0d$var$_react.default.createElement($3af3b1e9caa2bc0d$var$_information.default, Object.assign({
            LEGACY_fallbackIcon: $3af3b1e9caa2bc0d$var$_info.default
        }, props));
    $3af3b1e9caa2bc0d$var$InformationIcon.Name = 'InformationIconMigration';
    var $3af3b1e9caa2bc0d$var$_default = module.exports.default = $3af3b1e9caa2bc0d$var$InformationIcon;
});
parcelRegister("22OQR", function(module, exports) {
    $parcel$export(module.exports, "ThemedButton", ()=>$87e6157378e1cf19$export$f67fb575035cc7d0);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $4EETE;
    const $87e6157378e1cf19$export$f67fb575035cc7d0 = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(({ as: as, ...props }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($87e6157378e1cf19$var$CustomButton, {
            ...props,
            as: as,
            ref: ref
        })));
    const $87e6157378e1cf19$var$CustomButton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("4EETE")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1qt3kjry _1g9h1tex _1umfuwj9 _6l8r3x59 _9se5176f _12rallho _zk5uzt2a _18vg2zyf _192e1jcw _fnp717ga _1xjgvy9e _1u0u14e8 _17z218zq _7n83frbu _n2ul1jo4 _1cf1r7td _1d7c1ag4 _nwukvy9e _fsjd4zrn _z1i3eyly",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("2YBIF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3fc949edffc84954$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3fc949edffc84954$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        inviteFeedbackMessage: {
            "id": "business-summary.summary-view.feedback-banner.invite-feedback-message",
            "defaultMessage": "Was the information shown in this page useful? "
        },
        submitFeedbackCallToAction: {
            "id": "business-summary.summary-view.feedback-banner.submit-feedback-call-to-action",
            "defaultMessage": "Give us feedback"
        }
    });
});
parcelRegister("jtzbv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98db99f28774a83a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $54qG5;
    var $koVbs;
    var $3HwlS;
    var $cYlk7;
    var $l8ruj;
    var $dCm1o;
    var $7TJr2;
    var $6rHTj;
    var $lj6Bl;
    var $2nBWz;
    var $aXEqK;
    const $98db99f28774a83a$var$SummaryHeader = ({ isLoading: isLoading })=>{
        const { data: currentUserData, loading: isUserDataLoading } = (0, (0, parcelRequire("cYlk7")).useCurrentUser)();
        const { data: entity } = (0, (0, parcelRequire("54qG5")).useBusinessEntity)();
        const { hasShareButton: hasShareButton } = (0, (0, parcelRequire("7TJr2")).useSummaryFeatures)();
        const userName = currentUserData?.user?.displayName;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { emoji: emoji, message: message } = (0, (0, parcelRequire("aXEqK")).getTimeBasedGreeting)();
        const isSkeleton = isLoading || isUserDataLoading;
        const greeting = (0, ($parcel$interopDefault($5uXOq))).createElement($98db99f28774a83a$var$SummaryTitle, null, `${formatMessage(message, {
            userName: userName
        })} ${emoji}`);
        const withShareButton = (0, ($parcel$interopDefault($5uXOq))).createElement($98db99f28774a83a$var$SummaryTitleWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($98db99f28774a83a$var$SummaryTitleSideWrapper, null), greeting, (0, ($parcel$interopDefault($5uXOq))).createElement($98db99f28774a83a$var$SummaryTitleSideWrapper, null, hasShareButton && !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && !(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj6Bl")).default), null)));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "business-summary-header"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($98db99f28774a83a$var$SummaryHeaderWrapper, null, isSkeleton ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2nBWz")).default), {
            testId: "business-summary.ui.summary-view.header.skeleton"
        }) : withShareButton, (0, ($parcel$interopDefault($5uXOq))).createElement($98db99f28774a83a$var$SummarySubTitle, {
            isSkeleton: isSkeleton
        }, formatMessage((0, (0, parcelRequire("6rHTj")).default).description, {
            containerName: entity?.name
        }))));
    };
    var $98db99f28774a83a$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($98db99f28774a83a$var$SummaryHeader);
    const $98db99f28774a83a$var$SummaryHeaderWrapper = (0, $5uXOq.forwardRef)(({ as: C = "header", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _4cvr1h6o _y3gn1h6o _otyr1b66 _kqswh2mm _1bsb1osq _16jlkb7n _1o9zkb7n _i0dlf1ug",
                __cmplp.className
            ])
        });
    });
    const $98db99f28774a83a$var$SummaryTitle = (0, $5uXOq.forwardRef)(({ as: C = "h3", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syazfrbu _11c81p5s _y3gn1h6o _16jlkb7n _1o9zkb7n _i0dlf1ug _19pkidpf",
                __cmplp.className
            ])
        });
    });
    const $98db99f28774a83a$var$SummarySubTitle = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isSkeleton: isSkeleton, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_k48p1nn1 _18s8134w _p12f1fdn _vwz41ejb _2rko1y44",
                __cmplp.isSkeleton ? "_syaz3acm" : "_syazfrbu",
                __cmplp.isSkeleton ? "_bfhk1h97" : "_bfhk18uv",
                __cmplp.className
            ])
        });
    });
    const $98db99f28774a83a$var$SummaryTitleWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bsb1osq _1bah1b1v _4cvr1h6o _1tkezwfg",
                __cmplp.className
            ])
        });
    });
    const $98db99f28774a83a$var$SummaryTitleSideWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1ul91j4a _1e0c1txw _1bahh9n0 _y3gn1e5h",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("6rHTj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$adfba7517a529221$export$2e2bcd8739ae039);
    var $7VHMR;
    var $adfba7517a529221$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        morningGreeting: {
            "id": "business-summary.summary-view.header.morning-greeting",
            "defaultMessage": "Good morning, {userName}"
        },
        afternoonGreeting: {
            "id": "business-summary.summary-view.header.afternoon-greeting",
            "defaultMessage": "Good afternoon, {userName}"
        },
        eveningGreeting: {
            "id": "business-summary.summary-view.header.evening-greeting",
            "defaultMessage": "Good evening, {userName}"
        },
        description: {
            "id": "business-summary.summary-view.header.description",
            "defaultMessage": "Here's where you'll view a summary of {containerName}'s status, priorities, workload, and more."
        }
    });
});
parcelRegister("lj6Bl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$27ba5828f3985f21$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ccsmj;
    var $5GqLe;
    var $lfJbW;
    const $27ba5828f3985f21$var$ShareButton = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ccsmj")).JWMShareButton), {
            shareTitle: (0, (0, parcelRequire("lfJbW")).default).shareTitle,
            integrationType: (0, (0, parcelRequire("5GqLe")).integrationTypes).SUMMARY,
            shareContentType: "summary"
        });
    var $27ba5828f3985f21$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($27ba5828f3985f21$var$ShareButton);
});
parcelRegister("ccsmj", function(module, exports) {
    $parcel$export(module.exports, "JWMShareButton", ()=>$e895e30d5d3d8dcc$export$b326da26415fdf10);
    var $5uXOq = parcelRequire("5uXOq");
    var $aFThE;
    var $12jwF;
    var $koVbs;
    var $22OQR;
    var $iL8EU;
    var $9j8is;
    var $fjgF8;
    var $4XKuc;
    const $e895e30d5d3d8dcc$var$SHARE_ICON = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("aFThE"))))), {
        label: "",
        size: "small"
    });
    const $e895e30d5d3d8dcc$export$b326da26415fdf10 = ({ shareTitle: shareTitle, integrationType: integrationType, shareContentType: shareContentType, isAutoOpenDialog: isAutoOpenDialog = false, onDialogClose: onDialogClose })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { shareIntegrations: shareIntegrations } = (0, (0, parcelRequire("9j8is")).useShareIntegrations)(shareContentType);
        const entityAri = (0, (0, parcelRequire("12jwF")).useEntityAri)();
        const shareButtonRef = (0, $5uXOq.useRef)(null);
        const renderCustomTriggerButton = (0, $5uXOq.useCallback)(({ onClick: onClick, isSelected: isSelected }, { ref: ref, ...triggerProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                ref: ref
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
                ...triggerProps,
                ref: shareButtonRef,
                onClick: onClick,
                isSelected: isSelected,
                iconBefore: $e895e30d5d3d8dcc$var$SHARE_ICON,
                appearance: "subtle"
            }, formatMessage((0, (0, parcelRequire("4XKuc")).default).share))), [
            formatMessage
        ]);
        const handleDialogClose = ()=>{
            onDialogClose?.();
            shareButtonRef?.current?.focus();
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fjgF8")).AsyncShareProjectNudge), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iL8EU")).default), {
            isAutoOpenDialog: isAutoOpenDialog,
            integrationType: integrationType,
            triggerButtonStyle: "icon-with-text",
            productId: "jira",
            subProductId: "jira-core",
            shareLink: false ? '' : window.location.href,
            shareTitle: formatMessage(shareTitle),
            shareContentType: shareContentType,
            renderCustomTriggerButton: renderCustomTriggerButton,
            objectAri: entityAri,
            onDialogClose: handleDialogClose,
            copyTooltipText: formatMessage((0, (0, parcelRequire("4XKuc")).default).shareTooltipText),
            shareIntegrations: shareIntegrations,
            integrationMode: "tabs",
            shareFormHelperMessage: formatMessage((0, (0, parcelRequire("4XKuc")).default).shareJwmHelperMessage)
        }));
    };
});
parcelRegister("aFThE", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7c589dec533d9504$var$_react = $7c589dec533d9504$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $7c589dec533d9504$var$_share = $7c589dec533d9504$var$_interopRequireDefault((parcelRequire("1AJjz")));
    function $7c589dec533d9504$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7c589dec533d9504$var$ShareIcon = (props)=>$7c589dec533d9504$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
        }, props, {
            newIcon: $7c589dec533d9504$var$_share.default
        }));
    $7c589dec533d9504$var$ShareIcon.displayName = 'ShareIcon';
    var $7c589dec533d9504$var$_default = module.exports.default = $7c589dec533d9504$var$ShareIcon;
});
parcelRegister("1AJjz", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $128c4dc3501401e2$var$_react = $128c4dc3501401e2$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $128c4dc3501401e2$var$_UNSAFE_baseNew = $128c4dc3501401e2$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $128c4dc3501401e2$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $128c4dc3501401e2$var$ShareIcon = (props)=>$128c4dc3501401e2$var$_react.default.createElement($128c4dc3501401e2$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.434 11.717a1.75 1.75 0 1 0 3.131 1.566 1.75 1.75 0 0 0-3.13-1.566Zm0 0L5.316 8.783m0 0a1.74 1.74 0 0 0 0-1.566m0 1.566a1.75 1.75 0 1 1 0-1.566m0 0 5.118-2.934m0 0a1.75 1.75 0 1 0 3.13-1.566 1.75 1.75 0 0 0-3.13 1.566Z"/>`
        }, props));
    $128c4dc3501401e2$var$ShareIcon.displayName = 'ShareIcon';
    var $128c4dc3501401e2$var$_default = module.exports.default = $128c4dc3501401e2$var$ShareIcon;
});
parcelRegister("iL8EU", function(module, exports) {
    $parcel$export(module.exports, "ShareLoadingPlaceholder", ()=>$4e5335f44d688bbf$export$5619d05bf511476b);
    $parcel$export(module.exports, "default", ()=>$4e5335f44d688bbf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $2APCZ;
    var $aFThE;
    var $heNNl;
    var $koVbs;
    var $lfTZh;
    var $1jUsD;
    var $Kpokz;
    const $4e5335f44d688bbf$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
            appearance: "subtle",
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("aFThE"))))), {
                size: "medium",
                label: formatMessage((0, (0, parcelRequire("Kpokz")).messages).shareTriggerButtonText),
                primaryColor: `var(--ds-icon, ${(0, $72ba03e317f3d228$exports).N30})`
            }),
            isDisabled: true
        }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, (0, parcelRequire("Kpokz")).messages).shareTriggerButtonText) : null));
    };
    const $4e5335f44d688bbf$var$ShareButton = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("jHQiG")), {
        ssr: false,
        moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
    });
    var $4e5335f44d688bbf$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "async.share.button",
            packageName: "share-button"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "share-button",
            fallback: props.renderCustomTriggerButton === undefined ? (0, ($parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$5619d05bf511476b, {
                triggerButtonStyle: props.triggerButtonStyle
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement(props.renderCustomTriggerButton, {
                isDisabled: true,
                onClick: (0, ($parcel$interopDefault($8Rkzz)))
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$var$ShareButton, props)));
});
parcelRegister("Kpokz", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$026d1258a1c95d57$export$defe85febe8b728c);
    var $7VHMR;
    const $026d1258a1c95d57$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        shareTriggerButtonText: {
            "id": "share-button.share-trigger-button-text",
            "defaultMessage": "Share"
        }
    });
});
parcelRegister("jHQiG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("bfk3F")
    ]).then(()=>parcelRequire('7aU9g'));
});
parcelRegister("9j8is", function(module, exports) {
    $parcel$export(module.exports, "useShareIntegrations", ()=>$d021f3111fd4c646$export$58a9f7a7ab3466f4);
    var $5uXOq = parcelRequire("5uXOq");
    var $hnsNR;
    var $bCdIp;
    var $pa9q9;
    var $koeKL;
    var $2UEtd;
    var $aMZmw;
    const $d021f3111fd4c646$export$58a9f7a7ab3466f4 = (shareContentType)=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const ineligibilityReasons = (0, $5uXOq.useMemo)(()=>{
            const reasons = [];
            if ((0, (0, parcelRequire("bCdIp")).default)()) reasons.push('notDesktop');
            if ((0, (0, parcelRequire("hnsNR")).isFedRamp)()) reasons.push('isFedRAMP');
            return reasons;
        }, []);
        const shareIntegrations = (0, $5uXOq.useMemo)(()=>ineligibilityReasons.length === 0 ? [
                {
                    type: 'Slack',
                    Icon: (0, (0, parcelRequire("aMZmw")).default),
                    Content: ({ onClose: onClose, changeTab: changeTab })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2UEtd")).ShareToSlack), {
                            showFlag: showFlag,
                            product: "jira",
                            channel: "productAnalytics",
                            onClose: onClose,
                            cloudId: cloudId,
                            changeTab: changeTab,
                            shareContentType: shareContentType
                        })
                }
            ] : [], [
            ineligibilityReasons.length,
            showFlag,
            cloudId,
            shareContentType
        ]);
        return {
            shareIntegrations: shareIntegrations
        };
    };
});
parcelRegister("2UEtd", function(module, exports) {
    $parcel$export(module.exports, "ShareToSlack", ()=>$168b88234834bfea$export$2cc56764fd9edb21);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $113Tq;
    var $heNNl;
    var $lfTZh;
    var $3xc3R;
    const $168b88234834bfea$export$2cc56764fd9edb21 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "async-share-to-slack",
            packageName: "integrations"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "share-to-slack",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement($168b88234834bfea$var$StyledShareToSlackLoader, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($168b88234834bfea$var$StyledShareToSlack, props)));
    const $168b88234834bfea$var$StyledShareToSlackLoader = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("113Tq")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _19pkidpf _2hwx1wug _otyridpf _18u01wug",
                __cmplp.className
            ])
        });
    });
    const $168b88234834bfea$var$StyledShareToSlack = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("3xc3R")).LazyShareToSlack), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s8ax2b",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("3xc3R", function(module, exports) {
    $parcel$export(module.exports, "LazyShareToSlack", ()=>$0733f18014b5074d$export$24281652e6b89b3b);
    var $1jUsD;
    const $0733f18014b5074d$export$24281652e6b89b3b = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("0fzlI")), {
        ssr: false,
        moduleId: "../platform/packages/growth/integrations/src/share-to-slack/ui/index.tsx"
    });
});
parcelRegister("0fzlI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("b4k81")
    ]).then(()=>parcelRequire('2IxSM'));
});
parcelRegister("aMZmw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a1ef732ae0096135$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $a1ef732ae0096135$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "16",
            height: "16",
            viewBox: "4 4 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M7.50403 13.8563C7.50403 14.727 6.79278 15.4382 5.92212 15.4382C5.05146 15.4382 4.34021 14.727 4.34021 13.8563C4.34021 12.9857 5.05146 12.2744 5.92212 12.2744H7.50403V13.8563Z",
            fill: "#E01E5A"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M8.30115 13.8563C8.30115 12.9857 9.0124 12.2744 9.88307 12.2744C10.7537 12.2744 11.465 12.9857 11.465 13.8563V17.8172C11.465 18.6879 10.7537 19.3991 9.88307 19.3991C9.0124 19.3991 8.30115 18.6879 8.30115 17.8172V13.8563Z",
            fill: "#E01E5A"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M9.88307 7.50415C9.0124 7.50415 8.30115 6.79291 8.30115 5.92224C8.30115 5.05158 9.0124 4.34033 9.88307 4.34033C10.7537 4.34033 11.465 5.05158 11.465 5.92224V7.50415H9.88307Z",
            fill: "#36C5F0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M9.88304 8.30127C10.7537 8.30127 11.465 9.01251 11.465 9.88317C11.465 10.7538 10.7537 11.4651 9.88304 11.4651H5.92212C5.05146 11.4651 4.34021 10.7538 4.34021 9.88317C4.34021 9.01251 5.05146 8.30127 5.92212 8.30127H9.88304Z",
            fill: "#36C5F0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M16.2354 9.88317C16.2354 9.01251 16.9466 8.30127 17.8172 8.30127C18.6879 8.30127 19.3991 9.01251 19.3991 9.88317C19.3991 10.7538 18.6879 11.4651 17.8172 11.4651H16.2354V9.88317Z",
            fill: "#2EB67D"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M15.4381 9.88316C15.4381 10.7538 14.7269 11.4651 13.8562 11.4651C12.9855 11.4651 12.2743 10.7538 12.2743 9.88316V5.92225C12.2743 5.05158 12.9855 4.34033 13.8562 4.34033C14.7269 4.34033 15.4381 5.05158 15.4381 5.92225V9.88316Z",
            fill: "#2EB67D"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M13.8562 16.2354C14.7269 16.2354 15.4381 16.9466 15.4381 17.8172C15.4381 18.6879 14.7269 19.3991 13.8562 19.3991C12.9855 19.3991 12.2743 18.6879 12.2743 17.8172V16.2354H13.8562Z",
            fill: "#ECB22E"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M13.8562 15.4382C12.9855 15.4382 12.2743 14.727 12.2743 13.8563C12.2743 12.9857 12.9855 12.2744 13.8562 12.2744H17.8171C18.6878 12.2744 19.399 12.9857 19.399 13.8563C19.399 14.727 18.6878 15.4382 17.8171 15.4382H13.8562Z",
            fill: "#ECB22E"
        }));
});
parcelRegister("fjgF8", function(module, exports) {
    $parcel$export(module.exports, "AsyncShareProjectNudge", ()=>$7ce891b6fd7965bb$export$d95995d6ca76620b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bBbEG;
    var $lfTZh;
    var $1jUsD;
    const $7ce891b6fd7965bb$var$LazyShareProjectNudge = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("iEJkp")), {
        ssr: false,
        moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-share-project/index.tsx"
    });
    const $7ce891b6fd7965bb$export$d95995d6ca76620b = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bBbEG")).OnboardingNudgeErrorBoundary), {
            id: (0, $dbbf68c32d8c4308$export$a1be34032ee24f78),
            fallback: children,
            attributes: {
                nudgeId: (0, $dbbf68c32d8c4308$export$a1be34032ee24f78)
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jwm-share-project-nudge",
            fallback: children
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7ce891b6fd7965bb$var$LazyShareProjectNudge, null, children)));
});
const $dbbf68c32d8c4308$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $dbbf68c32d8c4308$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $dbbf68c32d8c4308$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $dbbf68c32d8c4308$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $dbbf68c32d8c4308$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $dbbf68c32d8c4308$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $dbbf68c32d8c4308$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $dbbf68c32d8c4308$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $dbbf68c32d8c4308$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $dbbf68c32d8c4308$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $dbbf68c32d8c4308$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $dbbf68c32d8c4308$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $dbbf68c32d8c4308$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $dbbf68c32d8c4308$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $dbbf68c32d8c4308$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $dbbf68c32d8c4308$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $dbbf68c32d8c4308$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $dbbf68c32d8c4308$export$f8bf435a6066832c = 'button clicked';
const $dbbf68c32d8c4308$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $dbbf68c32d8c4308$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $dbbf68c32d8c4308$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $dbbf68c32d8c4308$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $dbbf68c32d8c4308$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $dbbf68c32d8c4308$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $dbbf68c32d8c4308$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $dbbf68c32d8c4308$export$5908fa8acd2c0739 = 'filterListNudge';
const $dbbf68c32d8c4308$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $dbbf68c32d8c4308$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $dbbf68c32d8c4308$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $dbbf68c32d8c4308$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $dbbf68c32d8c4308$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $dbbf68c32d8c4308$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $dbbf68c32d8c4308$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $dbbf68c32d8c4308$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $dbbf68c32d8c4308$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $dbbf68c32d8c4308$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $dbbf68c32d8c4308$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $dbbf68c32d8c4308$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $dbbf68c32d8c4308$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $dbbf68c32d8c4308$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $dbbf68c32d8c4308$export$a1be34032ee24f78 = 'shareProjectNudge';
const $dbbf68c32d8c4308$export$29fe6611cc093756 = 'summaryTabNudge';
const $dbbf68c32d8c4308$export$f107c06c0830f09d = 'reportsTabNudge';
const $dbbf68c32d8c4308$export$9749a972a54ad7ba = 'boardContainerNudge';
parcelRegister("iEJkp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8qj8a").then(()=>parcelRequire('dRf63'));
});
parcelRegister("4XKuc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5ed6b88152ef6ea6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5ed6b88152ef6ea6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        share: {
            "id": "business-invite-people.jwm-share-button.share",
            "defaultMessage": "Share"
        },
        shareTooltipText: {
            "id": "business-invite-people.jwm-share-button.share-tooltip-text",
            "defaultMessage": "Embed this Smart Link in other Atlassian products such as Confluence"
        },
        shareJwmHelperMessage: {
            "id": "business-invite-people.jwm-share-button.share-jwm-helper-message",
            "defaultMessage": "This view, along with any applied groups and filters are shared"
        }
    });
});
parcelRegister("5GqLe", function(module, exports) {
    $parcel$export(module.exports, "integrationTypes", ()=>$0970fea694a8095f$export$a7359bcfb0ca8e98);
    const $0970fea694a8095f$export$a7359bcfb0ca8e98 = {
        BENTO_ISSUE: 'bentoIssue',
        CLASSIC_BOARD: 'classicBoard',
        NEXTGEN_BOARD: 'nextGenBoard',
        ROADMAP: 'roadmap',
        TIMELINE: 'timeline',
        LIST: 'list',
        CALENDAR: 'calendar',
        BOARD: 'board',
        FORM: 'form',
        SUMMARY: 'summary',
        ATTACHMENTS: 'attachments',
        DEPENDENCIES: 'dependencies',
        INCREMENT: 'increment'
    };
});
parcelRegister("lfJbW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0763585eeaeb408f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0763585eeaeb408f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        shareTitle: {
            "id": "business-summary.summary-view.header.share-button.share-title",
            "defaultMessage": "Summary"
        }
    });
});
parcelRegister("2nBWz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$52c386886c17ac7f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6cG4N;
    const $52c386886c17ac7f$var$SummaryHeaderSkeleton = ({ testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            height: "32px",
            width: "400px",
            viewBox: "0 0 400 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "0",
            y: "0",
            width: "400px",
            height: "32px",
            rx: "4",
            fill: (0, (0, parcelRequire("6cG4N")).Tokens).COLOR_SKELETON
        }));
    var $52c386886c17ac7f$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($52c386886c17ac7f$var$SummaryHeaderSkeleton);
});
parcelRegister("aXEqK", function(module, exports) {
    $parcel$export(module.exports, "getTimeBasedGreeting", ()=>$322b8934a3e124c7$export$1ca778b9c48306c7);
    var $6rHTj;
    const $322b8934a3e124c7$export$1ca778b9c48306c7 = ()=>{
        const dateNow = new Date();
        const hourNow = dateNow.getHours();
        const minutesNow = dateNow.getMinutes();
        if (hourNow >= 5 && hourNow < 12) return {
            emoji: "\u2615\uFE0F",
            message: (0, (0, parcelRequire("6rHTj")).default).morningGreeting
        };
        if (hourNow >= 12 && hourNow < 19 || hourNow === 19 && minutesNow < 30) return {
            emoji: "\u2600\uFE0F",
            message: (0, (0, parcelRequire("6rHTj")).default).afternoonGreeting
        };
        return {
            emoji: "\uD83C\uDF14",
            message: (0, (0, parcelRequire("6rHTj")).default).eveningGreeting
        };
    };
});
parcelRegister("fZDRX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b0653ad71c552210$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b0653ad71c552210$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        summaryHeading: {
            "id": "business-summary.summary-view.summary-heading",
            "defaultMessage": "Summary"
        }
    });
});
parcelRegister("gFWns", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$132c2c13428f5d42$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $l8ruj;
    var $95H4q;
    var $dGgQr;
    const $132c2c13428f5d42$var$OverviewItems = ()=>{
        const { data: data, loading: loading } = (0, (0, parcelRequire("95H4q")).useOverviewItems)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "business-summary-overview-items"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($132c2c13428f5d42$var$ListContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($132c2c13428f5d42$var$CardsList, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dGgQr")).default), {
            count: data?.doneThisWeek,
            type: (0, $fe8014b0074a1a49$export$71efb3495f6084f2),
            isLoading: loading,
            testId: "business-summary.ui.summary-view.overview-items.done-this-week"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dGgQr")).default), {
            count: data?.updatedThisWeek,
            type: (0, $fe8014b0074a1a49$export$cd8e68094cb5c3cb),
            isLoading: loading,
            testId: "business-summary.ui.summary-view.overview-items.updated-this-week"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dGgQr")).default), {
            count: data?.createdThisWeek,
            type: (0, $fe8014b0074a1a49$export$ff39ebd4bb12b718),
            isLoading: loading,
            testId: "business-summary.ui.summary-view.overview-items.created-this-week"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dGgQr")).default), {
            count: data?.dueThisWeek,
            type: (0, $fe8014b0074a1a49$export$ee74b0b7e193b0b0),
            isLoading: loading,
            testId: "business-summary.ui.summary-view.overview-items.due-this-week"
        }))));
    };
    var $132c2c13428f5d42$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($132c2c13428f5d42$var$OverviewItems);
    const $132c2c13428f5d42$var$ListContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlkb7n _85i5pxbi _1bsb1osq _wij2j5tq _7cca15wb _1f38lz1g _zomrwxkt _nr9phkll",
                __cmplp.className
            ])
        });
    });
    const $132c2c13428f5d42$var$CardsList = (0, $5uXOq.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw _1e0c11p5 _1bah1h6o _yv0e1ezz _gy1ppxbi _1p57pxbi _1ul9idpf _1bsb1osq",
                __cmplp.className
            ])
        });
    });
});
const $fe8014b0074a1a49$export$71efb3495f6084f2 = 'done';
const $fe8014b0074a1a49$export$cd8e68094cb5c3cb = 'updated';
const $fe8014b0074a1a49$export$ff39ebd4bb12b718 = 'created';
const $fe8014b0074a1a49$export$ee74b0b7e193b0b0 = 'due';
parcelRegister("dGgQr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5db7e3dc91e18f9c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $jDE68;
    var $Zmmeo;
    var $2jjJ7;
    var $f1QXZ;
    var $7NUKB;
    var $8Q4sF;
    var $koVbs;
    var $8zOmE;
    var $lwMsT;
    var $hDzhb;
    var $7TJr2;
    var $7erx9;
    const $5db7e3dc91e18f9c$var$EMPTY_ICON_COLOR = `var(--ds-icon, ${(0, $72ba03e317f3d228$exports).N500})`;
    const $5db7e3dc91e18f9c$var$EMPTY_BACKGROUND_COLOR = `var(--ds-background-neutral, ${(0, $72ba03e317f3d228$exports).N20A})`;
    const $5db7e3dc91e18f9c$var$CARD_TYPES = {
        [(0, $fe8014b0074a1a49$export$71efb3495f6084f2)]: {
            color: `var(--ds-text-accent-green, ${(0, $72ba03e317f3d228$exports).G500})`,
            backgroundColor: `var(--ds-background-accent-green-subtler, ${(0, $72ba03e317f3d228$exports).G50})`,
            getIcon: (color)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2jjJ7"))))), {
                    label: "",
                    color: color,
                    LEGACY_primaryColor: color
                }),
            message: (0, (0, parcelRequire("7erx9")).default).doneItems,
            getLink: (issuesLinkUrl)=>`${issuesLinkUrl}?filter=${encodeURIComponent('statusCategory = Done AND statusCategoryChangedDate >= -1w')}&hideDone=false`
        },
        [(0, $fe8014b0074a1a49$export$cd8e68094cb5c3cb)]: {
            color: `var(--ds-text-accent-blue, ${(0, $72ba03e317f3d228$exports).B400})`,
            backgroundColor: `var(--ds-background-accent-blue-subtler, ${(0, $72ba03e317f3d228$exports).B50})`,
            getIcon: (color)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("f1QXZ"))))), {
                    label: "",
                    color: color,
                    LEGACY_primaryColor: color
                }),
            message: (0, (0, parcelRequire("7erx9")).default).updatedItems,
            getLink: (issuesLinkUrl)=>`${issuesLinkUrl}?filter=${encodeURIComponent('updatedDate >= -1w')}&hideDone=false`
        },
        [(0, $fe8014b0074a1a49$export$ff39ebd4bb12b718)]: {
            color: `var(--ds-text-accent-purple, ${(0, $72ba03e317f3d228$exports).P300})`,
            backgroundColor: `var(--ds-background-accent-purple-subtler, ${(0, $72ba03e317f3d228$exports).P50})`,
            getIcon: (color)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jDE68"))))), {
                    label: "",
                    color: color,
                    LEGACY_primaryColor: color
                }),
            message: (0, (0, parcelRequire("7erx9")).default).createdItems,
            getLink: (issuesLinkUrl)=>`${issuesLinkUrl}?filter=${encodeURIComponent('createdDate >= -1w')}&hideDone=false`
        },
        [(0, $fe8014b0074a1a49$export$ee74b0b7e193b0b0)]: {
            color: `var(--ds-text-accent-red, ${(0, $72ba03e317f3d228$exports).R400})`,
            backgroundColor: `var(--ds-background-accent-red-subtler, ${(0, $72ba03e317f3d228$exports).R50})`,
            getIcon: (color)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("Zmmeo"))))), {
                    label: "",
                    color: color,
                    LEGACY_primaryColor: color
                }),
            message: (0, (0, parcelRequire("7erx9")).default).dueItems,
            getLink: (issuesLinkUrl)=>`${issuesLinkUrl}?filter=${encodeURIComponent('statusCategory != Done AND (duedate >= 0d AND duedate < 1w)')}`
        }
    };
    const $5db7e3dc91e18f9c$var$OverviewCard = ({ type: type, testId: testId, count: count, isLoading: isLoading })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { linksTarget: linksTarget, issuesLinkUrl: issuesLinkUrl } = (0, (0, parcelRequire("7TJr2")).useSummaryFeatures)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const isEmpty = count === 0;
        const card = $5db7e3dc91e18f9c$var$CARD_TYPES[type];
        const { message: message, color: color, backgroundColor: backgroundColor, getIcon: getIcon, getLink: getLink } = card;
        const cardColor = isEmpty ? null : color;
        const cardBackgroundColor = isEmpty ? $5db7e3dc91e18f9c$var$EMPTY_BACKGROUND_COLOR : backgroundColor;
        const icon = getIcon(isEmpty ? $5db7e3dc91e18f9c$var$EMPTY_ICON_COLOR : color);
        const celebrateEmoji = type === (0, $fe8014b0074a1a49$export$71efb3495f6084f2) && !isEmpty ? "  \uD83C\uDF89" : null;
        const onClick = (0, $5uXOq.useCallback)(()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'summaryOverviewCard', {
                type: type,
                count: count
            }), [
            type,
            count,
            createAnalyticsEvent
        ]);
        return isLoading ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7NUKB")).default), {
            name: "overview-card"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5db7e3dc91e18f9c$var$CardItem, null, (0, ($parcel$interopDefault($5uXOq))).createElement($5db7e3dc91e18f9c$var$SkeletonCardContainer, {
            "data-testid": testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5db7e3dc91e18f9c$var$Skeleton, {
            testId: "business-summary.ui.summary-view.overview-items.overview-card.skeleton"
        })))) : (0, ($parcel$interopDefault($5uXOq))).createElement($5db7e3dc91e18f9c$var$CardItem, null, (0, ($parcel$interopDefault($5uXOq))).createElement($5db7e3dc91e18f9c$var$CardContainer, {
            href: getLink(issuesLinkUrl),
            target: linksTarget,
            "data-testid": testId,
            onClick: onClick
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5db7e3dc91e18f9c$var$CardIconContainer, {
            color: cardBackgroundColor
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5db7e3dc91e18f9c$var$IconWrapper, null, icon)), (0, ($parcel$interopDefault($5uXOq))).createElement($5db7e3dc91e18f9c$var$ContentContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Q4sF")).FormattedI18nMessage), {
            message: formatMessage(message, {
                titleStart: '{titleStart}',
                titleEnd: '{titleEnd}',
                count: count
            }),
            componentsMapping: {
                title: ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($5db7e3dc91e18f9c$var$Title, {
                        color: cardColor
                    }, children)
            }
        }), celebrateEmoji)));
    };
    var $5db7e3dc91e18f9c$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($5db7e3dc91e18f9c$var$OverviewCard);
    const $5db7e3dc91e18f9c$var$SkeletonSVG = ({ className: className, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 264 99",
            fill: "none",
            preserveAspectRatio: "none",
            className: className,
            "data-testid": testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", null, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "25",
            y: "25",
            width: "48",
            height: "48",
            rx: "24",
            fill: `var(--ds-skeleton, ${(0, $72ba03e317f3d228$export$8d43898f60b96a82)})`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "85",
            y: "29",
            width: "83",
            height: "24",
            rx: "4",
            fill: `var(--ds-skeleton, ${(0, $72ba03e317f3d228$export$8d43898f60b96a82)})`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "85",
            y: "61",
            width: "154",
            height: "8",
            rx: "4",
            fill: `var(--ds-skeleton, ${(0, $72ba03e317f3d228$export$8d43898f60b96a82)})`
        })));
    const $5db7e3dc91e18f9c$var$IconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _v5641ycq _t9ec157v",
                __cmplp.className
            ])
        });
    });
    const $5db7e3dc91e18f9c$var$CardItem = (0, $5uXOq.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4t3i1ns9 _vchhusvi _1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $5db7e3dc91e18f9c$var$CardIconContainer = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_xexnhp": (0, (0, parcelRequire("lD23V")).default)(__cmplp.color)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3ickbl _1bsbckbl _2rko1ssb _1e0c1txw _4cvr1h6o _1bah1h6o _bfhk1cj8 _16jlidpf _1o9zidpf _i0dl1wug",
                __cmplp.className
            ])
        });
    });
    const $5db7e3dc91e18f9c$var$cardContainerBase = null;
    const $5db7e3dc91e18f9c$var$CardContainer = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("hDzhb")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i16xz _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1h6o _2rkoftgi _vchhusvi _bfhkhp5a _v564ds4c _16qs1os1 _15yoglyw _1yt41ejb _1nrm18uv _1a3b18uv _9oik18uv _1ydc18uv _c2waglyw _4fprglyw _1bnxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _1726nqa1 _180dzotn _7ehizotn _1dbzzotn _1urc3swd _1jxp3swd _1me43swd",
                __cmplp.className
            ])
        });
    });
    const $5db7e3dc91e18f9c$var$SkeletonCardContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i16xz _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1h6o _2rkoftgi _vchhusvi _bfhkhp5a _v564ds4c _16qs1os1 _15yoglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1nrm18uv _1a3b18uv _9oik18uv _1ydc18uv _c2waglyw _4fprglyw _1bnxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _1726nqa1 _180dzotn _7ehizotn _1dbzzotn _1urc3swd _1jxp3swd _1me43swd",
                __cmplp.className
            ])
        });
    });
    const $5db7e3dc91e18f9c$var$ContentContainer = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _18u0utpp _syaz1rc1 _k48pbfng _19pkidpf _1ul9idpf",
                __cmplp.className
            ])
        });
    });
    const $5db7e3dc91e18f9c$var$Skeleton = (0, $5uXOq.forwardRef)(({ as: C = $5db7e3dc91e18f9c$var$SkeletonSVG, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug",
                __cmplp.className
            ])
        });
    });
    const $5db7e3dc91e18f9c$var$Title = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_hk0kyc": (0, (0, parcelRequire("lD23V")).default)(__cmplp.color || `var(--ds-text-subtlest, ${0, $72ba03e317f3d228$export$e2ef2124cf4024b1})`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syazc59f _11c8o0gd _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("Zmmeo", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0b870a5dd988cc2f$var$_react = $0b870a5dd988cc2f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $0b870a5dd988cc2f$var$_calendar = $0b870a5dd988cc2f$var$_interopRequireDefault((parcelRequire("lL8mO")));
    var $0b870a5dd988cc2f$var$_calendar2 = $0b870a5dd988cc2f$var$_interopRequireDefault((parcelRequire("bLDEj")));
    function $0b870a5dd988cc2f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0b870a5dd988cc2f$var$CalendarIcon = (props)=>$0b870a5dd988cc2f$var$_react.default.createElement($0b870a5dd988cc2f$var$_calendar.default, Object.assign({
            LEGACY_fallbackIcon: $0b870a5dd988cc2f$var$_calendar2.default
        }, props));
    $0b870a5dd988cc2f$var$CalendarIcon.Name = 'CalendarIconMigration';
    var $0b870a5dd988cc2f$var$_default = module.exports.default = $0b870a5dd988cc2f$var$CalendarIcon;
});
parcelRegister("lL8mO", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fd747a425ea05ec4$var$_react = $fd747a425ea05ec4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fd747a425ea05ec4$var$_UNSAFE_baseNew = $fd747a425ea05ec4$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $fd747a425ea05ec4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fd747a425ea05ec4$var$CalendarIcon = (props)=>$fd747a425ea05ec4$var$_react.default.createElement($fd747a425ea05ec4$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
        }, props));
    $fd747a425ea05ec4$var$CalendarIcon.displayName = 'CalendarIcon';
    var $fd747a425ea05ec4$var$_default = module.exports.default = $fd747a425ea05ec4$var$CalendarIcon;
});
parcelRegister("bLDEj", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8912d6fb9cca436d$var$_react = $8912d6fb9cca436d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $8912d6fb9cca436d$var$_calendar = $8912d6fb9cca436d$var$_interopRequireDefault((parcelRequire("lL8mO")));
    function $8912d6fb9cca436d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8912d6fb9cca436d$var$CalendarIcon = (props)=>$8912d6fb9cca436d$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
        }, props, {
            newIcon: $8912d6fb9cca436d$var$_calendar.default
        }));
    $8912d6fb9cca436d$var$CalendarIcon.displayName = 'CalendarIcon';
    var $8912d6fb9cca436d$var$_default = module.exports.default = $8912d6fb9cca436d$var$CalendarIcon;
});
parcelRegister("2jjJ7", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1aeca873b3686d8c$var$_react = $1aeca873b3686d8c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $1aeca873b3686d8c$var$_checkMark = $1aeca873b3686d8c$var$_interopRequireDefault((parcelRequire("bZUh6")));
    var $1aeca873b3686d8c$var$_done = $1aeca873b3686d8c$var$_interopRequireDefault((parcelRequire("cQ0ub")));
    function $1aeca873b3686d8c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1aeca873b3686d8c$var$CheckMarkIcon = (props)=>$1aeca873b3686d8c$var$_react.default.createElement($1aeca873b3686d8c$var$_checkMark.default, Object.assign({
            LEGACY_fallbackIcon: $1aeca873b3686d8c$var$_done.default
        }, props));
    $1aeca873b3686d8c$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
    var $1aeca873b3686d8c$var$_default = module.exports.default = $1aeca873b3686d8c$var$CheckMarkIcon;
});
parcelRegister("bZUh6", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8bc10b3745ba142a$var$_react = $8bc10b3745ba142a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8bc10b3745ba142a$var$_UNSAFE_baseNew = $8bc10b3745ba142a$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $8bc10b3745ba142a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8bc10b3745ba142a$var$CheckMarkIcon = (props)=>$8bc10b3745ba142a$var$_react.default.createElement($8bc10b3745ba142a$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
        }, props));
    $8bc10b3745ba142a$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
    var $8bc10b3745ba142a$var$_default = module.exports.default = $8bc10b3745ba142a$var$CheckMarkIcon;
});
parcelRegister("cQ0ub", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $958ab7d49d641312$var$_react = $958ab7d49d641312$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $958ab7d49d641312$var$_checkMark = $958ab7d49d641312$var$_interopRequireDefault((parcelRequire("bZUh6")));
    function $958ab7d49d641312$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $958ab7d49d641312$var$EditorDoneIcon = (props)=>$958ab7d49d641312$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
        }, props, {
            newIcon: $958ab7d49d641312$var$_checkMark.default
        }));
    $958ab7d49d641312$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
    var $958ab7d49d641312$var$_default = module.exports.default = $958ab7d49d641312$var$EditorDoneIcon;
});
parcelRegister("f1QXZ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $af10090ed7943912$var$_react = $af10090ed7943912$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $af10090ed7943912$var$_edit = $af10090ed7943912$var$_interopRequireDefault((parcelRequire("czVbS")));
    var $af10090ed7943912$var$_editFilled = $af10090ed7943912$var$_interopRequireDefault((parcelRequire("6vWhg")));
    function $af10090ed7943912$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $af10090ed7943912$var$EditIcon = (props)=>$af10090ed7943912$var$_react.default.createElement($af10090ed7943912$var$_edit.default, Object.assign({
            LEGACY_fallbackIcon: $af10090ed7943912$var$_editFilled.default
        }, props));
    $af10090ed7943912$var$EditIcon.Name = 'EditIconMigration';
    var $af10090ed7943912$var$_default = module.exports.default = $af10090ed7943912$var$EditIcon;
});
parcelRegister("czVbS", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $92851dcc17341f34$var$_react = $92851dcc17341f34$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $92851dcc17341f34$var$_UNSAFE_baseNew = $92851dcc17341f34$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $92851dcc17341f34$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $92851dcc17341f34$var$EditIcon = (props)=>$92851dcc17341f34$var$_react.default.createElement($92851dcc17341f34$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 1.751H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V10m-.75-5 1.116-1.116a1.25 1.25 0 0 0 0-1.768l-.732-.732a1.25 1.25 0 0 0-1.768 0L11 2.5M13.5 5 9.479 9.021c-.15.15-.336.26-.54.318l-3.189.911.911-3.189a1.25 1.25 0 0 1 .318-.54L11 2.5M13.5 5 11 2.5"/>`
        }, props));
    $92851dcc17341f34$var$EditIcon.displayName = 'EditIcon';
    var $92851dcc17341f34$var$_default = module.exports.default = $92851dcc17341f34$var$EditIcon;
});
parcelRegister("6vWhg", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4be2d805008290c4$var$_react = $4be2d805008290c4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $4be2d805008290c4$var$_edit = $4be2d805008290c4$var$_interopRequireDefault((parcelRequire("czVbS")));
    function $4be2d805008290c4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4be2d805008290c4$var$EditFilledIcon = (props)=>$4be2d805008290c4$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zM19.84 6.71l-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
        }, props, {
            newIcon: $4be2d805008290c4$var$_edit.default
        }));
    $4be2d805008290c4$var$EditFilledIcon.displayName = 'EditFilledIcon';
    var $4be2d805008290c4$var$_default = module.exports.default = $4be2d805008290c4$var$EditFilledIcon;
});
parcelRegister("7erx9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$39f82b95b71db2c4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $39f82b95b71db2c4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        doneItems: {
            "id": "business-summary.summary-view.overview-items.overview-card.done-items",
            "defaultMessage": "{titleStart}{count} done{titleEnd} in the last 7 days"
        },
        updatedItems: {
            "id": "business-summary.summary-view.overview-items.overview-card.updated-items",
            "defaultMessage": "{titleStart}{count} updated{titleEnd} in the last 7 days"
        },
        createdItems: {
            "id": "business-summary.summary-view.overview-items.overview-card.created-items",
            "defaultMessage": "{titleStart}{count} created{titleEnd} in the last 7 days"
        },
        dueItems: {
            "id": "business-summary.summary-view.overview-items.overview-card.due-items",
            "defaultMessage": "{titleStart}{count} due{titleEnd} in the next 7 days"
        }
    });
});
parcelRegister("2vMT1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$85068340b2ff4a30$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eiOHN;
    var $ixV1I;
    var $koMvQ;
    var $3srSR;
    var $99gde;
    var $7NUKB;
    var $6s1PB;
    var $4R6GH;
    var $8Q4sF;
    var $koVbs;
    var $8GOso;
    var $9USr3;
    var $ghgEK;
    var $l8ruj;
    var $lVJAU;
    var $jWlFw;
    var $3iDn2;
    var $dLD8P;
    var $kbgBa;
    var $7TJr2;
    var $95H4q;
    var $6GihX;
    var $htu9M;
    var $fW0Mh;
    var $45kbr;
    var $2qxpw;
    var $dPFym;
    (0, parcelRequire("ixV1I")).use([
        (0, (0, parcelRequire("eiOHN")).install),
        (0, (0, parcelRequire("koMvQ")).install)
    ]);
    const $85068340b2ff4a30$var$CHART_STYLE = {
        height: '240px'
    };
    const $85068340b2ff4a30$var$CHART_OPTIONS = {
        renderer: 'svg'
    };
    const $85068340b2ff4a30$var$calculatePercentage = (currentEntryCount, chartTotalCount)=>Math.round(currentEntryCount / (chartTotalCount === 0 ? 1 : chartTotalCount) * 100);
    const $85068340b2ff4a30$var$ProgressByStatus = ({ position: position })=>{
        const [echartsInstance, setEchartsInstance] = (0, $5uXOq.useState)(null);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { data: data, loading: loading, refresh: refresh } = (0, (0, parcelRequire("95H4q")).useIssuesByStatus)();
        const { hasCreateItem: hasCreateItem, linksTarget: linksTarget, issuesLinkUrl: issuesLinkUrl } = (0, (0, parcelRequire("7TJr2")).useSummaryFeatures)();
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const isEnabledForTailoredOnboardingM2 = (0, (0, parcelRequire("4R6GH")).fg)('jira_tailored_onboarding_jtbd_feature_gate') ? (0, (0, parcelRequire("8GOso")).useIsTailoredOnboardingM2ForQuickstartEnabled)() : false;
        const { startHoverTimer: startHoverTimer, stopHoverTimer: stopHoverTimer, fireSectionAnalytics: fireSectionAnalytics } = (0, (0, parcelRequire("kbgBa")).useSectionAnalytics)(position, 'progressByStatus');
        const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('business_summary_page_inline_status');
        const isInlineStatusChangeEnabled = expConfig.get('isInlineStatusChangeEnabled', false);
        const { data: workflowsData } = isInlineStatusChangeEnabled ? (0, (0, parcelRequire("95H4q")).useWorkflowsCount)() : {
            data: null
        };
        const { isEligibleForCreateStatus: isEligibleForCreateStatus, isEligibleforEditStatus: isEligibleforEditStatus } = (0, (0, parcelRequire("4R6GH")).fg)('business_summary_page_inline_status_targeting_gate') ? (0, (0, parcelRequire("6GihX")).useInlineStatusEligibilityCheck)() : {
            isEligibleForCreateStatus: false,
            isEligibleforEditStatus: false
        };
        const hasMultipleWorkflows = (workflowsData?.totalCount ?? 0) > 1;
        const chartData = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("dPFym")).buildChartData)(data, issuesLinkUrl), [
            data,
            issuesLinkUrl
        ]);
        const existingStatusNames = isInlineStatusChangeEnabled ? (0, $5uXOq.useMemo)(()=>chartData?.entries.map((entry)=>entry.name) ?? [], [
            chartData
        ]) : [];
        const chartEvents = (0, $5uXOq.useMemo)(()=>({
                click: ({ dataIndex: dataIndex })=>{
                    if (chartData != null) {
                        const { value: value, categoryKey: categoryKey, link: link } = chartData.entries[dataIndex];
                        if (linksTarget === '_self') push(link);
                        else window.open(link, '_blank');
                        fireSectionAnalytics('viewWithFilter', {
                            count: value,
                            statusCategory: categoryKey
                        });
                    }
                }
            }), [
            chartData,
            fireSectionAnalytics,
            push,
            linksTarget
        ]);
        const highlightEntry = (0, $5uXOq.useCallback)((dataIndex)=>{
            if (echartsInstance) {
                echartsInstance.dispatchAction({
                    type: 'downplay'
                });
                echartsInstance.dispatchAction({
                    type: 'highlight',
                    dataIndex: dataIndex
                });
            }
        }, [
            echartsInstance
        ]);
        const handleCreateStatusButtonClick = (0, $5uXOq.useCallback)(()=>{
            fireSectionAnalytics('createStatus');
        }, [
            fireSectionAnalytics
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (echartsInstance && chartData) {
                highlightEntry(chartData.initialHighlight);
                echartsInstance.on('mouseover', 'series', ({ dataIndex: dataIndex })=>highlightEntry(dataIndex));
                return ()=>echartsInstance.off('mouseover');
            }
        }, [
            chartData,
            highlightEntry,
            echartsInstance
        ]);
        const viewAllLink = (0, $5uXOq.useMemo)(()=>`${issuesLinkUrl}?filter=${encodeURIComponent((0, $cd053842fd66588d$export$8cca17e1017ba894))}&hideDone=false`, [
            issuesLinkUrl
        ]);
        let content = null;
        if (!loading && chartData != null) {
            const isEmpty = chartData.totalCount === 0;
            const legendContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2qxpw")).Legend), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2qxpw")).LegendList), null, chartData.entries.map((entry, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fW0Mh")).default), {
                    key: entry.name,
                    entry: entry,
                    index: index,
                    highlightEntry: highlightEntry,
                    existingStatusNames: existingStatusNames,
                    percentage: $85068340b2ff4a30$var$calculatePercentage(entry.value, chartData.totalCount),
                    linksTarget: linksTarget,
                    onCountClick: ()=>fireSectionAnalytics('viewWithFilter', {
                            count: entry.value,
                            statusCategory: entry.categoryKey
                        }),
                    canEdit: isEligibleforEditStatus
                }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2qxpw")).LegendTotal), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2qxpw")).LegendItemName), null, formatMessage((0, (0, parcelRequire("45kbr")).default).total)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2qxpw")).LegendItemCount), {
                href: viewAllLink,
                target: linksTarget,
                onClick: ()=>fireSectionAnalytics('view', {
                        count: chartData.totalCount
                    }),
                "aria-label": formatMessage((0, (0, parcelRequire("45kbr")).default).totalCountWithLabel, {
                    issuesCount: chartData.totalCount
                })
            }, chartData.totalCount)));
            content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2qxpw")).Description), null, isEmpty ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, (0, parcelRequire("45kbr")).default).descriptionWhenEmpty), hasCreateItem && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, ' ', (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dLD8P")).default), {
                href: `${issuesLinkUrl}?inlineCreate=true`,
                onClick: ()=>fireSectionAnalytics('view', {
                        inlineCreate: true
                    }),
                target: linksTarget
            }))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Q4sF")).FormattedI18nMessage), {
                message: formatMessage((0, (0, parcelRequire("45kbr")).default).description, {
                    linkStart: '{linkStart}',
                    linkEnd: '{linkEnd}'
                }),
                componentsMapping: {
                    link: ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jWlFw")).default), {
                            href: viewAllLink,
                            target: linksTarget,
                            onClick: ()=>fireSectionAnalytics('view', {
                                    inlineCreate: false
                                }),
                            "aria-label": formatMessage((0, (0, parcelRequire("45kbr")).default).viewAllItemsLabel)
                        }, children)
                }
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2qxpw")).ChartWrapper), null, isEmpty ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2qxpw")).EmptyChart), {
                testId: "business-summary.ui.summary-view.progress-by-status.empty-chart"
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2qxpw")).Chart), {
                onChartReady: setEchartsInstance,
                echarts: (0, parcelRequire("ixV1I")),
                option: chartData.option,
                style: $85068340b2ff4a30$var$CHART_STYLE,
                opts: $85068340b2ff4a30$var$CHART_OPTIONS,
                onEvents: chartEvents
            }), isEligibleForCreateStatus && (0, (0, parcelRequire("6s1PB")).expVal)('business_summary_page_inline_status', 'isInlineStatusChangeEnabled', false) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3srSR")).default), {
                direction: "column",
                xcss: $85068340b2ff4a30$var$legendContainerStyles
            }, legendContent, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("htu9M")).CreateStatusButton), {
                onClick: handleCreateStatusButtonClick,
                statusNames: existingStatusNames,
                hasMultipleWorkflows: hasMultipleWorkflows,
                onCreateStatusSuccess: refresh
            })) : legendContent));
        } else content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7NUKB")).default), {
            name: "progress-by-status"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2qxpw")).CenteredSkeleton), {
            testId: "business-summary.ui.summary-view.progress-by-status.skeleton"
        }));
        if (isEnabledForTailoredOnboardingM2) {
            const { ref: summaryViewNudgeRef } = (0, (0, parcelRequire("9USr3")).useRegisterNudgeTarget)((0, $6784cbc7d62e5d7c$export$594d3436316492be), true);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
                name: "business-summary-progress-by-status"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iDn2")).default), {
                ref: summaryViewNudgeRef,
                title: formatMessage((0, (0, parcelRequire("45kbr")).default).title),
                isLoading: loading,
                testId: "business-summary.ui.summary-view.progress-by-status",
                onPointerEnter: startHoverTimer,
                onPointerLeave: stopHoverTimer
            }, content), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ghgEK")).SummaryViewNudgeAsync), null));
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "business-summary-progress-by-status"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iDn2")).default), {
            title: formatMessage((0, (0, parcelRequire("45kbr")).default).title),
            isLoading: loading,
            testId: "business-summary.ui.summary-view.progress-by-status",
            onPointerEnter: startHoverTimer,
            onPointerLeave: stopHoverTimer
        }, content));
    };
    const $85068340b2ff4a30$var$legendContainerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        flex: '1 1 50%',
        maxHeight: '100%',
        minWidth: '0'
    });
    var $85068340b2ff4a30$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($85068340b2ff4a30$var$ProgressByStatus);
});
parcelRegister("eiOHN", function(module, exports) {
    $parcel$export(module.exports, "install", ()=>$02afe78cfe66c8a4$export$4b3e715f166fdd78);
    var $1nKsD;
    var $jKcGl;
    var $75yO8;
    var $bahqM;
    var $5e4Cq;
    var $jft0T;
    var $3S1hK;
    function $02afe78cfe66c8a4$export$4b3e715f166fdd78(registers) {
        registers.registerChartView((0, (0, parcelRequire("5e4Cq")).default));
        registers.registerSeriesModel((0, (0, parcelRequire("jft0T")).default));
        (0, (0, parcelRequire("1nKsD")).createLegacyDataSelectAction)('pie', registers.registerAction);
        registers.registerLayout((0, (0, parcelRequire("bahqM")).curry)((0, (0, parcelRequire("jKcGl")).default), 'pie'));
        registers.registerProcessor((0, (0, parcelRequire("75yO8")).default)('pie'));
        registers.registerProcessor((0, (0, parcelRequire("3S1hK")).default)('pie'));
    }
});
parcelRegister("jKcGl", function(module, exports) {
    $parcel$export(module.exports, "getBasicPieLayout", ()=>$e5fc26945f1647c7$export$2a0d4d5b12383eb9);
    $parcel$export(module.exports, "default", ()=>$e5fc26945f1647c7$export$2e2bcd8739ae039);
    var $jmSNG;
    var $65MS1;
    var $bahqM;
    var $e5fc26945f1647c7$var$PI2 = Math.PI * 2;
    var $e5fc26945f1647c7$var$RADIAN = Math.PI / 180;
    function $e5fc26945f1647c7$var$getViewRect(seriesModel, api) {
        return (0, parcelRequire("65MS1")).getLayoutRect(seriesModel.getBoxLayoutParams(), {
            width: api.getWidth(),
            height: api.getHeight()
        });
    }
    function $e5fc26945f1647c7$export$2a0d4d5b12383eb9(seriesModel, api) {
        var viewRect = $e5fc26945f1647c7$var$getViewRect(seriesModel, api);
        var center = seriesModel.get('center');
        var radius = seriesModel.get('radius');
        if (!(0, parcelRequire("bahqM")).isArray(radius)) radius = [
            0,
            radius
        ];
        if (!(0, parcelRequire("bahqM")).isArray(center)) center = [
            center,
            center
        ];
        var width = (0, (0, parcelRequire("jmSNG")).parsePercent)(viewRect.width, api.getWidth());
        var height = (0, (0, parcelRequire("jmSNG")).parsePercent)(viewRect.height, api.getHeight());
        var size = Math.min(width, height);
        var cx = (0, (0, parcelRequire("jmSNG")).parsePercent)(center[0], width) + viewRect.x;
        var cy = (0, (0, parcelRequire("jmSNG")).parsePercent)(center[1], height) + viewRect.y;
        var r0 = (0, (0, parcelRequire("jmSNG")).parsePercent)(radius[0], size / 2);
        var r = (0, (0, parcelRequire("jmSNG")).parsePercent)(radius[1], size / 2);
        return {
            cx: cx,
            cy: cy,
            r0: r0,
            r: r
        };
    }
    function $e5fc26945f1647c7$export$2e2bcd8739ae039(seriesType, ecModel, api) {
        ecModel.eachSeriesByType(seriesType, function(seriesModel) {
            var data = seriesModel.getData();
            var valueDim = data.mapDimension('value');
            var viewRect = $e5fc26945f1647c7$var$getViewRect(seriesModel, api);
            var _a = $e5fc26945f1647c7$export$2a0d4d5b12383eb9(seriesModel, api), cx = _a.cx, cy = _a.cy, r = _a.r, r0 = _a.r0;
            var startAngle = -seriesModel.get('startAngle') * $e5fc26945f1647c7$var$RADIAN;
            var minAngle = seriesModel.get('minAngle') * $e5fc26945f1647c7$var$RADIAN;
            var validDataCount = 0;
            data.each(valueDim, function(value) {
                !isNaN(value) && validDataCount++;
            });
            var sum = data.getSum(valueDim);
            var unitRadian = Math.PI / (sum || validDataCount) * 2;
            var clockwise = seriesModel.get('clockwise');
            var roseType = seriesModel.get('roseType');
            var stillShowZeroSum = seriesModel.get('stillShowZeroSum');
            var extent = data.getDataExtent(valueDim);
            extent[0] = 0;
            var restAngle = $e5fc26945f1647c7$var$PI2;
            var valueSumLargerThanMinAngle = 0;
            var currentAngle = startAngle;
            var dir = clockwise ? 1 : -1;
            data.setLayout({
                viewRect: viewRect,
                r: r
            });
            data.each(valueDim, function(value, idx) {
                var angle;
                if (isNaN(value)) {
                    data.setItemLayout(idx, {
                        angle: NaN,
                        startAngle: NaN,
                        endAngle: NaN,
                        clockwise: clockwise,
                        cx: cx,
                        cy: cy,
                        r0: r0,
                        r: roseType ? NaN : r
                    });
                    return;
                }
                if (roseType !== 'area') angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
                else angle = $e5fc26945f1647c7$var$PI2 / validDataCount;
                if (angle < minAngle) {
                    angle = minAngle;
                    restAngle -= minAngle;
                } else valueSumLargerThanMinAngle += value;
                var endAngle = currentAngle + dir * angle;
                data.setItemLayout(idx, {
                    angle: angle,
                    startAngle: currentAngle,
                    endAngle: endAngle,
                    clockwise: clockwise,
                    cx: cx,
                    cy: cy,
                    r0: r0,
                    r: roseType ? (0, (0, parcelRequire("jmSNG")).linearMap)(value, extent, [
                        r0,
                        r
                    ]) : r
                });
                currentAngle = endAngle;
            });
            if (restAngle < $e5fc26945f1647c7$var$PI2 && validDataCount) {
                if (restAngle <= 1e-3) {
                    var angle_1 = $e5fc26945f1647c7$var$PI2 / validDataCount;
                    data.each(valueDim, function(value, idx) {
                        if (!isNaN(value)) {
                            var layout_1 = data.getItemLayout(idx);
                            layout_1.angle = angle_1;
                            layout_1.startAngle = startAngle + dir * idx * angle_1;
                            layout_1.endAngle = startAngle + dir * (idx + 1) * angle_1;
                        }
                    });
                } else {
                    unitRadian = restAngle / valueSumLargerThanMinAngle;
                    currentAngle = startAngle;
                    data.each(valueDim, function(value, idx) {
                        if (!isNaN(value)) {
                            var layout_2 = data.getItemLayout(idx);
                            var angle = layout_2.angle === minAngle ? minAngle : value * unitRadian;
                            layout_2.startAngle = currentAngle;
                            layout_2.endAngle = currentAngle + dir * angle;
                            currentAngle += dir * angle;
                        }
                    });
                }
            }
        });
    }
});
parcelRegister("75yO8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5294001d9ce76eb4$export$2e2bcd8739ae039);
    function $5294001d9ce76eb4$export$2e2bcd8739ae039(seriesType) {
        return {
            seriesType: seriesType,
            reset: function(seriesModel, ecModel) {
                var legendModels = ecModel.findComponents({
                    mainType: 'legend'
                });
                if (!legendModels || !legendModels.length) return;
                var data = seriesModel.getData();
                data.filterSelf(function(idx) {
                    var name = data.getName(idx);
                    for(var i = 0; i < legendModels.length; i++){
                        if (!legendModels[i].isSelected(name)) return false;
                    }
                    return true;
                });
            }
        };
    }
});
parcelRegister("5e4Cq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3ce1d7c042d0ed7a$export$2e2bcd8739ae039);
    var $3VFsf;
    var $bahqM;
    var $4KVOr;
    var $eYgMC;
    parcelRequire("fHITF");
    var $32bXc;
    var $elGBV;
    var $eYgMC;
    var $4gEFv;
    var $fIXXx;
    var $loerw;
    var $414M3;
    var $fxCHE;
    var $gvLUt;
    var $3odut;
    var $eYgMC;
    var $jKcGl;
    var $3ce1d7c042d0ed7a$var$PiePiece = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(PiePiece, _super);
        function PiePiece(data, idx, startAngle) {
            var _this = _super.call(this) || this;
            _this.z2 = 2;
            var text = new (0, parcelRequire("4gEFv")).default();
            _this.setTextContent(text);
            _this.updateData(data, idx, startAngle, true);
            return _this;
        }
        PiePiece.prototype.updateData = function(data, idx, startAngle, firstCreate) {
            var sector = this;
            var seriesModel = data.hostModel;
            var itemModel = data.getItemModel(idx);
            var emphasisModel = itemModel.getModel('emphasis');
            var layout = data.getItemLayout(idx);
            var sectorShape = (0, (0, parcelRequire("bahqM")).extend)((0, (0, parcelRequire("3odut")).getSectorCornerRadius)(itemModel.getModel('itemStyle'), layout, true), layout);
            if (isNaN(sectorShape.startAngle)) {
                sector.setShape(sectorShape);
                return;
            }
            if (firstCreate) {
                sector.setShape(sectorShape);
                var animationType = seriesModel.getShallow('animationType');
                if (animationType === 'scale') {
                    sector.shape.r = layout.r0;
                    (0, parcelRequire("eYgMC")).initProps(sector, {
                        shape: {
                            r: layout.r
                        }
                    }, seriesModel, idx);
                } else if (startAngle != null) {
                    sector.setShape({
                        startAngle: startAngle,
                        endAngle: startAngle
                    });
                    (0, parcelRequire("eYgMC")).initProps(sector, {
                        shape: {
                            startAngle: layout.startAngle,
                            endAngle: layout.endAngle
                        }
                    }, seriesModel, idx);
                } else {
                    sector.shape.endAngle = layout.startAngle;
                    (0, parcelRequire("eYgMC")).updateProps(sector, {
                        shape: {
                            endAngle: layout.endAngle
                        }
                    }, seriesModel, idx);
                }
            } else {
                (0, (0, parcelRequire("eYgMC")).saveOldStyle)(sector);
                (0, parcelRequire("eYgMC")).updateProps(sector, {
                    shape: sectorShape
                }, seriesModel, idx);
            }
            sector.useStyle(data.getItemVisual(idx, 'style'));
            (0, (0, parcelRequire("fIXXx")).setStatesStylesFromModel)(sector, itemModel);
            var midAngle = (layout.startAngle + layout.endAngle) / 2;
            var offset = seriesModel.get('selectedOffset');
            var dx = Math.cos(midAngle) * offset;
            var dy = Math.sin(midAngle) * offset;
            var cursorStyle = itemModel.getShallow('cursor');
            cursorStyle && sector.attr('cursor', cursorStyle);
            this._updateLabel(seriesModel, data, idx);
            sector.ensureState('emphasis').shape = (0, (0, parcelRequire("3VFsf")).__assign)({
                r: layout.r + (emphasisModel.get('scale') ? emphasisModel.get('scaleSize') || 0 : 0)
            }, (0, (0, parcelRequire("3odut")).getSectorCornerRadius)(emphasisModel.getModel('itemStyle'), layout));
            (0, (0, parcelRequire("bahqM")).extend)(sector.ensureState('select'), {
                x: dx,
                y: dy,
                shape: (0, (0, parcelRequire("3odut")).getSectorCornerRadius)(itemModel.getModel([
                    'select',
                    'itemStyle'
                ]), layout)
            });
            (0, (0, parcelRequire("bahqM")).extend)(sector.ensureState('blur'), {
                shape: (0, (0, parcelRequire("3odut")).getSectorCornerRadius)(itemModel.getModel([
                    'blur',
                    'itemStyle'
                ]), layout)
            });
            var labelLine = sector.getTextGuideLine();
            var labelText = sector.getTextContent();
            labelLine && (0, (0, parcelRequire("bahqM")).extend)(labelLine.ensureState('select'), {
                x: dx,
                y: dy
            });
            (0, (0, parcelRequire("bahqM")).extend)(labelText.ensureState('select'), {
                x: dx,
                y: dy
            });
            (0, (0, parcelRequire("fIXXx")).enableHoverEmphasis)(this, emphasisModel.get('focus'), emphasisModel.get('blurScope'));
        };
        PiePiece.prototype._updateLabel = function(seriesModel, data, idx) {
            var sector = this;
            var itemModel = data.getItemModel(idx);
            var labelLineModel = itemModel.getModel('labelLine');
            var style = data.getItemVisual(idx, 'style');
            var visualColor = style && style.fill;
            var visualOpacity = style && style.opacity;
            (0, (0, parcelRequire("gvLUt")).setLabelStyle)(sector, (0, (0, parcelRequire("gvLUt")).getLabelStatesModels)(itemModel), {
                labelFetcher: data.hostModel,
                labelDataIndex: idx,
                inheritColor: visualColor,
                defaultOpacity: visualOpacity,
                defaultText: seriesModel.getFormattedLabel(idx, 'normal') || data.getName(idx)
            });
            var labelText = sector.getTextContent();
            sector.setTextConfig({
                position: null,
                rotation: null
            });
            labelText.attr({
                z2: 10
            });
            var labelPosition = seriesModel.get([
                'label',
                'position'
            ]);
            if (labelPosition !== 'outside' && labelPosition !== 'outer') sector.removeTextGuideLine();
            else {
                var polyline = this.getTextGuideLine();
                if (!polyline) {
                    polyline = new (0, parcelRequire("32bXc")).default();
                    this.setTextGuideLine(polyline);
                }
                (0, (0, parcelRequire("fxCHE")).setLabelLineStyle)(this, (0, (0, parcelRequire("fxCHE")).getLabelLineStatesModels)(itemModel), {
                    stroke: visualColor,
                    opacity: (0, (0, parcelRequire("bahqM")).retrieve3)(labelLineModel.get([
                        'lineStyle',
                        'opacity'
                    ]), visualOpacity, 1)
                });
            }
        };
        return PiePiece;
    }((0, parcelRequire("elGBV")).default);
    var $3ce1d7c042d0ed7a$var$PieView = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(PieView, _super);
        function PieView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.ignoreLabelLineUpdate = true;
            return _this;
        }
        PieView.prototype.init = function() {
            var sectorGroup = new (0, parcelRequire("4KVOr")).default();
            this._sectorGroup = sectorGroup;
        };
        PieView.prototype.render = function(seriesModel, ecModel, api, payload) {
            var data = seriesModel.getData();
            var oldData = this._data;
            var group = this.group;
            var startAngle;
            if (!oldData && data.count() > 0) {
                var shape = data.getItemLayout(0);
                for(var s = 1; isNaN(shape && shape.startAngle) && s < data.count(); ++s)shape = data.getItemLayout(s);
                if (shape) startAngle = shape.startAngle;
            }
            if (this._emptyCircleSector) group.remove(this._emptyCircleSector);
            if (data.count() === 0 && seriesModel.get('showEmptyCircle')) {
                var sector = new (0, parcelRequire("elGBV")).default({
                    shape: (0, (0, parcelRequire("jKcGl")).getBasicPieLayout)(seriesModel, api)
                });
                sector.useStyle(seriesModel.getModel('emptyCircleStyle').getItemStyle());
                this._emptyCircleSector = sector;
                group.add(sector);
            }
            data.diff(oldData).add(function(idx) {
                var piePiece = new $3ce1d7c042d0ed7a$var$PiePiece(data, idx, startAngle);
                data.setItemGraphicEl(idx, piePiece);
                group.add(piePiece);
            }).update(function(newIdx, oldIdx) {
                var piePiece = oldData.getItemGraphicEl(oldIdx);
                piePiece.updateData(data, newIdx, startAngle);
                piePiece.off('click');
                group.add(piePiece);
                data.setItemGraphicEl(newIdx, piePiece);
            }).remove(function(idx) {
                var piePiece = oldData.getItemGraphicEl(idx);
                (0, parcelRequire("eYgMC")).removeElementWithFadeOut(piePiece, seriesModel, idx);
            }).execute();
            (0, (0, parcelRequire("414M3")).default)(seriesModel);
            if (seriesModel.get('animationTypeUpdate') !== 'expansion') this._data = data;
        };
        PieView.prototype.dispose = function() {};
        PieView.prototype.containPoint = function(point, seriesModel) {
            var data = seriesModel.getData();
            var itemLayout = data.getItemLayout(0);
            if (itemLayout) {
                var dx = point[0] - itemLayout.cx;
                var dy = point[1] - itemLayout.cy;
                var radius = Math.sqrt(dx * dx + dy * dy);
                return radius <= itemLayout.r && radius >= itemLayout.r0;
            }
        };
        PieView.type = 'pie';
        return PieView;
    }((0, (0, parcelRequire("loerw")).default));
    var $3ce1d7c042d0ed7a$export$2e2bcd8739ae039 = $3ce1d7c042d0ed7a$var$PieView;
});
parcelRegister("414M3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2ecaf56d2c00dc1e$export$2e2bcd8739ae039);
    var $jmSNG;
    var $bMDnR;
    var $bahqM;
    var $fxCHE;
    var $3LB2b;
    var $2ecaf56d2c00dc1e$var$RADIAN = Math.PI / 180;
    function $2ecaf56d2c00dc1e$var$adjustSingleSide(list, cx, cy, r, dir, viewWidth, viewHeight, viewLeft, viewTop, farthestX) {
        if (list.length < 2) return;
        function recalculateXOnSemiToAlignOnEllipseCurve(semi) {
            var rB = semi.rB;
            var rB2 = rB * rB;
            for(var i = 0; i < semi.list.length; i++){
                var item = semi.list[i];
                var dy = Math.abs(item.label.y - cy);
                var rA = r + item.len;
                var rA2 = rA * rA;
                var dx = Math.sqrt((1 - Math.abs(dy * dy / rB2)) * rA2);
                item.label.x = cx + (dx + item.len2) * dir;
            }
        }
        function recalculateX(items) {
            var topSemi = {
                list: [],
                maxY: 0
            };
            var bottomSemi = {
                list: [],
                maxY: 0
            };
            for(var i = 0; i < items.length; i++){
                if (items[i].labelAlignTo !== 'none') continue;
                var item = items[i];
                var semi = item.label.y > cy ? bottomSemi : topSemi;
                var dy = Math.abs(item.label.y - cy);
                if (dy > semi.maxY) {
                    var dx = item.label.x - cx - item.len2 * dir;
                    var rA = r + item.len;
                    var rB = Math.abs(dx) < rA ? Math.sqrt(dy * dy / (1 - dx * dx / rA / rA)) : rA;
                    semi.rB = rB;
                    semi.maxY = dy;
                }
                semi.list.push(item);
            }
            recalculateXOnSemiToAlignOnEllipseCurve(topSemi);
            recalculateXOnSemiToAlignOnEllipseCurve(bottomSemi);
        }
        var len = list.length;
        for(var i = 0; i < len; i++)if (list[i].position === 'outer' && list[i].labelAlignTo === 'labelLine') {
            var dx = list[i].label.x - farthestX;
            list[i].linePoints[1][0] += dx;
            list[i].label.x = farthestX;
        }
        if ((0, (0, parcelRequire("3LB2b")).shiftLayoutOnY)(list, viewTop, viewTop + viewHeight)) recalculateX(list);
    }
    function $2ecaf56d2c00dc1e$var$avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop) {
        var leftList = [];
        var rightList = [];
        var leftmostX = Number.MAX_VALUE;
        var rightmostX = -Number.MAX_VALUE;
        for(var i = 0; i < labelLayoutList.length; i++){
            var label = labelLayoutList[i].label;
            if ($2ecaf56d2c00dc1e$var$isPositionCenter(labelLayoutList[i])) continue;
            if (label.x < cx) {
                leftmostX = Math.min(leftmostX, label.x);
                leftList.push(labelLayoutList[i]);
            } else {
                rightmostX = Math.max(rightmostX, label.x);
                rightList.push(labelLayoutList[i]);
            }
        }
        $2ecaf56d2c00dc1e$var$adjustSingleSide(rightList, cx, cy, r, 1, viewWidth, viewHeight, viewLeft, viewTop, rightmostX);
        $2ecaf56d2c00dc1e$var$adjustSingleSide(leftList, cx, cy, r, -1, viewWidth, viewHeight, viewLeft, viewTop, leftmostX);
        for(var i = 0; i < labelLayoutList.length; i++){
            var layout = labelLayoutList[i];
            var label = layout.label;
            if ($2ecaf56d2c00dc1e$var$isPositionCenter(layout)) continue;
            var linePoints = layout.linePoints;
            if (linePoints) {
                var isAlignToEdge = layout.labelAlignTo === 'edge';
                var realTextWidth = layout.rect.width;
                var targetTextWidth = void 0;
                if (isAlignToEdge) {
                    if (label.x < cx) targetTextWidth = linePoints[2][0] - layout.labelDistance - viewLeft - layout.edgeDistance;
                    else targetTextWidth = viewLeft + viewWidth - layout.edgeDistance - linePoints[2][0] - layout.labelDistance;
                } else if (label.x < cx) targetTextWidth = label.x - viewLeft - layout.bleedMargin;
                else targetTextWidth = viewLeft + viewWidth - label.x - layout.bleedMargin;
                if (targetTextWidth < layout.rect.width) {
                    layout.label.style.width = targetTextWidth;
                    if (layout.labelAlignTo === 'edge') realTextWidth = targetTextWidth;
                }
                var dist = linePoints[1][0] - linePoints[2][0];
                if (isAlignToEdge) {
                    if (label.x < cx) linePoints[2][0] = viewLeft + layout.edgeDistance + realTextWidth + layout.labelDistance;
                    else linePoints[2][0] = viewLeft + viewWidth - layout.edgeDistance - realTextWidth - layout.labelDistance;
                } else {
                    if (label.x < cx) linePoints[2][0] = label.x + layout.labelDistance;
                    else linePoints[2][0] = label.x - layout.labelDistance;
                    linePoints[1][0] = linePoints[2][0] + dist;
                }
                linePoints[1][1] = linePoints[2][1] = label.y;
            }
        }
    }
    function $2ecaf56d2c00dc1e$var$isPositionCenter(sectorShape) {
        return sectorShape.position === 'center';
    }
    function $2ecaf56d2c00dc1e$export$2e2bcd8739ae039(seriesModel) {
        var data = seriesModel.getData();
        var labelLayoutList = [];
        var cx;
        var cy;
        var hasLabelRotate = false;
        var minShowLabelRadian = (seriesModel.get('minShowLabelAngle') || 0) * $2ecaf56d2c00dc1e$var$RADIAN;
        var viewRect = data.getLayout('viewRect');
        var r = data.getLayout('r');
        var viewWidth = viewRect.width;
        var viewLeft = viewRect.x;
        var viewTop = viewRect.y;
        var viewHeight = viewRect.height;
        function setNotShow(el) {
            el.ignore = true;
        }
        function isLabelShown(label) {
            if (!label.ignore) return true;
            for(var key in label.states){
                if (label.states[key].ignore === false) return true;
            }
            return false;
        }
        data.each(function(idx) {
            var sector = data.getItemGraphicEl(idx);
            var sectorShape = sector.shape;
            var label = sector.getTextContent();
            var labelLine = sector.getTextGuideLine();
            var itemModel = data.getItemModel(idx);
            var labelModel = itemModel.getModel('label');
            var labelPosition = labelModel.get('position') || itemModel.get([
                'emphasis',
                'label',
                'position'
            ]);
            var labelDistance = labelModel.get('distanceToLabelLine');
            var labelAlignTo = labelModel.get('alignTo');
            var edgeDistance = (0, (0, parcelRequire("jmSNG")).parsePercent)(labelModel.get('edgeDistance'), viewWidth);
            var bleedMargin = labelModel.get('bleedMargin');
            var labelLineModel = itemModel.getModel('labelLine');
            var labelLineLen = labelLineModel.get('length');
            labelLineLen = (0, (0, parcelRequire("jmSNG")).parsePercent)(labelLineLen, viewWidth);
            var labelLineLen2 = labelLineModel.get('length2');
            labelLineLen2 = (0, (0, parcelRequire("jmSNG")).parsePercent)(labelLineLen2, viewWidth);
            if (Math.abs(sectorShape.endAngle - sectorShape.startAngle) < minShowLabelRadian) {
                (0, (0, parcelRequire("bahqM")).each)(label.states, setNotShow);
                label.ignore = true;
                return;
            }
            if (!isLabelShown(label)) return;
            var midAngle = (sectorShape.startAngle + sectorShape.endAngle) / 2;
            var nx = Math.cos(midAngle);
            var ny = Math.sin(midAngle);
            var textX;
            var textY;
            var linePoints;
            var textAlign;
            cx = sectorShape.cx;
            cy = sectorShape.cy;
            var isLabelInside = labelPosition === 'inside' || labelPosition === 'inner';
            if (labelPosition === 'center') {
                textX = sectorShape.cx;
                textY = sectorShape.cy;
                textAlign = 'center';
            } else {
                var x1 = (isLabelInside ? (sectorShape.r + sectorShape.r0) / 2 * nx : sectorShape.r * nx) + cx;
                var y1 = (isLabelInside ? (sectorShape.r + sectorShape.r0) / 2 * ny : sectorShape.r * ny) + cy;
                textX = x1 + nx * 3;
                textY = y1 + ny * 3;
                if (!isLabelInside) {
                    var x2 = x1 + nx * (labelLineLen + r - sectorShape.r);
                    var y2 = y1 + ny * (labelLineLen + r - sectorShape.r);
                    var x3 = x2 + (nx < 0 ? -1 : 1) * labelLineLen2;
                    var y3 = y2;
                    if (labelAlignTo === 'edge') textX = nx < 0 ? viewLeft + edgeDistance : viewLeft + viewWidth - edgeDistance;
                    else textX = x3 + (nx < 0 ? -labelDistance : labelDistance);
                    textY = y3;
                    linePoints = [
                        [
                            x1,
                            y1
                        ],
                        [
                            x2,
                            y2
                        ],
                        [
                            x3,
                            y3
                        ]
                    ];
                }
                textAlign = isLabelInside ? 'center' : labelAlignTo === 'edge' ? nx > 0 ? 'right' : 'left' : nx > 0 ? 'left' : 'right';
            }
            var labelRotate;
            var rotate = labelModel.get('rotate');
            if (typeof rotate === 'number') labelRotate = rotate * (Math.PI / 180);
            else if (labelPosition === 'center') labelRotate = 0;
            else {
                var radialAngle = nx < 0 ? -midAngle + Math.PI : -midAngle;
                if (rotate === 'radial' || rotate === true) labelRotate = radialAngle;
                else if (rotate === 'tangential' && labelPosition !== 'outside' && labelPosition !== 'outer') {
                    labelRotate = radialAngle + Math.PI / 2;
                    if (labelRotate > Math.PI / 2) labelRotate -= Math.PI;
                } else labelRotate = 0;
            }
            hasLabelRotate = !!labelRotate;
            label.x = textX;
            label.y = textY;
            label.rotation = labelRotate;
            label.setStyle({
                verticalAlign: 'middle'
            });
            if (!isLabelInside) {
                var textRect = label.getBoundingRect().clone();
                textRect.applyTransform(label.getComputedTransform());
                var margin = (label.style.margin || 0) + 2.1;
                textRect.y -= margin / 2;
                textRect.height += margin;
                labelLayoutList.push({
                    label: label,
                    labelLine: labelLine,
                    position: labelPosition,
                    len: labelLineLen,
                    len2: labelLineLen2,
                    minTurnAngle: labelLineModel.get('minTurnAngle'),
                    maxSurfaceAngle: labelLineModel.get('maxSurfaceAngle'),
                    surfaceNormal: new (0, (0, parcelRequire("bMDnR")).default)(nx, ny),
                    linePoints: linePoints,
                    textAlign: textAlign,
                    labelDistance: labelDistance,
                    labelAlignTo: labelAlignTo,
                    edgeDistance: edgeDistance,
                    bleedMargin: bleedMargin,
                    rect: textRect
                });
            } else {
                label.setStyle({
                    align: textAlign
                });
                var selectState = label.states.select;
                if (selectState) {
                    selectState.x += label.x;
                    selectState.y += label.y;
                }
            }
            sector.setTextConfig({
                inside: isLabelInside
            });
        });
        if (!hasLabelRotate && seriesModel.get('avoidLabelOverlap')) $2ecaf56d2c00dc1e$var$avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop);
        for(var i = 0; i < labelLayoutList.length; i++){
            var layout = labelLayoutList[i];
            var label = layout.label;
            var labelLine = layout.labelLine;
            var notShowLabel = isNaN(label.x) || isNaN(label.y);
            if (label) {
                label.setStyle({
                    align: layout.textAlign
                });
                if (notShowLabel) {
                    (0, (0, parcelRequire("bahqM")).each)(label.states, setNotShow);
                    label.ignore = true;
                }
                var selectState = label.states.select;
                if (selectState) {
                    selectState.x += label.x;
                    selectState.y += label.y;
                }
            }
            if (labelLine) {
                var linePoints = layout.linePoints;
                if (notShowLabel || !linePoints) {
                    (0, (0, parcelRequire("bahqM")).each)(labelLine.states, setNotShow);
                    labelLine.ignore = true;
                } else {
                    (0, (0, parcelRequire("fxCHE")).limitTurnAngle)(linePoints, layout.minTurnAngle);
                    (0, (0, parcelRequire("fxCHE")).limitSurfaceAngle)(linePoints, layout.surfaceNormal, layout.maxSurfaceAngle);
                    labelLine.setShape({
                        points: linePoints
                    });
                    label.__hostTarget.textGuideLineConfig = {
                        anchor: new (0, (0, parcelRequire("bMDnR")).default)(linePoints[0][0], linePoints[0][1])
                    };
                }
            }
        }
    }
});
parcelRegister("3odut", function(module, exports) {
    $parcel$export(module.exports, "getSectorCornerRadius", ()=>$277e13e7ae730ea6$export$b395eeeb2ad7cce5);
    var $bahqM;
    var $b7ZX8;
    function $277e13e7ae730ea6$export$b395eeeb2ad7cce5(model, shape, zeroIfNull) {
        var cornerRadius = model.get('borderRadius');
        if (cornerRadius == null) return zeroIfNull ? {
            innerCornerRadius: 0,
            cornerRadius: 0
        } : null;
        if (!(0, (0, parcelRequire("bahqM")).isArray)(cornerRadius)) cornerRadius = [
            cornerRadius,
            cornerRadius
        ];
        return {
            innerCornerRadius: (0, (0, parcelRequire("b7ZX8")).parsePercent)(cornerRadius[0], shape.r0),
            cornerRadius: (0, (0, parcelRequire("b7ZX8")).parsePercent)(cornerRadius[1], shape.r)
        };
    }
});
parcelRegister("jft0T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e035ec843ba6c93c$export$2e2bcd8739ae039);
    var $3VFsf;
    var $iGPcw;
    var $bahqM;
    var $eaKsF;
    var $jmSNG;
    var $cNGs8;
    var $9xeC9;
    var $1O7Ua;
    var $e035ec843ba6c93c$var$PieSeriesModel = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(PieSeriesModel, _super);
        function PieSeriesModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        PieSeriesModel.prototype.init = function(option) {
            _super.prototype.init.apply(this, arguments);
            this.legendVisualProvider = new (0, (0, parcelRequire("9xeC9")).default)((0, parcelRequire("bahqM")).bind(this.getData, this), (0, parcelRequire("bahqM")).bind(this.getRawData, this));
            this._defaultLabelLine(option);
        };
        PieSeriesModel.prototype.mergeOption = function() {
            _super.prototype.mergeOption.apply(this, arguments);
        };
        PieSeriesModel.prototype.getInitialData = function() {
            return (0, (0, parcelRequire("iGPcw")).default)(this, {
                coordDimensions: [
                    'value'
                ],
                encodeDefaulter: (0, parcelRequire("bahqM")).curry((0, (0, parcelRequire("cNGs8")).makeSeriesEncodeForNameBased), this)
            });
        };
        PieSeriesModel.prototype.getDataParams = function(dataIndex) {
            var data = this.getData();
            var params = _super.prototype.getDataParams.call(this, dataIndex);
            var valueList = [];
            data.each(data.mapDimension('value'), function(value) {
                valueList.push(value);
            });
            params.percent = (0, (0, parcelRequire("jmSNG")).getPercentWithPrecision)(valueList, dataIndex, data.hostModel.get('percentPrecision'));
            params.$vars.push('percent');
            return params;
        };
        PieSeriesModel.prototype._defaultLabelLine = function(option) {
            (0, parcelRequire("eaKsF")).defaultEmphasis(option, 'labelLine', [
                'show'
            ]);
            var labelLineNormalOpt = option.labelLine;
            var labelLineEmphasisOpt = option.emphasis.labelLine;
            labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
            labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
        };
        PieSeriesModel.type = 'series.pie';
        PieSeriesModel.defaultOption = {
            zlevel: 0,
            z: 2,
            legendHoverLink: true,
            colorBy: 'data',
            center: [
                '50%',
                '50%'
            ],
            radius: [
                0,
                '75%'
            ],
            clockwise: true,
            startAngle: 90,
            minAngle: 0,
            minShowLabelAngle: 0,
            selectedOffset: 10,
            percentPrecision: 2,
            stillShowZeroSum: true,
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            width: null,
            height: null,
            label: {
                rotate: 0,
                show: true,
                overflow: 'truncate',
                position: 'outer',
                alignTo: 'none',
                edgeDistance: '25%',
                bleedMargin: 10,
                distanceToLabelLine: 5
            },
            labelLine: {
                show: true,
                length: 15,
                length2: 15,
                smooth: false,
                minTurnAngle: 90,
                maxSurfaceAngle: 90,
                lineStyle: {
                    width: 1,
                    type: 'solid'
                }
            },
            itemStyle: {
                borderWidth: 1,
                borderJoin: 'round'
            },
            showEmptyCircle: true,
            emptyCircleStyle: {
                color: 'lightgray',
                opacity: 1
            },
            labelLayout: {
                hideOverlap: true
            },
            emphasis: {
                scale: true,
                scaleSize: 5
            },
            avoidLabelOverlap: true,
            animationType: 'expansion',
            animationDuration: 1000,
            animationTypeUpdate: 'transition',
            animationEasingUpdate: 'cubicInOut',
            animationDurationUpdate: 500,
            animationEasing: 'cubicInOut'
        };
        return PieSeriesModel;
    }((0, (0, parcelRequire("1O7Ua")).default));
    var $e035ec843ba6c93c$export$2e2bcd8739ae039 = $e035ec843ba6c93c$var$PieSeriesModel;
});
parcelRegister("iGPcw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d9b3ddad845b31c1$export$2e2bcd8739ae039);
    var $h9jiS;
    var $liBXN;
    var $bahqM;
    function $d9b3ddad845b31c1$export$2e2bcd8739ae039(seriesModel, opt, nameList) {
        opt = (0, (0, parcelRequire("bahqM")).isArray)(opt) && {
            coordDimensions: opt
        } || (0, (0, parcelRequire("bahqM")).extend)({
            encodeDefine: seriesModel.getEncode()
        }, opt);
        var source = seriesModel.getSource();
        var dimensions = (0, (0, parcelRequire("h9jiS")).default)(source, opt).dimensions;
        var list = new (0, (0, parcelRequire("liBXN")).default)(dimensions, seriesModel);
        list.initData(source, nameList);
        return list;
    }
});
parcelRegister("9xeC9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6f128839c5e57ae4$export$2e2bcd8739ae039);
    var $6f128839c5e57ae4$var$LegendVisualProvider = function() {
        function LegendVisualProvider(getDataWithEncodedVisual, getRawData) {
            this._getDataWithEncodedVisual = getDataWithEncodedVisual;
            this._getRawData = getRawData;
        }
        LegendVisualProvider.prototype.getAllNames = function() {
            var rawData = this._getRawData();
            return rawData.mapArray(rawData.getName);
        };
        LegendVisualProvider.prototype.containName = function(name) {
            var rawData = this._getRawData();
            return rawData.indexOfName(name) >= 0;
        };
        LegendVisualProvider.prototype.indexOfName = function(name) {
            var dataWithEncodedVisual = this._getDataWithEncodedVisual();
            return dataWithEncodedVisual.indexOfName(name);
        };
        LegendVisualProvider.prototype.getItemVisual = function(dataIndex, key) {
            var dataWithEncodedVisual = this._getDataWithEncodedVisual();
            return dataWithEncodedVisual.getItemVisual(dataIndex, key);
        };
        return LegendVisualProvider;
    }();
    var $6f128839c5e57ae4$export$2e2bcd8739ae039 = $6f128839c5e57ae4$var$LegendVisualProvider;
});
parcelRegister("3S1hK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2d1769793ce44037$export$2e2bcd8739ae039);
    function $2d1769793ce44037$export$2e2bcd8739ae039(seriesType) {
        return {
            seriesType: seriesType,
            reset: function(seriesModel, ecModel) {
                var data = seriesModel.getData();
                data.filterSelf(function(idx) {
                    var valueDim = data.mapDimension('value');
                    var curValue = data.get(valueDim, idx);
                    if (typeof curValue === 'number' && !isNaN(curValue) && curValue < 0) return false;
                    return true;
                });
            }
        };
    }
});
const $6784cbc7d62e5d7c$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $6784cbc7d62e5d7c$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $6784cbc7d62e5d7c$export$e3884212029f7bef = 'should-show-welcome-modal';
const $6784cbc7d62e5d7c$export$eaf6b96a17b6476c = 'can-enroll-in-select-initial-view';
const $6784cbc7d62e5d7c$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $6784cbc7d62e5d7c$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $6784cbc7d62e5d7c$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $6784cbc7d62e5d7c$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $6784cbc7d62e5d7c$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $6784cbc7d62e5d7c$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $6784cbc7d62e5d7c$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $6784cbc7d62e5d7c$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $6784cbc7d62e5d7c$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $6784cbc7d62e5d7c$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $6784cbc7d62e5d7c$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $6784cbc7d62e5d7c$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $6784cbc7d62e5d7c$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $6784cbc7d62e5d7c$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $6784cbc7d62e5d7c$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $6784cbc7d62e5d7c$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $6784cbc7d62e5d7c$export$468488291ccd988 = 'timelineAddItemNudge';
const $6784cbc7d62e5d7c$export$7a33548109ac931d = 'createFormNudge';
const $6784cbc7d62e5d7c$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $6784cbc7d62e5d7c$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $6784cbc7d62e5d7c$export$594d3436316492be = 'summaryViewNudge';
const $6784cbc7d62e5d7c$export$77bc79debbf5c069 = 'inviteTeamNudge';
parcelRegister("8GOso", function(module, exports) {
    $parcel$export(module.exports, "usePersonalisationActions", ()=>$adde9919a40069db$export$5b1d43353c334c00);
    $parcel$export(module.exports, "useCommonEligibilityConditionsForJtbdOnboarding", ()=>$adde9919a40069db$export$c89644b13b6e777f);
    $parcel$export(module.exports, "useTailoredOnboardingPersonalisationAttributes", ()=>$adde9919a40069db$export$9aad8798ea46e07f);
    $parcel$export(module.exports, "useTailoredOnboardingPersonalisationM2", ()=>$adde9919a40069db$export$5875295cb096b1f2);
    $parcel$export(module.exports, "useIsTailoredOnboardingM2ForQuickstartEnabled", ()=>$adde9919a40069db$export$6bc15f8ade1cf36);
    $parcel$export(module.exports, "useFireExposureForTailoredOnboardingM2ForQuickstart", ()=>$adde9919a40069db$export$369994803661d31);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $jcw0u;
    var $6s1PB;
    var $4R6GH;
    var $cNd4s;
    var $3sQ5x;
    var $iXqE5;
    var $AK64q;
    var $4mXzi;
    var $iAFnF;
    var $1OQiY;
    const $adde9919a40069db$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'jira-onboarding-personalisation',
        initialState: (0, (0, parcelRequire("AK64q")).initialCachedEndpointState),
        actions: (0, parcelRequire("4mXzi")).actions
    });
    const $adde9919a40069db$export$5b1d43353c334c00 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($adde9919a40069db$var$store);
    const $adde9919a40069db$export$31a443426d101362 = (0, (0, parcelRequire("3sQ5x")).createHook)($adde9919a40069db$var$store);
    const $adde9919a40069db$export$c89644b13b6e777f = ()=>{
        const isSiteAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        return isSiteAdmin && (0, (0, parcelRequire("4R6GH")).fg)('jira_tailored_onboarding_jtbd_feature_gate');
    };
    const $adde9919a40069db$export$6f87e1662a24f8b9 = ({ isEligible: isEligible, experienceTypes: experienceTypes, additionalParameters: additionalParameters })=>{
        const [{ fetchedOnce: fetchedOnce, isFetching: isFetching, data: data }, { fetchOnboardingPersonalisation: fetchOnboardingPersonalisation }] = $adde9919a40069db$export$31a443426d101362();
        (0, $5uXOq.useEffect)(()=>{
            if (isEligible && !fetchedOnce && !isFetching && data === undefined) fetchOnboardingPersonalisation({
                experienceTypes: experienceTypes,
                additionalParameters: additionalParameters
            });
        }, [
            additionalParameters,
            data,
            experienceTypes,
            fetchOnboardingPersonalisation,
            fetchedOnce,
            isEligible,
            isFetching
        ]);
        if (!isEligible) return {
            data: undefined,
            isReady: true
        };
        return {
            data: data,
            isReady: fetchedOnce && !isFetching
        };
    };
    const $adde9919a40069db$export$9aad8798ea46e07f = ()=>{
        const isEligibleForTailoredOnboardingM2 = $adde9919a40069db$export$c89644b13b6e777f();
        const { data: personalisationData, isReady: personalisationDataIsReady } = $adde9919a40069db$export$6f87e1662a24f8b9({
            isEligible: isEligibleForTailoredOnboardingM2
        });
        return {
            personalisationDataIsReady: personalisationDataIsReady,
            teamType: personalisationData?.matched.variants.find((variant)=>variant.startsWith('teamType.'))?.replace('teamType.', ''),
            jtbd: personalisationData?.matched.variants.filter((variant)=>variant.startsWith('jtbd.option_')).map((option)=>option.replace('jtbd.option_', '')).join(',')
        };
    };
    const $adde9919a40069db$export$5875295cb096b1f2 = ({ isEligible: isEligible, additionalParameters: additionalParameters })=>{
        const hasSentErrorOnce = (0, $5uXOq.useRef)(false);
        const { data: data, isReady: isReady } = $adde9919a40069db$export$6f87e1662a24f8b9({
            isEligible: isEligible,
            experienceTypes: [
                'QUICKSTART',
                'TEMPLATE',
                'LANDING_PAGE'
            ],
            additionalParameters: additionalParameters
        });
        try {
            const conditionalProjectType = `projectType.${additionalParameters?.projectType}`;
            const isMatchingProjectType = Boolean(!additionalParameters?.projectType || data?.matched.variants.some((variant)=>variant === conditionalProjectType));
            const isMatchingTeamType = Boolean(data?.matched.variants.some((variant)=>variant.startsWith('teamType.') && (0, (0, parcelRequire("iAFnF")).ELIGIBLE_TEAM_TYPES_M2_FULL_NOTATION).includes(variant.split('.')[1])));
            const isMatchingJtbd = Boolean(data?.matched.variants.some((variant)=>variant.startsWith('jtbd')));
            const matched = Boolean(data && isMatchingJtbd && isMatchingProjectType && isMatchingTeamType);
            return {
                isReady: isReady,
                data: {
                    matched: matched,
                    matchedVariants: {
                        projectType: isMatchingProjectType,
                        tt: isMatchingTeamType,
                        jtbd: isMatchingJtbd
                    },
                    QUICKSTART: matched && data ? data.experience.QUICKSTART : [],
                    TEMPLATE: matched && data ? data.experience.TEMPLATE?.[0] : undefined,
                    LANDING_PAGE: matched && data ? data.experience.LANDING_PAGE?.[0] : undefined
                }
            };
        } catch (error) {
            if (!hasSentErrorOnce.current) (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'useTailoredOnboardingPersonalisationM2',
                    packageName: 'jiraOnboardingCore',
                    teamName: 'jlove-makkuro'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            hasSentErrorOnce.current = true;
        }
        return {
            isReady: isReady,
            data: {
                matched: false,
                matchedVariants: {
                    jtbd: false,
                    tt: false,
                    projectType: false
                },
                QUICKSTART: [],
                TEMPLATE: undefined,
                LANDING_PAGE: undefined
            }
        };
    };
    const $adde9919a40069db$export$6bc15f8ade1cf36 = ()=>{
        const isEligibleForJtbdOnboarding = $adde9919a40069db$export$c89644b13b6e777f();
        const isEnabled = (0, (0, parcelRequire("1OQiY")).isTailoredOnboardingM2ExperimentFlagEnabled)();
        const { isReady: personalisationDataIsReady, data: personalisationData } = $adde9919a40069db$export$5875295cb096b1f2({
            isEligible: isEligibleForJtbdOnboarding,
            additionalParameters: {
                projectType: (0, (0, parcelRequire("2vSU6")).CORE_PROJECT)
            }
        });
        return Boolean(personalisationDataIsReady && personalisationData.QUICKSTART && personalisationData.QUICKSTART?.length > 0 && isEnabled);
    };
    const $adde9919a40069db$export$369994803661d31 = ({ projectType: projectType })=>{
        const isEligibleForJtbdOnboarding = $adde9919a40069db$export$c89644b13b6e777f();
        const { isReady: personalisationDataIsReady, data: personalisationData } = $adde9919a40069db$export$5875295cb096b1f2({
            isEligible: isEligibleForJtbdOnboarding && (0, (0, parcelRequire("4R6GH")).fg)('tailored_onboarding_m2_content_exposure_adjust'),
            additionalParameters: {
                projectType: (0, (0, parcelRequire("2vSU6")).CORE_PROJECT)
            }
        });
        if ((0, (0, parcelRequire("4R6GH")).fg)('tailored_onboarding_m2_content_exposure_adjust') && projectType === (0, (0, parcelRequire("2vSU6")).CORE_PROJECT) && personalisationDataIsReady && personalisationData.matched && personalisationData.QUICKSTART && personalisationData.QUICKSTART?.length > 0) (0, (0, parcelRequire("6s1PB")).expVal)('jira_tailored_onboarding_jtbd', 'isEnabled', false);
    };
});
parcelRegister("AK64q", function(module, exports) {
    $parcel$export(module.exports, "initialCachedEndpointState", ()=>$e18633c22e50182e$export$aaed2d023c5dc2c);
    const $e18633c22e50182e$export$aaed2d023c5dc2c = {
        isFetching: false,
        wasFetched: false,
        fetchedOnce: false,
        fetchError: null
    };
});
parcelRegister("4mXzi", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$f50a5e3bb7b9f239$export$e324594224ef24da);
    var $7bRcT;
    var $FroD7;
    const $f50a5e3bb7b9f239$var$fetchOnboardingPersonalisation = (0, (0, parcelRequire("7bRcT")).cachedEndpointCall)((args)=>(0, (0, parcelRequire("FroD7")).fetchOnboardingPersonalisationWithRethrow)(args));
    const $f50a5e3bb7b9f239$var$trackPersonalisationAction = ({ additionalParameters: additionalParameters })=>()=>(0, (0, parcelRequire("FroD7")).trackPersonalisation)({
                additionalParameters: additionalParameters
            });
    const $f50a5e3bb7b9f239$export$e324594224ef24da = {
        fetchOnboardingPersonalisation: $f50a5e3bb7b9f239$var$fetchOnboardingPersonalisation,
        trackPersonalisation: $f50a5e3bb7b9f239$var$trackPersonalisationAction
    };
});
parcelRegister("7bRcT", function(module, exports) {
    $parcel$export(module.exports, "cachedEndpointCall", ()=>$69bbbca5d7164078$export$9ab04ab45a9b99da);
    const $69bbbca5d7164078$export$9ab04ab45a9b99da = (call)=>(params)=>async ({ getState: getState, setState: setState })=>{
                const { isFetching: isFetching, wasFetched: wasFetched, fetchedOnce: fetchedOnce } = getState();
                if (isFetching || wasFetched) return;
                setState({
                    isFetching: true
                });
                try {
                    const data = await call(params);
                    if (data !== null) setState({
                        data: data,
                        wasFetched: true
                    });
                    else setState({
                        wasFetched: fetchedOnce
                    });
                } catch (error) {
                    setState({
                        fetchError: error
                    });
                } finally{
                    setState({
                        isFetching: false,
                        fetchedOnce: true
                    });
                }
            };
});
parcelRegister("FroD7", function(module, exports) {
    $parcel$export(module.exports, "fetchOnboardingPersonalisationWithRethrow", ()=>$501ec097caecd266$export$6bc39428b6510a7c);
    $parcel$export(module.exports, "trackPersonalisation", ()=>$501ec097caecd266$export$9835c32b78102887);
    var $jcw0u;
    var $eusud;
    var $fv5ut;
    const $501ec097caecd266$var$PERSONALISATION_ENDPOINT = '/rest/personalisation/v1/experience';
    const $501ec097caecd266$var$TRACK_PERSONALISATION_ENDPOINT = '/rest/personalisation/v1/track';
    const $501ec097caecd266$var$responseHasAllRequestedExperienceTypes = ({ response: response, requestedExperienceTypes: requestedExperienceTypes })=>requestedExperienceTypes.every((requestedExperienceType)=>response.experience[requestedExperienceType]);
    const $501ec097caecd266$export$6bc39428b6510a7c = async ({ experienceTypes: experienceTypes = [
        'QUICKSTART',
        'TEMPLATE',
        'LANDING_PAGE'
    ], additionalParameters: additionalParameters })=>{
        try {
            const localStorageOnboardingPersonalisationResponse = (0, (0, parcelRequire("fv5ut")).getLocalStorageOnboardingPersonalisationResponse)();
            if (localStorageOnboardingPersonalisationResponse && $501ec097caecd266$var$responseHasAllRequestedExperienceTypes({
                response: localStorageOnboardingPersonalisationResponse,
                requestedExperienceTypes: experienceTypes
            })) return localStorageOnboardingPersonalisationResponse;
            const response = await (0, (0, parcelRequire("eusud")).performPostRequestWithRetry)($501ec097caecd266$var$PERSONALISATION_ENDPOINT, {
                body: JSON.stringify({
                    experienceTypes: experienceTypes,
                    additionalParameters: additionalParameters
                })
            });
            if (response) {
                const mergedResponse = {
                    experience: {
                        ...localStorageOnboardingPersonalisationResponse?.experience,
                        ...response.experience
                    },
                    matched: response.matched
                };
                (0, (0, parcelRequire("fv5ut")).setLocalStorageOnboardingPersonalisationResponse)(mergedResponse);
                return mergedResponse;
            }
            throw new Error('response from OnboardingPersonalisation is falsy');
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'fetchOnboardingPersonalisationWithRethrow',
                    packageName: 'jiraOnboardingCore',
                    teamName: 'jlove-makkuro'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
    const $501ec097caecd266$export$9835c32b78102887 = ({ additionalParameters: additionalParameters })=>{
        try {
            (0, (0, parcelRequire("eusud")).performPostRequestWithRetry)($501ec097caecd266$var$TRACK_PERSONALISATION_ENDPOINT, {
                body: JSON.stringify({
                    additionalParameters: additionalParameters
                })
            });
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'trackOnboardingPersonalisation',
                    packageName: 'jiraOnboardingCore',
                    teamName: 'jlove-makkuro'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
});
parcelRegister("fv5ut", function(module, exports) {
    $parcel$export(module.exports, "getLocalStorageOnboardingPersonalisationResponse", ()=>$673c953eac85fdf0$export$e9fb5b94c03fa495);
    $parcel$export(module.exports, "setLocalStorageOnboardingPersonalisationResponse", ()=>$673c953eac85fdf0$export$dda9cd59669fc243);
    var $bSSG7;
    var $jcw0u;
    const $673c953eac85fdf0$var$LOCALSTORAGE_ONBOARDING_PERSONALISATION_RESPONSE = 'response';
    const $673c953eac85fdf0$var$localStorage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('jira-onboarding-personalisation');
    const $673c953eac85fdf0$export$e9fb5b94c03fa495 = ()=>{
        try {
            return $673c953eac85fdf0$var$localStorage.get($673c953eac85fdf0$var$LOCALSTORAGE_ONBOARDING_PERSONALISATION_RESPONSE);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'localStorageGetOnboardingPersonalisation',
                    packageName: 'jiraOnboardingCore',
                    teamName: 'jlove-makkuro'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return undefined;
        }
    };
    const $673c953eac85fdf0$export$dda9cd59669fc243 = (response)=>{
        try {
            $673c953eac85fdf0$var$localStorage.set($673c953eac85fdf0$var$LOCALSTORAGE_ONBOARDING_PERSONALISATION_RESPONSE, response);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'localStorageSetOnboardingPersonalisationResponse',
                    packageName: 'jiraOnboardingCore',
                    teamName: 'jlove-makkuro'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
});
parcelRegister("iAFnF", function(module, exports) {
    $parcel$export(module.exports, "ELIGIBLE_TEAM_TYPES_M2_FULL_NOTATION", ()=>$afa1ef0e1c3d15e2$export$1d38dc41bb005254);
    var $5PxqD;
    const $afa1ef0e1c3d15e2$export$1d38dc41bb005254 = [
        (0, (0, parcelRequire("5PxqD")).USER_SEGMENTATION_TEAM_TYPE_MARKETING),
        (0, (0, parcelRequire("5PxqD")).USER_SEGMENTATION_TEAM_TYPE_OPERATIONS)
    ];
});
parcelRegister("5PxqD", function(module, exports) {
    $parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_MARKETING", ()=>$5d0851fa8905d151$export$e4824f74b9879164);
    $parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_OPERATIONS", ()=>$5d0851fa8905d151$export$4f3cb0844009af52);
    $parcel$export(module.exports, "userBelongsToBusinessUserSegCategory", ()=>$5d0851fa8905d151$export$517f94ab07724226);
    var $jcw0u;
    var $co1wz;
    const $5d0851fa8905d151$var$USER_SEGMENTATION_ROLE_DESIGNER = 'designer';
    const $5d0851fa8905d151$export$572242e58bd07594 = 'customer-service';
    const $5d0851fa8905d151$export$d7de553940261eba = 'it-support';
    const $5d0851fa8905d151$export$4c29d0d04c15e55d = 'human-resources';
    const $5d0851fa8905d151$export$3950f7f841bf94b6 = 'finance';
    const $5d0851fa8905d151$export$881249b988b6030f = 'legal';
    const $5d0851fa8905d151$export$e4824f74b9879164 = 'marketing';
    const $5d0851fa8905d151$export$4f3cb0844009af52 = 'operations';
    const $5d0851fa8905d151$export$1a65d50c4a641bb4 = 'sales';
    const $5d0851fa8905d151$export$b8b1ac856ba1434b = 'software-development';
    const $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE = 'all-roles-eligible';
    const $5d0851fa8905d151$export$2f3f9640393bd078 = 'unknown';
    const $5d0851fa8905d151$export$4c9a72dac5ce80ae = '';
    const $5d0851fa8905d151$var$USER_SEGMENTATION_CLIENT_MAPPING = {
        [$5d0851fa8905d151$var$USER_SEGMENTATION_ROLE_DESIGNER]: [
            'Designer',
            'Disainer',
            "Dise\xf1ador",
            'Formgivare',
            "Nh\xe0 thi\u1EBFt k\u1EBF",
            'Projektant',
            'Suunnittelija',
            "Tasar\u0131mc\u0131",
            "Tervez\u0151",
            "\u0414\u0438\u0437\u0430\u0439\u043D\u0435\u0440",
            "\u0E19\u0E31\u0E01\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A",
            "\u30C7\u30B6\u30A4\u30CA\u30FC",
            "\u8A2D\u8A08\u5E2B",
            "\u8BBE\u8BA1\u5E08",
            "\uB514\uC790\uC774\uB108"
        ],
        [$5d0851fa8905d151$export$572242e58bd07594]: [
            'Asiakaspalvelu',
            'Atendimento ao cliente',
            'Customer Service',
            "D\u1ECBch v\u1EE5 kh\xe1ch h\xe0ng",
            'Klantenservice',
            'Klienditeenindus',
            'Kundenservice',
            'Kundeservice',
            'Kundservice',
            "M\xfc\u015Fteri Hizmetleri",
            "Obs\u0142uga klienta",
            "Service \xe0 la client\xe8le",
            "Servicio de atenci\xf3n al cliente",
            'Servizio clienti',
            "Servi\xe7o de apoio ao cliente",
            "Z\xe1kaznick\xfd servis",
            "Z\xe1kazn\xedcky servis",
            "\xdcgyf\xe9lszolg\xe1lati",
            "\u041E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432",
            "\u0421\u043B\u0443\u0436\u0431\u0430 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438 \u043A\u043B\u0456\u0454\u043D\u0442\u0456\u0432",
            "\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
            "\u30AB\u30B9\u30BF\u30DE\u30FC \u30B5\u30FC\u30D3\u30B9",
            "\u5BA2\u6237\u670D\u52A1",
            "\u9867\u5BA2\u670D\u52D9",
            "\uACE0\uAC1D \uC11C\uBE44\uC2A4"
        ],
        [$5d0851fa8905d151$export$d7de553940261eba]: [
            'Assistenza IT',
            "BT Deste\u011Fi",
            "H\u1ED7 tr\u1EE3 CNTT",
            'IT',
            'IT Support',
            'IT podpora',
            "IT \u30B5\u30DD\u30FC\u30C8",
            "IT \u652F\u6301",
            "IT \u652F\u63F4",
            "IT \uC9C0\uC6D0",
            'IT_Support',
            "IT_st\xf8tte",
            'IT_support',
            'IT_tugi',
            'IT_tuki',
            "Informatikai t\xe1mogat\xe1si",
            'Soporte de TI',
            'Suporte de TI',
            "Support\xa0IT",
            'Wsparcie IT',
            "\u0418\u0422-\u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430",
            "\u0421\u043B\u0443\u0436\u0431\u0430 \u0442\u0435\u0445\u043D\u0456\u0447\u043D\u043E\u0457 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438",
            "\u0E1D\u0E48\u0E32\u0E22\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19 IT"
        ],
        [$5d0851fa8905d151$export$3950f7f841bf94b6]: [
            'Ekonomi',
            'Finance',
            'Financeiro',
            'Financie',
            'Finans',
            'Finanse',
            'Finants',
            'Finanza',
            'Finanzas',
            'Finanzen',
            "Finan\xe7as",
            "P\xe9nz\xfcgyi",
            'Rahoitus',
            "T\xe0i ch\xednh",
            "\xd8konomi",
            "\u0424\u0438\u043D\u0430\u043D\u0441\u044B",
            "\u0424\u0456\u043D\u0430\u043D\u0441\u0438",
            "\u0E01\u0E32\u0E23\u0E40\u0E07\u0E34\u0E19",
            "\u8CA1\u52D9",
            "\u91D1\u878D",
            "\uC7AC\uBB34"
        ],
        [$5d0851fa8905d151$export$4c29d0d04c15e55d]: [
            'HR',
            "Henkil\xf6st\xf6hallinto",
            'Human Resources',
            'Human resources',
            'human-resources',
            "Lidsk\xe9 zdroje",
            'Menneskelige ressourcer',
            "Nh\xe2n s\u1EF1",
            'Personal',
            "Personalfr\xe5gor",
            'RH',
            'Recursos Humanos',
            'Recursos humanos',
            'Risorse umane',
            "Szem\xe9lyzeti",
            'Zasoby ludzkie',
            "\u0130nsan Kaynaklar\u0131",
            "\u013Dudsk\xe9 zdroje",
            "\u0412\u0456\u0434\u0434\u0456\u043B \u043A\u0430\u0434\u0440\u0456\u0432",
            "\u041A\u0430\u0434\u0440\u043E\u0432\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
            "\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E32\u0E01\u0E23\u0E1A\u0E38\u0E04\u0E04\u0E25",
            "\u4EBA\u4E8B",
            "\u4EBA\u529B\u8CC7\u6E90",
            "\u4EBA\u529B\u8D44\u6E90",
            "\uC778\uC0AC"
        ],
        [$5d0851fa8905d151$export$881249b988b6030f]: [
            "Departamento jur\xeddico",
            'Hukuk',
            'Jogi',
            'Jura',
            'Juridik',
            'Juridisk',
            "Jur\xeddico",
            'Legal',
            'Legale',
            'Oikeudelliset asiat',
            "Ph\xe1p l\xfd",
            'Prawo',
            "Pr\xe1vne oddelenie",
            "Pr\xe1vn\xed odd\u011Blen\xed",
            'Rechtliches',
            'Service juridique',
            "\xd5igus",
            "\u042E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
            "\u042E\u0440\u0438\u0434\u0438\u0447\u043D\u0438\u0439 \u0432\u0456\u0434\u0434\u0456\u043B",
            "\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22",
            "\u6CD5\u52D9",
            "\u6CD5\u5F8B",
            "\uBC95\uB960"
        ],
        [$5d0851fa8905d151$export$e4824f74b9879164]: [
            "Markedsf\xf8ring",
            'Marketing',
            'Markkinointi',
            "Marknadsf\xf6ring",
            'Pazarlama',
            "Ti\u1EBFp th\u1ECB",
            'Turundus',
            "\u041C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433",
            "\u0E01\u0E32\u0E23\u0E15\u0E25\u0E32\u0E14",
            "\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0",
            "\u8425\u9500",
            "\u884C\u92B7",
            "\uB9C8\uCF00\uD305"
        ],
        [$5d0851fa8905d151$export$4f3cb0844009af52]: [
            'Drift',
            'Haldus',
            'Operacional',
            'Operaciones',
            'Operacje',
            'Operasyonlar',
            'Operations',
            'Operativer Betrieb',
            'Operazioni',
            "Opera\xe7\xf5es",
            "Op\xe9rations",
            "Prev\xe1dzka",
            'Provoz',
            'Toiminnot',
            "V\u1EADn h\xe0nh",
            "\xdczemeltet\xe9si",
            "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u0447\u0438\u0439 \u0432\u0456\u0434\u0434\u0456\u043B",
            "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
            "\u0E1D\u0E48\u0E32\u0E22\u0E1B\u0E0F\u0E34\u0E1A\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23",
            "\u30AA\u30DA\u30EC\u30FC\u30B7\u30E7\u30F3",
            "\u71DF\u904B",
            "\u8FD0\u8425",
            "\uC6B4\uC601"
        ],
        [$5d0851fa8905d151$export$1a65d50c4a641bb4]: [
            "B\xe1n h\xe0ng",
            "F\xf6rs\xe4ljning",
            'Myynti',
            "M\xfc\xfck",
            'Predaj',
            'Prodej',
            'Sales',
            'Salg',
            "Sat\u0131\u015F",
            "Sprzeda\u017C",
            'Vendas',
            'Vendite',
            'Ventas',
            'Ventes',
            'Vertrieb',
            "\xc9rt\xe9kes\xedt\xe9si",
            "\u041F\u0440\u043E\u0434\u0430\u0436\u0438",
            "\u041F\u0440\u043E\u0434\u0430\u0436\u0456",
            "\u0E1D\u0E48\u0E32\u0E22\u0E02\u0E32\u0E22",
            "\u30BB\u30FC\u30EB\u30B9",
            "\u92B7\u552E",
            "\u9500\u552E",
            "\uC601\uC5C5"
        ],
        [$5d0851fa8905d151$export$b8b1ac856ba1434b]: [
            'Desarrollo de software',
            'Desenvolvimento de software',
            "D\xe9veloppement logiciel",
            'Ohjelmistokehitys',
            "Ph\xe1t tri\u1EC3n ph\u1EA7n m\u1EC1m",
            'Programutveckling',
            'Programvareutvikling',
            'Software Development',
            'Softwareentwicklung',
            'Softwareontwikkeling',
            'Softwareudvikling',
            'Sviluppo software',
            "Szoftverfejleszt\u0151",
            'Tarkvaraarendus',
            'Tworzenie oprogramowania',
            "V\xfdvoj softv\xe9ru",
            "V\xfdvoj softwaru",
            "Yaz\u0131l\u0131m Geli\u015Ftirme",
            "\u0420\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u041F\u041E",
            "\u0420\u043E\u0437\u0440\u043E\u0431\u043A\u0430 \u041F\u0417",
            "\u0E1E\u0E31\u0E12\u0E19\u0E32\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C",
            "\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u958B\u767A",
            "\u8EDF\u9AD4\u958B\u767C",
            "\u8F6F\u4EF6\u5F00\u53D1",
            "\uC18C\uD504\uD2B8\uC6E8\uC5B4 \uAC1C\uBC1C"
        ]
    };
    const $5d0851fa8905d151$var$BUSINESS_TEAM_TYPES = [
        $5d0851fa8905d151$export$4c29d0d04c15e55d,
        $5d0851fa8905d151$export$3950f7f841bf94b6,
        $5d0851fa8905d151$export$881249b988b6030f,
        $5d0851fa8905d151$export$e4824f74b9879164,
        $5d0851fa8905d151$export$4f3cb0844009af52,
        $5d0851fa8905d151$export$1a65d50c4a641bb4,
        $5d0851fa8905d151$export$b8b1ac856ba1434b
    ];
    const $5d0851fa8905d151$var$BUSINESS_ROLES_PER_TEAM_TYPE = {
        [$5d0851fa8905d151$export$4c29d0d04c15e55d]: [
            $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
        ],
        [$5d0851fa8905d151$export$3950f7f841bf94b6]: [
            $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
        ],
        [$5d0851fa8905d151$export$881249b988b6030f]: [
            $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
        ],
        [$5d0851fa8905d151$export$e4824f74b9879164]: [
            $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
        ],
        [$5d0851fa8905d151$export$4f3cb0844009af52]: [
            $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
        ],
        [$5d0851fa8905d151$export$1a65d50c4a641bb4]: [
            $5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE
        ],
        [$5d0851fa8905d151$export$b8b1ac856ba1434b]: [
            $5d0851fa8905d151$var$USER_SEGMENTATION_ROLE_DESIGNER
        ]
    };
    const $5d0851fa8905d151$var$getNormalizedEntryNew = (userSegValue)=>{
        const lowerCaseUserSegValue = userSegValue.toLowerCase();
        return Object.entries($5d0851fa8905d151$var$USER_SEGMENTATION_CLIENT_MAPPING).find(([, translatedValues])=>translatedValues.map((v)=>v.toLowerCase()).includes(lowerCaseUserSegValue));
    };
    const $5d0851fa8905d151$var$getNormalizedEntry = (value)=>Object.entries($5d0851fa8905d151$var$USER_SEGMENTATION_CLIENT_MAPPING).find(([, translatedValues])=>translatedValues.includes(value));
    const $5d0851fa8905d151$export$d0bc507f0556398 = (value)=>{
        if (value === '') return $5d0851fa8905d151$export$4c9a72dac5ce80ae;
        const normalizedEntry = (0, (0, parcelRequire("co1wz")).ff)('use-upaas-to-display-template-picker-if-user-seg-is-unknown') ? $5d0851fa8905d151$var$getNormalizedEntryNew(value) : $5d0851fa8905d151$var$getNormalizedEntry(value);
        return normalizedEntry !== undefined ? normalizedEntry[0] : $5d0851fa8905d151$export$2f3f9640393bd078;
    };
    class $5d0851fa8905d151$var$SkipSentryError extends Error {
        constructor(message){
            super(message);
            this.skipSentry = true;
        }
    }
    const $5d0851fa8905d151$var$fireAnalyticsError = ({ id: id, field: field, error: error, unMatchedValue: unMatchedValue })=>{
        (0, (0, parcelRequire("jcw0u")).default)({
            meta: {
                id: id,
                packageName: 'jiraOnboardingCore'
            },
            attributes: {
                field: field,
                unMatchedValue: unMatchedValue
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const $5d0851fa8905d151$export$af8a28b856b3556f = (teamType)=>{
        if (!teamType) return false;
        const normalizedTeamType = $5d0851fa8905d151$export$d0bc507f0556398(teamType);
        if (normalizedTeamType === $5d0851fa8905d151$export$2f3f9640393bd078) $5d0851fa8905d151$var$fireAnalyticsError({
            id: 'isInSoftwareTeam',
            field: 'teamType',
            error: new $5d0851fa8905d151$var$SkipSentryError('teamType mapping is not found'),
            unMatchedValue: teamType
        });
        return normalizedTeamType === $5d0851fa8905d151$export$b8b1ac856ba1434b;
    };
    const $5d0851fa8905d151$export$517f94ab07724226 = (userAccountData)=>{
        const { teamType: teamType = '', role: role = '' } = userAccountData;
        const normalizedTeamType = $5d0851fa8905d151$export$d0bc507f0556398(teamType);
        if (normalizedTeamType === $5d0851fa8905d151$export$2f3f9640393bd078) $5d0851fa8905d151$var$fireAnalyticsError({
            id: 'userBelongsToBusinessUserSegCategory',
            field: 'teamType',
            error: new $5d0851fa8905d151$var$SkipSentryError('teamType mapping is not found'),
            unMatchedValue: teamType
        });
        const normalizedRole = $5d0851fa8905d151$export$d0bc507f0556398(role);
        if (normalizedRole === $5d0851fa8905d151$export$2f3f9640393bd078) $5d0851fa8905d151$var$fireAnalyticsError({
            id: 'userBelongsToBusinessUserSegCategory',
            field: 'role',
            error: new $5d0851fa8905d151$var$SkipSentryError('role mapping is not found'),
            unMatchedValue: role
        });
        const isTeamTypeEligible = $5d0851fa8905d151$var$BUSINESS_TEAM_TYPES.includes(normalizedTeamType);
        const isRoleEligible = $5d0851fa8905d151$var$BUSINESS_ROLES_PER_TEAM_TYPE[normalizedTeamType]?.includes($5d0851fa8905d151$var$ALL_ROLES_ELIGIBLE) || $5d0851fa8905d151$var$BUSINESS_ROLES_PER_TEAM_TYPE[normalizedTeamType]?.includes(normalizedRole);
        return isTeamTypeEligible && isRoleEligible;
    };
    const $5d0851fa8905d151$export$6710e0127706b297 = (userAccountData)=>{
        const { teamType: teamType = '', role: role = '' } = userAccountData;
        const normalizedTeamType = $5d0851fa8905d151$export$d0bc507f0556398(teamType);
        if (normalizedTeamType === $5d0851fa8905d151$export$2f3f9640393bd078) $5d0851fa8905d151$var$fireAnalyticsError({
            id: 'userBelongsToSoftwareUserSegCategory',
            field: 'teamType',
            error: new $5d0851fa8905d151$var$SkipSentryError('teamType mapping is not found'),
            unMatchedValue: teamType
        });
        const normalizedRole = $5d0851fa8905d151$export$d0bc507f0556398(role);
        if (normalizedRole === $5d0851fa8905d151$export$2f3f9640393bd078) $5d0851fa8905d151$var$fireAnalyticsError({
            id: 'userBelongsToSoftwareUserSegCategory',
            field: 'role',
            error: new $5d0851fa8905d151$var$SkipSentryError('role mapping is not found'),
            unMatchedValue: role
        });
        const isTeamTypeEligible = normalizedTeamType === $5d0851fa8905d151$export$b8b1ac856ba1434b;
        const isRoleEligible = normalizedRole !== $5d0851fa8905d151$var$USER_SEGMENTATION_ROLE_DESIGNER;
        return isTeamTypeEligible && isRoleEligible;
    };
});
parcelRegister("1OQiY", function(module, exports) {
    $parcel$export(module.exports, "isTailoredOnboardingM2ExperimentFlagEnabled", ()=>$58aa46dba9dc7a65$export$4f4879e3b4202c87);
    var $6s1PB;
    var $4R6GH;
    const $58aa46dba9dc7a65$export$4f4879e3b4202c87 = ()=>{
        const defaultValue = (0, (0, parcelRequire("4R6GH")).fg)('tailored_onboarding_m2_content_exposure_adjust') ? undefined : false;
        const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_tailored_onboarding_jtbd');
        return expConfig.get('isEnabled', defaultValue);
    };
});
parcelRegister("9USr3", function(module, exports) {
    $parcel$export(module.exports, "useRegisterNudgeTarget", ()=>$1aa5136c8225a4e1$export$eb8a96124d659f2d);
    $parcel$export(module.exports, "PortalledNudge", ()=>$1aa5136c8225a4e1$export$74f8d45d75dfda4f);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $ckPaC;
    class $1aa5136c8225a4e1$var$NudgeController {
        static{
            this.instance = new $1aa5136c8225a4e1$var$NudgeController();
        }
        registerNudgeTarget(id, ref) {
            this.nudgeTargetsMap.set(id, ref);
            this.notifySubscribers(id);
            return ()=>{
                this.nudgeTargetsMap.delete(id);
            };
        }
        subscribe(id, callback) {
            const subscribers = this.subscribers.get(id) ?? [];
            subscribers.push(callback);
            this.subscribers.set(id, subscribers);
            return ()=>{
                const subscribersOnCleanup = this.subscribers.get(id) ?? [];
                this.subscribers.set(id, subscribersOnCleanup.filter((cb)=>cb !== callback));
            };
        }
        notifySubscribers(id) {
            const subscribers = this.subscribers.get(id) ?? [];
            subscribers.forEach((subscriber)=>{
                subscriber();
            });
        }
        constructor(){
            this.nudgeTargetsMap = new Map();
            this.subscribers = new Map();
        }
    }
    const $1aa5136c8225a4e1$var$useNudgeController = ()=>$1aa5136c8225a4e1$var$NudgeController.instance;
    const $1aa5136c8225a4e1$export$eb8a96124d659f2d = (id, shouldRegister = true)=>{
        const controller = $1aa5136c8225a4e1$var$useNudgeController();
        const ref = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (shouldRegister) {
                const unregister = controller.registerNudgeTarget(id, ref);
                return ()=>{
                    unregister();
                };
            }
        }, [
            controller,
            id,
            shouldRegister
        ]);
        return {
            ref: ref
        };
    };
    const $1aa5136c8225a4e1$var$useHasNudgeTargetNode = (id)=>{
        const controller = $1aa5136c8225a4e1$var$useNudgeController();
        const [hasRefValue, setHasRefValue] = (0, $5uXOq.useState)(!!controller.nudgeTargetsMap.get(id)?.current);
        (0, $5uXOq.useLayoutEffect)(()=>{
            setHasRefValue(!!controller.nudgeTargetsMap.get(id)?.current);
            const unsubscribe = controller.subscribe(id, ()=>{
                setHasRefValue(!!controller.nudgeTargetsMap.get(id)?.current);
            });
            return ()=>{
                unsubscribe();
            };
        }, [
            controller,
            id
        ]);
        return hasRefValue;
    };
    const $1aa5136c8225a4e1$var$useNudgeRectangle = (isShown, id, nudgeContainer)=>{
        const [innerRectangle, setInnerRectangle] = (0, $5uXOq.useState)(null);
        const frameId = (0, $5uXOq.useRef)(null);
        const controller = $1aa5136c8225a4e1$var$useNudgeController();
        const nudgeTarget = controller.nudgeTargetsMap.get(id)?.current;
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!isShown || !nudgeTarget || !nudgeContainer.current) {
                if (innerRectangle !== null) setInnerRectangle(null);
                return undefined;
            }
            const loop = ()=>{
                const targetRectangle = controller.nudgeTargetsMap.get(id)?.current?.getBoundingClientRect();
                if (!targetRectangle) return undefined;
                const newRectangle = {
                    top: targetRectangle.top,
                    left: targetRectangle.left,
                    width: targetRectangle.width,
                    height: targetRectangle.height
                };
                if (innerRectangle == null || innerRectangle.top !== newRectangle.top || innerRectangle.left !== newRectangle.left || innerRectangle.width !== newRectangle.width || innerRectangle.height !== newRectangle.height) setInnerRectangle(newRectangle);
                else frameId.current = requestAnimationFrame(loop);
            };
            frameId.current = requestAnimationFrame(loop);
            return ()=>{
                if (frameId.current != null) cancelAnimationFrame(frameId.current);
            };
        }, [
            isShown,
            nudgeContainer,
            innerRectangle,
            nudgeTarget,
            controller.nudgeTargetsMap,
            id
        ]);
        return innerRectangle;
    };
    const $1aa5136c8225a4e1$var$usePortalContainer = ()=>{
        const nudgeContainer = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!nudgeContainer.current) {
                nudgeContainer.current = document.createElement('div');
                document.body.appendChild(nudgeContainer.current);
            }
            return ()=>{
                if (nudgeContainer.current) document.body.removeChild(nudgeContainer.current);
            };
        }, []);
        return nudgeContainer;
    };
    const $1aa5136c8225a4e1$export$74f8d45d75dfda4f = (props)=>{
        const nudgeContainer = $1aa5136c8225a4e1$var$usePortalContainer();
        const hasRefValue = $1aa5136c8225a4e1$var$useHasNudgeTargetNode(props.nudgeTargetId);
        const innerRectangle = $1aa5136c8225a4e1$var$useNudgeRectangle(!props.hidden, props.nudgeTargetId, nudgeContainer);
        const innerRectanglePrevious = (0, $5uXOq.useRef)(innerRectangle);
        const spotlightRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (innerRectangle !== null && innerRectanglePrevious.current !== innerRectangle && spotlightRef.current !== null) {
                innerRectanglePrevious.current = innerRectangle;
                if (spotlightRef.current.forceUpdateCardPosition) spotlightRef.current.forceUpdateCardPosition();
            }
        }, [
            innerRectangle
        ]);
        const hasNudgeTarget = hasRefValue;
        if (!nudgeContainer.current || !hasNudgeTarget || !innerRectangle) return null;
        return (0, $7nsd3.createPortal)((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                position: 'fixed',
                top: innerRectangle.top,
                left: innerRectangle.left,
                height: innerRectangle.height,
                width: innerRectangle.width,
                zIndex: props.zIndex
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ckPaC")).NudgeSpotlight), {
            ...props,
            ref: spotlightRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                height: innerRectangle.height,
                width: innerRectangle.width
            }
        }))), nudgeContainer.current);
    };
});
parcelRegister("ghgEK", function(module, exports) {
    $parcel$export(module.exports, "SummaryViewNudgeAsync", ()=>$789999f277d5d9b4$export$b531a7d8bb8249e7);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $cE2Qr;
    var $aCWJu;
    const $789999f277d5d9b4$var$runtimeProps = {};
    const $789999f277d5d9b4$var$entryPointParams = {};
    const $789999f277d5d9b4$export$b531a7d8bb8249e7 = ()=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("aCWJu")).summaryViewNudgeEntryPoint), $789999f277d5d9b4$var$entryPointParams);
        const [nudgeStep] = (0, (0, parcelRequire("cE2Qr")).useNudgeStep)();
        const [hasNudgeActive] = (0, (0, parcelRequire("cE2Qr")).useHasNudgeActive)();
        const firstLoadRef = (0, $5uXOq.useRef)(true);
        (0, $5uXOq.useEffect)(()=>{
            if (firstLoadRef.current && hasNudgeActive && nudgeStep === (0, $6784cbc7d62e5d7c$export$594d3436316492be)) {
                entryPointActions.load();
                firstLoadRef.current = false;
            }
        }, [
            entryPointActions,
            hasNudgeActive,
            nudgeStep
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: (0, $dbbf68c32d8c4308$export$cf1943561be3a3c2),
            packageName: "jiraSummaryViewOnboarding",
            entryPointReferenceSubject: entryPointReferenceSubject,
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null),
            runtimeProps: $789999f277d5d9b4$var$runtimeProps
        });
    };
});
parcelRegister("aCWJu", function(module, exports) {
    $parcel$export(module.exports, "summaryViewNudgeEntryPoint", ()=>$81e625d31894d565$export$81d6d191a3f971f5);
    var $evanD;
    var $7KfpL;
    const $81e625d31894d565$export$81d6d191a3f971f5 = (0, (0, parcelRequire("7KfpL")).createEntryPoint)({
        root: (0, (0, parcelRequire("evanD")).JSResourceForInteraction)(()=>(parcelRequire("5Z0nx")), {
            moduleId: "46bfac13"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("5Z0nx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dEu4P").then(()=>parcelRequire('a63rx'));
});
parcelRegister("6GihX", function(module, exports) {
    $parcel$export(module.exports, "useInlineStatusEligibilityCheck", ()=>$1ade7c948334df06$export$a3e3ba08d0abbb07);
    var $daQYX;
    var $DVljb;
    var $95H4q;
    const $1ade7c948334df06$export$a3e3ba08d0abbb07 = ()=>{
        const project = (0, (0, parcelRequire("daQYX")).useProject)();
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        const isEnglishLocale = locale && locale.startsWith('en');
        const isProjectAdmin = project.permissions.administerProject;
        const isTmp = project.isSimplified;
        const { data: workflowsData, loading: loading, error: workflowsError } = (0, (0, parcelRequire("95H4q")).useWorkflowsCount)();
        const isEligibleForCreateStatus = isProjectAdmin && isTmp && isEnglishLocale;
        const isEligibleforEditStatus = !(loading || workflowsError || !isEnglishLocale || !isProjectAdmin || !isTmp || !workflowsData?.totalCount || workflowsData?.totalCount > 1);
        return {
            isEligibleForCreateStatus: isEligibleForCreateStatus,
            isEligibleforEditStatus: isEligibleforEditStatus
        };
    };
});
parcelRegister("htu9M", function(module, exports) {
    $parcel$export(module.exports, "CreateStatusButton", ()=>$d1eda5072095c280$export$d2e0b4f33d77a2b8);
    var $5uXOq = parcelRequire("5uXOq");
    var $63TD8;
    var $3srSR;
    var $fm763;
    var $a95o8;
    var $ZuPvl;
    var $99gde;
    var $daQYX;
    var $8kNzi;
    var $4R6GH;
    var $kM5sB;
    var $koVbs;
    var $2vLHS;
    var $2KAtx;
    var $8zOmE;
    var $lwMsT;
    var $koeKL;
    var $7GkkF;
    var $dROaT;
    const $d1eda5072095c280$export$d2e0b4f33d77a2b8 = ({ onClick: onClick, statusNames: statusNames, onCreateStatusSuccess: onCreateStatusSuccess, hasMultipleWorkflows: hasMultipleWorkflows })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const createStatus = (0, (0, parcelRequire("8kNzi")).useCreateStatus)((0, (0, parcelRequire("7GkkF")).CREATE_STATUS_EXPERIENCE));
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { id: projectId, key: projectKey, type: projectType } = (0, (0, parcelRequire("daQYX")).useProject)();
        const onCreateStatus = (0, $5uXOq.useCallback)(async (payload)=>{
            await createStatus(payload);
            onCreateStatusSuccess?.();
        }, [
            createStatus,
            onCreateStatusSuccess
        ]);
        const onCloseCreateStatusModal = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'createStatusModal',
                action: 'dismissed'
            }), 'createStatusModalDismissed');
        }, [
            createAnalyticsEvent
        ]);
        const entryPointParams = (0, $5uXOq.useMemo)(()=>({
                cloudId: cloudId,
                projectKey: projectKey
            }), [
            cloudId,
            projectKey
        ]);
        const entryPointProps = (0, $5uXOq.useMemo)(()=>({
                statusNames: statusNames,
                hasMultipleWorkflows: hasMultipleWorkflows,
                projectId: projectId.toString(),
                projectKey: projectKey,
                projectType: projectType,
                onCreateStatus: onCreateStatus,
                onClose: onCloseCreateStatusModal,
                isNewControllerEnabled: (0, (0, parcelRequire("4R6GH")).fg)('jira_inline_status_new_controllers'),
                workflowAssociatedIssueTypeId: null,
                onStatusCreated: onCreateStatusSuccess
            }), [
            statusNames,
            hasMultipleWorkflows,
            projectId,
            projectKey,
            projectType,
            onCreateStatus,
            onCloseCreateStatusModal,
            onCreateStatusSuccess
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KAtx")).ModalEntryPointPressableTrigger), {
            entryPoint: (0, (0, parcelRequire("kM5sB")).asyncInlineCreateStatusModal),
            entryPointProps: entryPointProps,
            entryPointParams: entryPointParams,
            interactionName: "create-status-modal",
            modalProps: (0, (0, parcelRequire("2vLHS")).defaultModalProps),
            useInternalModal: true
        }, ({ ref: ref })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fm763")).default), {
                xcss: $d1eda5072095c280$var$dividerStyles,
                testId: "business-summary.ui.summary-view.progress-by-status.create-status-button"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a95o8")).default), {
                onClick: onClick,
                backgroundColor: "color.background.neutral.subtle",
                xcss: $d1eda5072095c280$var$buttonStyles,
                ref: ref
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3srSR")).default), {
                xcss: $d1eda5072095c280$var$addIconWrapperStyles,
                alignItems: "center",
                justifyContent: "center"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("63TD8"))))), {
                label: "",
                color: "var(--ds-icon, #44546F)"
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
                weight: "medium",
                color: "color.text.subtle"
            }, formatMessage((0, (0, parcelRequire("dROaT")).default).createStatus)))));
    };
    const $d1eda5072095c280$var$addIconWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        height: '24px',
        width: '24px',
        borderRadius: 'border.radius',
        backgroundColor: 'color.background.neutral'
    });
    const $d1eda5072095c280$var$dividerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        borderTopColor: 'color.border',
        borderTopStyle: 'solid',
        borderTopWidth: '1px',
        paddingTop: 'space.100',
        marginTop: 'space.100',
        marginBottom: 'space.100',
        marginLeft: 'space.300'
    });
    const $d1eda5072095c280$var$buttonStyles = (0, (0, parcelRequire("99gde")).xcss)({
        padding: 'space.025',
        color: 'color.text.subtlest',
        display: 'flex',
        alignItems: 'center',
        gap: 'space.075',
        justifyContent: 'center',
        ':hover': {
            textDecoration: 'underline'
        }
    });
});
parcelRegister("8kNzi", function(module, exports) {
    $parcel$export(module.exports, "useCreateStatus", ()=>$db31e0702feeb249$export$c2ab89f2f8598b1f);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $cm8b5;
    var $6nqwL;
    var $pa9q9;
    var $koeKL;
    var $8xg9P;
    var $ayqGc;
    var $3YY5f;
    const $db31e0702feeb249$export$c2ab89f2f8598b1f = (experienceDetails)=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { createWorkflowStatusforSingleWorkflow: createWorkflowStatusforSingleWorkflow } = (0, (0, parcelRequire("6nqwL")).useWorkflowsV2)();
        const startAddOperation = (0, (0, parcelRequire("8xg9P")).useStartAddOperation)();
        const stopWorkflowOperationInProgress = (0, (0, parcelRequire("8xg9P")).useStopWorkflowOperationInProgress)();
        const startExperience = (0, (0, parcelRequire("cm8b5")).useExperienceStart)(experienceDetails);
        const markExperienceSuccess = (0, (0, parcelRequire("cm8b5")).useExperienceSuccess)(experienceDetails);
        const markExperienceFailed = (0, (0, parcelRequire("cm8b5")).useExperienceFail)(experienceDetails);
        const abortExperience = (0, (0, parcelRequire("cm8b5")).useExperienceAbort)(experienceDetails);
        const project = (0, (0, parcelRequire("daQYX")).useProject)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const createNewStatus = (0, $5uXOq.useCallback)(async ({ statusName: statusName, statusCategory: statusCategory, issueTypeId: issueTypeId })=>{
            startAddOperation(String((0, $8acbf7056aed1170$export$9301910120a61d41)));
            startExperience();
            try {
                await createWorkflowStatusforSingleWorkflow({
                    statusName: statusName,
                    statusCategory: statusCategory,
                    cloudId: cloudId,
                    projectId: String(project.id),
                    issueTypeId: issueTypeId,
                    onSuccess: markExperienceSuccess
                });
            } catch (error) {
                showFlag((0, (0, parcelRequire("ayqGc")).getStatusActionFailedFlag)({
                    messageTitle: (0, (0, parcelRequire("3YY5f")).default).errorFlagTitleAddStatus,
                    action: 'add',
                    error: error,
                    issueTypeId: issueTypeId,
                    projectKey: project.key,
                    statusCode: error?.response?.status
                }));
                (0, (0, parcelRequire("ayqGc")).failStatusExperience)({
                    markExperienceFailed: markExperienceFailed,
                    abortExperience: abortExperience,
                    error: error,
                    errorMessage: 'Failed to validate and update workflow'
                });
                throw error;
            } finally{
                stopWorkflowOperationInProgress();
            }
        }, [
            startAddOperation,
            startExperience,
            createWorkflowStatusforSingleWorkflow,
            cloudId,
            markExperienceSuccess,
            showFlag,
            markExperienceFailed,
            abortExperience,
            stopWorkflowOperationInProgress,
            project
        ]);
        return createNewStatus;
    };
});
parcelRegister("6nqwL", function(module, exports) {
    $parcel$export(module.exports, "useWorkflowsV2", ()=>$140c546f51be918f$export$32b6f4c35d4611ee);
    var $5uXOq = parcelRequire("5uXOq");
    var $bXrHm = parcelRequire("bXrHm");
    var $gULOk;
    var $jcw0u;
    var $7f4tk;
    var $jJZqs;
    var $8zOmE;
    var $lwMsT;
    var $64pOt;
    var $eAapG;
    const $140c546f51be918f$var$noop = ()=>{};
    const $140c546f51be918f$export$32b6f4c35d4611ee = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const fetchWorkflowsV2 = (0, $5uXOq.useCallback)(async ({ cloudId: cloudId, projectAndIssueTypes: projectAndIssueTypes })=>{
            const url = `/gateway/api/jira/project-configuration/query/${cloudId}/2/workflow?useTransitionLinksFormat=true`;
            try {
                const response = await (0, (0, parcelRequire("7f4tk")).default)(url, {
                    method: 'POST',
                    body: JSON.stringify({
                        projectAndIssueTypes: projectAndIssueTypes
                    })
                });
                return response;
            } catch (error) {
                const jsonErrorResponse = error.originalResponse ? await error.originalResponse.json().catch($140c546f51be918f$var$noop) : undefined;
                if (jsonErrorResponse) {
                    const errorMessage = `Fetch workflow fail status code: ${error.statusCode}; response: ${JSON.stringify(jsonErrorResponse)}`;
                    const errorWithResponseMessage = new (0, (0, parcelRequire("jJZqs")).default)(error.statusCode, errorMessage, error.traceId);
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'fetchBoardWorkflowsV2',
                            packageName: 'jiraBusinessWorkflows',
                            teamName: 'wanjel'
                        },
                        error: errorWithResponseMessage,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    throw errorWithResponseMessage;
                }
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'fetchBoardWorkflowsV2',
                        packageName: 'jiraBusinessWorkflows',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: 'Failed to fetch board workflows'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        }, []);
        const updateWorkflowsV2 = (0, $5uXOq.useCallback)(async ({ payload: payload, cloudId: cloudId })=>{
            try {
                const response = await (0, (0, parcelRequire("7f4tk")).default)(`/gateway/api/jira/project-configuration/command/${cloudId}/2/workflow/update`, {
                    method: 'POST',
                    body: JSON.stringify(payload)
                });
                return response;
            } catch (error) {
                const jsonErrorResponse = error.originalResponse ? await error.originalResponse.json().catch($140c546f51be918f$var$noop) : undefined;
                if (jsonErrorResponse) {
                    const errorMessage = `Update workflow fail status code: ${error.statusCode}; response: ${JSON.stringify(jsonErrorResponse)}`;
                    const errorWithResponseMessage = new (0, (0, parcelRequire("jJZqs")).default)(error.statusCode, errorMessage, error.traceId);
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'updateBoardWorkflowsV2',
                            packageName: 'jiraBusinessWorkflows',
                            teamName: 'wanjel'
                        },
                        error: errorWithResponseMessage,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    throw errorWithResponseMessage;
                }
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'updateBoardWorkflowsV2',
                        packageName: 'jiraBusinessWorkflows',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: 'Failed to update board workflows'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        }, []);
        const validateAndUpdateWorkflowsV2 = (0, $5uXOq.useCallback)(async ({ payload: payload, cloudId: cloudId })=>{
            let validationResponse;
            try {
                validationResponse = await (0, (0, parcelRequire("7f4tk")).default)(`/gateway/api/jira/project-configuration/command/${cloudId}/2/workflow/update/validation`, {
                    method: 'POST',
                    body: JSON.stringify(payload)
                });
            } catch (error) {
                const jsonErrorResponse = error.originalResponse ? await error.originalResponse.json().catch($140c546f51be918f$var$noop) : undefined;
                if (jsonErrorResponse) {
                    const errorMessage = `Validate workflow fail status code: ${error.statusCode}; response: ${JSON.stringify(jsonErrorResponse)}`;
                    const errorWithResponseMessage = new (0, (0, parcelRequire("jJZqs")).default)(error.statusCode, errorMessage, error.traceId);
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'validateUpdateBoardWorkflowsV2',
                            packageName: 'jiraBusinessWorkflows',
                            teamName: 'wanjel'
                        },
                        error: errorWithResponseMessage,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    throw errorWithResponseMessage;
                }
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'validateUpdateBoardWorkflowsV2',
                        packageName: 'jiraBusinessWorkflows',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: 'Failed to validate payload for update workflows'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
            if (validationResponse.errors.length > 0) {
                validationResponse.errors.forEach((e)=>{
                    if (e.code === (0, $03da6b4adba8d655$export$fca543997a327d4c)) {
                        (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'workflowValidation failed', {
                            message: e.message,
                            code: e.code
                        });
                        throw new (0, (0, parcelRequire("64pOt")).StatusNameIsNotUniqueError)();
                    }
                    if (e.code === (0, $03da6b4adba8d655$export$cc9aaebfeb8efe99)) {
                        (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'workflowValidation failed', {
                            message: e.message,
                            code: e.code
                        });
                        throw new (0, (0, parcelRequire("64pOt")).StatusHasNoIncomingTransitionError)();
                    }
                    if (e.code === (0, $03da6b4adba8d655$export$cd6873a2b9593ebe)) throw new (0, (0, parcelRequire("64pOt")).OldStatusMissingInWorkflowError)();
                    if (e.code === (0, $03da6b4adba8d655$export$8f656a1a73ea2b22)) throw new (0, (0, parcelRequire("64pOt")).NewStatusMissingInWorkflowError)();
                    if (e.code === (0, $03da6b4adba8d655$export$a9ac4cce67a0398e)) throw new (0, (0, parcelRequire("64pOt")).OnlyOneInitialTransitionAllowedError)();
                    if (e.code === (0, $03da6b4adba8d655$export$7e934b410e3f0768)) throw new (0, (0, parcelRequire("64pOt")).ApprovalRuleMisconfiguredError)();
                    if (e.code === (0, $03da6b4adba8d655$export$3bf8ed0d6cdbf43d)) throw new (0, (0, parcelRequire("64pOt")).WorkflowVersionConflictError)();
                });
                const errorMsgs = validationResponse.errors.map((e)=>e.message).join(', ');
                const errorCodes = validationResponse.errors.map((e)=>e.code).join(', ');
                const errorMessage = `Validation error(s) in update workflows payload - ${errorMsgs}`;
                const error = Error(errorMessage);
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'validateUpdateBoardWorkflowsV2',
                        packageName: 'jiraBusinessWorkflows',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: errorMessage,
                        totalErrors: validationResponse.errors.length,
                        code: errorCodes
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
            return updateWorkflowsV2({
                payload: payload.payload,
                cloudId: cloudId
            });
        }, [
            updateWorkflowsV2,
            createAnalyticsEvent
        ]);
        const createWorkflowStatusV2 = (0, $5uXOq.useCallback)(async ({ statusName: statusName, statusCategory: statusCategory, cloudId: cloudId, projectId: projectId, issueTypes: issueTypes, onSuccess: onSuccess })=>{
            const workflowsData = await fetchWorkflowsV2({
                cloudId: cloudId,
                projectAndIssueTypes: issueTypes.map((it)=>({
                        projectId: projectId,
                        issueTypeId: it.id
                    }))
            });
            if (workflowsData) {
                const subtaskIssueTypeId = issueTypes.find((issueType)=>issueType.hierarchyLevel === -1)?.id;
                const { statuses: statuses, workflows: boardWorkflows } = (0, (0, parcelRequire("eAapG")).removeWorkflowAssociatedWithSubtaskOnly)(workflowsData, subtaskIssueTypeId);
                const workflow = boardWorkflows[0];
                const transitionId = (0, (0, parcelRequire("eAapG")).getUniqueTransitionId)(workflow.transitions);
                const isTransitionNameExists = workflow.transitions.some((t)=>t.name.toUpperCase() === statusName.toUpperCase());
                const newTransitionName = isTransitionNameExists ? `${statusName} ${transitionId}` : statusName;
                const statusReference = (0, ($parcel$interopDefault($bXrHm)))();
                const newStatus = {
                    statusReference: statusReference,
                    name: statusName,
                    statusCategory: statusCategory ?? (0, (0, parcelRequire("gULOk")).IN_PROGRESS),
                    description: ''
                };
                const newStatusInWorkflow = {
                    statusReference: statusReference,
                    properties: {},
                    deprecated: false
                };
                const transitionData = {
                    links: [],
                    toStatusReference: statusReference
                };
                const newTransitionInWorkflow = {
                    id: transitionId,
                    type: 'GLOBAL',
                    name: newTransitionName,
                    description: '',
                    actions: [],
                    validators: [],
                    triggers: [],
                    properties: {},
                    ...transitionData
                };
                workflow.statuses = [
                    ...workflow.statuses,
                    newStatusInWorkflow
                ];
                workflow.transitions = [
                    ...workflow.transitions,
                    newTransitionInWorkflow
                ];
                await validateAndUpdateWorkflowsV2({
                    cloudId: cloudId,
                    payload: {
                        payload: {
                            statuses: [
                                ...(0, (0, parcelRequire("eAapG")).mapStatusesToStatusUpdateObjects)(statuses),
                                newStatus
                            ],
                            workflows: [
                                (0, (0, parcelRequire("eAapG")).mapWorkflowToWorkflowUpdateObject)(workflow)
                            ]
                        },
                        validationOptions: {
                            levels: [
                                'ERROR'
                            ]
                        }
                    }
                });
                onSuccess();
            }
        }, [
            fetchWorkflowsV2,
            validateAndUpdateWorkflowsV2
        ]);
        const createWorkflowStatusforSingleWorkflow = (0, $5uXOq.useCallback)(async ({ statusName: statusName, statusCategory: statusCategory, cloudId: cloudId, projectId: projectId, issueTypeId: issueTypeId, onSuccess: onSuccess })=>{
            const workflowsData = await fetchWorkflowsV2({
                cloudId: cloudId,
                projectAndIssueTypes: [
                    {
                        projectId: projectId,
                        issueTypeId: issueTypeId
                    }
                ]
            });
            if (workflowsData) {
                const { statuses: statuses, workflows: workflows } = workflowsData;
                const workflow = workflows[0];
                const transitionId = (0, (0, parcelRequire("eAapG")).getUniqueTransitionId)(workflow.transitions);
                const isTransitionNameExists = workflow.transitions.some((t)=>t.name.toUpperCase() === statusName.toUpperCase());
                const newTransitionName = isTransitionNameExists ? `${statusName} ${transitionId}` : statusName;
                const statusReference = (0, ($parcel$interopDefault($bXrHm)))();
                const newStatus = {
                    statusReference: statusReference,
                    name: statusName,
                    statusCategory: statusCategory ?? (0, (0, parcelRequire("gULOk")).IN_PROGRESS),
                    description: ''
                };
                const newStatusInWorkflow = {
                    statusReference: statusReference,
                    properties: {},
                    deprecated: false
                };
                const transitionData = {
                    links: [],
                    toStatusReference: statusReference
                };
                const newTransitionInWorkflow = {
                    id: transitionId,
                    type: 'GLOBAL',
                    name: newTransitionName,
                    description: '',
                    actions: [],
                    validators: [],
                    triggers: [],
                    properties: {},
                    ...transitionData
                };
                workflow.statuses = [
                    ...workflow.statuses,
                    newStatusInWorkflow
                ];
                workflow.transitions = [
                    ...workflow.transitions,
                    newTransitionInWorkflow
                ];
                await validateAndUpdateWorkflowsV2({
                    cloudId: cloudId,
                    payload: {
                        payload: {
                            statuses: [
                                ...(0, (0, parcelRequire("eAapG")).mapStatusesToStatusUpdateObjects)(statuses),
                                newStatus
                            ],
                            workflows: [
                                (0, (0, parcelRequire("eAapG")).mapWorkflowToWorkflowUpdateObject)(workflow)
                            ]
                        },
                        validationOptions: {
                            levels: [
                                'ERROR'
                            ]
                        }
                    }
                });
                onSuccess();
            }
        }, [
            fetchWorkflowsV2,
            validateAndUpdateWorkflowsV2
        ]);
        return {
            fetchWorkflowsV2: fetchWorkflowsV2,
            updateWorkflowsV2: updateWorkflowsV2,
            validateAndUpdateWorkflowsV2: validateAndUpdateWorkflowsV2,
            createWorkflowStatusV2: createWorkflowStatusV2,
            createWorkflowStatusforSingleWorkflow: createWorkflowStatusforSingleWorkflow
        };
    };
});
const $03da6b4adba8d655$export$cc9aaebfeb8efe99 = 'NO_INBOUND_TRANSITIONS_TO_STATUS';
const $03da6b4adba8d655$export$fca543997a327d4c = 'NON_UNIQUE_STATUS_NAME';
const $03da6b4adba8d655$export$3bf8ed0d6cdbf43d = 'VERSION_CONFLICT';
const $03da6b4adba8d655$export$cd6873a2b9593ebe = 'OLD_STATUS_MISSING_IN_ORIGINAL_WORKFLOW';
const $03da6b4adba8d655$export$8f656a1a73ea2b22 = 'NEW_STATUS_IN_MAPPING_MISSING_IN_WORKFLOW';
const $03da6b4adba8d655$export$a9ac4cce67a0398e = 'ONLY_ONE_INITIAL_TRANSITION_ALLOWED';
const $03da6b4adba8d655$export$7e934b410e3f0768 = 'APPROVAL_RULE_MISCONFIGURED';
parcelRegister("64pOt", function(module, exports) {
    $parcel$export(module.exports, "StatusNameIsNotUniqueError", ()=>$6c179fd68447a1f2$export$364f122a770d50d5);
    $parcel$export(module.exports, "StatusHasNoIncomingTransitionError", ()=>$6c179fd68447a1f2$export$f19cc85abf8e1b56);
    $parcel$export(module.exports, "WorkflowVersionConflictError", ()=>$6c179fd68447a1f2$export$3bcae14a5d1b7831);
    $parcel$export(module.exports, "OldStatusMissingInWorkflowError", ()=>$6c179fd68447a1f2$export$d019204849f5b18d);
    $parcel$export(module.exports, "NewStatusMissingInWorkflowError", ()=>$6c179fd68447a1f2$export$a2f3292b51bfe008);
    $parcel$export(module.exports, "OnlyOneInitialTransitionAllowedError", ()=>$6c179fd68447a1f2$export$2d54d539af595c13);
    $parcel$export(module.exports, "ApprovalRuleMisconfiguredError", ()=>$6c179fd68447a1f2$export$abac4c6dd3226df);
    class $6c179fd68447a1f2$export$364f122a770d50d5 extends Error {
        constructor(){
            super('status name is not unique');
            this.name = 'StatusNameIsNotUniqueError';
        }
    }
    class $6c179fd68447a1f2$export$f19cc85abf8e1b56 extends Error {
        constructor(){
            super('status has no incoming transition error');
            this.name = 'StatusHasNoIncomingTransitionError';
        }
    }
    class $6c179fd68447a1f2$export$3bcae14a5d1b7831 extends Error {
        constructor(){
            super('Workflow version and version token must match');
            this.name = 'WorkflowVersionConflictError';
        }
    }
    class $6c179fd68447a1f2$export$d019204849f5b18d extends Error {
        constructor(){
            super('Old status missing in workflow');
            this.name = 'OldStatusMissingInWorkflowError';
        }
    }
    class $6c179fd68447a1f2$export$a2f3292b51bfe008 extends Error {
        constructor(){
            super('New status missing in workflow');
            this.name = 'NewStatusMissingInWorkflowError';
        }
    }
    class $6c179fd68447a1f2$export$2d54d539af595c13 extends Error {
        constructor(){
            super('Workflow must have exactly one initial transition');
            this.name = 'OnlyOneInitialTransitionAllowedError';
        }
    }
    class $6c179fd68447a1f2$export$abac4c6dd3226df extends Error {
        constructor(){
            super('Approval status has invalid transitions');
            this.name = 'ApprovalRuleMisconfiguredError';
        }
    }
});
parcelRegister("eAapG", function(module, exports) {
    $parcel$export(module.exports, "mapStatusesToStatusUpdateObjects", ()=>$f33564c11438cc95$export$6ce728204936b996);
    $parcel$export(module.exports, "mapWorkflowToWorkflowUpdateObject", ()=>$f33564c11438cc95$export$aab038e50114d198);
    $parcel$export(module.exports, "removeWorkflowAssociatedWithSubtaskOnly", ()=>$f33564c11438cc95$export$404cd34180e60200);
    $parcel$export(module.exports, "getUniqueTransitionId", ()=>$f33564c11438cc95$export$28172316ffe44a59);
    const $f33564c11438cc95$export$6ce728204936b996 = (statuses)=>statuses.map((s)=>({
                id: s.id,
                name: s.name,
                description: s.description,
                statusReference: s.statusReference,
                statusCategory: s.statusCategory
            }));
    const $f33564c11438cc95$export$aab038e50114d198 = (workflow)=>({
            id: workflow.id,
            version: workflow.version,
            description: workflow.description,
            statuses: workflow.statuses.map(({ deprecated: deprecated, ...status })=>status),
            transitions: workflow.transitions,
            startPointLayout: workflow.startPointLayout,
            statusMappings: workflow.statusMappings || []
        });
    const $f33564c11438cc95$export$404cd34180e60200 = (workflowV2Response, subtaskIssueTypeId)=>{
        if (subtaskIssueTypeId == null) return workflowV2Response;
        const filteredWorkflows = workflowV2Response.workflows.filter((wf)=>!wf.associatedWith.every((association)=>association.issueTypes.length === 1 && association.issueTypes[0] === subtaskIssueTypeId));
        if (filteredWorkflows.length === workflowV2Response.workflows.length) return workflowV2Response;
        return {
            ...workflowV2Response,
            workflows: filteredWorkflows
        };
    };
    const $f33564c11438cc95$export$28172316ffe44a59 = (transitions)=>{
        const largestId = Math.max(...transitions.map((t)=>parseInt(t.id, 10)));
        return String(largestId + 1);
    };
});
const $8acbf7056aed1170$export$35f245e1b98b8614 = 30;
const $8acbf7056aed1170$export$9301910120a61d41 = 42;
parcelRegister("ayqGc", function(module, exports) {
    $parcel$export(module.exports, "getStatusActionFailedFlag", ()=>$a5be4d50bda430ec$export$eb1cd60884388450);
    $parcel$export(module.exports, "failStatusExperience", ()=>$a5be4d50bda430ec$export$d258d7669afadfa1);
    $parcel$export(module.exports, "WorkflowNotFound", ()=>$a5be4d50bda430ec$export$eed4bea4cf8c4900);
    var $64pOt;
    var $jJZqs;
    var $fZneA;
    var $7HGHK;
    var $bRR9U;
    const $a5be4d50bda430ec$var$GENERIC_SAVING_ERROR = 'There was an error saving the workflows';
    const $a5be4d50bda430ec$var$excludedStatusCodes = new Set([
        401,
        403,
        404,
        409
    ]);
    const $a5be4d50bda430ec$var$isFilteredNetworkError = (error)=>Boolean('statusCode' in error && error.statusCode != null && $a5be4d50bda430ec$var$excludedStatusCodes.has(error.statusCode) || error.message?.includes($a5be4d50bda430ec$var$GENERIC_SAVING_ERROR));
    const $a5be4d50bda430ec$export$eb1cd60884388450 = ({ messageTitle: messageTitle, action: action, error: error, projectKey: projectKey, issueTypeId: issueTypeId, statusCode: statusCode })=>{
        const workflowEditorHref = issueTypeId != null && issueTypeId !== '' ? `/jira/core/projects/${projectKey}/settings/issuetypes/${issueTypeId}/workflow` : `/jira/core/projects/${projectKey}/settings/issuetypes`;
        const openWorkflowEditorAction = {
            content: (0, (0, parcelRequire("bRR9U")).default).openWorkflowEditorAction,
            href: workflowEditorHref,
            target: '_blank'
        };
        if (error instanceof (0, (0, parcelRequire("64pOt")).StatusNameIsNotUniqueError)) return {
            type: 'error',
            title: messageTitle,
            description: (0, (0, parcelRequire("bRR9U")).default).statusNameIsNotUniqueDescription,
            actions: [
                openWorkflowEditorAction
            ],
            id: (0, (0, parcelRequire("7HGHK")).toFlagId)(`business-${action}-status-name-is-not-unique.flag`)
        };
        if (error instanceof (0, (0, parcelRequire("64pOt")).StatusHasNoIncomingTransitionError)) return {
            type: 'error',
            title: (0, (0, parcelRequire("bRR9U")).default).statusHasNoIncomingTransitionTitle,
            description: (0, (0, parcelRequire("bRR9U")).default).statusHasNoIncomingTransitionDescription,
            actions: [
                openWorkflowEditorAction
            ],
            id: (0, (0, parcelRequire("7HGHK")).toFlagId)(`business-${action}-status-has-no-incoming-transition.flag`)
        };
        if (error instanceof (0, (0, parcelRequire("64pOt")).WorkflowVersionConflictError) || statusCode === 409) return {
            type: 'error',
            title: messageTitle,
            description: (0, (0, parcelRequire("bRR9U")).default).workflowVersionConflictDescription,
            actions: [
                {
                    content: (0, (0, parcelRequire("bRR9U")).default).viewWorkflowEditorAction,
                    href: workflowEditorHref,
                    target: '_blank'
                }
            ],
            id: (0, (0, parcelRequire("7HGHK")).toFlagId)(`business-${action}-workflow-version-conflict.flag`)
        };
        if (error instanceof (0, (0, parcelRequire("64pOt")).OldStatusMissingInWorkflowError)) return {
            type: 'error',
            title: messageTitle,
            description: (0, (0, parcelRequire("bRR9U")).default).oldStatusMissingInWorkflowDescription,
            actions: [
                openWorkflowEditorAction
            ],
            id: (0, (0, parcelRequire("7HGHK")).toFlagId)(`business-${action}-old-status-missing-in-workflow.flag`)
        };
        if (error instanceof (0, (0, parcelRequire("64pOt")).NewStatusMissingInWorkflowError)) return {
            type: 'error',
            title: messageTitle,
            description: (0, (0, parcelRequire("bRR9U")).default).newStatusMissingInWorkflowDescription,
            actions: [
                openWorkflowEditorAction
            ],
            id: (0, (0, parcelRequire("7HGHK")).toFlagId)(`business-${action}-new-status-missing-in-workflow.flag`)
        };
        if (error instanceof (0, (0, parcelRequire("64pOt")).OnlyOneInitialTransitionAllowedError)) return {
            type: 'error',
            title: messageTitle,
            description: (0, (0, parcelRequire("bRR9U")).default).oneInitialTransitionAllowedWorkflowDescription,
            actions: [
                openWorkflowEditorAction
            ],
            id: (0, (0, parcelRequire("7HGHK")).toFlagId)(`business-${action}-only-one-initial-transition-allowed.flag`)
        };
        if (error instanceof (0, (0, parcelRequire("64pOt")).ApprovalRuleMisconfiguredError)) return {
            type: 'error',
            title: messageTitle,
            description: (0, (0, parcelRequire("bRR9U")).default).approvalRuleMisconfiguredDescription,
            actions: [
                openWorkflowEditorAction
            ],
            id: (0, (0, parcelRequire("7HGHK")).toFlagId)(`business-${action}-approval-rule-misconfigured.flag`)
        };
        if (action === 'delete-polling') return {
            type: 'warning',
            title: messageTitle,
            description: (0, (0, parcelRequire("bRR9U")).default).deletePollingTimeoutDescription,
            actions: [
                openWorkflowEditorAction
            ],
            id: (0, (0, parcelRequire("7HGHK")).toFlagId)(`business-${action}-timeout.flag`)
        };
        return {
            type: 'error',
            title: messageTitle,
            description: (0, (0, parcelRequire("bRR9U")).default).errorFlagDescription,
            actions: [
                {
                    content: (0, (0, parcelRequire("bRR9U")).default).errorFlagActionsReload,
                    onClick: ()=>{
                        typeof window !== 'undefined' && window.location.reload();
                    },
                    target: '_blank'
                }
            ],
            id: (0, (0, parcelRequire("7HGHK")).toFlagId)(`business-${action}-status.flag`)
        };
    };
    const $a5be4d50bda430ec$export$d258d7669afadfa1 = ({ markExperienceFailed: markExperienceFailed, abortExperience: abortExperience, error: error, errorMessage: errorMessage })=>{
        if (error instanceof (0, (0, parcelRequire("64pOt")).StatusNameIsNotUniqueError) || error instanceof (0, (0, parcelRequire("64pOt")).StatusHasNoIncomingTransitionError) || error instanceof (0, (0, parcelRequire("64pOt")).WorkflowVersionConflictError) || error instanceof (0, (0, parcelRequire("64pOt")).OldStatusMissingInWorkflowError) || error instanceof (0, (0, parcelRequire("64pOt")).NewStatusMissingInWorkflowError) || error instanceof (0, (0, parcelRequire("64pOt")).OnlyOneInitialTransitionAllowedError) || error instanceof (0, (0, parcelRequire("64pOt")).ApprovalRuleMisconfiguredError) || (0, (0, parcelRequire("fZneA")).isClientFetchError)(error) || (0, (0, parcelRequire("jJZqs")).isValidationError)(error) || $a5be4d50bda430ec$var$isFilteredNetworkError(error)) {
            abortExperience(errorMessage);
            return;
        }
        markExperienceFailed(errorMessage, error);
    };
    class $a5be4d50bda430ec$export$eed4bea4cf8c4900 extends Error {
        constructor(){
            super();
            this.name = 'WorkflowNotFound';
            this.message = 'Workflow not found';
        }
    }
});
parcelRegister("bRR9U", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d7875f6ffe76a091$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d7875f6ffe76a091$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorFlagTitleAddStatus: {
            "id": "business-workflows.controllers.workflow-actions.error-flag-title-add-status",
            "defaultMessage": "Unable to create status"
        },
        errorFlagTitleDeleteStatus: {
            "id": "business-workflows.controllers.workflow-actions.error-flag-title-delete-status",
            "defaultMessage": "Unable to delete status"
        },
        errorFlagDescription: {
            "id": "business-workflows.controllers.workflow-actions.error-flag-description",
            "defaultMessage": "We\u2019ve run into some connection difficulties."
        },
        errorFlagActionsReload: {
            "id": "business-workflows.controllers.workflow-actions.error-flag-actions-reload",
            "defaultMessage": "Reload"
        },
        statusNameIsNotUniqueDescription: {
            "id": "business-workflows.controllers.workflow-actions.status-name-is-not-unique-description",
            "defaultMessage": "This status name has been used before. To use it again, open the workflow editor and create a status with the same name."
        },
        statusHasNoIncomingTransitionTitle: {
            "id": "business-workflows.controllers.workflow-actions.status-has-no-incoming-transition-title",
            "defaultMessage": "Action needed to delete status"
        },
        statusHasNoIncomingTransitionDescription: {
            "id": "business-workflows.controllers.workflow-actions.status-has-no-incoming-transition-description",
            "defaultMessage": "You need to remove the transitions linked to this status before you can delete it."
        },
        workflowVersionConflictDescription: {
            "id": "business-workflows.controllers.workflow-actions.workflow-version-conflict-description",
            "defaultMessage": "Other workflow updates are in progress. Check the workflow editor and make sure they are complete before making any changes."
        },
        openWorkflowEditorAction: {
            "id": "business-workflows.controllers.workflow-actions.open-workflow-editor-action",
            "defaultMessage": "Open workflow editor"
        },
        viewWorkflowEditorAction: {
            "id": "business-workflows.controllers.workflow-actions.view-workflow-editor-action",
            "defaultMessage": "View workflow editor"
        },
        deletePollingTimeoutTitle: {
            "id": "business-workflows.controllers.workflow-actions.delete-polling-timeout-title",
            "defaultMessage": "Your status is being deleted"
        },
        deletePollingTimeoutDescription: {
            "id": "business-workflows.controllers.workflow-actions.delete-polling-timeout-description",
            "defaultMessage": "Before you make other changes, check the workflow editor to make sure your status has been deleted."
        },
        oldStatusMissingInWorkflowDescription: {
            "id": "business-workflows.controllers.workflow-actions.old-status-missing-in-workflow-description",
            "defaultMessage": "The origin status is not in the current workflow. Check the workflow and try again."
        },
        newStatusMissingInWorkflowDescription: {
            "id": "business-workflows.controllers.workflow-actions.new-status-missing-in-workflow-description",
            "defaultMessage": "The target status is not in the current workflow. Check the workflow and try again."
        },
        oneInitialTransitionAllowedWorkflowDescription: {
            "id": "business-workflows.controllers.workflow-actions.one-initial-transition-allowed-workflow-description",
            "defaultMessage": "Workflow must have exactly one initial transition. Check the workflow and try again."
        },
        approvalRuleMisconfiguredDescription: {
            "id": "business-workflows.controllers.workflow-actions.approval-rule-misconfigured-description",
            "defaultMessage": "Approval status has invalid transitions. Check the workflow and try again."
        }
    });
});
parcelRegister("3YY5f", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31cf02652414d1d8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $31cf02652414d1d8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorFlagTitleAddStatus: {
            "id": "business-workflows.controllers.workflow-actions.create-status.error-flag-title-add-status",
            "defaultMessage": "Unable to create status"
        }
    });
});
parcelRegister("kM5sB", function(module, exports) {
    $parcel$export(module.exports, "asyncInlineCreateStatusModal", ()=>$4f3a1403b068163e$export$64a761d25b20910a);
    var $8p8PB;
    var $evanD;
    var $7KfpL;
    const $4f3a1403b068163e$export$64a761d25b20910a = (0, (0, parcelRequire("7KfpL")).createEntryPoint)({
        root: (0, (0, parcelRequire("evanD")).JSResourceForInteraction)(()=>(parcelRequire("e4F4f")), {
            moduleId: "32dc56f9"
        }),
        getPreloadProps: ({ cloudId: cloudId, projectKey: projectKey })=>({
                queries: {
                    inlineCreateStatusModal: {
                        options: {
                            fetchPolicy: 'store-or-network'
                        },
                        parameters: (0, parcelRequire("8p8PB")).default,
                        variables: {
                            cloudId: cloudId,
                            projectKey: projectKey
                        }
                    }
                }
            })
    });
});
parcelRegister("8p8PB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$32f21baf6b88fc48$export$2e2bcd8739ae039);
    const $32f21baf6b88fc48$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "a6f93e860194a5c2419c4911409b28d0ab9e3c6da5d722ecc79fae56d217265b",
            "metadata": {},
            "name": "srcAsyncInlineCreateStatusQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $32f21baf6b88fc48$export$2e2bcd8739ae039 = $32f21baf6b88fc48$var$node;
});
parcelRegister("e4F4f", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("dw9su")
    ]).then(()=>parcelRequire('e1HID'));
});
parcelRegister("2vLHS", function(module, exports) {
    $parcel$export(module.exports, "getProjectSettingsIssueTypesUrl", ()=>$1b4d3c262f1b4d6e$export$e2e29d5bcfe97104);
    $parcel$export(module.exports, "defaultModalProps", ()=>$1b4d3c262f1b4d6e$export$14c11acc66fd51b3);
    $parcel$export(module.exports, "useCanConfigureStatus", ()=>$1b4d3c262f1b4d6e$export$c330622bbe9077c2);
    $parcel$export(module.exports, "shouldShowConfigureStatusOption", ()=>$1b4d3c262f1b4d6e$export$33aa2c7a0150a75c);
    var $2vSU6;
    var $93Yeu;
    var $17Gip;
    const $1b4d3c262f1b4d6e$export$e2e29d5bcfe97104 = ({ projectKey: projectKey, projectType: projectType })=>{
        switch(projectType?.toLowerCase()){
            case 'service_desk':
                return `/plugins/servlet/project-config/${projectKey}/issueTypes`;
            case 'business':
                return `/jira/core/projects/${projectKey}/settings/issuetypes`;
            default:
                return `/jira/software/projects/${projectKey}/settings/issuetypes`;
        }
    };
    const $1b4d3c262f1b4d6e$export$14c11acc66fd51b3 = {
        width: 'small'
    };
    const $1b4d3c262f1b4d6e$export$c330622bbe9077c2 = (projectKey)=>{
        const isProjectAdmin = (0, (0, parcelRequire("17Gip")).useCanAdministerProject)(projectKey);
        const isTeamManaged = (0, (0, parcelRequire("93Yeu")).useIsSimplifiedProject)(projectKey);
        return isProjectAdmin && isTeamManaged;
    };
    const $1b4d3c262f1b4d6e$export$33aa2c7a0150a75c = (projectType)=>{
        return projectType === (0, (0, parcelRequire("2vSU6")).CORE_PROJECT) || projectType === (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT);
    };
});
parcelRegister("17Gip", function(module, exports) {
    $parcel$export(module.exports, "useProjectPermissions", ()=>$0b32a3d32d712870$export$c6c6b35628cf47a8);
    $parcel$export(module.exports, "useCanAdministerProject", ()=>$0b32a3d32d712870$export$f39ed5a161efa614);
    $parcel$export(module.exports, "useCanAdministerJira", ()=>$0b32a3d32d712870$export$ec12ddafd19b95ac);
    $parcel$export(module.exports, "useCanConfigureIssue", ()=>$0b32a3d32d712870$export$e7267b8a084eadb3);
    $parcel$export(module.exports, "useCanUseServiceDeskAgentFeatures", ()=>$0b32a3d32d712870$export$756d7c97077a2f76);
    $parcel$export(module.exports, "useCanDownloadAttachments", ()=>$0b32a3d32d712870$export$d47dad3a7e3265ea);
    $parcel$export(module.exports, "useProjectPermissionsActions", ()=>$0b32a3d32d712870$export$86c656cdb87052cd);
    var $5uXOq = parcelRequire("5uXOq");
    var $9OXo1;
    var $khL17;
    const $0b32a3d32d712870$export$c6c6b35628cf47a8 = (projectKey)=>{
        const [permissions, { setProjectPermissions: setProjectPermissions }] = (0, (0, parcelRequire("khL17")).useProjectPermissionsStore)({
            projectKey: projectKey
        });
        const actions = (0, $5uXOq.useMemo)(()=>({
                setProjectPermissions: setProjectPermissions
            }), [
            setProjectPermissions
        ]);
        return [
            permissions,
            actions
        ];
    };
    const $0b32a3d32d712870$export$f39ed5a161efa614 = (projectKey)=>{
        const [permissions] = (0, (0, parcelRequire("khL17")).useProjectPermissionsStore)({
            projectKey: projectKey
        });
        return permissions.canAdministerProject;
    };
    const $0b32a3d32d712870$export$ec12ddafd19b95ac = (projectKey)=>{
        const [permissions] = (0, (0, parcelRequire("khL17")).useProjectPermissionsStore)({
            projectKey: projectKey
        });
        return permissions.canAdministerJira;
    };
    const $0b32a3d32d712870$export$e7267b8a084eadb3 = (projectKey)=>{
        const canConfigureAdministerProject = $0b32a3d32d712870$export$f39ed5a161efa614(projectKey);
        const canAdministerJira = $0b32a3d32d712870$export$ec12ddafd19b95ac(projectKey);
        return canConfigureAdministerProject || canAdministerJira;
    };
    const $0b32a3d32d712870$export$756d7c97077a2f76 = (projectKey)=>{
        const [permissions] = (0, (0, parcelRequire("khL17")).useProjectPermissionsStore)({
            projectKey: projectKey
        });
        const { appPermissions: appPermissions } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return permissions.canUseServiceDeskAgentFeatures && appPermissions?.hasServiceDeskAccess;
    };
    const $0b32a3d32d712870$export$d47dad3a7e3265ea = (projectKey)=>{
        const [permissions] = (0, (0, parcelRequire("khL17")).useProjectPermissionsStore)({
            projectKey: projectKey
        });
        return permissions.canExportIssue;
    };
    const $0b32a3d32d712870$export$86c656cdb87052cd = ()=>{
        const [, { setProjectPermissions: setProjectPermissions }] = (0, (0, parcelRequire("khL17")).useProjectPermissionsStoreActions)();
        const actions = (0, $5uXOq.useMemo)(()=>({
                setProjectPermissions: setProjectPermissions
            }), [
            setProjectPermissions
        ]);
        return [
            null,
            actions
        ];
    };
});
parcelRegister("khL17", function(module, exports) {
    $parcel$export(module.exports, "defaultPermissions", ()=>$472e428a487a401f$export$ccfee65526b322ca);
    $parcel$export(module.exports, "useProjectPermissionsStore", ()=>$472e428a487a401f$export$4919fa09a3d81224);
    $parcel$export(module.exports, "useProjectPermissionsStoreActions", ()=>$472e428a487a401f$export$e8436ef485b33bdb);
    var $3sQ5x;
    var $iXqE5;
    var $l5qXF;
    const $472e428a487a401f$export$ccfee65526b322ca = {
        canAddComments: false,
        canAdministerJira: false,
        canAdministerProject: false,
        canAssignIssues: false,
        canBeAssignedToIssues: false,
        canCloneIssue: false,
        canCreateAttachments: false,
        canCreateChildren: false,
        canCreateSubtask: false,
        canDeleteAllAttachments: false,
        canDeleteAllComments: false,
        canDeleteAllWorklogs: false,
        canDeleteIssue: false,
        canDeleteOwnAttachments: false,
        canDeleteOwnComments: false,
        canDeleteOwnWorklogs: false,
        canEditAllComments: false,
        canEditAllWorklogs: false,
        canEditIssues: false,
        canEditOwnComments: false,
        canEditOwnWorklogs: false,
        canLinkIssues: false,
        canLogWork: false,
        canManageWatchers: false,
        canMoveIssue: false,
        canModifyReporter: false,
        canScheduleIssues: false,
        canUseServiceDeskAgentFeatures: false,
        canBrowseUsers: false,
        canViewDevTools: false,
        canViewWatchers: false,
        canViewVoters: false,
        canCreateIssuesInClassicProjectEpic: false,
        canResolveIssues: false,
        canExportIssue: false,
        canArchiveIssue: false,
        canUnarchiveIssue: false
    };
    const $472e428a487a401f$export$6f57813fe9f31bf9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'project-permissions',
        initialState: {},
        actions: (0, parcelRequire("l5qXF"))
    });
    const $472e428a487a401f$var$getProjectPermissionSelector = (state, { projectKey: projectKey })=>state[projectKey] || $472e428a487a401f$export$ccfee65526b322ca;
    const $472e428a487a401f$export$4919fa09a3d81224 = (0, (0, parcelRequire("3sQ5x")).createHook)($472e428a487a401f$export$6f57813fe9f31bf9, {
        selector: $472e428a487a401f$var$getProjectPermissionSelector
    });
    const $472e428a487a401f$export$e8436ef485b33bdb = (0, (0, parcelRequire("3sQ5x")).createHook)($472e428a487a401f$export$6f57813fe9f31bf9, {
        selector: null
    });
});
parcelRegister("l5qXF", function(module, exports) {
    $parcel$export(module.exports, "setProjectPermissions", ()=>$f3418fe5fb58759f$export$53f5cc27627e5fe3);
    const $f3418fe5fb58759f$export$53f5cc27627e5fe3 = (projectKey, permissions)=>({ setState: setState })=>{
            setState({
                [projectKey]: permissions
            });
        };
});
parcelRegister("2KAtx", function(module, exports) {
    $parcel$export(module.exports, "ModalEntryPointPressableTrigger", ()=>$a17c22dd70443cfd$export$defad645fcc21c0a);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $gd9yy;
    var $bTmOP;
    var $2Yyer;
    var $4qSaV;
    var $i9cxd;
    var $2TrWf;
    var $k0Jvh;
    var $lfaZL;
    var $9fuVs;
    var $4R6GH;
    var $c5vfY;
    var $7mPT9;
    var $gJdig;
    var $fiv1r;
    var $dWBzX;
    const $a17c22dd70443cfd$var$emptyObject = {};
    const $a17c22dd70443cfd$export$defad645fcc21c0a = ({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorAttributes: errorAttributes, Fallback: Fallback, interactionName: interactionName, title: title, modalProps: modalProps, useInternalModal: useInternalModal, forwardedRef: forwardedRef })=>{
        const { openModal: openModal } = (0, $5uXOq.useContext)((0, (0, parcelRequire("gJdig")).ModalContext));
        const environmentProvider = (0, (0, parcelRequire("fiv1r")).useJiraRelayEnvironmentProvider)();
        const pressTracing = (0, (0, parcelRequire("lfaZL")).default)(interactionName ?? '');
        const load = (0, $5uXOq.useCallback)(()=>(0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $a17c22dd70443cfd$var$emptyObject), [
            entryPoint,
            entryPointParams,
            environmentProvider
        ]);
        const onBeforeLoad = (0, $5uXOq.useCallback)(()=>{
            if (interactionName) pressTracing();
        }, [
            interactionName,
            pressTracing
        ]);
        const onLoad = (0, $5uXOq.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
            openModal(({ onClose: closeModal })=>{
                const onClose = ()=>{
                    entryPointProps?.onClose?.();
                    closeModal();
                    dispose();
                };
                const defaultFallbackInner = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i9cxd")).default), null, title ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2TrWf")).default), null, title) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0Jvh")).default), {
                    grow: "fill"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gd9yy")).default), null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2Yyer")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gd9yy")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gd9yy")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gd9yy")).default), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4qSaV")).default), null));
                const defaultFallback = useInternalModal ? defaultFallbackInner : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bTmOP")).default), {
                    onClose: closeModal,
                    width: modalProps?.width,
                    height: modalProps?.height
                }, defaultFallbackInner);
                const container = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c5vfY")).InternalEntryPointContainer), {
                    entryPointReference: entryPointReference,
                    errorAttributes: errorAttributes,
                    errorFallback: "flag",
                    fallback: Fallback ? (0, ($parcel$interopDefault($5uXOq))).createElement(Fallback, {
                        onClose: closeModal
                    }) : defaultFallback,
                    id: entryPoint.root.getModuleName?.() ?? 'unknown',
                    placeholderName: "modal-entry-point-pressable-trigger-container",
                    runtimeProps: {
                        ...entryPointProps ?? $a17c22dd70443cfd$var$emptyObject,
                        onClose: onClose
                    }
                });
                return useInternalModal ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bTmOP")).default), {
                    ...modalProps,
                    onClose: onClose
                }, container)) : container;
            });
        }, [
            entryPoint,
            entryPointProps,
            errorAttributes,
            Fallback,
            openModal,
            title,
            modalProps,
            useInternalModal
        ]);
        const triggerRef = (0, (0, parcelRequire("dWBzX")).usePressablePreloadRef)({
            load: load,
            onBeforeLoad: onBeforeLoad,
            onLoad: onLoad
        });
        if (forwardedRef != null && (0, (0, parcelRequire("4R6GH")).fg)('forward_ref_modalentrypointdropdownitemtrigger')) {
            const ref = (0, (0, parcelRequire("7mPT9")).default)(triggerRef, forwardedRef);
            return children({
                ref: ref
            });
        }
        return children({
            ref: triggerRef
        });
    };
});
parcelRegister("9fuVs", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistryContext", ()=>$1dd87679d9ca363b$export$ebbb59327adb551a);
    $parcel$export(module.exports, "default", ()=>$1dd87679d9ca363b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k4r7E;
    const $1dd87679d9ca363b$export$ebbb59327adb551a = (0, $5uXOq.createContext)((0, (0, parcelRequire("k4r7E")).rootRegistry));
    const $1dd87679d9ca363b$var$ShortcutScope = ({ children: children = null })=>{
        const registry = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("k4r7E")).ShortcutRegistry)(), []);
        const parentRegistry = (0, $5uXOq.useContext)($1dd87679d9ca363b$export$ebbb59327adb551a) || (0, (0, parcelRequire("k4r7E")).rootRegistry);
        (0, $5uXOq.useEffect)(()=>{
            const removeRegistry = parentRegistry.addChildRegistry(registry);
            return removeRegistry;
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1dd87679d9ca363b$export$ebbb59327adb551a.Provider, {
            value: registry
        }, children);
    };
    var $1dd87679d9ca363b$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : $1dd87679d9ca363b$var$ShortcutScope;
});
parcelRegister("k4r7E", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistry", ()=>$a65fecdbaed23de2$export$ca1c75b575abf5ff);
    $parcel$export(module.exports, "rootRegistry", ()=>$a65fecdbaed23de2$export$1dd4c61d1ce1fa15);
    var $lbWm4 = parcelRequire("lbWm4");
    var $561FV = parcelRequire("561FV");
    var $hGgHi = parcelRequire("hGgHi");
    var $FISJv = parcelRequire("FISJv");
    var $lIZQG;
    const $a65fecdbaed23de2$var$validateKeyMaps = (keyMaps)=>{
        (0, ($parcel$interopDefault($lbWm4)))(keyMaps, (keyMap, keyMapIndex)=>{
            const shortcuts = Object.keys(keyMap);
            (0, ($parcel$interopDefault($lbWm4)))(shortcuts, (shortcut, shortcutIndex)=>{
                if (!(0, (0, parcelRequire("lIZQG")).isValidShortcut)(shortcut)) console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
                for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                    const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                    (0, ($parcel$interopDefault($lbWm4)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                        if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(anotherShortcut, shortcut)) {
                            if ((0, ($parcel$interopDefault($hGgHi)))(keyMap[shortcut].priority) && (0, ($parcel$interopDefault($hGgHi)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                        }
                    });
                }
                for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
            });
        });
    };
    const $a65fecdbaed23de2$var$mergeKeyMaps = (keyMapsToMerge)=>keyMapsToMerge.reduce((prev, keyMap)=>({
                ...prev,
                ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                    if (!(0, ($parcel$interopDefault($561FV)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1)) return {
                        ...newAccumulator,
                        [newKey]: keyMap[newKey]
                    };
                    return newAccumulator;
                }, {})
            }), {});
    class $a65fecdbaed23de2$export$ca1c75b575abf5ff {
        addChildRegistry(child) {
            this.children.push(child);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.children, child);
            };
        }
        addKeyMap(getKeyMap) {
            this.keyMapRetrievers.push(getKeyMap);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.keyMapRetrievers, getKeyMap);
            };
        }
        getActiveKeyMap() {
            const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
            return {
                ...$a65fecdbaed23de2$var$mergeKeyMaps(keyMaps)
            };
        }
        getKeyMapInfo() {
            const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
            const flattenedInfo = [].concat(...info);
            return flattenedInfo;
        }
        constructor(){
            this.children = [];
            this.keyMapRetrievers = [];
        }
    }
    const $a65fecdbaed23de2$export$1dd4c61d1ce1fa15 = new $a65fecdbaed23de2$export$ca1c75b575abf5ff();
});
parcelRegister("lIZQG", function(module, exports) {
    $parcel$export(module.exports, "toKeyWithModifiers", ()=>$ca3344250c7b7406$export$8cf0d2c3d060a0c2);
    $parcel$export(module.exports, "isValidShortcut", ()=>$ca3344250c7b7406$export$8e231506c5580162);
    $parcel$export(module.exports, "isShortcutCollision", ()=>$ca3344250c7b7406$export$4add9e50cb49d130);
    const $ca3344250c7b7406$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
    const $ca3344250c7b7406$var$modifiers = [
        {
            name: 'ctrl',
            test: (e)=>e.ctrlKey
        },
        {
            name: 'shift',
            test: (e)=>e.shiftKey && $ca3344250c7b7406$var$isNonCharacterKey(e)
        },
        {
            name: 'meta',
            test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
        }
    ];
    const $ca3344250c7b7406$var$toKey = (e)=>{
        if ($ca3344250c7b7406$var$isNonCharacterKey(e)) return e.key.toLowerCase();
        return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
    };
    const $ca3344250c7b7406$export$8cf0d2c3d060a0c2 = (e)=>{
        if (!e || !e.key) return {
            sequence: '',
            e: e
        };
        return {
            sequence: $ca3344250c7b7406$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($ca3344250c7b7406$var$toKey(e)).join('+'),
            e: e
        };
    };
    const $ca3344250c7b7406$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
    const $ca3344250c7b7406$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$ca3344250c7b7406$var$orSpecialChars}))))?(meta\\+)?(${$ca3344250c7b7406$var$orSpecialChars}|[!-~])`;
    const $ca3344250c7b7406$var$shortcutRegex = RegExp(`^${$ca3344250c7b7406$var$singleShortcutEntry}( ${$ca3344250c7b7406$var$singleShortcutEntry})*$`);
    const $ca3344250c7b7406$export$8e231506c5580162 = (shortcut)=>$ca3344250c7b7406$var$shortcutRegex.test(shortcut);
    const $ca3344250c7b7406$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
        if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
        if (rightShortcut === leftShortcut) return true;
        if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
        if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
        return false;
    };
});
parcelRegister("7mPT9", function(module, exports) {
    $parcel$export(module.exports, "mergeRefs", ()=>$d1da29f25d5b5e0a$export$c9058316764c140e);
    $parcel$export(module.exports, "default", ()=>$d1da29f25d5b5e0a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $d1da29f25d5b5e0a$export$c9058316764c140e(...refs) {
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === 'function') ref(value);
                else if (ref != null) ref.current = value;
            });
        };
    }
    function $d1da29f25d5b5e0a$export$2e2bcd8739ae039(...refs) {
        return (0, $5uXOq.useMemo)(()=>$d1da29f25d5b5e0a$export$c9058316764c140e(...refs), refs);
    }
});
parcelRegister("dWBzX", function(module, exports) {
    $parcel$export(module.exports, "usePressablePreloadRef", ()=>$01294bc664dce1e5$export$1ff47f24e06a5d2d);
    var $5uXOq = parcelRequire("5uXOq");
    const $01294bc664dce1e5$var$PRELOAD_MAX_AGE = 2000;
    const $01294bc664dce1e5$var$TIME_TO_INTENT = 200;
    function $01294bc664dce1e5$export$1ff47f24e06a5d2d({ load: load, onBeforeLoad: onBeforeLoad, onLoad: onLoad }) {
        const ref = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            const el = ref.current;
            if (!el) return;
            const request = {};
            const clearPreloadTimeouts = ()=>{
                if (typeof request.preloadIntentTimeout === 'number') {
                    clearTimeout(request.preloadIntentTimeout);
                    delete request.preloadIntentTimeout;
                }
                if (typeof request.preloadMaxAgeTimeout === 'number') {
                    clearTimeout(request.preloadMaxAgeTimeout);
                    delete request.preloadMaxAgeTimeout;
                }
            };
            const cancelPreload = ()=>{
                clearPreloadTimeouts();
                request.preload?.dispose();
            };
            const loadReference = ()=>{
                if (request.load) return request.load;
                const reference = request.preload?.reference ?? load();
                if (request.preload) delete request.preload;
                request.load = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.load;
                    }
                };
                return request.load;
            };
            const clickListener = ()=>{
                clearPreloadTimeouts();
                onBeforeLoad();
                onLoad(loadReference());
            };
            const mouseDownListener = ()=>{
                clearPreloadTimeouts();
                loadReference();
            };
            const preloadReference = ()=>{
                if (request.preloadIntentTimeout || request.preload) return;
                request.preloadIntentTimeout = setTimeout(()=>{
                    delete request.preloadIntentTimeout;
                    const reference = load();
                    request.preload = {
                        reference: reference,
                        dispose () {
                            reference.dispose();
                            delete request.preload;
                        }
                    };
                    request.preloadMaxAgeTimeout = setTimeout(()=>{
                        delete request.preloadMaxAgeTimeout;
                        request.preload?.dispose();
                    }, $01294bc664dce1e5$var$PRELOAD_MAX_AGE);
                }, $01294bc664dce1e5$var$TIME_TO_INTENT);
            };
            el.addEventListener('click', clickListener);
            el.addEventListener('mousedown', mouseDownListener);
            el.addEventListener('mouseenter', preloadReference);
            el.addEventListener('mouseleave', cancelPreload);
            return ()=>{
                cancelPreload();
                el.removeEventListener('click', clickListener);
                el.removeEventListener('mousedown', mouseDownListener);
                el.removeEventListener('mouseenter', preloadReference);
                el.removeEventListener('mouseleave', cancelPreload);
            };
        }, [
            load,
            onBeforeLoad,
            onLoad
        ]);
        return ref;
    }
});
parcelRegister("dROaT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$68c3249678f66f5d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $68c3249678f66f5d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createStatus: {
            "id": "business-summary.summary-view.progress-by-status.create-status-button.create-status",
            "defaultMessage": "Create status"
        }
    });
});
parcelRegister("fW0Mh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d152bc1cdb0a2630$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $czVbS;
    var $6Rwwu;
    var $6Ll2T;
    var $a95o8;
    var $99gde;
    var $113Tq;
    var $loZC0;
    var $8xg9P;
    var $6s1PB;
    var $koVbs;
    var $8zOmE;
    var $lwMsT;
    var $4Z8SI;
    var $34f85;
    var $2qxpw;
    var $5vmU5;
    const $d152bc1cdb0a2630$var$LegendListItem = ({ entry: entry, index: index, highlightEntry: highlightEntry, existingStatusNames: existingStatusNames, percentage: percentage, linksTarget: linksTarget, onCountClick: onCountClick, canEdit: canEdit = false })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('business_summary_page_inline_status');
        const isInlineStatusChangeEnabled = expConfig.get('isInlineStatusChangeEnabled', false);
        const isWorkflowOperationInProgress = isInlineStatusChangeEnabled ? (0, (0, parcelRequire("8xg9P")).useIsWorkflowOperationInProgress)() : false;
        const { startEditMode: startEditMode, renameStatus: renameStatus, validateStatusRename: validateStatusRename, cancelInlineRename: cancelInlineRename, editInlineRename: editInlineRename, editModeIndex: editModeIndex, isEditing: isEditing, isWorkflowUpdating: isWorkflowUpdating, optimisticStatusName: optimisticStatusName } = isInlineStatusChangeEnabled ? (0, (0, parcelRequire("34f85")).useRenameStatusInline)() : {
            startEditMode: (0, ($parcel$interopDefault($8Rkzz))),
            renameStatus: (0, ($parcel$interopDefault($8Rkzz))),
            validateStatusRename: ()=>undefined,
            cancelInlineRename: (0, ($parcel$interopDefault($8Rkzz))),
            editInlineRename: (0, ($parcel$interopDefault($8Rkzz))),
            editModeIndex: null,
            isEditing: false,
            isWorkflowUpdating: false,
            optimisticStatusName: null
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2qxpw")).LegendItem), {
            onMouseEnter: ()=>{
                highlightEntry(index);
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2qxpw")).LegendItemColor), {
            color: entry.itemStyle.color
        }), canEdit && (0, (0, parcelRequire("6s1PB")).expVal)('business_summary_page_inline_status', 'isInlineStatusChangeEnabled', false) ? editModeIndex === index ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $d152bc1cdb0a2630$var$inlineRenameWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4Z8SI")).default), {
            defaultValue: entry.name,
            isEditing: isEditing,
            readView: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2qxpw")).LegendItemName), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                    xcss: $d152bc1cdb0a2630$var$statusNameStyles
                }, optimisticStatusName), isWorkflowUpdating && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                    xcss: $d152bc1cdb0a2630$var$spinnerStyles
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("113Tq")).default), {
                    size: "small",
                    label: ""
                }))),
            onCancel: cancelInlineRename,
            onConfirm: (newName)=>{
                renameStatus(entry.name, newName, entry.id);
            },
            onEdit: editInlineRename,
            onValidate: (newName)=>validateStatusRename(entry.name, newName, existingStatusNames),
            maxLength: (0, $8acbf7056aed1170$export$35f245e1b98b8614)
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2qxpw")).LegendItemName), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $d152bc1cdb0a2630$var$statusNameStyles
        }, entry.name), !isWorkflowOperationInProgress && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a95o8")).default), {
            tabIndex: 0,
            xcss: $d152bc1cdb0a2630$var$iconButtonStyles,
            onClick: ()=>{
                startEditMode(index);
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'statusNameInlineEdit');
            },
            "aria-label": formatMessage((0, (0, parcelRequire("5vmU5")).default).statusNameButtonLabel, {
                statusName: entry.name
            }),
            onFocus: ()=>highlightEntry(index),
            testId: "business-summary.ui.summary-view.progress-by-status.legend-item.edit-status-button"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: formatMessage((0, (0, parcelRequire("5vmU5")).default).statusNameTooltip),
            position: "bottom"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("czVbS"))))), {
            label: "",
            LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("6Rwwu"))))),
            LEGACY_size: "small",
            color: "var(--ds-icon, #44546F)"
        })))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2qxpw")).LegendItemName), null, entry.name), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2qxpw")).LegendItemCount), {
            href: entry.link,
            target: linksTarget,
            onClick: onCountClick,
            onFocus: ()=>highlightEntry(index),
            "aria-label": formatMessage((0, (0, parcelRequire("5vmU5")).default).tableCountersLabel, {
                issuesCount: entry.value,
                status: entry.name,
                percentage: percentage
            })
        }, entry.value));
    };
    const $d152bc1cdb0a2630$var$spinnerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        marginLeft: 'space.100'
    });
    const $d152bc1cdb0a2630$var$statusNameStyles = (0, (0, parcelRequire("99gde")).xcss)({
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    });
    const $d152bc1cdb0a2630$var$iconButtonStyles = (0, (0, parcelRequire("99gde")).xcss)({
        borderRadius: 'border.radius',
        outlineOffset: 'space.0',
        padding: 'space.025',
        marginInline: 'space.100',
        opacity: 'var(--edit-opacity, 0)',
        width: 'var(--edit-width, 0)',
        backgroundColor: 'color.background.neutral.subtle',
        ':hover': {
            backgroundColor: 'color.background.neutral.subtle.hovered'
        }
    });
    const $d152bc1cdb0a2630$var$inlineRenameWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        paddingBlockEnd: 'space.100',
        width: '100%'
    });
    var $d152bc1cdb0a2630$export$2e2bcd8739ae039 = $d152bc1cdb0a2630$var$LegendListItem;
});
parcelRegister("6Rwwu", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4ff0ebb5f1c6729f$var$_react = $4ff0ebb5f1c6729f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $4ff0ebb5f1c6729f$var$_edit = $4ff0ebb5f1c6729f$var$_interopRequireDefault((parcelRequire("czVbS")));
    function $4ff0ebb5f1c6729f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4ff0ebb5f1c6729f$var$EditIcon = (props)=>$4ff0ebb5f1c6729f$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
        }, props, {
            newIcon: $4ff0ebb5f1c6729f$var$_edit.default
        }));
    $4ff0ebb5f1c6729f$var$EditIcon.displayName = 'EditIcon';
    var $4ff0ebb5f1c6729f$var$_default = module.exports.default = $4ff0ebb5f1c6729f$var$EditIcon;
});
parcelRegister("4Z8SI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b67c26d51875f5db$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $4eOUJ;
    var $dKgvg;
    var $7iNNf;
    var $6Ll2T;
    var $99gde;
    var $8mGGj;
    var $koVbs;
    var $SKokA;
    const $b67c26d51875f5db$var$ERROR_MESSAGE_ID = 'field-name-error-dialog';
    const $b67c26d51875f5db$var$InlineRenameField = ({ defaultValue: defaultValue, isEditing: isEditing, onCancel: onCancel, onConfirm: onConfirm, onEdit: onEdit, onValidate: onValidate, readView: readView, maxLength: maxLength })=>{
        const renameTextFieldRef = (0, $5uXOq.useRef)(null);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const handleOnBlur = (0, $5uXOq.useCallback)((event, isInvalid)=>{
            if (isInvalid) onCancel();
        }, [
            onCancel
        ]);
        const handleConfirm = (0, $5uXOq.useCallback)((value)=>{
            onConfirm(value);
        }, [
            onConfirm
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iNNf")).default), {
            startWithEditViewOpen: isEditing,
            readViewFitContainerWidth: true,
            defaultValue: defaultValue,
            isEditing: isEditing,
            readView: readView,
            editView: ({ errorMessage: errorMessage, ...fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dKgvg")).default), {
                    isOpen: fieldProps.isInvalid,
                    content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                        id: $b67c26d51875f5db$var$ERROR_MESSAGE_ID
                    }, errorMessage),
                    placement: "top-end"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8mGGj")).default), {
                    ...fieldProps,
                    ref: renameTextFieldRef,
                    autoFocus: true,
                    elemAfterInput: fieldProps.isInvalid && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                        xcss: $b67c26d51875f5db$var$warningIconWrapperStyles
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("4eOUJ"))))), {
                        label: "error",
                        color: "var(--ds-icon-warning, #E56910)"
                    })),
                    onBlur: (event)=>handleOnBlur(event, fieldProps.isInvalid),
                    autoComplete: "off",
                    "aria-errormessage": $b67c26d51875f5db$var$ERROR_MESSAGE_ID,
                    isDisabled: !isEditing,
                    appearance: "subtle",
                    "aria-label": defaultValue,
                    maxLength: maxLength,
                    className: (0, (0, parcelRequire("bwpsq")).default)([
                        "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1srl1osq"
                    ])
                })),
            onEdit: onEdit,
            onCancel: onCancel,
            onConfirm: handleConfirm,
            validate: onValidate,
            editButtonLabel: defaultValue,
            editLabel: formatMessage((0, (0, parcelRequire("SKokA")).default).editActionLabel)
        });
    };
    const $b67c26d51875f5db$var$warningIconWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        paddingInlineEnd: 'space.075',
        lineHeight: '100%',
        display: 'flex',
        alignItems: 'center'
    });
    const $b67c26d51875f5db$var$textFieldStyles = null;
    var $b67c26d51875f5db$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($b67c26d51875f5db$var$InlineRenameField);
});
parcelRegister("7iNNf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$56ec3aea21318322$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2cjvv;
    var $knKRw;
    var $lOr6E;
    var $2oS3b;
    var $a95o8;
    var $AHUyh;
    var $6Y6uy;
    var $fWhPX;
    var $74fNf;
    function $56ec3aea21318322$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $56ec3aea21318322$var$fieldStyles = {
        name: "nziz0a",
        styles: "max-width:100%;position:relative"
    };
    const $56ec3aea21318322$var$analyticsAttributes = {
        componentName: 'inlineEdit',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $56ec3aea21318322$var$InnerInlineEdit = (props)=>{
        const { startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', editLabel: editLabel = 'edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel, onEdit: providedOnEdit, testId: testId } = props;
        const wasFocusReceivedSinceLastBlurRef = (0, $5uXOq.useRef)(false);
        const isControlled = typeof isEditing === 'undefined';
        const [isEditingState, setEditingState] = (0, $5uXOq.useState)(startWithEditViewOpen);
        const timerRef = (0, $5uXOq.useRef)();
        const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, (0, parcelRequire("fWhPX")).default)(isEditing, isEditingState);
        const onCancel = (0, $5uXOq.useCallback)(()=>{
            if (isControlled) setEditingState(false);
            providedOnCancel?.();
        }, [
            isControlled,
            providedOnCancel
        ]);
        const onEditRequested = (0, $5uXOq.useCallback)(()=>{
            if (isControlled) setEditingState(true);
            providedOnEdit?.();
            if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
        }, [
            isControlled,
            shouldBeEditing,
            editViewRef,
            providedOnEdit
        ]);
        const onConfirm = (0, (0, parcelRequire("2cjvv")).usePlatformLeafEventHandler)({
            fn: (value, analyticsEvent)=>{
                if (isControlled) setEditingState(false);
                providedOnConfirm(value, analyticsEvent);
            },
            action: 'confirmed',
            analyticsData: analyticsContext,
            ...$56ec3aea21318322$var$analyticsAttributes
        });
        const onCancelClick = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
            onCancel();
        }, [
            onCancel
        ]);
        const tryAutoSubmitWhenBlur = (0, $5uXOq.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
            if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
                doNotFocusOnEditButton();
                if (formRef.current.checkValidity()) onSubmit();
            }
        }, [
            doNotFocusOnEditButton
        ]);
        const onEditViewWrapperBlur = (0, $5uXOq.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
            if (!keepEditViewOpenOnBlur) {
                wasFocusReceivedSinceLastBlurRef.current = false;
                timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid, onSubmit, formRef), 0);
            }
        }, [
            keepEditViewOpenOnBlur,
            tryAutoSubmitWhenBlur
        ]);
        const onEditViewWrapperFocus = (0, $5uXOq.useCallback)(()=>{
            wasFocusReceivedSinceLastBlurRef.current = true;
        }, []);
        const concatenatedEditButtonLabel = ()=>{
            if (label) return `${editButtonLabel}, ${label}, ${editLabel}`;
            return `${editButtonLabel}, ${editLabel}`;
        };
        const renderReadView = ()=>{
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("74fNf")).default), {
                editButtonLabel: concatenatedEditButtonLabel(),
                onEditRequested: onEditRequested,
                postReadViewClick: doNotFocusOnEditButton,
                editButtonRef: editButtonRef,
                readViewFitContainerWidth: readViewFitContainerWidth,
                readView: readView,
                testId: testId
            });
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lOr6E")).default), {
            onSubmit: (data)=>onConfirm(data.inlineEdit)
        }, ({ formProps: { onKeyDown: onKeyDown, onSubmit: onSubmit, ref: formRef }, reset: reset })=>(0, (0, parcelRequire("f8Sb3")).jsx)("form", {
                role: "presentation",
                onKeyDown: (e)=>{
                    onKeyDown(e);
                    if (e.key === 'Esc' || e.key === 'Escape') {
                        if ((0, (0, parcelRequire("2oS3b")).fg)('platform-design-system-inline-edit-reset-on-escape')) reset();
                        onCancel();
                    }
                },
                onSubmit: onSubmit,
                ref: formRef
            }, shouldBeEditing ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("knKRw")).default), {
                name: "inlineEdit",
                label: label,
                defaultValue: defaultValue,
                validate: validate,
                isRequired: isRequired,
                key: "edit-view"
            }, ({ fieldProps: fieldProps, error: error })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                    css: $56ec3aea21318322$var$fieldStyles,
                    onBlur: (e)=>{
                        if (!e.currentTarget.contains(e.relatedTarget)) onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit, formRef);
                    },
                    onFocus: onEditViewWrapperFocus
                }, editView({
                    ...fieldProps,
                    errorMessage: error
                }, editViewRef), !hideActionButtons ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6Y6uy")).default), {
                    testId: testId,
                    cancelButtonLabel: cancelButtonLabel,
                    confirmButtonLabel: confirmButtonLabel,
                    onMouseDown: ()=>{
                        doNotFocusOnEditButton();
                    },
                    onCancelClick: (e)=>{
                        reset();
                        onCancelClick(e);
                    }
                }) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("a95o8")).default), {
                    hidden: true,
                    type: "submit"
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("AHUyh")).default), null, "Submit")))) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("knKRw")).default), {
                name: "inlineEdit",
                label: label,
                defaultValue: "",
                isRequired: isRequired,
                key: "read-view"
            }, renderReadView)));
    };
    const $56ec3aea21318322$var$InlineEdit = (props)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)($56ec3aea21318322$var$InnerInlineEdit, props);
    };
    var $56ec3aea21318322$export$2e2bcd8739ae039 = $56ec3aea21318322$var$InlineEdit;
});
parcelRegister("knKRw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$110243b5cd2eb92d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    parcelRequire("3joPi");
    var $bkJDg;
    var $1FTEF;
    var $lOr6E;
    var $7VnW8;
    var $8knNZ;
    var $6cAn5 = parcelRequire("6cAn5");
    function $110243b5cd2eb92d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $110243b5cd2eb92d$var$fieldWrapperStyles = {
        name: "wkpnc",
        styles: "margin-block-start:var(--ds-space-100, 8px)"
    };
    function $110243b5cd2eb92d$var$isEvent(event) {
        return Boolean(event && event.target);
    }
    function $110243b5cd2eb92d$var$isFunction(x) {
        return typeof x === 'function';
    }
    function $110243b5cd2eb92d$var$usePreviousRef(current) {
        const ref = (0, $5uXOq.useRef)(current);
        (0, $5uXOq.useEffect)(()=>{
            ref.current = current;
        });
        return ref;
    }
    function $110243b5cd2eb92d$var$isShallowEqual(previousValue, currentValue) {
        if (previousValue === currentValue) return true;
        if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
        if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
        if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
        return false;
    }
    function $110243b5cd2eb92d$export$2e2bcd8739ae039(props) {
        const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $5uXOq.useContext)((0, (0, parcelRequire("lOr6E")).FormContext));
        const isDisabled = (0, $5uXOq.useContext)((0, (0, parcelRequire("lOr6E")).IsDisabledContext)) || props.isDisabled || false;
        const defaultValue = $110243b5cd2eb92d$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
        const latestPropsRef = $110243b5cd2eb92d$var$usePreviousRef(props);
        const isDefaultValueChanged = !$110243b5cd2eb92d$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
        const [state, setState] = (0, $5uXOq.useState)({
            fieldProps: {
                onChange: ()=>{},
                onBlur: ()=>{},
                onFocus: ()=>{},
                value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
            },
            error: undefined,
            valid: false,
            meta: {
                dirty: false,
                dirtySinceLastSubmit: false,
                touched: false,
                valid: false,
                validating: false,
                submitting: false,
                submitFailed: false,
                error: undefined,
                submitError: undefined
            }
        });
        const latestStateRef = $110243b5cd2eb92d$var$usePreviousRef(state);
        (0, $5uXOq.useEffect)(()=>{
            typeof $6cAn5;
            function fieldStateToMeta(value = {}) {
                return {
                    dirty: value.dirty || false,
                    dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                    touched: value.touched || false,
                    valid: value.valid || false,
                    submitting: value.submitting || false,
                    submitFailed: value.submitFailed || false,
                    error: value.error,
                    submitError: value.submitError,
                    validating: !!value.validating
                };
            }
            const unregister = registerField(latestPropsRef.current.name, isDefaultValueChanged || $110243b5cd2eb92d$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
                const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
                const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
                const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
                const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
                const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
                function getTransform(eventOrValue, currentValue) {
                    if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                    if ($110243b5cd2eb92d$var$isEvent(eventOrValue)) {
                        const { currentTarget: currentTarget } = eventOrValue;
                        if (currentTarget.type === 'checkbox') {
                            if (currentTarget.checked) return currentTarget.value || true;
                            return currentTarget.value ? undefined : false;
                        } else if (currentTarget) return currentTarget.value;
                    } else return eventOrValue;
                }
                setState({
                    fieldProps: {
                        onChange: (e)=>{
                            fieldState.change(getTransform(e, fieldState.value));
                        },
                        onBlur: fieldState.blur,
                        onFocus: fieldState.focus,
                        value: fieldState.value
                    },
                    error: modifiedError || undefined,
                    valid: modifiedValid || false,
                    meta: fieldStateToMeta(fieldState)
                });
            }, {
                dirty: true,
                dirtySinceLastSubmit: true,
                touched: true,
                valid: true,
                submitting: true,
                submitFailed: true,
                value: true,
                error: true,
                submitError: true,
                validating: true
            }, {
                getValidator: ()=>function validate(value, formState, fieldState) {
                        const supplied = latestPropsRef.current.validate;
                        if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                    }
            });
            return unregister;
        }, [
            latestPropsRef,
            latestStateRef,
            registerField,
            props.name,
            isDefaultValueChanged
        ]);
        const uid = (0, (0, parcelRequire("bkJDg")).useId)();
        const fieldId = (0, $5uXOq.useMemo)(()=>{
            return props.id ? props.id : `${props.name}-${uid}`;
        }, [
            props.id,
            props.name,
            uid
        ]);
        const getDescribedBy = ()=>{
            let value = '';
            if (state.error) value += `${fieldId}-error `;
            if (state.valid) value += `${fieldId}-valid `;
            return `${value}${fieldId}-helper`;
        };
        const extendedFieldProps = {
            ...state.fieldProps,
            name: props.name,
            isDisabled: isDisabled,
            isInvalid: Boolean(state.error),
            isRequired: Boolean(props.isRequired),
            'aria-invalid': state.error ? 'true' : 'false',
            'aria-describedby': getDescribedBy(),
            'aria-labelledby': `${fieldId}-label`,
            id: fieldId
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $110243b5cd2eb92d$var$fieldWrapperStyles,
            "data-testid": props.testId
        }, props.label && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7VnW8")).Label), {
            htmlFor: fieldId,
            id: `${fieldId}-label`,
            testId: props.testId && `${props.testId}--label`
        }, props.label, props.isRequired && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8knNZ")).default), null), props.elementAfterLabel), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1FTEF")).FieldId).Provider, {
            value: fieldId
        }, props.children({
            fieldProps: extendedFieldProps,
            error: state.error,
            valid: state.valid,
            meta: state.meta
        })));
    }
});
parcelRegister("1FTEF", function(module, exports) {
    $parcel$export(module.exports, "FieldId", ()=>$b38f467b8b7721b2$export$3c4232819458a302);
    var $5uXOq = parcelRequire("5uXOq");
    const $b38f467b8b7721b2$export$3c4232819458a302 = (0, $5uXOq.createContext)(undefined);
});
parcelRegister("lOr6E", function(module, exports) {
    $parcel$export(module.exports, "FormContext", ()=>$75a5255a3d60692c$export$c24727297075ec6a);
    $parcel$export(module.exports, "IsDisabledContext", ()=>$75a5255a3d60692c$export$c17cf6b332a82dbc);
    $parcel$export(module.exports, "default", ()=>$75a5255a3d60692c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lqWDn = parcelRequire("lqWDn");
    var $8tHJX = parcelRequire("8tHJX");
    var $gZL7V = parcelRequire("gZL7V");
    const $75a5255a3d60692c$export$c24727297075ec6a = (0, $5uXOq.createContext)({
        registerField: function() {
            return ()=>{};
        },
        getCurrentValue: ()=>undefined,
        subscribe: function() {
            return ()=>{};
        }
    });
    const $75a5255a3d60692c$export$c17cf6b332a82dbc = (0, $5uXOq.createContext)(false);
    function $75a5255a3d60692c$export$2e2bcd8739ae039(props) {
        const formRef = (0, $5uXOq.useRef)(null);
        const onSubmitRef = (0, $5uXOq.useRef)(props.onSubmit);
        onSubmitRef.current = props.onSubmit;
        const [form] = (0, $5uXOq.useState)(()=>{
            const finalForm = (0, $lqWDn.createForm)({
                onSubmit: (...args)=>onSubmitRef.current(...args),
                destroyOnUnregister: true,
                initialValues: {},
                mutators: {
                    setDefaultValue: ([name, defaultValue], state)=>{
                        if (state.formState.initialValues) {
                            const initialValues = state.formState.initialValues;
                            const values = state.formState.values;
                            const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                            (0, ($parcel$interopDefault($gZL7V)))(initialValues, name, value);
                            (0, ($parcel$interopDefault($gZL7V)))(values, name, value);
                        }
                    }
                }
            });
            (0, $8tHJX.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
            return finalForm;
        });
        const [state, setState] = (0, $5uXOq.useState)({
            dirty: false,
            submitting: false
        });
        (0, $5uXOq.useEffect)(()=>{
            const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
                setState({
                    dirty: dirty,
                    submitting: submitting
                });
            }, {
                dirty: true,
                submitting: true
            });
            return unsubscribe;
        }, [
            form
        ]);
        const registerField = (0, $5uXOq.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
            form.pauseValidation();
            const unsubscribe = form.registerField(name, subscriber, subscription, config);
            form.mutators.setDefaultValue(name, defaultValue);
            form.resumeValidation();
            return unsubscribe;
        }, [
            form
        ]);
        const handleSubmit = (e)=>{
            if (e) e.preventDefault();
            form.submit();
        };
        const handleReset = (initialValues)=>{
            form.reset(initialValues);
        };
        const handleKeyDown = (e)=>{
            if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
                const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
                if (submitButton) submitButton.click();
                e.preventDefault();
            }
        };
        const { isDisabled: isDisabled = false, children: children } = props;
        const { dirty: dirty, submitting: submitting } = state;
        const getCurrentValue = (0, $5uXOq.useCallback)((name)=>{
            const formState = form.getState();
            return formState?.values[name] || undefined;
        }, [
            form
        ]);
        const FormContextValue = (0, $5uXOq.useMemo)(()=>{
            return {
                registerField: registerField,
                getCurrentValue: getCurrentValue,
                subscribe: form.subscribe
            };
        }, [
            registerField,
            getCurrentValue,
            form.subscribe
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($75a5255a3d60692c$export$c24727297075ec6a.Provider, {
            value: FormContextValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($75a5255a3d60692c$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled
        }, children({
            formProps: {
                onSubmit: handleSubmit,
                ref: formRef,
                onKeyDown: handleKeyDown
            },
            dirty: dirty,
            reset: handleReset,
            submitting: submitting,
            disabled: isDisabled,
            getState: ()=>form.getState(),
            getValues: ()=>form.getState().values,
            setFieldValue: form.change
        })));
    }
});
parcelRegister("lqWDn", function(module, exports) {
    $parcel$export(module.exports, "getIn", ()=>$f9a9822f8af64e2a$export$c52e5867d5879e24);
    $parcel$export(module.exports, "FORM_ERROR", ()=>$f9a9822f8af64e2a$export$97cd7fc25dd32915);
    $parcel$export(module.exports, "fieldSubscriptionItems", ()=>$f9a9822f8af64e2a$export$41e855cb628c1b55);
    $parcel$export(module.exports, "formSubscriptionItems", ()=>$f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3);
    $parcel$export(module.exports, "version", ()=>$f9a9822f8af64e2a$export$83d89fbfd8236492);
    $parcel$export(module.exports, "createForm", ()=>$f9a9822f8af64e2a$export$f681a8129d2e9d28);
    var $bS32t = parcelRequire("bS32t");
    var $ddEsc = parcelRequire("ddEsc");
    var $f9a9822f8af64e2a$var$charCodeOfDot = ".".charCodeAt(0);
    var $f9a9822f8af64e2a$var$reEscapeChar = /\\(\\)?/g;
    var $f9a9822f8af64e2a$var$rePropName = RegExp("[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
    var $f9a9822f8af64e2a$var$stringToPath = function stringToPath(string) {
        var result = [];
        if (string.charCodeAt(0) === $f9a9822f8af64e2a$var$charCodeOfDot) result.push("");
        string.replace($f9a9822f8af64e2a$var$rePropName, function(match, expression, quote, subString) {
            var key = match;
            if (quote) key = subString.replace($f9a9822f8af64e2a$var$reEscapeChar, "$1");
            else if (expression) key = expression.trim();
            result.push(key);
        });
        return result;
    };
    var $f9a9822f8af64e2a$var$keysCache = {};
    var $f9a9822f8af64e2a$var$keysRegex = /[.[\]]+/;
    var $f9a9822f8af64e2a$var$toPath = function toPath(key) {
        if (key === null || key === undefined || !key.length) return [];
        if (typeof key !== "string") throw new Error("toPath() expects a string");
        if ($f9a9822f8af64e2a$var$keysCache[key] == null) {
            if (key.endsWith("[]")) $f9a9822f8af64e2a$var$keysCache[key] = key.split($f9a9822f8af64e2a$var$keysRegex).filter(Boolean);
            else $f9a9822f8af64e2a$var$keysCache[key] = $f9a9822f8af64e2a$var$stringToPath(key);
        }
        return $f9a9822f8af64e2a$var$keysCache[key];
    };
    var $f9a9822f8af64e2a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
        var path = $f9a9822f8af64e2a$var$toPath(complexKey);
        var current = state;
        for(var i = 0; i < path.length; i++){
            var key = path[i];
            if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
            current = current[key];
        }
        return current;
    };
    function $f9a9822f8af64e2a$var$_toPropertyKey(arg) {
        var key = $f9a9822f8af64e2a$var$_toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    function $f9a9822f8af64e2a$var$_toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    var $f9a9822f8af64e2a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
        if (index >= path.length) return value1;
        var key = path[index];
        if (isNaN(key)) {
            var _extends2;
            if (current === undefined || current === null) {
                var _ref;
                var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
                return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
            }
            if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
            var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
            if (_result2 === undefined) {
                var numKeys = Object.keys(current).length;
                if (current[key] === undefined && numKeys === 0) return undefined;
                if (current[key] !== undefined && numKeys <= 1) {
                    if (!isNaN(path[index - 1]) && !destroyArrays) return {};
                    else return undefined;
                }
                current[key];
                var _final = (0, $ddEsc.default)(current, [
                    key
                ].map($f9a9822f8af64e2a$var$_toPropertyKey));
                return _final;
            }
            return (0, $bS32t.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
        }
        var numericKey = Number(key);
        if (current === undefined || current === null) {
            var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            if (_result3 === undefined) return undefined;
            var _array = [];
            _array[numericKey] = _result3;
            return _array;
        }
        if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
        var existingValue = current[numericKey];
        var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
        var array = [].concat(current);
        if (destroyArrays && result === undefined) {
            array.splice(numericKey, 1);
            if (array.length === 0) return undefined;
        } else array[numericKey] = result;
        return array;
    };
    var $f9a9822f8af64e2a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
        if (destroyArrays === void 0) destroyArrays = false;
        if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
        if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
        return $f9a9822f8af64e2a$var$setInRecursor(state, 0, $f9a9822f8af64e2a$var$toPath(key), value1, destroyArrays);
    };
    var $f9a9822f8af64e2a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
    var $f9a9822f8af64e2a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
    function $f9a9822f8af64e2a$var$publishFieldState(formState, field) {
        var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
        var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
        var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(values, name);
        var error = $f9a9822f8af64e2a$export$c52e5867d5879e24(errors, name);
        if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) error = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
        var submitError = submitErrors && $f9a9822f8af64e2a$export$c52e5867d5879e24(submitErrors, name);
        var initial = initialValues && $f9a9822f8af64e2a$export$c52e5867d5879e24(initialValues, name);
        var pristine = field.isEqual(initial, value1);
        var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
        var valid = !error && !submitError;
        return {
            active: active,
            blur: blur,
            change: change,
            data: data,
            dirty: !pristine,
            dirtySinceLastSubmit: dirtySinceLastSubmit,
            error: error,
            focus: focus,
            initial: initial,
            invalid: !valid,
            length: Array.isArray(value1) ? value1.length : undefined,
            modified: modified,
            modifiedSinceLastSubmit: modifiedSinceLastSubmit,
            name: name,
            pristine: pristine,
            submitError: submitError,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            submitting: submitting,
            touched: touched,
            valid: valid,
            value: value1,
            visited: visited,
            validating: validating
        };
    }
    var $f9a9822f8af64e2a$export$41e855cb628c1b55 = [
        "active",
        "data",
        "dirty",
        "dirtySinceLastSubmit",
        "error",
        "initial",
        "invalid",
        "length",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitError",
        "submitFailed",
        "submitSucceeded",
        "submitting",
        "touched",
        "valid",
        "value",
        "visited",
        "validating"
    ];
    var $f9a9822f8af64e2a$var$shallowEqual = function shallowEqual(a, b) {
        if (a === b) return true;
        if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        if (keysA.length !== keysB.length) return false;
        var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
        for(var idx = 0; idx < keysA.length; idx++){
            var key = keysA[idx];
            if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
        }
        return true;
    };
    function $f9a9822f8af64e2a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
        var different = false;
        keys.forEach(function(key) {
            if (subscription[key]) {
                dest[key] = src[key];
                if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f9a9822f8af64e2a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
            }
        });
        return different;
    }
    var $f9a9822f8af64e2a$var$shallowEqualKeys$1 = [
        "data"
    ];
    var $f9a9822f8af64e2a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
        var result = {
            blur: state.blur,
            change: state.change,
            focus: state.focus,
            name: state.name
        };
        var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$41e855cb628c1b55, $f9a9822f8af64e2a$var$shallowEqualKeys$1) || !previousState;
        return different || force ? result : undefined;
    };
    var $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3 = [
        "active",
        "dirty",
        "dirtyFields",
        "dirtyFieldsSinceLastSubmit",
        "dirtySinceLastSubmit",
        "error",
        "errors",
        "hasSubmitErrors",
        "hasValidationErrors",
        "initialValues",
        "invalid",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitting",
        "submitError",
        "submitErrors",
        "submitFailed",
        "submitSucceeded",
        "touched",
        "valid",
        "validating",
        "values",
        "visited"
    ];
    var $f9a9822f8af64e2a$var$shallowEqualKeys = [
        "touched",
        "visited"
    ];
    function $f9a9822f8af64e2a$var$filterFormState(state, previousState, subscription, force) {
        var result = {};
        var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3, $f9a9822f8af64e2a$var$shallowEqualKeys) || !previousState;
        return different || force ? result : undefined;
    }
    var $f9a9822f8af64e2a$var$memoize = function memoize(fn) {
        var lastArgs;
        var lastResult;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
                return !$f9a9822f8af64e2a$var$shallowEqual(lastArgs[index], arg);
            })) {
                lastArgs = args;
                lastResult = fn.apply(void 0, args);
            }
            return lastResult;
        };
    };
    var $f9a9822f8af64e2a$var$isPromise = function(obj) {
        return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
    };
    var $f9a9822f8af64e2a$export$83d89fbfd8236492 = "4.20.10";
    var $f9a9822f8af64e2a$export$480bc304a47a3b09 = [
        "debug",
        "initialValues",
        "keepDirtyOnReinitialize",
        "mutators",
        "onSubmit",
        "validate",
        "validateOnBlur"
    ];
    var $f9a9822f8af64e2a$var$tripleEquals = function tripleEquals(a, b) {
        return a === b;
    };
    var $f9a9822f8af64e2a$var$hasAnyError = function hasAnyError(errors) {
        return Object.keys(errors).some(function(key) {
            var value1 = errors[key];
            if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
            return typeof value1 !== "undefined";
        });
    };
    function $f9a9822f8af64e2a$var$convertToExternalFormState(_ref) {
        var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
        return {
            active: active,
            dirty: !pristine,
            dirtySinceLastSubmit: dirtySinceLastSubmit,
            modifiedSinceLastSubmit: modifiedSinceLastSubmit,
            error: error,
            errors: errors,
            hasSubmitErrors: !!(submitError || submitErrors && $f9a9822f8af64e2a$var$hasAnyError(submitErrors)),
            hasValidationErrors: !!(error || $f9a9822f8af64e2a$var$hasAnyError(errors)),
            invalid: !valid,
            initialValues: initialValues,
            pristine: pristine,
            submitting: submitting,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            submitError: submitError,
            submitErrors: submitErrors,
            valid: valid,
            validating: validating > 0,
            values: values
        };
    }
    function $f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
        var notification = filter(state, lastState, subscription, force);
        if (notification) {
            subscriber(notification);
            return true;
        }
        return false;
    }
    function $f9a9822f8af64e2a$var$notify(_ref2, state, lastState, filter, force) {
        var entries = _ref2.entries;
        Object.keys(entries).forEach(function(key) {
            var entry = entries[Number(key)];
            if (entry) {
                var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
                if ($f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
            }
        });
    }
    function $f9a9822f8af64e2a$export$f681a8129d2e9d28(config) {
        if (!config) throw new Error("No config specified");
        var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
        if (!onSubmit) throw new Error("No onSubmit function specified");
        var state = {
            subscribers: {
                index: 0,
                entries: {}
            },
            fieldSubscribers: {},
            fields: {},
            formState: {
                asyncErrors: {},
                dirtySinceLastSubmit: false,
                modifiedSinceLastSubmit: false,
                errors: {},
                initialValues: initialValues && (0, $bS32t.default)({}, initialValues),
                invalid: false,
                pristine: true,
                submitting: false,
                submitFailed: false,
                submitSucceeded: false,
                resetWhileSubmitting: false,
                valid: true,
                validating: 0,
                values: initialValues ? (0, $bS32t.default)({}, initialValues) : {}
            },
            lastFormState: undefined
        };
        var inBatch = 0;
        var validationPaused = false;
        var validationBlocked = false;
        var preventNotificationWhileValidationPaused = false;
        var nextAsyncValidationKey = 0;
        var asyncValidationPromises = {};
        var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
            return function(result) {
                delete asyncValidationPromises[key];
                return result;
            };
        };
        var changeValue = function changeValue(state, name, mutate) {
            var before = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name);
            var after = mutate(before);
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
        };
        var renameField = function renameField(state, from, to) {
            if (state.fields[from]) {
                var _extends2, _extends3;
                state.fields = (0, $bS32t.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $bS32t.default)({}, state.fields[from], {
                    name: to,
                    blur: function blur() {
                        return api.blur(to);
                    },
                    change: function change(value1) {
                        return api.change(to, value1);
                    },
                    focus: function focus() {
                        return api.focus(to);
                    },
                    lastFieldState: undefined
                }), _extends2));
                delete state.fields[from];
                state.fieldSubscribers = (0, $bS32t.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
                delete state.fieldSubscribers[from];
                var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, from);
                state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
                state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, to, value1);
                delete state.lastFormState;
            }
        };
        var getMutatorApi = function getMutatorApi(key) {
            return function() {
                if (mutators) {
                    var mutatableState = {
                        formState: state.formState,
                        fields: state.fields,
                        fieldSubscribers: state.fieldSubscribers,
                        lastFormState: state.lastFormState
                    };
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var returnValue = mutators[key](args, mutatableState, {
                        changeValue: changeValue,
                        getIn: $f9a9822f8af64e2a$export$c52e5867d5879e24,
                        renameField: renameField,
                        resetFieldState: api.resetFieldState,
                        setIn: $f9a9822f8af64e2a$export$e6bdf135a54e021b,
                        shallowEqual: $f9a9822f8af64e2a$var$shallowEqual
                    });
                    state.formState = mutatableState.formState;
                    state.fields = mutatableState.fields;
                    state.fieldSubscribers = mutatableState.fieldSubscribers;
                    state.lastFormState = mutatableState.lastFormState;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    return returnValue;
                }
            };
        };
        var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
            result[key] = getMutatorApi(key);
            return result;
        }, {}) : {};
        var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
            var promises = [];
            if (validate) {
                var errorsOrPromise = validate((0, $bS32t.default)({}, state.formState.values));
                if ($f9a9822f8af64e2a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                    return setErrors(errors, true);
                }));
                else setErrors(errorsOrPromise, false);
            }
            return promises;
        };
        var getValidators = function getValidators(field) {
            return Object.keys(field.validators).reduce(function(result, index) {
                var validator = field.validators[Number(index)]();
                if (validator) result.push(validator);
                return result;
            }, []);
        };
        var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
            var promises = [];
            var validators = getValidators(field);
            if (validators.length) {
                var error;
                validators.forEach(function(validator) {
                    var errorOrPromise = validator($f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f9a9822f8af64e2a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                    if (errorOrPromise && $f9a9822f8af64e2a$var$isPromise(errorOrPromise)) {
                        field.validating = true;
                        var promise = errorOrPromise.then(function(error) {
                            if (state.fields[field.name]) {
                                state.fields[field.name].validating = false;
                                setError(error);
                            }
                        });
                        promises.push(promise);
                    } else if (!error) error = errorOrPromise;
                });
                setError(error);
            }
            return promises;
        };
        var runValidation = function runValidation(fieldChanged, callback) {
            if (validationPaused) {
                validationBlocked = true;
                callback();
                return;
            }
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var fieldKeys = Object.keys(safeFields);
            if (!validate && !fieldKeys.some(function(key) {
                return getValidators(safeFields[key]).length;
            })) {
                callback();
                return;
            }
            var limitedFieldLevelValidation = false;
            if (fieldChanged) {
                var changedField = safeFields[fieldChanged];
                if (changedField) {
                    var validateFields = changedField.validateFields;
                    if (validateFields) {
                        limitedFieldLevelValidation = true;
                        fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                            fieldChanged
                        ];
                    }
                }
            }
            var recordLevelErrors = {};
            var asyncRecordLevelErrors = {};
            var fieldLevelErrors = {};
            var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
                if (wasAsync) asyncRecordLevelErrors = errors || {};
                else recordLevelErrors = errors || {};
            }), fieldKeys.reduce(function(result, name) {
                return result.concat(runFieldLevelValidation(fields[name], function(error) {
                    fieldLevelErrors[name] = error;
                }));
            }, []));
            var hasAsyncValidations = promises.length > 0;
            var asyncValidationPromiseKey = ++nextAsyncValidationKey;
            var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
            if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
            var processErrors = function processErrors(afterAsync) {
                var merged = (0, $bS32t.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors : formState.asyncErrors);
                var forEachError = function forEachError(fn) {
                    fieldKeys.forEach(function(name) {
                        if (fields[name]) {
                            var recordLevelError = $f9a9822f8af64e2a$export$c52e5867d5879e24(recordLevelErrors, name);
                            var errorFromParent = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                            var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                            var fieldLevelError = fieldLevelErrors[name];
                            fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                        }
                    });
                };
                forEachError(function(name, error) {
                    merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, error) || {};
                });
                forEachError(function(name, error) {
                    if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) {
                        var existing = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                        var copy = [].concat(existing);
                        copy[$f9a9822f8af64e2a$export$735bebc8ffabf28a] = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
                        merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, copy);
                    }
                });
                if (!$f9a9822f8af64e2a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
                if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
                formState.error = recordLevelErrors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
            };
            if (hasAsyncValidations) {
                state.formState.validating++;
                callback();
            }
            processErrors(false);
            callback();
            if (hasAsyncValidations) {
                var afterPromise = function afterPromise() {
                    state.formState.validating--;
                    callback();
                    if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
                };
                promise.then(function() {
                    if (nextAsyncValidationKey > asyncValidationPromiseKey) return;
                    processErrors(true);
                }).then(afterPromise, afterPromise);
            }
        };
        var notifyFieldListeners = function notifyFieldListeners(name) {
            if (inBatch) return;
            var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var notifyField = function notifyField(name) {
                var field = safeFields[name];
                var fieldState = $f9a9822f8af64e2a$var$publishFieldState(formState, field);
                var lastFieldState = field.lastFieldState;
                field.lastFieldState = fieldState;
                var fieldSubscriber = fieldSubscribers[name];
                if (fieldSubscriber) $f9a9822f8af64e2a$var$notify(fieldSubscriber, fieldState, lastFieldState, $f9a9822f8af64e2a$var$filterFieldState, lastFieldState === undefined);
            };
            if (name) notifyField(name);
            else Object.keys(safeFields).forEach(notifyField);
        };
        var markAllFieldsTouched = function markAllFieldsTouched() {
            Object.keys(state.fields).forEach(function(key) {
                state.fields[key].touched = true;
            });
        };
        var hasSyncErrors = function hasSyncErrors() {
            return !!(state.formState.error || $f9a9822f8af64e2a$var$hasAnyError(state.formState.errors));
        };
        var calculateNextFormState = function calculateNextFormState() {
            var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var safeFieldKeys = Object.keys(safeFields);
            var foundDirty = false;
            var dirtyFields = safeFieldKeys.reduce(function(result, key) {
                var dirty = !safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (dirty) {
                    foundDirty = true;
                    result[key] = true;
                }
                return result;
            }, {});
            var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
                var nonNullLastSubmittedValues = formState.lastSubmittedValues || {};
                if (!safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
                return result;
            }, {});
            formState.pristine = !foundDirty;
            formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
                return value1;
            }));
            formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && Object.keys(safeFields).some(function(value1) {
                return safeFields[value1].modifiedSinceLastSubmit;
            }));
            formState.valid = !formState.error && !formState.submitError && !$f9a9822f8af64e2a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f9a9822f8af64e2a$var$hasAnyError(formState.submitErrors));
            var nextFormState = $f9a9822f8af64e2a$var$convertToExternalFormState(formState);
            var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
                result.modified[key] = safeFields[key].modified;
                result.touched[key] = safeFields[key].touched;
                result.visited[key] = safeFields[key].visited;
                return result;
            }, {
                modified: {},
                touched: {},
                visited: {}
            }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
            nextFormState.dirtyFields = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
            nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
            nextFormState.modified = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
            nextFormState.touched = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
            nextFormState.visited = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
            return lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
        };
        var callDebug = function callDebug() {
            return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
                result[key] = state.fields[key];
                return result;
            }, {}));
        };
        var notifying = false;
        var scheduleNotification = false;
        var notifyFormListeners = function notifyFormListeners() {
            if (notifying) scheduleNotification = true;
            else {
                notifying = true;
                callDebug();
                if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                    var lastFormState = state.lastFormState;
                    var nextFormState = calculateNextFormState();
                    if (nextFormState !== lastFormState) {
                        state.lastFormState = nextFormState;
                        $f9a9822f8af64e2a$var$notify(state.subscribers, nextFormState, lastFormState, $f9a9822f8af64e2a$var$filterFormState);
                    }
                }
                notifying = false;
                if (scheduleNotification) {
                    scheduleNotification = false;
                    notifyFormListeners();
                }
            }
        };
        var beforeSubmit = function beforeSubmit() {
            return Object.keys(state.fields).some(function(name) {
                return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
            });
        };
        var afterSubmit = function afterSubmit() {
            return Object.keys(state.fields).forEach(function(name) {
                return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
            });
        };
        var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
            return Object.keys(state.fields).forEach(function(key) {
                return state.fields[key].modifiedSinceLastSubmit = false;
            });
        };
        runValidation(undefined, function() {
            notifyFormListeners();
        });
        var api = {
            batch: function batch(fn) {
                inBatch++;
                fn();
                inBatch--;
                notifyFieldListeners();
                notifyFormListeners();
            },
            blur: function blur(name) {
                var fields = state.fields, formState = state.formState;
                var previous = fields[name];
                if (previous) {
                    delete formState.active;
                    fields[name] = (0, $bS32t.default)({}, previous, {
                        active: false,
                        touched: true
                    });
                    if (validateOnBlur) runValidation(name, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    else {
                        notifyFieldListeners();
                        notifyFormListeners();
                    }
                }
            },
            change: function change(name, value1) {
                var fields = state.fields, formState = state.formState;
                if ($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                    changeValue(state, name, function() {
                        return value1;
                    });
                    var previous = fields[name];
                    if (previous) fields[name] = (0, $bS32t.default)({}, previous, {
                        modified: true,
                        modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                    });
                    if (validateOnBlur) {
                        notifyFieldListeners();
                        notifyFormListeners();
                    } else runValidation(name, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                }
            },
            get destroyOnUnregister () {
                return !!destroyOnUnregister;
            },
            set destroyOnUnregister (value){
                destroyOnUnregister = value;
            },
            focus: function focus(name) {
                var field = state.fields[name];
                if (field && !field.active) {
                    state.formState.active = name;
                    field.active = true;
                    field.visited = true;
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            },
            mutators: mutatorsApi,
            getFieldState: function getFieldState(name) {
                var field = state.fields[name];
                return field && field.lastFieldState;
            },
            getRegisteredFields: function getRegisteredFields() {
                return Object.keys(state.fields);
            },
            getState: function getState() {
                return calculateNextFormState();
            },
            initialize: function initialize(data) {
                var fields = state.fields, formState = state.formState;
                var safeFields = (0, $bS32t.default)({}, fields);
                var values = typeof data === "function" ? data(formState.values) : data;
                if (!keepDirtyOnReinitialize) formState.values = values;
                var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                    var field = safeFields[key];
                    var pristine = field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                    if (!pristine) result[key] = $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key);
                    return result;
                }, {}) : {};
                formState.initialValues = values;
                formState.values = values;
                Object.keys(savedDirtyValues).forEach(function(key) {
                    formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
                });
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            },
            isValidationPaused: function isValidationPaused() {
                return validationPaused;
            },
            pauseValidation: function pauseValidation(preventNotification) {
                if (preventNotification === void 0) preventNotification = true;
                validationPaused = true;
                preventNotificationWhileValidationPaused = preventNotification;
            },
            registerField: function registerField(name, subscriber, subscription, fieldConfig) {
                if (subscription === void 0) subscription = {};
                if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                    index: 0,
                    entries: {}
                };
                var index = state.fieldSubscribers[name].index++;
                state.fieldSubscribers[name].entries[index] = {
                    subscriber: $f9a9822f8af64e2a$var$memoize(subscriber),
                    subscription: subscription,
                    notified: false
                };
                var field = state.fields[name] || {
                    active: false,
                    afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                    beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                    data: fieldConfig && fieldConfig.data || {},
                    isEqual: fieldConfig && fieldConfig.isEqual || $f9a9822f8af64e2a$var$tripleEquals,
                    lastFieldState: undefined,
                    modified: false,
                    modifiedSinceLastSubmit: false,
                    name: name,
                    touched: false,
                    valid: true,
                    validateFields: fieldConfig && fieldConfig.validateFields,
                    validators: {},
                    validating: false,
                    visited: false
                };
                field.blur = field.blur || function() {
                    return api.blur(name);
                };
                field.change = field.change || function(value1) {
                    return api.change(name, value1);
                };
                field.focus = field.focus || function() {
                    return api.focus(name);
                };
                state.fields[name] = field;
                var haveValidator = false;
                var silent = fieldConfig && fieldConfig.silent;
                var notify = function notify() {
                    if (silent && state.fields[name]) notifyFieldListeners(name);
                    else {
                        notifyFormListeners();
                        notifyFieldListeners();
                    }
                };
                if (fieldConfig) {
                    haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                    if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                    var noValueInFormState = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                    if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                        state.formState.initialValues = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                        state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                        runValidation(undefined, notify);
                    }
                    if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
                }
                if (haveValidator) runValidation(undefined, notify);
                else notify();
                return function() {
                    var validatorRemoved = false;
                    if (state.fields[name]) {
                        validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                        delete state.fields[name].validators[index];
                    }
                    var hasFieldSubscribers = !!state.fieldSubscribers[name];
                    if (hasFieldSubscribers) delete state.fieldSubscribers[name].entries[index];
                    var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                    if (lastOne) {
                        delete state.fieldSubscribers[name];
                        delete state.fields[name];
                        if (validatorRemoved) state.formState.errors = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                        if (destroyOnUnregister) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                    }
                    if (!silent) {
                        if (validatorRemoved) runValidation(undefined, function() {
                            notifyFormListeners();
                            notifyFieldListeners();
                        });
                        else if (lastOne) notifyFormListeners();
                    }
                };
            },
            reset: function reset(initialValues) {
                if (initialValues === void 0) initialValues = state.formState.initialValues;
                if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
                state.formState.submitFailed = false;
                state.formState.submitSucceeded = false;
                delete state.formState.submitError;
                delete state.formState.submitErrors;
                delete state.formState.lastSubmittedValues;
                api.initialize(initialValues || {});
            },
            resetFieldState: function resetFieldState(name) {
                state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                    active: false,
                    lastFieldState: undefined,
                    modified: false,
                    touched: false,
                    valid: true,
                    validating: false,
                    visited: false
                });
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            },
            restart: function restart(initialValues) {
                if (initialValues === void 0) initialValues = state.formState.initialValues;
                api.batch(function() {
                    for(var name in state.fields){
                        api.resetFieldState(name);
                        state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                            active: false,
                            lastFieldState: undefined,
                            modified: false,
                            modifiedSinceLastSubmit: false,
                            touched: false,
                            valid: true,
                            validating: false,
                            visited: false
                        });
                    }
                    api.reset(initialValues);
                });
            },
            resumeValidation: function resumeValidation() {
                validationPaused = false;
                preventNotificationWhileValidationPaused = false;
                if (validationBlocked) runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                validationBlocked = false;
            },
            setConfig: function setConfig(name, value1) {
                switch(name){
                    case "debug":
                        debug = value1;
                        break;
                    case "destroyOnUnregister":
                        destroyOnUnregister = value1;
                        break;
                    case "initialValues":
                        api.initialize(value1);
                        break;
                    case "keepDirtyOnReinitialize":
                        keepDirtyOnReinitialize = value1;
                        break;
                    case "mutators":
                        mutators = value1;
                        if (value1) {
                            Object.keys(mutatorsApi).forEach(function(key) {
                                if (!(key in value1)) delete mutatorsApi[key];
                            });
                            Object.keys(value1).forEach(function(key) {
                                mutatorsApi[key] = getMutatorApi(key);
                            });
                        } else Object.keys(mutatorsApi).forEach(function(key) {
                            delete mutatorsApi[key];
                        });
                        break;
                    case "onSubmit":
                        onSubmit = value1;
                        break;
                    case "validate":
                        validate = value1;
                        runValidation(undefined, function() {
                            notifyFieldListeners();
                            notifyFormListeners();
                        });
                        break;
                    case "validateOnBlur":
                        validateOnBlur = value1;
                        break;
                    default:
                        throw new Error("Unrecognised option " + name);
                }
            },
            submit: function submit() {
                var formState = state.formState;
                if (formState.submitting) return;
                delete formState.submitErrors;
                delete formState.submitError;
                formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
                if (hasSyncErrors()) {
                    markAllFieldsTouched();
                    resetModifiedAfterSubmit();
                    state.formState.submitFailed = true;
                    notifyFormListeners();
                    notifyFieldListeners();
                    return;
                }
                var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
                if (asyncValidationPromisesKeys.length) {
                    Promise.all(asyncValidationPromisesKeys.map(function(key) {
                        return asyncValidationPromises[Number(key)];
                    })).then(api.submit, console.error);
                    return;
                }
                var submitIsBlocked = beforeSubmit();
                if (submitIsBlocked) return;
                var resolvePromise;
                var completeCalled = false;
                var complete = function complete(errors) {
                    formState.submitting = false;
                    var resetWhileSubmitting = formState.resetWhileSubmitting;
                    if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                    if (errors && $f9a9822f8af64e2a$var$hasAnyError(errors)) {
                        formState.submitFailed = true;
                        formState.submitSucceeded = false;
                        formState.submitErrors = errors;
                        formState.submitError = errors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
                        markAllFieldsTouched();
                    } else {
                        if (!resetWhileSubmitting) {
                            formState.submitFailed = false;
                            formState.submitSucceeded = true;
                        }
                        afterSubmit();
                    }
                    notifyFormListeners();
                    notifyFieldListeners();
                    completeCalled = true;
                    if (resolvePromise) resolvePromise(errors);
                    return errors;
                };
                formState.submitting = true;
                formState.submitFailed = false;
                formState.submitSucceeded = false;
                formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
                resetModifiedAfterSubmit();
                var result = onSubmit(formState.values, api, complete);
                if (!completeCalled) {
                    if (result && $f9a9822f8af64e2a$var$isPromise(result)) {
                        notifyFormListeners();
                        notifyFieldListeners();
                        return result.then(complete, function(error) {
                            complete();
                            throw error;
                        });
                    } else if (onSubmit.length >= 3) {
                        notifyFormListeners();
                        notifyFieldListeners();
                        return new Promise(function(resolve) {
                            resolvePromise = resolve;
                        });
                    } else complete(result);
                }
            },
            subscribe: function subscribe(subscriber, subscription) {
                if (!subscriber) throw new Error("No callback given.");
                if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
                var memoized = $f9a9822f8af64e2a$var$memoize(subscriber);
                var subscribers = state.subscribers;
                var index = subscribers.index++;
                subscribers.entries[index] = {
                    subscriber: memoized,
                    subscription: subscription,
                    notified: false
                };
                var nextFormState = calculateNextFormState();
                $f9a9822f8af64e2a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f9a9822f8af64e2a$var$filterFormState, true);
                return function() {
                    delete subscribers.entries[index];
                };
            }
        };
        return api;
    }
});
parcelRegister("8tHJX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62c2f612c5adb35a$export$2e2bcd8739ae039);
    var $lqWDn = parcelRequire("lqWDn");
    var $62c2f612c5adb35a$var$isFocusableInput = function isFocusableInput(wtf) {
        return !!(wtf && typeof wtf.focus === 'function');
    };
    var $62c2f612c5adb35a$var$getAllInputs = function getAllInputs() {
        if (typeof document === 'undefined') return [];
        return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
            return accumulator.concat(Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput));
        }, []);
    };
    var $62c2f612c5adb35a$var$findInput = function findInput(inputs, errors) {
        return inputs.find(function(input) {
            return input.name && (0, $lqWDn.getIn)(errors, input.name);
        });
    };
    var $62c2f612c5adb35a$var$noop = function noop() {};
    var $62c2f612c5adb35a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
        return function(form) {
            var focusOnFirstError = function focusOnFirstError(errors) {
                if (!getInputs) getInputs = $62c2f612c5adb35a$var$getAllInputs;
                if (!findInput$$1) findInput$$1 = $62c2f612c5adb35a$var$findInput;
                var firstInput = findInput$$1(getInputs(), errors);
                if (firstInput) firstInput.focus();
            };
            var originalSubmit = form.submit;
            var state = {};
            var unsubscribe = form.subscribe(function(nextState) {
                state = nextState;
            }, {
                errors: true,
                submitErrors: true
            });
            var afterSubmit = function afterSubmit() {
                var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
                if (errors && Object.keys(errors).length) focusOnFirstError(errors);
                else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
            };
            form.submit = function() {
                var result = originalSubmit.call(form);
                if (result && typeof result.then === 'function') result.then(afterSubmit, $62c2f612c5adb35a$var$noop);
                else afterSubmit();
                return result;
            };
            return function() {
                unsubscribe();
                form.submit = originalSubmit;
            };
        };
    };
    var $62c2f612c5adb35a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
        return function() {
            if (typeof document === 'undefined') return [];
            var form = document.forms[name];
            return form && form.length ? Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput) : [];
        };
    };
    var $62c2f612c5adb35a$export$2e2bcd8739ae039 = $62c2f612c5adb35a$var$createDecorator;
});
parcelRegister("gZL7V", function(module, exports) {
    var $ajB7H = parcelRequire("ajB7H");
    function $c5f6e64373be0bfc$var$set(object, path, value) {
        return object == null ? object : $ajB7H(object, path, value);
    }
    module.exports = $c5f6e64373be0bfc$var$set;
});
parcelRegister("7VnW8", function(module, exports) {
    $parcel$export(module.exports, "Label", ()=>$bc5fcc4d894aeca1$export$b04be29aa201d4f5);
    $parcel$export(module.exports, "Legend", ()=>$bc5fcc4d894aeca1$export$ed247974535929c7);
    var $f8Sb3;
    function $bc5fcc4d894aeca1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $bc5fcc4d894aeca1$var$fieldsetLabelStyles = {
        name: "zjewl9",
        styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
    };
    const $bc5fcc4d894aeca1$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            css: $bc5fcc4d894aeca1$var$fieldsetLabelStyles,
            id: id,
            htmlFor: htmlFor,
            "data-testid": testId
        }, children);
    const $bc5fcc4d894aeca1$export$ed247974535929c7 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("legend", {
            css: $bc5fcc4d894aeca1$var$fieldsetLabelStyles
        }, children);
    };
    var $bc5fcc4d894aeca1$export$2e2bcd8739ae039 = $bc5fcc4d894aeca1$export$b04be29aa201d4f5;
});
parcelRegister("8knNZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d3fe143ced70112a$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $d3fe143ced70112a$var$requiredIndicatorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-danger, ${(0, $72ba03e317f3d228$export$2010d0fb4295b346)})`,
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        paddingInlineStart: "var(--ds-space-025, 2px)"
    });
    function $d3fe143ced70112a$export$2e2bcd8739ae039() {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $d3fe143ced70112a$var$requiredIndicatorStyles,
            "aria-hidden": "true",
            title: "required"
        }, "*");
    }
});
parcelRegister("6Y6uy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9e2c7658229f720c$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $9jNMw;
    var $l8dDZ;
    var $i6qxo;
    function $9e2c7658229f720c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $9e2c7658229f720c$var$buttonsContainerStyles = {
        name: "ki22df",
        styles: "display:flex;position:absolute;flex-shrink:0;inset-block-start:100%;inset-inline-end:0;margin-block-start:var(--ds-space-075, 6px)"
    };
    const $9e2c7658229f720c$var$buttonWrapperBaseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        boxSizing: 'border-box',
        width: "var(--ds-space-400, 32px)",
        zIndex: 200,
        backgroundColor: `var(--ds-surface-overlay, ${(0, $72ba03e317f3d228$export$29a4f05edc054374)})`,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $72ba03e317f3d228$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $72ba03e317f3d228$export$d2d3bedfb276cac0)}`})`,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        '&:last-child': {
            marginInlineStart: "var(--ds-space-050, 4px)"
        },
        '& > button': {
            backgroundColor: `var(--ds-surface-overlay, ${(0, $72ba03e317f3d228$export$8d43898f60b96a82)})`
        },
        '& > button:hover': {
            backgroundColor: `var(--ds-surface-overlay-hovered, ${(0, $72ba03e317f3d228$export$920c0d5c49070351)})`
        },
        '& > button:active': {
            backgroundColor: "var(--ds-surface-overlay-pressed, rgba(179, 212, 255, 0.6))",
            color: `var(--ds-text, ${(0, $72ba03e317f3d228$export$b3de0ae08da2ce64)})`
        }
    });
    const $9e2c7658229f720c$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $9e2c7658229f720c$var$buttonsContainerStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $9e2c7658229f720c$var$buttonWrapperBaseStyles,
            tabIndex: -1
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9jNMw")).default), {
            type: "submit",
            icon: (iconProps)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("l8dDZ"))))), {
                    ...iconProps,
                    size: "small"
                }),
            onMouseDown: onMouseDown,
            label: confirmButtonLabel,
            testId: testId && `${testId}--confirm`
        })), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $9e2c7658229f720c$var$buttonWrapperBaseStyles,
            tabIndex: -1
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9jNMw")).default), {
            icon: (iconProps)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("i6qxo"))))), {
                    ...iconProps,
                    size: "small"
                }),
            label: cancelButtonLabel,
            onClick: onCancelClick,
            onMouseDown: onMouseDown,
            testId: testId && `${testId}--cancel`
        })));
    };
    var $9e2c7658229f720c$export$2e2bcd8739ae039 = $9e2c7658229f720c$var$Buttons;
});
parcelRegister("l8dDZ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f624edc1f9ce8020$var$_react = $f624edc1f9ce8020$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $f624edc1f9ce8020$var$_checkMark = $f624edc1f9ce8020$var$_interopRequireDefault((parcelRequire("bZUh6")));
    function $f624edc1f9ce8020$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f624edc1f9ce8020$var$CheckIcon = (props)=>$f624edc1f9ce8020$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
        }, props, {
            newIcon: $f624edc1f9ce8020$var$_checkMark.default
        }));
    $f624edc1f9ce8020$var$CheckIcon.displayName = 'CheckIcon';
    var $f624edc1f9ce8020$var$_default = module.exports.default = $f624edc1f9ce8020$var$CheckIcon;
});
parcelRegister("fWhPX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c18a1a65199d3f45$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $c18a1a65199d3f45$var$usePrevious = (value)=>{
        const ref = (0, $5uXOq.useRef)();
        (0, $5uXOq.useEffect)(()=>{
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    };
    const $c18a1a65199d3f45$var$useButtonFocusHook = (isEditing, isEditingState)=>{
        const editButtonRef = (0, $5uXOq.useRef)(null);
        const editViewRef = (0, $5uXOq.useRef)();
        const preventFocusOnEditButtonRef = (0, $5uXOq.useRef)(false);
        const isControlled = typeof isEditing === 'undefined';
        const shouldBeEditing = isControlled ? isEditingState : isEditing;
        const prevIsEditing = $c18a1a65199d3f45$var$usePrevious(shouldBeEditing);
        (0, $5uXOq.useEffect)(()=>{
            if (isEditingState && editViewRef.current) editViewRef.current.focus();
        }, [
            editViewRef,
            isEditingState
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (prevIsEditing && !shouldBeEditing) {
                if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
                else if (editButtonRef && editButtonRef.current) editButtonRef.current.focus();
            }
        }, [
            prevIsEditing,
            shouldBeEditing
        ]);
        const doNotFocusOnEditButton = ()=>preventFocusOnEditButtonRef.current = true;
        return {
            editButtonRef: editButtonRef,
            editViewRef: editViewRef,
            shouldBeEditing: shouldBeEditing,
            doNotFocusOnEditButton: doNotFocusOnEditButton
        };
    };
    var $c18a1a65199d3f45$export$2e2bcd8739ae039 = $c18a1a65199d3f45$var$useButtonFocusHook;
});
parcelRegister("74fNf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$089ec22991b1b165$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $a95o8;
    var $99gde;
    function $089ec22991b1b165$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $089ec22991b1b165$var$readViewContainerStyles = {
        name: "1xe63ku",
        styles: "line-height:1"
    };
    const $089ec22991b1b165$var$editButtonStyles = (0, (0, parcelRequire("99gde")).xcss)({
        display: 'block',
        margin: 'space.0',
        padding: 'space.0',
        appearance: 'none',
        background: 'transparent',
        border: 0,
        lineHeight: 1,
        outline: 0,
        ':focus-visible': {
            outline: 0
        },
        ':focus + div': {
            borderColor: 'color.border.focused',
            borderWidth: 'border.width.outline',
            borderStyle: 'solid'
        }
    });
    const $089ec22991b1b165$var$readViewWrapperStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-block',
        boxSizing: 'border-box',
        width: 'auto',
        maxWidth: '100%',
        border: '2px solid transparent',
        borderRadius: "var(--ds-border-radius, 3px)",
        transition: 'background 0.2s',
        '&:hover': {
            background: `var(--ds-background-neutral-subtle-hovered, ${(0, $72ba03e317f3d228$export$3e51e8f1440314ba)})`
        }
    });
    const $089ec22991b1b165$var$readViewFitContainerWidthStyles = {
        name: "1d3w5wq",
        styles: "width:100%"
    };
    const $089ec22991b1b165$var$DRAG_THRESHOLD = 5;
    const $089ec22991b1b165$var$ReadView = ({ editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId })=>{
        const startX = (0, $5uXOq.useRef)(0);
        const startY = (0, $5uXOq.useRef)(0);
        const mouseHasMovedAfterMouseDown = (event)=>{
            return Math.abs(startX.current - event.clientX) >= $089ec22991b1b165$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $089ec22991b1b165$var$DRAG_THRESHOLD;
        };
        const onReadViewClick = (event)=>{
            const element = event.target;
            if (element.tagName.toLowerCase() !== 'a' && !mouseHasMovedAfterMouseDown(event)) {
                event.preventDefault();
                onEditRequested();
                postReadViewClick();
            }
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $089ec22991b1b165$var$readViewContainerStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("a95o8")).default), {
            xcss: $089ec22991b1b165$var$editButtonStyles,
            onClick: onEditRequested,
            ref: editButtonRef,
            testId: testId && `${testId}--edit-button`,
            "aria-label": editButtonLabel
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $089ec22991b1b165$var$readViewWrapperStyles,
                readViewFitContainerWidth && $089ec22991b1b165$var$readViewFitContainerWidthStyles
            ],
            role: "presentation",
            onClick: onReadViewClick,
            onMouseDown: (e)=>{
                startX.current = e.clientX;
                startY.current = e.clientY;
            },
            "data-read-view-fit-container-width": readViewFitContainerWidth
        }, readView()));
    };
    var $089ec22991b1b165$export$2e2bcd8739ae039 = $089ec22991b1b165$var$ReadView;
});
parcelRegister("8mGGj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$af711023521e2d75$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2cjvv;
    var $9EfCw;
    const $af711023521e2d75$var$analyticsParams = {
        componentName: 'textField',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $af711023521e2d75$var$Textfield = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
        const inputRef = (0, $5uXOq.useRef)(null);
        const handleOnFocus = (0, (0, parcelRequire("2cjvv")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onFocus && onFocus(event);
            },
            action: 'focused',
            ...$af711023521e2d75$var$analyticsParams
        });
        const handleOnBlur = (0, (0, parcelRequire("2cjvv")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: 'blurred',
            ...$af711023521e2d75$var$analyticsParams
        });
        const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
            const target = event.target;
            if (target.tagName !== 'INPUT') event.preventDefault();
            if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
            onMouseDown && onMouseDown(event);
        }, [
            onMouseDown,
            isDisabled
        ]);
        const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
            inputRef.current = inputElement;
            if (!ref) return;
            if (typeof ref === 'object') ref.current = inputElement;
            if (typeof ref === 'function') ref(inputElement);
        }, [
            ref
        ]);
        const containerStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("9EfCw")).containerStyles)(appearance, width), [
            appearance,
            width
        ]);
        const inputStyle = (0, (0, parcelRequire("9EfCw")).inputStyles)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "presentation",
            "data-disabled": isDisabled ? isDisabled : undefined,
            "data-invalid": isInvalid ? isInvalid : undefined,
            "data-ds--text-field--container": true,
            "data-testid": testId && `${testId}-container`,
            onMouseDown: handleOnMouseDown,
            css: containerStyles,
            className: className
        }, elemBeforeInput, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ...spreadProps,
            "aria-invalid": isInvalid ? isInvalid : undefined,
            css: inputStyle,
            "data-compact": isCompact ? isCompact : undefined,
            "data-ds--text-field--input": true,
            "data-monospaced": isMonospaced ? isMonospaced : undefined,
            "data-testid": testId,
            disabled: isDisabled,
            name: name,
            onBlur: handleOnBlur,
            onChange: onChange,
            onFocus: handleOnFocus,
            placeholder: placeholder,
            readOnly: isReadOnly,
            ref: setInputRef,
            required: isRequired
        }), elemAfterInput));
    });
    var $af711023521e2d75$export$2e2bcd8739ae039 = $af711023521e2d75$var$Textfield;
});
parcelRegister("9EfCw", function(module, exports) {
    $parcel$export(module.exports, "containerStyles", ()=>$a7502c1f5abf97ed$export$5972a68b6e54f38f);
    $parcel$export(module.exports, "inputStyles", ()=>$a7502c1f5abf97ed$export$3eeb47dc8e6249d9);
    const $a7502c1f5abf97ed$var$backgroundColor = {
        standard: `var(--ds-background-input, ${(0, $72ba03e317f3d228$export$e655ef011c4aa1a2)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $a7502c1f5abf97ed$var$backgroundColorFocus = {
        standard: `var(--ds-background-input-pressed, ${(0, $72ba03e317f3d228$export$29a4f05edc054374)})`,
        subtle: `var(--ds-background-input-pressed, ${(0, $72ba03e317f3d228$export$29a4f05edc054374)})`,
        none: 'transparent'
    };
    const $a7502c1f5abf97ed$var$backgroundColorHover = {
        standard: `var(--ds-background-input-hovered, ${(0, $72ba03e317f3d228$export$3e51e8f1440314ba)})`,
        subtle: `var(--ds-background-input-hovered, ${(0, $72ba03e317f3d228$export$3e51e8f1440314ba)})`,
        none: 'transparent'
    };
    const $a7502c1f5abf97ed$var$borderColor = {
        standard: `var(--ds-border-input, ${(0, $72ba03e317f3d228$export$d6447c357493214f)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $a7502c1f5abf97ed$var$borderColorFocus = {
        standard: `var(--ds-border-focused, ${(0, $72ba03e317f3d228$export$215b7063051591f1)})`,
        subtle: `var(--ds-border-focused, ${(0, $72ba03e317f3d228$export$215b7063051591f1)})`,
        none: 'transparent'
    };
    const $a7502c1f5abf97ed$var$borderColorHover = {
        standard: `var(--ds-border-input, ${(0, $72ba03e317f3d228$export$d6447c357493214f)})`,
        subtle: "var(--ds-border-input, transparent)",
        none: 'transparent'
    };
    const $a7502c1f5abf97ed$var$getContainerTextBgAndBorderColor = (appearance)=>({
            backgroundColor: $a7502c1f5abf97ed$var$backgroundColor[appearance],
            borderColor: $a7502c1f5abf97ed$var$borderColor[appearance],
            color: `var(--ds-text, ${0, $72ba03e317f3d228$export$fbda843f0a27fe96})`,
            cursor: 'text',
            '&:hover:not([data-disabled])': {
                backgroundColor: $a7502c1f5abf97ed$var$backgroundColorHover[appearance],
                borderColor: $a7502c1f5abf97ed$var$borderColorHover[appearance]
            },
            '&:focus-within:not([data-disabled])': {
                backgroundColor: $a7502c1f5abf97ed$var$backgroundColorFocus[appearance],
                borderColor: $a7502c1f5abf97ed$var$borderColorFocus[appearance],
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$a7502c1f5abf97ed$var$borderColorFocus[appearance]}`
            },
            '&[data-disabled]': {
                color: `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})`,
                cursor: 'not-allowed',
                ...appearance === 'standard' && {
                    backgroundColor: `var(--ds-background-disabled, ${0, $72ba03e317f3d228$export$e655ef011c4aa1a2})`,
                    borderColor: `var(--ds-background-disabled, ${0, $72ba03e317f3d228$export$e655ef011c4aa1a2})`
                }
            },
            '&[data-invalid], &[data-invalid]:hover': {
                borderColor: `var(--ds-border-danger, ${0, $72ba03e317f3d228$export$2010d0fb4295b346})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $72ba03e317f3d228$export$2010d0fb4295b346})`}`
            },
            '&[data-invalid]:focus-within': {
                backgroundColor: `var(--ds-background-input-pressed, ${0, $72ba03e317f3d228$export$29a4f05edc054374})`,
                borderColor: `var(--ds-border-focused, ${0, $72ba03e317f3d228$export$215b7063051591f1})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $72ba03e317f3d228$export$215b7063051591f1})`}`
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[data-invalid]:focus-within': {
                    borderColor: 'Highlight'
                },
                '&:focus-within': {
                    borderColor: 'Highlight'
                },
                '&[data-disabled]': {
                    borderColor: 'GrayText'
                }
            }
        });
    const $a7502c1f5abf97ed$var$widthMap = {
        xsmall: 80,
        small: 160,
        medium: 240,
        large: 320,
        xlarge: 480
    };
    const $a7502c1f5abf97ed$var$getMaxWidth = (width)=>!width ? `100%` : width in $a7502c1f5abf97ed$var$widthMap ? $a7502c1f5abf97ed$var$widthMap[width] : +width;
    const $a7502c1f5abf97ed$export$5972a68b6e54f38f = (appearance, width)=>({
            alignItems: 'center',
            ...$a7502c1f5abf97ed$var$getContainerTextBgAndBorderColor(appearance),
            borderRadius: 3,
            borderWidth: "var(--ds-border-width, 1px)",
            ...appearance !== 'none' ? {
                padding: `${"var(--ds-border-width, 1px)"} 0`
            } : {},
            borderStyle: appearance === 'none' ? 'none' : 'solid',
            boxSizing: 'border-box',
            display: 'flex',
            flex: '1 1 100%',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            justifyContent: 'space-between',
            maxWidth: $a7502c1f5abf97ed$var$getMaxWidth(width),
            overflow: 'hidden',
            transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
            wordWrap: 'break-word',
            verticalAlign: 'top',
            pointerEvents: 'auto'
        });
    const $a7502c1f5abf97ed$export$3eeb47dc8e6249d9 = ()=>({
            backgroundColor: 'transparent',
            border: 0,
            boxSizing: 'border-box',
            color: 'inherit',
            cursor: 'inherit',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            minWidth: '0',
            outline: 'none',
            width: '100%',
            '&[data-monospaced]': {
                fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
            },
            '&[data-compact]': {
                padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&:not([data-compact])': {
                padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&[disabled]': {
                WebkitTextFillColor: `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})`
            },
            '&::-ms-clear': {
                display: 'none'
            },
            '&:invalid': {
                boxShadow: 'none'
            },
            '&:placeholder-shown': {
                textOverflow: 'ellipsis'
            },
            '&::placeholder': {
                color: `var(--ds-text-subtlest, ${0, $72ba03e317f3d228$export$f563ee71e9ee74cd})`,
                '&:disabled': {
                    color: `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})`
                }
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[disabled]': {
                    color: 'GrayText'
                }
            }
        });
});
parcelRegister("SKokA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$550aadc1baf0633a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $550aadc1baf0633a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        editActionLabel: {
            "id": "business-summary.common.inline-rename-field.edit-action-label",
            "defaultMessage": "edit name"
        }
    });
});
parcelRegister("34f85", function(module, exports) {
    $parcel$export(module.exports, "useRenameStatusInline", ()=>$162727f679e8015c$export$a579ec74e28b4eb9);
    var $5uXOq = parcelRequire("5uXOq");
    var $5cFkk;
    var $8zOmE;
    var $lwMsT;
    var $7GkkF;
    var $95H4q;
    const $162727f679e8015c$var$renameInitialState = {
        editModeIndex: null,
        optimisticStatusName: null,
        isWorkflowUpdating: false,
        isEditing: false
    };
    const $162727f679e8015c$var$reducer = (state, action)=>{
        switch(action.type){
            case 'START_STATUS_RENAME':
                return {
                    ...state,
                    isWorkflowUpdating: true,
                    optimisticStatusName: action.payload,
                    isEditing: false
                };
            case 'RESET_EDIT_STATE':
                return {
                    ...$162727f679e8015c$var$renameInitialState
                };
            case 'SET_EDIT_MODE':
                return {
                    ...state,
                    isEditing: action.payload
                };
            case 'START_EDIT_MODE':
                return {
                    ...state,
                    editModeIndex: action.payload,
                    isEditing: true
                };
            default:
                return state;
        }
    };
    const $162727f679e8015c$export$a579ec74e28b4eb9 = ()=>{
        const { renameStatus: renameStatus, validateRenameStatus: validateRenameStatus } = (0, (0, parcelRequire("5cFkk")).useRenameStatus)((0, (0, parcelRequire("7GkkF")).RENAME_STATUS_EXPERIENCE));
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const { refresh: refreshSummaryData, data: issuesByTypeData } = (0, (0, parcelRequire("95H4q")).useSummaryContext)();
        const [renameState, dispatch] = (0, $5uXOq.useReducer)($162727f679e8015c$var$reducer, $162727f679e8015c$var$renameInitialState);
        const setStartStatusRename = (0, $5uXOq.useCallback)((newName)=>{
            dispatch({
                type: 'START_STATUS_RENAME',
                payload: newName
            });
        }, [
            dispatch
        ]);
        const resetEditState = (0, $5uXOq.useCallback)(()=>dispatch({
                type: 'RESET_EDIT_STATE'
            }), [
            dispatch
        ]);
        const setIsEditing = (0, $5uXOq.useCallback)((isEditMode)=>dispatch({
                type: 'SET_EDIT_MODE',
                payload: isEditMode
            }), [
            dispatch
        ]);
        const startEditMode = (0, $5uXOq.useCallback)((statusRowIndex)=>{
            dispatch({
                type: 'START_EDIT_MODE',
                payload: statusRowIndex
            });
        }, [
            dispatch
        ]);
        const renameStatusInternal = (0, $5uXOq.useCallback)(async (oldName, newName, statusId)=>{
            if (oldName === newName || statusId == null) {
                resetEditState();
                return;
            }
            const issueTypeId = issuesByTypeData?.issuesByType?.data.map((issue)=>issue.issueType.id)[0];
            if (issueTypeId != null) try {
                setStartStatusRename(newName);
                await renameStatus({
                    oldName: oldName,
                    statusId: statusId,
                    newName: newName,
                    issueTypeId: issueTypeId
                });
                resetEditState();
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'workflow saved');
            } catch (error) {
                resetEditState();
                throw error;
            } finally{
                refreshSummaryData();
            }
        }, [
            issuesByTypeData?.issuesByType?.data,
            resetEditState,
            setStartStatusRename,
            renameStatus,
            createAnalyticsEvent,
            refreshSummaryData
        ]);
        const validateStatusRenameInternal = (0, $5uXOq.useCallback)((oldName, newName, existingStatusNames)=>{
            if (!existingStatusNames) return;
            return validateRenameStatus({
                oldName: oldName,
                newName: newName,
                existingStatusNames: existingStatusNames
            });
        }, [
            validateRenameStatus
        ]);
        const editInlineRename = (0, $5uXOq.useCallback)(()=>{
            setIsEditing(true);
        }, [
            setIsEditing
        ]);
        const cancelInlineRename = (0, $5uXOq.useCallback)(()=>{
            resetEditState();
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'statusNameInlineEdit cancelled');
        }, [
            createAnalyticsEvent,
            resetEditState
        ]);
        return {
            renameStatus: renameStatusInternal,
            validateStatusRename: validateStatusRenameInternal,
            cancelInlineRename: cancelInlineRename,
            editInlineRename: editInlineRename,
            startEditMode: startEditMode,
            isWorkflowUpdating: renameState.isWorkflowUpdating,
            isEditing: renameState.isEditing,
            editModeIndex: renameState.editModeIndex,
            optimisticStatusName: renameState.optimisticStatusName
        };
    };
});
parcelRegister("5cFkk", function(module, exports) {
    $parcel$export(module.exports, "useRenameStatus", ()=>$f4bf9e3762c9251c$export$a5702435b665f82d);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $cm8b5;
    var $6nqwL;
    var $eAapG;
    var $pa9q9;
    var $koVbs;
    var $koeKL;
    var $8xg9P;
    var $ayqGc;
    var $9a7GF;
    const $f4bf9e3762c9251c$var$getCleanColumnName = (name)=>name.replace(/\s{2,}/g, ' ').trim();
    const $f4bf9e3762c9251c$export$a5702435b665f82d = (experienceDetails)=>{
        const startRenameOperation = (0, (0, parcelRequire("8xg9P")).useStartRenameOperation)();
        const stopWorkflowOperationInProgress = (0, (0, parcelRequire("8xg9P")).useStopWorkflowOperationInProgress)();
        const { fetchWorkflowsV2: fetchWorkflowsV2, validateAndUpdateWorkflowsV2: validateAndUpdateWorkflowsV2 } = (0, (0, parcelRequire("6nqwL")).useWorkflowsV2)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const startExperience = (0, (0, parcelRequire("cm8b5")).useExperienceStart)(experienceDetails);
        const markExperienceSuccess = (0, (0, parcelRequire("cm8b5")).useExperienceSuccess)(experienceDetails);
        const markExperienceFailed = (0, (0, parcelRequire("cm8b5")).useExperienceFail)(experienceDetails);
        const abortExperience = (0, (0, parcelRequire("cm8b5")).useExperienceAbort)(experienceDetails);
        const project = (0, (0, parcelRequire("daQYX")).useProject)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const validateRenameStatus = (0, $5uXOq.useCallback)(({ oldName: oldName, newName: newName, existingStatusNames: existingStatusNames })=>{
            const cleanNewName = $f4bf9e3762c9251c$var$getCleanColumnName(newName);
            const convertedNewName = cleanNewName.toUpperCase();
            if (convertedNewName === oldName.toUpperCase()) return undefined;
            if (!cleanNewName.length) return formatMessage((0, (0, parcelRequire("9a7GF")).default).emptyStatusNameError);
            if (existingStatusNames.some((statusName)=>statusName.toUpperCase() === convertedNewName)) return formatMessage((0, (0, parcelRequire("9a7GF")).default).statusAlreadyExists, {
                statusName: cleanNewName
            });
        }, [
            formatMessage
        ]);
        const renameStatus = (0, $5uXOq.useCallback)(async ({ oldName: oldName, statusId: statusId, newName: newName, issueTypeId: issueTypeId })=>{
            const cleanNewName = $f4bf9e3762c9251c$var$getCleanColumnName(newName);
            const convertedNewName = cleanNewName.toUpperCase();
            if (!cleanNewName.length || convertedNewName === oldName.toUpperCase()) return;
            startRenameOperation(String(statusId));
            startExperience();
            try {
                const workflowsData = await fetchWorkflowsV2({
                    cloudId: cloudId,
                    projectAndIssueTypes: [
                        {
                            projectId: project.id.toString(),
                            issueTypeId: issueTypeId
                        }
                    ]
                });
                if (workflowsData) {
                    const toRenameStatus = workflowsData.statuses.find((s)=>s.id === statusId.toString());
                    if (toRenameStatus) {
                        toRenameStatus.name = cleanNewName;
                        await validateAndUpdateWorkflowsV2({
                            cloudId: cloudId,
                            payload: {
                                payload: {
                                    statuses: (0, (0, parcelRequire("eAapG")).mapStatusesToStatusUpdateObjects)(workflowsData.statuses),
                                    workflows: [
                                        (0, (0, parcelRequire("eAapG")).mapWorkflowToWorkflowUpdateObject)(workflowsData.workflows[0])
                                    ]
                                },
                                validationOptions: {
                                    levels: [
                                        'ERROR'
                                    ]
                                }
                            }
                        });
                        markExperienceSuccess();
                    }
                }
            } catch (error) {
                showFlag((0, (0, parcelRequire("ayqGc")).getStatusActionFailedFlag)({
                    messageTitle: (0, (0, parcelRequire("9a7GF")).default).errorFlagTitleRenameStatus,
                    action: 'rename',
                    error: error,
                    issueTypeId: issueTypeId,
                    projectKey: project.key,
                    statusCode: error?.response?.status
                }));
                (0, (0, parcelRequire("ayqGc")).failStatusExperience)({
                    markExperienceFailed: markExperienceFailed,
                    abortExperience: abortExperience,
                    error: error,
                    errorMessage: 'Failed to validate and update workflow'
                });
                throw error;
            } finally{
                stopWorkflowOperationInProgress();
            }
        }, [
            startRenameOperation,
            startExperience,
            fetchWorkflowsV2,
            cloudId,
            project.id,
            project.key,
            validateAndUpdateWorkflowsV2,
            markExperienceSuccess,
            showFlag,
            markExperienceFailed,
            abortExperience,
            stopWorkflowOperationInProgress
        ]);
        return {
            renameStatus: renameStatus,
            validateRenameStatus: validateRenameStatus
        };
    };
});
parcelRegister("9a7GF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff8da4909b64255e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ff8da4909b64255e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        statusAlreadyExists: {
            "id": "business-workflows.controllers.workflow-actions.rename-status.status-already-exists",
            "defaultMessage": "''{statusName}'' is already a status name in this project"
        },
        emptyStatusNameError: {
            "id": "business-workflows.controllers.workflow-actions.rename-status.empty-status-name-error",
            "defaultMessage": "Status name cannot be empty"
        },
        errorFlagTitleRenameStatus: {
            "id": "business-workflows.controllers.workflow-actions.rename-status.error-flag-title-rename-status",
            "defaultMessage": "Unable to rename status"
        }
    });
});
parcelRegister("2qxpw", function(module, exports) {
    $parcel$export(module.exports, "CenteredSkeleton", ()=>$e4b50b9c34347f7c$export$8faa72715fd79c70);
    $parcel$export(module.exports, "Description", ()=>$e4b50b9c34347f7c$export$393edc798c47379d);
    $parcel$export(module.exports, "ChartWrapper", ()=>$e4b50b9c34347f7c$export$b9dcbe7159acfdce);
    $parcel$export(module.exports, "Chart", ()=>$e4b50b9c34347f7c$export$acaa6426d77a227e);
    $parcel$export(module.exports, "EmptyChart", ()=>$e4b50b9c34347f7c$export$41a1e905224db08);
    $parcel$export(module.exports, "Legend", ()=>$e4b50b9c34347f7c$export$ed247974535929c7);
    $parcel$export(module.exports, "LegendList", ()=>$e4b50b9c34347f7c$export$837fa44b17e0c23);
    $parcel$export(module.exports, "LegendItemColor", ()=>$e4b50b9c34347f7c$export$3653d20b79249348);
    $parcel$export(module.exports, "LegendItem", ()=>$e4b50b9c34347f7c$export$590bd3a1b15e3e13);
    $parcel$export(module.exports, "LegendItemName", ()=>$e4b50b9c34347f7c$export$3457a2f79a1f9283);
    $parcel$export(module.exports, "LegendItemCount", ()=>$e4b50b9c34347f7c$export$3d82ef0a867249db);
    $parcel$export(module.exports, "LegendTotal", ()=>$e4b50b9c34347f7c$export$d95dac908204464);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $lXVui = parcelRequire("lXVui");
    var $hDzhb;
    var $jCYbZ;
    const $e4b50b9c34347f7c$export$8faa72715fd79c70 = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("jCYbZ")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug",
                __cmplp.className
            ])
        });
    });
    const $e4b50b9c34347f7c$export$393edc798c47379d = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                __cmplp.className
            ])
        });
    });
    const $e4b50b9c34347f7c$export$b9dcbe7159acfdce = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _1tkeidpf _19pkpxbi",
                __cmplp.className
            ])
        });
    });
    const $e4b50b9c34347f7c$export$acaa6426d77a227e = (0, $5uXOq.forwardRef)(({ as: C = (0, ($parcel$interopDefault($lXVui))), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dl1ssb",
                __cmplp.className
            ])
        });
    });
    const $e4b50b9c34347f7c$var$EmptyChartSvg = ({ className: className, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            version: "1.1",
            viewBox: "0 0 100 100",
            className: className,
            "data-testid": testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            cx: "50",
            cy: "50",
            r: "36",
            stroke: `var(--ds-background-accent-gray-subtler, ${(0, $72ba03e317f3d228$export$1ce2d1575d444ceb)})`,
            strokeWidth: "22.5",
            fill: "none"
        }));
    const $e4b50b9c34347f7c$export$41a1e905224db08 = (0, $5uXOq.forwardRef)(({ as: C = $e4b50b9c34347f7c$var$EmptyChartSvg, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dl1ssb _1bsbp3fh _4t3ip3fh",
                __cmplp.className
            ])
        });
    });
    const $e4b50b9c34347f7c$export$ed247974535929c7 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dl1ssb _vchhusvi _1ul9idpf _c71l1osq _2hwxx0bf _u5f3u2gc _18m91wug _19bv1ejb _k48pbfng _syazc8hx",
                __cmplp.className
            ])
        });
    });
    const $e4b50b9c34347f7c$export$837fa44b17e0c23 = (0, $5uXOq.forwardRef)(({ as: C = "ol", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
                __cmplp.className
            ])
        });
    });
    const $e4b50b9c34347f7c$export$3653d20b79249348 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_xexnhp": (0, (0, parcelRequire("lD23V")).default)(__cmplp.color)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhk1cj8 _16jlidpf _1o9zidpf _i0dl1wug _1bsb7vkz _4t3i7vkz _2hwxu2gc _2rko1l7b _16qs6u33 _tzy417j0",
                __cmplp.className
            ])
        });
    });
    const $e4b50b9c34347f7c$export$590bd3a1b15e3e13 = (0, $5uXOq.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _otyr1b66 _1yt41xzv _2rko1l7b _zlc4kb7n _30l31fxt _irr3k6hx _1wnun8xv _1u71kb7n _13aukb7n _pkyp1wug _1hen1wug",
                __cmplp.className
            ])
        });
    });
    const $e4b50b9c34347f7c$export$3457a2f79a1f9283 = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug _o5721q9c _1reo15vq _18m915vq _1bto1l2s _1e0c1txw _4cvr1h6o _4t3i1ul9",
                __cmplp.className
            ])
        });
    });
    const $e4b50b9c34347f7c$export$3d82ef0a867249db = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("hDzhb")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlidpf _1o9zidpf _i0dl1wug _18u0u2gc",
                __cmplp.className
            ])
        });
    });
    const $e4b50b9c34347f7c$export$d95dac908204464 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pku2gc _1yt4fnvl _k48p1fw0 _1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jCYbZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d5b0e0beb15cd2df$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $d5b0e0beb15cd2df$var$Skeleton = ({ className: className, testId: testId })=>{
        const skeletonColor = `var(--ds-skeleton, ${(0, $72ba03e317f3d228$export$8d43898f60b96a82)})`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            viewBox: "0 0 476 296",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: className,
            "data-testid": testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "476",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            y: "16",
            width: "320",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M240 176C240 242.274 186.274 296 120 296C53.7258 296 0 242.274 0 176C0 109.726 53.7258 56 120 56C186.274 56 240 109.726 240 176ZM60 176C60 209.137 86.8629 236 120 236C153.137 236 180 209.137 180 176C180 142.863 153.137 116 120 116C86.8629 116 60 142.863 60 176Z",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M120 56C145.342 56 170.033 64.0226 190.534 78.918C211.036 93.8133 226.296 114.817 234.127 138.918C241.958 163.019 241.958 188.981 234.127 213.082C226.296 237.183 211.036 258.187 190.534 273.082C170.033 287.977 145.341 296 120 296C94.6585 296 69.9675 287.977 49.4658 273.082C28.964 258.187 13.7042 237.183 5.87321 213.082C-1.95774 188.981 -1.95774 163.019 5.87322 138.918L62.9366 157.459C59.0211 169.51 59.0211 182.49 62.9366 194.541C66.8521 206.592 74.482 217.093 84.7329 224.541C94.9837 231.989 107.329 236 120 236C132.671 236 145.016 231.989 155.267 224.541C165.518 217.093 173.148 206.592 177.063 194.541C180.979 182.49 180.979 169.51 177.063 157.459C173.148 145.408 165.518 134.907 155.267 127.459C145.016 120.011 132.671 116 120 116V56Z",
            fill: `var(--ds-skeleton, ${(0, $72ba03e317f3d228$export$920c0d5c49070351)})`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M120 56C138.937 56 157.606 60.4819 174.479 69.0792C191.352 77.6765 205.951 90.1452 217.082 105.466C228.213 120.786 235.56 138.524 238.523 157.228C241.485 175.932 239.979 195.072 234.127 213.082L177.063 194.541C179.989 185.536 180.743 175.966 179.261 166.614C177.78 157.262 174.107 148.393 168.541 140.733C162.975 133.073 155.676 126.838 147.239 122.54C138.803 118.241 129.469 116 120 116L120 56Z",
            fill: `var(--ds-skeleton, ${(0, $72ba03e317f3d228$export$46987b49aab6d1a8)})`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "280",
            y: "104",
            width: "24",
            height: "24",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "320",
            y: "112",
            width: "120",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "280",
            y: "144",
            width: "24",
            height: "24",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "320",
            y: "152",
            width: "120",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "280",
            y: "184",
            width: "24",
            height: "24",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "320",
            y: "192",
            width: "120",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "280",
            y: "224",
            width: "24",
            height: "24",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "320",
            y: "232",
            width: "120",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }));
    };
    var $d5b0e0beb15cd2df$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($d5b0e0beb15cd2df$var$Skeleton);
});
parcelRegister("5vmU5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$66bc1cff9146d8b9$export$2e2bcd8739ae039);
    var $7VHMR;
    var $66bc1cff9146d8b9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        statusNameButtonLabel: {
            "id": "business-summary.summary-view.progress-by-status.legend-item.status-name-button-label",
            "defaultMessage": "Edit {statusName} status"
        },
        statusNameTooltip: {
            "id": "business-summary.summary-view.progress-by-status.legend-item.status-name-tooltip",
            "defaultMessage": "Edit name"
        },
        tableCountersLabel: {
            "id": "business-summary.summary-view.progress-by-status.legend-item.table-counters-label",
            "defaultMessage": "{issuesCount, number} {issuesCount, plural, one {issue} other {issues}}, {percentage}% with the {status} status"
        }
    });
});
parcelRegister("45kbr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$03c9b3efaae834e4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $03c9b3efaae834e4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "business-summary.summary-view.progress-by-status.title",
            "defaultMessage": "Status overview"
        },
        description: {
            "id": "business-summary.summary-view.progress-by-status.description",
            "defaultMessage": "Get a snapshot of the status of your items. {linkStart}View all items{linkEnd}"
        },
        viewAllItemsLabel: {
            "id": "business-summary.summary-view.progress-by-status.view-all-items-label",
            "defaultMessage": "View all issues with the status listed in the chart"
        },
        descriptionWhenEmpty: {
            "id": "business-summary.summary-view.progress-by-status.description-when-empty",
            "defaultMessage": "You'll need to create a few items for your project to get a status overview on the team's progress."
        },
        totalCountWithLabel: {
            "id": "business-summary.summary-view.progress-by-status.total-count-with-label",
            "defaultMessage": "Total {issuesCount, number} {issuesCount, plural, one {issue} other {issues}}"
        },
        total: {
            "id": "business-summary.summary-view.progress-by-status.total",
            "defaultMessage": "Total"
        }
    });
});
parcelRegister("dPFym", function(module, exports) {
    $parcel$export(module.exports, "buildChartData", ()=>$8ae0793913b3d3b4$export$bbcf2eea793fdd45);
    var $gR7Xw;
    var $gwIPs;
    var $6s1PB;
    const $8ae0793913b3d3b4$var$NEUTRAL = [
        (0, $72ba03e317f3d228$export$1ce2d1575d444ceb),
        `var(--ds-text-subtle, ${(0, $72ba03e317f3d228$export$e2ef2124cf4024b1)})`
    ];
    const $8ae0793913b3d3b4$var$BLUE = [
        (0, $72ba03e317f3d228$export$215b7063051591f1),
        (0, $72ba03e317f3d228$export$e62e8919cca44969)
    ];
    const $8ae0793913b3d3b4$var$GREEN = [
        (0, $72ba03e317f3d228$export$747d86715d4175de),
        (0, $72ba03e317f3d228$export$940e1f69e873f202)
    ];
    const $8ae0793913b3d3b4$var$YELLOW = [
        (0, $72ba03e317f3d228$export$5aae31392d72caaa),
        (0, $72ba03e317f3d228$export$c6930421db9fa514)
    ];
    const $8ae0793913b3d3b4$var$TEAL = [
        (0, $72ba03e317f3d228$export$69cb3ca10c1e330e),
        (0, $72ba03e317f3d228$export$9dc1ef0f3f48059b)
    ];
    const $8ae0793913b3d3b4$var$PURPLE = [
        (0, $72ba03e317f3d228$export$a7175d4e9206bc80),
        (0, $72ba03e317f3d228$export$b48405b95304b5a1)
    ];
    const $8ae0793913b3d3b4$var$RED = [
        (0, $72ba03e317f3d228$export$60847d42f9da92a6),
        (0, $72ba03e317f3d228$export$4a7404f376229999)
    ];
    const $8ae0793913b3d3b4$var$CATEGORY_COLORS = {
        new: $8ae0793913b3d3b4$var$NEUTRAL,
        indeterminate: $8ae0793913b3d3b4$var$BLUE,
        done: $8ae0793913b3d3b4$var$GREEN
    };
    const $8ae0793913b3d3b4$var$OTHER_COLORS = [
        $8ae0793913b3d3b4$var$YELLOW,
        $8ae0793913b3d3b4$var$TEAL,
        $8ae0793913b3d3b4$var$PURPLE,
        $8ae0793913b3d3b4$var$RED
    ];
    const $8ae0793913b3d3b4$var$StatusCategoryOrder = {
        new: 0,
        indeterminate: 1,
        done: 2
    };
    const $8ae0793913b3d3b4$export$bbcf2eea793fdd45 = (data, issuesLinkUrl)=>{
        if (data == null) return null;
        const categoryColors = {
            ...$8ae0793913b3d3b4$var$CATEGORY_COLORS
        };
        let otherColors;
        let totalCount = 0;
        let largestDoneStatusCount = 0;
        let largestDoneStatusIndex = 0;
        const entries = [
            ...data
        ].sort((a, b)=>{
            const comparison = $8ae0793913b3d3b4$var$StatusCategoryOrder[a.status.category.key] - $8ae0793913b3d3b4$var$StatusCategoryOrder[b.status.category.key];
            if (comparison === 0) return a.status.name.localeCompare(b.status.name);
            return comparison;
        }).map((entry, index)=>{
            const categoryKey = entry.status.category.key;
            totalCount += entry.count;
            const isDone = categoryKey === 'done';
            if (isDone && entry.count > largestDoneStatusCount) {
                largestDoneStatusCount = entry.count;
                largestDoneStatusIndex = index;
            }
            if (!otherColors?.length) otherColors = [
                ...$8ae0793913b3d3b4$var$OTHER_COLORS
            ];
            const [color, textColor] = categoryColors[categoryKey] || otherColors.pop();
            delete categoryColors[categoryKey];
            const escapedStatus = entry.status.name.split("'").join("\\'");
            const status = entry.status.jqlTerm ?? escapedStatus;
            const filter = isDone ? `status = '${status}' AND statusCategoryChangedDate >= -2w` : `status = '${status}'`;
            const link = `${issuesLinkUrl}?filter=${encodeURIComponent(filter)}&hideDone=${isDone ? 'false' : 'true'}`;
            const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('business_summary_page_inline_status');
            const isInlineStatusChangeEnabled = expConfig.get('isInlineStatusChangeEnabled', false);
            const statusId = isInlineStatusChangeEnabled ? (0, (0, parcelRequire("gR7Xw")).JiraIssueStatusAri).parse(entry.status.statusId).issuestatusId : '';
            return {
                categoryKey: categoryKey,
                value: entry.count,
                name: entry.status.name,
                id: isInlineStatusChangeEnabled ? Number(statusId) : null,
                link: link,
                itemStyle: {
                    color: color
                },
                emphasis: {
                    label: {
                        rich: {
                            percent: {
                                color: textColor
                            }
                        }
                    }
                }
            };
        });
        const option = {
            series: [
                {
                    animation: false,
                    type: 'pie',
                    radius: [
                        '50%',
                        '95%'
                    ],
                    clockwise: false,
                    label: {
                        show: false,
                        position: 'center'
                    },
                    labelLine: {
                        show: false
                    },
                    emphasis: {
                        disabled: true,
                        scale: false,
                        label: {
                            show: true,
                            color: `var(--ds-text-subtle, ${(0, $72ba03e317f3d228$export$7090862dc3038a9f)})`,
                            fontSize: 14,
                            fontFamily: (0, parcelRequire("gwIPs")).fontFamily,
                            fontWeight: 500,
                            overflow: 'truncate',
                            width: 100,
                            formatter: ({ name: name, value: value })=>`{percent|${Math.round(value / totalCount * 100)}%}\n${name}`,
                            rich: {
                                percent: {
                                    fontSize: 36
                                }
                            }
                        },
                        itemStyle: {
                            color: 'inherit',
                            opacity: 0.9
                        }
                    },
                    data: entries
                }
            ]
        };
        return {
            option: option,
            entries: entries,
            totalCount: totalCount,
            initialHighlight: largestDoneStatusIndex
        };
    };
});
parcelRegister("gR7Xw", function(module, exports) {
    $parcel$export(module.exports, "JiraIssueStatusAri", ()=>$c457c50d57fb630d$export$12447ab6c7bdd0b0);
    var $bnH8K;
    var $fe7YR;
    var $224I1;
    var $c457c50d57fb630d$var$jiraIssueStatusAriStaticOpts = {
        qualifier: "ari",
        platformQualifier: "cloud",
        cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
        resourceOwner: (0, (0, parcelRequire("bnH8K")).JiraIssueStatusAriResourceOwner),
        resourceType: (0, (0, parcelRequire("bnH8K")).JiraIssueStatusAriResourceType),
        resourceIdSlug: "activation/{activationId}/{issuestatusId}",
        resourceIdSegmentFormats: {
            activationId: /[a-zA-Z0-9\-]+/,
            issuestatusId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
        }
    };
    var $c457c50d57fb630d$export$12447ab6c7bdd0b0 = class _JiraIssueStatusAri extends (0, (0, parcelRequire("fe7YR")).RegisteredAri) {
        constructor(opts){
            super(opts);
            this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._issuestatusId = opts.resourceIdSegmentValues.issuestatusId;
        }
        get siteId() {
            return this._siteId;
        }
        get activationId() {
            return this._activationId;
        }
        get issuestatusId() {
            return this._issuestatusId;
        }
        static create(opts) {
            let derivedOpts = {
                qualifier: $c457c50d57fb630d$var$jiraIssueStatusAriStaticOpts.qualifier,
                platformQualifier: $c457c50d57fb630d$var$jiraIssueStatusAriStaticOpts.platformQualifier,
                cloudId: opts.siteId,
                resourceOwner: $c457c50d57fb630d$var$jiraIssueStatusAriStaticOpts.resourceOwner,
                resourceType: $c457c50d57fb630d$var$jiraIssueStatusAriStaticOpts.resourceType,
                resourceId: `activation/${opts.activationId}/${opts.issuestatusId}`,
                resourceIdSegmentValues: {
                    activationId: opts.activationId,
                    issuestatusId: opts.issuestatusId
                }
            }, ariOpts = (0, (0, parcelRequire("224I1")).AriParser).fromOpts(derivedOpts, $c457c50d57fb630d$var$jiraIssueStatusAriStaticOpts);
            return new _JiraIssueStatusAri(ariOpts);
        }
        static parse(maybeAri) {
            let opts = (0, (0, parcelRequire("224I1")).AriParser).fromString(maybeAri, $c457c50d57fb630d$var$jiraIssueStatusAriStaticOpts);
            return new _JiraIssueStatusAri(opts);
        }
        getVariables() {
            return {
                siteId: this.siteId,
                activationId: this.activationId,
                issuestatusId: this.issuestatusId
            };
        }
    };
});
parcelRegister("bnH8K", function(module, exports) {
    $parcel$export(module.exports, "JiraIssueStatusAriResourceOwner", ()=>$84934e6f85101959$export$7ac9f54b32d39fd3);
    $parcel$export(module.exports, "JiraIssueStatusAriResourceType", ()=>$84934e6f85101959$export$7f58026b0f198a18);
    var $84934e6f85101959$export$7ac9f54b32d39fd3 = "jira", $84934e6f85101959$export$7f58026b0f198a18 = "issue-status";
});
parcelRegister("g3c4A", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bbd280b4815db54b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $cSXhT;
    var $alDmu;
    var $7NUKB;
    var $dWvae;
    var $cm8b5;
    var $koVbs;
    var $8zOmE;
    var $lwMsT;
    var $22OQR;
    var $l8ruj;
    var $7GkkF;
    var $2GNBJ;
    var $jmHgC;
    var $cYwgM;
    const $bbd280b4815db54b$var$ProjectDetailsInternal = ({ isSkeleton: isSkeleton })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const { data: data, loading: loading, error: error, fetch: fetch } = (0, (0, parcelRequire("2GNBJ")).default)();
        const wasFetched = data != null || loading;
        const [isExpanded, setIsExpanded] = (0, $5uXOq.useState)(false);
        const toggleSection = (0, $5uXOq.useCallback)(()=>{
            if (!isExpanded && !wasFetched) fetch();
            setIsExpanded(!isExpanded);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'summaryProjectDetails', {
                expand: !isExpanded
            });
        }, [
            createAnalyticsEvent,
            fetch,
            isExpanded,
            wasFetched
        ]);
        const toggleIcon = (0, $5uXOq.useMemo)(()=>isExpanded ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("alDmu"))))), {
                label: ""
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("cSXhT"))))), {
                label: ""
            }), [
            isExpanded
        ]);
        if (isSkeleton) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7NUKB")).default), {
            name: "project-details"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($bbd280b4815db54b$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($bbd280b4815db54b$var$Skeleton, {
            "data-testid": "business-summary.ui.summary-view.project-details.skeleton"
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement($bbd280b4815db54b$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
            iconAfter: toggleIcon,
            appearance: "subtle-link",
            onClick: toggleSection,
            "aria-expanded": isExpanded,
            "aria-controls": "summary-project-details",
            testId: "business-summary.ui.summary-view.project-details.toggle"
        }, formatMessage((0, (0, parcelRequire("cYwgM")).default).projectDetails)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dWvae")).Collapsible), {
            id: "summary-project-details",
            isExpanded: isExpanded
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceStart), {
            experience: (0, (0, parcelRequire("7GkkF")).PROJECT_DETAILS_EXPERIENCE)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jmHgC")).default), {
            data: data,
            error: error,
            loading: loading
        })));
    };
    const $bbd280b4815db54b$var$ProjectDetails = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "business-summary-project-details"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceErrorBoundary), {
            experience: (0, (0, parcelRequire("7GkkF")).PROJECT_DETAILS_EXPERIENCE),
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($bbd280b4815db54b$var$ProjectDetailsInternal, props)));
    var $bbd280b4815db54b$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($bbd280b4815db54b$var$ProjectDetails);
    const $bbd280b4815db54b$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $bbd280b4815db54b$var$Skeleton = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1lit _2rko1y44 _18s8swc3 _4t3i1tcg _bfhk1h97",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("alDmu", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $788a65f61eb9d469$var$_react = $788a65f61eb9d469$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $788a65f61eb9d469$var$_chevronUp = $788a65f61eb9d469$var$_interopRequireDefault((parcelRequire("jx8BF")));
    function $788a65f61eb9d469$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $788a65f61eb9d469$var$ChevronUpIcon = (props)=>$788a65f61eb9d469$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.221 9.322-2.929 2.955a1.01 1.01 0 0 0 0 1.419.986.986 0 0 0 1.405 0l2.298-2.317 2.307 2.327a.99.99 0 0 0 1.407 0 1.01 1.01 0 0 0 0-1.419l-2.94-2.965A1.1 1.1 0 0 0 11.991 9c-.279 0-.557.107-.77.322"/></svg>`
        }, props, {
            newIcon: $788a65f61eb9d469$var$_chevronUp.default,
            iconType: "utility"
        }));
    $788a65f61eb9d469$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
    var $788a65f61eb9d469$var$_default = module.exports.default = $788a65f61eb9d469$var$ChevronUpIcon;
});
parcelRegister("2GNBJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$29097a6bef7e3bd9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $jcw0u;
    var $7f4tk;
    var $ahubt;
    const $29097a6bef7e3bd9$var$initialState = {
        data: undefined,
        loading: false,
        error: undefined
    };
    const $29097a6bef7e3bd9$var$reducer = (state, action)=>{
        switch(action.type){
            case 'init':
                return $29097a6bef7e3bd9$var$initialState;
            case 'fetch':
                return {
                    ...$29097a6bef7e3bd9$var$initialState,
                    loading: true
                };
            case 'success':
                return {
                    ...state,
                    data: action.value,
                    loading: false
                };
            case 'error':
                return {
                    ...state,
                    loading: false,
                    error: action.value
                };
            default:
                return state;
        }
    };
    const $29097a6bef7e3bd9$var$useProjectMeta = ()=>{
        const [{ data: data, loading: loading, error: error }, dispatch] = (0, $5uXOq.useReducer)($29097a6bef7e3bd9$var$reducer, $29097a6bef7e3bd9$var$initialState);
        const project = (0, (0, parcelRequire("daQYX")).useProject)();
        const projectKey = project.key;
        const fetch = (0, $5uXOq.useCallback)(async ()=>{
            dispatch({
                type: 'fetch'
            });
            try {
                const response = await (0, (0, parcelRequire("7f4tk")).default)(`/rest/api/3/project/${projectKey}?expand=lead`);
                dispatch({
                    type: 'success',
                    value: (0, (0, parcelRequire("ahubt")).transformData)(response)
                });
            } catch (restError) {
                dispatch({
                    type: 'error',
                    value: restError
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'ProjectMeta',
                        packageName: 'jiraBusinessSummary',
                        teamName: 'wanjel'
                    },
                    error: restError,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }, [
            projectKey
        ]);
        (0, $5uXOq.useEffect)(()=>dispatch({
                type: 'init'
            }), [
            projectKey
        ]);
        return {
            fetch: fetch,
            data: data,
            loading: loading,
            error: error
        };
    };
    var $29097a6bef7e3bd9$export$2e2bcd8739ae039 = $29097a6bef7e3bd9$var$useProjectMeta;
});
parcelRegister("ahubt", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$16ff120e8d0bd751$export$3ceb62baab058c6b);
    const $16ff120e8d0bd751$export$3ceb62baab058c6b = ({ key: key, lead: lead })=>({
            key: key,
            lead: {
                displayName: lead.displayName,
                avatarUrl: lead.avatarUrls['48x48'] ?? '',
                accountId: lead.accountId
            }
        });
});
parcelRegister("jmHgC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a046da4a924edf09$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $1IqIJ;
    var $6UxUy;
    var $cm8b5;
    var $koVbs;
    var $8zOmE;
    var $lwMsT;
    var $158Ve;
    var $lob44;
    var $7GkkF;
    var $7TJr2;
    var $58fPS;
    const $a046da4a924edf09$var$Content = ({ data: data, error: error, loading: loading })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const { linksTarget: linksTarget } = (0, (0, parcelRequire("7TJr2")).useSummaryFeatures)();
        const onProjectLeadClick = (0, $5uXOq.useCallback)(()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'summaryProjectLead'), [
            createAnalyticsEvent
        ]);
        if (loading) return (0, ($parcel$interopDefault($5uXOq))).createElement($a046da4a924edf09$var$LoadingPill, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lob44")).ThemedSpinner), {
            size: "medium"
        }));
        if (error || data == null) return (0, ($parcel$interopDefault($5uXOq))).createElement($a046da4a924edf09$var$ErrorPill, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6UxUy"))))), {
            label: "",
            primaryColor: `var(--ds-icon-danger, ${(0, $72ba03e317f3d228$export$2010d0fb4295b346)})`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($a046da4a924edf09$var$ErrorMessage, null, formatMessage((0, (0, parcelRequire("58fPS")).default).errorMessage)), error && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceFailed), {
            experience: (0, (0, parcelRequire("7GkkF")).PROJECT_DETAILS_EXPERIENCE),
            error: error
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a046da4a924edf09$var$Pill, null, (0, ($parcel$interopDefault($5uXOq))).createElement($a046da4a924edf09$var$LeadSection, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1IqIJ")).default), {
            src: data.lead.avatarUrl,
            size: "large"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($a046da4a924edf09$var$LeadDetails, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("158Ve")).ThemedLink), {
            href: `/secure/ViewProfile.jspa?accountId=${data.lead.accountId}`,
            target: linksTarget,
            "data-testid": "business-summary.ui.summary-view.project-details.content.lead-profile-link",
            onClick: onProjectLeadClick
        }, data.lead.displayName), (0, ($parcel$interopDefault($5uXOq))).createElement($a046da4a924edf09$var$Heading, null, formatMessage((0, (0, parcelRequire("58fPS")).default).projectLead)))), (0, ($parcel$interopDefault($5uXOq))).createElement($a046da4a924edf09$var$KeySection, null, (0, ($parcel$interopDefault($5uXOq))).createElement($a046da4a924edf09$var$Heading, null, formatMessage((0, (0, parcelRequire("58fPS")).default).projectKey)), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            "data-testid": "business-summary.ui.summary-view.project-details.content.project-key"
        }, data.key)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceSuccess), {
            experience: (0, (0, parcelRequire("7GkkF")).PROJECT_DETAILS_EXPERIENCE)
        }));
    };
    var $a046da4a924edf09$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($a046da4a924edf09$var$Content);
    const $a046da4a924edf09$var$PILL_HEIGHT = 64;
    const $a046da4a924edf09$var$AVATAR_BORDER_WIDTH = 2;
    const $a046da4a924edf09$var$Heading = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syazvy9e _11c8qk37",
                __cmplp.className
            ])
        });
    });
    const $a046da4a924edf09$var$Section = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4",
                __cmplp.className
            ])
        });
    });
    const $a046da4a924edf09$var$PillBase = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3ivbgk _1e0c1txw _4cvr1h6o _1bah1h6o _2rkozwfg _vchhusvi _bfhk155y",
                __cmplp.className
            ])
        });
    });
    const $a046da4a924edf09$var$Pill = (0, $5uXOq.forwardRef)(({ as: C = $a046da4a924edf09$var$PillBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ca0qidpf _u5f31ylp _n3tdidpf _19bv1crf",
                __cmplp.className
            ])
        });
    });
    const $a046da4a924edf09$var$LeadSection = (0, $5uXOq.forwardRef)(({ as: C = $a046da4a924edf09$var$Section, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4cvr1h6o _2lx2vrvc",
                __cmplp.className
            ])
        });
    });
    const $a046da4a924edf09$var$LeadDetails = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _1bah1h6o _18u0u2gc",
                __cmplp.className
            ])
        });
    });
    const $a046da4a924edf09$var$KeySection = (0, $5uXOq.forwardRef)(({ as: C = $a046da4a924edf09$var$Section, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlidpf _1o9zidpf _i0dl1wug _1kl71gya _18u0pxbi _19bvpxbi",
                __cmplp.className
            ])
        });
    });
    const $a046da4a924edf09$var$LoadingPill = (0, $5uXOq.forwardRef)(({ as: C = $a046da4a924edf09$var$PillBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbvbgk",
                __cmplp.className
            ])
        });
    });
    const $a046da4a924edf09$var$ErrorPill = (0, $5uXOq.forwardRef)(({ as: C = $a046da4a924edf09$var$PillBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4zdiv",
                __cmplp.className
            ])
        });
    });
    const $a046da4a924edf09$var$ErrorMessage = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u01b66",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("158Ve", function(module, exports) {
    $parcel$export(module.exports, "ThemedLink", ()=>$2cd24dac1e5791c7$export$4beb2d7caf878ce7);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $hDzhb;
    const $2cd24dac1e5791c7$export$4beb2d7caf878ce7 = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("hDzhb")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1u0u14e8 _17z218zq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("58fPS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b2f0ffd7bd7e2265$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b2f0ffd7bd7e2265$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projectLead: {
            "id": "business-summary.summary-view.project-details.content.project-lead",
            "defaultMessage": "Project lead"
        },
        projectKey: {
            "id": "business-summary.summary-view.project-details.content.project-key",
            "defaultMessage": "Project key"
        },
        errorMessage: {
            "id": "business-summary.summary-view.project-details.content.error-message",
            "defaultMessage": "Could not retrieve project details."
        }
    });
});
parcelRegister("cYwgM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$367dfd39bbf13525$export$2e2bcd8739ae039);
    var $7VHMR;
    var $367dfd39bbf13525$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projectDetails: {
            "id": "business-summary.summary-view.project-details.project-details",
            "defaultMessage": "Project details"
        }
    });
});
parcelRegister("9lJRz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bfe8a52407a244dc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $2APCZ;
    var $2mHtV;
    var $7NUKB;
    var $loZC0;
    var $172CC;
    var $cm8b5;
    var $koVbs;
    var $bKCrm;
    var $aFVvc;
    var $l8ruj;
    var $hDzhb;
    var $7GkkF;
    var $3iDn2;
    var $kbgBa;
    var $7TJr2;
    var $95H4q;
    var $5NGLm;
    var $aORH4;
    var $6m7w2;
    var $5i8ph;
    const $bfe8a52407a244dc$var$PROJECT_CREATE_OPTIONS = (0, (0, parcelRequire("172CC")).getJwmCreateProjectDrawerOptions)('jwmSummaryPage');
    const $bfe8a52407a244dc$var$RelatedProjects = ({ position: position })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { loading: isSummaryDataLoading } = (0, (0, parcelRequire("95H4q")).useSummaryContext)();
        const { linksTarget: linksTarget } = (0, (0, parcelRequire("7TJr2")).useSummaryFeatures)();
        const { data: data, loading: isRelatedProjectsLoading, error: error } = (0, (0, parcelRequire("5NGLm")).useRelatedProjects)();
        const { data: permissions } = (0, (0, parcelRequire("aFVvc")).useProjectCreatePermissionsResource)();
        const isLoading = isSummaryDataLoading || isRelatedProjectsLoading;
        const { startHoverTimer: startHoverTimer, stopHoverTimer: stopHoverTimer, fireSectionAnalytics: fireSectionAnalytics } = (0, (0, parcelRequire("kbgBa")).useSectionAnalytics)(position, 'relatedProjects');
        if (error != null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iDn2")).ErrorCard), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceFailed), {
            experience: (0, (0, parcelRequire("7GkkF")).RELATED_PROJECTS_EXPERIENCE),
            error: error
        }));
        const canCreateProject = Boolean(permissions?.canCreateProject);
        const createProjectRoute = `/jira/create-project?templateId=${$bfe8a52407a244dc$var$PROJECT_CREATE_OPTIONS.defaultSelectedTemplateKey}`;
        let content = null;
        if (isLoading) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7NUKB")).default), {
            name: "related-projects"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($bfe8a52407a244dc$var$CenteredSkeleton, {
            testId: "business-summary.ui.summary-view.related-projects.skeleton"
        }));
        else if (data != null && data.length === 0) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($bfe8a52407a244dc$var$Description, null, formatMessage((0, (0, parcelRequire("6m7w2")).default).descriptionWhenEmpty)), (0, ($parcel$interopDefault($5uXOq))).createElement($bfe8a52407a244dc$var$EmptyState, {
            withCreateProject: canCreateProject
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($bfe8a52407a244dc$var$EmptyStateIllustration, null), canCreateProject && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bKCrm")).ProjectCreateDrawerConsumer), null, ({ methods: { open: open } })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
                appearance: "primary",
                onClick: ()=>{
                    linksTarget === '_blank' ? window.open(createProjectRoute, '_blank') : open($bfe8a52407a244dc$var$PROJECT_CREATE_OPTIONS);
                    fireSectionAnalytics('createProject', {
                        isEmpty: true
                    });
                },
                testId: "business-summary.ui.summary-view.related-projects.create-project-button-empty"
            }, formatMessage((0, (0, parcelRequire("6m7w2")).default).createProject))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
            href: "/jira/projects",
            target: linksTarget,
            component: (0, (0, parcelRequire("hDzhb")).default),
            onClick: ()=>fireSectionAnalytics('projectDirectory', {
                    isEmpty: true
                })
        }, formatMessage((0, (0, parcelRequire("6m7w2")).default).viewAllProjects))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceSuccess), {
            experience: (0, (0, parcelRequire("7GkkF")).RELATED_PROJECTS_EXPERIENCE)
        }));
        else if (data != null) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($bfe8a52407a244dc$var$Description, null, formatMessage((0, (0, parcelRequire("6m7w2")).default).description)), (0, ($parcel$interopDefault($5uXOq))).createElement($bfe8a52407a244dc$var$Grid, {
            "data-testid": "business-summary.ui.summary-view.related-projects.grid"
        }, canCreateProject && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bKCrm")).ProjectCreateDrawerConsumer), null, ({ methods: { open: open } })=>(0, ($parcel$interopDefault($5uXOq))).createElement($bfe8a52407a244dc$var$CreateProject, {
                onClick: ()=>{
                    linksTarget === '_blank' ? window.open(createProjectRoute, '_blank') : open($bfe8a52407a244dc$var$PROJECT_CREATE_OPTIONS);
                    fireSectionAnalytics('createProject', {
                        isEmpty: false
                    });
                },
                "data-testid": "business-summary.ui.summary-view.related-projects.create-project-button"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($bfe8a52407a244dc$var$CreateProjectIcon, {
                "data-icon": true
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2mHtV"))))), {
                label: ""
            })), formatMessage((0, (0, parcelRequire("6m7w2")).default).createProject))), data.map(({ id: id, avatarUrl: avatarUrl, name: name, key: key, url: url, projectTypeKey: projectTypeKey }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement($bfe8a52407a244dc$var$Project, {
                "data-testid": "business-summary.ui.summary-view.related-projects.project",
                href: url,
                target: linksTarget,
                key: id,
                onClick: ()=>fireSectionAnalytics('relatedProject', {
                        projectTypeKey: projectTypeKey,
                        resultPosition: index + 1
                    })
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($bfe8a52407a244dc$var$ProjectAvatar, {
                src: `${avatarUrl}?size=xxlarge`,
                alt: ""
            }), (0, ($parcel$interopDefault($5uXOq))).createElement($bfe8a52407a244dc$var$ProjectDetails, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
                content: name
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($bfe8a52407a244dc$var$ProjectName, null, name)), key)))), (0, ($parcel$interopDefault($5uXOq))).createElement($bfe8a52407a244dc$var$AllProjects, {
            href: "/jira/projects",
            target: linksTarget,
            onClick: ()=>fireSectionAnalytics('projectDirectory', {
                    isEmpty: false
                })
        }, formatMessage((0, (0, parcelRequire("6m7w2")).default).viewAllProjects)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceSuccess), {
            experience: (0, (0, parcelRequire("7GkkF")).RELATED_PROJECTS_EXPERIENCE)
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "business-summary-related-projects"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iDn2")).default), {
            title: formatMessage((0, (0, parcelRequire("6m7w2")).default).title),
            isLoading: isLoading,
            testId: "business-summary.ui.summary-view.related-projects",
            onPointerEnter: startHoverTimer,
            onPointerLeave: stopHoverTimer
        }, content));
    };
    var $bfe8a52407a244dc$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($bfe8a52407a244dc$var$RelatedProjects);
    const $bfe8a52407a244dc$var$buttonStyles = null;
    const $bfe8a52407a244dc$var$iconStyles = null;
    const $bfe8a52407a244dc$var$CenteredSkeleton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("5i8ph")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug",
                __cmplp.className
            ])
        });
    });
    const $bfe8a52407a244dc$var$Description = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                __cmplp.className
            ])
        });
    });
    const $bfe8a52407a244dc$var$Grid = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c11p5 _zulpu2gc _yv0ewxkt _18s817ik _1yt4u2gc _18m91wug",
                __cmplp.className
            ])
        });
    });
    const $bfe8a52407a244dc$var$CreateProject = (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1yt4u2gc _2rko1l7b _1wybdlk8 _1ul9idpf _syaz1fxt _80omtlke _11q7glyw _19itglyw _k48pni7l _n3yiiw92 _1b3i2u25 _12dbfwzl _1nrm18uv _1a3b18uv _9oik18uv _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _1di6k6hx _jomrk6hx _irr3k6hx _u7j629zg _y6l529zg _1k1529zg _9tyi17uj _1opp17uj _m21a17uj _1w911edt _b14k1edt _4jwe1edt",
                __cmplp.className
            ])
        });
    });
    const $bfe8a52407a244dc$var$CreateProjectIcon = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlidpf _1o9zidpf _i0dl1wug _vchhusvi _4t3ickbl _1bsbckbl _2hwxutpp _syazkr0v _bfhk84zz _19it1owy _2rkoftgi _1e0c1txw _4cvr1h6o _1bah1h6o",
                __cmplp.className
            ])
        });
    });
    const $bfe8a52407a244dc$var$Project = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("hDzhb")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1yt4u2gc _2rko1l7b _1wybdlk8 _1ul9idpf _1nrm18uv _1a3b18uv _9oik18uv _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _1di6k6hx _jomrk6hx _irr3k6hx",
                __cmplp.className
            ])
        });
    });
    const $bfe8a52407a244dc$var$ProjectAvatar = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlidpf _1o9zidpf _i0dl1wug _vchhusvi _4t3ickbl _1bsbckbl _2hwxutpp _2rko1l7b",
                __cmplp.className
            ])
        });
    });
    const $bfe8a52407a244dc$var$ProjectDetails = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1rc1 _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
    const $bfe8a52407a244dc$var$ProjectName = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1fxt _k48pni7l _1reo15vq _18m915vq _o5721q9c _1bto1l2s",
                __cmplp.className
            ])
        });
    });
    const $bfe8a52407a244dc$var$AllProjects = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("hDzhb")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wpz1y6m",
                __cmplp.className
            ])
        });
    });
    const $bfe8a52407a244dc$var$EmptyState = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { withCreateProject: withCreateProject, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug _1wpz1h6o _1e0c11p5 _zulp1tr9 _ae4v1h6o _6a6z1h6o",
                __cmplp.withCreateProject ? "_1lmcd2gs" : "_1lmc4osr",
                __cmplp.className
            ])
        });
    });
    const $bfe8a52407a244dc$var$EmptyStateIllustration = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("aORH4")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_nd5l1gsw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("5NGLm", function(module, exports) {
    $parcel$export(module.exports, "useRelatedProjects", ()=>$96e58dcbc4b6b655$export$3ce5df02b255c535);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $jcw0u;
    var $7f4tk;
    var $9OXo1;
    var $qzB1l;
    const $96e58dcbc4b6b655$var$QUERY_NAME = 'collaborationGraph';
    const $96e58dcbc4b6b655$var$MAX_RESULTS = 5;
    const $96e58dcbc4b6b655$var$initialState = {
        data: undefined,
        loading: true,
        error: undefined
    };
    const $96e58dcbc4b6b655$var$reducer = (state, action)=>{
        switch(action.type){
            case 'init':
                return $96e58dcbc4b6b655$var$initialState;
            case 'success':
                return {
                    ...state,
                    data: action.value,
                    loading: false
                };
            case 'error':
                return {
                    ...state,
                    loading: false,
                    error: action.value
                };
            default:
                return state;
        }
    };
    const $96e58dcbc4b6b655$export$3ce5df02b255c535 = ()=>{
        const [{ data: data, loading: loading, error: error }, dispatch] = (0, $5uXOq.useReducer)($96e58dcbc4b6b655$var$reducer, $96e58dcbc4b6b655$var$initialState);
        const { cloudId: cloudId, atlassianAccountId: atlassianAccountId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const project = (0, (0, parcelRequire("daQYX")).useProject)();
        const currentProjectId = String(project.id);
        (0, $5uXOq.useEffect)(()=>{
            dispatch({
                type: 'init'
            });
            (0, (0, parcelRequire("7f4tk")).default)('/gateway/api/collaboration/v2/recommend/container', {
                method: 'POST',
                body: JSON.stringify({
                    context: {
                        userId: atlassianAccountId,
                        tenantId: cloudId,
                        containerId: currentProjectId,
                        product: 'jira'
                    },
                    modelRequestParams: {
                        experience: 'JiraContainerNearbyContainer',
                        caller: 'jira'
                    },
                    requestingUserId: atlassianAccountId,
                    expand: 'existing',
                    maxNumberOfResults: $96e58dcbc4b6b655$var$MAX_RESULTS
                })
            }).then((graphResponse)=>dispatch({
                    type: 'success',
                    value: (0, (0, parcelRequire("qzB1l")).transformData)(graphResponse, currentProjectId)
                })).catch((restError)=>{
                dispatch({
                    type: 'error',
                    value: restError
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: $96e58dcbc4b6b655$var$QUERY_NAME,
                        packageName: 'jiraBusinessSummary',
                        teamName: 'wanjel'
                    },
                    error: restError,
                    sendToPrivacyUnsafeSplunk: true
                });
            });
        }, [
            atlassianAccountId,
            cloudId,
            currentProjectId
        ]);
        return {
            loading: loading,
            error: error,
            data: data
        };
    };
});
parcelRegister("qzB1l", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$15a19c066a8a91fd$export$3ceb62baab058c6b);
    const $15a19c066a8a91fd$export$3ceb62baab058c6b = (graphResponse, currentProjectId)=>graphResponse.recommendedEntities.map(({ expand: { id: id, key: key, name: name, avatarUrl: avatarUrl, url: url, projectTypeKey: projectTypeKey } })=>({
                id: id,
                key: key,
                name: name,
                avatarUrl: avatarUrl,
                url: url,
                projectTypeKey: projectTypeKey
            })).filter(({ id: id })=>id !== currentProjectId);
});
parcelRegister("aORH4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d92c5df92ae4d352$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $d92c5df92ae4d352$var$EmptyIllustration = ({ className: className })=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            height: "140",
            viewBox: "0 0 270 197",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: className
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#related_proj_0_clip)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M38.1121 159.386L36.6245 161.141L73.9342 192.782L75.4219 191.027L38.1121 159.386Z",
            fill: "#B2D4FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M22.9727 98.5313L22.6646 100.811L73.6011 107.697L73.9092 105.418L22.9727 98.5313Z",
            fill: "#B2D4FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M69.1668 57.4796L67.4548 59.0156L94.3284 88.9667L96.0403 87.4307L69.1668 57.4796Z",
            fill: "#B2D4FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M174.162 69.7903L173.337 71.9375L222.285 90.7267L223.109 88.5795L174.162 69.7903Z",
            fill: "#B2D4FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M160.704 120.078L159.843 122.211L229.827 150.486L230.688 148.354L160.704 120.078Z",
            fill: "#B2D4FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M223.721 88.5916L221.444 88.8906L229.276 148.538L231.553 148.239L223.721 88.5916Z",
            fill: "#B2D4FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M67.4944 57.4183L22.0071 98.8086L23.5348 100.488L69.0221 59.0973L67.4944 57.4183Z",
            fill: "#B2D4FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M23.9733 99.3967L21.7368 99.9336L36.3085 160.629L38.5449 160.092L23.9733 99.3967Z",
            fill: "#B2D4FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M229.603 148.698L198.452 179.203L200.041 180.825L231.192 150.32L229.603 148.698Z",
            fill: "#B2D4FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M264.105 130.299L229.537 148.141L230.578 150.158L265.146 132.316L264.105 130.299Z",
            fill: "#B2D4FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M129.777 123.241L37.2278 158.953L38.045 161.071L130.594 125.359L129.777 123.241Z",
            fill: "#B2D4FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M222.268 88.5009L129.818 123.066L130.613 125.193L223.063 90.6272L222.268 88.5009Z",
            fill: "#B2D4FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M130.3 195.9C169.899 195.9 202 163.799 202 124.2C202 84.6012 169.899 52.5 130.3 52.5C90.701 52.5 58.5999 84.6012 58.5999 124.2C58.5999 163.799 90.701 195.9 130.3 195.9Z",
            fill: "url(#related_proj_0_linear)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            opacity: "0.5"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.5",
            d: "M129 79.8008H99.7999C99.4999 80.6008 99.1 81.4008 98.7 82.3008H129V79.8008Z",
            fill: "#B2D4FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.5",
            d: "M73.9999 79.8008C73.3999 80.6008 72.6999 81.4008 72.0999 82.3008H96.2999C96.6058 81.442 96.9734 80.6065 97.3999 79.8008H73.9999Z",
            fill: "#B2D4FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.5",
            d: "M188.4 82.3008C187.823 81.426 187.188 80.5908 186.5 79.8008H164.7C165 80.6008 165.4 81.4008 165.7 82.3008H188.4Z",
            fill: "#B2D4FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.5",
            d: "M131.5 82.3008H163.3C162.9 81.4008 162.6 80.6008 162.2 79.8008H131.5V82.3008Z",
            fill: "#B2D4FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.5",
            d: "M129 166.1H97.2C97.6 166.9 97.8999 167.8 98.2999 168.6H129V166.1Z",
            fill: "#B2D4FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.5",
            d: "M72.0999 166.1L73.9999 168.6H95.7999L94.7999 166.1H72.0999Z",
            fill: "#B2D4FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.5",
            d: "M186.5 168.6C187.2 167.8 187.8 166.9 188.4 166.1H164.2C163.875 166.951 163.508 167.785 163.1 168.6H186.5Z",
            fill: "#B2D4FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.5",
            d: "M131.5 168.6H160.7C161.108 167.785 161.475 166.951 161.8 166.1H131.5V168.6Z",
            fill: "#B2D4FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.5",
            d: "M98.6998 82.3C99.0998 81.4 99.4998 80.6 99.7998 79.8C107 64.9 117.4 55 129 53.8V52.5H131.5V53.7H132.1C142.7 53.9 152.5 61.5 159.8 74.8C160.6 76.4 161.5 78.1 162.2 79.8C162.9 81.5 162.9 81.4 163.3 82.3C168.1 94 170.6 108.1 170.5 122.9H172.7C172.8 108.2 170.4 94.1 165.7 82.3C165.4 81.4 165 80.6 164.7 79.8C164.4 79 162.8 75.7 161.8 73.7C156.2 63.5 149.2 56.6 141.4 53.4C138.323 52.8926 135.216 52.5919 132.1 52.5C129 52.5 125.9 52.6 122.9 52.9C112.7 56.5 103.7 66.2 97.3998 79.8C96.9733 80.6057 96.6057 81.4412 96.2998 82.3C91.2998 93.8 88.1998 107.8 87.7998 122.9H90.0998C90.3473 108.942 93.2666 95.1599 98.6998 82.3Z",
            fill: "#B2D4FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.5",
            d: "M164.2 166.1C169.578 153.192 172.463 139.382 172.7 125.4H170.4C170.163 139.392 167.243 153.209 161.8 166.1C161.475 166.952 161.108 167.786 160.7 168.6C153.5 183.5 143.1 193.3 131.5 194.5V195.6H129V194.7H128.4C117.8 194.4 108 186.9 100.7 173.5L98.2999 168.6C97.8999 167.8 97.5999 166.9 97.1999 166.1C92.3999 154.3 89.8999 140.2 90.0999 125.4H87.7999C87.6999 140.2 90.0999 154.2 94.7999 166.1L95.7999 168.6C96.6999 170.7 97.6999 172.7 98.6999 174.6C104.3 184.8 111.3 191.8 119.1 195C122.2 195.4 125.2 195.7 128.4 195.8C131.506 195.917 134.616 195.783 137.7 195.4C147.8 191.9 156.8 182.1 163.1 168.6C163.508 167.786 163.875 166.952 164.2 166.1Z",
            fill: "#B2D4FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.5",
            d: "M131.5 79.8V53.7V52.5H129V53.8V79.8V82.3V122.9H131.5V82.3V79.8Z",
            fill: "#B2D4FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.5",
            d: "M131.5 166.1V125.4H129V166.1V168.6V194.7V195.6H131.5V194.5V168.6V166.1Z",
            fill: "#B2D4FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.5",
            d: "M129 125.4H131.5H170.4H172.7H201.9V122.9H172.7H170.5H131.5H129H90.0999H87.7999H58.8999V125.4H87.7999H90.0999H129Z",
            fill: "#B2D4FF"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            opacity: "0.4"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.4",
            d: "M78.1999 155C77.959 155.028 77.7148 154.997 77.4884 154.91C77.262 154.822 77.06 154.682 76.8999 154.5C76.7084 154.331 76.555 154.123 76.4499 153.89C76.3449 153.657 76.2905 153.405 76.2905 153.15C76.2905 152.894 76.3449 152.642 76.4499 152.409C76.555 152.176 76.7084 151.968 76.8999 151.8L128.9 99.7995C129.252 99.4691 129.717 99.2852 130.2 99.2852C130.683 99.2852 131.148 99.4691 131.5 99.7995C131.691 99.9684 131.845 100.176 131.95 100.409C132.055 100.642 132.109 100.894 132.109 101.15C132.109 101.405 132.055 101.657 131.95 101.89C131.845 102.123 131.691 102.331 131.5 102.5L79.4999 154.5C79.3398 154.682 79.1379 154.822 78.9115 154.91C78.6851 154.997 78.4409 155.028 78.1999 155Z",
            fill: "url(#related_proj_1_linear)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M200.9 55.4995C177.8 46.0995 154.6 64.8995 131.5 55.4995V3.29948C154.6 12.6995 177.8 -6.10052 200.9 3.29948V55.4995Z",
            fill: "url(#related_proj_2_linear)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M130.2 102.9C129.739 102.901 129.296 102.725 128.961 102.409C128.626 102.092 128.425 101.66 128.4 101.2V3.3C128.4 2.82261 128.59 2.36477 128.927 2.02721C129.265 1.68964 129.723 1.5 130.2 1.5C130.677 1.5 131.135 1.68964 131.473 2.02721C131.81 2.36477 132 2.82261 132 3.3V101.2C131.974 101.66 131.773 102.092 131.439 102.409C131.104 102.725 130.66 102.901 130.2 102.9Z",
            fill: "#0052CC"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M166.8 15.4994L170.9 23.8994L180.1 25.0994C180.259 25.1278 180.408 25.1987 180.53 25.3045C180.653 25.4104 180.745 25.5473 180.796 25.7008C180.847 25.8544 180.856 26.0189 180.821 26.177C180.787 26.3351 180.71 26.4811 180.6 26.5994L174 33.2994L175.5 42.5994C175.546 42.756 175.544 42.923 175.492 43.0781C175.441 43.2331 175.344 43.3687 175.213 43.4667C175.082 43.5647 174.925 43.6203 174.762 43.6262C174.598 43.632 174.437 43.5878 174.3 43.4994L166 39.2994L157.8 43.7994C157.655 43.8723 157.494 43.9048 157.332 43.8936C157.171 43.8824 157.016 43.8279 156.882 43.7357C156.749 43.6436 156.644 43.5173 156.576 43.3701C156.509 43.2229 156.483 43.0603 156.5 42.8994L158.1 33.5994L151.4 27.0994C151.29 26.9811 151.213 26.8351 151.179 26.677C151.144 26.5189 151.153 26.3544 151.204 26.2008C151.255 26.0473 151.347 25.9104 151.469 25.8045C151.592 25.6987 151.741 25.6278 151.9 25.5994L161.1 24.0994L165.2 15.4994C165.276 15.3525 165.39 15.2293 165.531 15.1433C165.673 15.0572 165.835 15.0117 166 15.0117C166.165 15.0117 166.327 15.0572 166.468 15.1433C166.609 15.2293 166.724 15.3525 166.8 15.4994Z",
            fill: "#FFF0B2"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M68.3 68.7996C74.1542 68.7996 78.9 64.0538 78.9 58.1996C78.9 52.3454 74.1542 47.5996 68.3 47.5996C62.4457 47.5996 57.7 52.3454 57.7 58.1996C57.7 64.0538 62.4457 68.7996 68.3 68.7996Z",
            fill: "#4C9AFF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M199.2 190.6C205.054 190.6 209.8 185.855 209.8 180C209.8 174.146 205.054 169.4 199.2 169.4C193.346 169.4 188.6 174.146 188.6 180C188.6 185.855 193.346 190.6 199.2 190.6Z",
            fill: "url(#related_proj_3_linear)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M37.3 170.899C43.1542 170.899 47.9 166.153 47.9 160.299C47.9 154.445 43.1542 149.699 37.3 149.699C31.4457 149.699 26.7 154.445 26.7 160.299C26.7 166.153 31.4457 170.899 37.3 170.899Z",
            fill: "url(#related_proj_4_linear)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M230.4 154.3C233.106 154.3 235.3 152.106 235.3 149.4C235.3 146.694 233.106 144.5 230.4 144.5C227.694 144.5 225.5 146.694 225.5 149.4C225.5 152.106 227.694 154.3 230.4 154.3Z",
            fill: "#FFC400"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M222.7 94.5988C225.406 94.5988 227.6 92.405 227.6 89.6988C227.6 86.9926 225.406 84.7988 222.7 84.7988C219.994 84.7988 217.8 86.9926 217.8 89.6988C217.8 92.405 219.994 94.5988 222.7 94.5988Z",
            fill: "#505F79"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M264.4 136.4C267.106 136.4 269.3 134.206 269.3 131.5C269.3 128.793 267.106 126.6 264.4 126.6C261.694 126.6 259.5 128.793 259.5 131.5C259.5 134.206 261.694 136.4 264.4 136.4Z",
            fill: "#4C9AFF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M6.04613 73.1738L4.15063 74.4766L21.8622 100.247L23.7576 98.9443L6.04613 73.1738Z",
            fill: "#B2D4FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M5.2999 78.4992C8.0061 78.4992 10.1999 76.3054 10.1999 73.5992C10.1999 70.893 8.0061 68.6992 5.2999 68.6992C2.59371 68.6992 0.399902 70.893 0.399902 73.5992C0.399902 76.3054 2.59371 78.4992 5.2999 78.4992Z",
            fill: "#B2D4FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M22.7999 104.499C25.5061 104.499 27.6999 102.305 27.6999 99.5992C27.6999 96.893 25.5061 94.6992 22.7999 94.6992C20.0937 94.6992 17.8999 96.893 17.8999 99.5992C17.8999 102.305 20.0937 104.499 22.7999 104.499Z",
            fill: "#FFC400"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M74.5999 196.9C77.3061 196.9 79.4999 194.706 79.4999 192C79.4999 189.293 77.3061 187.1 74.5999 187.1C71.8937 187.1 69.7 189.293 69.7 192C69.7 194.706 71.8937 196.9 74.5999 196.9Z",
            fill: "#505F79"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: "related_proj_0_linear",
            x1: "79.5799",
            y1: "174.85",
            x2: "180.94",
            y2: "73.5",
            gradientUnits: "userSpaceOnUse"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            stopColor: "#0065FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.67",
            stopColor: "#4C9AFF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.99",
            stopColor: "#B2D4FF"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: "related_proj_1_linear",
            x1: "76.3199",
            y1: "127.16",
            x2: "132.09",
            y2: "127.16",
            gradientUnits: "userSpaceOnUse"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            stopColor: "#0052CC",
            stopOpacity: "0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "1",
            stopColor: "#0052CC"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: "related_proj_2_linear",
            x1: "135.77",
            y1: "59.8495",
            x2: "196.62",
            y2: "-1.00051",
            gradientUnits: "userSpaceOnUse"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.24",
            stopColor: "#FF991F"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "1",
            stopColor: "#FFC400"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: "related_proj_3_linear",
            x1: "191.7",
            y1: "187.46",
            x2: "206.69",
            y2: "172.47",
            gradientUnits: "userSpaceOnUse"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.05",
            stopColor: "#4C9AFF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.99",
            stopColor: "#B2D4FF"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: "related_proj_4_linear",
            x1: "650.616",
            y1: "3695.4",
            x2: "968.404",
            y2: "3377.4",
            gradientUnits: "userSpaceOnUse"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.05",
            stopColor: "#4C9AFF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.99",
            stopColor: "#B2D4FF"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "related_proj_0_clip"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M0.399902 0.599609H269.3V196.9H0.399902V0.599609Z",
            fill: "white"
        }))));
    var $d92c5df92ae4d352$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($d92c5df92ae4d352$var$EmptyIllustration);
});
parcelRegister("6m7w2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9eecf0faada51261$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9eecf0faada51261$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "business-summary.summary-view.related-projects.title",
            "defaultMessage": "Related projects"
        },
        description: {
            "id": "business-summary.summary-view.related-projects.description",
            "defaultMessage": "Connect with other projects your team frequently contributes to and align with other project dependencies."
        },
        descriptionWhenEmpty: {
            "id": "business-summary.summary-view.related-projects.description-when-empty",
            "defaultMessage": "Use projects to manage all your work in one place and stay aligned with stakeholders."
        },
        createProject: {
            "id": "business-summary.summary-view.related-projects.create-project",
            "defaultMessage": "Create a project"
        },
        viewAllProjects: {
            "id": "business-summary.summary-view.related-projects.view-all-projects",
            "defaultMessage": "View all projects"
        }
    });
});
parcelRegister("5i8ph", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8e7ccb3bff404caf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $8e7ccb3bff404caf$var$Skeleton = ({ className: className, testId: testId })=>{
        const skeletonColor = `var(--ds-skeleton, ${(0, $72ba03e317f3d228$export$8d43898f60b96a82)})`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            viewBox: "0 0 476 312",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: className,
            "data-testid": testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "476",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            y: "16",
            width: "320",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            y: "56",
            width: "48",
            height: "48",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "64",
            y: "68",
            width: "160",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "64",
            y: "84",
            width: "80",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "252",
            y: "56",
            width: "48",
            height: "48",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "316",
            y: "68",
            width: "160",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "316",
            y: "84",
            width: "80",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            y: "136",
            width: "48",
            height: "48",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "64",
            y: "148",
            width: "160",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "64",
            y: "164",
            width: "80",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "252",
            y: "136",
            width: "48",
            height: "48",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "316",
            y: "148",
            width: "160",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "316",
            y: "164",
            width: "80",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            y: "216",
            width: "48",
            height: "48",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "64",
            y: "228",
            width: "160",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "64",
            y: "244",
            width: "80",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "252",
            y: "216",
            width: "48",
            height: "48",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "316",
            y: "228",
            width: "160",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "316",
            y: "244",
            width: "80",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            y: "296",
            width: "180",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }));
    };
    var $8e7ccb3bff404caf$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($8e7ccb3bff404caf$var$Skeleton);
});
parcelRegister("7e46m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e67f4616e600fb22$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7NUKB;
    var $daQYX;
    var $6s1PB;
    var $4R6GH;
    var $8Q4sF;
    var $koVbs;
    var $DVljb;
    var $l8ruj;
    var $jWlFw;
    var $3iDn2;
    var $dLD8P;
    var $gdKUE;
    var $koEqp;
    var $kbgBa;
    var $7TJr2;
    var $6rokB;
    var $fIkt8;
    var $arAQK;
    var $hduOK;
    var $2qgdI;
    var $4I0ZP;
    const $e67f4616e600fb22$var$TypesOfWork = ({ position: position })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { data: data, loading: loading, fetch: fetch, fetchNext: fetchNext, loadingNext: loadingNext } = (0, (0, parcelRequire("6rokB")).default)();
        const { hasCreateItem: hasCreateItem, hasManageTypesButton: hasManageTypesButton, linksTarget: linksTarget, issuesLinkUrl: issuesLinkUrl } = (0, (0, parcelRequire("7TJr2")).useSummaryFeatures)();
        const project = (0, (0, parcelRequire("4R6GH")).fg)('jwm_summary_page_inline_issue_types_targeting_gate') ? (0, (0, parcelRequire("daQYX")).useProject)() : null;
        const isTmp = project?.isSimplified ?? false;
        const locale = (0, (0, parcelRequire("4R6GH")).fg)('jwm_summary_page_inline_issue_types_targeting_gate') ? (0, (0, parcelRequire("DVljb")).useLocale)() : null;
        const isEnglishLocale = locale ? locale.includes('en') : false;
        const { startHoverTimer: startHoverTimer, stopHoverTimer: stopHoverTimer, fireSectionAnalytics: fireSectionAnalytics } = (0, (0, parcelRequire("kbgBa")).useSectionAnalytics)(position, 'typesOfWork');
        const issueTypeNames = data?.issueTypes.map(({ issueType: currentIssueType })=>currentIssueType.name);
        let content;
        if (loading) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7NUKB")).default), {
            name: "types-of-work"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4I0ZP")).CenteredSkeleton), {
            testId: "business-summary.ui.summary-view.types-of-work.skeleton"
        }));
        else {
            const headers = {
                identifier: formatMessage((0, (0, parcelRequire("2qgdI")).default).issueTypeColumnHeader),
                percentageBar: formatMessage((0, (0, parcelRequire("2qgdI")).default).issueDistributionColumnHeader),
                count: formatMessage((0, (0, parcelRequire("2qgdI")).default).countColumnHeader)
            };
            content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($e67f4616e600fb22$var$Description, null, data?.totalUnresolvedIssues === 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, (0, parcelRequire("2qgdI")).default).descriptionWhenEmpty), hasCreateItem && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, ' ', (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dLD8P")).default), {
                href: `${issuesLinkUrl}?inlineCreate=true`,
                onClick: ()=>fireSectionAnalytics('view', {
                        inlineCreate: true
                    }),
                target: linksTarget
            }))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Q4sF")).FormattedI18nMessage), {
                message: formatMessage((0, (0, parcelRequire("2qgdI")).default).description, {
                    linkStart: '{linkStart}',
                    linkEnd: '{linkEnd}'
                }),
                componentsMapping: {
                    link: ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jWlFw")).default), {
                            href: `${issuesLinkUrl}?direction=ASC&sortBy=issuetype`,
                            target: linksTarget,
                            onClick: ()=>fireSectionAnalytics('view', {
                                    inlineCreate: false
                                }),
                            "aria-label": formatMessage((0, (0, parcelRequire("2qgdI")).default).viewAllItemsLabel)
                        }, children)
                }
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gdKUE")).default), {
                loading: loadingNext,
                onScrollToEnd: fetchNext,
                headers: headers,
                label: formatMessage((0, (0, parcelRequire("2qgdI")).default).title)
            }, data && data.issueTypes.map(({ id: id, issueType: issueType, count: count })=>isTmp && hasManageTypesButton && isEnglishLocale && (0, (0, parcelRequire("6s1PB")).expVal)('jwm_summary_page_inline_issue_types_change', 'isInlineIssueTypesEnabled', false) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("arAQK")).default), {
                    key: id,
                    count: count,
                    totalCount: data.totalUnresolvedIssues,
                    issueType: issueType,
                    position: position,
                    issueTypeNames: issueTypeNames,
                    refetchIssueTypes: fetch
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("koEqp")).default), {
                    key: id,
                    iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($e67f4616e600fb22$var$IssueType, {
                        src: issueType.iconUrl,
                        alt: ""
                    }),
                    itemCount: count,
                    totalCount: data.totalUnresolvedIssues,
                    linkUrl: `${issuesLinkUrl}?filter=${encodeURIComponent(`type = '${issueType.name.split("'").join("\\'")}' AND ${(0, $cd053842fd66588d$export$c49e48bfa75ab23c)}`)}`,
                    onRowLinkClick: ()=>fireSectionAnalytics('viewWithFilter', {
                            count: count
                        }),
                    linkTarget: linksTarget,
                    name: issueType.name
                }))), hasManageTypesButton && (isTmp && isEnglishLocale && (0, (0, parcelRequire("6s1PB")).expVal)('jwm_summary_page_inline_issue_types_change', 'isInlineIssueTypesEnabled', false) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fIkt8")).AddIssueTypes), {
                onAddIssueTypesButtonClick: ()=>fireSectionAnalytics('addIssueTypes'),
                onIssueTypesHierarchyEducationButtonClick: ()=>fireSectionAnalytics('tipsForHierarcyEducationIssueTypes'),
                onIssueTypeCreated: fetch,
                testId: "business-summary.ui.summary-view.types-of-work.create-issue-types"
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hduOK")).default), {
                onClick: ()=>fireSectionAnalytics('manageTypes')
            })));
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "business-summary-types-of-work"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iDn2")).default), {
            title: formatMessage((0, (0, parcelRequire("2qgdI")).default).title),
            isLoading: loading,
            testId: "business-summary.ui.summary-view.types-of-work",
            onPointerEnter: startHoverTimer,
            onPointerLeave: stopHoverTimer
        }, content));
    };
    var $e67f4616e600fb22$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($e67f4616e600fb22$var$TypesOfWork);
    const $e67f4616e600fb22$var$Description = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                __cmplp.className
            ])
        });
    });
    const $e67f4616e600fb22$var$IssueType = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1tcg _1bsb1tcg _2rkoglpi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("gdKUE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb01aad17e9f3730$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $113Tq;
    var $l8Afc;
    const $cb01aad17e9f3730$var$PercentageBarTable = ({ headers: headers, onScrollToEnd: onScrollToEnd, loading: loading, children: children, label: label })=>{
        const { onScroll: onScroll } = (0, (0, parcelRequire("l8Afc")).useScrollToEnd)({
            onScrollToEnd: onScrollToEnd,
            isDisabled: loading,
            options: {
                onEndReachedThreshold: 50
            }
        });
        const { identifier: identifier, percentageBar: percentageBar, count: count } = headers;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($cb01aad17e9f3730$var$ScrollableWrapper, {
            onScroll: onScroll
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("table", {
            "aria-label": label
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($cb01aad17e9f3730$var$TableHead, null, (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, (0, ($parcel$interopDefault($5uXOq))).createElement($cb01aad17e9f3730$var$IdentifierColumnHeader, null, identifier), (0, ($parcel$interopDefault($5uXOq))).createElement($cb01aad17e9f3730$var$BarColumnHeader, null, percentageBar), (0, ($parcel$interopDefault($5uXOq))).createElement($cb01aad17e9f3730$var$CountColumnHeader, null, count))), (0, ($parcel$interopDefault($5uXOq))).createElement($cb01aad17e9f3730$var$TableBody, null, children)), loading && (0, ($parcel$interopDefault($5uXOq))).createElement($cb01aad17e9f3730$var$SpinnerWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("113Tq")).default), {
            testId: "business-summary.common.ui.percentage-bar-table.spinner"
        })));
    };
    var $cb01aad17e9f3730$export$2e2bcd8739ae039 = $cb01aad17e9f3730$var$PercentageBarTable;
    const $cb01aad17e9f3730$var$TABLE_HEADER_HEIGHT = 24;
    const $cb01aad17e9f3730$var$ScrollableWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s8a2pq _1yt41e2i _18m91wug _16jlidpf _1o9zkb7n _i0dl1wug _11q71saz",
                __cmplp.className
            ])
        });
    });
    const $cb01aad17e9f3730$var$TableHead = (0, $5uXOq.forwardRef)(({ as: C = "thead", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19itglyw",
                __cmplp.className
            ])
        });
    });
    const $cb01aad17e9f3730$var$TableBody = (0, $5uXOq.forwardRef)(({ as: C = "tbody", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19itglyw",
                __cmplp.className
            ])
        });
    });
    const $cb01aad17e9f3730$var$BarColumnHeader = (0, $5uXOq.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_vwz47vkz _k48pbfng _syaz1wmz _kqsw1if8 _154iidpf _11q7hp5a _1pbykb7n _vchhusvi _4t3i1tcg",
                __cmplp.className
            ])
        });
    });
    const $cb01aad17e9f3730$var$IdentifierColumnHeader = (0, $5uXOq.forwardRef)(({ as: C = $cb01aad17e9f3730$var$BarColumnHeader, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1lit",
                __cmplp.className
            ])
        });
    });
    const $cb01aad17e9f3730$var$CountColumnHeader = (0, $5uXOq.forwardRef)(({ as: C = $cb01aad17e9f3730$var$BarColumnHeader, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1wqb _y3gnusic",
                __cmplp.className
            ])
        });
    });
    const $cb01aad17e9f3730$var$SpinnerWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c11p5 _1bah1h6o _18s8utpp",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("koEqp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$92421e35bc0cffe9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $6s1PB;
    var $hDzhb;
    var $7bEfu;
    var $lXGVD;
    const $92421e35bc0cffe9$var$PercentageBarRow = ({ iconBefore: iconBefore, itemCount: itemCount, totalCount: totalCount, barColor: barColor, name: name, linkUrl: linkUrl, onRowLinkClick: onRowLinkClick, linkTarget: linkTarget, actions: actions })=>{
        const percentage = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("lXGVD")).calcPercentage)(totalCount, itemCount), [
            totalCount,
            itemCount
        ]);
        const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jwm_summary_page_inline_issue_types_change');
        const isInlineIssueTypesEnabled = expConfig.get('isInlineIssueTypesEnabled', false);
        const content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($92421e35bc0cffe9$var$IdentifierCell, null, iconBefore, name != null && (0, ($parcel$interopDefault($5uXOq))).createElement($92421e35bc0cffe9$var$IdentifierName, {
            "data-testid": "business-summary.common.ui.percentage-bar-table.percentage-bar-row.identifier-name"
        }, name), actions != null && (0, ($parcel$interopDefault($5uXOq))).createElement($92421e35bc0cffe9$var$ActionsWrapper, null, actions)), (0, ($parcel$interopDefault($5uXOq))).createElement("td", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7bEfu")).default), {
            percentage: percentage,
            color: barColor
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($92421e35bc0cffe9$var$CountCell, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hDzhb")).default), {
            href: linkUrl,
            target: linkTarget,
            onClick: onRowLinkClick
        }, itemCount)));
        return isInlineIssueTypesEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement($92421e35bc0cffe9$var$Row, null, content) : (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, content);
    };
    const $92421e35bc0cffe9$export$95dd84bae798753c = 160;
    const $92421e35bc0cffe9$export$685f1c917853c2fc = 60;
    var $92421e35bc0cffe9$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($92421e35bc0cffe9$var$PercentageBarRow);
    const $92421e35bc0cffe9$var$Row = (0, $5uXOq.forwardRef)(({ as: C = "tr", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _1vchb3bt _vw87b3bt _1su61osq _1aum1osq _1wn1u2gc _16q2u2gc _13rbglpi _1yrjglpi _qybkglpi _oatjglpi _1yw4stnw _1wg6stnw _cvyhze3t _1fhpze3t _1d6vx0bf _gl8xx0bf _113b108i _1xqc108i _1wnsb3bt _1boqb3bt _iceo1osq _1kmz1osq _1j70u2gc _1uxru2gc _1svlglpi _14ovglpi _lsxsglpi _vbk1glpi _qa15stnw _ixiwstnw _1mhnze3t _l3jaze3t _1xpgx0bf _1j2wx0bf _8ve6108i _4tpu108i _10j7108i _irr3108i _11r3kb7n _39e3kb7n _179a1wug _1cso1wug",
                __cmplp.className
            ])
        });
    });
    const $92421e35bc0cffe9$var$ActionsWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _16jlidpf _1o9zkb7n _i0dlf1ug _16jlkb7n _tzy4fuy8 _1bsb15yu _p12f1osq _c71l1u1b",
                __cmplp.className
            ])
        });
    });
    const $92421e35bc0cffe9$var$IdentifierCell = (0, $5uXOq.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _zulpu2gc _4cvr1h6o _1bsb1lit _1tke14no",
                __cmplp.className
            ])
        });
    });
    const $92421e35bc0cffe9$var$IdentifierName = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
                __cmplp.className
            ])
        });
    });
    const $92421e35bc0cffe9$var$CountCell = (0, $5uXOq.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1wqb _y3gnusic _k48pbfng",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7bEfu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f5e1934410c90bfb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $f5e1934410c90bfb$var$PercentageBar = ({ percentage: percentage, color: color = `var(--ds-background-neutral-bold, ${0, $72ba03e317f3d228$export$eece5f492e429f08})` })=>(0, ($parcel$interopDefault($5uXOq))).createElement($f5e1934410c90bfb$var$PercentageBarWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($f5e1934410c90bfb$var$BarWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($f5e1934410c90bfb$var$Bar, {
            barColor: color,
            percentage: percentage
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($f5e1934410c90bfb$var$PercentageWrapper, null, percentage, "%"));
    var $f5e1934410c90bfb$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($f5e1934410c90bfb$var$PercentageBar);
    const $f5e1934410c90bfb$var$BAR_HEIGHT = 12;
    const $f5e1934410c90bfb$var$BAR_BORDER_RADIUS = $f5e1934410c90bfb$var$BAR_HEIGHT / 2;
    const $f5e1934410c90bfb$var$PercentageBarWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $f5e1934410c90bfb$var$BarWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _4t3i1crf _2rkoi2wt _bfhk134c",
                __cmplp.className
            ])
        });
    });
    const $f5e1934410c90bfb$var$Bar = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { barColor: barColor, percentage: percentage, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_96awuh": (0, (0, parcelRequire("lD23V")).default)(__cmplp.barColor),
                "--_6wa3km": (0, (0, parcelRequire("lD23V")).default)(__cmplp.percentage, "%")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhkm9ld _2rkoi2wt",
                __cmplp.percentage > 0 ? "_1bsbge15" : "_1bsbidpf",
                __cmplp.className
            ])
        });
    });
    const $f5e1934410c90bfb$var$PercentageWrapper = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1wqb _y3gnusic _k48pbfng",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("lXGVD", function(module, exports) {
    $parcel$export(module.exports, "calcPercentage", ()=>$15ae94ae477d399f$export$e687d7efb14a396b);
    const $15ae94ae477d399f$export$e687d7efb14a396b = (total, value)=>{
        if (total === 0) return total;
        return Math.round(value / total * 100);
    };
});
parcelRegister("6rokB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$adf2e3e58ef747f8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5GlnB;
    var $6s1PB;
    var $dG5lw;
    var $95H4q;
    const $adf2e3e58ef747f8$var$usePagedIssuesByType = ()=>{
        const { data: initialData, loading: initialLoading, error: initialError } = (0, (0, parcelRequire("95H4q")).useIssuesByType)();
        const fetchIssuesByType = (0, (0, parcelRequire("dG5lw")).default)();
        const { data: issueTypes, error: nextPageError, hasNextPage: hasNextPage, loadingNext: loadingNext, fetch: fetch, fetchNext: fetchNext, reset: reset, loading: loading } = (0, (0, parcelRequire("5GlnB")).usePagination)(fetchIssuesByType);
        const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jwm_summary_page_inline_issue_types_change');
        const isInlineIssueTypesEnabled = expConfig.get('isInlineIssueTypesEnabled', false);
        (0, $5uXOq.useEffect)(()=>{
            if (initialData != null) reset({
                data: initialData.data,
                pageInfo: initialData.pageInfo
            });
        }, [
            initialData,
            reset
        ]);
        const data = (0, $5uXOq.useMemo)(()=>initialData && issueTypes ? {
                issueTypes: issueTypes,
                totalUnresolvedIssues: initialData.totalUnresolvedIssues
            } : null, [
            issueTypes,
            initialData
        ]);
        return {
            data: data,
            loading: isInlineIssueTypesEnabled ? initialLoading || loading : initialLoading,
            loadingNext: loadingNext,
            error: initialError || nextPageError,
            hasNextPage: hasNextPage,
            fetch: fetch,
            fetchNext: fetchNext
        };
    };
    var $adf2e3e58ef747f8$export$2e2bcd8739ae039 = $adf2e3e58ef747f8$var$usePagedIssuesByType;
});
parcelRegister("dG5lw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aaff2107d29f3c3c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5YBrl;
    var $jlq4V;
    var $egekd;
    var $jcw0u;
    var $eusud;
    var $jXe9w;
    const $aaff2107d29f3c3c$var$QUERY_NAME = 'IssuesByTypeData';
    const $aaff2107d29f3c3c$var$useFetchIssuesByType = ()=>{
        const jqlContext = (0, (0, parcelRequire("5YBrl")).useJqlContext)();
        const handleError = (0, $5uXOq.useCallback)((error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: $aaff2107d29f3c3c$var$QUERY_NAME,
                    packageName: 'jiraBusinessSummary',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }, []);
        const fetch = (0, $5uXOq.useCallback)((after)=>(0, (0, parcelRequire("eusud")).performPostRequest)(`/rest/gira/1/?operation=${$aaff2107d29f3c3c$var$QUERY_NAME}`, {
                body: JSON.stringify({
                    query: (0, (0, parcelRequire("jXe9w")).ISSUES_BY_TYPE_QUERY),
                    variables: {
                        jql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$c49e48bfa75ab23c)}`,
                        pageSize: (0, $cd053842fd66588d$export$c0ecd9bd08a86184),
                        after: after
                    }
                })
            }).then((response)=>{
                if (response.errors != null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
                return (0, (0, parcelRequire("egekd")).transformIssuesByTypeData)(response.data.issuesByType);
            }).catch(handleError), [
            handleError,
            jqlContext
        ]);
        return fetch;
    };
    var $aaff2107d29f3c3c$export$2e2bcd8739ae039 = $aaff2107d29f3c3c$var$useFetchIssuesByType;
});
parcelRegister("jXe9w", function(module, exports) {
    $parcel$export(module.exports, "ISSUES_BY_TYPE_QUERY", ()=>$9077874cd922f439$export$547a994d0ac40539);
    const $9077874cd922f439$export$547a994d0ac40539 = `
  query JiraBusinessIssuesByTypeData($jql: String!, $pageSize: Int!, $after: String) {
    issuesByType: jwmItemGroups(jql: $jql, first: $pageSize, after: $after, fieldIds: [], groupByFieldId: "issuetype", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByTypeFragment
    }
  }

  ${(0, $cd053842fd66588d$export$5b2a5373659a0414)}
`;
});
parcelRegister("fIkt8", function(module, exports) {
    $parcel$export(module.exports, "AddIssueTypes", ()=>$72233fd9c176dedf$export$cb0a876caa864ea4);
    var $5uXOq = parcelRequire("5uXOq");
    var $fm763;
    var $99gde;
    var $1iFQe;
    var $k31Nl;
    const $72233fd9c176dedf$export$cb0a876caa864ea4 = ({ onAddIssueTypesButtonClick: onAddIssueTypesButtonClick, onIssueTypesHierarchyEducationButtonClick: onIssueTypesHierarchyEducationButtonClick, onIssueTypeCreated: onIssueTypeCreated, testId: testId })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fm763")).default), {
            space: "space.200",
            testId: testId,
            xcss: $72233fd9c176dedf$var$addIssueTypesStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iFQe")).default), {
            onClick: onAddIssueTypesButtonClick,
            onIssueTypeCreated: onIssueTypeCreated
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k31Nl")).IssueTypesHierarchyEducationButton), {
            onClick: onIssueTypesHierarchyEducationButtonClick
        }));
    };
    const $72233fd9c176dedf$var$addIssueTypesStyles = (0, (0, parcelRequire("99gde")).xcss)({
        paddingBlock: 'space.100'
    });
});
parcelRegister("1iFQe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0bd3a3969ee04a4b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $63TD8;
    var $6Ll2T;
    var $3srSR;
    var $a95o8;
    var $99gde;
    var $ZuPvl;
    var $daQYX;
    var $jimnS;
    var $koVbs;
    var $2KAtx;
    var $8zOmE;
    var $lwMsT;
    var $koeKL;
    var $7hgMA;
    const $0bd3a3969ee04a4b$var$modalConfigProps = {
        width: 424
    };
    const $0bd3a3969ee04a4b$var$AddIssueTypesButton = ({ onClick: onClick, onIssueTypeCreated: onIssueTypeCreated })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { key: projectKey } = (0, (0, parcelRequire("daQYX")).useProject)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const handleIssueTypeCreated = (0, $5uXOq.useCallback)(()=>{
            onIssueTypeCreated();
        }, [
            onIssueTypeCreated
        ]);
        const onCloseCreateIssueTypesModal = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'createIssueTypesModal',
                action: 'dismissed'
            }), 'createIssueTypesModalDismissed');
        }, [
            createAnalyticsEvent
        ]);
        const entryPointProps = (0, $5uXOq.useMemo)(()=>({
                onIssueTypeCreated: handleIssueTypeCreated,
                issueTypesCountLimit: 30,
                onClose: onCloseCreateIssueTypesModal
            }), [
            handleIssueTypeCreated,
            onCloseCreateIssueTypesModal
        ]);
        const entryPointParams = (0, $5uXOq.useMemo)(()=>({
                cloudId: cloudId,
                projectKey: projectKey
            }), [
            cloudId,
            projectKey
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KAtx")).ModalEntryPointPressableTrigger), {
            entryPoint: (0, (0, parcelRequire("jimnS")).asyncCreateIssueTypeModalEntryPoint),
            entryPointProps: entryPointProps,
            entryPointParams: entryPointParams,
            interactionName: "open-create-issue-type-modal",
            modalProps: $0bd3a3969ee04a4b$var$modalConfigProps,
            useInternalModal: false
        }, ({ ref: ref })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                ref: ref
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a95o8")).default), {
                onClick: onClick,
                backgroundColor: "color.background.neutral.subtle",
                xcss: $0bd3a3969ee04a4b$var$buttonStyles,
                testId: "business-summary.ui.summary-view.types-of-work.add-issue-types.add-issue-types-button"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3srSR")).default), {
                xcss: $0bd3a3969ee04a4b$var$addIconWrapperStyles,
                alignItems: "center",
                justifyContent: "center"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("63TD8"))))), {
                label: "",
                color: "var(--ds-icon, #44546F)"
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
                weight: "medium",
                color: "color.text.subtle"
            }, formatMessage((0, (0, parcelRequire("7hgMA")).default).addIssueTypes)))));
    };
    var $0bd3a3969ee04a4b$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($0bd3a3969ee04a4b$var$AddIssueTypesButton);
    const $0bd3a3969ee04a4b$var$addIconWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        height: '24px',
        width: '24px',
        borderRadius: 'border.radius',
        backgroundColor: 'color.background.neutral'
    });
    const $0bd3a3969ee04a4b$var$buttonStyles = (0, (0, parcelRequire("99gde")).xcss)({
        padding: 'space.025',
        color: 'color.text.subtlest',
        display: 'flex',
        alignItems: 'center',
        gap: 'space.075',
        justifyContent: 'center',
        ':hover': {
            textDecoration: 'underline'
        }
    });
});
parcelRegister("jimnS", function(module, exports) {
    $parcel$export(module.exports, "asyncCreateIssueTypeModalEntryPoint", ()=>$6ddc7f661493d5a6$export$7f9428aac5b01dff);
    var $ekCoo;
    var $evanD;
    var $7KfpL;
    const $6ddc7f661493d5a6$export$7f9428aac5b01dff = (0, (0, parcelRequire("7KfpL")).createEntryPoint)({
        root: (0, (0, parcelRequire("evanD")).JSResourceForInteraction)(()=>(parcelRequire("h8a3D")), {
            moduleId: "7c2525a9"
        }),
        getPreloadProps: ({ projectKey: projectKey, cloudId: cloudId })=>({
                queries: {
                    createIssueTypeModal: {
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        parameters: (0, parcelRequire("ekCoo")).default,
                        variables: {
                            projectKey: projectKey,
                            cloudId: cloudId
                        }
                    }
                }
            })
    });
});
parcelRegister("ekCoo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1115b945d8dda421$export$2e2bcd8739ae039);
    const $1115b945d8dda421$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "projectKey"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "srcAsyncCreateIssueTypeQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v1,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProjectByKey",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "JiraIssueTypeConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypes",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "ui_createIssueTypeModal_CreateIssueTypeModalWrapper"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "jira.jiraProjectByKey.issueTypes"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.jiraProjectByKey"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "srcAsyncCreateIssueTypeQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueTypeConnection",
                                        "kind": "LinkedField",
                                        "name": "issueTypes",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "totalCount"
                                            },
                                            {
                                                "concreteType": "JiraIssueTypeEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueType",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "name"
                                                            },
                                                            {
                                                                "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                "kind": "LinkedField",
                                                                "name": "hierarchy",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "level"
                                                                    }
                                                                ]
                                                            },
                                                            v2
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    v2
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "080f51b73dbfd5b8ecd4690222d8ed6fa54c88bc0c261f78a2737930d2f36bf5",
                "metadata": {},
                "name": "srcAsyncCreateIssueTypeQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $1115b945d8dda421$var$node.hash = "c2de4a5e60ef0aa0115dfe315cfefd73";
    var $1115b945d8dda421$export$2e2bcd8739ae039 = $1115b945d8dda421$var$node;
});
parcelRegister("h8a3D", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("36vk3")
    ]).then(()=>parcelRequire('jUF9R'));
});
parcelRegister("7hgMA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3e7e4f5ccd9b2735$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3e7e4f5ccd9b2735$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        addIssueTypes: {
            "id": "business-summary.summary-view.types-of-work.add-issue-types.add-issue-types-button.add-issue-types",
            "defaultMessage": "Create issue type"
        }
    });
});
parcelRegister("k31Nl", function(module, exports) {
    $parcel$export(module.exports, "IssueTypesHierarchyEducationButton", ()=>$b4853888b153b559$export$94d1b9a8dd77c147);
    var $5uXOq = parcelRequire("5uXOq");
    var $28lNA;
    var $6Ll2T;
    var $3srSR;
    var $a95o8;
    var $ZuPvl;
    var $99gde;
    var $koVbs;
    var $ciz84;
    var $2KAtx;
    var $8zOmE;
    var $lwMsT;
    var $4uEgo;
    const $b4853888b153b559$export$94d1b9a8dd77c147 = ({ onClick: onClick, testId: testId })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const onCloseIssueTypesHierarchyEducationModal = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'issueTypesEducationModal',
                action: 'dismissed'
            }), 'issueTypesEducationModalDismissed');
        }, [
            createAnalyticsEvent
        ]);
        const entryPointProps = (0, $5uXOq.useMemo)(()=>({
                onClose: onCloseIssueTypesHierarchyEducationModal
            }), [
            onCloseIssueTypesHierarchyEducationModal
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KAtx")).ModalEntryPointPressableTrigger), {
            entryPoint: (0, (0, parcelRequire("ciz84")).issueTypesEducationModalEntryPoint),
            entryPointProps: entryPointProps,
            interactionName: "issue-types-hierarchy-education-modal",
            useInternalModal: true
        }, ({ ref: ref })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                ref: ref,
                testId: testId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a95o8")).default), {
                onClick: onClick,
                backgroundColor: "color.background.neutral.subtle",
                xcss: $b4853888b153b559$var$buttonStyles,
                testId: "business-summary.ui.summary-view.types-of-work.add-issue-types.issue-types-hierarchy-education-button"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3srSR")).default), {
                xcss: $b4853888b153b559$var$tipsIconWrapperStyles,
                alignItems: "center",
                justifyContent: "center"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("28lNA"))))), {
                label: ""
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
                weight: "medium",
                color: "color.text.subtle"
            }, formatMessage((0, (0, parcelRequire("4uEgo")).default).tipsButtonLabel)))));
    };
    const $b4853888b153b559$var$tipsIconWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        height: '24px',
        width: '24px',
        borderRadius: 'border.radius',
        backgroundColor: 'color.background.neutral'
    });
    const $b4853888b153b559$var$buttonStyles = (0, (0, parcelRequire("99gde")).xcss)({
        padding: 'space.025',
        color: 'color.text.subtlest',
        display: 'flex',
        alignItems: 'center',
        gap: 'space.075',
        justifyContent: 'center',
        ':hover': {
            textDecoration: 'underline'
        }
    });
});
parcelRegister("ciz84", function(module, exports) {
    $parcel$export(module.exports, "issueTypesEducationModalEntryPoint", ()=>$cb414b9ba5ccd5bf$export$4cb516aeed4c1424);
    var $evanD;
    var $7KfpL;
    const $cb414b9ba5ccd5bf$export$4cb516aeed4c1424 = (0, (0, parcelRequire("7KfpL")).createEntryPoint)({
        root: (0, (0, parcelRequire("evanD")).JSResourceForInteraction)(()=>(parcelRequire("fTEnQ")), {
            moduleId: "45278778"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("fTEnQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5Tlts").then(()=>parcelRequire('bXSBr'));
});
parcelRegister("4uEgo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a2780655120a03b4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a2780655120a03b4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        tipsButtonLabel: {
            "id": "business-summary.summary-view.types-of-work.add-issue-types.issue-types-hierarchy-education-button.tips-button-label",
            "defaultMessage": "What are issue types?"
        }
    });
});
parcelRegister("arAQK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$35f4531e101d5474$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $czVbS;
    var $euzYv;
    var $6Ll2T;
    var $fm763;
    var $99gde;
    var $loZC0;
    var $pa9q9;
    var $koVbs;
    var $8zOmE;
    var $lwMsT;
    var $7GkkF;
    var $4Z8SI;
    var $koEqp;
    var $kbgBa;
    var $7TJr2;
    var $jOye6;
    var $3oEfw;
    var $9RA5g;
    var $Cv8Qg;
    const $35f4531e101d5474$var$IssueTypeRow = ({ count: count, totalCount: totalCount, issueType: issueType, position: position, issueTypeNames: issueTypeNames, refetchIssueTypes: refetchIssueTypes })=>{
        const [isEditing, setIsEditing] = (0, $5uXOq.useState)(false);
        const { linksTarget: linksTarget, issuesLinkUrl: issuesLinkUrl } = (0, (0, parcelRequire("7TJr2")).useSummaryFeatures)();
        const { fireSectionAnalytics: fireSectionAnalytics } = (0, (0, parcelRequire("kbgBa")).useSectionAnalytics)(position, 'typesOfWork');
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const [optimisticallyUpdatedName, setOptimisticallyUpdatedName] = (0, $5uXOq.useState)('');
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const issueTypeFilteredListViewUrl = (0, $5uXOq.useCallback)((issueTypeName)=>`${issuesLinkUrl}?filter=${encodeURIComponent(`type = '${issueTypeName.split("'").join("\\'")}' AND ${(0, $cd053842fd66588d$export$c49e48bfa75ab23c)}`)}`, [
            issuesLinkUrl
        ]);
        const renameIssueType = (0, (0, parcelRequire("jOye6")).useRenameIssueType)(issueType);
        const upperCaseIssueTypeNames = (0, $5uXOq.useMemo)(()=>issueTypeNames?.map((name)=>name.toUpperCase()), [
            issueTypeNames
        ]);
        const validateIssueTypeName = (0, $5uXOq.useCallback)((newName)=>(0, (0, parcelRequire("Cv8Qg")).getInvalidIssueTypeNameContent)({
                newName: newName,
                oldName: issueType.name,
                issueTypeNameList: upperCaseIssueTypeNames,
                formatMessage: formatMessage
            })?.inline, [
            issueType.name,
            upperCaseIssueTypeNames,
            formatMessage
        ]);
        const saveIssueTypeName = (0, $5uXOq.useCallback)(async (name)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'edit submitted', 'inlineEditIssueTypes');
            setIsEditing(false);
            if (!name) return undefined;
            if (name === issueType.name) return undefined;
            const cleanedName = (0, (0, parcelRequire("kbgBa")).getCleanIssueTypesName)(name);
            const invalidIssueTypeFlag = (0, (0, parcelRequire("Cv8Qg")).getInvalidIssueTypeNameContent)({
                newName: name,
                oldName: issueType.name,
                issueTypeNameList: upperCaseIssueTypeNames,
                formatMessage: formatMessage
            })?.flag;
            if (invalidIssueTypeFlag) {
                (0, (0, parcelRequire("pa9q9")).showFlag)(invalidIssueTypeFlag);
                return;
            }
            setOptimisticallyUpdatedName(cleanedName);
            await renameIssueType(cleanedName, refetchIssueTypes);
            setOptimisticallyUpdatedName('');
        }, [
            issueType.name,
            upperCaseIssueTypeNames,
            formatMessage,
            renameIssueType,
            refetchIssueTypes,
            createAnalyticsEvent
        ]);
        const handleEditIssueType = (0, $5uXOq.useCallback)(()=>{
            setIsEditing(true);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'inlineEditIssueTypes');
        }, [
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("koEqp")).default), {
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fm763")).default), {
                xcss: $35f4531e101d5474$var$IssueTypeIconStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("euzYv")).default), {
                src: issueType.iconUrl,
                alt: "",
                height: `${(0, (0, parcelRequire("3oEfw")).ICON_SIZE)}px`,
                width: `${(0, (0, parcelRequire("3oEfw")).ICON_SIZE)}px`
            })),
            itemCount: count,
            totalCount: totalCount,
            linkUrl: issueTypeFilteredListViewUrl(issueType.name),
            onRowLinkClick: ()=>fireSectionAnalytics('viewWithFilter', {
                    count: count
                }),
            linkTarget: linksTarget,
            name: !isEditing ? optimisticallyUpdatedName || issueType.name : undefined,
            actions: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                paddingBlockEnd: "space.100"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4Z8SI")).default), {
                defaultValue: issueType.name,
                isEditing: isEditing,
                readView: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                        xcss: $35f4531e101d5474$var$iconButtonStyles,
                        testId: "business-summary.ui.summary-view.types-of-work.issue-type-row.edit-issue-type-button"
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
                        content: formatMessage((0, (0, parcelRequire("9RA5g")).default).editButtonTooltip),
                        position: "bottom"
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("czVbS"))))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }))),
                onCancel: ()=>setIsEditing(false),
                onConfirm: (updatedName)=>saveIssueTypeName(updatedName),
                onEdit: handleEditIssueType,
                onValidate: validateIssueTypeName,
                maxLength: (0, (0, parcelRequire("7GkkF")).ISSUE_TYPE_MAX_LENGTH)
            }))
        });
    };
    const $35f4531e101d5474$var$iconButtonStyles = (0, (0, parcelRequire("99gde")).xcss)({
        cursor: 'pointer'
    });
    const $35f4531e101d5474$var$IssueTypeIconStyles = (0, (0, parcelRequire("99gde")).xcss)({
        borderRadius: 'border.radius.050',
        flex: 'none'
    });
    var $35f4531e101d5474$export$2e2bcd8739ae039 = $35f4531e101d5474$var$IssueTypeRow;
});
parcelRegister("jOye6", function(module, exports) {
    $parcel$export(module.exports, "useRenameIssueType", ()=>$cc1dcf82f37d36b4$export$570d961606abec5b);
    var $5uXOq = parcelRequire("5uXOq");
    var $lwMsT;
    var $daQYX;
    var $cm8b5;
    var $jcw0u;
    var $jJZqs;
    var $pa9q9;
    var $koVbs;
    var $8zOmE;
    var $7GkkF;
    var $hnH54;
    var $4ppz2;
    var $dV8Qx;
    const $cc1dcf82f37d36b4$export$570d961606abec5b = (issueType)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const project = (0, (0, parcelRequire("daQYX")).useProject)();
        const fetchIssueLayoutConfiguration = (0, (0, parcelRequire("hnH54")).default)(project.id, issueType.id);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const startExperience = (0, (0, parcelRequire("cm8b5")).useExperienceStart)((0, (0, parcelRequire("7GkkF")).RENAME_ISSUE_TYPE_EXPERIENCE));
        const markExperienceSuccess = (0, (0, parcelRequire("cm8b5")).useExperienceSuccess)((0, (0, parcelRequire("7GkkF")).RENAME_ISSUE_TYPE_EXPERIENCE));
        const markExperienceFailed = (0, (0, parcelRequire("cm8b5")).useExperienceFail)((0, (0, parcelRequire("7GkkF")).RENAME_ISSUE_TYPE_EXPERIENCE));
        const abortExperience = (0, (0, parcelRequire("cm8b5")).useExperienceAbort)((0, (0, parcelRequire("7GkkF")).RENAME_ISSUE_TYPE_EXPERIENCE));
        return (0, $5uXOq.useCallback)(async (name, refetchIssueTypes)=>{
            try {
                startExperience();
                const issueLayoutConfiguration = await fetchIssueLayoutConfiguration();
                if (!issueLayoutConfiguration) throw new Error(`cannot find issue layout configuration for project: ${project.id} and issue type: ${issueType.id}`);
                await (0, (0, parcelRequire("4ppz2")).default)(project.id, issueLayoutConfiguration.id, Number(issueType.id), {
                    owners: [
                        {
                            data: {
                                ...issueLayoutConfiguration.owners,
                                name: name,
                                iconUrl: issueType.iconUrl,
                                id: Number(issueType.id)
                            },
                            type: 'ISSUE_TYPE'
                        }
                    ]
                });
                await refetchIssueTypes();
                markExperienceSuccess();
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'issueType updated');
            } catch (saveIssueTypeError) {
                if (saveIssueTypeError instanceof (0, (0, parcelRequire("jJZqs")).default) && saveIssueTypeError.statusCode === 409) {
                    (0, (0, parcelRequire("pa9q9")).showFlag)({
                        type: 'error',
                        title: formatMessage((0, (0, parcelRequire("dV8Qx")).default).errorFlagTitleRenameIssueType),
                        description: formatMessage((0, (0, parcelRequire("dV8Qx")).default).issueTypeNameAlreadyInUse)
                    });
                    abortExperience('Issue type name already exists');
                    return;
                }
                markExperienceFailed('Failed to rename issue type', saveIssueTypeError);
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: saveIssueTypeError,
                    meta: {
                        id: 'business-summary-types-of-work-rename-error',
                        packageName: 'jiraBusinessSummary'
                    }
                });
                (0, (0, parcelRequire("pa9q9")).showFlag)({
                    type: 'error',
                    title: formatMessage((0, (0, parcelRequire("dV8Qx")).default).errorFlagTitleRenameIssueType),
                    description: formatMessage((0, (0, parcelRequire("dV8Qx")).default).issueTypeNameNetworkError)
                });
            }
        }, [
            project.id,
            issueType.id,
            issueType.iconUrl,
            startExperience,
            abortExperience,
            markExperienceSuccess,
            markExperienceFailed,
            fetchIssueLayoutConfiguration,
            formatMessage,
            createAnalyticsEvent
        ]);
    };
});
parcelRegister("hnH54", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a483ae108c826e02$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jlq4V;
    var $jcw0u;
    var $eusud;
    var $eFtOm;
    const $a483ae108c826e02$var$QUERY_NAME = 'IssueLayoutConfigurationData';
    const $a483ae108c826e02$var$useFetchIssueLayoutConfiguration = (projectId, extraDefinerId)=>{
        const fetch = (0, $5uXOq.useCallback)(()=>(0, (0, parcelRequire("eusud")).performPostRequest)(`/rest/gira/1/?operation=${$a483ae108c826e02$var$QUERY_NAME}`, {
                body: JSON.stringify({
                    query: (0, $ad9c1dd39779eb04$export$8e602f914516b024),
                    variables: {
                        projectId: projectId,
                        extraDefinerId: extraDefinerId
                    }
                })
            }).then((response)=>{
                if (response.errors != null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
                const transformed = (0, (0, parcelRequire("eFtOm")).transformIssueLayoutConfiguration)(response.data);
                if (transformed.owners.avatarId == null || transformed.owners.description == null || transformed.id == null || transformed.name == null) throw new Error('query result is not valid');
                return transformed;
            }).catch((error)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: $a483ae108c826e02$var$QUERY_NAME,
                        packageName: 'jiraBusinessSummary',
                        teamName: 'wanjel'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }), [
            extraDefinerId,
            projectId
        ]);
        return fetch;
    };
    var $a483ae108c826e02$export$2e2bcd8739ae039 = $a483ae108c826e02$var$useFetchIssueLayoutConfiguration;
});
const $ad9c1dd39779eb04$export$8e602f914516b024 = `
  query JiraBusinessIssueLayoutConfigurationData ($projectId: Long!, $extraDefinerId: Long!){
  issueLayoutConfiguration(
    issueLayoutKey: {projectId: $projectId, extraDefinerId: $extraDefinerId}
    type: ISSUE_VIEW
  ) {
    ... on JiraIssueLayoutConfigurationResult {
      issueLayoutResult {
        id
        name
        usageInfo {
          ... on JiraIssueLayoutUsageInfoConnection {
            edges {
              currentProject
              node {
                layoutOwners {
                  ... on JiraIssueLayoutIssueTypeOwner {
                    description
                    avatarId
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`;
parcelRegister("eFtOm", function(module, exports) {
    $parcel$export(module.exports, "transformIssueLayoutConfiguration", ()=>$e0c735a25d0477e2$export$c6cc1e357108d43a);
    const $e0c735a25d0477e2$export$c6cc1e357108d43a = (data)=>({
            ...data.issueLayoutConfiguration.issueLayoutResult,
            owners: {
                ...data.issueLayoutConfiguration.issueLayoutResult.usageInfo?.edges[0]?.node.layoutOwners[0]
            },
            usageInfo: undefined
        });
});
parcelRegister("4ppz2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d5dd525f05b60a09$export$2e2bcd8739ae039);
    var $jcw0u;
    var $eusud;
    const $d5dd525f05b60a09$var$updateIssueType = (projectId, layoutId, extraDefinerId, { owners: owners })=>(0, (0, parcelRequire("eusud")).performPutRequest)(`/rest/internal/1.0/issueLayouts/${layoutId}`, {
            body: JSON.stringify({
                projectId: projectId,
                extraDefinerId: extraDefinerId,
                owners: owners,
                issueLayoutType: 'ISSUE_VIEW'
            })
        }).catch((restError)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'UpdateIssueType',
                    packageName: 'jiraBusinessSummary',
                    teamName: 'wanjel'
                },
                error: restError,
                sendToPrivacyUnsafeSplunk: true
            });
            throw restError;
        });
    var $d5dd525f05b60a09$export$2e2bcd8739ae039 = $d5dd525f05b60a09$var$updateIssueType;
});
parcelRegister("dV8Qx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ab428ca841a3d8f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6ab428ca841a3d8f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorFlagTitleRenameIssueType: {
            "id": "business-summary.controllers.rename-issue-types.error-flag-title-rename-issue-type",
            "defaultMessage": "Unable to rename"
        },
        issueTypeNameNetworkError: {
            "id": "business-summary.controllers.rename-issue-types.issue-type-name-network-error",
            "defaultMessage": "Unable to rename. Try again."
        },
        issueTypeNameAlreadyInUse: {
            "id": "business-summary.controllers.rename-issue-types.issue-type-name-already-in-use",
            "defaultMessage": "Issue type already exists. Try a different name."
        }
    });
});
parcelRegister("3oEfw", function(module, exports) {
    $parcel$export(module.exports, "ICON_SIZE", ()=>$09720948c7f1ed23$export$91a15f1424900d33);
    $parcel$export(module.exports, "StyledButton", ()=>$09720948c7f1ed23$export$2d5d2ba3c7c8c40b);
    $parcel$export(module.exports, "IconWrapper", ()=>$09720948c7f1ed23$export$be58b4326e23250f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $2APCZ;
    const $09720948c7f1ed23$export$91a15f1424900d33 = 24;
    const $09720948c7f1ed23$export$2d5d2ba3c7c8c40b = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("2APCZ")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wpz1y6m _18u0x0bf _19pku2gc",
                __cmplp.className
            ])
        });
    });
    const $09720948c7f1ed23$export$be58b4326e23250f = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1tcg _1bsb1tcg _2rkoglpi _2hwx12x7 _1e0c1txw _4cvr1h6o _1bah1h6o _bfhk155y",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("9RA5g", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0339a13c8aa5e1a1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0339a13c8aa5e1a1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorFlagTitleRenameIssueType: {
            "id": "business-summary.summary-view.types-of-work.issue-type-row.error-flag-title-rename-issue-type",
            "defaultMessage": "Unable to rename"
        },
        issueTypeNameTooLongError: {
            "id": "business-summary.summary-view.types-of-work.issue-type-row.issue-type-name-too-long-error",
            "defaultMessage": "Maximum {maxLength, plural, one {# character} other {# characters}}. Try a shorter name."
        },
        issueTypeNameAlreadyInUse: {
            "id": "business-summary.summary-view.types-of-work.issue-type-row.issue-type-name-already-in-use",
            "defaultMessage": "Issue type already exists. Try a different name."
        },
        editButtonTooltip: {
            "id": "business-summary.summary-view.types-of-work.issue-type-row.edit-button-tooltip",
            "defaultMessage": "Edit name"
        }
    });
});
parcelRegister("Cv8Qg", function(module, exports) {
    $parcel$export(module.exports, "getInvalidIssueTypeNameContent", ()=>$735dac5b4b1b9ab0$export$28d4cc20a6db78bf);
    var $7HGHK;
    var $7GkkF;
    var $9RA5g;
    const $735dac5b4b1b9ab0$export$28d4cc20a6db78bf = ({ newName: newName, oldName: oldName, issueTypeNameList: issueTypeNameList, formatMessage: formatMessage })=>{
        if (!newName) return undefined;
        if (newName === oldName) return undefined;
        if (newName.length > (0, (0, parcelRequire("7GkkF")).ISSUE_TYPE_MAX_LENGTH)) return {
            flag: {
                type: 'error',
                title: formatMessage((0, (0, parcelRequire("9RA5g")).default).errorFlagTitleRenameIssueType),
                description: formatMessage((0, (0, parcelRequire("9RA5g")).default).issueTypeNameTooLongError, {
                    maxLength: (0, (0, parcelRequire("7GkkF")).ISSUE_TYPE_MAX_LENGTH)
                }),
                id: (0, (0, parcelRequire("7HGHK")).toFlagId)('jwm-rename-issue-type-name-is-not-unique.flag')
            },
            inline: formatMessage((0, (0, parcelRequire("9RA5g")).default).issueTypeNameTooLongError, {
                maxLength: (0, (0, parcelRequire("7GkkF")).ISSUE_TYPE_MAX_LENGTH)
            })
        };
        if (issueTypeNameList?.includes(newName.toUpperCase())) return {
            flag: {
                type: 'error',
                title: formatMessage((0, (0, parcelRequire("9RA5g")).default).errorFlagTitleRenameIssueType),
                description: formatMessage((0, (0, parcelRequire("9RA5g")).default).issueTypeNameAlreadyInUse, {
                    newName: newName
                }),
                id: (0, (0, parcelRequire("7HGHK")).toFlagId)('jwm-rename-issue-type-name-is-not-unique.flag')
            },
            inline: formatMessage((0, (0, parcelRequire("9RA5g")).default).issueTypeNameAlreadyInUse, {
                newName: newName
            })
        };
        return undefined;
    };
});
parcelRegister("hduOK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8586afd230c58498$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iUdme;
    var $daQYX;
    var $dkvNx;
    var $koVbs;
    var $7TJr2;
    var $k8OPk;
    var $3oEfw;
    const $8586afd230c58498$var$ManageTypesButton = ({ onClick: onClick })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const project = (0, (0, parcelRequire("daQYX")).useProject)();
        const projectKey = project.key;
        const { linksTarget: linksTarget } = (0, (0, parcelRequire("7TJr2")).useSummaryFeatures)();
        const href = (0, (0, parcelRequire("dkvNx")).getIssueTypesSettingsUrl)(projectKey, project.isSimplified);
        const icon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3oEfw")).IconWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("iUdme"))))), {
            label: "",
            size: "small",
            primaryColor: `var(--ds-icon-subtle, ${(0, $72ba03e317f3d228$export$d6447c357493214f)})`
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3oEfw")).StyledButton), {
            href: href,
            target: linksTarget,
            onClick: onClick,
            iconBefore: icon,
            appearance: "subtle-link",
            testId: "business-summary.ui.summary-view.types-of-work.manage-types-button"
        }, formatMessage((0, (0, parcelRequire("k8OPk")).default).manageTypes));
    };
    var $8586afd230c58498$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($8586afd230c58498$var$ManageTypesButton);
});
parcelRegister("dkvNx", function(module, exports) {
    $parcel$export(module.exports, "getIssueTypesSettingsUrl", ()=>$7576de1b6386c946$export$b9500524016e18f0);
    const $7576de1b6386c946$export$b9500524016e18f0 = (projectKey, isSimplified)=>isSimplified ? `/jira/core/projects/${projectKey}/settings/issuetypes` : `/plugins/servlet/project-config/${projectKey}/issuetypes`;
});
parcelRegister("k8OPk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2c67b0df9c71b3f8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2c67b0df9c71b3f8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        manageTypes: {
            "id": "business-summary.summary-view.types-of-work.manage-types-button.manage-types",
            "defaultMessage": "Manage types"
        }
    });
});
parcelRegister("2qgdI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e0ce78fcd3ecde5d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e0ce78fcd3ecde5d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "business-summary.summary-view.types-of-work.title",
            "defaultMessage": "Types of work"
        },
        description: {
            "id": "business-summary.summary-view.types-of-work.description",
            "defaultMessage": "Get a breakdown of items by their types. {linkStart}View all items{linkEnd}"
        },
        descriptionWhenEmpty: {
            "id": "business-summary.summary-view.types-of-work.description-when-empty",
            "defaultMessage": "You'll need to create a few items for your project to get started."
        },
        issueTypeColumnHeader: {
            "id": "business-summary.summary-view.types-of-work.issue-type-column-header",
            "defaultMessage": "Type"
        },
        issueDistributionColumnHeader: {
            "id": "business-summary.summary-view.types-of-work.issue-distribution-column-header",
            "defaultMessage": "Distribution"
        },
        countColumnHeader: {
            "id": "business-summary.summary-view.types-of-work.count-column-header",
            "defaultMessage": "Count"
        },
        viewAllItemsLabel: {
            "id": "business-summary.summary-view.types-of-work.view-all-items-label",
            "defaultMessage": "View all issues with different types of work"
        }
    });
});
parcelRegister("4I0ZP", function(module, exports) {
    $parcel$export(module.exports, "CenteredSkeleton", ()=>$59336ee5187042b1$export$8faa72715fd79c70);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lw4Yq;
    const $59336ee5187042b1$export$8faa72715fd79c70 = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("lw4Yq")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("lw4Yq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9e0332b23ba0d651$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $9e0332b23ba0d651$var$Skeleton = ({ className: className, testId: testId })=>{
        const skeletonColor = `var(--ds-skeleton, ${(0, $72ba03e317f3d228$export$8d43898f60b96a82)})`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            viewBox: "0 0 476 296",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: className,
            "data-testid": testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "476",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            y: "16",
            width: "320",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            y: "64",
            width: "24",
            height: "24",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "32",
            y: "68",
            width: "93",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "141",
            y: "68",
            width: "265",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "422",
            y: "68",
            width: "52",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            y: "116",
            width: "24",
            height: "24",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "32",
            y: "120",
            width: "93",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "141",
            y: "120",
            width: "265",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "422",
            y: "120",
            width: "52",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            y: "168",
            width: "24",
            height: "24",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "32",
            y: "172",
            width: "93",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "141",
            y: "172",
            width: "265",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "422",
            y: "172",
            width: "52",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            y: "216",
            width: "24",
            height: "24",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "32",
            y: "220",
            width: "93",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "141",
            y: "220",
            width: "265",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "422",
            y: "220",
            width: "52",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            y: "260",
            width: "24",
            height: "24",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "32",
            y: "264",
            width: "93",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "141",
            y: "264",
            width: "265",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "422",
            y: "264",
            width: "52",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            y: "304",
            width: "24",
            height: "24",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "32",
            y: "308",
            width: "93",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "141",
            y: "308",
            width: "265",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "422",
            y: "308",
            width: "52",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }));
    };
    var $9e0332b23ba0d651$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($9e0332b23ba0d651$var$Skeleton);
});
parcelRegister("2Fiz0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1c8ba4e1c46ab946$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1IqIJ;
    var $7NUKB;
    var $8Q4sF;
    var $koVbs;
    var $l8ruj;
    var $jWlFw;
    var $3iDn2;
    var $dLD8P;
    var $gdKUE;
    var $koEqp;
    var $kbgBa;
    var $7TJr2;
    var $2Owyl;
    var $5A8KW;
    var $lzVMJ;
    var $dcGdr;
    var $lJuAo;
    var $9AdWb;
    const $1c8ba4e1c46ab946$var$NO_ASSIGNEE_VALUE = 'EMPTY';
    const $1c8ba4e1c46ab946$var$getAssigneeFilterLink = (issuesLinkUrl, user)=>`${issuesLinkUrl}?filter=${encodeURIComponent(`assignee = ${user?.accountId ?? $1c8ba4e1c46ab946$var$NO_ASSIGNEE_VALUE} AND ${(0, $cd053842fd66588d$export$c49e48bfa75ab23c)}`)}`;
    const $1c8ba4e1c46ab946$var$WorkloadByAssignee = ({ position: position })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { hasCreateItem: hasCreateItem, hasInviteTeammateButton: hasInviteTeammateButton, linksTarget: linksTarget, issuesLinkUrl: issuesLinkUrl } = (0, (0, parcelRequire("7TJr2")).useSummaryFeatures)();
        const { data: data, loading: loading, fetchNext: fetchNext, loadingNext: loadingNext } = (0, (0, parcelRequire("2Owyl")).default)();
        const { startHoverTimer: startHoverTimer, stopHoverTimer: stopHoverTimer, fireSectionAnalytics: fireSectionAnalytics } = (0, (0, parcelRequire("kbgBa")).useSectionAnalytics)(position, 'workloadByAssignee');
        const fireInviteUserAnalytics = (0, $5uXOq.useCallback)(()=>fireSectionAnalytics('inviteUser'), [
            fireSectionAnalytics
        ]);
        let content;
        if (loading) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7NUKB")).default), {
            name: "workload-by-assignee"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dcGdr")).CenteredSkeleton), {
            testId: "business-summary.ui.summary-view.workload-by-assignee.skeleton"
        }));
        else {
            const isEmptyProject = data?.totalUnresolvedIssues === 0;
            const hasNoIssuesAssigned = data?.assignees.length === 1 && data?.assignees[0].user == null;
            const description = hasNoIssuesAssigned ? (0, (0, parcelRequire("lzVMJ")).default).descriptionWhenNoIssuesAssigned : (0, (0, parcelRequire("lzVMJ")).default).description;
            const headers = {
                identifier: formatMessage((0, (0, parcelRequire("lzVMJ")).default).assigneeColumnHeader),
                percentageBar: formatMessage((0, (0, parcelRequire("lzVMJ")).default).workloadColumnHeader),
                count: formatMessage((0, (0, parcelRequire("lzVMJ")).default).countColumnHeader)
            };
            content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lJuAo")).Description), null, isEmptyProject ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, (0, parcelRequire("lzVMJ")).default).descriptionWhenEmpty), hasCreateItem && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, ' ', (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dLD8P")).default), {
                href: `${issuesLinkUrl}?inlineCreate=true`,
                onClick: ()=>fireSectionAnalytics('view', {
                        inlineCreate: true
                    }),
                target: linksTarget
            }))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Q4sF")).FormattedI18nMessage), {
                message: formatMessage(description, {
                    linkStart: '{linkStart}',
                    linkEnd: '{linkEnd}'
                }),
                componentsMapping: {
                    link: ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jWlFw")).default), {
                            href: `${issuesLinkUrl}?direction=ASC&sortBy=assignee`,
                            target: linksTarget,
                            onClick: ()=>fireSectionAnalytics('view', {
                                    inlineCreate: false
                                })
                        }, children)
                }
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gdKUE")).default), {
                loading: loadingNext,
                onScrollToEnd: fetchNext,
                headers: headers,
                label: formatMessage((0, (0, parcelRequire("lzVMJ")).default).title)
            }, data && data.assignees.map(({ id: id, user: user, count: count }, index)=>{
                const displayName = user?.displayName ?? formatMessage((0, (0, parcelRequire("lzVMJ")).default).unassigned);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("koEqp")).default), {
                    key: id,
                    iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1IqIJ")).default), {
                        src: user?.avatarUrl,
                        name: displayName
                    }),
                    itemCount: count,
                    totalCount: data.totalUnresolvedIssues,
                    barColor: user ? (0, (0, parcelRequire("9AdWb")).getColor)(index) : undefined,
                    name: displayName,
                    linkUrl: $1c8ba4e1c46ab946$var$getAssigneeFilterLink(issuesLinkUrl, user),
                    onRowLinkClick: ()=>fireSectionAnalytics('viewWithFilter', {
                            count: count,
                            isUnassigned: !user
                        }),
                    linkTarget: linksTarget
                });
            }), isEmptyProject && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("koEqp")).default), {
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1IqIJ")).default), {
                    name: formatMessage((0, (0, parcelRequire("lzVMJ")).default).unassigned)
                }),
                itemCount: 0,
                totalCount: 0,
                name: formatMessage((0, (0, parcelRequire("lzVMJ")).default).unassigned),
                linkUrl: $1c8ba4e1c46ab946$var$getAssigneeFilterLink(issuesLinkUrl, null),
                onRowLinkClick: ()=>fireSectionAnalytics('viewWithFilter', {
                        count: 0,
                        isUnassigned: true
                    }),
                linkTarget: linksTarget
            })), hasInviteTeammateButton && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5A8KW")).default), {
                onClick: fireInviteUserAnalytics
            }));
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "business-summary-workload-by-assignee"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iDn2")).default), {
            title: formatMessage((0, (0, parcelRequire("lzVMJ")).default).title),
            isLoading: loading,
            testId: "business-summary.ui.summary-view.workload-by-assignee",
            onPointerEnter: startHoverTimer,
            onPointerLeave: stopHoverTimer
        }, content));
    };
    var $1c8ba4e1c46ab946$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($1c8ba4e1c46ab946$var$WorkloadByAssignee);
});
parcelRegister("2Owyl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bdfa5243440773f9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5GlnB;
    var $1EcuR;
    var $95H4q;
    const $bdfa5243440773f9$var$usePagedIssuesByAssignee = ()=>{
        const { data: initialData, loading: initialLoading, error: initialError } = (0, (0, parcelRequire("95H4q")).useIssuesByAssignee)();
        const fetchIssuesByAssignee = (0, (0, parcelRequire("1EcuR")).default)();
        const { data: assignees, error: nextPageError, hasNextPage: hasNextPage, loadingNext: loadingNext, fetchNext: fetchNext, reset: reset } = (0, (0, parcelRequire("5GlnB")).usePagination)(fetchIssuesByAssignee);
        (0, $5uXOq.useEffect)(()=>{
            if (initialData != null) reset({
                data: initialData.data,
                pageInfo: initialData.pageInfo
            });
        }, [
            initialData,
            reset
        ]);
        const data = (0, $5uXOq.useMemo)(()=>initialData && assignees ? {
                assignees: assignees,
                totalUnresolvedIssues: initialData.totalUnresolvedIssues
            } : null, [
            assignees,
            initialData
        ]);
        return {
            data: data,
            loading: initialLoading,
            loadingNext: loadingNext,
            error: initialError || nextPageError,
            hasNextPage: hasNextPage,
            fetchNext: fetchNext
        };
    };
    var $bdfa5243440773f9$export$2e2bcd8739ae039 = $bdfa5243440773f9$var$usePagedIssuesByAssignee;
});
parcelRegister("1EcuR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e19b9c5685dcc585$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5YBrl;
    var $jlq4V;
    var $egekd;
    var $jcw0u;
    var $eusud;
    var $cpNcC;
    const $e19b9c5685dcc585$var$QUERY_NAME = 'IssuesByAssigneeData';
    const $e19b9c5685dcc585$var$useFetchIssuesByAssignee = ()=>{
        const jqlContext = (0, (0, parcelRequire("5YBrl")).useJqlContext)();
        const handleError = (0, $5uXOq.useCallback)((error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: $e19b9c5685dcc585$var$QUERY_NAME,
                    packageName: 'jiraBusinessSummary',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }, []);
        const fetch = (0, $5uXOq.useCallback)((after)=>(0, (0, parcelRequire("eusud")).performPostRequest)(`/rest/gira/1/?operation=${$e19b9c5685dcc585$var$QUERY_NAME}`, {
                body: JSON.stringify({
                    query: (0, (0, parcelRequire("cpNcC")).ISSUES_BY_ASSIGNEE_QUERY),
                    variables: {
                        jql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$c49e48bfa75ab23c)}`,
                        pageSize: (0, $cd053842fd66588d$export$c0ecd9bd08a86184),
                        after: after
                    }
                })
            }).then((response)=>{
                if (response.errors != null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
                return (0, (0, parcelRequire("egekd")).transformIssuesByAssigneeData)(response.data.issuesByAssignee);
            }).catch(handleError), [
            handleError,
            jqlContext
        ]);
        return fetch;
    };
    var $e19b9c5685dcc585$export$2e2bcd8739ae039 = $e19b9c5685dcc585$var$useFetchIssuesByAssignee;
});
parcelRegister("cpNcC", function(module, exports) {
    $parcel$export(module.exports, "ISSUES_BY_ASSIGNEE_QUERY", ()=>$b033daba467695d5$export$b50987cf704e54a4);
    const $b033daba467695d5$export$b50987cf704e54a4 = `
  query JiraBusinessIssuesByAssigneeData($jql: String!, $pageSize: Int!, $after: String) {
    issuesByAssignee: jwmItemGroups(jql: $jql, first: $pageSize, after: $after, fieldIds: [], groupByFieldId: "assignee", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByAssigneeFragment
    }
  }

  ${(0, $cd053842fd66588d$export$27f4fb65edc908d0)}
`;
});
parcelRegister("5A8KW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f8000c44ab8b3db6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $e1OxR;
    var $1l3YZ;
    const $f8000c44ab8b3db6$var$InviteTeammate = ({ onClick: onClick })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e1OxR")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1l3YZ")).default), {
            onClick: onClick
        }));
    var $f8000c44ab8b3db6$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($f8000c44ab8b3db6$var$InviteTeammate);
});
parcelRegister("e1OxR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0f3117b4e456671f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $heNNl;
    var $7wK4b;
    var $bZLPe;
    const $0f3117b4e456671f$var$AddPeopleModal = ({ shouldUseInvitePeopleModal: shouldUseInvitePeopleModal, source: source })=>{
        const { isModalOpen: isModalOpen, closeAddPeopleModal: closeAddPeopleModal } = (0, (0, parcelRequire("7wK4b")).useAddPeople)();
        if (isModalOpen) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bZLPe")).ProjectInvitePeopleModal), {
            onModalClose: closeAddPeopleModal,
            shouldUseInvitePeopleModal: shouldUseInvitePeopleModal,
            source: source
        });
        return null;
    };
    const $0f3117b4e456671f$var$AddPeople = ({ children: children, shouldUseInvitePeopleModal: shouldUseInvitePeopleModal, source: source })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7wK4b")).AddPeopleProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "jira-business.invite-people.ui.add-people",
            packageName: "jira-business.invite-people.ui.add-people",
            teamName: "jira-warepil"
        }, children, (0, ($parcel$interopDefault($5uXOq))).createElement($0f3117b4e456671f$var$InviteWrapper, {
            "data-testid": "business-invite-people.ui.add-people-with-avatars.add-people.invite-wrapper"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0f3117b4e456671f$var$AddPeopleModal, {
            shouldUseInvitePeopleModal: shouldUseInvitePeopleModal,
            source: source
        }))));
    var $0f3117b4e456671f$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($0f3117b4e456671f$var$AddPeople);
    const $0f3117b4e456671f$var$InviteWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0cglyw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7wK4b", function(module, exports) {
    $parcel$export(module.exports, "AddPeopleProvider", ()=>$3ebbf4ad1e53c7be$export$6d41c2327e862d9d);
    $parcel$export(module.exports, "useAddPeople", ()=>$3ebbf4ad1e53c7be$export$93ea361ec674cff6);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $8zOmE;
    var $lwMsT;
    const $3ebbf4ad1e53c7be$var$AddPeopleContext = (0, $5uXOq.createContext)({
        triggerBtnRef: {
            current: null
        },
        isModalOpen: false,
        openAddPeopleModal: ()=>{},
        closeAddPeopleModal: ()=>{}
    });
    const $3ebbf4ad1e53c7be$export$6d41c2327e862d9d = ({ children: children })=>{
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const [isModalOpen, setIsModalOpen] = (0, $5uXOq.useState)(false);
        const triggerBtnRef = (0, $5uXOq.useRef)(null);
        const onCloseCallbackRef = (0, $5uXOq.useRef)();
        const openAddPeopleModal = (0, $5uXOq.useCallback)((onClose, source)=>{
            setIsModalOpen(true);
            const eventName = projectData.isSimplified ? 'jwmProjectInviteComponent' : 'jwmInstanceInviteComponent';
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', eventName, {
                source: source
            });
            if (onClose) onCloseCallbackRef.current = onClose;
        }, [
            createAnalyticsEvent,
            projectData.isSimplified
        ]);
        const closeAddPeopleModal = (0, $5uXOq.useCallback)(()=>{
            setIsModalOpen(false);
            if (typeof onCloseCallbackRef.current === 'function') {
                onCloseCallbackRef.current();
                onCloseCallbackRef.current = null;
            }
        }, []);
        const context = (0, $5uXOq.useMemo)(()=>({
                triggerBtnRef: triggerBtnRef,
                isModalOpen: isModalOpen,
                openAddPeopleModal: openAddPeopleModal,
                closeAddPeopleModal: closeAddPeopleModal
            }), [
            triggerBtnRef,
            isModalOpen,
            openAddPeopleModal,
            closeAddPeopleModal
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($3ebbf4ad1e53c7be$var$AddPeopleContext.Provider, {
            value: context
        }, children);
    };
    const $3ebbf4ad1e53c7be$export$93ea361ec674cff6 = ()=>(0, $5uXOq.useContext)($3ebbf4ad1e53c7be$var$AddPeopleContext);
});
parcelRegister("bZLPe", function(module, exports) {
    $parcel$export(module.exports, "ProjectInvitePeopleModal", ()=>$74aeebd820c67267$export$6dfea89767cb5ac1);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $2erM2;
    var $cb8cx;
    var $9AFuM;
    const $74aeebd820c67267$export$6dfea89767cb5ac1 = ({ onModalClose: onModalClose, shouldUseInvitePeopleModal: shouldUseInvitePeopleModal = false, source: source })=>{
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const { handleAddSuccess: handleAddSuccess, handleError: handleError } = (0, (0, parcelRequire("2erM2")).useInviteModalHandlers)();
        if (!shouldUseInvitePeopleModal && projectData.isSimplified) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cb8cx")).AddPeopleModal), {
            onModalClose: onModalClose,
            onInviteSuccess: handleAddSuccess,
            onInviteError: handleError
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9AFuM")).InvitePeopleModal), {
            onModalClose: onModalClose,
            onInviteSuccess: handleAddSuccess,
            onInviteError: handleError,
            source: source
        });
    };
});
parcelRegister("2erM2", function(module, exports) {
    $parcel$export(module.exports, "useInviteModalHandlers", ()=>$d23a63b1c343bca5$export$f696e14fc423d0b);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $jcw0u;
    var $pa9q9;
    var $8zOmE;
    var $lwMsT;
    var $9OXo1;
    var $99ejj;
    var $kPioc;
    const $d23a63b1c343bca5$export$f696e14fc423d0b = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const { isSiteAdmin: isSiteAdmin } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const handleAddSuccess = (0, $5uXOq.useCallback)(({ modalType: modalType, totalPeopleAdded: totalPeopleAdded, email: email, inviteStatus: inviteStatus })=>{
            const hasSentInvitation = inviteStatus === (0, (0, parcelRequire("99ejj")).InvitationStatusEnum).INVITED;
            const hasSuccessfullyAddedPeople = !inviteStatus && projectData.permissions.administerProject;
            showFlag(hasSuccessfullyAddedPeople ? (0, (0, parcelRequire("kPioc")).createAddSuccessFlagConfig)({
                totalPeopleAdded: totalPeopleAdded,
                email: email,
                projectKey: projectData.key
            }) : (0, (0, parcelRequire("kPioc")).createInviteSuccessFlagConfig)({
                totalPeopleAdded: totalPeopleAdded,
                email: email,
                hasSentInvitation: hasSentInvitation
            }));
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), `jwm${modalType}Invite success`, {
                inviteStatus: inviteStatus
            });
        }, [
            createAnalyticsEvent,
            showFlag,
            projectData
        ]);
        const handleError = (0, $5uXOq.useCallback)(({ modalType: modalType, errorMessage: errorMessage, statusCode: statusCode })=>{
            if (errorMessage.includes((0, $20132b2015719a62$export$4e427f77b64bbbed)) || errorMessage.includes((0, $20132b2015719a62$export$20ef020abfaa9ec))) {
                showFlag((0, (0, parcelRequire("kPioc")).createInviteFailedUserLimitFlagConfig)(isSiteAdmin, createAnalyticsEvent));
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'userLimit reached', `jwm${modalType}Invite`);
                return;
            }
            if (errorMessage.includes((0, $20132b2015719a62$export$a1d765adf759361e))) showFlag((0, (0, parcelRequire("kPioc")).inviteFailBadRequestFlagConfig));
            else if (errorMessage.includes((0, $20132b2015719a62$export$c7f012c6e67c4217))) showFlag((0, (0, parcelRequire("kPioc")).inviteFailNetworkErrorFlagConfig));
            else if (errorMessage.includes((0, $20132b2015719a62$export$c8a538cf4ae41623)) || errorMessage.includes((0, $20132b2015719a62$export$9bbcbc11675c1278)) || errorMessage.includes((0, $20132b2015719a62$export$a51af3c30283d234))) showFlag((0, (0, parcelRequire("kPioc")).inviteFailGenericFlagConfig));
            else showFlag((0, (0, parcelRequire("kPioc")).inviteFailFlagConfig));
            const isClientError = statusCode && statusCode >= 400 && statusCode < 500;
            if (errorMessage.includes((0, $20132b2015719a62$export$14fb68f74ccc8b23)) || isClientError) return;
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: `jwm${modalType}Invite`,
                    packageName: (0, $20132b2015719a62$export$b8b9d90f9e5bd72b),
                    teamName: 'jira-warepil'
                },
                attributes: {
                    message: errorMessage
                },
                error: new Error(errorMessage),
                sendToPrivacyUnsafeSplunk: true
            });
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), `jwm${modalType}Invite failed`);
        }, [
            createAnalyticsEvent,
            isSiteAdmin,
            showFlag
        ]);
        return {
            handleAddSuccess: handleAddSuccess,
            handleError: handleError
        };
    };
});
const $20132b2015719a62$export$b8b9d90f9e5bd72b = 'jira-business.invite-people';
const $20132b2015719a62$export$a1d765adf759361e = 'Check your request, then give it another try.';
const $20132b2015719a62$export$c7f012c6e67c4217 = 'Check your network connection, then give it another try.';
const $20132b2015719a62$export$c8a538cf4ae41623 = 'AUTH_FAILED';
const $20132b2015719a62$export$9bbcbc11675c1278 = 'SERVER_ERROR';
const $20132b2015719a62$export$a51af3c30283d234 = 'USER_NOT_FOUND';
const $20132b2015719a62$export$4e427f77b64bbbed = 'LICENSE_LIMIT_REACHED';
const $20132b2015719a62$export$20ef020abfaa9ec = 'Licence Exceeded';
const $20132b2015719a62$export$14fb68f74ccc8b23 = 'Recaptcha validation failed';
parcelRegister("99ejj", function(module, exports) {
    $parcel$export(module.exports, "InvitationStatusEnum", ()=>$e49e7d7763027049$export$2e0a7d2dc28c9a18);
    const $e49e7d7763027049$export$2e0a7d2dc28c9a18 = {
        ACCESS_REQUESTED: 'ACCESS_REQUESTED',
        INVITED: 'INVITED'
    };
});
parcelRegister("kPioc", function(module, exports) {
    $parcel$export(module.exports, "inviteFailFlagConfig", ()=>$366128c003d2496b$export$95c6157ced8b3439);
    $parcel$export(module.exports, "inviteFailGenericFlagConfig", ()=>$366128c003d2496b$export$1108ab4b8a5d8a7d);
    $parcel$export(module.exports, "inviteFailBadRequestFlagConfig", ()=>$366128c003d2496b$export$7f2d6442eed4d708);
    $parcel$export(module.exports, "inviteFailNetworkErrorFlagConfig", ()=>$366128c003d2496b$export$c3bdacfc2255a9ed);
    $parcel$export(module.exports, "createInviteSuccessFlagConfig", ()=>$366128c003d2496b$export$d456881895c2a0b2);
    $parcel$export(module.exports, "createAddSuccessFlagConfig", ()=>$366128c003d2496b$export$cca35dec2a083169);
    $parcel$export(module.exports, "createInviteFailedUserLimitFlagConfig", ()=>$366128c003d2496b$export$251dc06b3962c565);
    var $8zOmE;
    var $6OFcj;
    const $366128c003d2496b$export$8c9a09c293b933fb = ({ specificDescription: specificDescription, agnosticDescription: agnosticDescription, totalPeopleAdded: totalPeopleAdded, email: email })=>{
        if (totalPeopleAdded <= 0) return [
            agnosticDescription,
            {}
        ];
        return [
            specificDescription,
            {
                totalPeopleAddedMinusOne: totalPeopleAdded - 1,
                totalPeopleAdded: totalPeopleAdded,
                email: email
            }
        ];
    };
    const $366128c003d2496b$export$95c6157ced8b3439 = {
        type: 'error',
        title: (0, (0, parcelRequire("6OFcj")).default).inviteFailedMessageTitle,
        description: (0, (0, parcelRequire("6OFcj")).default).inviteFailedMessageDescription,
        actions: [
            {
                content: (0, (0, parcelRequire("6OFcj")).default).inviteFailedMessageCta,
                onClick: ()=>window.open('/secure/ContactAdministrators!default.jspa', '_blank')
            }
        ],
        messageType: 'transactional'
    };
    const $366128c003d2496b$export$1108ab4b8a5d8a7d = {
        type: 'error',
        title: (0, (0, parcelRequire("6OFcj")).default).inviteFailedMessageTitle,
        description: (0, (0, parcelRequire("6OFcj")).default).inviteFailedGenericMessageDescription,
        messageType: 'transactional'
    };
    const $366128c003d2496b$export$7f2d6442eed4d708 = {
        type: 'error',
        title: (0, (0, parcelRequire("6OFcj")).default).inviteFailedMessageTitle,
        description: (0, (0, parcelRequire("6OFcj")).default).inviteFailedBadRequestMessageDescription,
        messageType: 'transactional'
    };
    const $366128c003d2496b$export$c3bdacfc2255a9ed = {
        type: 'error',
        title: (0, (0, parcelRequire("6OFcj")).default).inviteFailedMessageTitle,
        description: (0, (0, parcelRequire("6OFcj")).default).inviteFailedNetworkErrorMessageDescription,
        messageType: 'transactional'
    };
    const $366128c003d2496b$export$d456881895c2a0b2 = ({ totalPeopleAdded: totalPeopleAdded, email: email, hasSentInvitation: hasSentInvitation })=>{
        if (!hasSentInvitation) return {
            type: 'success',
            title: (0, (0, parcelRequire("6OFcj")).default).requestInviteSuccessMessageTitle,
            description: $366128c003d2496b$export$8c9a09c293b933fb({
                agnosticDescription: (0, (0, parcelRequire("6OFcj")).default).requestInviteSuccessMessageDescriptionAgnostic,
                specificDescription: (0, (0, parcelRequire("6OFcj")).default).requestInviteSuccessMessageDescription,
                totalPeopleAdded: totalPeopleAdded,
                email: email
            }),
            messageType: 'transactional'
        };
        return {
            type: 'success',
            title: (0, (0, parcelRequire("6OFcj")).default).inviteSuccessMessageTitle,
            description: $366128c003d2496b$export$8c9a09c293b933fb({
                agnosticDescription: (0, (0, parcelRequire("6OFcj")).default).inviteSuccessMessageDescriptionAgnostic,
                specificDescription: (0, (0, parcelRequire("6OFcj")).default).inviteSuccessMessageDescription,
                totalPeopleAdded: totalPeopleAdded,
                email: email
            }),
            messageType: 'transactional'
        };
    };
    const $366128c003d2496b$export$cca35dec2a083169 = ({ totalPeopleAdded: totalPeopleAdded, email: email, projectKey: projectKey })=>({
            type: 'success',
            title: (0, (0, parcelRequire("6OFcj")).default).peopleAddedSuccessMessageTitle,
            description: $366128c003d2496b$export$8c9a09c293b933fb({
                agnosticDescription: (0, (0, parcelRequire("6OFcj")).default).peopleAddedSuccessMessageDescriptionAgnostic,
                specificDescription: (0, (0, parcelRequire("6OFcj")).default).peopleAddedSuccessMessageDescription,
                totalPeopleAdded: totalPeopleAdded,
                email: email
            }),
            actions: [
                {
                    content: (0, (0, parcelRequire("6OFcj")).default).peopleAddedManageAccess,
                    onClick: ()=>window.location.assign(`/jira/core/projects/${projectKey}/settings/access`)
                }
            ],
            messageType: 'transactional'
        });
    const $366128c003d2496b$export$251dc06b3962c565 = (isSiteAdmin, createAnalyticsEvent)=>({
            type: 'warning',
            title: (0, (0, parcelRequire("6OFcj")).default).userLimitInviteErrorTitle,
            description: isSiteAdmin ? (0, (0, parcelRequire("6OFcj")).default).userLimitInviteErrorDescriptionAdmin : (0, (0, parcelRequire("6OFcj")).default).userLimitInviteErrorDescription,
            actions: isSiteAdmin ? [
                {
                    content: (0, (0, parcelRequire("6OFcj")).default).upgradePlan,
                    onClick: ()=>{
                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'upgradePlan');
                        window.open('/admin/billing/applications', '_blank');
                    }
                },
                {
                    content: (0, (0, parcelRequire("6OFcj")).default).viewUsers,
                    onClick: ()=>{
                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'viewUsers');
                        window.open('/admin/users', '_blank');
                    }
                }
            ] : [
                {
                    content: (0, (0, parcelRequire("6OFcj")).default).inviteFailedMessageCta,
                    onClick: ()=>{
                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'contactAdmin');
                        window.open('/secure/ContactAdministrators!default.jspa', '_blank');
                    }
                }
            ],
            messageType: 'transactional'
        });
});
parcelRegister("6OFcj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d87007b6d35f6d31$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d87007b6d35f6d31$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        inviteSuccessMessageTitle: {
            "id": "business-invite-people.controllers.modal-handlers.invite-success-message-title",
            "defaultMessage": "Invitation sent"
        },
        inviteSuccessMessageDescription: {
            "id": "business-invite-people.controllers.modal-handlers.invite-success-message-description",
            "defaultMessage": "You've invited {totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}} to this business project."
        },
        inviteSuccessMessageDescriptionAgnostic: {
            "id": "business-invite-people.controllers.modal-handlers.invite-success-message-description-agnostic",
            "defaultMessage": "You've successfully invited people to your business project."
        },
        inviteFailedMessageTitle: {
            "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-title",
            "defaultMessage": "Something went wrong"
        },
        inviteFailedMessageDescription: {
            "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-description",
            "defaultMessage": "We weren\u2019t able to invite any users. Contact your admin for help."
        },
        inviteFailedMessageCta: {
            "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-cta",
            "defaultMessage": "Contact your admin"
        },
        inviteFailedGenericMessageDescription: {
            "id": "business-invite-people.controllers.modal-handlers.invite-failed-generic-message-description",
            "defaultMessage": "We weren\u2019t able to invite any users, please try again."
        },
        inviteFailedBadRequestMessageDescription: {
            "id": "business-invite-people.controllers.modal-handlers.invite-failed-bad-request-message-description",
            "defaultMessage": "We weren\u2019t able to invite any users. Check your request, then give it another try."
        },
        inviteFailedNetworkErrorMessageDescription: {
            "id": "business-invite-people.controllers.modal-handlers.invite-failed-network-error-message-description",
            "defaultMessage": "We weren\u2019t able to invite any users. Check your network connection, then give it another try."
        },
        requestInviteSuccessMessageTitle: {
            "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-title",
            "defaultMessage": "Access request sent to your admin"
        },
        requestInviteSuccessMessageDescription: {
            "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-description",
            "defaultMessage": "Your admin needs to approve access for {totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}}."
        },
        requestInviteSuccessMessageDescriptionAgnostic: {
            "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-description-agnostic",
            "defaultMessage": "Your admin needs to approve access for people to your business project."
        },
        peopleAddedSuccessMessageTitle: {
            "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-title",
            "defaultMessage": "New people added"
        },
        peopleAddedSuccessMessageDescription: {
            "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-description",
            "defaultMessage": "{totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}} added to the project. You can also add teammates and manage their access to the project from Project settings"
        },
        peopleAddedSuccessMessageDescriptionAgnostic: {
            "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-description-agnostic",
            "defaultMessage": "People added to the project. You can also add teammates and manage their access to the project from Project settings"
        },
        peopleAddedManageAccess: {
            "id": "business-invite-people.controllers.modal-handlers.people-added-manage-access",
            "defaultMessage": "Manage access"
        },
        userLimitInviteErrorTitle: {
            "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-title",
            "defaultMessage": "Can't add more people"
        },
        userLimitInviteErrorDescriptionAdmin: {
            "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-description-admin",
            "defaultMessage": "You've reached your user limit. Upgrade your plan or remove other users."
        },
        userLimitInviteErrorDescription: {
            "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-description",
            "defaultMessage": "You've reached your user limit. Contact your admin for help."
        },
        viewUsers: {
            "id": "business-invite-people.controllers.modal-handlers.view-users",
            "defaultMessage": "View users"
        },
        upgradePlan: {
            "id": "business-invite-people.controllers.modal-handlers.upgrade-plan",
            "defaultMessage": "Upgrade plan"
        }
    });
});
parcelRegister("cb8cx", function(module, exports) {
    $parcel$export(module.exports, "AddPeopleModal", ()=>$4afbb4a2961eae5f$export$b28f48897cdf7241);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $daQYX;
    var $heNNl;
    var $lfTZh;
    var $5oFIy;
    var $itmJb;
    var $1jUsD;
    var $7wK4b;
    const $4afbb4a2961eae5f$export$a4917c848b5c6ce8 = (0, (0, parcelRequire("1jUsD")).lazy)(()=>(parcelRequire("7HRyA")), {
        ssr: false,
        moduleId: "./src/packages/permissions-administration/components/project-add-people/src/index.tsx"
    });
    const $4afbb4a2961eae5f$var$userInviteErrorCodes = {
        BAD_REQUEST_ERROR_CODE: $20132b2015719a62$export$a1d765adf759361e,
        NETWORK_ERROR_CODE: $20132b2015719a62$export$c7f012c6e67c4217,
        AUTH_FAILED_ERROR_CODE: $20132b2015719a62$export$c8a538cf4ae41623,
        SERVER_ERROR_ERROR_CODE: $20132b2015719a62$export$9bbcbc11675c1278,
        USER_NOT_FOUND_ERROR_CODE: $20132b2015719a62$export$a51af3c30283d234
    };
    const $4afbb4a2961eae5f$export$b28f48897cdf7241 = (0, $5uXOq.memo)(({ onInviteSuccess: onInviteSuccess, onInviteError: onInviteError, onModalClose: onModalClose })=>{
        const { triggerBtnRef: triggerBtnRef } = (0, (0, parcelRequire("7wK4b")).useAddPeople)();
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const handleInviteSuccess = (0, $5uXOq.useCallback)((addedParties, _role)=>{
            onInviteSuccess({
                totalPeopleAdded: addedParties.length,
                email: addedParties[0]?.email || addedParties[0]?.displayName,
                modalType: 'Project'
            });
        }, [
            onInviteSuccess
        ]);
        const extractErrorCode = (message)=>{
            for (const errorCode of Object.keys($4afbb4a2961eae5f$var$userInviteErrorCodes)){
                const errorMessage = $4afbb4a2961eae5f$var$userInviteErrorCodes[errorCode];
                if (message.includes(errorMessage)) return errorCode;
            }
            return message;
        };
        const handleInviteFailure = (0, $5uXOq.useCallback)((errors)=>{
            const userInviteErrorsWithCode = {};
            errors.forEach((error)=>{
                const errorCode = extractErrorCode(error.message);
                if (errorCode) {
                    if (!userInviteErrorsWithCode[errorCode]) userInviteErrorsWithCode[errorCode] = [];
                    userInviteErrorsWithCode[errorCode].push(error);
                }
            });
            const groupedUserInviteErrors = Object.values(userInviteErrorsWithCode).map((group)=>{
                const statusCode = group[0]?.statusCode;
                const messages = group.map((obj)=>obj.message).join('\n');
                return {
                    message: messages,
                    statusCode: statusCode
                };
            });
            groupedUserInviteErrors.forEach((groupedUserInviteError)=>{
                onInviteError({
                    modalType: 'Project',
                    errorMessage: groupedUserInviteError.message,
                    statusCode: groupedUserInviteError.statusCode
                });
            });
        }, [
            onInviteError
        ]);
        const { id: id, key: key } = projectData;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "async.jira-business.project-invite-people-modal.add-people",
            packageName: "jira-business.project-invite-people-modal.add-people",
            teamName: "jira-warepil"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireTrackAnalytics), {
            eventName: "jwmProjectInviteComponent viewed"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "add-people-modal-lazy",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4afbb4a2961eae5f$export$a4917c848b5c6ce8, {
            isOpen: true,
            triggerBtnRef: triggerBtnRef,
            onClose: onModalClose,
            onAddSuccess: handleInviteSuccess,
            onError: handleInviteFailure,
            projectId: id,
            projectKey: key,
            projectType: "business",
            isAdmin: isAdmin,
            baseUrl: "",
            analyticsPrefix: "",
            allowFlags: false,
            onStopPerfMetric: (0, ($parcel$interopDefault($8Rkzz)))
        })));
    });
});
parcelRegister("7HRyA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("1TWxe")
    ]).then(()=>parcelRequire('jd2mv'));
});
parcelRegister("9AFuM", function(module, exports) {
    $parcel$export(module.exports, "InvitePeopleModal", ()=>$5ae346fd9b1f20af$export$e3ec81c4d0451f63);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $9fuVs;
    var $65Ltd;
    var $heNNl;
    var $7NYq5;
    var $lfTZh;
    var $6jY6G;
    var $5oFIy;
    var $12hlA;
    var $14XJw;
    var $efvDm;
    var $ldyPw;
    var $k9JTq;
    var $koeKL;
    var $itmJb;
    var $1jUsD;
    var $99ejj;
    const $5ae346fd9b1f20af$export$cbfde4f653ce234 = (0, (0, parcelRequire("1jUsD")).lazy)(()=>(parcelRequire("cRCnX")), {
        ssr: false,
        moduleId: "../platform/packages/people-and-teams/invite-people/src/index.ts"
    });
    const $5ae346fd9b1f20af$export$4d2a63c83bbce998 = (res)=>{
        if (res.accessRequested?.length) return (0, (0, parcelRequire("99ejj")).InvitationStatusEnum).ACCESS_REQUESTED;
        return (0, (0, parcelRequire("99ejj")).InvitationStatusEnum).INVITED;
    };
    const $5ae346fd9b1f20af$var$LIST_ROUTES = [
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST)
    ];
    const $5ae346fd9b1f20af$var$isFailureResponse = (res)=>res.failure !== undefined;
    const $5ae346fd9b1f20af$export$e3ec81c4d0451f63 = (0, $5uXOq.memo)(({ onInviteSuccess: onInviteSuccess, onInviteError: onInviteError, onModalClose: onModalClose, source: source = 'projectBoard' })=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const onInviteCompleteHandler = (0, $5uXOq.useCallback)((response)=>{
            if ($5ae346fd9b1f20af$var$isFailureResponse(response)) {
                const { message: message, status: status } = response.failure;
                onInviteError({
                    modalType: 'Instance',
                    errorMessage: message,
                    statusCode: status
                });
                return;
            }
            const inviteStatus = $5ae346fd9b1f20af$export$4d2a63c83bbce998(response);
            const { invited: invited, accessRequested: accessRequested } = response;
            onInviteSuccess({
                totalPeopleAdded: invited.length || accessRequested.length,
                email: invited[0]?.email || accessRequested[0]?.email || '',
                modalType: 'Instance',
                inviteStatus: inviteStatus
            });
        }, [
            onInviteError,
            onInviteSuccess
        ]);
        const isSoftwareRoute = (0, $5uXOq.useMemo)(()=>$5ae346fd9b1f20af$var$LIST_ROUTES.includes(route.name), [
            route
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "async.jira-business.project-invite-people-modal.invite-people",
            packageName: "jira-business.project-invite-people-modal.invite-people",
            teamName: "jira-warepil"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "project-invite-people-modal.invite-people",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7NYq5")).JiraModal), {
            messageId: "business-invite-people.ui.add-people-with-avatars.add-people.project-invite-people-modal.invite-people-modal.jira-modal",
            messageType: "transactional",
            onClose: onModalClose,
            width: "small",
            shouldScrollInViewport: true,
            testId: "business-invite-people.ui.add-people-with-avatars.add-people.project-invite-people-modal.invite-people-modal"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireTrackAnalytics), {
            eventName: "jwmInstanceInviteComponent viewed"
        }), isSoftwareRoute ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("12hlA")).default), {
            isOpen: true,
            cloudId: cloudId,
            projectId: projectData.id,
            jiraProjectKey: projectData.key,
            isSiteAdmin: isAdmin,
            onClose: onModalClose,
            appEdition: (0, (0, parcelRequire("ldyPw")).getEdition)((0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE), appEditions),
            jiraProjectName: projectData.name
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement($5ae346fd9b1f20af$export$cbfde4f653ce234, {
            onSendHandler: onModalClose,
            onInviteCompletedHandler: onInviteCompleteHandler,
            onCancelHandler: onModalClose,
            resourceAri: `ari:cloud:jira::site/${cloudId}`,
            continueUrl: window.location.href,
            enableThirdParty: true,
            source: source,
            orgId: orgId
        })))));
    });
});
parcelRegister("7NYq5", function(module, exports) {
    $parcel$export(module.exports, "JiraModal", ()=>$d308ab9275c4cac7$export$3782fcca1f68992e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bTmOP;
    var $10xFf;
    var $1WAOl;
    const $d308ab9275c4cac7$export$3782fcca1f68992e = (props)=>{
        if ((0, (0, parcelRequire("10xFf")).shouldBeChoreographed)(props)) {
            const { messageType: messageType, ...rest } = props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1WAOl")).ChoreographerModal), rest);
        }
        const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bTmOP")).default), rest);
    };
    $d308ab9275c4cac7$export$3782fcca1f68992e.displayName = 'JiraModal';
});
parcelRegister("1WAOl", function(module, exports) {
    $parcel$export(module.exports, "ChoreographerModal", ()=>$ae3d8c3c4e97b978$export$3f5d627caa6fc630);
    var $bTmOP;
    var $cSWNW;
    const $ae3d8c3c4e97b978$export$3f5d627caa6fc630 = (0, (0, parcelRequire("cSWNW")).withChoreographedRender)((0, (0, parcelRequire("bTmOP")).default));
});
parcelRegister("12hlA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0bc8c7c74346f034$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $1jUsD;
    const $0bc8c7c74346f034$var$LazyComponent = (0, (0, parcelRequire("1jUsD")).lazyForPaint)(()=>(parcelRequire("jWZZk")), {
        moduleId: "./src/packages/project-settings/invite-people-modal-project/src/index.tsx"
    });
    const $0bc8c7c74346f034$export$6a02a79fa2b0ddab = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "async-project-invite-people-modal",
            packageName: "jira-project-invite-people-modal",
            teamName: "groot-growth"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "project-invite-people-modal",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0bc8c7c74346f034$var$LazyComponent, props)));
    var $0bc8c7c74346f034$export$2e2bcd8739ae039 = $0bc8c7c74346f034$export$6a02a79fa2b0ddab;
});
parcelRegister("jWZZk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6C6tQ")
    ]).then(()=>parcelRequire('3dNZP'));
});
parcelRegister("cRCnX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("29qSX")
    ]).then(()=>parcelRequire('ig8jN'));
});
parcelRegister("1l3YZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cbfac59b1ef70ece$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2APCZ;
    var $5husp;
    var $hE5wF;
    var $7wK4b;
    var $koVbs;
    var $ieDtd;
    var $7TJr2;
    var $knyfk;
    var $ifJ7u;
    const $cbfac59b1ef70ece$var$InviteTeammateButton = ({ onClick: onClick })=>{
        const { openAddPeopleModal: openAddPeopleModal } = (0, (0, parcelRequire("7wK4b")).useAddPeople)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [inviteOpenParam, setInviteOpenParam] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("hE5wF")).INVITE_OPEN_PARAM));
        const hasInviteOpenParam = inviteOpenParam === 'true';
        const { linksTarget: linksTarget } = (0, (0, parcelRequire("7TJr2")).useSummaryFeatures)();
        const handleClick = (0, $5uXOq.useCallback)((event)=>{
            openAddPeopleModal();
            onClick(event);
        }, [
            onClick,
            openAddPeopleModal
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (hasInviteOpenParam) openAddPeopleModal(()=>{
                setInviteOpenParam(undefined);
            });
        }, [
            hasInviteOpenParam,
            openAddPeopleModal,
            setInviteOpenParam
        ]);
        const inviteTeammateIcon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ifJ7u")).InviteTeammateIconContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("5husp"))))), {
            label: "",
            size: "small",
            primaryColor: `var(--ds-icon-subtle, ${(0, $72ba03e317f3d228$export$d6447c357493214f)})`
        }));
        const buttonProps = linksTarget === '_blank' ? {
            href: `${window.location.href.replace('/embed', '')}?${0, (0, parcelRequire("hE5wF")).INVITE_OPEN_PARAM}=true`,
            target: '_blank'
        } : {
            onClick: handleClick
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ifJ7u")).InviteTeammateButtonContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
            ...buttonProps,
            iconBefore: inviteTeammateIcon,
            appearance: "subtle-link",
            testId: "business-summary.ui.summary-view.workload-by-assignee.invite-teammate.invite-teammate-button"
        }, formatMessage((0, (0, parcelRequire("knyfk")).default).inviteTeammateButton)));
    };
    var $cbfac59b1ef70ece$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($cbfac59b1ef70ece$var$InviteTeammateButton);
});
parcelRegister("5husp", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3d862a74cef6689e$var$_react = $3d862a74cef6689e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $3d862a74cef6689e$var$_personAdd = $3d862a74cef6689e$var$_interopRequireDefault((parcelRequire("lGxut")));
    function $3d862a74cef6689e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3d862a74cef6689e$var$InviteTeamIcon = (props)=>$3d862a74cef6689e$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="2" height="6" x="18" y="5" rx="1"/><rect width="6" height="2" x="16" y="7" rx="1"/><path d="M5 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="11" cy="7" r="4"/></g></svg>`
        }, props, {
            newIcon: $3d862a74cef6689e$var$_personAdd.default
        }));
    $3d862a74cef6689e$var$InviteTeamIcon.displayName = 'InviteTeamIcon';
    var $3d862a74cef6689e$var$_default = module.exports.default = $3d862a74cef6689e$var$InviteTeamIcon;
});
parcelRegister("lGxut", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fc977fba78ace458$var$_react = $fc977fba78ace458$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fc977fba78ace458$var$_UNSAFE_baseNew = $fc977fba78ace458$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $fc977fba78ace458$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fc977fba78ace458$var$PersonAddIcon = (props)=>$fc977fba78ace458$var$_react.default.createElement($fc977fba78ace458$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M.75 15v-2.25a3 3 0 0 1 3-3h2.5a3 3 0 0 1 3 3V15M13 8V5m0 3v3m0-3h3m-3 0h-3M8.25 4a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"/>`
        }, props));
    $fc977fba78ace458$var$PersonAddIcon.displayName = 'PersonAddIcon';
    var $fc977fba78ace458$var$_default = module.exports.default = $fc977fba78ace458$var$PersonAddIcon;
});
parcelRegister("knyfk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$00f05ca8fb1916bf$export$2e2bcd8739ae039);
    var $7VHMR;
    var $00f05ca8fb1916bf$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        inviteTeammateButton: {
            "id": "business-summary.summary-view.workload-by-assignee.invite-teammate.invite-teammate-button.invite-teammate-button",
            "defaultMessage": "Invite teammate"
        }
    });
});
parcelRegister("ifJ7u", function(module, exports) {
    $parcel$export(module.exports, "InviteTeammateButtonContainer", ()=>$236bba964d182346$export$4a485f895a272d98);
    $parcel$export(module.exports, "InviteTeammateIconContainer", ()=>$236bba964d182346$export$f131e5fdcf18ca2f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $236bba964d182346$export$4a485f895a272d98 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0196n _19pk12x7",
                __cmplp.className
            ])
        });
    });
    const $236bba964d182346$export$f131e5fdcf18ca2f = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3izwfg _1bsbzwfg _2rko1ssb _2hwx12x7 _1e0c1txw _4cvr1h6o _1bah1h6o _bfhk155y",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("lzVMJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5d323784b4f704c8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5d323784b4f704c8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "business-summary.summary-view.workload-by-assignee.title",
            "defaultMessage": "Team workload"
        },
        description: {
            "id": "business-summary.summary-view.workload-by-assignee.description",
            "defaultMessage": "Oversee the capacity of your team. {linkStart}Re-assign tasks across your team{linkEnd}"
        },
        descriptionWhenNoIssuesAssigned: {
            "id": "business-summary.summary-view.workload-by-assignee.description-when-no-issues-assigned",
            "defaultMessage": "Assign and share the workload in your team. {linkStart}Go to the list view{linkEnd}."
        },
        descriptionWhenEmpty: {
            "id": "business-summary.summary-view.workload-by-assignee.description-when-empty",
            "defaultMessage": "You'll need to create a few items to assign work to the right people in your team."
        },
        assigneeColumnHeader: {
            "id": "business-summary.summary-view.workload-by-assignee.assignee-column-header",
            "defaultMessage": "Assignee"
        },
        workloadColumnHeader: {
            "id": "business-summary.summary-view.workload-by-assignee.workload-column-header",
            "defaultMessage": "Work distribution"
        },
        countColumnHeader: {
            "id": "business-summary.summary-view.workload-by-assignee.count-column-header",
            "defaultMessage": "Count"
        },
        unassigned: {
            "id": "business-summary.summary-view.workload-by-assignee.unassigned",
            "defaultMessage": "Unassigned"
        }
    });
});
parcelRegister("dcGdr", function(module, exports) {
    $parcel$export(module.exports, "CenteredSkeleton", ()=>$4b16bb3bbc3d52ca$export$8faa72715fd79c70);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $02wft;
    const $4b16bb3bbc3d52ca$export$8faa72715fd79c70 = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("02wft")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("02wft", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a393197e6fba8461$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $a393197e6fba8461$var$Skeleton = ({ className: className, testId: testId })=>{
        const skeletonColor = `var(--ds-skeleton, ${(0, $72ba03e317f3d228$export$8d43898f60b96a82)})`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            viewBox: "0 0 476 296",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: className,
            "data-testid": testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "476",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            y: "16",
            width: "320",
            height: "8",
            rx: "4",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            y: "72",
            width: "32",
            height: "32",
            rx: "16",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "40",
            y: "80",
            width: "170",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "226",
            y: "80",
            width: "156",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "398",
            y: "80",
            width: "78",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            y: "120",
            width: "32",
            height: "32",
            rx: "16",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "40",
            y: "128",
            width: "170",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "226",
            y: "128",
            width: "156",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "398",
            y: "128",
            width: "78",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            y: "168",
            width: "32",
            height: "32",
            rx: "16",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "40",
            y: "176",
            width: "170",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "226",
            y: "176",
            width: "156",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "398",
            y: "176",
            width: "78",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            y: "216",
            width: "32",
            height: "32",
            rx: "16",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "40",
            y: "224",
            width: "170",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "226",
            y: "224",
            width: "156",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "398",
            y: "224",
            width: "78",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            y: "264",
            width: "32",
            height: "32",
            rx: "16",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "40",
            y: "272",
            width: "170",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "226",
            y: "272",
            width: "156",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "398",
            y: "272",
            width: "78",
            height: "16",
            rx: "8",
            fill: skeletonColor
        }));
    };
    var $a393197e6fba8461$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($a393197e6fba8461$var$Skeleton);
});
parcelRegister("lJuAo", function(module, exports) {
    $parcel$export(module.exports, "Description", ()=>$859ed340c298ea37$export$393edc798c47379d);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $859ed340c298ea37$export$393edc798c47379d = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("9AdWb", function(module, exports) {
    $parcel$export(module.exports, "getColor", ()=>$d6eb08968cbe8c4e$export$5551a2d24ff40153);
    const $d6eb08968cbe8c4e$var$COLORS = [
        (0, $72ba03e317f3d228$export$940e1f69e873f202),
        (0, $72ba03e317f3d228$export$c6930421db9fa514),
        (0, $72ba03e317f3d228$export$4a7404f376229999),
        (0, $72ba03e317f3d228$export$e62e8919cca44969),
        (0, $72ba03e317f3d228$export$b48405b95304b5a1),
        (0, $72ba03e317f3d228$export$9dc1ef0f3f48059b)
    ];
    const $d6eb08968cbe8c4e$export$5551a2d24ff40153 = (index)=>$d6eb08968cbe8c4e$var$COLORS[index % $d6eb08968cbe8c4e$var$COLORS.length];
});
parcelRegister("9dbF6", function(module, exports) {
    $parcel$export(module.exports, "SubProductUpdater", ()=>$5979c081afa32bfa$export$eb40d3df56aa5c53);
    var $5uXOq = parcelRequire("5uXOq");
    var $bNvU3;
    var $3iTiR;
    var $ero6m;
    var $54I24;
    var $8OHH4;
    const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
        const subProduct = (0, (0, parcelRequire("8OHH4")).isSubProductProps)(props) ? props.subProduct : (0, (0, parcelRequire("ero6m")).getSubProductFromProjectType)(props.projectType);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
            op: (0, (0, parcelRequire("54I24")).default),
            args: [
                subProduct,
                allowMonolithDeferral
            ]
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iTiR")).default), {
            subProduct: subProduct
        }));
    };
});
parcelRegister("3iTiR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1214b0731559b377$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1u3Jv;
    var $hFChZ;
    var $1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1u3Jv")).default), {
            op: (0, (0, parcelRequire("hFChZ")).default),
            args: [
                subProduct
            ]
        });
});
parcelRegister("hFChZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e606430ead76cd8$export$2e2bcd8739ae039);
    var $dJl1T;
    var $eusud;
    var $0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
        (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
        });
    };
});
parcelRegister("ero6m", function(module, exports) {
    $parcel$export(module.exports, "getSubProductFromProjectType", ()=>$0997694844c8a9e7$export$b1fe420ed15dff7b);
    var $16v4H;
    const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
        if (projectType === 'product_discovery') return 'polaris';
        return (0, (0, parcelRequire("16v4H")).subProductFromProjectType)(projectType);
    };
});
parcelRegister("54I24", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bcbbcd48ca398ed4$export$2e2bcd8739ae039);
    var $7T84i;
    var $9B86Q;
    var $cQZXC;
    var $dJl1T;
    var $fjcgS;
    const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
            maybeWaitPromise.then(getDefaultPromise),
            getRacePromise()
        ]) : getDefaultPromise();
    var $bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            client.setSubProduct(subProduct);
            if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
                solutions: [
                    (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
                ]
            });
            else client.removeUIViewedAttribute('solutions');
        });
        $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, (0, parcelRequire("cQZXC")).waitForHeritage)() : null, ()=>(0, (0, parcelRequire("7T84i")).loadBridgeStrict)({
                name: 'jira/analytics/sub-product-resolver',
                wrmKeys: [
                    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
                ]
            }), ()=>(0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: 'jira/analytics/sub-product-resolver'
            })).then((subProductResolver)=>{
            subProductResolver.setSubProduct(subProduct);
        }).catch((e)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
    };
});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';
parcelRegister("8OHH4", function(module, exports) {
    $parcel$export(module.exports, "isSubProductProps", ()=>$701d07b56c3e3574$export$c3063d6d7a8c075f);
    const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
    const $701d07b56c3e3574$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';
});
